import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  /** The javascript `Date` as string. Type represents date and time as the ISO Date string. */
  DateTime: string;
  /**
   * a custom scalar used to describe and validate a String-like enum
   *
   * possible values: `Field`, `Mutation`, or `Query`
   */
  GraphQLDeprecationLogRequestTypeScalar: any;
  /**
   * used with `PDFDesignLayer.json.options`
   *
   * `options` should be an object where each key is an entity's `globalId` and its corresponding value is a list of numbers
   */
  PDFDesignLayerOptionsScalar: any;
  /** A scalar describing a simple JSON object with no consistent schema */
  SimpleJSONScalar: any;
};

export type ApiKey = {
  __typename: 'APIKey';
  /** the date this record was inserted into the database */
  createdDate: Scalars['DateTime'];
  /**
   * the email address of a user associated with the `createdDate`
   *
   * this value will be `unknown` if the `createdDate` was not set by a user
   */
  createdUser: Scalars['String'];
  /** a unique integer to identify this record in the database table */
  id: Scalars['Int'];
  /** the date this record was last updated in the database */
  lastEditedDate: Scalars['DateTime'];
  /**
   * the email address of a user associated with the `lastEditedDate`
   *
   * this value will be `system` if the `lastEditedDate` was not set by a user
   */
  lastEditedUser: Scalars['String'];
  recipient: Scalars['String'];
};

/** helps filter multiple `APIKey` records */
export type ApiKeyListInput = {
  createdDate?: InputMaybe<DateTimeFilter>;
  lastEditedDate?: InputMaybe<DateTimeFilter>;
  /**
   * how to order `APIKey` records
   *
   * executed in the order they are defined
   */
  orderBy?: InputMaybe<Array<OrderByInput>>;
  /**
   * paginate `APIKey` records
   *
   * using `paginate` may require multiple requests to get all possible results,
   * but will give more fine-grain control in the event all records cannot be
   * returned gracefully
   */
  paginate?: InputMaybe<PaginationInput>;
  recipient?: InputMaybe<StringFilter>;
};

/** response metadata for a list query of APIKey records */
export type ApiKeyListResponse = {
  __typename: 'APIKeyListResponse';
  /** the total count of APIKey records matching any configured filters */
  count: Scalars['Int'];
  /** the total count of paginated groups of APIKey */
  pages: Scalars['Int'];
  /** APIKey records */
  records: Array<ApiKey>;
};

export type Alignment = {
  __typename: 'Alignment';
  alignmentName: Maybe<Scalars['String']>;
  /** the date this record was inserted into the database */
  createdDate: Maybe<Scalars['DateTime']>;
  /** the username or email address of a mobile app user associated with the `createdDate` */
  createdUser: Maybe<Scalars['String']>;
  deleted: Maybe<Scalars['String']>;
  endStation: Maybe<Scalars['Float']>;
  /** a GUID used to globally identify this record in the database */
  globalId: Scalars['String'];
  /** the date this record was last updated in the database */
  lastEditedDate: Maybe<Scalars['DateTime']>;
  /** the username or email address of a mobile app user associated with the `lastEditedDate` */
  lastEditedUser: Maybe<Scalars['String']>;
  /** a related `Project` */
  project: Maybe<Project>;
  /** the `globalId` of a related `Project` */
  projectId: Maybe<Scalars['String']>;
  shape: Maybe<Scalars['String']>;
  sortOrder: Maybe<Scalars['Int']>;
  startStation: Maybe<Scalars['Float']>;
};

/**
 * helps filter multiple `Alignment` records
 *
 * this version of the input will have limited options compared to its other counterpart
 */
export type AlignmentFieldInput = {
  alignmentName?: InputMaybe<StringFilter>;
  createdDate?: InputMaybe<DateTimeFilter>;
  /**
   * determines now to handle deleted `Alignment` records
   *
   * - when `true`, only return deleted records
   * - when `false`, do not return deleted records
   * - when omitted, `deleted` is ignored
   */
  deleted?: InputMaybe<Scalars['Boolean']>;
  lastEditedDate?: InputMaybe<DateTimeFilter>;
  /**
   * how to order `Alignment` records
   *
   * executed in the order they are defined
   */
  orderBy?: InputMaybe<Array<OrderByInput>>;
  projectId?: InputMaybe<StringFilter>;
  /**
   * specifies how many records to return
   *
   * analogous to `limit`, `first`, or `top` in SQL dialects
   */
  take?: InputMaybe<Scalars['Int']>;
};

/** helps filter multiple `Alignment` records */
export type AlignmentListInput = {
  alignmentName?: InputMaybe<StringFilter>;
  createdDate?: InputMaybe<DateTimeFilter>;
  /**
   * determines now to handle deleted `Alignment` records
   *
   * - when `true`, only return deleted records
   * - when `false`, do not return deleted records
   * - when omitted, `deleted` is ignored
   */
  deleted?: InputMaybe<Scalars['Boolean']>;
  lastEditedDate?: InputMaybe<DateTimeFilter>;
  /**
   * how to order `Alignment` records
   *
   * executed in the order they are defined
   */
  orderBy?: InputMaybe<Array<OrderByInput>>;
  /**
   * paginate `Alignment` records
   *
   * using `paginate` may require multiple requests to get all possible results,
   * but will give more fine-grain control in the event all records cannot be
   * returned gracefully
   */
  paginate?: InputMaybe<PaginationInput>;
  projectId?: InputMaybe<StringFilter>;
};

/** response metadata for a list query of Alignment records */
export type AlignmentListResponse = {
  __typename: 'AlignmentListResponse';
  /** the total count of Alignment records matching any configured filters */
  count: Scalars['Int'];
  /** the total count of paginated groups of Alignment */
  pages: Scalars['Int'];
  /** Alignment records */
  records: Array<Alignment>;
};

export type AsphaltCoreMeasurement = {
  __typename: 'AsphaltCoreMeasurement';
  alignment: Maybe<Scalars['String']>;
  archiveDate: Maybe<Scalars['DateTime']>;
  archiveUser: Maybe<Scalars['String']>;
  archived: Maybe<Scalars['String']>;
  asphaltLot: Maybe<AsphaltLot>;
  asphaltLotGuid: Maybe<Scalars['String']>;
  asphaltPlacement: Maybe<AsphaltPlacement>;
  asphaltPlacementJoint: Maybe<AsphaltPlacementJoint>;
  avgMeasuredThickness: Maybe<Scalars['Float']>;
  closedDate: Maybe<Scalars['DateTime']>;
  coreIdentifier: Maybe<Scalars['Float']>;
  /**
   * used to describe the `AsphaltCoreMeasurement` and
   * specify which related Type corresponds to `parentGuid` in the database
   *
   * | object type | value |
   * | --- | :---: |
   * | `AsphaltPlacementJoint` | Joint |
   * | `AsphaltPlacement` | Manual* |
   * | `AsphaltPlacement` | Mat |
   * | `-` | Placement |
   *
   * *Manual suggests either `AsphaltPlacement` or `AsphaltPlacementJoint` are
   * possibly related, but the database only seems to return `AsphaltPlacement`
   */
  coreType: Maybe<Scalars['String']>;
  /** the date this record was inserted into the database */
  createdDate: Maybe<Scalars['DateTime']>;
  /** the username or email address of a mobile app user associated with the `createdDate` */
  createdUser: Maybe<Scalars['String']>;
  creationType: Maybe<Scalars['String']>;
  deleted: Maybe<Scalars['String']>;
  difference: Maybe<Scalars['Float']>;
  /** a GUID used to globally identify this record in the database */
  globalId: Scalars['String'];
  /**
   * `jointGuid` is unreliable, a misnomer, every record contains `null` values, or its purpose is generally unknown
   *
   * use `parentGuid` instead
   */
  jointGuid: Maybe<Scalars['String']>;
  /** the date this record was last updated in the database */
  lastEditedDate: Maybe<Scalars['DateTime']>;
  /** the username or email address of a mobile app user associated with the `lastEditedDate` */
  lastEditedUser: Maybe<Scalars['String']>;
  measurementDate: Maybe<Scalars['DateTime']>;
  measurementId: Maybe<Scalars['String']>;
  /**
   * If set, contains a comma separated list of
   * `PayItemNoGeometry.globalId` values
   *
   * unfortunately, there have been instances where one of these values doesn't map
   * to a valid `PayItemNoGeometry`
   *
   * `payItemNoGeometries` will skip these rather than map them to `null`
   */
  multiplePayItems: Maybe<Scalars['String']>;
  notes: Maybe<Scalars['String']>;
  offset: Maybe<Scalars['String']>;
  offsetRandom: Maybe<Scalars['Float']>;
  overrideComments: Maybe<Scalars['String']>;
  /** the `globalId` of one of the related types: `AsphaltPlacement` or `AsphaltPlacementJoint` */
  parentGuid: Maybe<Scalars['String']>;
  /**
   * aggregates all `PayItemNoGeometry` records associated with this
   * `AsphaltCoreMeasurement` by using its `PayItemNoGeometry` reference and `multiplePayItems`
   *
   * if any `PayItemNoGeometry.globalId` values used to query the database return `null`,
   * the `null` value will be filtered out of the results
   *
   * every result will be a valid `PayItemNoGeometry`
   */
  payItemNoGeometries: Array<PayItemNoGeometry>;
  payItemsGuid: Maybe<Scalars['String']>;
  /** a related `Project` */
  project: Maybe<Project>;
  /** the `globalId` of a related `Project` */
  projectId: Maybe<Scalars['String']>;
  random: Maybe<Scalars['String']>;
  reOpenedDate: Maybe<Scalars['DateTime']>;
  requiredThickness: Maybe<Scalars['Float']>;
  shape: Maybe<Scalars['String']>;
  station: Maybe<Scalars['String']>;
  stationingRandom: Maybe<Scalars['Float']>;
  status: Maybe<Scalars['String']>;
  technician: Maybe<Technician>;
  /** the `globalId` of a related `Technician` */
  technicianGuid: Maybe<Scalars['String']>;
};


export type AsphaltCoreMeasurementPayItemNoGeometriesArgs = {
  payItemNoGeometryFieldInput?: InputMaybe<PayItemNoGeometryFieldInput>;
};

/**
 * helps filter multiple `AsphaltCoreMeasurement` records
 *
 * this version of the input will have limited options compared to its other counterpart
 */
export type AsphaltCoreMeasurementFieldInput = {
  coreType?: InputMaybe<StringFilter>;
  createdDate?: InputMaybe<DateTimeFilter>;
  /**
   * determines now to handle deleted `AsphaltCoreMeasurement` records
   *
   * - when `true`, only return deleted records
   * - when `false`, do not return deleted records
   * - when omitted, `deleted` is ignored
   */
  deleted?: InputMaybe<Scalars['Boolean']>;
  lastEditedDate?: InputMaybe<DateTimeFilter>;
  measurementId?: InputMaybe<StringFilter>;
  /**
   * how to order `AsphaltCoreMeasurement` records
   *
   * executed in the order they are defined
   */
  orderBy?: InputMaybe<Array<OrderByInput>>;
  /**
   * paginate `AsphaltCoreMeasurement` records
   *
   * using `paginate` may require multiple requests to get all possible results,
   * but will give more fine-grain control in the event all records cannot be
   * returned gracefully
   */
  paginate?: InputMaybe<PaginationInput>;
  projectId?: InputMaybe<StringFilter>;
  status?: InputMaybe<StringFilter>;
};

/** helps filter multiple `AsphaltCoreMeasurement` records */
export type AsphaltCoreMeasurementListInput = {
  coreType?: InputMaybe<StringFilter>;
  createdDate?: InputMaybe<DateTimeFilter>;
  /**
   * determines now to handle deleted `AsphaltCoreMeasurement` records
   *
   * - when `true`, only return deleted records
   * - when `false`, do not return deleted records
   * - when omitted, `deleted` is ignored
   */
  deleted?: InputMaybe<Scalars['Boolean']>;
  lastEditedDate?: InputMaybe<DateTimeFilter>;
  measurementId?: InputMaybe<StringFilter>;
  /**
   * how to order `AsphaltCoreMeasurement` records
   *
   * executed in the order they are defined
   */
  orderBy?: InputMaybe<Array<OrderByInput>>;
  /**
   * paginate `AsphaltCoreMeasurement` records
   *
   * using `paginate` may require multiple requests to get all possible results,
   * but will give more fine-grain control in the event all records cannot be
   * returned gracefully
   */
  paginate?: InputMaybe<PaginationInput>;
  projectId?: InputMaybe<StringFilter>;
  status?: InputMaybe<StringFilter>;
};

/** response metadata for a list query of AsphaltCoreMeasurement records */
export type AsphaltCoreMeasurementListResponse = {
  __typename: 'AsphaltCoreMeasurementListResponse';
  /** the total count of AsphaltCoreMeasurement records matching any configured filters */
  count: Scalars['Int'];
  /** the total count of paginated groups of AsphaltCoreMeasurement */
  pages: Scalars['Int'];
  /** AsphaltCoreMeasurement records */
  records: Array<AsphaltCoreMeasurement>;
};

export type AsphaltLot = {
  __typename: 'AsphaltLot';
  archiveDate: Maybe<Scalars['DateTime']>;
  archiveUser: Maybe<Scalars['String']>;
  archived: Maybe<Scalars['String']>;
  asphaltCoreMeasurements: Array<AsphaltCoreMeasurement>;
  asphaltLotId: Maybe<Scalars['String']>;
  asphaltMaterial: Maybe<AsphaltMaterial>;
  /** the `globalId` of a related `AsphaltMaterial` */
  asphaltMaterialsGuid: Maybe<Scalars['String']>;
  asphaltMixDesign: Maybe<AsphaltMixDesign>;
  /** the `globalId` of a related `AsphaltMixDesign` */
  asphaltMixDesignGuid: Maybe<Scalars['String']>;
  asphaltPlacementJoints: Array<AsphaltPlacementJoint>;
  asphaltPlacements: Array<AsphaltPlacement>;
  asphaltSamples: Array<AsphaltSample>;
  checkGenerateErrors: Maybe<Scalars['String']>;
  closedDate: Maybe<Scalars['DateTime']>;
  /** the date this record was inserted into the database */
  createdDate: Maybe<Scalars['DateTime']>;
  /** the username or email address of a mobile app user associated with the `createdDate` */
  createdUser: Maybe<Scalars['String']>;
  deleted: Maybe<Scalars['String']>;
  estimatedTons: Maybe<Scalars['Float']>;
  /** a GUID used to globally identify this record in the database */
  globalId: Scalars['String'];
  identifiedFieldIssue: Maybe<IdentifiedFieldIssue>;
  issueToReports: Array<IssueToReport>;
  /** the date this record was last updated in the database */
  lastEditedDate: Maybe<Scalars['DateTime']>;
  /** the username or email address of a mobile app user associated with the `lastEditedDate` */
  lastEditedUser: Maybe<Scalars['String']>;
  lotCreatedDate: Maybe<Scalars['DateTime']>;
  mediaUploads: Array<MediaUpload>;
  /**
   * If set, contains a comma separated list of
   * `PayItemNoGeometry.globalId` values
   *
   * unfortunately, there have been instances where one of these values doesn't map
   * to a valid `PayItemNoGeometry`
   *
   * `payItemNoGeometries` will skip these rather than map them to `null`
   */
  multiplePayItems: Maybe<Scalars['String']>;
  notes: Maybe<Scalars['String']>;
  overrideComments: Maybe<Scalars['String']>;
  payItemGuid: Maybe<Scalars['String']>;
  /**
   * aggregates all `PayItemNoGeometry` records associated with this
   * `AsphaltLot` by using its `PayItemNoGeometry` reference and `multiplePayItems`
   *
   * if any `PayItemNoGeometry.globalId` values used to query the database return `null`,
   * the `null` value will be filtered out of the results
   *
   * every result will be a valid `PayItemNoGeometry`
   */
  payItemNoGeometries: Array<PayItemNoGeometry>;
  /** a related `Project` */
  project: Maybe<Project>;
  /** the `globalId` of a related `Project` */
  projectId: Maybe<Scalars['String']>;
  reOpenedDate: Maybe<Scalars['DateTime']>;
  reject: Maybe<Scalars['DateTime']>;
  reportToTags: Array<ReportToTag>;
  reviewComment: Maybe<Scalars['String']>;
  reviewedBy: Maybe<Technician>;
  reviewedByGuid: Maybe<Scalars['String']>;
  status: Maybe<Scalars['String']>;
  testedDate: Maybe<Scalars['DateTime']>;
};


export type AsphaltLotAsphaltCoreMeasurementsArgs = {
  asphaltCoreMeasurementFieldInput?: InputMaybe<AsphaltCoreMeasurementFieldInput>;
};


export type AsphaltLotAsphaltPlacementJointsArgs = {
  asphaltPlacementJointFieldInput?: InputMaybe<AsphaltPlacementJointFieldInput>;
};


export type AsphaltLotAsphaltPlacementsArgs = {
  asphaltPlacementFieldInput?: InputMaybe<AsphaltPlacementFieldInput>;
};


export type AsphaltLotAsphaltSamplesArgs = {
  asphaltSampleFieldInput?: InputMaybe<AsphaltSampleFieldInput>;
};


export type AsphaltLotIssueToReportsArgs = {
  issueToReportFieldInput?: InputMaybe<IssueToReportFieldInput>;
};


export type AsphaltLotMediaUploadsArgs = {
  mediaUploadFieldInput?: InputMaybe<MediaUploadFieldInput>;
};


export type AsphaltLotPayItemNoGeometriesArgs = {
  payItemNoGeometryFieldInput?: InputMaybe<PayItemNoGeometryFieldInput>;
};


export type AsphaltLotReportToTagsArgs = {
  reportToTagFieldInput?: InputMaybe<ReportToTagFieldInput>;
};

/**
 * helps filter multiple `AsphaltLot` records
 *
 * this version of the input will have limited options compared to its other counterpart
 */
export type AsphaltLotFieldInput = {
  asphaltLotId?: InputMaybe<StringFilter>;
  createdDate?: InputMaybe<DateTimeFilter>;
  /**
   * determines now to handle deleted `AsphaltLot` records
   *
   * - when `true`, only return deleted records
   * - when `false`, do not return deleted records
   * - when omitted, `deleted` is ignored
   */
  deleted?: InputMaybe<Scalars['Boolean']>;
  lastEditedDate?: InputMaybe<DateTimeFilter>;
  /**
   * how to order `AsphaltLot` records
   *
   * executed in the order they are defined
   */
  orderBy?: InputMaybe<Array<OrderByInput>>;
  projectId?: InputMaybe<StringFilter>;
  status?: InputMaybe<StringFilter>;
  /**
   * specifies how many records to return
   *
   * analogous to `limit`, `first`, or `top` in SQL dialects
   */
  take?: InputMaybe<Scalars['Int']>;
};

/** helps filter multiple `AsphaltLot` records */
export type AsphaltLotListInput = {
  asphaltLotId?: InputMaybe<StringFilter>;
  createdDate?: InputMaybe<DateTimeFilter>;
  /**
   * determines now to handle deleted `AsphaltLot` records
   *
   * - when `true`, only return deleted records
   * - when `false`, do not return deleted records
   * - when omitted, `deleted` is ignored
   */
  deleted?: InputMaybe<Scalars['Boolean']>;
  lastEditedDate?: InputMaybe<DateTimeFilter>;
  /**
   * how to order `AsphaltLot` records
   *
   * executed in the order they are defined
   */
  orderBy?: InputMaybe<Array<OrderByInput>>;
  /**
   * paginate `AsphaltLot` records
   *
   * using `paginate` may require multiple requests to get all possible results,
   * but will give more fine-grain control in the event all records cannot be
   * returned gracefully
   */
  paginate?: InputMaybe<PaginationInput>;
  projectId?: InputMaybe<StringFilter>;
  status?: InputMaybe<StringFilter>;
};

/** response metadata for a list query of AsphaltLot records */
export type AsphaltLotListResponse = {
  __typename: 'AsphaltLotListResponse';
  /** the total count of AsphaltLot records matching any configured filters */
  count: Scalars['Int'];
  /** the total count of paginated groups of AsphaltLot */
  pages: Scalars['Int'];
  /** AsphaltLot records */
  records: Array<AsphaltLot>;
};

export type AsphaltMaterial = {
  __typename: 'AsphaltMaterial';
  asphaltLots: Array<AsphaltLot>;
  asphaltSamplesPerLot: Maybe<Scalars['Int']>;
  coreUnits: Maybe<Scalars['String']>;
  /** the date this record was inserted into the database */
  createdDate: Maybe<Scalars['DateTime']>;
  /** the username or email address of a mobile app user associated with the `createdDate` */
  createdUser: Maybe<Scalars['String']>;
  deleted: Maybe<Scalars['String']>;
  excludeCores: Maybe<Scalars['String']>;
  excludeCylinders: Maybe<Scalars['String']>;
  fieldCoresCore1: Maybe<Scalars['Int']>;
  fieldCoresCore3: Maybe<Scalars['Int']>;
  fieldCoresCores2: Maybe<Scalars['Int']>;
  fieldCoresCores4: Maybe<Scalars['Int']>;
  fieldCoresCores5: Maybe<Scalars['Int']>;
  fieldCoresCores6: Maybe<Scalars['Int']>;
  fieldCoresTopOfBandTons1: Maybe<Scalars['Float']>;
  fieldCoresTopOfBandTons2: Maybe<Scalars['Float']>;
  fieldCoresTopOfBandTons3: Maybe<Scalars['Float']>;
  fieldCoresTopOfBandTons4: Maybe<Scalars['Float']>;
  fieldCoresTopOfBandTons5: Maybe<Scalars['Float']>;
  fieldCoresTopOfBandTons6: Maybe<Scalars['Float']>;
  /** a GUID used to globally identify this record in the database */
  globalId: Scalars['String'];
  grade: Maybe<Scalars['String']>;
  jointCorePer: Maybe<Scalars['Float']>;
  jointCorePerFeet: Maybe<Scalars['Float']>;
  jointCoreUnit: Maybe<Scalars['Float']>;
  /** the date this record was last updated in the database */
  lastEditedDate: Maybe<Scalars['DateTime']>;
  /** the username or email address of a mobile app user associated with the `lastEditedDate` */
  lastEditedUser: Maybe<Scalars['String']>;
  materialSection: Maybe<Scalars['String']>;
  placementType: Maybe<Scalars['String']>;
  /** a related `Project` */
  project: Maybe<Project>;
  /** the `globalId` of a related `Project` */
  projectId: Maybe<Scalars['String']>;
  shortName: Maybe<Scalars['String']>;
};


export type AsphaltMaterialAsphaltLotsArgs = {
  asphaltLotFieldInput?: InputMaybe<AsphaltLotFieldInput>;
};

/**
 * helps filter multiple `AsphaltMaterial` records
 *
 * this version of the input will have limited options compared to its other counterpart
 */
export type AsphaltMaterialFieldInput = {
  createdDate?: InputMaybe<DateTimeFilter>;
  /**
   * determines now to handle deleted `AsphaltMaterial` records
   *
   * - when `true`, only return deleted records
   * - when `false`, do not return deleted records
   * - when omitted, `deleted` is ignored
   */
  deleted?: InputMaybe<Scalars['Boolean']>;
  lastEditedDate?: InputMaybe<DateTimeFilter>;
  /**
   * how to order `AsphaltMaterial` records
   *
   * executed in the order they are defined
   */
  orderBy?: InputMaybe<Array<OrderByInput>>;
  placementType?: InputMaybe<StringFilter>;
  projectId?: InputMaybe<StringFilter>;
  /**
   * specifies how many records to return
   *
   * analogous to `limit`, `first`, or `top` in SQL dialects
   */
  take?: InputMaybe<Scalars['Int']>;
};

/** helps filter multiple `AsphaltMaterial` records */
export type AsphaltMaterialListInput = {
  createdDate?: InputMaybe<DateTimeFilter>;
  /**
   * determines now to handle deleted `AsphaltMaterial` records
   *
   * - when `true`, only return deleted records
   * - when `false`, do not return deleted records
   * - when omitted, `deleted` is ignored
   */
  deleted?: InputMaybe<Scalars['Boolean']>;
  lastEditedDate?: InputMaybe<DateTimeFilter>;
  /**
   * how to order `AsphaltMaterial` records
   *
   * executed in the order they are defined
   */
  orderBy?: InputMaybe<Array<OrderByInput>>;
  /**
   * paginate `AsphaltMaterial` records
   *
   * using `paginate` may require multiple requests to get all possible results,
   * but will give more fine-grain control in the event all records cannot be
   * returned gracefully
   */
  paginate?: InputMaybe<PaginationInput>;
  placementType?: InputMaybe<StringFilter>;
  projectId?: InputMaybe<StringFilter>;
};

/** response metadata for a list query of AsphaltMaterial records */
export type AsphaltMaterialListResponse = {
  __typename: 'AsphaltMaterialListResponse';
  /** the total count of AsphaltMaterial records matching any configured filters */
  count: Scalars['Int'];
  /** the total count of paginated groups of AsphaltMaterial */
  pages: Scalars['Int'];
  /** AsphaltMaterial records */
  records: Array<AsphaltMaterial>;
};

export type AsphaltMaterialSource = {
  __typename: 'AsphaltMaterialSource';
  asphaltMixDesigns: Array<AsphaltMixDesign>;
  /** the date this record was inserted into the database */
  createdDate: Maybe<Scalars['DateTime']>;
  /** the username or email address of a mobile app user associated with the `createdDate` */
  createdUser: Maybe<Scalars['String']>;
  deleted: Maybe<Scalars['String']>;
  /** a GUID used to globally identify this record in the database */
  globalId: Scalars['String'];
  isDeleted: Scalars['Boolean'];
  /** the date this record was last updated in the database */
  lastEditedDate: Maybe<Scalars['DateTime']>;
  /** the username or email address of a mobile app user associated with the `lastEditedDate` */
  lastEditedUser: Maybe<Scalars['String']>;
  /** a related `Project` */
  project: Maybe<Project>;
  /** the `globalId` of a related `Project` */
  projectId: Maybe<Scalars['String']>;
  source: Maybe<Scalars['String']>;
};


export type AsphaltMaterialSourceAsphaltMixDesignsArgs = {
  asphaltMixDesignFieldInput?: InputMaybe<AsphaltMixDesignFieldInput>;
};

/**
 * helps filter multiple `AsphaltMaterialSource` records
 *
 * this version of the input will have limited options compared to its other counterpart
 */
export type AsphaltMaterialSourceFieldInput = {
  createdDate?: InputMaybe<DateTimeFilter>;
  /**
   * determines now to handle deleted `AsphaltMaterialSource` records
   *
   * - when `true`, only return deleted records
   * - when `false`, do not return deleted records
   * - when omitted, `deleted` is ignored
   */
  deleted?: InputMaybe<Scalars['Boolean']>;
  lastEditedDate?: InputMaybe<DateTimeFilter>;
  /**
   * how to order `AsphaltMaterialSource` records
   *
   * executed in the order they are defined
   */
  orderBy?: InputMaybe<Array<OrderByInput>>;
  projectId?: InputMaybe<StringFilter>;
  source?: InputMaybe<StringFilter>;
  /**
   * specifies how many records to return
   *
   * analogous to `limit`, `first`, or `top` in SQL dialects
   */
  take?: InputMaybe<Scalars['Int']>;
};

/** helps filter multiple `AsphaltMaterialSource` records */
export type AsphaltMaterialSourceListInput = {
  createdDate?: InputMaybe<DateTimeFilter>;
  /**
   * determines now to handle deleted `AsphaltMaterialSource` records
   *
   * - when `true`, only return deleted records
   * - when `false`, do not return deleted records
   * - when omitted, `deleted` is ignored
   */
  deleted?: InputMaybe<Scalars['Boolean']>;
  lastEditedDate?: InputMaybe<DateTimeFilter>;
  /**
   * how to order `AsphaltMaterialSource` records
   *
   * executed in the order they are defined
   */
  orderBy?: InputMaybe<Array<OrderByInput>>;
  /**
   * paginate `AsphaltMaterialSource` records
   *
   * using `paginate` may require multiple requests to get all possible results,
   * but will give more fine-grain control in the event all records cannot be
   * returned gracefully
   */
  paginate?: InputMaybe<PaginationInput>;
  projectId?: InputMaybe<StringFilter>;
  source?: InputMaybe<StringFilter>;
};

/** response metadata for a list query of AsphaltMaterialSource records */
export type AsphaltMaterialSourceListResponse = {
  __typename: 'AsphaltMaterialSourceListResponse';
  /** the total count of AsphaltMaterialSource records matching any configured filters */
  count: Scalars['Int'];
  /** the total count of paginated groups of AsphaltMaterialSource */
  pages: Scalars['Int'];
  /** AsphaltMaterialSource records */
  records: Array<AsphaltMaterialSource>;
};

export type AsphaltMixDesign = {
  __typename: 'AsphaltMixDesign';
  active: Scalars['Boolean'];
  asphaltLots: Array<AsphaltLot>;
  asphaltMaterialSource: Maybe<AsphaltMaterialSource>;
  /** the `globalId` of a related `AsphaltMaterialSource` */
  asphaltMaterialSourceGuid: Maybe<Scalars['String']>;
  /** bulk specific gravity of aggregates */
  bulkSpecGravAgg: Maybe<Scalars['Float']>;
  /** the date this record was inserted into the database */
  createdDate: Maybe<Scalars['DateTime']>;
  /** the username or email address of a mobile app user associated with the `createdDate` */
  createdUser: Maybe<Scalars['String']>;
  /**
   * custom fields are defined, configured, and activated for `AsphaltMixDesign`
   *     records in the Administration module
   *
   *     values are saved and retrieved for each individual `AsphaltMixDesign`
   */
  customFields: CustomFields;
  deleted: Scalars['Boolean'];
  designBinderContent: Maybe<Scalars['Float']>;
  expirationDate: Maybe<Scalars['DateTime']>;
  /** a GUID used to globally identify this record in the database */
  globalId: Scalars['String'];
  /** also known as the binder grade */
  grade: Maybe<Scalars['String']>;
  /** the date this record was last updated in the database */
  lastEditedDate: Maybe<Scalars['DateTime']>;
  /** the username or email address of a mobile app user associated with the `lastEditedDate` */
  lastEditedUser: Maybe<Scalars['String']>;
  limsAsphaltLots: Array<LimsAsphaltLot>;
  maxAggregateSize: Maybe<Scalars['Float']>;
  mixDesignNumber: Maybe<Scalars['String']>;
  nominalSize: Maybe<Scalars['String']>;
  percentages: Array<AsphaltMixDesignTargetPercentage>;
  /** a related `Project` */
  project: Maybe<Project>;
  /** the `globalId` of a related `Project` */
  projectId: Maybe<Scalars['String']>;
  supplier: Maybe<Scalars['String']>;
  /** theoretical max specific gravity */
  theoMaxSpecGrav: Maybe<Scalars['Float']>;
  vma: Maybe<Scalars['Float']>;
};


export type AsphaltMixDesignAsphaltLotsArgs = {
  asphaltLotFieldInput?: InputMaybe<AsphaltLotFieldInput>;
};


export type AsphaltMixDesignLimsAsphaltLotsArgs = {
  limsAsphaltLotFieldInput?: InputMaybe<LimsAsphaltLotFieldInput>;
};


export type AsphaltMixDesignPercentagesArgs = {
  asphaltMixDesignTargetPercentageFieldInput?: InputMaybe<AsphaltMixDesignTargetPercentageFieldInput>;
};

/**
 * helps filter multiple `AsphaltMixDesign` records
 *
 * this version of the input will have limited options compared to its other counterpart
 */
export type AsphaltMixDesignFieldInput = {
  /**
   * - when `true`, `active` is truthy
   * - when `false`, `active` is falsy
   * - when omitted, `active` is ignored
   */
  active?: InputMaybe<Scalars['Boolean']>;
  bulkSpecGravAgg?: InputMaybe<FloatFilter>;
  createdDate?: InputMaybe<DateTimeFilter>;
  /**
   * determines now to handle deleted `AsphaltMixDesign` records
   *
   * - when `true`, only return deleted records
   * - when `false`, do not return deleted records
   * - when omitted, `deleted` is ignored
   */
  deleted?: InputMaybe<Scalars['Boolean']>;
  designBinderContent?: InputMaybe<FloatFilter>;
  lastEditedDate?: InputMaybe<DateTimeFilter>;
  maxAggregateSize?: InputMaybe<FloatFilter>;
  mixDesignNumber?: InputMaybe<StringFilter>;
  nominalSize?: InputMaybe<StringFilter>;
  /**
   * how to order `AsphaltMixDesign` records
   *
   * executed in the order they are defined
   */
  orderBy?: InputMaybe<Array<OrderByInput>>;
  projectId?: InputMaybe<StringFilter>;
  supplier?: InputMaybe<StringFilter>;
  /**
   * specifies how many records to return
   *
   * analogous to `limit`, `first`, or `top` in SQL dialects
   */
  take?: InputMaybe<Scalars['Int']>;
  theoMaxSpecGrav?: InputMaybe<FloatFilter>;
  vma?: InputMaybe<FloatFilter>;
};

/** helps filter multiple `AsphaltMixDesign` records */
export type AsphaltMixDesignListInput = {
  /**
   * - when `true`, `active` is truthy
   * - when `false`, `active` is falsy
   * - when omitted, `active` is ignored
   */
  active?: InputMaybe<Scalars['Boolean']>;
  bulkSpecGravAgg?: InputMaybe<FloatFilter>;
  createdDate?: InputMaybe<DateTimeFilter>;
  /**
   * determines now to handle deleted `AsphaltMixDesign` records
   *
   * - when `true`, only return deleted records
   * - when `false`, do not return deleted records
   * - when omitted, `deleted` is ignored
   */
  deleted?: InputMaybe<Scalars['Boolean']>;
  designBinderContent?: InputMaybe<FloatFilter>;
  lastEditedDate?: InputMaybe<DateTimeFilter>;
  maxAggregateSize?: InputMaybe<FloatFilter>;
  mixDesignNumber?: InputMaybe<StringFilter>;
  nominalSize?: InputMaybe<StringFilter>;
  /**
   * how to order `AsphaltMixDesign` records
   *
   * executed in the order they are defined
   */
  orderBy?: InputMaybe<Array<OrderByInput>>;
  /**
   * paginate `AsphaltMixDesign` records
   *
   * using `paginate` may require multiple requests to get all possible results,
   * but will give more fine-grain control in the event all records cannot be
   * returned gracefully
   */
  paginate?: InputMaybe<PaginationInput>;
  projectId?: InputMaybe<StringFilter>;
  supplier?: InputMaybe<StringFilter>;
  theoMaxSpecGrav?: InputMaybe<FloatFilter>;
  vma?: InputMaybe<FloatFilter>;
};

/** response metadata for a list query of AsphaltMixDesign records */
export type AsphaltMixDesignListResponse = {
  __typename: 'AsphaltMixDesignListResponse';
  /** the total count of AsphaltMixDesign records matching any configured filters */
  count: Scalars['Int'];
  /** the total count of paginated groups of AsphaltMixDesign */
  pages: Scalars['Int'];
  /** AsphaltMixDesign records */
  records: Array<AsphaltMixDesign>;
};

export type AsphaltMixDesignTargetPercentage = {
  __typename: 'AsphaltMixDesignTargetPercentage';
  /** the date this record was inserted into the database */
  createdDate: Scalars['DateTime'];
  /**
   * the email address of a user associated with the `createdDate`
   *
   * this value will be `unknown` if the `createdDate` was not set by a user
   */
  createdUser: Scalars['String'];
  /** the date this record was last updated in the database */
  lastEditedDate: Scalars['DateTime'];
  /**
   * the email address of a user associated with the `lastEditedDate`
   *
   * this value will be `system` if the `lastEditedDate` was not set by a user
   */
  lastEditedUser: Scalars['String'];
  mixDesign: AsphaltMixDesign;
  mixDesignId: Scalars['String'];
  /** assumed to be a number between 0 and 100 */
  percentage: Scalars['Float'];
  target: LimsAsphaltMixDesignTarget;
  targetId: Scalars['String'];
};

/**
 * helps filter multiple `AsphaltMixDesignTargetPercentage` records
 *
 * this version of the input will have limited options compared to its other counterpart
 */
export type AsphaltMixDesignTargetPercentageFieldInput = {
  lastEditedDate?: InputMaybe<DateTimeFilter>;
  mixDesignId?: InputMaybe<StringFilter>;
  /**
   * how to order `AsphaltMixDesignTargetPercentage` records
   *
   * executed in the order they are defined
   */
  orderBy?: InputMaybe<Array<OrderByInput>>;
  /**
   * specifies how many records to return
   *
   * analogous to `limit`, `first`, or `top` in SQL dialects
   */
  take?: InputMaybe<Scalars['Int']>;
  targetId?: InputMaybe<StringFilter>;
};

/** helps filter multiple `AsphaltMixDesignTargetPercentage` records */
export type AsphaltMixDesignTargetPercentageListInput = {
  lastEditedDate?: InputMaybe<DateTimeFilter>;
  mixDesignId?: InputMaybe<StringFilter>;
  /**
   * how to order `AsphaltMixDesignTargetPercentage` records
   *
   * executed in the order they are defined
   */
  orderBy?: InputMaybe<Array<OrderByInput>>;
  /**
   * paginate `AsphaltMixDesignTargetPercentage` records
   *
   * using `paginate` may require multiple requests to get all possible results,
   * but will give more fine-grain control in the event all records cannot be
   * returned gracefully
   */
  paginate?: InputMaybe<PaginationInput>;
  targetId?: InputMaybe<StringFilter>;
};

/** response metadata for a list query of AsphaltMixDesignTargetPercentage records */
export type AsphaltMixDesignTargetPercentageListResponse = {
  __typename: 'AsphaltMixDesignTargetPercentageListResponse';
  /** the total count of AsphaltMixDesignTargetPercentage records matching any configured filters */
  count: Scalars['Int'];
  /** the total count of paginated groups of AsphaltMixDesignTargetPercentage */
  pages: Scalars['Int'];
  /** AsphaltMixDesignTargetPercentage records */
  records: Array<AsphaltMixDesignTargetPercentage>;
};

export type AsphaltPlacement = {
  __typename: 'AsphaltPlacement';
  archiveDate: Maybe<Scalars['DateTime']>;
  archiveUser: Maybe<Scalars['String']>;
  archived: Maybe<Scalars['String']>;
  asphaltCoreMeasurements: Array<AsphaltCoreMeasurement>;
  asphaltLot: Maybe<AsphaltLot>;
  asphaltLotGuid: Maybe<Scalars['String']>;
  asphaltPlacementJoints: Array<AsphaltPlacementJoint>;
  averageThickness: Maybe<Scalars['Float']>;
  base64MapImage: Maybe<Scalars['String']>;
  beginAlignment: Maybe<Scalars['String']>;
  beginOffset: Maybe<Scalars['String']>;
  beginStation: Maybe<Scalars['String']>;
  closedDate: Maybe<Scalars['DateTime']>;
  contractor: Maybe<Contractor>;
  /** the `globalId` of a related `Contractor` */
  contractorGuid: Maybe<Scalars['String']>;
  /** the date this record was inserted into the database */
  createdDate: Maybe<Scalars['DateTime']>;
  /** the username or email address of a mobile app user associated with the `createdDate` */
  createdUser: Maybe<Scalars['String']>;
  deleted: Maybe<Scalars['String']>;
  endAlignment: Maybe<Scalars['String']>;
  endOffset: Maybe<Scalars['String']>;
  endStation: Maybe<Scalars['String']>;
  /** a GUID used to globally identify this record in the database */
  globalId: Scalars['String'];
  /** the date this record was last updated in the database */
  lastEditedDate: Maybe<Scalars['DateTime']>;
  /** the username or email address of a mobile app user associated with the `lastEditedDate` */
  lastEditedUser: Maybe<Scalars['String']>;
  linearFt: Maybe<Scalars['Float']>;
  manualMeasurements: Maybe<Scalars['String']>;
  mediaUploads: Array<MediaUpload>;
  /**
   * If set, contains a comma separated list of
   * `PayItemNoGeometry.globalId` values
   *
   * unfortunately, there have been instances where one of these values doesn't map
   * to a valid `PayItemNoGeometry`
   *
   * `payItemNoGeometries` will skip these rather than map them to `null`
   */
  multiplePayItems: Maybe<Scalars['String']>;
  notes: Maybe<Scalars['String']>;
  numberOfRequiredTests: Maybe<Scalars['Int']>;
  overrideComments: Maybe<Scalars['String']>;
  /**
   * aggregates all `PayItemNoGeometry` records associated with this
   * `AsphaltPlacement` by using its `PayItemNoGeometry` reference and `multiplePayItems`
   *
   * if any `PayItemNoGeometry.globalId` values used to query the database return `null`,
   * the `null` value will be filtered out of the results
   *
   * every result will be a valid `PayItemNoGeometry`
   */
  payItemNoGeometries: Array<PayItemNoGeometry>;
  payItemsGuid: Maybe<Scalars['String']>;
  placementId: Maybe<Scalars['String']>;
  placementQuantityTons: Maybe<Scalars['Float']>;
  placementType: Maybe<Scalars['String']>;
  /** a related `Project` */
  project: Maybe<Project>;
  /** the `globalId` of a related `Project` */
  projectId: Maybe<Scalars['String']>;
  reOpenedDate: Maybe<Scalars['DateTime']>;
  requiredThickness: Maybe<Scalars['Float']>;
  shape: Maybe<Scalars['String']>;
  sqFt: Maybe<Scalars['Float']>;
  sqYd: Maybe<Scalars['Float']>;
  status: Maybe<Scalars['String']>;
  technician: Maybe<Technician>;
  /** the `globalId` of a related `Technician` */
  technicianGuid: Maybe<Scalars['String']>;
  testedDate: Maybe<Scalars['DateTime']>;
};


export type AsphaltPlacementAsphaltCoreMeasurementsArgs = {
  asphaltCoreMeasurementFieldInput?: InputMaybe<AsphaltCoreMeasurementFieldInput>;
};


export type AsphaltPlacementAsphaltPlacementJointsArgs = {
  asphaltPlacementJointFieldInput?: InputMaybe<AsphaltPlacementJointFieldInput>;
};


export type AsphaltPlacementBase64MapImageArgs = {
  projectLayerIds?: InputMaybe<Array<Scalars['Int']>>;
};


export type AsphaltPlacementMediaUploadsArgs = {
  mediaUploadFieldInput?: InputMaybe<MediaUploadFieldInput>;
};


export type AsphaltPlacementPayItemNoGeometriesArgs = {
  payItemNoGeometryFieldInput?: InputMaybe<PayItemNoGeometryFieldInput>;
};

/**
 * helps filter multiple `AsphaltPlacement` records
 *
 * this version of the input will have limited options compared to its other counterpart
 */
export type AsphaltPlacementFieldInput = {
  createdDate?: InputMaybe<DateTimeFilter>;
  /**
   * determines now to handle deleted `AsphaltPlacement` records
   *
   * - when `true`, only return deleted records
   * - when `false`, do not return deleted records
   * - when omitted, `deleted` is ignored
   */
  deleted?: InputMaybe<Scalars['Boolean']>;
  lastEditedDate?: InputMaybe<DateTimeFilter>;
  /**
   * how to order `AsphaltPlacement` records
   *
   * executed in the order they are defined
   */
  orderBy?: InputMaybe<Array<OrderByInput>>;
  placementId?: InputMaybe<StringFilter>;
  projectId?: InputMaybe<StringFilter>;
  status?: InputMaybe<StringFilter>;
  /**
   * specifies how many records to return
   *
   * analogous to `limit`, `first`, or `top` in SQL dialects
   */
  take?: InputMaybe<Scalars['Int']>;
};

export type AsphaltPlacementJoint = {
  __typename: 'AsphaltPlacementJoint';
  archiveDate: Maybe<Scalars['DateTime']>;
  archiveUser: Maybe<Scalars['String']>;
  archived: Maybe<Scalars['String']>;
  asphaltCoreMeasurements: Array<AsphaltCoreMeasurement>;
  asphaltLot: Maybe<AsphaltLot>;
  asphaltLotGuid: Maybe<Scalars['String']>;
  asphaltPlacement: Maybe<AsphaltPlacement>;
  /** the `globalId` of a related `AsphaltPlacement` */
  asphaltPlacementGuid: Maybe<Scalars['String']>;
  closedDate: Maybe<Scalars['DateTime']>;
  /** the date this record was inserted into the database */
  createdDate: Maybe<Scalars['DateTime']>;
  /** the username or email address of a mobile app user associated with the `createdDate` */
  createdUser: Maybe<Scalars['String']>;
  deleted: Maybe<Scalars['String']>;
  endAlignment: Maybe<Scalars['String']>;
  endOffset: Maybe<Scalars['String']>;
  endStation: Maybe<Scalars['String']>;
  /** a GUID used to globally identify this record in the database */
  globalId: Scalars['String'];
  jointId: Maybe<Scalars['String']>;
  /** the date this record was last updated in the database */
  lastEditedDate: Maybe<Scalars['DateTime']>;
  /** the username or email address of a mobile app user associated with the `lastEditedDate` */
  lastEditedUser: Maybe<Scalars['String']>;
  linearFt: Maybe<Scalars['Float']>;
  manualMeasurements: Maybe<Scalars['String']>;
  notes: Maybe<Scalars['String']>;
  overrideComments: Maybe<Scalars['String']>;
  /** a related `Project` */
  project: Maybe<Project>;
  /** the `globalId` of a related `Project` */
  projectId: Maybe<Scalars['String']>;
  reOpenedDate: Maybe<Scalars['DateTime']>;
  shape: Maybe<Scalars['String']>;
  startAlignment: Maybe<Scalars['String']>;
  startOffset: Maybe<Scalars['String']>;
  startStation: Maybe<Scalars['String']>;
  status: Maybe<Scalars['String']>;
  testedDate: Maybe<Scalars['DateTime']>;
};


export type AsphaltPlacementJointAsphaltCoreMeasurementsArgs = {
  asphaltCoreMeasurementFieldInput?: InputMaybe<AsphaltCoreMeasurementFieldInput>;
};

/**
 * helps filter multiple `AsphaltPlacementJoint` records
 *
 * this version of the input will have limited options compared to its other counterpart
 */
export type AsphaltPlacementJointFieldInput = {
  createdDate?: InputMaybe<DateTimeFilter>;
  /**
   * determines now to handle deleted `AsphaltPlacementJoint` records
   *
   * - when `true`, only return deleted records
   * - when `false`, do not return deleted records
   * - when omitted, `deleted` is ignored
   */
  deleted?: InputMaybe<Scalars['Boolean']>;
  jointId?: InputMaybe<StringFilter>;
  lastEditedDate?: InputMaybe<DateTimeFilter>;
  /**
   * how to order `AsphaltPlacementJoint` records
   *
   * executed in the order they are defined
   */
  orderBy?: InputMaybe<Array<OrderByInput>>;
  projectId?: InputMaybe<StringFilter>;
  /**
   * specifies how many records to return
   *
   * analogous to `limit`, `first`, or `top` in SQL dialects
   */
  take?: InputMaybe<Scalars['Int']>;
};

/** helps filter multiple `AsphaltPlacementJoint` records */
export type AsphaltPlacementJointListInput = {
  createdDate?: InputMaybe<DateTimeFilter>;
  /**
   * determines now to handle deleted `AsphaltPlacementJoint` records
   *
   * - when `true`, only return deleted records
   * - when `false`, do not return deleted records
   * - when omitted, `deleted` is ignored
   */
  deleted?: InputMaybe<Scalars['Boolean']>;
  jointId?: InputMaybe<StringFilter>;
  lastEditedDate?: InputMaybe<DateTimeFilter>;
  /**
   * how to order `AsphaltPlacementJoint` records
   *
   * executed in the order they are defined
   */
  orderBy?: InputMaybe<Array<OrderByInput>>;
  /**
   * paginate `AsphaltPlacementJoint` records
   *
   * using `paginate` may require multiple requests to get all possible results,
   * but will give more fine-grain control in the event all records cannot be
   * returned gracefully
   */
  paginate?: InputMaybe<PaginationInput>;
  projectId?: InputMaybe<StringFilter>;
};

/** response metadata for a list query of AsphaltPlacementJoint records */
export type AsphaltPlacementJointListResponse = {
  __typename: 'AsphaltPlacementJointListResponse';
  /** the total count of AsphaltPlacementJoint records matching any configured filters */
  count: Scalars['Int'];
  /** the total count of paginated groups of AsphaltPlacementJoint */
  pages: Scalars['Int'];
  /** AsphaltPlacementJoint records */
  records: Array<AsphaltPlacementJoint>;
};

/** helps filter multiple `AsphaltPlacement` records */
export type AsphaltPlacementListInput = {
  createdDate?: InputMaybe<DateTimeFilter>;
  /**
   * determines now to handle deleted `AsphaltPlacement` records
   *
   * - when `true`, only return deleted records
   * - when `false`, do not return deleted records
   * - when omitted, `deleted` is ignored
   */
  deleted?: InputMaybe<Scalars['Boolean']>;
  lastEditedDate?: InputMaybe<DateTimeFilter>;
  /**
   * how to order `AsphaltPlacement` records
   *
   * executed in the order they are defined
   */
  orderBy?: InputMaybe<Array<OrderByInput>>;
  /**
   * paginate `AsphaltPlacement` records
   *
   * using `paginate` may require multiple requests to get all possible results,
   * but will give more fine-grain control in the event all records cannot be
   * returned gracefully
   */
  paginate?: InputMaybe<PaginationInput>;
  placementId?: InputMaybe<StringFilter>;
  projectId?: InputMaybe<StringFilter>;
  status?: InputMaybe<StringFilter>;
};

/** response metadata for a list query of AsphaltPlacement records */
export type AsphaltPlacementListResponse = {
  __typename: 'AsphaltPlacementListResponse';
  /** the total count of AsphaltPlacement records matching any configured filters */
  count: Scalars['Int'];
  /** the total count of paginated groups of AsphaltPlacement */
  pages: Scalars['Int'];
  /** AsphaltPlacement records */
  records: Array<AsphaltPlacement>;
};

export type AsphaltSample = {
  __typename: 'AsphaltSample';
  airTemp: Maybe<Scalars['Float']>;
  asphaltLot: Maybe<AsphaltLot>;
  asphaltLotGuid: Maybe<Scalars['String']>;
  asphaltSampleId: Maybe<Scalars['String']>;
  asphaltTemp: Maybe<Scalars['Float']>;
  closedDate: Maybe<Scalars['DateTime']>;
  /** the date this record was inserted into the database */
  createdDate: Maybe<Scalars['DateTime']>;
  /** the username or email address of a mobile app user associated with the `createdDate` */
  createdUser: Maybe<Scalars['String']>;
  deleted: Maybe<Scalars['String']>;
  /** a GUID used to globally identify this record in the database */
  globalId: Scalars['String'];
  /** the date this record was last updated in the database */
  lastEditedDate: Maybe<Scalars['DateTime']>;
  /** the username or email address of a mobile app user associated with the `lastEditedDate` */
  lastEditedUser: Maybe<Scalars['String']>;
  notes: Maybe<Scalars['String']>;
  offset: Maybe<Scalars['String']>;
  overrideComments: Maybe<Scalars['String']>;
  /** a related `Project` */
  project: Maybe<Project>;
  /** the `globalId` of a related `Project` */
  projectId: Maybe<Scalars['String']>;
  reOpenedDate: Maybe<Scalars['DateTime']>;
  sampleAtQuantity: Maybe<Scalars['Float']>;
  station: Maybe<Scalars['String']>;
  status: Maybe<Scalars['String']>;
  technician: Maybe<Technician>;
  /** the `globalId` of a related `Technician` */
  technicianGuid: Maybe<Scalars['String']>;
  timeSampled: Maybe<Scalars['DateTime']>;
  truckNumber: Maybe<Scalars['Int']>;
};

/**
 * helps filter multiple `AsphaltSample` records
 *
 * this version of the input will have limited options compared to its other counterpart
 */
export type AsphaltSampleFieldInput = {
  asphaltSampleId?: InputMaybe<StringFilter>;
  createdDate?: InputMaybe<DateTimeFilter>;
  /**
   * determines now to handle deleted `AsphaltSample` records
   *
   * - when `true`, only return deleted records
   * - when `false`, do not return deleted records
   * - when omitted, `deleted` is ignored
   */
  deleted?: InputMaybe<Scalars['Boolean']>;
  lastEditedDate?: InputMaybe<DateTimeFilter>;
  /**
   * how to order `AsphaltSample` records
   *
   * executed in the order they are defined
   */
  orderBy?: InputMaybe<Array<OrderByInput>>;
  projectId?: InputMaybe<StringFilter>;
  /**
   * specifies how many records to return
   *
   * analogous to `limit`, `first`, or `top` in SQL dialects
   */
  take?: InputMaybe<Scalars['Int']>;
};

/** helps filter multiple `AsphaltSample` records */
export type AsphaltSampleListInput = {
  asphaltSampleId?: InputMaybe<StringFilter>;
  createdDate?: InputMaybe<DateTimeFilter>;
  /**
   * determines now to handle deleted `AsphaltSample` records
   *
   * - when `true`, only return deleted records
   * - when `false`, do not return deleted records
   * - when omitted, `deleted` is ignored
   */
  deleted?: InputMaybe<Scalars['Boolean']>;
  lastEditedDate?: InputMaybe<DateTimeFilter>;
  /**
   * how to order `AsphaltSample` records
   *
   * executed in the order they are defined
   */
  orderBy?: InputMaybe<Array<OrderByInput>>;
  /**
   * paginate `AsphaltSample` records
   *
   * using `paginate` may require multiple requests to get all possible results,
   * but will give more fine-grain control in the event all records cannot be
   * returned gracefully
   */
  paginate?: InputMaybe<PaginationInput>;
  projectId?: InputMaybe<StringFilter>;
};

/** response metadata for a list query of AsphaltSample records */
export type AsphaltSampleListResponse = {
  __typename: 'AsphaltSampleListResponse';
  /** the total count of AsphaltSample records matching any configured filters */
  count: Scalars['Int'];
  /** the total count of paginated groups of AsphaltSample */
  pages: Scalars['Int'];
  /** AsphaltSample records */
  records: Array<AsphaltSample>;
};

/** values required to associate an existing `Project` with CIMS Online */
export type AssociateProjectWithCimsInput = {
  /**
   * the id associated with the Project in the CM_Project_Layers Map Server
   *
   *     this id is used to get design layers for PDF Design Layers and should only need to be set once
   *
   *     if it does change, this may lead to incorrectly configured PDF Design Layers
   */
  cmProjectLayersId?: InputMaybe<Scalars['Float']>;
  /** the `globalId` of a related `Project` */
  projectId: Scalars['String'];
  /**
   * the name of the SharePoint site that appears after `/site`
   * in the SharePoint site webURL
   *
   * for example `https://horrocksengineersinc.sharepoint.com/sites/{sharePointSiteName}`
   */
  sharePointSiteName: Scalars['String'];
  /**
   * a list of Azure User Group Ids to associate with the `Project`
   *
   * an error is thrown if this, or `userGroupNames`, is not defined
   *
   * if both `userGroupNames` and `userGroupIds` are defined, `userGroupIds` takes precedence
   */
  userGroupIds?: InputMaybe<Array<Scalars['String']>>;
  /**
   * a list of Azure User Group Names to associate with the `Project`
   *
   * an error is thrown if this, or `userGroupIds`, is not defined
   *
   * if both `userGroupNames` and `userGroupIds` are defined, `userGroupIds` takes precedence
   */
  userGroupNames?: InputMaybe<Array<Scalars['String']>>;
};

export type AssociateProjectWithCimsResponse = {
  __typename: 'AssociateProjectWithCIMSResponse';
  project: Project;
};

export type BaseFrequency = {
  next: Scalars['DateTime'];
  previous: Scalars['DateTime'];
};

export type BatchReportAverage = {
  __typename: 'BatchReportAverage';
  /** the average time spent generating the report associated with the `reportId` */
  milliseconds: Scalars['Int'];
  project: Project;
  projectId: Scalars['String'];
  report: Scalars['String'];
  /** an unmodified Report id */
  reportId: Scalars['String'];
};

/** holds error metadata for errors encountered during generation */
export type BatchReportErrorJson = {
  __typename: 'BatchReportErrorJSON';
  /** the `globalId` of the type used to generate the `report` */
  globalId: Maybe<Scalars['String']>;
  /** the message associated with the error */
  message: Scalars['String'];
  report: Maybe<Scalars['String']>;
  /** a stack trace that may have been included with the error */
  stack: Maybe<Scalars['String']>;
};

/** stores current and past Batch Report requests */
export type BatchReportRequest = {
  __typename: 'BatchReportRequest';
  /** the actual time it took to completely fulfill the request in milliseconds */
  actualMilliseconds: Maybe<Scalars['Int']>;
  /** `actualMilliseconds` formatted into a more human readable value */
  actualString: Maybe<Scalars['String']>;
  /** the date this record was inserted into the database */
  createdDate: Scalars['DateTime'];
  /**
   * the email address of a user associated with the `createdDate`
   *
   * this value will be `unknown` if the `createdDate` was not set by a user
   */
  createdUser: Scalars['String'];
  /**
   * the estimated time it will take to completely fulfill _this_ request in milliseconds
   *
   *   does not include the time it may have to wait to start
   */
  estimatedMilliseconds: Scalars['Int'];
  /** `estimatedMilliseconds` formatted into a more human readable value */
  estimatedString: Scalars['String'];
  /** a timestamp describing when the archive associated with this request is marked for deletion */
  expirationDate: Maybe<Scalars['DateTime']>;
  /** whether the request is expired and therefore considered deletable */
  expired: Scalars['Boolean'];
  /**
   * a timestamp describing when the request was finished
   *
   * if the request was cancelled, this value will not be set
   */
  finishedDate: Maybe<Scalars['DateTime']>;
  /** a UUID used to globally identify this record in the database */
  id: Scalars['String'];
  /** a JSON containing metadata associated with the request */
  json: BatchReportRequestJson;
  /** the date this record was last updated in the database */
  lastEditedDate: Scalars['DateTime'];
  /**
   * the email address of a user associated with the `lastEditedDate`
   *
   * this value will be `system` if the `lastEditedDate` was not set by a user
   */
  lastEditedUser: Scalars['String'];
  /** a related `Project` */
  project: Project;
  /** the `globalId` of a related `Project` */
  projectId: Scalars['String'];
  /**
   * a related `User` which requests the `BatchReportRequest`
   *
   * this `User` is also notified via email after the request completes with download instructions
   */
  requestedBy: User;
  /** the `id` of a related `User` which requests the `QueuableEntity` */
  requestedById: Scalars['String'];
  /** a timestamp describing when the request was started */
  startedDate: Maybe<Scalars['DateTime']>;
  /** the `id` of a related `QueuableRequestStatus` */
  statusId: Scalars['String'];
};

export type BatchReportRequestArgumentsJson = {
  __typename: 'BatchReportRequestArgumentsJSON';
  dateRange: Maybe<DateRange>;
  /** a list of `PayItemNoGeometry.globalId` values */
  payItemIds: Array<Scalars['String']>;
  /** `PayItemNoGeometry` records associated with `payItemIds` */
  payItemNoGeometries: Array<PayItemNoGeometry>;
  reportIds: Array<Scalars['String']>;
};


export type BatchReportRequestArgumentsJsonPayItemNoGeometriesArgs = {
  payItemNoGeometryFieldInput?: InputMaybe<PayItemNoGeometryFieldInput>;
};

/**
 * helps filter multiple `BatchReportRequest` records
 *
 * this version of the input will have limited options compared to its other counterpart
 */
export type BatchReportRequestFieldInput = {
  actualMilliseconds?: InputMaybe<IntFilter>;
  createdDate?: InputMaybe<DateTimeFilter>;
  /**
   * - when `true`, only include records with errors
   * - when `false`, exclude any record with errors
   * - when omitted, `errored` is ignored
   */
  errored?: InputMaybe<Scalars['Boolean']>;
  estimatedMilliseconds?: InputMaybe<IntFilter>;
  finishedDate?: InputMaybe<DateTimeFilter>;
  lastEditedDate?: InputMaybe<DateTimeFilter>;
  /**
   * how to order `BatchReportRequest` records
   *
   * executed in the order they are defined
   */
  orderBy?: InputMaybe<Array<OrderByInput>>;
  projectId?: InputMaybe<StringFilter>;
  requestedById?: InputMaybe<StringFilter>;
  startedDate?: InputMaybe<DateTimeFilter>;
  statusId?: InputMaybe<StringFilter>;
  /**
   * specifies how many records to return
   *
   * analogous to `limit`, `first`, or `top` in SQL dialects
   */
  take?: InputMaybe<Scalars['Int']>;
};

export type BatchReportRequestJson = {
  __typename: 'BatchReportRequestJSON';
  /** arguments used to configure the request */
  arguments: BatchReportRequestArgumentsJson;
  /** a list of errors encountered during execution */
  errors: Array<BatchReportErrorJson>;
};

/** helps filter multiple `BatchReportRequest` records */
export type BatchReportRequestListInput = {
  actualMilliseconds?: InputMaybe<IntFilter>;
  createdDate?: InputMaybe<DateTimeFilter>;
  /**
   * - when `true`, only include records with errors
   * - when `false`, exclude any record with errors
   * - when omitted, `errored` is ignored
   */
  errored?: InputMaybe<Scalars['Boolean']>;
  estimatedMilliseconds?: InputMaybe<IntFilter>;
  finishedDate?: InputMaybe<DateTimeFilter>;
  lastEditedDate?: InputMaybe<DateTimeFilter>;
  /**
   * how to order `BatchReportRequest` records
   *
   * executed in the order they are defined
   */
  orderBy?: InputMaybe<Array<OrderByInput>>;
  /**
   * paginate `BatchReportRequest` records
   *
   * using `paginate` may require multiple requests to get all possible results,
   * but will give more fine-grain control in the event all records cannot be
   * returned gracefully
   */
  paginate?: InputMaybe<PaginationInput>;
  projectId?: InputMaybe<StringFilter>;
  requestedById?: InputMaybe<StringFilter>;
  startedDate?: InputMaybe<DateTimeFilter>;
  statusId?: InputMaybe<StringFilter>;
};

/** response metadata for a list query of BatchReportRequest records */
export type BatchReportRequestListResponse = {
  __typename: 'BatchReportRequestListResponse';
  /** the total count of BatchReportRequest records matching any configured filters */
  count: Scalars['Int'];
  /** the total count of paginated groups of BatchReportRequest */
  pages: Scalars['Int'];
  /** BatchReportRequest records */
  records: Array<BatchReportRequest>;
};

/** a simple checkbox */
export type BooleanCustomFieldValue = {
  __typename: 'BooleanCustomFieldValue';
  /** the date this record was inserted into the database */
  createdDate: Scalars['DateTime'];
  /**
   * the email address of a user associated with the `createdDate`
   *
   * this value will be `unknown` if the `createdDate` was not set by a user
   */
  createdUser: Scalars['String'];
  customField: CustomField;
  /** the `id` of a related `CustomField` */
  customFieldId: Scalars['String'];
  /** the date this record was soft-deleted in the database */
  deletedDate: Maybe<Scalars['DateTime']>;
  /**
   * the email address of a user associated with the `deletedDate`
   *
   * this value will be `system` if the `deletedDate` was not set by a user
   */
  deletedUser: Maybe<Scalars['String']>;
  /** the date this record was last updated in the database */
  lastEditedDate: Scalars['DateTime'];
  /**
   * the email address of a user associated with the `lastEditedDate`
   *
   * this value will be `system` if the `lastEditedDate` was not set by a user
   */
  lastEditedUser: Scalars['String'];
  /** a Boolean value */
  value: Scalars['Boolean'];
};

export type BooleanListCustomFieldValue = {
  __typename: 'BooleanListCustomFieldValue';
  /** whether the `CustomListItem` is checked or not */
  checked: Scalars['Boolean'];
  customListItem: CustomListItem;
  /** the `id` of a related `CustomListItem` */
  customListItemId: Scalars['String'];
};

/** undefined with pre-defined values */
export type BooleanListCustomFieldValues = {
  __typename: 'BooleanListCustomFieldValues';
  booleans: Array<BooleanListCustomFieldValue>;
  /** the date this record was inserted into the database */
  createdDate: Scalars['DateTime'];
  /**
   * the email address of a user associated with the `createdDate`
   *
   * this value will be `unknown` if the `createdDate` was not set by a user
   */
  createdUser: Scalars['String'];
  customField: CustomField;
  /** the `id` of a related `CustomField` */
  customFieldId: Scalars['String'];
  /** the date this record was soft-deleted in the database */
  deletedDate: Maybe<Scalars['DateTime']>;
  /**
   * the email address of a user associated with the `deletedDate`
   *
   * this value will be `system` if the `deletedDate` was not set by a user
   */
  deletedUser: Maybe<Scalars['String']>;
  /** the date this record was last updated in the database */
  lastEditedDate: Scalars['DateTime'];
  /**
   * the email address of a user associated with the `lastEditedDate`
   *
   * this value will be `system` if the `lastEditedDate` was not set by a user
   */
  lastEditedUser: Scalars['String'];
};

export type ByCasRoutingGroup = {
  __typename: 'ByCASRoutingGroup';
  recipients: Recipients;
  routingGroup: CasRoutingGroup;
};

export type ByCasRoutingGroupInput = {
  recipients: RecipientsInput;
  routingGroupId: Scalars['String'];
};

export type ByConcreteMaterial = {
  __typename: 'ByConcreteMaterial';
  concreteMaterial: ConcreteMaterial;
  recipients: Recipients;
};

export type ByConcreteMaterialInput = {
  concreteMaterialId: Scalars['String'];
  recipients: RecipientsInput;
};

export type ByConcreteMixDesign = {
  __typename: 'ByConcreteMixDesign';
  concreteMixDesign: ConcreteMixDesign;
  recipients: Recipients;
};

export type ByConcreteMixDesignInput = {
  concreteMixDesignId: Scalars['String'];
  recipients: RecipientsInput;
};

export type ByDsDiscipline = {
  __typename: 'ByDSDiscipline';
  discipline: DsDiscipline;
  recipients: Recipients;
};

export type ByDsDisciplineInput = {
  dsDisciplineId: Scalars['String'];
  recipients: RecipientsInput;
};

export type ByFdcApprovalGroup = {
  __typename: 'ByFDCApprovalGroup';
  approvalGroup: FdcApprovalGroup;
  recipients: Recipients;
};

export type ByFdcApprovalGroupInput = {
  approvalGroupId: Scalars['String'];
  recipients: RecipientsInput;
};

export type ByFdcConcurrenceGroup = {
  __typename: 'ByFDCConcurrenceGroup';
  concurrenceGroup: FdcConcurrenceGroup;
  recipients: Recipients;
};

export type ByFdcConcurrenceGroupInput = {
  concurrenceGroupId: Scalars['String'];
  recipients: RecipientsInput;
};

export type ByFdcConcurrenceLevel = {
  __typename: 'ByFDCConcurrenceLevel';
  concurrenceLevel: FdcConcurrenceLevel;
  recipients: Recipients;
};

export type ByFdcConcurrenceLevelAndApprovalGroup = {
  __typename: 'ByFDCConcurrenceLevelAndApprovalGroup';
  approvalGroup: FdcApprovalGroup;
  concurrenceLevel: FdcConcurrenceLevel;
  recipients: Recipients;
};

export type ByFdcConcurrenceLevelAndApprovalGroupInput = {
  approvalGroupId: Scalars['String'];
  concurrenceLevelId: Scalars['String'];
  recipients: RecipientsInput;
};

export type ByFdcConcurrenceLevelAndConcurrenceGroup = {
  __typename: 'ByFDCConcurrenceLevelAndConcurrenceGroup';
  concurrenceGroup: FdcConcurrenceGroup;
  concurrenceLevel: FdcConcurrenceLevel;
  recipients: Recipients;
};

export type ByFdcConcurrenceLevelAndConcurrenceGroupInput = {
  concurrenceGroupId: Scalars['String'];
  concurrenceLevelId: Scalars['String'];
  recipients: RecipientsInput;
};

export type ByFdcConcurrenceLevelInput = {
  concurrenceLevelId: Scalars['String'];
  recipients: RecipientsInput;
};

export type ByIfiReportType = {
  __typename: 'ByIFIReportType';
  recipients: Recipients;
  typeId: Scalars['String'];
};

export type ByIssueType = {
  __typename: 'ByIssueType';
  recipients: Recipients;
  type: IssueType;
  typeId: Scalars['String'];
};

export type ByIssueTypeInput = {
  recipients: RecipientsInput;
  typeId: Scalars['String'];
};

export type ByResponseDiscipline = {
  __typename: 'ByResponseDiscipline';
  recipients: Recipients;
  responseDiscipline: RfiResponseDiscipline;
};

export type ByResponseDisciplineInput = {
  recipients: RecipientsInput;
  responseDisciplineId: Scalars['String'];
};

/** comments made against related `ConstructionAdminSubmittal` records */
export type CasComment = {
  __typename: 'CASComment';
  /** the date this record was inserted into the database */
  createdDate: Scalars['DateTime'];
  /**
   * the email address of a user associated with the `createdDate`
   *
   * this value will be `unknown` if the `createdDate` was not set by a user
   */
  createdUser: Scalars['String'];
  /** describes whether the record has been soft-deleted or not */
  deleted: Scalars['Boolean'];
  /** the date this record was soft-deleted in the database */
  deletedDate: Maybe<Scalars['DateTime']>;
  /**
   * the email address of a user associated with the `deletedDate`
   *
   * this value will be `system` if the `deletedDate` was not set by a user
   */
  deletedUser: Maybe<Scalars['String']>;
  /** a UUID used to globally identify this record in the database */
  id: Scalars['String'];
  /** the date this record was last updated in the database */
  lastEditedDate: Scalars['DateTime'];
  /**
   * the email address of a user associated with the `lastEditedDate`
   *
   * this value will be `system` if the `lastEditedDate` was not set by a user
   */
  lastEditedUser: Scalars['String'];
  submittal: ConstructionAdminSubmittal;
  submittalId: Scalars['String'];
  /**
   * the text of the comment
   *
   * limited to 1000 characters
   */
  text: Scalars['String'];
  user: User;
  /** the `id` of a related `User` */
  userId: Scalars['String'];
};

/**
 * helps filter multiple `CASComment` records
 *
 * this version of the input will have limited options compared to its other counterpart
 */
export type CasCommentFieldInput = {
  createdDate?: InputMaybe<DateTimeFilter>;
  /**
   * determines now to handle deleted `CASComment` records
   *
   * - when `true`, only return deleted records
   * - when `false`, do not return deleted records
   * - when omitted, `deleted` is ignored
   */
  deleted?: InputMaybe<Scalars['Boolean']>;
  lastEditedDate?: InputMaybe<DateTimeFilter>;
  /**
   * how to order `CASComment` records
   *
   * executed in the order they are defined
   */
  orderBy?: InputMaybe<Array<OrderByInput>>;
  submittalId?: InputMaybe<StringFilter>;
  /**
   * specifies how many records to return
   *
   * analogous to `limit`, `first`, or `top` in SQL dialects
   */
  take?: InputMaybe<Scalars['Int']>;
  text?: InputMaybe<StringFilter>;
  userId?: InputMaybe<StringFilter>;
};

/** helps filter multiple `CASComment` records */
export type CasCommentListInput = {
  createdDate?: InputMaybe<DateTimeFilter>;
  /**
   * determines now to handle deleted `CASComment` records
   *
   * - when `true`, only return deleted records
   * - when `false`, do not return deleted records
   * - when omitted, `deleted` is ignored
   */
  deleted?: InputMaybe<Scalars['Boolean']>;
  lastEditedDate?: InputMaybe<DateTimeFilter>;
  /**
   * how to order `CASComment` records
   *
   * executed in the order they are defined
   */
  orderBy?: InputMaybe<Array<OrderByInput>>;
  /**
   * paginate `CASComment` records
   *
   * using `paginate` may require multiple requests to get all possible results,
   * but will give more fine-grain control in the event all records cannot be
   * returned gracefully
   */
  paginate?: InputMaybe<PaginationInput>;
  submittalId?: InputMaybe<StringFilter>;
  text?: InputMaybe<StringFilter>;
  userId?: InputMaybe<StringFilter>;
};

/** response metadata for a list query of CASComment records */
export type CasCommentListResponse = {
  __typename: 'CASCommentListResponse';
  /** the total count of CASComment records matching any configured filters */
  count: Scalars['Int'];
  /** the total count of paginated groups of CASComment */
  pages: Scalars['Int'];
  /** CASComment records */
  records: Array<CasComment>;
};

export type CasDispositionType = {
  __typename: 'CASDispositionType';
  /** the date this record was inserted into the database */
  createdDate: Scalars['DateTime'];
  /**
   * the email address of a user associated with the `createdDate`
   *
   * this value will be `unknown` if the `createdDate` was not set by a user
   */
  createdUser: Scalars['String'];
  /** describes whether the record has been soft-deleted or not */
  deleted: Scalars['Boolean'];
  /** the date this record was soft-deleted in the database */
  deletedDate: Maybe<Scalars['DateTime']>;
  /**
   * the email address of a user associated with the `deletedDate`
   *
   * this value will be `system` if the `deletedDate` was not set by a user
   */
  deletedUser: Maybe<Scalars['String']>;
  /**
   * an extended description associated with the record
   *
   * this description will be used to describe the record in CIMS, where possible
   */
  description: Maybe<Scalars['String']>;
  /** a UUID used to globally identify this record in the database */
  id: Scalars['String'];
  /** the date this record was last updated in the database */
  lastEditedDate: Scalars['DateTime'];
  /**
   * the email address of a user associated with the `lastEditedDate`
   *
   * this value will be `system` if the `lastEditedDate` was not set by a user
   */
  lastEditedUser: Scalars['String'];
  /** a human readable name associated with the record */
  name: Scalars['String'];
  /** a related `Project` */
  project: Project;
  /** the `globalId` of a related `Project` */
  projectId: Scalars['String'];
  requiresComments: Scalars['Boolean'];
  submittals: Array<ConstructionAdminSubmittal>;
};


export type CasDispositionTypeSubmittalsArgs = {
  constructionAdminSubmittalFieldInput?: InputMaybe<ConstructionAdminSubmittalFieldInput>;
};

/**
 * helps filter multiple `CASDispositionType` records
 *
 * this version of the input will have limited options compared to its other counterpart
 */
export type CasDispositionTypeFieldInput = {
  createdDate?: InputMaybe<DateTimeFilter>;
  /**
   * determines now to handle deleted `CASDispositionType` records
   *
   * - when `true`, only return deleted records
   * - when `false`, do not return deleted records
   * - when omitted, `deleted` is ignored
   */
  deleted?: InputMaybe<Scalars['Boolean']>;
  description?: InputMaybe<StringFilter>;
  id?: InputMaybe<StringFilter>;
  lastEditedDate?: InputMaybe<DateTimeFilter>;
  name?: InputMaybe<StringFilter>;
  /**
   * how to order `CASDispositionType` records
   *
   * executed in the order they are defined
   */
  orderBy?: InputMaybe<Array<OrderByInput>>;
  projectId?: InputMaybe<StringFilter>;
  /**
   * specifies how many records to return
   *
   * analogous to `limit`, `first`, or `top` in SQL dialects
   */
  take?: InputMaybe<Scalars['Int']>;
};

/** helps filter multiple `CASDispositionType` records */
export type CasDispositionTypeListInput = {
  createdDate?: InputMaybe<DateTimeFilter>;
  /**
   * determines now to handle deleted `CASDispositionType` records
   *
   * - when `true`, only return deleted records
   * - when `false`, do not return deleted records
   * - when omitted, `deleted` is ignored
   */
  deleted?: InputMaybe<Scalars['Boolean']>;
  description?: InputMaybe<StringFilter>;
  id?: InputMaybe<StringFilter>;
  lastEditedDate?: InputMaybe<DateTimeFilter>;
  name?: InputMaybe<StringFilter>;
  /**
   * how to order `CASDispositionType` records
   *
   * executed in the order they are defined
   */
  orderBy?: InputMaybe<Array<OrderByInput>>;
  /**
   * paginate `CASDispositionType` records
   *
   * using `paginate` may require multiple requests to get all possible results,
   * but will give more fine-grain control in the event all records cannot be
   * returned gracefully
   */
  paginate?: InputMaybe<PaginationInput>;
  projectId?: InputMaybe<StringFilter>;
};

/** response metadata for a list query of CASDispositionType records */
export type CasDispositionTypeListResponse = {
  __typename: 'CASDispositionTypeListResponse';
  /** the total count of CASDispositionType records matching any configured filters */
  count: Scalars['Int'];
  /** the total count of paginated groups of CASDispositionType */
  pages: Scalars['Int'];
  /** CASDispositionType records */
  records: Array<CasDispositionType>;
};

/**
 * notifications hold a recipients configuration for a given
 * notification event in Submittal Tracker workflows
 *
 * recipients can be users, or non user emails
 *
 * certain events may require users to receive a notification if they are given permission
 * to perform a specific task
 */
export type CasNotification = {
  __typename: 'CASNotification';
  /** the date this record was inserted into the database */
  createdDate: Scalars['DateTime'];
  /**
   * the email address of a user associated with the `createdDate`
   *
   * this value will be `unknown` if the `createdDate` was not set by a user
   */
  createdUser: Scalars['String'];
  /** the date this record was last updated in the database */
  lastEditedDate: Scalars['DateTime'];
  /**
   * the email address of a user associated with the `lastEditedDate`
   *
   * this value will be `system` if the `lastEditedDate` was not set by a user
   */
  lastEditedUser: Scalars['String'];
  /** the name of the notification event associated with this Notification */
  notificationEvent: Scalars['String'];
  notificationEventId: Scalars['String'];
  /** a related `Project` */
  project: Project;
  /** the `globalId` of a related `Project` */
  projectId: Scalars['String'];
  recipients: CasNotificationRecipients;
  settings: Maybe<CasNotificationSettingsJson>;
};

/**
 * helps filter multiple `CASNotification` records
 *
 * this version of the input will have limited options compared to its other counterpart
 */
export type CasNotificationFieldInput = {
  createdDate?: InputMaybe<DateTimeFilter>;
  lastEditedDate?: InputMaybe<DateTimeFilter>;
  notificationEventId?: InputMaybe<StringFilter>;
  /**
   * how to order `CASNotification` records
   *
   * executed in the order they are defined
   */
  orderBy?: InputMaybe<Array<OrderByInput>>;
  projectId?: InputMaybe<StringFilter>;
  /**
   * specifies how many records to return
   *
   * analogous to `limit`, `first`, or `top` in SQL dialects
   */
  take?: InputMaybe<Scalars['Int']>;
};

/** helps filter multiple `CASNotification` records */
export type CasNotificationListInput = {
  createdDate?: InputMaybe<DateTimeFilter>;
  lastEditedDate?: InputMaybe<DateTimeFilter>;
  notificationEventId?: InputMaybe<StringFilter>;
  /**
   * how to order `CASNotification` records
   *
   * executed in the order they are defined
   */
  orderBy?: InputMaybe<Array<OrderByInput>>;
  /**
   * paginate `CASNotification` records
   *
   * using `paginate` may require multiple requests to get all possible results,
   * but will give more fine-grain control in the event all records cannot be
   * returned gracefully
   */
  paginate?: InputMaybe<PaginationInput>;
  projectId?: InputMaybe<StringFilter>;
};

/** response metadata for a list query of CASNotification records */
export type CasNotificationListResponse = {
  __typename: 'CASNotificationListResponse';
  /** the total count of CASNotification records matching any configured filters */
  count: Scalars['Int'];
  /** the total count of paginated groups of CASNotification */
  pages: Scalars['Int'];
  /** CASNotification records */
  records: Array<CasNotification>;
};

export type CasNotificationRecipients = {
  __typename: 'CASNotificationRecipients';
  byRoutingGroup: Array<ByCasRoutingGroup>;
  every: Maybe<Recipients>;
};


export type CasNotificationRecipientsByRoutingGroupArgs = {
  casRoutingGroupFieldInput?: InputMaybe<CasRoutingGroupFieldInput>;
};

export type CasNotificationSettingsInput = {
  frequency?: InputMaybe<DailyFrequencyInput>;
  threshold?: InputMaybe<Scalars['Float']>;
};

export type CasNotificationSettingsJson = {
  __typename: 'CASNotificationSettingsJSON';
  /** Defaults to 08:00 */
  frequency: DailyFrequency;
  /** Defaults to 3 */
  notificationThresholdDay: Scalars['Float'];
};

/**
 * `CASQuickLink` records are used in the External Link Editor to allow users
 * to quickly add external links to the `externalLinks` field of a `ConstructionAdminSubmittal`
 *
 * `CASQuickLink` records used in `externalLinks` are not referenced by `id`, but copied
 * as they are currently defined
 *
 * changes made to any `CASQuickLink` record will not affect the `externalLinks` of the `ConstructionAdminSubmittal`
 */
export type CasQuickLink = {
  __typename: 'CASQuickLink';
  /** the date this record was inserted into the database */
  createdDate: Scalars['DateTime'];
  /**
   * the email address of a user associated with the `createdDate`
   *
   * this value will be `unknown` if the `createdDate` was not set by a user
   */
  createdUser: Scalars['String'];
  /** describes whether the record has been soft-deleted or not */
  deleted: Scalars['Boolean'];
  /** the date this record was soft-deleted in the database */
  deletedDate: Maybe<Scalars['DateTime']>;
  /**
   * the email address of a user associated with the `deletedDate`
   *
   * this value will be `system` if the `deletedDate` was not set by a user
   */
  deletedUser: Maybe<Scalars['String']>;
  /**
   * an extended description associated with the record
   *
   * this description will be used to describe the record in CIMS, where possible
   */
  description: Maybe<Scalars['String']>;
  /** an optional link associated with the `label` */
  href: Maybe<Scalars['String']>;
  /** a UUID used to globally identify this record in the database */
  id: Scalars['String'];
  /** the human readable link text */
  label: Scalars['String'];
  /** the date this record was last updated in the database */
  lastEditedDate: Scalars['DateTime'];
  /**
   * the email address of a user associated with the `lastEditedDate`
   *
   * this value will be `system` if the `lastEditedDate` was not set by a user
   */
  lastEditedUser: Scalars['String'];
  project: Project;
  /** the `globalId` of a related `Project` */
  projectId: Scalars['String'];
};

/**
 * helps filter multiple `CASQuickLink` records
 *
 * this version of the input will have limited options compared to its other counterpart
 */
export type CasQuickLinkFieldInput = {
  createdDate?: InputMaybe<DateTimeFilter>;
  /**
   * determines now to handle deleted `CASQuickLink` records
   *
   * - when `true`, only return deleted records
   * - when `false`, do not return deleted records
   * - when omitted, `deleted` is ignored
   */
  deleted?: InputMaybe<Scalars['Boolean']>;
  description?: InputMaybe<StringFilter>;
  href?: InputMaybe<StringFilter>;
  id?: InputMaybe<StringFilter>;
  label?: InputMaybe<StringFilter>;
  lastEditedDate?: InputMaybe<DateTimeFilter>;
  /**
   * how to order `CASQuickLink` records
   *
   * executed in the order they are defined
   */
  orderBy?: InputMaybe<Array<OrderByInput>>;
  projectId?: InputMaybe<StringFilter>;
  /**
   * specifies how many records to return
   *
   * analogous to `limit`, `first`, or `top` in SQL dialects
   */
  take?: InputMaybe<Scalars['Int']>;
};

/** helps filter multiple `CASQuickLink` records */
export type CasQuickLinkListInput = {
  createdDate?: InputMaybe<DateTimeFilter>;
  /**
   * determines now to handle deleted `CASQuickLink` records
   *
   * - when `true`, only return deleted records
   * - when `false`, do not return deleted records
   * - when omitted, `deleted` is ignored
   */
  deleted?: InputMaybe<Scalars['Boolean']>;
  description?: InputMaybe<StringFilter>;
  href?: InputMaybe<StringFilter>;
  id?: InputMaybe<StringFilter>;
  label?: InputMaybe<StringFilter>;
  lastEditedDate?: InputMaybe<DateTimeFilter>;
  /**
   * how to order `CASQuickLink` records
   *
   * executed in the order they are defined
   */
  orderBy?: InputMaybe<Array<OrderByInput>>;
  /**
   * paginate `CASQuickLink` records
   *
   * using `paginate` may require multiple requests to get all possible results,
   * but will give more fine-grain control in the event all records cannot be
   * returned gracefully
   */
  paginate?: InputMaybe<PaginationInput>;
  projectId?: InputMaybe<StringFilter>;
};

/** response metadata for a list query of CASQuickLink records */
export type CasQuickLinkListResponse = {
  __typename: 'CASQuickLinkListResponse';
  /** the total count of CASQuickLink records matching any configured filters */
  count: Scalars['Int'];
  /** the total count of paginated groups of CASQuickLink */
  pages: Scalars['Int'];
  /** CASQuickLink records */
  records: Array<CasQuickLink>;
};

export type CasRoutingGroup = {
  __typename: 'CASRoutingGroup';
  casToCASRoutingGroups: Array<CasToCasRoutingGroup>;
  /** the date this record was inserted into the database */
  createdDate: Scalars['DateTime'];
  /**
   * the email address of a user associated with the `createdDate`
   *
   * this value will be `unknown` if the `createdDate` was not set by a user
   */
  createdUser: Scalars['String'];
  /** describes whether the record has been soft-deleted or not */
  deleted: Scalars['Boolean'];
  /** the date this record was soft-deleted in the database */
  deletedDate: Maybe<Scalars['DateTime']>;
  /**
   * the email address of a user associated with the `deletedDate`
   *
   * this value will be `system` if the `deletedDate` was not set by a user
   */
  deletedUser: Maybe<Scalars['String']>;
  /**
   * an extended description associated with the record
   *
   * this description will be used to describe the record in CIMS, where possible
   */
  description: Maybe<Scalars['String']>;
  /** a UUID used to globally identify this record in the database */
  id: Scalars['String'];
  /** the date this record was last updated in the database */
  lastEditedDate: Scalars['DateTime'];
  /**
   * the email address of a user associated with the `lastEditedDate`
   *
   * this value will be `system` if the `lastEditedDate` was not set by a user
   */
  lastEditedUser: Scalars['String'];
  /** a human readable name associated with the record */
  name: Scalars['String'];
  /** a related `Project` */
  project: Project;
  /** the `globalId` of a related `Project` */
  projectId: Scalars['String'];
  users: Array<User>;
};


export type CasRoutingGroupCasToCasRoutingGroupsArgs = {
  casToCASRoutingGroupFieldInput?: InputMaybe<CasToCasRoutingGroupFieldInput>;
};


export type CasRoutingGroupUsersArgs = {
  userFieldInput?: InputMaybe<UserFieldInput>;
};

/**
 * helps filter multiple `CASRoutingGroup` records
 *
 * this version of the input will have limited options compared to its other counterpart
 */
export type CasRoutingGroupFieldInput = {
  createdDate?: InputMaybe<DateTimeFilter>;
  /**
   * determines now to handle deleted `CASRoutingGroup` records
   *
   * - when `true`, only return deleted records
   * - when `false`, do not return deleted records
   * - when omitted, `deleted` is ignored
   */
  deleted?: InputMaybe<Scalars['Boolean']>;
  description?: InputMaybe<StringFilter>;
  id?: InputMaybe<StringFilter>;
  lastEditedDate?: InputMaybe<DateTimeFilter>;
  name?: InputMaybe<StringFilter>;
  /**
   * how to order `CASRoutingGroup` records
   *
   * executed in the order they are defined
   */
  orderBy?: InputMaybe<Array<OrderByInput>>;
  projectId?: InputMaybe<StringFilter>;
  /**
   * specifies how many records to return
   *
   * analogous to `limit`, `first`, or `top` in SQL dialects
   */
  take?: InputMaybe<Scalars['Int']>;
};

/** helps filter multiple `CASRoutingGroup` records */
export type CasRoutingGroupListInput = {
  createdDate?: InputMaybe<DateTimeFilter>;
  /**
   * determines now to handle deleted `CASRoutingGroup` records
   *
   * - when `true`, only return deleted records
   * - when `false`, do not return deleted records
   * - when omitted, `deleted` is ignored
   */
  deleted?: InputMaybe<Scalars['Boolean']>;
  description?: InputMaybe<StringFilter>;
  id?: InputMaybe<StringFilter>;
  lastEditedDate?: InputMaybe<DateTimeFilter>;
  name?: InputMaybe<StringFilter>;
  /**
   * how to order `CASRoutingGroup` records
   *
   * executed in the order they are defined
   */
  orderBy?: InputMaybe<Array<OrderByInput>>;
  /**
   * paginate `CASRoutingGroup` records
   *
   * using `paginate` may require multiple requests to get all possible results,
   * but will give more fine-grain control in the event all records cannot be
   * returned gracefully
   */
  paginate?: InputMaybe<PaginationInput>;
  projectId?: InputMaybe<StringFilter>;
};

/** response metadata for a list query of CASRoutingGroup records */
export type CasRoutingGroupListResponse = {
  __typename: 'CASRoutingGroupListResponse';
  /** the total count of CASRoutingGroup records matching any configured filters */
  count: Scalars['Int'];
  /** the total count of paginated groups of CASRoutingGroup */
  pages: Scalars['Int'];
  /** CASRoutingGroup records */
  records: Array<CasRoutingGroup>;
};

export type CasSubtype = {
  __typename: 'CASSubtype';
  /** the date this record was inserted into the database */
  createdDate: Scalars['DateTime'];
  /**
   * the email address of a user associated with the `createdDate`
   *
   * this value will be `unknown` if the `createdDate` was not set by a user
   */
  createdUser: Scalars['String'];
  /** describes whether the record has been soft-deleted or not */
  deleted: Scalars['Boolean'];
  /** the date this record was soft-deleted in the database */
  deletedDate: Maybe<Scalars['DateTime']>;
  /**
   * the email address of a user associated with the `deletedDate`
   *
   * this value will be `system` if the `deletedDate` was not set by a user
   */
  deletedUser: Maybe<Scalars['String']>;
  /**
   * an extended description associated with the record
   *
   * this description will be used to describe the record in CIMS, where possible
   */
  description: Maybe<Scalars['String']>;
  /** a UUID used to globally identify this record in the database */
  id: Scalars['String'];
  /** the date this record was last updated in the database */
  lastEditedDate: Scalars['DateTime'];
  /**
   * the email address of a user associated with the `lastEditedDate`
   *
   * this value will be `system` if the `lastEditedDate` was not set by a user
   */
  lastEditedUser: Scalars['String'];
  /** a human readable name associated with the record */
  name: Scalars['String'];
  /** a related `Project` */
  project: Project;
  /** the `globalId` of a related `Project` */
  projectId: Scalars['String'];
  submittals: Array<ConstructionAdminSubmittal>;
};


export type CasSubtypeSubmittalsArgs = {
  constructionAdminSubmittalFieldInput?: InputMaybe<ConstructionAdminSubmittalFieldInput>;
};

/**
 * helps filter multiple `CASSubtype` records
 *
 * this version of the input will have limited options compared to its other counterpart
 */
export type CasSubtypeFieldInput = {
  createdDate?: InputMaybe<DateTimeFilter>;
  /**
   * determines now to handle deleted `CASSubtype` records
   *
   * - when `true`, only return deleted records
   * - when `false`, do not return deleted records
   * - when omitted, `deleted` is ignored
   */
  deleted?: InputMaybe<Scalars['Boolean']>;
  description?: InputMaybe<StringFilter>;
  id?: InputMaybe<StringFilter>;
  lastEditedDate?: InputMaybe<DateTimeFilter>;
  name?: InputMaybe<StringFilter>;
  /**
   * how to order `CASSubtype` records
   *
   * executed in the order they are defined
   */
  orderBy?: InputMaybe<Array<OrderByInput>>;
  projectId?: InputMaybe<StringFilter>;
  /**
   * specifies how many records to return
   *
   * analogous to `limit`, `first`, or `top` in SQL dialects
   */
  take?: InputMaybe<Scalars['Int']>;
};

/** helps filter multiple `CASSubtype` records */
export type CasSubtypeListInput = {
  createdDate?: InputMaybe<DateTimeFilter>;
  /**
   * determines now to handle deleted `CASSubtype` records
   *
   * - when `true`, only return deleted records
   * - when `false`, do not return deleted records
   * - when omitted, `deleted` is ignored
   */
  deleted?: InputMaybe<Scalars['Boolean']>;
  description?: InputMaybe<StringFilter>;
  id?: InputMaybe<StringFilter>;
  lastEditedDate?: InputMaybe<DateTimeFilter>;
  name?: InputMaybe<StringFilter>;
  /**
   * how to order `CASSubtype` records
   *
   * executed in the order they are defined
   */
  orderBy?: InputMaybe<Array<OrderByInput>>;
  /**
   * paginate `CASSubtype` records
   *
   * using `paginate` may require multiple requests to get all possible results,
   * but will give more fine-grain control in the event all records cannot be
   * returned gracefully
   */
  paginate?: InputMaybe<PaginationInput>;
  projectId?: InputMaybe<StringFilter>;
};

/** response metadata for a list query of CASSubtype records */
export type CasSubtypeListResponse = {
  __typename: 'CASSubtypeListResponse';
  /** the total count of CASSubtype records matching any configured filters */
  count: Scalars['Int'];
  /** the total count of paginated groups of CASSubtype */
  pages: Scalars['Int'];
  /** CASSubtype records */
  records: Array<CasSubtype>;
};

export type CasToCasRoutingGroup = {
  __typename: 'CASToCASRoutingGroup';
  accepted: Scalars['Boolean'];
  /** a related `User` which accepted the `CASRoutingGroup` */
  acceptedBy: Maybe<User>;
  acceptedById: Maybe<Scalars['String']>;
  /** a `DateTime` which denotes when the `CASRoutingGroup` was accepted */
  acceptedDate: Maybe<Scalars['DateTime']>;
  routingGroup: CasRoutingGroup;
  routingGroupId: Scalars['String'];
  submittal: ConstructionAdminSubmittal;
  submittalId: Scalars['String'];
};

/**
 * helps filter multiple `CASToCASRoutingGroup` records
 *
 * this version of the input will have limited options compared to its other counterpart
 */
export type CasToCasRoutingGroupFieldInput = {
  /**
   * - when `true`, `accepted` is truthy
   * - when `false`, `accepted` is falsy
   * - when omitted, `accepted` is ignored
   */
  accepted?: InputMaybe<Scalars['Boolean']>;
  acceptedById?: InputMaybe<StringFilter>;
  acceptedDate?: InputMaybe<DateTimeFilter>;
  /**
   * how to order `CASToCASRoutingGroup` records
   *
   * executed in the order they are defined
   */
  orderBy?: InputMaybe<Array<OrderByInput>>;
  routingGroupId?: InputMaybe<StringFilter>;
  submittalId?: InputMaybe<StringFilter>;
  /**
   * specifies how many records to return
   *
   * analogous to `limit`, `first`, or `top` in SQL dialects
   */
  take?: InputMaybe<Scalars['Int']>;
};

/** helps filter multiple `CASToCASRoutingGroup` records */
export type CasToCasRoutingGroupListInput = {
  /**
   * - when `true`, `accepted` is truthy
   * - when `false`, `accepted` is falsy
   * - when omitted, `accepted` is ignored
   */
  accepted?: InputMaybe<Scalars['Boolean']>;
  acceptedById?: InputMaybe<StringFilter>;
  acceptedDate?: InputMaybe<DateTimeFilter>;
  /**
   * how to order `CASToCASRoutingGroup` records
   *
   * executed in the order they are defined
   */
  orderBy?: InputMaybe<Array<OrderByInput>>;
  /**
   * paginate `CASToCASRoutingGroup` records
   *
   * using `paginate` may require multiple requests to get all possible results,
   * but will give more fine-grain control in the event all records cannot be
   * returned gracefully
   */
  paginate?: InputMaybe<PaginationInput>;
  routingGroupId?: InputMaybe<StringFilter>;
  submittalId?: InputMaybe<StringFilter>;
};

/** response metadata for a list query of CASToCASRoutingGroup records */
export type CasToCasRoutingGroupListResponse = {
  __typename: 'CASToCASRoutingGroupListResponse';
  /** the total count of CASToCASRoutingGroup records matching any configured filters */
  count: Scalars['Int'];
  /** the total count of paginated groups of CASToCASRoutingGroup */
  pages: Scalars['Int'];
  /** CASToCASRoutingGroup records */
  records: Array<CasToCasRoutingGroup>;
};

/** `CASToPayItemNoGeometry` helps connect many `ConstructionAdminSubmittal` records with many `PayItemNoGeometry` records */
export type CasToPayItemNoGeometry = {
  __typename: 'CASToPayItemNoGeometry';
  payItem: PayItemNoGeometry;
  /** the `globalId` of a related `PayItemNoGeometry` */
  payItemId: Scalars['String'];
  submittal: ConstructionAdminSubmittal;
  submittalId: Scalars['String'];
};

/**
 * helps filter multiple `CASToPayItemNoGeometry` records
 *
 * this version of the input will have limited options compared to its other counterpart
 */
export type CasToPayItemNoGeometryFieldInput = {
  /**
   * how to order `CASToPayItemNoGeometry` records
   *
   * executed in the order they are defined
   */
  orderBy?: InputMaybe<Array<OrderByInput>>;
  payItemId?: InputMaybe<StringFilter>;
  submittalId?: InputMaybe<StringFilter>;
  /**
   * specifies how many records to return
   *
   * analogous to `limit`, `first`, or `top` in SQL dialects
   */
  take?: InputMaybe<Scalars['Int']>;
};

/** helps filter multiple `CASToPayItemNoGeometry` records */
export type CasToPayItemNoGeometryListInput = {
  /**
   * how to order `CASToPayItemNoGeometry` records
   *
   * executed in the order they are defined
   */
  orderBy?: InputMaybe<Array<OrderByInput>>;
  /**
   * paginate `CASToPayItemNoGeometry` records
   *
   * using `paginate` may require multiple requests to get all possible results,
   * but will give more fine-grain control in the event all records cannot be
   * returned gracefully
   */
  paginate?: InputMaybe<PaginationInput>;
  payItemId?: InputMaybe<StringFilter>;
  submittalId?: InputMaybe<StringFilter>;
};

/** response metadata for a list query of CASToPayItemNoGeometry records */
export type CasToPayItemNoGeometryListResponse = {
  __typename: 'CASToPayItemNoGeometryListResponse';
  /** the total count of CASToPayItemNoGeometry records matching any configured filters */
  count: Scalars['Int'];
  /** the total count of paginated groups of CASToPayItemNoGeometry */
  pages: Scalars['Int'];
  /** CASToPayItemNoGeometry records */
  records: Array<CasToPayItemNoGeometry>;
};

export type CasType = {
  __typename: 'CASType';
  /** the date this record was inserted into the database */
  createdDate: Scalars['DateTime'];
  /**
   * the email address of a user associated with the `createdDate`
   *
   * this value will be `unknown` if the `createdDate` was not set by a user
   */
  createdUser: Scalars['String'];
  /** describes whether the record has been soft-deleted or not */
  deleted: Scalars['Boolean'];
  /** the date this record was soft-deleted in the database */
  deletedDate: Maybe<Scalars['DateTime']>;
  /**
   * the email address of a user associated with the `deletedDate`
   *
   * this value will be `system` if the `deletedDate` was not set by a user
   */
  deletedUser: Maybe<Scalars['String']>;
  /**
   * an extended description associated with the record
   *
   * this description will be used to describe the record in CIMS, where possible
   */
  description: Maybe<Scalars['String']>;
  /** a UUID used to globally identify this record in the database */
  id: Scalars['String'];
  /** the date this record was last updated in the database */
  lastEditedDate: Scalars['DateTime'];
  /**
   * the email address of a user associated with the `lastEditedDate`
   *
   * this value will be `system` if the `lastEditedDate` was not set by a user
   */
  lastEditedUser: Scalars['String'];
  /** a human readable name associated with the record */
  name: Scalars['String'];
  /** a related `Project` */
  project: Project;
  /** the `globalId` of a related `Project` */
  projectId: Scalars['String'];
  submittals: Array<ConstructionAdminSubmittal>;
};


export type CasTypeSubmittalsArgs = {
  constructionAdminSubmittalFieldInput?: InputMaybe<ConstructionAdminSubmittalFieldInput>;
};

/**
 * helps filter multiple `CASType` records
 *
 * this version of the input will have limited options compared to its other counterpart
 */
export type CasTypeFieldInput = {
  createdDate?: InputMaybe<DateTimeFilter>;
  /**
   * determines now to handle deleted `CASType` records
   *
   * - when `true`, only return deleted records
   * - when `false`, do not return deleted records
   * - when omitted, `deleted` is ignored
   */
  deleted?: InputMaybe<Scalars['Boolean']>;
  description?: InputMaybe<StringFilter>;
  id?: InputMaybe<StringFilter>;
  lastEditedDate?: InputMaybe<DateTimeFilter>;
  name?: InputMaybe<StringFilter>;
  /**
   * how to order `CASType` records
   *
   * executed in the order they are defined
   */
  orderBy?: InputMaybe<Array<OrderByInput>>;
  projectId?: InputMaybe<StringFilter>;
  /**
   * specifies how many records to return
   *
   * analogous to `limit`, `first`, or `top` in SQL dialects
   */
  take?: InputMaybe<Scalars['Int']>;
};

/** helps filter multiple `CASType` records */
export type CasTypeListInput = {
  createdDate?: InputMaybe<DateTimeFilter>;
  /**
   * determines now to handle deleted `CASType` records
   *
   * - when `true`, only return deleted records
   * - when `false`, do not return deleted records
   * - when omitted, `deleted` is ignored
   */
  deleted?: InputMaybe<Scalars['Boolean']>;
  description?: InputMaybe<StringFilter>;
  id?: InputMaybe<StringFilter>;
  lastEditedDate?: InputMaybe<DateTimeFilter>;
  name?: InputMaybe<StringFilter>;
  /**
   * how to order `CASType` records
   *
   * executed in the order they are defined
   */
  orderBy?: InputMaybe<Array<OrderByInput>>;
  /**
   * paginate `CASType` records
   *
   * using `paginate` may require multiple requests to get all possible results,
   * but will give more fine-grain control in the event all records cannot be
   * returned gracefully
   */
  paginate?: InputMaybe<PaginationInput>;
  projectId?: InputMaybe<StringFilter>;
};

/** response metadata for a list query of CASType records */
export type CasTypeListResponse = {
  __typename: 'CASTypeListResponse';
  /** the total count of CASType records matching any configured filters */
  count: Scalars['Int'];
  /** the total count of paginated groups of CASType */
  pages: Scalars['Int'];
  /** CASType records */
  records: Array<CasType>;
};

export type CancelBatchReportRequestResponse = {
  __typename: 'CancelBatchReportRequestResponse';
  batchReportRequest: BatchReportRequest;
};

export type CancelPhotoExportRequestResponse = {
  __typename: 'CancelPhotoExportRequestResponse';
  photoExportRequest: PhotoExportRequest;
};

export type CloseIssueInput = {
  closureNotes: Scalars['String'];
  comment?: InputMaybe<Scalars['String']>;
  externalLinks?: InputMaybe<Array<ExternalLinkInput>>;
  id: Scalars['String'];
};

export type CloseIssueResponse = {
  __typename: 'CloseIssueResponse';
  issue: Issue;
};

export type ConcreteCoreBreakData = {
  __typename: 'ConcreteCoreBreakData';
  age: Maybe<Scalars['Int']>;
  breakDate: Maybe<Scalars['DateTime']>;
  concreteCoreMeasurement: ConcreteCoreMeasurement;
  concreteCoreMeasurementId: Scalars['String'];
  /** the date this record was inserted into the database */
  createdDate: Scalars['DateTime'];
  /**
   * the email address of a user associated with the `createdDate`
   *
   * this value will be `unknown` if the `createdDate` was not set by a user
   */
  createdUser: Scalars['String'];
  diameter: Maybe<Scalars['String']>;
  labNumber: Maybe<Scalars['String']>;
  labTech: Maybe<LabTech>;
  /** the `id` of a related `LabTech` */
  labTechId: Maybe<Scalars['Int']>;
  /** the date this record was last updated in the database */
  lastEditedDate: Scalars['DateTime'];
  /**
   * the email address of a user associated with the `lastEditedDate`
   *
   * this value will be `system` if the `lastEditedDate` was not set by a user
   */
  lastEditedUser: Scalars['String'];
  peakLoad: Maybe<Scalars['Int']>;
  strength: Maybe<Scalars['Int']>;
  testingLab: Maybe<TestingLab>;
  /** the `id` of a related `TestingLab` */
  testingLabId: Maybe<Scalars['Int']>;
  type: Maybe<Scalars['String']>;
};

/**
 * helps filter multiple `ConcreteCoreBreakData` records
 *
 * this version of the input will have limited options compared to its other counterpart
 */
export type ConcreteCoreBreakDataFieldInput = {
  age?: InputMaybe<IntFilter>;
  breakDate?: InputMaybe<DateTimeFilter>;
  concreteCoreMeasurementId?: InputMaybe<StringFilter>;
  createdDate?: InputMaybe<DateTimeFilter>;
  diameter?: InputMaybe<StringFilter>;
  labNumber?: InputMaybe<StringFilter>;
  lastEditedDate?: InputMaybe<DateTimeFilter>;
  /**
   * how to order `ConcreteCoreBreakData` records
   *
   * executed in the order they are defined
   */
  orderBy?: InputMaybe<Array<OrderByInput>>;
  peakLoad?: InputMaybe<IntFilter>;
  strength?: InputMaybe<IntFilter>;
  /**
   * specifies how many records to return
   *
   * analogous to `limit`, `first`, or `top` in SQL dialects
   */
  take?: InputMaybe<Scalars['Int']>;
  type?: InputMaybe<StringFilter>;
};

/** helps filter multiple `ConcreteCoreBreakData` records */
export type ConcreteCoreBreakDataListInput = {
  age?: InputMaybe<IntFilter>;
  breakDate?: InputMaybe<DateTimeFilter>;
  concreteCoreMeasurementId?: InputMaybe<StringFilter>;
  createdDate?: InputMaybe<DateTimeFilter>;
  diameter?: InputMaybe<StringFilter>;
  labNumber?: InputMaybe<StringFilter>;
  lastEditedDate?: InputMaybe<DateTimeFilter>;
  /**
   * how to order `ConcreteCoreBreakData` records
   *
   * executed in the order they are defined
   */
  orderBy?: InputMaybe<Array<OrderByInput>>;
  /**
   * paginate `ConcreteCoreBreakData` records
   *
   * using `paginate` may require multiple requests to get all possible results,
   * but will give more fine-grain control in the event all records cannot be
   * returned gracefully
   */
  paginate?: InputMaybe<PaginationInput>;
  peakLoad?: InputMaybe<IntFilter>;
  strength?: InputMaybe<IntFilter>;
  type?: InputMaybe<StringFilter>;
};

/** response metadata for a list query of ConcreteCoreBreakData records */
export type ConcreteCoreBreakDataListResponse = {
  __typename: 'ConcreteCoreBreakDataListResponse';
  /** the total count of ConcreteCoreBreakData records matching any configured filters */
  count: Scalars['Int'];
  /** the total count of paginated groups of ConcreteCoreBreakData */
  pages: Scalars['Int'];
  /** ConcreteCoreBreakData records */
  records: Array<ConcreteCoreBreakData>;
};

export type ConcreteCoreMeasurement = {
  __typename: 'ConcreteCoreMeasurement';
  alignment: Maybe<Scalars['String']>;
  archiveDate: Maybe<Scalars['DateTime']>;
  archiveUser: Maybe<Scalars['String']>;
  archived: Maybe<Scalars['String']>;
  /** the average measured thickness found in the database */
  avgMeasuredThickness: Maybe<Scalars['Float']>;
  breakStrength: Maybe<Scalars['Float']>;
  breakType: Maybe<Scalars['String']>;
  closed: Maybe<Scalars['DateTime']>;
  closedBy: Maybe<Technician>;
  /** the `globalId` of a related `Technician` */
  closedByGuid: Maybe<Scalars['String']>;
  compositeIdentifier: Maybe<Scalars['String']>;
  /** the average measured thickness computed using each measured thickness field value */
  computedAvgMeasuredThickness: Maybe<Scalars['Float']>;
  concreteCoreBreakData: Maybe<ConcreteCoreBreakData>;
  concretePlacement: Maybe<ConcretePlacement>;
  /** the `globalId` of a related `ConcretePlacement` */
  concretePlacementGuid: Maybe<Scalars['String']>;
  concreteTestSet: Maybe<ConcreteTestSet>;
  /** the `globalId` of a related `ConcreteTestSet` */
  concreteTestSetGuid: Maybe<Scalars['String']>;
  coreIdentifier: Maybe<Scalars['Float']>;
  /** `coreTestGuid` is unreliable, a misnomer, every record contains `null` values, or its purpose is generally unknown */
  coreTestGuid: Maybe<Scalars['String']>;
  /** the date this record was inserted into the database */
  createdDate: Maybe<Scalars['DateTime']>;
  /** the username or email address of a mobile app user associated with the `createdDate` */
  createdUser: Maybe<Scalars['String']>;
  deleted: Maybe<Scalars['String']>;
  difference: Maybe<Scalars['Float']>;
  genericPlacements: Array<GenericPlacement>;
  /** a GUID used to globally identify this record in the database */
  globalId: Scalars['String'];
  /** the date this record was last updated in the database */
  lastEditedDate: Maybe<Scalars['DateTime']>;
  /** the username or email address of a mobile app user associated with the `lastEditedDate` */
  lastEditedUser: Maybe<Scalars['String']>;
  measuredThickness1: Maybe<Scalars['Float']>;
  measuredThickness2: Maybe<Scalars['Float']>;
  measuredThickness3: Maybe<Scalars['Float']>;
  measurementDate: Maybe<Scalars['DateTime']>;
  measurementId: Maybe<Scalars['String']>;
  /**
   * If set, contains a comma separated list of
   * `PayItemNoGeometry.globalId` values
   *
   * unfortunately, there have been instances where one of these values doesn't map
   * to a valid `PayItemNoGeometry`
   *
   * `payItemNoGeometries` will skip these rather than map them to `null`
   */
  multiplePayItems: Maybe<Scalars['String']>;
  notes: Maybe<Scalars['String']>;
  offset: Maybe<Scalars['String']>;
  offsetRandom: Maybe<Scalars['Float']>;
  overrideComments: Maybe<Scalars['String']>;
  /**
   * aggregates all `PayItemNoGeometry` records associated with this
   * `ConcreteCoreMeasurement` by using its `PayItemNoGeometry` reference and `multiplePayItems`
   *
   * if any `PayItemNoGeometry.globalId` values used to query the database return `null`,
   * the `null` value will be filtered out of the results
   *
   * every result will be a valid `PayItemNoGeometry`
   */
  payItemNoGeometries: Array<PayItemNoGeometry>;
  payItemsGuid: Maybe<Scalars['String']>;
  /** a related `Project` */
  project: Maybe<Project>;
  /** the `globalId` of a related `Project` */
  projectId: Maybe<Scalars['String']>;
  random: Maybe<Scalars['String']>;
  reOpen: Maybe<Scalars['DateTime']>;
  renderInfo: Maybe<Scalars['String']>;
  requiredThickness: Maybe<Scalars['Float']>;
  shape: Maybe<Scalars['String']>;
  station: Maybe<Scalars['String']>;
  stationingRandom: Maybe<Scalars['Float']>;
  status: Maybe<Scalars['String']>;
  technician: Maybe<Technician>;
  /** the `globalId` of a related `Technician` */
  technicianGuid: Maybe<Scalars['String']>;
};


export type ConcreteCoreMeasurementGenericPlacementsArgs = {
  genericPlacementFieldInput?: InputMaybe<GenericPlacementFieldInput>;
};


export type ConcreteCoreMeasurementPayItemNoGeometriesArgs = {
  payItemNoGeometryFieldInput?: InputMaybe<PayItemNoGeometryFieldInput>;
};

/**
 * helps filter multiple `ConcreteCoreMeasurement` records
 *
 * this version of the input will have limited options compared to its other counterpart
 */
export type ConcreteCoreMeasurementFieldInput = {
  createdDate?: InputMaybe<DateTimeFilter>;
  /**
   * determines now to handle deleted `ConcreteCoreMeasurement` records
   *
   * - when `true`, only return deleted records
   * - when `false`, do not return deleted records
   * - when omitted, `deleted` is ignored
   */
  deleted?: InputMaybe<Scalars['Boolean']>;
  lastEditedDate?: InputMaybe<DateTimeFilter>;
  measurementId?: InputMaybe<StringFilter>;
  /**
   * how to order `ConcreteCoreMeasurement` records
   *
   * executed in the order they are defined
   */
  orderBy?: InputMaybe<Array<OrderByInput>>;
  projectId?: InputMaybe<StringFilter>;
  status?: InputMaybe<StringFilter>;
  /**
   * specifies how many records to return
   *
   * analogous to `limit`, `first`, or `top` in SQL dialects
   */
  take?: InputMaybe<Scalars['Int']>;
};

/** helps filter multiple `ConcreteCoreMeasurement` records */
export type ConcreteCoreMeasurementListInput = {
  createdDate?: InputMaybe<DateTimeFilter>;
  /**
   * determines now to handle deleted `ConcreteCoreMeasurement` records
   *
   * - when `true`, only return deleted records
   * - when `false`, do not return deleted records
   * - when omitted, `deleted` is ignored
   */
  deleted?: InputMaybe<Scalars['Boolean']>;
  lastEditedDate?: InputMaybe<DateTimeFilter>;
  measurementId?: InputMaybe<StringFilter>;
  /**
   * how to order `ConcreteCoreMeasurement` records
   *
   * executed in the order they are defined
   */
  orderBy?: InputMaybe<Array<OrderByInput>>;
  /**
   * paginate `ConcreteCoreMeasurement` records
   *
   * using `paginate` may require multiple requests to get all possible results,
   * but will give more fine-grain control in the event all records cannot be
   * returned gracefully
   */
  paginate?: InputMaybe<PaginationInput>;
  projectId?: InputMaybe<StringFilter>;
  status?: InputMaybe<StringFilter>;
};

/** response metadata for a list query of ConcreteCoreMeasurement records */
export type ConcreteCoreMeasurementListResponse = {
  __typename: 'ConcreteCoreMeasurementListResponse';
  /** the total count of ConcreteCoreMeasurement records matching any configured filters */
  count: Scalars['Int'];
  /** the total count of paginated groups of ConcreteCoreMeasurement */
  pages: Scalars['Int'];
  /** ConcreteCoreMeasurement records */
  records: Array<ConcreteCoreMeasurement>;
};

export type ConcreteCuringMethod = {
  __typename: 'ConcreteCuringMethod';
  ambientTempMax: Maybe<Scalars['Float']>;
  ambientTempMin: Maybe<Scalars['Float']>;
  concretePlacements: Array<ConcretePlacement>;
  /** the date this record was inserted into the database */
  createdDate: Maybe<Scalars['DateTime']>;
  /** the username or email address of a mobile app user associated with the `createdDate` */
  createdUser: Maybe<Scalars['String']>;
  cureTempMax: Maybe<Scalars['Float']>;
  cureTempMin: Maybe<Scalars['Float']>;
  curingMethod: Maybe<Scalars['String']>;
  deleted: Scalars['Boolean'];
  /** a GUID used to globally identify this record in the database */
  globalId: Scalars['String'];
  /** the date this record was last updated in the database */
  lastEditedDate: Maybe<Scalars['DateTime']>;
  /** the username or email address of a mobile app user associated with the `lastEditedDate` */
  lastEditedUser: Maybe<Scalars['String']>;
  /** a related `Project` */
  project: Maybe<Project>;
  /** the `globalId` of a related `Project` */
  projectId: Maybe<Scalars['String']>;
};


export type ConcreteCuringMethodConcretePlacementsArgs = {
  concretePlacementFieldInput?: InputMaybe<ConcretePlacementFieldInput>;
};

/**
 * helps filter multiple `ConcreteCuringMethod` records
 *
 * this version of the input will have limited options compared to its other counterpart
 */
export type ConcreteCuringMethodFieldInput = {
  ambientTempMax?: InputMaybe<FloatFilter>;
  ambientTempMin?: InputMaybe<FloatFilter>;
  createdDate?: InputMaybe<DateTimeFilter>;
  createdUser?: InputMaybe<StringFilter>;
  cureTempMax?: InputMaybe<FloatFilter>;
  cureTempMin?: InputMaybe<FloatFilter>;
  curingMethod?: InputMaybe<StringFilter>;
  /**
   * determines now to handle deleted `ConcreteCuringMethod` records
   *
   * - when `true`, only return deleted records
   * - when `false`, do not return deleted records
   * - when omitted, `deleted` is ignored
   */
  deleted?: InputMaybe<Scalars['Boolean']>;
  globalId?: InputMaybe<StringFilter>;
  lastEditedDate?: InputMaybe<DateTimeFilter>;
  lastEditedUser?: InputMaybe<StringFilter>;
  /**
   * how to order `ConcreteCuringMethod` records
   *
   * executed in the order they are defined
   */
  orderBy?: InputMaybe<Array<OrderByInput>>;
  projectId?: InputMaybe<StringFilter>;
  /**
   * specifies how many records to return
   *
   * analogous to `limit`, `first`, or `top` in SQL dialects
   */
  take?: InputMaybe<Scalars['Int']>;
};

/** helps filter multiple `ConcreteCuringMethod` records */
export type ConcreteCuringMethodListInput = {
  ambientTempMax?: InputMaybe<FloatFilter>;
  ambientTempMin?: InputMaybe<FloatFilter>;
  createdDate?: InputMaybe<DateTimeFilter>;
  createdUser?: InputMaybe<StringFilter>;
  cureTempMax?: InputMaybe<FloatFilter>;
  cureTempMin?: InputMaybe<FloatFilter>;
  curingMethod?: InputMaybe<StringFilter>;
  /**
   * determines now to handle deleted `ConcreteCuringMethod` records
   *
   * - when `true`, only return deleted records
   * - when `false`, do not return deleted records
   * - when omitted, `deleted` is ignored
   */
  deleted?: InputMaybe<Scalars['Boolean']>;
  globalId?: InputMaybe<StringFilter>;
  lastEditedDate?: InputMaybe<DateTimeFilter>;
  lastEditedUser?: InputMaybe<StringFilter>;
  /**
   * how to order `ConcreteCuringMethod` records
   *
   * executed in the order they are defined
   */
  orderBy?: InputMaybe<Array<OrderByInput>>;
  /**
   * paginate `ConcreteCuringMethod` records
   *
   * using `paginate` may require multiple requests to get all possible results,
   * but will give more fine-grain control in the event all records cannot be
   * returned gracefully
   */
  paginate?: InputMaybe<PaginationInput>;
  projectId?: InputMaybe<StringFilter>;
};

/** response metadata for a list query of ConcreteCuringMethod records */
export type ConcreteCuringMethodListResponse = {
  __typename: 'ConcreteCuringMethodListResponse';
  /** the total count of ConcreteCuringMethod records matching any configured filters */
  count: Scalars['Int'];
  /** the total count of paginated groups of ConcreteCuringMethod */
  pages: Scalars['Int'];
  /** ConcreteCuringMethod records */
  records: Array<ConcreteCuringMethod>;
};

export type ConcreteFieldData = {
  __typename: 'ConcreteFieldData';
  airContentFromUWT: Maybe<Scalars['Float']>;
  ambientAirTemperature: Maybe<Scalars['Float']>;
  amountOfConcrete: Maybe<Scalars['Float']>;
  concreteTemperature: Maybe<Scalars['Float']>;
  concreteTestSet: Maybe<ConcreteTestSet>;
  concreteTestSetGuid: Maybe<Scalars['String']>;
  correctedAirContent: Maybe<Scalars['Float']>;
  /** the date this record was inserted into the database */
  createdDate: Maybe<Scalars['DateTime']>;
  /** the username or email address of a mobile app user associated with the `createdDate` */
  createdUser: Maybe<Scalars['String']>;
  deleted: Scalars['Boolean'];
  fieldDataId: Maybe<Scalars['String']>;
  /** a GUID used to globally identify this record in the database */
  globalId: Scalars['String'];
  /** the date this record was last updated in the database */
  lastEditedDate: Maybe<Scalars['DateTime']>;
  /** the username or email address of a mobile app user associated with the `lastEditedDate` */
  lastEditedUser: Maybe<Scalars['String']>;
  measuredSlump: Maybe<Scalars['Float']>;
  numberCylindersCast: Maybe<Scalars['Float']>;
  orderNum: Maybe<Scalars['Int']>;
  /** the `globalId` of a related `Project` */
  projectId: Maybe<Scalars['String']>;
  sizeOfLoad: Maybe<Scalars['Float']>;
  t121MeasuredUnitWeight: Maybe<Scalars['Float']>;
  t152AirContent: Maybe<Scalars['Float']>;
  ticketNumber: Maybe<Scalars['String']>;
  timeFinalTestCompleted: Maybe<Scalars['DateTime']>;
  timeSampleObtained: Maybe<Scalars['DateTime']>;
  totalConcretePlaced: Maybe<Scalars['Float']>;
  truckNumber: Maybe<Scalars['String']>;
};

/**
 * helps filter multiple `ConcreteFieldData` records
 *
 * this version of the input will have limited options compared to its other counterpart
 */
export type ConcreteFieldDataFieldInput = {
  airContentFromUWT?: InputMaybe<FloatFilter>;
  ambientAirTemperature?: InputMaybe<FloatFilter>;
  amountOfConcrete?: InputMaybe<FloatFilter>;
  concreteTemperature?: InputMaybe<FloatFilter>;
  concreteTestSetGuid?: InputMaybe<StringFilter>;
  correctedAirContent?: InputMaybe<FloatFilter>;
  createdDate?: InputMaybe<DateTimeFilter>;
  /**
   * determines now to handle deleted `ConcreteFieldData` records
   *
   * - when `true`, only return deleted records
   * - when `false`, do not return deleted records
   * - when omitted, `deleted` is ignored
   */
  deleted?: InputMaybe<Scalars['Boolean']>;
  fieldDataId?: InputMaybe<StringFilter>;
  lastEditedDate?: InputMaybe<DateTimeFilter>;
  measuredSlump?: InputMaybe<FloatFilter>;
  numberCylindersCast?: InputMaybe<FloatFilter>;
  /**
   * how to order `ConcreteFieldData` records
   *
   * executed in the order they are defined
   */
  orderBy?: InputMaybe<Array<OrderByInput>>;
  projectId?: InputMaybe<StringFilter>;
  sizeOfLoad?: InputMaybe<FloatFilter>;
  t121MeasuredUnitWeight?: InputMaybe<FloatFilter>;
  t152AirContent?: InputMaybe<FloatFilter>;
  /**
   * specifies how many records to return
   *
   * analogous to `limit`, `first`, or `top` in SQL dialects
   */
  take?: InputMaybe<Scalars['Int']>;
  ticketNumber?: InputMaybe<StringFilter>;
  timeFinalTestCompleted?: InputMaybe<DateTimeFilter>;
  timeSampleObtained?: InputMaybe<DateTimeFilter>;
  totalConcretePlaced?: InputMaybe<FloatFilter>;
  truckNumber?: InputMaybe<StringFilter>;
};

/** helps filter multiple `ConcreteFieldData` records */
export type ConcreteFieldDataListInput = {
  airContentFromUWT?: InputMaybe<FloatFilter>;
  ambientAirTemperature?: InputMaybe<FloatFilter>;
  amountOfConcrete?: InputMaybe<FloatFilter>;
  concreteTemperature?: InputMaybe<FloatFilter>;
  concreteTestSetGuid?: InputMaybe<StringFilter>;
  correctedAirContent?: InputMaybe<FloatFilter>;
  createdDate?: InputMaybe<DateTimeFilter>;
  /**
   * determines now to handle deleted `ConcreteFieldData` records
   *
   * - when `true`, only return deleted records
   * - when `false`, do not return deleted records
   * - when omitted, `deleted` is ignored
   */
  deleted?: InputMaybe<Scalars['Boolean']>;
  fieldDataId?: InputMaybe<StringFilter>;
  lastEditedDate?: InputMaybe<DateTimeFilter>;
  measuredSlump?: InputMaybe<FloatFilter>;
  numberCylindersCast?: InputMaybe<FloatFilter>;
  /**
   * how to order `ConcreteFieldData` records
   *
   * executed in the order they are defined
   */
  orderBy?: InputMaybe<Array<OrderByInput>>;
  /**
   * paginate `ConcreteFieldData` records
   *
   * using `paginate` may require multiple requests to get all possible results,
   * but will give more fine-grain control in the event all records cannot be
   * returned gracefully
   */
  paginate?: InputMaybe<PaginationInput>;
  projectId?: InputMaybe<StringFilter>;
  sizeOfLoad?: InputMaybe<FloatFilter>;
  t121MeasuredUnitWeight?: InputMaybe<FloatFilter>;
  t152AirContent?: InputMaybe<FloatFilter>;
  ticketNumber?: InputMaybe<StringFilter>;
  timeFinalTestCompleted?: InputMaybe<DateTimeFilter>;
  timeSampleObtained?: InputMaybe<DateTimeFilter>;
  totalConcretePlaced?: InputMaybe<FloatFilter>;
  truckNumber?: InputMaybe<StringFilter>;
};

/** response metadata for a list query of ConcreteFieldData records */
export type ConcreteFieldDataListResponse = {
  __typename: 'ConcreteFieldDataListResponse';
  /** the total count of ConcreteFieldData records matching any configured filters */
  count: Scalars['Int'];
  /** the total count of paginated groups of ConcreteFieldData */
  pages: Scalars['Int'];
  /** ConcreteFieldData records */
  records: Array<ConcreteFieldData>;
};

export type ConcreteMaterial = {
  __typename: 'ConcreteMaterial';
  airSlumpStartup: Maybe<Scalars['Int']>;
  airSlumpTestingFrequency: Maybe<Scalars['Float']>;
  airTestsPer: Maybe<Scalars['Float']>;
  airUnits: Maybe<Scalars['String']>;
  concretePlacement: Maybe<ConcretePlacement>;
  /**
   * `concretePlacementGuid` is unreliable, a misnomer, every record contains `null` values, or its purpose is generally unknown
   *
   * To get the `ConcreteMaterial` of a `ConcretePlacement`, go through `ConcreteTestSet`
   *
   * ``` graphql
   * concretePlacement {
   *   concreteTestSet {
   *     concreteMaterial {
   *       ...ConcreteMaterialFragment
   *     }
   *   }
   * }
   * ```
   */
  concretePlacementGuid: Maybe<Scalars['String']>;
  concreteTestSets: Array<ConcreteTestSet>;
  coreTestingFrequency: Maybe<Scalars['Float']>;
  coreUnits: Maybe<Scalars['String']>;
  coresMin: Maybe<Scalars['Float']>;
  /** the date this record was inserted into the database */
  createdDate: Maybe<Scalars['DateTime']>;
  /** the username or email address of a mobile app user associated with the `createdDate` */
  createdUser: Maybe<Scalars['String']>;
  cureRate: Maybe<Scalars['Float']>;
  cylinderSetFrequency: Maybe<Scalars['Float']>;
  cylinderSetMin: Maybe<Scalars['Float']>;
  cylinderSetsPer: Maybe<Scalars['Float']>;
  cylinderTestUnits: Maybe<Scalars['String']>;
  deleted: Maybe<Scalars['String']>;
  documentChecklistItemToConcreteMaterials: Array<DocumentChecklistItemToConcreteMaterial>;
  excludeCores: Maybe<Scalars['String']>;
  excludeCylinders: Maybe<Scalars['String']>;
  /** a GUID used to globally identify this record in the database */
  globalId: Scalars['String'];
  hasAirAdded: Maybe<Scalars['String']>;
  hasAirTemp: Maybe<Scalars['String']>;
  hasBatchTime: Maybe<Scalars['String']>;
  hasConcreteTemp: Maybe<Scalars['String']>;
  hasCureCheck: Maybe<Scalars['String']>;
  hasIaConnected: Maybe<Scalars['String']>;
  hasManualCylinders: Maybe<Scalars['String']>;
  hasPercentAir: Maybe<Scalars['String']>;
  hasSlump: Maybe<Scalars['String']>;
  hasSteelCheck: Maybe<Scalars['String']>;
  hasTruckRejected: Maybe<Scalars['String']>;
  hasUnitWeight: Maybe<Scalars['String']>;
  hasWaterAdded: Maybe<Scalars['String']>;
  /** the date this record was last updated in the database */
  lastEditedDate: Maybe<Scalars['DateTime']>;
  /** the username or email address of a mobile app user associated with the `lastEditedDate` */
  lastEditedUser: Maybe<Scalars['String']>;
  lowFailureBreakStrength: Maybe<Scalars['Float']>;
  maximumBreakStrength: Maybe<Scalars['Float']>;
  mixDesignNumber: Maybe<Scalars['String']>;
  placementType: Maybe<Scalars['String']>;
  /** a related `Project` */
  project: Maybe<Project>;
  /** the `globalId` of a related `Project` */
  projectId: Maybe<Scalars['String']>;
  shortName: Maybe<Scalars['String']>;
  slumpUnits: Maybe<Scalars['String']>;
  specBreakStrength: Maybe<Scalars['Float']>;
  thicknessCoresPerPlacement: Maybe<Scalars['String']>;
  unitWeight: Maybe<Scalars['Float']>;
  weightUnits: Maybe<Scalars['String']>;
};


export type ConcreteMaterialConcreteTestSetsArgs = {
  concreteTestSetFieldInput?: InputMaybe<ConcreteTestSetFieldInput>;
};


export type ConcreteMaterialDocumentChecklistItemToConcreteMaterialsArgs = {
  documentChecklistItemToConcreteMaterialFieldInput?: InputMaybe<DocumentChecklistItemToConcreteMaterialFieldInput>;
};

/**
 * helps filter multiple `ConcreteMaterial` records
 *
 * this version of the input will have limited options compared to its other counterpart
 */
export type ConcreteMaterialFieldInput = {
  createdDate?: InputMaybe<DateTimeFilter>;
  /**
   * determines now to handle deleted `ConcreteMaterial` records
   *
   * - when `true`, only return deleted records
   * - when `false`, do not return deleted records
   * - when omitted, `deleted` is ignored
   */
  deleted?: InputMaybe<Scalars['Boolean']>;
  lastEditedDate?: InputMaybe<DateTimeFilter>;
  /**
   * how to order `ConcreteMaterial` records
   *
   * executed in the order they are defined
   */
  orderBy?: InputMaybe<Array<OrderByInput>>;
  placementType?: InputMaybe<StringFilter>;
  projectId?: InputMaybe<StringFilter>;
  /**
   * specifies how many records to return
   *
   * analogous to `limit`, `first`, or `top` in SQL dialects
   */
  take?: InputMaybe<Scalars['Int']>;
};

/** helps filter multiple `ConcreteMaterial` records */
export type ConcreteMaterialListInput = {
  createdDate?: InputMaybe<DateTimeFilter>;
  /**
   * determines now to handle deleted `ConcreteMaterial` records
   *
   * - when `true`, only return deleted records
   * - when `false`, do not return deleted records
   * - when omitted, `deleted` is ignored
   */
  deleted?: InputMaybe<Scalars['Boolean']>;
  lastEditedDate?: InputMaybe<DateTimeFilter>;
  /**
   * how to order `ConcreteMaterial` records
   *
   * executed in the order they are defined
   */
  orderBy?: InputMaybe<Array<OrderByInput>>;
  /**
   * paginate `ConcreteMaterial` records
   *
   * using `paginate` may require multiple requests to get all possible results,
   * but will give more fine-grain control in the event all records cannot be
   * returned gracefully
   */
  paginate?: InputMaybe<PaginationInput>;
  placementType?: InputMaybe<StringFilter>;
  projectId?: InputMaybe<StringFilter>;
};

/** response metadata for a list query of ConcreteMaterial records */
export type ConcreteMaterialListResponse = {
  __typename: 'ConcreteMaterialListResponse';
  /** the total count of ConcreteMaterial records matching any configured filters */
  count: Scalars['Int'];
  /** the total count of paginated groups of ConcreteMaterial */
  pages: Scalars['Int'];
  /** ConcreteMaterial records */
  records: Array<ConcreteMaterial>;
};

export type ConcreteMixDesign = {
  __typename: 'ConcreteMixDesign';
  /** Current workflow status of mix design */
  active: Scalars['Boolean'];
  /** Admixtures used in mix design */
  admixtures: Maybe<Scalars['String']>;
  aggregate1: Maybe<Scalars['String']>;
  aggregate2: Maybe<Scalars['String']>;
  aggregate3: Maybe<Scalars['String']>;
  aggregate4: Maybe<Scalars['String']>;
  /**
   * using the associated
   * `ProjectMetadata.materialsLogSpreadSheetId` and `ProjectMetadata.mixDesignSheetName`,
   * loads and searches a Google Sheet for the `mixDesignNumber` in a `Mix Design`
   * column and groups any values found in an `Aggregates` column for the `mixDesignNumber`
   * @deprecated this field has been deprecated and expires when the last project using it closes.
   *
   * it may be removed at any time after expiration, but not before
   *
   * Aggregate sources are no longer managed through Google Sheets
   */
  aggregateSources: Array<Scalars['String']>;
  aggregates: Array<Scalars['String']>;
  /** The larger number in the air range */
  airHigh: Maybe<Scalars['Float']>;
  /** The smaller number in the air range */
  airLow: Maybe<Scalars['Float']>;
  airRange: Maybe<Scalars['String']>;
  /** Use class of mix design */
  class: Maybe<Scalars['String']>;
  clientDesignNumber: Maybe<Scalars['String']>;
  concreteTestSets: Array<ConcreteTestSet>;
  /** Allowable uses of mix design */
  concreteUse: Maybe<Scalars['String']>;
  /** the date this record was inserted into the database */
  createdDate: Maybe<Scalars['DateTime']>;
  /** the username or email address of a mobile app user associated with the `createdDate` */
  createdUser: Maybe<Scalars['String']>;
  /**
   * custom fields are defined, configured, and activated for `ConcreteMixDesign`
   *     records in the Administration module
   *
   *     values are saved and retrieved for each individual `ConcreteMixDesign`
   */
  customFields: CustomFields;
  deleted: Scalars['Boolean'];
  /** Expiration date of mix design */
  expirationDate: Maybe<Scalars['DateTime']>;
  /** 28 day break strength the mix was designed for */
  f28DayStrengthPSI: Maybe<Scalars['Float']>;
  /** a GUID used to globally identify this record in the database */
  globalId: Scalars['String'];
  /** the date this record was last updated in the database */
  lastEditedDate: Maybe<Scalars['DateTime']>;
  /** the username or email address of a mobile app user associated with the `lastEditedDate` */
  lastEditedUser: Maybe<Scalars['String']>;
  /** The company supplying the concrete */
  materialSource: Maybe<Scalars['String']>;
  /** Maximum aggregate size of mix design */
  maxAggSize: Maybe<Scalars['String']>;
  /** Mix design number of placed concrete */
  mixDesignNumber: Maybe<Scalars['String']>;
  /** a related `Project` */
  project: Maybe<Project>;
  /** the `globalId` of a related `Project` */
  projectId: Maybe<Scalars['String']>;
  /** The larger number in the slump range */
  slumpHighInches: Maybe<Scalars['Float']>;
  /** The smaller number in the slump range */
  slumpLowInches: Maybe<Scalars['Float']>;
  slumpRange: Maybe<Scalars['String']>;
  /** The ID the mix design was submitted under. */
  submittalId: Maybe<Scalars['String']>;
  /** Water and cement ratio of mix design */
  wc: Maybe<Scalars['String']>;
};


export type ConcreteMixDesignConcreteTestSetsArgs = {
  concreteTestSetFieldInput?: InputMaybe<ConcreteTestSetFieldInput>;
};

/**
 * helps filter multiple `ConcreteMixDesign` records
 *
 * this version of the input will have limited options compared to its other counterpart
 */
export type ConcreteMixDesignFieldInput = {
  clientDesignNumber?: InputMaybe<StringFilter>;
  createdDate?: InputMaybe<DateTimeFilter>;
  /**
   * determines now to handle deleted `ConcreteMixDesign` records
   *
   * - when `true`, only return deleted records
   * - when `false`, do not return deleted records
   * - when omitted, `deleted` is ignored
   */
  deleted?: InputMaybe<Scalars['Boolean']>;
  lastEditedDate?: InputMaybe<DateTimeFilter>;
  mixDesignNumber?: InputMaybe<StringFilter>;
  /**
   * how to order `ConcreteMixDesign` records
   *
   * executed in the order they are defined
   */
  orderBy?: InputMaybe<Array<OrderByInput>>;
  projectId?: InputMaybe<StringFilter>;
  /**
   * specifies how many records to return
   *
   * analogous to `limit`, `first`, or `top` in SQL dialects
   */
  take?: InputMaybe<Scalars['Int']>;
};

/** helps filter multiple `ConcreteMixDesign` records */
export type ConcreteMixDesignListInput = {
  clientDesignNumber?: InputMaybe<StringFilter>;
  createdDate?: InputMaybe<DateTimeFilter>;
  /**
   * determines now to handle deleted `ConcreteMixDesign` records
   *
   * - when `true`, only return deleted records
   * - when `false`, do not return deleted records
   * - when omitted, `deleted` is ignored
   */
  deleted?: InputMaybe<Scalars['Boolean']>;
  lastEditedDate?: InputMaybe<DateTimeFilter>;
  mixDesignNumber?: InputMaybe<StringFilter>;
  /**
   * how to order `ConcreteMixDesign` records
   *
   * executed in the order they are defined
   */
  orderBy?: InputMaybe<Array<OrderByInput>>;
  /**
   * paginate `ConcreteMixDesign` records
   *
   * using `paginate` may require multiple requests to get all possible results,
   * but will give more fine-grain control in the event all records cannot be
   * returned gracefully
   */
  paginate?: InputMaybe<PaginationInput>;
  projectId?: InputMaybe<StringFilter>;
};

/** response metadata for a list query of ConcreteMixDesign records */
export type ConcreteMixDesignListResponse = {
  __typename: 'ConcreteMixDesignListResponse';
  /** the total count of ConcreteMixDesign records matching any configured filters */
  count: Scalars['Int'];
  /** the total count of paginated groups of ConcreteMixDesign */
  pages: Scalars['Int'];
  /** ConcreteMixDesign records */
  records: Array<ConcreteMixDesign>;
};

/**
 * notifications hold a recipients configuration for a given
 * notification event in Concrete workflows
 *
 * recipients can be users, or non user emails
 *
 * certain events may require users to receive a notification if they are given permission
 * to perform a specific task
 */
export type ConcreteNotification = {
  __typename: 'ConcreteNotification';
  /** the date this record was inserted into the database */
  createdDate: Scalars['DateTime'];
  /**
   * the email address of a user associated with the `createdDate`
   *
   * this value will be `unknown` if the `createdDate` was not set by a user
   */
  createdUser: Scalars['String'];
  /** the date this record was last updated in the database */
  lastEditedDate: Scalars['DateTime'];
  /**
   * the email address of a user associated with the `lastEditedDate`
   *
   * this value will be `system` if the `lastEditedDate` was not set by a user
   */
  lastEditedUser: Scalars['String'];
  /** the name of the notification event associated with this Notification */
  notificationEvent: Scalars['String'];
  notificationEventId: Scalars['String'];
  /** a related `Project` */
  project: Project;
  /** the `globalId` of a related `Project` */
  projectId: Scalars['String'];
  recipients: ConcreteNotificationRecipients;
};

/**
 * helps filter multiple `ConcreteNotification` records
 *
 * this version of the input will have limited options compared to its other counterpart
 */
export type ConcreteNotificationFieldInput = {
  createdDate?: InputMaybe<DateTimeFilter>;
  lastEditedDate?: InputMaybe<DateTimeFilter>;
  notificationEventId?: InputMaybe<StringFilter>;
  /**
   * how to order `ConcreteNotification` records
   *
   * executed in the order they are defined
   */
  orderBy?: InputMaybe<Array<OrderByInput>>;
  projectId?: InputMaybe<StringFilter>;
  /**
   * specifies how many records to return
   *
   * analogous to `limit`, `first`, or `top` in SQL dialects
   */
  take?: InputMaybe<Scalars['Int']>;
};

/** helps filter multiple `ConcreteNotification` records */
export type ConcreteNotificationListInput = {
  createdDate?: InputMaybe<DateTimeFilter>;
  lastEditedDate?: InputMaybe<DateTimeFilter>;
  notificationEventId?: InputMaybe<StringFilter>;
  /**
   * how to order `ConcreteNotification` records
   *
   * executed in the order they are defined
   */
  orderBy?: InputMaybe<Array<OrderByInput>>;
  /**
   * paginate `ConcreteNotification` records
   *
   * using `paginate` may require multiple requests to get all possible results,
   * but will give more fine-grain control in the event all records cannot be
   * returned gracefully
   */
  paginate?: InputMaybe<PaginationInput>;
  projectId?: InputMaybe<StringFilter>;
};

/** response metadata for a list query of ConcreteNotification records */
export type ConcreteNotificationListResponse = {
  __typename: 'ConcreteNotificationListResponse';
  /** the total count of ConcreteNotification records matching any configured filters */
  count: Scalars['Int'];
  /** the total count of paginated groups of ConcreteNotification */
  pages: Scalars['Int'];
  /** ConcreteNotification records */
  records: Array<ConcreteNotification>;
};

export type ConcreteNotificationRecipients = {
  __typename: 'ConcreteNotificationRecipients';
  /** all concrete test sets with a specific concrete material */
  byConcreteMaterial: Array<ByConcreteMaterial>;
  /** all concrete test sets with a specific mix design */
  byConcreteMixDesign: Array<ByConcreteMixDesign>;
  every: Maybe<Recipients>;
};


export type ConcreteNotificationRecipientsByConcreteMaterialArgs = {
  concreteMaterialFieldInput?: InputMaybe<ConcreteMaterialFieldInput>;
};


export type ConcreteNotificationRecipientsByConcreteMixDesignArgs = {
  concreteMixDesignFieldInput?: InputMaybe<ConcreteMixDesignFieldInput>;
};

export type ConcretePlacement = {
  __typename: 'ConcretePlacement';
  ambientTempHi: Maybe<Scalars['Float']>;
  ambientTempLo: Maybe<Scalars['Float']>;
  archiveDate: Maybe<Scalars['DateTime']>;
  archiveUser: Maybe<Scalars['String']>;
  archived: Scalars['Boolean'];
  associatedPayItems: Maybe<Scalars['String']>;
  averageThickness: Maybe<Scalars['Float']>;
  base64MapImage: Maybe<Scalars['String']>;
  beginAlignment: Maybe<Scalars['String']>;
  beginOffset: Maybe<Scalars['String']>;
  beginStation: Maybe<Scalars['String']>;
  concreteCoreMeasurements: Array<ConcreteCoreMeasurement>;
  concreteCuringMethod: Maybe<ConcreteCuringMethod>;
  concreteMaterials: Array<ConcreteMaterial>;
  concreteSampleLocations: Array<ConcreteSampleLocation>;
  concreteTestSet: Maybe<ConcreteTestSet>;
  /** the `globalId` of a related `ConcreteTestSet` */
  concreteTestSetGuid: Maybe<Scalars['String']>;
  /**
   * @deprecated this field has been deprecated and expires once all projects previously using this field have been archived.
   *
   * it may be removed at any time after expiration, but not before
   *
   * `ConcreteTestSetPlacement` was created to connect a `ConcreteTest`
   * and `ConcretePlacement` in older versions of the Field App
   *
   * `ConcreteTestSet` now fulfills that roll, while also holding its own metadata
   *
   * `ConcreteTestSetPlacement` will be removed when all projects on older versions
   * of the Field App upgrade to a newer version of the Field App, or finish
   */
  concreteTestSetPlacements: Array<ConcreteTestSetPlacement>;
  contractor: Maybe<Contractor>;
  /** the `globalId` of a related `Contractor` */
  contractorGuid: Scalars['String'];
  /** the date this record was inserted into the database */
  createdDate: Maybe<Scalars['DateTime']>;
  /** the username or email address of a mobile app user associated with the `createdDate` */
  createdUser: Maybe<Scalars['String']>;
  cureApplied: Scalars['Boolean'];
  cureCheck: Scalars['Boolean'];
  cureCoverage: Scalars['String'];
  cureGallons: Maybe<Scalars['Float']>;
  cureOnApprovedList: Scalars['Boolean'];
  cureSqft: Maybe<Scalars['Float']>;
  cureTempHi: Maybe<Scalars['Float']>;
  cureTempLo: Maybe<Scalars['Float']>;
  curingMethodGuid: Maybe<Scalars['String']>;
  deleted: Scalars['Boolean'];
  ejToReports: Array<EjToReport>;
  endAlignment: Maybe<Scalars['String']>;
  endOffset: Maybe<Scalars['String']>;
  endStation: Maybe<Scalars['String']>;
  generatedInfo: Maybe<Scalars['String']>;
  genericPlacements: Array<GenericPlacement>;
  /** a GUID used to globally identify this record in the database */
  globalId: Scalars['String'];
  /** the date this record was last updated in the database */
  lastEditedDate: Maybe<Scalars['DateTime']>;
  /** the username or email address of a mobile app user associated with the `lastEditedDate` */
  lastEditedUser: Maybe<Scalars['String']>;
  linearFt: Maybe<Scalars['Float']>;
  manualMeasurements: Scalars['Boolean'];
  /**
   * If set, contains a comma separated list of
   * `PayItemNoGeometry.globalId` values
   *
   * unfortunately, there have been instances where one of these values doesn't map
   * to a valid `PayItemNoGeometry`
   *
   * `payItemNoGeometries` will skip these rather than map them to `null`
   */
  multiplePayItems: Maybe<Scalars['String']>;
  notes: Maybe<Scalars['String']>;
  numberOfRequiredTests: Maybe<Scalars['Int']>;
  overrideComments: Maybe<Scalars['String']>;
  /**
   * aggregates all `PayItemNoGeometry` records associated with this
   * `ConcretePlacement` by using its `PayItemNoGeometry` reference and `multiplePayItems`
   *
   * if any `PayItemNoGeometry.globalId` values used to query the database return `null`,
   * the `null` value will be filtered out of the results
   *
   * every result will be a valid `PayItemNoGeometry`
   */
  payItemNoGeometries: Array<PayItemNoGeometry>;
  payItemsGuid: Maybe<Scalars['String']>;
  placementId: Maybe<Scalars['String']>;
  placementQtyVolCy: Maybe<Scalars['Float']>;
  placementType: Maybe<Scalars['String']>;
  /** a related `Project` */
  project: Project;
  /** the `globalId` of a related `Project` */
  projectId: Scalars['String'];
  projectRiskZone: Maybe<Scalars['String']>;
  renderInfo: Maybe<Scalars['String']>;
  requiredThickness: Maybe<Scalars['Float']>;
  shape: Maybe<Scalars['String']>;
  sqFt: Maybe<Scalars['Float']>;
  sqYd: Maybe<Scalars['Float']>;
  status: Maybe<Scalars['String']>;
  steelCheck: Scalars['Boolean'];
  steelNotes: Maybe<Scalars['String']>;
  steelResults: Scalars['String'];
  steelVerified: Scalars['String'];
  steelVerify: Maybe<Scalars['String']>;
  structureType: Maybe<StructureType>;
  structureTypeId: Maybe<Scalars['String']>;
  technician: Technician;
  /** the `globalId` of a related `Technician` */
  technicianGuid: Scalars['String'];
  testedDate: Maybe<Scalars['DateTime']>;
};


export type ConcretePlacementBase64MapImageArgs = {
  projectLayerIds?: InputMaybe<Array<Scalars['Int']>>;
};


export type ConcretePlacementConcreteCoreMeasurementsArgs = {
  concreteCoreMeasurementFieldInput?: InputMaybe<ConcreteCoreMeasurementFieldInput>;
};


export type ConcretePlacementConcreteMaterialsArgs = {
  concreteMaterialFieldInput?: InputMaybe<ConcreteMaterialFieldInput>;
};


export type ConcretePlacementConcreteSampleLocationsArgs = {
  concreteSampleLocationFieldInput?: InputMaybe<ConcreteSampleLocationFieldInput>;
};


export type ConcretePlacementEjToReportsArgs = {
  eJToReportFieldInput?: InputMaybe<EjToReportFieldInput>;
};


export type ConcretePlacementGenericPlacementsArgs = {
  genericPlacementFieldInput?: InputMaybe<GenericPlacementFieldInput>;
};


export type ConcretePlacementPayItemNoGeometriesArgs = {
  payItemNoGeometryFieldInput?: InputMaybe<PayItemNoGeometryFieldInput>;
};

/**
 * helps filter multiple `ConcretePlacement` records
 *
 * this version of the input will have limited options compared to its other counterpart
 */
export type ConcretePlacementFieldInput = {
  createdDate?: InputMaybe<DateTimeFilter>;
  /**
   * determines now to handle deleted `ConcretePlacement` records
   *
   * - when `true`, only return deleted records
   * - when `false`, do not return deleted records
   * - when omitted, `deleted` is ignored
   */
  deleted?: InputMaybe<Scalars['Boolean']>;
  lastEditedDate?: InputMaybe<DateTimeFilter>;
  /**
   * how to order `ConcretePlacement` records
   *
   * executed in the order they are defined
   */
  orderBy?: InputMaybe<Array<OrderByInput>>;
  placementId?: InputMaybe<StringFilter>;
  projectId?: InputMaybe<StringFilter>;
  /**
   * specifies how many records to return
   *
   * analogous to `limit`, `first`, or `top` in SQL dialects
   */
  take?: InputMaybe<Scalars['Int']>;
};

/** helps filter multiple `ConcretePlacement` records */
export type ConcretePlacementListInput = {
  createdDate?: InputMaybe<DateTimeFilter>;
  /**
   * determines now to handle deleted `ConcretePlacement` records
   *
   * - when `true`, only return deleted records
   * - when `false`, do not return deleted records
   * - when omitted, `deleted` is ignored
   */
  deleted?: InputMaybe<Scalars['Boolean']>;
  lastEditedDate?: InputMaybe<DateTimeFilter>;
  /**
   * how to order `ConcretePlacement` records
   *
   * executed in the order they are defined
   */
  orderBy?: InputMaybe<Array<OrderByInput>>;
  /**
   * paginate `ConcretePlacement` records
   *
   * using `paginate` may require multiple requests to get all possible results,
   * but will give more fine-grain control in the event all records cannot be
   * returned gracefully
   */
  paginate?: InputMaybe<PaginationInput>;
  placementId?: InputMaybe<StringFilter>;
  projectId?: InputMaybe<StringFilter>;
};

/** response metadata for a list query of ConcretePlacement records */
export type ConcretePlacementListResponse = {
  __typename: 'ConcretePlacementListResponse';
  /** the total count of ConcretePlacement records matching any configured filters */
  count: Scalars['Int'];
  /** the total count of paginated groups of ConcretePlacement */
  pages: Scalars['Int'];
  /** ConcretePlacement records */
  records: Array<ConcretePlacement>;
};

export type ConcreteProductionData = {
  __typename: 'ConcreteProductionData';
  concreteTemperature: Maybe<Scalars['Float']>;
  concreteTestSet: Maybe<ConcreteTestSet>;
  concreteTestSetGuid: Maybe<Scalars['String']>;
  /** the date this record was inserted into the database */
  createdDate: Maybe<Scalars['DateTime']>;
  /** the username or email address of a mobile app user associated with the `createdDate` */
  createdUser: Maybe<Scalars['String']>;
  deleted: Scalars['Boolean'];
  extraWaterPlant: Maybe<Scalars['Float']>;
  /** a GUID used to globally identify this record in the database */
  globalId: Scalars['String'];
  /** the date this record was last updated in the database */
  lastEditedDate: Maybe<Scalars['DateTime']>;
  /** the username or email address of a mobile app user associated with the `lastEditedDate` */
  lastEditedUser: Maybe<Scalars['String']>;
  moistureContentCoarseAgg1: Maybe<Scalars['Float']>;
  moistureContentCoarseAgg2: Maybe<Scalars['Float']>;
  moistureContentCoarseAgg3: Maybe<Scalars['Float']>;
  moistureContentFineAgg: Maybe<Scalars['Float']>;
  orderNum: Maybe<Scalars['Int']>;
  productionDataId: Maybe<Scalars['String']>;
  /** the `globalId` of a related `Project` */
  projectId: Maybe<Scalars['String']>;
  relativeYield: Maybe<Scalars['Float']>;
  sizeOfLoad: Maybe<Scalars['Float']>;
  ticketNumber: Maybe<Scalars['String']>;
  timeDeliveryCompleted: Maybe<Scalars['DateTime']>;
  timeLoadBatched: Maybe<Scalars['DateTime']>;
  totalCementWeight: Maybe<Scalars['Float']>;
  totalCementitousWeight: Maybe<Scalars['Float']>;
  totalCoarseAgg1Weight: Maybe<Scalars['Float']>;
  totalCoarseAgg2Weight: Maybe<Scalars['Float']>;
  totalCoarseAgg3Weight: Maybe<Scalars['Float']>;
  totalFineAggregateWeight: Maybe<Scalars['Float']>;
  totalFlyAshWeight: Maybe<Scalars['Float']>;
  totalFreeWaterCoarseAgg1: Maybe<Scalars['Float']>;
  totalFreeWaterCoarseAgg2: Maybe<Scalars['Float']>;
  totalFreeWaterCoarseAgg3: Maybe<Scalars['Float']>;
  totalFreeWaterFineAgg: Maybe<Scalars['Float']>;
  totalWeightMaterials: Maybe<Scalars['Float']>;
  unusedWaterForLoad: Maybe<Scalars['Float']>;
  waterAddedBatchPlant: Maybe<Scalars['Float']>;
  waterAddedOnSite: Maybe<Scalars['Float']>;
};

/**
 * helps filter multiple `ConcreteProductionData` records
 *
 * this version of the input will have limited options compared to its other counterpart
 */
export type ConcreteProductionDataFieldInput = {
  concreteTemperature?: InputMaybe<FloatFilter>;
  concreteTestSetGuid?: InputMaybe<StringFilter>;
  createdDate?: InputMaybe<DateTimeFilter>;
  /**
   * determines now to handle deleted `ConcreteProductionData` records
   *
   * - when `true`, only return deleted records
   * - when `false`, do not return deleted records
   * - when omitted, `deleted` is ignored
   */
  deleted?: InputMaybe<Scalars['Boolean']>;
  extraWaterPlant?: InputMaybe<FloatFilter>;
  lastEditedDate?: InputMaybe<DateTimeFilter>;
  moistureContentCoarseAgg1?: InputMaybe<FloatFilter>;
  moistureContentCoarseAgg2?: InputMaybe<FloatFilter>;
  moistureContentCoarseAgg3?: InputMaybe<FloatFilter>;
  moistureContentFineAgg?: InputMaybe<FloatFilter>;
  /**
   * how to order `ConcreteProductionData` records
   *
   * executed in the order they are defined
   */
  orderBy?: InputMaybe<Array<OrderByInput>>;
  productionDataId?: InputMaybe<StringFilter>;
  projectId?: InputMaybe<StringFilter>;
  relativeYield?: InputMaybe<FloatFilter>;
  sizeOfLoad?: InputMaybe<FloatFilter>;
  /**
   * specifies how many records to return
   *
   * analogous to `limit`, `first`, or `top` in SQL dialects
   */
  take?: InputMaybe<Scalars['Int']>;
  ticketNumber?: InputMaybe<StringFilter>;
  totalCementWeight?: InputMaybe<FloatFilter>;
  totalCementitousWeight?: InputMaybe<FloatFilter>;
  totalCoarseAgg1Weight?: InputMaybe<FloatFilter>;
  totalCoarseAgg2Weight?: InputMaybe<FloatFilter>;
  totalCoarseAgg3Weight?: InputMaybe<FloatFilter>;
  totalFineAggregateWeight?: InputMaybe<FloatFilter>;
  totalFlyAshWeight?: InputMaybe<FloatFilter>;
  totalFreeWaterCoarseAgg1?: InputMaybe<FloatFilter>;
  totalFreeWaterCoarseAgg2?: InputMaybe<FloatFilter>;
  totalFreeWaterCoarseAgg3?: InputMaybe<FloatFilter>;
  totalFreeWaterFineAgg?: InputMaybe<FloatFilter>;
  totalWeightMaterials?: InputMaybe<FloatFilter>;
  unusedWaterForLoad?: InputMaybe<FloatFilter>;
  waterAddedBatchPlant?: InputMaybe<FloatFilter>;
  waterAddedOnSite?: InputMaybe<FloatFilter>;
};

/** helps filter multiple `ConcreteProductionData` records */
export type ConcreteProductionDataListInput = {
  concreteTemperature?: InputMaybe<FloatFilter>;
  concreteTestSetGuid?: InputMaybe<StringFilter>;
  createdDate?: InputMaybe<DateTimeFilter>;
  /**
   * determines now to handle deleted `ConcreteProductionData` records
   *
   * - when `true`, only return deleted records
   * - when `false`, do not return deleted records
   * - when omitted, `deleted` is ignored
   */
  deleted?: InputMaybe<Scalars['Boolean']>;
  extraWaterPlant?: InputMaybe<FloatFilter>;
  lastEditedDate?: InputMaybe<DateTimeFilter>;
  moistureContentCoarseAgg1?: InputMaybe<FloatFilter>;
  moistureContentCoarseAgg2?: InputMaybe<FloatFilter>;
  moistureContentCoarseAgg3?: InputMaybe<FloatFilter>;
  moistureContentFineAgg?: InputMaybe<FloatFilter>;
  /**
   * how to order `ConcreteProductionData` records
   *
   * executed in the order they are defined
   */
  orderBy?: InputMaybe<Array<OrderByInput>>;
  /**
   * paginate `ConcreteProductionData` records
   *
   * using `paginate` may require multiple requests to get all possible results,
   * but will give more fine-grain control in the event all records cannot be
   * returned gracefully
   */
  paginate?: InputMaybe<PaginationInput>;
  productionDataId?: InputMaybe<StringFilter>;
  projectId?: InputMaybe<StringFilter>;
  relativeYield?: InputMaybe<FloatFilter>;
  sizeOfLoad?: InputMaybe<FloatFilter>;
  ticketNumber?: InputMaybe<StringFilter>;
  totalCementWeight?: InputMaybe<FloatFilter>;
  totalCementitousWeight?: InputMaybe<FloatFilter>;
  totalCoarseAgg1Weight?: InputMaybe<FloatFilter>;
  totalCoarseAgg2Weight?: InputMaybe<FloatFilter>;
  totalCoarseAgg3Weight?: InputMaybe<FloatFilter>;
  totalFineAggregateWeight?: InputMaybe<FloatFilter>;
  totalFlyAshWeight?: InputMaybe<FloatFilter>;
  totalFreeWaterCoarseAgg1?: InputMaybe<FloatFilter>;
  totalFreeWaterCoarseAgg2?: InputMaybe<FloatFilter>;
  totalFreeWaterCoarseAgg3?: InputMaybe<FloatFilter>;
  totalFreeWaterFineAgg?: InputMaybe<FloatFilter>;
  totalWeightMaterials?: InputMaybe<FloatFilter>;
  unusedWaterForLoad?: InputMaybe<FloatFilter>;
  waterAddedBatchPlant?: InputMaybe<FloatFilter>;
  waterAddedOnSite?: InputMaybe<FloatFilter>;
};

/** response metadata for a list query of ConcreteProductionData records */
export type ConcreteProductionDataListResponse = {
  __typename: 'ConcreteProductionDataListResponse';
  /** the total count of ConcreteProductionData records matching any configured filters */
  count: Scalars['Int'];
  /** the total count of paginated groups of ConcreteProductionData */
  pages: Scalars['Int'];
  /** ConcreteProductionData records */
  records: Array<ConcreteProductionData>;
};

export type ConcreteSampleLocation = {
  __typename: 'ConcreteSampleLocation';
  alignment: Maybe<Scalars['String']>;
  archiveDate: Maybe<Scalars['DateTime']>;
  archiveUser: Maybe<Scalars['String']>;
  archived: Maybe<Scalars['String']>;
  closed: Maybe<Scalars['DateTime']>;
  concretePlacement: Maybe<ConcretePlacement>;
  concretePlacementGuid: Maybe<Scalars['String']>;
  concreteTestSet: Maybe<ConcreteTestSet>;
  concreteTestSetGuid: Maybe<Scalars['String']>;
  /** the date this record was inserted into the database */
  createdDate: Maybe<Scalars['DateTime']>;
  /** the username or email address of a mobile app user associated with the `createdDate` */
  createdUser: Maybe<Scalars['String']>;
  deleted: Maybe<Scalars['String']>;
  /** a GUID used to globally identify this record in the database */
  globalId: Scalars['String'];
  /** the date this record was last updated in the database */
  lastEditedDate: Maybe<Scalars['DateTime']>;
  /** the username or email address of a mobile app user associated with the `lastEditedDate` */
  lastEditedUser: Maybe<Scalars['String']>;
  measurementDate: Maybe<Scalars['DateTime']>;
  measurementId: Maybe<Scalars['String']>;
  /**
   * If set, contains a comma separated list of
   * `PayItemNoGeometry.globalId` values
   *
   * unfortunately, there have been instances where one of these values doesn't map
   * to a valid `PayItemNoGeometry`
   *
   * `payItemNoGeometries` will skip these rather than map them to `null`
   */
  multiplePayItems: Maybe<Scalars['String']>;
  notes: Maybe<Scalars['String']>;
  offset: Maybe<Scalars['String']>;
  overrideComments: Maybe<Scalars['String']>;
  payItemsGuid: Maybe<Scalars['String']>;
  /** a related `Project` */
  project: Maybe<Project>;
  /** the `globalId` of a related `Project` */
  projectId: Maybe<Scalars['String']>;
  reopen: Maybe<Scalars['DateTime']>;
  sampleIdentifier: Maybe<Scalars['Float']>;
  shape: Maybe<Scalars['String']>;
  station: Maybe<Scalars['String']>;
  status: Maybe<Scalars['String']>;
  technician: Maybe<Technician>;
  technicianGuid: Maybe<Scalars['String']>;
};

/**
 * helps filter multiple `ConcreteSampleLocation` records
 *
 * this version of the input will have limited options compared to its other counterpart
 */
export type ConcreteSampleLocationFieldInput = {
  createdDate?: InputMaybe<DateTimeFilter>;
  /**
   * determines now to handle deleted `ConcreteSampleLocation` records
   *
   * - when `true`, only return deleted records
   * - when `false`, do not return deleted records
   * - when omitted, `deleted` is ignored
   */
  deleted?: InputMaybe<Scalars['Boolean']>;
  lastEditedDate?: InputMaybe<DateTimeFilter>;
  /**
   * how to order `ConcreteSampleLocation` records
   *
   * executed in the order they are defined
   */
  orderBy?: InputMaybe<Array<OrderByInput>>;
  projectId?: InputMaybe<StringFilter>;
  /**
   * specifies how many records to return
   *
   * analogous to `limit`, `first`, or `top` in SQL dialects
   */
  take?: InputMaybe<Scalars['Int']>;
};

/** helps filter multiple `ConcreteSampleLocation` records */
export type ConcreteSampleLocationListInput = {
  createdDate?: InputMaybe<DateTimeFilter>;
  /**
   * determines now to handle deleted `ConcreteSampleLocation` records
   *
   * - when `true`, only return deleted records
   * - when `false`, do not return deleted records
   * - when omitted, `deleted` is ignored
   */
  deleted?: InputMaybe<Scalars['Boolean']>;
  lastEditedDate?: InputMaybe<DateTimeFilter>;
  /**
   * how to order `ConcreteSampleLocation` records
   *
   * executed in the order they are defined
   */
  orderBy?: InputMaybe<Array<OrderByInput>>;
  /**
   * paginate `ConcreteSampleLocation` records
   *
   * using `paginate` may require multiple requests to get all possible results,
   * but will give more fine-grain control in the event all records cannot be
   * returned gracefully
   */
  paginate?: InputMaybe<PaginationInput>;
  projectId?: InputMaybe<StringFilter>;
};

/** response metadata for a list query of ConcreteSampleLocation records */
export type ConcreteSampleLocationListResponse = {
  __typename: 'ConcreteSampleLocationListResponse';
  /** the total count of ConcreteSampleLocation records matching any configured filters */
  count: Scalars['Int'];
  /** the total count of paginated groups of ConcreteSampleLocation */
  pages: Scalars['Int'];
  /** ConcreteSampleLocation records */
  records: Array<ConcreteSampleLocation>;
};

export type ConcreteTest = {
  __typename: 'ConcreteTest';
  airAdded: Maybe<Scalars['String']>;
  airMeterCalibrationDate: Maybe<Scalars['DateTime']>;
  airMeterNumber: Maybe<Scalars['String']>;
  airTemp: Maybe<Scalars['Float']>;
  alignment: Maybe<Scalars['String']>;
  archiveDate: Maybe<Scalars['DateTime']>;
  archiveUser: Maybe<Scalars['String']>;
  archived: Maybe<Scalars['String']>;
  average28DayStrength: Scalars['Int'];
  batchTime: Maybe<Scalars['DateTime']>;
  closed: Maybe<Scalars['DateTime']>;
  concreteTemp: Maybe<Scalars['Float']>;
  concreteTempTestedBy: Maybe<Technician>;
  /** the `globalId` of a related `Technician` */
  concreteTempTestedByGuid: Maybe<Scalars['String']>;
  concreteTestBreakData: Array<ConcreteTestBreakData>;
  concreteTestSet: Maybe<ConcreteTestSet>;
  /** the `globalId` of a related `ConcreteTestSet` */
  concreteTestSetGuid: Maybe<Scalars['String']>;
  /**
   * @deprecated this field has been deprecated and expires once all projects previously using this field have been archived.
   *
   * it may be removed at any time after expiration, but not before
   *
   * `ConcreteTestSetPlacement` was created to connect a `ConcreteTest`
   * and `ConcretePlacement` in older versions of the Field App
   *
   * `ConcreteTestSet` now fulfills that roll, while also holding its own metadata
   *
   * `ConcreteTestSetPlacement` will be removed when all projects on older versions
   * of the Field App upgrade to a newer version of the Field App, or finish
   */
  concreteTestSetPlacements: Array<ConcreteTestSetPlacement>;
  contractor: Maybe<Contractor>;
  /** the `globalId` of a related `Contractor` */
  contractorGuid: Maybe<Scalars['String']>;
  /** the date this record was inserted into the database */
  createdDate: Maybe<Scalars['DateTime']>;
  /** the username or email address of a mobile app user associated with the `createdDate` */
  createdUser: Maybe<Scalars['String']>;
  cylinderNumber: Maybe<Scalars['String']>;
  cylindersCaseByTech: Maybe<Technician>;
  /** the `globalId` of a related `Technician` */
  cylindersCaseByTechGuid: Maybe<Scalars['String']>;
  deleted: Maybe<Scalars['String']>;
  ejToReports: Array<EjToReport>;
  /**
   * chooses the correct test identifier by preferring
   * `cylinderNum` over `testSubId`
   *
   * this is not stored in the database
   */
  fieldNumber: Maybe<Scalars['String']>;
  generatedInfo: Maybe<Scalars['String']>;
  /** a GUID used to globally identify this record in the database */
  globalId: Scalars['String'];
  iaSample: Maybe<Scalars['String']>;
  iaWith: Maybe<Scalars['String']>;
  identifiedFieldIssue: Maybe<IdentifiedFieldIssue>;
  issueToReports: Array<IssueToReport>;
  /** the date this record was last updated in the database */
  lastEditedDate: Maybe<Scalars['DateTime']>;
  /** the username or email address of a mobile app user associated with the `lastEditedDate` */
  lastEditedUser: Maybe<Scalars['String']>;
  /**
   * If set, contains a comma separated list of
   * `PayItemNoGeometry.globalId` values
   *
   * unfortunately, there have been instances where one of these values doesn't map
   * to a valid `PayItemNoGeometry`
   *
   * `payItemNoGeometries` will skip these rather than map them to `null`
   */
  multiplePayItems: Maybe<Scalars['String']>;
  notes: Maybe<Scalars['String']>;
  overrideComments: Maybe<Scalars['String']>;
  /**
   * aggregates all `PayItemNoGeometry` records associated with this
   * `ConcreteTest` by using its `PayItemNoGeometry` reference and `multiplePayItems`
   *
   * if any `PayItemNoGeometry.globalId` values used to query the database return `null`,
   * the `null` value will be filtered out of the results
   *
   * every result will be a valid `PayItemNoGeometry`
   */
  payItemNoGeometries: Array<PayItemNoGeometry>;
  payItemsGuid: Maybe<Scalars['String']>;
  percentAir: Maybe<Scalars['Float']>;
  percentAirTestedBy: Maybe<Technician>;
  /** the `globalId` of a related `Technician` */
  percentAirTestedByGuid: Maybe<Scalars['String']>;
  placementDate: Maybe<Scalars['DateTime']>;
  /** a related `Project` */
  project: Maybe<Project>;
  /** the `globalId` of a related `Project` */
  projectId: Maybe<Scalars['String']>;
  reOpen: Maybe<Scalars['DateTime']>;
  renderInfo: Maybe<Scalars['String']>;
  sampleAtQuantity: Maybe<Scalars['Float']>;
  sampleAtQuantityModified: Maybe<Scalars['String']>;
  slump: Maybe<Scalars['Float']>;
  slumpTestedBy: Maybe<Technician>;
  /** the `globalId` of a related `Technician` */
  slumpTestedByGuid: Maybe<Scalars['String']>;
  station1: Maybe<Scalars['String']>;
  station2: Maybe<Scalars['String']>;
  station3: Maybe<Scalars['String']>;
  station4: Maybe<Scalars['String']>;
  status: Maybe<Scalars['String']>;
  strengthAge: Maybe<Scalars['String']>;
  /**
   * parses `strengthAge` into a sorted array of integers
   *
   * assumes `strengthAge` to be a comma separated list of the following symbols
   *
   * - `x`
   * - `x(y)`
   *
   * where `x` is the age, and `y` is the number of times the age should repeat itself
   */
  strengthAges: Array<Scalars['Int']>;
  testSubId: Maybe<Scalars['String']>;
  testType: Maybe<Scalars['Int']>;
  timeTested: Scalars['DateTime'];
  truckNumber: Maybe<Scalars['Int']>;
  truckRejected: Maybe<Scalars['Int']>;
  unitWeight: Maybe<Scalars['Float']>;
  unitWeightTech: Maybe<Technician>;
  /** the `globalId` of a related `Technician` */
  unitWeightTechGuid: Maybe<Scalars['String']>;
  waterAdded: Maybe<Scalars['String']>;
};


export type ConcreteTestAverage28DayStrengthArgs = {
  concreteTestBreakDataFieldInput?: InputMaybe<ConcreteTestBreakDataFieldInput>;
};


export type ConcreteTestConcreteTestBreakDataArgs = {
  concreteTestBreakDataFieldInput?: InputMaybe<ConcreteTestBreakDataFieldInput>;
};


export type ConcreteTestEjToReportsArgs = {
  eJToReportFieldInput?: InputMaybe<EjToReportFieldInput>;
};


export type ConcreteTestIssueToReportsArgs = {
  issueToReportFieldInput?: InputMaybe<IssueToReportFieldInput>;
};


export type ConcreteTestPayItemNoGeometriesArgs = {
  payItemNoGeometryFieldInput?: InputMaybe<PayItemNoGeometryFieldInput>;
};

export type ConcreteTestAmbientAirIfiSettings = {
  __typename: 'ConcreteTestAmbientAirIFISettings';
  /** the date this record was enabled the database */
  effectiveDate: Maybe<Scalars['DateTime']>;
  enabled: Scalars['Boolean'];
  message: Maybe<Scalars['String']>;
  minimumAmbientAirTemperature: Maybe<Scalars['Float']>;
};

export type ConcreteTestBreakData = {
  __typename: 'ConcreteTestBreakData';
  age: Maybe<Scalars['Int']>;
  breakDate: Maybe<Scalars['DateTime']>;
  concreteTest: ConcreteTest;
  concreteTestId: Scalars['String'];
  /** the date this record was inserted into the database */
  createdDate: Scalars['DateTime'];
  /**
   * the email address of a user associated with the `createdDate`
   *
   * this value will be `unknown` if the `createdDate` was not set by a user
   */
  createdUser: Scalars['String'];
  diameter: Maybe<Scalars['String']>;
  /** a unique integer to identify this record in the database table */
  id: Scalars['Int'];
  labNumber: Maybe<Scalars['String']>;
  labTech: Maybe<LabTech>;
  /** the `id` of a related `LabTech` */
  labTechId: Maybe<Scalars['Int']>;
  /** the date this record was last updated in the database */
  lastEditedDate: Scalars['DateTime'];
  /**
   * the email address of a user associated with the `lastEditedDate`
   *
   * this value will be `system` if the `lastEditedDate` was not set by a user
   */
  lastEditedUser: Scalars['String'];
  peakLoad: Maybe<Scalars['Int']>;
  strength: Maybe<Scalars['Int']>;
  testingLab: Maybe<TestingLab>;
  /** the `id` of a related `TestingLab` */
  testingLabId: Maybe<Scalars['Int']>;
  type: Maybe<Scalars['String']>;
};

/**
 * helps filter multiple `ConcreteTestBreakData` records
 *
 * this version of the input will have limited options compared to its other counterpart
 */
export type ConcreteTestBreakDataFieldInput = {
  age?: InputMaybe<IntFilter>;
  breakDate?: InputMaybe<DateTimeFilter>;
  concreteTestId?: InputMaybe<StringFilter>;
  createdDate?: InputMaybe<DateTimeFilter>;
  diameter?: InputMaybe<StringFilter>;
  labNumber?: InputMaybe<StringFilter>;
  lastEditedDate?: InputMaybe<DateTimeFilter>;
  /**
   * how to order `ConcreteTestBreakData` records
   *
   * executed in the order they are defined
   */
  orderBy?: InputMaybe<Array<OrderByInput>>;
  peakLoad?: InputMaybe<IntFilter>;
  /**
   * specifies how many records to return
   *
   * analogous to `limit`, `first`, or `top` in SQL dialects
   */
  take?: InputMaybe<Scalars['Int']>;
  type?: InputMaybe<StringFilter>;
};

/** helps filter multiple `ConcreteTestBreakData` records */
export type ConcreteTestBreakDataListInput = {
  age?: InputMaybe<IntFilter>;
  breakDate?: InputMaybe<DateTimeFilter>;
  concreteTestId?: InputMaybe<StringFilter>;
  createdDate?: InputMaybe<DateTimeFilter>;
  diameter?: InputMaybe<StringFilter>;
  labNumber?: InputMaybe<StringFilter>;
  lastEditedDate?: InputMaybe<DateTimeFilter>;
  /**
   * how to order `ConcreteTestBreakData` records
   *
   * executed in the order they are defined
   */
  orderBy?: InputMaybe<Array<OrderByInput>>;
  /**
   * paginate `ConcreteTestBreakData` records
   *
   * using `paginate` may require multiple requests to get all possible results,
   * but will give more fine-grain control in the event all records cannot be
   * returned gracefully
   */
  paginate?: InputMaybe<PaginationInput>;
  peakLoad?: InputMaybe<IntFilter>;
  type?: InputMaybe<StringFilter>;
};

/** response metadata for a list query of ConcreteTestBreakData records */
export type ConcreteTestBreakDataListResponse = {
  __typename: 'ConcreteTestBreakDataListResponse';
  /** the total count of ConcreteTestBreakData records matching any configured filters */
  count: Scalars['Int'];
  /** the total count of paginated groups of ConcreteTestBreakData */
  pages: Scalars['Int'];
  /** ConcreteTestBreakData records */
  records: Array<ConcreteTestBreakData>;
};

/**
 * helps filter multiple `ConcreteTest` records
 *
 * this version of the input will have limited options compared to its other counterpart
 */
export type ConcreteTestFieldInput = {
  createdDate?: InputMaybe<DateTimeFilter>;
  cylinderNumber?: InputMaybe<StringFilter>;
  /**
   * determines now to handle deleted `ConcreteTest` records
   *
   * - when `true`, only return deleted records
   * - when `false`, do not return deleted records
   * - when omitted, `deleted` is ignored
   */
  deleted?: InputMaybe<Scalars['Boolean']>;
  fieldNumber?: InputMaybe<StringFilter>;
  lastEditedDate?: InputMaybe<DateTimeFilter>;
  /**
   * how to order `ConcreteTest` records
   *
   * executed in the order they are defined
   */
  orderBy?: InputMaybe<Array<OrderByInput>>;
  projectId?: InputMaybe<StringFilter>;
  /**
   * specifies how many records to return
   *
   * analogous to `limit`, `first`, or `top` in SQL dialects
   */
  take?: InputMaybe<Scalars['Int']>;
  testSubId?: InputMaybe<StringFilter>;
};

export type ConcreteTestIfiSettings = {
  __typename: 'ConcreteTestIFISettings';
  ambientAir: ConcreteTestAmbientAirIfiSettings;
  /** the date this record was inserted into the database */
  createdDate: Scalars['DateTime'];
  /**
   * the email address of a user associated with the `createdDate`
   *
   * this value will be `unknown` if the `createdDate` was not set by a user
   */
  createdUser: Scalars['String'];
  effectiveDate: Maybe<Scalars['DateTime']>;
  enabled: Scalars['Boolean'];
  /** the date this record was last updated in the database */
  lastEditedDate: Scalars['DateTime'];
  /**
   * the email address of a user associated with the `lastEditedDate`
   *
   * this value will be `system` if the `lastEditedDate` was not set by a user
   */
  lastEditedUser: Scalars['String'];
  percentAir: ConcreteTestPercentAirIfiSettings;
  /** a related `Project` */
  project: Project;
  /** the `globalId` of a related `Project` */
  projectId: Scalars['String'];
  slump: ConcreteTestSlumpIfiSettings;
  temperature: ConcreteTestTemperatureIfiSettings;
};

/** helps filter multiple `ConcreteTestIFISettings` records */
export type ConcreteTestIfiSettingsListInput = {
  /**
   * determines now to handle deleted `ConcreteTestIFISettings` records
   *
   * - when `true`, only return deleted records
   * - when `false`, do not return deleted records
   * - when omitted, `deleted` is ignored
   */
  deleted?: InputMaybe<Scalars['Boolean']>;
  effectiveDate?: InputMaybe<DateTimeFilter>;
  /**
   * how to order `ConcreteTestIFISettings` records
   *
   * executed in the order they are defined
   */
  orderBy?: InputMaybe<Array<OrderByInput>>;
  /**
   * paginate `ConcreteTestIFISettings` records
   *
   * using `paginate` may require multiple requests to get all possible results,
   * but will give more fine-grain control in the event all records cannot be
   * returned gracefully
   */
  paginate?: InputMaybe<PaginationInput>;
  projectId?: InputMaybe<StringFilter>;
};

/** response metadata for a list query of ConcreteTestIFISettings records */
export type ConcreteTestIfiSettingsListResponse = {
  __typename: 'ConcreteTestIFISettingsListResponse';
  /** the total count of ConcreteTestIFISettings records matching any configured filters */
  count: Scalars['Int'];
  /** the total count of paginated groups of ConcreteTestIFISettings */
  pages: Scalars['Int'];
  /** ConcreteTestIFISettings records */
  records: Array<ConcreteTestIfiSettings>;
};

/** helps filter multiple `ConcreteTest` records */
export type ConcreteTestListInput = {
  createdDate?: InputMaybe<DateTimeFilter>;
  cylinderNumber?: InputMaybe<StringFilter>;
  /**
   * determines now to handle deleted `ConcreteTest` records
   *
   * - when `true`, only return deleted records
   * - when `false`, do not return deleted records
   * - when omitted, `deleted` is ignored
   */
  deleted?: InputMaybe<Scalars['Boolean']>;
  fieldNumber?: InputMaybe<StringFilter>;
  lastEditedDate?: InputMaybe<DateTimeFilter>;
  /**
   * how to order `ConcreteTest` records
   *
   * executed in the order they are defined
   */
  orderBy?: InputMaybe<Array<OrderByInput>>;
  /**
   * paginate `ConcreteTest` records
   *
   * using `paginate` may require multiple requests to get all possible results,
   * but will give more fine-grain control in the event all records cannot be
   * returned gracefully
   */
  paginate?: InputMaybe<PaginationInput>;
  projectId?: InputMaybe<StringFilter>;
  testSubId?: InputMaybe<StringFilter>;
};

/** response metadata for a list query of ConcreteTest records */
export type ConcreteTestListResponse = {
  __typename: 'ConcreteTestListResponse';
  /** the total count of ConcreteTest records matching any configured filters */
  count: Scalars['Int'];
  /** the total count of paginated groups of ConcreteTest */
  pages: Scalars['Int'];
  /** ConcreteTest records */
  records: Array<ConcreteTest>;
};

export type ConcreteTestPercentAirIfiSettings = {
  __typename: 'ConcreteTestPercentAirIFISettings';
  /** the date this record was enabled the database */
  effectiveDate: Maybe<Scalars['DateTime']>;
  enabled: Scalars['Boolean'];
  highMessage: Maybe<Scalars['String']>;
  lowMessage: Maybe<Scalars['String']>;
};

export type ConcreteTestSet = {
  __typename: 'ConcreteTestSet';
  airMeterCalibrationDate: Maybe<Scalars['DateTime']>;
  airMeterNumber: Maybe<Scalars['String']>;
  archiveDate: Maybe<Scalars['DateTime']>;
  archiveUser: Maybe<Scalars['String']>;
  archived: Maybe<Scalars['String']>;
  checkGenerateErrors: Maybe<Scalars['String']>;
  closed: Maybe<Scalars['DateTime']>;
  concreteFieldDatas: Array<ConcreteFieldData>;
  concreteMaterial: Maybe<ConcreteMaterial>;
  /** the `globalId` of a related `ConcreteMaterial` */
  concreteMaterialsGuid: Maybe<Scalars['String']>;
  concreteMixDesign: Maybe<ConcreteMixDesign>;
  /** the `globalId` of a related `ConcreteMixDesign` */
  concreteMixDesignGuid: Maybe<Scalars['String']>;
  concretePlacements: Array<ConcretePlacement>;
  concreteProductionDatas: Array<ConcreteProductionData>;
  concreteSampleLocations: Array<ConcreteSampleLocation>;
  concreteTestSetMetadata: Maybe<ConcreteTestSetMetadata>;
  concreteTests: Array<ConcreteTest>;
  /** the date this record was inserted into the database */
  createdDate: Maybe<Scalars['DateTime']>;
  /** the username or email address of a mobile app user associated with the `createdDate` */
  createdUser: Maybe<Scalars['String']>;
  deleted: Maybe<Scalars['String']>;
  documentChecklistValues: Array<DocumentChecklistValue>;
  estimatedQuantity: Maybe<Scalars['Float']>;
  estimatedThicknessIn: Maybe<Scalars['Float']>;
  /** a GUID used to globally identify this record in the database */
  globalId: Scalars['String'];
  hydration_stabilizer_approved: Maybe<Scalars['String']>;
  issueToReports: Array<IssueToReport>;
  /** the date this record was last updated in the database */
  lastEditedDate: Maybe<Scalars['DateTime']>;
  /** the username or email address of a mobile app user associated with the `lastEditedDate` */
  lastEditedUser: Maybe<Scalars['String']>;
  mediaUploads: Array<MediaUpload>;
  /**
   * If set, contains a comma separated list of
   * `PayItemNoGeometry.globalId` values
   *
   * unfortunately, there have been instances where one of these values doesn't map
   * to a valid `PayItemNoGeometry`
   *
   * `payItemNoGeometries` will skip these rather than map them to `null`
   */
  multiplePayItems: Maybe<Scalars['String']>;
  overrideComments: Maybe<Scalars['String']>;
  payItemGuid: Maybe<Scalars['String']>;
  /**
   * aggregates all `PayItemNoGeometry` records associated with this
   * `ConcreteTestSet` by using its `PayItemNoGeometry` reference and `multiplePayItems`
   *
   * if any `PayItemNoGeometry.globalId` values used to query the database return `null`,
   * the `null` value will be filtered out of the results
   *
   * every result will be a valid `PayItemNoGeometry`
   */
  payItemNoGeometries: Array<PayItemNoGeometry>;
  placementDate: Maybe<Scalars['DateTime']>;
  /** a related `Project` */
  project: Maybe<Project>;
  /** the `globalId` of a related `Project` */
  projectId: Maybe<Scalars['String']>;
  reOpen: Maybe<Scalars['DateTime']>;
  reject: Maybe<Scalars['DateTime']>;
  reportToTags: Array<ReportToTag>;
  reviewComment: Maybe<Scalars['String']>;
  reviewedBy: Maybe<Technician>;
  reviewedByGuid: Maybe<Scalars['String']>;
  /** pulls a `SharePointResource` object from SharePoint for the parent folder associated with this `ConcreteTestSet` */
  sharePointResource: Maybe<SharePointResource>;
  status: Maybe<Scalars['String']>;
  technician: Maybe<Technician>;
  technicianGuid: Maybe<Scalars['String']>;
  testSetId: Maybe<Scalars['String']>;
};


export type ConcreteTestSetConcreteFieldDatasArgs = {
  concreteFieldDataFieldInput?: InputMaybe<ConcreteFieldDataFieldInput>;
};


export type ConcreteTestSetConcretePlacementsArgs = {
  concretePlacementFieldInput?: InputMaybe<ConcretePlacementFieldInput>;
};


export type ConcreteTestSetConcreteProductionDatasArgs = {
  concreteProductionDataFieldInput?: InputMaybe<ConcreteProductionDataFieldInput>;
};


export type ConcreteTestSetConcreteSampleLocationsArgs = {
  concreteSampleLocationFieldInput?: InputMaybe<ConcreteSampleLocationFieldInput>;
};


export type ConcreteTestSetConcreteTestsArgs = {
  concreteTestFieldInput?: InputMaybe<ConcreteTestFieldInput>;
};


export type ConcreteTestSetDocumentChecklistValuesArgs = {
  documentChecklistValueFieldInput?: InputMaybe<DocumentChecklistValueFieldInput>;
};


export type ConcreteTestSetIssueToReportsArgs = {
  issueToReportFieldInput?: InputMaybe<IssueToReportFieldInput>;
};


export type ConcreteTestSetMediaUploadsArgs = {
  mediaUploadFieldInput?: InputMaybe<MediaUploadFieldInput>;
};


export type ConcreteTestSetPayItemNoGeometriesArgs = {
  payItemNoGeometryFieldInput?: InputMaybe<PayItemNoGeometryFieldInput>;
};


export type ConcreteTestSetReportToTagsArgs = {
  reportToTagFieldInput?: InputMaybe<ReportToTagFieldInput>;
};

/**
 * helps filter multiple `ConcreteTestSet` records
 *
 * this version of the input will have limited options compared to its other counterpart
 */
export type ConcreteTestSetFieldInput = {
  createdDate?: InputMaybe<DateTimeFilter>;
  /**
   * determines now to handle deleted `ConcreteTestSet` records
   *
   * - when `true`, only return deleted records
   * - when `false`, do not return deleted records
   * - when omitted, `deleted` is ignored
   */
  deleted?: InputMaybe<Scalars['Boolean']>;
  globalId?: InputMaybe<StringFilter>;
  lastEditedDate?: InputMaybe<DateTimeFilter>;
  /**
   * how to order `ConcreteTestSet` records
   *
   * executed in the order they are defined
   */
  orderBy?: InputMaybe<Array<OrderByInput>>;
  projectId?: InputMaybe<StringFilter>;
  status?: InputMaybe<StringFilter>;
  /**
   * specifies how many records to return
   *
   * analogous to `limit`, `first`, or `top` in SQL dialects
   */
  take?: InputMaybe<Scalars['Int']>;
  testSetId?: InputMaybe<StringFilter>;
};

/** helps filter multiple `ConcreteTestSet` records */
export type ConcreteTestSetListInput = {
  createdDate?: InputMaybe<DateTimeFilter>;
  /**
   * determines now to handle deleted `ConcreteTestSet` records
   *
   * - when `true`, only return deleted records
   * - when `false`, do not return deleted records
   * - when omitted, `deleted` is ignored
   */
  deleted?: InputMaybe<Scalars['Boolean']>;
  globalId?: InputMaybe<StringFilter>;
  lastEditedDate?: InputMaybe<DateTimeFilter>;
  /**
   * how to order `ConcreteTestSet` records
   *
   * executed in the order they are defined
   */
  orderBy?: InputMaybe<Array<OrderByInput>>;
  /**
   * paginate `ConcreteTestSet` records
   *
   * using `paginate` may require multiple requests to get all possible results,
   * but will give more fine-grain control in the event all records cannot be
   * returned gracefully
   */
  paginate?: InputMaybe<PaginationInput>;
  projectId?: InputMaybe<StringFilter>;
  status?: InputMaybe<StringFilter>;
  testSetId?: InputMaybe<StringFilter>;
};

/** response metadata for a list query of ConcreteTestSet records */
export type ConcreteTestSetListResponse = {
  __typename: 'ConcreteTestSetListResponse';
  /** the total count of ConcreteTestSet records matching any configured filters */
  count: Scalars['Int'];
  /** the total count of paginated groups of ConcreteTestSet */
  pages: Scalars['Int'];
  /** ConcreteTestSet records */
  records: Array<ConcreteTestSet>;
};

export type ConcreteTestSetMetadata = {
  __typename: 'ConcreteTestSetMetadata';
  concreteTestSet: ConcreteTestSet;
  /** the `globalId` of a related `ConcreteTestSet` */
  concreteTestSetId: Scalars['String'];
  /** the date this record was inserted into the database */
  createdDate: Scalars['DateTime'];
  /**
   * the email address of a user associated with the `createdDate`
   *
   * this value will be `unknown` if the `createdDate` was not set by a user
   */
  createdUser: Scalars['String'];
  /** the date this record was last updated in the database */
  lastEditedDate: Scalars['DateTime'];
  /**
   * the email address of a user associated with the `lastEditedDate`
   *
   * this value will be `system` if the `lastEditedDate` was not set by a user
   */
  lastEditedUser: Scalars['String'];
  /**
   * this is
   * stored in the database with data from the Microsoft Graph API
   *
   * it corresponds to a `DriveItem.id` value
   * @deprecated this field has been deprecated and expires 2024-06-01
   *
   * it may be removed at any time after expiration, but not before
   *
   * use `packetSharePointResourceId` instead
   */
  packetSharePointItemId: Maybe<Scalars['String']>;
  packetSharePointResource: Maybe<SharePointResource>;
  packetSharePointResourceId: Maybe<Scalars['String']>;
  packetSharePointResourceName: Maybe<Scalars['String']>;
  packetSharePointResourceWebUrl: Maybe<Scalars['String']>;
  sharePointResourceId: Maybe<Scalars['String']>;
  sharePointResourceWebUrl: Maybe<Scalars['String']>;
};

/** helps filter multiple `ConcreteTestSetMetadata` records */
export type ConcreteTestSetMetadataListInput = {
  createdDate?: InputMaybe<DateTimeFilter>;
  lastEditedDate?: InputMaybe<DateTimeFilter>;
  /**
   * how to order `ConcreteTestSetMetadata` records
   *
   * executed in the order they are defined
   */
  orderBy?: InputMaybe<Array<OrderByInput>>;
  packetSharePointResourceName?: InputMaybe<StringFilter>;
  /**
   * paginate `ConcreteTestSetMetadata` records
   *
   * using `paginate` may require multiple requests to get all possible results,
   * but will give more fine-grain control in the event all records cannot be
   * returned gracefully
   */
  paginate?: InputMaybe<PaginationInput>;
};

/** response metadata for a list query of ConcreteTestSetMetadata records */
export type ConcreteTestSetMetadataListResponse = {
  __typename: 'ConcreteTestSetMetadataListResponse';
  /** the total count of ConcreteTestSetMetadata records matching any configured filters */
  count: Scalars['Int'];
  /** the total count of paginated groups of ConcreteTestSetMetadata */
  pages: Scalars['Int'];
  /** ConcreteTestSetMetadata records */
  records: Array<ConcreteTestSetMetadata>;
};

/**
 * `ConcreteTestSetPlacement` was created to connect a `ConcreteTest`
 * and `ConcretePlacement` in older versions of the Field App
 *
 * `ConcreteTestSet` now fulfills that roll, while also holding its own metadata
 *
 * `ConcreteTestSetPlacement` will be removed when all projects on older versions
 * of the Field App upgrade to a newer version of the Field App, or finish
 */
export type ConcreteTestSetPlacement = {
  __typename: 'ConcreteTestSetPlacement';
  concretePlacement: ConcretePlacement;
  /** the `globalId` of a related `ConcretePlacement` */
  concretePlacementGuid: Maybe<Scalars['String']>;
  concreteTest: ConcreteTest;
  /** the `globalId` of a related `ConcreteTest` */
  concreteTestGuid: Maybe<Scalars['String']>;
  concreteTestSet: Maybe<ConcreteTestSet>;
  /** the `globalId` of a related `ConcreteTestSet` */
  concreteTestSetGuid: Maybe<Scalars['String']>;
  /** the date this record was inserted into the database */
  createdDate: Maybe<Scalars['DateTime']>;
  /** the username or email address of a mobile app user associated with the `createdDate` */
  createdUser: Maybe<Scalars['String']>;
  deleted: Maybe<Scalars['String']>;
  /** a GUID used to globally identify this record in the database */
  globalId: Scalars['String'];
  /** the date this record was last updated in the database */
  lastEditedDate: Maybe<Scalars['DateTime']>;
  /** the username or email address of a mobile app user associated with the `lastEditedDate` */
  lastEditedUser: Maybe<Scalars['String']>;
  notes: Maybe<Scalars['String']>;
  /** a related `Project` */
  project: Maybe<Project>;
  /** the `globalId` of a related `Project` */
  projectId: Maybe<Scalars['String']>;
  status: Maybe<Scalars['String']>;
  testSetPlacementId: Maybe<Scalars['String']>;
};

export type ConcreteTestSlumpIfiSettings = {
  __typename: 'ConcreteTestSlumpIFISettings';
  /** the date this record was enabled the database */
  effectiveDate: Maybe<Scalars['DateTime']>;
  enabled: Scalars['Boolean'];
  highMessage: Maybe<Scalars['String']>;
  lowMessage: Maybe<Scalars['String']>;
};

export type ConcreteTestTemperatureIfiSettings = {
  __typename: 'ConcreteTestTemperatureIFISettings';
  /** the date this record was enabled the database */
  effectiveDate: Maybe<Scalars['DateTime']>;
  enabled: Scalars['Boolean'];
  highMessage: Maybe<Scalars['String']>;
  lowMessage: Maybe<Scalars['String']>;
  tempRange: Maybe<Scalars['String']>;
  temperatureHigh: Maybe<Scalars['Float']>;
  temperatureLow: Maybe<Scalars['Float']>;
};

export type ConstructionAdminSubmittal = {
  __typename: 'ConstructionAdminSubmittal';
  casToCASRoutingGroups: Array<CasToCasRoutingGroup>;
  casToPayItemNoGeometries: Array<CasToPayItemNoGeometry>;
  comments: Array<CasComment>;
  contractualReviewDate: Maybe<Scalars['DateTime']>;
  /** the date this record was inserted into the database */
  createdDate: Scalars['DateTime'];
  /**
   * the email address of a user associated with the `createdDate`
   *
   * this value will be `unknown` if the `createdDate` was not set by a user
   */
  createdUser: Scalars['String'];
  /**
   * custom fields are defined, configured, and activated for `ConstructionAdminSubmittal`
   *     records in the Administration module
   *
   *     values are saved and retrieved for each individual `ConstructionAdminSubmittal`
   */
  customFields: CustomFields;
  /** describes whether the record has been soft-deleted or not */
  deleted: Scalars['Boolean'];
  /** the date this record was soft-deleted in the database */
  deletedDate: Maybe<Scalars['DateTime']>;
  /**
   * the email address of a user associated with the `deletedDate`
   *
   * this value will be `system` if the `deletedDate` was not set by a user
   */
  deletedUser: Maybe<Scalars['String']>;
  dispositionBy: Maybe<User>;
  /** the `id` of a related `User` which gives the final disposition */
  dispositionById: Maybe<Scalars['String']>;
  /** a `DateTime` which is associated with the disposition */
  dispositionDate: Maybe<Scalars['DateTime']>;
  dispositionType: Maybe<CasDispositionType>;
  dispositionTypeId: Maybe<Scalars['String']>;
  externalLinks: Array<ExternalLink>;
  /** a UUID used to globally identify this record in the database */
  id: Scalars['String'];
  /** the date this record was last updated in the database */
  lastEditedDate: Scalars['DateTime'];
  /**
   * the email address of a user associated with the `lastEditedDate`
   *
   * this value will be `system` if the `lastEditedDate` was not set by a user
   */
  lastEditedUser: Scalars['String'];
  packageName: Scalars['String'];
  packageNumber: Scalars['String'];
  packetSharePointResource: Maybe<SharePointResource>;
  packetSharePointResourceId: Maybe<Scalars['String']>;
  packetSharePointResourceName: Maybe<Scalars['String']>;
  packetSharePointResourceWebUrl: Maybe<Scalars['String']>;
  /**
   * `ConstructionAdminSubmittal` records were populated from a deprecated, now removed, database table
   *
   * This field assists in opening old hyperlinks generated when the old table was active
   */
  previousId: Maybe<Scalars['Int']>;
  /** a related `Project` */
  project: Project;
  /** the `globalId` of a related `Project` */
  projectId: Scalars['String'];
  quantity: Scalars['Int'];
  requestedReviewDate: Scalars['DateTime'];
  /**
   * a composite field composed
   * of `packageNumber` and `packageName`
   */
  sharePointFolderName: Scalars['String'];
  /** pulls a `SharePointResource` object from SharePoint for the parent folder associated with this `ConstructionAdminSubmittal` */
  sharePointResource: Maybe<SharePointResource>;
  sharePointResourceId: Maybe<Scalars['String']>;
  sharePointResourceWebUrl: Maybe<Scalars['String']>;
  statusId: Scalars['String'];
  submittedBy: User;
  /** the `id` of a related `User` which submits the `ConstructionAdminSubmittal` */
  submittedById: Scalars['String'];
  subtype: Maybe<CasSubtype>;
  subtypeId: Maybe<Scalars['String']>;
  type: CasType;
  typeId: Scalars['String'];
  units: Scalars['String'];
};


export type ConstructionAdminSubmittalCasToCasRoutingGroupsArgs = {
  casToCASRoutingGroupFieldInput?: InputMaybe<CasToCasRoutingGroupFieldInput>;
};


export type ConstructionAdminSubmittalCasToPayItemNoGeometriesArgs = {
  casToPayItemNoGeometryFieldInput?: InputMaybe<CasToPayItemNoGeometryFieldInput>;
};


export type ConstructionAdminSubmittalCommentsArgs = {
  casCommentFieldInput?: InputMaybe<CasCommentFieldInput>;
};

/**
 * helps filter multiple `ConstructionAdminSubmittal` records
 *
 * this version of the input will have limited options compared to its other counterpart
 */
export type ConstructionAdminSubmittalFieldInput = {
  contractualReviewDate?: InputMaybe<DateTimeFilter>;
  createdDate?: InputMaybe<DateTimeFilter>;
  /**
   * determines now to handle deleted `ConstructionAdminSubmittal` records
   *
   * - when `true`, only return deleted records
   * - when `false`, do not return deleted records
   * - when omitted, `deleted` is ignored
   */
  deleted?: InputMaybe<Scalars['Boolean']>;
  dispositionById?: InputMaybe<StringFilter>;
  dispositionDate?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<StringFilter>;
  lastEditedDate?: InputMaybe<DateTimeFilter>;
  /**
   * how to order `ConstructionAdminSubmittal` records
   *
   * executed in the order they are defined
   */
  orderBy?: InputMaybe<Array<OrderByInput>>;
  packageName?: InputMaybe<StringFilter>;
  packageNumber?: InputMaybe<StringFilter>;
  projectId?: InputMaybe<StringFilter>;
  quantity?: InputMaybe<IntFilter>;
  requestedReviewDate?: InputMaybe<DateTimeFilter>;
  statusId?: InputMaybe<StringFilter>;
  submittedById?: InputMaybe<StringFilter>;
  /**
   * specifies how many records to return
   *
   * analogous to `limit`, `first`, or `top` in SQL dialects
   */
  take?: InputMaybe<Scalars['Int']>;
  units?: InputMaybe<StringFilter>;
};

/** helps filter multiple `ConstructionAdminSubmittal` records */
export type ConstructionAdminSubmittalListInput = {
  contractualReviewDate?: InputMaybe<DateTimeFilter>;
  createdDate?: InputMaybe<DateTimeFilter>;
  /**
   * determines now to handle deleted `ConstructionAdminSubmittal` records
   *
   * - when `true`, only return deleted records
   * - when `false`, do not return deleted records
   * - when omitted, `deleted` is ignored
   */
  deleted?: InputMaybe<Scalars['Boolean']>;
  dispositionById?: InputMaybe<StringFilter>;
  dispositionDate?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<StringFilter>;
  lastEditedDate?: InputMaybe<DateTimeFilter>;
  /**
   * how to order `ConstructionAdminSubmittal` records
   *
   * executed in the order they are defined
   */
  orderBy?: InputMaybe<Array<OrderByInput>>;
  packageName?: InputMaybe<StringFilter>;
  packageNumber?: InputMaybe<StringFilter>;
  /**
   * paginate `ConstructionAdminSubmittal` records
   *
   * using `paginate` may require multiple requests to get all possible results,
   * but will give more fine-grain control in the event all records cannot be
   * returned gracefully
   */
  paginate?: InputMaybe<PaginationInput>;
  projectId?: InputMaybe<StringFilter>;
  quantity?: InputMaybe<IntFilter>;
  requestedReviewDate?: InputMaybe<DateTimeFilter>;
  statusId?: InputMaybe<StringFilter>;
  submittedById?: InputMaybe<StringFilter>;
  units?: InputMaybe<StringFilter>;
};

/** response metadata for a list query of ConstructionAdminSubmittal records */
export type ConstructionAdminSubmittalListResponse = {
  __typename: 'ConstructionAdminSubmittalListResponse';
  /** the total count of ConstructionAdminSubmittal records matching any configured filters */
  count: Scalars['Int'];
  /** the total count of paginated groups of ConstructionAdminSubmittal */
  pages: Scalars['Int'];
  /** ConstructionAdminSubmittal records */
  records: Array<ConstructionAdminSubmittal>;
};

export type Contractor = {
  __typename: 'Contractor';
  asphaltPlacements: Array<AsphaltPlacement>;
  concretePlacements: Array<ConcretePlacement>;
  concreteTests: Array<ConcreteTest>;
  /** `contractorId` is unreliable, a misnomer, every record contains `null` values, or its purpose is generally unknown */
  contractorId: Maybe<Scalars['String']>;
  contractorName: Maybe<Scalars['String']>;
  /** the date this record was inserted into the database */
  createdDate: Maybe<Scalars['DateTime']>;
  /** the username or email address of a mobile app user associated with the `createdDate` */
  createdUser: Maybe<Scalars['String']>;
  dailyInspectionDailyContractorEquipments: Array<DailyInspectionDailyContractorEquipment>;
  dailyInspectionDailyContractorPersons: Array<DailyInspectionDailyContractorPerson>;
  dailyInspectionInspections: Array<DailyInspectionInspection>;
  deleted: Maybe<Scalars['String']>;
  /** a GUID used to globally identify this record in the database */
  globalId: Scalars['String'];
  /** the date this record was last updated in the database */
  lastEditedDate: Maybe<Scalars['DateTime']>;
  /** the username or email address of a mobile app user associated with the `lastEditedDate` */
  lastEditedUser: Maybe<Scalars['String']>;
  lots: Array<Lot>;
  /** a related `Project` */
  project: Maybe<Project>;
  /** the `globalId` of a related `Project` */
  projectId: Maybe<Scalars['String']>;
};


export type ContractorAsphaltPlacementsArgs = {
  asphaltPlacementFieldInput?: InputMaybe<AsphaltPlacementFieldInput>;
};


export type ContractorConcretePlacementsArgs = {
  concretePlacementFieldInput?: InputMaybe<ConcretePlacementFieldInput>;
};


export type ContractorConcreteTestsArgs = {
  concreteTestFieldInput?: InputMaybe<ConcreteTestFieldInput>;
};


export type ContractorDailyInspectionDailyContractorEquipmentsArgs = {
  dailyInspectionDailyContractorEquipmentFieldInput?: InputMaybe<DailyInspectionDailyContractorEquipmentFieldInput>;
};


export type ContractorDailyInspectionDailyContractorPersonsArgs = {
  dailyInspectionDailyContractorPersonFieldInput?: InputMaybe<DailyInspectionDailyContractorPersonFieldInput>;
};


export type ContractorDailyInspectionInspectionsArgs = {
  dailyInspectionInspectionFieldInput?: InputMaybe<DailyInspectionInspectionFieldInput>;
};


export type ContractorLotsArgs = {
  lotFieldInput?: InputMaybe<LotFieldInput>;
};

/**
 * helps filter multiple `Contractor` records
 *
 * this version of the input will have limited options compared to its other counterpart
 */
export type ContractorFieldInput = {
  contractorName?: InputMaybe<StringFilter>;
  createdDate?: InputMaybe<DateTimeFilter>;
  /**
   * determines now to handle deleted `Contractor` records
   *
   * - when `true`, only return deleted records
   * - when `false`, do not return deleted records
   * - when omitted, `deleted` is ignored
   */
  deleted?: InputMaybe<Scalars['Boolean']>;
  lastEditedDate?: InputMaybe<DateTimeFilter>;
  /**
   * how to order `Contractor` records
   *
   * executed in the order they are defined
   */
  orderBy?: InputMaybe<Array<OrderByInput>>;
  projectId?: InputMaybe<StringFilter>;
  /**
   * specifies how many records to return
   *
   * analogous to `limit`, `first`, or `top` in SQL dialects
   */
  take?: InputMaybe<Scalars['Int']>;
};

/** helps filter multiple `Contractor` records */
export type ContractorListInput = {
  contractorName?: InputMaybe<StringFilter>;
  createdDate?: InputMaybe<DateTimeFilter>;
  /**
   * determines now to handle deleted `Contractor` records
   *
   * - when `true`, only return deleted records
   * - when `false`, do not return deleted records
   * - when omitted, `deleted` is ignored
   */
  deleted?: InputMaybe<Scalars['Boolean']>;
  lastEditedDate?: InputMaybe<DateTimeFilter>;
  /**
   * how to order `Contractor` records
   *
   * executed in the order they are defined
   */
  orderBy?: InputMaybe<Array<OrderByInput>>;
  /**
   * paginate `Contractor` records
   *
   * using `paginate` may require multiple requests to get all possible results,
   * but will give more fine-grain control in the event all records cannot be
   * returned gracefully
   */
  paginate?: InputMaybe<PaginationInput>;
  projectId?: InputMaybe<StringFilter>;
};

/** response metadata for a list query of Contractor records */
export type ContractorListResponse = {
  __typename: 'ContractorListResponse';
  /** the total count of Contractor records matching any configured filters */
  count: Scalars['Int'];
  /** the total count of paginated groups of Contractor */
  pages: Scalars['Int'];
  /** Contractor records */
  records: Array<Contractor>;
};

export type ControlPointMissingGeometryIfiSettings = {
  __typename: 'ControlPointMissingGeometryIFISettings';
  /** the date this record was enabled the database */
  effectiveDate: Maybe<Scalars['DateTime']>;
  enabled: Scalars['Boolean'];
  message: Maybe<Scalars['String']>;
};

/** values required to create new `APIKey` objects */
export type CreateApiKeyInput = {
  createdUser: Scalars['String'];
  recipient: Scalars['String'];
};

export type CreateApiKeyResponse = {
  __typename: 'CreateAPIKeyResponse';
  /**
   * the API Key that should be used when making requests to the server
   *
   * it cannot be generated again
   */
  formattedKey: Scalars['String'];
};

/** values required to create new `AsphaltMixDesign` objects */
export type CreateAsphaltMixDesignInput = {
  bulkSpecGravAgg?: InputMaybe<Scalars['Float']>;
  customFields?: InputMaybe<MutateCustomFieldsInput>;
  designBinderContent: Scalars['Float'];
  expirationDate: Scalars['DateTime'];
  grade: Scalars['String'];
  materialSourceId?: InputMaybe<Scalars['String']>;
  maxAggregateSize?: InputMaybe<Scalars['Float']>;
  mixDesignNumber: Scalars['String'];
  nominalSize: Scalars['String'];
  percentages?: InputMaybe<Array<MutateAsphaltMixDesignTargetPercentageInput>>;
  projectId: Scalars['String'];
  supplier: Scalars['String'];
  theoMaxSpecGrav: Scalars['Float'];
  vma: Scalars['Float'];
};

export type CreateAsphaltMixDesignResponse = {
  __typename: 'CreateAsphaltMixDesignResponse';
  /** the created `AsphaltMixDesign` */
  mixDesign: AsphaltMixDesign;
};

/** values required to create new `BatchReportRequest` objects */
export type CreateBatchReportRequestInput = {
  dateRange?: InputMaybe<DateTimeFilterBetweenInput>;
  /** a list of `PayItemNoGeometry.globalId` values */
  payItemIds?: InputMaybe<Array<Scalars['String']>>;
  /** the `globalId` of a related `Project` */
  projectId: Scalars['String'];
  reportIds: Array<Scalars['String']>;
};

export type CreateBatchReportRequestResponse = {
  __typename: 'CreateBatchReportRequestResponse';
  /** the created `BatchReportRequest` */
  batchReportRequest: BatchReportRequest;
};

/** values required to create new `CASComment` objects */
export type CreateCasCommentInput = {
  submittalId: Scalars['String'];
  text: Scalars['String'];
};

export type CreateCasCommentResponse = {
  __typename: 'CreateCASCommentResponse';
  /** the created `CASComment` */
  comment: CasComment;
};

/** values required to create new `CASDispositionType` objects */
export type CreateCasDispositionTypeInput = {
  description?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  projectId: Scalars['String'];
  requiresComments?: InputMaybe<Scalars['Boolean']>;
};

export type CreateCasDispositionTypeResponse = {
  __typename: 'CreateCASDispositionTypeResponse';
  /** the created `CASDispositionType` */
  dispositionType: CasDispositionType;
};

/** values required to create new `CASQuickLink` objects */
export type CreateCasQuickLinkInput = {
  description?: InputMaybe<Scalars['String']>;
  href?: InputMaybe<Scalars['String']>;
  label: Scalars['String'];
  projectId: Scalars['String'];
};

export type CreateCasQuickLinkResponse = {
  __typename: 'CreateCASQuickLinkResponse';
  /** the created `CASQuickLink` */
  casQuickLink: CasQuickLink;
};

/** values required to create new `CASRoutingGroup` objects */
export type CreateCasRoutingGroupInput = {
  /**
   * an extended description associated with the record
   *
   * this description will be used to describe the record in CIMS, where possible
   */
  description?: InputMaybe<Scalars['String']>;
  /** a human readable name associated with the record */
  name: Scalars['String'];
  /** the `globalId` of a related `Project` */
  projectId: Scalars['String'];
  userIds?: InputMaybe<Array<Scalars['String']>>;
};

export type CreateCasRoutingGroupResponse = {
  __typename: 'CreateCASRoutingGroupResponse';
  /** the created `CASRoutingGroup` */
  routingGroup: CasRoutingGroup;
};

export type CreateCasSubtypeInput = {
  description?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  projectId: Scalars['String'];
};

export type CreateCasSubtypeResponse = {
  __typename: 'CreateCASSubtypeResponse';
  /** the created `CASSubtype` */
  subtype: CasSubtype;
};

export type CreateCasTypeInput = {
  description?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  projectId: Scalars['String'];
};

export type CreateCasTypeResponse = {
  __typename: 'CreateCASTypeResponse';
  /** the created `CASType` */
  type: CasType;
};

/** values required to create new `ConcreteMixDesign` objects */
export type CreateConcreteMixDesignInput = {
  admixtures: Scalars['String'];
  aggregates: Array<Scalars['String']>;
  airHigh: Scalars['Float'];
  airLow: Scalars['Float'];
  class: Scalars['String'];
  concreteUse?: InputMaybe<Scalars['String']>;
  customFields?: InputMaybe<MutateCustomFieldsInput>;
  expirationDate: Scalars['DateTime'];
  materialSource: Scalars['String'];
  maxAggSize: Scalars['String'];
  mixDesignNumber: Scalars['String'];
  projectId: Scalars['String'];
  slumpHighInches: Scalars['Float'];
  slumpLowInches: Scalars['Float'];
  submittalId?: InputMaybe<Scalars['String']>;
  wc: Scalars['String'];
};

export type CreateConcreteMixDesignResponse = {
  __typename: 'CreateConcreteMixDesignResponse';
  /** the created `ConcreteMixDesign` */
  mixDesign: ConcreteMixDesign;
};

/** values required to create new `ConstructionAdminSubmittal` objects */
export type CreateConstructionAdminSubmittalInput = {
  customFields?: InputMaybe<MutateCustomFieldsInput>;
  externalLinks?: InputMaybe<Array<ExternalLinkInput>>;
  packageName: Scalars['String'];
  packageNumber: Scalars['String'];
  payItemIds?: InputMaybe<Array<Scalars['String']>>;
  projectId: Scalars['String'];
  quantity: Scalars['Int'];
  requestedReviewDate: Scalars['DateTime'];
  subtypeId?: InputMaybe<Scalars['String']>;
  typeId: Scalars['String'];
  units: Scalars['String'];
};

export type CreateConstructionAdminSubmittalResponse = {
  __typename: 'CreateConstructionAdminSubmittalResponse';
  submittal: ConstructionAdminSubmittal;
};

/** values required to create new `CustomField` objects */
export type CreateCustomFieldInput = {
  customFieldToClassTypeInputs?: InputMaybe<Array<CreateCustomFieldToClassTypeInput>>;
  customListItems?: InputMaybe<Array<CreateCustomListItemInput>>;
  dataTypeId: Scalars['String'];
  /** the `description` to give to the `CustomField` */
  description?: InputMaybe<Scalars['String']>;
  metadata?: InputMaybe<CustomFieldMetadataInput>;
  /** the `name` to give to the `CustomField` */
  name: Scalars['String'];
  /** the `globalId` of a related `Project` */
  projectId: Scalars['String'];
};

export type CreateCustomFieldResponse = {
  __typename: 'CreateCustomFieldResponse';
  /** the created `CustomField` */
  customField: CustomField;
};

/** values required to create new `CustomFieldToClassType` objects */
export type CreateCustomFieldToClassTypeInput = {
  alwaysEditable?: InputMaybe<Scalars['Boolean']>;
  alwaysVisible?: InputMaybe<Scalars['Boolean']>;
  classTypeId: Scalars['String'];
  customFieldId?: InputMaybe<Scalars['String']>;
  prominent?: InputMaybe<Scalars['Boolean']>;
  required?: InputMaybe<Scalars['Boolean']>;
  roleIds?: InputMaybe<Array<Scalars['String']>>;
  userIds?: InputMaybe<Array<Scalars['String']>>;
};

export type CreateCustomFieldToClassTypeResponse = {
  __typename: 'CreateCustomFieldToClassTypeResponse';
  /** the created `CustomFieldToClassType` */
  customFieldToClassType: CustomFieldToClassType;
};

/** values required to create new `CustomListItem` objects */
export type CreateCustomListItemInput = {
  customFieldId?: InputMaybe<Scalars['String']>;
  value: Scalars['String'];
};

export type CreateCustomListItemResponse = {
  __typename: 'CreateCustomListItemResponse';
  /** the created `CustomListItem` */
  customListItem: CustomListItem;
};

/** values required to create new `DSAction` objects */
export type CreateDsActionInput = {
  description?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  projectId: Scalars['String'];
};

export type CreateDsActionResponse = {
  __typename: 'CreateDSActionResponse';
  /** the created `DSAction` */
  action: DsAction;
};

/** values required to create new `DSComment` objects */
export type CreateDsCommentInput = {
  submittalId: Scalars['String'];
  text: Scalars['String'];
};

export type CreateDsCommentResponse = {
  __typename: 'CreateDSCommentResponse';
  /** the created `DSComment` */
  comment: DsComment;
};

/** values required to create new `DSDiscipline` objects */
export type CreateDsDisciplineInput = {
  description?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  projectId: Scalars['String'];
  userIds?: InputMaybe<Array<Scalars['String']>>;
};

export type CreateDsDisciplineResponse = {
  __typename: 'CreateDSDisciplineResponse';
  /** the created `DSDiscipline` */
  discipline: DsDiscipline;
};

/** values required to create new `DSOrganization` objects */
export type CreateDsOrganizationInput = {
  description?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  projectId: Scalars['String'];
};

export type CreateDsOrganizationResponse = {
  __typename: 'CreateDSOrganizationResponse';
  /** the created `DSOrganization` */
  organization: DsOrganization;
};

/** values required to create new `DSQuickLink` objects */
export type CreateDsQuickLinkInput = {
  description?: InputMaybe<Scalars['String']>;
  href?: InputMaybe<Scalars['String']>;
  label: Scalars['String'];
  projectId: Scalars['String'];
};

export type CreateDsQuickLinkResponse = {
  __typename: 'CreateDSQuickLinkResponse';
  /** the created `DSQuickLink` */
  dsQuickLink: DsQuickLink;
};

/** values required to create new `DSType` objects */
export type CreateDsTypeInput = {
  description?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  projectId: Scalars['String'];
};

export type CreateDsTypeResponse = {
  __typename: 'CreateDSTypeResponse';
  /** the created `DSType` */
  type: DsType;
};

/** values required to create new `DesignSubmittal` objects */
export type CreateDesignSubmittalInput = {
  /** a list of `DSAction.id` values  */
  actionIds?: InputMaybe<Array<Scalars['String']>>;
  customFields?: InputMaybe<MutateCustomFieldsInput>;
  /** a list of `DSDiscipline.id` values  */
  disciplineIds?: InputMaybe<Array<Scalars['String']>>;
  externalLinks?: InputMaybe<Array<ExternalLinkInput>>;
  fieldDesignChangeIds?: InputMaybe<Array<Scalars['String']>>;
  /** the `id` of a related `DSOrganization` */
  organizationId: Scalars['String'];
  packageName: Scalars['String'];
  packageNumber: Scalars['String'];
  payItemIds?: InputMaybe<Array<Scalars['String']>>;
  projectId: Scalars['String'];
  requestedActionDate: Scalars['DateTime'];
  typeId: Scalars['String'];
};

export type CreateDesignSubmittalResponse = {
  __typename: 'CreateDesignSubmittalResponse';
  /** the created `DesignSubmittal` */
  designSubmittal: DesignSubmittal;
};

/** values required to create new `DocumentChecklistItem` objects */
export type CreateDocumentChecklistItemInput = {
  /** a list of `ConcreteMaterial.globalId` values */
  concreteMaterialIds?: InputMaybe<Array<Scalars['String']>>;
  name: Scalars['String'];
  /** the `globalId` of a related `Project` */
  projectId: Scalars['String'];
};

export type CreateDocumentChecklistItemResponse = {
  __typename: 'CreateDocumentChecklistItemResponse';
  /** the created `DocumentChecklistItem` */
  documentChecklistItem: DocumentChecklistItem;
};

/** values required to create new `EJQuickLink` objects */
export type CreateEjQuickLinkInput = {
  description?: InputMaybe<Scalars['String']>;
  href?: InputMaybe<Scalars['String']>;
  label: Scalars['String'];
  projectId: Scalars['String'];
};

export type CreateEjQuickLinkResponse = {
  __typename: 'CreateEJQuickLinkResponse';
  /** the created `EJQuickLink` */
  ejQuickLink: EjQuickLink;
};

/** values required to create new `EJType` objects */
export type CreateEjTypeInput = {
  allowanceDescription: Scalars['String'];
  name: Scalars['String'];
  projectId: Scalars['String'];
  reportTypeId?: InputMaybe<Scalars['String']>;
  userIds?: InputMaybe<Array<Scalars['String']>>;
};

export type CreateEjTypeResponse = {
  __typename: 'CreateEJTypeResponse';
  /** the created `EJType` */
  type: EjType;
};

/** values required to create new `FDCApprovalGroup` objects */
export type CreateFdcApprovalGroupInput = {
  concurrenceLevelIds?: InputMaybe<Array<Scalars['String']>>;
  /** the `description` to give to the `FDCApprovalGroup` */
  description?: InputMaybe<Scalars['String']>;
  /** the `name` to give to the `FDCApprovalGroup` */
  name: Scalars['String'];
  /** the `globalId` of a related `Project` */
  projectId: Scalars['String'];
  /** `Role.id` values to associate with the `FDCApprovalGroup` */
  roleIds?: InputMaybe<Array<Scalars['String']>>;
  /** `User.id` values to associate with the `FDCApprovalGroup` */
  userIds?: InputMaybe<Array<Scalars['String']>>;
};

export type CreateFdcApprovalGroupResponse = {
  __typename: 'CreateFDCApprovalGroupResponse';
  /** the created `FDCApprovalGroup` */
  approvalGroup: FdcApprovalGroup;
};

/** values required to create new `FDCComment` objects */
export type CreateFdcCommentInput = {
  /** the `id` of a related `FieldDesignChange` */
  fieldDesignChangeId: Scalars['String'];
  /**
   * the text of the comment
   *
   * limited to 1000 characters
   */
  text: Scalars['String'];
};

export type CreateFdcCommentResponse = {
  __typename: 'CreateFDCCommentResponse';
  /** the created `FDCComment` */
  comment: FdcComment;
};

/** values required to create new `FDCConcurrenceGroup` objects */
export type CreateFdcConcurrenceGroupInput = {
  /** the `description` to give to the `FDCConcurrenceGroup` */
  description?: InputMaybe<Scalars['String']>;
  /** the `name` to give to the `FDCConcurrenceGroup` */
  name: Scalars['String'];
  /** the `globalId` of a related `Project` */
  projectId: Scalars['String'];
  /** `Role.id` values to associate with the `FDCConcurrenceGroup` */
  roleIds?: InputMaybe<Array<Scalars['String']>>;
  /** `User.id` values to associate with the `FDCConcurrenceGroup` */
  userIds?: InputMaybe<Array<Scalars['String']>>;
};

export type CreateFdcConcurrenceGroupResponse = {
  __typename: 'CreateFDCConcurrenceGroupResponse';
  /** the created `FDCConcurrenceGroup` */
  concurrenceGroup: FdcConcurrenceGroup;
};

/** values required to create new `FDCConcurrenceLevel` objects */
export type CreateFdcConcurrenceLevelInput = {
  /** `FDCApprovalGroup.id` values to associate with the `FDCConcurrenceLevel` */
  approvalGroupIds?: InputMaybe<Array<Scalars['String']>>;
  /** the `description` to give to the `FDCConcurrenceLevel` */
  description?: InputMaybe<Scalars['String']>;
  /** the `name` to give to the `FDCConcurrenceLevel` */
  name: Scalars['String'];
  /** the `globalId` of a related `Project` */
  projectId: Scalars['String'];
  /** an `FDCConcurrenceLevelSideEffect.id` value to associate with the `FDCConcurrenceLevel` */
  sideEffectId?: InputMaybe<Scalars['String']>;
};

export type CreateFdcConcurrenceLevelResponse = {
  __typename: 'CreateFDCConcurrenceLevelResponse';
  /** the created `FDCConcurrenceLevel` */
  concurrenceLevel: FdcConcurrenceLevel;
};

/** values required to create new `FDCDiscipline` objects */
export type CreateFdcDisciplineInput = {
  /** the `description` to give to the `FDCDiscipline` */
  description?: InputMaybe<Scalars['String']>;
  /** the `name` to give to the `FDCDiscipline` */
  name: Scalars['String'];
  /** the `globalId` of a related `Project` */
  projectId: Scalars['String'];
};

export type CreateFdcDisciplineResponse = {
  __typename: 'CreateFDCDisciplineResponse';
  /** the created `FDCDiscipline` */
  discipline: FdcDiscipline;
};

/** values required to create new `FDCQuickLink` objects */
export type CreateFdcQuickLinkInput = {
  description?: InputMaybe<Scalars['String']>;
  href?: InputMaybe<Scalars['String']>;
  label: Scalars['String'];
  projectId: Scalars['String'];
};

export type CreateFdcQuickLinkResponse = {
  __typename: 'CreateFDCQuickLinkResponse';
  /** the created `FDCQuickLink` */
  fdcQuickLink: FdcQuickLink;
};

/** values required to create new `GoogleSheetPayItemConnection` objects */
export type CreateGoogleSheetPayItemConnectionInput = {
  documentId?: InputMaybe<Scalars['String']>;
  groupId?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  payItemColumnKey?: InputMaybe<Scalars['String']>;
  projectId: Scalars['String'];
  sheetId?: InputMaybe<Scalars['Int']>;
  url?: InputMaybe<Scalars['String']>;
};

export type CreateGoogleSheetPayItemConnectionResponse = {
  __typename: 'CreateGoogleSheetPayItemConnectionResponse';
  /** the created `GoogleSheetPayItemConnection` */
  googleSheet: GoogleSheetPayItemConnection;
};

/** values required to create new `IFIComment` objects */
export type CreateIfiCommentInput = {
  identifiedFieldIssueId: Scalars['String'];
  text: Scalars['String'];
};

export type CreateIfiCommentResponse = {
  __typename: 'CreateIFICommentResponse';
  /** the created `IFIComment` */
  comment: IfiComment;
};

/** values required to create new `IssueComment` objects */
export type CreateIssueCommentInput = {
  issueId: Scalars['String'];
  /**
   * the text of the comment
   *
   * limited to 1000 characters
   */
  text: Scalars['String'];
};

export type CreateIssueCommentResponse = {
  __typename: 'CreateIssueCommentResponse';
  /** the created `IssueComment` */
  comment: IssueComment;
};

/** values required to create new `IssueDispositionType` objects */
export type CreateIssueDispositionTypeInput = {
  description?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  nonApplicableIssueTypeIds?: InputMaybe<Array<Scalars['String']>>;
  projectId: Scalars['String'];
};

export type CreateIssueDispositionTypeResponse = {
  __typename: 'CreateIssueDispositionTypeResponse';
  /** the created `IssueDispositionType` */
  dispositionType: IssueDispositionType;
};

/** values required to create new `IssueQuickLink` objects */
export type CreateIssueQuickLinkInput = {
  description?: InputMaybe<Scalars['String']>;
  href?: InputMaybe<Scalars['String']>;
  label: Scalars['String'];
  projectId: Scalars['String'];
};

export type CreateIssueQuickLinkResponse = {
  __typename: 'CreateIssueQuickLinkResponse';
  /** the created `IssueQuickLink` */
  quickLink: IssueQuickLink;
};

/** values required to create new `IssueType` objects */
export type CreateIssueTypeInput = {
  description?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  nonApplicableIssueDispositionTypeIds?: InputMaybe<Array<Scalars['String']>>;
  projectId: Scalars['String'];
};

export type CreateIssueTypeResponse = {
  __typename: 'CreateIssueTypeResponse';
  /** the created `IssueType` */
  type: IssueType;
};

/** values required to create new `LIMSAsphaltMixDesignTarget` objects */
export type CreateLimsAsphaltMixDesignTargetInput = {
  description?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  optional?: InputMaybe<Scalars['Boolean']>;
  percentages?: InputMaybe<Array<MutateAsphaltMixDesignTargetPercentageInput>>;
  projectId: Scalars['String'];
};

export type CreateLimsAsphaltMixDesignTargetResponse = {
  __typename: 'CreateLIMSAsphaltMixDesignTargetResponse';
  /** the created `LIMSAsphaltMixDesignTarget` */
  target: LimsAsphaltMixDesignTarget;
};

/** values required to create new `LabTech` objects */
export type CreateLabTechInput = {
  name?: InputMaybe<Scalars['String']>;
  projectId: Scalars['String'];
  testingLabIds?: InputMaybe<Array<Scalars['Int']>>;
  userId?: InputMaybe<Scalars['String']>;
};

export type CreateLabTechResponse = {
  __typename: 'CreateLabTechResponse';
  /** the created `LabTech` */
  labTech: LabTech;
};

/** values required to create new `NonUserEmail` objects */
export type CreateNonUserEmailInput = {
  address: Scalars['String'];
  description?: InputMaybe<Scalars['String']>;
  label?: InputMaybe<Scalars['String']>;
  /** the `globalId` of a related `Project` */
  projectId: Scalars['String'];
};

export type CreateNonUserEmailResponse = {
  __typename: 'CreateNonUserEmailResponse';
  /** the created `NonUserEmail` */
  nonUserEmail: NonUserEmail;
};

/** values required to create new `PayItemConnectionGroup` objects */
export type CreatePayItemConnectionGroupInput = {
  connectionIds?: InputMaybe<Array<Scalars['String']>>;
  description?: InputMaybe<Scalars['String']>;
  internalConnectionIds?: InputMaybe<Array<Scalars['String']>>;
  name: Scalars['String'];
  projectId: Scalars['String'];
};

export type CreatePayItemConnectionGroupResponse = {
  __typename: 'CreatePayItemConnectionGroupResponse';
  /** the created `PayItemConnectionGroup` */
  payItemConnectionGroup: PayItemConnectionGroup;
};

export type CreatePhotoExportRequestInput = {
  createdDate: DateTimeFilterBetweenInput;
  projectId: Scalars['String'];
};

export type CreatePhotoExportRequestResponse = {
  __typename: 'CreatePhotoExportRequestResponse';
  /** the created `PhotoExportRequest` */
  photoExportRequest: PhotoExportRequest;
};

/** values required to create new `ProjectToCIMSOnlineAdmin` objects */
export type CreateProjectToCimsOnlineAdminInput = {
  projectId: Scalars['String'];
  userId: Scalars['String'];
};

export type CreateProjectToCimsOnlineAdminResponse = {
  __typename: 'CreateProjectToCIMSOnlineAdminResponse';
  /** the created `ProjectToCIMSOnlineAdmin` */
  admin: ProjectToCimsOnlineAdmin;
};

/** values required to create new `RFIComment` objects */
export type CreateRfiCommentInput = {
  /** the `id` of a related `RequestForInformation` */
  requestForInformationId: Scalars['String'];
  /**
   * the text of the comment
   *
   * limited to 1000 characters
   */
  text: Scalars['String'];
};

export type CreateRfiCommentResponse = {
  __typename: 'CreateRFICommentResponse';
  /** the created `RFIComment` */
  comment: RfiComment;
};

/** values required to create new `RFIOrganization` objects */
export type CreateRfiOrganizationInput = {
  description?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  projectId: Scalars['String'];
};

export type CreateRfiOrganizationResponse = {
  __typename: 'CreateRFIOrganizationResponse';
  /** the created `RFIOrganization` */
  organization: RfiOrganization;
};

/** values required to create new `RFIQuickLink` objects */
export type CreateRfiQuickLinkInput = {
  description?: InputMaybe<Scalars['String']>;
  href?: InputMaybe<Scalars['String']>;
  label: Scalars['String'];
  projectId: Scalars['String'];
};

export type CreateRfiQuickLinkResponse = {
  __typename: 'CreateRFIQuickLinkResponse';
  /** the created `RFIQuickLink` */
  rfiQuickLink: RfiQuickLink;
};

/** values required to create new `RFIResponseDiscipline` objects */
export type CreateRfiResponseDisciplineInput = {
  description?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  projectId: Scalars['String'];
  userIds?: InputMaybe<Array<Scalars['String']>>;
};

export type CreateRfiResponseDisciplineResponse = {
  __typename: 'CreateRFIResponseDisciplineResponse';
  /** the created `RFIResponseDiscipline` */
  responseDiscipline: RfiResponseDiscipline;
};

/** values required to create new `RFIResponse` objects */
export type CreateRfiResponseInput = {
  closed: Scalars['Boolean'];
  externalLinks?: InputMaybe<Array<ExternalLinkInput>>;
  requestForInformationId: Scalars['String'];
  responseDisciplineId: Scalars['String'];
  text: Scalars['String'];
};

export type CreateRfiResponseResponse = {
  __typename: 'CreateRFIResponseResponse';
  /** the created `RFIResponse` */
  response: RfiResponse;
};

export type CreateRoleInput = {
  name: Scalars['String'];
  permissionIds?: InputMaybe<Array<Scalars['String']>>;
  /** the `globalId` of a related `Project` */
  projectId: Scalars['String'];
};

export type CreateRoleResponse = {
  __typename: 'CreateRoleResponse';
  /** the created `Role` */
  role: Role;
};

/** values required to create new `TestingLab` objects */
export type CreateTestingLabInput = {
  labTechIds?: InputMaybe<Array<Scalars['Int']>>;
  name: Scalars['String'];
  projectId: Scalars['String'];
};

export type CreateTestingLabResponse = {
  __typename: 'CreateTestingLabResponse';
  /** the created `TestingLab` */
  testingLab: TestingLab;
};

/**
 * custom fields allow for users to extend supported
 * record types with additional metadata not provided by CIMS
 *
 * custom fields are configured per `Project`, while values are assigned per record
 */
export type CustomField = {
  __typename: 'CustomField';
  /** the date this record was inserted into the database */
  createdDate: Scalars['DateTime'];
  /**
   * the email address of a user associated with the `createdDate`
   *
   * this value will be `unknown` if the `createdDate` was not set by a user
   */
  createdUser: Scalars['String'];
  customFieldToClassTypes: Array<CustomFieldToClassType>;
  customListItems: Array<CustomListItem>;
  dataType: Scalars['String'];
  /** the `id` of a related ``CustomFieldDataType`` */
  dataTypeId: Scalars['String'];
  /** describes whether the record has been soft-deleted or not */
  deleted: Scalars['Boolean'];
  /** the date this record was soft-deleted in the database */
  deletedDate: Maybe<Scalars['DateTime']>;
  /**
   * the email address of a user associated with the `deletedDate`
   *
   * this value will be `system` if the `deletedDate` was not set by a user
   */
  deletedUser: Maybe<Scalars['String']>;
  /**
   * an extended description associated with the record
   *
   * this description will be used to describe the record in CIMS, where possible
   */
  description: Maybe<Scalars['String']>;
  /** a UUID used to globally identify this record in the database */
  id: Scalars['String'];
  /** the date this record was last updated in the database */
  lastEditedDate: Scalars['DateTime'];
  /**
   * the email address of a user associated with the `lastEditedDate`
   *
   * this value will be `system` if the `lastEditedDate` was not set by a user
   */
  lastEditedUser: Scalars['String'];
  metadata: CustomFieldMetadata;
  /** a human readable name associated with the record */
  name: Scalars['String'];
  /** a related `Project` */
  project: Project;
  /** the `globalId` of a related `Project` */
  projectId: Scalars['String'];
};


/**
 * custom fields allow for users to extend supported
 * record types with additional metadata not provided by CIMS
 *
 * custom fields are configured per `Project`, while values are assigned per record
 */
export type CustomFieldCustomFieldToClassTypesArgs = {
  customFieldToClassTypeFieldInput?: InputMaybe<CustomFieldToClassTypeFieldInput>;
};


/**
 * custom fields allow for users to extend supported
 * record types with additional metadata not provided by CIMS
 *
 * custom fields are configured per `Project`, while values are assigned per record
 */
export type CustomFieldCustomListItemsArgs = {
  customListItemFieldInput?: InputMaybe<CustomListItemFieldInput>;
};

/**
 * helps filter multiple `CustomField` records
 *
 * this version of the input will have limited options compared to its other counterpart
 */
export type CustomFieldFieldInput = {
  createdDate?: InputMaybe<DateTimeFilter>;
  dataTypeId?: InputMaybe<StringFilter>;
  /**
   * determines now to handle deleted `CustomField` records
   *
   * - when `true`, only return deleted records
   * - when `false`, do not return deleted records
   * - when omitted, `deleted` is ignored
   */
  deleted?: InputMaybe<Scalars['Boolean']>;
  description?: InputMaybe<StringFilter>;
  lastEditedDate?: InputMaybe<DateTimeFilter>;
  name?: InputMaybe<StringFilter>;
  /**
   * how to order `CustomField` records
   *
   * executed in the order they are defined
   */
  orderBy?: InputMaybe<Array<OrderByInput>>;
  projectId?: InputMaybe<StringFilter>;
  /**
   * specifies how many records to return
   *
   * analogous to `limit`, `first`, or `top` in SQL dialects
   */
  take?: InputMaybe<Scalars['Int']>;
};

/** helps filter multiple `CustomField` records */
export type CustomFieldListInput = {
  createdDate?: InputMaybe<DateTimeFilter>;
  dataTypeId?: InputMaybe<StringFilter>;
  /**
   * determines now to handle deleted `CustomField` records
   *
   * - when `true`, only return deleted records
   * - when `false`, do not return deleted records
   * - when omitted, `deleted` is ignored
   */
  deleted?: InputMaybe<Scalars['Boolean']>;
  description?: InputMaybe<StringFilter>;
  lastEditedDate?: InputMaybe<DateTimeFilter>;
  name?: InputMaybe<StringFilter>;
  /**
   * how to order `CustomField` records
   *
   * executed in the order they are defined
   */
  orderBy?: InputMaybe<Array<OrderByInput>>;
  /**
   * paginate `CustomField` records
   *
   * using `paginate` may require multiple requests to get all possible results,
   * but will give more fine-grain control in the event all records cannot be
   * returned gracefully
   */
  paginate?: InputMaybe<PaginationInput>;
  projectId?: InputMaybe<StringFilter>;
};

/** response metadata for a list query of CustomField records */
export type CustomFieldListResponse = {
  __typename: 'CustomFieldListResponse';
  /** the total count of CustomField records matching any configured filters */
  count: Scalars['Int'];
  /** the total count of paginated groups of CustomField */
  pages: Scalars['Int'];
  /** CustomField records */
  records: Array<CustomField>;
};

export type CustomFieldMetadata = {
  __typename: 'CustomFieldMetadata';
  /**
   * will be set for Entity type custom fields
   *
   * `CustomFieldEntityItem.id` values describing which entities users should be able
   * to configure a link for when setting a custom field value
   */
  entityIds: Maybe<Array<Scalars['String']>>;
  /**
   * will be set for Report type custom fields
   *
   * `ReportItem.id` values describing which reports users should be able to configure
   * an on demand generation for when setting a custom field value
   */
  reportIds: Maybe<Array<Scalars['String']>>;
  /**
   * will be set for List type custom fields
   *
   * which style of list the custom list will use
   *
   * defaults to Multiple - a dropdown where multiple items can be selected - a dropdown where multiple items can be selected
   */
  styleId: Maybe<Scalars['String']>;
  /**
   * will be set for Date type custom fields
   *
   * the time portion is important to the value
   *
   * defaults to `false`
   */
  timestamp: Maybe<Scalars['Boolean']>;
};

export type CustomFieldMetadataInput = {
  /**
   * must be set for Entity type custom fields
   *
   * `CustomFieldEntityItem.id` values describing which entities users should be able
   * to configure a link for when setting a custom field value
   */
  entityIds?: InputMaybe<Array<Scalars['String']>>;
  /**
   * must be set for Report type custom fields
   *
   * `ReportItem.id` values describing which reports users should be able to configure
   * an on demand generation for when setting a custom field value
   */
  reportIds?: InputMaybe<Array<Scalars['String']>>;
  /**
   * must be set for List type custom fields
   *
   * which style of list the custom list will use
   *
   * defaults to Multiple - a dropdown where multiple items can be selected - a dropdown where multiple items can be selected
   */
  styleId?: InputMaybe<Scalars['String']>;
  /**
   * must be set for Date type custom fields
   *
   * the time portion is important to the value
   *
   * defaults to `false`
   */
  timestamp?: InputMaybe<Scalars['Boolean']>;
};

/**
 * holds configuration options for each
 * record type which supports custom fields and a custom field
 *
 * this allows users to use the same custom field for multiple record types, but
 * still have control over how that custom field behaves for each record type
 */
export type CustomFieldToClassType = {
  __typename: 'CustomFieldToClassType';
  /**
   * allows editors to edit a custom field value, regardless of the
   * record's status
   *
   * by default, custom field values are locked when a record is closed
   */
  alwaysEditable: Scalars['Boolean'];
  /**
   * allows users to view, and editors to edit, custom field values,
   * regardless of the custom field's active status
   *
   * by default custom field values are hidden when their associated custom field is
   * removed
   */
  alwaysVisible: Scalars['Boolean'];
  classType: Scalars['String'];
  classTypeId: Scalars['String'];
  /** the date this record was inserted into the database */
  createdDate: Scalars['DateTime'];
  /**
   * the email address of a user associated with the `createdDate`
   *
   * this value will be `unknown` if the `createdDate` was not set by a user
   */
  createdUser: Scalars['String'];
  customField: CustomField;
  customFieldId: Scalars['String'];
  /** describes whether the record has been soft-deleted or not */
  deleted: Scalars['Boolean'];
  /** the date this record was soft-deleted in the database */
  deletedDate: Maybe<Scalars['DateTime']>;
  /**
   * the email address of a user associated with the `deletedDate`
   *
   * this value will be `system` if the `deletedDate` was not set by a user
   */
  deletedUser: Maybe<Scalars['String']>;
  /** the date this record was last updated in the database */
  lastEditedDate: Scalars['DateTime'];
  /**
   * the email address of a user associated with the `lastEditedDate`
   *
   * this value will be `system` if the `lastEditedDate` was not set by a user
   */
  lastEditedUser: Scalars['String'];
  /**
   * this custom field should appear in table headers where possible
   *
   * by default, custom fields are displayed in expandable sections
   */
  prominent: Scalars['Boolean'];
  /**
   * records cannot be saved in the database without a custom field value
   *
   * by default, records can be saved without custom field values
   */
  required: Scalars['Boolean'];
  roles: Array<Role>;
  users: Array<User>;
};


/**
 * holds configuration options for each
 * record type which supports custom fields and a custom field
 *
 * this allows users to use the same custom field for multiple record types, but
 * still have control over how that custom field behaves for each record type
 */
export type CustomFieldToClassTypeRolesArgs = {
  roleFieldInput?: InputMaybe<RoleFieldInput>;
};


/**
 * holds configuration options for each
 * record type which supports custom fields and a custom field
 *
 * this allows users to use the same custom field for multiple record types, but
 * still have control over how that custom field behaves for each record type
 */
export type CustomFieldToClassTypeUsersArgs = {
  userFieldInput?: InputMaybe<UserFieldInput>;
};

/**
 * helps filter multiple `CustomFieldToClassType` records
 *
 * this version of the input will have limited options compared to its other counterpart
 */
export type CustomFieldToClassTypeFieldInput = {
  /**
   * - when `true`, `alwaysEditable` is truthy
   * - when `false`, `alwaysEditable` is falsy
   * - when omitted, `alwaysEditable` is ignored
   */
  alwaysEditable?: InputMaybe<Scalars['Boolean']>;
  classTypeId?: InputMaybe<StringFilter>;
  createdDate?: InputMaybe<DateTimeFilter>;
  customFieldId?: InputMaybe<StringFilter>;
  /**
   * determines now to handle deleted `CustomFieldToClassType` records
   *
   * - when `true`, only return deleted records
   * - when `false`, do not return deleted records
   * - when omitted, `deleted` is ignored
   */
  deleted?: InputMaybe<Scalars['Boolean']>;
  lastEditedDate?: InputMaybe<DateTimeFilter>;
  /**
   * how to order `CustomFieldToClassType` records
   *
   * executed in the order they are defined
   */
  orderBy?: InputMaybe<Array<OrderByInput>>;
  /**
   * - when `true`, `prominent` is truthy
   * - when `false`, `prominent` is falsy
   * - when omitted, `prominent` is ignored
   */
  prominent?: InputMaybe<Scalars['Boolean']>;
  /**
   * - when `true`, `required` is truthy
   * - when `false`, `required` is falsy
   * - when omitted, `required` is ignored
   */
  required?: InputMaybe<Scalars['Boolean']>;
  /**
   * specifies how many records to return
   *
   * analogous to `limit`, `first`, or `top` in SQL dialects
   */
  take?: InputMaybe<Scalars['Int']>;
};

/** helps filter multiple `CustomFieldToClassType` records */
export type CustomFieldToClassTypeListInput = {
  /**
   * - when `true`, `alwaysEditable` is truthy
   * - when `false`, `alwaysEditable` is falsy
   * - when omitted, `alwaysEditable` is ignored
   */
  alwaysEditable?: InputMaybe<Scalars['Boolean']>;
  classTypeId?: InputMaybe<StringFilter>;
  createdDate?: InputMaybe<DateTimeFilter>;
  customFieldId?: InputMaybe<StringFilter>;
  /**
   * determines now to handle deleted `CustomFieldToClassType` records
   *
   * - when `true`, only return deleted records
   * - when `false`, do not return deleted records
   * - when omitted, `deleted` is ignored
   */
  deleted?: InputMaybe<Scalars['Boolean']>;
  lastEditedDate?: InputMaybe<DateTimeFilter>;
  /**
   * how to order `CustomFieldToClassType` records
   *
   * executed in the order they are defined
   */
  orderBy?: InputMaybe<Array<OrderByInput>>;
  /**
   * paginate `CustomFieldToClassType` records
   *
   * using `paginate` may require multiple requests to get all possible results,
   * but will give more fine-grain control in the event all records cannot be
   * returned gracefully
   */
  paginate?: InputMaybe<PaginationInput>;
  /**
   * - when `true`, `prominent` is truthy
   * - when `false`, `prominent` is falsy
   * - when omitted, `prominent` is ignored
   */
  prominent?: InputMaybe<Scalars['Boolean']>;
  /**
   * - when `true`, `required` is truthy
   * - when `false`, `required` is falsy
   * - when omitted, `required` is ignored
   */
  required?: InputMaybe<Scalars['Boolean']>;
};

/** response metadata for a list query of CustomFieldToClassType records */
export type CustomFieldToClassTypeListResponse = {
  __typename: 'CustomFieldToClassTypeListResponse';
  /** the total count of CustomFieldToClassType records matching any configured filters */
  count: Scalars['Int'];
  /** the total count of paginated groups of CustomFieldToClassType */
  pages: Scalars['Int'];
  /** CustomFieldToClassType records */
  records: Array<CustomFieldToClassType>;
};

export type CustomFields = {
  __typename: 'CustomFields';
  booleanValues: Array<BooleanCustomFieldValue>;
  dateValues: Array<DateCustomFieldValue>;
  entityValues: Array<EntityCustomFieldValues>;
  listValues: ListValues;
  numberValues: Array<NumberCustomFieldValue>;
  reportValues: Array<ReportCustomFieldValues>;
  textValues: Array<TextCustomFieldValue>;
};

/**
 * custom list items are text values which users
 * can define and select for list type custom field values
 */
export type CustomListItem = {
  __typename: 'CustomListItem';
  /** the date this record was inserted into the database */
  createdDate: Scalars['DateTime'];
  /**
   * the email address of a user associated with the `createdDate`
   *
   * this value will be `unknown` if the `createdDate` was not set by a user
   */
  createdUser: Scalars['String'];
  customField: CustomField;
  /** the `id` of a related `CustomField` */
  customFieldId: Scalars['String'];
  /** describes whether the record has been soft-deleted or not */
  deleted: Scalars['Boolean'];
  /** the date this record was soft-deleted in the database */
  deletedDate: Maybe<Scalars['DateTime']>;
  /**
   * the email address of a user associated with the `deletedDate`
   *
   * this value will be `system` if the `deletedDate` was not set by a user
   */
  deletedUser: Maybe<Scalars['String']>;
  /** a UUID used to globally identify this record in the database */
  id: Scalars['String'];
  /** the date this record was last updated in the database */
  lastEditedDate: Scalars['DateTime'];
  /**
   * the email address of a user associated with the `lastEditedDate`
   *
   * this value will be `system` if the `lastEditedDate` was not set by a user
   */
  lastEditedUser: Scalars['String'];
  /** the value of the `CustomListItem` that will be used in the application */
  value: Scalars['String'];
};

/**
 * helps filter multiple `CustomListItem` records
 *
 * this version of the input will have limited options compared to its other counterpart
 */
export type CustomListItemFieldInput = {
  createdDate?: InputMaybe<DateTimeFilter>;
  customFieldId?: InputMaybe<StringFilter>;
  /**
   * determines now to handle deleted `CustomListItem` records
   *
   * - when `true`, only return deleted records
   * - when `false`, do not return deleted records
   * - when omitted, `deleted` is ignored
   */
  deleted?: InputMaybe<Scalars['Boolean']>;
  lastEditedDate?: InputMaybe<DateTimeFilter>;
  /**
   * how to order `CustomListItem` records
   *
   * executed in the order they are defined
   */
  orderBy?: InputMaybe<Array<OrderByInput>>;
  /**
   * specifies how many records to return
   *
   * analogous to `limit`, `first`, or `top` in SQL dialects
   */
  take?: InputMaybe<Scalars['Int']>;
  value?: InputMaybe<StringFilter>;
};

/** helps filter multiple `CustomListItem` records */
export type CustomListItemListInput = {
  createdDate?: InputMaybe<DateTimeFilter>;
  customFieldId?: InputMaybe<StringFilter>;
  /**
   * determines now to handle deleted `CustomListItem` records
   *
   * - when `true`, only return deleted records
   * - when `false`, do not return deleted records
   * - when omitted, `deleted` is ignored
   */
  deleted?: InputMaybe<Scalars['Boolean']>;
  lastEditedDate?: InputMaybe<DateTimeFilter>;
  /**
   * how to order `CustomListItem` records
   *
   * executed in the order they are defined
   */
  orderBy?: InputMaybe<Array<OrderByInput>>;
  /**
   * paginate `CustomListItem` records
   *
   * using `paginate` may require multiple requests to get all possible results,
   * but will give more fine-grain control in the event all records cannot be
   * returned gracefully
   */
  paginate?: InputMaybe<PaginationInput>;
  value?: InputMaybe<StringFilter>;
};

/** response metadata for a list query of CustomListItem records */
export type CustomListItemListResponse = {
  __typename: 'CustomListItemListResponse';
  /** the total count of CustomListItem records matching any configured filters */
  count: Scalars['Int'];
  /** the total count of paginated groups of CustomListItem */
  pages: Scalars['Int'];
  /** CustomListItem records */
  records: Array<CustomListItem>;
};

export type DsAction = {
  __typename: 'DSAction';
  /** the date this record was inserted into the database */
  createdDate: Scalars['DateTime'];
  /**
   * the email address of a user associated with the `createdDate`
   *
   * this value will be `unknown` if the `createdDate` was not set by a user
   */
  createdUser: Scalars['String'];
  /** describes whether the record has been soft-deleted or not */
  deleted: Scalars['Boolean'];
  /** the date this record was soft-deleted in the database */
  deletedDate: Maybe<Scalars['DateTime']>;
  /**
   * the email address of a user associated with the `deletedDate`
   *
   * this value will be `system` if the `deletedDate` was not set by a user
   */
  deletedUser: Maybe<Scalars['String']>;
  /**
   * an extended description associated with the record
   *
   * this description will be used to describe the record in CIMS, where possible
   */
  description: Maybe<Scalars['String']>;
  /** a UUID used to globally identify this record in the database */
  id: Scalars['String'];
  /** the date this record was last updated in the database */
  lastEditedDate: Scalars['DateTime'];
  /**
   * the email address of a user associated with the `lastEditedDate`
   *
   * this value will be `system` if the `lastEditedDate` was not set by a user
   */
  lastEditedUser: Scalars['String'];
  /** a human readable name associated with the record */
  name: Scalars['String'];
  /** a related `Project` */
  project: Project;
  /** the `globalId` of a related `Project` */
  projectId: Scalars['String'];
  submittals: Array<DesignSubmittal>;
};


export type DsActionSubmittalsArgs = {
  designSubmittalFieldInput?: InputMaybe<DesignSubmittalFieldInput>;
};

/**
 * helps filter multiple `DSAction` records
 *
 * this version of the input will have limited options compared to its other counterpart
 */
export type DsActionFieldInput = {
  createdDate?: InputMaybe<DateTimeFilter>;
  /**
   * determines now to handle deleted `DSAction` records
   *
   * - when `true`, only return deleted records
   * - when `false`, do not return deleted records
   * - when omitted, `deleted` is ignored
   */
  deleted?: InputMaybe<Scalars['Boolean']>;
  lastEditedDate?: InputMaybe<DateTimeFilter>;
  name?: InputMaybe<StringFilter>;
  /**
   * how to order `DSAction` records
   *
   * executed in the order they are defined
   */
  orderBy?: InputMaybe<Array<OrderByInput>>;
  projectId?: InputMaybe<StringFilter>;
  /**
   * specifies how many records to return
   *
   * analogous to `limit`, `first`, or `top` in SQL dialects
   */
  take?: InputMaybe<Scalars['Int']>;
};

/** helps filter multiple `DSAction` records */
export type DsActionListInput = {
  createdDate?: InputMaybe<DateTimeFilter>;
  /**
   * determines now to handle deleted `DSAction` records
   *
   * - when `true`, only return deleted records
   * - when `false`, do not return deleted records
   * - when omitted, `deleted` is ignored
   */
  deleted?: InputMaybe<Scalars['Boolean']>;
  lastEditedDate?: InputMaybe<DateTimeFilter>;
  name?: InputMaybe<StringFilter>;
  /**
   * how to order `DSAction` records
   *
   * executed in the order they are defined
   */
  orderBy?: InputMaybe<Array<OrderByInput>>;
  /**
   * paginate `DSAction` records
   *
   * using `paginate` may require multiple requests to get all possible results,
   * but will give more fine-grain control in the event all records cannot be
   * returned gracefully
   */
  paginate?: InputMaybe<PaginationInput>;
  projectId?: InputMaybe<StringFilter>;
};

/** response metadata for a list query of DSAction records */
export type DsActionListResponse = {
  __typename: 'DSActionListResponse';
  /** the total count of DSAction records matching any configured filters */
  count: Scalars['Int'];
  /** the total count of paginated groups of DSAction */
  pages: Scalars['Int'];
  /** DSAction records */
  records: Array<DsAction>;
};

/** comments made against related `DesignSubmittal` records */
export type DsComment = {
  __typename: 'DSComment';
  /** the date this record was inserted into the database */
  createdDate: Scalars['DateTime'];
  /**
   * the email address of a user associated with the `createdDate`
   *
   * this value will be `unknown` if the `createdDate` was not set by a user
   */
  createdUser: Scalars['String'];
  /** describes whether the record has been soft-deleted or not */
  deleted: Scalars['Boolean'];
  /** the date this record was soft-deleted in the database */
  deletedDate: Maybe<Scalars['DateTime']>;
  /**
   * the email address of a user associated with the `deletedDate`
   *
   * this value will be `system` if the `deletedDate` was not set by a user
   */
  deletedUser: Maybe<Scalars['String']>;
  /** a UUID used to globally identify this record in the database */
  id: Scalars['String'];
  /** the date this record was last updated in the database */
  lastEditedDate: Scalars['DateTime'];
  /**
   * the email address of a user associated with the `lastEditedDate`
   *
   * this value will be `system` if the `lastEditedDate` was not set by a user
   */
  lastEditedUser: Scalars['String'];
  submittal: DesignSubmittal;
  submittalId: Scalars['String'];
  /**
   * the text of the comment
   *
   * limited to 1000 characters
   */
  text: Scalars['String'];
  user: User;
  /** the `id` of a related `User` */
  userId: Scalars['String'];
};

/**
 * helps filter multiple `DSComment` records
 *
 * this version of the input will have limited options compared to its other counterpart
 */
export type DsCommentFieldInput = {
  createdDate?: InputMaybe<DateTimeFilter>;
  /**
   * determines now to handle deleted `DSComment` records
   *
   * - when `true`, only return deleted records
   * - when `false`, do not return deleted records
   * - when omitted, `deleted` is ignored
   */
  deleted?: InputMaybe<Scalars['Boolean']>;
  lastEditedDate?: InputMaybe<DateTimeFilter>;
  /**
   * how to order `DSComment` records
   *
   * executed in the order they are defined
   */
  orderBy?: InputMaybe<Array<OrderByInput>>;
  submittalId?: InputMaybe<StringFilter>;
  /**
   * specifies how many records to return
   *
   * analogous to `limit`, `first`, or `top` in SQL dialects
   */
  take?: InputMaybe<Scalars['Int']>;
  text?: InputMaybe<StringFilter>;
  userId?: InputMaybe<StringFilter>;
};

/** helps filter multiple `DSComment` records */
export type DsCommentListInput = {
  createdDate?: InputMaybe<DateTimeFilter>;
  /**
   * determines now to handle deleted `DSComment` records
   *
   * - when `true`, only return deleted records
   * - when `false`, do not return deleted records
   * - when omitted, `deleted` is ignored
   */
  deleted?: InputMaybe<Scalars['Boolean']>;
  lastEditedDate?: InputMaybe<DateTimeFilter>;
  /**
   * how to order `DSComment` records
   *
   * executed in the order they are defined
   */
  orderBy?: InputMaybe<Array<OrderByInput>>;
  /**
   * paginate `DSComment` records
   *
   * using `paginate` may require multiple requests to get all possible results,
   * but will give more fine-grain control in the event all records cannot be
   * returned gracefully
   */
  paginate?: InputMaybe<PaginationInput>;
  submittalId?: InputMaybe<StringFilter>;
  text?: InputMaybe<StringFilter>;
  userId?: InputMaybe<StringFilter>;
};

/** response metadata for a list query of DSComment records */
export type DsCommentListResponse = {
  __typename: 'DSCommentListResponse';
  /** the total count of DSComment records matching any configured filters */
  count: Scalars['Int'];
  /** the total count of paginated groups of DSComment */
  pages: Scalars['Int'];
  /** DSComment records */
  records: Array<DsComment>;
};

export type DsDiscipline = {
  __typename: 'DSDiscipline';
  /** the date this record was inserted into the database */
  createdDate: Scalars['DateTime'];
  /**
   * the email address of a user associated with the `createdDate`
   *
   * this value will be `unknown` if the `createdDate` was not set by a user
   */
  createdUser: Scalars['String'];
  /** describes whether the record has been soft-deleted or not */
  deleted: Scalars['Boolean'];
  /** the date this record was soft-deleted in the database */
  deletedDate: Maybe<Scalars['DateTime']>;
  /**
   * the email address of a user associated with the `deletedDate`
   *
   * this value will be `system` if the `deletedDate` was not set by a user
   */
  deletedUser: Maybe<Scalars['String']>;
  /**
   * an extended description associated with the record
   *
   * this description will be used to describe the record in CIMS, where possible
   */
  description: Maybe<Scalars['String']>;
  dsToDSDisciplines: Array<DsToDsDiscipline>;
  /** a UUID used to globally identify this record in the database */
  id: Scalars['String'];
  /** the date this record was last updated in the database */
  lastEditedDate: Scalars['DateTime'];
  /**
   * the email address of a user associated with the `lastEditedDate`
   *
   * this value will be `system` if the `lastEditedDate` was not set by a user
   */
  lastEditedUser: Scalars['String'];
  /** a human readable name associated with the record */
  name: Scalars['String'];
  /** a related `Project` */
  project: Project;
  /** the `globalId` of a related `Project` */
  projectId: Scalars['String'];
  users: Array<User>;
};


export type DsDisciplineDsToDsDisciplinesArgs = {
  dsToDSDisciplineFieldInput?: InputMaybe<DsToDsDisciplineFieldInput>;
};


export type DsDisciplineUsersArgs = {
  userFieldInput?: InputMaybe<UserFieldInput>;
};

/**
 * helps filter multiple `DSDiscipline` records
 *
 * this version of the input will have limited options compared to its other counterpart
 */
export type DsDisciplineFieldInput = {
  createdDate?: InputMaybe<DateTimeFilter>;
  /**
   * determines now to handle deleted `DSDiscipline` records
   *
   * - when `true`, only return deleted records
   * - when `false`, do not return deleted records
   * - when omitted, `deleted` is ignored
   */
  deleted?: InputMaybe<Scalars['Boolean']>;
  lastEditedDate?: InputMaybe<DateTimeFilter>;
  name?: InputMaybe<StringFilter>;
  /**
   * how to order `DSDiscipline` records
   *
   * executed in the order they are defined
   */
  orderBy?: InputMaybe<Array<OrderByInput>>;
  projectId?: InputMaybe<StringFilter>;
  /**
   * specifies how many records to return
   *
   * analogous to `limit`, `first`, or `top` in SQL dialects
   */
  take?: InputMaybe<Scalars['Int']>;
};

/** helps filter multiple `DSDiscipline` records */
export type DsDisciplineListInput = {
  createdDate?: InputMaybe<DateTimeFilter>;
  /**
   * determines now to handle deleted `DSDiscipline` records
   *
   * - when `true`, only return deleted records
   * - when `false`, do not return deleted records
   * - when omitted, `deleted` is ignored
   */
  deleted?: InputMaybe<Scalars['Boolean']>;
  lastEditedDate?: InputMaybe<DateTimeFilter>;
  name?: InputMaybe<StringFilter>;
  /**
   * how to order `DSDiscipline` records
   *
   * executed in the order they are defined
   */
  orderBy?: InputMaybe<Array<OrderByInput>>;
  /**
   * paginate `DSDiscipline` records
   *
   * using `paginate` may require multiple requests to get all possible results,
   * but will give more fine-grain control in the event all records cannot be
   * returned gracefully
   */
  paginate?: InputMaybe<PaginationInput>;
  projectId?: InputMaybe<StringFilter>;
};

/** response metadata for a list query of DSDiscipline records */
export type DsDisciplineListResponse = {
  __typename: 'DSDisciplineListResponse';
  /** the total count of DSDiscipline records matching any configured filters */
  count: Scalars['Int'];
  /** the total count of paginated groups of DSDiscipline */
  pages: Scalars['Int'];
  /** DSDiscipline records */
  records: Array<DsDiscipline>;
};

/**
 * notifications hold a recipients configuration for a given
 * notification event in Design Submittal Log workflows
 *
 * recipients can be users, or non user emails
 *
 * certain events may require users to receive a notification if they are given permission
 * to perform a specific task
 */
export type DsNotification = {
  __typename: 'DSNotification';
  /** the date this record was inserted into the database */
  createdDate: Scalars['DateTime'];
  /**
   * the email address of a user associated with the `createdDate`
   *
   * this value will be `unknown` if the `createdDate` was not set by a user
   */
  createdUser: Scalars['String'];
  /** the date this record was last updated in the database */
  lastEditedDate: Scalars['DateTime'];
  /**
   * the email address of a user associated with the `lastEditedDate`
   *
   * this value will be `system` if the `lastEditedDate` was not set by a user
   */
  lastEditedUser: Scalars['String'];
  /** the name of the notification event associated with this Notification */
  notificationEvent: Scalars['String'];
  notificationEventId: Scalars['String'];
  /** a related `Project` */
  project: Project;
  /** the `globalId` of a related `Project` */
  projectId: Scalars['String'];
  recipients: DsNotificationRecipients;
};

/**
 * helps filter multiple `DSNotification` records
 *
 * this version of the input will have limited options compared to its other counterpart
 */
export type DsNotificationFieldInput = {
  createdDate?: InputMaybe<DateTimeFilter>;
  lastEditedDate?: InputMaybe<DateTimeFilter>;
  notificationEventId?: InputMaybe<StringFilter>;
  /**
   * how to order `DSNotification` records
   *
   * executed in the order they are defined
   */
  orderBy?: InputMaybe<Array<OrderByInput>>;
  projectId?: InputMaybe<StringFilter>;
  /**
   * specifies how many records to return
   *
   * analogous to `limit`, `first`, or `top` in SQL dialects
   */
  take?: InputMaybe<Scalars['Int']>;
};

/** helps filter multiple `DSNotification` records */
export type DsNotificationListInput = {
  createdDate?: InputMaybe<DateTimeFilter>;
  lastEditedDate?: InputMaybe<DateTimeFilter>;
  notificationEventId?: InputMaybe<StringFilter>;
  /**
   * how to order `DSNotification` records
   *
   * executed in the order they are defined
   */
  orderBy?: InputMaybe<Array<OrderByInput>>;
  /**
   * paginate `DSNotification` records
   *
   * using `paginate` may require multiple requests to get all possible results,
   * but will give more fine-grain control in the event all records cannot be
   * returned gracefully
   */
  paginate?: InputMaybe<PaginationInput>;
  projectId?: InputMaybe<StringFilter>;
};

/** response metadata for a list query of DSNotification records */
export type DsNotificationListResponse = {
  __typename: 'DSNotificationListResponse';
  /** the total count of DSNotification records matching any configured filters */
  count: Scalars['Int'];
  /** the total count of paginated groups of DSNotification */
  pages: Scalars['Int'];
  /** DSNotification records */
  records: Array<DsNotification>;
};

export type DsNotificationRecipients = {
  __typename: 'DSNotificationRecipients';
  /** all design submittals with a specific discipline */
  byDSDiscipline: Array<ByDsDiscipline>;
  every: Maybe<Recipients>;
};


export type DsNotificationRecipientsByDsDisciplineArgs = {
  disciplineFieldInput?: InputMaybe<DsDisciplineFieldInput>;
};

export type DsOrganization = {
  __typename: 'DSOrganization';
  /** the date this record was inserted into the database */
  createdDate: Scalars['DateTime'];
  /**
   * the email address of a user associated with the `createdDate`
   *
   * this value will be `unknown` if the `createdDate` was not set by a user
   */
  createdUser: Scalars['String'];
  /** describes whether the record has been soft-deleted or not */
  deleted: Scalars['Boolean'];
  /** the date this record was soft-deleted in the database */
  deletedDate: Maybe<Scalars['DateTime']>;
  /**
   * the email address of a user associated with the `deletedDate`
   *
   * this value will be `system` if the `deletedDate` was not set by a user
   */
  deletedUser: Maybe<Scalars['String']>;
  /**
   * an extended description associated with the record
   *
   * this description will be used to describe the record in CIMS, where possible
   */
  description: Maybe<Scalars['String']>;
  /** a UUID used to globally identify this record in the database */
  id: Scalars['String'];
  /** the date this record was last updated in the database */
  lastEditedDate: Scalars['DateTime'];
  /**
   * the email address of a user associated with the `lastEditedDate`
   *
   * this value will be `system` if the `lastEditedDate` was not set by a user
   */
  lastEditedUser: Scalars['String'];
  /** a human readable name associated with the record */
  name: Scalars['String'];
  /** a related `Project` */
  project: Project;
  /** the `globalId` of a related `Project` */
  projectId: Scalars['String'];
  submittals: Array<DesignSubmittal>;
};


export type DsOrganizationSubmittalsArgs = {
  designSubmittalFieldInput?: InputMaybe<DesignSubmittalFieldInput>;
};

/**
 * helps filter multiple `DSOrganization` records
 *
 * this version of the input will have limited options compared to its other counterpart
 */
export type DsOrganizationFieldInput = {
  createdDate?: InputMaybe<DateTimeFilter>;
  /**
   * determines now to handle deleted `DSOrganization` records
   *
   * - when `true`, only return deleted records
   * - when `false`, do not return deleted records
   * - when omitted, `deleted` is ignored
   */
  deleted?: InputMaybe<Scalars['Boolean']>;
  lastEditedDate?: InputMaybe<DateTimeFilter>;
  name?: InputMaybe<StringFilter>;
  /**
   * how to order `DSOrganization` records
   *
   * executed in the order they are defined
   */
  orderBy?: InputMaybe<Array<OrderByInput>>;
  projectId?: InputMaybe<StringFilter>;
  /**
   * specifies how many records to return
   *
   * analogous to `limit`, `first`, or `top` in SQL dialects
   */
  take?: InputMaybe<Scalars['Int']>;
};

/** helps filter multiple `DSOrganization` records */
export type DsOrganizationListInput = {
  createdDate?: InputMaybe<DateTimeFilter>;
  /**
   * determines now to handle deleted `DSOrganization` records
   *
   * - when `true`, only return deleted records
   * - when `false`, do not return deleted records
   * - when omitted, `deleted` is ignored
   */
  deleted?: InputMaybe<Scalars['Boolean']>;
  lastEditedDate?: InputMaybe<DateTimeFilter>;
  name?: InputMaybe<StringFilter>;
  /**
   * how to order `DSOrganization` records
   *
   * executed in the order they are defined
   */
  orderBy?: InputMaybe<Array<OrderByInput>>;
  /**
   * paginate `DSOrganization` records
   *
   * using `paginate` may require multiple requests to get all possible results,
   * but will give more fine-grain control in the event all records cannot be
   * returned gracefully
   */
  paginate?: InputMaybe<PaginationInput>;
  projectId?: InputMaybe<StringFilter>;
};

/** response metadata for a list query of DSOrganization records */
export type DsOrganizationListResponse = {
  __typename: 'DSOrganizationListResponse';
  /** the total count of DSOrganization records matching any configured filters */
  count: Scalars['Int'];
  /** the total count of paginated groups of DSOrganization */
  pages: Scalars['Int'];
  /** DSOrganization records */
  records: Array<DsOrganization>;
};

/**
 * `DSQuickLink` records are used in the External Link Editor to allow users
 * to quickly add external links to the `externalLinks` field of a `DesignSubmittal`
 *
 * `DSQuickLink` records used in `externalLinks` are not referenced by `id`, but copied
 * as they are currently defined
 *
 * changes made to any `DSQuickLink` record will not affect the `externalLinks` of the `DesignSubmittal`
 */
export type DsQuickLink = {
  __typename: 'DSQuickLink';
  /** the date this record was inserted into the database */
  createdDate: Scalars['DateTime'];
  /**
   * the email address of a user associated with the `createdDate`
   *
   * this value will be `unknown` if the `createdDate` was not set by a user
   */
  createdUser: Scalars['String'];
  /** describes whether the record has been soft-deleted or not */
  deleted: Scalars['Boolean'];
  /** the date this record was soft-deleted in the database */
  deletedDate: Maybe<Scalars['DateTime']>;
  /**
   * the email address of a user associated with the `deletedDate`
   *
   * this value will be `system` if the `deletedDate` was not set by a user
   */
  deletedUser: Maybe<Scalars['String']>;
  /**
   * an extended description associated with the record
   *
   * this description will be used to describe the record in CIMS, where possible
   */
  description: Maybe<Scalars['String']>;
  /** an optional link associated with the `label` */
  href: Maybe<Scalars['String']>;
  /** a UUID used to globally identify this record in the database */
  id: Scalars['String'];
  /** the human readable link text */
  label: Scalars['String'];
  /** the date this record was last updated in the database */
  lastEditedDate: Scalars['DateTime'];
  /**
   * the email address of a user associated with the `lastEditedDate`
   *
   * this value will be `system` if the `lastEditedDate` was not set by a user
   */
  lastEditedUser: Scalars['String'];
  project: Project;
  /** the `globalId` of a related `Project` */
  projectId: Scalars['String'];
};

/**
 * helps filter multiple `DSQuickLink` records
 *
 * this version of the input will have limited options compared to its other counterpart
 */
export type DsQuickLinkFieldInput = {
  createdDate?: InputMaybe<DateTimeFilter>;
  /**
   * determines now to handle deleted `DSQuickLink` records
   *
   * - when `true`, only return deleted records
   * - when `false`, do not return deleted records
   * - when omitted, `deleted` is ignored
   */
  deleted?: InputMaybe<Scalars['Boolean']>;
  description?: InputMaybe<StringFilter>;
  href?: InputMaybe<StringFilter>;
  id?: InputMaybe<StringFilter>;
  label?: InputMaybe<StringFilter>;
  lastEditedDate?: InputMaybe<DateTimeFilter>;
  /**
   * how to order `DSQuickLink` records
   *
   * executed in the order they are defined
   */
  orderBy?: InputMaybe<Array<OrderByInput>>;
  projectId?: InputMaybe<StringFilter>;
  /**
   * specifies how many records to return
   *
   * analogous to `limit`, `first`, or `top` in SQL dialects
   */
  take?: InputMaybe<Scalars['Int']>;
};

/** helps filter multiple `DSQuickLink` records */
export type DsQuickLinkListInput = {
  createdDate?: InputMaybe<DateTimeFilter>;
  /**
   * determines now to handle deleted `DSQuickLink` records
   *
   * - when `true`, only return deleted records
   * - when `false`, do not return deleted records
   * - when omitted, `deleted` is ignored
   */
  deleted?: InputMaybe<Scalars['Boolean']>;
  description?: InputMaybe<StringFilter>;
  href?: InputMaybe<StringFilter>;
  id?: InputMaybe<StringFilter>;
  label?: InputMaybe<StringFilter>;
  lastEditedDate?: InputMaybe<DateTimeFilter>;
  /**
   * how to order `DSQuickLink` records
   *
   * executed in the order they are defined
   */
  orderBy?: InputMaybe<Array<OrderByInput>>;
  /**
   * paginate `DSQuickLink` records
   *
   * using `paginate` may require multiple requests to get all possible results,
   * but will give more fine-grain control in the event all records cannot be
   * returned gracefully
   */
  paginate?: InputMaybe<PaginationInput>;
  projectId?: InputMaybe<StringFilter>;
};

/** response metadata for a list query of DSQuickLink records */
export type DsQuickLinkListResponse = {
  __typename: 'DSQuickLinkListResponse';
  /** the total count of DSQuickLink records matching any configured filters */
  count: Scalars['Int'];
  /** the total count of paginated groups of DSQuickLink */
  pages: Scalars['Int'];
  /** DSQuickLink records */
  records: Array<DsQuickLink>;
};

export type DsToDsDiscipline = {
  __typename: 'DSToDSDiscipline';
  accepted: Scalars['Boolean'];
  /** a related `User` which accepted the `DSDiscipline` */
  acceptedBy: Maybe<User>;
  acceptedById: Maybe<Scalars['String']>;
  /** a `DateTime` which denotes when the `DSDiscipline` was accepted */
  acceptedDate: Maybe<Scalars['DateTime']>;
  /** the date this record was inserted into the database */
  createdDate: Scalars['DateTime'];
  /**
   * the email address of a user associated with the `createdDate`
   *
   * this value will be `unknown` if the `createdDate` was not set by a user
   */
  createdUser: Scalars['String'];
  discipline: DsDiscipline;
  disciplineId: Scalars['String'];
  /** the date this record was last updated in the database */
  lastEditedDate: Scalars['DateTime'];
  /**
   * the email address of a user associated with the `lastEditedDate`
   *
   * this value will be `system` if the `lastEditedDate` was not set by a user
   */
  lastEditedUser: Scalars['String'];
  submittal: DesignSubmittal;
  submittalId: Scalars['String'];
};

/**
 * helps filter multiple `DSToDSDiscipline` records
 *
 * this version of the input will have limited options compared to its other counterpart
 */
export type DsToDsDisciplineFieldInput = {
  createdDate?: InputMaybe<DateTimeFilter>;
  disciplineId?: InputMaybe<StringFilter>;
  lastEditedDate?: InputMaybe<DateTimeFilter>;
  /**
   * how to order `DSToDSDiscipline` records
   *
   * executed in the order they are defined
   */
  orderBy?: InputMaybe<Array<OrderByInput>>;
  submittalId?: InputMaybe<StringFilter>;
  /**
   * specifies how many records to return
   *
   * analogous to `limit`, `first`, or `top` in SQL dialects
   */
  take?: InputMaybe<Scalars['Int']>;
};

/** helps filter multiple `DSToDSDiscipline` records */
export type DsToDsDisciplineListInput = {
  createdDate?: InputMaybe<DateTimeFilter>;
  disciplineId?: InputMaybe<StringFilter>;
  lastEditedDate?: InputMaybe<DateTimeFilter>;
  /**
   * how to order `DSToDSDiscipline` records
   *
   * executed in the order they are defined
   */
  orderBy?: InputMaybe<Array<OrderByInput>>;
  /**
   * paginate `DSToDSDiscipline` records
   *
   * using `paginate` may require multiple requests to get all possible results,
   * but will give more fine-grain control in the event all records cannot be
   * returned gracefully
   */
  paginate?: InputMaybe<PaginationInput>;
  submittalId?: InputMaybe<StringFilter>;
};

/** response metadata for a list query of DSToDSDiscipline records */
export type DsToDsDisciplineListResponse = {
  __typename: 'DSToDSDisciplineListResponse';
  /** the total count of DSToDSDiscipline records matching any configured filters */
  count: Scalars['Int'];
  /** the total count of paginated groups of DSToDSDiscipline */
  pages: Scalars['Int'];
  /** DSToDSDiscipline records */
  records: Array<DsToDsDiscipline>;
};

/** `DSToPayItemNoGeometry` helps connect many `DesignSubmittal` records with many `PayItemNoGeometry` records */
export type DsToPayItemNoGeometry = {
  __typename: 'DSToPayItemNoGeometry';
  payItem: PayItemNoGeometry;
  /** the `globalId` of a related `PayItemNoGeometry` */
  payItemId: Scalars['String'];
  submittal: DesignSubmittal;
  /** the `id` of a related `DesignSubmittal` */
  submittalId: Scalars['String'];
};

/**
 * helps filter multiple `DSToPayItemNoGeometry` records
 *
 * this version of the input will have limited options compared to its other counterpart
 */
export type DsToPayItemNoGeometryFieldInput = {
  /**
   * how to order `DSToPayItemNoGeometry` records
   *
   * executed in the order they are defined
   */
  orderBy?: InputMaybe<Array<OrderByInput>>;
  payItemId?: InputMaybe<StringFilter>;
  submittalId?: InputMaybe<StringFilter>;
  /**
   * specifies how many records to return
   *
   * analogous to `limit`, `first`, or `top` in SQL dialects
   */
  take?: InputMaybe<Scalars['Int']>;
};

/** helps filter multiple `DSToPayItemNoGeometry` records */
export type DsToPayItemNoGeometryListInput = {
  /**
   * how to order `DSToPayItemNoGeometry` records
   *
   * executed in the order they are defined
   */
  orderBy?: InputMaybe<Array<OrderByInput>>;
  /**
   * paginate `DSToPayItemNoGeometry` records
   *
   * using `paginate` may require multiple requests to get all possible results,
   * but will give more fine-grain control in the event all records cannot be
   * returned gracefully
   */
  paginate?: InputMaybe<PaginationInput>;
  payItemId?: InputMaybe<StringFilter>;
  submittalId?: InputMaybe<StringFilter>;
};

/** response metadata for a list query of DSToPayItemNoGeometry records */
export type DsToPayItemNoGeometryListResponse = {
  __typename: 'DSToPayItemNoGeometryListResponse';
  /** the total count of DSToPayItemNoGeometry records matching any configured filters */
  count: Scalars['Int'];
  /** the total count of paginated groups of DSToPayItemNoGeometry */
  pages: Scalars['Int'];
  /** DSToPayItemNoGeometry records */
  records: Array<DsToPayItemNoGeometry>;
};

export type DsType = {
  __typename: 'DSType';
  /** the date this record was inserted into the database */
  createdDate: Scalars['DateTime'];
  /**
   * the email address of a user associated with the `createdDate`
   *
   * this value will be `unknown` if the `createdDate` was not set by a user
   */
  createdUser: Scalars['String'];
  /** describes whether the record has been soft-deleted or not */
  deleted: Scalars['Boolean'];
  /** the date this record was soft-deleted in the database */
  deletedDate: Maybe<Scalars['DateTime']>;
  /**
   * the email address of a user associated with the `deletedDate`
   *
   * this value will be `system` if the `deletedDate` was not set by a user
   */
  deletedUser: Maybe<Scalars['String']>;
  /**
   * an extended description associated with the record
   *
   * this description will be used to describe the record in CIMS, where possible
   */
  description: Maybe<Scalars['String']>;
  /** a UUID used to globally identify this record in the database */
  id: Scalars['String'];
  /** the date this record was last updated in the database */
  lastEditedDate: Scalars['DateTime'];
  /**
   * the email address of a user associated with the `lastEditedDate`
   *
   * this value will be `system` if the `lastEditedDate` was not set by a user
   */
  lastEditedUser: Scalars['String'];
  /** a human readable name associated with the record */
  name: Scalars['String'];
  /** a related `Project` */
  project: Project;
  /** the `globalId` of a related `Project` */
  projectId: Scalars['String'];
  submittals: Array<DesignSubmittal>;
};


export type DsTypeSubmittalsArgs = {
  designSubmittalFieldInput?: InputMaybe<DesignSubmittalFieldInput>;
};

/**
 * helps filter multiple `DSType` records
 *
 * this version of the input will have limited options compared to its other counterpart
 */
export type DsTypeFieldInput = {
  createdDate?: InputMaybe<DateTimeFilter>;
  /**
   * determines now to handle deleted `DSType` records
   *
   * - when `true`, only return deleted records
   * - when `false`, do not return deleted records
   * - when omitted, `deleted` is ignored
   */
  deleted?: InputMaybe<Scalars['Boolean']>;
  lastEditedDate?: InputMaybe<DateTimeFilter>;
  name?: InputMaybe<StringFilter>;
  /**
   * how to order `DSType` records
   *
   * executed in the order they are defined
   */
  orderBy?: InputMaybe<Array<OrderByInput>>;
  projectId?: InputMaybe<StringFilter>;
  /**
   * specifies how many records to return
   *
   * analogous to `limit`, `first`, or `top` in SQL dialects
   */
  take?: InputMaybe<Scalars['Int']>;
};

/** helps filter multiple `DSType` records */
export type DsTypeListInput = {
  createdDate?: InputMaybe<DateTimeFilter>;
  /**
   * determines now to handle deleted `DSType` records
   *
   * - when `true`, only return deleted records
   * - when `false`, do not return deleted records
   * - when omitted, `deleted` is ignored
   */
  deleted?: InputMaybe<Scalars['Boolean']>;
  lastEditedDate?: InputMaybe<DateTimeFilter>;
  name?: InputMaybe<StringFilter>;
  /**
   * how to order `DSType` records
   *
   * executed in the order they are defined
   */
  orderBy?: InputMaybe<Array<OrderByInput>>;
  /**
   * paginate `DSType` records
   *
   * using `paginate` may require multiple requests to get all possible results,
   * but will give more fine-grain control in the event all records cannot be
   * returned gracefully
   */
  paginate?: InputMaybe<PaginationInput>;
  projectId?: InputMaybe<StringFilter>;
};

/** response metadata for a list query of DSType records */
export type DsTypeListResponse = {
  __typename: 'DSTypeListResponse';
  /** the total count of DSType records matching any configured filters */
  count: Scalars['Int'];
  /** the total count of paginated groups of DSType */
  pages: Scalars['Int'];
  /** DSType records */
  records: Array<DsType>;
};

export type DailyFrequency = BaseFrequency & {
  __typename: 'DailyFrequency';
  /** Default value is 8 */
  hour: Scalars['Int'];
  /** Default value is 0 */
  minute: Scalars['Int'];
  next: Scalars['DateTime'];
  previous: Scalars['DateTime'];
};

export type DailyFrequencyInput = {
  hour: Scalars['Int'];
  minute: Scalars['Int'];
};

export type DailyInspectionControlPoint = {
  __typename: 'DailyInspectionControlPoint';
  approve: Maybe<Scalars['DateTime']>;
  archiveDate: Maybe<Scalars['DateTime']>;
  archiveUser: Maybe<Scalars['String']>;
  archived: Maybe<Scalars['String']>;
  base64MapImage: Maybe<Scalars['String']>;
  cdr: Maybe<Scalars['String']>;
  comments: Maybe<Scalars['String']>;
  controlPointId: Maybe<Scalars['String']>;
  controlPointType: Maybe<DailyInspectionControlPointType>;
  /** the `globalId` of a related `DailyInspectionControlPointType` */
  controlPointTypeGuid: Maybe<Scalars['String']>;
  cpmActivityId: Maybe<Scalars['String']>;
  /** the date this record was inserted into the database */
  createdDate: Maybe<Scalars['DateTime']>;
  /** the username or email address of a mobile app user associated with the `createdDate` */
  createdUser: Maybe<Scalars['String']>;
  dailyInspectionForm: Maybe<DailyInspectionForm>;
  dailyInspectionFormAnswers: Array<DailyInspectionFormAnswer>;
  dailyInspectionFormsGuid: Maybe<Scalars['String']>;
  dateCreated: Maybe<Scalars['DateTime']>;
  deleted: Maybe<Scalars['String']>;
  ejToReports: Array<EjToReport>;
  endAlignment: Maybe<Scalars['String']>;
  endOffset: Maybe<Scalars['String']>;
  endStation: Maybe<Scalars['String']>;
  formData: Maybe<Scalars['String']>;
  genericPlacements: Array<GenericPlacement>;
  /** a GUID used to globally identify this record in the database */
  globalId: Scalars['String'];
  hasUnresolvedIssues: Maybe<Scalars['String']>;
  identifiedFieldIssue: Maybe<IdentifiedFieldIssue>;
  issueToReports: Array<IssueToReport>;
  json: Maybe<DailyInspectionControlPointJson>;
  /** the date this record was last updated in the database */
  lastEditedDate: Maybe<Scalars['DateTime']>;
  /** the username or email address of a mobile app user associated with the `lastEditedDate` */
  lastEditedUser: Maybe<Scalars['String']>;
  lowTemp: Maybe<Scalars['Float']>;
  manualMeasurements: Maybe<Scalars['String']>;
  mediaUploads: Array<MediaUpload>;
  /**
   * If set, contains a comma separated list of
   * `PayItemNoGeometry.globalId` values
   *
   * unfortunately, there have been instances where one of these values doesn't map
   * to a valid `PayItemNoGeometry`
   *
   * `payItemNoGeometries` will skip these rather than map them to `null`
   */
  multiplePayItems: Maybe<Scalars['String']>;
  ncr: Maybe<Scalars['String']>;
  ncrIssueDescription: Maybe<Scalars['String']>;
  ohcRep: Maybe<DailyInspectionLookUp>;
  /** the `globalId` of a related `DailyInspectionLookUp` */
  ohcRepGuid: Maybe<Scalars['String']>;
  ohcRepSignatureDate: Maybe<Scalars['DateTime']>;
  ohcRepSignatureUri: Maybe<Scalars['String']>;
  payItemGuid: Maybe<Scalars['String']>;
  /**
   * aggregates all `PayItemNoGeometry` records associated with this
   * `DailyInspectionControlPoint` by using its `PayItemNoGeometry` reference and `multiplePayItems`
   *
   * if any `PayItemNoGeometry.globalId` values used to query the database return `null`,
   * the `null` value will be filtered out of the results
   *
   * every result will be a valid `PayItemNoGeometry`
   */
  payItemNoGeometries: Array<PayItemNoGeometry>;
  preExistingIssueNumber: Maybe<Scalars['String']>;
  precipitationAmount: Maybe<Scalars['String']>;
  precipitationType: Maybe<Scalars['String']>;
  /** a related `Project` */
  project: Maybe<Project>;
  /**
   * `projectGuid` is unreliable, a misnomer, every record contains `null` values, or its purpose is generally unknown
   *
   * use `projectId` instead
   */
  projectGuid: Maybe<Scalars['String']>;
  /** the `globalId` of a related `Project` */
  projectId: Maybe<Scalars['String']>;
  punchListCheck: Maybe<Scalars['String']>;
  qaRep: Maybe<DailyInspectionLookUp>;
  /** the `globalId` of a related `DailyInspectionLookUp` */
  qaRepGuid: Maybe<Scalars['String']>;
  qaRepSignatureDate: Maybe<Scalars['DateTime']>;
  qaRepSignatureUri: Maybe<Scalars['String']>;
  qaSigner: Maybe<DailyInspectionLookUp>;
  /** the `globalId` of a related `DailyInspectionLookUp` */
  qaSignerGuid: Maybe<Scalars['String']>;
  reject: Maybe<Scalars['DateTime']>;
  renderInfo: Maybe<Scalars['String']>;
  reopen: Maybe<Scalars['DateTime']>;
  reportDate: Maybe<Scalars['DateTime']>;
  reportToTags: Array<ReportToTag>;
  responseComment: Maybe<Scalars['String']>;
  reviewComment: Maybe<Scalars['String']>;
  reviewDate: Maybe<Scalars['DateTime']>;
  reviewStatus: Maybe<Scalars['String']>;
  reviewedBy: Maybe<Technician>;
  /** the `globalId` of a related `Technician` */
  reviewedByGuid: Maybe<Scalars['String']>;
  shape: Maybe<Scalars['String']>;
  skies: Maybe<Scalars['String']>;
  startAlignment: Maybe<Scalars['String']>;
  startOffset: Maybe<Scalars['String']>;
  startStation: Maybe<Scalars['String']>;
  submit: Maybe<Scalars['DateTime']>;
  technician: Maybe<Technician>;
  /** the `globalId` of a related `Technician` */
  technicianGuid: Maybe<Scalars['String']>;
  tempHigh: Maybe<Scalars['Float']>;
  unresolvedIssueNew: Maybe<Scalars['String']>;
  unresolvedIssuePreExisting: Maybe<Scalars['String']>;
  weatherImpactNotes: Maybe<Scalars['String']>;
  weatherImpacted: Maybe<Scalars['String']>;
  windSpeed: Maybe<Scalars['String']>;
  workType: Maybe<DailyInspectionWorkType>;
  /** the `globalId` of a related `DailyInspectionWorkType` */
  workTypeGuid: Maybe<Scalars['String']>;
  /**
   * `workTypeId` is unreliable, a misnomer, every record contains `null` values, or its purpose is generally unknown
   *
   * use `workTypeGuid` instead
   */
  workTypeId: Maybe<Scalars['String']>;
};


export type DailyInspectionControlPointBase64MapImageArgs = {
  projectLayerIds?: InputMaybe<Array<Scalars['Int']>>;
};


export type DailyInspectionControlPointDailyInspectionFormAnswersArgs = {
  dailyInspectionFormAnswerFieldInput?: InputMaybe<DailyInspectionFormAnswerFieldInput>;
};


export type DailyInspectionControlPointEjToReportsArgs = {
  eJToReportFieldInput?: InputMaybe<EjToReportFieldInput>;
};


export type DailyInspectionControlPointGenericPlacementsArgs = {
  genericPlacementFieldInput?: InputMaybe<GenericPlacementFieldInput>;
};


export type DailyInspectionControlPointIssueToReportsArgs = {
  issueToReportFieldInput?: InputMaybe<IssueToReportFieldInput>;
};


export type DailyInspectionControlPointMediaUploadsArgs = {
  mediaUploadFieldInput?: InputMaybe<MediaUploadFieldInput>;
};


export type DailyInspectionControlPointPayItemNoGeometriesArgs = {
  payItemNoGeometryFieldInput?: InputMaybe<PayItemNoGeometryFieldInput>;
};


export type DailyInspectionControlPointReportToTagsArgs = {
  reportToTagFieldInput?: InputMaybe<ReportToTagFieldInput>;
};

/**
 * helps filter multiple `DailyInspectionControlPoint` records
 *
 * this version of the input will have limited options compared to its other counterpart
 */
export type DailyInspectionControlPointFieldInput = {
  controlPointId?: InputMaybe<StringFilter>;
  createdDate?: InputMaybe<DateTimeFilter>;
  /**
   * determines now to handle deleted `DailyInspectionControlPoint` records
   *
   * - when `true`, only return deleted records
   * - when `false`, do not return deleted records
   * - when omitted, `deleted` is ignored
   */
  deleted?: InputMaybe<Scalars['Boolean']>;
  lastEditedDate?: InputMaybe<DateTimeFilter>;
  /**
   * how to order `DailyInspectionControlPoint` records
   *
   * executed in the order they are defined
   */
  orderBy?: InputMaybe<Array<OrderByInput>>;
  projectId?: InputMaybe<StringFilter>;
  reviewStatus?: InputMaybe<StringFilter>;
  /**
   * specifies how many records to return
   *
   * analogous to `limit`, `first`, or `top` in SQL dialects
   */
  take?: InputMaybe<Scalars['Int']>;
};

export type DailyInspectionControlPointIfiSettings = {
  __typename: 'DailyInspectionControlPointIFISettings';
  /** the date this record was inserted into the database */
  createdDate: Scalars['DateTime'];
  /**
   * the email address of a user associated with the `createdDate`
   *
   * this value will be `unknown` if the `createdDate` was not set by a user
   */
  createdUser: Scalars['String'];
  effectiveDate: Maybe<Scalars['DateTime']>;
  enabled: Scalars['Boolean'];
  /** the date this record was last updated in the database */
  lastEditedDate: Scalars['DateTime'];
  /**
   * the email address of a user associated with the `lastEditedDate`
   *
   * this value will be `system` if the `lastEditedDate` was not set by a user
   */
  lastEditedUser: Scalars['String'];
  missingGeometry: ControlPointMissingGeometryIfiSettings;
  /** a related `Project` */
  project: Project;
  /** the `globalId` of a related `Project` */
  projectId: Scalars['String'];
};

/** helps filter multiple `DailyInspectionControlPointIFISettings` records */
export type DailyInspectionControlPointIfiSettingsListInput = {
  /**
   * determines now to handle deleted `DailyInspectionControlPointIFISettings` records
   *
   * - when `true`, only return deleted records
   * - when `false`, do not return deleted records
   * - when omitted, `deleted` is ignored
   */
  deleted?: InputMaybe<Scalars['Boolean']>;
  effectiveDate?: InputMaybe<DateTimeFilter>;
  /**
   * how to order `DailyInspectionControlPointIFISettings` records
   *
   * executed in the order they are defined
   */
  orderBy?: InputMaybe<Array<OrderByInput>>;
  /**
   * paginate `DailyInspectionControlPointIFISettings` records
   *
   * using `paginate` may require multiple requests to get all possible results,
   * but will give more fine-grain control in the event all records cannot be
   * returned gracefully
   */
  paginate?: InputMaybe<PaginationInput>;
  projectId?: InputMaybe<StringFilter>;
};

/** response metadata for a list query of DailyInspectionControlPointIFISettings records */
export type DailyInspectionControlPointIfiSettingsListResponse = {
  __typename: 'DailyInspectionControlPointIFISettingsListResponse';
  /** the total count of DailyInspectionControlPointIFISettings records matching any configured filters */
  count: Scalars['Int'];
  /** the total count of paginated groups of DailyInspectionControlPointIFISettings */
  pages: Scalars['Int'];
  /** DailyInspectionControlPointIFISettings records */
  records: Array<DailyInspectionControlPointIfiSettings>;
};

export type DailyInspectionControlPointJson = {
  __typename: 'DailyInspectionControlPointJSON';
  CPMActivityId: Maybe<Scalars['String']>;
  Comments: Maybe<Scalars['String']>;
  ControlPointId: Maybe<Scalars['String']>;
  DateCreated: Maybe<Scalars['String']>;
  EndAlignment: Maybe<Scalars['String']>;
  EndOffset: Maybe<Scalars['String']>;
  EndStation: Maybe<Scalars['String']>;
  FormData: Maybe<DailyInspectionControlPointJsonFormData>;
  OHCRepGuid: Maybe<Scalars['String']>;
  OHCRepSignatureUri: Maybe<Scalars['String']>;
  PayItemGuid: Maybe<Scalars['String']>;
  ProjectGuid: Maybe<Scalars['String']>;
  QARepGuid: Maybe<Scalars['String']>;
  QARepSignatureUri: Maybe<Scalars['String']>;
  ReportDate: Maybe<Scalars['String']>;
  ReviewComment: Maybe<Scalars['String']>;
  ReviewDate: Maybe<Scalars['String']>;
  ReviewStatus: Maybe<Scalars['String']>;
  ReviewedByGuid: Maybe<Scalars['String']>;
  StartAlignment: Maybe<Scalars['String']>;
  StartOffset: Maybe<Scalars['String']>;
  StartStation: Maybe<Scalars['String']>;
  TechnicianGuid: Maybe<Scalars['String']>;
  WorkTypeGuid: Maybe<Scalars['String']>;
};

export type DailyInspectionControlPointJsonFormData = {
  __typename: 'DailyInspectionControlPointJSONFormData';
  FieldsJson: Maybe<Scalars['String']>;
  FormName: Maybe<Scalars['String']>;
  ProjectId: Maybe<Scalars['String']>;
  WorkTypeId: Maybe<Scalars['String']>;
};

/** helps filter multiple `DailyInspectionControlPoint` records */
export type DailyInspectionControlPointListInput = {
  controlPointId?: InputMaybe<StringFilter>;
  createdDate?: InputMaybe<DateTimeFilter>;
  /**
   * determines now to handle deleted `DailyInspectionControlPoint` records
   *
   * - when `true`, only return deleted records
   * - when `false`, do not return deleted records
   * - when omitted, `deleted` is ignored
   */
  deleted?: InputMaybe<Scalars['Boolean']>;
  lastEditedDate?: InputMaybe<DateTimeFilter>;
  /**
   * how to order `DailyInspectionControlPoint` records
   *
   * executed in the order they are defined
   */
  orderBy?: InputMaybe<Array<OrderByInput>>;
  /**
   * paginate `DailyInspectionControlPoint` records
   *
   * using `paginate` may require multiple requests to get all possible results,
   * but will give more fine-grain control in the event all records cannot be
   * returned gracefully
   */
  paginate?: InputMaybe<PaginationInput>;
  projectId?: InputMaybe<StringFilter>;
  reviewStatus?: InputMaybe<StringFilter>;
};

/** response metadata for a list query of DailyInspectionControlPoint records */
export type DailyInspectionControlPointListResponse = {
  __typename: 'DailyInspectionControlPointListResponse';
  /** the total count of DailyInspectionControlPoint records matching any configured filters */
  count: Scalars['Int'];
  /** the total count of paginated groups of DailyInspectionControlPoint */
  pages: Scalars['Int'];
  /** DailyInspectionControlPoint records */
  records: Array<DailyInspectionControlPoint>;
};

export type DailyInspectionControlPointType = {
  __typename: 'DailyInspectionControlPointType';
  /** the date this record was inserted into the database */
  createdDate: Maybe<Scalars['DateTime']>;
  /** the username or email address of a mobile app user associated with the `createdDate` */
  createdUser: Maybe<Scalars['String']>;
  dailyInspectionControlPoints: Array<DailyInspectionControlPoint>;
  deleted: Maybe<Scalars['String']>;
  /** a GUID used to globally identify this record in the database */
  globalId: Scalars['String'];
  /** the date this record was last updated in the database */
  lastEditedDate: Maybe<Scalars['DateTime']>;
  /** the username or email address of a mobile app user associated with the `lastEditedDate` */
  lastEditedUser: Maybe<Scalars['String']>;
};


export type DailyInspectionControlPointTypeDailyInspectionControlPointsArgs = {
  dailyInspectionControlPointFieldInput?: InputMaybe<DailyInspectionControlPointFieldInput>;
};

/**
 * helps filter multiple `DailyInspectionControlPointType` records
 *
 * this version of the input will have limited options compared to its other counterpart
 */
export type DailyInspectionControlPointTypeFieldInput = {
  createdDate?: InputMaybe<DateTimeFilter>;
  /**
   * determines now to handle deleted `DailyInspectionControlPointType` records
   *
   * - when `true`, only return deleted records
   * - when `false`, do not return deleted records
   * - when omitted, `deleted` is ignored
   */
  deleted?: InputMaybe<Scalars['Boolean']>;
  lastEditedDate?: InputMaybe<DateTimeFilter>;
  /**
   * how to order `DailyInspectionControlPointType` records
   *
   * executed in the order they are defined
   */
  orderBy?: InputMaybe<Array<OrderByInput>>;
  /**
   * specifies how many records to return
   *
   * analogous to `limit`, `first`, or `top` in SQL dialects
   */
  take?: InputMaybe<Scalars['Int']>;
};

/** helps filter multiple `DailyInspectionControlPointType` records */
export type DailyInspectionControlPointTypeListInput = {
  createdDate?: InputMaybe<DateTimeFilter>;
  /**
   * determines now to handle deleted `DailyInspectionControlPointType` records
   *
   * - when `true`, only return deleted records
   * - when `false`, do not return deleted records
   * - when omitted, `deleted` is ignored
   */
  deleted?: InputMaybe<Scalars['Boolean']>;
  lastEditedDate?: InputMaybe<DateTimeFilter>;
  /**
   * how to order `DailyInspectionControlPointType` records
   *
   * executed in the order they are defined
   */
  orderBy?: InputMaybe<Array<OrderByInput>>;
  /**
   * paginate `DailyInspectionControlPointType` records
   *
   * using `paginate` may require multiple requests to get all possible results,
   * but will give more fine-grain control in the event all records cannot be
   * returned gracefully
   */
  paginate?: InputMaybe<PaginationInput>;
};

/** response metadata for a list query of DailyInspectionControlPointType records */
export type DailyInspectionControlPointTypeListResponse = {
  __typename: 'DailyInspectionControlPointTypeListResponse';
  /** the total count of DailyInspectionControlPointType records matching any configured filters */
  count: Scalars['Int'];
  /** the total count of paginated groups of DailyInspectionControlPointType */
  pages: Scalars['Int'];
  /** DailyInspectionControlPointType records */
  records: Array<DailyInspectionControlPointType>;
};

export type DailyInspectionDailyContractorEquipment = {
  __typename: 'DailyInspectionDailyContractorEquipment';
  comments: Maybe<Scalars['String']>;
  contractor: Maybe<Contractor>;
  /** the `globalId` of a related `Contractor` */
  contractorGuid: Maybe<Scalars['String']>;
  /** the date this record was inserted into the database */
  createdDate: Maybe<Scalars['DateTime']>;
  /** the username or email address of a mobile app user associated with the `createdDate` */
  createdUser: Maybe<Scalars['String']>;
  deleted: Maybe<Scalars['String']>;
  duration: Maybe<Scalars['Float']>;
  /** a GUID used to globally identify this record in the database */
  globalId: Scalars['String'];
  inspection: Maybe<DailyInspectionInspection>;
  /**
   * the `globalId` of a related `DailyInspectionInspection`
   *
   * this field name is result of a naming convention collision
   * which would produce an invalid schema
   *
   * if any of the below is a column, the associated value is the _database_ column name
   *
   * - this column : `Inspection_ID`
   * - colliding column : `InspectionId`
   */
  inspectionGuid: Maybe<Scalars['String']>;
  /**
   * this field name is result of a naming convention collision
   * which would produce an invalid schema
   *
   * if any of the below is a column, the associated value is the _database_ column name
   *
   * - this column : `InspectionId`
   * - colliding column : `Inspection_ID`
   */
  inspectionId: Maybe<Scalars['String']>;
  /** the date this record was last updated in the database */
  lastEditedDate: Maybe<Scalars['DateTime']>;
  /** the username or email address of a mobile app user associated with the `lastEditedDate` */
  lastEditedUser: Maybe<Scalars['String']>;
  make: Maybe<Scalars['String']>;
  model: Maybe<Scalars['String']>;
  notes: Maybe<Scalars['String']>;
  numberOfUnits: Maybe<Scalars['Int']>;
  operatingQty: Maybe<Scalars['Int']>;
  standbyQty: Maybe<Scalars['Int']>;
  type: Maybe<Scalars['String']>;
  year: Maybe<Scalars['Int']>;
};

/**
 * helps filter multiple `DailyInspectionDailyContractorEquipment` records
 *
 * this version of the input will have limited options compared to its other counterpart
 */
export type DailyInspectionDailyContractorEquipmentFieldInput = {
  createdDate?: InputMaybe<DateTimeFilter>;
  /**
   * determines now to handle deleted `DailyInspectionDailyContractorEquipment` records
   *
   * - when `true`, only return deleted records
   * - when `false`, do not return deleted records
   * - when omitted, `deleted` is ignored
   */
  deleted?: InputMaybe<Scalars['Boolean']>;
  inspectionId?: InputMaybe<StringFilter>;
  lastEditedDate?: InputMaybe<DateTimeFilter>;
  /**
   * how to order `DailyInspectionDailyContractorEquipment` records
   *
   * executed in the order they are defined
   */
  orderBy?: InputMaybe<Array<OrderByInput>>;
  /**
   * specifies how many records to return
   *
   * analogous to `limit`, `first`, or `top` in SQL dialects
   */
  take?: InputMaybe<Scalars['Int']>;
};

/** helps filter multiple `DailyInspectionDailyContractorEquipment` records */
export type DailyInspectionDailyContractorEquipmentListInput = {
  createdDate?: InputMaybe<DateTimeFilter>;
  /**
   * determines now to handle deleted `DailyInspectionDailyContractorEquipment` records
   *
   * - when `true`, only return deleted records
   * - when `false`, do not return deleted records
   * - when omitted, `deleted` is ignored
   */
  deleted?: InputMaybe<Scalars['Boolean']>;
  inspectionId?: InputMaybe<StringFilter>;
  lastEditedDate?: InputMaybe<DateTimeFilter>;
  /**
   * how to order `DailyInspectionDailyContractorEquipment` records
   *
   * executed in the order they are defined
   */
  orderBy?: InputMaybe<Array<OrderByInput>>;
  /**
   * paginate `DailyInspectionDailyContractorEquipment` records
   *
   * using `paginate` may require multiple requests to get all possible results,
   * but will give more fine-grain control in the event all records cannot be
   * returned gracefully
   */
  paginate?: InputMaybe<PaginationInput>;
};

/** response metadata for a list query of DailyInspectionDailyContractorEquipment records */
export type DailyInspectionDailyContractorEquipmentListResponse = {
  __typename: 'DailyInspectionDailyContractorEquipmentListResponse';
  /** the total count of DailyInspectionDailyContractorEquipment records matching any configured filters */
  count: Scalars['Int'];
  /** the total count of paginated groups of DailyInspectionDailyContractorEquipment */
  pages: Scalars['Int'];
  /** DailyInspectionDailyContractorEquipment records */
  records: Array<DailyInspectionDailyContractorEquipment>;
};

export type DailyInspectionDailyContractorPerson = {
  __typename: 'DailyInspectionDailyContractorPerson';
  contractor: Maybe<Contractor>;
  /** the `globalId` of a related `Contractor` */
  contractorGuid: Maybe<Scalars['String']>;
  /** the date this record was inserted into the database */
  createdDate: Maybe<Scalars['DateTime']>;
  /** the username or email address of a mobile app user associated with the `createdDate` */
  createdUser: Maybe<Scalars['String']>;
  deleted: Maybe<Scalars['String']>;
  /** a GUID used to globally identify this record in the database */
  globalId: Scalars['String'];
  inspection: Maybe<DailyInspectionInspection>;
  /** the `globalId` of a related `DailyInspectionInspection` */
  inspectionId: Maybe<Scalars['String']>;
  laborCount: Maybe<Scalars['Int']>;
  /** the date this record was last updated in the database */
  lastEditedDate: Maybe<Scalars['DateTime']>;
  /** the username or email address of a mobile app user associated with the `lastEditedDate` */
  lastEditedUser: Maybe<Scalars['String']>;
  skilledCount: Maybe<Scalars['Int']>;
  supervisorCount: Maybe<Scalars['Int']>;
};

/**
 * helps filter multiple `DailyInspectionDailyContractorPerson` records
 *
 * this version of the input will have limited options compared to its other counterpart
 */
export type DailyInspectionDailyContractorPersonFieldInput = {
  createdDate?: InputMaybe<DateTimeFilter>;
  /**
   * determines now to handle deleted `DailyInspectionDailyContractorPerson` records
   *
   * - when `true`, only return deleted records
   * - when `false`, do not return deleted records
   * - when omitted, `deleted` is ignored
   */
  deleted?: InputMaybe<Scalars['Boolean']>;
  lastEditedDate?: InputMaybe<DateTimeFilter>;
  /**
   * how to order `DailyInspectionDailyContractorPerson` records
   *
   * executed in the order they are defined
   */
  orderBy?: InputMaybe<Array<OrderByInput>>;
  /**
   * specifies how many records to return
   *
   * analogous to `limit`, `first`, or `top` in SQL dialects
   */
  take?: InputMaybe<Scalars['Int']>;
};

/** helps filter multiple `DailyInspectionDailyContractorPerson` records */
export type DailyInspectionDailyContractorPersonListInput = {
  createdDate?: InputMaybe<DateTimeFilter>;
  /**
   * determines now to handle deleted `DailyInspectionDailyContractorPerson` records
   *
   * - when `true`, only return deleted records
   * - when `false`, do not return deleted records
   * - when omitted, `deleted` is ignored
   */
  deleted?: InputMaybe<Scalars['Boolean']>;
  lastEditedDate?: InputMaybe<DateTimeFilter>;
  /**
   * how to order `DailyInspectionDailyContractorPerson` records
   *
   * executed in the order they are defined
   */
  orderBy?: InputMaybe<Array<OrderByInput>>;
  /**
   * paginate `DailyInspectionDailyContractorPerson` records
   *
   * using `paginate` may require multiple requests to get all possible results,
   * but will give more fine-grain control in the event all records cannot be
   * returned gracefully
   */
  paginate?: InputMaybe<PaginationInput>;
};

/** response metadata for a list query of DailyInspectionDailyContractorPerson records */
export type DailyInspectionDailyContractorPersonListResponse = {
  __typename: 'DailyInspectionDailyContractorPersonListResponse';
  /** the total count of DailyInspectionDailyContractorPerson records matching any configured filters */
  count: Scalars['Int'];
  /** the total count of paginated groups of DailyInspectionDailyContractorPerson */
  pages: Scalars['Int'];
  /** DailyInspectionDailyContractorPerson records */
  records: Array<DailyInspectionDailyContractorPerson>;
};

export type DailyInspectionFeatureEngineeringJudgement = {
  __typename: 'DailyInspectionFeatureEngineeringJudgement';
  /** the date this record was inserted into the database */
  createdDate: Maybe<Scalars['DateTime']>;
  /** the username or email address of a mobile app user associated with the `createdDate` */
  createdUser: Maybe<Scalars['String']>;
  dailyInspectionInspections: Array<DailyInspectionInspection>;
  deleted: Maybe<Scalars['String']>;
  displayName: Maybe<Scalars['String']>;
  /** a GUID used to globally identify this record in the database */
  globalId: Scalars['String'];
  /** the date this record was last updated in the database */
  lastEditedDate: Maybe<Scalars['DateTime']>;
  /** the username or email address of a mobile app user associated with the `lastEditedDate` */
  lastEditedUser: Maybe<Scalars['String']>;
  name: Maybe<Scalars['String']>;
  /** a related `Project` */
  project: Maybe<Project>;
  /** the `globalId` of a related `Project` */
  projectId: Maybe<Scalars['String']>;
  requiredLevel: Maybe<Scalars['Int']>;
  text: Maybe<Scalars['String']>;
};


export type DailyInspectionFeatureEngineeringJudgementDailyInspectionInspectionsArgs = {
  dailyInspectionInspectionFieldInput?: InputMaybe<DailyInspectionInspectionFieldInput>;
};

/**
 * helps filter multiple `DailyInspectionFeatureEngineeringJudgement` records
 *
 * this version of the input will have limited options compared to its other counterpart
 */
export type DailyInspectionFeatureEngineeringJudgementFieldInput = {
  createdDate?: InputMaybe<DateTimeFilter>;
  /**
   * determines now to handle deleted `DailyInspectionFeatureEngineeringJudgement` records
   *
   * - when `true`, only return deleted records
   * - when `false`, do not return deleted records
   * - when omitted, `deleted` is ignored
   */
  deleted?: InputMaybe<Scalars['Boolean']>;
  displayName?: InputMaybe<StringFilter>;
  lastEditedDate?: InputMaybe<DateTimeFilter>;
  name?: InputMaybe<StringFilter>;
  /**
   * how to order `DailyInspectionFeatureEngineeringJudgement` records
   *
   * executed in the order they are defined
   */
  orderBy?: InputMaybe<Array<OrderByInput>>;
  projectId?: InputMaybe<StringFilter>;
  /**
   * specifies how many records to return
   *
   * analogous to `limit`, `first`, or `top` in SQL dialects
   */
  take?: InputMaybe<Scalars['Int']>;
};

/** helps filter multiple `DailyInspectionFeatureEngineeringJudgement` records */
export type DailyInspectionFeatureEngineeringJudgementListInput = {
  createdDate?: InputMaybe<DateTimeFilter>;
  /**
   * determines now to handle deleted `DailyInspectionFeatureEngineeringJudgement` records
   *
   * - when `true`, only return deleted records
   * - when `false`, do not return deleted records
   * - when omitted, `deleted` is ignored
   */
  deleted?: InputMaybe<Scalars['Boolean']>;
  displayName?: InputMaybe<StringFilter>;
  lastEditedDate?: InputMaybe<DateTimeFilter>;
  name?: InputMaybe<StringFilter>;
  /**
   * how to order `DailyInspectionFeatureEngineeringJudgement` records
   *
   * executed in the order they are defined
   */
  orderBy?: InputMaybe<Array<OrderByInput>>;
  /**
   * paginate `DailyInspectionFeatureEngineeringJudgement` records
   *
   * using `paginate` may require multiple requests to get all possible results,
   * but will give more fine-grain control in the event all records cannot be
   * returned gracefully
   */
  paginate?: InputMaybe<PaginationInput>;
  projectId?: InputMaybe<StringFilter>;
};

/** response metadata for a list query of DailyInspectionFeatureEngineeringJudgement records */
export type DailyInspectionFeatureEngineeringJudgementListResponse = {
  __typename: 'DailyInspectionFeatureEngineeringJudgementListResponse';
  /** the total count of DailyInspectionFeatureEngineeringJudgement records matching any configured filters */
  count: Scalars['Int'];
  /** the total count of paginated groups of DailyInspectionFeatureEngineeringJudgement */
  pages: Scalars['Int'];
  /** DailyInspectionFeatureEngineeringJudgement records */
  records: Array<DailyInspectionFeatureEngineeringJudgement>;
};

export type DailyInspectionForm = {
  __typename: 'DailyInspectionForm';
  /** the date this record was inserted into the database */
  createdDate: Maybe<Scalars['DateTime']>;
  /** the username or email address of a mobile app user associated with the `createdDate` */
  createdUser: Maybe<Scalars['String']>;
  dailyInspectionControlPoints: Array<DailyInspectionControlPoint>;
  dailyInspectionFormQuestions: Array<DailyInspectionFormQuestion>;
  deleted: Maybe<Scalars['String']>;
  formName: Maybe<Scalars['String']>;
  /** a GUID used to globally identify this record in the database */
  globalId: Scalars['String'];
  id: Maybe<Scalars['String']>;
  /** the date this record was last updated in the database */
  lastEditedDate: Maybe<Scalars['DateTime']>;
  /** the username or email address of a mobile app user associated with the `lastEditedDate` */
  lastEditedUser: Maybe<Scalars['String']>;
  orderNum: Maybe<Scalars['Int']>;
  /** a related `Project` */
  project: Maybe<Project>;
  /** the `globalId` of a related `Project` */
  projectId: Maybe<Scalars['String']>;
  question: Maybe<Scalars['String']>;
  valueType: Maybe<Scalars['Int']>;
  workType: Maybe<DailyInspectionWorkType>;
  /** the `globalId` of a related `DailyInspectionWorkType` */
  workTypeGuid: Maybe<Scalars['String']>;
  workTypeId: Maybe<Scalars['String']>;
};


export type DailyInspectionFormDailyInspectionControlPointsArgs = {
  dailyInspectionControlPointFieldInput?: InputMaybe<DailyInspectionControlPointFieldInput>;
};


export type DailyInspectionFormDailyInspectionFormQuestionsArgs = {
  dailyInspectionFormQuestionFieldInput?: InputMaybe<DailyInspectionFormQuestionFieldInput>;
};

export type DailyInspectionFormAnswer = {
  __typename: 'DailyInspectionFormAnswer';
  conditionMet: Maybe<Scalars['String']>;
  /** the date this record was inserted into the database */
  createdDate: Maybe<Scalars['DateTime']>;
  /** the username or email address of a mobile app user associated with the `createdDate` */
  createdUser: Maybe<Scalars['String']>;
  dailyInspectionControlPoint: Maybe<DailyInspectionControlPoint>;
  dailyInspectionInspection: Maybe<DailyInspectionInspection>;
  dailyInspectionPunchList: Maybe<DailyInspectionPunchList>;
  deleted: Maybe<Scalars['String']>;
  /** the `globalId` of one of the related types: `DailyInspectionControlPoint`, `DailyInspectionInspection`, or `DailyInspectionPunchList` */
  featureGuid: Maybe<Scalars['String']>;
  featureId: Maybe<Scalars['String']>;
  /** a GUID used to globally identify this record in the database */
  globalId: Scalars['String'];
  isGroup: Maybe<Scalars['String']>;
  json: Maybe<DailyInspectionFormAnswerJson>;
  /** the date this record was last updated in the database */
  lastEditedDate: Maybe<Scalars['DateTime']>;
  /** the username or email address of a mobile app user associated with the `lastEditedDate` */
  lastEditedUser: Maybe<Scalars['String']>;
  orderNum: Maybe<Scalars['Int']>;
  parentFeatureTable: Maybe<Scalars['Int']>;
  question: Maybe<Scalars['String']>;
  value: Maybe<Scalars['String']>;
  valueType: Maybe<Scalars['Int']>;
};

/**
 * helps filter multiple `DailyInspectionFormAnswer` records
 *
 * this version of the input will have limited options compared to its other counterpart
 */
export type DailyInspectionFormAnswerFieldInput = {
  createdDate?: InputMaybe<DateTimeFilter>;
  /**
   * determines now to handle deleted `DailyInspectionFormAnswer` records
   *
   * - when `true`, only return deleted records
   * - when `false`, do not return deleted records
   * - when omitted, `deleted` is ignored
   */
  deleted?: InputMaybe<Scalars['Boolean']>;
  lastEditedDate?: InputMaybe<DateTimeFilter>;
  /**
   * how to order `DailyInspectionFormAnswer` records
   *
   * executed in the order they are defined
   */
  orderBy?: InputMaybe<Array<OrderByInput>>;
  /**
   * specifies how many records to return
   *
   * analogous to `limit`, `first`, or `top` in SQL dialects
   */
  take?: InputMaybe<Scalars['Int']>;
};

export type DailyInspectionFormAnswerJson = {
  __typename: 'DailyInspectionFormAnswerJSON';
  FeatureGUID: Maybe<Scalars['String']>;
  Order: Maybe<Scalars['Int']>;
  Value: Maybe<Scalars['String']>;
  ValueType: Maybe<Scalars['Int']>;
};

/** helps filter multiple `DailyInspectionFormAnswer` records */
export type DailyInspectionFormAnswerListInput = {
  createdDate?: InputMaybe<DateTimeFilter>;
  /**
   * determines now to handle deleted `DailyInspectionFormAnswer` records
   *
   * - when `true`, only return deleted records
   * - when `false`, do not return deleted records
   * - when omitted, `deleted` is ignored
   */
  deleted?: InputMaybe<Scalars['Boolean']>;
  lastEditedDate?: InputMaybe<DateTimeFilter>;
  /**
   * how to order `DailyInspectionFormAnswer` records
   *
   * executed in the order they are defined
   */
  orderBy?: InputMaybe<Array<OrderByInput>>;
  /**
   * paginate `DailyInspectionFormAnswer` records
   *
   * using `paginate` may require multiple requests to get all possible results,
   * but will give more fine-grain control in the event all records cannot be
   * returned gracefully
   */
  paginate?: InputMaybe<PaginationInput>;
};

/** response metadata for a list query of DailyInspectionFormAnswer records */
export type DailyInspectionFormAnswerListResponse = {
  __typename: 'DailyInspectionFormAnswerListResponse';
  /** the total count of DailyInspectionFormAnswer records matching any configured filters */
  count: Scalars['Int'];
  /** the total count of paginated groups of DailyInspectionFormAnswer */
  pages: Scalars['Int'];
  /** DailyInspectionFormAnswer records */
  records: Array<DailyInspectionFormAnswer>;
};

/**
 * helps filter multiple `DailyInspectionForm` records
 *
 * this version of the input will have limited options compared to its other counterpart
 */
export type DailyInspectionFormFieldInput = {
  createdDate?: InputMaybe<DateTimeFilter>;
  /**
   * determines now to handle deleted `DailyInspectionForm` records
   *
   * - when `true`, only return deleted records
   * - when `false`, do not return deleted records
   * - when omitted, `deleted` is ignored
   */
  deleted?: InputMaybe<Scalars['Boolean']>;
  formName?: InputMaybe<StringFilter>;
  lastEditedDate?: InputMaybe<DateTimeFilter>;
  /**
   * how to order `DailyInspectionForm` records
   *
   * executed in the order they are defined
   */
  orderBy?: InputMaybe<Array<OrderByInput>>;
  projectId?: InputMaybe<StringFilter>;
  /**
   * specifies how many records to return
   *
   * analogous to `limit`, `first`, or `top` in SQL dialects
   */
  take?: InputMaybe<Scalars['Int']>;
};

/** helps filter multiple `DailyInspectionForm` records */
export type DailyInspectionFormListInput = {
  createdDate?: InputMaybe<DateTimeFilter>;
  /**
   * determines now to handle deleted `DailyInspectionForm` records
   *
   * - when `true`, only return deleted records
   * - when `false`, do not return deleted records
   * - when omitted, `deleted` is ignored
   */
  deleted?: InputMaybe<Scalars['Boolean']>;
  formName?: InputMaybe<StringFilter>;
  lastEditedDate?: InputMaybe<DateTimeFilter>;
  /**
   * how to order `DailyInspectionForm` records
   *
   * executed in the order they are defined
   */
  orderBy?: InputMaybe<Array<OrderByInput>>;
  /**
   * paginate `DailyInspectionForm` records
   *
   * using `paginate` may require multiple requests to get all possible results,
   * but will give more fine-grain control in the event all records cannot be
   * returned gracefully
   */
  paginate?: InputMaybe<PaginationInput>;
  projectId?: InputMaybe<StringFilter>;
};

/** response metadata for a list query of DailyInspectionForm records */
export type DailyInspectionFormListResponse = {
  __typename: 'DailyInspectionFormListResponse';
  /** the total count of DailyInspectionForm records matching any configured filters */
  count: Scalars['Int'];
  /** the total count of paginated groups of DailyInspectionForm */
  pages: Scalars['Int'];
  /** DailyInspectionForm records */
  records: Array<DailyInspectionForm>;
};

export type DailyInspectionFormQuestion = {
  __typename: 'DailyInspectionFormQuestion';
  condition: Maybe<Scalars['String']>;
  /** the date this record was inserted into the database */
  createdDate: Maybe<Scalars['DateTime']>;
  /** the username or email address of a mobile app user associated with the `createdDate` */
  createdUser: Maybe<Scalars['String']>;
  dailyInspectionForm: Maybe<DailyInspectionForm>;
  /** the `globalId` of a related `DailyInspectionForm` */
  dailyInspectionFormsGuid: Maybe<Scalars['String']>;
  deleted: Maybe<Scalars['String']>;
  /** a GUID used to globally identify this record in the database */
  globalId: Scalars['String'];
  isGroup: Maybe<Scalars['String']>;
  /** the date this record was last updated in the database */
  lastEditedDate: Maybe<Scalars['DateTime']>;
  /** the username or email address of a mobile app user associated with the `lastEditedDate` */
  lastEditedUser: Maybe<Scalars['String']>;
  orderNum: Maybe<Scalars['Int']>;
  pickerOptions: Maybe<Scalars['String']>;
  question: Maybe<Scalars['String']>;
  valueType: Maybe<Scalars['Int']>;
};

/**
 * helps filter multiple `DailyInspectionFormQuestion` records
 *
 * this version of the input will have limited options compared to its other counterpart
 */
export type DailyInspectionFormQuestionFieldInput = {
  createdDate?: InputMaybe<DateTimeFilter>;
  /**
   * determines now to handle deleted `DailyInspectionFormQuestion` records
   *
   * - when `true`, only return deleted records
   * - when `false`, do not return deleted records
   * - when omitted, `deleted` is ignored
   */
  deleted?: InputMaybe<Scalars['Boolean']>;
  lastEditedDate?: InputMaybe<DateTimeFilter>;
  /**
   * how to order `DailyInspectionFormQuestion` records
   *
   * executed in the order they are defined
   */
  orderBy?: InputMaybe<Array<OrderByInput>>;
  question?: InputMaybe<StringFilter>;
  /**
   * specifies how many records to return
   *
   * analogous to `limit`, `first`, or `top` in SQL dialects
   */
  take?: InputMaybe<Scalars['Int']>;
};

/** helps filter multiple `DailyInspectionFormQuestion` records */
export type DailyInspectionFormQuestionListInput = {
  createdDate?: InputMaybe<DateTimeFilter>;
  /**
   * determines now to handle deleted `DailyInspectionFormQuestion` records
   *
   * - when `true`, only return deleted records
   * - when `false`, do not return deleted records
   * - when omitted, `deleted` is ignored
   */
  deleted?: InputMaybe<Scalars['Boolean']>;
  lastEditedDate?: InputMaybe<DateTimeFilter>;
  /**
   * how to order `DailyInspectionFormQuestion` records
   *
   * executed in the order they are defined
   */
  orderBy?: InputMaybe<Array<OrderByInput>>;
  /**
   * paginate `DailyInspectionFormQuestion` records
   *
   * using `paginate` may require multiple requests to get all possible results,
   * but will give more fine-grain control in the event all records cannot be
   * returned gracefully
   */
  paginate?: InputMaybe<PaginationInput>;
  question?: InputMaybe<StringFilter>;
};

/** response metadata for a list query of DailyInspectionFormQuestion records */
export type DailyInspectionFormQuestionListResponse = {
  __typename: 'DailyInspectionFormQuestionListResponse';
  /** the total count of DailyInspectionFormQuestion records matching any configured filters */
  count: Scalars['Int'];
  /** the total count of paginated groups of DailyInspectionFormQuestion */
  pages: Scalars['Int'];
  /** DailyInspectionFormQuestion records */
  records: Array<DailyInspectionFormQuestion>;
};

export type DailyInspectionInspection = {
  __typename: 'DailyInspectionInspection';
  approve: Maybe<Scalars['DateTime']>;
  archiveDate: Maybe<Scalars['DateTime']>;
  archiveUser: Maybe<Scalars['String']>;
  archived: Maybe<Scalars['String']>;
  areaSqFt: Maybe<Scalars['Float']>;
  areaSqYrd: Maybe<Scalars['Float']>;
  associatedMOT: Maybe<Scalars['String']>;
  base64MapImage: Maybe<Scalars['String']>;
  cdr: Maybe<Scalars['String']>;
  contractor: Maybe<Contractor>;
  /** the `globalId` of a related `Contractor` */
  contractorGuid: Maybe<Scalars['String']>;
  controlPointNumber: Maybe<Scalars['String']>;
  controlPointPerformed: Maybe<Scalars['String']>;
  copiedInspectionId: Maybe<Scalars['String']>;
  /** the date this record was inserted into the database */
  createdDate: Maybe<Scalars['DateTime']>;
  /** the username or email address of a mobile app user associated with the `createdDate` */
  createdUser: Maybe<Scalars['String']>;
  dailyInspectionDailyContractorEquipments: Array<DailyInspectionDailyContractorEquipment>;
  dailyInspectionDailyContractorPersons: Array<DailyInspectionDailyContractorPerson>;
  dailyInspectionFormAnswers: Array<DailyInspectionFormAnswer>;
  dateCreated: Maybe<Scalars['DateTime']>;
  deleted: Maybe<Scalars['String']>;
  description: Maybe<Scalars['String']>;
  ejToReports: Array<EjToReport>;
  endAlignment: Maybe<Scalars['String']>;
  endOffset: Maybe<Scalars['String']>;
  endStation: Maybe<Scalars['String']>;
  engineeringJudgeExcersized: Maybe<Scalars['String']>;
  engineeringJudgement: Maybe<DailyInspectionFeatureEngineeringJudgement>;
  engineeringJudgementDetails: Maybe<Scalars['String']>;
  /** the `globalId` of a related `DailyInspectionFeatureEngineeringJudgement` */
  engineeringJudgementGuid: Maybe<Scalars['String']>;
  /** `featureGuid` is unreliable, a misnomer, every record contains `null` values, or its purpose is generally unknown */
  featureGuid: Maybe<Scalars['String']>;
  foreman: Maybe<DailyInspectionLookUp>;
  /** the `globalId` of a related `DailyInspectionLookUp` */
  foremanGuid: Maybe<Scalars['String']>;
  genericPlacements: Array<GenericPlacement>;
  /** a GUID used to globally identify this record in the database */
  globalId: Scalars['String'];
  hasUnresolvedIssues: Maybe<Scalars['String']>;
  identifiedFieldIssue: Maybe<IdentifiedFieldIssue>;
  inspectionId: Maybe<Scalars['String']>;
  inspectionNotes: Maybe<Scalars['String']>;
  inspectionStart: Maybe<Scalars['DateTime']>;
  inspectionStop: Maybe<Scalars['DateTime']>;
  inspectionTimeOnSite: Maybe<Scalars['Float']>;
  issueToReports: Array<IssueToReport>;
  json: Maybe<DailyInspectionInspectionJson>;
  /** the date this record was last updated in the database */
  lastEditedDate: Maybe<Scalars['DateTime']>;
  /** the username or email address of a mobile app user associated with the `lastEditedDate` */
  lastEditedUser: Maybe<Scalars['String']>;
  linearFt: Maybe<Scalars['Float']>;
  lowTemp: Maybe<Scalars['Float']>;
  manualMeasurements: Maybe<Scalars['String']>;
  mediaUploads: Array<MediaUpload>;
  /**
   * If set, contains a comma separated list of
   * `PayItemNoGeometry.globalId` values
   *
   * unfortunately, there have been instances where one of these values doesn't map
   * to a valid `PayItemNoGeometry`
   *
   * `payItemNoGeometries` will skip these rather than map them to `null`
   */
  multiplePayItems: Maybe<Scalars['String']>;
  ncr: Maybe<Scalars['String']>;
  ncrIssueDescription: Maybe<Scalars['String']>;
  payItemGuid: Maybe<Scalars['String']>;
  /**
   * aggregates all `PayItemNoGeometry` records associated with this
   * `DailyInspectionInspection` by using its `PayItemNoGeometry` reference and `multiplePayItems`
   *
   * if any `PayItemNoGeometry.globalId` values used to query the database return `null`,
   * the `null` value will be filtered out of the results
   *
   * every result will be a valid `PayItemNoGeometry`
   */
  payItemNoGeometries: Array<PayItemNoGeometry>;
  preExistingIssueNumber: Maybe<Scalars['String']>;
  precipitationAmount: Maybe<Scalars['String']>;
  precipitationType: Maybe<Scalars['String']>;
  productionStart: Maybe<Scalars['DateTime']>;
  productionStop: Maybe<Scalars['DateTime']>;
  productionWorkingDuration: Maybe<Scalars['Float']>;
  /** a related `Project` */
  project: Maybe<Project>;
  /**
   * `projectGuid` is unreliable, a misnomer, every record contains `null` values, or its purpose is generally unknown
   *
   * use `projectId` instead
   */
  projectGuid: Maybe<Scalars['String']>;
  /** the `globalId` of a related `Project` */
  projectId: Maybe<Scalars['String']>;
  punchListCheck: Maybe<Scalars['String']>;
  reject: Maybe<Scalars['DateTime']>;
  renderInfo: Maybe<Scalars['String']>;
  reopen: Maybe<Scalars['DateTime']>;
  reportDate: Maybe<Scalars['DateTime']>;
  reportToTags: Array<ReportToTag>;
  responseComment: Maybe<Scalars['String']>;
  reviewComment: Maybe<Scalars['String']>;
  reviewDate: Maybe<Scalars['DateTime']>;
  reviewStatus: Maybe<Scalars['String']>;
  reviewedBy: Maybe<Technician>;
  /** the `globalId` of a related `DailyInspectionLookUp` */
  reviewedByGuid: Maybe<Scalars['String']>;
  roadway: Maybe<DailyInspectionLookUp>;
  /** the `globalId` of a related `DailyInspectionLookUp` */
  roadwayGuid: Maybe<Scalars['String']>;
  segment: Maybe<DailyInspectionLookUp>;
  /** the `globalId` of a related `DailyInspectionLookUp` */
  segmentGuid: Maybe<Scalars['String']>;
  shape: Maybe<Scalars['String']>;
  skies: Maybe<Scalars['String']>;
  startAlignment: Maybe<Scalars['String']>;
  startOffset: Maybe<Scalars['String']>;
  startStation: Maybe<Scalars['String']>;
  structure: Maybe<DailyInspectionLookUp>;
  /** the `globalId` of a related `DailyInspectionLookUp` */
  structureGuid: Maybe<Scalars['String']>;
  submit: Maybe<Scalars['DateTime']>;
  technician: Maybe<Technician>;
  /** the `globalId` of a related `Technician` */
  technicianGuid: Maybe<Scalars['String']>;
  tempHigh: Maybe<Scalars['Float']>;
  testingAndSamplingNotes: Maybe<Scalars['String']>;
  unresolvedIssueNew: Maybe<Scalars['String']>;
  unresolvedIssuePreExisting: Maybe<Scalars['String']>;
  verbalInstructionsGiven: Maybe<Scalars['String']>;
  verbalInstructionsReceived: Maybe<Scalars['String']>;
  weatherImpactNotes: Maybe<Scalars['String']>;
  weatherImpacted: Maybe<Scalars['String']>;
  windSpeed: Maybe<Scalars['String']>;
  workType: Maybe<DailyInspectionWorkType>;
  /** the `globalId` of a related `DailyInspectionWorkType` */
  workTypeGuid: Maybe<Scalars['String']>;
};


export type DailyInspectionInspectionBase64MapImageArgs = {
  projectLayerIds?: InputMaybe<Array<Scalars['Int']>>;
};


export type DailyInspectionInspectionDailyInspectionDailyContractorEquipmentsArgs = {
  dailyInspectionDailyContractorEquipmentFieldInput?: InputMaybe<DailyInspectionDailyContractorEquipmentFieldInput>;
};


export type DailyInspectionInspectionDailyInspectionDailyContractorPersonsArgs = {
  dailyInspectionDailyContractorPersonFieldInput?: InputMaybe<DailyInspectionDailyContractorPersonFieldInput>;
};


export type DailyInspectionInspectionDailyInspectionFormAnswersArgs = {
  dailyInspectionFormAnswerFieldInput?: InputMaybe<DailyInspectionFormAnswerFieldInput>;
};


export type DailyInspectionInspectionEjToReportsArgs = {
  eJToReportFieldInput?: InputMaybe<EjToReportFieldInput>;
};


export type DailyInspectionInspectionGenericPlacementsArgs = {
  genericPlacementFieldInput?: InputMaybe<GenericPlacementFieldInput>;
};


export type DailyInspectionInspectionIssueToReportsArgs = {
  issueToReportFieldInput?: InputMaybe<IssueToReportFieldInput>;
};


export type DailyInspectionInspectionMediaUploadsArgs = {
  mediaUploadFieldInput?: InputMaybe<MediaUploadFieldInput>;
};


export type DailyInspectionInspectionPayItemNoGeometriesArgs = {
  payItemNoGeometryFieldInput?: InputMaybe<PayItemNoGeometryFieldInput>;
};


export type DailyInspectionInspectionReportToTagsArgs = {
  reportToTagFieldInput?: InputMaybe<ReportToTagFieldInput>;
};

/**
 * helps filter multiple `DailyInspectionInspection` records
 *
 * this version of the input will have limited options compared to its other counterpart
 */
export type DailyInspectionInspectionFieldInput = {
  createdDate?: InputMaybe<DateTimeFilter>;
  /**
   * determines now to handle deleted `DailyInspectionInspection` records
   *
   * - when `true`, only return deleted records
   * - when `false`, do not return deleted records
   * - when omitted, `deleted` is ignored
   */
  deleted?: InputMaybe<Scalars['Boolean']>;
  inspectionId?: InputMaybe<StringFilter>;
  lastEditedDate?: InputMaybe<DateTimeFilter>;
  /**
   * how to order `DailyInspectionInspection` records
   *
   * executed in the order they are defined
   */
  orderBy?: InputMaybe<Array<OrderByInput>>;
  projectId?: InputMaybe<StringFilter>;
  reviewStatus?: InputMaybe<StringFilter>;
  /**
   * specifies how many records to return
   *
   * analogous to `limit`, `first`, or `top` in SQL dialects
   */
  take?: InputMaybe<Scalars['Int']>;
};

export type DailyInspectionInspectionIfiSettings = {
  __typename: 'DailyInspectionInspectionIFISettings';
  /** the date this record was inserted into the database */
  createdDate: Scalars['DateTime'];
  /**
   * the email address of a user associated with the `createdDate`
   *
   * this value will be `unknown` if the `createdDate` was not set by a user
   */
  createdUser: Scalars['String'];
  effectiveDate: Maybe<Scalars['DateTime']>;
  enabled: Scalars['Boolean'];
  /** the date this record was last updated in the database */
  lastEditedDate: Scalars['DateTime'];
  /**
   * the email address of a user associated with the `lastEditedDate`
   *
   * this value will be `system` if the `lastEditedDate` was not set by a user
   */
  lastEditedUser: Scalars['String'];
  missingGeometry: InspectionMissingGeometryIfiSettings;
  /** a related `Project` */
  project: Project;
  /** the `globalId` of a related `Project` */
  projectId: Scalars['String'];
};

/** helps filter multiple `DailyInspectionInspectionIFISettings` records */
export type DailyInspectionInspectionIfiSettingsListInput = {
  /**
   * determines now to handle deleted `DailyInspectionInspectionIFISettings` records
   *
   * - when `true`, only return deleted records
   * - when `false`, do not return deleted records
   * - when omitted, `deleted` is ignored
   */
  deleted?: InputMaybe<Scalars['Boolean']>;
  effectiveDate?: InputMaybe<DateTimeFilter>;
  /**
   * how to order `DailyInspectionInspectionIFISettings` records
   *
   * executed in the order they are defined
   */
  orderBy?: InputMaybe<Array<OrderByInput>>;
  /**
   * paginate `DailyInspectionInspectionIFISettings` records
   *
   * using `paginate` may require multiple requests to get all possible results,
   * but will give more fine-grain control in the event all records cannot be
   * returned gracefully
   */
  paginate?: InputMaybe<PaginationInput>;
  projectId?: InputMaybe<StringFilter>;
};

/** response metadata for a list query of DailyInspectionInspectionIFISettings records */
export type DailyInspectionInspectionIfiSettingsListResponse = {
  __typename: 'DailyInspectionInspectionIFISettingsListResponse';
  /** the total count of DailyInspectionInspectionIFISettings records matching any configured filters */
  count: Scalars['Int'];
  /** the total count of paginated groups of DailyInspectionInspectionIFISettings */
  pages: Scalars['Int'];
  /** DailyInspectionInspectionIFISettings records */
  records: Array<DailyInspectionInspectionIfiSettings>;
};

export type DailyInspectionInspectionJson = {
  __typename: 'DailyInspectionInspectionJSON';
  AreaSqFt: Maybe<Scalars['Float']>;
  AreaSqYrd: Maybe<Scalars['Float']>;
  CDR: Maybe<Scalars['Boolean']>;
  ContractorGuid: Maybe<Scalars['String']>;
  ControlPointNumber: Maybe<Scalars['String']>;
  ControlPointPerformed: Maybe<Scalars['Boolean']>;
  CopiedInspectionId: Maybe<Scalars['String']>;
  DateCreated: Maybe<Scalars['DateTime']>;
  Description: Maybe<Scalars['String']>;
  EndAlignment: Maybe<Scalars['String']>;
  EndOffset: Maybe<Scalars['String']>;
  EndStation: Maybe<Scalars['String']>;
  EngineeringJudgementDetails: Maybe<Scalars['String']>;
  EngineeringJudgementExcersized: Maybe<Scalars['Boolean']>;
  EngineeringJudgementGuid: Maybe<Scalars['String']>;
  ForemanGuid: Maybe<Scalars['String']>;
  HasUnresolvedIssues: Maybe<Scalars['Boolean']>;
  InspectionId: Maybe<Scalars['String']>;
  InspectionNotes: Maybe<Scalars['String']>;
  InspectionStart: Maybe<Scalars['DateTime']>;
  InspectionStop: Maybe<Scalars['DateTime']>;
  InspectionTimeOnSite: Maybe<Scalars['Float']>;
  LinearFt: Maybe<Scalars['Float']>;
  LowTemp: Maybe<Scalars['Float']>;
  ManualMeasurements: Maybe<Scalars['Boolean']>;
  MultiplePayItems: Maybe<Scalars['String']>;
  NCR: Maybe<Scalars['Boolean']>;
  NcrIssueDescription: Maybe<Scalars['String']>;
  PayItemGuid: Maybe<Scalars['String']>;
  PreExistingIssueNumber: Maybe<Scalars['String']>;
  PrecipatationType: Maybe<Scalars['String']>;
  PrecipitationAmount: Maybe<Scalars['String']>;
  ProductionStart: Maybe<Scalars['DateTime']>;
  ProductionStop: Maybe<Scalars['DateTime']>;
  ProductionWorkingDuration: Maybe<Scalars['Float']>;
  ProjectGuid: Maybe<Scalars['String']>;
  ReportDate: Maybe<Scalars['DateTime']>;
  ReportDateString: Maybe<Scalars['String']>;
  ReportTimeString: Maybe<Scalars['String']>;
  ReviewComment: Maybe<Scalars['String']>;
  ReviewDate: Maybe<Scalars['DateTime']>;
  ReviewStatus: Maybe<Scalars['String']>;
  ReviewTech: Maybe<Scalars['String']>;
  ReviewedByGuid: Maybe<Scalars['String']>;
  RoadwayGuid: Maybe<Scalars['String']>;
  SegmentGuid: Maybe<Scalars['String']>;
  Skies: Maybe<Scalars['String']>;
  StartAlignment: Maybe<Scalars['String']>;
  StartOffset: Maybe<Scalars['String']>;
  StartStation: Maybe<Scalars['String']>;
  StructureGuid: Maybe<Scalars['String']>;
  TechnicianGuid: Maybe<Scalars['String']>;
  TempHigh: Maybe<Scalars['Float']>;
  TestingAndSamplingNotes: Maybe<Scalars['String']>;
  UnresolvedIssueNew: Maybe<Scalars['Boolean']>;
  UnresolvedIssuePreexisting: Maybe<Scalars['Boolean']>;
  VerbalInstructionsGiven: Maybe<Scalars['String']>;
  VerbalInstructionsReceived: Maybe<Scalars['String']>;
  Verbose: Maybe<Scalars['Boolean']>;
  WeatherImpactNotes: Maybe<Scalars['String']>;
  WeatherImpacted: Maybe<Scalars['Boolean']>;
  WindSpeed: Maybe<Scalars['String']>;
  WorkTypeGuid: Maybe<Scalars['String']>;
};

/** helps filter multiple `DailyInspectionInspection` records */
export type DailyInspectionInspectionListInput = {
  createdDate?: InputMaybe<DateTimeFilter>;
  /**
   * determines now to handle deleted `DailyInspectionInspection` records
   *
   * - when `true`, only return deleted records
   * - when `false`, do not return deleted records
   * - when omitted, `deleted` is ignored
   */
  deleted?: InputMaybe<Scalars['Boolean']>;
  inspectionId?: InputMaybe<StringFilter>;
  lastEditedDate?: InputMaybe<DateTimeFilter>;
  /**
   * how to order `DailyInspectionInspection` records
   *
   * executed in the order they are defined
   */
  orderBy?: InputMaybe<Array<OrderByInput>>;
  /**
   * paginate `DailyInspectionInspection` records
   *
   * using `paginate` may require multiple requests to get all possible results,
   * but will give more fine-grain control in the event all records cannot be
   * returned gracefully
   */
  paginate?: InputMaybe<PaginationInput>;
  projectId?: InputMaybe<StringFilter>;
  reviewStatus?: InputMaybe<StringFilter>;
};

/** response metadata for a list query of DailyInspectionInspection records */
export type DailyInspectionInspectionListResponse = {
  __typename: 'DailyInspectionInspectionListResponse';
  /** the total count of DailyInspectionInspection records matching any configured filters */
  count: Scalars['Int'];
  /** the total count of paginated groups of DailyInspectionInspection */
  pages: Scalars['Int'];
  /** DailyInspectionInspection records */
  records: Array<DailyInspectionInspection>;
};

export type DailyInspectionLookUp = {
  __typename: 'DailyInspectionLookUp';
  /** the date this record was inserted into the database */
  createdDate: Maybe<Scalars['DateTime']>;
  /** the username or email address of a mobile app user associated with the `createdDate` */
  createdUser: Maybe<Scalars['String']>;
  deleted: Maybe<Scalars['String']>;
  displayName: Maybe<Scalars['String']>;
  foremanDailyInspectionInspections: Array<DailyInspectionInspection>;
  /** a GUID used to globally identify this record in the database */
  globalId: Scalars['String'];
  /** the date this record was last updated in the database */
  lastEditedDate: Maybe<Scalars['DateTime']>;
  /** the username or email address of a mobile app user associated with the `lastEditedDate` */
  lastEditedUser: Maybe<Scalars['String']>;
  name: Maybe<Scalars['String']>;
  ohcRepDailyInspectionControlPoints: Array<DailyInspectionControlPoint>;
  originatorRepDailyInspectionPunchLists: Array<DailyInspectionPunchList>;
  plClosureDailyInspectionPunchLists: Array<DailyInspectionPunchList>;
  /** a related `Project` */
  project: Maybe<Project>;
  /** the `globalId` of a related `Project` */
  projectId: Maybe<Scalars['String']>;
  qaClosurePersonDailyInspectionPunchLists: Array<DailyInspectionPunchList>;
  qaRepDailyInspectionControlPoints: Array<DailyInspectionControlPoint>;
  qaRepDailyInspectionPunchLists: Array<DailyInspectionPunchList>;
  qaSignerDailyInspectionControlPoints: Array<DailyInspectionControlPoint>;
  qcRepDailyInspectionPunchLists: Array<DailyInspectionPunchList>;
  qcRequestForClosureDailyInspectionPunchLists: Array<DailyInspectionPunchList>;
  roadwayDailyInspectionInspections: Array<DailyInspectionInspection>;
  segmentDailyInspectionInspections: Array<DailyInspectionInspection>;
  structureDailyInspectionInspections: Array<DailyInspectionInspection>;
  type: Maybe<Scalars['String']>;
  udotRepDailyInspectionPunchLists: Array<DailyInspectionPunchList>;
};


export type DailyInspectionLookUpForemanDailyInspectionInspectionsArgs = {
  dailyInspectionInspectionFieldInput?: InputMaybe<DailyInspectionInspectionFieldInput>;
};


export type DailyInspectionLookUpOhcRepDailyInspectionControlPointsArgs = {
  dailyInspectionControlPointFieldInput?: InputMaybe<DailyInspectionControlPointFieldInput>;
};


export type DailyInspectionLookUpOriginatorRepDailyInspectionPunchListsArgs = {
  dailyInspectionPunchListFieldInput?: InputMaybe<DailyInspectionPunchListFieldInput>;
};


export type DailyInspectionLookUpPlClosureDailyInspectionPunchListsArgs = {
  dailyInspectionPunchListFieldInput?: InputMaybe<DailyInspectionPunchListFieldInput>;
};


export type DailyInspectionLookUpQaClosurePersonDailyInspectionPunchListsArgs = {
  dailyInspectionPunchListFieldInput?: InputMaybe<DailyInspectionPunchListFieldInput>;
};


export type DailyInspectionLookUpQaRepDailyInspectionControlPointsArgs = {
  dailyInspectionControlPointFieldInput?: InputMaybe<DailyInspectionControlPointFieldInput>;
};


export type DailyInspectionLookUpQaRepDailyInspectionPunchListsArgs = {
  dailyInspectionPunchListFieldInput?: InputMaybe<DailyInspectionPunchListFieldInput>;
};


export type DailyInspectionLookUpQaSignerDailyInspectionControlPointsArgs = {
  dailyInspectionControlPointFieldInput?: InputMaybe<DailyInspectionControlPointFieldInput>;
};


export type DailyInspectionLookUpQcRepDailyInspectionPunchListsArgs = {
  dailyInspectionPunchListFieldInput?: InputMaybe<DailyInspectionPunchListFieldInput>;
};


export type DailyInspectionLookUpQcRequestForClosureDailyInspectionPunchListsArgs = {
  dailyInspectionPunchListFieldInput?: InputMaybe<DailyInspectionPunchListFieldInput>;
};


export type DailyInspectionLookUpRoadwayDailyInspectionInspectionsArgs = {
  dailyInspectionInspectionFieldInput?: InputMaybe<DailyInspectionInspectionFieldInput>;
};


export type DailyInspectionLookUpSegmentDailyInspectionInspectionsArgs = {
  dailyInspectionInspectionFieldInput?: InputMaybe<DailyInspectionInspectionFieldInput>;
};


export type DailyInspectionLookUpStructureDailyInspectionInspectionsArgs = {
  dailyInspectionInspectionFieldInput?: InputMaybe<DailyInspectionInspectionFieldInput>;
};


export type DailyInspectionLookUpUdotRepDailyInspectionPunchListsArgs = {
  dailyInspectionPunchListFieldInput?: InputMaybe<DailyInspectionPunchListFieldInput>;
};

/**
 * helps filter multiple `DailyInspectionLookUp` records
 *
 * this version of the input will have limited options compared to its other counterpart
 */
export type DailyInspectionLookUpFieldInput = {
  createdDate?: InputMaybe<DateTimeFilter>;
  /**
   * determines now to handle deleted `DailyInspectionLookUp` records
   *
   * - when `true`, only return deleted records
   * - when `false`, do not return deleted records
   * - when omitted, `deleted` is ignored
   */
  deleted?: InputMaybe<Scalars['Boolean']>;
  lastEditedDate?: InputMaybe<DateTimeFilter>;
  /**
   * how to order `DailyInspectionLookUp` records
   *
   * executed in the order they are defined
   */
  orderBy?: InputMaybe<Array<OrderByInput>>;
  projectId?: InputMaybe<StringFilter>;
  /**
   * specifies how many records to return
   *
   * analogous to `limit`, `first`, or `top` in SQL dialects
   */
  take?: InputMaybe<Scalars['Int']>;
  type?: InputMaybe<StringFilter>;
};

/** helps filter multiple `DailyInspectionLookUp` records */
export type DailyInspectionLookUpListInput = {
  createdDate?: InputMaybe<DateTimeFilter>;
  /**
   * determines now to handle deleted `DailyInspectionLookUp` records
   *
   * - when `true`, only return deleted records
   * - when `false`, do not return deleted records
   * - when omitted, `deleted` is ignored
   */
  deleted?: InputMaybe<Scalars['Boolean']>;
  lastEditedDate?: InputMaybe<DateTimeFilter>;
  /**
   * how to order `DailyInspectionLookUp` records
   *
   * executed in the order they are defined
   */
  orderBy?: InputMaybe<Array<OrderByInput>>;
  /**
   * paginate `DailyInspectionLookUp` records
   *
   * using `paginate` may require multiple requests to get all possible results,
   * but will give more fine-grain control in the event all records cannot be
   * returned gracefully
   */
  paginate?: InputMaybe<PaginationInput>;
  projectId?: InputMaybe<StringFilter>;
  type?: InputMaybe<StringFilter>;
};

/** response metadata for a list query of DailyInspectionLookUp records */
export type DailyInspectionLookUpListResponse = {
  __typename: 'DailyInspectionLookUpListResponse';
  /** the total count of DailyInspectionLookUp records matching any configured filters */
  count: Scalars['Int'];
  /** the total count of paginated groups of DailyInspectionLookUp */
  pages: Scalars['Int'];
  /** DailyInspectionLookUp records */
  records: Array<DailyInspectionLookUp>;
};

export type DailyInspectionPunchList = {
  __typename: 'DailyInspectionPunchList';
  approve: Maybe<Scalars['DateTime']>;
  archiveDate: Maybe<Scalars['DateTime']>;
  archiveUser: Maybe<Scalars['String']>;
  archived: Maybe<Scalars['String']>;
  base64MapImage: Maybe<Scalars['String']>;
  /** the date this record was inserted into the database */
  createdDate: Maybe<Scalars['DateTime']>;
  /** the username or email address of a mobile app user associated with the `createdDate` */
  createdUser: Maybe<Scalars['String']>;
  dailyInspectionFormAnswers: Array<DailyInspectionFormAnswer>;
  dateClosed: Maybe<Scalars['DateTime']>;
  dateCreated: Maybe<Scalars['DateTime']>;
  deleted: Maybe<Scalars['String']>;
  description: Maybe<Scalars['String']>;
  endAlignment: Maybe<Scalars['String']>;
  endOffset: Maybe<Scalars['String']>;
  endStation: Maybe<Scalars['String']>;
  formData: Maybe<Scalars['String']>;
  formSnapshot: Maybe<Scalars['String']>;
  genericPlacements: Array<GenericPlacement>;
  /** a GUID used to globally identify this record in the database */
  globalId: Scalars['String'];
  identifiedFieldIssue: Maybe<IdentifiedFieldIssue>;
  issueToReports: Array<IssueToReport>;
  json: Maybe<DailyInspectionPunchListJson>;
  /** the date this record was last updated in the database */
  lastEditedDate: Maybe<Scalars['DateTime']>;
  /** the username or email address of a mobile app user associated with the `lastEditedDate` */
  lastEditedUser: Maybe<Scalars['String']>;
  manualMeasurements: Maybe<Scalars['String']>;
  mediaUploads: Array<MediaUpload>;
  /**
   * If set, contains a comma separated list of
   * `PayItemNoGeometry.globalId` values
   *
   * unfortunately, there have been instances where one of these values doesn't map
   * to a valid `PayItemNoGeometry`
   *
   * `payItemNoGeometries` will skip these rather than map them to `null`
   */
  multiplePayItems: Maybe<Scalars['String']>;
  originatorRep: Maybe<DailyInspectionLookUp>;
  /** the `globalId` of a related `DailyInspectionLookUp` */
  originatorRepGuid: Maybe<Scalars['String']>;
  payItemGuid: Maybe<Scalars['String']>;
  /**
   * aggregates all `PayItemNoGeometry` records associated with this
   * `DailyInspectionPunchList` by using its `PayItemNoGeometry` reference and `multiplePayItems`
   *
   * if any `PayItemNoGeometry.globalId` values used to query the database return `null`,
   * the `null` value will be filtered out of the results
   *
   * every result will be a valid `PayItemNoGeometry`
   */
  payItemNoGeometries: Array<PayItemNoGeometry>;
  photoUrls: Maybe<Scalars['String']>;
  plClosure: Maybe<DailyInspectionLookUp>;
  /** the `globalId` of a related `DailyInspectionLookUp` */
  plClosureGuid: Maybe<Scalars['String']>;
  productionStart: Maybe<Scalars['DateTime']>;
  /** a related `Project` */
  project: Maybe<Project>;
  /**
   * `projectGuid` is unreliable, a misnomer, every record contains `null` values, or its purpose is generally unknown
   *
   * use `projectId` instead
   */
  projectGuid: Maybe<Scalars['String']>;
  /** the `globalId` of a related `Project` */
  projectId: Maybe<Scalars['String']>;
  punchListId: Maybe<Scalars['String']>;
  qaClosurePerson: Maybe<DailyInspectionLookUp>;
  /** the `globalId` of a related `DailyInspectionLookUp` */
  qaClosurePersonGuid: Maybe<Scalars['String']>;
  qaClosureRecSignatureDate: Maybe<Scalars['DateTime']>;
  qaClosureRecSignatureUri: Maybe<Scalars['String']>;
  qaClosureSignatureDate: Maybe<Scalars['DateTime']>;
  qaClosureSignatureUri: Maybe<Scalars['String']>;
  qaRep: Maybe<DailyInspectionLookUp>;
  /** the `globalId` of a related `DailyInspectionLookUp` */
  qaRepGuid: Maybe<Scalars['String']>;
  qcRep: Maybe<DailyInspectionLookUp>;
  /** the `globalId` of a related `DailyInspectionLookUp` */
  qcRepGuid: Maybe<Scalars['String']>;
  qcRequestForClosure: Maybe<DailyInspectionLookUp>;
  /** the `globalId` of a related `DailyInspectionLookUp` */
  qcRequestForClosureGuid: Maybe<Scalars['String']>;
  reject: Maybe<Scalars['DateTime']>;
  renderInfo: Maybe<Scalars['String']>;
  reopen: Maybe<Scalars['DateTime']>;
  reportDate: Maybe<Scalars['DateTime']>;
  reportToTags: Array<ReportToTag>;
  responseComment: Maybe<Scalars['String']>;
  reviewComment: Maybe<Scalars['String']>;
  reviewDate: Maybe<Scalars['DateTime']>;
  reviewStatus: Maybe<Scalars['String']>;
  reviewedBy: Maybe<Technician>;
  /** the `globalId` of a related `Technician` */
  reviewedByGuid: Maybe<Scalars['String']>;
  shape: Maybe<Scalars['String']>;
  startAlignment: Maybe<Scalars['String']>;
  startOffset: Maybe<Scalars['String']>;
  startStation: Maybe<Scalars['String']>;
  status: Maybe<Scalars['String']>;
  statusUpdate: Maybe<Scalars['String']>;
  submit: Maybe<Scalars['DateTime']>;
  technician: Maybe<Technician>;
  /** the `globalId` of a related `Technician` */
  technicianGuid: Maybe<Scalars['String']>;
  udotClosureSignatureDate: Maybe<Scalars['DateTime']>;
  udotClosureSignatureUri: Maybe<Scalars['String']>;
  udotRep: Maybe<DailyInspectionLookUp>;
  /** the `globalId` of a related `DailyInspectionLookUp` */
  udotRepGuid: Maybe<Scalars['String']>;
  workType: Maybe<DailyInspectionWorkType>;
  /** the `globalId` of a related `DailyInspectionWorkType` */
  workTypeGuid: Maybe<Scalars['String']>;
};


export type DailyInspectionPunchListBase64MapImageArgs = {
  projectLayerIds?: InputMaybe<Array<Scalars['Int']>>;
};


export type DailyInspectionPunchListDailyInspectionFormAnswersArgs = {
  dailyInspectionFormAnswerFieldInput?: InputMaybe<DailyInspectionFormAnswerFieldInput>;
};


export type DailyInspectionPunchListGenericPlacementsArgs = {
  genericPlacementFieldInput?: InputMaybe<GenericPlacementFieldInput>;
};


export type DailyInspectionPunchListIssueToReportsArgs = {
  issueToReportFieldInput?: InputMaybe<IssueToReportFieldInput>;
};


export type DailyInspectionPunchListMediaUploadsArgs = {
  mediaUploadFieldInput?: InputMaybe<MediaUploadFieldInput>;
};


export type DailyInspectionPunchListPayItemNoGeometriesArgs = {
  payItemNoGeometryFieldInput?: InputMaybe<PayItemNoGeometryFieldInput>;
};


export type DailyInspectionPunchListReportToTagsArgs = {
  reportToTagFieldInput?: InputMaybe<ReportToTagFieldInput>;
};

/**
 * helps filter multiple `DailyInspectionPunchList` records
 *
 * this version of the input will have limited options compared to its other counterpart
 */
export type DailyInspectionPunchListFieldInput = {
  createdDate?: InputMaybe<DateTimeFilter>;
  /**
   * determines now to handle deleted `DailyInspectionPunchList` records
   *
   * - when `true`, only return deleted records
   * - when `false`, do not return deleted records
   * - when omitted, `deleted` is ignored
   */
  deleted?: InputMaybe<Scalars['Boolean']>;
  lastEditedDate?: InputMaybe<DateTimeFilter>;
  /**
   * how to order `DailyInspectionPunchList` records
   *
   * executed in the order they are defined
   */
  orderBy?: InputMaybe<Array<OrderByInput>>;
  projectId?: InputMaybe<StringFilter>;
  punchListId?: InputMaybe<StringFilter>;
  reviewStatus?: InputMaybe<StringFilter>;
  /**
   * specifies how many records to return
   *
   * analogous to `limit`, `first`, or `top` in SQL dialects
   */
  take?: InputMaybe<Scalars['Int']>;
};

export type DailyInspectionPunchListIfiSettings = {
  __typename: 'DailyInspectionPunchListIFISettings';
  /** the date this record was inserted into the database */
  createdDate: Scalars['DateTime'];
  /**
   * the email address of a user associated with the `createdDate`
   *
   * this value will be `unknown` if the `createdDate` was not set by a user
   */
  createdUser: Scalars['String'];
  effectiveDate: Maybe<Scalars['DateTime']>;
  enabled: Scalars['Boolean'];
  /** the date this record was last updated in the database */
  lastEditedDate: Scalars['DateTime'];
  /**
   * the email address of a user associated with the `lastEditedDate`
   *
   * this value will be `system` if the `lastEditedDate` was not set by a user
   */
  lastEditedUser: Scalars['String'];
  /** a related `Project` */
  project: Project;
  /** the `globalId` of a related `Project` */
  projectId: Scalars['String'];
};

/** helps filter multiple `DailyInspectionPunchListIFISettings` records */
export type DailyInspectionPunchListIfiSettingsListInput = {
  /**
   * determines now to handle deleted `DailyInspectionPunchListIFISettings` records
   *
   * - when `true`, only return deleted records
   * - when `false`, do not return deleted records
   * - when omitted, `deleted` is ignored
   */
  deleted?: InputMaybe<Scalars['Boolean']>;
  effectiveDate?: InputMaybe<DateTimeFilter>;
  /**
   * how to order `DailyInspectionPunchListIFISettings` records
   *
   * executed in the order they are defined
   */
  orderBy?: InputMaybe<Array<OrderByInput>>;
  /**
   * paginate `DailyInspectionPunchListIFISettings` records
   *
   * using `paginate` may require multiple requests to get all possible results,
   * but will give more fine-grain control in the event all records cannot be
   * returned gracefully
   */
  paginate?: InputMaybe<PaginationInput>;
  projectId?: InputMaybe<StringFilter>;
};

/** response metadata for a list query of DailyInspectionPunchListIFISettings records */
export type DailyInspectionPunchListIfiSettingsListResponse = {
  __typename: 'DailyInspectionPunchListIFISettingsListResponse';
  /** the total count of DailyInspectionPunchListIFISettings records matching any configured filters */
  count: Scalars['Int'];
  /** the total count of paginated groups of DailyInspectionPunchListIFISettings */
  pages: Scalars['Int'];
  /** DailyInspectionPunchListIFISettings records */
  records: Array<DailyInspectionPunchListIfiSettings>;
};

export type DailyInspectionPunchListJson = {
  __typename: 'DailyInspectionPunchListJSON';
  DateCreated: Maybe<Scalars['DateTime']>;
  EndAlignment: Maybe<Scalars['String']>;
  EndOffset: Maybe<Scalars['String']>;
  EndStation: Maybe<Scalars['String']>;
  FormData: Maybe<Scalars['String']>;
  FormSnapshot: Maybe<Scalars['String']>;
  OriginatorRepGuid: Maybe<Scalars['String']>;
  PLClosureGuid: Maybe<Scalars['String']>;
  PayItemsGUID: Maybe<Scalars['String']>;
  ProjectGuid: Maybe<Scalars['String']>;
  PunchListId: Maybe<Scalars['String']>;
  QAClosurePresonGuid: Maybe<Scalars['String']>;
  QAClosureRecomendationSignatureUri: Maybe<Scalars['String']>;
  QARepGuid: Maybe<Scalars['String']>;
  QCRepGuid: Maybe<Scalars['String']>;
  QCRequestForClosureGuid: Maybe<Scalars['String']>;
  RenderInfo: Maybe<Scalars['String']>;
  ReportDate: Maybe<Scalars['DateTime']>;
  ReviewDate: Maybe<Scalars['DateTime']>;
  ReviewStatus: Maybe<Scalars['String']>;
  ReviewedByGuid: Maybe<Scalars['String']>;
  StartAlignment: Maybe<Scalars['String']>;
  StartOffset: Maybe<Scalars['String']>;
  StartStation: Maybe<Scalars['String']>;
  TechnicianGuid: Maybe<Scalars['String']>;
  UDOTClosureSignatureUri: Maybe<Scalars['String']>;
  UDOTRepGuid: Maybe<Scalars['String']>;
  Verbose: Maybe<Scalars['Boolean']>;
  WorkTypeGuid: Maybe<Scalars['String']>;
};

/** helps filter multiple `DailyInspectionPunchList` records */
export type DailyInspectionPunchListListInput = {
  createdDate?: InputMaybe<DateTimeFilter>;
  /**
   * determines now to handle deleted `DailyInspectionPunchList` records
   *
   * - when `true`, only return deleted records
   * - when `false`, do not return deleted records
   * - when omitted, `deleted` is ignored
   */
  deleted?: InputMaybe<Scalars['Boolean']>;
  lastEditedDate?: InputMaybe<DateTimeFilter>;
  /**
   * how to order `DailyInspectionPunchList` records
   *
   * executed in the order they are defined
   */
  orderBy?: InputMaybe<Array<OrderByInput>>;
  /**
   * paginate `DailyInspectionPunchList` records
   *
   * using `paginate` may require multiple requests to get all possible results,
   * but will give more fine-grain control in the event all records cannot be
   * returned gracefully
   */
  paginate?: InputMaybe<PaginationInput>;
  projectId?: InputMaybe<StringFilter>;
  punchListId?: InputMaybe<StringFilter>;
  reviewStatus?: InputMaybe<StringFilter>;
};

/** response metadata for a list query of DailyInspectionPunchList records */
export type DailyInspectionPunchListListResponse = {
  __typename: 'DailyInspectionPunchListListResponse';
  /** the total count of DailyInspectionPunchList records matching any configured filters */
  count: Scalars['Int'];
  /** the total count of paginated groups of DailyInspectionPunchList */
  pages: Scalars['Int'];
  /** DailyInspectionPunchList records */
  records: Array<DailyInspectionPunchList>;
};

export type DailyInspectionWorkType = {
  __typename: 'DailyInspectionWorkType';
  /** the date this record was inserted into the database */
  createdDate: Maybe<Scalars['DateTime']>;
  /** the username or email address of a mobile app user associated with the `createdDate` */
  createdUser: Maybe<Scalars['String']>;
  dailyInspectionControlPoints: Array<DailyInspectionControlPoint>;
  dailyInspectionForms: Array<DailyInspectionForm>;
  dailyInspectionInspections: Array<DailyInspectionInspection>;
  dailyInspectionPunchLists: Array<DailyInspectionPunchList>;
  deleted: Maybe<Scalars['String']>;
  /** a GUID used to globally identify this record in the database */
  globalId: Scalars['String'];
  inspectionSuggestions: Maybe<Scalars['String']>;
  /** the date this record was last updated in the database */
  lastEditedDate: Maybe<Scalars['DateTime']>;
  /** the username or email address of a mobile app user associated with the `lastEditedDate` */
  lastEditedUser: Maybe<Scalars['String']>;
  name: Maybe<Scalars['String']>;
  /** a related `Project` */
  project: Maybe<Project>;
  /** the `globalId` of a related `Project` */
  projectId: Maybe<Scalars['String']>;
  reportType: Maybe<Scalars['Int']>;
  shortName: Maybe<Scalars['String']>;
  testingSuggestions: Maybe<Scalars['String']>;
  /** `workTypeGuid` is unreliable, a misnomer, every record contains `null` values, or its purpose is generally unknown */
  workTypeGuid: Maybe<Scalars['String']>;
};


export type DailyInspectionWorkTypeDailyInspectionControlPointsArgs = {
  dailyInspectionControlPointFieldInput?: InputMaybe<DailyInspectionControlPointFieldInput>;
};


export type DailyInspectionWorkTypeDailyInspectionFormsArgs = {
  dailyInspectionFormFieldInput?: InputMaybe<DailyInspectionFormFieldInput>;
};


export type DailyInspectionWorkTypeDailyInspectionInspectionsArgs = {
  dailyInspectionInspectionFieldInput?: InputMaybe<DailyInspectionInspectionFieldInput>;
};


export type DailyInspectionWorkTypeDailyInspectionPunchListsArgs = {
  dailyInspectionPunchListFieldInput?: InputMaybe<DailyInspectionPunchListFieldInput>;
};

/**
 * helps filter multiple `DailyInspectionWorkType` records
 *
 * this version of the input will have limited options compared to its other counterpart
 */
export type DailyInspectionWorkTypeFieldInput = {
  createdDate?: InputMaybe<DateTimeFilter>;
  /**
   * determines now to handle deleted `DailyInspectionWorkType` records
   *
   * - when `true`, only return deleted records
   * - when `false`, do not return deleted records
   * - when omitted, `deleted` is ignored
   */
  deleted?: InputMaybe<Scalars['Boolean']>;
  lastEditedDate?: InputMaybe<DateTimeFilter>;
  name?: InputMaybe<StringFilter>;
  /**
   * how to order `DailyInspectionWorkType` records
   *
   * executed in the order they are defined
   */
  orderBy?: InputMaybe<Array<OrderByInput>>;
  projectId?: InputMaybe<StringFilter>;
  /**
   * specifies how many records to return
   *
   * analogous to `limit`, `first`, or `top` in SQL dialects
   */
  take?: InputMaybe<Scalars['Int']>;
};

/** helps filter multiple `DailyInspectionWorkType` records */
export type DailyInspectionWorkTypeListInput = {
  createdDate?: InputMaybe<DateTimeFilter>;
  /**
   * determines now to handle deleted `DailyInspectionWorkType` records
   *
   * - when `true`, only return deleted records
   * - when `false`, do not return deleted records
   * - when omitted, `deleted` is ignored
   */
  deleted?: InputMaybe<Scalars['Boolean']>;
  lastEditedDate?: InputMaybe<DateTimeFilter>;
  name?: InputMaybe<StringFilter>;
  /**
   * how to order `DailyInspectionWorkType` records
   *
   * executed in the order they are defined
   */
  orderBy?: InputMaybe<Array<OrderByInput>>;
  /**
   * paginate `DailyInspectionWorkType` records
   *
   * using `paginate` may require multiple requests to get all possible results,
   * but will give more fine-grain control in the event all records cannot be
   * returned gracefully
   */
  paginate?: InputMaybe<PaginationInput>;
  projectId?: InputMaybe<StringFilter>;
};

/** response metadata for a list query of DailyInspectionWorkType records */
export type DailyInspectionWorkTypeListResponse = {
  __typename: 'DailyInspectionWorkTypeListResponse';
  /** the total count of DailyInspectionWorkType records matching any configured filters */
  count: Scalars['Int'];
  /** the total count of paginated groups of DailyInspectionWorkType */
  pages: Scalars['Int'];
  /** DailyInspectionWorkType records */
  records: Array<DailyInspectionWorkType>;
};

/** A date selector */
export type DateCustomFieldValue = {
  __typename: 'DateCustomFieldValue';
  /** the date this record was inserted into the database */
  createdDate: Scalars['DateTime'];
  /**
   * the email address of a user associated with the `createdDate`
   *
   * this value will be `unknown` if the `createdDate` was not set by a user
   */
  createdUser: Scalars['String'];
  customField: CustomField;
  /** the `id` of a related `CustomField` */
  customFieldId: Scalars['String'];
  /** the date this record was soft-deleted in the database */
  deletedDate: Maybe<Scalars['DateTime']>;
  /**
   * the email address of a user associated with the `deletedDate`
   *
   * this value will be `system` if the `deletedDate` was not set by a user
   */
  deletedUser: Maybe<Scalars['String']>;
  /** the date this record was last updated in the database */
  lastEditedDate: Scalars['DateTime'];
  /**
   * the email address of a user associated with the `lastEditedDate`
   *
   * this value will be `system` if the `lastEditedDate` was not set by a user
   */
  lastEditedUser: Scalars['String'];
  /** a DateTime value */
  value: Maybe<Scalars['DateTime']>;
};

export type DateRange = {
  __typename: 'DateRange';
  /**
   * the end of the range
   *
   * values are rounded up to 23:59:59
   */
  from: Scalars['DateTime'];
  /**
   * the end of the range
   *
   * values are rounded up to 23:59:59
   */
  to: Scalars['DateTime'];
};

/**
 * filter options for `DateTime` values
 *
 * values are assumed to be valid [string representations](https://tc39.es/ecma262/#sec-date-time-string-format) of JavaScript `Date` objects
 *
 * only one filter will be active at a time
 *
 * filters are preferred in the following order
 *
 * - equals
 * - between
 * - lastNumDays
 * - greaterThan
 * - lessThan
 * - list
 * - null
 */
export type DateTimeFilter = {
  /** the field value is greater than `between.from` and less than `between.to` */
  between?: InputMaybe<DateTimeFilterBetweenInput>;
  /** the supplied value, without its time portion, is equal to the field value, without its time portion */
  equals?: InputMaybe<Scalars['DateTime']>;
  /**
   * the supplied value, without its time portion, is greater than the field value
   *
   * analogous to `between.from`
   */
  greaterThan?: InputMaybe<Scalars['DateTime']>;
  /**
   * how many days before this moment to include
   *
   * for example
   *
   * - use 365 to get records from 365 days ago until now
   * - use 0.0412 to get records from an hour ago until now (1/24)
   */
  lastNumDays?: InputMaybe<Scalars['Float']>;
  /**
   * the supplied value, without its time portion, is less than the field value
   *
   * analogous to `between.to`
   */
  lessThan?: InputMaybe<Scalars['DateTime']>;
  /** possible values, without their time portions, of the field value, without its time portion */
  list?: InputMaybe<Array<Scalars['String']>>;
  /**
   * filters based on the nullability of the field
   *
   * - if true: return records where the field value is null
   * - if false: return records where the field value is not null
   */
  null?: InputMaybe<Scalars['Boolean']>;
};

/** allows for date range configurations */
export type DateTimeFilterBetweenInput = {
  /**
   * the start of the range
   *
   * values are rounded down to 00:00:00
   */
  from: Scalars['DateTime'];
  /**
   * the end of the range
   *
   * values are rounded up to 23:59:59
   */
  to: Scalars['DateTime'];
};

export type DensityTest = {
  __typename: 'DensityTest';
  alignment: Maybe<Scalars['String']>;
  archiveDate: Maybe<Scalars['DateTime']>;
  archiveUser: Maybe<Scalars['String']>;
  archived: Maybe<Scalars['String']>;
  averageDryDensity: Maybe<Scalars['Float']>;
  averageFieldMoisture: Maybe<Scalars['Float']>;
  averagePercent: Maybe<Scalars['Float']>;
  closed: Maybe<Scalars['DateTime']>;
  /** the date this record was inserted into the database */
  createdDate: Maybe<Scalars['DateTime']>;
  /** the username or email address of a mobile app user associated with the `createdDate` */
  createdUser: Maybe<Scalars['String']>;
  cwWorkOrderId: Maybe<Scalars['String']>;
  dailyDensityCounts: Maybe<Scalars['Int']>;
  dailyMoistureCounts: Maybe<Scalars['Int']>;
  dateTestCreated: Maybe<Scalars['DateTime']>;
  deleted: Maybe<Scalars['String']>;
  duplicateRetestId: Maybe<Scalars['String']>;
  genericPlacement: Maybe<GenericPlacement>;
  /** the `globalId` of a related `GenericPlacement` */
  genericPlacementGuid: Maybe<Scalars['String']>;
  /** a GUID used to globally identify this record in the database */
  globalId: Scalars['String'];
  guageNumber: Maybe<Scalars['String']>;
  identifiedFieldIssue: Maybe<IdentifiedFieldIssue>;
  issueToReports: Array<IssueToReport>;
  /** the date this record was last updated in the database */
  lastEditedDate: Maybe<Scalars['DateTime']>;
  /** the username or email address of a mobile app user associated with the `lastEditedDate` */
  lastEditedUser: Maybe<Scalars['String']>;
  liftNumber: Maybe<Scalars['Int']>;
  liftThicknessIn: Maybe<Scalars['Int']>;
  localOptimumMoisture: Maybe<Scalars['Float']>;
  localProctorValue: Maybe<Scalars['Float']>;
  localT99OrT180: Maybe<Scalars['String']>;
  lot: Maybe<Lot>;
  /** the `globalId` of a related `Lot` */
  lotGuid: Maybe<Scalars['String']>;
  materialSource: Maybe<MaterialSource>;
  /** the `globalId` of a related `MaterialSource` */
  materialSourceGuid: Maybe<Scalars['String']>;
  materialSourceOverride: Maybe<Scalars['String']>;
  offset: Maybe<Scalars['String']>;
  offsetRandom: Maybe<Scalars['Float']>;
  overrideComments: Maybe<Scalars['String']>;
  overrideDate: Maybe<Scalars['DateTime']>;
  overrideStatus: Maybe<Scalars['String']>;
  overrideUser: Maybe<Scalars['String']>;
  proctor: Maybe<Proctor>;
  /** the `globalId` of a related `Proctor` */
  proctorGuid: Maybe<Scalars['String']>;
  proctorManualOverride: Maybe<Scalars['String']>;
  /** a related `Project` */
  project: Maybe<Project>;
  /** the `globalId` of a related `Project` */
  projectId: Maybe<Scalars['String']>;
  random: Maybe<Scalars['String']>;
  reading1s: Array<Reading1>;
  remarks: Maybe<Scalars['String']>;
  renderInfo: Maybe<Scalars['String']>;
  reopen: Maybe<Scalars['DateTime']>;
  retestId: Maybe<Scalars['String']>;
  shape: Maybe<Scalars['String']>;
  station: Maybe<Scalars['String']>;
  stationingRandom: Maybe<Scalars['Float']>;
  status: Maybe<Scalars['String']>;
  technician: Maybe<Technician>;
  /** the `globalId` of a related `Technician` */
  technicianGuid: Maybe<Scalars['String']>;
  testId: Maybe<Scalars['String']>;
  truckNumber: Maybe<Scalars['Int']>;
};


export type DensityTestIssueToReportsArgs = {
  issueToReportFieldInput?: InputMaybe<IssueToReportFieldInput>;
};


export type DensityTestReading1sArgs = {
  reading1FieldInput?: InputMaybe<Reading1FieldInput>;
};

/**
 * helps filter multiple `DensityTest` records
 *
 * this version of the input will have limited options compared to its other counterpart
 */
export type DensityTestFieldInput = {
  createdDate?: InputMaybe<DateTimeFilter>;
  /**
   * determines now to handle deleted `DensityTest` records
   *
   * - when `true`, only return deleted records
   * - when `false`, do not return deleted records
   * - when omitted, `deleted` is ignored
   */
  deleted?: InputMaybe<Scalars['Boolean']>;
  lastEditedDate?: InputMaybe<DateTimeFilter>;
  /**
   * how to order `DensityTest` records
   *
   * executed in the order they are defined
   */
  orderBy?: InputMaybe<Array<OrderByInput>>;
  projectId?: InputMaybe<StringFilter>;
  /**
   * specifies how many records to return
   *
   * analogous to `limit`, `first`, or `top` in SQL dialects
   */
  take?: InputMaybe<Scalars['Int']>;
  testId?: InputMaybe<StringFilter>;
};

export type DensityTestIfiSettings = {
  __typename: 'DensityTestIFISettings';
  /** the date this record was inserted into the database */
  createdDate: Scalars['DateTime'];
  /**
   * the email address of a user associated with the `createdDate`
   *
   * this value will be `unknown` if the `createdDate` was not set by a user
   */
  createdUser: Scalars['String'];
  effectiveDate: Maybe<Scalars['DateTime']>;
  enabled: Scalars['Boolean'];
  /** the date this record was last updated in the database */
  lastEditedDate: Scalars['DateTime'];
  /**
   * the email address of a user associated with the `lastEditedDate`
   *
   * this value will be `system` if the `lastEditedDate` was not set by a user
   */
  lastEditedUser: Scalars['String'];
  message: Maybe<Scalars['String']>;
  /** a related `Project` */
  project: Project;
  /** the `globalId` of a related `Project` */
  projectId: Scalars['String'];
};

/** helps filter multiple `DensityTestIFISettings` records */
export type DensityTestIfiSettingsListInput = {
  /**
   * determines now to handle deleted `DensityTestIFISettings` records
   *
   * - when `true`, only return deleted records
   * - when `false`, do not return deleted records
   * - when omitted, `deleted` is ignored
   */
  deleted?: InputMaybe<Scalars['Boolean']>;
  effectiveDate?: InputMaybe<DateTimeFilter>;
  /**
   * how to order `DensityTestIFISettings` records
   *
   * executed in the order they are defined
   */
  orderBy?: InputMaybe<Array<OrderByInput>>;
  /**
   * paginate `DensityTestIFISettings` records
   *
   * using `paginate` may require multiple requests to get all possible results,
   * but will give more fine-grain control in the event all records cannot be
   * returned gracefully
   */
  paginate?: InputMaybe<PaginationInput>;
  projectId?: InputMaybe<StringFilter>;
};

/** response metadata for a list query of DensityTestIFISettings records */
export type DensityTestIfiSettingsListResponse = {
  __typename: 'DensityTestIFISettingsListResponse';
  /** the total count of DensityTestIFISettings records matching any configured filters */
  count: Scalars['Int'];
  /** the total count of paginated groups of DensityTestIFISettings */
  pages: Scalars['Int'];
  /** DensityTestIFISettings records */
  records: Array<DensityTestIfiSettings>;
};

/** helps filter multiple `DensityTest` records */
export type DensityTestListInput = {
  createdDate?: InputMaybe<DateTimeFilter>;
  /**
   * determines now to handle deleted `DensityTest` records
   *
   * - when `true`, only return deleted records
   * - when `false`, do not return deleted records
   * - when omitted, `deleted` is ignored
   */
  deleted?: InputMaybe<Scalars['Boolean']>;
  lastEditedDate?: InputMaybe<DateTimeFilter>;
  /**
   * how to order `DensityTest` records
   *
   * executed in the order they are defined
   */
  orderBy?: InputMaybe<Array<OrderByInput>>;
  /**
   * paginate `DensityTest` records
   *
   * using `paginate` may require multiple requests to get all possible results,
   * but will give more fine-grain control in the event all records cannot be
   * returned gracefully
   */
  paginate?: InputMaybe<PaginationInput>;
  projectId?: InputMaybe<StringFilter>;
  testId?: InputMaybe<StringFilter>;
};

/** response metadata for a list query of DensityTest records */
export type DensityTestListResponse = {
  __typename: 'DensityTestListResponse';
  /** the total count of DensityTest records matching any configured filters */
  count: Scalars['Int'];
  /** the total count of paginated groups of DensityTest */
  pages: Scalars['Int'];
  /** DensityTest records */
  records: Array<DensityTest>;
};

export type DesignSubmittal = {
  __typename: 'DesignSubmittal';
  actions: Array<DsAction>;
  comments: Array<DsComment>;
  contractDueDate: Maybe<Scalars['DateTime']>;
  /** the date this record was inserted into the database */
  createdDate: Scalars['DateTime'];
  /**
   * the email address of a user associated with the `createdDate`
   *
   * this value will be `unknown` if the `createdDate` was not set by a user
   */
  createdUser: Scalars['String'];
  /**
   * custom fields are defined, configured, and activated for `ConstructionAdminSubmittal`
   *     records in the Administration module
   *
   *     values are saved and retrieved for each individual `ConstructionAdminSubmittal`
   */
  customFields: CustomFields;
  /** describes whether the record has been soft-deleted or not */
  deleted: Scalars['Boolean'];
  /** the date this record was soft-deleted in the database */
  deletedDate: Maybe<Scalars['DateTime']>;
  /**
   * the email address of a user associated with the `deletedDate`
   *
   * this value will be `system` if the `deletedDate` was not set by a user
   */
  deletedUser: Maybe<Scalars['String']>;
  /**
   * an enum describing the `DesignSubmittalDisposition`
   *
   * possible values: `Rejected`, `Returned with Comments`, `Returned with Comments - No Resubmittal Required`, or `Returned with no Comments`
   */
  disposition: Maybe<Scalars['String']>;
  /** a related `User` which gives the final disposition */
  dispositionBy: Maybe<User>;
  /** the `id` of a related `User` which gives the final disposition */
  dispositionById: Maybe<Scalars['String']>;
  /** a `DateTime` which is associated with the disposition */
  dispositionDate: Maybe<Scalars['DateTime']>;
  dsToDSDisciplines: Array<DsToDsDiscipline>;
  dsToPayItemNoGeometries: Array<DsToPayItemNoGeometry>;
  externalLinks: Array<ExternalLink>;
  fieldDesignChanges: Array<FieldDesignChange>;
  /** a UUID used to globally identify this record in the database */
  id: Scalars['String'];
  /** the date this record was last updated in the database */
  lastEditedDate: Scalars['DateTime'];
  /**
   * the email address of a user associated with the `lastEditedDate`
   *
   * this value will be `system` if the `lastEditedDate` was not set by a user
   */
  lastEditedUser: Scalars['String'];
  organization: DsOrganization;
  /** the `id` of a related `DSOrganization` */
  organizationId: Scalars['String'];
  packageName: Scalars['String'];
  packageNumber: Scalars['String'];
  /** a related `Project` */
  project: Project;
  /** the `globalId` of a related `Project` */
  projectId: Scalars['String'];
  requestedActionDate: Scalars['DateTime'];
  /**
   * a composite field composed
   * of `packageNumber` and `packageName`
   */
  sharePointFolderName: Scalars['String'];
  /** pulls a `SharePointResource` object from SharePoint for the parent folder associated with this `DesignSubmittal` */
  sharePointResource: Maybe<SharePointResource>;
  sharePointResourceId: Maybe<Scalars['String']>;
  sharePointResourceWebUrl: Maybe<Scalars['String']>;
  /**
   * an enum describing the `DesignSubmittalStatus`
   *
   * possible values: `Discipline Action`, `Returned to Design Builder`, `Router Review`, or `Unlocked`
   */
  status: Scalars['String'];
  /** a related `User` which submits the `DesignSubmittal` */
  submittedBy: User;
  /** the `id` of a related `User` which submits the `DesignSubmittal` */
  submittedById: Scalars['String'];
  submittedDate: Scalars['DateTime'];
  type: DsType;
  /** the `id` of a related `DSType` */
  typeId: Scalars['String'];
};


export type DesignSubmittalActionsArgs = {
  dsActionFieldInput?: InputMaybe<DsActionFieldInput>;
};


export type DesignSubmittalCommentsArgs = {
  dsCommentFieldInput?: InputMaybe<DsCommentFieldInput>;
};


export type DesignSubmittalDsToDsDisciplinesArgs = {
  dsToDSDisciplineFieldInput?: InputMaybe<DsToDsDisciplineFieldInput>;
};


export type DesignSubmittalDsToPayItemNoGeometriesArgs = {
  dSToPayItemNoGeometryFieldInput?: InputMaybe<DsToPayItemNoGeometryFieldInput>;
};


export type DesignSubmittalFieldDesignChangesArgs = {
  fieldDesignChangeFieldInput?: InputMaybe<FieldDesignChangeFieldInput>;
};

/**
 * helps filter multiple `DesignSubmittal` records
 *
 * this version of the input will have limited options compared to its other counterpart
 */
export type DesignSubmittalFieldInput = {
  createdDate?: InputMaybe<DateTimeFilter>;
  /**
   * determines now to handle deleted `DesignSubmittal` records
   *
   * - when `true`, only return deleted records
   * - when `false`, do not return deleted records
   * - when omitted, `deleted` is ignored
   */
  deleted?: InputMaybe<Scalars['Boolean']>;
  lastEditedDate?: InputMaybe<DateTimeFilter>;
  /**
   * how to order `DesignSubmittal` records
   *
   * executed in the order they are defined
   */
  orderBy?: InputMaybe<Array<OrderByInput>>;
  packageName?: InputMaybe<StringFilter>;
  packageNumber?: InputMaybe<StringFilter>;
  projectId?: InputMaybe<StringFilter>;
  /**
   * specifies how many records to return
   *
   * analogous to `limit`, `first`, or `top` in SQL dialects
   */
  take?: InputMaybe<Scalars['Int']>;
};

/** helps filter multiple `DesignSubmittal` records */
export type DesignSubmittalListInput = {
  createdDate?: InputMaybe<DateTimeFilter>;
  /**
   * determines now to handle deleted `DesignSubmittal` records
   *
   * - when `true`, only return deleted records
   * - when `false`, do not return deleted records
   * - when omitted, `deleted` is ignored
   */
  deleted?: InputMaybe<Scalars['Boolean']>;
  lastEditedDate?: InputMaybe<DateTimeFilter>;
  /**
   * how to order `DesignSubmittal` records
   *
   * executed in the order they are defined
   */
  orderBy?: InputMaybe<Array<OrderByInput>>;
  packageName?: InputMaybe<StringFilter>;
  packageNumber?: InputMaybe<StringFilter>;
  /**
   * paginate `DesignSubmittal` records
   *
   * using `paginate` may require multiple requests to get all possible results,
   * but will give more fine-grain control in the event all records cannot be
   * returned gracefully
   */
  paginate?: InputMaybe<PaginationInput>;
  projectId?: InputMaybe<StringFilter>;
};

/** response metadata for a list query of DesignSubmittal records */
export type DesignSubmittalListResponse = {
  __typename: 'DesignSubmittalListResponse';
  /** the total count of DesignSubmittal records matching any configured filters */
  count: Scalars['Int'];
  /** the total count of paginated groups of DesignSubmittal */
  pages: Scalars['Int'];
  /** DesignSubmittal records */
  records: Array<DesignSubmittal>;
};

export type DocumentChecklistItem = {
  __typename: 'DocumentChecklistItem';
  /** the date this record was inserted into the database */
  createdDate: Scalars['DateTime'];
  /**
   * the email address of a user associated with the `createdDate`
   *
   * this value will be `unknown` if the `createdDate` was not set by a user
   */
  createdUser: Scalars['String'];
  documentChecklistItemToConcreteMaterials: Array<DocumentChecklistItemToConcreteMaterial>;
  documentChecklistValues: Array<DocumentChecklistValue>;
  /** a unique integer to identify this record in the database table */
  id: Scalars['Int'];
  /** the date this record was last updated in the database */
  lastEditedDate: Scalars['DateTime'];
  /**
   * the email address of a user associated with the `lastEditedDate`
   *
   * this value will be `system` if the `lastEditedDate` was not set by a user
   */
  lastEditedUser: Scalars['String'];
  name: Scalars['String'];
  /** a related `Project` */
  project: Project;
  /** the `globalId` of a related `Project` */
  projectId: Scalars['String'];
};


export type DocumentChecklistItemDocumentChecklistItemToConcreteMaterialsArgs = {
  documentChecklistItemToConcreteMaterialFieldInput?: InputMaybe<DocumentChecklistItemToConcreteMaterialFieldInput>;
};


export type DocumentChecklistItemDocumentChecklistValuesArgs = {
  documentChecklistValueFieldInput?: InputMaybe<DocumentChecklistValueFieldInput>;
};

/**
 * helps filter multiple `DocumentChecklistItem` records
 *
 * this version of the input will have limited options compared to its other counterpart
 */
export type DocumentChecklistItemFieldInput = {
  createdDate?: InputMaybe<DateTimeFilter>;
  lastEditedDate?: InputMaybe<DateTimeFilter>;
  name?: InputMaybe<StringFilter>;
  /**
   * how to order `DocumentChecklistItem` records
   *
   * executed in the order they are defined
   */
  orderBy?: InputMaybe<Array<OrderByInput>>;
  projectId?: InputMaybe<StringFilter>;
  /**
   * specifies how many records to return
   *
   * analogous to `limit`, `first`, or `top` in SQL dialects
   */
  take?: InputMaybe<Scalars['Int']>;
};

/** helps filter multiple `DocumentChecklistItem` records */
export type DocumentChecklistItemListInput = {
  createdDate?: InputMaybe<DateTimeFilter>;
  lastEditedDate?: InputMaybe<DateTimeFilter>;
  name?: InputMaybe<StringFilter>;
  /**
   * how to order `DocumentChecklistItem` records
   *
   * executed in the order they are defined
   */
  orderBy?: InputMaybe<Array<OrderByInput>>;
  /**
   * paginate `DocumentChecklistItem` records
   *
   * using `paginate` may require multiple requests to get all possible results,
   * but will give more fine-grain control in the event all records cannot be
   * returned gracefully
   */
  paginate?: InputMaybe<PaginationInput>;
  projectId?: InputMaybe<StringFilter>;
};

/** response metadata for a list query of DocumentChecklistItem records */
export type DocumentChecklistItemListResponse = {
  __typename: 'DocumentChecklistItemListResponse';
  /** the total count of DocumentChecklistItem records matching any configured filters */
  count: Scalars['Int'];
  /** the total count of paginated groups of DocumentChecklistItem */
  pages: Scalars['Int'];
  /** DocumentChecklistItem records */
  records: Array<DocumentChecklistItem>;
};

/**
 * ### intermediary types
 *
 * DocumentChecklistItemToConcreteMaterial is an intermediary object type to create a many to many relationship between
 * `DocumentChecklistItem` and `ConcreteMaterial`
 *
 * certain object types can only be referenced through a database view or need to facilitate
 * more advanced logic flows
 *
 * this makes it impossible to create a layer of abstraction on top of certain relationships
 */
export type DocumentChecklistItemToConcreteMaterial = {
  __typename: 'DocumentChecklistItemToConcreteMaterial';
  concreteMaterial: ConcreteMaterial;
  /** the `globalId` of a related `ConcreteMaterial` */
  concreteMaterialId: Scalars['String'];
  documentChecklistItem: DocumentChecklistItem;
  /** the `id` of a related `DocumentChecklistItem` */
  documentChecklistItemId: Scalars['Int'];
};

/**
 * helps filter multiple `DocumentChecklistItemToConcreteMaterial` records
 *
 * this version of the input will have limited options compared to its other counterpart
 */
export type DocumentChecklistItemToConcreteMaterialFieldInput = {
  concreteMaterialId?: InputMaybe<StringFilter>;
  documentChecklistItemId?: InputMaybe<IntFilter>;
  /**
   * how to order `DocumentChecklistItemToConcreteMaterial` records
   *
   * executed in the order they are defined
   */
  orderBy?: InputMaybe<Array<OrderByInput>>;
  /**
   * specifies how many records to return
   *
   * analogous to `limit`, `first`, or `top` in SQL dialects
   */
  take?: InputMaybe<Scalars['Int']>;
};

/** helps filter multiple `DocumentChecklistItemToConcreteMaterial` records */
export type DocumentChecklistItemToConcreteMaterialListInput = {
  concreteMaterialId?: InputMaybe<StringFilter>;
  documentChecklistItemId?: InputMaybe<IntFilter>;
  /**
   * how to order `DocumentChecklistItemToConcreteMaterial` records
   *
   * executed in the order they are defined
   */
  orderBy?: InputMaybe<Array<OrderByInput>>;
  /**
   * paginate `DocumentChecklistItemToConcreteMaterial` records
   *
   * using `paginate` may require multiple requests to get all possible results,
   * but will give more fine-grain control in the event all records cannot be
   * returned gracefully
   */
  paginate?: InputMaybe<PaginationInput>;
};

/** response metadata for a list query of DocumentChecklistItemToConcreteMaterial records */
export type DocumentChecklistItemToConcreteMaterialListResponse = {
  __typename: 'DocumentChecklistItemToConcreteMaterialListResponse';
  /** the total count of DocumentChecklistItemToConcreteMaterial records matching any configured filters */
  count: Scalars['Int'];
  /** the total count of paginated groups of DocumentChecklistItemToConcreteMaterial */
  pages: Scalars['Int'];
  /** DocumentChecklistItemToConcreteMaterial records */
  records: Array<DocumentChecklistItemToConcreteMaterial>;
};

/**
 * ### intermediary types
 *
 * DocumentChecklistValue is an intermediary object type to create a many to many relationship between
 * `DocumentChecklistItem` and `ConcreteTestSet`
 *
 * certain object types can only be referenced through a database view or need to facilitate
 * more advanced logic flows
 *
 * this makes it impossible to create a layer of abstraction on top of certain relationships
 */
export type DocumentChecklistValue = {
  __typename: 'DocumentChecklistValue';
  /** whether the `DocumentChecklistItem` has been checked off during a CIMS workflow */
  checked: Scalars['Boolean'];
  concreteTestSet: ConcreteTestSet;
  /** the `globalId` of a related `ConcreteTestSet` */
  concreteTestSetId: Scalars['String'];
  /** the date this record was inserted into the database */
  createdDate: Scalars['DateTime'];
  /**
   * the email address of a user associated with the `createdDate`
   *
   * this value will be `unknown` if the `createdDate` was not set by a user
   */
  createdUser: Scalars['String'];
  documentChecklistItem: DocumentChecklistItem;
  /** the `id` of a related `DocumentChecklistItem` */
  documentChecklistItemId: Scalars['Int'];
  /** the date this record was last updated in the database */
  lastEditedDate: Scalars['DateTime'];
  /**
   * the email address of a user associated with the `lastEditedDate`
   *
   * this value will be `system` if the `lastEditedDate` was not set by a user
   */
  lastEditedUser: Scalars['String'];
};

/**
 * helps filter multiple `DocumentChecklistValue` records
 *
 * this version of the input will have limited options compared to its other counterpart
 */
export type DocumentChecklistValueFieldInput = {
  /**
   * - when `true`, `checked` is truthy
   * - when `false`, `checked` is falsy
   * - when omitted, `checked` is ignored
   */
  checked?: InputMaybe<Scalars['Boolean']>;
  concreteTestSetId?: InputMaybe<StringFilter>;
  createdDate?: InputMaybe<DateTimeFilter>;
  documentChecklistItemId?: InputMaybe<IntFilter>;
  lastEditedDate?: InputMaybe<DateTimeFilter>;
  /**
   * how to order `DocumentChecklistValue` records
   *
   * executed in the order they are defined
   */
  orderBy?: InputMaybe<Array<OrderByInput>>;
  /**
   * specifies how many records to return
   *
   * analogous to `limit`, `first`, or `top` in SQL dialects
   */
  take?: InputMaybe<Scalars['Int']>;
};

/** helps filter multiple `DocumentChecklistValue` records */
export type DocumentChecklistValueListInput = {
  /**
   * - when `true`, `checked` is truthy
   * - when `false`, `checked` is falsy
   * - when omitted, `checked` is ignored
   */
  checked?: InputMaybe<Scalars['Boolean']>;
  concreteTestSetId?: InputMaybe<StringFilter>;
  createdDate?: InputMaybe<DateTimeFilter>;
  documentChecklistItemId?: InputMaybe<IntFilter>;
  lastEditedDate?: InputMaybe<DateTimeFilter>;
  /**
   * how to order `DocumentChecklistValue` records
   *
   * executed in the order they are defined
   */
  orderBy?: InputMaybe<Array<OrderByInput>>;
  /**
   * paginate `DocumentChecklistValue` records
   *
   * using `paginate` may require multiple requests to get all possible results,
   * but will give more fine-grain control in the event all records cannot be
   * returned gracefully
   */
  paginate?: InputMaybe<PaginationInput>;
};

/** response metadata for a list query of DocumentChecklistValue records */
export type DocumentChecklistValueListResponse = {
  __typename: 'DocumentChecklistValueListResponse';
  /** the total count of DocumentChecklistValue records matching any configured filters */
  count: Scalars['Int'];
  /** the total count of paginated groups of DocumentChecklistValue */
  pages: Scalars['Int'];
  /** DocumentChecklistValue records */
  records: Array<DocumentChecklistValue>;
};

export type DraftEngineeringJudgementInput = {
  customFields?: InputMaybe<MutateCustomFieldsInput>;
  externalLinks?: InputMaybe<Array<ExternalLinkInput>>;
  failureDate: Scalars['DateTime'];
  failureDescription?: InputMaybe<Scalars['String']>;
  identifiedFieldIssueId?: InputMaybe<Scalars['String']>;
  justification?: InputMaybe<Scalars['String']>;
  manualReportId?: InputMaybe<Scalars['String']>;
  notes?: InputMaybe<Scalars['String']>;
  payItemIds?: InputMaybe<Array<Scalars['String']>>;
  projectId: Scalars['String'];
  reports?: InputMaybe<Array<MutateEjToReportInput>>;
  typeId: Scalars['String'];
};

export type DraftEngineeringJudgementResponse = {
  __typename: 'DraftEngineeringJudgementResponse';
  judgement: EngineeringJudgement;
};

export type DraftFieldDesignChangeInput = {
  concurrenceLevelId?: InputMaybe<Scalars['String']>;
  customFields?: InputMaybe<MutateCustomFieldsInput>;
  disciplineIds?: InputMaybe<Array<Scalars['String']>>;
  drawingsAffected?: InputMaybe<Scalars['String']>;
  externalLinks?: InputMaybe<Array<ExternalLinkInput>>;
  issue: Scalars['String'];
  location?: InputMaybe<Scalars['String']>;
  number?: InputMaybe<Scalars['String']>;
  payItemIds?: InputMaybe<Array<Scalars['String']>>;
  projectId: Scalars['String'];
  requestedApprovalDate?: InputMaybe<Scalars['DateTime']>;
  resolution?: InputMaybe<Scalars['String']>;
  specsAffected?: InputMaybe<Scalars['String']>;
};

export type DraftFieldDesignChangeResponse = {
  __typename: 'DraftFieldDesignChangeResponse';
  fieldDesignChange: FieldDesignChange;
};

export type DraftIssueInput = {
  customFields?: InputMaybe<MutateCustomFieldsInput>;
  description?: InputMaybe<Scalars['String']>;
  externalLinks?: InputMaybe<Array<ExternalLinkInput>>;
  id?: InputMaybe<Scalars['String']>;
  identifiedFieldIssueId?: InputMaybe<Scalars['String']>;
  number?: InputMaybe<Scalars['String']>;
  payItemIds: Array<Scalars['String']>;
  projectId?: InputMaybe<Scalars['String']>;
  reports?: InputMaybe<Array<MutateIssueToReportInput>>;
  typeIds: Array<Scalars['String']>;
};

export type DraftIssueResponse = {
  __typename: 'DraftIssueResponse';
  issue: Issue;
};

export type DraftRequestForInformationInput = {
  customFields?: InputMaybe<MutateCustomFieldsInput>;
  description: Scalars['String'];
  externalLinks?: InputMaybe<Array<ExternalLinkInput>>;
  number?: InputMaybe<Scalars['String']>;
  organizationId?: InputMaybe<Scalars['String']>;
  projectId: Scalars['String'];
  requestedResponseDate?: InputMaybe<Scalars['DateTime']>;
  responseDisciplineIds?: InputMaybe<Array<Scalars['String']>>;
};

export type DraftRequestForInformationResponse = {
  __typename: 'DraftRequestForInformationResponse';
  requestForInformation: RequestForInformation;
};

/**
 * notifications hold a recipients configuration for a given
 * notification event in EJ Tracker workflows
 *
 * recipients can be users, or non user emails
 *
 * certain events may require users to receive a notification if they are given permission
 * to perform a specific task
 */
export type EjNotification = {
  __typename: 'EJNotification';
  /** the date this record was inserted into the database */
  createdDate: Scalars['DateTime'];
  /**
   * the email address of a user associated with the `createdDate`
   *
   * this value will be `unknown` if the `createdDate` was not set by a user
   */
  createdUser: Scalars['String'];
  /** the date this record was last updated in the database */
  lastEditedDate: Scalars['DateTime'];
  /**
   * the email address of a user associated with the `lastEditedDate`
   *
   * this value will be `system` if the `lastEditedDate` was not set by a user
   */
  lastEditedUser: Scalars['String'];
  /** the name of the notification event associated with this Notification */
  notificationEvent: Scalars['String'];
  notificationEventId: Scalars['String'];
  /** a related `Project` */
  project: Project;
  /** the `globalId` of a related `Project` */
  projectId: Scalars['String'];
  recipients: EjNotificationRecipients;
};

/**
 * helps filter multiple `EJNotification` records
 *
 * this version of the input will have limited options compared to its other counterpart
 */
export type EjNotificationFieldInput = {
  createdDate?: InputMaybe<DateTimeFilter>;
  lastEditedDate?: InputMaybe<DateTimeFilter>;
  notificationEventId?: InputMaybe<StringFilter>;
  /**
   * how to order `EJNotification` records
   *
   * executed in the order they are defined
   */
  orderBy?: InputMaybe<Array<OrderByInput>>;
  projectId?: InputMaybe<StringFilter>;
  /**
   * specifies how many records to return
   *
   * analogous to `limit`, `first`, or `top` in SQL dialects
   */
  take?: InputMaybe<Scalars['Int']>;
};

/** helps filter multiple `EJNotification` records */
export type EjNotificationListInput = {
  createdDate?: InputMaybe<DateTimeFilter>;
  lastEditedDate?: InputMaybe<DateTimeFilter>;
  notificationEventId?: InputMaybe<StringFilter>;
  /**
   * how to order `EJNotification` records
   *
   * executed in the order they are defined
   */
  orderBy?: InputMaybe<Array<OrderByInput>>;
  /**
   * paginate `EJNotification` records
   *
   * using `paginate` may require multiple requests to get all possible results,
   * but will give more fine-grain control in the event all records cannot be
   * returned gracefully
   */
  paginate?: InputMaybe<PaginationInput>;
  projectId?: InputMaybe<StringFilter>;
};

/** response metadata for a list query of EJNotification records */
export type EjNotificationListResponse = {
  __typename: 'EJNotificationListResponse';
  /** the total count of EJNotification records matching any configured filters */
  count: Scalars['Int'];
  /** the total count of paginated groups of EJNotification */
  pages: Scalars['Int'];
  /** EJNotification records */
  records: Array<EjNotification>;
};

export type EjNotificationRecipients = {
  __typename: 'EJNotificationRecipients';
  every: Maybe<Recipients>;
};

/**
 * `EJQuickLink` records are used in the External Link Editor to allow users
 * to quickly add external links to the `externalLinks` field of a `EngineeringJudgement`
 *
 * `EJQuickLink` records used in `externalLinks` are not referenced by `id`, but copied
 * as they are currently defined
 *
 * changes made to any `EJQuickLink` record will not affect the `externalLinks` of the `EngineeringJudgement`
 */
export type EjQuickLink = {
  __typename: 'EJQuickLink';
  /** the date this record was inserted into the database */
  createdDate: Scalars['DateTime'];
  /**
   * the email address of a user associated with the `createdDate`
   *
   * this value will be `unknown` if the `createdDate` was not set by a user
   */
  createdUser: Scalars['String'];
  /** describes whether the record has been soft-deleted or not */
  deleted: Scalars['Boolean'];
  /** the date this record was soft-deleted in the database */
  deletedDate: Maybe<Scalars['DateTime']>;
  /**
   * the email address of a user associated with the `deletedDate`
   *
   * this value will be `system` if the `deletedDate` was not set by a user
   */
  deletedUser: Maybe<Scalars['String']>;
  /**
   * an extended description associated with the record
   *
   * this description will be used to describe the record in CIMS, where possible
   */
  description: Maybe<Scalars['String']>;
  /** an optional link associated with the `label` */
  href: Maybe<Scalars['String']>;
  /** a UUID used to globally identify this record in the database */
  id: Scalars['String'];
  /** the human readable link text */
  label: Scalars['String'];
  /** the date this record was last updated in the database */
  lastEditedDate: Scalars['DateTime'];
  /**
   * the email address of a user associated with the `lastEditedDate`
   *
   * this value will be `system` if the `lastEditedDate` was not set by a user
   */
  lastEditedUser: Scalars['String'];
  project: Project;
  /** the `globalId` of a related `Project` */
  projectId: Scalars['String'];
};

/**
 * helps filter multiple `EJQuickLink` records
 *
 * this version of the input will have limited options compared to its other counterpart
 */
export type EjQuickLinkFieldInput = {
  createdDate?: InputMaybe<DateTimeFilter>;
  /**
   * determines now to handle deleted `EJQuickLink` records
   *
   * - when `true`, only return deleted records
   * - when `false`, do not return deleted records
   * - when omitted, `deleted` is ignored
   */
  deleted?: InputMaybe<Scalars['Boolean']>;
  description?: InputMaybe<StringFilter>;
  href?: InputMaybe<StringFilter>;
  id?: InputMaybe<StringFilter>;
  label?: InputMaybe<StringFilter>;
  lastEditedDate?: InputMaybe<DateTimeFilter>;
  /**
   * how to order `EJQuickLink` records
   *
   * executed in the order they are defined
   */
  orderBy?: InputMaybe<Array<OrderByInput>>;
  projectId?: InputMaybe<StringFilter>;
  /**
   * specifies how many records to return
   *
   * analogous to `limit`, `first`, or `top` in SQL dialects
   */
  take?: InputMaybe<Scalars['Int']>;
};

/** helps filter multiple `EJQuickLink` records */
export type EjQuickLinkListInput = {
  createdDate?: InputMaybe<DateTimeFilter>;
  /**
   * determines now to handle deleted `EJQuickLink` records
   *
   * - when `true`, only return deleted records
   * - when `false`, do not return deleted records
   * - when omitted, `deleted` is ignored
   */
  deleted?: InputMaybe<Scalars['Boolean']>;
  description?: InputMaybe<StringFilter>;
  href?: InputMaybe<StringFilter>;
  id?: InputMaybe<StringFilter>;
  label?: InputMaybe<StringFilter>;
  lastEditedDate?: InputMaybe<DateTimeFilter>;
  /**
   * how to order `EJQuickLink` records
   *
   * executed in the order they are defined
   */
  orderBy?: InputMaybe<Array<OrderByInput>>;
  /**
   * paginate `EJQuickLink` records
   *
   * using `paginate` may require multiple requests to get all possible results,
   * but will give more fine-grain control in the event all records cannot be
   * returned gracefully
   */
  paginate?: InputMaybe<PaginationInput>;
  projectId?: InputMaybe<StringFilter>;
};

/** response metadata for a list query of EJQuickLink records */
export type EjQuickLinkListResponse = {
  __typename: 'EJQuickLinkListResponse';
  /** the total count of EJQuickLink records matching any configured filters */
  count: Scalars['Int'];
  /** the total count of paginated groups of EJQuickLink */
  pages: Scalars['Int'];
  /** EJQuickLink records */
  records: Array<EjQuickLink>;
};

/** `EJToPayItemNoGeometry` helps connect many `EngineeringJudgement` records with many `PayItemNoGeometry` records */
export type EjToPayItemNoGeometry = {
  __typename: 'EJToPayItemNoGeometry';
  judgement: EngineeringJudgement;
  /** the `id` of a related `EngineeringJudgement` */
  judgementId: Scalars['String'];
  payItem: PayItemNoGeometry;
  /** the `globalId` of a related `PayItemNoGeometry` */
  payItemId: Scalars['String'];
};

/**
 * helps filter multiple `EJToPayItemNoGeometry` records
 *
 * this version of the input will have limited options compared to its other counterpart
 */
export type EjToPayItemNoGeometryFieldInput = {
  judgementId?: InputMaybe<StringFilter>;
  /**
   * how to order `EJToPayItemNoGeometry` records
   *
   * executed in the order they are defined
   */
  orderBy?: InputMaybe<Array<OrderByInput>>;
  payItemId?: InputMaybe<StringFilter>;
  /**
   * specifies how many records to return
   *
   * analogous to `limit`, `first`, or `top` in SQL dialects
   */
  take?: InputMaybe<Scalars['Int']>;
};

/** helps filter multiple `EJToPayItemNoGeometry` records */
export type EjToPayItemNoGeometryListInput = {
  judgementId?: InputMaybe<StringFilter>;
  /**
   * how to order `EJToPayItemNoGeometry` records
   *
   * executed in the order they are defined
   */
  orderBy?: InputMaybe<Array<OrderByInput>>;
  /**
   * paginate `EJToPayItemNoGeometry` records
   *
   * using `paginate` may require multiple requests to get all possible results,
   * but will give more fine-grain control in the event all records cannot be
   * returned gracefully
   */
  paginate?: InputMaybe<PaginationInput>;
  payItemId?: InputMaybe<StringFilter>;
};

/** response metadata for a list query of EJToPayItemNoGeometry records */
export type EjToPayItemNoGeometryListResponse = {
  __typename: 'EJToPayItemNoGeometryListResponse';
  /** the total count of EJToPayItemNoGeometry records matching any configured filters */
  count: Scalars['Int'];
  /** the total count of paginated groups of EJToPayItemNoGeometry */
  pages: Scalars['Int'];
  /** EJToPayItemNoGeometry records */
  records: Array<EjToPayItemNoGeometry>;
};

export type EjToReport = {
  __typename: 'EJToReport';
  concretePlacement: Maybe<ConcretePlacement>;
  concreteTest: Maybe<ConcreteTest>;
  dailyInspectionControlPoint: Maybe<DailyInspectionControlPoint>;
  dailyInspectionInspection: Maybe<DailyInspectionInspection>;
  ejId: Scalars['String'];
  lot: Maybe<Lot>;
  reportId: Scalars['String'];
  reportType: Scalars['String'];
  reportTypeId: Scalars['String'];
};

/**
 * helps filter multiple `EJToReport` records
 *
 * this version of the input will have limited options compared to its other counterpart
 */
export type EjToReportFieldInput = {
  ejId?: InputMaybe<StringFilter>;
  /**
   * how to order `EJToReport` records
   *
   * executed in the order they are defined
   */
  orderBy?: InputMaybe<Array<OrderByInput>>;
  reportId?: InputMaybe<StringFilter>;
  reportTypeId?: InputMaybe<StringFilter>;
  /**
   * specifies how many records to return
   *
   * analogous to `limit`, `first`, or `top` in SQL dialects
   */
  take?: InputMaybe<Scalars['Int']>;
};

/** helps filter multiple `EJToReport` records */
export type EjToReportListInput = {
  ejId?: InputMaybe<StringFilter>;
  /**
   * how to order `EJToReport` records
   *
   * executed in the order they are defined
   */
  orderBy?: InputMaybe<Array<OrderByInput>>;
  /**
   * paginate `EJToReport` records
   *
   * using `paginate` may require multiple requests to get all possible results,
   * but will give more fine-grain control in the event all records cannot be
   * returned gracefully
   */
  paginate?: InputMaybe<PaginationInput>;
  reportId?: InputMaybe<StringFilter>;
  reportTypeId?: InputMaybe<StringFilter>;
};

/** response metadata for a list query of EJToReport records */
export type EjToReportListResponse = {
  __typename: 'EJToReportListResponse';
  /** the total count of EJToReport records matching any configured filters */
  count: Scalars['Int'];
  /** the total count of paginated groups of EJToReport */
  pages: Scalars['Int'];
  /** EJToReport records */
  records: Array<EjToReport>;
};

export type EjType = {
  __typename: 'EJType';
  /** limited to 4000 characters */
  allowanceDescription: Scalars['String'];
  /** the date this record was inserted into the database */
  createdDate: Scalars['DateTime'];
  /**
   * the email address of a user associated with the `createdDate`
   *
   * this value will be `unknown` if the `createdDate` was not set by a user
   */
  createdUser: Scalars['String'];
  /** describes whether the record has been soft-deleted or not */
  deleted: Scalars['Boolean'];
  /** the date this record was soft-deleted in the database */
  deletedDate: Maybe<Scalars['DateTime']>;
  /**
   * the email address of a user associated with the `deletedDate`
   *
   * this value will be `system` if the `deletedDate` was not set by a user
   */
  deletedUser: Maybe<Scalars['String']>;
  /** a UUID used to globally identify this record in the database */
  id: Scalars['String'];
  judgements: Array<EngineeringJudgement>;
  /** the date this record was last updated in the database */
  lastEditedDate: Scalars['DateTime'];
  /**
   * the email address of a user associated with the `lastEditedDate`
   *
   * this value will be `system` if the `lastEditedDate` was not set by a user
   */
  lastEditedUser: Scalars['String'];
  /** a human readable name associated with the record */
  name: Scalars['String'];
  /** a related `Project` */
  project: Project;
  /** the `globalId` of a related `Project` */
  projectId: Scalars['String'];
  reportTypeId: Maybe<Scalars['String']>;
  users: Array<User>;
};


export type EjTypeJudgementsArgs = {
  engineeringJudgementFieldInput?: InputMaybe<EngineeringJudgementFieldInput>;
};


export type EjTypeUsersArgs = {
  userFieldInput?: InputMaybe<UserFieldInput>;
};

/**
 * helps filter multiple `EJType` records
 *
 * this version of the input will have limited options compared to its other counterpart
 */
export type EjTypeFieldInput = {
  createdDate?: InputMaybe<DateTimeFilter>;
  /**
   * determines now to handle deleted `EJType` records
   *
   * - when `true`, only return deleted records
   * - when `false`, do not return deleted records
   * - when omitted, `deleted` is ignored
   */
  deleted?: InputMaybe<Scalars['Boolean']>;
  lastEditedDate?: InputMaybe<DateTimeFilter>;
  name?: InputMaybe<StringFilter>;
  /**
   * how to order `EJType` records
   *
   * executed in the order they are defined
   */
  orderBy?: InputMaybe<Array<OrderByInput>>;
  projectId?: InputMaybe<StringFilter>;
  reportTypeId?: InputMaybe<StringFilter>;
  /**
   * specifies how many records to return
   *
   * analogous to `limit`, `first`, or `top` in SQL dialects
   */
  take?: InputMaybe<Scalars['Int']>;
};

/** helps filter multiple `EJType` records */
export type EjTypeListInput = {
  createdDate?: InputMaybe<DateTimeFilter>;
  /**
   * determines now to handle deleted `EJType` records
   *
   * - when `true`, only return deleted records
   * - when `false`, do not return deleted records
   * - when omitted, `deleted` is ignored
   */
  deleted?: InputMaybe<Scalars['Boolean']>;
  lastEditedDate?: InputMaybe<DateTimeFilter>;
  name?: InputMaybe<StringFilter>;
  /**
   * how to order `EJType` records
   *
   * executed in the order they are defined
   */
  orderBy?: InputMaybe<Array<OrderByInput>>;
  /**
   * paginate `EJType` records
   *
   * using `paginate` may require multiple requests to get all possible results,
   * but will give more fine-grain control in the event all records cannot be
   * returned gracefully
   */
  paginate?: InputMaybe<PaginationInput>;
  projectId?: InputMaybe<StringFilter>;
  reportTypeId?: InputMaybe<StringFilter>;
};

/** response metadata for a list query of EJType records */
export type EjTypeListResponse = {
  __typename: 'EJTypeListResponse';
  /** the total count of EJType records matching any configured filters */
  count: Scalars['Int'];
  /** the total count of paginated groups of EJType */
  pages: Scalars['Int'];
  /** EJType records */
  records: Array<EjType>;
};

/** values required to edit an existing `AsphaltMixDesign` objects */
export type EditAsphaltMixDesignInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  bulkSpecGravAgg?: InputMaybe<Scalars['Float']>;
  customFields?: InputMaybe<MutateCustomFieldsInput>;
  designBinderContent?: InputMaybe<Scalars['Float']>;
  expirationDate?: InputMaybe<Scalars['DateTime']>;
  globalId: Scalars['String'];
  grade?: InputMaybe<Scalars['String']>;
  materialSourceId?: InputMaybe<Scalars['String']>;
  maxAggregateSize?: InputMaybe<Scalars['Float']>;
  mixDesignNumber?: InputMaybe<Scalars['String']>;
  nominalSize?: InputMaybe<Scalars['String']>;
  percentages?: InputMaybe<Array<MutateAsphaltMixDesignTargetPercentageInput>>;
  supplier?: InputMaybe<Scalars['String']>;
  theoMaxSpecGrav?: InputMaybe<Scalars['Float']>;
  vma?: InputMaybe<Scalars['Float']>;
};

export type EditAsphaltMixDesignResponse = {
  __typename: 'EditAsphaltMixDesignResponse';
  /** the edited `AsphaltMixDesign` */
  mixDesign: AsphaltMixDesign;
};

/** values required to edit an existing `CASDispositionType` objects */
export type EditCasDispositionTypeInput = {
  description?: InputMaybe<Scalars['String']>;
  id: Scalars['String'];
  name: Scalars['String'];
  requiresComments?: InputMaybe<Scalars['Boolean']>;
};

export type EditCasDispositionTypeResponse = {
  __typename: 'EditCASDispositionTypeResponse';
  /** the edited `CASDispositionType` */
  dispositionType: CasDispositionType;
};

export type EditCasNotificationInput = {
  byRoutingGroup: Array<ByCasRoutingGroupInput>;
  every?: InputMaybe<RecipientsInput>;
  notificationEventId: Scalars['String'];
  /** the `globalId` of a related `Project` */
  projectId: Scalars['String'];
  settings?: InputMaybe<CasNotificationSettingsInput>;
};

export type EditCasNotificationResponse = {
  __typename: 'EditCASNotificationResponse';
  /** the edited `CASNotification` */
  notification: CasNotification;
};

/** values required to edit an existing `CASQuickLink` objects */
export type EditCasQuickLinkInput = {
  description?: InputMaybe<Scalars['String']>;
  href?: InputMaybe<Scalars['String']>;
  id: Scalars['String'];
  label: Scalars['String'];
};

export type EditCasQuickLinkResponse = {
  __typename: 'EditCASQuickLinkResponse';
  /** the edited `CASQuickLink` */
  casQuickLink: CasQuickLink;
};

/** values required to edit an existing `CASRoutingGroup` objects */
export type EditCasRoutingGroupInput = {
  /**
   * an extended description associated with the record
   *
   * this description will be used to describe the record in CIMS, where possible
   */
  description?: InputMaybe<Scalars['String']>;
  id: Scalars['String'];
  /** a human readable name associated with the record */
  name: Scalars['String'];
  userIds?: InputMaybe<Array<Scalars['String']>>;
};

export type EditCasRoutingGroupResponse = {
  __typename: 'EditCASRoutingGroupResponse';
  /** the edited `CASRoutingGroup` */
  routingGroup: CasRoutingGroup;
};

export type EditCasSubtypeInput = {
  description?: InputMaybe<Scalars['String']>;
  id: Scalars['String'];
  name: Scalars['String'];
};

export type EditCasSubtypeResponse = {
  __typename: 'EditCASSubtypeResponse';
  /** the edited `CASSubtype` */
  subtype: CasSubtype;
};

export type EditCasTypeInput = {
  description?: InputMaybe<Scalars['String']>;
  id: Scalars['String'];
  name: Scalars['String'];
};

export type EditCasTypeResponse = {
  __typename: 'EditCASTypeResponse';
  /** the edited `CASType` */
  type: CasType;
};

/** values required to edit an existing `ConcreteMixDesign` objects */
export type EditConcreteMixDesignInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  admixtures?: InputMaybe<Scalars['String']>;
  aggregates?: InputMaybe<Array<Scalars['String']>>;
  airHigh?: InputMaybe<Scalars['Float']>;
  airLow?: InputMaybe<Scalars['Float']>;
  class?: InputMaybe<Scalars['String']>;
  concreteUse?: InputMaybe<Scalars['String']>;
  customFields?: InputMaybe<MutateCustomFieldsInput>;
  expirationDate?: InputMaybe<Scalars['DateTime']>;
  globalId: Scalars['String'];
  materialSource?: InputMaybe<Scalars['String']>;
  maxAggSize?: InputMaybe<Scalars['String']>;
  mixDesignNumber?: InputMaybe<Scalars['String']>;
  slumpHighInches?: InputMaybe<Scalars['Float']>;
  slumpLowInches?: InputMaybe<Scalars['Float']>;
  submittalId?: InputMaybe<Scalars['String']>;
  wc?: InputMaybe<Scalars['String']>;
};

export type EditConcreteMixDesignResponse = {
  __typename: 'EditConcreteMixDesignResponse';
  /** the edited `ConcreteMixDesign` */
  mixDesign: ConcreteMixDesign;
};

export type EditConcreteNotificationInput = {
  /** all concrete test sets with a specific concrete material */
  byConcreteMaterial?: InputMaybe<Array<ByConcreteMaterialInput>>;
  /** all concrete test sets with a specific mix design */
  byConcreteMixDesign?: InputMaybe<Array<ByConcreteMixDesignInput>>;
  every?: InputMaybe<RecipientsInput>;
  notificationEventId: Scalars['String'];
  /** the `globalId` of a related `Project` */
  projectId: Scalars['String'];
};

export type EditConcreteNotificationResponse = {
  __typename: 'EditConcreteNotificationResponse';
  /** the edited `ConcreteNotification` */
  notification: ConcreteNotification;
};

/** values required to edit an existing `ConcreteTestSet` objects */
export type EditConcreteTestSetInput = {
  /** edit or remove existing, or insert new, `ConcreteCoreBreakData` records associated with `ConcreteTestSet.concretePlacements.concreteCoreMeasurements` */
  concreteCoreBreakData?: InputMaybe<Array<UpsertConcreteCoreBreakDataInput>>;
  /**
   * edit or remove existing, or insert new, `ConcreteTestBreakData` records associated with `ConcreteTestSet.concreteTests`
   *
   * use `removeConcreteTestBreakData` to remove a specific `ConcreteTestBreakData`
   *
   * if there is a discrepancy between `ConcreteTest.strengthAges` and the ages of associated inputs, `ConcreteTest.strengthAge` will be updated
   */
  concreteTestBreakData?: InputMaybe<Array<UpsertConcreteTestBreakDataInput>>;
  globalId: Scalars['String'];
};

export type EditConcreteTestSetResponse = {
  __typename: 'EditConcreteTestSetResponse';
  /** the edited `ConcreteTestSet` */
  concreteTestSet: ConcreteTestSet;
};

/** values required to edit an existing `ConstructionAdminSubmittal` objects */
export type EditConstructionAdminSubmittalInput = {
  contractualReviewDate?: InputMaybe<Scalars['DateTime']>;
  customFields?: InputMaybe<MutateCustomFieldsInput>;
  externalLinks?: InputMaybe<Array<ExternalLinkInput>>;
  id: Scalars['String'];
  payItemIds?: InputMaybe<Array<Scalars['String']>>;
  quantity?: InputMaybe<Scalars['Int']>;
  requestedReviewDate?: InputMaybe<Scalars['DateTime']>;
  routingGroupIds?: InputMaybe<Array<Scalars['String']>>;
  subtypeId?: InputMaybe<Scalars['String']>;
  typeId?: InputMaybe<Scalars['String']>;
  units?: InputMaybe<Scalars['String']>;
};

export type EditConstructionAdminSubmittalResponse = {
  __typename: 'EditConstructionAdminSubmittalResponse';
  /** the edited `ConstructionAdminSubmittal` */
  submittal: ConstructionAdminSubmittal;
};

/** input options required to update a `SharePointResource.name` for `ConstructionAdminSubmittal` records */
export type EditConstructionAdminSubmittalSharePointReferenceInput = {
  id: Scalars['String'];
  /** the new value for the packageName */
  packageName?: InputMaybe<Scalars['String']>;
  /** the new value for the packageNumber */
  packageNumber?: InputMaybe<Scalars['String']>;
};

/** values required to edit an existing `CustomField` objects */
export type EditCustomFieldInput = {
  customFieldToClassTypeInputs?: InputMaybe<Array<EditCustomFieldToClassTypeInput>>;
  customListItems?: InputMaybe<Array<EditCustomListItemInput>>;
  /** the `description` to give to the `CustomField` */
  description?: InputMaybe<Scalars['String']>;
  /** a UUID used to globally identify this record in the database */
  id: Scalars['String'];
  metadata?: InputMaybe<CustomFieldMetadataInput>;
  /** the `name` to give to the `CustomField` */
  name?: InputMaybe<Scalars['String']>;
};

export type EditCustomFieldResponse = {
  __typename: 'EditCustomFieldResponse';
  /** the edited `CustomField` */
  customField: CustomField;
};

/** values required to edit an existing `CustomFieldToClassType` objects */
export type EditCustomFieldToClassTypeInput = {
  alwaysEditable?: InputMaybe<Scalars['Boolean']>;
  alwaysVisible?: InputMaybe<Scalars['Boolean']>;
  classTypeId: Scalars['String'];
  customFieldId?: InputMaybe<Scalars['String']>;
  prominent?: InputMaybe<Scalars['Boolean']>;
  required?: InputMaybe<Scalars['Boolean']>;
  roleIds?: InputMaybe<Array<Scalars['String']>>;
  userIds?: InputMaybe<Array<Scalars['String']>>;
};

export type EditCustomFieldToClassTypeResponse = {
  __typename: 'EditCustomFieldToClassTypeResponse';
  /** the edited `CustomFieldToClassType` */
  customFieldToClassType: CustomFieldToClassType;
};

/** values required to edit an existing `CustomListItem` objects */
export type EditCustomListItemInput = {
  id?: InputMaybe<Scalars['String']>;
  value: Scalars['String'];
};

export type EditCustomListItemResponse = {
  __typename: 'EditCustomListItemResponse';
  /** the edited `CustomListItem` */
  customListItem: CustomListItem;
};

/** values required to edit an existing `DSAction` objects */
export type EditDsActionInput = {
  description?: InputMaybe<Scalars['String']>;
  id: Scalars['String'];
  name: Scalars['String'];
};

export type EditDsActionResponse = {
  __typename: 'EditDSActionResponse';
  /** the edited `DSAction` */
  action: DsAction;
};

/** values required to edit an existing `DSDiscipline` objects */
export type EditDsDisciplineInput = {
  description?: InputMaybe<Scalars['String']>;
  id: Scalars['String'];
  name?: InputMaybe<Scalars['String']>;
  userIds?: InputMaybe<Array<Scalars['String']>>;
};

export type EditDsDisciplineResponse = {
  __typename: 'EditDSDisciplineResponse';
  /** the edited `DSDiscipline` */
  discipline: DsDiscipline;
};

export type EditDsNotificationInput = {
  /** all design submittals with a specific discipline */
  byDSDiscipline?: InputMaybe<Array<ByDsDisciplineInput>>;
  every?: InputMaybe<RecipientsInput>;
  notificationEventId: Scalars['String'];
  /** the `globalId` of a related `Project` */
  projectId: Scalars['String'];
};

export type EditDsNotificationResponse = {
  __typename: 'EditDSNotificationResponse';
  /** the edited `DSNotification` */
  notification: DsNotification;
};

/** values required to edit an existing `DSOrganization` objects */
export type EditDsOrganizationInput = {
  description?: InputMaybe<Scalars['String']>;
  id: Scalars['String'];
  name: Scalars['String'];
};

export type EditDsOrganizationResponse = {
  __typename: 'EditDSOrganizationResponse';
  /** the edited `DSOrganization` */
  organization: DsOrganization;
};

/** values required to edit an existing `DSQuickLink` objects */
export type EditDsQuickLinkInput = {
  description?: InputMaybe<Scalars['String']>;
  href?: InputMaybe<Scalars['String']>;
  id: Scalars['String'];
  label: Scalars['String'];
};

export type EditDsQuickLinkResponse = {
  __typename: 'EditDSQuickLinkResponse';
  /** the edited `DSQuickLink` */
  dsQuickLink: DsQuickLink;
};

/** values required to edit an existing `DSType` objects */
export type EditDsTypeInput = {
  description?: InputMaybe<Scalars['String']>;
  id: Scalars['String'];
  name: Scalars['String'];
};

export type EditDsTypeResponse = {
  __typename: 'EditDSTypeResponse';
  /** the edited `DSType` */
  type: DsType;
};

/** values required to edit an existing `DesignSubmittal` objects */
export type EditDesignSubmittalInput = {
  /** a list of `DSAction.id` values  */
  actionIds?: InputMaybe<Array<Scalars['String']>>;
  contractDueDate?: InputMaybe<Scalars['DateTime']>;
  customFields?: InputMaybe<MutateCustomFieldsInput>;
  /** a list of `DSDiscipline.id` values  */
  disciplineIds?: InputMaybe<Array<Scalars['String']>>;
  externalLinks?: InputMaybe<Array<ExternalLinkInput>>;
  fieldDesignChangeIds?: InputMaybe<Array<Scalars['String']>>;
  id: Scalars['String'];
  organizationId?: InputMaybe<Scalars['String']>;
  payItemIds?: InputMaybe<Array<Scalars['String']>>;
  requestedActionDate?: InputMaybe<Scalars['DateTime']>;
  typeId?: InputMaybe<Scalars['String']>;
};

export type EditDesignSubmittalResponse = {
  __typename: 'EditDesignSubmittalResponse';
  /** the edited `DesignSubmittal` */
  designSubmittal: DesignSubmittal;
};

/** input options required to update a `SharePointResource.name` for `DesignSubmittal` records */
export type EditDesignSubmittalSharePointReferenceInput = {
  id: Scalars['String'];
  /** the new value for the packageName */
  packageName?: InputMaybe<Scalars['String']>;
  /** the new value for the packageNumber */
  packageNumber?: InputMaybe<Scalars['String']>;
};

/** values required to edit an existing `DocumentChecklistItem` objects */
export type EditDocumentChecklistItemInput = {
  /** a list of `ConcreteMaterial.globalId` values */
  concreteMaterialIds?: InputMaybe<Array<Scalars['String']>>;
  id: Scalars['Int'];
  name?: InputMaybe<Scalars['String']>;
};

export type EditDocumentChecklistItemResponse = {
  __typename: 'EditDocumentChecklistItemResponse';
  /** the edited `DocumentChecklistItem` */
  documentChecklistItem: DocumentChecklistItem;
};

export type EditEjNotificationInput = {
  every?: InputMaybe<RecipientsInput>;
  notificationEventId: Scalars['String'];
  /** the `globalId` of a related `Project` */
  projectId: Scalars['String'];
};

export type EditEjNotificationResponse = {
  __typename: 'EditEJNotificationResponse';
  /** the edited `EJNotification` */
  notification: EjNotification;
};

/** values required to edit an existing `EJQuickLink` objects */
export type EditEjQuickLinkInput = {
  description?: InputMaybe<Scalars['String']>;
  href?: InputMaybe<Scalars['String']>;
  id: Scalars['String'];
  label: Scalars['String'];
};

export type EditEjQuickLinkResponse = {
  __typename: 'EditEJQuickLinkResponse';
  /** the edited `EJQuickLink` */
  ejQuickLink: EjQuickLink;
};

/** values required to edit an existing `EJType` objects */
export type EditEjTypeInput = {
  allowanceDescription: Scalars['String'];
  id: Scalars['String'];
  name: Scalars['String'];
  reportTypeId?: InputMaybe<Scalars['String']>;
  userIds?: InputMaybe<Array<Scalars['String']>>;
};

export type EditEjTypeResponse = {
  __typename: 'EditEJTypeResponse';
  /** the edited `EJType` */
  type: EjType;
};

/** values required to edit an existing `EngineeringJudgement` objects */
export type EditEngineeringJudgementInput = {
  customFields?: InputMaybe<MutateCustomFieldsInput>;
  externalLinks?: InputMaybe<Array<ExternalLinkInput>>;
  failureDate?: InputMaybe<Scalars['DateTime']>;
  failureDescription?: InputMaybe<Scalars['String']>;
  id: Scalars['String'];
  justification?: InputMaybe<Scalars['String']>;
  manualReportId?: InputMaybe<Scalars['String']>;
  notes?: InputMaybe<Scalars['String']>;
  payItemIds?: InputMaybe<Array<Scalars['String']>>;
  reports?: InputMaybe<Array<MutateEjToReportInput>>;
  typeId?: InputMaybe<Scalars['String']>;
};

export type EditEngineeringJudgementResponse = {
  __typename: 'EditEngineeringJudgementResponse';
  /** the edited `EngineeringJudgement` */
  judgement: EngineeringJudgement;
};

/** values required to edit an existing `FDCApprovalGroup` objects */
export type EditFdcApprovalGroupInput = {
  concurrenceLevelIds?: InputMaybe<Array<Scalars['String']>>;
  /** the `description` to give to the `FDCApprovalGroup` */
  description?: InputMaybe<Scalars['String']>;
  /** a UUID used to globally identify this record in the database */
  id: Scalars['String'];
  /** the `name` to give to the `FDCApprovalGroup` */
  name?: InputMaybe<Scalars['String']>;
  /** `Role.id` values to associate with the `FDCApprovalGroup` */
  roleIds?: InputMaybe<Array<Scalars['String']>>;
  /** `User.id` values to associate with the `FDCApprovalGroup` */
  userIds?: InputMaybe<Array<Scalars['String']>>;
};

export type EditFdcApprovalGroupResponse = {
  __typename: 'EditFDCApprovalGroupResponse';
  /** the edited `FDCApprovalGroup` */
  approvalGroup: FdcApprovalGroup;
};

/** values required to edit an existing `FDCConcurrenceGroup` objects */
export type EditFdcConcurrenceGroupInput = {
  /** the `description` to give to the `FDCConcurrenceGroup` */
  description?: InputMaybe<Scalars['String']>;
  /** a UUID used to globally identify this record in the database */
  id: Scalars['String'];
  /** the `name` to give to the `FDCConcurrenceGroup` */
  name?: InputMaybe<Scalars['String']>;
  /** `Role.id` values to associate with the `FDCConcurrenceGroup` */
  roleIds?: InputMaybe<Array<Scalars['String']>>;
  /** `User.id` values to associate with the `FDCConcurrenceGroup` */
  userIds?: InputMaybe<Array<Scalars['String']>>;
};

export type EditFdcConcurrenceGroupResponse = {
  __typename: 'EditFDCConcurrenceGroupResponse';
  /** the edited `FDCConcurrenceGroup` */
  concurrenceGroup: FdcConcurrenceGroup;
};

/** values required to edit an existing `FDCConcurrenceLevel` objects */
export type EditFdcConcurrenceLevelInput = {
  /** `FDCApprovalGroup.id` values to associate with the `FDCConcurrenceLevel` */
  approvalGroupIds?: InputMaybe<Array<Scalars['String']>>;
  /** the `description` to give to the `FDCConcurrenceLevel` */
  description?: InputMaybe<Scalars['String']>;
  /** a UUID used to globally identify this record in the database */
  id: Scalars['String'];
  /** the `name` to give to the `FDCConcurrenceLevel` */
  name?: InputMaybe<Scalars['String']>;
  /** an `FDCConcurrenceLevelSideEffect.id` value to associate with the `FDCConcurrenceLevel` */
  sideEffectId?: InputMaybe<Scalars['String']>;
};

export type EditFdcConcurrenceLevelResponse = {
  __typename: 'EditFDCConcurrenceLevelResponse';
  /** the edited `FDCConcurrenceLevel` */
  concurrenceLevel: FdcConcurrenceLevel;
};

/** values required to edit an existing `FDCDiscipline` objects */
export type EditFdcDisciplineInput = {
  /** the `description` to give to the `FDCDiscipline` */
  description?: InputMaybe<Scalars['String']>;
  /** a UUID used to globally identify this record in the database */
  id: Scalars['String'];
  /** the `name` to give to the `FDCDiscipline` */
  name?: InputMaybe<Scalars['String']>;
};

export type EditFdcDisciplineResponse = {
  __typename: 'EditFDCDisciplineResponse';
  /** the edited `FDCDiscipline` */
  discipline: FdcDiscipline;
};

export type EditFdcNotificationInput = {
  /**
   * only present in Any Approval
   *
   * when a specific approval group is approved, regardless of concurrence level
   */
  byApprovalGroup?: InputMaybe<Array<ByFdcApprovalGroupInput>>;
  /**
   * only present in Any Level Concurrence
   *
   * when a specific concurrence group is concurred on, regardless of concurrence level
   */
  byConcurrenceGroup?: InputMaybe<Array<ByFdcConcurrenceGroupInput>>;
  /** all field design changes of a specific concurrence level */
  byConcurrenceLevel?: InputMaybe<Array<ByFdcConcurrenceLevelInput>>;
  /**
   * only present in Any Approval
   *
   * when a specific approval group is approved, for a specific concurrence level
   */
  byConcurrenceLevelAndApprovalGroup?: InputMaybe<Array<ByFdcConcurrenceLevelAndApprovalGroupInput>>;
  /**
   * only present in Any Level Concurrence
   *
   * when a specific concurrence group is concurred on, for a specific concurrence level
   */
  byConcurrenceLevelAndConcurrenceGroup?: InputMaybe<Array<ByFdcConcurrenceLevelAndConcurrenceGroupInput>>;
  every?: InputMaybe<RecipientsInput>;
  notificationEventId: Scalars['String'];
  /** the `globalId` of a related `Project` */
  projectId: Scalars['String'];
};

export type EditFdcNotificationResponse = {
  __typename: 'EditFDCNotificationResponse';
  /** the edited `FDCNotification` */
  notification: FdcNotification;
};

/** values required to edit an existing `FDCQuickLink` objects */
export type EditFdcQuickLinkInput = {
  description?: InputMaybe<Scalars['String']>;
  href?: InputMaybe<Scalars['String']>;
  id: Scalars['String'];
  label: Scalars['String'];
};

export type EditFdcQuickLinkResponse = {
  __typename: 'EditFDCQuickLinkResponse';
  /** the edited `FDCQuickLink` */
  fdcQuickLink: FdcQuickLink;
};

export type EditFieldDesignChangeInput = {
  concurrenceLevelId?: InputMaybe<Scalars['String']>;
  customFields?: InputMaybe<MutateCustomFieldsInput>;
  disciplineIds?: InputMaybe<Array<Scalars['String']>>;
  /** allows users to list construction plan sets, with sheet numbers, where the proposed construction will deviate from the current project design */
  drawingsAffected?: InputMaybe<Scalars['String']>;
  externalLinks?: InputMaybe<Array<ExternalLinkInput>>;
  /** a UUID used to globally identify this record in the database */
  id: Scalars['String'];
  /** allows users to document the reason they want to deviate from the current project design. limited to 2000 characters */
  issue: Scalars['String'];
  /** allows users to document locations, stations, and offsets on the project where the Field Design Change is allowed to be made */
  location?: InputMaybe<Scalars['String']>;
  payItemIds?: InputMaybe<Array<Scalars['String']>>;
  /** when the reviewers to respond by to prevent delays in construction */
  requestedApprovalDate?: InputMaybe<Scalars['DateTime']>;
  /** allows users to propose a plan for how to construct the item differently from the current design and resolve the issue */
  resolution?: InputMaybe<Scalars['String']>;
  /** allows users to list which construction and/or design specifications, with which  sections and sub-sections, should be referenced when reviewing the Field Design Change for approval */
  specsAffected?: InputMaybe<Scalars['String']>;
};

export type EditFieldDesignChangeResponse = {
  __typename: 'EditFieldDesignChangeResponse';
  /** the edited `FieldDesignChange` */
  fieldDesignChange: FieldDesignChange;
};

export type EditFilenameTemplateItemInput = {
  type: Scalars['String'];
  value: Scalars['String'];
};

/** values required to edit an existing `GoogleSheetPayItemConnection` objects */
export type EditGoogleSheetPayItemConnectionInput = {
  connectionId: Scalars['String'];
  documentId?: InputMaybe<Scalars['String']>;
  groupId?: InputMaybe<Scalars['String']>;
  headers?: InputMaybe<Array<EditHeaderInput>>;
  name?: InputMaybe<Scalars['String']>;
  payItemColumnKey?: InputMaybe<Scalars['String']>;
  sheetId?: InputMaybe<Scalars['Int']>;
};

export type EditGoogleSheetPayItemConnectionResponse = {
  __typename: 'EditGoogleSheetPayItemConnectionResponse';
  /** the edited `GoogleSheetPayItemConnection` */
  googleSheet: GoogleSheetPayItemConnection;
};

export type EditHeaderInput = {
  id: Scalars['String'];
  order: Scalars['Int'];
  visible: Scalars['Boolean'];
};

/** values required to edit an existing `IFINotification` objects */
export type EditIfiNotificationInput = {
  asphaltLot?: InputMaybe<RecipientsInput>;
  concreteTest?: InputMaybe<RecipientsInput>;
  dailyInspectionControlPoint?: InputMaybe<RecipientsInput>;
  dailyInspectionInspection?: InputMaybe<RecipientsInput>;
  dailyInspectionPunchList?: InputMaybe<RecipientsInput>;
  densityLot?: InputMaybe<RecipientsInput>;
  densityTest?: InputMaybe<RecipientsInput>;
  every?: InputMaybe<RecipientsInput>;
  frequency?: InputMaybe<FrequencyInput>;
  notificationEventId: Scalars['String'];
  /** the `globalId` of a related `Project` */
  projectId: Scalars['String'];
};

export type EditIfiNotificationResponse = {
  __typename: 'EditIFINotificationResponse';
  /** the edited `IFINotification` */
  notification: IfiNotification;
};

/** values required to edit an existing `IdentifiedFieldIssue` objects */
export type EditIdentifiedFieldIssueInput = {
  customFields?: InputMaybe<MutateCustomFieldsInput>;
  issueIds?: InputMaybe<Array<Scalars['String']>>;
  judgementIds?: InputMaybe<Array<Scalars['String']>>;
  reportId: Scalars['String'];
  reviewNotes?: InputMaybe<Scalars['String']>;
};

export type EditIdentifiedFieldIssueResponse = {
  __typename: 'EditIdentifiedFieldIssueResponse';
  /** the edited `IdentifiedFieldIssue` */
  identifiedFieldIssue: IdentifiedFieldIssue;
};

/** values required to edit an existing `IssueDispositionType` objects */
export type EditIssueDispositionTypeInput = {
  description?: InputMaybe<Scalars['String']>;
  id: Scalars['String'];
  name?: InputMaybe<Scalars['String']>;
  nonApplicableIssueTypeIds?: InputMaybe<Array<Scalars['String']>>;
};

export type EditIssueDispositionTypeResponse = {
  __typename: 'EditIssueDispositionTypeResponse';
  /** the edited `IssueDispositionType` */
  dispositionType: IssueDispositionType;
};

/** values required to edit an existing `Issue` objects */
export type EditIssueInput = {
  customFields?: InputMaybe<MutateCustomFieldsInput>;
  description?: InputMaybe<Scalars['String']>;
  externalLinks?: InputMaybe<Array<ExternalLinkInput>>;
  id: Scalars['String'];
  payItemIds?: InputMaybe<Array<Scalars['String']>>;
  reports?: InputMaybe<Array<MutateIssueToReportInput>>;
  response?: InputMaybe<Scalars['String']>;
  typeIds?: InputMaybe<Array<Scalars['String']>>;
};

export type EditIssueNotificationInput = {
  byIssueType?: InputMaybe<Array<ByIssueTypeInput>>;
  every?: InputMaybe<RecipientsInput>;
  notificationEventId: Scalars['String'];
  /** the `globalId` of a related `Project` */
  projectId: Scalars['String'];
};

export type EditIssueNotificationResponse = {
  __typename: 'EditIssueNotificationResponse';
  /** the edited `IssueNotification` */
  notification: IssueNotification;
};

/** values required to edit an existing `IssueQuickLink` objects */
export type EditIssueQuickLinkInput = {
  description?: InputMaybe<Scalars['String']>;
  href?: InputMaybe<Scalars['String']>;
  id: Scalars['String'];
  label: Scalars['String'];
};

export type EditIssueQuickLinkResponse = {
  __typename: 'EditIssueQuickLinkResponse';
  /** the edited `IssueQuickLink` */
  quickLink: IssueQuickLink;
};

export type EditIssueResponse = {
  __typename: 'EditIssueResponse';
  /** the edited `Issue` */
  issue: Issue;
};

/** values required to edit an existing `IssueType` objects */
export type EditIssueTypeInput = {
  description?: InputMaybe<Scalars['String']>;
  id: Scalars['String'];
  name?: InputMaybe<Scalars['String']>;
  nonApplicableIssueDispositionTypeIds?: InputMaybe<Array<Scalars['String']>>;
};

export type EditIssueTypeResponse = {
  __typename: 'EditIssueTypeResponse';
  /** the edited `IssueType` */
  type: IssueType;
};

/** values required to edit an existing `LIMSAsphaltMixDesignTarget` objects */
export type EditLimsAsphaltMixDesignTargetInput = {
  description?: InputMaybe<Scalars['String']>;
  id: Scalars['String'];
  name?: InputMaybe<Scalars['String']>;
  optional?: InputMaybe<Scalars['Boolean']>;
  percentages?: InputMaybe<Array<MutateAsphaltMixDesignTargetPercentageInput>>;
};

export type EditLimsAsphaltMixDesignTargetResponse = {
  __typename: 'EditLIMSAsphaltMixDesignTargetResponse';
  /** the edited `LIMSAsphaltMixDesignTarget` */
  target: LimsAsphaltMixDesignTarget;
};

/** values required to edit an existing `LabTech` objects */
export type EditLabTechInput = {
  id: Scalars['Int'];
  name?: InputMaybe<Scalars['String']>;
  testingLabIds?: InputMaybe<Array<Scalars['Int']>>;
  userId?: InputMaybe<Scalars['String']>;
};

export type EditLabTechResponse = {
  __typename: 'EditLabTechResponse';
  /** the edited `LabTech` */
  labTech: LabTech;
};

/** values required to edit an existing `NonUserEmail` objects */
export type EditNonUserEmailInput = {
  address: Scalars['String'];
  description?: InputMaybe<Scalars['String']>;
  id: Scalars['Float'];
  label?: InputMaybe<Scalars['String']>;
};

export type EditNonUserEmailResponse = {
  __typename: 'EditNonUserEmailResponse';
  /** the edited `NonUserEmail` */
  nonUserEmail: NonUserEmail;
};

export type EditPdfDesignLayerInput = {
  /**
   * a map server index of a `Table` in Horrocks' ArcGIS REST service
   *
   * used to help distinguish which object type is associated with `PDFDesignLayer.json`
   *
   * | object type | index |
   * | --- | :---: |
   * | `MaterialRequirement` | 8 |
   * | `ConcreteMaterial` | 18 |
   * | `DailyInspectionWorkType` | 31 |
   * | `AsphaltMaterial` | 45 |
   */
  index: Scalars['Int'];
  json: EditPdfDesignLayerJsonInput;
  /** the `globalId` of a related `Project` */
  projectId: Scalars['String'];
};

export type EditPdfDesignLayerJsonInput = {
  /** a list of `ArcGISProjectIndex` layer integers */
  allLayers?: InputMaybe<Array<Scalars['Int']>>;
  /** an object where each key is an entity's `globalId` and its corresponding value is a list of `ArcGISProjectIndex` layer integers */
  options?: InputMaybe<Scalars['SimpleJSONScalar']>;
  /** whether to use `allLayers` when setting layers for a `PDFDesignLayer.index` */
  useAllLayers: Scalars['Boolean'];
};

export type EditPdfDesignLayerResponse = {
  __typename: 'EditPDFDesignLayerResponse';
  /** the edited `PDFDesignLayer` */
  pdfDesignLayer: PdfDesignLayer;
};

/** values required to edit an existing `PayItemConnectionGroup` objects */
export type EditPayItemConnectionGroupInput = {
  connectionIds?: InputMaybe<Array<Scalars['String']>>;
  description?: InputMaybe<Scalars['String']>;
  id: Scalars['String'];
  internalConnectionIds?: InputMaybe<Array<Scalars['String']>>;
  name?: InputMaybe<Scalars['String']>;
};

export type EditPayItemConnectionGroupResponse = {
  __typename: 'EditPayItemConnectionGroupResponse';
  /** the edited `PayItemConnectionGroup` */
  payItemConnectionGroup: PayItemConnectionGroup;
};

export type EditPayItemSummaryOrderInput = {
  connections: Array<PayItemConnectionOrderInput>;
  groups: Array<PayItemConnectionGroupOrderInput>;
  internalConnections: Array<InternalPayItemConnectionOrderInput>;
  projectId: Scalars['String'];
};

export type EditPayItemSummaryOrderResponse = {
  __typename: 'EditPayItemSummaryOrderResponse';
  /** the edited `Project` */
  project: Project;
};

/** values required to edit an existing `PhotoFilename` objects */
export type EditPhotoFilenameInput = {
  classTypeId: Scalars['String'];
  projectId: Scalars['String'];
  templateItems: Array<EditFilenameTemplateItemInput>;
};

export type EditPhotoFilenameResponse = {
  __typename: 'EditPhotoFilenameResponse';
  /** the edited `PhotoFilename` */
  photoFilename: PhotoFilename;
};

/** values required to edit an existing `ProjectMetadata` objects */
export type EditProjectMetadataInput = {
  /**
   * the id associated with the Project in the CM_Project_Layers Map Server
   *
   *     this id is used to get design layers for PDF Design Layers and should only need to be set once
   *
   *     if it does change, this may lead to incorrectly configured PDF Design Layers
   */
  cmProjectLayersId?: InputMaybe<Scalars['Float']>;
  concreteSixSheetName?: InputMaybe<Scalars['String']>;
  concreteThreeSheetName?: InputMaybe<Scalars['String']>;
  customDriveId?: InputMaybe<Scalars['String']>;
  /** When set to `true`, will delete the project logo from Azure Blob Storage */
  deleteProjectLogo?: InputMaybe<Scalars['Boolean']>;
  gradationsLogSpreadsheetId?: InputMaybe<Scalars['String']>;
  materialsLogSpreadsheetId?: InputMaybe<Scalars['String']>;
  mixDesignSheetName?: InputMaybe<Scalars['String']>;
  /** the `projectId` of a `ProjectMetadata` to update */
  projectId: Scalars['String'];
  /** a `boolean` to set `promptDesignSubmittalAtFDCClosure` bit value */
  promptDesignSubmittalAtFDCClosure?: InputMaybe<Scalars['Boolean']>;
  /** a `boolean` to set `replaceSpacesWithDashesInFilenames` bit value */
  replaceSpacesWithDashesInFilenames?: InputMaybe<Scalars['Boolean']>;
  /**
   * a new `sharePointSiteLandingPage`
   *
   *   empty values will be treated as `null`
   */
  sharePointSiteLandingPage?: InputMaybe<Scalars['String']>;
};

export type EditProjectMetadataResponse = {
  __typename: 'EditProjectMetadataResponse';
  /** the edited `ProjectMetadata` */
  projectMetadata: ProjectMetadata;
};

/** values required to edit an existing `ProjectToInternalConnection` objects */
export type EditProjectToInternalConnectionInput = {
  groupId?: InputMaybe<Scalars['String']>;
  internalConnectionId: Scalars['String'];
  order?: InputMaybe<Scalars['Int']>;
  projectId: Scalars['String'];
};

export type EditProjectToInternalConnectionResponse = {
  __typename: 'EditProjectToInternalConnectionResponse';
  /** the edited `ProjectToInternalConnection` */
  projectToInternalConnection: ProjectToInternalConnection;
};

export type EditRfiNotificationInput = {
  byResponseDiscipline: Array<ByResponseDisciplineInput>;
  every?: InputMaybe<RecipientsInput>;
  notificationEventId: Scalars['String'];
  /** the `globalId` of a related `Project` */
  projectId: Scalars['String'];
};

export type EditRfiNotificationResponse = {
  __typename: 'EditRFINotificationResponse';
  /** the edited `RFINotification` */
  notification: RfiNotification;
};

/** values required to edit an existing `RFIOrganization` objects */
export type EditRfiOrganizationInput = {
  description?: InputMaybe<Scalars['String']>;
  id: Scalars['String'];
  name: Scalars['String'];
};

export type EditRfiOrganizationResponse = {
  __typename: 'EditRFIOrganizationResponse';
  /** the edited `RFIOrganization` */
  organization: RfiOrganization;
};

/** values required to edit an existing `RFIQuickLink` objects */
export type EditRfiQuickLinkInput = {
  description?: InputMaybe<Scalars['String']>;
  href?: InputMaybe<Scalars['String']>;
  id: Scalars['String'];
  label: Scalars['String'];
};

export type EditRfiQuickLinkResponse = {
  __typename: 'EditRFIQuickLinkResponse';
  /** the edited `RFIQuickLink` */
  rfiQuickLink: RfiQuickLink;
};

/** values required to edit an existing `RFIResponseDiscipline` objects */
export type EditRfiResponseDisciplineInput = {
  description?: InputMaybe<Scalars['String']>;
  id: Scalars['String'];
  name: Scalars['String'];
  userIds?: InputMaybe<Array<Scalars['String']>>;
};

export type EditRfiResponseDisciplineResponse = {
  __typename: 'EditRFIResponseDisciplineResponse';
  /** the edited `RFIResponseDiscipline` */
  responseDiscipline: RfiResponseDiscipline;
};

/** values required to edit an existing `RFIResponse` objects */
export type EditRfiResponseInput = {
  id: Scalars['String'];
  text: Scalars['String'];
};

export type EditRfiResponseResponse = {
  __typename: 'EditRFIResponseResponse';
  /** the edited `RFIResponse` */
  response: RfiResponse;
};

/** values required to edit an existing `ReportFilename` objects */
export type EditReportFilenameInput = {
  projectId: Scalars['String'];
  reportId: Scalars['String'];
  templateItems: Array<EditFilenameTemplateItemInput>;
};

export type EditReportFilenameResponse = {
  __typename: 'EditReportFilenameResponse';
  /** the edited `ReportFilename` */
  reportFilename: ReportFilename;
};

export type EditRequestForInformationInput = {
  customFields?: InputMaybe<MutateCustomFieldsInput>;
  description: Scalars['String'];
  externalLinks?: InputMaybe<Array<ExternalLinkInput>>;
  /** a UUID used to globally identify this record in the database */
  id: Scalars['String'];
  organizationId?: InputMaybe<Scalars['String']>;
  requestedResponseDate?: InputMaybe<Scalars['DateTime']>;
  responseDisciplineIds?: InputMaybe<Array<Scalars['String']>>;
};

export type EditRequestForInformationResponse = {
  __typename: 'EditRequestForInformationResponse';
  /** the edited `RequestForInformation` */
  requestForInformation: RequestForInformation;
};

export type EditRoleInput = {
  id: Scalars['String'];
  name: Scalars['String'];
  permissionIds?: InputMaybe<Array<Scalars['String']>>;
};

export type EditRoleResponse = {
  __typename: 'EditRoleResponse';
  /** the edited `Role` */
  role: Role;
};

/** values required to edit an existing `TestingLab` objects */
export type EditTestingLabInput = {
  id: Scalars['Int'];
  labTechIds?: InputMaybe<Array<Scalars['Int']>>;
  name?: InputMaybe<Scalars['String']>;
};

export type EditTestingLabResponse = {
  __typename: 'EditTestingLabResponse';
  /** the edited `TestingLab` */
  testingLab: TestingLab;
};

/** values required to edit an existing `User` objects */
export type EditUserInput = {
  additionalPermissionIds?: InputMaybe<Array<Scalars['String']>>;
  admin?: InputMaybe<Scalars['Boolean']>;
  developer?: InputMaybe<Scalars['Boolean']>;
  id: Scalars['String'];
  projectId?: InputMaybe<Scalars['String']>;
  roleIds?: InputMaybe<Array<Scalars['String']>>;
};

export type EditUserResponse = {
  __typename: 'EditUserResponse';
  /** the edited `User` */
  user: User;
};

export type EngineeringJudgement = {
  __typename: 'EngineeringJudgement';
  /** the date this record was inserted into the database */
  createdDate: Scalars['DateTime'];
  /**
   * the email address of a user associated with the `createdDate`
   *
   * this value will be `unknown` if the `createdDate` was not set by a user
   */
  createdUser: Scalars['String'];
  /**
   * custom fields are defined, configured, and activated for `EngineeringJudgement`
   *     records in the Administration module
   *
   *     values are saved and retrieved for each individual `EngineeringJudgement`
   */
  customFields: CustomFields;
  /** describes whether the record has been soft-deleted or not */
  deleted: Scalars['Boolean'];
  /** the date this record was soft-deleted in the database */
  deletedDate: Maybe<Scalars['DateTime']>;
  /**
   * the email address of a user associated with the `deletedDate`
   *
   * this value will be `system` if the `deletedDate` was not set by a user
   */
  deletedUser: Maybe<Scalars['String']>;
  ejToPayItemNoGeometries: Array<EjToPayItemNoGeometry>;
  ejToReports: Array<EjToReport>;
  externalLinks: Array<ExternalLink>;
  failureDate: Scalars['DateTime'];
  /** limited to 4000 characters */
  failureDescription: Maybe<Scalars['String']>;
  /** the `number` prefixed with "EJ" */
  formattedNumber: Scalars['String'];
  /** a UUID used to globally identify this record in the database */
  id: Scalars['String'];
  identifiedFieldIssue: Maybe<IdentifiedFieldIssue>;
  identifiedFieldIssueId: Maybe<Scalars['String']>;
  issuedBy: Maybe<User>;
  /** the `id` of a related `User` who issued the Engineering Judgement */
  issuedById: Maybe<Scalars['String']>;
  issuedDate: Maybe<Scalars['DateTime']>;
  /** limited to 4000 characters */
  justification: Maybe<Scalars['String']>;
  /** the date this record was last updated in the database */
  lastEditedDate: Scalars['DateTime'];
  /**
   * the email address of a user associated with the `lastEditedDate`
   *
   * this value will be `system` if the `lastEditedDate` was not set by a user
   */
  lastEditedUser: Scalars['String'];
  manualReportId: Maybe<Scalars['String']>;
  /** limited to 4000 characters */
  notes: Maybe<Scalars['String']>;
  /** a generated number for the `EngineeringJudgement` */
  number: Scalars['Int'];
  /** a related `Project` */
  project: Project;
  /** the `globalId` of a related `Project` */
  projectId: Scalars['String'];
  status: Scalars['String'];
  statusId: Scalars['String'];
  type: EjType;
  typeId: Scalars['String'];
};


export type EngineeringJudgementEjToPayItemNoGeometriesArgs = {
  eJToPayItemNoGeometryFieldInput?: InputMaybe<EjToPayItemNoGeometryFieldInput>;
};


export type EngineeringJudgementEjToReportsArgs = {
  eJToReportFieldInput?: InputMaybe<EjToReportFieldInput>;
};

/**
 * helps filter multiple `EngineeringJudgement` records
 *
 * this version of the input will have limited options compared to its other counterpart
 */
export type EngineeringJudgementFieldInput = {
  createdDate?: InputMaybe<DateTimeFilter>;
  /**
   * determines now to handle deleted `EngineeringJudgement` records
   *
   * - when `true`, only return deleted records
   * - when `false`, do not return deleted records
   * - when omitted, `deleted` is ignored
   */
  deleted?: InputMaybe<Scalars['Boolean']>;
  deletedDate?: InputMaybe<DateTimeFilter>;
  failureDate?: InputMaybe<DateTimeFilter>;
  failureDescription?: InputMaybe<StringFilter>;
  issuedById?: InputMaybe<StringFilter>;
  issuedDate?: InputMaybe<DateTimeFilter>;
  justification?: InputMaybe<StringFilter>;
  lastEditedDate?: InputMaybe<DateTimeFilter>;
  manualReportId?: InputMaybe<StringFilter>;
  notes?: InputMaybe<StringFilter>;
  number?: InputMaybe<IntFilter>;
  /**
   * how to order `EngineeringJudgement` records
   *
   * executed in the order they are defined
   */
  orderBy?: InputMaybe<Array<OrderByInput>>;
  projectId?: InputMaybe<StringFilter>;
  statusId?: InputMaybe<StringFilter>;
  /**
   * specifies how many records to return
   *
   * analogous to `limit`, `first`, or `top` in SQL dialects
   */
  take?: InputMaybe<Scalars['Int']>;
  typeId?: InputMaybe<StringFilter>;
};

/** helps filter multiple `EngineeringJudgement` records */
export type EngineeringJudgementListInput = {
  createdDate?: InputMaybe<DateTimeFilter>;
  /**
   * determines now to handle deleted `EngineeringJudgement` records
   *
   * - when `true`, only return deleted records
   * - when `false`, do not return deleted records
   * - when omitted, `deleted` is ignored
   */
  deleted?: InputMaybe<Scalars['Boolean']>;
  deletedDate?: InputMaybe<DateTimeFilter>;
  failureDate?: InputMaybe<DateTimeFilter>;
  failureDescription?: InputMaybe<StringFilter>;
  issuedById?: InputMaybe<StringFilter>;
  issuedDate?: InputMaybe<DateTimeFilter>;
  justification?: InputMaybe<StringFilter>;
  lastEditedDate?: InputMaybe<DateTimeFilter>;
  manualReportId?: InputMaybe<StringFilter>;
  notes?: InputMaybe<StringFilter>;
  number?: InputMaybe<IntFilter>;
  /**
   * how to order `EngineeringJudgement` records
   *
   * executed in the order they are defined
   */
  orderBy?: InputMaybe<Array<OrderByInput>>;
  /**
   * paginate `EngineeringJudgement` records
   *
   * using `paginate` may require multiple requests to get all possible results,
   * but will give more fine-grain control in the event all records cannot be
   * returned gracefully
   */
  paginate?: InputMaybe<PaginationInput>;
  projectId?: InputMaybe<StringFilter>;
  statusId?: InputMaybe<StringFilter>;
  typeId?: InputMaybe<StringFilter>;
};

/** response metadata for a list query of EngineeringJudgement records */
export type EngineeringJudgementListResponse = {
  __typename: 'EngineeringJudgementListResponse';
  /** the total count of EngineeringJudgement records matching any configured filters */
  count: Scalars['Int'];
  /** the total count of paginated groups of EngineeringJudgement */
  pages: Scalars['Int'];
  /** EngineeringJudgement records */
  records: Array<EngineeringJudgement>;
};

export type EntityCustomFieldValue = {
  __typename: 'EntityCustomFieldValue';
  /** the id of a `CustomFieldEntity` */
  entityId: Scalars['String'];
  href: Maybe<Scalars['String']>;
  label: Maybe<Scalars['String']>;
  /** the id of a related database entity */
  recordId: Maybe<Scalars['String']>;
};


export type EntityCustomFieldValueHrefArgs = {
  projectId: Scalars['String'];
};

/** a hyperlink from one supported record to another in CIMS */
export type EntityCustomFieldValues = {
  __typename: 'EntityCustomFieldValues';
  /** the date this record was inserted into the database */
  createdDate: Scalars['DateTime'];
  /**
   * the email address of a user associated with the `createdDate`
   *
   * this value will be `unknown` if the `createdDate` was not set by a user
   */
  createdUser: Scalars['String'];
  customField: CustomField;
  /** the `id` of a related `CustomField` */
  customFieldId: Scalars['String'];
  /** the date this record was soft-deleted in the database */
  deletedDate: Maybe<Scalars['DateTime']>;
  /**
   * the email address of a user associated with the `deletedDate`
   *
   * this value will be `system` if the `deletedDate` was not set by a user
   */
  deletedUser: Maybe<Scalars['String']>;
  entities: Array<EntityCustomFieldValue>;
  /** the date this record was last updated in the database */
  lastEditedDate: Scalars['DateTime'];
  /**
   * the email address of a user associated with the `lastEditedDate`
   *
   * this value will be `system` if the `lastEditedDate` was not set by a user
   */
  lastEditedUser: Scalars['String'];
};

export type ExternalLink = {
  __typename: 'ExternalLink';
  href: Scalars['String'];
  label: Scalars['String'];
};

export type ExternalLinkInput = {
  href: Scalars['String'];
  label: Scalars['String'];
};

/**
 * approval groups work much like Design Submittal
 * disciplines and Construction & Admin Submittal routing groups
 *
 * users, or users associated with roles, approve a Field Design Change on behalf
 * of the approval group
 *
 * approval groups are determined by the concurrence level of the Field Design Change
 */
export type FdcApprovalGroup = {
  __typename: 'FDCApprovalGroup';
  concurrenceLevels: Array<FdcConcurrenceLevel>;
  /** the date this record was inserted into the database */
  createdDate: Scalars['DateTime'];
  /**
   * the email address of a user associated with the `createdDate`
   *
   * this value will be `unknown` if the `createdDate` was not set by a user
   */
  createdUser: Scalars['String'];
  /** describes whether the record has been soft-deleted or not */
  deleted: Scalars['Boolean'];
  /** the date this record was soft-deleted in the database */
  deletedDate: Maybe<Scalars['DateTime']>;
  /**
   * the email address of a user associated with the `deletedDate`
   *
   * this value will be `system` if the `deletedDate` was not set by a user
   */
  deletedUser: Maybe<Scalars['String']>;
  /**
   * an extended description associated with the record
   *
   * this description will be used to describe the record in CIMS, where possible
   */
  description: Maybe<Scalars['String']>;
  fdcToFDCApprovalGroups: Array<FdcToFdcApprovalGroup>;
  /** a UUID used to globally identify this record in the database */
  id: Scalars['String'];
  /** the date this record was last updated in the database */
  lastEditedDate: Scalars['DateTime'];
  /**
   * the email address of a user associated with the `lastEditedDate`
   *
   * this value will be `system` if the `lastEditedDate` was not set by a user
   */
  lastEditedUser: Scalars['String'];
  /** a human readable name associated with the record */
  name: Scalars['String'];
  /** a related `Project` */
  project: Project;
  /** the `globalId` of a related `Project` */
  projectId: Scalars['String'];
  /** `Role` records with permission to approve a `FieldDesignChange` */
  roles: Array<Role>;
  /** `User` records with permission to approve a `FieldDesignChange` */
  users: Array<User>;
};


/**
 * approval groups work much like Design Submittal
 * disciplines and Construction & Admin Submittal routing groups
 *
 * users, or users associated with roles, approve a Field Design Change on behalf
 * of the approval group
 *
 * approval groups are determined by the concurrence level of the Field Design Change
 */
export type FdcApprovalGroupConcurrenceLevelsArgs = {
  fdcConcurrenceLevelFieldInput?: InputMaybe<FdcConcurrenceLevelFieldInput>;
};


/**
 * approval groups work much like Design Submittal
 * disciplines and Construction & Admin Submittal routing groups
 *
 * users, or users associated with roles, approve a Field Design Change on behalf
 * of the approval group
 *
 * approval groups are determined by the concurrence level of the Field Design Change
 */
export type FdcApprovalGroupFdcToFdcApprovalGroupsArgs = {
  fdcToFDCApprovalGroupFieldInput?: InputMaybe<FdcToFdcApprovalGroupFieldInput>;
};


/**
 * approval groups work much like Design Submittal
 * disciplines and Construction & Admin Submittal routing groups
 *
 * users, or users associated with roles, approve a Field Design Change on behalf
 * of the approval group
 *
 * approval groups are determined by the concurrence level of the Field Design Change
 */
export type FdcApprovalGroupRolesArgs = {
  roleFieldInput?: InputMaybe<RoleFieldInput>;
};


/**
 * approval groups work much like Design Submittal
 * disciplines and Construction & Admin Submittal routing groups
 *
 * users, or users associated with roles, approve a Field Design Change on behalf
 * of the approval group
 *
 * approval groups are determined by the concurrence level of the Field Design Change
 */
export type FdcApprovalGroupUsersArgs = {
  userFieldInput?: InputMaybe<UserFieldInput>;
};

/**
 * helps filter multiple `FDCApprovalGroup` records
 *
 * this version of the input will have limited options compared to its other counterpart
 */
export type FdcApprovalGroupFieldInput = {
  createdDate?: InputMaybe<DateTimeFilter>;
  /**
   * determines now to handle deleted `FDCApprovalGroup` records
   *
   * - when `true`, only return deleted records
   * - when `false`, do not return deleted records
   * - when omitted, `deleted` is ignored
   */
  deleted?: InputMaybe<Scalars['Boolean']>;
  description?: InputMaybe<StringFilter>;
  lastEditedDate?: InputMaybe<DateTimeFilter>;
  name?: InputMaybe<StringFilter>;
  /**
   * how to order `FDCApprovalGroup` records
   *
   * executed in the order they are defined
   */
  orderBy?: InputMaybe<Array<OrderByInput>>;
  projectId?: InputMaybe<StringFilter>;
  /**
   * specifies how many records to return
   *
   * analogous to `limit`, `first`, or `top` in SQL dialects
   */
  take?: InputMaybe<Scalars['Int']>;
};

/** helps filter multiple `FDCApprovalGroup` records */
export type FdcApprovalGroupListInput = {
  createdDate?: InputMaybe<DateTimeFilter>;
  /**
   * determines now to handle deleted `FDCApprovalGroup` records
   *
   * - when `true`, only return deleted records
   * - when `false`, do not return deleted records
   * - when omitted, `deleted` is ignored
   */
  deleted?: InputMaybe<Scalars['Boolean']>;
  description?: InputMaybe<StringFilter>;
  lastEditedDate?: InputMaybe<DateTimeFilter>;
  name?: InputMaybe<StringFilter>;
  /**
   * how to order `FDCApprovalGroup` records
   *
   * executed in the order they are defined
   */
  orderBy?: InputMaybe<Array<OrderByInput>>;
  /**
   * paginate `FDCApprovalGroup` records
   *
   * using `paginate` may require multiple requests to get all possible results,
   * but will give more fine-grain control in the event all records cannot be
   * returned gracefully
   */
  paginate?: InputMaybe<PaginationInput>;
  projectId?: InputMaybe<StringFilter>;
};

/** response metadata for a list query of FDCApprovalGroup records */
export type FdcApprovalGroupListResponse = {
  __typename: 'FDCApprovalGroupListResponse';
  /** the total count of FDCApprovalGroup records matching any configured filters */
  count: Scalars['Int'];
  /** the total count of paginated groups of FDCApprovalGroup */
  pages: Scalars['Int'];
  /** FDCApprovalGroup records */
  records: Array<FdcApprovalGroup>;
};

/** comments made against related `FieldDesignChange` records */
export type FdcComment = {
  __typename: 'FDCComment';
  /** the date this record was inserted into the database */
  createdDate: Scalars['DateTime'];
  /**
   * the email address of a user associated with the `createdDate`
   *
   * this value will be `unknown` if the `createdDate` was not set by a user
   */
  createdUser: Scalars['String'];
  /** describes whether the record has been soft-deleted or not */
  deleted: Scalars['Boolean'];
  /** the date this record was soft-deleted in the database */
  deletedDate: Maybe<Scalars['DateTime']>;
  /**
   * the email address of a user associated with the `deletedDate`
   *
   * this value will be `system` if the `deletedDate` was not set by a user
   */
  deletedUser: Maybe<Scalars['String']>;
  /** a related `FieldDesignChange` */
  fieldDesignChange: FieldDesignChange;
  /** the `id` of a related `FieldDesignChange` */
  fieldDesignChangeId: Scalars['String'];
  /** a UUID used to globally identify this record in the database */
  id: Scalars['String'];
  /** the date this record was last updated in the database */
  lastEditedDate: Scalars['DateTime'];
  /**
   * the email address of a user associated with the `lastEditedDate`
   *
   * this value will be `system` if the `lastEditedDate` was not set by a user
   */
  lastEditedUser: Scalars['String'];
  /**
   * the text of the comment
   *
   * limited to 1000 characters
   */
  text: Scalars['String'];
  user: User;
  /** the `id` of a related `User` */
  userId: Scalars['String'];
};

/**
 * helps filter multiple `FDCComment` records
 *
 * this version of the input will have limited options compared to its other counterpart
 */
export type FdcCommentFieldInput = {
  createdDate?: InputMaybe<DateTimeFilter>;
  /**
   * determines now to handle deleted `FDCComment` records
   *
   * - when `true`, only return deleted records
   * - when `false`, do not return deleted records
   * - when omitted, `deleted` is ignored
   */
  deleted?: InputMaybe<Scalars['Boolean']>;
  fieldDesignChangeId?: InputMaybe<StringFilter>;
  lastEditedDate?: InputMaybe<DateTimeFilter>;
  /**
   * how to order `FDCComment` records
   *
   * executed in the order they are defined
   */
  orderBy?: InputMaybe<Array<OrderByInput>>;
  /**
   * specifies how many records to return
   *
   * analogous to `limit`, `first`, or `top` in SQL dialects
   */
  take?: InputMaybe<Scalars['Int']>;
  text?: InputMaybe<StringFilter>;
  userId?: InputMaybe<StringFilter>;
};

/** helps filter multiple `FDCComment` records */
export type FdcCommentListInput = {
  createdDate?: InputMaybe<DateTimeFilter>;
  /**
   * determines now to handle deleted `FDCComment` records
   *
   * - when `true`, only return deleted records
   * - when `false`, do not return deleted records
   * - when omitted, `deleted` is ignored
   */
  deleted?: InputMaybe<Scalars['Boolean']>;
  fieldDesignChangeId?: InputMaybe<StringFilter>;
  lastEditedDate?: InputMaybe<DateTimeFilter>;
  /**
   * how to order `FDCComment` records
   *
   * executed in the order they are defined
   */
  orderBy?: InputMaybe<Array<OrderByInput>>;
  /**
   * paginate `FDCComment` records
   *
   * using `paginate` may require multiple requests to get all possible results,
   * but will give more fine-grain control in the event all records cannot be
   * returned gracefully
   */
  paginate?: InputMaybe<PaginationInput>;
  text?: InputMaybe<StringFilter>;
  userId?: InputMaybe<StringFilter>;
};

/** response metadata for a list query of FDCComment records */
export type FdcCommentListResponse = {
  __typename: 'FDCCommentListResponse';
  /** the total count of FDCComment records matching any configured filters */
  count: Scalars['Int'];
  /** the total count of paginated groups of FDCComment */
  pages: Scalars['Int'];
  /** FDCComment records */
  records: Array<FdcComment>;
};

/**
 * concurrence groups hold users and roles
 * allowed to concur on, or reject, the concurrence level of a Field Design Change,
 * on behalf of the group
 *
 * when all concurrence groups associated with a project have concurred on the
 * concurrence level, the Field Design Change advances to Pending Approvals
 */
export type FdcConcurrenceGroup = {
  __typename: 'FDCConcurrenceGroup';
  /** the date this record was inserted into the database */
  createdDate: Scalars['DateTime'];
  /**
   * the email address of a user associated with the `createdDate`
   *
   * this value will be `unknown` if the `createdDate` was not set by a user
   */
  createdUser: Scalars['String'];
  /** describes whether the record has been soft-deleted or not */
  deleted: Scalars['Boolean'];
  /** the date this record was soft-deleted in the database */
  deletedDate: Maybe<Scalars['DateTime']>;
  /**
   * the email address of a user associated with the `deletedDate`
   *
   * this value will be `system` if the `deletedDate` was not set by a user
   */
  deletedUser: Maybe<Scalars['String']>;
  /**
   * an extended description associated with the record
   *
   * this description will be used to describe the record in CIMS, where possible
   */
  description: Maybe<Scalars['String']>;
  fdcToFDCConcurrenceGroups: Array<FdcToFdcConcurrenceGroup>;
  /** a UUID used to globally identify this record in the database */
  id: Scalars['String'];
  /** the date this record was last updated in the database */
  lastEditedDate: Scalars['DateTime'];
  /**
   * the email address of a user associated with the `lastEditedDate`
   *
   * this value will be `system` if the `lastEditedDate` was not set by a user
   */
  lastEditedUser: Scalars['String'];
  /** a human readable name associated with the record */
  name: Scalars['String'];
  /** a related `Project` */
  project: Project;
  /** the `globalId` of a related `Project` */
  projectId: Scalars['String'];
  /** `Role` records with permission to concur on, or reject the associated `FDCConcurrenceLevel` of a `FieldDesignChange` on behalf of their `FDCConcurrenceGroup` */
  roles: Array<Role>;
  /** `User` records with permission to concur on, or reject the associated `FDCConcurrenceLevel` of a `FieldDesignChange` on behalf of their `FDCConcurrenceGroup` */
  users: Array<User>;
};


/**
 * concurrence groups hold users and roles
 * allowed to concur on, or reject, the concurrence level of a Field Design Change,
 * on behalf of the group
 *
 * when all concurrence groups associated with a project have concurred on the
 * concurrence level, the Field Design Change advances to Pending Approvals
 */
export type FdcConcurrenceGroupFdcToFdcConcurrenceGroupsArgs = {
  fdcToFDCConcurrenceGroupFieldInput?: InputMaybe<FdcToFdcConcurrenceGroupFieldInput>;
};


/**
 * concurrence groups hold users and roles
 * allowed to concur on, or reject, the concurrence level of a Field Design Change,
 * on behalf of the group
 *
 * when all concurrence groups associated with a project have concurred on the
 * concurrence level, the Field Design Change advances to Pending Approvals
 */
export type FdcConcurrenceGroupRolesArgs = {
  roleFieldInput?: InputMaybe<RoleFieldInput>;
};


/**
 * concurrence groups hold users and roles
 * allowed to concur on, or reject, the concurrence level of a Field Design Change,
 * on behalf of the group
 *
 * when all concurrence groups associated with a project have concurred on the
 * concurrence level, the Field Design Change advances to Pending Approvals
 */
export type FdcConcurrenceGroupUsersArgs = {
  userFieldInput?: InputMaybe<UserFieldInput>;
};

/**
 * helps filter multiple `FDCConcurrenceGroup` records
 *
 * this version of the input will have limited options compared to its other counterpart
 */
export type FdcConcurrenceGroupFieldInput = {
  createdDate?: InputMaybe<DateTimeFilter>;
  /**
   * determines now to handle deleted `FDCConcurrenceGroup` records
   *
   * - when `true`, only return deleted records
   * - when `false`, do not return deleted records
   * - when omitted, `deleted` is ignored
   */
  deleted?: InputMaybe<Scalars['Boolean']>;
  description?: InputMaybe<StringFilter>;
  lastEditedDate?: InputMaybe<DateTimeFilter>;
  name?: InputMaybe<StringFilter>;
  /**
   * how to order `FDCConcurrenceGroup` records
   *
   * executed in the order they are defined
   */
  orderBy?: InputMaybe<Array<OrderByInput>>;
  projectId?: InputMaybe<StringFilter>;
  /**
   * specifies how many records to return
   *
   * analogous to `limit`, `first`, or `top` in SQL dialects
   */
  take?: InputMaybe<Scalars['Int']>;
};

/** helps filter multiple `FDCConcurrenceGroup` records */
export type FdcConcurrenceGroupListInput = {
  createdDate?: InputMaybe<DateTimeFilter>;
  /**
   * determines now to handle deleted `FDCConcurrenceGroup` records
   *
   * - when `true`, only return deleted records
   * - when `false`, do not return deleted records
   * - when omitted, `deleted` is ignored
   */
  deleted?: InputMaybe<Scalars['Boolean']>;
  description?: InputMaybe<StringFilter>;
  lastEditedDate?: InputMaybe<DateTimeFilter>;
  name?: InputMaybe<StringFilter>;
  /**
   * how to order `FDCConcurrenceGroup` records
   *
   * executed in the order they are defined
   */
  orderBy?: InputMaybe<Array<OrderByInput>>;
  /**
   * paginate `FDCConcurrenceGroup` records
   *
   * using `paginate` may require multiple requests to get all possible results,
   * but will give more fine-grain control in the event all records cannot be
   * returned gracefully
   */
  paginate?: InputMaybe<PaginationInput>;
  projectId?: InputMaybe<StringFilter>;
};

/** response metadata for a list query of FDCConcurrenceGroup records */
export type FdcConcurrenceGroupListResponse = {
  __typename: 'FDCConcurrenceGroupListResponse';
  /** the total count of FDCConcurrenceGroup records matching any configured filters */
  count: Scalars['Int'];
  /** the total count of paginated groups of FDCConcurrenceGroup */
  pages: Scalars['Int'];
  /** FDCConcurrenceGroup records */
  records: Array<FdcConcurrenceGroup>;
};

/**
 * a single concurrence level is associated
 * with a Field Design Change
 *
 * users and roles in concurrence groups are responsible for concurring on, or
 * rejecting, the concurrence level of the Field Design Change for their group
 *
 * every group will appear, regardless of the concurrence level
 *
 * when all groups concur on the Field Design Change, it moves to Pending Approvals and
 * the approval groups associated with its concurrence level will be available
 * for approval for users and roles associated with each approval group
 */
export type FdcConcurrenceLevel = {
  __typename: 'FDCConcurrenceLevel';
  approvalGroups: Array<FdcApprovalGroup>;
  /** the date this record was inserted into the database */
  createdDate: Scalars['DateTime'];
  /**
   * the email address of a user associated with the `createdDate`
   *
   * this value will be `unknown` if the `createdDate` was not set by a user
   */
  createdUser: Scalars['String'];
  /** describes whether the record has been soft-deleted or not */
  deleted: Scalars['Boolean'];
  /** the date this record was soft-deleted in the database */
  deletedDate: Maybe<Scalars['DateTime']>;
  /**
   * the email address of a user associated with the `deletedDate`
   *
   * this value will be `system` if the `deletedDate` was not set by a user
   */
  deletedUser: Maybe<Scalars['String']>;
  /**
   * an extended description associated with the record
   *
   * this description will be used to describe the record in CIMS, where possible
   */
  description: Maybe<Scalars['String']>;
  fieldDesignChanges: Array<FieldDesignChange>;
  /** a UUID used to globally identify this record in the database */
  id: Scalars['String'];
  /** the date this record was last updated in the database */
  lastEditedDate: Scalars['DateTime'];
  /**
   * the email address of a user associated with the `lastEditedDate`
   *
   * this value will be `system` if the `lastEditedDate` was not set by a user
   */
  lastEditedUser: Scalars['String'];
  /** a human readable name associated with the record */
  name: Scalars['String'];
  /** a related `Project` */
  project: Project;
  /** the `globalId` of a related `Project` */
  projectId: Scalars['String'];
  sideEffect: Maybe<Scalars['String']>;
  /** the `id` of a related `FDCConcurrenceLevelSideEffect` */
  sideEffectId: Maybe<Scalars['String']>;
};


/**
 * a single concurrence level is associated
 * with a Field Design Change
 *
 * users and roles in concurrence groups are responsible for concurring on, or
 * rejecting, the concurrence level of the Field Design Change for their group
 *
 * every group will appear, regardless of the concurrence level
 *
 * when all groups concur on the Field Design Change, it moves to Pending Approvals and
 * the approval groups associated with its concurrence level will be available
 * for approval for users and roles associated with each approval group
 */
export type FdcConcurrenceLevelApprovalGroupsArgs = {
  fdcApprovalGroupFieldInput?: InputMaybe<FdcApprovalGroupFieldInput>;
};


/**
 * a single concurrence level is associated
 * with a Field Design Change
 *
 * users and roles in concurrence groups are responsible for concurring on, or
 * rejecting, the concurrence level of the Field Design Change for their group
 *
 * every group will appear, regardless of the concurrence level
 *
 * when all groups concur on the Field Design Change, it moves to Pending Approvals and
 * the approval groups associated with its concurrence level will be available
 * for approval for users and roles associated with each approval group
 */
export type FdcConcurrenceLevelFieldDesignChangesArgs = {
  fieldDesignChangeFieldInput?: InputMaybe<FieldDesignChangeFieldInput>;
};

/**
 * helps filter multiple `FDCConcurrenceLevel` records
 *
 * this version of the input will have limited options compared to its other counterpart
 */
export type FdcConcurrenceLevelFieldInput = {
  createdDate?: InputMaybe<DateTimeFilter>;
  /**
   * determines now to handle deleted `FDCConcurrenceLevel` records
   *
   * - when `true`, only return deleted records
   * - when `false`, do not return deleted records
   * - when omitted, `deleted` is ignored
   */
  deleted?: InputMaybe<Scalars['Boolean']>;
  description?: InputMaybe<StringFilter>;
  lastEditedDate?: InputMaybe<DateTimeFilter>;
  name?: InputMaybe<StringFilter>;
  /**
   * how to order `FDCConcurrenceLevel` records
   *
   * executed in the order they are defined
   */
  orderBy?: InputMaybe<Array<OrderByInput>>;
  projectId?: InputMaybe<StringFilter>;
  sideEffectId?: InputMaybe<StringFilter>;
  /**
   * specifies how many records to return
   *
   * analogous to `limit`, `first`, or `top` in SQL dialects
   */
  take?: InputMaybe<Scalars['Int']>;
};

/** helps filter multiple `FDCConcurrenceLevel` records */
export type FdcConcurrenceLevelListInput = {
  createdDate?: InputMaybe<DateTimeFilter>;
  /**
   * determines now to handle deleted `FDCConcurrenceLevel` records
   *
   * - when `true`, only return deleted records
   * - when `false`, do not return deleted records
   * - when omitted, `deleted` is ignored
   */
  deleted?: InputMaybe<Scalars['Boolean']>;
  description?: InputMaybe<StringFilter>;
  lastEditedDate?: InputMaybe<DateTimeFilter>;
  name?: InputMaybe<StringFilter>;
  /**
   * how to order `FDCConcurrenceLevel` records
   *
   * executed in the order they are defined
   */
  orderBy?: InputMaybe<Array<OrderByInput>>;
  /**
   * paginate `FDCConcurrenceLevel` records
   *
   * using `paginate` may require multiple requests to get all possible results,
   * but will give more fine-grain control in the event all records cannot be
   * returned gracefully
   */
  paginate?: InputMaybe<PaginationInput>;
  projectId?: InputMaybe<StringFilter>;
  sideEffectId?: InputMaybe<StringFilter>;
};

/** response metadata for a list query of FDCConcurrenceLevel records */
export type FdcConcurrenceLevelListResponse = {
  __typename: 'FDCConcurrenceLevelListResponse';
  /** the total count of FDCConcurrenceLevel records matching any configured filters */
  count: Scalars['Int'];
  /** the total count of paginated groups of FDCConcurrenceLevel */
  pages: Scalars['Int'];
  /** FDCConcurrenceLevel records */
  records: Array<FdcConcurrenceLevel>;
};

/** allows users to select a list of suggested disciplines which should review the Field Design Change before final approval */
export type FdcDiscipline = {
  __typename: 'FDCDiscipline';
  /** the date this record was inserted into the database */
  createdDate: Scalars['DateTime'];
  /**
   * the email address of a user associated with the `createdDate`
   *
   * this value will be `unknown` if the `createdDate` was not set by a user
   */
  createdUser: Scalars['String'];
  /** describes whether the record has been soft-deleted or not */
  deleted: Scalars['Boolean'];
  /** the date this record was soft-deleted in the database */
  deletedDate: Maybe<Scalars['DateTime']>;
  /**
   * the email address of a user associated with the `deletedDate`
   *
   * this value will be `system` if the `deletedDate` was not set by a user
   */
  deletedUser: Maybe<Scalars['String']>;
  /**
   * an extended description associated with the record
   *
   * this description will be used to describe the record in CIMS, where possible
   */
  description: Maybe<Scalars['String']>;
  fieldDesignChanges: Array<FieldDesignChange>;
  /** a UUID used to globally identify this record in the database */
  id: Scalars['String'];
  /** the date this record was last updated in the database */
  lastEditedDate: Scalars['DateTime'];
  /**
   * the email address of a user associated with the `lastEditedDate`
   *
   * this value will be `system` if the `lastEditedDate` was not set by a user
   */
  lastEditedUser: Scalars['String'];
  /** a human readable name associated with the record */
  name: Scalars['String'];
  /** a related `Project` */
  project: Project;
  /** the `globalId` of a related `Project` */
  projectId: Scalars['String'];
};


/** allows users to select a list of suggested disciplines which should review the Field Design Change before final approval */
export type FdcDisciplineFieldDesignChangesArgs = {
  fieldDesignChangeFieldInput?: InputMaybe<FieldDesignChangeFieldInput>;
};

/**
 * helps filter multiple `FDCDiscipline` records
 *
 * this version of the input will have limited options compared to its other counterpart
 */
export type FdcDisciplineFieldInput = {
  createdDate?: InputMaybe<DateTimeFilter>;
  /**
   * determines now to handle deleted `FDCDiscipline` records
   *
   * - when `true`, only return deleted records
   * - when `false`, do not return deleted records
   * - when omitted, `deleted` is ignored
   */
  deleted?: InputMaybe<Scalars['Boolean']>;
  description?: InputMaybe<StringFilter>;
  lastEditedDate?: InputMaybe<DateTimeFilter>;
  name?: InputMaybe<StringFilter>;
  /**
   * how to order `FDCDiscipline` records
   *
   * executed in the order they are defined
   */
  orderBy?: InputMaybe<Array<OrderByInput>>;
  projectId?: InputMaybe<StringFilter>;
  /**
   * specifies how many records to return
   *
   * analogous to `limit`, `first`, or `top` in SQL dialects
   */
  take?: InputMaybe<Scalars['Int']>;
};

/** helps filter multiple `FDCDiscipline` records */
export type FdcDisciplineListInput = {
  createdDate?: InputMaybe<DateTimeFilter>;
  /**
   * determines now to handle deleted `FDCDiscipline` records
   *
   * - when `true`, only return deleted records
   * - when `false`, do not return deleted records
   * - when omitted, `deleted` is ignored
   */
  deleted?: InputMaybe<Scalars['Boolean']>;
  description?: InputMaybe<StringFilter>;
  lastEditedDate?: InputMaybe<DateTimeFilter>;
  name?: InputMaybe<StringFilter>;
  /**
   * how to order `FDCDiscipline` records
   *
   * executed in the order they are defined
   */
  orderBy?: InputMaybe<Array<OrderByInput>>;
  /**
   * paginate `FDCDiscipline` records
   *
   * using `paginate` may require multiple requests to get all possible results,
   * but will give more fine-grain control in the event all records cannot be
   * returned gracefully
   */
  paginate?: InputMaybe<PaginationInput>;
  projectId?: InputMaybe<StringFilter>;
};

/** response metadata for a list query of FDCDiscipline records */
export type FdcDisciplineListResponse = {
  __typename: 'FDCDisciplineListResponse';
  /** the total count of FDCDiscipline records matching any configured filters */
  count: Scalars['Int'];
  /** the total count of paginated groups of FDCDiscipline */
  pages: Scalars['Int'];
  /** FDCDiscipline records */
  records: Array<FdcDiscipline>;
};

/**
 * notifications hold a recipients configuration for a given
 * notification event in FDC Tracker workflows
 *
 * recipients can be users, or non user emails
 *
 * certain events may require users to receive a notification if they are given permission
 * to perform a specific task
 */
export type FdcNotification = {
  __typename: 'FDCNotification';
  /** the date this record was inserted into the database */
  createdDate: Scalars['DateTime'];
  /**
   * the email address of a user associated with the `createdDate`
   *
   * this value will be `unknown` if the `createdDate` was not set by a user
   */
  createdUser: Scalars['String'];
  /** the date this record was last updated in the database */
  lastEditedDate: Scalars['DateTime'];
  /**
   * the email address of a user associated with the `lastEditedDate`
   *
   * this value will be `system` if the `lastEditedDate` was not set by a user
   */
  lastEditedUser: Scalars['String'];
  /** the name of the notification event associated with this Notification */
  notificationEvent: Scalars['String'];
  notificationEventId: Scalars['String'];
  /** a related `Project` */
  project: Project;
  /** the `globalId` of a related `Project` */
  projectId: Scalars['String'];
  recipients: FdcNotificationRecipients;
};

/**
 * helps filter multiple `FDCNotification` records
 *
 * this version of the input will have limited options compared to its other counterpart
 */
export type FdcNotificationFieldInput = {
  createdDate?: InputMaybe<DateTimeFilter>;
  lastEditedDate?: InputMaybe<DateTimeFilter>;
  notificationEventId?: InputMaybe<StringFilter>;
  /**
   * how to order `FDCNotification` records
   *
   * executed in the order they are defined
   */
  orderBy?: InputMaybe<Array<OrderByInput>>;
  projectId?: InputMaybe<StringFilter>;
  /**
   * specifies how many records to return
   *
   * analogous to `limit`, `first`, or `top` in SQL dialects
   */
  take?: InputMaybe<Scalars['Int']>;
};

/** helps filter multiple `FDCNotification` records */
export type FdcNotificationListInput = {
  createdDate?: InputMaybe<DateTimeFilter>;
  lastEditedDate?: InputMaybe<DateTimeFilter>;
  notificationEventId?: InputMaybe<StringFilter>;
  /**
   * how to order `FDCNotification` records
   *
   * executed in the order they are defined
   */
  orderBy?: InputMaybe<Array<OrderByInput>>;
  /**
   * paginate `FDCNotification` records
   *
   * using `paginate` may require multiple requests to get all possible results,
   * but will give more fine-grain control in the event all records cannot be
   * returned gracefully
   */
  paginate?: InputMaybe<PaginationInput>;
  projectId?: InputMaybe<StringFilter>;
};

/** response metadata for a list query of FDCNotification records */
export type FdcNotificationListResponse = {
  __typename: 'FDCNotificationListResponse';
  /** the total count of FDCNotification records matching any configured filters */
  count: Scalars['Int'];
  /** the total count of paginated groups of FDCNotification */
  pages: Scalars['Int'];
  /** FDCNotification records */
  records: Array<FdcNotification>;
};

export type FdcNotificationRecipients = {
  __typename: 'FDCNotificationRecipients';
  /**
   * only present in Any Approval
   *
   * when a specific approval group is approved, regardless of concurrence level
   */
  byApprovalGroup: Array<ByFdcApprovalGroup>;
  /**
   * only present in Any Level Concurrence
   *
   * when a specific concurrence group is concurred on, regardless of concurrence level
   */
  byConcurrenceGroup: Array<ByFdcConcurrenceGroup>;
  /** all field design changes of a specific concurrence level */
  byConcurrenceLevel: Array<ByFdcConcurrenceLevel>;
  /**
   * only present in Any Approval
   *
   * when a specific approval group is approved, for a specific concurrence level
   */
  byConcurrenceLevelAndApprovalGroup: Array<ByFdcConcurrenceLevelAndApprovalGroup>;
  /**
   * only present in Any Level Concurrence
   *
   * when a specific concurrence group is concurred on, for a specific concurrence level
   */
  byConcurrenceLevelAndConcurrenceGroup: Array<ByFdcConcurrenceLevelAndConcurrenceGroup>;
  every: Maybe<Recipients>;
};


export type FdcNotificationRecipientsByApprovalGroupArgs = {
  fdcApprovalGroupFieldInput?: InputMaybe<FdcApprovalGroupFieldInput>;
};


export type FdcNotificationRecipientsByConcurrenceGroupArgs = {
  fdcConcurrenceGroupFieldInput?: InputMaybe<FdcConcurrenceGroupFieldInput>;
};


export type FdcNotificationRecipientsByConcurrenceLevelArgs = {
  fdcConcurrenceLevelFieldInput?: InputMaybe<FdcConcurrenceLevelFieldInput>;
};


export type FdcNotificationRecipientsByConcurrenceLevelAndApprovalGroupArgs = {
  fdcApprovalGroupFieldInput?: InputMaybe<FdcApprovalGroupFieldInput>;
  fdcConcurrenceLevelFieldInput?: InputMaybe<FdcConcurrenceLevelFieldInput>;
};


export type FdcNotificationRecipientsByConcurrenceLevelAndConcurrenceGroupArgs = {
  fdcConcurrenceGroupFieldInput?: InputMaybe<FdcConcurrenceGroupFieldInput>;
  fdcConcurrenceLevelFieldInput?: InputMaybe<FdcConcurrenceLevelFieldInput>;
};

/**
 * `FDCQuickLink` records are used in the External Link Editor to allow users
 * to quickly add external links to the `externalLinks` field of a `FieldDesignChange`
 *
 * `FDCQuickLink` records used in `externalLinks` are not referenced by `id`, but copied
 * as they are currently defined
 *
 * changes made to any `FDCQuickLink` record will not affect the `externalLinks` of the `FieldDesignChange`
 */
export type FdcQuickLink = {
  __typename: 'FDCQuickLink';
  /** the date this record was inserted into the database */
  createdDate: Scalars['DateTime'];
  /**
   * the email address of a user associated with the `createdDate`
   *
   * this value will be `unknown` if the `createdDate` was not set by a user
   */
  createdUser: Scalars['String'];
  /** describes whether the record has been soft-deleted or not */
  deleted: Scalars['Boolean'];
  /** the date this record was soft-deleted in the database */
  deletedDate: Maybe<Scalars['DateTime']>;
  /**
   * the email address of a user associated with the `deletedDate`
   *
   * this value will be `system` if the `deletedDate` was not set by a user
   */
  deletedUser: Maybe<Scalars['String']>;
  /**
   * an extended description associated with the record
   *
   * this description will be used to describe the record in CIMS, where possible
   */
  description: Maybe<Scalars['String']>;
  /** an optional link associated with the `label` */
  href: Maybe<Scalars['String']>;
  /** a UUID used to globally identify this record in the database */
  id: Scalars['String'];
  /** the human readable link text */
  label: Scalars['String'];
  /** the date this record was last updated in the database */
  lastEditedDate: Scalars['DateTime'];
  /**
   * the email address of a user associated with the `lastEditedDate`
   *
   * this value will be `system` if the `lastEditedDate` was not set by a user
   */
  lastEditedUser: Scalars['String'];
  project: Project;
  /** the `globalId` of a related `Project` */
  projectId: Scalars['String'];
};

/**
 * helps filter multiple `FDCQuickLink` records
 *
 * this version of the input will have limited options compared to its other counterpart
 */
export type FdcQuickLinkFieldInput = {
  createdDate?: InputMaybe<DateTimeFilter>;
  /**
   * determines now to handle deleted `FDCQuickLink` records
   *
   * - when `true`, only return deleted records
   * - when `false`, do not return deleted records
   * - when omitted, `deleted` is ignored
   */
  deleted?: InputMaybe<Scalars['Boolean']>;
  description?: InputMaybe<StringFilter>;
  href?: InputMaybe<StringFilter>;
  id?: InputMaybe<StringFilter>;
  label?: InputMaybe<StringFilter>;
  lastEditedDate?: InputMaybe<DateTimeFilter>;
  /**
   * how to order `FDCQuickLink` records
   *
   * executed in the order they are defined
   */
  orderBy?: InputMaybe<Array<OrderByInput>>;
  projectId?: InputMaybe<StringFilter>;
  /**
   * specifies how many records to return
   *
   * analogous to `limit`, `first`, or `top` in SQL dialects
   */
  take?: InputMaybe<Scalars['Int']>;
};

/** helps filter multiple `FDCQuickLink` records */
export type FdcQuickLinkListInput = {
  createdDate?: InputMaybe<DateTimeFilter>;
  /**
   * determines now to handle deleted `FDCQuickLink` records
   *
   * - when `true`, only return deleted records
   * - when `false`, do not return deleted records
   * - when omitted, `deleted` is ignored
   */
  deleted?: InputMaybe<Scalars['Boolean']>;
  description?: InputMaybe<StringFilter>;
  href?: InputMaybe<StringFilter>;
  id?: InputMaybe<StringFilter>;
  label?: InputMaybe<StringFilter>;
  lastEditedDate?: InputMaybe<DateTimeFilter>;
  /**
   * how to order `FDCQuickLink` records
   *
   * executed in the order they are defined
   */
  orderBy?: InputMaybe<Array<OrderByInput>>;
  /**
   * paginate `FDCQuickLink` records
   *
   * using `paginate` may require multiple requests to get all possible results,
   * but will give more fine-grain control in the event all records cannot be
   * returned gracefully
   */
  paginate?: InputMaybe<PaginationInput>;
  projectId?: InputMaybe<StringFilter>;
};

/** response metadata for a list query of FDCQuickLink records */
export type FdcQuickLinkListResponse = {
  __typename: 'FDCQuickLinkListResponse';
  /** the total count of FDCQuickLink records matching any configured filters */
  count: Scalars['Int'];
  /** the total count of paginated groups of FDCQuickLink */
  pages: Scalars['Int'];
  /** FDCQuickLink records */
  records: Array<FdcQuickLink>;
};

export type FdcToFdcApprovalGroup = {
  __typename: 'FDCToFDCApprovalGroup';
  approvalBy: User;
  /** the `id` of a related `User` */
  approvalById: Scalars['String'];
  /** the date this record was approved in the database */
  approvalDate: Scalars['DateTime'];
  approvalGroup: FdcApprovalGroup;
  /** the `id` of a related `FDCApprovalGroup` */
  approvalGroupId: Scalars['String'];
  /** the approval state of the related `FDCApprovalGroup` and `FieldDesignChange` */
  approved: Scalars['Boolean'];
  fieldDesignChange: FieldDesignChange;
  /** the `id` of a related `FieldDesignChange` */
  fieldDesignChangeId: Scalars['String'];
};

/**
 * helps filter multiple `FDCToFDCApprovalGroup` records
 *
 * this version of the input will have limited options compared to its other counterpart
 */
export type FdcToFdcApprovalGroupFieldInput = {
  approvalById?: InputMaybe<StringFilter>;
  approvalDate?: InputMaybe<DateTimeFilter>;
  approvalGroupId?: InputMaybe<StringFilter>;
  /**
   * - when `true`, `accepted` is truthy
   * - when `false`, `accepted` is falsy
   * - when omitted, `accepted` is ignored
   */
  approved?: InputMaybe<Scalars['Boolean']>;
  fieldDesignChangeId?: InputMaybe<StringFilter>;
  /**
   * how to order `FDCToFDCApprovalGroup` records
   *
   * executed in the order they are defined
   */
  orderBy?: InputMaybe<Array<OrderByInput>>;
  /**
   * specifies how many records to return
   *
   * analogous to `limit`, `first`, or `top` in SQL dialects
   */
  take?: InputMaybe<Scalars['Int']>;
};

/** helps filter multiple `FDCToFDCApprovalGroup` records */
export type FdcToFdcApprovalGroupListInput = {
  approvalById?: InputMaybe<StringFilter>;
  approvalDate?: InputMaybe<DateTimeFilter>;
  approvalGroupId?: InputMaybe<StringFilter>;
  /**
   * - when `true`, `accepted` is truthy
   * - when `false`, `accepted` is falsy
   * - when omitted, `accepted` is ignored
   */
  approved?: InputMaybe<Scalars['Boolean']>;
  fieldDesignChangeId?: InputMaybe<StringFilter>;
  /**
   * how to order `FDCToFDCApprovalGroup` records
   *
   * executed in the order they are defined
   */
  orderBy?: InputMaybe<Array<OrderByInput>>;
  /**
   * paginate `FDCToFDCApprovalGroup` records
   *
   * using `paginate` may require multiple requests to get all possible results,
   * but will give more fine-grain control in the event all records cannot be
   * returned gracefully
   */
  paginate?: InputMaybe<PaginationInput>;
};

/** response metadata for a list query of FDCToFDCApprovalGroup records */
export type FdcToFdcApprovalGroupListResponse = {
  __typename: 'FDCToFDCApprovalGroupListResponse';
  /** the total count of FDCToFDCApprovalGroup records matching any configured filters */
  count: Scalars['Int'];
  /** the total count of paginated groups of FDCToFDCApprovalGroup */
  pages: Scalars['Int'];
  /** FDCToFDCApprovalGroup records */
  records: Array<FdcToFdcApprovalGroup>;
};

export type FdcToFdcConcurrenceGroup = {
  __typename: 'FDCToFDCConcurrenceGroup';
  /** the concurrence state of the related `FDCConcurrenceGroup` and `FieldDesignChange` */
  concurred: Scalars['Boolean'];
  concurrenceBy: User;
  /** the `id` of a related `User` */
  concurrenceById: Scalars['String'];
  /** the date this record was concurred on in the database */
  concurrenceDate: Scalars['DateTime'];
  concurrenceGroup: FdcConcurrenceGroup;
  /** the `id` of a related `FDCConcurrenceGroup` */
  concurrenceGroupId: Scalars['String'];
  fieldDesignChange: FieldDesignChange;
  /** the `id` of a related `FieldDesignChange` */
  fieldDesignChangeId: Scalars['String'];
};

/**
 * helps filter multiple `FDCToFDCConcurrenceGroup` records
 *
 * this version of the input will have limited options compared to its other counterpart
 */
export type FdcToFdcConcurrenceGroupFieldInput = {
  /**
   * - when `true`, `concurred` is truthy
   * - when `false`, `concurred` is falsy
   * - when omitted, `concurred` is ignored
   */
  concurred?: InputMaybe<Scalars['Boolean']>;
  concurrenceById?: InputMaybe<StringFilter>;
  concurrenceDate?: InputMaybe<DateTimeFilter>;
  concurrenceGroupId?: InputMaybe<StringFilter>;
  fieldDesignChangeId?: InputMaybe<StringFilter>;
  /**
   * how to order `FDCToFDCConcurrenceGroup` records
   *
   * executed in the order they are defined
   */
  orderBy?: InputMaybe<Array<OrderByInput>>;
  /**
   * specifies how many records to return
   *
   * analogous to `limit`, `first`, or `top` in SQL dialects
   */
  take?: InputMaybe<Scalars['Int']>;
};

/** helps filter multiple `FDCToFDCConcurrenceGroup` records */
export type FdcToFdcConcurrenceGroupListInput = {
  /**
   * - when `true`, `concurred` is truthy
   * - when `false`, `concurred` is falsy
   * - when omitted, `concurred` is ignored
   */
  concurred?: InputMaybe<Scalars['Boolean']>;
  concurrenceById?: InputMaybe<StringFilter>;
  concurrenceDate?: InputMaybe<DateTimeFilter>;
  concurrenceGroupId?: InputMaybe<StringFilter>;
  fieldDesignChangeId?: InputMaybe<StringFilter>;
  /**
   * how to order `FDCToFDCConcurrenceGroup` records
   *
   * executed in the order they are defined
   */
  orderBy?: InputMaybe<Array<OrderByInput>>;
  /**
   * paginate `FDCToFDCConcurrenceGroup` records
   *
   * using `paginate` may require multiple requests to get all possible results,
   * but will give more fine-grain control in the event all records cannot be
   * returned gracefully
   */
  paginate?: InputMaybe<PaginationInput>;
};

/** response metadata for a list query of FDCToFDCConcurrenceGroup records */
export type FdcToFdcConcurrenceGroupListResponse = {
  __typename: 'FDCToFDCConcurrenceGroupListResponse';
  /** the total count of FDCToFDCConcurrenceGroup records matching any configured filters */
  count: Scalars['Int'];
  /** the total count of paginated groups of FDCToFDCConcurrenceGroup */
  pages: Scalars['Int'];
  /** FDCToFDCConcurrenceGroup records */
  records: Array<FdcToFdcConcurrenceGroup>;
};

/** `FDCToPayItemNoGeometry` helps connect many `FieldDesignChange` records with many `PayItemNoGeometry` records */
export type FdcToPayItemNoGeometry = {
  __typename: 'FDCToPayItemNoGeometry';
  fieldDesignChange: FieldDesignChange;
  /** the `id` of a related `FieldDesignChange` */
  fieldDesignChangeId: Scalars['String'];
  payItem: PayItemNoGeometry;
  /** the `globalId` of a related `PayItemNoGeometry` */
  payItemId: Scalars['String'];
};

/**
 * helps filter multiple `FDCToPayItemNoGeometry` records
 *
 * this version of the input will have limited options compared to its other counterpart
 */
export type FdcToPayItemNoGeometryFieldInput = {
  fieldDesignChangeId?: InputMaybe<StringFilter>;
  /**
   * how to order `FDCToPayItemNoGeometry` records
   *
   * executed in the order they are defined
   */
  orderBy?: InputMaybe<Array<OrderByInput>>;
  payItemId?: InputMaybe<StringFilter>;
  /**
   * specifies how many records to return
   *
   * analogous to `limit`, `first`, or `top` in SQL dialects
   */
  take?: InputMaybe<Scalars['Int']>;
};

/** helps filter multiple `FDCToPayItemNoGeometry` records */
export type FdcToPayItemNoGeometryListInput = {
  fieldDesignChangeId?: InputMaybe<StringFilter>;
  /**
   * how to order `FDCToPayItemNoGeometry` records
   *
   * executed in the order they are defined
   */
  orderBy?: InputMaybe<Array<OrderByInput>>;
  /**
   * paginate `FDCToPayItemNoGeometry` records
   *
   * using `paginate` may require multiple requests to get all possible results,
   * but will give more fine-grain control in the event all records cannot be
   * returned gracefully
   */
  paginate?: InputMaybe<PaginationInput>;
  payItemId?: InputMaybe<StringFilter>;
};

/** response metadata for a list query of FDCToPayItemNoGeometry records */
export type FdcToPayItemNoGeometryListResponse = {
  __typename: 'FDCToPayItemNoGeometryListResponse';
  /** the total count of FDCToPayItemNoGeometry records matching any configured filters */
  count: Scalars['Int'];
  /** the total count of paginated groups of FDCToPayItemNoGeometry */
  pages: Scalars['Int'];
  /** FDCToPayItemNoGeometry records */
  records: Array<FdcToPayItemNoGeometry>;
};

export type FieldDesignChange = {
  __typename: 'FieldDesignChange';
  comments: Array<FdcComment>;
  concurrenceLevel: Maybe<FdcConcurrenceLevel>;
  /** the `id` of a related `FDCConcurrenceLevel` */
  concurrenceLevelId: Maybe<Scalars['String']>;
  /** the date this record was inserted into the database */
  createdDate: Scalars['DateTime'];
  /**
   * the email address of a user associated with the `createdDate`
   *
   * this value will be `unknown` if the `createdDate` was not set by a user
   */
  createdUser: Scalars['String'];
  /**
   * custom fields are defined, configured, and activated for `FieldDesignChange`
   *     records in the Administration module
   *
   *     values are saved and retrieved for each individual `FieldDesignChange`
   */
  customFields: CustomFields;
  /** describes whether the record has been soft-deleted or not */
  deleted: Scalars['Boolean'];
  /** the date this record was soft-deleted in the database */
  deletedDate: Maybe<Scalars['DateTime']>;
  /**
   * the email address of a user associated with the `deletedDate`
   *
   * this value will be `system` if the `deletedDate` was not set by a user
   */
  deletedUser: Maybe<Scalars['String']>;
  designSubmittals: Array<DesignSubmittal>;
  disciplines: Array<FdcDiscipline>;
  /** allows users to list construction plan sets, with sheet numbers, where the proposed construction will deviate from the current project design */
  drawingsAffected: Maybe<Scalars['String']>;
  externalLinks: Array<ExternalLink>;
  fdcToFDCApprovalGroups: Array<FdcToFdcApprovalGroup>;
  fdcToFDCConcurrenceGroups: Array<FdcToFdcConcurrenceGroup>;
  fdcToPayItemNoGeometries: Array<FdcToPayItemNoGeometry>;
  /** the `number` prefixed with "FDC" */
  formattedNumber: Scalars['String'];
  /** a UUID used to globally identify this record in the database */
  id: Scalars['String'];
  /** allows users to document the reason they want to deviate from the current project design. limited to 2000 characters */
  issue: Scalars['String'];
  /** the date this record was last updated in the database */
  lastEditedDate: Scalars['DateTime'];
  /**
   * the email address of a user associated with the `lastEditedDate`
   *
   * this value will be `system` if the `lastEditedDate` was not set by a user
   */
  lastEditedUser: Scalars['String'];
  /** allows users to document locations, stations, and offsets on the project where the Field Design Change is allowed to be made */
  location: Maybe<Scalars['String']>;
  /** a generated number for the `FieldDesignChange` */
  number: Scalars['Int'];
  project: Project;
  /** the `globalId` of a related `Project` */
  projectId: Scalars['String'];
  /** when the reviewers to respond by to prevent delays in construction */
  requestedApprovalDate: Maybe<Scalars['DateTime']>;
  requestedBy: Maybe<User>;
  /** the `id` of a related `User` which requests the `FieldDesignChange` */
  requestedById: Maybe<Scalars['String']>;
  /** allows users to propose a plan for how to construct the item differently from the current design and resolve the issue */
  resolution: Maybe<Scalars['String']>;
  /** pulls a `SharePointResource` object from SharePoint for the parent folder associated with this `FieldDesignChange` */
  sharePointResource: Maybe<SharePointResource>;
  sharePointResourceId: Maybe<Scalars['String']>;
  sharePointResourceWebUrl: Maybe<Scalars['String']>;
  /** allows users to list which construction and/or design specifications, with which  sections and sub-sections, should be referenced when reviewing the Field Design Change for approval */
  specsAffected: Maybe<Scalars['String']>;
  status: Scalars['String'];
  statusId: Scalars['String'];
  /** a `DateTime` which denotes when the `FieldDesignChange` was submitted */
  submittedDate: Maybe<Scalars['DateTime']>;
};


export type FieldDesignChangeCommentsArgs = {
  fdcCommentFieldInput?: InputMaybe<FdcCommentFieldInput>;
};


export type FieldDesignChangeDesignSubmittalsArgs = {
  designSubmittalFieldInput?: InputMaybe<DesignSubmittalFieldInput>;
};


export type FieldDesignChangeDisciplinesArgs = {
  fdcDisciplineFieldInput?: InputMaybe<FdcDisciplineFieldInput>;
};


export type FieldDesignChangeFdcToFdcApprovalGroupsArgs = {
  fdcToFDCApprovalGroupFieldInput?: InputMaybe<FdcToFdcApprovalGroupFieldInput>;
};


export type FieldDesignChangeFdcToFdcConcurrenceGroupsArgs = {
  fdcToFDCConcurrenceGroupFieldInput?: InputMaybe<FdcToFdcConcurrenceGroupFieldInput>;
};


export type FieldDesignChangeFdcToPayItemNoGeometriesArgs = {
  fdcFieldInput?: InputMaybe<FdcToPayItemNoGeometryFieldInput>;
};

/**
 * helps filter multiple `FieldDesignChange` records
 *
 * this version of the input will have limited options compared to its other counterpart
 */
export type FieldDesignChangeFieldInput = {
  concurrenceLevelId?: InputMaybe<StringFilter>;
  createdDate?: InputMaybe<DateTimeFilter>;
  /**
   * determines now to handle deleted `FieldDesignChange` records
   *
   * - when `true`, only return deleted records
   * - when `false`, do not return deleted records
   * - when omitted, `deleted` is ignored
   */
  deleted?: InputMaybe<Scalars['Boolean']>;
  drawingsAffected?: InputMaybe<StringFilter>;
  issue?: InputMaybe<StringFilter>;
  lastEditedDate?: InputMaybe<DateTimeFilter>;
  location?: InputMaybe<StringFilter>;
  number?: InputMaybe<IntFilter>;
  /**
   * how to order `FieldDesignChange` records
   *
   * executed in the order they are defined
   */
  orderBy?: InputMaybe<Array<OrderByInput>>;
  projectId?: InputMaybe<StringFilter>;
  requestedApprovalDate?: InputMaybe<DateTimeFilter>;
  requestedById?: InputMaybe<StringFilter>;
  resolution?: InputMaybe<StringFilter>;
  specsAffected?: InputMaybe<StringFilter>;
  submittedDate?: InputMaybe<DateTimeFilter>;
  /**
   * specifies how many records to return
   *
   * analogous to `limit`, `first`, or `top` in SQL dialects
   */
  take?: InputMaybe<Scalars['Int']>;
};

/** helps filter multiple `FieldDesignChange` records */
export type FieldDesignChangeListInput = {
  concurrenceLevelId?: InputMaybe<StringFilter>;
  createdDate?: InputMaybe<DateTimeFilter>;
  /**
   * determines now to handle deleted `FieldDesignChange` records
   *
   * - when `true`, only return deleted records
   * - when `false`, do not return deleted records
   * - when omitted, `deleted` is ignored
   */
  deleted?: InputMaybe<Scalars['Boolean']>;
  drawingsAffected?: InputMaybe<StringFilter>;
  issue?: InputMaybe<StringFilter>;
  lastEditedDate?: InputMaybe<DateTimeFilter>;
  location?: InputMaybe<StringFilter>;
  number?: InputMaybe<IntFilter>;
  /**
   * how to order `FieldDesignChange` records
   *
   * executed in the order they are defined
   */
  orderBy?: InputMaybe<Array<OrderByInput>>;
  /**
   * paginate `FieldDesignChange` records
   *
   * using `paginate` may require multiple requests to get all possible results,
   * but will give more fine-grain control in the event all records cannot be
   * returned gracefully
   */
  paginate?: InputMaybe<PaginationInput>;
  projectId?: InputMaybe<StringFilter>;
  requestedApprovalDate?: InputMaybe<DateTimeFilter>;
  requestedById?: InputMaybe<StringFilter>;
  resolution?: InputMaybe<StringFilter>;
  specsAffected?: InputMaybe<StringFilter>;
  submittedDate?: InputMaybe<DateTimeFilter>;
};

/** response metadata for a list query of FieldDesignChange records */
export type FieldDesignChangeListResponse = {
  __typename: 'FieldDesignChangeListResponse';
  /** the total count of FieldDesignChange records matching any configured filters */
  count: Scalars['Int'];
  /** the total count of paginated groups of FieldDesignChange */
  pages: Scalars['Int'];
  /** FieldDesignChange records */
  records: Array<FieldDesignChange>;
};

export type FilenameTemplateItem = {
  __typename: 'FilenameTemplateItem';
  type: Scalars['String'];
  value: Scalars['String'];
};

/**
 * filter options for `Float` values
 *
 * undefined
 *
 * only one filter will be active at a time
 *
 * filters are preferred in the following order
 *
 * - equals
 * - between
 * - greaterThan
 * - lessThan
 * - list
 * - null
 */
export type FloatFilter = {
  between?: InputMaybe<FloatFilterBetweenInput>;
  /** the field value equals the supplied value */
  equals?: InputMaybe<Scalars['Float']>;
  /** the supplied value is greater than the field value */
  greaterThan?: InputMaybe<Scalars['Float']>;
  /** the supplied value is less than the field value */
  lessThan?: InputMaybe<Scalars['Float']>;
  /** possible values of the field value */
  list?: InputMaybe<Array<Scalars['Float']>>;
  /**
   * filters based on the nullability of the field
   *
   * - if true: return records where the field value is null
   * - if false: return records where the field value is not null
   */
  null?: InputMaybe<Scalars['Boolean']>;
};

/** allows for number range configurations */
export type FloatFilterBetweenInput = {
  /** the start of the range */
  from: Scalars['Float'];
  /** the end of the range */
  to: Scalars['Float'];
};

export type Frequency = DailyFrequency | HourlyFrequency | MinuteFrequency | WeeklyFrequency;

export type FrequencyInput = {
  daily?: InputMaybe<DailyFrequencyInput>;
  hourly?: InputMaybe<HourlyFrequencyInput>;
  minute?: InputMaybe<MinuteFrequencyInput>;
  weekly?: InputMaybe<WeeklyFrequencyInput>;
};

export type GenericPlacement = {
  __typename: 'GenericPlacement';
  areaSqft: Maybe<Scalars['Float']>;
  areaSqyrd: Maybe<Scalars['Float']>;
  base64MapImage: Maybe<Scalars['String']>;
  closed: Maybe<Scalars['DateTime']>;
  concreteCoreMeasurement: Maybe<ConcreteCoreMeasurement>;
  concretePlacement: Maybe<ConcretePlacement>;
  /** the date this record was inserted into the database */
  createdDate: Maybe<Scalars['DateTime']>;
  /** the username or email address of a mobile app user associated with the `createdDate` */
  createdUser: Maybe<Scalars['String']>;
  dailyInspectionControlPoint: Maybe<DailyInspectionControlPoint>;
  dailyInspectionInspection: Maybe<DailyInspectionInspection>;
  dailyInspectionPunchList: Maybe<DailyInspectionPunchList>;
  deleted: Maybe<Scalars['String']>;
  densityTests: Maybe<Array<DensityTest>>;
  endAlignment: Maybe<Scalars['String']>;
  endOffset: Maybe<Scalars['String']>;
  endStation: Maybe<Scalars['String']>;
  featureId: Maybe<Scalars['String']>;
  /** a GUID used to globally identify this record in the database */
  globalId: Scalars['String'];
  /** the date this record was last updated in the database */
  lastEditedDate: Maybe<Scalars['DateTime']>;
  /** the username or email address of a mobile app user associated with the `lastEditedDate` */
  lastEditedUser: Maybe<Scalars['String']>;
  linealFt: Maybe<Scalars['Float']>;
  lot: Maybe<Lot>;
  manualMeasurements: Maybe<Scalars['String']>;
  /**
   * If set, contains a comma separated list of
   * `PayItemNoGeometry.globalId` values
   *
   * unfortunately, there have been instances where one of these values doesn't map
   * to a valid `PayItemNoGeometry`
   *
   * `payItemNoGeometries` will skip these rather than map them to `null`
   */
  multiplePayItems: Maybe<Scalars['String']>;
  numberOfRequiredTests: Maybe<Scalars['Int']>;
  opened: Maybe<Scalars['DateTime']>;
  overrideComments: Maybe<Scalars['String']>;
  /**
   * an ArcGIS feature layer index
   *
   * used in the database to help specify the type of `parentGuid`
   *
   * | object type | index |
   * | --- | :---: |
   * | `Lot` | 1 |
   * | `ConcreteCoreMeasurement` | 13 |
   * | `ConcretePlacement` | 14 |
   * | `DailyInspectionControlPoint` | 15 |
   * | `DailyInspectionInspection` | 16 |
   * | `DailyInspectionPunchList` | 17 |
   */
  parentFeatureTable: Maybe<Scalars['Int']>;
  /** the `globalId` of one of the related types: `ConcreteCoreMeasurement`, `ConcretePlacement`, `DailyInspectionControlPoint`, `DailyInspectionInspection`, `DailyInspectionPunchList`, or `Lot` */
  parentGuid: Maybe<Scalars['String']>;
  /**
   * aggregates all `PayItemNoGeometry` records associated with this
   * `GenericPlacement` by using its `PayItemNoGeometry` reference and `multiplePayItems`
   *
   * if any `PayItemNoGeometry.globalId` values used to query the database return `null`,
   * the `null` value will be filtered out of the results
   *
   * every result will be a valid `PayItemNoGeometry`
   */
  payItemNoGeometries: Array<PayItemNoGeometry>;
  payItemsGuid: Maybe<Scalars['String']>;
  /** a related `Project` */
  project: Maybe<Project>;
  /** the `globalId` of a related `Project` */
  projectId: Maybe<Scalars['String']>;
  reopen: Maybe<Scalars['DateTime']>;
  requiredThickness: Maybe<Scalars['Float']>;
  shape: Maybe<Scalars['String']>;
  startAlignment: Maybe<Scalars['String']>;
  startOffset: Maybe<Scalars['String']>;
  startStation: Maybe<Scalars['String']>;
  status: Maybe<Scalars['String']>;
  volumeCuYds: Maybe<Scalars['Float']>;
};


export type GenericPlacementBase64MapImageArgs = {
  projectLayerIds?: InputMaybe<Array<Scalars['Int']>>;
};


export type GenericPlacementDensityTestsArgs = {
  densityTestFieldInput?: InputMaybe<DensityTestFieldInput>;
};


export type GenericPlacementPayItemNoGeometriesArgs = {
  payItemNoGeometryFieldInput?: InputMaybe<PayItemNoGeometryFieldInput>;
};

/**
 * helps filter multiple `GenericPlacement` records
 *
 * this version of the input will have limited options compared to its other counterpart
 */
export type GenericPlacementFieldInput = {
  createdDate?: InputMaybe<DateTimeFilter>;
  /**
   * determines now to handle deleted `GenericPlacement` records
   *
   * - when `true`, only return deleted records
   * - when `false`, do not return deleted records
   * - when omitted, `deleted` is ignored
   */
  deleted?: InputMaybe<Scalars['Boolean']>;
  featureId?: InputMaybe<StringFilter>;
  lastEditedDate?: InputMaybe<DateTimeFilter>;
  /**
   * how to order `GenericPlacement` records
   *
   * executed in the order they are defined
   */
  orderBy?: InputMaybe<Array<OrderByInput>>;
  parentFeatureTable?: InputMaybe<IntFilter>;
  projectId?: InputMaybe<StringFilter>;
  status?: InputMaybe<StringFilter>;
  /**
   * specifies how many records to return
   *
   * analogous to `limit`, `first`, or `top` in SQL dialects
   */
  take?: InputMaybe<Scalars['Int']>;
};

/** helps filter multiple `GenericPlacement` records */
export type GenericPlacementListInput = {
  createdDate?: InputMaybe<DateTimeFilter>;
  /**
   * determines now to handle deleted `GenericPlacement` records
   *
   * - when `true`, only return deleted records
   * - when `false`, do not return deleted records
   * - when omitted, `deleted` is ignored
   */
  deleted?: InputMaybe<Scalars['Boolean']>;
  featureId?: InputMaybe<StringFilter>;
  lastEditedDate?: InputMaybe<DateTimeFilter>;
  /**
   * how to order `GenericPlacement` records
   *
   * executed in the order they are defined
   */
  orderBy?: InputMaybe<Array<OrderByInput>>;
  /**
   * paginate `GenericPlacement` records
   *
   * using `paginate` may require multiple requests to get all possible results,
   * but will give more fine-grain control in the event all records cannot be
   * returned gracefully
   */
  paginate?: InputMaybe<PaginationInput>;
  parentFeatureTable?: InputMaybe<IntFilter>;
  projectId?: InputMaybe<StringFilter>;
  status?: InputMaybe<StringFilter>;
};

/** response metadata for a list query of GenericPlacement records */
export type GenericPlacementListResponse = {
  __typename: 'GenericPlacementListResponse';
  /** the total count of GenericPlacement records matching any configured filters */
  count: Scalars['Int'];
  /** the total count of paginated groups of GenericPlacement */
  pages: Scalars['Int'];
  /** GenericPlacement records */
  records: Array<GenericPlacement>;
};

export type GiveDesignSubmittalDispositionInput = {
  /** uses the maximum character length available in the database */
  comment?: InputMaybe<Scalars['String']>;
  /**
   * an enum describing the `DesignSubmittalDisposition`
   *
   * possible values: `Rejected`, `Returned with Comments`, `Returned with Comments - No Resubmittal Required`, or `Returned with no Comments`
   */
  disposition: Scalars['String'];
  id: Scalars['String'];
};

export type GiveDesignSubmittalDispositionResponse = {
  __typename: 'GiveDesignSubmittalDispositionResponse';
  designSubmittal: DesignSubmittal;
};

export type GiveIssueDispositionInput = {
  comment?: InputMaybe<Scalars['String']>;
  dispositionNotes: Scalars['String'];
  dispositionTypeId: Scalars['String'];
  externalLinks?: InputMaybe<Array<ExternalLinkInput>>;
  id: Scalars['String'];
};

export type GiveIssueDispositionResponse = {
  __typename: 'GiveIssueDispositionResponse';
  issue: Issue;
};

export type GoogleSheetPayItemConnection = {
  __typename: 'GoogleSheetPayItemConnection';
  /**
   * a two dimensional array of cells
   *
   * use `records` to get the filtered and sorted cells based on the `headers`
   */
  cells: Array<Array<GoogleSheetPayItemConnectionCell>>;
  /** the `documentId` and `sheetId` joined with a hyphen */
  compositeId: Scalars['String'];
  connection: PayItemConnection;
  /** the `id` of a related `PayItemConnection` */
  connectionId: Scalars['String'];
  /** the date this record was inserted into the database */
  createdDate: Scalars['DateTime'];
  /**
   * the email address of a user associated with the `createdDate`
   *
   * this value will be `unknown` if the `createdDate` was not set by a user
   */
  createdUser: Scalars['String'];
  /** the object id of the Google Sheet associated with this record */
  documentId: Scalars['String'];
  /** the title of the Google Sheet associated with this record */
  documentTitle: Maybe<Scalars['String']>;
  /**
   * the "column headers" for the `cells`
   *
   * use `records` to get the filtered and sorted headers
   */
  headers: Array<GoogleSheetPayItemConnectionHeader>;
  /** the date this record was last updated in the database */
  lastEditedDate: Scalars['DateTime'];
  /**
   * the email address of a user associated with the `lastEditedDate`
   *
   * this value will be `system` if the `lastEditedDate` was not set by a user
   */
  lastEditedUser: Scalars['String'];
  /**
   * the value of cell denoting which column Pay Items will appear in
   *
   * this also controls which row is considered the "starting" row
   *
   * for example, if the value appears in cell C4, rows A and B are ignored, row C will
   * populate `headers`, and rows D+ will populate `cells`
   */
  payItemColumnKey: Maybe<Scalars['String']>;
  /**
   * headers and cells resolved into a single object
   *
   * headers are filtered by their `visible` field and sorted by their `order` field
   *
   * rows of cells are filtered and sorted based on the headers
   */
  records: GoogleSheetPayItemConnectionRecords;
  /** the object id of the worksheet, or tab, associated with this record */
  sheetId: Scalars['Int'];
  /** the title of the worksheet, or tab, associated with this record */
  sheetTitle: Maybe<Scalars['String']>;
  /** attempts to create a composite title with `documentTitle` and `sheetTitle` by joining them with a hyphen */
  title: Maybe<Scalars['String']>;
  /** a url to link to the Google Sheet */
  url: Scalars['String'];
};


export type GoogleSheetPayItemConnectionRecordsArgs = {
  payItemGlobalId?: InputMaybe<Scalars['String']>;
};

export type GoogleSheetPayItemConnectionCell = {
  __typename: 'GoogleSheetPayItemConnectionCell';
  formattedValue: Maybe<Scalars['String']>;
  /** the id of a header in `headers` */
  headerId: Scalars['String'];
  hyperlink: Maybe<Scalars['String']>;
  /** a readonly id to identify this header */
  id: Scalars['String'];
  note: Maybe<Scalars['String']>;
};

export type GoogleSheetPayItemConnectionHeader = {
  __typename: 'GoogleSheetPayItemConnectionHeader';
  formattedValue: Scalars['String'];
  hyperlink: Maybe<Scalars['String']>;
  /** a readonly id to identify this header */
  id: Scalars['String'];
  note: Maybe<Scalars['String']>;
  /** the order this header, and cells associated with it, will appear in the Pay Items Summary */
  order: Scalars['Int'];
  /** whether this header, and cells associated with it, should be visible in the Pay Items Summary */
  visible: Scalars['Boolean'];
};

/** helps filter multiple `GoogleSheetPayItemConnection` records */
export type GoogleSheetPayItemConnectionListInput = {
  connectionId?: InputMaybe<StringFilter>;
  documentId?: InputMaybe<StringFilter>;
  documentTitle?: InputMaybe<StringFilter>;
  /**
   * how to order `GoogleSheetPayItemConnection` records
   *
   * executed in the order they are defined
   */
  orderBy?: InputMaybe<Array<OrderByInput>>;
  /**
   * paginate `GoogleSheetPayItemConnection` records
   *
   * using `paginate` may require multiple requests to get all possible results,
   * but will give more fine-grain control in the event all records cannot be
   * returned gracefully
   */
  paginate?: InputMaybe<PaginationInput>;
  payItemColumnKey?: InputMaybe<StringFilter>;
  sheetId?: InputMaybe<IntFilter>;
  sheetTitle?: InputMaybe<StringFilter>;
};

/** response metadata for a list query of GoogleSheetPayItemConnection records */
export type GoogleSheetPayItemConnectionListResponse = {
  __typename: 'GoogleSheetPayItemConnectionListResponse';
  /** the total count of GoogleSheetPayItemConnection records matching any configured filters */
  count: Scalars['Int'];
  /** the total count of paginated groups of GoogleSheetPayItemConnection */
  pages: Scalars['Int'];
  /** GoogleSheetPayItemConnection records */
  records: Array<GoogleSheetPayItemConnection>;
};

export type GoogleSheetPayItemConnectionRecords = {
  __typename: 'GoogleSheetPayItemConnectionRecords';
  /** cells, sorted and filtered, for the headers */
  cells: Array<Array<GoogleSheetPayItemConnectionCell>>;
  /** the sorted and visible headers */
  headers: Array<GoogleSheetPayItemConnectionHeader>;
  rows: Scalars['Int'];
};

/** tracks requests made to deprecated endpoints and fields in the CIMS GraphQL API */
export type GraphQlDeprecationLog = {
  __typename: 'GraphQLDeprecationLog';
  /** the owner of an API key present in the request */
  apiKeyOwner: Maybe<Scalars['String']>;
  /** the date associated the deprecated request */
  dateRequested: Scalars['DateTime'];
  /**
   * the name of the requested field
   *
   * for Queries and Mutations, this will be the name of the endpoint
   */
  fieldName: Scalars['String'];
  /** did the request come with an API key? */
  hadApiKey: Maybe<Scalars['Boolean']>;
  /** a hostname from the request headers */
  hostname: Maybe<Scalars['String']>;
  /** a unique integer to identify this record in the database table */
  id: Scalars['Int'];
  /**
   * an enum describing the type of deprecated request
   *
   * possible values: `Field`, `Mutation`, or `Query`
   */
  requestType: Scalars['GraphQLDeprecationLogRequestTypeScalar'];
  /** a related `User` which requests the `GraphQLDeprecationLog` */
  requestedBy: Maybe<User>;
  /** the `id` of a related `User` which requests the `GraphQLDeprecationLog` */
  requestedById: Maybe<Scalars['String']>;
};

/**
 * helps filter multiple `GraphQLDeprecationLog` records
 *
 * this version of the input will have limited options compared to its other counterpart
 */
export type GraphQlDeprecationLogFieldInput = {
  apiKeyOwner?: InputMaybe<StringFilter>;
  dateRequested?: InputMaybe<DateTimeFilter>;
  fieldName?: InputMaybe<StringFilter>;
  hadApiKey?: InputMaybe<Scalars['Boolean']>;
  hostname?: InputMaybe<StringFilter>;
  /**
   * how to order `GraphQLDeprecationLog` records
   *
   * executed in the order they are defined
   */
  orderBy?: InputMaybe<Array<OrderByInput>>;
  requestType?: InputMaybe<StringFilter>;
  /**
   * specifies how many records to return
   *
   * analogous to `limit`, `first`, or `top` in SQL dialects
   */
  take?: InputMaybe<Scalars['Int']>;
};

/** helps filter multiple `GraphQLDeprecationLog` records */
export type GraphQlDeprecationLogListInput = {
  apiKeyOwner?: InputMaybe<StringFilter>;
  dateRequested?: InputMaybe<DateTimeFilter>;
  fieldName?: InputMaybe<StringFilter>;
  hadApiKey?: InputMaybe<Scalars['Boolean']>;
  hostname?: InputMaybe<StringFilter>;
  /**
   * how to order `GraphQLDeprecationLog` records
   *
   * executed in the order they are defined
   */
  orderBy?: InputMaybe<Array<OrderByInput>>;
  /**
   * paginate `GraphQLDeprecationLog` records
   *
   * using `paginate` may require multiple requests to get all possible results,
   * but will give more fine-grain control in the event all records cannot be
   * returned gracefully
   */
  paginate?: InputMaybe<PaginationInput>;
  requestType?: InputMaybe<StringFilter>;
};

/** response metadata for a list query of GraphQLDeprecationLog records */
export type GraphQlDeprecationLogListResponse = {
  __typename: 'GraphQLDeprecationLogListResponse';
  /** the total count of GraphQLDeprecationLog records matching any configured filters */
  count: Scalars['Int'];
  /** the total count of paginated groups of GraphQLDeprecationLog */
  pages: Scalars['Int'];
  /** GraphQLDeprecationLog records */
  records: Array<GraphQlDeprecationLog>;
};

export type GroupReviewConstructionAdminSubmittalInput = {
  comment: Scalars['String'];
  id: Scalars['String'];
};

export type GroupReviewConstructionAdminSubmittalResponse = {
  __typename: 'GroupReviewConstructionAdminSubmittalResponse';
  /** Group Reviewed Submittal */
  submittal: ConstructionAdminSubmittal;
};

export type HourlyFrequency = BaseFrequency & {
  __typename: 'HourlyFrequency';
  /** Default value is 1 hours */
  hours: Scalars['Int'];
  next: Scalars['DateTime'];
  previous: Scalars['DateTime'];
};

export type HourlyFrequencyInput = {
  hours: Scalars['Int'];
};

/** comments made against related `IdentifiedFieldIssue` records */
export type IfiComment = {
  __typename: 'IFIComment';
  /** the date this record was inserted into the database */
  createdDate: Scalars['DateTime'];
  /**
   * the email address of a user associated with the `createdDate`
   *
   * this value will be `unknown` if the `createdDate` was not set by a user
   */
  createdUser: Scalars['String'];
  /** describes whether the record has been soft-deleted or not */
  deleted: Scalars['Boolean'];
  /** the date this record was soft-deleted in the database */
  deletedDate: Maybe<Scalars['DateTime']>;
  /**
   * the email address of a user associated with the `deletedDate`
   *
   * this value will be `system` if the `deletedDate` was not set by a user
   */
  deletedUser: Maybe<Scalars['String']>;
  /** a UUID used to globally identify this record in the database */
  id: Scalars['String'];
  identifiedFieldIssue: IdentifiedFieldIssue;
  identifiedFieldIssueId: Scalars['String'];
  /** the date this record was last updated in the database */
  lastEditedDate: Scalars['DateTime'];
  /**
   * the email address of a user associated with the `lastEditedDate`
   *
   * this value will be `system` if the `lastEditedDate` was not set by a user
   */
  lastEditedUser: Scalars['String'];
  /**
   * the text of the comment
   *
   * limited to 1000 characters
   */
  text: Scalars['String'];
  user: User;
  /** the `id` of a related `User` */
  userId: Scalars['String'];
};

/**
 * helps filter multiple `IFIComment` records
 *
 * this version of the input will have limited options compared to its other counterpart
 */
export type IfiCommentFieldInput = {
  createdDate?: InputMaybe<DateTimeFilter>;
  /**
   * determines now to handle deleted `IFIComment` records
   *
   * - when `true`, only return deleted records
   * - when `false`, do not return deleted records
   * - when omitted, `deleted` is ignored
   */
  deleted?: InputMaybe<Scalars['Boolean']>;
  identifiedFieldIssueId?: InputMaybe<StringFilter>;
  lastEditedDate?: InputMaybe<DateTimeFilter>;
  /**
   * how to order `IFIComment` records
   *
   * executed in the order they are defined
   */
  orderBy?: InputMaybe<Array<OrderByInput>>;
  /**
   * specifies how many records to return
   *
   * analogous to `limit`, `first`, or `top` in SQL dialects
   */
  take?: InputMaybe<Scalars['Int']>;
  text?: InputMaybe<StringFilter>;
  userId?: InputMaybe<StringFilter>;
};

/** helps filter multiple `IFIComment` records */
export type IfiCommentListInput = {
  createdDate?: InputMaybe<DateTimeFilter>;
  /**
   * determines now to handle deleted `IFIComment` records
   *
   * - when `true`, only return deleted records
   * - when `false`, do not return deleted records
   * - when omitted, `deleted` is ignored
   */
  deleted?: InputMaybe<Scalars['Boolean']>;
  identifiedFieldIssueId?: InputMaybe<StringFilter>;
  lastEditedDate?: InputMaybe<DateTimeFilter>;
  /**
   * how to order `IFIComment` records
   *
   * executed in the order they are defined
   */
  orderBy?: InputMaybe<Array<OrderByInput>>;
  /**
   * paginate `IFIComment` records
   *
   * using `paginate` may require multiple requests to get all possible results,
   * but will give more fine-grain control in the event all records cannot be
   * returned gracefully
   */
  paginate?: InputMaybe<PaginationInput>;
  text?: InputMaybe<StringFilter>;
  userId?: InputMaybe<StringFilter>;
};

/** response metadata for a list query of IFIComment records */
export type IfiCommentListResponse = {
  __typename: 'IFICommentListResponse';
  /** the total count of IFIComment records matching any configured filters */
  count: Scalars['Int'];
  /** the total count of paginated groups of IFIComment */
  pages: Scalars['Int'];
  /** IFIComment records */
  records: Array<IfiComment>;
};

/**
 * notifications hold a recipients configuration for a given
 * notification event in IFI Tracker workflows
 *
 * recipients can be users, or non user emails
 *
 * certain events may require users to receive a notification if they are given permission
 * to perform a specific task
 */
export type IfiNotification = {
  __typename: 'IFINotification';
  /** the date this record was inserted into the database */
  createdDate: Scalars['DateTime'];
  /**
   * the email address of a user associated with the `createdDate`
   *
   * this value will be `unknown` if the `createdDate` was not set by a user
   */
  createdUser: Scalars['String'];
  frequency: Maybe<Frequency>;
  /** the date this record was last updated in the database */
  lastEditedDate: Scalars['DateTime'];
  /**
   * the email address of a user associated with the `lastEditedDate`
   *
   * this value will be `system` if the `lastEditedDate` was not set by a user
   */
  lastEditedUser: Scalars['String'];
  /** the name of the notification event associated with this Notification */
  notificationEvent: Scalars['String'];
  notificationEventId: Scalars['String'];
  /** a related `Project` */
  project: Project;
  /** the `globalId` of a related `Project` */
  projectId: Scalars['String'];
  recipients: IfiNotificationRecipients;
};

/**
 * helps filter multiple `IFINotification` records
 *
 * this version of the input will have limited options compared to its other counterpart
 */
export type IfiNotificationFieldInput = {
  createdDate?: InputMaybe<DateTimeFilter>;
  lastEditedDate?: InputMaybe<DateTimeFilter>;
  notificationEventId?: InputMaybe<StringFilter>;
  /**
   * how to order `IFINotification` records
   *
   * executed in the order they are defined
   */
  orderBy?: InputMaybe<Array<OrderByInput>>;
  projectId?: InputMaybe<StringFilter>;
  /**
   * specifies how many records to return
   *
   * analogous to `limit`, `first`, or `top` in SQL dialects
   */
  take?: InputMaybe<Scalars['Int']>;
};

/** helps filter multiple `IFINotification` records */
export type IfiNotificationListInput = {
  createdDate?: InputMaybe<DateTimeFilter>;
  lastEditedDate?: InputMaybe<DateTimeFilter>;
  notificationEventId?: InputMaybe<StringFilter>;
  /**
   * how to order `IFINotification` records
   *
   * executed in the order they are defined
   */
  orderBy?: InputMaybe<Array<OrderByInput>>;
  /**
   * paginate `IFINotification` records
   *
   * using `paginate` may require multiple requests to get all possible results,
   * but will give more fine-grain control in the event all records cannot be
   * returned gracefully
   */
  paginate?: InputMaybe<PaginationInput>;
  projectId?: InputMaybe<StringFilter>;
};

/** response metadata for a list query of IFINotification records */
export type IfiNotificationListResponse = {
  __typename: 'IFINotificationListResponse';
  /** the total count of IFINotification records matching any configured filters */
  count: Scalars['Int'];
  /** the total count of paginated groups of IFINotification */
  pages: Scalars['Int'];
  /** IFINotification records */
  records: Array<IfiNotification>;
};

export type IfiNotificationRecipients = {
  __typename: 'IFINotificationRecipients';
  asphaltLot: Maybe<Recipients>;
  concreteTest: Maybe<Recipients>;
  dailyInspectionControlPoint: Maybe<Recipients>;
  dailyInspectionInspection: Maybe<Recipients>;
  dailyInspectionPunchList: Maybe<Recipients>;
  densityLot: Maybe<Recipients>;
  densityTest: Maybe<Recipients>;
  every: Maybe<Recipients>;
};

export type IdentifiedFieldIssue = {
  __typename: 'IdentifiedFieldIssue';
  asphaltLot: Maybe<AsphaltLot>;
  automaticallyClosed: Scalars['Boolean'];
  comments: Array<IfiComment>;
  concreteTest: Maybe<ConcreteTest>;
  /** the date this record was inserted into the database */
  createdDate: Scalars['DateTime'];
  /**
   * the email address of a user associated with the `createdDate`
   *
   * this value will be `unknown` if the `createdDate` was not set by a user
   */
  createdUser: Scalars['String'];
  /**
   * custom fields are defined, configured, and activated for `IdentifiedFieldIssue`
   *     records in the Administration module
   *
   *     values are saved and retrieved for each individual `IdentifiedFieldIssue`
   */
  customFields: CustomFields;
  dailyInspectionControlPoint: Maybe<DailyInspectionControlPoint>;
  dailyInspectionInspection: Maybe<DailyInspectionInspection>;
  dailyInspectionPunchList: Maybe<DailyInspectionPunchList>;
  densityTest: Maybe<DensityTest>;
  engineeringJudgements: Array<EngineeringJudgement>;
  /** limited to 4000 characters */
  initialDescription: Maybe<Scalars['String']>;
  issueSuggestedEmailSent: Scalars['Boolean'];
  issues: Array<Issue>;
  /** the date this record was last updated in the database */
  lastEditedDate: Scalars['DateTime'];
  /**
   * the email address of a user associated with the `lastEditedDate`
   *
   * this value will be `system` if the `lastEditedDate` was not set by a user
   */
  lastEditedUser: Scalars['String'];
  lot: Maybe<Lot>;
  reportDate: Maybe<Scalars['DateTime']>;
  reportDescription: Maybe<Scalars['String']>;
  reportId: Scalars['String'];
  reportName: Maybe<Scalars['String']>;
  reportReviewStatus: Maybe<Scalars['String']>;
  reportTechnician: Maybe<Technician>;
  reportTechnicianGuid: Maybe<Scalars['String']>;
  reportType: Scalars['String'];
  reportTypeId: Scalars['String'];
  /** limited to 4000 characters */
  reviewNotes: Maybe<Scalars['String']>;
  reviewedBy: Maybe<User>;
  reviewedById: Maybe<Scalars['String']>;
  reviewedDate: Maybe<Scalars['DateTime']>;
  status: Scalars['String'];
  statusId: Scalars['String'];
  suggestedIssueTypes: Array<Scalars['String']>;
};


export type IdentifiedFieldIssueCommentsArgs = {
  ifiCommentFieldInput?: InputMaybe<IfiCommentFieldInput>;
};


export type IdentifiedFieldIssueEngineeringJudgementsArgs = {
  engineeringJudgementFieldInput?: InputMaybe<EngineeringJudgementFieldInput>;
};


export type IdentifiedFieldIssueIssuesArgs = {
  issueFieldInput?: InputMaybe<IssueFieldInput>;
};

/**
 * helps filter multiple `IdentifiedFieldIssue` records
 *
 * this version of the input will have limited options compared to its other counterpart
 */
export type IdentifiedFieldIssueFieldInput = {
  createdDate?: InputMaybe<DateTimeFilter>;
  lastEditedDate?: InputMaybe<DateTimeFilter>;
  /**
   * how to order `IdentifiedFieldIssue` records
   *
   * executed in the order they are defined
   */
  orderBy?: InputMaybe<Array<OrderByInput>>;
  projectId?: InputMaybe<StringFilter>;
  reportId?: InputMaybe<StringFilter>;
  reportTypeId?: InputMaybe<StringFilter>;
  reviewNotes?: InputMaybe<StringFilter>;
  reviewedById?: InputMaybe<StringFilter>;
  reviewedDate?: InputMaybe<DateTimeFilter>;
  statusId?: InputMaybe<StringFilter>;
  /**
   * specifies how many records to return
   *
   * analogous to `limit`, `first`, or `top` in SQL dialects
   */
  take?: InputMaybe<Scalars['Int']>;
};

/** helps filter multiple `IdentifiedFieldIssue` records */
export type IdentifiedFieldIssueListInput = {
  createdDate?: InputMaybe<DateTimeFilter>;
  lastEditedDate?: InputMaybe<DateTimeFilter>;
  /**
   * how to order `IdentifiedFieldIssue` records
   *
   * executed in the order they are defined
   */
  orderBy?: InputMaybe<Array<OrderByInput>>;
  /**
   * paginate `IdentifiedFieldIssue` records
   *
   * using `paginate` may require multiple requests to get all possible results,
   * but will give more fine-grain control in the event all records cannot be
   * returned gracefully
   */
  paginate?: InputMaybe<PaginationInput>;
  projectId?: InputMaybe<StringFilter>;
  reportId?: InputMaybe<StringFilter>;
  reportTypeId?: InputMaybe<StringFilter>;
  reviewNotes?: InputMaybe<StringFilter>;
  reviewedById?: InputMaybe<StringFilter>;
  reviewedDate?: InputMaybe<DateTimeFilter>;
  statusId?: InputMaybe<StringFilter>;
};

/** response metadata for a list query of IdentifiedFieldIssue records */
export type IdentifiedFieldIssueListResponse = {
  __typename: 'IdentifiedFieldIssueListResponse';
  /** the total count of IdentifiedFieldIssue records matching any configured filters */
  count: Scalars['Int'];
  /** the total count of paginated groups of IdentifiedFieldIssue */
  pages: Scalars['Int'];
  /** IdentifiedFieldIssue records */
  records: Array<IdentifiedFieldIssue>;
};

export type IdentifiedFieldIssueSync = {
  __typename: 'IdentifiedFieldIssueSync';
  lastEditedDate: Scalars['DateTime'];
  project: Project;
  projectId: Scalars['String'];
  syncing: Scalars['Boolean'];
};

export type InspectionMissingGeometryIfiSettings = {
  __typename: 'InspectionMissingGeometryIFISettings';
  /** the date this record was enabled the database */
  effectiveDate: Maybe<Scalars['DateTime']>;
  enabled: Scalars['Boolean'];
  message: Maybe<Scalars['String']>;
};

/**
 * filter options for `Int` values
 *
 * undefined
 *
 * only one filter will be active at a time
 *
 * filters are preferred in the following order
 *
 * - equals
 * - between
 * - greaterThan
 * - lessThan
 * - list
 * - null
 */
export type IntFilter = {
  between?: InputMaybe<IntFilterBetweenInput>;
  /** the field value equals the supplied value */
  equals?: InputMaybe<Scalars['Int']>;
  /** the supplied value is greater than the field value */
  greaterThan?: InputMaybe<Scalars['Int']>;
  /** the supplied value is less than the field value */
  lessThan?: InputMaybe<Scalars['Int']>;
  /** possible values of the field value */
  list?: InputMaybe<Array<Scalars['Int']>>;
  /**
   * filters based on the nullability of the field
   *
   * - if true: return records where the field value is null
   * - if false: return records where the field value is not null
   */
  null?: InputMaybe<Scalars['Boolean']>;
};

/** allows for integer range configurations */
export type IntFilterBetweenInput = {
  /** the start of the range */
  from: Scalars['Int'];
  /** the end of the range */
  to: Scalars['Int'];
};

export type InternalConnectionPayItemSummaryCount = {
  __typename: 'InternalConnectionPayItemSummaryCount';
  count: Maybe<Scalars['Int']>;
  group: Maybe<PayItemConnectionGroup>;
  groupId: Maybe<Scalars['String']>;
  internalConnectionId: Scalars['String'];
};

export type InternalPayItemConnectionOrderInput = {
  groupId?: InputMaybe<Scalars['String']>;
  internalConnectionId: Scalars['String'];
  order: Scalars['Int'];
};

export type Issue = {
  __typename: 'Issue';
  closedBy: Maybe<User>;
  closedById: Maybe<Scalars['String']>;
  closedDate: Maybe<Scalars['DateTime']>;
  closureNotes: Maybe<Scalars['String']>;
  comments: Array<IssueComment>;
  /** the date this record was inserted into the database */
  createdDate: Scalars['DateTime'];
  /**
   * the email address of a user associated with the `createdDate`
   *
   * this value will be `unknown` if the `createdDate` was not set by a user
   */
  createdUser: Scalars['String'];
  /**
   * custom fields are defined, configured, and activated for `Issue`
   *     records in the Administration module
   *
   *     values are saved and retrieved for each individual `Issue`
   */
  customFields: CustomFields;
  /** describes whether the record has been soft-deleted or not */
  deleted: Scalars['Boolean'];
  /** the date this record was soft-deleted in the database */
  deletedDate: Maybe<Scalars['DateTime']>;
  /**
   * the email address of a user associated with the `deletedDate`
   *
   * this value will be `system` if the `deletedDate` was not set by a user
   */
  deletedUser: Maybe<Scalars['String']>;
  /**
   * an extended description associated with the record
   *
   * this description will be used to describe the record in CIMS, where possible
   */
  description: Maybe<Scalars['String']>;
  dispositionBy: Maybe<User>;
  dispositionById: Maybe<Scalars['String']>;
  dispositionDate: Maybe<Scalars['DateTime']>;
  dispositionNotes: Maybe<Scalars['String']>;
  dispositionType: Maybe<IssueDispositionType>;
  dispositionTypeId: Maybe<Scalars['String']>;
  externalLinks: Array<ExternalLink>;
  /** the `number` prefixed with "Item" */
  formattedNumber: Scalars['String'];
  /** a UUID used to globally identify this record in the database */
  id: Scalars['String'];
  identifiedFieldIssue: Maybe<IdentifiedFieldIssue>;
  identifiedFieldIssueId: Maybe<Scalars['String']>;
  issueToPayItemNoGeometries: Array<IssueToPayItemNoGeometry>;
  issueToReports: Array<IssueToReport>;
  /** the date this record was last updated in the database */
  lastEditedDate: Scalars['DateTime'];
  /**
   * the email address of a user associated with the `lastEditedDate`
   *
   * this value will be `system` if the `lastEditedDate` was not set by a user
   */
  lastEditedUser: Scalars['String'];
  /** a generated number for the `Issue` */
  number: Scalars['Int'];
  /** a related `Project` */
  project: Project;
  /** the `globalId` of a related `Project` */
  projectId: Scalars['String'];
  response: Maybe<Scalars['String']>;
  responseBy: Maybe<User>;
  responseById: Maybe<Scalars['String']>;
  responseDate: Maybe<Scalars['DateTime']>;
  /** pulls a `SharePointResource` object from SharePoint for the parent folder associated with this `Issue` */
  sharePointResource: Maybe<SharePointResource>;
  sharePointResourceId: Maybe<Scalars['String']>;
  sharePointResourceWebUrl: Maybe<Scalars['String']>;
  status: Scalars['String'];
  statusId: Scalars['String'];
  submittedBy: Maybe<User>;
  submittedById: Maybe<Scalars['String']>;
  submittedDate: Maybe<Scalars['DateTime']>;
  types: Array<IssueType>;
};


export type IssueCommentsArgs = {
  issueCommentFieldInput?: InputMaybe<IssueCommentFieldInput>;
};


export type IssueIssueToPayItemNoGeometriesArgs = {
  issueToPayItemNoGeometryFieldInput?: InputMaybe<IssueToPayItemNoGeometryFieldInput>;
};


export type IssueIssueToReportsArgs = {
  issueToReportFieldInput?: InputMaybe<IssueToReportFieldInput>;
};


export type IssueTypesArgs = {
  issueTypeFieldInput?: InputMaybe<IssueTypeFieldInput>;
};

/** comments made against related `Issue` records */
export type IssueComment = {
  __typename: 'IssueComment';
  /** the date this record was inserted into the database */
  createdDate: Scalars['DateTime'];
  /**
   * the email address of a user associated with the `createdDate`
   *
   * this value will be `unknown` if the `createdDate` was not set by a user
   */
  createdUser: Scalars['String'];
  /** describes whether the record has been soft-deleted or not */
  deleted: Scalars['Boolean'];
  /** the date this record was soft-deleted in the database */
  deletedDate: Maybe<Scalars['DateTime']>;
  /**
   * the email address of a user associated with the `deletedDate`
   *
   * this value will be `system` if the `deletedDate` was not set by a user
   */
  deletedUser: Maybe<Scalars['String']>;
  /** a UUID used to globally identify this record in the database */
  id: Scalars['String'];
  issue: Issue;
  issueId: Scalars['String'];
  /** the date this record was last updated in the database */
  lastEditedDate: Scalars['DateTime'];
  /**
   * the email address of a user associated with the `lastEditedDate`
   *
   * this value will be `system` if the `lastEditedDate` was not set by a user
   */
  lastEditedUser: Scalars['String'];
  /**
   * the text of the comment
   *
   * limited to 1000 characters
   */
  text: Scalars['String'];
  user: User;
  /** the `id` of a related `User` */
  userId: Scalars['String'];
};

/**
 * helps filter multiple `IssueComment` records
 *
 * this version of the input will have limited options compared to its other counterpart
 */
export type IssueCommentFieldInput = {
  createdDate?: InputMaybe<DateTimeFilter>;
  /**
   * determines now to handle deleted `IssueComment` records
   *
   * - when `true`, only return deleted records
   * - when `false`, do not return deleted records
   * - when omitted, `deleted` is ignored
   */
  deleted?: InputMaybe<Scalars['Boolean']>;
  issueId?: InputMaybe<StringFilter>;
  lastEditedDate?: InputMaybe<DateTimeFilter>;
  /**
   * how to order `IssueComment` records
   *
   * executed in the order they are defined
   */
  orderBy?: InputMaybe<Array<OrderByInput>>;
  /**
   * specifies how many records to return
   *
   * analogous to `limit`, `first`, or `top` in SQL dialects
   */
  take?: InputMaybe<Scalars['Int']>;
  text?: InputMaybe<StringFilter>;
  userId?: InputMaybe<StringFilter>;
};

/** helps filter multiple `IssueComment` records */
export type IssueCommentListInput = {
  createdDate?: InputMaybe<DateTimeFilter>;
  /**
   * determines now to handle deleted `IssueComment` records
   *
   * - when `true`, only return deleted records
   * - when `false`, do not return deleted records
   * - when omitted, `deleted` is ignored
   */
  deleted?: InputMaybe<Scalars['Boolean']>;
  issueId?: InputMaybe<StringFilter>;
  lastEditedDate?: InputMaybe<DateTimeFilter>;
  /**
   * how to order `IssueComment` records
   *
   * executed in the order they are defined
   */
  orderBy?: InputMaybe<Array<OrderByInput>>;
  /**
   * paginate `IssueComment` records
   *
   * using `paginate` may require multiple requests to get all possible results,
   * but will give more fine-grain control in the event all records cannot be
   * returned gracefully
   */
  paginate?: InputMaybe<PaginationInput>;
  text?: InputMaybe<StringFilter>;
  userId?: InputMaybe<StringFilter>;
};

/** response metadata for a list query of IssueComment records */
export type IssueCommentListResponse = {
  __typename: 'IssueCommentListResponse';
  /** the total count of IssueComment records matching any configured filters */
  count: Scalars['Int'];
  /** the total count of paginated groups of IssueComment */
  pages: Scalars['Int'];
  /** IssueComment records */
  records: Array<IssueComment>;
};

export type IssueDispositionType = {
  __typename: 'IssueDispositionType';
  /** the date this record was inserted into the database */
  createdDate: Scalars['DateTime'];
  /**
   * the email address of a user associated with the `createdDate`
   *
   * this value will be `unknown` if the `createdDate` was not set by a user
   */
  createdUser: Scalars['String'];
  /** describes whether the record has been soft-deleted or not */
  deleted: Scalars['Boolean'];
  /** the date this record was soft-deleted in the database */
  deletedDate: Maybe<Scalars['DateTime']>;
  /**
   * the email address of a user associated with the `deletedDate`
   *
   * this value will be `system` if the `deletedDate` was not set by a user
   */
  deletedUser: Maybe<Scalars['String']>;
  /**
   * an extended description associated with the record
   *
   * this description will be used to describe the record in CIMS, where possible
   */
  description: Maybe<Scalars['String']>;
  /** a UUID used to globally identify this record in the database */
  id: Scalars['String'];
  issues: Array<Issue>;
  /** the date this record was last updated in the database */
  lastEditedDate: Scalars['DateTime'];
  /**
   * the email address of a user associated with the `lastEditedDate`
   *
   * this value will be `system` if the `lastEditedDate` was not set by a user
   */
  lastEditedUser: Scalars['String'];
  /** a human readable name associated with the record */
  name: Scalars['String'];
  nonApplicableIssueTypes: Array<IssueType>;
  /** a related `Project` */
  project: Project;
  /** the `globalId` of a related `Project` */
  projectId: Scalars['String'];
};


export type IssueDispositionTypeIssuesArgs = {
  issueFieldInput?: InputMaybe<IssueFieldInput>;
};


export type IssueDispositionTypeNonApplicableIssueTypesArgs = {
  issueTypeFieldInput?: InputMaybe<IssueTypeFieldInput>;
};

/**
 * helps filter multiple `IssueDispositionType` records
 *
 * this version of the input will have limited options compared to its other counterpart
 */
export type IssueDispositionTypeFieldInput = {
  createdDate?: InputMaybe<DateTimeFilter>;
  /**
   * determines now to handle deleted `IssueDispositionType` records
   *
   * - when `true`, only return deleted records
   * - when `false`, do not return deleted records
   * - when omitted, `deleted` is ignored
   */
  deleted?: InputMaybe<Scalars['Boolean']>;
  description?: InputMaybe<StringFilter>;
  lastEditedDate?: InputMaybe<DateTimeFilter>;
  name?: InputMaybe<StringFilter>;
  /**
   * how to order `IssueDispositionType` records
   *
   * executed in the order they are defined
   */
  orderBy?: InputMaybe<Array<OrderByInput>>;
  projectId?: InputMaybe<StringFilter>;
  /**
   * specifies how many records to return
   *
   * analogous to `limit`, `first`, or `top` in SQL dialects
   */
  take?: InputMaybe<Scalars['Int']>;
};

/** helps filter multiple `IssueDispositionType` records */
export type IssueDispositionTypeListInput = {
  createdDate?: InputMaybe<DateTimeFilter>;
  /**
   * determines now to handle deleted `IssueDispositionType` records
   *
   * - when `true`, only return deleted records
   * - when `false`, do not return deleted records
   * - when omitted, `deleted` is ignored
   */
  deleted?: InputMaybe<Scalars['Boolean']>;
  description?: InputMaybe<StringFilter>;
  lastEditedDate?: InputMaybe<DateTimeFilter>;
  name?: InputMaybe<StringFilter>;
  /**
   * how to order `IssueDispositionType` records
   *
   * executed in the order they are defined
   */
  orderBy?: InputMaybe<Array<OrderByInput>>;
  /**
   * paginate `IssueDispositionType` records
   *
   * using `paginate` may require multiple requests to get all possible results,
   * but will give more fine-grain control in the event all records cannot be
   * returned gracefully
   */
  paginate?: InputMaybe<PaginationInput>;
  projectId?: InputMaybe<StringFilter>;
};

/** response metadata for a list query of IssueDispositionType records */
export type IssueDispositionTypeListResponse = {
  __typename: 'IssueDispositionTypeListResponse';
  /** the total count of IssueDispositionType records matching any configured filters */
  count: Scalars['Int'];
  /** the total count of paginated groups of IssueDispositionType */
  pages: Scalars['Int'];
  /** IssueDispositionType records */
  records: Array<IssueDispositionType>;
};

/**
 * helps filter multiple `Issue` records
 *
 * this version of the input will have limited options compared to its other counterpart
 */
export type IssueFieldInput = {
  closedById?: InputMaybe<StringFilter>;
  closedDate?: InputMaybe<DateTimeFilter>;
  closureNotes?: InputMaybe<StringFilter>;
  createdDate?: InputMaybe<DateTimeFilter>;
  /**
   * determines now to handle deleted `Issue` records
   *
   * - when `true`, only return deleted records
   * - when `false`, do not return deleted records
   * - when omitted, `deleted` is ignored
   */
  deleted?: InputMaybe<Scalars['Boolean']>;
  description?: InputMaybe<StringFilter>;
  dispositionById?: InputMaybe<StringFilter>;
  dispositionDate?: InputMaybe<DateTimeFilter>;
  dispositionNotes?: InputMaybe<StringFilter>;
  dispositionTypeId?: InputMaybe<StringFilter>;
  lastEditedDate?: InputMaybe<DateTimeFilter>;
  number?: InputMaybe<IntFilter>;
  /**
   * how to order `Issue` records
   *
   * executed in the order they are defined
   */
  orderBy?: InputMaybe<Array<OrderByInput>>;
  projectId?: InputMaybe<StringFilter>;
  response?: InputMaybe<StringFilter>;
  responseById?: InputMaybe<StringFilter>;
  responseDate?: InputMaybe<DateTimeFilter>;
  statusId?: InputMaybe<StringFilter>;
  submittedById?: InputMaybe<StringFilter>;
  submittedDate?: InputMaybe<DateTimeFilter>;
  /**
   * specifies how many records to return
   *
   * analogous to `limit`, `first`, or `top` in SQL dialects
   */
  take?: InputMaybe<Scalars['Int']>;
};

/** helps filter multiple `Issue` records */
export type IssueListInput = {
  closedById?: InputMaybe<StringFilter>;
  closedDate?: InputMaybe<DateTimeFilter>;
  closureNotes?: InputMaybe<StringFilter>;
  createdDate?: InputMaybe<DateTimeFilter>;
  /**
   * determines now to handle deleted `Issue` records
   *
   * - when `true`, only return deleted records
   * - when `false`, do not return deleted records
   * - when omitted, `deleted` is ignored
   */
  deleted?: InputMaybe<Scalars['Boolean']>;
  description?: InputMaybe<StringFilter>;
  dispositionById?: InputMaybe<StringFilter>;
  dispositionDate?: InputMaybe<DateTimeFilter>;
  dispositionNotes?: InputMaybe<StringFilter>;
  dispositionTypeId?: InputMaybe<StringFilter>;
  lastEditedDate?: InputMaybe<DateTimeFilter>;
  number?: InputMaybe<IntFilter>;
  /**
   * how to order `Issue` records
   *
   * executed in the order they are defined
   */
  orderBy?: InputMaybe<Array<OrderByInput>>;
  /**
   * paginate `Issue` records
   *
   * using `paginate` may require multiple requests to get all possible results,
   * but will give more fine-grain control in the event all records cannot be
   * returned gracefully
   */
  paginate?: InputMaybe<PaginationInput>;
  projectId?: InputMaybe<StringFilter>;
  response?: InputMaybe<StringFilter>;
  responseById?: InputMaybe<StringFilter>;
  responseDate?: InputMaybe<DateTimeFilter>;
  statusId?: InputMaybe<StringFilter>;
  submittedById?: InputMaybe<StringFilter>;
  submittedDate?: InputMaybe<DateTimeFilter>;
};

/** response metadata for a list query of Issue records */
export type IssueListResponse = {
  __typename: 'IssueListResponse';
  /** the total count of Issue records matching any configured filters */
  count: Scalars['Int'];
  /** the total count of paginated groups of Issue */
  pages: Scalars['Int'];
  /** Issue records */
  records: Array<Issue>;
};

/**
 * notifications hold a recipients configuration for a given
 * notification event in Issue Tracker workflows
 *
 * recipients can be users, or non user emails
 *
 * certain events may require users to receive a notification if they are given permission
 * to perform a specific task
 */
export type IssueNotification = {
  __typename: 'IssueNotification';
  /** the date this record was inserted into the database */
  createdDate: Scalars['DateTime'];
  /**
   * the email address of a user associated with the `createdDate`
   *
   * this value will be `unknown` if the `createdDate` was not set by a user
   */
  createdUser: Scalars['String'];
  /** the date this record was last updated in the database */
  lastEditedDate: Scalars['DateTime'];
  /**
   * the email address of a user associated with the `lastEditedDate`
   *
   * this value will be `system` if the `lastEditedDate` was not set by a user
   */
  lastEditedUser: Scalars['String'];
  /** the name of the notification event associated with this Notification */
  notificationEvent: Scalars['String'];
  notificationEventId: Scalars['String'];
  /** a related `Project` */
  project: Project;
  /** the `globalId` of a related `Project` */
  projectId: Scalars['String'];
  recipients: IssueNotificationRecipients;
};

/**
 * helps filter multiple `IssueNotification` records
 *
 * this version of the input will have limited options compared to its other counterpart
 */
export type IssueNotificationFieldInput = {
  createdDate?: InputMaybe<DateTimeFilter>;
  lastEditedDate?: InputMaybe<DateTimeFilter>;
  notificationEventId?: InputMaybe<StringFilter>;
  /**
   * how to order `IssueNotification` records
   *
   * executed in the order they are defined
   */
  orderBy?: InputMaybe<Array<OrderByInput>>;
  projectId?: InputMaybe<StringFilter>;
  /**
   * specifies how many records to return
   *
   * analogous to `limit`, `first`, or `top` in SQL dialects
   */
  take?: InputMaybe<Scalars['Int']>;
};

/** helps filter multiple `IssueNotification` records */
export type IssueNotificationListInput = {
  createdDate?: InputMaybe<DateTimeFilter>;
  lastEditedDate?: InputMaybe<DateTimeFilter>;
  notificationEventId?: InputMaybe<StringFilter>;
  /**
   * how to order `IssueNotification` records
   *
   * executed in the order they are defined
   */
  orderBy?: InputMaybe<Array<OrderByInput>>;
  /**
   * paginate `IssueNotification` records
   *
   * using `paginate` may require multiple requests to get all possible results,
   * but will give more fine-grain control in the event all records cannot be
   * returned gracefully
   */
  paginate?: InputMaybe<PaginationInput>;
  projectId?: InputMaybe<StringFilter>;
};

/** response metadata for a list query of IssueNotification records */
export type IssueNotificationListResponse = {
  __typename: 'IssueNotificationListResponse';
  /** the total count of IssueNotification records matching any configured filters */
  count: Scalars['Int'];
  /** the total count of paginated groups of IssueNotification */
  pages: Scalars['Int'];
  /** IssueNotification records */
  records: Array<IssueNotification>;
};

export type IssueNotificationRecipients = {
  __typename: 'IssueNotificationRecipients';
  byIssueType: Maybe<Array<ByIssueType>>;
  every: Maybe<Recipients>;
};


export type IssueNotificationRecipientsByIssueTypeArgs = {
  issueTypeFieldInput?: InputMaybe<IssueTypeFieldInput>;
};

/**
 * `IssueQuickLink` records are used in the External Link Editor to allow users
 * to quickly add external links to the `externalLinks` field of a `Issue`
 *
 * `IssueQuickLink` records used in `externalLinks` are not referenced by `id`, but copied
 * as they are currently defined
 *
 * changes made to any `IssueQuickLink` record will not affect the `externalLinks` of the `Issue`
 */
export type IssueQuickLink = {
  __typename: 'IssueQuickLink';
  /** the date this record was inserted into the database */
  createdDate: Scalars['DateTime'];
  /**
   * the email address of a user associated with the `createdDate`
   *
   * this value will be `unknown` if the `createdDate` was not set by a user
   */
  createdUser: Scalars['String'];
  /** describes whether the record has been soft-deleted or not */
  deleted: Scalars['Boolean'];
  /** the date this record was soft-deleted in the database */
  deletedDate: Maybe<Scalars['DateTime']>;
  /**
   * the email address of a user associated with the `deletedDate`
   *
   * this value will be `system` if the `deletedDate` was not set by a user
   */
  deletedUser: Maybe<Scalars['String']>;
  /**
   * an extended description associated with the record
   *
   * this description will be used to describe the record in CIMS, where possible
   */
  description: Maybe<Scalars['String']>;
  /** an optional link associated with the `label` */
  href: Maybe<Scalars['String']>;
  /** a UUID used to globally identify this record in the database */
  id: Scalars['String'];
  /** the human readable link text */
  label: Scalars['String'];
  /** the date this record was last updated in the database */
  lastEditedDate: Scalars['DateTime'];
  /**
   * the email address of a user associated with the `lastEditedDate`
   *
   * this value will be `system` if the `lastEditedDate` was not set by a user
   */
  lastEditedUser: Scalars['String'];
  project: Project;
  /** the `globalId` of a related `Project` */
  projectId: Scalars['String'];
};

/**
 * helps filter multiple `IssueQuickLink` records
 *
 * this version of the input will have limited options compared to its other counterpart
 */
export type IssueQuickLinkFieldInput = {
  createdDate?: InputMaybe<DateTimeFilter>;
  /**
   * determines now to handle deleted `IssueQuickLink` records
   *
   * - when `true`, only return deleted records
   * - when `false`, do not return deleted records
   * - when omitted, `deleted` is ignored
   */
  deleted?: InputMaybe<Scalars['Boolean']>;
  description?: InputMaybe<StringFilter>;
  href?: InputMaybe<StringFilter>;
  id?: InputMaybe<StringFilter>;
  label?: InputMaybe<StringFilter>;
  lastEditedDate?: InputMaybe<DateTimeFilter>;
  /**
   * how to order `IssueQuickLink` records
   *
   * executed in the order they are defined
   */
  orderBy?: InputMaybe<Array<OrderByInput>>;
  projectId?: InputMaybe<StringFilter>;
  /**
   * specifies how many records to return
   *
   * analogous to `limit`, `first`, or `top` in SQL dialects
   */
  take?: InputMaybe<Scalars['Int']>;
};

/** helps filter multiple `IssueQuickLink` records */
export type IssueQuickLinkListInput = {
  createdDate?: InputMaybe<DateTimeFilter>;
  /**
   * determines now to handle deleted `IssueQuickLink` records
   *
   * - when `true`, only return deleted records
   * - when `false`, do not return deleted records
   * - when omitted, `deleted` is ignored
   */
  deleted?: InputMaybe<Scalars['Boolean']>;
  description?: InputMaybe<StringFilter>;
  href?: InputMaybe<StringFilter>;
  id?: InputMaybe<StringFilter>;
  label?: InputMaybe<StringFilter>;
  lastEditedDate?: InputMaybe<DateTimeFilter>;
  /**
   * how to order `IssueQuickLink` records
   *
   * executed in the order they are defined
   */
  orderBy?: InputMaybe<Array<OrderByInput>>;
  /**
   * paginate `IssueQuickLink` records
   *
   * using `paginate` may require multiple requests to get all possible results,
   * but will give more fine-grain control in the event all records cannot be
   * returned gracefully
   */
  paginate?: InputMaybe<PaginationInput>;
  projectId?: InputMaybe<StringFilter>;
};

/** response metadata for a list query of IssueQuickLink records */
export type IssueQuickLinkListResponse = {
  __typename: 'IssueQuickLinkListResponse';
  /** the total count of IssueQuickLink records matching any configured filters */
  count: Scalars['Int'];
  /** the total count of paginated groups of IssueQuickLink */
  pages: Scalars['Int'];
  /** IssueQuickLink records */
  records: Array<IssueQuickLink>;
};

/** `IssueToPayItemNoGeometry` helps connect many `Issue` records with many `PayItemNoGeometry` records */
export type IssueToPayItemNoGeometry = {
  __typename: 'IssueToPayItemNoGeometry';
  issue: Issue;
  issueId: Scalars['String'];
  payItem: PayItemNoGeometry;
  /** the `globalId` of a related `PayItemNoGeometry` */
  payItemId: Scalars['String'];
};

/**
 * helps filter multiple `IssueToPayItemNoGeometry` records
 *
 * this version of the input will have limited options compared to its other counterpart
 */
export type IssueToPayItemNoGeometryFieldInput = {
  issueId?: InputMaybe<StringFilter>;
  /**
   * how to order `IssueToPayItemNoGeometry` records
   *
   * executed in the order they are defined
   */
  orderBy?: InputMaybe<Array<OrderByInput>>;
  payItemId?: InputMaybe<StringFilter>;
  /**
   * specifies how many records to return
   *
   * analogous to `limit`, `first`, or `top` in SQL dialects
   */
  take?: InputMaybe<Scalars['Int']>;
};

/** helps filter multiple `IssueToPayItemNoGeometry` records */
export type IssueToPayItemNoGeometryListInput = {
  issueId?: InputMaybe<StringFilter>;
  /**
   * how to order `IssueToPayItemNoGeometry` records
   *
   * executed in the order they are defined
   */
  orderBy?: InputMaybe<Array<OrderByInput>>;
  /**
   * paginate `IssueToPayItemNoGeometry` records
   *
   * using `paginate` may require multiple requests to get all possible results,
   * but will give more fine-grain control in the event all records cannot be
   * returned gracefully
   */
  paginate?: InputMaybe<PaginationInput>;
  payItemId?: InputMaybe<StringFilter>;
};

/** response metadata for a list query of IssueToPayItemNoGeometry records */
export type IssueToPayItemNoGeometryListResponse = {
  __typename: 'IssueToPayItemNoGeometryListResponse';
  /** the total count of IssueToPayItemNoGeometry records matching any configured filters */
  count: Scalars['Int'];
  /** the total count of paginated groups of IssueToPayItemNoGeometry */
  pages: Scalars['Int'];
  /** IssueToPayItemNoGeometry records */
  records: Array<IssueToPayItemNoGeometry>;
};

export type IssueToReport = {
  __typename: 'IssueToReport';
  asphaltLot: Maybe<AsphaltLot>;
  concreteTest: Maybe<ConcreteTest>;
  concreteTestSet: Maybe<ConcreteTestSet>;
  dailyInspectionControlPoint: Maybe<DailyInspectionControlPoint>;
  dailyInspectionInspection: Maybe<DailyInspectionInspection>;
  dailyInspectionPunchList: Maybe<DailyInspectionPunchList>;
  densityTest: Maybe<DensityTest>;
  issue: Issue;
  issueId: Scalars['String'];
  lot: Maybe<Lot>;
  reportId: Scalars['String'];
  reportType: Scalars['String'];
  reportTypeId: Scalars['String'];
};

/**
 * helps filter multiple `IssueToReport` records
 *
 * this version of the input will have limited options compared to its other counterpart
 */
export type IssueToReportFieldInput = {
  issueId?: InputMaybe<StringFilter>;
  /**
   * how to order `IssueToReport` records
   *
   * executed in the order they are defined
   */
  orderBy?: InputMaybe<Array<OrderByInput>>;
  reportId?: InputMaybe<StringFilter>;
  reportTypeId?: InputMaybe<StringFilter>;
  /**
   * specifies how many records to return
   *
   * analogous to `limit`, `first`, or `top` in SQL dialects
   */
  take?: InputMaybe<Scalars['Int']>;
};

/** helps filter multiple `IssueToReport` records */
export type IssueToReportListInput = {
  issueId?: InputMaybe<StringFilter>;
  /**
   * how to order `IssueToReport` records
   *
   * executed in the order they are defined
   */
  orderBy?: InputMaybe<Array<OrderByInput>>;
  /**
   * paginate `IssueToReport` records
   *
   * using `paginate` may require multiple requests to get all possible results,
   * but will give more fine-grain control in the event all records cannot be
   * returned gracefully
   */
  paginate?: InputMaybe<PaginationInput>;
  reportId?: InputMaybe<StringFilter>;
  reportTypeId?: InputMaybe<StringFilter>;
};

/** response metadata for a list query of IssueToReport records */
export type IssueToReportListResponse = {
  __typename: 'IssueToReportListResponse';
  /** the total count of IssueToReport records matching any configured filters */
  count: Scalars['Int'];
  /** the total count of paginated groups of IssueToReport */
  pages: Scalars['Int'];
  /** IssueToReport records */
  records: Array<IssueToReport>;
};

export type IssueType = {
  __typename: 'IssueType';
  /** the date this record was inserted into the database */
  createdDate: Scalars['DateTime'];
  /**
   * the email address of a user associated with the `createdDate`
   *
   * this value will be `unknown` if the `createdDate` was not set by a user
   */
  createdUser: Scalars['String'];
  /** describes whether the record has been soft-deleted or not */
  deleted: Scalars['Boolean'];
  /** the date this record was soft-deleted in the database */
  deletedDate: Maybe<Scalars['DateTime']>;
  /**
   * the email address of a user associated with the `deletedDate`
   *
   * this value will be `system` if the `deletedDate` was not set by a user
   */
  deletedUser: Maybe<Scalars['String']>;
  /**
   * an extended description associated with the record
   *
   * this description will be used to describe the record in CIMS, where possible
   */
  description: Maybe<Scalars['String']>;
  /** a UUID used to globally identify this record in the database */
  id: Scalars['String'];
  issues: Array<Issue>;
  /** the date this record was last updated in the database */
  lastEditedDate: Scalars['DateTime'];
  /**
   * the email address of a user associated with the `lastEditedDate`
   *
   * this value will be `system` if the `lastEditedDate` was not set by a user
   */
  lastEditedUser: Scalars['String'];
  /** a human readable name associated with the record */
  name: Scalars['String'];
  nonApplicableIssueDispositionTypes: Array<IssueDispositionType>;
  /** a related `Project` */
  project: Project;
  /** the `globalId` of a related `Project` */
  projectId: Scalars['String'];
};


export type IssueTypeIssuesArgs = {
  issueFieldInput?: InputMaybe<IssueFieldInput>;
};


export type IssueTypeNonApplicableIssueDispositionTypesArgs = {
  issueDispositionTypeFieldInput?: InputMaybe<IssueDispositionTypeFieldInput>;
};

/**
 * helps filter multiple `IssueType` records
 *
 * this version of the input will have limited options compared to its other counterpart
 */
export type IssueTypeFieldInput = {
  createdDate?: InputMaybe<DateTimeFilter>;
  /**
   * determines now to handle deleted `IssueType` records
   *
   * - when `true`, only return deleted records
   * - when `false`, do not return deleted records
   * - when omitted, `deleted` is ignored
   */
  deleted?: InputMaybe<Scalars['Boolean']>;
  description?: InputMaybe<StringFilter>;
  lastEditedDate?: InputMaybe<DateTimeFilter>;
  name?: InputMaybe<StringFilter>;
  /**
   * how to order `IssueType` records
   *
   * executed in the order they are defined
   */
  orderBy?: InputMaybe<Array<OrderByInput>>;
  projectId?: InputMaybe<StringFilter>;
  /**
   * specifies how many records to return
   *
   * analogous to `limit`, `first`, or `top` in SQL dialects
   */
  take?: InputMaybe<Scalars['Int']>;
};

/** helps filter multiple `IssueType` records */
export type IssueTypeListInput = {
  createdDate?: InputMaybe<DateTimeFilter>;
  /**
   * determines now to handle deleted `IssueType` records
   *
   * - when `true`, only return deleted records
   * - when `false`, do not return deleted records
   * - when omitted, `deleted` is ignored
   */
  deleted?: InputMaybe<Scalars['Boolean']>;
  description?: InputMaybe<StringFilter>;
  lastEditedDate?: InputMaybe<DateTimeFilter>;
  name?: InputMaybe<StringFilter>;
  /**
   * how to order `IssueType` records
   *
   * executed in the order they are defined
   */
  orderBy?: InputMaybe<Array<OrderByInput>>;
  /**
   * paginate `IssueType` records
   *
   * using `paginate` may require multiple requests to get all possible results,
   * but will give more fine-grain control in the event all records cannot be
   * returned gracefully
   */
  paginate?: InputMaybe<PaginationInput>;
  projectId?: InputMaybe<StringFilter>;
};

/** response metadata for a list query of IssueType records */
export type IssueTypeListResponse = {
  __typename: 'IssueTypeListResponse';
  /** the total count of IssueType records matching any configured filters */
  count: Scalars['Int'];
  /** the total count of paginated groups of IssueType */
  pages: Scalars['Int'];
  /** IssueType records */
  records: Array<IssueType>;
};

export type LimsAsphaltJointCore = {
  __typename: 'LIMSAsphaltJointCore';
  /** the date this record was inserted into the database */
  createdDate: Scalars['DateTime'];
  /**
   * the email address of a user associated with the `createdDate`
   *
   * this value will be `unknown` if the `createdDate` was not set by a user
   */
  createdUser: Scalars['String'];
  /** describes whether the record has been soft-deleted or not */
  deleted: Scalars['Boolean'];
  /** the date this record was soft-deleted in the database */
  deletedDate: Maybe<Scalars['DateTime']>;
  /**
   * the email address of a user associated with the `deletedDate`
   *
   * this value will be `system` if the `deletedDate` was not set by a user
   */
  deletedUser: Maybe<Scalars['String']>;
  density: Maybe<Scalars['Float']>;
  /** a UUID used to globally identify this record in the database */
  id: Scalars['String'];
  label: Scalars['String'];
  /** the date this record was last updated in the database */
  lastEditedDate: Scalars['DateTime'];
  /**
   * the email address of a user associated with the `lastEditedDate`
   *
   * this value will be `system` if the `lastEditedDate` was not set by a user
   */
  lastEditedUser: Scalars['String'];
  lot: LimsAsphaltLot;
  lotId: Scalars['String'];
  station: Maybe<Scalars['String']>;
};

/**
 * helps filter multiple `LIMSAsphaltJointCore` records
 *
 * this version of the input will have limited options compared to its other counterpart
 */
export type LimsAsphaltJointCoreFieldInput = {
  createdDate?: InputMaybe<DateTimeFilter>;
  /**
   * determines now to handle deleted `LIMSAsphaltJointCore` records
   *
   * - when `true`, only return deleted records
   * - when `false`, do not return deleted records
   * - when omitted, `deleted` is ignored
   */
  deleted?: InputMaybe<Scalars['Boolean']>;
  density?: InputMaybe<FloatFilter>;
  label?: InputMaybe<StringFilter>;
  lastEditedDate?: InputMaybe<DateTimeFilter>;
  lotId?: InputMaybe<StringFilter>;
  /**
   * how to order `LIMSAsphaltJointCore` records
   *
   * executed in the order they are defined
   */
  orderBy?: InputMaybe<Array<OrderByInput>>;
  station?: InputMaybe<StringFilter>;
  /**
   * specifies how many records to return
   *
   * analogous to `limit`, `first`, or `top` in SQL dialects
   */
  take?: InputMaybe<Scalars['Int']>;
};

/** helps filter multiple `LIMSAsphaltJointCore` records */
export type LimsAsphaltJointCoreListInput = {
  createdDate?: InputMaybe<DateTimeFilter>;
  /**
   * determines now to handle deleted `LIMSAsphaltJointCore` records
   *
   * - when `true`, only return deleted records
   * - when `false`, do not return deleted records
   * - when omitted, `deleted` is ignored
   */
  deleted?: InputMaybe<Scalars['Boolean']>;
  density?: InputMaybe<FloatFilter>;
  label?: InputMaybe<StringFilter>;
  lastEditedDate?: InputMaybe<DateTimeFilter>;
  lotId?: InputMaybe<StringFilter>;
  /**
   * how to order `LIMSAsphaltJointCore` records
   *
   * executed in the order they are defined
   */
  orderBy?: InputMaybe<Array<OrderByInput>>;
  /**
   * paginate `LIMSAsphaltJointCore` records
   *
   * using `paginate` may require multiple requests to get all possible results,
   * but will give more fine-grain control in the event all records cannot be
   * returned gracefully
   */
  paginate?: InputMaybe<PaginationInput>;
  station?: InputMaybe<StringFilter>;
};

/** response metadata for a list query of LIMSAsphaltJointCore records */
export type LimsAsphaltJointCoreListResponse = {
  __typename: 'LIMSAsphaltJointCoreListResponse';
  /** the total count of LIMSAsphaltJointCore records matching any configured filters */
  count: Scalars['Int'];
  /** the total count of paginated groups of LIMSAsphaltJointCore */
  pages: Scalars['Int'];
  /** LIMSAsphaltJointCore records */
  records: Array<LimsAsphaltJointCore>;
};

export type LimsAsphaltLot = {
  __typename: 'LIMSAsphaltLot';
  /** the date this record was inserted into the database */
  createdDate: Scalars['DateTime'];
  /**
   * the email address of a user associated with the `createdDate`
   *
   * this value will be `unknown` if the `createdDate` was not set by a user
   */
  createdUser: Scalars['String'];
  /** describes whether the record has been soft-deleted or not */
  deleted: Scalars['Boolean'];
  /** the date this record was soft-deleted in the database */
  deletedDate: Maybe<Scalars['DateTime']>;
  /**
   * the email address of a user associated with the `deletedDate`
   *
   * this value will be `system` if the `deletedDate` was not set by a user
   */
  deletedUser: Maybe<Scalars['String']>;
  designSize: Maybe<Scalars['String']>;
  /** a UUID used to globally identify this record in the database */
  id: Scalars['String'];
  /** joint compaction pay incentive */
  jointCompactPayIncen: Maybe<Scalars['Float']>;
  jointCoreTargetDensity: Maybe<Scalars['Float']>;
  jointCores: Array<LimsAsphaltJointCore>;
  label: Scalars['String'];
  /** the date this record was last updated in the database */
  lastEditedDate: Scalars['DateTime'];
  /**
   * the email address of a user associated with the `lastEditedDate`
   *
   * this value will be `system` if the `lastEditedDate` was not set by a user
   */
  lastEditedUser: Scalars['String'];
  limsAsphaltLotToPayItemNoGeometries: Array<LimsAsphaltLotToPayItemNoGeometry>;
  /** mat compaction pay incentive pay adjustment */
  matCompactPayIncenPayAdjust: Maybe<Scalars['Float']>;
  matCoreDesignThickness: Maybe<Scalars['Float']>;
  matCorePtValue: Maybe<Scalars['Float']>;
  matCoreTargetDensity: Maybe<Scalars['Float']>;
  matCores: Array<LimsAsphaltMatCore>;
  mixDesign: AsphaltMixDesign;
  mixDesignId: Scalars['String'];
  /** limited to 4000 characters */
  notes: Maybe<Scalars['String']>;
  /** a related `Project` */
  project: Project;
  /** the `globalId` of a related `Project` */
  projectId: Scalars['String'];
  quantityReportedTons: Maybe<Scalars['Float']>;
  /** limited to 4000 characters */
  remarks: Maybe<Scalars['String']>;
  samples: Array<LimsAsphaltSample>;
  status: Scalars['String'];
  statusId: Scalars['String'];
  /**
   * @deprecated this field has been deprecated and expires soon after lims is moved to cims office
   *
   * it may be removed at any time after expiration, but not before
   *
   * this field will eventually be removed in favor of the fields `submittedById` and `submittedBy`, which will map to an actual CIMS `User`
   */
  submittedByName: Maybe<Scalars['String']>;
  /** the date this record was submitted the database */
  submittedDate: Maybe<Scalars['DateTime']>;
  unitPrice: Maybe<Scalars['Float']>;
};


export type LimsAsphaltLotJointCoresArgs = {
  limsAsphaltJointCoreFieldInput?: InputMaybe<LimsAsphaltJointCoreFieldInput>;
};


export type LimsAsphaltLotLimsAsphaltLotToPayItemNoGeometriesArgs = {
  limsAsphaltLotToPayItemNoGeometryFieldInput?: InputMaybe<LimsAsphaltLotToPayItemNoGeometryFieldInput>;
};


export type LimsAsphaltLotMatCoresArgs = {
  limsAsphaltMatCoreFieldInput?: InputMaybe<LimsAsphaltMatCoreFieldInput>;
};


export type LimsAsphaltLotSamplesArgs = {
  limsAsphaltSampleFieldInput?: InputMaybe<LimsAsphaltSampleFieldInput>;
};

/**
 * helps filter multiple `LIMSAsphaltLot` records
 *
 * this version of the input will have limited options compared to its other counterpart
 */
export type LimsAsphaltLotFieldInput = {
  createdDate?: InputMaybe<DateTimeFilter>;
  /**
   * determines now to handle deleted `LIMSAsphaltLot` records
   *
   * - when `true`, only return deleted records
   * - when `false`, do not return deleted records
   * - when omitted, `deleted` is ignored
   */
  deleted?: InputMaybe<Scalars['Boolean']>;
  designSize?: InputMaybe<StringFilter>;
  jointCompactPayIncen?: InputMaybe<FloatFilter>;
  jointCoreTargetDensity?: InputMaybe<FloatFilter>;
  label?: InputMaybe<StringFilter>;
  lastEditedDate?: InputMaybe<DateTimeFilter>;
  matCompactPayIncenPayAdjust?: InputMaybe<FloatFilter>;
  matCoreDesignThickness?: InputMaybe<FloatFilter>;
  matCorePtValue?: InputMaybe<FloatFilter>;
  matCoreTargetDensity?: InputMaybe<FloatFilter>;
  mixDesignId?: InputMaybe<StringFilter>;
  notes?: InputMaybe<StringFilter>;
  /**
   * how to order `LIMSAsphaltLot` records
   *
   * executed in the order they are defined
   */
  orderBy?: InputMaybe<Array<OrderByInput>>;
  projectId?: InputMaybe<StringFilter>;
  quantityReportedTons?: InputMaybe<FloatFilter>;
  remarks?: InputMaybe<StringFilter>;
  statusId?: InputMaybe<StringFilter>;
  submittedByName?: InputMaybe<StringFilter>;
  submittedDate?: InputMaybe<DateTimeFilter>;
  /**
   * specifies how many records to return
   *
   * analogous to `limit`, `first`, or `top` in SQL dialects
   */
  take?: InputMaybe<Scalars['Int']>;
  unitPrice?: InputMaybe<FloatFilter>;
};

/** helps filter multiple `LIMSAsphaltLot` records */
export type LimsAsphaltLotListInput = {
  createdDate?: InputMaybe<DateTimeFilter>;
  /**
   * determines now to handle deleted `LIMSAsphaltLot` records
   *
   * - when `true`, only return deleted records
   * - when `false`, do not return deleted records
   * - when omitted, `deleted` is ignored
   */
  deleted?: InputMaybe<Scalars['Boolean']>;
  designSize?: InputMaybe<StringFilter>;
  jointCompactPayIncen?: InputMaybe<FloatFilter>;
  jointCoreTargetDensity?: InputMaybe<FloatFilter>;
  label?: InputMaybe<StringFilter>;
  lastEditedDate?: InputMaybe<DateTimeFilter>;
  matCompactPayIncenPayAdjust?: InputMaybe<FloatFilter>;
  matCoreDesignThickness?: InputMaybe<FloatFilter>;
  matCorePtValue?: InputMaybe<FloatFilter>;
  matCoreTargetDensity?: InputMaybe<FloatFilter>;
  mixDesignId?: InputMaybe<StringFilter>;
  notes?: InputMaybe<StringFilter>;
  /**
   * how to order `LIMSAsphaltLot` records
   *
   * executed in the order they are defined
   */
  orderBy?: InputMaybe<Array<OrderByInput>>;
  /**
   * paginate `LIMSAsphaltLot` records
   *
   * using `paginate` may require multiple requests to get all possible results,
   * but will give more fine-grain control in the event all records cannot be
   * returned gracefully
   */
  paginate?: InputMaybe<PaginationInput>;
  projectId?: InputMaybe<StringFilter>;
  quantityReportedTons?: InputMaybe<FloatFilter>;
  remarks?: InputMaybe<StringFilter>;
  statusId?: InputMaybe<StringFilter>;
  submittedByName?: InputMaybe<StringFilter>;
  submittedDate?: InputMaybe<DateTimeFilter>;
  unitPrice?: InputMaybe<FloatFilter>;
};

/** response metadata for a list query of LIMSAsphaltLot records */
export type LimsAsphaltLotListResponse = {
  __typename: 'LIMSAsphaltLotListResponse';
  /** the total count of LIMSAsphaltLot records matching any configured filters */
  count: Scalars['Int'];
  /** the total count of paginated groups of LIMSAsphaltLot */
  pages: Scalars['Int'];
  /** LIMSAsphaltLot records */
  records: Array<LimsAsphaltLot>;
};

/** `LIMSAsphaltLotToPayItemNoGeometry` helps connect many `LIMSAsphaltLot` records with many `PayItemNoGeometry` records */
export type LimsAsphaltLotToPayItemNoGeometry = {
  __typename: 'LIMSAsphaltLotToPayItemNoGeometry';
  lot: LimsAsphaltLot;
  lotId: Scalars['String'];
  payItem: PayItemNoGeometry;
  /** the `globalId` of a related `PayItemNoGeometry` */
  payItemId: Scalars['String'];
};

/**
 * helps filter multiple `LIMSAsphaltLotToPayItemNoGeometry` records
 *
 * this version of the input will have limited options compared to its other counterpart
 */
export type LimsAsphaltLotToPayItemNoGeometryFieldInput = {
  lotId?: InputMaybe<StringFilter>;
  /**
   * how to order `LIMSAsphaltLotToPayItemNoGeometry` records
   *
   * executed in the order they are defined
   */
  orderBy?: InputMaybe<Array<OrderByInput>>;
  payItemId?: InputMaybe<StringFilter>;
  /**
   * specifies how many records to return
   *
   * analogous to `limit`, `first`, or `top` in SQL dialects
   */
  take?: InputMaybe<Scalars['Int']>;
};

/** helps filter multiple `LIMSAsphaltLotToPayItemNoGeometry` records */
export type LimsAsphaltLotToPayItemNoGeometryListInput = {
  lotId?: InputMaybe<StringFilter>;
  /**
   * how to order `LIMSAsphaltLotToPayItemNoGeometry` records
   *
   * executed in the order they are defined
   */
  orderBy?: InputMaybe<Array<OrderByInput>>;
  /**
   * paginate `LIMSAsphaltLotToPayItemNoGeometry` records
   *
   * using `paginate` may require multiple requests to get all possible results,
   * but will give more fine-grain control in the event all records cannot be
   * returned gracefully
   */
  paginate?: InputMaybe<PaginationInput>;
  payItemId?: InputMaybe<StringFilter>;
};

/** response metadata for a list query of LIMSAsphaltLotToPayItemNoGeometry records */
export type LimsAsphaltLotToPayItemNoGeometryListResponse = {
  __typename: 'LIMSAsphaltLotToPayItemNoGeometryListResponse';
  /** the total count of LIMSAsphaltLotToPayItemNoGeometry records matching any configured filters */
  count: Scalars['Int'];
  /** the total count of paginated groups of LIMSAsphaltLotToPayItemNoGeometry */
  pages: Scalars['Int'];
  /** LIMSAsphaltLotToPayItemNoGeometry records */
  records: Array<LimsAsphaltLotToPayItemNoGeometry>;
};

export type LimsAsphaltMatCore = {
  __typename: 'LIMSAsphaltMatCore';
  /** the date this record was inserted into the database */
  createdDate: Scalars['DateTime'];
  /**
   * the email address of a user associated with the `createdDate`
   *
   * this value will be `unknown` if the `createdDate` was not set by a user
   */
  createdUser: Scalars['String'];
  /** describes whether the record has been soft-deleted or not */
  deleted: Scalars['Boolean'];
  /** the date this record was soft-deleted in the database */
  deletedDate: Maybe<Scalars['DateTime']>;
  /**
   * the email address of a user associated with the `deletedDate`
   *
   * this value will be `system` if the `deletedDate` was not set by a user
   */
  deletedUser: Maybe<Scalars['String']>;
  density: Maybe<Scalars['Float']>;
  /** a UUID used to globally identify this record in the database */
  id: Scalars['String'];
  include: Scalars['Boolean'];
  label: Scalars['String'];
  /** the date this record was last updated in the database */
  lastEditedDate: Scalars['DateTime'];
  /**
   * the email address of a user associated with the `lastEditedDate`
   *
   * this value will be `system` if the `lastEditedDate` was not set by a user
   */
  lastEditedUser: Scalars['String'];
  lot: LimsAsphaltLot;
  lotId: Scalars['String'];
  station: Maybe<Scalars['String']>;
  thickness: Maybe<Scalars['Float']>;
};

/**
 * helps filter multiple `LIMSAsphaltMatCore` records
 *
 * this version of the input will have limited options compared to its other counterpart
 */
export type LimsAsphaltMatCoreFieldInput = {
  createdDate?: InputMaybe<DateTimeFilter>;
  /**
   * determines now to handle deleted `LIMSAsphaltMatCore` records
   *
   * - when `true`, only return deleted records
   * - when `false`, do not return deleted records
   * - when omitted, `deleted` is ignored
   */
  deleted?: InputMaybe<Scalars['Boolean']>;
  density?: InputMaybe<FloatFilter>;
  /**
   * - when `true`, `include` is truthy
   * - when `false`, `include` is falsy
   * - when omitted, `include` is ignored
   */
  include?: InputMaybe<Scalars['Boolean']>;
  label?: InputMaybe<StringFilter>;
  lastEditedDate?: InputMaybe<DateTimeFilter>;
  lotId?: InputMaybe<StringFilter>;
  /**
   * how to order `LIMSAsphaltMatCore` records
   *
   * executed in the order they are defined
   */
  orderBy?: InputMaybe<Array<OrderByInput>>;
  station?: InputMaybe<StringFilter>;
  /**
   * specifies how many records to return
   *
   * analogous to `limit`, `first`, or `top` in SQL dialects
   */
  take?: InputMaybe<Scalars['Int']>;
  thickness?: InputMaybe<FloatFilter>;
};

/** helps filter multiple `LIMSAsphaltMatCore` records */
export type LimsAsphaltMatCoreListInput = {
  createdDate?: InputMaybe<DateTimeFilter>;
  /**
   * determines now to handle deleted `LIMSAsphaltMatCore` records
   *
   * - when `true`, only return deleted records
   * - when `false`, do not return deleted records
   * - when omitted, `deleted` is ignored
   */
  deleted?: InputMaybe<Scalars['Boolean']>;
  density?: InputMaybe<FloatFilter>;
  /**
   * - when `true`, `include` is truthy
   * - when `false`, `include` is falsy
   * - when omitted, `include` is ignored
   */
  include?: InputMaybe<Scalars['Boolean']>;
  label?: InputMaybe<StringFilter>;
  lastEditedDate?: InputMaybe<DateTimeFilter>;
  lotId?: InputMaybe<StringFilter>;
  /**
   * how to order `LIMSAsphaltMatCore` records
   *
   * executed in the order they are defined
   */
  orderBy?: InputMaybe<Array<OrderByInput>>;
  /**
   * paginate `LIMSAsphaltMatCore` records
   *
   * using `paginate` may require multiple requests to get all possible results,
   * but will give more fine-grain control in the event all records cannot be
   * returned gracefully
   */
  paginate?: InputMaybe<PaginationInput>;
  station?: InputMaybe<StringFilter>;
  thickness?: InputMaybe<FloatFilter>;
};

/** response metadata for a list query of LIMSAsphaltMatCore records */
export type LimsAsphaltMatCoreListResponse = {
  __typename: 'LIMSAsphaltMatCoreListResponse';
  /** the total count of LIMSAsphaltMatCore records matching any configured filters */
  count: Scalars['Int'];
  /** the total count of paginated groups of LIMSAsphaltMatCore */
  pages: Scalars['Int'];
  /** LIMSAsphaltMatCore records */
  records: Array<LimsAsphaltMatCore>;
};

export type LimsAsphaltMixDesignTarget = {
  __typename: 'LIMSAsphaltMixDesignTarget';
  /** the date this record was inserted into the database */
  createdDate: Scalars['DateTime'];
  /**
   * the email address of a user associated with the `createdDate`
   *
   * this value will be `unknown` if the `createdDate` was not set by a user
   */
  createdUser: Scalars['String'];
  /** describes whether the record has been soft-deleted or not */
  deleted: Scalars['Boolean'];
  /** the date this record was soft-deleted in the database */
  deletedDate: Maybe<Scalars['DateTime']>;
  /**
   * the email address of a user associated with the `deletedDate`
   *
   * this value will be `system` if the `deletedDate` was not set by a user
   */
  deletedUser: Maybe<Scalars['String']>;
  /**
   * an extended description associated with the record
   *
   * this description will be used to describe the record in CIMS, where possible
   */
  description: Maybe<Scalars['String']>;
  /** a UUID used to globally identify this record in the database */
  id: Scalars['String'];
  /** the date this record was last updated in the database */
  lastEditedDate: Scalars['DateTime'];
  /**
   * the email address of a user associated with the `lastEditedDate`
   *
   * this value will be `system` if the `lastEditedDate` was not set by a user
   */
  lastEditedUser: Scalars['String'];
  /** a human readable name associated with the record */
  name: Scalars['String'];
  percentages: Array<AsphaltMixDesignTargetPercentage>;
  /** a related `Project` */
  project: Project;
  /** the `globalId` of a related `Project` */
  projectId: Scalars['String'];
  /** `AsphaltMixDesign` records must have an `AsphaltMixDesignTargetPercentage` for this `LIMSAsphaltMixDesignTarget` when required is true */
  required: Scalars['Boolean'];
  results: Array<LimsAsphaltSampleResult>;
};


export type LimsAsphaltMixDesignTargetPercentagesArgs = {
  asphaltMixDesignTargetPercentageFieldInput?: InputMaybe<AsphaltMixDesignTargetPercentageFieldInput>;
};


export type LimsAsphaltMixDesignTargetResultsArgs = {
  limsAsphaltSampleResultFieldInput?: InputMaybe<LimsAsphaltSampleResultFieldInput>;
};

/**
 * helps filter multiple `LIMSAsphaltMixDesignTarget` records
 *
 * this version of the input will have limited options compared to its other counterpart
 */
export type LimsAsphaltMixDesignTargetFieldInput = {
  createdDate?: InputMaybe<DateTimeFilter>;
  /**
   * determines now to handle deleted `LIMSAsphaltMixDesignTarget` records
   *
   * - when `true`, only return deleted records
   * - when `false`, do not return deleted records
   * - when omitted, `deleted` is ignored
   */
  deleted?: InputMaybe<Scalars['Boolean']>;
  description?: InputMaybe<StringFilter>;
  lastEditedDate?: InputMaybe<DateTimeFilter>;
  name?: InputMaybe<StringFilter>;
  /**
   * how to order `LIMSAsphaltMixDesignTarget` records
   *
   * executed in the order they are defined
   */
  orderBy?: InputMaybe<Array<OrderByInput>>;
  percentage?: InputMaybe<FloatFilter>;
  projectId?: InputMaybe<StringFilter>;
  /**
   * specifies how many records to return
   *
   * analogous to `limit`, `first`, or `top` in SQL dialects
   */
  take?: InputMaybe<Scalars['Int']>;
};

/** helps filter multiple `LIMSAsphaltMixDesignTarget` records */
export type LimsAsphaltMixDesignTargetListInput = {
  createdDate?: InputMaybe<DateTimeFilter>;
  /**
   * determines now to handle deleted `LIMSAsphaltMixDesignTarget` records
   *
   * - when `true`, only return deleted records
   * - when `false`, do not return deleted records
   * - when omitted, `deleted` is ignored
   */
  deleted?: InputMaybe<Scalars['Boolean']>;
  description?: InputMaybe<StringFilter>;
  lastEditedDate?: InputMaybe<DateTimeFilter>;
  name?: InputMaybe<StringFilter>;
  /**
   * how to order `LIMSAsphaltMixDesignTarget` records
   *
   * executed in the order they are defined
   */
  orderBy?: InputMaybe<Array<OrderByInput>>;
  /**
   * paginate `LIMSAsphaltMixDesignTarget` records
   *
   * using `paginate` may require multiple requests to get all possible results,
   * but will give more fine-grain control in the event all records cannot be
   * returned gracefully
   */
  paginate?: InputMaybe<PaginationInput>;
  percentage?: InputMaybe<FloatFilter>;
  projectId?: InputMaybe<StringFilter>;
};

/** response metadata for a list query of LIMSAsphaltMixDesignTarget records */
export type LimsAsphaltMixDesignTargetListResponse = {
  __typename: 'LIMSAsphaltMixDesignTargetListResponse';
  /** the total count of LIMSAsphaltMixDesignTarget records matching any configured filters */
  count: Scalars['Int'];
  /** the total count of paginated groups of LIMSAsphaltMixDesignTarget */
  pages: Scalars['Int'];
  /** LIMSAsphaltMixDesignTarget records */
  records: Array<LimsAsphaltMixDesignTarget>;
};

export type LimsAsphaltSample = {
  __typename: 'LIMSAsphaltSample';
  /** assumed to be a number between 0 and 100 */
  acPercentage: Maybe<Scalars['Float']>;
  avgMixVoids: Maybe<Scalars['Float']>;
  bulkSpecGravMix: Maybe<Scalars['Float']>;
  /** the date this record was inserted into the database */
  createdDate: Scalars['DateTime'];
  /**
   * the email address of a user associated with the `createdDate`
   *
   * this value will be `unknown` if the `createdDate` was not set by a user
   */
  createdUser: Scalars['String'];
  /** describes whether the record has been soft-deleted or not */
  deleted: Scalars['Boolean'];
  /** the date this record was soft-deleted in the database */
  deletedDate: Maybe<Scalars['DateTime']>;
  /**
   * the email address of a user associated with the `deletedDate`
   *
   * this value will be `system` if the `deletedDate` was not set by a user
   */
  deletedUser: Maybe<Scalars['String']>;
  /** a UUID used to globally identify this record in the database */
  id: Scalars['String'];
  label: Scalars['String'];
  /** the date this record was last updated in the database */
  lastEditedDate: Scalars['DateTime'];
  /**
   * the email address of a user associated with the `lastEditedDate`
   *
   * this value will be `system` if the `lastEditedDate` was not set by a user
   */
  lastEditedUser: Scalars['String'];
  laydownTemp: Maybe<Scalars['Float']>;
  location: Maybe<Scalars['String']>;
  lot: LimsAsphaltLot;
  lotId: Scalars['String'];
  results: Array<LimsAsphaltSampleResult>;
  riceMaxDensity: Maybe<Scalars['Float']>;
  riceVolumeVoidless: Maybe<Scalars['Float']>;
  vma: Maybe<Scalars['Float']>;
};


export type LimsAsphaltSampleResultsArgs = {
  limsAsphaltSampleResultFieldInput?: InputMaybe<LimsAsphaltSampleResultFieldInput>;
};

/**
 * helps filter multiple `LIMSAsphaltSample` records
 *
 * this version of the input will have limited options compared to its other counterpart
 */
export type LimsAsphaltSampleFieldInput = {
  acPercentage?: InputMaybe<FloatFilter>;
  avgMixVoids?: InputMaybe<FloatFilter>;
  bulkSpecGravMix?: InputMaybe<FloatFilter>;
  createdDate?: InputMaybe<DateTimeFilter>;
  /**
   * determines now to handle deleted `LIMSAsphaltSample` records
   *
   * - when `true`, only return deleted records
   * - when `false`, do not return deleted records
   * - when omitted, `deleted` is ignored
   */
  deleted?: InputMaybe<Scalars['Boolean']>;
  label?: InputMaybe<StringFilter>;
  lastEditedDate?: InputMaybe<DateTimeFilter>;
  laydownTemp?: InputMaybe<FloatFilter>;
  location?: InputMaybe<StringFilter>;
  lotId?: InputMaybe<StringFilter>;
  /**
   * how to order `LIMSAsphaltSample` records
   *
   * executed in the order they are defined
   */
  orderBy?: InputMaybe<Array<OrderByInput>>;
  riceMaxDensity?: InputMaybe<FloatFilter>;
  riceVolumeVoidless?: InputMaybe<FloatFilter>;
  /**
   * specifies how many records to return
   *
   * analogous to `limit`, `first`, or `top` in SQL dialects
   */
  take?: InputMaybe<Scalars['Int']>;
  vma?: InputMaybe<FloatFilter>;
};

/** helps filter multiple `LIMSAsphaltSample` records */
export type LimsAsphaltSampleListInput = {
  acPercentage?: InputMaybe<FloatFilter>;
  avgMixVoids?: InputMaybe<FloatFilter>;
  bulkSpecGravMix?: InputMaybe<FloatFilter>;
  createdDate?: InputMaybe<DateTimeFilter>;
  /**
   * determines now to handle deleted `LIMSAsphaltSample` records
   *
   * - when `true`, only return deleted records
   * - when `false`, do not return deleted records
   * - when omitted, `deleted` is ignored
   */
  deleted?: InputMaybe<Scalars['Boolean']>;
  label?: InputMaybe<StringFilter>;
  lastEditedDate?: InputMaybe<DateTimeFilter>;
  laydownTemp?: InputMaybe<FloatFilter>;
  location?: InputMaybe<StringFilter>;
  lotId?: InputMaybe<StringFilter>;
  /**
   * how to order `LIMSAsphaltSample` records
   *
   * executed in the order they are defined
   */
  orderBy?: InputMaybe<Array<OrderByInput>>;
  /**
   * paginate `LIMSAsphaltSample` records
   *
   * using `paginate` may require multiple requests to get all possible results,
   * but will give more fine-grain control in the event all records cannot be
   * returned gracefully
   */
  paginate?: InputMaybe<PaginationInput>;
  riceMaxDensity?: InputMaybe<FloatFilter>;
  riceVolumeVoidless?: InputMaybe<FloatFilter>;
  vma?: InputMaybe<FloatFilter>;
};

/** response metadata for a list query of LIMSAsphaltSample records */
export type LimsAsphaltSampleListResponse = {
  __typename: 'LIMSAsphaltSampleListResponse';
  /** the total count of LIMSAsphaltSample records matching any configured filters */
  count: Scalars['Int'];
  /** the total count of paginated groups of LIMSAsphaltSample */
  pages: Scalars['Int'];
  /** LIMSAsphaltSample records */
  records: Array<LimsAsphaltSample>;
};

export type LimsAsphaltSampleResult = {
  __typename: 'LIMSAsphaltSampleResult';
  /** the date this record was inserted into the database */
  createdDate: Scalars['DateTime'];
  /**
   * the email address of a user associated with the `createdDate`
   *
   * this value will be `unknown` if the `createdDate` was not set by a user
   */
  createdUser: Scalars['String'];
  /** describes whether the record has been soft-deleted or not */
  deleted: Scalars['Boolean'];
  /** the date this record was soft-deleted in the database */
  deletedDate: Maybe<Scalars['DateTime']>;
  /**
   * the email address of a user associated with the `deletedDate`
   *
   * this value will be `system` if the `deletedDate` was not set by a user
   */
  deletedUser: Maybe<Scalars['String']>;
  /** the date this record was last updated in the database */
  lastEditedDate: Scalars['DateTime'];
  /**
   * the email address of a user associated with the `lastEditedDate`
   *
   * this value will be `system` if the `lastEditedDate` was not set by a user
   */
  lastEditedUser: Scalars['String'];
  sample: LimsAsphaltSample;
  sampleId: Scalars['String'];
  target: LimsAsphaltMixDesignTarget;
  targetId: Scalars['String'];
  /** assumed to be a number between 0 and 100 */
  value: Scalars['Float'];
};

/**
 * helps filter multiple `LIMSAsphaltSampleResult` records
 *
 * this version of the input will have limited options compared to its other counterpart
 */
export type LimsAsphaltSampleResultFieldInput = {
  /**
   * determines now to handle deleted `LIMSAsphaltSampleResult` records
   *
   * - when `true`, only return deleted records
   * - when `false`, do not return deleted records
   * - when omitted, `deleted` is ignored
   */
  deleted?: InputMaybe<Scalars['Boolean']>;
  /**
   * how to order `LIMSAsphaltSampleResult` records
   *
   * executed in the order they are defined
   */
  orderBy?: InputMaybe<Array<OrderByInput>>;
  sampleId?: InputMaybe<StringFilter>;
  /**
   * specifies how many records to return
   *
   * analogous to `limit`, `first`, or `top` in SQL dialects
   */
  take?: InputMaybe<Scalars['Int']>;
  targetId?: InputMaybe<StringFilter>;
  value?: InputMaybe<FloatFilter>;
};

/** helps filter multiple `LIMSAsphaltSampleResult` records */
export type LimsAsphaltSampleResultListInput = {
  /**
   * determines now to handle deleted `LIMSAsphaltSampleResult` records
   *
   * - when `true`, only return deleted records
   * - when `false`, do not return deleted records
   * - when omitted, `deleted` is ignored
   */
  deleted?: InputMaybe<Scalars['Boolean']>;
  /**
   * how to order `LIMSAsphaltSampleResult` records
   *
   * executed in the order they are defined
   */
  orderBy?: InputMaybe<Array<OrderByInput>>;
  /**
   * paginate `LIMSAsphaltSampleResult` records
   *
   * using `paginate` may require multiple requests to get all possible results,
   * but will give more fine-grain control in the event all records cannot be
   * returned gracefully
   */
  paginate?: InputMaybe<PaginationInput>;
  sampleId?: InputMaybe<StringFilter>;
  targetId?: InputMaybe<StringFilter>;
  value?: InputMaybe<FloatFilter>;
};

/** response metadata for a list query of LIMSAsphaltSampleResult records */
export type LimsAsphaltSampleResultListResponse = {
  __typename: 'LIMSAsphaltSampleResultListResponse';
  /** the total count of LIMSAsphaltSampleResult records matching any configured filters */
  count: Scalars['Int'];
  /** the total count of paginated groups of LIMSAsphaltSampleResult */
  pages: Scalars['Int'];
  /** LIMSAsphaltSampleResult records */
  records: Array<LimsAsphaltSampleResult>;
};

export type LabTech = {
  __typename: 'LabTech';
  concreteCoreBreakDatas: Array<ConcreteCoreBreakData>;
  concreteTestBreakDatas: Array<ConcreteTestBreakData>;
  /** the date this record was inserted into the database */
  createdDate: Scalars['DateTime'];
  /**
   * the email address of a user associated with the `createdDate`
   *
   * this value will be `unknown` if the `createdDate` was not set by a user
   */
  createdUser: Scalars['String'];
  /** a unique integer to identify this record in the database table */
  id: Scalars['Int'];
  /** the date this record was last updated in the database */
  lastEditedDate: Scalars['DateTime'];
  /**
   * the email address of a user associated with the `lastEditedDate`
   *
   * this value will be `system` if the `lastEditedDate` was not set by a user
   */
  lastEditedUser: Scalars['String'];
  name: Scalars['String'];
  /** a related `Project` */
  project: Project;
  /** the `globalId` of a related `Project` */
  projectId: Scalars['String'];
  testingLabs: Array<TestingLab>;
  user: Maybe<User>;
  userId: Maybe<Scalars['String']>;
};


export type LabTechConcreteCoreBreakDatasArgs = {
  concreteCoreBreakDataFieldInput?: InputMaybe<ConcreteCoreBreakDataFieldInput>;
};


export type LabTechConcreteTestBreakDatasArgs = {
  concreteTestBreakDataFieldInput?: InputMaybe<ConcreteTestBreakDataFieldInput>;
};


export type LabTechTestingLabsArgs = {
  testingLabFieldInput?: InputMaybe<TestingLabFieldInput>;
};

/**
 * helps filter multiple `LabTech` records
 *
 * this version of the input will have limited options compared to its other counterpart
 */
export type LabTechFieldInput = {
  createdDate?: InputMaybe<DateTimeFilter>;
  lastEditedDate?: InputMaybe<DateTimeFilter>;
  name?: InputMaybe<StringFilter>;
  /**
   * how to order `LabTech` records
   *
   * executed in the order they are defined
   */
  orderBy?: InputMaybe<Array<OrderByInput>>;
  projectId?: InputMaybe<StringFilter>;
  /**
   * specifies how many records to return
   *
   * analogous to `limit`, `first`, or `top` in SQL dialects
   */
  take?: InputMaybe<Scalars['Int']>;
};

/** helps filter multiple `LabTech` records */
export type LabTechListInput = {
  createdDate?: InputMaybe<DateTimeFilter>;
  lastEditedDate?: InputMaybe<DateTimeFilter>;
  name?: InputMaybe<StringFilter>;
  /**
   * how to order `LabTech` records
   *
   * executed in the order they are defined
   */
  orderBy?: InputMaybe<Array<OrderByInput>>;
  /**
   * paginate `LabTech` records
   *
   * using `paginate` may require multiple requests to get all possible results,
   * but will give more fine-grain control in the event all records cannot be
   * returned gracefully
   */
  paginate?: InputMaybe<PaginationInput>;
  projectId?: InputMaybe<StringFilter>;
};

/** response metadata for a list query of LabTech records */
export type LabTechListResponse = {
  __typename: 'LabTechListResponse';
  /** the total count of LabTech records matching any configured filters */
  count: Scalars['Int'];
  /** the total count of paginated groups of LabTech */
  pages: Scalars['Int'];
  /** LabTech records */
  records: Array<LabTech>;
};

/** a dropdown with pre-defined values */
export type ListCustomFieldValue = {
  __typename: 'ListCustomFieldValue';
  /** the date this record was inserted into the database */
  createdDate: Scalars['DateTime'];
  /**
   * the email address of a user associated with the `createdDate`
   *
   * this value will be `unknown` if the `createdDate` was not set by a user
   */
  createdUser: Scalars['String'];
  customField: CustomField;
  /** the `id` of a related `CustomField` */
  customFieldId: Scalars['String'];
  customListItem: Maybe<CustomListItem>;
  /** the `id` of a related `CustomListItem` */
  customListItemId: Maybe<Scalars['String']>;
  /** the date this record was soft-deleted in the database */
  deletedDate: Maybe<Scalars['DateTime']>;
  /**
   * the email address of a user associated with the `deletedDate`
   *
   * this value will be `system` if the `deletedDate` was not set by a user
   */
  deletedUser: Maybe<Scalars['String']>;
  /** the date this record was last updated in the database */
  lastEditedDate: Scalars['DateTime'];
  /**
   * the email address of a user associated with the `lastEditedDate`
   *
   * this value will be `system` if the `lastEditedDate` was not set by a user
   */
  lastEditedUser: Scalars['String'];
};

/** a dropdown with pre-defined values */
export type ListCustomFieldValues = {
  __typename: 'ListCustomFieldValues';
  /** the date this record was inserted into the database */
  createdDate: Scalars['DateTime'];
  /**
   * the email address of a user associated with the `createdDate`
   *
   * this value will be `unknown` if the `createdDate` was not set by a user
   */
  createdUser: Scalars['String'];
  customField: CustomField;
  /** the `id` of a related `CustomField` */
  customFieldId: Scalars['String'];
  /** the ids of related `CustomListItem` records */
  customListItemIds: Array<Scalars['String']>;
  customListItems: Array<CustomListItem>;
  /** the date this record was soft-deleted in the database */
  deletedDate: Maybe<Scalars['DateTime']>;
  /**
   * the email address of a user associated with the `deletedDate`
   *
   * this value will be `system` if the `deletedDate` was not set by a user
   */
  deletedUser: Maybe<Scalars['String']>;
  /** the date this record was last updated in the database */
  lastEditedDate: Scalars['DateTime'];
  /**
   * the email address of a user associated with the `lastEditedDate`
   *
   * this value will be `system` if the `lastEditedDate` was not set by a user
   */
  lastEditedUser: Scalars['String'];
};

export type ListValues = {
  __typename: 'ListValues';
  checkboxes: Array<BooleanListCustomFieldValues>;
  multiples: Array<ListCustomFieldValues>;
  singles: Array<ListCustomFieldValue>;
};

export type Lot = {
  __typename: 'Lot';
  archiveDate: Maybe<Scalars['DateTime']>;
  archiveUser: Maybe<Scalars['String']>;
  archived: Scalars['Boolean'];
  areaSqft: Maybe<Scalars['Float']>;
  areaSqyrd: Maybe<Scalars['Float']>;
  base64MapImage: Maybe<Scalars['String']>;
  beginAlignment: Maybe<Scalars['String']>;
  beginningLiftNumber: Maybe<Scalars['Int']>;
  checkGenerateErrors: Scalars['Boolean'];
  closed: Maybe<Scalars['DateTime']>;
  compactionAverage: Maybe<Scalars['Float']>;
  contractor: Maybe<Contractor>;
  contractorNameOverride: Maybe<Scalars['String']>;
  /** the `globalId` of a related `Contractor` */
  contractorsGuid: Maybe<Scalars['String']>;
  /** the date this record was inserted into the database */
  createdDate: Maybe<Scalars['DateTime']>;
  /** the username or email address of a mobile app user associated with the `createdDate` */
  createdUser: Maybe<Scalars['String']>;
  dailyStandardDensityCounts: Maybe<Scalars['Int']>;
  dailyStandardMoistureCounts: Maybe<Scalars['Int']>;
  dateLotCreated: Maybe<Scalars['DateTime']>;
  deleted: Scalars['Boolean'];
  densityTests: Array<DensityTest>;
  ejToReports: Array<EjToReport>;
  endAlignment: Maybe<Scalars['String']>;
  endOffset: Maybe<Scalars['String']>;
  endStation: Maybe<Scalars['String']>;
  genericPlacements: Array<GenericPlacement>;
  /** a GUID used to globally identify this record in the database */
  globalId: Scalars['String'];
  globalOptimumMoisture: Maybe<Scalars['Float']>;
  globalProctorValue: Maybe<Scalars['Float']>;
  globalT99OrT180: Maybe<Scalars['String']>;
  globalTestDepth: Maybe<Scalars['Float']>;
  guageNumber: Maybe<Scalars['String']>;
  guidBackup: Maybe<Scalars['String']>;
  identifiedFieldIssue: Maybe<IdentifiedFieldIssue>;
  issueToReports: Array<IssueToReport>;
  /** the date this record was last updated in the database */
  lastEditedDate: Maybe<Scalars['DateTime']>;
  /** the username or email address of a mobile app user associated with the `lastEditedDate` */
  lastEditedUser: Maybe<Scalars['String']>;
  liftThickness: Maybe<Scalars['Float']>;
  liftThicknessIn: Maybe<Scalars['Float']>;
  linealFt: Maybe<Scalars['Float']>;
  lotId: Maybe<Scalars['String']>;
  manualMeasurements: Scalars['Boolean'];
  material: Maybe<MaterialRequirement>;
  /** the `globalId` of a related `MaterialRequirement` */
  materialGuid: Maybe<Scalars['String']>;
  /**
   * this field name is result of a naming convention collision
   * which would produce an invalid schema
   *
   * if any of the below is a column, the associated value is the _database_ column name
   *
   * - this relation : `materialSource`
   * - colliding column : `Material_Source`
   */
  materialSource: Maybe<MaterialSource>;
  /** the `globalId` of a related `MaterialSource` */
  materialSourceGuid: Maybe<Scalars['String']>;
  materialSourceOverride: Maybe<Scalars['String']>;
  /**
   * this field name is result of a naming convention collision
   * which would produce an invalid schema
   *
   * if any of the below is a column, the associated value is the _database_ column name
   *
   * - this column : `Material_Source`
   * - colliding relation : `materialSource`
   */
  materialSourceString: Maybe<Scalars['String']>;
  materialType: Maybe<MaterialType>;
  materialTypeId: Maybe<Scalars['String']>;
  materialTypeString: Maybe<Scalars['String']>;
  mediaUploads: Array<MediaUpload>;
  /**
   * If set, contains a comma separated list of
   * `PayItemNoGeometry.globalId` values
   *
   * unfortunately, there have been instances where one of these values doesn't map
   * to a valid `PayItemNoGeometry`
   *
   * `payItemNoGeometries` will skip these rather than map them to `null`
   */
  multiplePayItems: Maybe<Scalars['String']>;
  numberOfRequiredTests: Maybe<Scalars['Int']>;
  overrideComments: Maybe<Scalars['String']>;
  overrideDate: Maybe<Scalars['DateTime']>;
  overrideStatus: Maybe<Scalars['String']>;
  overrideUser: Maybe<Scalars['String']>;
  payItemGuid: Maybe<Scalars['String']>;
  /**
   * aggregates all `PayItemNoGeometry` records associated with this
   * `Lot` by using its `PayItemNoGeometry` reference and `multiplePayItems`
   *
   * if any `PayItemNoGeometry.globalId` values used to query the database return `null`,
   * the `null` value will be filtered out of the results
   *
   * every result will be a valid `PayItemNoGeometry`
   */
  payItemNoGeometries: Array<PayItemNoGeometry>;
  pinNumber: Maybe<Scalars['String']>;
  proctor: Maybe<Proctor>;
  /** the `globalId` of a related `Proctor` */
  proctorGuid: Maybe<Scalars['String']>;
  proctorManualOverride: Scalars['Boolean'];
  /** a related `Project` */
  project: Maybe<Project>;
  /** the `globalId` of a related `Project` */
  projectId: Maybe<Scalars['String']>;
  projectName: Maybe<Scalars['String']>;
  projectNumber: Maybe<Scalars['String']>;
  reject: Maybe<Scalars['DateTime']>;
  renderInfo: Maybe<Scalars['String']>;
  reopen: Maybe<Scalars['DateTime']>;
  reportToTags: Array<ReportToTag>;
  retestId: Maybe<Scalars['String']>;
  reviewComment: Maybe<Scalars['String']>;
  reviewedBy: Maybe<Scalars['String']>;
  reviewedByGuid: Maybe<Scalars['String']>;
  reviewedByTechnician: Maybe<Technician>;
  reviewedDate: Maybe<Scalars['DateTime']>;
  shape: Maybe<Scalars['String']>;
  startOffset: Maybe<Scalars['String']>;
  startStation: Maybe<Scalars['String']>;
  status: Maybe<Scalars['String']>;
  structure: Maybe<Structure>;
  structureId: Maybe<Scalars['String']>;
  structureType: Maybe<StructureType>;
  structureTypeId: Maybe<Scalars['String']>;
  technician: Maybe<Scalars['String']>;
  technicianDate: Maybe<Scalars['DateTime']>;
  testId: Maybe<Scalars['String']>;
  udotRe: Maybe<Scalars['String']>;
  volumeCuYds: Maybe<Scalars['Float']>;
};


export type LotBase64MapImageArgs = {
  projectLayerIds?: InputMaybe<Array<Scalars['Int']>>;
};


export type LotDensityTestsArgs = {
  densityTestFieldInput?: InputMaybe<DensityTestFieldInput>;
};


export type LotEjToReportsArgs = {
  eJToReportFieldInput?: InputMaybe<EjToReportFieldInput>;
};


export type LotGenericPlacementsArgs = {
  genericPlacementFieldInput?: InputMaybe<GenericPlacementFieldInput>;
};


export type LotIssueToReportsArgs = {
  issueToReportFieldInput?: InputMaybe<IssueToReportFieldInput>;
};


export type LotMediaUploadsArgs = {
  mediaUploadFieldInput?: InputMaybe<MediaUploadFieldInput>;
};


export type LotPayItemNoGeometriesArgs = {
  payItemNoGeometryFieldInput?: InputMaybe<PayItemNoGeometryFieldInput>;
};


export type LotReportToTagsArgs = {
  reportToTagFieldInput?: InputMaybe<ReportToTagFieldInput>;
};

export type LotCompactionIfiSettings = {
  __typename: 'LotCompactionIFISettings';
  /** the date this record was enabled the database */
  effectiveDate: Maybe<Scalars['DateTime']>;
  enabled: Scalars['Boolean'];
  levelId: Maybe<Scalars['String']>;
  message: Maybe<Scalars['String']>;
};

/**
 * helps filter multiple `Lot` records
 *
 * this version of the input will have limited options compared to its other counterpart
 */
export type LotFieldInput = {
  createdDate?: InputMaybe<DateTimeFilter>;
  /**
   * determines now to handle deleted `Lot` records
   *
   * - when `true`, only return deleted records
   * - when `false`, do not return deleted records
   * - when omitted, `deleted` is ignored
   */
  deleted?: InputMaybe<Scalars['Boolean']>;
  lastEditedDate?: InputMaybe<DateTimeFilter>;
  lotId?: InputMaybe<StringFilter>;
  /**
   * how to order `Lot` records
   *
   * executed in the order they are defined
   */
  orderBy?: InputMaybe<Array<OrderByInput>>;
  projectId?: InputMaybe<StringFilter>;
  status?: InputMaybe<StringFilter>;
  /**
   * specifies how many records to return
   *
   * analogous to `limit`, `first`, or `top` in SQL dialects
   */
  take?: InputMaybe<Scalars['Int']>;
};

export type LotIfiSettings = {
  __typename: 'LotIFISettings';
  compaction: LotCompactionIfiSettings;
  /** the date this record was inserted into the database */
  createdDate: Scalars['DateTime'];
  /**
   * the email address of a user associated with the `createdDate`
   *
   * this value will be `unknown` if the `createdDate` was not set by a user
   */
  createdUser: Scalars['String'];
  effectiveDate: Maybe<Scalars['DateTime']>;
  enabled: Scalars['Boolean'];
  /** the date this record was last updated in the database */
  lastEditedDate: Scalars['DateTime'];
  /**
   * the email address of a user associated with the `lastEditedDate`
   *
   * this value will be `system` if the `lastEditedDate` was not set by a user
   */
  lastEditedUser: Scalars['String'];
  proctor: LotProctorIfiSettings;
  /** a related `Project` */
  project: Project;
  /** the `globalId` of a related `Project` */
  projectId: Scalars['String'];
  testCount: LotTestCountIfiSettings;
};

/** helps filter multiple `LotIFISettings` records */
export type LotIfiSettingsListInput = {
  /**
   * determines now to handle deleted `LotIFISettings` records
   *
   * - when `true`, only return deleted records
   * - when `false`, do not return deleted records
   * - when omitted, `deleted` is ignored
   */
  deleted?: InputMaybe<Scalars['Boolean']>;
  effectiveDate?: InputMaybe<DateTimeFilter>;
  /**
   * how to order `LotIFISettings` records
   *
   * executed in the order they are defined
   */
  orderBy?: InputMaybe<Array<OrderByInput>>;
  /**
   * paginate `LotIFISettings` records
   *
   * using `paginate` may require multiple requests to get all possible results,
   * but will give more fine-grain control in the event all records cannot be
   * returned gracefully
   */
  paginate?: InputMaybe<PaginationInput>;
  projectId?: InputMaybe<StringFilter>;
};

/** response metadata for a list query of LotIFISettings records */
export type LotIfiSettingsListResponse = {
  __typename: 'LotIFISettingsListResponse';
  /** the total count of LotIFISettings records matching any configured filters */
  count: Scalars['Int'];
  /** the total count of paginated groups of LotIFISettings */
  pages: Scalars['Int'];
  /** LotIFISettings records */
  records: Array<LotIfiSettings>;
};

/** helps filter multiple `Lot` records */
export type LotListInput = {
  createdDate?: InputMaybe<DateTimeFilter>;
  /**
   * determines now to handle deleted `Lot` records
   *
   * - when `true`, only return deleted records
   * - when `false`, do not return deleted records
   * - when omitted, `deleted` is ignored
   */
  deleted?: InputMaybe<Scalars['Boolean']>;
  lastEditedDate?: InputMaybe<DateTimeFilter>;
  lotId?: InputMaybe<StringFilter>;
  /**
   * how to order `Lot` records
   *
   * executed in the order they are defined
   */
  orderBy?: InputMaybe<Array<OrderByInput>>;
  /**
   * paginate `Lot` records
   *
   * using `paginate` may require multiple requests to get all possible results,
   * but will give more fine-grain control in the event all records cannot be
   * returned gracefully
   */
  paginate?: InputMaybe<PaginationInput>;
  projectId?: InputMaybe<StringFilter>;
  status?: InputMaybe<StringFilter>;
};

/** response metadata for a list query of Lot records */
export type LotListResponse = {
  __typename: 'LotListResponse';
  /** the total count of Lot records matching any configured filters */
  count: Scalars['Int'];
  /** the total count of paginated groups of Lot */
  pages: Scalars['Int'];
  /** Lot records */
  records: Array<Lot>;
};

export type LotProctorIfiSettings = {
  __typename: 'LotProctorIFISettings';
  /** the date this record was enabled the database */
  effectiveDate: Maybe<Scalars['DateTime']>;
  enabled: Scalars['Boolean'];
  message: Maybe<Scalars['String']>;
};

export type LotTestCountIfiSettings = {
  __typename: 'LotTestCountIFISettings';
  /** the date this record was enabled the database */
  effectiveDate: Maybe<Scalars['DateTime']>;
  enabled: Scalars['Boolean'];
  message: Maybe<Scalars['String']>;
};

export type MapImageResponse = {
  __typename: 'MapImageResponse';
  /** a base 64 encoded string containing a composite ArcGIS map image */
  b64: Scalars['String'];
};

/** `id` and `name` values for an ArcGIS map server layer */
export type MapServerLayer = {
  __typename: 'MapServerLayer';
  id: Scalars['Int'];
  name: Scalars['String'];
};

export type MaterialRequirement = {
  __typename: 'MaterialRequirement';
  /** the date this record was inserted into the database */
  createdDate: Maybe<Scalars['DateTime']>;
  /** the username or email address of a mobile app user associated with the `createdDate` */
  createdUser: Maybe<Scalars['String']>;
  deleted: Scalars['Boolean'];
  /** a GUID used to globally identify this record in the database */
  globalId: Scalars['String'];
  gradationArea: Maybe<Scalars['Int']>;
  gradationUnits: Maybe<Scalars['String']>;
  individualCompactionRequireme: Maybe<Scalars['Float']>;
  /** the date this record was last updated in the database */
  lastEditedDate: Maybe<Scalars['DateTime']>;
  /** the username or email address of a mobile app user associated with the `lastEditedDate` */
  lastEditedUser: Maybe<Scalars['String']>;
  lotCompactionRequirement: Maybe<Scalars['Float']>;
  lots: Array<Lot>;
  materialSection: Maybe<Scalars['String']>;
  maxIndividualCompaction: Maybe<Scalars['Float']>;
  maxLotCompaction: Maybe<Scalars['Float']>;
  mstrRandomOnly: Scalars['Boolean'];
  payItemNoGeometries: Array<PayItemNoGeometry>;
  payItems: Array<PayItem>;
  proctorArea: Maybe<Scalars['Int']>;
  proctorUnits: Maybe<Scalars['String']>;
  /** a related `Project` */
  project: Maybe<Project>;
  /** the `globalId` of a related `Project` */
  projectId: Maybe<Scalars['String']>;
  shortName: Maybe<Scalars['String']>;
  testingRequirementArea: Maybe<Scalars['Int']>;
  testingRequirementMinimum: Maybe<Scalars['Int']>;
  testingRequirementNumberOfT: Maybe<Scalars['Int']>;
  testingRequirementUnits: Maybe<Scalars['String']>;
  typicalLiftThicknessInches: Maybe<Scalars['Float']>;
};


export type MaterialRequirementPayItemNoGeometriesArgs = {
  payItemNoGeometryFieldInput?: InputMaybe<PayItemNoGeometryFieldInput>;
};


export type MaterialRequirementPayItemsArgs = {
  payItemFieldInput?: InputMaybe<PayItemFieldInput>;
};

/**
 * helps filter multiple `MaterialRequirement` records
 *
 * this version of the input will have limited options compared to its other counterpart
 */
export type MaterialRequirementFieldInput = {
  createdDate?: InputMaybe<DateTimeFilter>;
  /**
   * determines now to handle deleted `MaterialRequirement` records
   *
   * - when `true`, only return deleted records
   * - when `false`, do not return deleted records
   * - when omitted, `deleted` is ignored
   */
  deleted?: InputMaybe<Scalars['Boolean']>;
  lastEditedDate?: InputMaybe<DateTimeFilter>;
  materialSection?: InputMaybe<StringFilter>;
  /**
   * how to order `MaterialRequirement` records
   *
   * executed in the order they are defined
   */
  orderBy?: InputMaybe<Array<OrderByInput>>;
  projectId?: InputMaybe<StringFilter>;
  /**
   * specifies how many records to return
   *
   * analogous to `limit`, `first`, or `top` in SQL dialects
   */
  take?: InputMaybe<Scalars['Int']>;
};

/** helps filter multiple `MaterialRequirement` records */
export type MaterialRequirementListInput = {
  createdDate?: InputMaybe<DateTimeFilter>;
  /**
   * determines now to handle deleted `MaterialRequirement` records
   *
   * - when `true`, only return deleted records
   * - when `false`, do not return deleted records
   * - when omitted, `deleted` is ignored
   */
  deleted?: InputMaybe<Scalars['Boolean']>;
  lastEditedDate?: InputMaybe<DateTimeFilter>;
  materialSection?: InputMaybe<StringFilter>;
  /**
   * how to order `MaterialRequirement` records
   *
   * executed in the order they are defined
   */
  orderBy?: InputMaybe<Array<OrderByInput>>;
  /**
   * paginate `MaterialRequirement` records
   *
   * using `paginate` may require multiple requests to get all possible results,
   * but will give more fine-grain control in the event all records cannot be
   * returned gracefully
   */
  paginate?: InputMaybe<PaginationInput>;
  projectId?: InputMaybe<StringFilter>;
};

/** response metadata for a list query of MaterialRequirement records */
export type MaterialRequirementListResponse = {
  __typename: 'MaterialRequirementListResponse';
  /** the total count of MaterialRequirement records matching any configured filters */
  count: Scalars['Int'];
  /** the total count of paginated groups of MaterialRequirement */
  pages: Scalars['Int'];
  /** MaterialRequirement records */
  records: Array<MaterialRequirement>;
};

export type MaterialSource = {
  __typename: 'MaterialSource';
  classification: Maybe<Scalars['String']>;
  /** the date this record was inserted into the database */
  createdDate: Maybe<Scalars['DateTime']>;
  /** the username or email address of a mobile app user associated with the `createdDate` */
  createdUser: Maybe<Scalars['String']>;
  deleted: Scalars['Boolean'];
  densityTests: Array<DensityTest>;
  /** a GUID used to globally identify this record in the database */
  globalId: Scalars['String'];
  /** the date this record was last updated in the database */
  lastEditedDate: Maybe<Scalars['DateTime']>;
  /** the username or email address of a mobile app user associated with the `lastEditedDate` */
  lastEditedUser: Maybe<Scalars['String']>;
  lots: Array<Lot>;
  proctors: Array<Proctor>;
  /** a related `Project` */
  project: Maybe<Project>;
  /** the `globalId` of a related `Project` */
  projectId: Maybe<Scalars['String']>;
  source: Maybe<Scalars['String']>;
};


export type MaterialSourceDensityTestsArgs = {
  densityTestFieldInput?: InputMaybe<DensityTestFieldInput>;
};


export type MaterialSourceLotsArgs = {
  lotFieldInput?: InputMaybe<LotFieldInput>;
};


export type MaterialSourceProctorsArgs = {
  proctorFieldInput?: InputMaybe<ProctorFieldInput>;
};

/**
 * helps filter multiple `MaterialSource` records
 *
 * this version of the input will have limited options compared to its other counterpart
 */
export type MaterialSourceFieldInput = {
  createdDate?: InputMaybe<DateTimeFilter>;
  /**
   * determines now to handle deleted `MaterialSource` records
   *
   * - when `true`, only return deleted records
   * - when `false`, do not return deleted records
   * - when omitted, `deleted` is ignored
   */
  deleted?: InputMaybe<Scalars['Boolean']>;
  lastEditedDate?: InputMaybe<DateTimeFilter>;
  /**
   * how to order `MaterialSource` records
   *
   * executed in the order they are defined
   */
  orderBy?: InputMaybe<Array<OrderByInput>>;
  projectId?: InputMaybe<StringFilter>;
  source?: InputMaybe<StringFilter>;
  /**
   * specifies how many records to return
   *
   * analogous to `limit`, `first`, or `top` in SQL dialects
   */
  take?: InputMaybe<Scalars['Int']>;
};

/** helps filter multiple `MaterialSource` records */
export type MaterialSourceListInput = {
  createdDate?: InputMaybe<DateTimeFilter>;
  /**
   * determines now to handle deleted `MaterialSource` records
   *
   * - when `true`, only return deleted records
   * - when `false`, do not return deleted records
   * - when omitted, `deleted` is ignored
   */
  deleted?: InputMaybe<Scalars['Boolean']>;
  lastEditedDate?: InputMaybe<DateTimeFilter>;
  /**
   * how to order `MaterialSource` records
   *
   * executed in the order they are defined
   */
  orderBy?: InputMaybe<Array<OrderByInput>>;
  /**
   * paginate `MaterialSource` records
   *
   * using `paginate` may require multiple requests to get all possible results,
   * but will give more fine-grain control in the event all records cannot be
   * returned gracefully
   */
  paginate?: InputMaybe<PaginationInput>;
  projectId?: InputMaybe<StringFilter>;
  source?: InputMaybe<StringFilter>;
};

/** response metadata for a list query of MaterialSource records */
export type MaterialSourceListResponse = {
  __typename: 'MaterialSourceListResponse';
  /** the total count of MaterialSource records matching any configured filters */
  count: Scalars['Int'];
  /** the total count of paginated groups of MaterialSource */
  pages: Scalars['Int'];
  /** MaterialSource records */
  records: Array<MaterialSource>;
};

export type MaterialType = {
  __typename: 'MaterialType';
  /** the date this record was inserted into the database */
  createdDate: Maybe<Scalars['DateTime']>;
  /** the username or email address of a mobile app user associated with the `createdDate` */
  createdUser: Maybe<Scalars['String']>;
  deleted: Scalars['Boolean'];
  /** a GUID used to globally identify this record in the database */
  globalId: Scalars['String'];
  /** the date this record was last updated in the database */
  lastEditedDate: Maybe<Scalars['DateTime']>;
  /** the username or email address of a mobile app user associated with the `lastEditedDate` */
  lastEditedUser: Maybe<Scalars['String']>;
  lots: Array<Lot>;
  maxPercentMoisture: Maybe<Scalars['Float']>;
  minPercentMoisture: Maybe<Scalars['Float']>;
  name: Maybe<Scalars['String']>;
  /** a related `Project` */
  project: Maybe<Project>;
  /** the `globalId` of a related `Project` */
  projectId: Maybe<Scalars['String']>;
};


export type MaterialTypeLotsArgs = {
  lotFieldInput?: InputMaybe<LotFieldInput>;
};

/**
 * helps filter multiple `MaterialType` records
 *
 * this version of the input will have limited options compared to its other counterpart
 */
export type MaterialTypeFieldInput = {
  createdDate?: InputMaybe<DateTimeFilter>;
  createdUser?: InputMaybe<StringFilter>;
  /**
   * determines now to handle deleted `MaterialType` records
   *
   * - when `true`, only return deleted records
   * - when `false`, do not return deleted records
   * - when omitted, `deleted` is ignored
   */
  deleted?: InputMaybe<Scalars['Boolean']>;
  globalId?: InputMaybe<StringFilter>;
  lastEditedDate?: InputMaybe<DateTimeFilter>;
  lastEditedUser?: InputMaybe<StringFilter>;
  maxPercentMoisture?: InputMaybe<FloatFilter>;
  minPercentMoisture?: InputMaybe<FloatFilter>;
  name?: InputMaybe<StringFilter>;
  /**
   * how to order `MaterialType` records
   *
   * executed in the order they are defined
   */
  orderBy?: InputMaybe<Array<OrderByInput>>;
  projectId?: InputMaybe<StringFilter>;
  /**
   * specifies how many records to return
   *
   * analogous to `limit`, `first`, or `top` in SQL dialects
   */
  take?: InputMaybe<Scalars['Int']>;
};

/** helps filter multiple `MaterialType` records */
export type MaterialTypeListInput = {
  createdDate?: InputMaybe<DateTimeFilter>;
  createdUser?: InputMaybe<StringFilter>;
  /**
   * determines now to handle deleted `MaterialType` records
   *
   * - when `true`, only return deleted records
   * - when `false`, do not return deleted records
   * - when omitted, `deleted` is ignored
   */
  deleted?: InputMaybe<Scalars['Boolean']>;
  globalId?: InputMaybe<StringFilter>;
  lastEditedDate?: InputMaybe<DateTimeFilter>;
  lastEditedUser?: InputMaybe<StringFilter>;
  maxPercentMoisture?: InputMaybe<FloatFilter>;
  minPercentMoisture?: InputMaybe<FloatFilter>;
  name?: InputMaybe<StringFilter>;
  /**
   * how to order `MaterialType` records
   *
   * executed in the order they are defined
   */
  orderBy?: InputMaybe<Array<OrderByInput>>;
  /**
   * paginate `MaterialType` records
   *
   * using `paginate` may require multiple requests to get all possible results,
   * but will give more fine-grain control in the event all records cannot be
   * returned gracefully
   */
  paginate?: InputMaybe<PaginationInput>;
  projectId?: InputMaybe<StringFilter>;
};

/** response metadata for a list query of MaterialType records */
export type MaterialTypeListResponse = {
  __typename: 'MaterialTypeListResponse';
  /** the total count of MaterialType records matching any configured filters */
  count: Scalars['Int'];
  /** the total count of paginated groups of MaterialType */
  pages: Scalars['Int'];
  /** MaterialType records */
  records: Array<MaterialType>;
};

export type MediaUpload = {
  __typename: 'MediaUpload';
  asphaltLot: Maybe<AsphaltLot>;
  asphaltPlacement: Maybe<AsphaltPlacement>;
  concreteTestSet: Maybe<ConcreteTestSet>;
  /** the date this record was inserted into the database */
  createdDate: Maybe<Scalars['DateTime']>;
  /** the username or email address of a mobile app user associated with the `createdDate` */
  createdUser: Maybe<Scalars['String']>;
  dailyInspectionControlPoint: Maybe<DailyInspectionControlPoint>;
  dailyInspectionInspection: Maybe<DailyInspectionInspection>;
  dailyInspectionPunchList: Maybe<DailyInspectionPunchList>;
  deleted: Maybe<Scalars['String']>;
  /** the `globalId` of one of the related types: `AsphaltLot`, `AsphaltPlacement`, `ConcreteTestSet`, `DailyInspectionControlPoint`, `DailyInspectionInspection`, `DailyInspectionPunchList`, or `Lot` */
  featureId: Maybe<Scalars['String']>;
  /** a GUID used to globally identify this record in the database */
  globalId: Scalars['String'];
  /** the date this record was last updated in the database */
  lastEditedDate: Maybe<Scalars['DateTime']>;
  /** the username or email address of a mobile app user associated with the `lastEditedDate` */
  lastEditedUser: Maybe<Scalars['String']>;
  localHostName: Maybe<Scalars['String']>;
  localPath: Maybe<Scalars['String']>;
  lot: Maybe<Lot>;
  originalFileName: Maybe<Scalars['String']>;
  /** a related `Project` */
  project: Maybe<Project>;
  /** the `globalId` of a related `Project` */
  projectId: Maybe<Scalars['String']>;
  remoteFileName: Maybe<Scalars['String']>;
  tableName: Maybe<Scalars['String']>;
  thumbUrl: Maybe<Scalars['String']>;
  url: Maybe<Scalars['String']>;
};

/**
 * helps filter multiple `MediaUpload` records
 *
 * this version of the input will have limited options compared to its other counterpart
 */
export type MediaUploadFieldInput = {
  createdDate?: InputMaybe<DateTimeFilter>;
  /**
   * determines now to handle deleted `MediaUpload` records
   *
   * - when `true`, only return deleted records
   * - when `false`, do not return deleted records
   * - when omitted, `deleted` is ignored
   */
  deleted?: InputMaybe<Scalars['Boolean']>;
  featureId?: InputMaybe<StringFilter>;
  lastEditedDate?: InputMaybe<DateTimeFilter>;
  /**
   * how to order `MediaUpload` records
   *
   * executed in the order they are defined
   */
  orderBy?: InputMaybe<Array<OrderByInput>>;
  originalFileName?: InputMaybe<StringFilter>;
  projectId?: InputMaybe<StringFilter>;
  tableName?: InputMaybe<StringFilter>;
  /**
   * specifies how many records to return
   *
   * analogous to `limit`, `first`, or `top` in SQL dialects
   */
  take?: InputMaybe<Scalars['Int']>;
};

/** helps filter multiple `MediaUpload` records */
export type MediaUploadListInput = {
  createdDate?: InputMaybe<DateTimeFilter>;
  /**
   * determines now to handle deleted `MediaUpload` records
   *
   * - when `true`, only return deleted records
   * - when `false`, do not return deleted records
   * - when omitted, `deleted` is ignored
   */
  deleted?: InputMaybe<Scalars['Boolean']>;
  featureId?: InputMaybe<StringFilter>;
  lastEditedDate?: InputMaybe<DateTimeFilter>;
  /**
   * how to order `MediaUpload` records
   *
   * executed in the order they are defined
   */
  orderBy?: InputMaybe<Array<OrderByInput>>;
  originalFileName?: InputMaybe<StringFilter>;
  /**
   * paginate `MediaUpload` records
   *
   * using `paginate` may require multiple requests to get all possible results,
   * but will give more fine-grain control in the event all records cannot be
   * returned gracefully
   */
  paginate?: InputMaybe<PaginationInput>;
  projectId?: InputMaybe<StringFilter>;
  tableName?: InputMaybe<StringFilter>;
};

/** response metadata for a list query of MediaUpload records */
export type MediaUploadListResponse = {
  __typename: 'MediaUploadListResponse';
  /** the total count of MediaUpload records matching any configured filters */
  count: Scalars['Int'];
  /** the total count of paginated groups of MediaUpload */
  pages: Scalars['Int'];
  /** MediaUpload records */
  records: Array<MediaUpload>;
};

export type MinuteFrequency = BaseFrequency & {
  __typename: 'MinuteFrequency';
  /** Default value is 30 minutes */
  minutes: Scalars['Int'];
  next: Scalars['DateTime'];
  previous: Scalars['DateTime'];
};

export type MinuteFrequencyInput = {
  minutes: Scalars['Int'];
};

export type MutateAsphaltMixDesignTargetPercentageInput = {
  mixDesignId?: InputMaybe<Scalars['String']>;
  percentage: Scalars['Float'];
  targetId?: InputMaybe<Scalars['String']>;
};

export type MutateBooleanCustomFieldValueInput = {
  customFieldId: Scalars['String'];
  value?: InputMaybe<Scalars['Boolean']>;
};

export type MutateBooleanListCustomFieldValueInput = {
  checked: Scalars['Boolean'];
  customListItemId: Scalars['String'];
};

export type MutateBooleanListCustomFieldValuesInput = {
  booleans?: InputMaybe<Array<MutateBooleanListCustomFieldValueInput>>;
  customFieldId: Scalars['String'];
};

export type MutateCustomFieldsInput = {
  booleanInputs?: InputMaybe<Array<MutateBooleanCustomFieldValueInput>>;
  dateInputs?: InputMaybe<Array<MutateDateCustomFieldValueInput>>;
  entityInputs?: InputMaybe<Array<MutateEntityCustomFieldValuesInput>>;
  listInputs?: InputMaybe<MutateListInputs>;
  numberInputs?: InputMaybe<Array<MutateNumberCustomFieldValueInput>>;
  reportInputs?: InputMaybe<Array<MutateReportCustomFieldValuesInput>>;
  textInputs?: InputMaybe<Array<MutateTextCustomFieldValueInput>>;
};

export type MutateDateCustomFieldValueInput = {
  customFieldId: Scalars['String'];
  value?: InputMaybe<Scalars['DateTime']>;
};

export type MutateEjToReportInput = {
  ejId?: InputMaybe<Scalars['String']>;
  reportId: Scalars['String'];
  reportTypeId: Scalars['String'];
};

export type MutateEntityCustomFieldValueInput = {
  entityId: Scalars['String'];
  recordId?: InputMaybe<Scalars['String']>;
};

export type MutateEntityCustomFieldValuesInput = {
  customFieldId: Scalars['String'];
  entities?: InputMaybe<Array<MutateEntityCustomFieldValueInput>>;
};

export type MutateIssueToReportInput = {
  issueId?: InputMaybe<Scalars['String']>;
  reportId: Scalars['String'];
  reportTypeId: Scalars['String'];
};

export type MutateListCustomFieldValueInput = {
  customFieldId: Scalars['String'];
  customListItemId?: InputMaybe<Scalars['String']>;
};

export type MutateListCustomFieldValuesInput = {
  customFieldId: Scalars['String'];
  customListItemIds?: InputMaybe<Array<Scalars['String']>>;
};

export type MutateListInputs = {
  checkboxes?: InputMaybe<Array<MutateBooleanListCustomFieldValuesInput>>;
  multiples?: InputMaybe<Array<MutateListCustomFieldValuesInput>>;
  singles?: InputMaybe<Array<MutateListCustomFieldValueInput>>;
};

export type MutateNumberCustomFieldValueInput = {
  customFieldId: Scalars['String'];
  value?: InputMaybe<Scalars['Float']>;
};

export type MutateReportCustomFieldValueInput = {
  recordId?: InputMaybe<Scalars['String']>;
  reportId: Scalars['String'];
};

export type MutateReportCustomFieldValuesInput = {
  customFieldId: Scalars['String'];
  reports?: InputMaybe<Array<MutateReportCustomFieldValueInput>>;
};

export type MutateTextCustomFieldValueInput = {
  customFieldId: Scalars['String'];
  value?: InputMaybe<Scalars['String']>;
};

export type Mutation = {
  __typename: 'Mutation';
  /** associates an existing `Project` in the companion mobile application with CIMS Online */
  associateProjectWithCIMS: AssociateProjectWithCimsResponse;
  cancelBatchReportRequest: CancelBatchReportRequestResponse;
  cancelPhotoExportRequest: CancelPhotoExportRequestResponse;
  closeIssue: CloseIssueResponse;
  /** creates and returns a newly created `APIKey` in a `CreateAPIKeyResponse` */
  createAPIKey: CreateApiKeyResponse;
  /** creates and returns a newly created `AsphaltMixDesign` in a `CreateAsphaltMixDesignResponse` */
  createAsphaltMixDesign: CreateAsphaltMixDesignResponse;
  /** creates and returns a newly created `BatchReportRequest` in a `CreateBatchReportRequestResponse` */
  createBatchReportRequest: CreateBatchReportRequestResponse;
  /** creates and returns a newly created `CASComment` in a `CreateCASCommentResponse` */
  createCASComment: CreateCasCommentResponse;
  /** creates and returns a newly created `CASDispositionType` in a `CreateCASDispositionTypeResponse` */
  createCASDispositionType: CreateCasDispositionTypeResponse;
  /** creates and returns a newly created `CASQuickLink` in a `CreateCASQuickLinkResponse` */
  createCASQuickLink: CreateCasQuickLinkResponse;
  /** creates and returns a newly created `CASRoutingGroup` in a `CreateCASRoutingGroupResponse` */
  createCASRoutingGroup: CreateCasRoutingGroupResponse;
  /** creates and returns a newly created `CASSubtype` in a `CreateCASSubtypeResponse` */
  createCASSubtype: CreateCasSubtypeResponse;
  /** creates and returns a newly created `CASType` in a `CreateCASTypeResponse` */
  createCASType: CreateCasTypeResponse;
  /** creates and returns a newly created `ConcreteMixDesign` in a `CreateConcreteMixDesignResponse` */
  createConcreteMixDesign: CreateConcreteMixDesignResponse;
  /** creates and returns a newly created `ConstructionAdminSubmittal` in a `CreateConstructionAdminSubmittalResponse` */
  createConstructionAdminSubmittal: CreateConstructionAdminSubmittalResponse;
  /** creates and returns a newly created `CustomField` in a `CreateCustomFieldResponse` */
  createCustomField: CreateCustomFieldResponse;
  /** creates and returns a newly created `CustomFieldToClassType` in a `CreateCustomFieldToClassTypeResponse` */
  createCustomFieldToClassType: CreateCustomFieldToClassTypeResponse;
  /** creates and returns a newly created `CustomListItem` in a `CreateCustomListItemResponse` */
  createCustomListItem: CreateCustomListItemResponse;
  /** creates and returns a newly created `DSAction` in a `CreateDSActionResponse` */
  createDSAction: CreateDsActionResponse;
  /** creates and returns a newly created `DSComment` in a `CreateDSCommentResponse` */
  createDSComment: CreateDsCommentResponse;
  /** creates and returns a newly created `DSDiscipline` in a `CreateDSDisciplineResponse` */
  createDSDiscipline: CreateDsDisciplineResponse;
  /** creates and returns a newly created `DSOrganization` in a `CreateDSOrganizationResponse` */
  createDSOrganization: CreateDsOrganizationResponse;
  /** creates and returns a newly created `DSQuickLink` in a `CreateDSQuickLinkResponse` */
  createDSQuickLink: CreateDsQuickLinkResponse;
  /** creates and returns a newly created `DSType` in a `CreateDSTypeResponse` */
  createDSType: CreateDsTypeResponse;
  /** creates and returns a newly created `DesignSubmittal` in a `CreateDesignSubmittalResponse` */
  createDesignSubmittal: CreateDesignSubmittalResponse;
  /** creates and returns a newly created `DocumentChecklistItem` in a `CreateDocumentChecklistItemResponse` */
  createDocumentChecklistItem: CreateDocumentChecklistItemResponse;
  /** creates and returns a newly created `EJQuickLink` in a `CreateEJQuickLinkResponse` */
  createEJQuickLink: CreateEjQuickLinkResponse;
  /** creates and returns a newly created `EJType` in a `CreateEJTypeResponse` */
  createEJType: CreateEjTypeResponse;
  /** creates and returns a newly created `FDCApprovalGroup` in a `CreateFDCApprovalGroupResponse` */
  createFDCApprovalGroup: CreateFdcApprovalGroupResponse;
  /** creates and returns a newly created `FDCComment` in a `CreateFDCCommentResponse` */
  createFDCComment: CreateFdcCommentResponse;
  /** creates and returns a newly created `FDCConcurrenceGroup` in a `CreateFDCConcurrenceGroupResponse` */
  createFDCConcurrenceGroup: CreateFdcConcurrenceGroupResponse;
  /** creates and returns a newly created `FDCConcurrenceLevel` in a `CreateFDCConcurrenceLevelResponse` */
  createFDCConcurrenceLevel: CreateFdcConcurrenceLevelResponse;
  /** creates and returns a newly created `FDCDiscipline` in a `CreateFDCDisciplineResponse` */
  createFDCDiscipline: CreateFdcDisciplineResponse;
  /** creates and returns a newly created `FDCQuickLink` in a `CreateFDCQuickLinkResponse` */
  createFDCQuickLink: CreateFdcQuickLinkResponse;
  /** creates and returns a newly created `GoogleSheetPayItemConnection` in a `CreateGoogleSheetPayItemConnectionResponse` */
  createGoogleSheetPayItemConnection: CreateGoogleSheetPayItemConnectionResponse;
  /** creates and returns a newly created `IFIComment` in a `CreateIFICommentResponse` */
  createIFIComment: CreateIfiCommentResponse;
  /** creates and returns a newly created `IssueComment` in a `CreateIssueCommentResponse` */
  createIssueComment: CreateIssueCommentResponse;
  /** creates and returns a newly created `IssueDispositionType` in a `CreateIssueDispositionTypeResponse` */
  createIssueDispositionType: CreateIssueDispositionTypeResponse;
  /** creates and returns a newly created `IssueQuickLink` in a `CreateIssueQuickLinkResponse` */
  createIssueQuickLink: CreateIssueQuickLinkResponse;
  /** creates and returns a newly created `IssueType` in a `CreateIssueTypeResponse` */
  createIssueType: CreateIssueTypeResponse;
  /** creates and returns a newly created `LIMSAsphaltMixDesignTarget` in a `CreateLIMSAsphaltMixDesignTargetResponse` */
  createLIMSAsphaltMixDesignTarget: CreateLimsAsphaltMixDesignTargetResponse;
  /** creates and returns a newly created `LabTech` in a `CreateLabTechResponse` */
  createLabTech: CreateLabTechResponse;
  /** creates and returns a newly created `NonUserEmail` in a `CreateNonUserEmailResponse` */
  createNonUserEmail: CreateNonUserEmailResponse;
  /** creates and returns a newly created `PayItemConnectionGroup` in a `CreatePayItemConnectionGroupResponse` */
  createPayItemConnectionGroup: CreatePayItemConnectionGroupResponse;
  /** creates and returns a newly created `PhotoExportRequest` in a `CreatePhotoExportRequestResponse` */
  createPhotoExportRequest: CreatePhotoExportRequestResponse;
  /** creates and returns a newly created `ProjectToCIMSOnlineAdmin` in a `CreateProjectToCIMSOnlineAdminReponse` */
  createProjectToCIMSOnlineAdmin: CreateProjectToCimsOnlineAdminResponse;
  /** creates and returns a newly created `RFIComment` in a `CreateRFICommentResponse` */
  createRFIComment: CreateRfiCommentResponse;
  /** creates and returns a newly created `RFIOrganization` in a `CreateRFIOrganizationResponse` */
  createRFIOrganization: CreateRfiOrganizationResponse;
  /** creates and returns a newly created `RFIQuickLink` in a `CreateRFIQuickLinkResponse` */
  createRFIQuickLink: CreateRfiQuickLinkResponse;
  /** creates and returns a newly created `RFIResponse` in a `CreateRFIResponseResponse` */
  createRFIResponse: CreateRfiResponseResponse;
  /** creates and returns a newly created `RFIResponseDiscipline` in a `CreateRFIResponseDisciplineResponse` */
  createRFIResponseDiscipline: CreateRfiResponseDisciplineResponse;
  /** creates and returns a newly created `Role` in a `CreateRoleResponse` */
  createRole: CreateRoleResponse;
  /** creates and returns a newly created `TestingLab` in a `CreateTestingLabResponse` */
  createTestingLab: CreateTestingLabResponse;
  draftEngineeringJudgement: DraftEngineeringJudgementResponse;
  draftFieldDesignChange: DraftFieldDesignChangeResponse;
  draftIssue: DraftIssueResponse;
  draftRequestForInformation: DraftRequestForInformationResponse;
  /** edits and returns edit an existing `AsphaltMixDesign` in a `EditAsphaltMixDesignResponse` */
  editAsphaltMixDesign: EditAsphaltMixDesignResponse;
  /** edits and returns edit an existing `CASDispositionType` in a `EditCASDispositionTypeResponse` */
  editCASDispositionType: EditCasDispositionTypeResponse;
  /** edits and returns edit an existing `CASNotification` in a `EditCASNotificationResponse` */
  editCASNotification: EditCasNotificationResponse;
  /** edits and returns edit an existing `CASQuickLink` in a `EditCASQuickLinkResponse` */
  editCASQuickLink: EditCasQuickLinkResponse;
  /** edits and returns edit an existing `CASRoutingGroup` in a `EditCASRoutingGroupResponse` */
  editCASRoutingGroup: EditCasRoutingGroupResponse;
  /** edits and returns edit an existing `CASSubtype` in a `EditCASSubtypeResponse` */
  editCASSubtype: EditCasSubtypeResponse;
  /** edits and returns edit an existing `CASType` in a `EditCASTypeResponse` */
  editCASType: EditCasTypeResponse;
  /** edits and returns edit an existing `ConcreteMixDesign` in a `EditConcreteMixDesignResponse` */
  editConcreteMixDesign: EditConcreteMixDesignResponse;
  /** edits and returns edit an existing `ConcreteNotification` in a `EditConcreteNotificationResponse` */
  editConcreteNotification: EditConcreteNotificationResponse;
  /** edits and returns edit an existing `ConcreteTestSet` in a `EditConcreteTestSetResponse` */
  editConcreteTestSet: EditConcreteTestSetResponse;
  /** edits and returns edit an existing `ConstructionAdminSubmittal` in a `EditConstructionAdminSubmittalResponse` */
  editConstructionAdminSubmittal: EditConstructionAdminSubmittalResponse;
  /** edits the `SharePointResource.name` associated with a `ConstructionAdminSubmittal` */
  editConstructionAdminSubmittalSharePointReference: ConstructionAdminSubmittal;
  /** edits and returns edit an existing `CustomField` in a `EditCustomFieldResponse` */
  editCustomField: EditCustomFieldResponse;
  /** edits and returns edit an existing `CustomFieldToClassType` in a `EditCustomFieldToClassTypeResponse` */
  editCustomFieldToClassType: EditCustomFieldToClassTypeResponse;
  /** edits and returns edit an existing `CustomListItem` in a `EditCustomListItemResponse` */
  editCustomListItem: EditCustomListItemResponse;
  /** edits and returns edit an existing `DSAction` in a `EditDSActionResponse` */
  editDSAction: EditDsActionResponse;
  /** edits and returns edit an existing `DSDiscipline` in a `EditDSDisciplineResponse` */
  editDSDiscipline: EditDsDisciplineResponse;
  /** edits and returns edit an existing `DSNotification` in a `EditDSNotificationResponse` */
  editDSNotification: EditDsNotificationResponse;
  /** edits and returns edit an existing `DSOrganization` in a `EditDSOrganizationResponse` */
  editDSOrganization: EditDsOrganizationResponse;
  /** edits and returns edit an existing `DSQuickLink` in a `EditDSQuickLinkResponse` */
  editDSQuickLink: EditDsQuickLinkResponse;
  /** edits and returns edit an existing `DSType` in a `EditDSTypeResponse` */
  editDSType: EditDsTypeResponse;
  /** edits and returns edit an existing `DesignSubmittal` in a `EditDesignSubmittalResponse` */
  editDesignSubmittal: EditDesignSubmittalResponse;
  /** edits the `SharePointResource.name` associated with a `DesignSubmittal` */
  editDesignSubmittalSharePointReference: DesignSubmittal;
  /** edits and returns edit an existing `DocumentChecklistItem` in a `EditDocumentChecklistItemResponse` */
  editDocumentChecklistItem: EditDocumentChecklistItemResponse;
  /** edits and returns edit an existing `EJNotification` in a `EditEJNotificationResponse` */
  editEJNotification: EditEjNotificationResponse;
  /** edits and returns edit an existing `EJQuickLink` in a `EditEJQuickLinkResponse` */
  editEJQuickLink: EditEjQuickLinkResponse;
  /** edits and returns edit an existing `EJType` in a `EditEJTypeResponse` */
  editEJType: EditEjTypeResponse;
  /** edits and returns edit an existing `EngineeringJudgement` in a `EditEngineeringJudgementResponse` */
  editEngineeringJudgement: EditEngineeringJudgementResponse;
  /** edits and returns edit an existing `FDCApprovalGroup` in a `EditFDCApprovalGroupResponse` */
  editFDCApprovalGroup: EditFdcApprovalGroupResponse;
  /** edits and returns edit an existing `FDCConcurrenceGroup` in a `EditFDCConcurrenceGroupResponse` */
  editFDCConcurrenceGroup: EditFdcConcurrenceGroupResponse;
  /** edits and returns edit an existing `FDCConcurrenceLevel` in a `EditFDCConcurrenceLevelResponse` */
  editFDCConcurrenceLevel: EditFdcConcurrenceLevelResponse;
  /** edits and returns edit an existing `FDCDiscipline` in a `EditFDCDisciplineResponse` */
  editFDCDiscipline: EditFdcDisciplineResponse;
  /** edits and returns edit an existing `FDCNotification` in a `EditFDCNotificationResponse` */
  editFDCNotification: EditFdcNotificationResponse;
  /** edits and returns edit an existing `FDCQuickLink` in a `EditFDCQuickLinkResponse` */
  editFDCQuickLink: EditFdcQuickLinkResponse;
  /** edits and returns edit an existing `FieldDesignChange` in a `EditFieldDesignChangeResponse` */
  editFieldDesignChange: EditFieldDesignChangeResponse;
  /** edits and returns edit an existing `GoogleSheetPayItemConnection` in a `EditGoogleSheetPayItemConnectionResponse` */
  editGoogleSheetPayItemConnection: EditGoogleSheetPayItemConnectionResponse;
  /** edits and returns edit an existing `IFINotification` in a `EditIFINotificationResponse` */
  editIFINotification: EditIfiNotificationResponse;
  /** edits and returns edit an existing `IdentifiedFieldIssue` in a `EditIdentifiedFieldIssueResponse` */
  editIdentifiedFieldIssue: EditIdentifiedFieldIssueResponse;
  /** edits and returns edit an existing `Issue` in a `EditIssueResponse` */
  editIssue: EditIssueResponse;
  /** edits and returns edit an existing `IssueDispositionType` in a `EditIssueDispositionTypeResponse` */
  editIssueDispositionType: EditIssueDispositionTypeResponse;
  /** edits and returns edit an existing `IssueNotification` in a `EditIssueNotificationResponse` */
  editIssueNotification: EditIssueNotificationResponse;
  /** edits and returns edit an existing `IssueQuickLink` in a `EditIssueQuickLinkResponse` */
  editIssueQuickLink: EditIssueQuickLinkResponse;
  /** edits and returns edit an existing `IssueType` in a `EditIssueTypeResponse` */
  editIssueType: EditIssueTypeResponse;
  /** edits and returns edit an existing `LIMSAsphaltMixDesignTarget` in a `EditLIMSAsphaltMixDesignTargetResponse` */
  editLIMSAsphaltMixDesignTarget: EditLimsAsphaltMixDesignTargetResponse;
  /** edits and returns edit an existing `LabTech` in a `EditLabTechResponse` */
  editLabTech: EditLabTechResponse;
  /** edits and returns edit an existing `NonUserEmail` in a `EditNonUserEmailResponse` */
  editNonUserEmail: EditNonUserEmailResponse;
  /** edits and returns edit an existing `PDFDesignLayer` in a `EditPDFDesignLayerResponse` */
  editPDFDesignLayer: EditPdfDesignLayerResponse;
  /** edits and returns edit an existing `PayItemConnectionGroup` in a `EditPayItemConnectionGroupResponse` */
  editPayItemConnectionGroup: EditPayItemConnectionGroupResponse;
  editPayItemSummaryOrder: EditPayItemSummaryOrderResponse;
  /** edits and returns edit an existing `PhotoFilename` in a `EditPhotoFilenameResponse` */
  editPhotoFilename: EditPhotoFilenameResponse;
  /** edits and returns edit an existing `ProjectMetadata` in a `EditProjectMetadataResponse` */
  editProjectMetadata: EditProjectMetadataResponse;
  /** edits and returns edit an existing `ProjectToInternalConnection` in a `EditProjectToInternalConnectionResponse` */
  editProjectToInternalConnection: EditProjectToInternalConnectionResponse;
  /** edits and returns edit an existing `RFINotification` in a `EditRFINotificationResponse` */
  editRFINotification: EditRfiNotificationResponse;
  /** edits and returns edit an existing `RFIOrganization` in a `EditRFIOrganizationResponse` */
  editRFIOrganization: EditRfiOrganizationResponse;
  /** edits and returns edit an existing `RFIQuickLink` in a `EditRFIQuickLinkResponse` */
  editRFIQuickLink: EditRfiQuickLinkResponse;
  /** edits and returns edit an existing `RFIResponse` in a `EditRFIResponseResponse` */
  editRFIResponse: EditRfiResponseResponse;
  /** edits and returns edit an existing `RFIResponseDiscipline` in a `EditRFIResponseDisciplineResponse` */
  editRFIResponseDiscipline: EditRfiResponseDisciplineResponse;
  /** edits and returns edit an existing `ReportFilename` in a `EditReportFilenameResponse` */
  editReportFilename: EditReportFilenameResponse;
  /** edits and returns edit an existing `RequestForInformation` in a `EditRequestForInformationResponse` */
  editRequestForInformation: EditRequestForInformationResponse;
  /** edits and returns edit an existing `Role` in a `EditRoleResponse` */
  editRole: EditRoleResponse;
  /** edits and returns edit an existing `TestingLab` in a `EditTestingLabResponse` */
  editTestingLab: EditTestingLabResponse;
  /** edits and returns edit an existing `User` in a `EditUserResponse` */
  editUser: EditUserResponse;
  giveDesignSubmittalDisposition: GiveDesignSubmittalDispositionResponse;
  giveIssueDisposition: GiveIssueDispositionResponse;
  groupReviewConstructionAdminSubmittal: GroupReviewConstructionAdminSubmittalResponse;
  reReviewConstructionAdminSubmittal: ReReviewConstructionAdminSubmittalResponse;
  /** removes and returns remove an existing `APIKey` in a `RemoveAPIKeyResponse` */
  removeAPIKey: RemoveApiKeyResponse;
  /** removes and returns remove an existing `ConcreteTestBreakData` in a `RemoveConcreteTestBreakDataResponse` */
  removeConcreteTestBreakData: RemoveConcreteTestBreakDataResponse;
  /** removes and returns remove an existing `DocumentChecklistItem` in a `RemoveDocumentChecklistItemResponse` */
  removeDocumentChecklistItem: RemoveDocumentChecklistItemResponse;
  /** removes and returns remove an existing `LabTech` in a `RemoveLabTechResponse` */
  removeLabTech: RemoveLabTechResponse;
  /** removes and returns remove an existing `NonUserEmail` in a `RemoveNonUserEmailResponse` */
  removeNonUserEmail: RemoveNonUserEmailResponse;
  /** removes and returns remove an existing `ProjectToCIMSOnlineAdmin` in a `RemoveProjectToCIMSOnlineAdminResponse` */
  removeProjectToCIMSOnlineAdmin: RemoveProjectToCimsOnlineAdminResponse;
  removeSharePointResource: RemoveSharePointResourceResponse;
  /** removes and returns remove an existing `TestingLab` in a `RemoveTestingLabResponse` */
  removeTestingLab: RemoveTestingLabResponse;
  repairSharePointResource: RepairSharePointResourceResponse;
  requestConstructionAdminSubmittalRevisions: RequestConstructionAdminSubmittalRevisionsResponse;
  respondToIssue: RespondToIssueResponse;
  /** restores and returns restore an existing `CASDispositionType` in a `RestoreCASDispositionTypeResponse` */
  restoreCASDispositionType: RestoreCasDispositionTypeResponse;
  /** restores and returns restore an existing `CASQuickLink` in a `RestoreCASQuickLinkResponse` */
  restoreCASQuickLink: RestoreCasQuickLinkResponse;
  /** restores and returns restore an existing `CASRoutingGroup` in a `RestoreCASRoutingGroupResponse` */
  restoreCASRoutingGroup: RestoreCasRoutingGroupResponse;
  /** restores and returns restore an existing `CASSubtype` in a `RestoreCASSubtypeResponse` */
  restoreCASSubtype: RestoreCasSubtypeResponse;
  /** restores and returns restore an existing `CASType` in a `RestoreCASTypeResponse` */
  restoreCASType: RestoreCasTypeResponse;
  /** restores and returns restore an existing `ConstructionAdminSubmittal` in a `RestoreConstructionAdminSubmittalResponse` */
  restoreConstructionAdminSubmittal: RestoreConstructionAdminSubmittalResponse;
  /** restores and returns restore an existing `CustomField` in a `RestoreCustomFieldResponse` */
  restoreCustomField: RestoreCustomFieldResponse;
  /** restores and returns restore an existing `DSAction` in a `RestoreDSActionResponse` */
  restoreDSAction: RestoreDsActionResponse;
  /** restores and returns restore an existing `DSDiscipline` in a `RestoreDSDisciplineResponse` */
  restoreDSDiscipline: RestoreDsDisciplineResponse;
  /** restores and returns restore an existing `DSOrganization` in a `RestoreDSOrganizationResponse` */
  restoreDSOrganization: RestoreDsOrganizationResponse;
  /** restores and returns restore an existing `DSQuickLink` in a `RestoreDSQuickLinkResponse` */
  restoreDSQuickLink: RestoreDsQuickLinkResponse;
  /** restores and returns restore an existing `DSType` in a `RestoreDSTypeResponse` */
  restoreDSType: RestoreDsTypeResponse;
  /** restores and returns restore an existing `DesignSubmittal` in a `RestoreDesignSubmittalResponse` */
  restoreDesignSubmittal: RestoreDesignSubmittalResponse;
  /** restores and returns restore an existing `EJQuickLink` in a `RestoreEJQuickLinkResponse` */
  restoreEJQuickLink: RestoreEjQuickLinkResponse;
  /** restores and returns restore an existing `EJType` in a `RestoreEJTypeResponse` */
  restoreEJType: RestoreEjTypeResponse;
  /** restores and returns restore an existing `EngineeringJudgement` in a `RestoreEngineeringJudgementResponse` */
  restoreEngineeringJudgement: RestoreEngineeringJudgementResponse;
  /** restores and returns restore an existing `FDCApprovalGroup` in a `RestoreFDCApprovalGroupResponse` */
  restoreFDCApprovalGroup: RestoreFdcApprovalGroupResponse;
  /** restores and returns restore an existing `FDCConcurrenceGroup` in a `RestoreFDCConcurrenceGroupResponse` */
  restoreFDCConcurrenceGroup: RestoreFdcConcurrenceGroupResponse;
  /** restores and returns restore an existing `FDCConcurrenceLevel` in a `RestoreFDCConcurrenceLevelResponse` */
  restoreFDCConcurrenceLevel: RestoreFdcConcurrenceLevelResponse;
  /** restores and returns restore an existing `FDCDiscipline` in a `RestoreFDCDisciplineResponse` */
  restoreFDCDiscipline: RestoreFdcDisciplineResponse;
  /** restores and returns restore an existing `FDCQuickLink` in a `RestoreFDCQuickLinkResponse` */
  restoreFDCQuickLink: RestoreFdcQuickLinkResponse;
  /** restores and returns restore an existing `FieldDesignChange` in a `RestoreFieldDesignChangeResponse` */
  restoreFieldDesignChange: RestoreFieldDesignChangeResponse;
  /** restores and returns restore an existing `Issue` in a `RestoreIssueResponse` */
  restoreIssue: RestoreIssueResponse;
  /** restores and returns restore an existing `IssueDispositionType` in a `RestoreIssueDispositionTypeResponse` */
  restoreIssueDispositionType: RestoreIssueDispositionTypeResponse;
  /** restores and returns restore an existing `IssueQuickLink` in a `RestoreIssueQuickLinkResponse` */
  restoreIssueQuickLink: RestoreIssueQuickLinkResponse;
  /** restores and returns restore an existing `IssueType` in a `RestoreIssueTypeResponse` */
  restoreIssueType: RestoreIssueTypeResponse;
  /** restores and returns restore an existing `LIMSAsphaltMixDesignTarget` in a `RestoreLIMSAsphaltMixDesignTargetResponse` */
  restoreLIMSAsphaltMixDesignTarget: RestoreLimsAsphaltMixDesignTargetResponse;
  /** restores and returns restore an existing `PayItemConnection` in a `RestorePayItemConnectionResponse` */
  restorePayItemConnection: RestorePayItemConnectionResponse;
  /** restores and returns restore an existing `PayItemConnectionGroup` in a `RestorePayItemConnectionGroupResponse` */
  restorePayItemConnectionGroup: RestorePayItemConnectionGroupResponse;
  /** restores and returns restore an existing `RFIOrganization` in a `RestoreRFIOrganizationResponse` */
  restoreRFIOrganization: RestoreRfiOrganizationResponse;
  /** restores and returns restore an existing `RFIQuickLink` in a `RestoreRFIQuickLinkResponse` */
  restoreRFIQuickLink: RestoreRfiQuickLinkResponse;
  /** restores and returns restore an existing `RFIResponse` in a `RestoreRFIResponseResponse` */
  restoreRFIResponse: RestoreRfiResponseResponse;
  /** restores and returns restore an existing `RFIResponseDiscipline` in a `RestoreRFIResponseDisciplineResponse` */
  restoreRFIResponseDiscipline: RestoreRfiResponseDisciplineResponse;
  /** restores and returns restore an existing `RequestForInformation` in a `RestoreRequestForInformationResponse` */
  restoreRequestForInformation: RestoreRequestForInformationResponse;
  /** restores and returns restore an existing `Role` in a `RestoreRoleResponse` */
  restoreRole: RestoreRoleResponse;
  revertConstructionAdminSubmittal: RevertConstructionAdminSubmittalResponse;
  revertDesignSubmittal: RevertDesignSubmittalResponse;
  revertEngineeringJudgement: RevertEngineeringJudgementResponse;
  /** reverts a Field Design Change back to Pending Level Concurrences */
  revertFieldDesignChange: RevertFieldDesignChangeResponse;
  revertIdentifiedFieldIssue: RevertIdentifiedFieldIssueResponse;
  revertIssue: RevertIssueResponse;
  revertRequestForInformation: RevertRequestForInformationResponse;
  reviewIdentifiedFieldIssue: ReviewIdentifiedFieldIssueResponse;
  reviseConstructionAdminSubmittal: ReviseConstructionAdminSubmittalResponse;
  routeConstructionAdminSubmittalToGroupReview: RouteConstructionAdminSubmittalToGroupReviewResponse;
  routeConstructionAdminSubmittalToREReview: RouteConstructionAdminSubmittalToReReviewResponse;
  routeDesignSubmittal: RouteDesignSubmittalResponse;
  /** creates, edits, or even removes `CASToCASRoutingGroup` records based on value of `accepted` */
  setCASToCASRoutingGroup: SetCasToCasRoutingGroupResponse;
  /** creates, edits, or even removes `DSToDSDiscipline` records based on value of `accepted` */
  setDSToDSDiscipline: SetDsToDsDisciplineResponse;
  /** creates, edits, or even removes `DocumentChecklistValue` records based on value of `checked` */
  setDocumentChecklistValue: SetDocumentChecklistValueResponse;
  /** creates, edits, or even removes `FDCToFDCApprovalGroup` records based on value of `approved` */
  setFDCToFDCApprovalGroup: SetFdcToFdcApprovalGroupResponse;
  /** creates, edits, or even removes `FDCToFDCConcurrenceGroup` records based on value of `concurred` */
  setFDCToFDCConcurrenceGroup: SetFdcToFdcConcurrenceGroupResponse;
  /**
   * updates the read/write permissions of a `SharePointResource`
   *
   * depending on the provided `parent`, different object types may be affected and returned in the response
   */
  setSharePointResourcePermissions: SetSharePointResourcePermissionsResponse;
  /** soft-removes and returns soft-remove an existing `CASDispositionType` in a `SoftRemoveCASDispositionTypeResponse` */
  softRemoveCASDispositionType: SoftRemoveCasDispositionTypeResponse;
  /** soft-removes and returns soft-remove an existing `CASQuickLink` in a `SoftRemoveCASQuickLinkResponse` */
  softRemoveCASQuickLink: SoftRemoveCasQuickLinkResponse;
  /** soft-removes and returns soft-remove an existing `CASRoutingGroup` in a `SoftRemoveCASRoutingGroupResponse` */
  softRemoveCASRoutingGroup: SoftRemoveCasRoutingGroupResponse;
  /** soft-removes and returns soft-remove an existing `CASSubtype` in a `SoftRemoveCASSubtypeResponse` */
  softRemoveCASSubtype: SoftRemoveCasSubtypeResponse;
  /** soft-removes and returns soft-remove an existing `CASType` in a `SoftRemoveCASTypeResponse` */
  softRemoveCASType: SoftRemoveCasTypeResponse;
  /** soft-removes and returns soft-remove an existing `ConstructionAdminSubmittal` in a `SoftRemoveConstructionAdminSubmittalResponse` */
  softRemoveConstructionAdminSubmittal: SoftRemoveConstructionAdminSubmittalResponse;
  /** soft-removes and returns soft-remove an existing `CustomField` in a `SoftRemoveCustomFieldResponse` */
  softRemoveCustomField: SoftRemoveCustomFieldResponse;
  /** soft-removes and returns soft-remove an existing `CustomFieldToClassType` in a `SoftRemoveCustomFieldToClassTypeResponse` */
  softRemoveCustomFieldToClassType: SoftRemoveCustomFieldToClassTypeResponse;
  /** soft-removes and returns soft-remove an existing `CustomListItem` in a `SoftRemoveCustomListItemResponse` */
  softRemoveCustomListItem: SoftRemoveCustomListItemResponse;
  /** soft-removes and returns soft-remove an existing `DSAction` in a `SoftRemoveDSActionResponse` */
  softRemoveDSAction: SoftRemoveDsActionResponse;
  /** soft-removes and returns soft-remove an existing `DSDiscipline` in a `SoftRemoveDSDisciplineResponse` */
  softRemoveDSDiscipline: SoftRemoveDsDisciplineResponse;
  /** soft-removes and returns soft-remove an existing `DSOrganization` in a `SoftRemoveDSOrganizationResponse` */
  softRemoveDSOrganization: SoftRemoveDsOrganizationResponse;
  /** soft-removes and returns soft-remove an existing `DSQuickLink` in a `SoftRemoveDSQuickLinkResponse` */
  softRemoveDSQuickLink: SoftRemoveDsQuickLinkResponse;
  /** soft-removes and returns soft-remove an existing `DSType` in a `SoftRemoveDSTypeResponse` */
  softRemoveDSType: SoftRemoveDsTypeResponse;
  /** soft-removes and returns soft-remove an existing `DesignSubmittal` in a `SoftRemoveDesignSubmittalResponse` */
  softRemoveDesignSubmittal: SoftRemoveDesignSubmittalResponse;
  /** soft-removes and returns soft-remove an existing `EJQuickLink` in a `SoftRemoveEJQuickLinkResponse` */
  softRemoveEJQuickLink: SoftRemoveEjQuickLinkResponse;
  /** soft-removes and returns soft-remove an existing `EJType` in a `SoftRemoveEJTypeResponse` */
  softRemoveEJType: SoftRemoveEjTypeResponse;
  /** soft-removes and returns soft-remove an existing `EngineeringJudgement` in a `SoftRemoveEngineeringJudgementResponse` */
  softRemoveEngineeringJudgement: SoftRemoveEngineeringJudgementResponse;
  /** soft-removes and returns soft-remove an existing `FDCApprovalGroup` in a `SoftRemoveFDCApprovalGroupResponse` */
  softRemoveFDCApprovalGroup: SoftRemoveFdcApprovalGroupResponse;
  /** soft-removes and returns soft-remove an existing `FDCConcurrenceGroup` in a `SoftRemoveFDCConcurrenceGroupResponse` */
  softRemoveFDCConcurrenceGroup: SoftRemoveFdcConcurrenceGroupResponse;
  /** soft-removes and returns soft-remove an existing `FDCConcurrenceLevel` in a `SoftRemoveFDCConcurrenceLevelResponse` */
  softRemoveFDCConcurrenceLevel: SoftRemoveFdcConcurrenceLevelResponse;
  /** soft-removes and returns soft-remove an existing `FDCDiscipline` in a `SoftRemoveFDCDisciplineResponse` */
  softRemoveFDCDiscipline: SoftRemoveFdcDisciplineResponse;
  /** soft-removes and returns soft-remove an existing `FDCQuickLink` in a `SoftRemoveFDCQuickLinkResponse` */
  softRemoveFDCQuickLink: SoftRemoveFdcQuickLinkResponse;
  /** soft-removes and returns soft-remove an existing `FieldDesignChange` in a `SoftRemoveFieldDesignChangeResponse` */
  softRemoveFieldDesignChange: SoftRemoveFieldDesignChangeResponse;
  /** soft-removes and returns soft-remove an existing `Issue` in a `SoftRemoveIssueResponse` */
  softRemoveIssue: SoftRemoveIssueResponse;
  /** soft-removes and returns soft-remove an existing `IssueDispositionType` in a `SoftRemoveIssueDispositionTypeResponse` */
  softRemoveIssueDispositionType: SoftRemoveIssueDispositionTypeResponse;
  /** soft-removes and returns soft-remove an existing `IssueQuickLink` in a `SoftRemoveIssueQuickLinkResponse` */
  softRemoveIssueQuickLink: SoftRemoveIssueQuickLinkResponse;
  /** soft-removes and returns soft-remove an existing `IssueType` in a `SoftRemoveIssueTypeResponse` */
  softRemoveIssueType: SoftRemoveIssueTypeResponse;
  /** soft-removes and returns soft-remove an existing `LIMSAsphaltMixDesignTarget` in a `SoftRemoveLIMSAsphaltMixDesignTargetResponse` */
  softRemoveLIMSAsphaltMixDesignTarget: SoftRemoveLimsAsphaltMixDesignTargetResponse;
  /** soft-removes and returns soft-remove an existing `PayItemConnection` in a `SoftRemovePayItemConnectionResponse` */
  softRemovePayItemConnection: SoftRemovePayItemConnectionResponse;
  /** soft-removes and returns soft-remove an existing `PayItemConnectionGroup` in a `SoftRemovePayItemConnectionGroupResponse` */
  softRemovePayItemConnectionGroup: SoftRemovePayItemConnectionGroupResponse;
  /** soft-removes and returns soft-remove an existing `RFIOrganization` in a `SoftRemoveRFIOrganizationResponse` */
  softRemoveRFIOrganization: SoftRemoveRfiOrganizationResponse;
  /** soft-removes and returns soft-remove an existing `RFIQuickLink` in a `SoftRemoveRFIQuickLinkResponse` */
  softRemoveRFIQuickLink: SoftRemoveRfiQuickLinkResponse;
  /** soft-removes and returns soft-remove an existing `RFIResponse` in a `SoftRemoveRFIResponseResponse` */
  softRemoveRFIResponse: SoftRemoveRfiResponseResponse;
  /** soft-removes and returns soft-remove an existing `RFIResponseDiscipline` in a `SoftRemoveRFIResponseDisciplineResponse` */
  softRemoveRFIResponseDiscipline: SoftRemoveRfiResponseDisciplineResponse;
  /** soft-removes and returns soft-remove an existing `RequestForInformation` in a `SoftRemoveRequestForInformationResponse` */
  softRemoveRequestForInformation: SoftRemoveRequestForInformationResponse;
  /** soft-removes and returns soft-remove an existing `Role` in a `SoftRemoveRoleResponse` */
  softRemoveRole: SoftRemoveRoleResponse;
  submitEngineeringJudgement: SubmitEngineeringJudgementResponse;
  submitFieldDesignChange: SubmitFieldDesignChangeResponse;
  submitIssue: SubmitIssueResponse;
  submitRequestForInformation: SubmitRequestForInformationResponse;
  /** syncs and returns sync an existing `GoogleSheetPayItemConnection` in a `SyncGoogleSheetPayItemConnectionResponse` */
  syncGoogleSheetPayItemConnection: SyncGoogleSheetPayItemConnectionResponse;
  syncIdentifiedFieldIssues: IdentifiedFieldIssueSync;
  syncUsers: SyncUsersResponse;
  /** upserts and returns the newly created, or edited, `ConcreteTestIFISettings` in a `UpsertConcreteTestIFISettingsResponse` */
  upsertConcreteTestIFISettings: UpsertConcreteTestIfiSettingsResponse;
  /** upserts and returns the newly created, or edited, `DailyInspectionControlPointIFISettings` in a `UpsertDailyInspectionControlPointIFISettingsResponse` */
  upsertDailyInspectionControlPointIFISettings: UpsertDailyInspectionControlPointIfiSettingsResponse;
  /** upserts and returns the newly created, or edited, `DailyInspectionInspectionIFISettings` in a `UpsertDailyInspectionInspectionIFISettingsResponse` */
  upsertDailyInspectionInspectionIFISettings: UpsertDailyInspectionInspectionIfiSettingsResponse;
  /** upserts and returns the newly created, or edited, `DailyInspectionPunchListIFISettings` in a `UpsertDailyInspectionPunchListIFISettingsResponse` */
  upsertDailyInspectionPunchListIFISettings: UpsertDailyInspectionPunchListIfiSettingsResponse;
  /** upserts and returns the newly created, or edited, `DensityTestIFISettings` in a `UpsertDensityTestIFISettingsResponse` */
  upsertDensityTestIFISettings: UpsertDensityTestIfiSettingsResponse;
  /** upserts and returns the newly created, or edited, `LIMSAsphaltLot` in a `UpsertLIMSAsphaltLotResponse` */
  upsertLIMSAsphaltLot: UpsertLimsAsphaltLotResponse;
  /** upserts and returns the newly created, or edited, `LotIFISettings` in a `UpsertLotIFISettingsResponse` */
  upsertLotIFISettings: UpsertLotIfiSettingsResponse;
  /** upserts and returns the newly created, or edited, `ProjectToIFIReportType` in a `UpsertProjectToIFIReportTypeResponse` */
  upsertProjectToIFIReportType: UpsertProjectToIfiReportTypeResponse;
  /** upserts and returns the newly created, or edited, `UserToDeveloperPermission` in a `UpsertUserToDeveloperPermissionResponse` */
  upsertUserToDeveloperPermission: UpsertUserToDeveloperPermissionResponse;
  /** see https://nodejs.org/en/learn/diagnostics/memory/using-heap-snapshot/#how-to-find-a-memory-leak-with-heap-snapshots for more information */
  writeHeapSnapshot: WriteHeapSnapshotResponse;
};


export type MutationAssociateProjectWithCimsArgs = {
  associateProjectWithCIMSInput: AssociateProjectWithCimsInput;
};


export type MutationCancelBatchReportRequestArgs = {
  id: Scalars['String'];
};


export type MutationCancelPhotoExportRequestArgs = {
  id: Scalars['String'];
};


export type MutationCloseIssueArgs = {
  closeIssueInput: CloseIssueInput;
};


export type MutationCreateApiKeyArgs = {
  createAPIKeyInput: CreateApiKeyInput;
};


export type MutationCreateAsphaltMixDesignArgs = {
  createAsphaltMixDesignInput: CreateAsphaltMixDesignInput;
};


export type MutationCreateBatchReportRequestArgs = {
  createBatchReportRequestInput: CreateBatchReportRequestInput;
};


export type MutationCreateCasCommentArgs = {
  createCASCommentInput: CreateCasCommentInput;
};


export type MutationCreateCasDispositionTypeArgs = {
  createCASDispositionTypeInput: CreateCasDispositionTypeInput;
};


export type MutationCreateCasQuickLinkArgs = {
  createCASQuickLinkInput: CreateCasQuickLinkInput;
};


export type MutationCreateCasRoutingGroupArgs = {
  createCASRoutingGroupInput: CreateCasRoutingGroupInput;
};


export type MutationCreateCasSubtypeArgs = {
  createCASSubtypeInput: CreateCasSubtypeInput;
};


export type MutationCreateCasTypeArgs = {
  createCASTypeInput: CreateCasTypeInput;
};


export type MutationCreateConcreteMixDesignArgs = {
  createConcreteMixDesignInput: CreateConcreteMixDesignInput;
};


export type MutationCreateConstructionAdminSubmittalArgs = {
  createConstructionAdminSubmittalInput: CreateConstructionAdminSubmittalInput;
};


export type MutationCreateCustomFieldArgs = {
  createCustomFieldInput: CreateCustomFieldInput;
};


export type MutationCreateCustomFieldToClassTypeArgs = {
  createCustomFieldToClassTypeInput: CreateCustomFieldToClassTypeInput;
};


export type MutationCreateCustomListItemArgs = {
  createCustomListItemInput: CreateCustomListItemInput;
};


export type MutationCreateDsActionArgs = {
  createDSActionInput: CreateDsActionInput;
};


export type MutationCreateDsCommentArgs = {
  createDSCommentInput: CreateDsCommentInput;
};


export type MutationCreateDsDisciplineArgs = {
  createDSDisciplineInput: CreateDsDisciplineInput;
};


export type MutationCreateDsOrganizationArgs = {
  createDSOrganizationInput: CreateDsOrganizationInput;
};


export type MutationCreateDsQuickLinkArgs = {
  createDSQuickLinkInput: CreateDsQuickLinkInput;
};


export type MutationCreateDsTypeArgs = {
  createDSTypeInput: CreateDsTypeInput;
};


export type MutationCreateDesignSubmittalArgs = {
  createDesignSubmittalInput: CreateDesignSubmittalInput;
};


export type MutationCreateDocumentChecklistItemArgs = {
  createDocumentChecklistItemInput: CreateDocumentChecklistItemInput;
};


export type MutationCreateEjQuickLinkArgs = {
  createEJQuickLinkInput: CreateEjQuickLinkInput;
};


export type MutationCreateEjTypeArgs = {
  createEJTypeInput: CreateEjTypeInput;
};


export type MutationCreateFdcApprovalGroupArgs = {
  createFDCApprovalGroupInput: CreateFdcApprovalGroupInput;
};


export type MutationCreateFdcCommentArgs = {
  createFDCCommentInput: CreateFdcCommentInput;
};


export type MutationCreateFdcConcurrenceGroupArgs = {
  createFDCConcurrenceGroupInput: CreateFdcConcurrenceGroupInput;
};


export type MutationCreateFdcConcurrenceLevelArgs = {
  createFDCConcurrenceLevelInput: CreateFdcConcurrenceLevelInput;
};


export type MutationCreateFdcDisciplineArgs = {
  createFDCDisciplineInput: CreateFdcDisciplineInput;
};


export type MutationCreateFdcQuickLinkArgs = {
  createFDCQuickLinkInput: CreateFdcQuickLinkInput;
};


export type MutationCreateGoogleSheetPayItemConnectionArgs = {
  createGoogleSheetPayItemConnectionInput: CreateGoogleSheetPayItemConnectionInput;
};


export type MutationCreateIfiCommentArgs = {
  createIFICommentInput: CreateIfiCommentInput;
};


export type MutationCreateIssueCommentArgs = {
  createIssueCommentInput: CreateIssueCommentInput;
};


export type MutationCreateIssueDispositionTypeArgs = {
  createIssueDispositionTypeInput: CreateIssueDispositionTypeInput;
};


export type MutationCreateIssueQuickLinkArgs = {
  createIssueQuickLinkInput: CreateIssueQuickLinkInput;
};


export type MutationCreateIssueTypeArgs = {
  createIssueTypeInput: CreateIssueTypeInput;
};


export type MutationCreateLimsAsphaltMixDesignTargetArgs = {
  createLIMSAsphaltMixDesignTargetInput: CreateLimsAsphaltMixDesignTargetInput;
};


export type MutationCreateLabTechArgs = {
  createLabTechInput: CreateLabTechInput;
};


export type MutationCreateNonUserEmailArgs = {
  createNonUserEmailInput: CreateNonUserEmailInput;
};


export type MutationCreatePayItemConnectionGroupArgs = {
  createPayItemConnectionGroupInput: CreatePayItemConnectionGroupInput;
};


export type MutationCreatePhotoExportRequestArgs = {
  createPhotoExportRequestInput: CreatePhotoExportRequestInput;
};


export type MutationCreateProjectToCimsOnlineAdminArgs = {
  createProjectToCIMSOnlineAdminInput: CreateProjectToCimsOnlineAdminInput;
};


export type MutationCreateRfiCommentArgs = {
  createRFICommentInput: CreateRfiCommentInput;
};


export type MutationCreateRfiOrganizationArgs = {
  createRFIOrganizationInput: CreateRfiOrganizationInput;
};


export type MutationCreateRfiQuickLinkArgs = {
  createRFIQuickLinkInput: CreateRfiQuickLinkInput;
};


export type MutationCreateRfiResponseArgs = {
  createRFIResponseInput: CreateRfiResponseInput;
};


export type MutationCreateRfiResponseDisciplineArgs = {
  createRFIResponseDisciplineInput: CreateRfiResponseDisciplineInput;
};


export type MutationCreateRoleArgs = {
  createRoleInput: CreateRoleInput;
};


export type MutationCreateTestingLabArgs = {
  createTestingLabInput: CreateTestingLabInput;
};


export type MutationDraftEngineeringJudgementArgs = {
  draftEngineeringJudgementInput: DraftEngineeringJudgementInput;
};


export type MutationDraftFieldDesignChangeArgs = {
  draftFieldDesignChangeInput: DraftFieldDesignChangeInput;
};


export type MutationDraftIssueArgs = {
  draftIssueInput: DraftIssueInput;
};


export type MutationDraftRequestForInformationArgs = {
  draftRequestForInformationInput: DraftRequestForInformationInput;
};


export type MutationEditAsphaltMixDesignArgs = {
  editAsphaltMixDesignInput: EditAsphaltMixDesignInput;
};


export type MutationEditCasDispositionTypeArgs = {
  editCASDispositionTypeInput: EditCasDispositionTypeInput;
};


export type MutationEditCasNotificationArgs = {
  editCASNotificationInput: EditCasNotificationInput;
};


export type MutationEditCasQuickLinkArgs = {
  editCASQuickLinkInput: EditCasQuickLinkInput;
};


export type MutationEditCasRoutingGroupArgs = {
  editCASRoutingGroupInput: EditCasRoutingGroupInput;
};


export type MutationEditCasSubtypeArgs = {
  editCASSubtypeInput: EditCasSubtypeInput;
};


export type MutationEditCasTypeArgs = {
  editCASTypeInput: EditCasTypeInput;
};


export type MutationEditConcreteMixDesignArgs = {
  editConcreteMixDesignInput: EditConcreteMixDesignInput;
};


export type MutationEditConcreteNotificationArgs = {
  editConcreteNotificationInput: EditConcreteNotificationInput;
};


export type MutationEditConcreteTestSetArgs = {
  editConcreteTestSetInput: EditConcreteTestSetInput;
};


export type MutationEditConstructionAdminSubmittalArgs = {
  editConstructionAdminSubmittalInput: EditConstructionAdminSubmittalInput;
};


export type MutationEditConstructionAdminSubmittalSharePointReferenceArgs = {
  editConstructionAdminSubmittalSharePointReferenceInput: EditConstructionAdminSubmittalSharePointReferenceInput;
};


export type MutationEditCustomFieldArgs = {
  editCustomFieldInput: EditCustomFieldInput;
};


export type MutationEditCustomFieldToClassTypeArgs = {
  editCustomFieldToClassTypeInput: EditCustomFieldToClassTypeInput;
};


export type MutationEditCustomListItemArgs = {
  editCustomListItemInput: EditCustomListItemInput;
};


export type MutationEditDsActionArgs = {
  editDSActionInput: EditDsActionInput;
};


export type MutationEditDsDisciplineArgs = {
  editDSDisciplineInput: EditDsDisciplineInput;
};


export type MutationEditDsNotificationArgs = {
  editDSNotificationInput: EditDsNotificationInput;
};


export type MutationEditDsOrganizationArgs = {
  editDSOrganizationInput: EditDsOrganizationInput;
};


export type MutationEditDsQuickLinkArgs = {
  editDSQuickLinkInput: EditDsQuickLinkInput;
};


export type MutationEditDsTypeArgs = {
  editDSTypeInput: EditDsTypeInput;
};


export type MutationEditDesignSubmittalArgs = {
  editDesignSubmittalInput: EditDesignSubmittalInput;
};


export type MutationEditDesignSubmittalSharePointReferenceArgs = {
  editDesignSubmittalSharePointReferenceInput: EditDesignSubmittalSharePointReferenceInput;
};


export type MutationEditDocumentChecklistItemArgs = {
  editDocumentChecklistItemInput: EditDocumentChecklistItemInput;
};


export type MutationEditEjNotificationArgs = {
  editEJNotificationInput: EditEjNotificationInput;
};


export type MutationEditEjQuickLinkArgs = {
  editEJQuickLinkInput: EditEjQuickLinkInput;
};


export type MutationEditEjTypeArgs = {
  editEJTypeInput: EditEjTypeInput;
};


export type MutationEditEngineeringJudgementArgs = {
  editEngineeringJudgementInput: EditEngineeringJudgementInput;
};


export type MutationEditFdcApprovalGroupArgs = {
  editFDCApprovalGroupInput: EditFdcApprovalGroupInput;
};


export type MutationEditFdcConcurrenceGroupArgs = {
  editFDCConcurrenceGroupInput: EditFdcConcurrenceGroupInput;
};


export type MutationEditFdcConcurrenceLevelArgs = {
  editFDCConcurrenceLevelInput: EditFdcConcurrenceLevelInput;
};


export type MutationEditFdcDisciplineArgs = {
  editFDCDisciplineInput: EditFdcDisciplineInput;
};


export type MutationEditFdcNotificationArgs = {
  editFDCNotificationInput: EditFdcNotificationInput;
};


export type MutationEditFdcQuickLinkArgs = {
  editFDCQuickLinkInput: EditFdcQuickLinkInput;
};


export type MutationEditFieldDesignChangeArgs = {
  editFieldDesignChangeInput: EditFieldDesignChangeInput;
};


export type MutationEditGoogleSheetPayItemConnectionArgs = {
  editGoogleSheetPayItemConnectionInput: EditGoogleSheetPayItemConnectionInput;
};


export type MutationEditIfiNotificationArgs = {
  editIFINotificationInput: EditIfiNotificationInput;
};


export type MutationEditIdentifiedFieldIssueArgs = {
  editIdentifiedFieldIssueInput: EditIdentifiedFieldIssueInput;
};


export type MutationEditIssueArgs = {
  editIssueInput: EditIssueInput;
};


export type MutationEditIssueDispositionTypeArgs = {
  editIssueDispositionTypeInput: EditIssueDispositionTypeInput;
};


export type MutationEditIssueNotificationArgs = {
  editIssueNotificationInput: EditIssueNotificationInput;
};


export type MutationEditIssueQuickLinkArgs = {
  editIssueQuickLinkInput: EditIssueQuickLinkInput;
};


export type MutationEditIssueTypeArgs = {
  editIssueTypeInput: EditIssueTypeInput;
};


export type MutationEditLimsAsphaltMixDesignTargetArgs = {
  editLIMSAsphaltMixDesignTargetInput: EditLimsAsphaltMixDesignTargetInput;
};


export type MutationEditLabTechArgs = {
  editLabTechInput: EditLabTechInput;
};


export type MutationEditNonUserEmailArgs = {
  editNonUserEmailInput: EditNonUserEmailInput;
};


export type MutationEditPdfDesignLayerArgs = {
  editPDFDesignLayerInput: EditPdfDesignLayerInput;
};


export type MutationEditPayItemConnectionGroupArgs = {
  editPayItemConnectionGroupInput: EditPayItemConnectionGroupInput;
};


export type MutationEditPayItemSummaryOrderArgs = {
  editPayItemSummaryOrderInput: EditPayItemSummaryOrderInput;
};


export type MutationEditPhotoFilenameArgs = {
  editPhotoFilenameInput: EditPhotoFilenameInput;
};


export type MutationEditProjectMetadataArgs = {
  editProjectMetadataInput: EditProjectMetadataInput;
};


export type MutationEditProjectToInternalConnectionArgs = {
  editProjectToInternalConnectionInput: EditProjectToInternalConnectionInput;
};


export type MutationEditRfiNotificationArgs = {
  editRFINotificationInput: EditRfiNotificationInput;
};


export type MutationEditRfiOrganizationArgs = {
  editRFIOrganizationInput: EditRfiOrganizationInput;
};


export type MutationEditRfiQuickLinkArgs = {
  editRFIQuickLinkInput: EditRfiQuickLinkInput;
};


export type MutationEditRfiResponseArgs = {
  editRFIResponseInput: EditRfiResponseInput;
};


export type MutationEditRfiResponseDisciplineArgs = {
  editRFIResponseDisciplineInput: EditRfiResponseDisciplineInput;
};


export type MutationEditReportFilenameArgs = {
  editReportFilenameInput: EditReportFilenameInput;
};


export type MutationEditRequestForInformationArgs = {
  editRequestForInformationInput: EditRequestForInformationInput;
};


export type MutationEditRoleArgs = {
  editRoleInput: EditRoleInput;
};


export type MutationEditTestingLabArgs = {
  editTestingLabInput: EditTestingLabInput;
};


export type MutationEditUserArgs = {
  editUserInput: EditUserInput;
};


export type MutationGiveDesignSubmittalDispositionArgs = {
  giveDesignSubmittalDispositionInput: GiveDesignSubmittalDispositionInput;
};


export type MutationGiveIssueDispositionArgs = {
  giveIssueDispositionInput: GiveIssueDispositionInput;
};


export type MutationGroupReviewConstructionAdminSubmittalArgs = {
  groupReviewConstructionAdminSubmittalInput: GroupReviewConstructionAdminSubmittalInput;
};


export type MutationReReviewConstructionAdminSubmittalArgs = {
  reReviewConstructionAdminSubmittalInput: ReReviewConstructionAdminSubmittalInput;
};


export type MutationRemoveApiKeyArgs = {
  removeAPIKeyInput: RemoveApiKeyInput;
};


export type MutationRemoveConcreteTestBreakDataArgs = {
  id: Scalars['Int'];
};


export type MutationRemoveDocumentChecklistItemArgs = {
  id: Scalars['Int'];
};


export type MutationRemoveLabTechArgs = {
  id: Scalars['Int'];
};


export type MutationRemoveNonUserEmailArgs = {
  id: Scalars['Int'];
};


export type MutationRemoveProjectToCimsOnlineAdminArgs = {
  removeProjectToCIMSOnlineAdminInput: RemoveProjectToCimsOnlineAdminInput;
};


export type MutationRemoveSharePointResourceArgs = {
  removeSharePointResourceInput: SharePointResourceInput;
};


export type MutationRemoveTestingLabArgs = {
  id: Scalars['Int'];
};


export type MutationRepairSharePointResourceArgs = {
  repairSharePointResourceInput: RepairSharePointResourceInput;
};


export type MutationRequestConstructionAdminSubmittalRevisionsArgs = {
  requestConstructionAdminSubmittalRevisionsInput: RequestConstructionAdminSubmittalRevisionsInput;
};


export type MutationRespondToIssueArgs = {
  respondToIssueInput: RespondToIssueInput;
};


export type MutationRestoreCasDispositionTypeArgs = {
  id: Scalars['String'];
};


export type MutationRestoreCasQuickLinkArgs = {
  id: Scalars['String'];
};


export type MutationRestoreCasRoutingGroupArgs = {
  id: Scalars['String'];
};


export type MutationRestoreCasSubtypeArgs = {
  id: Scalars['String'];
};


export type MutationRestoreCasTypeArgs = {
  id: Scalars['String'];
};


export type MutationRestoreConstructionAdminSubmittalArgs = {
  id: Scalars['String'];
};


export type MutationRestoreCustomFieldArgs = {
  id: Scalars['String'];
};


export type MutationRestoreDsActionArgs = {
  id: Scalars['String'];
};


export type MutationRestoreDsDisciplineArgs = {
  id: Scalars['String'];
};


export type MutationRestoreDsOrganizationArgs = {
  id: Scalars['String'];
};


export type MutationRestoreDsQuickLinkArgs = {
  id: Scalars['String'];
};


export type MutationRestoreDsTypeArgs = {
  id: Scalars['String'];
};


export type MutationRestoreDesignSubmittalArgs = {
  id: Scalars['String'];
};


export type MutationRestoreEjQuickLinkArgs = {
  id: Scalars['String'];
};


export type MutationRestoreEjTypeArgs = {
  id: Scalars['String'];
};


export type MutationRestoreEngineeringJudgementArgs = {
  id: Scalars['String'];
};


export type MutationRestoreFdcApprovalGroupArgs = {
  id: Scalars['String'];
};


export type MutationRestoreFdcConcurrenceGroupArgs = {
  id: Scalars['String'];
};


export type MutationRestoreFdcConcurrenceLevelArgs = {
  id: Scalars['String'];
};


export type MutationRestoreFdcDisciplineArgs = {
  id: Scalars['String'];
};


export type MutationRestoreFdcQuickLinkArgs = {
  id: Scalars['String'];
};


export type MutationRestoreFieldDesignChangeArgs = {
  id: Scalars['String'];
};


export type MutationRestoreIssueArgs = {
  id: Scalars['String'];
};


export type MutationRestoreIssueDispositionTypeArgs = {
  id: Scalars['String'];
};


export type MutationRestoreIssueQuickLinkArgs = {
  id: Scalars['String'];
};


export type MutationRestoreIssueTypeArgs = {
  id: Scalars['String'];
};


export type MutationRestoreLimsAsphaltMixDesignTargetArgs = {
  id: Scalars['String'];
};


export type MutationRestorePayItemConnectionArgs = {
  id: Scalars['String'];
};


export type MutationRestorePayItemConnectionGroupArgs = {
  id: Scalars['String'];
};


export type MutationRestoreRfiOrganizationArgs = {
  id: Scalars['String'];
};


export type MutationRestoreRfiQuickLinkArgs = {
  id: Scalars['String'];
};


export type MutationRestoreRfiResponseArgs = {
  id: Scalars['String'];
};


export type MutationRestoreRfiResponseDisciplineArgs = {
  id: Scalars['String'];
};


export type MutationRestoreRequestForInformationArgs = {
  id: Scalars['String'];
};


export type MutationRestoreRoleArgs = {
  id: Scalars['String'];
};


export type MutationRevertConstructionAdminSubmittalArgs = {
  revertConstructionAdminSubmittalInput: RevertConstructionAdminSubmittalInput;
};


export type MutationRevertDesignSubmittalArgs = {
  revertDesignSubmittalInput: RevertDesignSubmittalInput;
};


export type MutationRevertEngineeringJudgementArgs = {
  revertEngineeringJudgementInput: RevertEngineeringJudgementInput;
};


export type MutationRevertFieldDesignChangeArgs = {
  revertFieldDesignChangeInput: RevertFieldDesignChangeInput;
};


export type MutationRevertIdentifiedFieldIssueArgs = {
  revertIdentifiedFieldIssueInput: RevertIdentifiedFieldIssueInput;
};


export type MutationRevertIssueArgs = {
  revertIssueInput: RevertIssueInput;
};


export type MutationRevertRequestForInformationArgs = {
  revertRequestForInformationInput: RevertRequestForInformationInput;
};


export type MutationReviewIdentifiedFieldIssueArgs = {
  reviewIdentifiedFieldIssueInput: ReviewIdentifiedFieldIssueInput;
};


export type MutationReviseConstructionAdminSubmittalArgs = {
  reviseConstructionAdminSubmittalInput: ReviseConstructionAdminSubmittalInput;
};


export type MutationRouteConstructionAdminSubmittalToGroupReviewArgs = {
  routeConstructionAdminSubmittalToGroupReviewInput: RouteConstructionAdminSubmittalToGroupReviewInput;
};


export type MutationRouteConstructionAdminSubmittalToReReviewArgs = {
  routeConstructionAdminSubmittalToREReviewInput: RouteConstructionAdminSubmittalToReReviewInput;
};


export type MutationRouteDesignSubmittalArgs = {
  routeDesignSubmittalInput: RouteDesignSubmittalInput;
};


export type MutationSetCasToCasRoutingGroupArgs = {
  setCASToCASRoutingGroupInput: SetCasToCasRoutingGroupInput;
};


export type MutationSetDsToDsDisciplineArgs = {
  setDSToDSDisciplineInput: SetDsToDsDisciplineInput;
};


export type MutationSetDocumentChecklistValueArgs = {
  setDocumentChecklistValueInput: SetDocumentChecklistValueInput;
};


export type MutationSetFdcToFdcApprovalGroupArgs = {
  setFDCToFDCApprovalGroupInput: SetFdcToFdcApprovalGroupInput;
};


export type MutationSetFdcToFdcConcurrenceGroupArgs = {
  setFDCToFDCConcurrenceGroupInput: SetFdcToFdcConcurrenceGroupInput;
};


export type MutationSetSharePointResourcePermissionsArgs = {
  setSharePointResourcePermissionsInput: SetSharePointResourcePermissionsInput;
};


export type MutationSoftRemoveCasDispositionTypeArgs = {
  id: Scalars['String'];
};


export type MutationSoftRemoveCasQuickLinkArgs = {
  id: Scalars['String'];
};


export type MutationSoftRemoveCasRoutingGroupArgs = {
  id: Scalars['String'];
};


export type MutationSoftRemoveCasSubtypeArgs = {
  id: Scalars['String'];
};


export type MutationSoftRemoveCasTypeArgs = {
  id: Scalars['String'];
};


export type MutationSoftRemoveConstructionAdminSubmittalArgs = {
  id: Scalars['String'];
};


export type MutationSoftRemoveCustomFieldArgs = {
  id: Scalars['String'];
};


export type MutationSoftRemoveCustomFieldToClassTypeArgs = {
  id: Scalars['String'];
};


export type MutationSoftRemoveCustomListItemArgs = {
  id: Scalars['String'];
};


export type MutationSoftRemoveDsActionArgs = {
  id: Scalars['String'];
};


export type MutationSoftRemoveDsDisciplineArgs = {
  id: Scalars['String'];
};


export type MutationSoftRemoveDsOrganizationArgs = {
  id: Scalars['String'];
};


export type MutationSoftRemoveDsQuickLinkArgs = {
  id: Scalars['String'];
};


export type MutationSoftRemoveDsTypeArgs = {
  id: Scalars['String'];
};


export type MutationSoftRemoveDesignSubmittalArgs = {
  id: Scalars['String'];
};


export type MutationSoftRemoveEjQuickLinkArgs = {
  id: Scalars['String'];
};


export type MutationSoftRemoveEjTypeArgs = {
  id: Scalars['String'];
};


export type MutationSoftRemoveEngineeringJudgementArgs = {
  id: Scalars['String'];
};


export type MutationSoftRemoveFdcApprovalGroupArgs = {
  id: Scalars['String'];
};


export type MutationSoftRemoveFdcConcurrenceGroupArgs = {
  id: Scalars['String'];
};


export type MutationSoftRemoveFdcConcurrenceLevelArgs = {
  id: Scalars['String'];
};


export type MutationSoftRemoveFdcDisciplineArgs = {
  id: Scalars['String'];
};


export type MutationSoftRemoveFdcQuickLinkArgs = {
  id: Scalars['String'];
};


export type MutationSoftRemoveFieldDesignChangeArgs = {
  id: Scalars['String'];
};


export type MutationSoftRemoveIssueArgs = {
  id: Scalars['String'];
};


export type MutationSoftRemoveIssueDispositionTypeArgs = {
  id: Scalars['String'];
};


export type MutationSoftRemoveIssueQuickLinkArgs = {
  id: Scalars['String'];
};


export type MutationSoftRemoveIssueTypeArgs = {
  id: Scalars['String'];
};


export type MutationSoftRemoveLimsAsphaltMixDesignTargetArgs = {
  id: Scalars['String'];
};


export type MutationSoftRemovePayItemConnectionArgs = {
  id: Scalars['String'];
};


export type MutationSoftRemovePayItemConnectionGroupArgs = {
  id: Scalars['String'];
};


export type MutationSoftRemoveRfiOrganizationArgs = {
  id: Scalars['String'];
};


export type MutationSoftRemoveRfiQuickLinkArgs = {
  id: Scalars['String'];
};


export type MutationSoftRemoveRfiResponseArgs = {
  id: Scalars['String'];
};


export type MutationSoftRemoveRfiResponseDisciplineArgs = {
  id: Scalars['String'];
};


export type MutationSoftRemoveRequestForInformationArgs = {
  id: Scalars['String'];
};


export type MutationSoftRemoveRoleArgs = {
  id: Scalars['String'];
};


export type MutationSubmitEngineeringJudgementArgs = {
  submitEngineeringJudgementInput: SubmitEngineeringJudgementInput;
};


export type MutationSubmitFieldDesignChangeArgs = {
  submitFieldDesignChangeInput: SubmitFieldDesignChangeInput;
};


export type MutationSubmitIssueArgs = {
  submitIssueInput: SubmitIssueInput;
};


export type MutationSubmitRequestForInformationArgs = {
  submitRequestForInformationInput: SubmitRequestForInformationInput;
};


export type MutationSyncGoogleSheetPayItemConnectionArgs = {
  syncGoogleSheetPayItemConnectionInput: SyncGoogleSheetPayItemConnectionInput;
};


export type MutationSyncIdentifiedFieldIssuesArgs = {
  projectId: Scalars['String'];
};


export type MutationUpsertConcreteTestIfiSettingsArgs = {
  upsertConcreteTestIFISettingsInput: UpsertConcreteTestIfiSettingsInput;
};


export type MutationUpsertDailyInspectionControlPointIfiSettingsArgs = {
  upsertDailyInspectionControlPointIFISettingsInput: UpsertDailyInspectionControlPointIfiSettingsInput;
};


export type MutationUpsertDailyInspectionInspectionIfiSettingsArgs = {
  upsertDailyInspectionInspectionIFISettingsInput: UpsertDailyInspectionInspectionIfiSettingsInput;
};


export type MutationUpsertDailyInspectionPunchListIfiSettingsArgs = {
  upsertDailyInspectionPunchListIFISettingsInput: UpsertDailyInspectionPunchListIfiSettingsInput;
};


export type MutationUpsertDensityTestIfiSettingsArgs = {
  upsertDensityTestIFISettingsInput: UpsertDensityTestIfiSettingsInput;
};


export type MutationUpsertLimsAsphaltLotArgs = {
  upsertLIMSAsphaltLotInput: UpsertLimsAsphaltLotInput;
};


export type MutationUpsertLotIfiSettingsArgs = {
  upsertLotIFISettingsInput: UpsertLotIfiSettingsInput;
};


export type MutationUpsertProjectToIfiReportTypeArgs = {
  upsertProjectToIFIReportTypeInput: UpsertProjectToIfiReportTypeInput;
};


export type MutationUpsertUserToDeveloperPermissionArgs = {
  upsertUserToDeveloperPermissionInput: UpsertUserToDeveloperPermissionInput;
};

export type NonUserEmail = {
  __typename: 'NonUserEmail';
  address: Scalars['String'];
  /** the date this record was inserted into the database */
  createdDate: Scalars['DateTime'];
  /**
   * the email address of a user associated with the `createdDate`
   *
   * this value will be `unknown` if the `createdDate` was not set by a user
   */
  createdUser: Scalars['String'];
  /**
   * an extended description associated with the record
   *
   * this description will be used to describe the record in CIMS, where possible
   */
  description: Maybe<Scalars['String']>;
  /** a unique integer to identify this record in the database table */
  id: Scalars['Int'];
  label: Maybe<Scalars['String']>;
  /** the date this record was last updated in the database */
  lastEditedDate: Scalars['DateTime'];
  /**
   * the email address of a user associated with the `lastEditedDate`
   *
   * this value will be `system` if the `lastEditedDate` was not set by a user
   */
  lastEditedUser: Scalars['String'];
  /** a related `Project` */
  project: Project;
  /** the `globalId` of a related `Project` */
  projectId: Scalars['String'];
};

/**
 * helps filter multiple `NonUserEmail` records
 *
 * this version of the input will have limited options compared to its other counterpart
 */
export type NonUserEmailFieldInput = {
  address?: InputMaybe<StringFilter>;
  createdDate?: InputMaybe<DateTimeFilter>;
  description?: InputMaybe<StringFilter>;
  label?: InputMaybe<StringFilter>;
  lastEditedDate?: InputMaybe<DateTimeFilter>;
  /**
   * how to order `NonUserEmail` records
   *
   * executed in the order they are defined
   */
  orderBy?: InputMaybe<Array<OrderByInput>>;
  projectId?: InputMaybe<StringFilter>;
  /**
   * specifies how many records to return
   *
   * analogous to `limit`, `first`, or `top` in SQL dialects
   */
  take?: InputMaybe<Scalars['Int']>;
};

/** helps filter multiple `NonUserEmail` records */
export type NonUserEmailListInput = {
  address?: InputMaybe<StringFilter>;
  createdDate?: InputMaybe<DateTimeFilter>;
  description?: InputMaybe<StringFilter>;
  label?: InputMaybe<StringFilter>;
  lastEditedDate?: InputMaybe<DateTimeFilter>;
  /**
   * how to order `NonUserEmail` records
   *
   * executed in the order they are defined
   */
  orderBy?: InputMaybe<Array<OrderByInput>>;
  /**
   * paginate `NonUserEmail` records
   *
   * using `paginate` may require multiple requests to get all possible results,
   * but will give more fine-grain control in the event all records cannot be
   * returned gracefully
   */
  paginate?: InputMaybe<PaginationInput>;
  projectId?: InputMaybe<StringFilter>;
};

/** response metadata for a list query of NonUserEmail records */
export type NonUserEmailListResponse = {
  __typename: 'NonUserEmailListResponse';
  /** the total count of NonUserEmail records matching any configured filters */
  count: Scalars['Int'];
  /** the total count of paginated groups of NonUserEmail */
  pages: Scalars['Int'];
  /** NonUserEmail records */
  records: Array<NonUserEmail>;
};

/** a simple number field */
export type NumberCustomFieldValue = {
  __typename: 'NumberCustomFieldValue';
  /** the date this record was inserted into the database */
  createdDate: Scalars['DateTime'];
  /**
   * the email address of a user associated with the `createdDate`
   *
   * this value will be `unknown` if the `createdDate` was not set by a user
   */
  createdUser: Scalars['String'];
  customField: CustomField;
  /** the `id` of a related `CustomField` */
  customFieldId: Scalars['String'];
  /** the date this record was soft-deleted in the database */
  deletedDate: Maybe<Scalars['DateTime']>;
  /**
   * the email address of a user associated with the `deletedDate`
   *
   * this value will be `system` if the `deletedDate` was not set by a user
   */
  deletedUser: Maybe<Scalars['String']>;
  /** the date this record was last updated in the database */
  lastEditedDate: Scalars['DateTime'];
  /**
   * the email address of a user associated with the `lastEditedDate`
   *
   * this value will be `system` if the `lastEditedDate` was not set by a user
   */
  lastEditedUser: Scalars['String'];
  /** a Float value */
  value: Maybe<Scalars['Float']>;
};

/** allows for sort order configuration */
export type OrderByInput = {
  /**
   * order records in descending order (z-a)
   *
   * by default, records are ordered in ascending order (a-z)
   */
  descending?: InputMaybe<Scalars['Boolean']>;
  /** a field in the object type to order by */
  field: Scalars['String'];
};

export type OrphanedSharePointResources = {
  __typename: 'OrphanedSharePointResources';
  concreteTestSetResources: Array<SharePointResource>;
  constructionAdminSubmittalResources: Array<SharePointResource>;
  designSubmittalResources: Array<SharePointResource>;
  fieldDesignChangeResources: Array<SharePointResource>;
};

export type OrphanedSharePointResourcesInput = {
  /** accepts the enum or name of the parent folder */
  parent?: InputMaybe<StringFilter>;
  projectId: Scalars['String'];
};

export type PdfDesignLayer = {
  __typename: 'PDFDesignLayer';
  /** the date this record was inserted into the database */
  createdDate: Scalars['DateTime'];
  /**
   * the email address of a user associated with the `createdDate`
   *
   * this value will be `unknown` if the `createdDate` was not set by a user
   */
  createdUser: Scalars['String'];
  /**
   * a map server index of a `Table` in Horrocks' ArcGIS REST service
   *
   * used to help distinguish which object type is associated with `PDFDesignLayer.json`
   *
   * | object type | index |
   * | --- | :---: |
   * | `MaterialRequirement` | 8 |
   * | `ConcreteMaterial` | 18 |
   * | `DailyInspectionWorkType` | 31 |
   * | `AsphaltMaterial` | 45 |
   */
  index: Scalars['Int'];
  /**
   * a JSON containing the desired `CM_Project_Layer` map
   * server indexes for the associated `PDFDesignLayer.index`
   *
   * `useAllLayers` denotes whether to use the indexes in `allLayers` for every
   * associated object type
   *
   * otherwise, `options` will contain a map of `globalId` to indexes
   *
   * each `options` key will be the `globalId` of one of the related types: `AsphaltMaterial`, `ConcreteMaterial`, `DailyInspectionWorkType`, or `MaterialRequirement`
   *
   * ``` json
   * {
   *   "useAllLayers": false,
   *   "options": {
   *     "09BDB846-CAE2-4854-9ECF-76A86AAB68C4": [ "1", "35", "23" ],
   *     "AC3562BF-0BCF-440C-9BA7-06BED6AEC5E1": [ "3", "32", "12" ]
   *   }
   * }
   * {
   *   "useAllLayers": true,
   *   "allLayers": [ "1", "5", "29" ]
   * }
   * {
   *   "useAllLayers": false,
   *   "allLayers": [],
   *   "options": {
   *     "1450DB38-296B-4AF4-92DC-510D74E53003": [ "32", "1", "4" ],
   *     "AA2CCD65-B79F-4FDA-B8E2-98BA21589079": [ "7", "10", "18" ]
   *   }
   * }
   * ```
   */
  json: Maybe<PdfDesignLayerJson>;
  /** the date this record was last updated in the database */
  lastEditedDate: Scalars['DateTime'];
  /**
   * the email address of a user associated with the `lastEditedDate`
   *
   * this value will be `system` if the `lastEditedDate` was not set by a user
   */
  lastEditedUser: Scalars['String'];
  /** a related `Project` */
  project: Project;
  /** the `globalId` of a related `Project` */
  projectId: Scalars['String'];
};

/**
 * helps filter multiple `PDFDesignLayer` records
 *
 * this version of the input will have limited options compared to its other counterpart
 */
export type PdfDesignLayerFieldInput = {
  createdDate?: InputMaybe<DateTimeFilter>;
  index?: InputMaybe<IntFilter>;
  lastEditedDate?: InputMaybe<DateTimeFilter>;
  /**
   * how to order `PDFDesignLayer` records
   *
   * executed in the order they are defined
   */
  orderBy?: InputMaybe<Array<OrderByInput>>;
  projectId?: InputMaybe<StringFilter>;
  /**
   * specifies how many records to return
   *
   * analogous to `limit`, `first`, or `top` in SQL dialects
   */
  take?: InputMaybe<Scalars['Int']>;
};

export type PdfDesignLayerJson = {
  __typename: 'PDFDesignLayerJSON';
  /** a list of `ArcGISProjectIndex` layer integers */
  allLayers: Maybe<Array<Scalars['Int']>>;
  /** an object where each key is an entity's `globalId` and its corresponding value is a list of `ArcGISProjectIndex` layer integers */
  options: Maybe<Scalars['PDFDesignLayerOptionsScalar']>;
  /** whether to use `allLayers` when setting layers for a `PDFDesignLayer.index` */
  useAllLayers: Scalars['Boolean'];
};

/** helps filter multiple `PDFDesignLayer` records */
export type PdfDesignLayerListInput = {
  createdDate?: InputMaybe<DateTimeFilter>;
  index?: InputMaybe<IntFilter>;
  lastEditedDate?: InputMaybe<DateTimeFilter>;
  /**
   * how to order `PDFDesignLayer` records
   *
   * executed in the order they are defined
   */
  orderBy?: InputMaybe<Array<OrderByInput>>;
  /**
   * paginate `PDFDesignLayer` records
   *
   * using `paginate` may require multiple requests to get all possible results,
   * but will give more fine-grain control in the event all records cannot be
   * returned gracefully
   */
  paginate?: InputMaybe<PaginationInput>;
  projectId?: InputMaybe<StringFilter>;
};

/** response metadata for a list query of PDFDesignLayer records */
export type PdfDesignLayerListResponse = {
  __typename: 'PDFDesignLayerListResponse';
  /** the total count of PDFDesignLayer records matching any configured filters */
  count: Scalars['Int'];
  /** the total count of paginated groups of PDFDesignLayer */
  pages: Scalars['Int'];
  /** PDFDesignLayer records */
  records: Array<PdfDesignLayer>;
};

/**
 * paginates records with the supplied `skip` and `take` options
 *
 *   when configured
 */
export type PaginationInput = {
  /**
   * specifies from which record to start returning records
   *
   * analogous to `offset` in SQL dialects
   *
   * by default, records will not be skipped
   */
  skip?: InputMaybe<Scalars['Int']>;
  /**
   * specifies how many records to return
   *
   * analogous to `limit`, `first`, or `top` in SQL dialects
   */
  take: Scalars['Int'];
};

/**
 * ### `PayItem` vs `PayItemNoGeometry`
 *
 * throughout the schema there will be references to `PayItem` and `PayItemNoGeometry`
 *
 * as with most confusing things, the reason is legacy
 *
 * before the creation of this API, `PayItem` was the predominant object type used with
 * a mobile field application, and made use of geometry metadata
 *
 * at some point, the metadata was phased out and a new object type for `PayItemNoGeometry`
 * was created; as the name suggests, it doesn't have geometry metadata
 *
 * enter this API
 *
 * rather than take the time to write out `payItemNoGeometry` everywhere,
 * `payItem` was used as shorthand for everything since `PayItem` wasn't being used;
 * _this was shortsighted_
 *
 * because of course it would, `PayItem` was eventually added back with the desire
 * to start using geometry metadata again
 *
 * rather than take the time to go through and update _all_ the database columns to
 * match the correct object type, the understanding is, for most things, the referenced
 * `payItem` is a `PayItemNoGeometry`
 *
 * luckily, this schema will include the correct object type with the field name and has
 * been able make small changes to help clear things up in a big way
 */
export type PayItem = {
  __typename: 'PayItem';
  /** the date this record was inserted into the database */
  createdDate: Maybe<Scalars['DateTime']>;
  /** the username or email address of a mobile app user associated with the `createdDate` */
  createdUser: Maybe<Scalars['String']>;
  deleted: Maybe<Scalars['String']>;
  description: Maybe<Scalars['String']>;
  /** a GUID used to globally identify this record in the database */
  globalId: Scalars['String'];
  /** the date this record was last updated in the database */
  lastEditedDate: Maybe<Scalars['DateTime']>;
  /** the username or email address of a mobile app user associated with the `lastEditedDate` */
  lastEditedUser: Maybe<Scalars['String']>;
  layer: Maybe<Scalars['String']>;
  material: Maybe<MaterialRequirement>;
  /** the `globalId` of a related `MaterialRequirement` */
  materialGuid: Maybe<Scalars['String']>;
  payItemId: Maybe<Scalars['String']>;
  payItemNoGeometry: Maybe<PayItemNoGeometry>;
  payItemNoGeometryGuid: Maybe<Scalars['String']>;
  /** a related `Project` */
  project: Maybe<Project>;
  /** the `globalId` of a related `Project` */
  projectId: Maybe<Scalars['String']>;
  renderInfo: Maybe<Scalars['String']>;
  shape: Maybe<Scalars['String']>;
  status: Maybe<Scalars['String']>;
};

export type PayItemConnection = {
  __typename: 'PayItemConnection';
  /** the date this record was inserted into the database */
  createdDate: Scalars['DateTime'];
  /**
   * the email address of a user associated with the `createdDate`
   *
   * this value will be `unknown` if the `createdDate` was not set by a user
   */
  createdUser: Scalars['String'];
  /** describes whether the record has been soft-deleted or not */
  deleted: Scalars['Boolean'];
  /** the date this record was soft-deleted in the database */
  deletedDate: Maybe<Scalars['DateTime']>;
  /**
   * the email address of a user associated with the `deletedDate`
   *
   * this value will be `system` if the `deletedDate` was not set by a user
   */
  deletedUser: Maybe<Scalars['String']>;
  googleSheet: Maybe<GoogleSheetPayItemConnection>;
  group: Maybe<PayItemConnectionGroup>;
  groupId: Maybe<Scalars['String']>;
  /** a UUID used to globally identify this record in the database */
  id: Scalars['String'];
  /** the date a sync task, or request, last attempted to sync the connection's data */
  lastAttemptedDate: Maybe<Scalars['DateTime']>;
  /** the date this record was last updated in the database */
  lastEditedDate: Scalars['DateTime'];
  /**
   * the email address of a user associated with the `lastEditedDate`
   *
   * this value will be `system` if the `lastEditedDate` was not set by a user
   */
  lastEditedUser: Scalars['String'];
  /** the date a sync task, or request, last successfully synced the connection's data */
  lastSyncDate: Maybe<Scalars['DateTime']>;
  /**
   * the last encountered error during a sync task or, request
   *
   * cleared after a successful sync
   */
  lastSyncError: Maybe<PayItemConnectionSyncError>;
  /** the display name of the record in the Pay Items Summary and Manage pages */
  name: Maybe<Scalars['String']>;
  /**
   * the order of this connection in the Pay Items Summary
   *
   * if a `groupId` is set, the order inside the associated `PayItemConnectionGroup`
   */
  order: Maybe<Scalars['Int']>;
  /** a related `Project` */
  project: Project;
  /** the `globalId` of a related `Project` */
  projectId: Scalars['String'];
  /** whether the `PayItemConnection is currently syncing` */
  syncing: Scalars['Boolean'];
};

/**
 * helps filter multiple `PayItemConnection` records
 *
 * this version of the input will have limited options compared to its other counterpart
 */
export type PayItemConnectionFieldInput = {
  createdDate?: InputMaybe<DateTimeFilter>;
  /**
   * determines now to handle deleted `PayItemConnection` records
   *
   * - when `true`, only return deleted records
   * - when `false`, do not return deleted records
   * - when omitted, `deleted` is ignored
   */
  deleted?: InputMaybe<Scalars['Boolean']>;
  errored?: InputMaybe<Scalars['Boolean']>;
  groupId?: InputMaybe<StringFilter>;
  lastAttemptedDate?: InputMaybe<DateTimeFilter>;
  lastEditedDate?: InputMaybe<DateTimeFilter>;
  lastSyncDate?: InputMaybe<DateTimeFilter>;
  name?: InputMaybe<StringFilter>;
  /**
   * how to order `PayItemConnection` records
   *
   * executed in the order they are defined
   */
  orderBy?: InputMaybe<Array<OrderByInput>>;
  projectId?: InputMaybe<StringFilter>;
  /**
   * - when `true`, `syncing` is truthy
   * - when `false`, `syncing` is falsy
   * - when omitted, `syncing` is ignored
   */
  syncing?: InputMaybe<Scalars['Boolean']>;
  /**
   * specifies how many records to return
   *
   * analogous to `limit`, `first`, or `top` in SQL dialects
   */
  take?: InputMaybe<Scalars['Int']>;
};

export type PayItemConnectionGroup = {
  __typename: 'PayItemConnectionGroup';
  connections: Array<PayItemConnection>;
  /** the date this record was inserted into the database */
  createdDate: Scalars['DateTime'];
  /**
   * the email address of a user associated with the `createdDate`
   *
   * this value will be `unknown` if the `createdDate` was not set by a user
   */
  createdUser: Scalars['String'];
  /** describes whether the record has been soft-deleted or not */
  deleted: Scalars['Boolean'];
  /** the date this record was soft-deleted in the database */
  deletedDate: Maybe<Scalars['DateTime']>;
  /**
   * the email address of a user associated with the `deletedDate`
   *
   * this value will be `system` if the `deletedDate` was not set by a user
   */
  deletedUser: Maybe<Scalars['String']>;
  /**
   * an extended description associated with the record
   *
   * this description will be used to describe the record in CIMS, where possible
   */
  description: Maybe<Scalars['String']>;
  /** a UUID used to globally identify this record in the database */
  id: Scalars['String'];
  internalConnections: Array<ProjectToInternalConnection>;
  /** the date this record was last updated in the database */
  lastEditedDate: Scalars['DateTime'];
  /**
   * the email address of a user associated with the `lastEditedDate`
   *
   * this value will be `system` if the `lastEditedDate` was not set by a user
   */
  lastEditedUser: Scalars['String'];
  /** a human readable name associated with the record */
  name: Scalars['String'];
  /** the order of this group in the Pay Items Summary */
  order: Maybe<Scalars['Int']>;
  /** a related `Project` */
  project: Project;
  /** the `globalId` of a related `Project` */
  projectId: Scalars['String'];
};


export type PayItemConnectionGroupConnectionsArgs = {
  payItemConnectionFieldInput?: InputMaybe<PayItemConnectionFieldInput>;
};


export type PayItemConnectionGroupInternalConnectionsArgs = {
  payItemConnectionGroupInternalConnectionsFieldInput?: InputMaybe<PayItemConnectionGroupInternalConnectionsFieldInput>;
};

/**
 * helps filter multiple `PayItemConnectionGroup` records
 *
 * this version of the input will have limited options compared to its other counterpart
 */
export type PayItemConnectionGroupFieldInput = {
  createdDate?: InputMaybe<DateTimeFilter>;
  /**
   * determines now to handle deleted `PayItemConnectionGroup` records
   *
   * - when `true`, only return deleted records
   * - when `false`, do not return deleted records
   * - when omitted, `deleted` is ignored
   */
  deleted?: InputMaybe<Scalars['Boolean']>;
  description?: InputMaybe<StringFilter>;
  lastEditedDate?: InputMaybe<DateTimeFilter>;
  name?: InputMaybe<StringFilter>;
  /**
   * how to order `PayItemConnectionGroup` records
   *
   * executed in the order they are defined
   */
  orderBy?: InputMaybe<Array<OrderByInput>>;
  projectId?: InputMaybe<StringFilter>;
  /**
   * specifies how many records to return
   *
   * analogous to `limit`, `first`, or `top` in SQL dialects
   */
  take?: InputMaybe<Scalars['Int']>;
};

export type PayItemConnectionGroupInternalConnectionsFieldInput = {
  internalConnectionId?: InputMaybe<StringFilter>;
  /**
   * how to order `ProjectToInternalConnection` records
   *
   * executed in the order they are defined
   */
  orderBy?: InputMaybe<Array<OrderByInput>>;
  /**
   * specifies how many records to return
   *
   * analogous to `limit`, `first`, or `top` in SQL dialects
   */
  take?: InputMaybe<Scalars['Int']>;
};

/** helps filter multiple `PayItemConnectionGroup` records */
export type PayItemConnectionGroupListInput = {
  createdDate?: InputMaybe<DateTimeFilter>;
  /**
   * determines now to handle deleted `PayItemConnectionGroup` records
   *
   * - when `true`, only return deleted records
   * - when `false`, do not return deleted records
   * - when omitted, `deleted` is ignored
   */
  deleted?: InputMaybe<Scalars['Boolean']>;
  description?: InputMaybe<StringFilter>;
  lastEditedDate?: InputMaybe<DateTimeFilter>;
  name?: InputMaybe<StringFilter>;
  /**
   * how to order `PayItemConnectionGroup` records
   *
   * executed in the order they are defined
   */
  orderBy?: InputMaybe<Array<OrderByInput>>;
  /**
   * paginate `PayItemConnectionGroup` records
   *
   * using `paginate` may require multiple requests to get all possible results,
   * but will give more fine-grain control in the event all records cannot be
   * returned gracefully
   */
  paginate?: InputMaybe<PaginationInput>;
  projectId?: InputMaybe<StringFilter>;
};

/** response metadata for a list query of PayItemConnectionGroup records */
export type PayItemConnectionGroupListResponse = {
  __typename: 'PayItemConnectionGroupListResponse';
  /** the total count of PayItemConnectionGroup records matching any configured filters */
  count: Scalars['Int'];
  /** the total count of paginated groups of PayItemConnectionGroup */
  pages: Scalars['Int'];
  /** PayItemConnectionGroup records */
  records: Array<PayItemConnectionGroup>;
};

export type PayItemConnectionGroupOrderInput = {
  id: Scalars['String'];
  order: Scalars['Int'];
};

/** helps filter multiple `PayItemConnection` records */
export type PayItemConnectionListInput = {
  createdDate?: InputMaybe<DateTimeFilter>;
  /**
   * determines now to handle deleted `PayItemConnection` records
   *
   * - when `true`, only return deleted records
   * - when `false`, do not return deleted records
   * - when omitted, `deleted` is ignored
   */
  deleted?: InputMaybe<Scalars['Boolean']>;
  errored?: InputMaybe<Scalars['Boolean']>;
  groupId?: InputMaybe<StringFilter>;
  lastAttemptedDate?: InputMaybe<DateTimeFilter>;
  lastEditedDate?: InputMaybe<DateTimeFilter>;
  lastSyncDate?: InputMaybe<DateTimeFilter>;
  name?: InputMaybe<StringFilter>;
  /**
   * how to order `PayItemConnection` records
   *
   * executed in the order they are defined
   */
  orderBy?: InputMaybe<Array<OrderByInput>>;
  /**
   * paginate `PayItemConnection` records
   *
   * using `paginate` may require multiple requests to get all possible results,
   * but will give more fine-grain control in the event all records cannot be
   * returned gracefully
   */
  paginate?: InputMaybe<PaginationInput>;
  projectId?: InputMaybe<StringFilter>;
  /**
   * - when `true`, `syncing` is truthy
   * - when `false`, `syncing` is falsy
   * - when omitted, `syncing` is ignored
   */
  syncing?: InputMaybe<Scalars['Boolean']>;
};

/** response metadata for a list query of PayItemConnection records */
export type PayItemConnectionListResponse = {
  __typename: 'PayItemConnectionListResponse';
  /** the total count of PayItemConnection records matching any configured filters */
  count: Scalars['Int'];
  /** the total count of paginated groups of PayItemConnection */
  pages: Scalars['Int'];
  /** PayItemConnection records */
  records: Array<PayItemConnection>;
};

export type PayItemConnectionOrderInput = {
  groupId?: InputMaybe<Scalars['String']>;
  id: Scalars['String'];
  order: Scalars['Int'];
};

export type PayItemConnectionPayItemSummaryCount = {
  __typename: 'PayItemConnectionPayItemSummaryCount';
  count: Maybe<Scalars['Int']>;
  payItemConnection: PayItemConnection;
};

export type PayItemConnectionSyncError = {
  __typename: 'PayItemConnectionSyncError';
  /** the message associated with the error */
  message: Scalars['String'];
  /** a stack trace that may have been included with the error */
  stack: Maybe<Scalars['String']>;
};

/**
 * helps filter multiple `PayItem` records
 *
 * this version of the input will have limited options compared to its other counterpart
 */
export type PayItemFieldInput = {
  createdDate?: InputMaybe<DateTimeFilter>;
  /**
   * determines now to handle deleted `PayItem` records
   *
   * - when `true`, only return deleted records
   * - when `false`, do not return deleted records
   * - when omitted, `deleted` is ignored
   */
  deleted?: InputMaybe<Scalars['Boolean']>;
  description?: InputMaybe<StringFilter>;
  lastEditedDate?: InputMaybe<DateTimeFilter>;
  /**
   * how to order `PayItem` records
   *
   * executed in the order they are defined
   */
  orderBy?: InputMaybe<Array<OrderByInput>>;
  payItemId?: InputMaybe<StringFilter>;
  projectId?: InputMaybe<StringFilter>;
  status?: InputMaybe<StringFilter>;
  /**
   * specifies how many records to return
   *
   * analogous to `limit`, `first`, or `top` in SQL dialects
   */
  take?: InputMaybe<Scalars['Int']>;
};

export type PayItemGroup = {
  __typename: 'PayItemGroup';
  /** the date this record was inserted into the database */
  createdDate: Maybe<Scalars['DateTime']>;
  /** the username or email address of a mobile app user associated with the `createdDate` */
  createdUser: Maybe<Scalars['String']>;
  dailyDate: Maybe<Scalars['DateTime']>;
  deleted: Maybe<Scalars['String']>;
  description: Maybe<Scalars['String']>;
  /** a GUID used to globally identify this record in the database */
  globalId: Scalars['String'];
  /** the date this record was last updated in the database */
  lastEditedDate: Maybe<Scalars['DateTime']>;
  /** the username or email address of a mobile app user associated with the `lastEditedDate` */
  lastEditedUser: Maybe<Scalars['String']>;
  /**
   * If set, contains a comma separated list of
   * `PayItemNoGeometry.globalId` values
   *
   * unfortunately, there have been instances where one of these values doesn't map
   * to a valid `PayItemNoGeometry`
   *
   * `payItemNoGeometries` will skip these rather than map them to `null`
   */
  multiplePayItems: Maybe<Scalars['String']>;
  payItemGuid: Maybe<Scalars['String']>;
  /**
   * aggregates all `PayItemNoGeometry` records associated with this
   * `PayItemGroup` by using its `PayItemNoGeometry` reference and `multiplePayItems`
   *
   * if any `PayItemNoGeometry.globalId` values used to query the database return `null`,
   * the `null` value will be filtered out of the results
   *
   * every result will be a valid `PayItemNoGeometry`
   */
  payItemNoGeometries: Array<PayItemNoGeometry>;
  /** a related `Project` */
  project: Maybe<Project>;
  /** the `globalId` of a related `Project` */
  projectId: Maybe<Scalars['String']>;
  technician: Maybe<Technician>;
  /** the `globalId` of a related `Technician` */
  technicianGuid: Maybe<Scalars['String']>;
};


export type PayItemGroupPayItemNoGeometriesArgs = {
  payItemNoGeometryFieldInput?: InputMaybe<PayItemNoGeometryFieldInput>;
};

/**
 * helps filter multiple `PayItemGroup` records
 *
 * this version of the input will have limited options compared to its other counterpart
 */
export type PayItemGroupFieldInput = {
  createdDate?: InputMaybe<DateTimeFilter>;
  /**
   * determines now to handle deleted `PayItemGroup` records
   *
   * - when `true`, only return deleted records
   * - when `false`, do not return deleted records
   * - when omitted, `deleted` is ignored
   */
  deleted?: InputMaybe<Scalars['Boolean']>;
  description?: InputMaybe<StringFilter>;
  lastEditedDate?: InputMaybe<DateTimeFilter>;
  /**
   * how to order `PayItemGroup` records
   *
   * executed in the order they are defined
   */
  orderBy?: InputMaybe<Array<OrderByInput>>;
  projectId?: InputMaybe<StringFilter>;
  /**
   * specifies how many records to return
   *
   * analogous to `limit`, `first`, or `top` in SQL dialects
   */
  take?: InputMaybe<Scalars['Int']>;
};

/** helps filter multiple `PayItemGroup` records */
export type PayItemGroupListInput = {
  createdDate?: InputMaybe<DateTimeFilter>;
  /**
   * determines now to handle deleted `PayItemGroup` records
   *
   * - when `true`, only return deleted records
   * - when `false`, do not return deleted records
   * - when omitted, `deleted` is ignored
   */
  deleted?: InputMaybe<Scalars['Boolean']>;
  description?: InputMaybe<StringFilter>;
  lastEditedDate?: InputMaybe<DateTimeFilter>;
  /**
   * how to order `PayItemGroup` records
   *
   * executed in the order they are defined
   */
  orderBy?: InputMaybe<Array<OrderByInput>>;
  /**
   * paginate `PayItemGroup` records
   *
   * using `paginate` may require multiple requests to get all possible results,
   * but will give more fine-grain control in the event all records cannot be
   * returned gracefully
   */
  paginate?: InputMaybe<PaginationInput>;
  projectId?: InputMaybe<StringFilter>;
};

/** response metadata for a list query of PayItemGroup records */
export type PayItemGroupListResponse = {
  __typename: 'PayItemGroupListResponse';
  /** the total count of PayItemGroup records matching any configured filters */
  count: Scalars['Int'];
  /** the total count of paginated groups of PayItemGroup */
  pages: Scalars['Int'];
  /** PayItemGroup records */
  records: Array<PayItemGroup>;
};

/** helps filter multiple `PayItem` records */
export type PayItemListInput = {
  createdDate?: InputMaybe<DateTimeFilter>;
  /**
   * determines now to handle deleted `PayItem` records
   *
   * - when `true`, only return deleted records
   * - when `false`, do not return deleted records
   * - when omitted, `deleted` is ignored
   */
  deleted?: InputMaybe<Scalars['Boolean']>;
  description?: InputMaybe<StringFilter>;
  lastEditedDate?: InputMaybe<DateTimeFilter>;
  /**
   * how to order `PayItem` records
   *
   * executed in the order they are defined
   */
  orderBy?: InputMaybe<Array<OrderByInput>>;
  /**
   * paginate `PayItem` records
   *
   * using `paginate` may require multiple requests to get all possible results,
   * but will give more fine-grain control in the event all records cannot be
   * returned gracefully
   */
  paginate?: InputMaybe<PaginationInput>;
  payItemId?: InputMaybe<StringFilter>;
  projectId?: InputMaybe<StringFilter>;
  status?: InputMaybe<StringFilter>;
};

/** response metadata for a list query of PayItem records */
export type PayItemListResponse = {
  __typename: 'PayItemListResponse';
  /** the total count of PayItem records matching any configured filters */
  count: Scalars['Int'];
  /** the total count of paginated groups of PayItem */
  pages: Scalars['Int'];
  /** PayItem records */
  records: Array<PayItem>;
};

/**
 * ### `PayItem` vs `PayItemNoGeometry`
 *
 * throughout the schema there will be references to `PayItem` and `PayItemNoGeometry`
 *
 * as with most confusing things, the reason is legacy
 *
 * before the creation of this API, `PayItem` was the predominant object type used with
 * a mobile field application, and made use of geometry metadata
 *
 * at some point, the metadata was phased out and a new object type for `PayItemNoGeometry`
 * was created; as the name suggests, it doesn't have geometry metadata
 *
 * enter this API
 *
 * rather than take the time to write out `payItemNoGeometry` everywhere,
 * `payItem` was used as shorthand for everything since `PayItem` wasn't being used;
 * _this was shortsighted_
 *
 * because of course it would, `PayItem` was eventually added back with the desire
 * to start using geometry metadata again
 *
 * rather than take the time to go through and update _all_ the database columns to
 * match the correct object type, the understanding is, for most things, the referenced
 * `payItem` is a `PayItemNoGeometry`
 *
 * luckily, this schema will include the correct object type with the field name and has
 * been able make small changes to help clear things up in a big way
 */
export type PayItemNoGeometry = {
  __typename: 'PayItemNoGeometry';
  casToPayItemNoGeometries: Array<CasToPayItemNoGeometry>;
  /** the date this record was inserted into the database */
  createdDate: Maybe<Scalars['DateTime']>;
  /** the username or email address of a mobile app user associated with the `createdDate` */
  createdUser: Maybe<Scalars['String']>;
  deleted: Scalars['Boolean'];
  description: Maybe<Scalars['String']>;
  dsToPayItemNoGeometries: Array<DsToPayItemNoGeometry>;
  fdcToPayItemNoGeometries: Array<FdcToPayItemNoGeometry>;
  /** a GUID used to globally identify this record in the database */
  globalId: Scalars['String'];
  issueToPayItemNoGeometries: Array<IssueToPayItemNoGeometry>;
  /** Concatenates the `payItemId` and `description` together with a hyphen */
  label: Scalars['String'];
  /** the date this record was last updated in the database */
  lastEditedDate: Maybe<Scalars['DateTime']>;
  /** the username or email address of a mobile app user associated with the `lastEditedDate` */
  lastEditedUser: Maybe<Scalars['String']>;
  limsAsphaltLotToPayItemNoGeometry: Array<LimsAsphaltLotToPayItemNoGeometry>;
  material: Maybe<MaterialRequirement>;
  /** the `globalId` of a related `MaterialRequirement` */
  materialGuid: Maybe<Scalars['String']>;
  payItemId: Maybe<Scalars['String']>;
  payItems: Array<PayItem>;
  /** a related `Project` */
  project: Maybe<Project>;
  /** the `globalId` of a related `Project` */
  projectId: Maybe<Scalars['String']>;
  status: Maybe<Scalars['String']>;
};


/**
 * ### `PayItem` vs `PayItemNoGeometry`
 *
 * throughout the schema there will be references to `PayItem` and `PayItemNoGeometry`
 *
 * as with most confusing things, the reason is legacy
 *
 * before the creation of this API, `PayItem` was the predominant object type used with
 * a mobile field application, and made use of geometry metadata
 *
 * at some point, the metadata was phased out and a new object type for `PayItemNoGeometry`
 * was created; as the name suggests, it doesn't have geometry metadata
 *
 * enter this API
 *
 * rather than take the time to write out `payItemNoGeometry` everywhere,
 * `payItem` was used as shorthand for everything since `PayItem` wasn't being used;
 * _this was shortsighted_
 *
 * because of course it would, `PayItem` was eventually added back with the desire
 * to start using geometry metadata again
 *
 * rather than take the time to go through and update _all_ the database columns to
 * match the correct object type, the understanding is, for most things, the referenced
 * `payItem` is a `PayItemNoGeometry`
 *
 * luckily, this schema will include the correct object type with the field name and has
 * been able make small changes to help clear things up in a big way
 */
export type PayItemNoGeometryCasToPayItemNoGeometriesArgs = {
  casToPayItemNoGeometryFieldInput?: InputMaybe<CasToPayItemNoGeometryFieldInput>;
};


/**
 * ### `PayItem` vs `PayItemNoGeometry`
 *
 * throughout the schema there will be references to `PayItem` and `PayItemNoGeometry`
 *
 * as with most confusing things, the reason is legacy
 *
 * before the creation of this API, `PayItem` was the predominant object type used with
 * a mobile field application, and made use of geometry metadata
 *
 * at some point, the metadata was phased out and a new object type for `PayItemNoGeometry`
 * was created; as the name suggests, it doesn't have geometry metadata
 *
 * enter this API
 *
 * rather than take the time to write out `payItemNoGeometry` everywhere,
 * `payItem` was used as shorthand for everything since `PayItem` wasn't being used;
 * _this was shortsighted_
 *
 * because of course it would, `PayItem` was eventually added back with the desire
 * to start using geometry metadata again
 *
 * rather than take the time to go through and update _all_ the database columns to
 * match the correct object type, the understanding is, for most things, the referenced
 * `payItem` is a `PayItemNoGeometry`
 *
 * luckily, this schema will include the correct object type with the field name and has
 * been able make small changes to help clear things up in a big way
 */
export type PayItemNoGeometryDsToPayItemNoGeometriesArgs = {
  dSToPayItemNoGeometryFieldInput?: InputMaybe<DsToPayItemNoGeometryFieldInput>;
};


/**
 * ### `PayItem` vs `PayItemNoGeometry`
 *
 * throughout the schema there will be references to `PayItem` and `PayItemNoGeometry`
 *
 * as with most confusing things, the reason is legacy
 *
 * before the creation of this API, `PayItem` was the predominant object type used with
 * a mobile field application, and made use of geometry metadata
 *
 * at some point, the metadata was phased out and a new object type for `PayItemNoGeometry`
 * was created; as the name suggests, it doesn't have geometry metadata
 *
 * enter this API
 *
 * rather than take the time to write out `payItemNoGeometry` everywhere,
 * `payItem` was used as shorthand for everything since `PayItem` wasn't being used;
 * _this was shortsighted_
 *
 * because of course it would, `PayItem` was eventually added back with the desire
 * to start using geometry metadata again
 *
 * rather than take the time to go through and update _all_ the database columns to
 * match the correct object type, the understanding is, for most things, the referenced
 * `payItem` is a `PayItemNoGeometry`
 *
 * luckily, this schema will include the correct object type with the field name and has
 * been able make small changes to help clear things up in a big way
 */
export type PayItemNoGeometryFdcToPayItemNoGeometriesArgs = {
  fdcFieldInput?: InputMaybe<FdcToPayItemNoGeometryFieldInput>;
};


/**
 * ### `PayItem` vs `PayItemNoGeometry`
 *
 * throughout the schema there will be references to `PayItem` and `PayItemNoGeometry`
 *
 * as with most confusing things, the reason is legacy
 *
 * before the creation of this API, `PayItem` was the predominant object type used with
 * a mobile field application, and made use of geometry metadata
 *
 * at some point, the metadata was phased out and a new object type for `PayItemNoGeometry`
 * was created; as the name suggests, it doesn't have geometry metadata
 *
 * enter this API
 *
 * rather than take the time to write out `payItemNoGeometry` everywhere,
 * `payItem` was used as shorthand for everything since `PayItem` wasn't being used;
 * _this was shortsighted_
 *
 * because of course it would, `PayItem` was eventually added back with the desire
 * to start using geometry metadata again
 *
 * rather than take the time to go through and update _all_ the database columns to
 * match the correct object type, the understanding is, for most things, the referenced
 * `payItem` is a `PayItemNoGeometry`
 *
 * luckily, this schema will include the correct object type with the field name and has
 * been able make small changes to help clear things up in a big way
 */
export type PayItemNoGeometryIssueToPayItemNoGeometriesArgs = {
  issueToPayItemNoGeometryFieldInput?: InputMaybe<IssueToPayItemNoGeometryFieldInput>;
};


/**
 * ### `PayItem` vs `PayItemNoGeometry`
 *
 * throughout the schema there will be references to `PayItem` and `PayItemNoGeometry`
 *
 * as with most confusing things, the reason is legacy
 *
 * before the creation of this API, `PayItem` was the predominant object type used with
 * a mobile field application, and made use of geometry metadata
 *
 * at some point, the metadata was phased out and a new object type for `PayItemNoGeometry`
 * was created; as the name suggests, it doesn't have geometry metadata
 *
 * enter this API
 *
 * rather than take the time to write out `payItemNoGeometry` everywhere,
 * `payItem` was used as shorthand for everything since `PayItem` wasn't being used;
 * _this was shortsighted_
 *
 * because of course it would, `PayItem` was eventually added back with the desire
 * to start using geometry metadata again
 *
 * rather than take the time to go through and update _all_ the database columns to
 * match the correct object type, the understanding is, for most things, the referenced
 * `payItem` is a `PayItemNoGeometry`
 *
 * luckily, this schema will include the correct object type with the field name and has
 * been able make small changes to help clear things up in a big way
 */
export type PayItemNoGeometryLimsAsphaltLotToPayItemNoGeometryArgs = {
  limsAsphaltLotToPayItemNoGeometryFieldInput?: InputMaybe<LimsAsphaltLotToPayItemNoGeometryFieldInput>;
};


/**
 * ### `PayItem` vs `PayItemNoGeometry`
 *
 * throughout the schema there will be references to `PayItem` and `PayItemNoGeometry`
 *
 * as with most confusing things, the reason is legacy
 *
 * before the creation of this API, `PayItem` was the predominant object type used with
 * a mobile field application, and made use of geometry metadata
 *
 * at some point, the metadata was phased out and a new object type for `PayItemNoGeometry`
 * was created; as the name suggests, it doesn't have geometry metadata
 *
 * enter this API
 *
 * rather than take the time to write out `payItemNoGeometry` everywhere,
 * `payItem` was used as shorthand for everything since `PayItem` wasn't being used;
 * _this was shortsighted_
 *
 * because of course it would, `PayItem` was eventually added back with the desire
 * to start using geometry metadata again
 *
 * rather than take the time to go through and update _all_ the database columns to
 * match the correct object type, the understanding is, for most things, the referenced
 * `payItem` is a `PayItemNoGeometry`
 *
 * luckily, this schema will include the correct object type with the field name and has
 * been able make small changes to help clear things up in a big way
 */
export type PayItemNoGeometryPayItemsArgs = {
  payItemFieldInput?: InputMaybe<PayItemFieldInput>;
};

/**
 * helps filter multiple `PayItemNoGeometry` records
 *
 * this version of the input will have limited options compared to its other counterpart
 */
export type PayItemNoGeometryFieldInput = {
  createdDate?: InputMaybe<DateTimeFilter>;
  /**
   * determines now to handle deleted `PayItemNoGeometry` records
   *
   * - when `true`, only return deleted records
   * - when `false`, do not return deleted records
   * - when omitted, `deleted` is ignored
   */
  deleted?: InputMaybe<Scalars['Boolean']>;
  description?: InputMaybe<StringFilter>;
  lastEditedDate?: InputMaybe<DateTimeFilter>;
  /**
   * how to order `PayItemNoGeometry` records
   *
   * executed in the order they are defined
   */
  orderBy?: InputMaybe<Array<OrderByInput>>;
  payItemId?: InputMaybe<StringFilter>;
  projectId?: InputMaybe<StringFilter>;
  status?: InputMaybe<StringFilter>;
  /**
   * specifies how many records to return
   *
   * analogous to `limit`, `first`, or `top` in SQL dialects
   */
  take?: InputMaybe<Scalars['Int']>;
};

/** helps filter multiple `PayItemNoGeometry` records */
export type PayItemNoGeometryListInput = {
  createdDate?: InputMaybe<DateTimeFilter>;
  /**
   * determines now to handle deleted `PayItemNoGeometry` records
   *
   * - when `true`, only return deleted records
   * - when `false`, do not return deleted records
   * - when omitted, `deleted` is ignored
   */
  deleted?: InputMaybe<Scalars['Boolean']>;
  description?: InputMaybe<StringFilter>;
  lastEditedDate?: InputMaybe<DateTimeFilter>;
  /**
   * how to order `PayItemNoGeometry` records
   *
   * executed in the order they are defined
   */
  orderBy?: InputMaybe<Array<OrderByInput>>;
  /**
   * paginate `PayItemNoGeometry` records
   *
   * using `paginate` may require multiple requests to get all possible results,
   * but will give more fine-grain control in the event all records cannot be
   * returned gracefully
   */
  paginate?: InputMaybe<PaginationInput>;
  payItemId?: InputMaybe<StringFilter>;
  projectId?: InputMaybe<StringFilter>;
  status?: InputMaybe<StringFilter>;
};

/** response metadata for a list query of PayItemNoGeometry records */
export type PayItemNoGeometryListResponse = {
  __typename: 'PayItemNoGeometryListResponse';
  /** the total count of PayItemNoGeometry records matching any configured filters */
  count: Scalars['Int'];
  /** the total count of paginated groups of PayItemNoGeometry */
  pages: Scalars['Int'];
  /** PayItemNoGeometry records */
  records: Array<PayItemNoGeometry>;
};

export type PayItemSummaryCounts = {
  __typename: 'PayItemSummaryCounts';
  internalConnections: Array<InternalConnectionPayItemSummaryCount>;
  payItemConnections: Array<PayItemConnectionPayItemSummaryCount>;
};

export type PayItemSummaryCountsInput = {
  internalConnectionId?: InputMaybe<StringFilter>;
  payItemGlobalId?: InputMaybe<Scalars['String']>;
};

export type PhotoExportAverage = {
  __typename: 'PhotoExportAverage';
  /** the average time spent exporting any given media upload */
  milliseconds: Scalars['Float'];
  project: Project;
  projectId: Scalars['String'];
};

export type PhotoExportRequest = {
  __typename: 'PhotoExportRequest';
  /** the actual time it took to completely fulfill the request in milliseconds */
  actualMilliseconds: Maybe<Scalars['Int']>;
  /** `actualMilliseconds` formatted into a more human readable value */
  actualString: Maybe<Scalars['String']>;
  /** the date this record was inserted into the database */
  createdDate: Scalars['DateTime'];
  /**
   * the email address of a user associated with the `createdDate`
   *
   * this value will be `unknown` if the `createdDate` was not set by a user
   */
  createdUser: Scalars['String'];
  /**
   * the estimated time it will take to completely fulfill _this_ request in milliseconds
   *
   *   does not include the time it may have to wait to start
   */
  estimatedMilliseconds: Scalars['Int'];
  /** `estimatedMilliseconds` formatted into a more human readable value */
  estimatedString: Scalars['String'];
  /** a timestamp describing when the archive associated with this request is marked for deletion */
  expirationDate: Maybe<Scalars['DateTime']>;
  /** whether the request is expired and therefore considered deletable */
  expired: Scalars['Boolean'];
  /**
   * a timestamp describing when the request was finished
   *
   * if the request was cancelled, this value will not be set
   */
  finishedDate: Maybe<Scalars['DateTime']>;
  /** a UUID used to globally identify this record in the database */
  id: Scalars['String'];
  /** a JSON containing metadata associated with the request */
  json: PhotoExportRequestJson;
  /** the date this record was last updated in the database */
  lastEditedDate: Scalars['DateTime'];
  /**
   * the email address of a user associated with the `lastEditedDate`
   *
   * this value will be `system` if the `lastEditedDate` was not set by a user
   */
  lastEditedUser: Scalars['String'];
  project: Project;
  /** the `globalId` of a related `Project` */
  projectId: Scalars['String'];
  requestedBy: User;
  /** the `id` of a related `User` which requests the `QueuableEntity` */
  requestedById: Scalars['String'];
  /** a timestamp describing when the request was started */
  startedDate: Maybe<Scalars['DateTime']>;
  /** the `id` of a related `QueuableRequestStatus` */
  statusId: Scalars['String'];
};

export type PhotoExportRequestArgumentsJson = {
  __typename: 'PhotoExportRequestArgumentsJSON';
  createdDate: DateRange;
};

export type PhotoExportRequestError = {
  __typename: 'PhotoExportRequestError';
  asphaltLot: Maybe<AsphaltLot>;
  asphaltPlacement: Maybe<AsphaltPlacement>;
  concreteTestSet: Maybe<ConcreteTestSet>;
  dailyInspectionControlPoint: Maybe<DailyInspectionControlPoint>;
  dailyInspectionInspection: Maybe<DailyInspectionInspection>;
  dailyInspectionPunchList: Maybe<DailyInspectionPunchList>;
  featureId: Maybe<Scalars['String']>;
  globalId: Maybe<Scalars['String']>;
  lot: Maybe<Lot>;
  /** the message associated with the error */
  message: Scalars['String'];
  originalFileName: Maybe<Scalars['String']>;
  /** a stack trace that may have been included with the error */
  stack: Maybe<Scalars['String']>;
  tableName: Maybe<Scalars['String']>;
};

/**
 * helps filter multiple `PhotoExportRequest` records
 *
 * this version of the input will have limited options compared to its other counterpart
 */
export type PhotoExportRequestFieldInput = {
  actualMilliseconds?: InputMaybe<IntFilter>;
  createdDate?: InputMaybe<DateTimeFilter>;
  /**
   * - when `true`, only include records with errors
   * - when `false`, exclude any record with errors
   * - when omitted, `errored` is ignored
   */
  errored?: InputMaybe<Scalars['Boolean']>;
  estimatedMilliseconds?: InputMaybe<IntFilter>;
  finishedDate?: InputMaybe<DateTimeFilter>;
  lastEditedDate?: InputMaybe<DateTimeFilter>;
  /**
   * how to order `PhotoExportRequest` records
   *
   * executed in the order they are defined
   */
  orderBy?: InputMaybe<Array<OrderByInput>>;
  projectId?: InputMaybe<StringFilter>;
  requestedById?: InputMaybe<StringFilter>;
  startedDate?: InputMaybe<DateTimeFilter>;
  statusId?: InputMaybe<StringFilter>;
  /**
   * specifies how many records to return
   *
   * analogous to `limit`, `first`, or `top` in SQL dialects
   */
  take?: InputMaybe<Scalars['Int']>;
};

export type PhotoExportRequestJson = {
  __typename: 'PhotoExportRequestJSON';
  arguments: PhotoExportRequestArgumentsJson;
  errors: Array<PhotoExportRequestError>;
};

/** helps filter multiple `PhotoExportRequest` records */
export type PhotoExportRequestListInput = {
  actualMilliseconds?: InputMaybe<IntFilter>;
  createdDate?: InputMaybe<DateTimeFilter>;
  /**
   * - when `true`, only include records with errors
   * - when `false`, exclude any record with errors
   * - when omitted, `errored` is ignored
   */
  errored?: InputMaybe<Scalars['Boolean']>;
  estimatedMilliseconds?: InputMaybe<IntFilter>;
  finishedDate?: InputMaybe<DateTimeFilter>;
  lastEditedDate?: InputMaybe<DateTimeFilter>;
  /**
   * how to order `PhotoExportRequest` records
   *
   * executed in the order they are defined
   */
  orderBy?: InputMaybe<Array<OrderByInput>>;
  /**
   * paginate `PhotoExportRequest` records
   *
   * using `paginate` may require multiple requests to get all possible results,
   * but will give more fine-grain control in the event all records cannot be
   * returned gracefully
   */
  paginate?: InputMaybe<PaginationInput>;
  projectId?: InputMaybe<StringFilter>;
  requestedById?: InputMaybe<StringFilter>;
  startedDate?: InputMaybe<DateTimeFilter>;
  statusId?: InputMaybe<StringFilter>;
};

/** response metadata for a list query of PhotoExportRequest records */
export type PhotoExportRequestListResponse = {
  __typename: 'PhotoExportRequestListResponse';
  /** the total count of PhotoExportRequest records matching any configured filters */
  count: Scalars['Int'];
  /** the total count of paginated groups of PhotoExportRequest */
  pages: Scalars['Int'];
  /** PhotoExportRequest records */
  records: Array<PhotoExportRequest>;
};

export type PhotoFilename = {
  __typename: 'PhotoFilename';
  classType: Scalars['String'];
  classTypeId: Scalars['String'];
  /** the date this record was inserted into the database */
  createdDate: Scalars['DateTime'];
  /**
   * the email address of a user associated with the `createdDate`
   *
   * this value will be `unknown` if the `createdDate` was not set by a user
   */
  createdUser: Scalars['String'];
  /** the date this record was last updated in the database */
  lastEditedDate: Scalars['DateTime'];
  /**
   * the email address of a user associated with the `lastEditedDate`
   *
   * this value will be `system` if the `lastEditedDate` was not set by a user
   */
  lastEditedUser: Scalars['String'];
  /** a related `Project` */
  project: Project;
  /** the `globalId` of a related `Project` */
  projectId: Scalars['String'];
  templateItems: Maybe<Array<FilenameTemplateItem>>;
};

export type PhotoFilenameExampleInput = {
  classTypeId: Scalars['String'];
  projectId: Scalars['String'];
  templateItems?: InputMaybe<Array<EditFilenameTemplateItemInput>>;
};

/**
 * helps filter multiple `PhotoFilename` records
 *
 * this version of the input will have limited options compared to its other counterpart
 */
export type PhotoFilenameFieldInput = {
  classTypeId?: InputMaybe<StringFilter>;
  createdDate?: InputMaybe<DateTimeFilter>;
  lastEditedDate?: InputMaybe<DateTimeFilter>;
  /**
   * how to order `PhotoFilename` records
   *
   * executed in the order they are defined
   */
  orderBy?: InputMaybe<Array<OrderByInput>>;
  projectId?: InputMaybe<StringFilter>;
  /**
   * specifies how many records to return
   *
   * analogous to `limit`, `first`, or `top` in SQL dialects
   */
  take?: InputMaybe<Scalars['Int']>;
};

/** helps filter multiple `PhotoFilename` records */
export type PhotoFilenameListInput = {
  classTypeId?: InputMaybe<StringFilter>;
  createdDate?: InputMaybe<DateTimeFilter>;
  lastEditedDate?: InputMaybe<DateTimeFilter>;
  /**
   * how to order `PhotoFilename` records
   *
   * executed in the order they are defined
   */
  orderBy?: InputMaybe<Array<OrderByInput>>;
  /**
   * paginate `PhotoFilename` records
   *
   * using `paginate` may require multiple requests to get all possible results,
   * but will give more fine-grain control in the event all records cannot be
   * returned gracefully
   */
  paginate?: InputMaybe<PaginationInput>;
  projectId?: InputMaybe<StringFilter>;
};

/** response metadata for a list query of PhotoFilename records */
export type PhotoFilenameListResponse = {
  __typename: 'PhotoFilenameListResponse';
  /** the total count of PhotoFilename records matching any configured filters */
  count: Scalars['Int'];
  /** the total count of paginated groups of PhotoFilename */
  pages: Scalars['Int'];
  /** PhotoFilename records */
  records: Array<PhotoFilename>;
};

export type PhotoFilenameTemplateInput = {
  classTypeId: Scalars['String'];
  projectId: Scalars['String'];
};

export type Proctor = {
  __typename: 'Proctor';
  active: Scalars['Boolean'];
  comments: Maybe<Scalars['String']>;
  /** the date this record was inserted into the database */
  createdDate: Maybe<Scalars['DateTime']>;
  /** the username or email address of a mobile app user associated with the `createdDate` */
  createdUser: Maybe<Scalars['String']>;
  deleted: Scalars['Boolean'];
  densityTests: Array<DensityTest>;
  dryDensity: Maybe<Scalars['Float']>;
  /** a GUID used to globally identify this record in the database */
  globalId: Scalars['String'];
  globalT99OrT180: Maybe<Scalars['String']>;
  gradationLink: Maybe<Scalars['String']>;
  /** the date this record was last updated in the database */
  lastEditedDate: Maybe<Scalars['DateTime']>;
  /** the username or email address of a mobile app user associated with the `lastEditedDate` */
  lastEditedUser: Maybe<Scalars['String']>;
  location: Maybe<Scalars['String']>;
  lots: Array<Lot>;
  /** the `globalId` of a related `MaterialRequirement` */
  materialGuid: Maybe<Scalars['String']>;
  materialSource: Maybe<MaterialSource>;
  /** the `globalId` of a related `MaterialSource` */
  materialSourceGuid: Maybe<Scalars['String']>;
  materials: Array<MaterialRequirement>;
  /** A string of comma-separated Material Requirements globalIds */
  multipleMaterialGuids: Maybe<Scalars['String']>;
  optimumMoisture: Maybe<Scalars['Float']>;
  proctorId: Maybe<Scalars['String']>;
  proctorLink: Maybe<Scalars['String']>;
  /** a related `Project` */
  project: Maybe<Project>;
  /** the `globalId` of a related `Project` */
  projectId: Maybe<Scalars['String']>;
  sampleDate: Maybe<Scalars['DateTime']>;
  value: Maybe<Scalars['Float']>;
};


export type ProctorDensityTestsArgs = {
  densityTestFieldInput?: InputMaybe<DensityTestFieldInput>;
};


export type ProctorLotsArgs = {
  lotFieldInput?: InputMaybe<LotFieldInput>;
};


export type ProctorMaterialsArgs = {
  materialRequirementFieldInput?: InputMaybe<MaterialRequirementFieldInput>;
};

/**
 * helps filter multiple `Proctor` records
 *
 * this version of the input will have limited options compared to its other counterpart
 */
export type ProctorFieldInput = {
  createdDate?: InputMaybe<DateTimeFilter>;
  /**
   * determines now to handle deleted `Proctor` records
   *
   * - when `true`, only return deleted records
   * - when `false`, do not return deleted records
   * - when omitted, `deleted` is ignored
   */
  deleted?: InputMaybe<Scalars['Boolean']>;
  lastEditedDate?: InputMaybe<DateTimeFilter>;
  /**
   * how to order `Proctor` records
   *
   * executed in the order they are defined
   */
  orderBy?: InputMaybe<Array<OrderByInput>>;
  proctorId?: InputMaybe<StringFilter>;
  projectId?: InputMaybe<StringFilter>;
  /**
   * specifies how many records to return
   *
   * analogous to `limit`, `first`, or `top` in SQL dialects
   */
  take?: InputMaybe<Scalars['Int']>;
};

/** helps filter multiple `Proctor` records */
export type ProctorListInput = {
  createdDate?: InputMaybe<DateTimeFilter>;
  /**
   * determines now to handle deleted `Proctor` records
   *
   * - when `true`, only return deleted records
   * - when `false`, do not return deleted records
   * - when omitted, `deleted` is ignored
   */
  deleted?: InputMaybe<Scalars['Boolean']>;
  lastEditedDate?: InputMaybe<DateTimeFilter>;
  /**
   * how to order `Proctor` records
   *
   * executed in the order they are defined
   */
  orderBy?: InputMaybe<Array<OrderByInput>>;
  /**
   * paginate `Proctor` records
   *
   * using `paginate` may require multiple requests to get all possible results,
   * but will give more fine-grain control in the event all records cannot be
   * returned gracefully
   */
  paginate?: InputMaybe<PaginationInput>;
  proctorId?: InputMaybe<StringFilter>;
  projectId?: InputMaybe<StringFilter>;
};

/** response metadata for a list query of Proctor records */
export type ProctorListResponse = {
  __typename: 'ProctorListResponse';
  /** the total count of Proctor records matching any configured filters */
  count: Scalars['Int'];
  /** the total count of paginated groups of Proctor */
  pages: Scalars['Int'];
  /** Proctor records */
  records: Array<Proctor>;
};

export type Project = {
  __typename: 'Project';
  active: Maybe<Scalars['String']>;
  adminEmail: Maybe<Scalars['String']>;
  alignments: Array<Alignment>;
  /** `applicationNamesGuid` is unreliable, a misnomer, every record contains `null` values, or its purpose is generally unknown */
  applicationNamesGuid: Maybe<Scalars['String']>;
  asphaltCoreMeasurements: Array<AsphaltCoreMeasurement>;
  asphaltLots: Array<AsphaltLot>;
  asphaltMaterialSources: Array<AsphaltMaterialSource>;
  asphaltMaterials: Array<AsphaltMaterial>;
  asphaltMixDesigns: Array<AsphaltMixDesign>;
  asphaltPlacementJoints: Array<AsphaltPlacementJoint>;
  asphaltPlacements: Array<AsphaltPlacement>;
  asphaltSamples: Array<AsphaltSample>;
  batchReportRequests: Array<BatchReportRequest>;
  casDispositionTypes: Array<CasDispositionType>;
  casNotifications: Array<CasNotification>;
  casQuickLinks: Array<CasQuickLink>;
  casRoutingGroups: Array<CasRoutingGroup>;
  casSubtypes: Array<CasSubtype>;
  casTypes: Array<CasType>;
  cidNumber: Maybe<Scalars['String']>;
  clientProjectName: Maybe<Scalars['String']>;
  clientProjectNumber: Maybe<Scalars['String']>;
  concreteCoreMeasurements: Array<ConcreteCoreMeasurement>;
  concreteCuringMethods: Array<ConcreteCuringMethod>;
  concreteCylindersAssignURL: Maybe<Scalars['String']>;
  concreteFieldDatas: Array<ConcreteFieldData>;
  concreteMaterials: Array<ConcreteMaterial>;
  concreteMixDesigns: Array<ConcreteMixDesign>;
  concreteNotifications: Array<ConcreteNotification>;
  concretePlacements: Array<ConcretePlacement>;
  concreteProductionDatas: Array<ConcreteProductionData>;
  concreteSampleLocations: Array<ConcreteSampleLocation>;
  concreteTestIFISettings: Maybe<ConcreteTestIfiSettings>;
  /**
   * @deprecated this field has been deprecated and expires once all projects previously using this field have been archived.
   *
   * it may be removed at any time after expiration, but not before
   *
   * `ConcreteTestSetPlacement` was created to connect a `ConcreteTest`
   * and `ConcretePlacement` in older versions of the Field App
   *
   * `ConcreteTestSet` now fulfills that roll, while also holding its own metadata
   *
   * `ConcreteTestSetPlacement` will be removed when all projects on older versions
   * of the Field App upgrade to a newer version of the Field App, or finish
   */
  concreteTestSetPlacements: Array<ConcreteTestSetPlacement>;
  concreteTestSets: Array<ConcreteTestSet>;
  concreteTests: Array<ConcreteTest>;
  constructionAdminSubmittals: Array<ConstructionAdminSubmittal>;
  contractors: Array<Contractor>;
  /** the date this record was inserted into the database */
  createdDate: Maybe<Scalars['DateTime']>;
  /** the username or email address of a mobile app user associated with the `createdDate` */
  createdUser: Maybe<Scalars['String']>;
  customFields: Array<CustomField>;
  dailyInspectionControlPointIFISettings: Maybe<DailyInspectionControlPointIfiSettings>;
  dailyInspectionControlPoints: Array<DailyInspectionControlPoint>;
  dailyInspectionFeatureEngineeringJudgements: Array<DailyInspectionFeatureEngineeringJudgement>;
  dailyInspectionForms: Array<DailyInspectionForm>;
  dailyInspectionInspectionIFISettings: Maybe<DailyInspectionInspectionIfiSettings>;
  dailyInspectionInspections: Array<DailyInspectionInspection>;
  dailyInspectionLookUps: Array<DailyInspectionLookUp>;
  dailyInspectionPunchListIFISettings: Maybe<DailyInspectionPunchListIfiSettings>;
  dailyInspectionPunchLists: Array<DailyInspectionPunchList>;
  dailyInspectionWorkTypes: Array<DailyInspectionWorkType>;
  deleted: Maybe<Scalars['String']>;
  densityTestIFISettings: Maybe<DensityTestIfiSettings>;
  densityTests: Array<DensityTest>;
  designSubmittals: Array<DesignSubmittal>;
  documentChecklistItems: Array<DocumentChecklistItem>;
  dsActions: Array<DsAction>;
  dsDisciplines: Array<DsDiscipline>;
  dsNotifications: Array<DsNotification>;
  dsOrganizations: Array<DsOrganization>;
  dsQuickLinks: Array<DsQuickLink>;
  dsTypes: Array<DsType>;
  ejNotifications: Array<EjNotification>;
  ejQuickLinks: Array<EjQuickLink>;
  ejTypes: Array<EjType>;
  engineeringJudgements: Array<EngineeringJudgement>;
  fdcApprovalGroups: Array<FdcApprovalGroup>;
  fdcConcurrenceGroups: Array<FdcConcurrenceGroup>;
  fdcConcurrenceLevels: Array<FdcConcurrenceLevel>;
  fdcDisciplines: Array<FdcDiscipline>;
  fdcNotifications: Array<FdcNotification>;
  fdcQuickLinks: Array<FdcQuickLink>;
  fieldDesignChanges: Array<FieldDesignChange>;
  genericPlacements: Array<GenericPlacement>;
  /** a GUID used to globally identify this record in the database */
  globalId: Scalars['String'];
  heProjectNumber: Maybe<Scalars['String']>;
  ifiNotifications: Array<IfiNotification>;
  issueDispositionTypes: Array<IssueDispositionType>;
  issueNotifications: Array<IssueNotification>;
  issueQuickLinks: Array<IssueQuickLink>;
  issueTypes: Array<IssueType>;
  issues: Array<Issue>;
  labTechs: Array<LabTech>;
  /** the date this record was last updated in the database */
  lastEditedDate: Maybe<Scalars['DateTime']>;
  /** the username or email address of a mobile app user associated with the `lastEditedDate` */
  lastEditedUser: Maybe<Scalars['String']>;
  limsAsphaltLots: Array<LimsAsphaltLot>;
  limsAsphaltMixDesignTargets: Array<LimsAsphaltMixDesignTarget>;
  lotIFISettings: Maybe<LotIfiSettings>;
  lots: Array<Lot>;
  materialRequirements: Array<MaterialRequirement>;
  materialSources: Array<MaterialSource>;
  materialTypes: Array<MaterialType>;
  mediaUploads: Array<MediaUpload>;
  nonUserEmails: Array<NonUserEmail>;
  notes: Maybe<Scalars['String']>;
  offlineUrlMMPK: Maybe<Scalars['String']>;
  offlineUrlTPKX: Maybe<Scalars['String']>;
  orgNumber: Maybe<Scalars['Float']>;
  payItemConnectionGroups: Array<PayItemConnectionGroup>;
  payItemConnections: Array<PayItemConnection>;
  payItemGroups: Array<PayItemGroup>;
  payItemNoGeometries: Array<PayItemNoGeometry>;
  payItemSummaryCounts: Maybe<PayItemSummaryCounts>;
  payItems: Array<PayItem>;
  pdfDesignLayers: Array<PdfDesignLayer>;
  photoExportRequests: Array<PhotoExportRequest>;
  photoFilenames: Array<PhotoFilename>;
  /**
   * `primeContractorGuid` is unreliable, a misnomer, every record contains `null` values, or its purpose is generally unknown
   *
   * use `primeContractorName` instead
   */
  primeContractorGuid: Maybe<Scalars['String']>;
  primeContractorName: Maybe<Scalars['String']>;
  proctors: Array<Proctor>;
  projectCloseDate: Maybe<Scalars['DateTime']>;
  projectMetadata: Maybe<ProjectMetadata>;
  projectName: Maybe<Scalars['String']>;
  projectOpenDate: Maybe<Scalars['DateTime']>;
  projectStatus: Maybe<Scalars['String']>;
  projectToCIMSOnlineAdmins: Array<ProjectToCimsOnlineAdmin>;
  projectToIFIReportTypes: Array<ProjectToIfiReportType>;
  projectToInternalConnections: Array<ProjectToInternalConnection>;
  projectToUserGroups: Array<ProjectToUserGroup>;
  qaSignerPin: Maybe<Scalars['String']>;
  reading1s: Array<Reading1>;
  reportFilenames: Array<ReportFilename>;
  reportToTags: Array<ReportToTag>;
  requestsForInformation: Array<RequestForInformation>;
  residentEngineer: Maybe<Scalars['String']>;
  rfiNotifications: Array<RfiNotification>;
  rfiOrganizations: Array<RfiOrganization>;
  rfiQuickLinks: Array<RfiQuickLink>;
  rfiResponseDisciplines: Array<RfiResponseDiscipline>;
  roles: Array<Role>;
  sharePointDrives: Array<SharePointDrive>;
  spatial: Maybe<Scalars['String']>;
  structureTypes: Array<StructureType>;
  structures: Array<Structure>;
  tagCategories: Array<TagCategory>;
  tagToTagCategories: Array<TagToTagCategory>;
  tags: Array<Tag>;
  technicians: Array<Technician>;
  testingLabs: Array<TestingLab>;
  timeZone: Maybe<Scalars['String']>;
  userToProjectToPermissions: Array<UserToProjectToPermission>;
  /**
   * queries the database for `User` records associated with the `Project`
   * through `Project.userGroups`
   */
  users: Array<User>;
};


export type ProjectAlignmentsArgs = {
  alignmentFieldInput?: InputMaybe<AlignmentFieldInput>;
};


export type ProjectAsphaltCoreMeasurementsArgs = {
  asphaltCoreMeasurementFieldInput?: InputMaybe<AsphaltCoreMeasurementFieldInput>;
};


export type ProjectAsphaltLotsArgs = {
  asphaltLotFieldInput?: InputMaybe<AsphaltLotFieldInput>;
};


export type ProjectAsphaltMaterialSourcesArgs = {
  asphaltMaterialSourceFieldInput?: InputMaybe<AsphaltMaterialSourceFieldInput>;
};


export type ProjectAsphaltMaterialsArgs = {
  asphaltMaterialFieldInput?: InputMaybe<AsphaltMaterialFieldInput>;
};


export type ProjectAsphaltMixDesignsArgs = {
  asphaltMixDesignFieldInput?: InputMaybe<AsphaltMixDesignFieldInput>;
};


export type ProjectAsphaltPlacementJointsArgs = {
  asphaltPlacementJointFieldInput?: InputMaybe<AsphaltPlacementJointFieldInput>;
};


export type ProjectAsphaltPlacementsArgs = {
  asphaltPlacementFieldInput?: InputMaybe<AsphaltPlacementFieldInput>;
};


export type ProjectAsphaltSamplesArgs = {
  asphaltSampleFieldInput?: InputMaybe<AsphaltSampleFieldInput>;
};


export type ProjectBatchReportRequestsArgs = {
  batchReportRequestFieldInput?: InputMaybe<BatchReportRequestFieldInput>;
};


export type ProjectCasDispositionTypesArgs = {
  casDispositionTypeFieldInput?: InputMaybe<CasDispositionTypeFieldInput>;
};


export type ProjectCasNotificationsArgs = {
  casNotificationFieldInput?: InputMaybe<CasNotificationFieldInput>;
};


export type ProjectCasQuickLinksArgs = {
  casQuickLinkFieldInput?: InputMaybe<CasQuickLinkFieldInput>;
};


export type ProjectCasRoutingGroupsArgs = {
  casRoutingGroupFieldInput?: InputMaybe<CasRoutingGroupFieldInput>;
};


export type ProjectCasSubtypesArgs = {
  casSubtypeFieldInput?: InputMaybe<CasSubtypeFieldInput>;
};


export type ProjectCasTypesArgs = {
  casTypeFieldInput?: InputMaybe<CasTypeFieldInput>;
};


export type ProjectConcreteCoreMeasurementsArgs = {
  concreteCoreMeasurementFieldInput?: InputMaybe<ConcreteCoreMeasurementFieldInput>;
};


export type ProjectConcreteCuringMethodsArgs = {
  concreteCuringMethodFieldInput?: InputMaybe<ConcreteCuringMethodFieldInput>;
};


export type ProjectConcreteFieldDatasArgs = {
  concreteFieldDataFieldInput?: InputMaybe<ConcreteFieldDataFieldInput>;
};


export type ProjectConcreteMaterialsArgs = {
  concreteMaterialFieldInput?: InputMaybe<ConcreteMaterialFieldInput>;
};


export type ProjectConcreteMixDesignsArgs = {
  concreteMixDesignFieldInput?: InputMaybe<ConcreteMixDesignFieldInput>;
};


export type ProjectConcreteNotificationsArgs = {
  concreteNotificationFieldInput?: InputMaybe<ConcreteNotificationFieldInput>;
};


export type ProjectConcretePlacementsArgs = {
  concretePlacementFieldInput?: InputMaybe<ConcretePlacementFieldInput>;
};


export type ProjectConcreteProductionDatasArgs = {
  concreteProductionDataFieldInput?: InputMaybe<ConcreteProductionDataFieldInput>;
};


export type ProjectConcreteSampleLocationsArgs = {
  concreteSampleLocationFieldInput?: InputMaybe<ConcreteSampleLocationFieldInput>;
};


export type ProjectConcreteTestSetsArgs = {
  concreteTestSetFieldInput?: InputMaybe<ConcreteTestSetFieldInput>;
};


export type ProjectConcreteTestsArgs = {
  concreteTestFieldInput?: InputMaybe<ConcreteTestFieldInput>;
};


export type ProjectConstructionAdminSubmittalsArgs = {
  constructionAdminSubmittalFieldInput?: InputMaybe<ConstructionAdminSubmittalFieldInput>;
};


export type ProjectContractorsArgs = {
  contractorFieldInput?: InputMaybe<ContractorFieldInput>;
};


export type ProjectCustomFieldsArgs = {
  customFieldFieldInput?: InputMaybe<CustomFieldFieldInput>;
};


export type ProjectDailyInspectionControlPointsArgs = {
  dailyInspectionControlPointFieldInput?: InputMaybe<DailyInspectionControlPointFieldInput>;
};


export type ProjectDailyInspectionFeatureEngineeringJudgementsArgs = {
  dailyInspectionFeatureEngineeringJudgementFieldInput?: InputMaybe<DailyInspectionFeatureEngineeringJudgementFieldInput>;
};


export type ProjectDailyInspectionFormsArgs = {
  dailyInspectionFormFieldInput?: InputMaybe<DailyInspectionFormFieldInput>;
};


export type ProjectDailyInspectionInspectionsArgs = {
  dailyInspectionInspectionFieldInput?: InputMaybe<DailyInspectionInspectionFieldInput>;
};


export type ProjectDailyInspectionLookUpsArgs = {
  dailyInspectionLookUpFieldInput?: InputMaybe<DailyInspectionLookUpFieldInput>;
};


export type ProjectDailyInspectionPunchListsArgs = {
  dailyInspectionPunchListFieldInput?: InputMaybe<DailyInspectionPunchListFieldInput>;
};


export type ProjectDailyInspectionWorkTypesArgs = {
  dailyInspectionWorkTypeFieldInput?: InputMaybe<DailyInspectionWorkTypeFieldInput>;
};


export type ProjectDensityTestsArgs = {
  densityTestFieldInput?: InputMaybe<DensityTestFieldInput>;
};


export type ProjectDesignSubmittalsArgs = {
  designSubmittalFieldInput?: InputMaybe<DesignSubmittalFieldInput>;
};


export type ProjectDocumentChecklistItemsArgs = {
  documentChecklistItemFieldInput?: InputMaybe<DocumentChecklistItemFieldInput>;
};


export type ProjectDsActionsArgs = {
  dsActionFieldInput?: InputMaybe<DsActionFieldInput>;
};


export type ProjectDsDisciplinesArgs = {
  dsDisciplineFieldInput?: InputMaybe<DsDisciplineFieldInput>;
};


export type ProjectDsNotificationsArgs = {
  dsNotificationFieldInput?: InputMaybe<DsNotificationFieldInput>;
};


export type ProjectDsOrganizationsArgs = {
  dSOrganizationFieldInput?: InputMaybe<DsOrganizationFieldInput>;
};


export type ProjectDsQuickLinksArgs = {
  dsQuickLinkFieldInput?: InputMaybe<DsQuickLinkFieldInput>;
};


export type ProjectDsTypesArgs = {
  dsTypeFieldInput?: InputMaybe<DsTypeFieldInput>;
};


export type ProjectEjNotificationsArgs = {
  ejNotificationFieldInput?: InputMaybe<EjNotificationFieldInput>;
};


export type ProjectEjQuickLinksArgs = {
  eJQuickLinkFieldInput?: InputMaybe<EjQuickLinkFieldInput>;
};


export type ProjectEjTypesArgs = {
  ejTypeFieldInput?: InputMaybe<EjTypeFieldInput>;
};


export type ProjectEngineeringJudgementsArgs = {
  engineeringJudgementFieldInput?: InputMaybe<EngineeringJudgementFieldInput>;
};


export type ProjectFdcApprovalGroupsArgs = {
  fdcApprovalGroupFieldInput?: InputMaybe<FdcApprovalGroupFieldInput>;
};


export type ProjectFdcConcurrenceGroupsArgs = {
  fdcConcurrenceGroupFieldInput?: InputMaybe<FdcConcurrenceGroupFieldInput>;
};


export type ProjectFdcConcurrenceLevelsArgs = {
  fdcConcurrenceLevelFieldInput?: InputMaybe<FdcConcurrenceLevelFieldInput>;
};


export type ProjectFdcDisciplinesArgs = {
  fdcDisciplineFieldInput?: InputMaybe<FdcDisciplineFieldInput>;
};


export type ProjectFdcNotificationsArgs = {
  fdcNotificationFieldInput?: InputMaybe<FdcNotificationFieldInput>;
};


export type ProjectFdcQuickLinksArgs = {
  fdcQuickLinkFieldInput?: InputMaybe<FdcQuickLinkFieldInput>;
};


export type ProjectFieldDesignChangesArgs = {
  fieldDesignChangeFieldInput?: InputMaybe<FieldDesignChangeFieldInput>;
};


export type ProjectGenericPlacementsArgs = {
  genericPlacementFieldInput?: InputMaybe<GenericPlacementFieldInput>;
};


export type ProjectIfiNotificationsArgs = {
  ifiNotificationFieldInput?: InputMaybe<IfiNotificationFieldInput>;
};


export type ProjectIssueDispositionTypesArgs = {
  issueDispositionTypeFieldInput?: InputMaybe<IssueDispositionTypeFieldInput>;
};


export type ProjectIssueNotificationsArgs = {
  issueNotificationFieldInput?: InputMaybe<IssueNotificationFieldInput>;
};


export type ProjectIssueQuickLinksArgs = {
  issueQuickLinkFieldInput?: InputMaybe<IssueQuickLinkFieldInput>;
};


export type ProjectIssueTypesArgs = {
  issueTypeFieldInput?: InputMaybe<IssueTypeFieldInput>;
};


export type ProjectIssuesArgs = {
  issueFieldInput?: InputMaybe<IssueFieldInput>;
};


export type ProjectLabTechsArgs = {
  labTechFieldInput?: InputMaybe<LabTechFieldInput>;
};


export type ProjectLimsAsphaltLotsArgs = {
  limsAsphaltLotFieldInput?: InputMaybe<LimsAsphaltLotFieldInput>;
};


export type ProjectLimsAsphaltMixDesignTargetsArgs = {
  limsAsphaltMixDesignTargetFieldInput?: InputMaybe<AsphaltMixDesignFieldInput>;
};


export type ProjectLotsArgs = {
  lotFieldInput?: InputMaybe<LotFieldInput>;
};


export type ProjectMaterialRequirementsArgs = {
  materialRequirementFieldInput?: InputMaybe<MaterialRequirementFieldInput>;
};


export type ProjectMaterialSourcesArgs = {
  materialSourceFieldInput?: InputMaybe<MaterialSourceFieldInput>;
};


export type ProjectMaterialTypesArgs = {
  materialTypeFieldInput?: InputMaybe<MaterialTypeFieldInput>;
};


export type ProjectMediaUploadsArgs = {
  mediaUploadFieldInput?: InputMaybe<MediaUploadFieldInput>;
};


export type ProjectNonUserEmailsArgs = {
  nonUserEmailFieldInput?: InputMaybe<NonUserEmailFieldInput>;
};


export type ProjectPayItemConnectionGroupsArgs = {
  payItemConnectionGroupFieldInput?: InputMaybe<PayItemConnectionGroupFieldInput>;
};


export type ProjectPayItemConnectionsArgs = {
  payItemConnectionFieldInput?: InputMaybe<PayItemConnectionFieldInput>;
};


export type ProjectPayItemGroupsArgs = {
  payItemGroupFieldInput?: InputMaybe<PayItemGroupFieldInput>;
};


export type ProjectPayItemNoGeometriesArgs = {
  payItemNoGeometryFieldInput?: InputMaybe<PayItemNoGeometryFieldInput>;
};


export type ProjectPayItemSummaryCountsArgs = {
  payItemSummaryCountsInput: PayItemSummaryCountsInput;
};


export type ProjectPayItemsArgs = {
  payItemFieldInput?: InputMaybe<PayItemFieldInput>;
};


export type ProjectPdfDesignLayersArgs = {
  pdfDesignLayerFieldInput?: InputMaybe<PdfDesignLayerFieldInput>;
};


export type ProjectPhotoExportRequestsArgs = {
  photoExportRequestsFieldInput?: InputMaybe<PhotoExportRequestFieldInput>;
};


export type ProjectPhotoFilenamesArgs = {
  photoFilenameFieldInput?: InputMaybe<PhotoFilenameFieldInput>;
};


export type ProjectProctorsArgs = {
  proctorFieldInput?: InputMaybe<ProctorFieldInput>;
};


export type ProjectProjectToCimsOnlineAdminsArgs = {
  projectToCIMSOnlineAdminFieldInput?: InputMaybe<ProjectToCimsOnlineAdminFieldInput>;
};


export type ProjectProjectToIfiReportTypesArgs = {
  projectToIFIReportTypeFieldInput?: InputMaybe<ProjectToIfiReportTypeFieldInput>;
};


export type ProjectProjectToInternalConnectionsArgs = {
  projectToInternalConnectionFieldInput?: InputMaybe<ProjectToInternalConnectionFieldInput>;
};


export type ProjectProjectToUserGroupsArgs = {
  projectToUserGroupFieldInput?: InputMaybe<ProjectToUserGroupFieldInput>;
};


export type ProjectReading1sArgs = {
  reading1FieldInput?: InputMaybe<Reading1FieldInput>;
};


export type ProjectReportFilenamesArgs = {
  reportFilenameFieldInput?: InputMaybe<ReportFilenameFieldInput>;
};


export type ProjectReportToTagsArgs = {
  reportToTagFieldInput?: InputMaybe<ReportToTagFieldInput>;
};


export type ProjectRequestsForInformationArgs = {
  requestForInformationFieldInput?: InputMaybe<RequestForInformationFieldInput>;
};


export type ProjectRfiNotificationsArgs = {
  rfiNotificationFieldInput?: InputMaybe<RfiNotificationFieldInput>;
};


export type ProjectRfiOrganizationsArgs = {
  rfiOrganizationFieldInput?: InputMaybe<RfiOrganizationFieldInput>;
};


export type ProjectRfiQuickLinksArgs = {
  rfiQuickLinkFieldInput?: InputMaybe<RfiQuickLinkFieldInput>;
};


export type ProjectRfiResponseDisciplinesArgs = {
  rfiResponseDisciplineFieldInput?: InputMaybe<RfiResponseDisciplineFieldInput>;
};


export type ProjectRolesArgs = {
  roleFieldInput?: InputMaybe<RoleFieldInput>;
};


export type ProjectStructureTypesArgs = {
  structureTypeFieldInput?: InputMaybe<StructureTypeFieldInput>;
};


export type ProjectStructuresArgs = {
  structureFieldInput?: InputMaybe<StructureFieldInput>;
};


export type ProjectTagCategoriesArgs = {
  tagCategoryFieldInput?: InputMaybe<TagCategoryFieldInput>;
};


export type ProjectTagToTagCategoriesArgs = {
  tagToTagCategoryFieldInput?: InputMaybe<TagToTagCategoryFieldInput>;
};


export type ProjectTagsArgs = {
  tagFieldInput?: InputMaybe<TagFieldInput>;
};


export type ProjectTechniciansArgs = {
  technicianFieldInput?: InputMaybe<TechnicianFieldInput>;
};


export type ProjectTestingLabsArgs = {
  testingLabFieldInput?: InputMaybe<TestingLabFieldInput>;
};


export type ProjectUserToProjectToPermissionsArgs = {
  userToProjectToPermissionFieldInput?: InputMaybe<UserToProjectToPermissionFieldInput>;
};


export type ProjectUsersArgs = {
  userFieldInput?: InputMaybe<UserFieldInput>;
};

/**
 * helps filter multiple `Project` records
 *
 * this version of the input will have limited options compared to its other counterpart
 */
export type ProjectFieldInput = {
  /**
   * - when `true`, `active` is truthy
   * - when `false`, `active` is falsy
   * - when omitted, `active` is ignored
   */
  active?: InputMaybe<Scalars['Boolean']>;
  clientProjectName?: InputMaybe<StringFilter>;
  clientProjectNumber?: InputMaybe<StringFilter>;
  createdDate?: InputMaybe<DateTimeFilter>;
  /**
   * determines now to handle deleted `Project` records
   *
   * - when `true`, only return deleted records
   * - when `false`, do not return deleted records
   * - when omitted, `deleted` is ignored
   */
  deleted?: InputMaybe<Scalars['Boolean']>;
  globalId?: InputMaybe<StringFilter>;
  lastEditedDate?: InputMaybe<DateTimeFilter>;
  /**
   * how to order `Project` records
   *
   * executed in the order they are defined
   */
  orderBy?: InputMaybe<Array<OrderByInput>>;
  primeContractorName?: InputMaybe<StringFilter>;
  projectName?: InputMaybe<StringFilter>;
  /**
   * specifies how many records to return
   *
   * analogous to `limit`, `first`, or `top` in SQL dialects
   */
  take?: InputMaybe<Scalars['Int']>;
};

/** helps filter multiple `Project` records */
export type ProjectListInput = {
  /**
   * - when `true`, `active` is truthy
   * - when `false`, `active` is falsy
   * - when omitted, `active` is ignored
   */
  active?: InputMaybe<Scalars['Boolean']>;
  clientProjectName?: InputMaybe<StringFilter>;
  clientProjectNumber?: InputMaybe<StringFilter>;
  createdDate?: InputMaybe<DateTimeFilter>;
  /**
   * determines now to handle deleted `Project` records
   *
   * - when `true`, only return deleted records
   * - when `false`, do not return deleted records
   * - when omitted, `deleted` is ignored
   */
  deleted?: InputMaybe<Scalars['Boolean']>;
  globalId?: InputMaybe<StringFilter>;
  lastEditedDate?: InputMaybe<DateTimeFilter>;
  /**
   * how to order `Project` records
   *
   * executed in the order they are defined
   */
  orderBy?: InputMaybe<Array<OrderByInput>>;
  /**
   * paginate `Project` records
   *
   * using `paginate` may require multiple requests to get all possible results,
   * but will give more fine-grain control in the event all records cannot be
   * returned gracefully
   */
  paginate?: InputMaybe<PaginationInput>;
  primeContractorName?: InputMaybe<StringFilter>;
  projectName?: InputMaybe<StringFilter>;
};

/** response metadata for a list query of Project records */
export type ProjectListResponse = {
  __typename: 'ProjectListResponse';
  /** the total count of Project records matching any configured filters */
  count: Scalars['Int'];
  /** the total count of paginated groups of Project */
  pages: Scalars['Int'];
  /** Project records */
  records: Array<Project>;
};

/**
 * extends `Project` to store data specific to this API
 *
 * additionally, records are synced roughly every 67 minutes with their
 * corresponding `Site` in Microsoft's API
 */
export type ProjectMetadata = {
  __typename: 'ProjectMetadata';
  /**
   * the id associated with the Project in the CM_Project_Layers Map Server
   *
   *     this id is used to get design layers for PDF Design Layers and should only need to be set once
   *
   *     if it does change, this may lead to incorrectly configured PDF Design Layers
   */
  cmProjectLayersId: Maybe<Scalars['Float']>;
  /** the date this record was inserted into the database */
  createdDate: Scalars['DateTime'];
  /**
   * the email address of a user associated with the `createdDate`
   *
   * this value will be `unknown` if the `createdDate` was not set by a user
   */
  createdUser: Scalars['String'];
  /**
   * the id of a Document Library to use as the application's Document Library
   *
   * when unset, uses the default Documents library of the associated SharePoint site
   *
   * for most projects, this value should remain unset
   */
  customDriveId: Maybe<Scalars['String']>;
  /** the date this record was last updated in the database */
  lastEditedDate: Scalars['DateTime'];
  /**
   * the email address of a user associated with the `lastEditedDate`
   *
   * this value will be `system` if the `lastEditedDate` was not set by a user
   */
  lastEditedUser: Scalars['String'];
  mapServerLayers: Array<MapServerLayer>;
  /** a related `Project` */
  project: Project;
  /** the `globalId` of a related `Project` */
  projectId: Scalars['String'];
  /** A base64 string representation of a project logo png */
  projectLogoB64: Maybe<Scalars['String']>;
  /** when enabled, users will be prompted to create and link a new Design Submittal to a Field Design Change when the Concurrence Level causes an Early Closure side effect */
  promptDesignSubmittalAtFDCClosure: Maybe<Scalars['Boolean']>;
  /** when resolving the filename of a report or photo export image, replace any space characters with a dash */
  replaceSpacesWithDashesInFilenames: Scalars['Boolean'];
  sharePointSite: SharePointSite;
  /**
   * this is
   * stored in the database with data from the Microsoft Graph API
   *
   * it corresponds to a `Site.id` value
   */
  sharePointSiteId: Maybe<Scalars['String']>;
  /** a partial address path in the connected SharePoint site */
  sharePointSiteLandingPage: Maybe<Scalars['String']>;
  /**
   * this is
   * stored in the database with data from the Microsoft Graph API
   *
   * it corresponds to a `Site.webUrl` value
   */
  sharePointSiteURL: Maybe<Scalars['String']>;
  /**
   * a composite field composed
   * of `sharePointSiteURL` and `sharePointSiteLandingPage`
   *
   * used to link directly to a specific page in the connected SharePoint site
   */
  sharePointURL: Maybe<Scalars['String']>;
};

/** helps filter multiple `ProjectMetadata` records */
export type ProjectMetadataListInput = {
  createdDate?: InputMaybe<DateTimeFilter>;
  lastEditedDate?: InputMaybe<DateTimeFilter>;
  /**
   * how to order `ProjectMetadata` records
   *
   * executed in the order they are defined
   */
  orderBy?: InputMaybe<Array<OrderByInput>>;
  /**
   * paginate `ProjectMetadata` records
   *
   * using `paginate` may require multiple requests to get all possible results,
   * but will give more fine-grain control in the event all records cannot be
   * returned gracefully
   */
  paginate?: InputMaybe<PaginationInput>;
  /**
   * - when `true`, `promptDesignSubmittalAtFDCClosure` is truthy
   * - when `false`, `promptDesignSubmittalAtFDCClosure` is falsy
   * - when omitted, `promptDesignSubmittalAtFDCClosure` is ignored
   */
  promptDesignSubmittalAtFDCClosure?: InputMaybe<Scalars['Boolean']>;
  sharePointSiteId?: InputMaybe<StringFilter>;
  sharePointSiteLandingPage?: InputMaybe<StringFilter>;
  sharePointSiteURL?: InputMaybe<StringFilter>;
};

/** response metadata for a list query of ProjectMetadata records */
export type ProjectMetadataListResponse = {
  __typename: 'ProjectMetadataListResponse';
  /** the total count of ProjectMetadata records matching any configured filters */
  count: Scalars['Int'];
  /** the total count of paginated groups of ProjectMetadata */
  pages: Scalars['Int'];
  /** ProjectMetadata records */
  records: Array<ProjectMetadata>;
};

export type ProjectToCimsOnlineAdmin = {
  __typename: 'ProjectToCIMSOnlineAdmin';
  /** the date this record was inserted into the database */
  createdDate: Scalars['DateTime'];
  /**
   * the email address of a user associated with the `createdDate`
   *
   * this value will be `unknown` if the `createdDate` was not set by a user
   */
  createdUser: Scalars['String'];
  /** the date this record was last updated in the database */
  lastEditedDate: Scalars['DateTime'];
  /**
   * the email address of a user associated with the `lastEditedDate`
   *
   * this value will be `system` if the `lastEditedDate` was not set by a user
   */
  lastEditedUser: Scalars['String'];
  /** a related `Project` */
  project: Project;
  /** the `globalId` of a related `Project` */
  projectId: Scalars['String'];
  user: User;
  userId: Scalars['String'];
};

/**
 * helps filter multiple `ProjectToCIMSOnlineAdmin` records
 *
 * this version of the input will have limited options compared to its other counterpart
 */
export type ProjectToCimsOnlineAdminFieldInput = {
  createdDate?: InputMaybe<DateTimeFilter>;
  createdUser?: InputMaybe<StringFilter>;
  lastEditedDate?: InputMaybe<DateTimeFilter>;
  lastEditedUser?: InputMaybe<StringFilter>;
  /**
   * how to order `ProjectToCIMSOnlineAdmin` records
   *
   * executed in the order they are defined
   */
  orderBy?: InputMaybe<Array<OrderByInput>>;
  projectId?: InputMaybe<StringFilter>;
  /**
   * specifies how many records to return
   *
   * analogous to `limit`, `first`, or `top` in SQL dialects
   */
  take?: InputMaybe<Scalars['Int']>;
  userId?: InputMaybe<StringFilter>;
};

/** helps filter multiple `ProjectToCIMSOnlineAdmin` records */
export type ProjectToCimsOnlineAdminListInput = {
  createdDate?: InputMaybe<DateTimeFilter>;
  createdUser?: InputMaybe<StringFilter>;
  lastEditedDate?: InputMaybe<DateTimeFilter>;
  lastEditedUser?: InputMaybe<StringFilter>;
  /**
   * how to order `ProjectToCIMSOnlineAdmin` records
   *
   * executed in the order they are defined
   */
  orderBy?: InputMaybe<Array<OrderByInput>>;
  /**
   * paginate `ProjectToCIMSOnlineAdmin` records
   *
   * using `paginate` may require multiple requests to get all possible results,
   * but will give more fine-grain control in the event all records cannot be
   * returned gracefully
   */
  paginate?: InputMaybe<PaginationInput>;
  projectId?: InputMaybe<StringFilter>;
  userId?: InputMaybe<StringFilter>;
};

/** response metadata for a list query of ProjectToCIMSOnlineAdmin records */
export type ProjectToCimsOnlineAdminListResponse = {
  __typename: 'ProjectToCIMSOnlineAdminListResponse';
  /** the total count of ProjectToCIMSOnlineAdmin records matching any configured filters */
  count: Scalars['Int'];
  /** the total count of paginated groups of ProjectToCIMSOnlineAdmin */
  pages: Scalars['Int'];
  /** ProjectToCIMSOnlineAdmin records */
  records: Array<ProjectToCimsOnlineAdmin>;
};

export type ProjectToIfiReportType = {
  __typename: 'ProjectToIFIReportType';
  /** the date this record was inserted into the database */
  createdDate: Scalars['DateTime'];
  /**
   * the email address of a user associated with the `createdDate`
   *
   * this value will be `unknown` if the `createdDate` was not set by a user
   */
  createdUser: Scalars['String'];
  dateEnabled: Maybe<Scalars['DateTime']>;
  /** Whether or not the issue report type is enabled to create and update Identified Field Issues */
  isEnabled: Scalars['Boolean'];
  /** the date this record was last updated in the database */
  lastEditedDate: Scalars['DateTime'];
  /**
   * the email address of a user associated with the `lastEditedDate`
   *
   * this value will be `system` if the `lastEditedDate` was not set by a user
   */
  lastEditedUser: Scalars['String'];
  /** a related `Project` */
  project: Project;
  /** the `globalId` of a related `Project` */
  projectId: Scalars['String'];
  reportType: Scalars['String'];
  reportTypeId: Scalars['String'];
};

/**
 * helps filter multiple `ProjectToIFIReportType` records
 *
 * this version of the input will have limited options compared to its other counterpart
 */
export type ProjectToIfiReportTypeFieldInput = {
  createdDate?: InputMaybe<DateTimeFilter>;
  dateEnabled?: InputMaybe<DateTimeFilter>;
  lastEditedDate?: InputMaybe<DateTimeFilter>;
  /**
   * how to order `ProjectToIFIReportType` records
   *
   * executed in the order they are defined
   */
  orderBy?: InputMaybe<Array<OrderByInput>>;
  projectId?: InputMaybe<StringFilter>;
  reportTypeId?: InputMaybe<StringFilter>;
  /**
   * specifies how many records to return
   *
   * analogous to `limit`, `first`, or `top` in SQL dialects
   */
  take?: InputMaybe<Scalars['Int']>;
};

/** helps filter multiple `ProjectToIFIReportType` records */
export type ProjectToIfiReportTypeListInput = {
  createdDate?: InputMaybe<DateTimeFilter>;
  dateEnabled?: InputMaybe<DateTimeFilter>;
  lastEditedDate?: InputMaybe<DateTimeFilter>;
  /**
   * how to order `ProjectToIFIReportType` records
   *
   * executed in the order they are defined
   */
  orderBy?: InputMaybe<Array<OrderByInput>>;
  /**
   * paginate `ProjectToIFIReportType` records
   *
   * using `paginate` may require multiple requests to get all possible results,
   * but will give more fine-grain control in the event all records cannot be
   * returned gracefully
   */
  paginate?: InputMaybe<PaginationInput>;
  projectId?: InputMaybe<StringFilter>;
  reportTypeId?: InputMaybe<StringFilter>;
};

/** response metadata for a list query of ProjectToIFIReportType records */
export type ProjectToIfiReportTypeListResponse = {
  __typename: 'ProjectToIFIReportTypeListResponse';
  /** the total count of ProjectToIFIReportType records matching any configured filters */
  count: Scalars['Int'];
  /** the total count of paginated groups of ProjectToIFIReportType */
  pages: Scalars['Int'];
  /** ProjectToIFIReportType records */
  records: Array<ProjectToIfiReportType>;
};

export type ProjectToInternalConnection = {
  __typename: 'ProjectToInternalConnection';
  /** the date this record was inserted into the database */
  createdDate: Scalars['DateTime'];
  /**
   * the email address of a user associated with the `createdDate`
   *
   * this value will be `unknown` if the `createdDate` was not set by a user
   */
  createdUser: Scalars['String'];
  group: Maybe<PayItemConnectionGroup>;
  groupId: Maybe<Scalars['String']>;
  internalConnection: Scalars['String'];
  internalConnectionId: Scalars['String'];
  /** the date this record was last updated in the database */
  lastEditedDate: Scalars['DateTime'];
  /**
   * the email address of a user associated with the `lastEditedDate`
   *
   * this value will be `system` if the `lastEditedDate` was not set by a user
   */
  lastEditedUser: Scalars['String'];
  /**
   * the order of this connection in the Pay Items Summary
   *
   * if a `groupId` is set, the order inside the associated `PayItemConnectionGroup`
   */
  order: Maybe<Scalars['Int']>;
  /** a related `Project` */
  project: Project;
  projectId: Scalars['String'];
};

/**
 * helps filter multiple `ProjectToInternalConnection` records
 *
 * this version of the input will have limited options compared to its other counterpart
 */
export type ProjectToInternalConnectionFieldInput = {
  groupId?: InputMaybe<StringFilter>;
  internalConnectionId?: InputMaybe<StringFilter>;
  /**
   * how to order `ProjectToInternalConnection` records
   *
   * executed in the order they are defined
   */
  orderBy?: InputMaybe<Array<OrderByInput>>;
  projectId?: InputMaybe<StringFilter>;
  /**
   * specifies how many records to return
   *
   * analogous to `limit`, `first`, or `top` in SQL dialects
   */
  take?: InputMaybe<Scalars['Int']>;
};

/** helps filter multiple `ProjectToInternalConnection` records */
export type ProjectToInternalConnectionListInput = {
  groupId?: InputMaybe<StringFilter>;
  internalConnectionId?: InputMaybe<StringFilter>;
  /**
   * how to order `ProjectToInternalConnection` records
   *
   * executed in the order they are defined
   */
  orderBy?: InputMaybe<Array<OrderByInput>>;
  /**
   * paginate `ProjectToInternalConnection` records
   *
   * using `paginate` may require multiple requests to get all possible results,
   * but will give more fine-grain control in the event all records cannot be
   * returned gracefully
   */
  paginate?: InputMaybe<PaginationInput>;
  projectId?: InputMaybe<StringFilter>;
};

/** response metadata for a list query of ProjectToInternalConnection records */
export type ProjectToInternalConnectionListResponse = {
  __typename: 'ProjectToInternalConnectionListResponse';
  /** the total count of ProjectToInternalConnection records matching any configured filters */
  count: Scalars['Int'];
  /** the total count of paginated groups of ProjectToInternalConnection */
  pages: Scalars['Int'];
  /** ProjectToInternalConnection records */
  records: Array<ProjectToInternalConnection>;
};

/**
 * ### intermediary types
 *
 * ProjectToUserGroup is an intermediary object type to create a many to many relationship between
 * `Project` and `UserGroup`
 *
 * certain object types can only be referenced through a database view or need to facilitate
 * more advanced logic flows
 *
 * this makes it impossible to create a layer of abstraction on top of certain relationships
 *
 *
 * when associated with this API, each `Project` will be given a list of `UserGroup` entities
 *
 * this list will be used to sync `User` and `UserGroup` values
 */
export type ProjectToUserGroup = {
  __typename: 'ProjectToUserGroup';
  /** a related `Project` */
  project: Project;
  /** the `globalId` of a related `Project` */
  projectId: Scalars['String'];
  userGroup: UserGroup;
  /** the `id` of a related `UserGroup` */
  userGroupId: Scalars['String'];
};

/**
 * helps filter multiple `ProjectToUserGroup` records
 *
 * this version of the input will have limited options compared to its other counterpart
 */
export type ProjectToUserGroupFieldInput = {
  /**
   * how to order `ProjectToUserGroup` records
   *
   * executed in the order they are defined
   */
  orderBy?: InputMaybe<Array<OrderByInput>>;
  projectId?: InputMaybe<StringFilter>;
  /**
   * specifies how many records to return
   *
   * analogous to `limit`, `first`, or `top` in SQL dialects
   */
  take?: InputMaybe<Scalars['Int']>;
  userGroupId?: InputMaybe<StringFilter>;
};

/** helps filter multiple `ProjectToUserGroup` records */
export type ProjectToUserGroupListInput = {
  /**
   * how to order `ProjectToUserGroup` records
   *
   * executed in the order they are defined
   */
  orderBy?: InputMaybe<Array<OrderByInput>>;
  /**
   * paginate `ProjectToUserGroup` records
   *
   * using `paginate` may require multiple requests to get all possible results,
   * but will give more fine-grain control in the event all records cannot be
   * returned gracefully
   */
  paginate?: InputMaybe<PaginationInput>;
  projectId?: InputMaybe<StringFilter>;
  userGroupId?: InputMaybe<StringFilter>;
};

/** response metadata for a list query of ProjectToUserGroup records */
export type ProjectToUserGroupListResponse = {
  __typename: 'ProjectToUserGroupListResponse';
  /** the total count of ProjectToUserGroup records matching any configured filters */
  count: Scalars['Int'];
  /** the total count of paginated groups of ProjectToUserGroup */
  pages: Scalars['Int'];
  /** ProjectToUserGroup records */
  records: Array<ProjectToUserGroup>;
};

export type Query = {
  __typename: 'Query';
  /** returns a single `Alignment` by `globalId` */
  alignment: Alignment;
  /**
   * returns many Alignment records in a `AlignmentListResponse`
   *
   * records will available in `AlignmentListResponse.records`
   */
  alignments: AlignmentListResponse;
  /**
   * returns many APIKey records in a `APIKeyListResponse`
   *
   * records will available in `APIKeyListResponse.records`
   */
  apiKeys: ApiKeyListResponse;
  /** returns a single `AsphaltCoreMeasurement` by `globalId` */
  asphaltCoreMeasurement: AsphaltCoreMeasurement;
  /**
   * returns many AsphaltCoreMeasurement records in a `AsphaltCoreMeasurementListResponse`
   *
   * records will available in `AsphaltCoreMeasurementListResponse.records`
   */
  asphaltCoreMeasurements: AsphaltCoreMeasurementListResponse;
  /** returns a single `AsphaltLot` by `globalId` */
  asphaltLot: AsphaltLot;
  /**
   * returns many AsphaltLot records in a `AsphaltLotListResponse`
   *
   * records will available in `AsphaltLotListResponse.records`
   */
  asphaltLots: AsphaltLotListResponse;
  /** returns a single `AsphaltMaterial` by `globalId` */
  asphaltMaterial: AsphaltMaterial;
  /** returns a single `AsphaltMaterialSource` by `globalId` */
  asphaltMaterialSource: AsphaltMaterialSource;
  /**
   * returns many AsphaltMaterialSource records in a `AsphaltMaterialSourceListResponse`
   *
   * records will available in `AsphaltMaterialSourceListResponse.records`
   */
  asphaltMaterialSources: AsphaltMaterialSourceListResponse;
  /**
   * returns many AsphaltMaterial records in a `AsphaltMaterialListResponse`
   *
   * records will available in `AsphaltMaterialListResponse.records`
   */
  asphaltMaterials: AsphaltMaterialListResponse;
  /** returns a single `AsphaltMixDesign` by `globalId` */
  asphaltMixDesign: AsphaltMixDesign;
  /** returns a single `AsphaltMixDesignTargetPercentage` by `mixDesignId` and `targetId` */
  asphaltMixDesignTargetPercentage: AsphaltMixDesignTargetPercentage;
  /**
   * returns many AsphaltMixDesignTargetPercentage records in a `AsphaltMixDesignTargetPercentageListResponse`
   *
   * records will available in `AsphaltMixDesignTargetPercentageListResponse.records`
   */
  asphaltMixDesignTargetPercentages: AsphaltMixDesignTargetPercentageListResponse;
  /**
   * returns many AsphaltMixDesign records in a `AsphaltMixDesignListResponse`
   *
   * records will available in `AsphaltMixDesignListResponse.records`
   */
  asphaltMixDesigns: AsphaltMixDesignListResponse;
  /** returns a single `AsphaltPlacement` by `globalId` */
  asphaltPlacement: AsphaltPlacement;
  /** returns a single `AsphaltPlacementJoint` by `globalId` */
  asphaltPlacementJoint: AsphaltPlacementJoint;
  /**
   * returns many AsphaltPlacementJoint records in a `AsphaltPlacementJointListResponse`
   *
   * records will available in `AsphaltPlacementJointListResponse.records`
   */
  asphaltPlacementJoints: AsphaltPlacementJointListResponse;
  /**
   * returns many AsphaltPlacement records in a `AsphaltPlacementListResponse`
   *
   * records will available in `AsphaltPlacementListResponse.records`
   */
  asphaltPlacements: AsphaltPlacementListResponse;
  /** returns a single `AsphaltSample` by `globalId` */
  asphaltSample: AsphaltSample;
  /**
   * returns many AsphaltSample records in a `AsphaltSampleListResponse`
   *
   * records will available in `AsphaltSampleListResponse.records`
   */
  asphaltSamples: AsphaltSampleListResponse;
  /** returns a single `BatchReportRequest` by `id` */
  batchReportRequest: BatchReportRequest;
  /**
   * returns many BatchReportRequest records in a `BatchReportRequestListResponse`
   *
   * records will available in `BatchReportRequestListResponse.records`
   */
  batchReportRequests: BatchReportRequestListResponse;
  /** returns a single `CASComment` by `id` */
  casComment: CasComment;
  /**
   * returns many CASComment records in a `CASCommentListResponse`
   *
   * records will available in `CASCommentListResponse.records`
   */
  casComments: CasCommentListResponse;
  /** returns a single `CASDispositionType` by `id` */
  casDispositionType: CasDispositionType;
  /**
   * returns many CASDispositionType records in a `CASDispositionTypeListResponse`
   *
   * records will available in `CASDispositionTypeListResponse.records`
   */
  casDispositionTypes: CasDispositionTypeListResponse;
  /** returns a single `CASNotification` by `notificationEventId` and `projectId` */
  casNotification: CasNotification;
  /**
   * returns many CASNotification records in a `CASNotificationListResponse`
   *
   * records will available in `CASNotificationListResponse.records`
   */
  casNotifications: CasNotificationListResponse;
  /** returns a single `CASQuickLink` by `id` */
  casQuickLink: CasQuickLink;
  /**
   * returns many CASQuickLink records in a `CASQuickLinkListResponse`
   *
   * records will available in `CASQuickLinkListResponse.records`
   */
  casQuickLinks: CasQuickLinkListResponse;
  /** returns a single `CASRoutingGroup` by `id` */
  casRoutingGroup: CasRoutingGroup;
  /**
   * returns many CASRoutingGroup records in a `CASRoutingGroupListResponse`
   *
   * records will available in `CASRoutingGroupListResponse.records`
   */
  casRoutingGroups: CasRoutingGroupListResponse;
  /** returns a single `CASSubtype` by `id` */
  casSubtype: CasSubtype;
  /**
   * returns many CASSubtype records in a `CASSubtypeListResponse`
   *
   * records will available in `CASSubtypeListResponse.records`
   */
  casSubtypes: CasSubtypeListResponse;
  /** returns a single `CASToCASRoutingGroup` by `routingGroupId` and `submittalId` */
  casToCASRoutingGroup: CasToCasRoutingGroup;
  /**
   * returns many CASToCASRoutingGroup records in a `CASToCASRoutingGroupListResponse`
   *
   * records will available in `CASToCASRoutingGroupListResponse.records`
   */
  casToCASRoutingGroups: CasToCasRoutingGroupListResponse;
  /**
   * returns many CASToPayItemNoGeometry records in a `CASToPayItemNoGeometryListResponse`
   *
   * records will available in `CASToPayItemNoGeometryListResponse.records`
   */
  casToPayItemNoGeometries: CasToPayItemNoGeometryListResponse;
  /** returns a single `CASToPayItemNoGeometry` by `payItemId` and `submittalId` */
  casToPayItemNoGeometry: CasToPayItemNoGeometry;
  /** returns a single `CASType` by `id` */
  casType: CasType;
  /**
   * returns many CASType records in a `CASTypeListResponse`
   *
   * records will available in `CASTypeListResponse.records`
   */
  casTypes: CasTypeListResponse;
  /** get all parent project layers from the CM_Project_Layers ArcGIS service */
  cmProjectLayers: Array<MapServerLayer>;
  /** returns a single `ConcreteCoreBreakData` by `concreteCoreMeasurementId` */
  concreteCoreBreakData: ConcreteCoreBreakData;
  /**
   * returns many ConcreteCoreBreakData records in a `ConcreteCoreBreakDataListResponse`
   *
   * records will available in `ConcreteCoreBreakDataListResponse.records`
   */
  concreteCoreBreakDatas: ConcreteCoreBreakDataListResponse;
  /** returns a single `ConcreteCoreMeasurement` by `globalId` */
  concreteCoreMeasurement: ConcreteCoreMeasurement;
  /**
   * returns many ConcreteCoreMeasurement records in a `ConcreteCoreMeasurementListResponse`
   *
   * records will available in `ConcreteCoreMeasurementListResponse.records`
   */
  concreteCoreMeasurements: ConcreteCoreMeasurementListResponse;
  /** returns a single `ConcreteCuringMethod` by `globalId` */
  concreteCuringMethod: ConcreteCuringMethod;
  /**
   * returns many ConcreteCuringMethodListReponse records in a `ConcreteCuringMethodListReponse`
   *
   * records will available in `ConcreteCuringMethodListReponse.records`
   */
  concreteCuringMethods: ConcreteCuringMethodListResponse;
  /** returns a single `ConcreteFieldData` by `globalId` */
  concreteFieldData: ConcreteFieldData;
  /**
   * returns many ConcreteFieldData records in a `ConcreteFieldDataListResponse`
   *
   * records will available in `ConcreteFieldDataListResponse.records`
   */
  concreteFieldDatas: ConcreteFieldDataListResponse;
  /** returns a single `ConcreteMaterial` by `globalId` */
  concreteMaterial: ConcreteMaterial;
  /**
   * returns many ConcreteMaterial records in a `ConcreteMaterialListResponse`
   *
   * records will available in `ConcreteMaterialListResponse.records`
   */
  concreteMaterials: ConcreteMaterialListResponse;
  /** returns a single `ConcreteMixDesign` by `globalId` */
  concreteMixDesign: ConcreteMixDesign;
  /**
   * returns many ConcreteMixDesign records in a `ConcreteMixDesignListResponse`
   *
   * records will available in `ConcreteMixDesignListResponse.records`
   */
  concreteMixDesigns: ConcreteMixDesignListResponse;
  /** returns a single `ConcreteNotification` by `notificationEventId` and `projectId` */
  concreteNotification: ConcreteNotification;
  /**
   * returns many ConcreteNotification records in a `ConcreteNotificationListResponse`
   *
   * records will available in `ConcreteNotificationListResponse.records`
   */
  concreteNotifications: ConcreteNotificationListResponse;
  /** returns a single `ConcretePlacement` by `globalId` */
  concretePlacement: ConcretePlacement;
  /**
   * returns many ConcretePlacement records in a `ConcretePlacementListResponse`
   *
   * records will available in `ConcretePlacementListResponse.records`
   */
  concretePlacements: ConcretePlacementListResponse;
  /** returns a single `ConcreteProductionData` by `globalId` */
  concreteProductionData: ConcreteProductionData;
  /**
   * returns many ConcreteProductionData records in a `ConcreteProductionDataListResponse`
   *
   * records will available in `ConcreteProductionDataListResponse.records`
   */
  concreteProductionDatas: ConcreteProductionDataListResponse;
  /** returns a single `ConcreteSampleLocation` by `globalId` */
  concreteSampleLocation: ConcreteSampleLocation;
  /**
   * returns many ConcreteSampleLocation records in a `ConcreteSampleLocationListResponse`
   *
   * records will available in `ConcreteSampleLocationListResponse.records`
   */
  concreteSampleLocations: ConcreteSampleLocationListResponse;
  /** returns a single `ConcreteTest` by `globalId` */
  concreteTest: ConcreteTest;
  /** returns a single `ConcreteTestBreakData` by `id` */
  concreteTestBreakData: ConcreteTestBreakData;
  /**
   * returns many ConcreteTestBreakData records in a `ConcreteTestBreakDataListResponse`
   *
   * records will available in `ConcreteTestBreakDataListResponse.records`
   */
  concreteTestBreakDatas: ConcreteTestBreakDataListResponse;
  /**
   * returns many ConcreteTestIFISettings records in a `ConcreteTestIFISettingsListResponse`
   *
   * records will available in `ConcreteTestIFISettingsListResponse.records`
   */
  concreteTestIFISettings: ConcreteTestIfiSettingsListResponse;
  /** returns a single `ConcreteTestSet` by `globalId` */
  concreteTestSet: ConcreteTestSet;
  /** returns a single `ConcreteTestSetMetadata` by `concreteTestSetId` */
  concreteTestSetMetadata: ConcreteTestSetMetadata;
  /**
   * returns many ConcreteTestSetMetadata records in a `ConcreteTestSetMetadataListResponse`
   *
   * records will available in `ConcreteTestSetMetadataListResponse.records`
   */
  concreteTestSetMetadatas: ConcreteTestSetMetadataListResponse;
  /**
   * returns many ConcreteTestSet records in a `ConcreteTestSetListResponse`
   *
   * records will available in `ConcreteTestSetListResponse.records`
   */
  concreteTestSets: ConcreteTestSetListResponse;
  /**
   * returns many ConcreteTest records in a `ConcreteTestListResponse`
   *
   * records will available in `ConcreteTestListResponse.records`
   */
  concreteTests: ConcreteTestListResponse;
  /** returns a single `ConstructionAdminSubmittal` by `id` */
  constructionAdminSubmittal: ConstructionAdminSubmittal;
  /**
   * returns many ConstructionAdminSubmittal records in a `ConstructionAdminSubmittalListResponse`
   *
   * records will available in `ConstructionAdminSubmittalListResponse.records`
   */
  constructionAdminSubmittals: ConstructionAdminSubmittalListResponse;
  /** returns a single `Contractor` by `globalId` */
  contractor: Contractor;
  /**
   * returns many Contractor records in a `ContractorListResponse`
   *
   * records will available in `ContractorListResponse.records`
   */
  contractors: ContractorListResponse;
  /** returns a single `CustomField` by `id` */
  customField: CustomField;
  /** returns a single `CustomFieldToClassType` by `classTypeId` and `customFieldId` */
  customFieldToClassType: CustomFieldToClassType;
  /**
   * returns many CustomFieldToClassType records in a `CustomFieldToClassTypeListResponse`
   *
   * records will available in `CustomFieldToClassTypeListResponse.records`
   */
  customFieldToClassTypes: CustomFieldToClassTypeListResponse;
  /**
   * returns many CustomField records in a `CustomFieldListResponse`
   *
   * records will available in `CustomFieldListResponse.records`
   */
  customFields: CustomFieldListResponse;
  /** returns a single `CustomListItem` by `id` */
  customListItem: CustomListItem;
  /**
   * returns many CustomListItem records in a `CustomListItemListResponse`
   *
   * records will available in `CustomListItemListResponse.records`
   */
  customListItems: CustomListItemListResponse;
  /** returns a single `DailyInspectionControlPoint` by `globalId` */
  dailyInspectionControlPoint: DailyInspectionControlPoint;
  /**
   * returns many DailyInspectionControlPointIFISettings records in a `DailyInspectionControlPointIFISettingsListResponse`
   *
   * records will available in `DailyInspectionControlPointIFISettingsListResponse.records`
   */
  dailyInspectionControlPointIFISettings: DailyInspectionControlPointIfiSettingsListResponse;
  /** returns a single `DailyInspectionControlPointType` by `globalId` */
  dailyInspectionControlPointType: DailyInspectionControlPointType;
  /**
   * returns many DailyInspectionControlPointType records in a `DailyInspectionControlPointTypeListResponse`
   *
   * records will available in `DailyInspectionControlPointTypeListResponse.records`
   */
  dailyInspectionControlPointTypes: DailyInspectionControlPointTypeListResponse;
  /**
   * returns many DailyInspectionControlPoint records in a `DailyInspectionControlPointListResponse`
   *
   * records will available in `DailyInspectionControlPointListResponse.records`
   */
  dailyInspectionControlPoints: DailyInspectionControlPointListResponse;
  /** returns a single `DailyInspectionDailyContractorEquipment` by `globalId` */
  dailyInspectionDailyContractorEquipment: DailyInspectionDailyContractorEquipment;
  /**
   * returns many DailyInspectionDailyContractorEquipment records in a `DailyInspectionDailyContractorEquipmentListResponse`
   *
   * records will available in `DailyInspectionDailyContractorEquipmentListResponse.records`
   */
  dailyInspectionDailyContractorEquipments: DailyInspectionDailyContractorEquipmentListResponse;
  /** returns a single `DailyInspectionDailyContractorPerson` by `globalId` */
  dailyInspectionDailyContractorPerson: DailyInspectionDailyContractorPerson;
  /**
   * returns many DailyInspectionDailyContractorPerson records in a `DailyInspectionDailyContractorPersonListResponse`
   *
   * records will available in `DailyInspectionDailyContractorPersonListResponse.records`
   */
  dailyInspectionDailyContractorPersons: DailyInspectionDailyContractorPersonListResponse;
  /** returns a single `DailyInspectionFeatureEngineeringJudgement` by `globalId` */
  dailyInspectionFeatureEngineeringJudgement: DailyInspectionFeatureEngineeringJudgement;
  /**
   * returns many DailyInspectionFeatureEngineeringJudgement records in a `DailyInspectionFeatureEngineeringJudgementListResponse`
   *
   * records will available in `DailyInspectionFeatureEngineeringJudgementListResponse.records`
   */
  dailyInspectionFeatureEngineeringJudgements: DailyInspectionFeatureEngineeringJudgementListResponse;
  /** returns a single `DailyInspectionForm` by `globalId` */
  dailyInspectionForm: DailyInspectionForm;
  /** returns a single `DailyInspectionFormAnswer` by `globalId` */
  dailyInspectionFormAnswer: DailyInspectionFormAnswer;
  /**
   * returns many DailyInspectionFormAnswer records in a `DailyInspectionFormAnswerListResponse`
   *
   * records will available in `DailyInspectionFormAnswerListResponse.records`
   */
  dailyInspectionFormAnswers: DailyInspectionFormAnswerListResponse;
  /** returns a single `DailyInspectionFormQuestion` by `globalId` */
  dailyInspectionFormQuestion: DailyInspectionFormQuestion;
  /**
   * returns many DailyInspectionFormQuestion records in a `DailyInspectionFormQuestionListResponse`
   *
   * records will available in `DailyInspectionFormQuestionListResponse.records`
   */
  dailyInspectionFormQuestions: DailyInspectionFormQuestionListResponse;
  /**
   * returns many DailyInspectionForm records in a `DailyInspectionFormListResponse`
   *
   * records will available in `DailyInspectionFormListResponse.records`
   */
  dailyInspectionForms: DailyInspectionFormListResponse;
  /** returns a single `DailyInspectionInspection` by `globalId` */
  dailyInspectionInspection: DailyInspectionInspection;
  /**
   * returns many DailyInspectionInspectionIFISettings records in a `DailyInspectionInspectionIFISettingsListResponse`
   *
   * records will available in `DailyInspectionInspectionIFISettingsListResponse.records`
   */
  dailyInspectionInspectionIFISettings: DailyInspectionInspectionIfiSettingsListResponse;
  /**
   * returns many DailyInspectionInspection records in a `DailyInspectionInspectionListResponse`
   *
   * records will available in `DailyInspectionInspectionListResponse.records`
   */
  dailyInspectionInspections: DailyInspectionInspectionListResponse;
  /** returns a single `DailyInspectionLookUp` by `globalId` */
  dailyInspectionLookUp: DailyInspectionLookUp;
  /**
   * returns many DailyInspectionLookUp records in a `DailyInspectionLookUpListResponse`
   *
   * records will available in `DailyInspectionLookUpListResponse.records`
   */
  dailyInspectionLookUps: DailyInspectionLookUpListResponse;
  /** returns a single `DailyInspectionPunchList` by `globalId` */
  dailyInspectionPunchList: DailyInspectionPunchList;
  /**
   * returns many DailyInspectionPunchListIFISettings records in a `DailyInspectionPunchListIFISettingsListResponse`
   *
   * records will available in `DailyInspectionPunchListIFISettingsListResponse.records`
   */
  dailyInspectionPunchListIFISettings: DailyInspectionPunchListIfiSettingsListResponse;
  /**
   * returns many DailyInspectionPunchList records in a `DailyInspectionPunchListListResponse`
   *
   * records will available in `DailyInspectionPunchListListResponse.records`
   */
  dailyInspectionPunchLists: DailyInspectionPunchListListResponse;
  /** returns a single `DailyInspectionWorkType` by `globalId` */
  dailyInspectionWorkType: DailyInspectionWorkType;
  /**
   * returns many DailyInspectionWorkType records in a `DailyInspectionWorkTypeListResponse`
   *
   * records will available in `DailyInspectionWorkTypeListResponse.records`
   */
  dailyInspectionWorkTypes: DailyInspectionWorkTypeListResponse;
  /** returns a single `DensityTest` by `globalId` */
  densityTest: DensityTest;
  /**
   * returns many DensityTestIFISettings records in a `DensityTestIFISettingsListResponse`
   *
   * records will available in `DensityTestIFISettingsListResponse.records`
   */
  densityTestIFISettings: DensityTestIfiSettingsListResponse;
  /**
   * returns many DensityTest records in a `DensityTestListResponse`
   *
   * records will available in `DensityTestListResponse.records`
   */
  densityTests: DensityTestListResponse;
  /** returns a single `DesignSubmittal` by `id` */
  designSubmittal: DesignSubmittal;
  /**
   * returns many DesignSubmittal records in a `DesignSubmittalListResponse`
   *
   * records will available in `DesignSubmittalListResponse.records`
   */
  designSubmittals: DesignSubmittalListResponse;
  /** returns a single `DocumentChecklistItem` by `id` */
  documentChecklistItem: DocumentChecklistItem;
  /** returns a single `DocumentChecklistItemToConcreteMaterial` by `concreteMaterialId` and `documentChecklistItemId` */
  documentChecklistItemToConcreteMaterial: DocumentChecklistItemToConcreteMaterial;
  /**
   * returns many DocumentChecklistItemToConcreteMaterial records in a `DocumentChecklistItemToConcreteMaterialListResponse`
   *
   * records will available in `DocumentChecklistItemToConcreteMaterialListResponse.records`
   */
  documentChecklistItemToConcreteMaterials: DocumentChecklistItemToConcreteMaterialListResponse;
  /**
   * returns many DocumentChecklistItem records in a `DocumentChecklistItemListResponse`
   *
   * records will available in `DocumentChecklistItemListResponse.records`
   */
  documentChecklistItems: DocumentChecklistItemListResponse;
  /** returns a single `DocumentChecklistValue` by `concreteTestSetId` and `documentChecklistItemId` */
  documentChecklistValue: DocumentChecklistValue;
  /**
   * returns many DocumentChecklistValue records in a `DocumentChecklistValueListResponse`
   *
   * records will available in `DocumentChecklistValueListResponse.records`
   */
  documentChecklistValues: DocumentChecklistValueListResponse;
  /** returns a single `DSAction` by `id` */
  dsAction: DsAction;
  /**
   * returns many DSAction records in a `DSActionListResponse`
   *
   * records will available in `DSActionListResponse.records`
   */
  dsActions: DsActionListResponse;
  /** returns a single `DSDiscipline` by `id` */
  dsDiscipline: DsDiscipline;
  /**
   * returns many DSDiscipline records in a `DSDisciplineListResponse`
   *
   * records will available in `DSDisciplineListResponse.records`
   */
  dsDisciplines: DsDisciplineListResponse;
  /** returns a single `DSNotification` by `notificationEventId` and `projectId` */
  dsNotification: DsNotification;
  /**
   * returns many DSNotification records in a `DSNotificationListResponse`
   *
   * records will available in `DSNotificationListResponse.records`
   */
  dsNotifications: DsNotificationListResponse;
  /** returns a single `DSOrganization` by `id` */
  dsOrganization: DsOrganization;
  /**
   * returns many DSOrganization records in a `DSOrganizationListResponse`
   *
   * records will available in `DSOrganizationListResponse.records`
   */
  dsOrganizations: DsOrganizationListResponse;
  /** returns a single `DSQuickLink` by `id` */
  dsQuickLink: DsQuickLink;
  /**
   * returns many DSQuickLink records in a `DSQuickLinkListResponse`
   *
   * records will available in `DSQuickLinkListResponse.records`
   */
  dsQuickLinks: DsQuickLinkListResponse;
  /** returns a single `DSToDSDiscipline` by `disciplineId` and `submittalId` */
  dsToDSDiscipline: DsToDsDiscipline;
  /**
   * returns many DSToDSDiscipline records in a `DSToDSDisciplineListResponse`
   *
   * records will available in `DSToDSDisciplineListResponse.records`
   */
  dsToDSDisciplines: DsToDsDisciplineListResponse;
  /**
   * returns many DSToPayItemNoGeometry records in a `DSToPayItemNoGeometryListResponse`
   *
   * records will available in `DSToPayItemNoGeometryListResponse.records`
   */
  dsToPayItemNoGeometries: DsToPayItemNoGeometryListResponse;
  /** returns a single `DSToPayItemNoGeometry` by `payItemId` and `submittalId` */
  dsToPayItemNoGeometry: DsToPayItemNoGeometry;
  /** returns a single `DSType` by `id` */
  dsType: DsType;
  /**
   * returns many DSType records in a `DSTypeListResponse`
   *
   * records will available in `DSTypeListResponse.records`
   */
  dsTypes: DsTypeListResponse;
  /** returns a single `EJNotification` by `notificationEventId` and `projectId` */
  eJNotification: EjNotification;
  /** returns a single `EJToPayItemNoGeometry` by `judgementId` and `payItemId` */
  eJToPayItemNoGeometry: EjToPayItemNoGeometry;
  /**
   * returns many EJNotification records in a `EJNotificationListResponse`
   *
   * records will available in `EJNotificationListResponse.records`
   */
  ejNotifications: EjNotificationListResponse;
  /** returns a single `EJQuickLink` by `id` */
  ejQuickLink: EjQuickLink;
  /**
   * returns many EJQuickLink records in a `EJQuickLinkListResponse`
   *
   * records will available in `EJQuickLinkListResponse.records`
   */
  ejQuickLinks: EjQuickLinkListResponse;
  /**
   * returns many EJToPayItemNoGeometry records in a `EJToPayItemNoGeometryListResponse`
   *
   * records will available in `EJToPayItemNoGeometryListResponse.records`
   */
  ejToPayItemNoGeometries: EjToPayItemNoGeometryListResponse;
  /** returns a single `EJToReport` by `ejId` and `reportId` */
  ejToReport: EjToReport;
  /**
   * returns many EJToReport records in a `EJToReportListResponse`
   *
   * records will available in `EJToReportListResponse.records`
   */
  ejToReports: EjToReportListResponse;
  /** returns a single `EJType` by `id` */
  ejType: EjType;
  /**
   * returns many EJType records in a `EJTypeListResponse`
   *
   * records will available in `EJTypeListResponse.records`
   */
  ejTypes: EjTypeListResponse;
  /** returns a single `EngineeringJudgement` by `id` */
  engineeringJudgement: EngineeringJudgement;
  /**
   * returns many EngineeringJudgement records in a `EngineeringJudgementListResponse`
   *
   * records will available in `EngineeringJudgementListResponse.records`
   */
  engineeringJudgements: EngineeringJudgementListResponse;
  /** returns a single `FDCApprovalGroup` by `id` */
  fdcApprovalGroup: FdcApprovalGroup;
  /**
   * returns many FDCApprovalGroup records in a `FDCApprovalGroupListResponse`
   *
   * records will available in `FDCApprovalGroupListResponse.records`
   */
  fdcApprovalGroups: FdcApprovalGroupListResponse;
  /** returns a single `FDCComment` by `id` */
  fdcComment: FdcComment;
  /**
   * returns many FDCComment records in a `FDCCommentListResponse`
   *
   * records will available in `FDCCommentListResponse.records`
   */
  fdcComments: FdcCommentListResponse;
  /** returns a single `FDCConcurrenceGroup` by `id` */
  fdcConcurrenceGroup: FdcConcurrenceGroup;
  /**
   * returns many FDCConcurrenceGroup records in a `FDCConcurrenceGroupListResponse`
   *
   * records will available in `FDCConcurrenceGroupListResponse.records`
   */
  fdcConcurrenceGroups: FdcConcurrenceGroupListResponse;
  /** returns a single `FDCConcurrenceLevel` by `id` */
  fdcConcurrenceLevel: FdcConcurrenceLevel;
  /**
   * returns many FDCConcurrenceLevel records in a `FDCConcurrenceLevelListResponse`
   *
   * records will available in `FDCConcurrenceLevelListResponse.records`
   */
  fdcConcurrenceLevels: FdcConcurrenceLevelListResponse;
  /** returns a single `FDCDiscipline` by `id` */
  fdcDiscipline: FdcDiscipline;
  /**
   * returns many FDCDiscipline records in a `FDCDisciplineListResponse`
   *
   * records will available in `FDCDisciplineListResponse.records`
   */
  fdcDisciplines: FdcDisciplineListResponse;
  /** returns a single `FDCNotification` by `notificationEventId` and `projectId` */
  fdcNotification: FdcNotification;
  /**
   * returns many FDCNotification records in a `FDCNotificationListResponse`
   *
   * records will available in `FDCNotificationListResponse.records`
   */
  fdcNotifications: FdcNotificationListResponse;
  /** returns a single `FDCQuickLink` by `id` */
  fdcQuickLink: FdcQuickLink;
  /**
   * returns many FDCQuickLink records in a `FDCQuickLinkListResponse`
   *
   * records will available in `FDCQuickLinkListResponse.records`
   */
  fdcQuickLinks: FdcQuickLinkListResponse;
  /** returns a single `FDCToFDCApprovalGroup` by `approvalGroupId` and `fieldDesignChangeId` */
  fdcToFDCApprovalGroup: FdcToFdcApprovalGroup;
  /**
   * returns many FDCToFDCApprovalGroup records in a `FDCToFDCApprovalGroupListResponse`
   *
   * records will available in `FDCToFDCApprovalGroupListResponse.records`
   */
  fdcToFDCApprovalGroups: FdcToFdcApprovalGroupListResponse;
  /** returns a single `FDCToFDCConcurrenceGroup` by `concurrenceGroupId` and `fieldDesignChangeId` */
  fdcToFDCConcurrenceGroup: FdcToFdcConcurrenceGroup;
  /**
   * returns many FDCToFDCConcurrenceGroup records in a `FDCToFDCConcurrenceGroupListResponse`
   *
   * records will available in `FDCToFDCConcurrenceGroupListResponse.records`
   */
  fdcToFDCConcurrenceGroups: FdcToFdcConcurrenceGroupListResponse;
  /**
   * returns many FDCToPayItemNoGeometry records in a `FDCToPayItemNoGeometryListResponse`
   *
   * records will available in `FDCToPayItemNoGeometryListResponse.records`
   */
  fdcToPayItemNoGeometries: FdcToPayItemNoGeometryListResponse;
  /** returns a single `FDCToPayItemNoGeometry` by `fieldDesignChangeId` and `payItemId` */
  fdcToPayItemNoGeometry: FdcToPayItemNoGeometry;
  /** returns a single `FieldDesignChange` by `id` */
  fieldDesignChange: FieldDesignChange;
  /**
   * returns many FieldDesignChange records in a `FieldDesignChangeListResponse`
   *
   * records will available in `FieldDesignChangeListResponse.records`
   */
  fieldDesignChanges: FieldDesignChangeListResponse;
  /** returns a single `GenericPlacement` by `globalId` */
  genericPlacement: GenericPlacement;
  /**
   * returns many GenericPlacement records in a `GenericPlacementListResponse`
   *
   * records will available in `GenericPlacementListResponse.records`
   */
  genericPlacements: GenericPlacementListResponse;
  /** returns a single `GoogleSheetPayItemConnection` by `connectionId` */
  googleSheetPayItemConnection: GoogleSheetPayItemConnection;
  /**
   * returns many GoogleSheetPayItemConnection records in a `GoogleSheetPayItemConnectionListResponse`
   *
   * records will available in `GoogleSheetPayItemConnectionListResponse.records`
   */
  googleSheetPayItemConnections: GoogleSheetPayItemConnectionListResponse;
  /** returns a single `GraphQLDeprecationLog` by `id` */
  graphqlDeprecationLog: GraphQlDeprecationLog;
  /**
   * returns many GraphQLDeprecationLog records in a `GraphQLDeprecationLogListResponse`
   *
   * records will available in `GraphQLDeprecationLogListResponse.records`
   */
  graphqlDeprecationLogs: GraphQlDeprecationLogListResponse;
  /** returns a single `IdentifiedFieldIssue` by `reportId` */
  identifiedFieldIssue: IdentifiedFieldIssue;
  identifiedFieldIssueSyncs: Array<IdentifiedFieldIssueSync>;
  /**
   * returns many IdentifiedFieldIssue records in a `IdentifiedFieldIssueListResponse`
   *
   * records will available in `IdentifiedFieldIssueListResponse.records`
   */
  identifiedFieldIssues: IdentifiedFieldIssueListResponse;
  /** returns a single `IFIComment` by `id` */
  ifiComment: IfiComment;
  /**
   * returns many IFIComment records in a `IFICommentListResponse`
   *
   * records will available in `IFICommentListResponse.records`
   */
  ifiComments: IfiCommentListResponse;
  /** returns a single `IFINotification` by `notificationEventId` and `projectId` */
  ifiNotification: IfiNotification;
  /**
   * returns many IFINotification records in a `IFINotificationListResponse`
   *
   * records will available in `IFINotificationListResponse.records`
   */
  ifiNotifications: IfiNotificationListResponse;
  /** returns a single `Issue` by `id` */
  issue: Issue;
  /** returns a single `IssueComment` by `id` */
  issueComment: IssueComment;
  /**
   * returns many IssueComment records in a `IssueCommentListResponse`
   *
   * records will available in `IssueCommentListResponse.records`
   */
  issueComments: IssueCommentListResponse;
  /** returns a single `IssueDispositionType` by `id` */
  issueDispositionType: IssueDispositionType;
  /**
   * returns many IssueDispositionType records in a `IssueDispositionTypeListResponse`
   *
   * records will available in `IssueDispositionTypeListResponse.records`
   */
  issueDispositionTypes: IssueDispositionTypeListResponse;
  /** returns a single `IssueNotification` by `notificationEventId` and `projectId` */
  issueNotification: IssueNotification;
  /**
   * returns many IssueNotification records in a `IssueNotificationListResponse`
   *
   * records will available in `IssueNotificationListResponse.records`
   */
  issueNotifications: IssueNotificationListResponse;
  /** returns a single `IssueQuickLink` by `id` */
  issueQuickLink: IssueQuickLink;
  /**
   * returns many IssueQuickLink records in a `IssueQuickLinkListResponse`
   *
   * records will available in `IssueQuickLinkListResponse.records`
   */
  issueQuickLinks: IssueQuickLinkListResponse;
  /**
   * returns many IssueToPayItemNoGeometry records in a `IssueToPayItemNoGeometryListResponse`
   *
   * records will available in `IssueToPayItemNoGeometryListResponse.records`
   */
  issueToPayItemNoGeometries: IssueToPayItemNoGeometryListResponse;
  /** returns a single `IssueToPayItemNoGeometry` by `issueId` and `payItemId` */
  issueToPayItemNoGeometry: IssueToPayItemNoGeometry;
  /** returns a single `IssueToReport` by `issueId` and `reportId` */
  issueToReport: IssueToReport;
  /**
   * returns many IssueToReport records in a `IssueToReportListResponse`
   *
   * records will available in `IssueToReportListResponse.records`
   */
  issueToReports: IssueToReportListResponse;
  /** returns a single `IssueType` by `id` */
  issueType: IssueType;
  /**
   * returns many IssueType records in a `IssueTypeListResponse`
   *
   * records will available in `IssueTypeListResponse.records`
   */
  issueTypes: IssueTypeListResponse;
  /**
   * returns many Issue records in a `IssueListResponse`
   *
   * records will available in `IssueListResponse.records`
   */
  issues: IssueListResponse;
  /** returns a single `LabTech` by `id` */
  labTech: LabTech;
  /**
   * returns many LabTech records in a `LabTechListResponse`
   *
   * records will available in `LabTechListResponse.records`
   */
  labTechs: LabTechListResponse;
  /** returns a single `LIMSAsphaltJointCore` by `id` */
  limsAsphaltJointCore: LimsAsphaltJointCore;
  /**
   * returns many LIMSAsphaltJointCore records in a `LIMSAsphaltJointCoreListResponse`
   *
   * records will available in `LIMSAsphaltJointCoreListResponse.records`
   */
  limsAsphaltJointCores: LimsAsphaltJointCoreListResponse;
  /** returns a single `LIMSAsphaltLot` by `id` */
  limsAsphaltLot: LimsAsphaltLot;
  /**
   * returns many LIMSAsphaltLotToPayItemNoGeometry records in a `LIMSAsphaltLotToPayItemNoGeometryListResponse`
   *
   * records will available in `LIMSAsphaltLotToPayItemNoGeometryListResponse.records`
   */
  limsAsphaltLotToPayItemNoGeometries: LimsAsphaltLotToPayItemNoGeometryListResponse;
  /** returns a single `LIMSAsphaltLotToPayItemNoGeometry` by `lotId` and `payItemId` */
  limsAsphaltLotToPayItemNoGeometry: LimsAsphaltLotToPayItemNoGeometry;
  /**
   * returns many LIMSAsphaltLot records in a `LIMSAsphaltLotListResponse`
   *
   * records will available in `LIMSAsphaltLotListResponse.records`
   */
  limsAsphaltLots: LimsAsphaltLotListResponse;
  /** returns a single `LIMSAsphaltMatCore` by `id` */
  limsAsphaltMatCore: LimsAsphaltMatCore;
  /**
   * returns many LIMSAsphaltMatCore records in a `LIMSAsphaltMatCoreListResponse`
   *
   * records will available in `LIMSAsphaltMatCoreListResponse.records`
   */
  limsAsphaltMatCores: LimsAsphaltMatCoreListResponse;
  /** returns a single `LIMSAsphaltMixDesignTarget` by `id` */
  limsAsphaltMixDesignTarget: LimsAsphaltMixDesignTarget;
  /**
   * returns many LIMSAsphaltMixDesignTarget records in a `LIMSAsphaltMixDesignTargetListResponse`
   *
   * records will available in `LIMSAsphaltMixDesignTargetListResponse.records`
   */
  limsAsphaltMixDesignTargets: LimsAsphaltMixDesignTargetListResponse;
  /** returns a single `LIMSAsphaltSample` by `id` */
  limsAsphaltSample: LimsAsphaltSample;
  /** returns a single `LIMSAsphaltSampleResult` by `sampleId` and `targetId` */
  limsAsphaltSampleResult: LimsAsphaltSampleResult;
  /**
   * returns many LIMSAsphaltSampleResult records in a `LIMSAsphaltSampleResultListResponse`
   *
   * records will available in `LIMSAsphaltSampleResultListResponse.records`
   */
  limsAsphaltSampleResults: LimsAsphaltSampleResultListResponse;
  /**
   * returns many LIMSAsphaltSample records in a `LIMSAsphaltSampleListResponse`
   *
   * records will available in `LIMSAsphaltSampleListResponse.records`
   */
  limsAsphaltSamples: LimsAsphaltSampleListResponse;
  /** returns a single `Lot` by `globalId` */
  lot: Lot;
  /**
   * returns many LotIFISettings records in a `LotIFISettingsListResponse`
   *
   * records will available in `LotIFISettingsListResponse.records`
   */
  lotIFISettings: LotIfiSettingsListResponse;
  /**
   * returns many Lot records in a `LotListResponse`
   *
   * records will available in `LotListResponse.records`
   */
  lots: LotListResponse;
  /** returns a single `MaterialRequirement` by `globalId` */
  materialRequirement: MaterialRequirement;
  /**
   * returns many MaterialRequirement records in a `MaterialRequirementListResponse`
   *
   * records will available in `MaterialRequirementListResponse.records`
   */
  materialRequirements: MaterialRequirementListResponse;
  /** returns a single `MaterialSource` by `globalId` */
  materialSource: MaterialSource;
  /**
   * returns many MaterialSource records in a `MaterialSourceListResponse`
   *
   * records will available in `MaterialSourceListResponse.records`
   */
  materialSources: MaterialSourceListResponse;
  /** returns a single `MaterialType` by `globalId` */
  materialType: MaterialType;
  /**
   * returns many MaterialType records in a `MaterialTypeListResponse`
   *
   * records will available in `MaterialTypeListResponse.records`
   */
  materialTypes: MaterialTypeListResponse;
  /** returns a single `MediaUpload` by `globalId` */
  mediaUpload: MediaUpload;
  /**
   * returns many MediaUpload records in a `MediaUploadListResponse`
   *
   * records will available in `MediaUploadListResponse.records`
   */
  mediaUploads: MediaUploadListResponse;
  /** returns a single `NonUserEmail` by `id` */
  nonUserEmail: NonUserEmail;
  /**
   * returns many NonUserEmail records in a `NonUserEmailListResponse`
   *
   * records will available in `NonUserEmailListResponse.records`
   */
  nonUserEmails: NonUserEmailListResponse;
  orphanedSharePointResources: OrphanedSharePointResources;
  /** returns a single `PayItem` by `globalId` */
  payItem: PayItem;
  /** returns a single `PayItemConnection` by `id` */
  payItemConnection: PayItemConnection;
  /** returns a single `PayItemConnectionGroup` by `id` */
  payItemConnectionGroup: PayItemConnectionGroup;
  /**
   * returns many ProjectToInternalConnection records in a `ProjectToInternalConnectionListResponse`
   *
   * records will available in `ProjectToInternalConnectionListResponse.records`
   */
  payItemConnectionGroupToInternalConnections: ProjectToInternalConnectionListResponse;
  /**
   * returns many PayItemConnectionGroup records in a `PayItemConnectionGroupListResponse`
   *
   * records will available in `PayItemConnectionGroupListResponse.records`
   */
  payItemConnectionGroups: PayItemConnectionGroupListResponse;
  /**
   * returns many PayItemConnection records in a `PayItemConnectionListResponse`
   *
   * records will available in `PayItemConnectionListResponse.records`
   */
  payItemConnections: PayItemConnectionListResponse;
  /** returns a single `PayItemGroup` by `globalId` */
  payItemGroup: PayItemGroup;
  /**
   * returns many PayItemGroup records in a `PayItemGroupListResponse`
   *
   * records will available in `PayItemGroupListResponse.records`
   */
  payItemGroups: PayItemGroupListResponse;
  /**
   * returns many PayItemNoGeometry records in a `PayItemNoGeometryListResponse`
   *
   * records will available in `PayItemNoGeometryListResponse.records`
   */
  payItemNoGeometries: PayItemNoGeometryListResponse;
  /** returns a single `PayItemNoGeometry` by `globalId` */
  payItemNoGeometry: PayItemNoGeometry;
  /**
   * returns many PayItem records in a `PayItemListResponse`
   *
   * records will available in `PayItemListResponse.records`
   */
  payItems: PayItemListResponse;
  /** returns a single `PDFDesignLayer` by `index` and `projectId` */
  pdfDesignLayer: PdfDesignLayer;
  /**
   * returns many PDFDesignLayer records in a `PDFDesignLayerListResponse`
   *
   * records will available in `PDFDesignLayerListResponse.records`
   */
  pdfDesignLayers: PdfDesignLayerListResponse;
  photoExportAverages: Array<PhotoExportAverage>;
  /** returns a single `PhotoExportRequest` by `id` */
  photoExportRequest: PhotoExportRequest;
  /**
   * returns many PhotoExportRequest records in a `PhotoExportRequestListResponse`
   *
   * records will available in `PhotoExportRequestListResponse.records`
   */
  photoExportRequests: PhotoExportRequestListResponse;
  /** returns a single `PhotoFilename` by `classTypeId` and `projectId` */
  photoFilename: PhotoFilename;
  photoFilenameExample: Maybe<Scalars['String']>;
  photoFilenameTemplate: Maybe<Scalars['String']>;
  /**
   * returns many PhotoFilename records in a `PhotoFilenameListResponse`
   *
   * records will available in `PhotoFilenameListResponse.records`
   */
  photoFilenames: PhotoFilenameListResponse;
  /** returns a single `Proctor` by `globalId` */
  proctor: Proctor;
  /**
   * returns many Proctor records in a `ProctorListResponse`
   *
   * records will available in `ProctorListResponse.records`
   */
  proctors: ProctorListResponse;
  /** returns a single `Project` by `globalId` */
  project: Project;
  /** returns a single `ProjectMetadata` by `projectId` */
  projectMetadata: ProjectMetadata;
  /**
   * returns many ProjectMetadata records in a `ProjectMetadataListResponse`
   *
   * records will available in `ProjectMetadataListResponse.records`
   */
  projectMetadatas: ProjectMetadataListResponse;
  /** returns a single `ProjectToCIMSOnlineAdmin` by `projectId` and `userId` */
  projectToCIMSOnlineAdmin: ProjectToCimsOnlineAdmin;
  /**
   * returns many ProjectToCIMSOnlineAdmin records in a `ProjectToCIMSOnlineAdminListResponse`
   *
   * records will available in `ProjectToCIMSOnlineAdminListResponse.records`
   */
  projectToCIMSOnlineAdmins: ProjectToCimsOnlineAdminListResponse;
  /** returns a single `ProjectToIFIReportType` by `projectId` and `reportTypeId` */
  projectToIFIReportType: ProjectToIfiReportType;
  /**
   * returns many ProjectToIFIReportType records in a `ProjectToIFIReportTypeListResponse`
   *
   * records will available in `ProjectToIFIReportTypeListResponse.records`
   */
  projectToIFIReportTypes: ProjectToIfiReportTypeListResponse;
  /** returns a single `ProjectToInternalConnection` by `groupId`, `internalConnectionId`, and `projectId` */
  projectToInternalConnection: ProjectToInternalConnection;
  /** returns a single `ProjectToUserGroup` by `projectId` and `userGroupId` */
  projectToUserGroup: ProjectToUserGroup;
  /**
   * returns many ProjectToUserGroup records in a `ProjectToUserGroupListResponse`
   *
   * records will available in `ProjectToUserGroupListResponse.records`
   */
  projectToUserGroups: ProjectToUserGroupListResponse;
  /**
   * returns many Project records in a `ProjectListResponse`
   *
   * records will available in `ProjectListResponse.records`
   */
  projects: ProjectListResponse;
  /** returns a single `Reading1` by `globalId` */
  reading1: Reading1;
  /**
   * returns many Reading1 records in a `Reading1ListResponse`
   *
   * records will available in `Reading1ListResponse.records`
   */
  reading1s: Reading1ListResponse;
  reportAverages: Array<BatchReportAverage>;
  /** returns a single `ReportFilename` by `projectId` and `reportId` */
  reportFilename: ReportFilename;
  reportFilenameExample: Maybe<Scalars['String']>;
  reportFilenameTemplate: Maybe<Scalars['String']>;
  /**
   * returns many ReportFilename records in a `ReportFilenameListResponse`
   *
   * records will available in `ReportFilenameListResponse.records`
   */
  reportFilenames: ReportFilenameListResponse;
  /** returns a single `ReportToTag` by `globalId` */
  reportToTag: ReportToTag;
  /**
   * returns many ReportToTag records in a `ReportToTagListResponse`
   *
   * records will available in `ReportToTagListResponse.records`
   */
  reportToTags: ReportToTagListResponse;
  /** returns a single `RequestForInformation` by `id` */
  requestForInformation: RequestForInformation;
  /**
   * returns many RequestForInformation records in a `RequestForInformationListResponse`
   *
   * records will available in `RequestForInformationListResponse.records`
   */
  requestsForInformation: RequestForInformationListResponse;
  /** returns a single `RFIComment` by `id` */
  rfiComment: RfiComment;
  /**
   * returns many RFIComment records in a `RFICommentListResponse`
   *
   * records will available in `RFICommentListResponse.records`
   */
  rfiComments: RfiCommentListResponse;
  /** returns a single `RFINotification` by `notificationEventId` and `projectId` */
  rfiNotification: RfiNotification;
  /**
   * returns many RFINotification records in a `RFINotificationListResponse`
   *
   * records will available in `RFINotificationListResponse.records`
   */
  rfiNotifications: RfiNotificationListResponse;
  /** returns a single `RFIOrganization` by `id` */
  rfiOrganization: RfiOrganization;
  /**
   * returns many RFIOrganization records in a `RFIOrganizationListResponse`
   *
   * records will available in `RFIOrganizationListResponse.records`
   */
  rfiOrganizations: RfiOrganizationListResponse;
  /** returns a single `RFIQuickLink` by `id` */
  rfiQuickLink: RfiQuickLink;
  /**
   * returns many RFIQuickLink records in a `RFIQuickLinkListResponse`
   *
   * records will available in `RFIQuickLinkListResponse.records`
   */
  rfiQuickLinks: RfiQuickLinkListResponse;
  /** returns a single `RFIResponse` by `id` */
  rfiResponse: RfiResponse;
  /** returns a single `RFIResponseDiscipline` by `id` */
  rfiResponseDiscipline: RfiResponseDiscipline;
  /**
   * returns many RFIResponseDiscipline records in a `RFIResponseDisciplineListResponse`
   *
   * records will available in `RFIResponseDisciplineListResponse.records`
   */
  rfiResponseDisciplines: RfiResponseDisciplineListResponse;
  /**
   * returns many RFIResponse records in a `RFIResponseListResponse`
   *
   * records will available in `RFIResponseListResponse.records`
   */
  rfiResponses: RfiResponseListResponse;
  /** returns a single `Role` by `id` */
  role: Role;
  /**
   * returns many Role records in a `RoleListResponse`
   *
   * records will available in `RoleListResponse.records`
   */
  roles: RoleListResponse;
  sharePointResource: Maybe<SharePointResource>;
  /** returns a single `Structure` by `globalId` */
  structure: Structure;
  /** returns a single `StructureType` by `globalId` */
  structureType: StructureType;
  /**
   * returns many StructureType records in a `StructureTypeListResponse`
   *
   * records will available in `StructureTypeListResponse.records`
   */
  structureTypes: StructureTypeListResponse;
  /**
   * returns many Structure records in a `StructureListResponse`
   *
   * records will available in `StructureListResponse.records`
   */
  structures: StructureListResponse;
  /** returns a single `Tag` by `globalId` */
  tag: Tag;
  /**
   * returns many TagCategory records in a `TagCategoryListResponse`
   *
   * records will available in `TagCategoryListResponse.records`
   */
  tagCategories: TagCategoryListResponse;
  /** returns a single `TagCategory` by `globalId` */
  tagCategory: TagCategory;
  /**
   * returns many TagToTagCategory records in a `TagToTagCategoryListResponse`
   *
   * records will available in `TagToTagCategoryListResponse.records`
   */
  tagToTagCategories: TagToTagCategoryListResponse;
  /** returns a single `TagToTagCategory` by `globalId` */
  tagToTagCategory: TagToTagCategory;
  /**
   * returns many Tag records in a `TagListResponse`
   *
   * records will available in `TagListResponse.records`
   */
  tags: TagListResponse;
  /** returns a single `Technician` by `globalId` */
  technician: Technician;
  /** returns a single `TechnicianPermission` by `globalId` */
  technicianPermission: TechnicianPermission;
  /**
   * returns many TechnicianPermission records in a `TechnicianPermissionListResponse`
   *
   * records will available in `TechnicianPermissionListResponse.records`
   */
  technicianPermissions: TechnicianPermissionListResponse;
  /**
   * returns many Technician records in a `TechnicianListResponse`
   *
   * records will available in `TechnicianListResponse.records`
   */
  technicians: TechnicianListResponse;
  /** returns a single `TestingLab` by `id` */
  testingLab: TestingLab;
  /**
   * returns many TestingLab records in a `TestingLabListResponse`
   *
   * records will available in `TestingLabListResponse.records`
   */
  testingLabs: TestingLabListResponse;
  /** returns a single `User` by `id` */
  user: User;
  /** returns a single `UserGroup` by `id` */
  userGroup: UserGroup;
  /**
   * returns many UserGroup records in a `UserGroupListResponse`
   *
   * records will available in `UserGroupListResponse.records`
   */
  userGroups: UserGroupListResponse;
  /** returns a single `UserToDeveloperPermission` by `permissionId` and `userId` */
  userToDeveloperPermission: UserToDeveloperPermission;
  /**
   * returns many UserToDeveloperPermission records in a `UserToDeveloperPermissionListResponse`
   *
   * records will available in `UserToDeveloperPermissionListResponse.records`
   */
  userToDeveloperPermissions: UserToDeveloperPermissionListResponse;
  /** returns a single `UserToProjectToPermission` by `permissionId`, `projectId`, and `userId` */
  userToProjectToPermission: UserToProjectToPermission;
  /**
   * returns many UserToProjectToPermission records in a `UserToProjectToPermissionListResponse`
   *
   * records will available in `UserToProjectToPermissionListResponse.records`
   */
  userToProjectToPermissions: UserToProjectToPermissionListResponse;
  /**
   * returns many User records in a `UserListResponse`
   *
   * records will available in `UserListResponse.records`
   */
  users: UserListResponse;
};


export type QueryAlignmentArgs = {
  globalId: Scalars['String'];
};


export type QueryAlignmentsArgs = {
  alignmentListInput: AlignmentListInput;
};


export type QueryApiKeysArgs = {
  apiKeyListInput: ApiKeyListInput;
};


export type QueryAsphaltCoreMeasurementArgs = {
  globalId: Scalars['String'];
};


export type QueryAsphaltCoreMeasurementsArgs = {
  asphaltCoreMeasurementListInput: AsphaltCoreMeasurementListInput;
};


export type QueryAsphaltLotArgs = {
  globalId: Scalars['String'];
};


export type QueryAsphaltLotsArgs = {
  asphaltLotListInput: AsphaltLotListInput;
};


export type QueryAsphaltMaterialArgs = {
  globalId: Scalars['String'];
};


export type QueryAsphaltMaterialSourceArgs = {
  globalId: Scalars['String'];
};


export type QueryAsphaltMaterialSourcesArgs = {
  asphaltMaterialSourceListInput: AsphaltMaterialSourceListInput;
};


export type QueryAsphaltMaterialsArgs = {
  asphaltMaterialListInput: AsphaltMaterialListInput;
};


export type QueryAsphaltMixDesignArgs = {
  globalId: Scalars['String'];
};


export type QueryAsphaltMixDesignTargetPercentageArgs = {
  mixDesignId: Scalars['String'];
  targetId: Scalars['String'];
};


export type QueryAsphaltMixDesignTargetPercentagesArgs = {
  asphaltMixDesignTargetPercentageListInput: AsphaltMixDesignTargetPercentageListInput;
};


export type QueryAsphaltMixDesignsArgs = {
  asphaltMixDesignListInput: AsphaltMixDesignListInput;
};


export type QueryAsphaltPlacementArgs = {
  globalId: Scalars['String'];
};


export type QueryAsphaltPlacementJointArgs = {
  globalId: Scalars['String'];
};


export type QueryAsphaltPlacementJointsArgs = {
  asphaltPlacementJointListInput: AsphaltPlacementJointListInput;
};


export type QueryAsphaltPlacementsArgs = {
  asphaltPlacementListInput: AsphaltPlacementListInput;
};


export type QueryAsphaltSampleArgs = {
  globalId: Scalars['String'];
};


export type QueryAsphaltSamplesArgs = {
  asphaltSampleListInput: AsphaltSampleListInput;
};


export type QueryBatchReportRequestArgs = {
  id: Scalars['String'];
};


export type QueryBatchReportRequestsArgs = {
  batchReportRequestListInput: BatchReportRequestListInput;
};


export type QueryCasCommentArgs = {
  id: Scalars['String'];
};


export type QueryCasCommentsArgs = {
  casCommentListInput: CasCommentListInput;
};


export type QueryCasDispositionTypeArgs = {
  id: Scalars['String'];
};


export type QueryCasDispositionTypesArgs = {
  casDispositionTypeListInput: CasDispositionTypeListInput;
};


export type QueryCasNotificationArgs = {
  notificationEventId: Scalars['String'];
  projectId: Scalars['String'];
};


export type QueryCasNotificationsArgs = {
  casNotificationListInput: CasNotificationListInput;
};


export type QueryCasQuickLinkArgs = {
  id: Scalars['String'];
};


export type QueryCasQuickLinksArgs = {
  casQuickLinkListInput: CasQuickLinkListInput;
};


export type QueryCasRoutingGroupArgs = {
  id: Scalars['String'];
};


export type QueryCasRoutingGroupsArgs = {
  casRoutingGroupListInput: CasRoutingGroupListInput;
};


export type QueryCasSubtypeArgs = {
  id: Scalars['String'];
};


export type QueryCasSubtypesArgs = {
  casSubtypeListInput: CasSubtypeListInput;
};


export type QueryCasToCasRoutingGroupArgs = {
  routingGroupId: Scalars['String'];
  submittalId: Scalars['String'];
};


export type QueryCasToCasRoutingGroupsArgs = {
  casToCASRoutingGroupListInput: CasToCasRoutingGroupListInput;
};


export type QueryCasToPayItemNoGeometriesArgs = {
  casToPayItemNoGeometryListInput: CasToPayItemNoGeometryListInput;
};


export type QueryCasToPayItemNoGeometryArgs = {
  payItemId: Scalars['String'];
  submittalId: Scalars['String'];
};


export type QueryCasTypeArgs = {
  id: Scalars['String'];
};


export type QueryCasTypesArgs = {
  casTypeListInput: CasTypeListInput;
};


export type QueryConcreteCoreBreakDataArgs = {
  concreteCoreMeasurementId: Scalars['String'];
};


export type QueryConcreteCoreBreakDatasArgs = {
  concreteCoreBreakDataListInput: ConcreteCoreBreakDataListInput;
};


export type QueryConcreteCoreMeasurementArgs = {
  globalId: Scalars['String'];
};


export type QueryConcreteCoreMeasurementsArgs = {
  concreteCoreMeasurementListInput: ConcreteCoreMeasurementListInput;
};


export type QueryConcreteCuringMethodArgs = {
  globalId: Scalars['String'];
};


export type QueryConcreteCuringMethodsArgs = {
  concreteCuringMethodListInput: ConcreteCuringMethodListInput;
};


export type QueryConcreteFieldDataArgs = {
  globalId: Scalars['String'];
};


export type QueryConcreteFieldDatasArgs = {
  concreteFieldDataListInput: ConcreteFieldDataListInput;
};


export type QueryConcreteMaterialArgs = {
  globalId: Scalars['String'];
};


export type QueryConcreteMaterialsArgs = {
  concreteMaterialListInput: ConcreteMaterialListInput;
};


export type QueryConcreteMixDesignArgs = {
  globalId: Scalars['String'];
};


export type QueryConcreteMixDesignsArgs = {
  concreteMixDesignListInput: ConcreteMixDesignListInput;
};


export type QueryConcreteNotificationArgs = {
  notificationEventId: Scalars['String'];
  projectId: Scalars['String'];
};


export type QueryConcreteNotificationsArgs = {
  concreteNotificationListInput: ConcreteNotificationListInput;
};


export type QueryConcretePlacementArgs = {
  globalId: Scalars['String'];
};


export type QueryConcretePlacementsArgs = {
  concretePlacementListInput: ConcretePlacementListInput;
};


export type QueryConcreteProductionDataArgs = {
  globalId: Scalars['String'];
};


export type QueryConcreteProductionDatasArgs = {
  concreteProductionDataListInput: ConcreteProductionDataListInput;
};


export type QueryConcreteSampleLocationArgs = {
  globalId: Scalars['String'];
};


export type QueryConcreteSampleLocationsArgs = {
  concreteSampleLocationListInput: ConcreteSampleLocationListInput;
};


export type QueryConcreteTestArgs = {
  globalId: Scalars['String'];
};


export type QueryConcreteTestBreakDataArgs = {
  id: Scalars['Int'];
};


export type QueryConcreteTestBreakDatasArgs = {
  concreteTestBreakDataListInput: ConcreteTestBreakDataListInput;
};


export type QueryConcreteTestIfiSettingsArgs = {
  concreteTestIFISettingsListInput: ConcreteTestIfiSettingsListInput;
};


export type QueryConcreteTestSetArgs = {
  globalId: Scalars['String'];
};


export type QueryConcreteTestSetMetadataArgs = {
  concreteTestSetId: Scalars['String'];
};


export type QueryConcreteTestSetMetadatasArgs = {
  concreteTestSetMetaDataListInput: ConcreteTestSetMetadataListInput;
};


export type QueryConcreteTestSetsArgs = {
  concreteTestSetListInput: ConcreteTestSetListInput;
};


export type QueryConcreteTestsArgs = {
  concreteTestListInput: ConcreteTestListInput;
};


export type QueryConstructionAdminSubmittalArgs = {
  id: Scalars['String'];
};


export type QueryConstructionAdminSubmittalsArgs = {
  constructionAdminSubmittalListInput: ConstructionAdminSubmittalListInput;
};


export type QueryContractorArgs = {
  globalId: Scalars['String'];
};


export type QueryContractorsArgs = {
  contractorListInput: ContractorListInput;
};


export type QueryCustomFieldArgs = {
  id: Scalars['String'];
};


export type QueryCustomFieldToClassTypeArgs = {
  classTypeId: Scalars['String'];
  customFieldId: Scalars['String'];
};


export type QueryCustomFieldToClassTypesArgs = {
  customFieldToClassTypeListInput: CustomFieldToClassTypeListInput;
};


export type QueryCustomFieldsArgs = {
  customFieldListInput: CustomFieldListInput;
};


export type QueryCustomListItemArgs = {
  id: Scalars['String'];
};


export type QueryCustomListItemsArgs = {
  customListItemListInput: CustomListItemListInput;
};


export type QueryDailyInspectionControlPointArgs = {
  globalId: Scalars['String'];
};


export type QueryDailyInspectionControlPointIfiSettingsArgs = {
  dailyInspectionControlPointIFISettingsListInput: DailyInspectionControlPointIfiSettingsListInput;
};


export type QueryDailyInspectionControlPointTypeArgs = {
  globalId: Scalars['String'];
};


export type QueryDailyInspectionControlPointTypesArgs = {
  dailyInspectionControlPointTypeListInput: DailyInspectionControlPointTypeListInput;
};


export type QueryDailyInspectionControlPointsArgs = {
  dailyInspectionControlPointListInput: DailyInspectionControlPointListInput;
};


export type QueryDailyInspectionDailyContractorEquipmentArgs = {
  globalId: Scalars['String'];
};


export type QueryDailyInspectionDailyContractorEquipmentsArgs = {
  dailyInspectionDailyContractorEquipmentListInput: DailyInspectionDailyContractorEquipmentListInput;
};


export type QueryDailyInspectionDailyContractorPersonArgs = {
  globalId: Scalars['String'];
};


export type QueryDailyInspectionDailyContractorPersonsArgs = {
  dailyInspectionDailyContractorPersonListInput: DailyInspectionDailyContractorPersonListInput;
};


export type QueryDailyInspectionFeatureEngineeringJudgementArgs = {
  globalId: Scalars['String'];
};


export type QueryDailyInspectionFeatureEngineeringJudgementsArgs = {
  dailyInspectionFeatureEngineeringJudgementListInput: DailyInspectionFeatureEngineeringJudgementListInput;
};


export type QueryDailyInspectionFormArgs = {
  globalId: Scalars['String'];
};


export type QueryDailyInspectionFormAnswerArgs = {
  globalId: Scalars['String'];
};


export type QueryDailyInspectionFormAnswersArgs = {
  dailyInspectionFormAnswerListInput: DailyInspectionFormAnswerListInput;
};


export type QueryDailyInspectionFormQuestionArgs = {
  globalId: Scalars['String'];
};


export type QueryDailyInspectionFormQuestionsArgs = {
  dailyInspectionFormQuestionListInput: DailyInspectionFormQuestionListInput;
};


export type QueryDailyInspectionFormsArgs = {
  dailyInspectionFormListInput: DailyInspectionFormListInput;
};


export type QueryDailyInspectionInspectionArgs = {
  globalId: Scalars['String'];
};


export type QueryDailyInspectionInspectionIfiSettingsArgs = {
  dailyInspectionInspectionIFISettingsListInput: DailyInspectionInspectionIfiSettingsListInput;
};


export type QueryDailyInspectionInspectionsArgs = {
  dailyInspectionInspectionListInput: DailyInspectionInspectionListInput;
};


export type QueryDailyInspectionLookUpArgs = {
  globalId: Scalars['String'];
};


export type QueryDailyInspectionLookUpsArgs = {
  dailyInspectionLookUpListInput: DailyInspectionLookUpListInput;
};


export type QueryDailyInspectionPunchListArgs = {
  globalId: Scalars['String'];
};


export type QueryDailyInspectionPunchListIfiSettingsArgs = {
  dailyInspectionPunchListIFISettingsListInput: DailyInspectionPunchListIfiSettingsListInput;
};


export type QueryDailyInspectionPunchListsArgs = {
  dailyInspectionPunchListListInput: DailyInspectionPunchListListInput;
};


export type QueryDailyInspectionWorkTypeArgs = {
  globalId: Scalars['String'];
};


export type QueryDailyInspectionWorkTypesArgs = {
  dailyInspectionWorkTypeListInput: DailyInspectionWorkTypeListInput;
};


export type QueryDensityTestArgs = {
  globalId: Scalars['String'];
};


export type QueryDensityTestIfiSettingsArgs = {
  densityTestIFISettingsListInput: DensityTestIfiSettingsListInput;
};


export type QueryDensityTestsArgs = {
  densityTestListInput: DensityTestListInput;
};


export type QueryDesignSubmittalArgs = {
  id: Scalars['String'];
};


export type QueryDesignSubmittalsArgs = {
  designSubmittalListInput: DesignSubmittalListInput;
};


export type QueryDocumentChecklistItemArgs = {
  id: Scalars['Int'];
};


export type QueryDocumentChecklistItemToConcreteMaterialArgs = {
  concreteMaterialId: Scalars['String'];
  documentChecklistItemId: Scalars['Int'];
};


export type QueryDocumentChecklistItemToConcreteMaterialsArgs = {
  documentChecklistItemToConcreteMaterialListInput: DocumentChecklistItemToConcreteMaterialListInput;
};


export type QueryDocumentChecklistItemsArgs = {
  documentChecklistItemListInput: DocumentChecklistItemListInput;
};


export type QueryDocumentChecklistValueArgs = {
  concreteTestSetId: Scalars['String'];
  documentChecklistItemId: Scalars['Int'];
};


export type QueryDocumentChecklistValuesArgs = {
  documentChecklistValueListInput: DocumentChecklistValueListInput;
};


export type QueryDsActionArgs = {
  id: Scalars['String'];
};


export type QueryDsActionsArgs = {
  dsActionListInput: DsActionListInput;
};


export type QueryDsDisciplineArgs = {
  id: Scalars['String'];
};


export type QueryDsDisciplinesArgs = {
  dsDisciplineListInput: DsDisciplineListInput;
};


export type QueryDsNotificationArgs = {
  notificationEventId: Scalars['String'];
  projectId: Scalars['String'];
};


export type QueryDsNotificationsArgs = {
  dsNotificationListInput: DsNotificationListInput;
};


export type QueryDsOrganizationArgs = {
  id: Scalars['String'];
};


export type QueryDsOrganizationsArgs = {
  dsOrganizationListInput: DsOrganizationListInput;
};


export type QueryDsQuickLinkArgs = {
  id: Scalars['String'];
};


export type QueryDsQuickLinksArgs = {
  dsQuickLinkListInput: DsQuickLinkListInput;
};


export type QueryDsToDsDisciplineArgs = {
  disciplineId: Scalars['String'];
  submittalId: Scalars['String'];
};


export type QueryDsToDsDisciplinesArgs = {
  dsToDSRoutingGroupListInput: DsToDsDisciplineListInput;
};


export type QueryDsToPayItemNoGeometriesArgs = {
  dsToPayItemNoGeometryListInput: DsToPayItemNoGeometryListInput;
};


export type QueryDsToPayItemNoGeometryArgs = {
  payItemId: Scalars['String'];
  submittalId: Scalars['String'];
};


export type QueryDsTypeArgs = {
  id: Scalars['String'];
};


export type QueryDsTypesArgs = {
  dsTypeListInput: DsTypeListInput;
};


export type QueryEjNotificationArgs = {
  notificationEventId: Scalars['String'];
  projectId: Scalars['String'];
};


export type QueryEjToPayItemNoGeometryArgs = {
  judgementId: Scalars['String'];
  payItemId: Scalars['String'];
};


export type QueryEjNotificationsArgs = {
  eJNotificationListInput: EjNotificationListInput;
};


export type QueryEjQuickLinkArgs = {
  id: Scalars['String'];
};


export type QueryEjQuickLinksArgs = {
  ejQuickLinkListInput: EjQuickLinkListInput;
};


export type QueryEjToPayItemNoGeometriesArgs = {
  ejToPayItemNoGeometryListInput: EjToPayItemNoGeometryListInput;
};


export type QueryEjToReportArgs = {
  ejId: Scalars['String'];
  reportId: Scalars['String'];
};


export type QueryEjToReportsArgs = {
  ejToReportListInput: EjToReportListInput;
};


export type QueryEjTypeArgs = {
  id: Scalars['String'];
};


export type QueryEjTypesArgs = {
  ejTypeListInput: EjTypeListInput;
};


export type QueryEngineeringJudgementArgs = {
  id: Scalars['String'];
};


export type QueryEngineeringJudgementsArgs = {
  engineeringJudgementListInput: EngineeringJudgementListInput;
};


export type QueryFdcApprovalGroupArgs = {
  id: Scalars['String'];
};


export type QueryFdcApprovalGroupsArgs = {
  fdcApprovalGroupListInput: FdcApprovalGroupListInput;
};


export type QueryFdcCommentArgs = {
  id: Scalars['String'];
};


export type QueryFdcCommentsArgs = {
  fdcCommentListInput: FdcCommentListInput;
};


export type QueryFdcConcurrenceGroupArgs = {
  id: Scalars['String'];
};


export type QueryFdcConcurrenceGroupsArgs = {
  fdcConcurrenceGroupListInput: FdcConcurrenceGroupListInput;
};


export type QueryFdcConcurrenceLevelArgs = {
  id: Scalars['String'];
};


export type QueryFdcConcurrenceLevelsArgs = {
  fdcConcurrenceLevelListInput: FdcConcurrenceLevelListInput;
};


export type QueryFdcDisciplineArgs = {
  id: Scalars['String'];
};


export type QueryFdcDisciplinesArgs = {
  fdcDisciplineListInput: FdcDisciplineListInput;
};


export type QueryFdcNotificationArgs = {
  notificationEventId: Scalars['String'];
  projectId: Scalars['String'];
};


export type QueryFdcNotificationsArgs = {
  fdcNotificationListInput: FdcNotificationListInput;
};


export type QueryFdcQuickLinkArgs = {
  id: Scalars['String'];
};


export type QueryFdcQuickLinksArgs = {
  fdcQuickLinkListInput: FdcQuickLinkListInput;
};


export type QueryFdcToFdcApprovalGroupArgs = {
  approvalGroupId: Scalars['String'];
  fieldDesignChangeId: Scalars['String'];
};


export type QueryFdcToFdcApprovalGroupsArgs = {
  fdcToFDCApprovalGroupListInput: FdcToFdcApprovalGroupListInput;
};


export type QueryFdcToFdcConcurrenceGroupArgs = {
  concurrenceGroupId: Scalars['String'];
  fieldDesignChangeId: Scalars['String'];
};


export type QueryFdcToFdcConcurrenceGroupsArgs = {
  fdcToFDCConcurrenceGroupListInput: FdcToFdcConcurrenceGroupListInput;
};


export type QueryFdcToPayItemNoGeometriesArgs = {
  fdcToPayItemNoGeometryListInput: FdcToPayItemNoGeometryListInput;
};


export type QueryFdcToPayItemNoGeometryArgs = {
  fieldDesignChangeId: Scalars['String'];
  payItemId: Scalars['String'];
};


export type QueryFieldDesignChangeArgs = {
  id: Scalars['String'];
};


export type QueryFieldDesignChangesArgs = {
  fieldDesignChangeListInput: FieldDesignChangeListInput;
};


export type QueryGenericPlacementArgs = {
  globalId: Scalars['String'];
};


export type QueryGenericPlacementsArgs = {
  genericPlacementListInput: GenericPlacementListInput;
};


export type QueryGoogleSheetPayItemConnectionArgs = {
  connectionId: Scalars['String'];
};


export type QueryGoogleSheetPayItemConnectionsArgs = {
  googleSheetPayItemConnectionListInput: GoogleSheetPayItemConnectionListInput;
};


export type QueryGraphqlDeprecationLogArgs = {
  id: Scalars['Int'];
};


export type QueryGraphqlDeprecationLogsArgs = {
  graphQLDeprecationLogListInput: GraphQlDeprecationLogListInput;
};


export type QueryIdentifiedFieldIssueArgs = {
  reportId: Scalars['String'];
};


export type QueryIdentifiedFieldIssueSyncsArgs = {
  projectId?: InputMaybe<Scalars['String']>;
};


export type QueryIdentifiedFieldIssuesArgs = {
  identifiedFieldIssueListInput: IdentifiedFieldIssueListInput;
};


export type QueryIfiCommentArgs = {
  id: Scalars['String'];
};


export type QueryIfiCommentsArgs = {
  ifiCommentListInput: IfiCommentListInput;
};


export type QueryIfiNotificationArgs = {
  notificationEventId: Scalars['String'];
  projectId: Scalars['String'];
};


export type QueryIfiNotificationsArgs = {
  ifiNotificationListInput: IfiNotificationListInput;
};


export type QueryIssueArgs = {
  id: Scalars['String'];
};


export type QueryIssueCommentArgs = {
  id: Scalars['String'];
};


export type QueryIssueCommentsArgs = {
  issueCommentListInput: IssueCommentListInput;
};


export type QueryIssueDispositionTypeArgs = {
  id: Scalars['String'];
};


export type QueryIssueDispositionTypesArgs = {
  issueDispositionTypeListInput: IssueDispositionTypeListInput;
};


export type QueryIssueNotificationArgs = {
  notificationEventId: Scalars['String'];
  projectId: Scalars['String'];
};


export type QueryIssueNotificationsArgs = {
  issueNotificationListInput: IssueNotificationListInput;
};


export type QueryIssueQuickLinkArgs = {
  id: Scalars['String'];
};


export type QueryIssueQuickLinksArgs = {
  issueQuickLinkListInput: IssueQuickLinkListInput;
};


export type QueryIssueToPayItemNoGeometriesArgs = {
  issueToPayItemNoGeometryListInput: IssueToPayItemNoGeometryListInput;
};


export type QueryIssueToPayItemNoGeometryArgs = {
  issueId: Scalars['String'];
  payItemId: Scalars['String'];
};


export type QueryIssueToReportArgs = {
  issueId: Scalars['String'];
  reportId: Scalars['String'];
};


export type QueryIssueToReportsArgs = {
  issueToReportListInput: IssueToReportListInput;
};


export type QueryIssueTypeArgs = {
  id: Scalars['String'];
};


export type QueryIssueTypesArgs = {
  issueTypeListInput: IssueTypeListInput;
};


export type QueryIssuesArgs = {
  issueListInput: IssueListInput;
};


export type QueryLabTechArgs = {
  id: Scalars['Int'];
};


export type QueryLabTechsArgs = {
  labTechListInput: LabTechListInput;
};


export type QueryLimsAsphaltJointCoreArgs = {
  id: Scalars['String'];
};


export type QueryLimsAsphaltJointCoresArgs = {
  limsAsphaltJointCoreListInput: LimsAsphaltJointCoreListInput;
};


export type QueryLimsAsphaltLotArgs = {
  id: Scalars['String'];
};


export type QueryLimsAsphaltLotToPayItemNoGeometriesArgs = {
  lIMSAsphaltLotToPayItemNoGeometryListInput: LimsAsphaltLotToPayItemNoGeometryListInput;
};


export type QueryLimsAsphaltLotToPayItemNoGeometryArgs = {
  lotId: Scalars['String'];
  payItemId: Scalars['String'];
};


export type QueryLimsAsphaltLotsArgs = {
  limsAsphaltLotListInput: LimsAsphaltLotListInput;
};


export type QueryLimsAsphaltMatCoreArgs = {
  id: Scalars['String'];
};


export type QueryLimsAsphaltMatCoresArgs = {
  limsAsphaltMatCoreListInput: LimsAsphaltMatCoreListInput;
};


export type QueryLimsAsphaltMixDesignTargetArgs = {
  id: Scalars['String'];
};


export type QueryLimsAsphaltMixDesignTargetsArgs = {
  limsAsphaltMixDesignTargetListInput: LimsAsphaltMixDesignTargetListInput;
};


export type QueryLimsAsphaltSampleArgs = {
  id: Scalars['String'];
};


export type QueryLimsAsphaltSampleResultArgs = {
  sampleId: Scalars['String'];
  targetId: Scalars['String'];
};


export type QueryLimsAsphaltSampleResultsArgs = {
  limsAsphaltSampleResultListInput: LimsAsphaltSampleResultListInput;
};


export type QueryLimsAsphaltSamplesArgs = {
  limsAsphaltSampleListInput: LimsAsphaltSampleListInput;
};


export type QueryLotArgs = {
  globalId: Scalars['String'];
};


export type QueryLotIfiSettingsArgs = {
  lotIFISettingsListInput: LotIfiSettingsListInput;
};


export type QueryLotsArgs = {
  lotListInput: LotListInput;
};


export type QueryMaterialRequirementArgs = {
  globalId: Scalars['String'];
};


export type QueryMaterialRequirementsArgs = {
  materialRequirementListInput: MaterialRequirementListInput;
};


export type QueryMaterialSourceArgs = {
  globalId: Scalars['String'];
};


export type QueryMaterialSourcesArgs = {
  materialSourceListInput: MaterialSourceListInput;
};


export type QueryMaterialTypeArgs = {
  globalId: Scalars['String'];
};


export type QueryMaterialTypesArgs = {
  materialTypeListInput: MaterialTypeListInput;
};


export type QueryMediaUploadArgs = {
  globalId: Scalars['String'];
};


export type QueryMediaUploadsArgs = {
  mediaUploadListInput: MediaUploadListInput;
};


export type QueryNonUserEmailArgs = {
  id: Scalars['Int'];
};


export type QueryNonUserEmailsArgs = {
  nonUserEmailListInput: NonUserEmailListInput;
};


export type QueryOrphanedSharePointResourcesArgs = {
  orphanedSharePointResourcesInput: OrphanedSharePointResourcesInput;
};


export type QueryPayItemArgs = {
  globalId: Scalars['String'];
};


export type QueryPayItemConnectionArgs = {
  id: Scalars['String'];
};


export type QueryPayItemConnectionGroupArgs = {
  id: Scalars['String'];
};


export type QueryPayItemConnectionGroupToInternalConnectionsArgs = {
  projectToInternalConnectionListInput: ProjectToInternalConnectionListInput;
};


export type QueryPayItemConnectionGroupsArgs = {
  payItemConnectionGroupListInput: PayItemConnectionGroupListInput;
};


export type QueryPayItemConnectionsArgs = {
  payItemConnectionListInput: PayItemConnectionListInput;
};


export type QueryPayItemGroupArgs = {
  globalId: Scalars['String'];
};


export type QueryPayItemGroupsArgs = {
  payItemGroupListInput: PayItemGroupListInput;
};


export type QueryPayItemNoGeometriesArgs = {
  payItemNoGeometryListInput: PayItemNoGeometryListInput;
};


export type QueryPayItemNoGeometryArgs = {
  globalId: Scalars['String'];
};


export type QueryPayItemsArgs = {
  payItemListInput: PayItemListInput;
};


export type QueryPdfDesignLayerArgs = {
  index: Scalars['Int'];
  projectId: Scalars['String'];
};


export type QueryPdfDesignLayersArgs = {
  pdfDesignLayerListInput: PdfDesignLayerListInput;
};


export type QueryPhotoExportAveragesArgs = {
  projectId?: InputMaybe<Scalars['String']>;
};


export type QueryPhotoExportRequestArgs = {
  id: Scalars['String'];
};


export type QueryPhotoExportRequestsArgs = {
  photoExportRequestListInput: PhotoExportRequestListInput;
};


export type QueryPhotoFilenameArgs = {
  classTypeId: Scalars['String'];
  projectId: Scalars['String'];
};


export type QueryPhotoFilenameExampleArgs = {
  photoFilenameExampleInput: PhotoFilenameExampleInput;
};


export type QueryPhotoFilenameTemplateArgs = {
  photoFilenameTemplateInput: PhotoFilenameTemplateInput;
};


export type QueryPhotoFilenamesArgs = {
  photoFilenameListInput: PhotoFilenameListInput;
};


export type QueryProctorArgs = {
  globalId: Scalars['String'];
};


export type QueryProctorsArgs = {
  proctorListInput: ProctorListInput;
};


export type QueryProjectArgs = {
  globalId: Scalars['String'];
};


export type QueryProjectMetadataArgs = {
  projectId: Scalars['String'];
};


export type QueryProjectMetadatasArgs = {
  projectMetadataListInput: ProjectMetadataListInput;
};


export type QueryProjectToCimsOnlineAdminArgs = {
  projectId: Scalars['String'];
  userId: Scalars['String'];
};


export type QueryProjectToCimsOnlineAdminsArgs = {
  projectToCIMSOnlineAdminListInput: ProjectToCimsOnlineAdminListInput;
};


export type QueryProjectToIfiReportTypeArgs = {
  projectId: Scalars['String'];
  reportTypeId: Scalars['String'];
};


export type QueryProjectToIfiReportTypesArgs = {
  projectToIFIReportTypeListInput: ProjectToIfiReportTypeListInput;
};


export type QueryProjectToInternalConnectionArgs = {
  groupId: Scalars['String'];
  internalConnectionId: Scalars['String'];
  projectId: Scalars['String'];
};


export type QueryProjectToUserGroupArgs = {
  projectId: Scalars['String'];
  userGroupId: Scalars['String'];
};


export type QueryProjectToUserGroupsArgs = {
  projectToUserGroupListInput: ProjectToUserGroupListInput;
};


export type QueryProjectsArgs = {
  projectListInput: ProjectListInput;
};


export type QueryReading1Args = {
  globalId: Scalars['String'];
};


export type QueryReading1sArgs = {
  reading1ListInput: Reading1ListInput;
};


export type QueryReportAveragesArgs = {
  reportAveragesListInput?: InputMaybe<ReportAveragesListInput>;
};


export type QueryReportFilenameArgs = {
  projectId: Scalars['String'];
  reportId: Scalars['String'];
};


export type QueryReportFilenameExampleArgs = {
  reportFilenameExampleInput: ReportFilenameExampleInput;
};


export type QueryReportFilenameTemplateArgs = {
  reportFilenameTemplateInput: ReportFilenameTemplateInput;
};


export type QueryReportFilenamesArgs = {
  reportFilenameListInput: ReportFilenameListInput;
};


export type QueryReportToTagArgs = {
  globalId: Scalars['String'];
};


export type QueryReportToTagsArgs = {
  reportToTagListInput: ReportToTagListInput;
};


export type QueryRequestForInformationArgs = {
  id: Scalars['String'];
};


export type QueryRequestsForInformationArgs = {
  requestForInformationListInput: RequestForInformationListInput;
};


export type QueryRfiCommentArgs = {
  id: Scalars['String'];
};


export type QueryRfiCommentsArgs = {
  rfiCommentListInput: RfiCommentListInput;
};


export type QueryRfiNotificationArgs = {
  notificationEventId: Scalars['String'];
  projectId: Scalars['String'];
};


export type QueryRfiNotificationsArgs = {
  rfiNotificationListInput: RfiNotificationListInput;
};


export type QueryRfiOrganizationArgs = {
  id: Scalars['String'];
};


export type QueryRfiOrganizationsArgs = {
  rfiOrganizationListInput: RfiOrganizationListInput;
};


export type QueryRfiQuickLinkArgs = {
  id: Scalars['String'];
};


export type QueryRfiQuickLinksArgs = {
  rfiQuickLinkListInput: RfiQuickLinkListInput;
};


export type QueryRfiResponseArgs = {
  id: Scalars['String'];
};


export type QueryRfiResponseDisciplineArgs = {
  id: Scalars['String'];
};


export type QueryRfiResponseDisciplinesArgs = {
  rfiResponseDisciplineListInput: RfiResponseDisciplineListInput;
};


export type QueryRfiResponsesArgs = {
  rfiResponseListInput: RfiResponseListInput;
};


export type QueryRoleArgs = {
  id: Scalars['String'];
};


export type QueryRolesArgs = {
  roleListInput: RoleListInput;
};


export type QuerySharePointResourceArgs = {
  sharePointResourceInput: SharePointResourceInput;
};


export type QueryStructureArgs = {
  globalId: Scalars['String'];
};


export type QueryStructureTypeArgs = {
  globalId: Scalars['String'];
};


export type QueryStructureTypesArgs = {
  structureTypeListInput: StructureTypeListInput;
};


export type QueryStructuresArgs = {
  structureListInput: StructureListInput;
};


export type QueryTagArgs = {
  globalId: Scalars['String'];
};


export type QueryTagCategoriesArgs = {
  tagCategoryListInput: TagCategoryListInput;
};


export type QueryTagCategoryArgs = {
  globalId: Scalars['String'];
};


export type QueryTagToTagCategoriesArgs = {
  tagToTagCategoryListInput: TagToTagCategoryListInput;
};


export type QueryTagToTagCategoryArgs = {
  globalId: Scalars['String'];
};


export type QueryTagsArgs = {
  tagListInput: TagListInput;
};


export type QueryTechnicianArgs = {
  globalId: Scalars['String'];
};


export type QueryTechnicianPermissionArgs = {
  globalId: Scalars['String'];
};


export type QueryTechnicianPermissionsArgs = {
  technicianPermissionListInput: TechnicianPermissionListInput;
};


export type QueryTechniciansArgs = {
  technicianListInput: TechnicianListInput;
};


export type QueryTestingLabArgs = {
  id: Scalars['Int'];
};


export type QueryTestingLabsArgs = {
  testingLabListInput: TestingLabListInput;
};


export type QueryUserArgs = {
  id: Scalars['String'];
};


export type QueryUserGroupArgs = {
  id: Scalars['String'];
};


export type QueryUserGroupsArgs = {
  userGroupListInput: UserGroupListInput;
};


export type QueryUserToDeveloperPermissionArgs = {
  permissionId: Scalars['String'];
  userId: Scalars['String'];
};


export type QueryUserToDeveloperPermissionsArgs = {
  userToDeveloperListInput: UserToDeveloperPermissionListInput;
};


export type QueryUserToProjectToPermissionArgs = {
  permissionId: Scalars['String'];
  projectId: Scalars['String'];
  userId: Scalars['String'];
};


export type QueryUserToProjectToPermissionsArgs = {
  userToProjectToPermissionListInput: UserToProjectToPermissionListInput;
};


export type QueryUsersArgs = {
  userListInput: UserListInput;
};

export type ReReviewConstructionAdminSubmittalInput = {
  comment?: InputMaybe<Scalars['String']>;
  contractualReviewDate?: InputMaybe<Scalars['DateTime']>;
  dispositionTypeId: Scalars['String'];
  id: Scalars['String'];
};

export type ReReviewConstructionAdminSubmittalResponse = {
  __typename: 'REReviewConstructionAdminSubmittalResponse';
  /** RE Reviewed Submittal */
  submittal: ConstructionAdminSubmittal;
};

/** comments made against related `RequestForInformation` records */
export type RfiComment = {
  __typename: 'RFIComment';
  /** the date this record was inserted into the database */
  createdDate: Scalars['DateTime'];
  /**
   * the email address of a user associated with the `createdDate`
   *
   * this value will be `unknown` if the `createdDate` was not set by a user
   */
  createdUser: Scalars['String'];
  /** describes whether the record has been soft-deleted or not */
  deleted: Scalars['Boolean'];
  /** the date this record was soft-deleted in the database */
  deletedDate: Maybe<Scalars['DateTime']>;
  /**
   * the email address of a user associated with the `deletedDate`
   *
   * this value will be `system` if the `deletedDate` was not set by a user
   */
  deletedUser: Maybe<Scalars['String']>;
  /** a UUID used to globally identify this record in the database */
  id: Scalars['String'];
  /** the date this record was last updated in the database */
  lastEditedDate: Scalars['DateTime'];
  /**
   * the email address of a user associated with the `lastEditedDate`
   *
   * this value will be `system` if the `lastEditedDate` was not set by a user
   */
  lastEditedUser: Scalars['String'];
  requestForInformation: RequestForInformation;
  /** the `id` of a related `RequestForInformation` */
  requestForInformationId: Scalars['String'];
  /**
   * the text of the comment
   *
   * limited to 1000 characters
   */
  text: Scalars['String'];
  user: User;
  /** the `id` of a related `User` */
  userId: Scalars['String'];
};

/**
 * helps filter multiple `RFIComment` records
 *
 * this version of the input will have limited options compared to its other counterpart
 */
export type RfiCommentFieldInput = {
  createdDate?: InputMaybe<DateTimeFilter>;
  /**
   * determines now to handle deleted `RFIComment` records
   *
   * - when `true`, only return deleted records
   * - when `false`, do not return deleted records
   * - when omitted, `deleted` is ignored
   */
  deleted?: InputMaybe<Scalars['Boolean']>;
  lastEditedDate?: InputMaybe<DateTimeFilter>;
  /**
   * how to order `RFIComment` records
   *
   * executed in the order they are defined
   */
  orderBy?: InputMaybe<Array<OrderByInput>>;
  requestForInformationId?: InputMaybe<StringFilter>;
  /**
   * specifies how many records to return
   *
   * analogous to `limit`, `first`, or `top` in SQL dialects
   */
  take?: InputMaybe<Scalars['Int']>;
  text?: InputMaybe<StringFilter>;
  userId?: InputMaybe<StringFilter>;
};

/** helps filter multiple `RFIComment` records */
export type RfiCommentListInput = {
  createdDate?: InputMaybe<DateTimeFilter>;
  /**
   * determines now to handle deleted `RFIComment` records
   *
   * - when `true`, only return deleted records
   * - when `false`, do not return deleted records
   * - when omitted, `deleted` is ignored
   */
  deleted?: InputMaybe<Scalars['Boolean']>;
  lastEditedDate?: InputMaybe<DateTimeFilter>;
  /**
   * how to order `RFIComment` records
   *
   * executed in the order they are defined
   */
  orderBy?: InputMaybe<Array<OrderByInput>>;
  /**
   * paginate `RFIComment` records
   *
   * using `paginate` may require multiple requests to get all possible results,
   * but will give more fine-grain control in the event all records cannot be
   * returned gracefully
   */
  paginate?: InputMaybe<PaginationInput>;
  requestForInformationId?: InputMaybe<StringFilter>;
  text?: InputMaybe<StringFilter>;
  userId?: InputMaybe<StringFilter>;
};

/** response metadata for a list query of RFIComment records */
export type RfiCommentListResponse = {
  __typename: 'RFICommentListResponse';
  /** the total count of RFIComment records matching any configured filters */
  count: Scalars['Int'];
  /** the total count of paginated groups of RFIComment */
  pages: Scalars['Int'];
  /** RFIComment records */
  records: Array<RfiComment>;
};

/**
 * notifications hold a recipients configuration for a given
 * notification event in RFI Tracker workflows
 *
 * recipients can be users, or non user emails
 *
 * certain events may require users to receive a notification if they are given permission
 * to perform a specific task
 */
export type RfiNotification = {
  __typename: 'RFINotification';
  /** the date this record was inserted into the database */
  createdDate: Scalars['DateTime'];
  /**
   * the email address of a user associated with the `createdDate`
   *
   * this value will be `unknown` if the `createdDate` was not set by a user
   */
  createdUser: Scalars['String'];
  /** the date this record was last updated in the database */
  lastEditedDate: Scalars['DateTime'];
  /**
   * the email address of a user associated with the `lastEditedDate`
   *
   * this value will be `system` if the `lastEditedDate` was not set by a user
   */
  lastEditedUser: Scalars['String'];
  /** the name of the notification event associated with this Notification */
  notificationEvent: Scalars['String'];
  notificationEventId: Scalars['String'];
  /** a related `Project` */
  project: Project;
  /** the `globalId` of a related `Project` */
  projectId: Scalars['String'];
  recipients: RfiNotificationRecipients;
};

/**
 * helps filter multiple `RFINotification` records
 *
 * this version of the input will have limited options compared to its other counterpart
 */
export type RfiNotificationFieldInput = {
  createdDate?: InputMaybe<DateTimeFilter>;
  lastEditedDate?: InputMaybe<DateTimeFilter>;
  notificationEventId?: InputMaybe<StringFilter>;
  /**
   * how to order `RFINotification` records
   *
   * executed in the order they are defined
   */
  orderBy?: InputMaybe<Array<OrderByInput>>;
  projectId?: InputMaybe<StringFilter>;
  /**
   * specifies how many records to return
   *
   * analogous to `limit`, `first`, or `top` in SQL dialects
   */
  take?: InputMaybe<Scalars['Int']>;
};

/** helps filter multiple `RFINotification` records */
export type RfiNotificationListInput = {
  createdDate?: InputMaybe<DateTimeFilter>;
  lastEditedDate?: InputMaybe<DateTimeFilter>;
  notificationEventId?: InputMaybe<StringFilter>;
  /**
   * how to order `RFINotification` records
   *
   * executed in the order they are defined
   */
  orderBy?: InputMaybe<Array<OrderByInput>>;
  /**
   * paginate `RFINotification` records
   *
   * using `paginate` may require multiple requests to get all possible results,
   * but will give more fine-grain control in the event all records cannot be
   * returned gracefully
   */
  paginate?: InputMaybe<PaginationInput>;
  projectId?: InputMaybe<StringFilter>;
};

/** response metadata for a list query of RFINotification records */
export type RfiNotificationListResponse = {
  __typename: 'RFINotificationListResponse';
  /** the total count of RFINotification records matching any configured filters */
  count: Scalars['Int'];
  /** the total count of paginated groups of RFINotification */
  pages: Scalars['Int'];
  /** RFINotification records */
  records: Array<RfiNotification>;
};

export type RfiNotificationRecipients = {
  __typename: 'RFINotificationRecipients';
  byResponseDiscipline: Array<ByResponseDiscipline>;
  every: Maybe<Recipients>;
};


export type RfiNotificationRecipientsByResponseDisciplineArgs = {
  rFIResponseDiscipline?: InputMaybe<RfiResponseDisciplineFieldInput>;
};

export type RfiOrganization = {
  __typename: 'RFIOrganization';
  /** the date this record was inserted into the database */
  createdDate: Scalars['DateTime'];
  /**
   * the email address of a user associated with the `createdDate`
   *
   * this value will be `unknown` if the `createdDate` was not set by a user
   */
  createdUser: Scalars['String'];
  /** describes whether the record has been soft-deleted or not */
  deleted: Scalars['Boolean'];
  /** the date this record was soft-deleted in the database */
  deletedDate: Maybe<Scalars['DateTime']>;
  /**
   * the email address of a user associated with the `deletedDate`
   *
   * this value will be `system` if the `deletedDate` was not set by a user
   */
  deletedUser: Maybe<Scalars['String']>;
  /**
   * an extended description associated with the record
   *
   * this description will be used to describe the record in CIMS, where possible
   */
  description: Maybe<Scalars['String']>;
  /** a UUID used to globally identify this record in the database */
  id: Scalars['String'];
  /** the date this record was last updated in the database */
  lastEditedDate: Scalars['DateTime'];
  /**
   * the email address of a user associated with the `lastEditedDate`
   *
   * this value will be `system` if the `lastEditedDate` was not set by a user
   */
  lastEditedUser: Scalars['String'];
  /** a human readable name associated with the record */
  name: Scalars['String'];
  /** a related `Project` */
  project: Project;
  /** the `globalId` of a related `Project` */
  projectId: Scalars['String'];
  requestsForInformation: Array<RequestForInformation>;
};


export type RfiOrganizationRequestsForInformationArgs = {
  requestForInformationFieldInput?: InputMaybe<RequestForInformationFieldInput>;
};

/**
 * helps filter multiple `RFIOrganization` records
 *
 * this version of the input will have limited options compared to its other counterpart
 */
export type RfiOrganizationFieldInput = {
  createdDate?: InputMaybe<DateTimeFilter>;
  /**
   * determines now to handle deleted `RFIOrganization` records
   *
   * - when `true`, only return deleted records
   * - when `false`, do not return deleted records
   * - when omitted, `deleted` is ignored
   */
  deleted?: InputMaybe<Scalars['Boolean']>;
  lastEditedDate?: InputMaybe<DateTimeFilter>;
  name?: InputMaybe<StringFilter>;
  /**
   * how to order `RFIOrganization` records
   *
   * executed in the order they are defined
   */
  orderBy?: InputMaybe<Array<OrderByInput>>;
  projectId?: InputMaybe<StringFilter>;
  /**
   * specifies how many records to return
   *
   * analogous to `limit`, `first`, or `top` in SQL dialects
   */
  take?: InputMaybe<Scalars['Int']>;
};

/** helps filter multiple `RFIOrganization` records */
export type RfiOrganizationListInput = {
  createdDate?: InputMaybe<DateTimeFilter>;
  /**
   * determines now to handle deleted `RFIOrganization` records
   *
   * - when `true`, only return deleted records
   * - when `false`, do not return deleted records
   * - when omitted, `deleted` is ignored
   */
  deleted?: InputMaybe<Scalars['Boolean']>;
  lastEditedDate?: InputMaybe<DateTimeFilter>;
  name?: InputMaybe<StringFilter>;
  /**
   * how to order `RFIOrganization` records
   *
   * executed in the order they are defined
   */
  orderBy?: InputMaybe<Array<OrderByInput>>;
  /**
   * paginate `RFIOrganization` records
   *
   * using `paginate` may require multiple requests to get all possible results,
   * but will give more fine-grain control in the event all records cannot be
   * returned gracefully
   */
  paginate?: InputMaybe<PaginationInput>;
  projectId?: InputMaybe<StringFilter>;
};

/** response metadata for a list query of RFIOrganization records */
export type RfiOrganizationListResponse = {
  __typename: 'RFIOrganizationListResponse';
  /** the total count of RFIOrganization records matching any configured filters */
  count: Scalars['Int'];
  /** the total count of paginated groups of RFIOrganization */
  pages: Scalars['Int'];
  /** RFIOrganization records */
  records: Array<RfiOrganization>;
};

/**
 * `RFIQuickLink` records are used in the External Link Editor to allow users
 * to quickly add external links to the `externalLinks` field of a `RequestForInformation`
 *
 * `RFIQuickLink` records used in `externalLinks` are not referenced by `id`, but copied
 * as they are currently defined
 *
 * changes made to any `RFIQuickLink` record will not affect the `externalLinks` of the `RequestForInformation`
 */
export type RfiQuickLink = {
  __typename: 'RFIQuickLink';
  /** the date this record was inserted into the database */
  createdDate: Scalars['DateTime'];
  /**
   * the email address of a user associated with the `createdDate`
   *
   * this value will be `unknown` if the `createdDate` was not set by a user
   */
  createdUser: Scalars['String'];
  /** describes whether the record has been soft-deleted or not */
  deleted: Scalars['Boolean'];
  /** the date this record was soft-deleted in the database */
  deletedDate: Maybe<Scalars['DateTime']>;
  /**
   * the email address of a user associated with the `deletedDate`
   *
   * this value will be `system` if the `deletedDate` was not set by a user
   */
  deletedUser: Maybe<Scalars['String']>;
  /**
   * an extended description associated with the record
   *
   * this description will be used to describe the record in CIMS, where possible
   */
  description: Maybe<Scalars['String']>;
  /** an optional link associated with the `label` */
  href: Maybe<Scalars['String']>;
  /** a UUID used to globally identify this record in the database */
  id: Scalars['String'];
  /** the human readable link text */
  label: Scalars['String'];
  /** the date this record was last updated in the database */
  lastEditedDate: Scalars['DateTime'];
  /**
   * the email address of a user associated with the `lastEditedDate`
   *
   * this value will be `system` if the `lastEditedDate` was not set by a user
   */
  lastEditedUser: Scalars['String'];
  project: Project;
  /** the `globalId` of a related `Project` */
  projectId: Scalars['String'];
};

/**
 * helps filter multiple `RFIQuickLink` records
 *
 * this version of the input will have limited options compared to its other counterpart
 */
export type RfiQuickLinkFieldInput = {
  createdDate?: InputMaybe<DateTimeFilter>;
  /**
   * determines now to handle deleted `RFIQuickLink` records
   *
   * - when `true`, only return deleted records
   * - when `false`, do not return deleted records
   * - when omitted, `deleted` is ignored
   */
  deleted?: InputMaybe<Scalars['Boolean']>;
  description?: InputMaybe<StringFilter>;
  href?: InputMaybe<StringFilter>;
  id?: InputMaybe<StringFilter>;
  label?: InputMaybe<StringFilter>;
  lastEditedDate?: InputMaybe<DateTimeFilter>;
  /**
   * how to order `RFIQuickLink` records
   *
   * executed in the order they are defined
   */
  orderBy?: InputMaybe<Array<OrderByInput>>;
  projectId?: InputMaybe<StringFilter>;
  /**
   * specifies how many records to return
   *
   * analogous to `limit`, `first`, or `top` in SQL dialects
   */
  take?: InputMaybe<Scalars['Int']>;
};

/** helps filter multiple `RFIQuickLink` records */
export type RfiQuickLinkListInput = {
  createdDate?: InputMaybe<DateTimeFilter>;
  /**
   * determines now to handle deleted `RFIQuickLink` records
   *
   * - when `true`, only return deleted records
   * - when `false`, do not return deleted records
   * - when omitted, `deleted` is ignored
   */
  deleted?: InputMaybe<Scalars['Boolean']>;
  description?: InputMaybe<StringFilter>;
  href?: InputMaybe<StringFilter>;
  id?: InputMaybe<StringFilter>;
  label?: InputMaybe<StringFilter>;
  lastEditedDate?: InputMaybe<DateTimeFilter>;
  /**
   * how to order `RFIQuickLink` records
   *
   * executed in the order they are defined
   */
  orderBy?: InputMaybe<Array<OrderByInput>>;
  /**
   * paginate `RFIQuickLink` records
   *
   * using `paginate` may require multiple requests to get all possible results,
   * but will give more fine-grain control in the event all records cannot be
   * returned gracefully
   */
  paginate?: InputMaybe<PaginationInput>;
  projectId?: InputMaybe<StringFilter>;
};

/** response metadata for a list query of RFIQuickLink records */
export type RfiQuickLinkListResponse = {
  __typename: 'RFIQuickLinkListResponse';
  /** the total count of RFIQuickLink records matching any configured filters */
  count: Scalars['Int'];
  /** the total count of paginated groups of RFIQuickLink */
  pages: Scalars['Int'];
  /** RFIQuickLink records */
  records: Array<RfiQuickLink>;
};

export type RfiResponse = {
  __typename: 'RFIResponse';
  /** whether the `Response Discipline` has been checked off during a CIMS workflow */
  closed: Scalars['Boolean'];
  /** the date this record was inserted into the database */
  createdDate: Scalars['DateTime'];
  /**
   * the email address of a user associated with the `createdDate`
   *
   * this value will be `unknown` if the `createdDate` was not set by a user
   */
  createdUser: Scalars['String'];
  /** describes whether the record has been soft-deleted or not */
  deleted: Scalars['Boolean'];
  /** the date this record was soft-deleted in the database */
  deletedDate: Maybe<Scalars['DateTime']>;
  /**
   * the email address of a user associated with the `deletedDate`
   *
   * this value will be `system` if the `deletedDate` was not set by a user
   */
  deletedUser: Maybe<Scalars['String']>;
  /** a UUID used to globally identify this record in the database */
  id: Scalars['String'];
  /** the date this record was last updated in the database */
  lastEditedDate: Scalars['DateTime'];
  /**
   * the email address of a user associated with the `lastEditedDate`
   *
   * this value will be `system` if the `lastEditedDate` was not set by a user
   */
  lastEditedUser: Scalars['String'];
  /** the related `Request For Information` */
  requestForInformation: RequestForInformation;
  /** the `id` of a related `Request For Information` */
  requestForInformationId: Scalars['String'];
  responseDate: Scalars['DateTime'];
  /** the related `Response Discipline` */
  responseDiscipline: RfiResponseDiscipline;
  /** the `id` of a related `Response Discipline` */
  responseDisciplineId: Scalars['String'];
  /** limited to 4000 characters */
  text: Scalars['String'];
  user: User;
  /** the `id` of a related `User` */
  userId: Scalars['String'];
};

export type RfiResponseDiscipline = {
  __typename: 'RFIResponseDiscipline';
  /** the date this record was inserted into the database */
  createdDate: Scalars['DateTime'];
  /**
   * the email address of a user associated with the `createdDate`
   *
   * this value will be `unknown` if the `createdDate` was not set by a user
   */
  createdUser: Scalars['String'];
  /** describes whether the record has been soft-deleted or not */
  deleted: Scalars['Boolean'];
  /** the date this record was soft-deleted in the database */
  deletedDate: Maybe<Scalars['DateTime']>;
  /**
   * the email address of a user associated with the `deletedDate`
   *
   * this value will be `system` if the `deletedDate` was not set by a user
   */
  deletedUser: Maybe<Scalars['String']>;
  /**
   * an extended description associated with the record
   *
   * this description will be used to describe the record in CIMS, where possible
   */
  description: Maybe<Scalars['String']>;
  /** a UUID used to globally identify this record in the database */
  id: Scalars['String'];
  /** the date this record was last updated in the database */
  lastEditedDate: Scalars['DateTime'];
  /**
   * the email address of a user associated with the `lastEditedDate`
   *
   * this value will be `system` if the `lastEditedDate` was not set by a user
   */
  lastEditedUser: Scalars['String'];
  /** a human readable name associated with the record */
  name: Scalars['String'];
  /** a related `Project` */
  project: Project;
  /** the `globalId` of a related `Project` */
  projectId: Scalars['String'];
  requestsForInformation: Array<RequestForInformation>;
  responses: Array<RfiResponse>;
  users: Array<User>;
};


export type RfiResponseDisciplineRequestsForInformationArgs = {
  requestForInformationFieldInput?: InputMaybe<RequestForInformationFieldInput>;
};


export type RfiResponseDisciplineResponsesArgs = {
  rfiResponseFieldInput?: InputMaybe<RfiResponseFieldInput>;
};


export type RfiResponseDisciplineUsersArgs = {
  userFieldInput?: InputMaybe<UserFieldInput>;
};

/**
 * helps filter multiple `RFIResponseDiscipline` records
 *
 * this version of the input will have limited options compared to its other counterpart
 */
export type RfiResponseDisciplineFieldInput = {
  createdDate?: InputMaybe<DateTimeFilter>;
  /**
   * determines now to handle deleted `RFIResponseDiscipline` records
   *
   * - when `true`, only return deleted records
   * - when `false`, do not return deleted records
   * - when omitted, `deleted` is ignored
   */
  deleted?: InputMaybe<Scalars['Boolean']>;
  lastEditedDate?: InputMaybe<DateTimeFilter>;
  name?: InputMaybe<StringFilter>;
  /**
   * how to order `RFIResponseDiscipline` records
   *
   * executed in the order they are defined
   */
  orderBy?: InputMaybe<Array<OrderByInput>>;
  projectId?: InputMaybe<StringFilter>;
  /**
   * specifies how many records to return
   *
   * analogous to `limit`, `first`, or `top` in SQL dialects
   */
  take?: InputMaybe<Scalars['Int']>;
};

/** helps filter multiple `RFIResponseDiscipline` records */
export type RfiResponseDisciplineListInput = {
  createdDate?: InputMaybe<DateTimeFilter>;
  /**
   * determines now to handle deleted `RFIResponseDiscipline` records
   *
   * - when `true`, only return deleted records
   * - when `false`, do not return deleted records
   * - when omitted, `deleted` is ignored
   */
  deleted?: InputMaybe<Scalars['Boolean']>;
  lastEditedDate?: InputMaybe<DateTimeFilter>;
  name?: InputMaybe<StringFilter>;
  /**
   * how to order `RFIResponseDiscipline` records
   *
   * executed in the order they are defined
   */
  orderBy?: InputMaybe<Array<OrderByInput>>;
  /**
   * paginate `RFIResponseDiscipline` records
   *
   * using `paginate` may require multiple requests to get all possible results,
   * but will give more fine-grain control in the event all records cannot be
   * returned gracefully
   */
  paginate?: InputMaybe<PaginationInput>;
  projectId?: InputMaybe<StringFilter>;
};

/** response metadata for a list query of RFIResponseDiscipline records */
export type RfiResponseDisciplineListResponse = {
  __typename: 'RFIResponseDisciplineListResponse';
  /** the total count of RFIResponseDiscipline records matching any configured filters */
  count: Scalars['Int'];
  /** the total count of paginated groups of RFIResponseDiscipline */
  pages: Scalars['Int'];
  /** RFIResponseDiscipline records */
  records: Array<RfiResponseDiscipline>;
};

/**
 * helps filter multiple `RFIResponse` records
 *
 * this version of the input will have limited options compared to its other counterpart
 */
export type RfiResponseFieldInput = {
  /**
   * - when `true`, `closed` is truthy
   * - when `false`, `closed` is falsy
   * - when omitted, `closed` is ignored
   */
  closed?: InputMaybe<Scalars['Boolean']>;
  createdDate?: InputMaybe<DateTimeFilter>;
  /**
   * determines now to handle deleted `RFIResponse` records
   *
   * - when `true`, only return deleted records
   * - when `false`, do not return deleted records
   * - when omitted, `deleted` is ignored
   */
  deleted?: InputMaybe<Scalars['Boolean']>;
  lastEditedDate?: InputMaybe<DateTimeFilter>;
  /**
   * how to order `RFIResponse` records
   *
   * executed in the order they are defined
   */
  orderBy?: InputMaybe<Array<OrderByInput>>;
  responseDisciplineId?: InputMaybe<StringFilter>;
  /**
   * specifies how many records to return
   *
   * analogous to `limit`, `first`, or `top` in SQL dialects
   */
  take?: InputMaybe<Scalars['Int']>;
};

/** helps filter multiple `RFIResponse` records */
export type RfiResponseListInput = {
  /**
   * - when `true`, `closed` is truthy
   * - when `false`, `closed` is falsy
   * - when omitted, `closed` is ignored
   */
  closed?: InputMaybe<Scalars['Boolean']>;
  createdDate?: InputMaybe<DateTimeFilter>;
  /**
   * determines now to handle deleted `RFIResponse` records
   *
   * - when `true`, only return deleted records
   * - when `false`, do not return deleted records
   * - when omitted, `deleted` is ignored
   */
  deleted?: InputMaybe<Scalars['Boolean']>;
  lastEditedDate?: InputMaybe<DateTimeFilter>;
  /**
   * how to order `RFIResponse` records
   *
   * executed in the order they are defined
   */
  orderBy?: InputMaybe<Array<OrderByInput>>;
  /**
   * paginate `RFIResponse` records
   *
   * using `paginate` may require multiple requests to get all possible results,
   * but will give more fine-grain control in the event all records cannot be
   * returned gracefully
   */
  paginate?: InputMaybe<PaginationInput>;
  responseDisciplineId?: InputMaybe<StringFilter>;
};

/** response metadata for a list query of RFIResponse records */
export type RfiResponseListResponse = {
  __typename: 'RFIResponseListResponse';
  /** the total count of RFIResponse records matching any configured filters */
  count: Scalars['Int'];
  /** the total count of paginated groups of RFIResponse */
  pages: Scalars['Int'];
  /** RFIResponse records */
  records: Array<RfiResponse>;
};

export type Reading1 = {
  __typename: 'Reading1';
  /** the date this record was inserted into the database */
  createdDate: Maybe<Scalars['DateTime']>;
  /** the username or email address of a mobile app user associated with the `createdDate` */
  createdUser: Maybe<Scalars['String']>;
  dateReadingCreated: Maybe<Scalars['DateTime']>;
  deleted: Maybe<Scalars['String']>;
  densityCount: Maybe<Scalars['Int']>;
  densityTest: Maybe<DensityTest>;
  /** the `globalId` of a related `DensityTest` */
  densityTestId: Maybe<Scalars['String']>;
  dryDensity: Maybe<Scalars['Float']>;
  /** a GUID used to globally identify this record in the database */
  globalId: Scalars['String'];
  /** the date this record was last updated in the database */
  lastEditedDate: Maybe<Scalars['DateTime']>;
  /** the username or email address of a mobile app user associated with the `lastEditedDate` */
  lastEditedUser: Maybe<Scalars['String']>;
  moistureCount: Maybe<Scalars['Int']>;
  moistureLbs: Maybe<Scalars['Float']>;
  orderNum: Maybe<Scalars['Int']>;
  percentCompaction: Maybe<Scalars['Float']>;
  percentMoisture: Maybe<Scalars['Float']>;
  /** a related `Project` */
  project: Maybe<Project>;
  /** the `globalId` of a related `Project` */
  projectId: Maybe<Scalars['String']>;
  renderInfo: Maybe<Scalars['String']>;
  status: Maybe<Scalars['String']>;
  testDepthIn: Maybe<Scalars['Float']>;
  used: Maybe<Scalars['String']>;
  wetDensity: Maybe<Scalars['Float']>;
};

/**
 * helps filter multiple `Reading1` records
 *
 * this version of the input will have limited options compared to its other counterpart
 */
export type Reading1FieldInput = {
  createdDate?: InputMaybe<DateTimeFilter>;
  /**
   * determines now to handle deleted `Reading1` records
   *
   * - when `true`, only return deleted records
   * - when `false`, do not return deleted records
   * - when omitted, `deleted` is ignored
   */
  deleted?: InputMaybe<Scalars['Boolean']>;
  lastEditedDate?: InputMaybe<DateTimeFilter>;
  /**
   * how to order `Reading1` records
   *
   * executed in the order they are defined
   */
  orderBy?: InputMaybe<Array<OrderByInput>>;
  projectId?: InputMaybe<StringFilter>;
  /**
   * specifies how many records to return
   *
   * analogous to `limit`, `first`, or `top` in SQL dialects
   */
  take?: InputMaybe<Scalars['Int']>;
};

/** helps filter multiple `Reading1` records */
export type Reading1ListInput = {
  createdDate?: InputMaybe<DateTimeFilter>;
  /**
   * determines now to handle deleted `Reading1` records
   *
   * - when `true`, only return deleted records
   * - when `false`, do not return deleted records
   * - when omitted, `deleted` is ignored
   */
  deleted?: InputMaybe<Scalars['Boolean']>;
  lastEditedDate?: InputMaybe<DateTimeFilter>;
  /**
   * how to order `Reading1` records
   *
   * executed in the order they are defined
   */
  orderBy?: InputMaybe<Array<OrderByInput>>;
  /**
   * paginate `Reading1` records
   *
   * using `paginate` may require multiple requests to get all possible results,
   * but will give more fine-grain control in the event all records cannot be
   * returned gracefully
   */
  paginate?: InputMaybe<PaginationInput>;
  projectId?: InputMaybe<StringFilter>;
};

/** response metadata for a list query of Reading1 records */
export type Reading1ListResponse = {
  __typename: 'Reading1ListResponse';
  /** the total count of Reading1 records matching any configured filters */
  count: Scalars['Int'];
  /** the total count of paginated groups of Reading1 */
  pages: Scalars['Int'];
  /** Reading1 records */
  records: Array<Reading1>;
};

export type Recipients = {
  __typename: 'Recipients';
  /** `NonUserEmail` records associated with this recipients configuration */
  nonUserEmails: Array<NonUserEmail>;
  /** `User` records associated with this recipients configuration */
  users: Array<User>;
};


export type RecipientsNonUserEmailsArgs = {
  nonUserEmailFieldInput?: InputMaybe<NonUserEmailFieldInput>;
};


export type RecipientsUsersArgs = {
  userFieldInput?: InputMaybe<UserFieldInput>;
};

/** helps configure recipients for notification events */
export type RecipientsInput = {
  /** `NonUserEmail.id` values used to associate `NonUserEmail` records with the notification event */
  nonUserEmailIds: Array<Scalars['Int']>;
  /** `User.id` values used to associate `User` records with the notification event */
  userIds: Array<Scalars['String']>;
};

export type RemoveApiKeyInput = {
  createdDate?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<IntFilter>;
  recipient?: InputMaybe<StringFilter>;
};

export type RemoveApiKeyResponse = {
  __typename: 'RemoveAPIKeyResponse';
  apiKeys: Array<ApiKey>;
};

export type RemoveConcreteTestBreakDataResponse = {
  __typename: 'RemoveConcreteTestBreakDataResponse';
  /** the removed `ConcreteTestBreakData` */
  concreteTestBreakData: ConcreteTestBreakData;
};

export type RemoveDocumentChecklistItemResponse = {
  __typename: 'RemoveDocumentChecklistItemResponse';
  /** the removed `DocumentChecklistItem` */
  documentChecklistItem: DocumentChecklistItem;
};

export type RemoveLabTechResponse = {
  __typename: 'RemoveLabTechResponse';
  /** the removed `LabTech` */
  labTech: LabTech;
};

export type RemoveNonUserEmailResponse = {
  __typename: 'RemoveNonUserEmailResponse';
  /** the removed `NonUserEmail` */
  nonUserEmail: NonUserEmail;
};

export type RemoveProjectToCimsOnlineAdminInput = {
  projectId: Scalars['String'];
  userId: Scalars['String'];
};

export type RemoveProjectToCimsOnlineAdminResponse = {
  __typename: 'RemoveProjectToCIMSOnlineAdminResponse';
  /** the removed `ProjectToCIMSOnlineAdmin` */
  admin: ProjectToCimsOnlineAdmin;
};

export type RemoveSharePointResourceResponse = {
  __typename: 'RemoveSharePointResourceResponse';
  /** a message concerning the removal of the `SharePointResource` */
  message: Maybe<Scalars['String']>;
  /** whether the `SharePointResource` was successfully removed */
  removed: Scalars['Boolean'];
};

export type RemoveTestingLabResponse = {
  __typename: 'RemoveTestingLabResponse';
  /** the removed `TestingLab` */
  testingLab: TestingLab;
};

export type RepairSharePointResourceInput = {
  parentId: Scalars['String'];
  recordId: Scalars['String'];
  sharePointResourceId: Scalars['String'];
};

export type RepairSharePointResourceResponse = {
  __typename: 'RepairSharePointResourceResponse';
  sharePointResource: SharePointResource;
};

export type ReportAveragesListInput = {
  projectId?: InputMaybe<Scalars['String']>;
  reportId?: InputMaybe<Scalars['String']>;
};

export type ReportCustomFieldValue = {
  __typename: 'ReportCustomFieldValue';
  href: Maybe<Scalars['String']>;
  label: Maybe<Scalars['String']>;
  /** the id of a related database entity */
  recordId: Maybe<Scalars['String']>;
  /** the id of a `Report` */
  reportId: Scalars['String'];
};


export type ReportCustomFieldValueHrefArgs = {
  projectId: Scalars['String'];
};

/** a hyperlink to generate and download a specific report on demand */
export type ReportCustomFieldValues = {
  __typename: 'ReportCustomFieldValues';
  /** the date this record was inserted into the database */
  createdDate: Scalars['DateTime'];
  /**
   * the email address of a user associated with the `createdDate`
   *
   * this value will be `unknown` if the `createdDate` was not set by a user
   */
  createdUser: Scalars['String'];
  customField: CustomField;
  /** the `id` of a related `CustomField` */
  customFieldId: Scalars['String'];
  /** the date this record was soft-deleted in the database */
  deletedDate: Maybe<Scalars['DateTime']>;
  /**
   * the email address of a user associated with the `deletedDate`
   *
   * this value will be `system` if the `deletedDate` was not set by a user
   */
  deletedUser: Maybe<Scalars['String']>;
  /** the date this record was last updated in the database */
  lastEditedDate: Scalars['DateTime'];
  /**
   * the email address of a user associated with the `lastEditedDate`
   *
   * this value will be `system` if the `lastEditedDate` was not set by a user
   */
  lastEditedUser: Scalars['String'];
  reports: Array<ReportCustomFieldValue>;
};

export type ReportFilename = {
  __typename: 'ReportFilename';
  /** the date this record was inserted into the database */
  createdDate: Scalars['DateTime'];
  /**
   * the email address of a user associated with the `createdDate`
   *
   * this value will be `unknown` if the `createdDate` was not set by a user
   */
  createdUser: Scalars['String'];
  /** the date this record was last updated in the database */
  lastEditedDate: Scalars['DateTime'];
  /**
   * the email address of a user associated with the `lastEditedDate`
   *
   * this value will be `system` if the `lastEditedDate` was not set by a user
   */
  lastEditedUser: Scalars['String'];
  /** a related `Project` */
  project: Project;
  /** the `globalId` of a related `Project` */
  projectId: Scalars['String'];
  report: Scalars['String'];
  reportId: Scalars['String'];
  templateItems: Maybe<Array<FilenameTemplateItem>>;
};

export type ReportFilenameExampleInput = {
  projectId: Scalars['String'];
  reportId: Scalars['String'];
  templateItems?: InputMaybe<Array<EditFilenameTemplateItemInput>>;
};

/**
 * helps filter multiple `ReportFilename` records
 *
 * this version of the input will have limited options compared to its other counterpart
 */
export type ReportFilenameFieldInput = {
  createdDate?: InputMaybe<DateTimeFilter>;
  lastEditedDate?: InputMaybe<DateTimeFilter>;
  /**
   * how to order `ReportFilename` records
   *
   * executed in the order they are defined
   */
  orderBy?: InputMaybe<Array<OrderByInput>>;
  projectId?: InputMaybe<StringFilter>;
  reportId?: InputMaybe<StringFilter>;
  /**
   * specifies how many records to return
   *
   * analogous to `limit`, `first`, or `top` in SQL dialects
   */
  take?: InputMaybe<Scalars['Int']>;
};

/** helps filter multiple `ReportFilename` records */
export type ReportFilenameListInput = {
  createdDate?: InputMaybe<DateTimeFilter>;
  lastEditedDate?: InputMaybe<DateTimeFilter>;
  /**
   * how to order `ReportFilename` records
   *
   * executed in the order they are defined
   */
  orderBy?: InputMaybe<Array<OrderByInput>>;
  /**
   * paginate `ReportFilename` records
   *
   * using `paginate` may require multiple requests to get all possible results,
   * but will give more fine-grain control in the event all records cannot be
   * returned gracefully
   */
  paginate?: InputMaybe<PaginationInput>;
  projectId?: InputMaybe<StringFilter>;
  reportId?: InputMaybe<StringFilter>;
};

/** response metadata for a list query of ReportFilename records */
export type ReportFilenameListResponse = {
  __typename: 'ReportFilenameListResponse';
  /** the total count of ReportFilename records matching any configured filters */
  count: Scalars['Int'];
  /** the total count of paginated groups of ReportFilename */
  pages: Scalars['Int'];
  /** ReportFilename records */
  records: Array<ReportFilename>;
};

export type ReportFilenameTemplateInput = {
  projectId: Scalars['String'];
  reportId: Scalars['String'];
};

export type ReportToTag = {
  __typename: 'ReportToTag';
  asphaltLot: Maybe<AsphaltLot>;
  concreteTestSet: Maybe<ConcreteTestSet>;
  /** the date this record was inserted into the database */
  createdDate: Maybe<Scalars['DateTime']>;
  /** the username or email address of a mobile app user associated with the `createdDate` */
  createdUser: Maybe<Scalars['String']>;
  dailyInspectionControlPoint: Maybe<DailyInspectionControlPoint>;
  dailyInspectionInspection: Maybe<DailyInspectionInspection>;
  dailyInspectionPunchList: Maybe<DailyInspectionPunchList>;
  deleted: Maybe<Scalars['String']>;
  /** the `globalId` of one of the related types: `AsphaltLot`, `ConcreteTestSet`, `DailyInspectionControlPoint`, `DailyInspectionInspection`, `DailyInspectionPunchList`, or `Lot` */
  featureGuid: Maybe<Scalars['String']>;
  featureId: Maybe<Scalars['String']>;
  /** a GUID used to globally identify this record in the database */
  globalId: Scalars['String'];
  /** the date this record was last updated in the database */
  lastEditedDate: Maybe<Scalars['DateTime']>;
  /** the username or email address of a mobile app user associated with the `lastEditedDate` */
  lastEditedUser: Maybe<Scalars['String']>;
  lot: Maybe<Lot>;
  name: Maybe<Scalars['String']>;
  /**
   * an ArcGIS feature layer index
   *
   * used in the database to help specify the type of `featureGuid`
   *
   * | object type | index |
   * | --- | :---: |
   * | `Lot` | 1 |
   * | `DailyInspectionControlPoint` | 15 |
   * | `DailyInspectionInspection` | 16 |
   * | `DailyInspectionPunchList` | 17 |
   * | `ConcreteTestSet` | 21 |
   * | `AsphaltLot` | 44 |
   */
  parentFeatureTable: Maybe<Scalars['Int']>;
  /** a related `Project` */
  project: Maybe<Project>;
  /** the `globalId` of a related `Project` */
  projectId: Maybe<Scalars['String']>;
  tag: Maybe<Tag>;
  tagCategory: Maybe<TagCategory>;
  tagCategoryId: Maybe<Scalars['String']>;
  tagId: Maybe<Scalars['String']>;
};

/**
 * helps filter multiple `ReportToTag` records
 *
 * this version of the input will have limited options compared to its other counterpart
 */
export type ReportToTagFieldInput = {
  createdDate?: InputMaybe<DateTimeFilter>;
  /**
   * determines now to handle deleted `ReportToTag` records
   *
   * - when `true`, only return deleted records
   * - when `false`, do not return deleted records
   * - when omitted, `deleted` is ignored
   */
  deleted?: InputMaybe<Scalars['Boolean']>;
  featureGuid?: InputMaybe<StringFilter>;
  featureId?: InputMaybe<StringFilter>;
  lastEditedDate?: InputMaybe<DateTimeFilter>;
  /**
   * how to order `ReportToTag` records
   *
   * executed in the order they are defined
   */
  orderBy?: InputMaybe<Array<OrderByInput>>;
  parentFeatureTable?: InputMaybe<IntFilter>;
  projectId?: InputMaybe<StringFilter>;
  tagCategoryId?: InputMaybe<StringFilter>;
  tagId?: InputMaybe<StringFilter>;
  /**
   * specifies how many records to return
   *
   * analogous to `limit`, `first`, or `top` in SQL dialects
   */
  take?: InputMaybe<Scalars['Int']>;
};

/** helps filter multiple `ReportToTag` records */
export type ReportToTagListInput = {
  createdDate?: InputMaybe<DateTimeFilter>;
  /**
   * determines now to handle deleted `ReportToTag` records
   *
   * - when `true`, only return deleted records
   * - when `false`, do not return deleted records
   * - when omitted, `deleted` is ignored
   */
  deleted?: InputMaybe<Scalars['Boolean']>;
  featureGuid?: InputMaybe<StringFilter>;
  featureId?: InputMaybe<StringFilter>;
  lastEditedDate?: InputMaybe<DateTimeFilter>;
  /**
   * how to order `ReportToTag` records
   *
   * executed in the order they are defined
   */
  orderBy?: InputMaybe<Array<OrderByInput>>;
  /**
   * paginate `ReportToTag` records
   *
   * using `paginate` may require multiple requests to get all possible results,
   * but will give more fine-grain control in the event all records cannot be
   * returned gracefully
   */
  paginate?: InputMaybe<PaginationInput>;
  parentFeatureTable?: InputMaybe<IntFilter>;
  projectId?: InputMaybe<StringFilter>;
  tagCategoryId?: InputMaybe<StringFilter>;
  tagId?: InputMaybe<StringFilter>;
};

/** response metadata for a list query of ReportToTag records */
export type ReportToTagListResponse = {
  __typename: 'ReportToTagListResponse';
  /** the total count of ReportToTag records matching any configured filters */
  count: Scalars['Int'];
  /** the total count of paginated groups of ReportToTag */
  pages: Scalars['Int'];
  /** ReportToTag records */
  records: Array<ReportToTag>;
};

export type RequestConstructionAdminSubmittalRevisionsInput = {
  comment: Scalars['String'];
  id: Scalars['String'];
};

export type RequestConstructionAdminSubmittalRevisionsResponse = {
  __typename: 'RequestConstructionAdminSubmittalRevisionsResponse';
  /** Submittal with revisions requested */
  submittal: ConstructionAdminSubmittal;
};

export type RequestForInformation = {
  __typename: 'RequestForInformation';
  closedDate: Maybe<Scalars['DateTime']>;
  comments: Array<RfiComment>;
  /** the date this record was inserted into the database */
  createdDate: Scalars['DateTime'];
  /**
   * the email address of a user associated with the `createdDate`
   *
   * this value will be `unknown` if the `createdDate` was not set by a user
   */
  createdUser: Scalars['String'];
  /**
   * custom fields are defined, configured, and activated for `RequestForInformation`
   *     records in the Administration module
   *
   *     values are saved and retrieved for each individual `RequestForInformation`
   */
  customFields: CustomFields;
  /** describes whether the record has been soft-deleted or not */
  deleted: Scalars['Boolean'];
  /** the date this record was soft-deleted in the database */
  deletedDate: Maybe<Scalars['DateTime']>;
  /**
   * the email address of a user associated with the `deletedDate`
   *
   * this value will be `system` if the `deletedDate` was not set by a user
   */
  deletedUser: Maybe<Scalars['String']>;
  /**
   * limited to 4000 characters
   *
   * This is the actual request being made, the question that needs to be answered.
   */
  description: Scalars['String'];
  externalLinks: Array<ExternalLink>;
  /** the `number` prefixed with "RFI" */
  formattedNumber: Scalars['String'];
  /** a UUID used to globally identify this record in the database */
  id: Scalars['String'];
  /** the date this record was last updated in the database */
  lastEditedDate: Scalars['DateTime'];
  /**
   * the email address of a user associated with the `lastEditedDate`
   *
   * this value will be `system` if the `lastEditedDate` was not set by a user
   */
  lastEditedUser: Scalars['String'];
  /** a generated number for the `RequestForInformation` */
  number: Scalars['Int'];
  organization: Maybe<RfiOrganization>;
  /** the `id` of a related `RFI Organization` */
  organizationId: Maybe<Scalars['String']>;
  /** a related `Project` */
  project: Project;
  /** the `globalId` of a related `Project` */
  projectId: Scalars['String'];
  requestedResponseDate: Maybe<Scalars['DateTime']>;
  responseDisciplines: Array<RfiResponseDiscipline>;
  responses: Array<RfiResponse>;
  /** pulls a `SharePointResource` object from SharePoint for the parent folder associated with this `RequestForInformation` */
  sharePointResource: Maybe<SharePointResource>;
  sharePointResourceId: Maybe<Scalars['String']>;
  sharePointResourceWebUrl: Maybe<Scalars['String']>;
  status: Scalars['String'];
  statusId: Scalars['String'];
  submittedBy: Maybe<User>;
  /** the `id` of a related `User` which submits the `Request For Information` */
  submittedById: Maybe<Scalars['String']>;
  submittedDate: Maybe<Scalars['DateTime']>;
};


export type RequestForInformationCommentsArgs = {
  rfiCommentFieldInput?: InputMaybe<RfiCommentFieldInput>;
};


export type RequestForInformationResponseDisciplinesArgs = {
  rfiResponseDisciplineFieldInput?: InputMaybe<RfiResponseDisciplineFieldInput>;
};


export type RequestForInformationResponsesArgs = {
  rFIResponseFieldInput?: InputMaybe<RfiResponseFieldInput>;
};

/**
 * helps filter multiple `RequestForInformation` records
 *
 * this version of the input will have limited options compared to its other counterpart
 */
export type RequestForInformationFieldInput = {
  closedDate?: InputMaybe<DateTimeFilter>;
  createdDate?: InputMaybe<DateTimeFilter>;
  /**
   * determines now to handle deleted `RequestForInformation` records
   *
   * - when `true`, only return deleted records
   * - when `false`, do not return deleted records
   * - when omitted, `deleted` is ignored
   */
  deleted?: InputMaybe<Scalars['Boolean']>;
  lastEditedDate?: InputMaybe<DateTimeFilter>;
  number?: InputMaybe<IntFilter>;
  /**
   * how to order `RequestForInformation` records
   *
   * executed in the order they are defined
   */
  orderBy?: InputMaybe<Array<OrderByInput>>;
  organizationId?: InputMaybe<StringFilter>;
  projectId?: InputMaybe<StringFilter>;
  requestedResponseDate?: InputMaybe<DateTimeFilter>;
  submittedById?: InputMaybe<StringFilter>;
  submittedDate?: InputMaybe<DateTimeFilter>;
  /**
   * specifies how many records to return
   *
   * analogous to `limit`, `first`, or `top` in SQL dialects
   */
  take?: InputMaybe<Scalars['Int']>;
};

/** helps filter multiple `RequestForInformation` records */
export type RequestForInformationListInput = {
  closedDate?: InputMaybe<DateTimeFilter>;
  createdDate?: InputMaybe<DateTimeFilter>;
  /**
   * determines now to handle deleted `RequestForInformation` records
   *
   * - when `true`, only return deleted records
   * - when `false`, do not return deleted records
   * - when omitted, `deleted` is ignored
   */
  deleted?: InputMaybe<Scalars['Boolean']>;
  lastEditedDate?: InputMaybe<DateTimeFilter>;
  number?: InputMaybe<IntFilter>;
  /**
   * how to order `RequestForInformation` records
   *
   * executed in the order they are defined
   */
  orderBy?: InputMaybe<Array<OrderByInput>>;
  organizationId?: InputMaybe<StringFilter>;
  /**
   * paginate `RequestForInformation` records
   *
   * using `paginate` may require multiple requests to get all possible results,
   * but will give more fine-grain control in the event all records cannot be
   * returned gracefully
   */
  paginate?: InputMaybe<PaginationInput>;
  projectId?: InputMaybe<StringFilter>;
  requestedResponseDate?: InputMaybe<DateTimeFilter>;
  submittedById?: InputMaybe<StringFilter>;
  submittedDate?: InputMaybe<DateTimeFilter>;
};

/** response metadata for a list query of RequestForInformation records */
export type RequestForInformationListResponse = {
  __typename: 'RequestForInformationListResponse';
  /** the total count of RequestForInformation records matching any configured filters */
  count: Scalars['Int'];
  /** the total count of paginated groups of RequestForInformation */
  pages: Scalars['Int'];
  /** RequestForInformation records */
  records: Array<RequestForInformation>;
};

export type RespondToIssueInput = {
  comment?: InputMaybe<Scalars['String']>;
  externalLinks?: InputMaybe<Array<ExternalLinkInput>>;
  id: Scalars['String'];
  response: Scalars['String'];
};

export type RespondToIssueResponse = {
  __typename: 'RespondToIssueResponse';
  issue: Issue;
};

export type RestoreCasDispositionTypeResponse = {
  __typename: 'RestoreCASDispositionTypeResponse';
  /** the restored `CASDispositionType` */
  dispositionType: CasDispositionType;
};

export type RestoreCasQuickLinkResponse = {
  __typename: 'RestoreCASQuickLinkResponse';
  /** the restored `CASQuickLink` */
  casQuickLink: CasQuickLink;
};

export type RestoreCasRoutingGroupResponse = {
  __typename: 'RestoreCASRoutingGroupResponse';
  /** the restored `CASRoutingGroup` */
  routingGroup: CasRoutingGroup;
};

export type RestoreCasSubtypeResponse = {
  __typename: 'RestoreCASSubtypeResponse';
  /** the restored `CASSubtype` */
  subtype: CasSubtype;
};

export type RestoreCasTypeResponse = {
  __typename: 'RestoreCASTypeResponse';
  /** the restored `CASType` */
  type: CasType;
};

export type RestoreConstructionAdminSubmittalResponse = {
  __typename: 'RestoreConstructionAdminSubmittalResponse';
  /** the restored `ConstructionAdminSubmittal` */
  submittal: ConstructionAdminSubmittal;
};

export type RestoreCustomFieldResponse = {
  __typename: 'RestoreCustomFieldResponse';
  /** the restored `CustomField` */
  customField: CustomField;
};

export type RestoreDsActionResponse = {
  __typename: 'RestoreDSActionResponse';
  /** the restored `DSAction` */
  action: DsAction;
};

export type RestoreDsDisciplineResponse = {
  __typename: 'RestoreDSDisciplineResponse';
  /** the restored `DSDiscipline` */
  discipline: DsDiscipline;
};

export type RestoreDsOrganizationResponse = {
  __typename: 'RestoreDSOrganizationResponse';
  /** the restored `DSOrganization` */
  organization: DsOrganization;
};

export type RestoreDsQuickLinkResponse = {
  __typename: 'RestoreDSQuickLinkResponse';
  /** the restored `DSQuickLink` */
  dsQuickLink: DsQuickLink;
};

export type RestoreDsTypeResponse = {
  __typename: 'RestoreDSTypeResponse';
  /** the restored `DSType` */
  type: DsType;
};

export type RestoreDesignSubmittalResponse = {
  __typename: 'RestoreDesignSubmittalResponse';
  /** the restored `DesignSubmittal` */
  designSubmittal: DesignSubmittal;
};

export type RestoreEjQuickLinkResponse = {
  __typename: 'RestoreEJQuickLinkResponse';
  /** the restored `EJQuickLink` */
  ejQuickLink: EjQuickLink;
};

export type RestoreEjTypeResponse = {
  __typename: 'RestoreEJTypeResponse';
  /** the restored `EJType` */
  type: EjType;
};

export type RestoreEngineeringJudgementResponse = {
  __typename: 'RestoreEngineeringJudgementResponse';
  /** the restored `EngineeringJudgement` */
  judgement: EngineeringJudgement;
};

export type RestoreFdcApprovalGroupResponse = {
  __typename: 'RestoreFDCApprovalGroupResponse';
  /** the restored `FDCApprovalGroup` */
  approvalGroup: FdcApprovalGroup;
};

export type RestoreFdcConcurrenceGroupResponse = {
  __typename: 'RestoreFDCConcurrenceGroupResponse';
  /** the restored `FDCConcurrenceGroup` */
  concurrenceGroup: FdcConcurrenceGroup;
};

export type RestoreFdcConcurrenceLevelResponse = {
  __typename: 'RestoreFDCConcurrenceLevelResponse';
  /** the restored `FDCConcurrenceLevel` */
  concurrenceLevel: FdcConcurrenceLevel;
};

export type RestoreFdcDisciplineResponse = {
  __typename: 'RestoreFDCDisciplineResponse';
  /** the restored `FDCDiscipline` */
  discipline: FdcDiscipline;
};

export type RestoreFdcQuickLinkResponse = {
  __typename: 'RestoreFDCQuickLinkResponse';
  /** the restored `FDCQuickLink` */
  fdcQuickLink: FdcQuickLink;
};

export type RestoreFieldDesignChangeResponse = {
  __typename: 'RestoreFieldDesignChangeResponse';
  /** the restored `FieldDesignChange` */
  fieldDesignChange: FieldDesignChange;
};

export type RestoreIssueDispositionTypeResponse = {
  __typename: 'RestoreIssueDispositionTypeResponse';
  /** the restored `IssueDispositionType` */
  dispositionType: IssueDispositionType;
};

export type RestoreIssueQuickLinkResponse = {
  __typename: 'RestoreIssueQuickLinkResponse';
  /** the restored `IssueQuickLink` */
  quickLink: IssueQuickLink;
};

export type RestoreIssueResponse = {
  __typename: 'RestoreIssueResponse';
  /** the restored `Issue` */
  issue: Issue;
};

export type RestoreIssueTypeResponse = {
  __typename: 'RestoreIssueTypeResponse';
  /** the restored `IssueType` */
  type: IssueType;
};

export type RestoreLimsAsphaltMixDesignTargetResponse = {
  __typename: 'RestoreLIMSAsphaltMixDesignTargetResponse';
  /** the restored `LIMSAsphaltMixDesignTarget` */
  target: LimsAsphaltMixDesignTarget;
};

export type RestorePayItemConnectionGroupResponse = {
  __typename: 'RestorePayItemConnectionGroupResponse';
  /** the restored `PayItemConnectionGroup` */
  payItemConnectionGroup: PayItemConnectionGroup;
};

export type RestorePayItemConnectionResponse = {
  __typename: 'RestorePayItemConnectionResponse';
  /** the restored `PayItemConnection` */
  payItemConnection: PayItemConnection;
};

export type RestoreRfiOrganizationResponse = {
  __typename: 'RestoreRFIOrganizationResponse';
  /** the restored `RFIOrganization` */
  organization: RfiOrganization;
};

export type RestoreRfiQuickLinkResponse = {
  __typename: 'RestoreRFIQuickLinkResponse';
  /** the restored `RFIQuickLink` */
  rfiQuickLink: RfiQuickLink;
};

export type RestoreRfiResponseDisciplineResponse = {
  __typename: 'RestoreRFIResponseDisciplineResponse';
  /** the restored `RFIResponseDiscipline` */
  responseDiscipline: RfiResponseDiscipline;
};

export type RestoreRfiResponseResponse = {
  __typename: 'RestoreRFIResponseResponse';
  /** the restored `RFIResponse` */
  response: RfiResponse;
};

export type RestoreRequestForInformationResponse = {
  __typename: 'RestoreRequestForInformationResponse';
  /** the restored `RequestForInformation` */
  requestForInformation: RequestForInformation;
};

export type RestoreRoleResponse = {
  __typename: 'RestoreRoleResponse';
  /** the restored `Role` */
  role: Role;
};

export type RevertConstructionAdminSubmittalInput = {
  comment: Scalars['String'];
  contractualReviewDate?: InputMaybe<Scalars['DateTime']>;
  id: Scalars['String'];
  quantity?: InputMaybe<Scalars['Int']>;
  requestedReviewDate?: InputMaybe<Scalars['DateTime']>;
  routingGroupIds?: InputMaybe<Array<Scalars['String']>>;
  statusId: Scalars['String'];
  subtypeId?: InputMaybe<Scalars['String']>;
  typeId?: InputMaybe<Scalars['String']>;
  units?: InputMaybe<Scalars['String']>;
};

export type RevertConstructionAdminSubmittalResponse = {
  __typename: 'RevertConstructionAdminSubmittalResponse';
  /** Reverted Submittal */
  submittal: ConstructionAdminSubmittal;
};

export type RevertDesignSubmittalInput = {
  /** a list of `DSAction.id` values  */
  actionIds: Array<Scalars['String']>;
  /** uses the maximum character length available in the database */
  comment?: InputMaybe<Scalars['String']>;
  contractDueDate: Scalars['DateTime'];
  /** a list of `DSDiscipline.id` values  */
  disciplineIds: Array<Scalars['String']>;
  id: Scalars['String'];
};

export type RevertDesignSubmittalResponse = {
  __typename: 'RevertDesignSubmittalResponse';
  designSubmittal: DesignSubmittal;
};

export type RevertEngineeringJudgementInput = {
  failureDate?: InputMaybe<Scalars['DateTime']>;
  failureDescription?: InputMaybe<Scalars['String']>;
  id: Scalars['String'];
  justification?: InputMaybe<Scalars['String']>;
  manualReportId?: InputMaybe<Scalars['String']>;
  notes?: InputMaybe<Scalars['String']>;
  reports?: InputMaybe<Array<MutateEjToReportInput>>;
  typeId?: InputMaybe<Scalars['String']>;
};

export type RevertEngineeringJudgementResponse = {
  __typename: 'RevertEngineeringJudgementResponse';
  judgement: EngineeringJudgement;
};

export type RevertFieldDesignChangeInput = {
  /**
   * the text of the comment
   *
   * limited to 1000 characters
   */
  comment: Scalars['String'];
  id: Scalars['String'];
};

export type RevertFieldDesignChangeResponse = {
  __typename: 'RevertFieldDesignChangeResponse';
  fieldDesignChange: FieldDesignChange;
};

export type RevertIdentifiedFieldIssueInput = {
  comment: Scalars['String'];
  reportId: Scalars['String'];
};

export type RevertIdentifiedFieldIssueResponse = {
  __typename: 'RevertIdentifiedFieldIssueResponse';
  identifiedFieldIssue: IdentifiedFieldIssue;
};

export type RevertIssueInput = {
  closureNotes?: InputMaybe<Scalars['String']>;
  comment: Scalars['String'];
  description?: InputMaybe<Scalars['String']>;
  dispositionNotes?: InputMaybe<Scalars['String']>;
  id: Scalars['String'];
  response?: InputMaybe<Scalars['String']>;
  statusId: Scalars['String'];
};

export type RevertIssueResponse = {
  __typename: 'RevertIssueResponse';
  issue: Issue;
};

export type RevertRequestForInformationInput = {
  additionalDisciplineIds?: InputMaybe<Array<Scalars['String']>>;
  /**
   * the text of the comment
   *
   * limited to 1000 characters
   */
  comment: Scalars['String'];
  description: Scalars['String'];
  id: Scalars['String'];
  organizationId?: InputMaybe<Scalars['String']>;
  reopenDisciplineIds?: InputMaybe<Array<Scalars['String']>>;
  requestedResponseDate?: InputMaybe<Scalars['DateTime']>;
  responseDisciplineIds?: InputMaybe<Array<Scalars['String']>>;
  statusId: Scalars['String'];
};

export type RevertRequestForInformationResponse = {
  __typename: 'RevertRequestForInformationResponse';
  requestForInformation: RequestForInformation;
};

export type ReviewIdentifiedFieldIssueInput = {
  reportId: Scalars['String'];
  reviewNotes: Scalars['String'];
};

export type ReviewIdentifiedFieldIssueResponse = {
  __typename: 'ReviewIdentifiedFieldIssueResponse';
  identifiedFieldIssue: IdentifiedFieldIssue;
};

export type ReviseConstructionAdminSubmittalInput = {
  comment: Scalars['String'];
  id: Scalars['String'];
  quantity: Scalars['Int'];
  requestedReviewDate: Scalars['DateTime'];
  subtypeId?: InputMaybe<Scalars['String']>;
  typeId: Scalars['String'];
  units: Scalars['String'];
};

export type ReviseConstructionAdminSubmittalResponse = {
  __typename: 'ReviseConstructionAdminSubmittalResponse';
  /** Revised Submittal */
  submittal: ConstructionAdminSubmittal;
};

export type Role = {
  __typename: 'Role';
  /** the date this record was inserted into the database */
  createdDate: Scalars['DateTime'];
  /**
   * the email address of a user associated with the `createdDate`
   *
   * this value will be `unknown` if the `createdDate` was not set by a user
   */
  createdUser: Scalars['String'];
  /** describes whether the record has been soft-deleted or not */
  deleted: Scalars['Boolean'];
  /** the date this record was soft-deleted in the database */
  deletedDate: Maybe<Scalars['DateTime']>;
  /**
   * the email address of a user associated with the `deletedDate`
   *
   * this value will be `system` if the `deletedDate` was not set by a user
   */
  deletedUser: Maybe<Scalars['String']>;
  /**
   * an extended description associated with the record
   *
   * this description will be used to describe the record in CIMS, where possible
   */
  description: Maybe<Scalars['String']>;
  fdcApprovalGroups: Array<FdcApprovalGroup>;
  fdcConcurrenceGroups: Array<FdcConcurrenceGroup>;
  /** a UUID used to globally identify this record in the database */
  id: Scalars['String'];
  /** the date this record was last updated in the database */
  lastEditedDate: Scalars['DateTime'];
  /**
   * the email address of a user associated with the `lastEditedDate`
   *
   * this value will be `system` if the `lastEditedDate` was not set by a user
   */
  lastEditedUser: Scalars['String'];
  /** a human readable name associated with the record */
  name: Scalars['String'];
  permissions: Array<Scalars['String']>;
  /** a related `Project` */
  project: Project;
  /** the `globalId` of a related `Project` */
  projectId: Scalars['String'];
  users: Array<User>;
};


export type RoleFdcApprovalGroupsArgs = {
  fdcApprovalGroupFieldInput?: InputMaybe<FdcApprovalGroupFieldInput>;
};


export type RoleFdcConcurrenceGroupsArgs = {
  fdcConcurrenceGroupFieldInput?: InputMaybe<FdcConcurrenceGroupFieldInput>;
};


export type RoleUsersArgs = {
  userFieldInput?: InputMaybe<UserFieldInput>;
};

/**
 * helps filter multiple `Role` records
 *
 * this version of the input will have limited options compared to its other counterpart
 */
export type RoleFieldInput = {
  createdDate?: InputMaybe<DateTimeFilter>;
  /**
   * determines now to handle deleted `Role` records
   *
   * - when `true`, only return deleted records
   * - when `false`, do not return deleted records
   * - when omitted, `deleted` is ignored
   */
  deleted?: InputMaybe<Scalars['Boolean']>;
  lastEditedDate?: InputMaybe<DateTimeFilter>;
  name?: InputMaybe<StringFilter>;
  /**
   * how to order `Role` records
   *
   * executed in the order they are defined
   */
  orderBy?: InputMaybe<Array<OrderByInput>>;
  projectId?: InputMaybe<StringFilter>;
  /**
   * specifies how many records to return
   *
   * analogous to `limit`, `first`, or `top` in SQL dialects
   */
  take?: InputMaybe<Scalars['Int']>;
};

/** helps filter multiple `Role` records */
export type RoleListInput = {
  createdDate?: InputMaybe<DateTimeFilter>;
  /**
   * determines now to handle deleted `Role` records
   *
   * - when `true`, only return deleted records
   * - when `false`, do not return deleted records
   * - when omitted, `deleted` is ignored
   */
  deleted?: InputMaybe<Scalars['Boolean']>;
  lastEditedDate?: InputMaybe<DateTimeFilter>;
  name?: InputMaybe<StringFilter>;
  /**
   * how to order `Role` records
   *
   * executed in the order they are defined
   */
  orderBy?: InputMaybe<Array<OrderByInput>>;
  /**
   * paginate `Role` records
   *
   * using `paginate` may require multiple requests to get all possible results,
   * but will give more fine-grain control in the event all records cannot be
   * returned gracefully
   */
  paginate?: InputMaybe<PaginationInput>;
  projectId?: InputMaybe<StringFilter>;
};

/** response metadata for a list query of Role records */
export type RoleListResponse = {
  __typename: 'RoleListResponse';
  /** the total count of Role records matching any configured filters */
  count: Scalars['Int'];
  /** the total count of paginated groups of Role */
  pages: Scalars['Int'];
  /** Role records */
  records: Array<Role>;
};

export type RoleToPermission = {
  __typename: 'RoleToPermission';
  permissionId: Scalars['String'];
  roleId: Scalars['String'];
};

export type RouteConstructionAdminSubmittalToGroupReviewInput = {
  comment: Scalars['String'];
  contractualReviewDate: Scalars['DateTime'];
  externalLinks?: InputMaybe<Array<ExternalLinkInput>>;
  id: Scalars['String'];
  routingGroupIds?: InputMaybe<Array<Scalars['String']>>;
};

export type RouteConstructionAdminSubmittalToGroupReviewResponse = {
  __typename: 'RouteConstructionAdminSubmittalToGroupReviewResponse';
  /** Routed Submittal */
  submittal: ConstructionAdminSubmittal;
};

export type RouteConstructionAdminSubmittalToReReviewInput = {
  comment: Scalars['String'];
  contractualReviewDate: Scalars['DateTime'];
  externalLinks?: InputMaybe<Array<ExternalLinkInput>>;
  id: Scalars['String'];
};

export type RouteConstructionAdminSubmittalToReReviewResponse = {
  __typename: 'RouteConstructionAdminSubmittalToREReviewResponse';
  /** Routed Submittal */
  submittal: ConstructionAdminSubmittal;
};

export type RouteDesignSubmittalInput = {
  /** a list of `DSAction.id` values  */
  actionIds: Array<Scalars['String']>;
  /** uses the maximum character length available in the database */
  comment?: InputMaybe<Scalars['String']>;
  contractDueDate: Scalars['DateTime'];
  /** a list of `DSDiscipline.id` values  */
  disciplineIds: Array<Scalars['String']>;
  id: Scalars['String'];
};

export type RouteDesignSubmittalResponse = {
  __typename: 'RouteDesignSubmittalResponse';
  designSubmittal: DesignSubmittal;
};

/** values required to create, edit, or remove `CASToCASRoutingGroup` records based on the value of `accepted` */
export type SetCasToCasRoutingGroupInput = {
  accepted: Scalars['Boolean'];
  routingGroupId: Scalars['String'];
  submittalId: Scalars['String'];
};

export type SetCasToCasRoutingGroupResponse = {
  __typename: 'SetCASToCASRoutingGroupResponse';
  accepted: Scalars['Boolean'];
  routingGroup: CasRoutingGroup;
};

/** values required to create, edit, or remove `DSToDSDiscipline` records based on the value of `accepted` */
export type SetDsToDsDisciplineInput = {
  accepted: Scalars['Boolean'];
  disciplineId: Scalars['String'];
  submittalId: Scalars['String'];
};

export type SetDsToDsDisciplineResponse = {
  __typename: 'SetDSToDSDisciplineResponse';
  accepted: Scalars['Boolean'];
  discipline: DsDiscipline;
};

/** values required to create, edit, or remove `DocumentChecklistValue` records based on the value of `checked` */
export type SetDocumentChecklistValueInput = {
  checked: Scalars['Boolean'];
  concreteTestSetId: Scalars['String'];
  documentChecklistItemId: Scalars['Int'];
};

export type SetDocumentChecklistValueResponse = {
  __typename: 'SetDocumentChecklistValueResponse';
  documentChecklistValue: DocumentChecklistValue;
};

/** values required to create, edit, or remove `FDCToFDCApprovalGroup` records based on the value of `approved` */
export type SetFdcToFdcApprovalGroupInput = {
  approvalGroupId: Scalars['String'];
  approved: Scalars['Boolean'];
  fieldDesignChangeId: Scalars['String'];
};

export type SetFdcToFdcApprovalGroupResponse = {
  __typename: 'SetFDCToFDCApprovalGroupResponse';
  approvalGroup: FdcApprovalGroup;
  approved: Scalars['Boolean'];
};

/** values required to create, edit, or remove `FDCToFDCConcurrenceGroup` records based on the value of `concurred` */
export type SetFdcToFdcConcurrenceGroupInput = {
  comment?: InputMaybe<Scalars['String']>;
  concurred: Scalars['Boolean'];
  concurrenceGroupId: Scalars['String'];
  concurrenceLevelId?: InputMaybe<Scalars['String']>;
  fieldDesignChangeId: Scalars['String'];
};

export type SetFdcToFdcConcurrenceGroupResponse = {
  __typename: 'SetFDCToFDCConcurrenceGroupResponse';
  concurred: Scalars['Boolean'];
  concurrenceGroup: FdcConcurrenceGroup;
};

export enum SetSharePointPermissionsRequest {
  /** lock the resource from editing */
  Lock = 'Lock',
  /** unlock the resource for editing */
  Unlock = 'Unlock'
}

export type SetSharePointResourcePermissionsInput = {
  /** the id of the `SharePointParentFolderItem` associated with the record */
  parentId: Scalars['String'];
  /** the id of the record associated with the `SharePointParentFolderItem` */
  recordId: Scalars['String'];
  request: SetSharePointPermissionsRequest;
  /** the id of the primary `SharePointResource` of the record */
  resourceId: Scalars['String'];
};

export type SetSharePointResourcePermissionsResponse = {
  __typename: 'SetSharePointResourcePermissionsResponse';
  concreteTestSet: Maybe<ConcreteTestSet>;
  constructionAdminSubmittal: Maybe<ConstructionAdminSubmittal>;
  designSubmittal: Maybe<DesignSubmittal>;
  fieldDesignChange: Maybe<FieldDesignChange>;
  issue: Maybe<Issue>;
  requestForInformation: Maybe<RequestForInformation>;
  /** the `User` associated with the request */
  user: User;
};

export type SharePointDrive = {
  __typename: 'SharePointDrive';
  description: Maybe<Scalars['String']>;
  id: Scalars['String'];
  name: Scalars['String'];
};

/** a collection of Microsoft Graph API `DriveItem` fields and useful fields for CIMS */
export type SharePointResource = {
  __typename: 'SharePointResource';
  /** the `DriveItem.createdDateTime` */
  createdDate: Maybe<Scalars['String']>;
  /**
   * a download url for the associated `DriveItem`
   *
   * this link is a short-lived url and will only be available for 1 hour from the time of a request
   */
  downloadUrl: Maybe<Scalars['String']>;
  /** the `DriveItem.id` */
  id: Scalars['String'];
  /** the `DriveItem.lastModifiedDateTime` */
  lastEditedDate: Maybe<Scalars['String']>;
  /** the `DriveItem.name` */
  name: Maybe<Scalars['String']>;
  /** any child `SharePointResource` objects associated with this resource */
  sharePointResources: Array<SharePointResource>;
  /** the `DriveItem.webUrl` */
  webUrl: Maybe<Scalars['String']>;
};

/** input options for handling a `SharePointResource` by folder name */
export type SharePointResourceFolderInput = {
  folder: Scalars['String'];
  parentId: Scalars['String'];
};

/** input options for handling a `SharePointResource` by `id` */
export type SharePointResourceIdInput = {
  /** the `DriveItem.id` */
  id: Scalars['String'];
};

/** options for handling `SharePointResource` objects */
export type SharePointResourceInput = {
  byFolder?: InputMaybe<SharePointResourceFolderInput>;
  byId?: InputMaybe<SharePointResourceIdInput>;
  /** the `globalId` of a related `Project` */
  projectId: Scalars['String'];
};

export type SharePointSite = {
  __typename: 'SharePointSite';
  createdDate: Maybe<Scalars['DateTime']>;
  description: Maybe<Scalars['String']>;
  displayName: Maybe<Scalars['String']>;
  id: Scalars['String'];
  lastEditedDate: Maybe<Scalars['DateTime']>;
  name: Maybe<Scalars['String']>;
  webUrl: Maybe<Scalars['String']>;
};

export type SoftRemoveCasDispositionTypeResponse = {
  __typename: 'SoftRemoveCASDispositionTypeResponse';
  /** the soft-removed `CASDispositionType` */
  dispositionType: CasDispositionType;
};

export type SoftRemoveCasQuickLinkResponse = {
  __typename: 'SoftRemoveCASQuickLinkResponse';
  /** the soft-removed `CASQuickLink` */
  casQuickLink: CasQuickLink;
};

export type SoftRemoveCasRoutingGroupResponse = {
  __typename: 'SoftRemoveCASRoutingGroupResponse';
  /** the removed `CASRoutingGroup` */
  routingGroup: CasRoutingGroup;
};

export type SoftRemoveCasSubtypeResponse = {
  __typename: 'SoftRemoveCASSubtypeResponse';
  /** the soft-removed `CASSubtype` */
  subtype: CasSubtype;
};

export type SoftRemoveCasTypeResponse = {
  __typename: 'SoftRemoveCASTypeResponse';
  /** the soft-removed `CASType` */
  type: CasType;
};

export type SoftRemoveConstructionAdminSubmittalResponse = {
  __typename: 'SoftRemoveConstructionAdminSubmittalResponse';
  /** the soft-removed `ConstructionAdminSubmittal` */
  submittal: ConstructionAdminSubmittal;
};

export type SoftRemoveCustomFieldResponse = {
  __typename: 'SoftRemoveCustomFieldResponse';
  /** the soft-removed `CustomField` */
  customField: CustomField;
};

export type SoftRemoveCustomFieldToClassTypeResponse = {
  __typename: 'SoftRemoveCustomFieldToClassTypeResponse';
  /** the soft-removed `CustomFieldToClassType` */
  customFieldToClassType: CustomFieldToClassType;
};

export type SoftRemoveCustomListItemResponse = {
  __typename: 'SoftRemoveCustomListItemResponse';
  /** the soft-removed `CustomListItem` */
  customListItem: CustomListItem;
};

export type SoftRemoveDsActionResponse = {
  __typename: 'SoftRemoveDSActionResponse';
  /** the soft-removed `DSAction` */
  action: DsAction;
};

export type SoftRemoveDsDisciplineResponse = {
  __typename: 'SoftRemoveDSDisciplineResponse';
  /** the soft-removed `DSDiscipline` */
  discipline: DsDiscipline;
};

export type SoftRemoveDsOrganizationResponse = {
  __typename: 'SoftRemoveDSOrganizationResponse';
  /** the soft-removed `DSOrganization` */
  organization: DsOrganization;
};

export type SoftRemoveDsQuickLinkResponse = {
  __typename: 'SoftRemoveDSQuickLinkResponse';
  /** the soft-removed `DSQuickLink` */
  dsQuickLink: DsQuickLink;
};

export type SoftRemoveDsTypeResponse = {
  __typename: 'SoftRemoveDSTypeResponse';
  /** the soft-removed `DSType` */
  type: DsType;
};

export type SoftRemoveDesignSubmittalResponse = {
  __typename: 'SoftRemoveDesignSubmittalResponse';
  /** the soft-removed `DesignSubmittal` */
  designSubmittal: DesignSubmittal;
};

export type SoftRemoveEjQuickLinkResponse = {
  __typename: 'SoftRemoveEJQuickLinkResponse';
  /** the soft-removed `EJQuickLink` */
  ejQuickLink: EjQuickLink;
};

export type SoftRemoveEjTypeResponse = {
  __typename: 'SoftRemoveEJTypeResponse';
  /** the soft-removed `EJType` */
  type: EjType;
};

export type SoftRemoveEngineeringJudgementResponse = {
  __typename: 'SoftRemoveEngineeringJudgementResponse';
  /** the soft-removed `EngineeringJudgement` */
  judgement: EngineeringJudgement;
};

export type SoftRemoveFdcApprovalGroupResponse = {
  __typename: 'SoftRemoveFDCApprovalGroupResponse';
  /** the soft-removed `FDCApprovalGroup` */
  approvalGroup: FdcApprovalGroup;
};

export type SoftRemoveFdcConcurrenceGroupResponse = {
  __typename: 'SoftRemoveFDCConcurrenceGroupResponse';
  /** the soft-removed `FDCConcurrenceGroup` */
  concurrenceGroup: FdcConcurrenceGroup;
};

export type SoftRemoveFdcConcurrenceLevelResponse = {
  __typename: 'SoftRemoveFDCConcurrenceLevelResponse';
  /** the soft-removed `FDCConcurrenceLevel` */
  concurrenceLevel: FdcConcurrenceLevel;
};

export type SoftRemoveFdcDisciplineResponse = {
  __typename: 'SoftRemoveFDCDisciplineResponse';
  /** the soft-removed `FDCDiscipline` */
  discipline: FdcDiscipline;
};

export type SoftRemoveFdcQuickLinkResponse = {
  __typename: 'SoftRemoveFDCQuickLinkResponse';
  /** the soft-removed `FDCQuickLink` */
  fdcQuickLink: FdcQuickLink;
};

export type SoftRemoveFieldDesignChangeResponse = {
  __typename: 'SoftRemoveFieldDesignChangeResponse';
  /** the soft-removed `FieldDesignChange` */
  fieldDesignChange: FieldDesignChange;
};

export type SoftRemoveIssueDispositionTypeResponse = {
  __typename: 'SoftRemoveIssueDispositionTypeResponse';
  /** the soft-removed `IssueDispositionType` */
  dispositionType: IssueDispositionType;
};

export type SoftRemoveIssueQuickLinkResponse = {
  __typename: 'SoftRemoveIssueQuickLinkResponse';
  /** the soft-removed `IssueQuickLink` */
  quickLink: IssueQuickLink;
};

export type SoftRemoveIssueResponse = {
  __typename: 'SoftRemoveIssueResponse';
  /** the soft-removed `Issue` */
  issue: Issue;
};

export type SoftRemoveIssueTypeResponse = {
  __typename: 'SoftRemoveIssueTypeResponse';
  /** the soft-removed `IssueType` */
  type: IssueType;
};

export type SoftRemoveLimsAsphaltMixDesignTargetResponse = {
  __typename: 'SoftRemoveLIMSAsphaltMixDesignTargetResponse';
  /** the removed `LIMSAsphaltMixDesignTarget` */
  target: LimsAsphaltMixDesignTarget;
};

export type SoftRemovePayItemConnectionGroupResponse = {
  __typename: 'SoftRemovePayItemConnectionGroupResponse';
  /** the soft-removed `PayItemConnectionGroup` */
  payItemConnectionGroup: PayItemConnectionGroup;
};

export type SoftRemovePayItemConnectionResponse = {
  __typename: 'SoftRemovePayItemConnectionResponse';
  /** the soft-removed `PayItemConnection` */
  payItemConnection: PayItemConnection;
};

export type SoftRemoveRfiOrganizationResponse = {
  __typename: 'SoftRemoveRFIOrganizationResponse';
  /** the soft-removed `RFIOrganization` */
  organization: RfiOrganization;
};

export type SoftRemoveRfiQuickLinkResponse = {
  __typename: 'SoftRemoveRFIQuickLinkResponse';
  /** the soft-removed `RFIQuickLink` */
  rfiQuickLink: RfiQuickLink;
};

export type SoftRemoveRfiResponseDisciplineResponse = {
  __typename: 'SoftRemoveRFIResponseDisciplineResponse';
  /** the soft-removed `RFIResponseDiscipline` */
  responseDiscipline: RfiResponseDiscipline;
};

export type SoftRemoveRfiResponseResponse = {
  __typename: 'SoftRemoveRFIResponseResponse';
  /** the soft-removed `RFIResponse` */
  response: RfiResponse;
};

export type SoftRemoveRequestForInformationResponse = {
  __typename: 'SoftRemoveRequestForInformationResponse';
  /** the soft-removed `RequestForInformation` */
  requestForInformation: RequestForInformation;
};

export type SoftRemoveRoleResponse = {
  __typename: 'SoftRemoveRoleResponse';
  /** the soft-removed `Role` */
  role: Role;
};

/**
 * filter options for `String` values
 *
 * undefined
 *
 * only one filter will be active at a time
 *
 * filters are preferred in the following order
 *
 * - equals
 * - contains
 * - list
 * - null
 */
export type StringFilter = {
  /**
   * the supplied value appears anywhere in the field value
   *
   * the supplied value is always transformed to lowercase and wrapped in wildcards
   */
  contains?: InputMaybe<Scalars['String']>;
  /** the supplied value equals the field value */
  equals?: InputMaybe<Scalars['String']>;
  /** possible values of the field value */
  list?: InputMaybe<Array<Scalars['String']>>;
  /**
   * filters based on the nullability of the field
   *
   * - if true: return records where the field value is null
   * - if false: return records where the field value is not null
   */
  null?: InputMaybe<Scalars['Boolean']>;
};

export type Structure = {
  __typename: 'Structure';
  /** the date this record was inserted into the database */
  createdDate: Maybe<Scalars['DateTime']>;
  /** the username or email address of a mobile app user associated with the `createdDate` */
  createdUser: Maybe<Scalars['String']>;
  deleted: Scalars['Boolean'];
  /** a GUID used to globally identify this record in the database */
  globalId: Scalars['String'];
  /** the date this record was last updated in the database */
  lastEditedDate: Maybe<Scalars['DateTime']>;
  /** the username or email address of a mobile app user associated with the `lastEditedDate` */
  lastEditedUser: Maybe<Scalars['String']>;
  lots: Array<Lot>;
  name: Maybe<Scalars['String']>;
  /** a related `Project` */
  project: Maybe<Project>;
  /** the `globalId` of a related `Project` */
  projectId: Maybe<Scalars['String']>;
  structureType: Maybe<StructureType>;
  structureTypeId: Maybe<Scalars['String']>;
};


export type StructureLotsArgs = {
  lotFieldInput?: InputMaybe<LotFieldInput>;
};

/**
 * helps filter multiple `Structure` records
 *
 * this version of the input will have limited options compared to its other counterpart
 */
export type StructureFieldInput = {
  /**
   * determines now to handle deleted `Structure` records
   *
   * - when `true`, only return deleted records
   * - when `false`, do not return deleted records
   * - when omitted, `deleted` is ignored
   */
  deleted?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<StringFilter>;
  /**
   * how to order `Structure` records
   *
   * executed in the order they are defined
   */
  orderBy?: InputMaybe<Array<OrderByInput>>;
  projectId?: InputMaybe<StringFilter>;
  structureTypeId?: InputMaybe<StringFilter>;
  /**
   * specifies how many records to return
   *
   * analogous to `limit`, `first`, or `top` in SQL dialects
   */
  take?: InputMaybe<Scalars['Int']>;
};

/** helps filter multiple `Structure` records */
export type StructureListInput = {
  /**
   * determines now to handle deleted `Structure` records
   *
   * - when `true`, only return deleted records
   * - when `false`, do not return deleted records
   * - when omitted, `deleted` is ignored
   */
  deleted?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<StringFilter>;
  /**
   * how to order `Structure` records
   *
   * executed in the order they are defined
   */
  orderBy?: InputMaybe<Array<OrderByInput>>;
  /**
   * paginate `Structure` records
   *
   * using `paginate` may require multiple requests to get all possible results,
   * but will give more fine-grain control in the event all records cannot be
   * returned gracefully
   */
  paginate?: InputMaybe<PaginationInput>;
  projectId?: InputMaybe<StringFilter>;
  structureTypeId?: InputMaybe<StringFilter>;
};

/** response metadata for a list query of Structure records */
export type StructureListResponse = {
  __typename: 'StructureListResponse';
  /** the total count of Structure records matching any configured filters */
  count: Scalars['Int'];
  /** the total count of paginated groups of Structure */
  pages: Scalars['Int'];
  /** Structure records */
  records: Array<Structure>;
};

export type StructureType = {
  __typename: 'StructureType';
  concretePlacements: Array<ConcretePlacement>;
  /** the date this record was inserted into the database */
  createdDate: Maybe<Scalars['DateTime']>;
  /** the username or email address of a mobile app user associated with the `createdDate` */
  createdUser: Maybe<Scalars['String']>;
  deleted: Scalars['Boolean'];
  /** a GUID used to globally identify this record in the database */
  globalId: Scalars['String'];
  /** the date this record was last updated in the database */
  lastEditedDate: Maybe<Scalars['DateTime']>;
  /** the username or email address of a mobile app user associated with the `lastEditedDate` */
  lastEditedUser: Maybe<Scalars['String']>;
  lots: Array<Lot>;
  name: Maybe<Scalars['String']>;
  /** a related `Project` */
  project: Maybe<Project>;
  /** the `globalId` of a related `Project` */
  projectId: Maybe<Scalars['String']>;
  structures: Array<Structure>;
};


export type StructureTypeConcretePlacementsArgs = {
  concretePlacementFieldInput?: InputMaybe<ConcretePlacementFieldInput>;
};


export type StructureTypeLotsArgs = {
  lotFieldInput?: InputMaybe<LotFieldInput>;
};


export type StructureTypeStructuresArgs = {
  structureFieldInput?: InputMaybe<StructureFieldInput>;
};

/**
 * helps filter multiple `StructureType` records
 *
 * this version of the input will have limited options compared to its other counterpart
 */
export type StructureTypeFieldInput = {
  createdDate?: InputMaybe<DateTimeFilter>;
  /**
   * determines now to handle deleted `StructureType` records
   *
   * - when `true`, only return deleted records
   * - when `false`, do not return deleted records
   * - when omitted, `deleted` is ignored
   */
  deleted?: InputMaybe<Scalars['Boolean']>;
  lastEditedDate?: InputMaybe<DateTimeFilter>;
  name?: InputMaybe<StringFilter>;
  /**
   * how to order `StructureType` records
   *
   * executed in the order they are defined
   */
  orderBy?: InputMaybe<Array<OrderByInput>>;
  projectId?: InputMaybe<StringFilter>;
  /**
   * specifies how many records to return
   *
   * analogous to `limit`, `first`, or `top` in SQL dialects
   */
  take?: InputMaybe<Scalars['Int']>;
};

/** helps filter multiple `StructureType` records */
export type StructureTypeListInput = {
  createdDate?: InputMaybe<DateTimeFilter>;
  /**
   * determines now to handle deleted `StructureType` records
   *
   * - when `true`, only return deleted records
   * - when `false`, do not return deleted records
   * - when omitted, `deleted` is ignored
   */
  deleted?: InputMaybe<Scalars['Boolean']>;
  lastEditedDate?: InputMaybe<DateTimeFilter>;
  name?: InputMaybe<StringFilter>;
  /**
   * how to order `StructureType` records
   *
   * executed in the order they are defined
   */
  orderBy?: InputMaybe<Array<OrderByInput>>;
  /**
   * paginate `StructureType` records
   *
   * using `paginate` may require multiple requests to get all possible results,
   * but will give more fine-grain control in the event all records cannot be
   * returned gracefully
   */
  paginate?: InputMaybe<PaginationInput>;
  projectId?: InputMaybe<StringFilter>;
};

/** response metadata for a list query of StructureType records */
export type StructureTypeListResponse = {
  __typename: 'StructureTypeListResponse';
  /** the total count of StructureType records matching any configured filters */
  count: Scalars['Int'];
  /** the total count of paginated groups of StructureType */
  pages: Scalars['Int'];
  /** StructureType records */
  records: Array<StructureType>;
};

export type SubmitEngineeringJudgementInput = {
  customFields?: InputMaybe<MutateCustomFieldsInput>;
  externalLinks?: InputMaybe<Array<ExternalLinkInput>>;
  failureDate: Scalars['DateTime'];
  failureDescription: Scalars['String'];
  id?: InputMaybe<Scalars['String']>;
  justification: Scalars['String'];
  manualReportId?: InputMaybe<Scalars['String']>;
  notes: Scalars['String'];
  payItemIds?: InputMaybe<Array<Scalars['String']>>;
  projectId: Scalars['String'];
  reports?: InputMaybe<Array<MutateEjToReportInput>>;
  typeId: Scalars['String'];
};

export type SubmitEngineeringJudgementResponse = {
  __typename: 'SubmitEngineeringJudgementResponse';
  judgement: EngineeringJudgement;
};

export type SubmitFieldDesignChangeInput = {
  concurrenceLevelId: Scalars['String'];
  customFields?: InputMaybe<MutateCustomFieldsInput>;
  disciplineIds: Array<Scalars['String']>;
  drawingsAffected?: InputMaybe<Scalars['String']>;
  externalLinks?: InputMaybe<Array<ExternalLinkInput>>;
  id?: InputMaybe<Scalars['String']>;
  issue: Scalars['String'];
  location: Scalars['String'];
  number?: InputMaybe<Scalars['String']>;
  payItemIds?: InputMaybe<Array<Scalars['String']>>;
  projectId: Scalars['String'];
  requestedApprovalDate?: InputMaybe<Scalars['DateTime']>;
  resolution?: InputMaybe<Scalars['String']>;
  specsAffected?: InputMaybe<Scalars['String']>;
};

export type SubmitFieldDesignChangeResponse = {
  __typename: 'SubmitFieldDesignChangeResponse';
  fieldDesignChange: FieldDesignChange;
};

export type SubmitIssueInput = {
  customFields?: InputMaybe<MutateCustomFieldsInput>;
  description: Scalars['String'];
  externalLinks?: InputMaybe<Array<ExternalLinkInput>>;
  id?: InputMaybe<Scalars['String']>;
  identifiedFieldIssueId?: InputMaybe<Scalars['String']>;
  number?: InputMaybe<Scalars['String']>;
  payItemIds: Array<Scalars['String']>;
  projectId?: InputMaybe<Scalars['String']>;
  reports?: InputMaybe<Array<MutateIssueToReportInput>>;
  typeIds: Array<Scalars['String']>;
};

export type SubmitIssueResponse = {
  __typename: 'SubmitIssueResponse';
  issue: Issue;
};

export type SubmitRequestForInformationInput = {
  customFields?: InputMaybe<MutateCustomFieldsInput>;
  description: Scalars['String'];
  externalLinks?: InputMaybe<Array<ExternalLinkInput>>;
  id?: InputMaybe<Scalars['String']>;
  number?: InputMaybe<Scalars['String']>;
  organizationId: Scalars['String'];
  projectId: Scalars['String'];
  requestedResponseDate: Scalars['DateTime'];
  responseDisciplineIds: Array<Scalars['String']>;
};

export type SubmitRequestForInformationResponse = {
  __typename: 'SubmitRequestForInformationResponse';
  requestForInformation: RequestForInformation;
};

/** values required to sync `GoogleSheetPayItemConnection` objects */
export type SyncGoogleSheetPayItemConnectionInput = {
  connectionId: Scalars['String'];
  wait?: InputMaybe<Scalars['Boolean']>;
};

export type SyncGoogleSheetPayItemConnectionResponse = {
  __typename: 'SyncGoogleSheetPayItemConnectionResponse';
  /** the synced `GoogleSheetPayItemConnection` */
  googleSheet: GoogleSheetPayItemConnection;
};

export type SyncUsersResponse = {
  __typename: 'SyncUsersResponse';
  success: Scalars['Boolean'];
};

export type Tag = {
  __typename: 'Tag';
  /** the date this record was inserted into the database */
  createdDate: Maybe<Scalars['DateTime']>;
  /** the username or email address of a mobile app user associated with the `createdDate` */
  createdUser: Maybe<Scalars['String']>;
  deleted: Maybe<Scalars['String']>;
  /** a GUID used to globally identify this record in the database */
  globalId: Scalars['String'];
  /** the date this record was last updated in the database */
  lastEditedDate: Maybe<Scalars['DateTime']>;
  /** the username or email address of a mobile app user associated with the `lastEditedDate` */
  lastEditedUser: Maybe<Scalars['String']>;
  name: Maybe<Scalars['String']>;
  /** a related `Project` */
  project: Maybe<Project>;
  /** the `globalId` of a related `Project` */
  projectId: Maybe<Scalars['String']>;
  reportToTags: Array<ReportToTag>;
  tagToTagCategories: Array<TagToTagCategory>;
};


export type TagReportToTagsArgs = {
  reportToTagFieldInput?: InputMaybe<ReportToTagFieldInput>;
};


export type TagTagToTagCategoriesArgs = {
  tagToTagCategoryFieldInput?: InputMaybe<TagToTagCategoryFieldInput>;
};

export type TagCategory = {
  __typename: 'TagCategory';
  /** the date this record was inserted into the database */
  createdDate: Maybe<Scalars['DateTime']>;
  /** the username or email address of a mobile app user associated with the `createdDate` */
  createdUser: Maybe<Scalars['String']>;
  deleted: Maybe<Scalars['String']>;
  /** a GUID used to globally identify this record in the database */
  globalId: Scalars['String'];
  /** the date this record was last updated in the database */
  lastEditedDate: Maybe<Scalars['DateTime']>;
  /** the username or email address of a mobile app user associated with the `lastEditedDate` */
  lastEditedUser: Maybe<Scalars['String']>;
  name: Maybe<Scalars['String']>;
  /** a related `Project` */
  project: Maybe<Project>;
  /** the `globalId` of a related `Project` */
  projectId: Maybe<Scalars['String']>;
  reportToTags: Array<ReportToTag>;
  tagToTagCategories: Array<TagToTagCategory>;
};


export type TagCategoryReportToTagsArgs = {
  reportToTagFieldInput?: InputMaybe<ReportToTagFieldInput>;
};


export type TagCategoryTagToTagCategoriesArgs = {
  tagToTagCategoryFieldInput?: InputMaybe<TagToTagCategoryFieldInput>;
};

/**
 * helps filter multiple `TagCategory` records
 *
 * this version of the input will have limited options compared to its other counterpart
 */
export type TagCategoryFieldInput = {
  createdDate?: InputMaybe<DateTimeFilter>;
  /**
   * determines now to handle deleted `TagCategory` records
   *
   * - when `true`, only return deleted records
   * - when `false`, do not return deleted records
   * - when omitted, `deleted` is ignored
   */
  deleted?: InputMaybe<Scalars['Boolean']>;
  lastEditedDate?: InputMaybe<DateTimeFilter>;
  name?: InputMaybe<StringFilter>;
  /**
   * how to order `TagCategory` records
   *
   * executed in the order they are defined
   */
  orderBy?: InputMaybe<Array<OrderByInput>>;
  projectId?: InputMaybe<StringFilter>;
  /**
   * specifies how many records to return
   *
   * analogous to `limit`, `first`, or `top` in SQL dialects
   */
  take?: InputMaybe<Scalars['Int']>;
};

/** helps filter multiple `TagCategory` records */
export type TagCategoryListInput = {
  createdDate?: InputMaybe<DateTimeFilter>;
  /**
   * determines now to handle deleted `TagCategory` records
   *
   * - when `true`, only return deleted records
   * - when `false`, do not return deleted records
   * - when omitted, `deleted` is ignored
   */
  deleted?: InputMaybe<Scalars['Boolean']>;
  lastEditedDate?: InputMaybe<DateTimeFilter>;
  name?: InputMaybe<StringFilter>;
  /**
   * how to order `TagCategory` records
   *
   * executed in the order they are defined
   */
  orderBy?: InputMaybe<Array<OrderByInput>>;
  /**
   * paginate `TagCategory` records
   *
   * using `paginate` may require multiple requests to get all possible results,
   * but will give more fine-grain control in the event all records cannot be
   * returned gracefully
   */
  paginate?: InputMaybe<PaginationInput>;
  projectId?: InputMaybe<StringFilter>;
};

/** response metadata for a list query of TagCategory records */
export type TagCategoryListResponse = {
  __typename: 'TagCategoryListResponse';
  /** the total count of TagCategory records matching any configured filters */
  count: Scalars['Int'];
  /** the total count of paginated groups of TagCategory */
  pages: Scalars['Int'];
  /** TagCategory records */
  records: Array<TagCategory>;
};

/**
 * helps filter multiple `Tag` records
 *
 * this version of the input will have limited options compared to its other counterpart
 */
export type TagFieldInput = {
  createdDate?: InputMaybe<DateTimeFilter>;
  /**
   * determines now to handle deleted `Tag` records
   *
   * - when `true`, only return deleted records
   * - when `false`, do not return deleted records
   * - when omitted, `deleted` is ignored
   */
  deleted?: InputMaybe<Scalars['Boolean']>;
  lastEditedDate?: InputMaybe<DateTimeFilter>;
  name?: InputMaybe<StringFilter>;
  /**
   * how to order `Tag` records
   *
   * executed in the order they are defined
   */
  orderBy?: InputMaybe<Array<OrderByInput>>;
  projectId?: InputMaybe<StringFilter>;
  /**
   * specifies how many records to return
   *
   * analogous to `limit`, `first`, or `top` in SQL dialects
   */
  take?: InputMaybe<Scalars['Int']>;
};

/** helps filter multiple `Tag` records */
export type TagListInput = {
  createdDate?: InputMaybe<DateTimeFilter>;
  /**
   * determines now to handle deleted `Tag` records
   *
   * - when `true`, only return deleted records
   * - when `false`, do not return deleted records
   * - when omitted, `deleted` is ignored
   */
  deleted?: InputMaybe<Scalars['Boolean']>;
  lastEditedDate?: InputMaybe<DateTimeFilter>;
  name?: InputMaybe<StringFilter>;
  /**
   * how to order `Tag` records
   *
   * executed in the order they are defined
   */
  orderBy?: InputMaybe<Array<OrderByInput>>;
  /**
   * paginate `Tag` records
   *
   * using `paginate` may require multiple requests to get all possible results,
   * but will give more fine-grain control in the event all records cannot be
   * returned gracefully
   */
  paginate?: InputMaybe<PaginationInput>;
  projectId?: InputMaybe<StringFilter>;
};

/** response metadata for a list query of Tag records */
export type TagListResponse = {
  __typename: 'TagListResponse';
  /** the total count of Tag records matching any configured filters */
  count: Scalars['Int'];
  /** the total count of paginated groups of Tag */
  pages: Scalars['Int'];
  /** Tag records */
  records: Array<Tag>;
};

export type TagToTagCategory = {
  __typename: 'TagToTagCategory';
  /** the date this record was inserted into the database */
  createdDate: Maybe<Scalars['DateTime']>;
  /** the username or email address of a mobile app user associated with the `createdDate` */
  createdUser: Maybe<Scalars['String']>;
  deleted: Maybe<Scalars['String']>;
  /** a GUID used to globally identify this record in the database */
  globalId: Scalars['String'];
  /** the date this record was last updated in the database */
  lastEditedDate: Maybe<Scalars['DateTime']>;
  /** the username or email address of a mobile app user associated with the `lastEditedDate` */
  lastEditedUser: Maybe<Scalars['String']>;
  /** a related `Project` */
  project: Maybe<Project>;
  /** the `globalId` of a related `Project` */
  projectId: Maybe<Scalars['String']>;
  tag: Maybe<Tag>;
  tagCategory: Maybe<TagCategory>;
  tagCategoryId: Maybe<Scalars['String']>;
  tagId: Maybe<Scalars['String']>;
};

/**
 * helps filter multiple `TagToTagCategory` records
 *
 * this version of the input will have limited options compared to its other counterpart
 */
export type TagToTagCategoryFieldInput = {
  createdDate?: InputMaybe<DateTimeFilter>;
  /**
   * determines now to handle deleted `TagToTagCategory` records
   *
   * - when `true`, only return deleted records
   * - when `false`, do not return deleted records
   * - when omitted, `deleted` is ignored
   */
  deleted?: InputMaybe<Scalars['Boolean']>;
  lastEditedDate?: InputMaybe<DateTimeFilter>;
  /**
   * how to order `TagToTagCategory` records
   *
   * executed in the order they are defined
   */
  orderBy?: InputMaybe<Array<OrderByInput>>;
  projectId?: InputMaybe<StringFilter>;
  tagCategoryId?: InputMaybe<StringFilter>;
  tagId?: InputMaybe<StringFilter>;
  /**
   * specifies how many records to return
   *
   * analogous to `limit`, `first`, or `top` in SQL dialects
   */
  take?: InputMaybe<Scalars['Int']>;
};

/** helps filter multiple `TagToTagCategory` records */
export type TagToTagCategoryListInput = {
  createdDate?: InputMaybe<DateTimeFilter>;
  /**
   * determines now to handle deleted `TagToTagCategory` records
   *
   * - when `true`, only return deleted records
   * - when `false`, do not return deleted records
   * - when omitted, `deleted` is ignored
   */
  deleted?: InputMaybe<Scalars['Boolean']>;
  lastEditedDate?: InputMaybe<DateTimeFilter>;
  /**
   * how to order `TagToTagCategory` records
   *
   * executed in the order they are defined
   */
  orderBy?: InputMaybe<Array<OrderByInput>>;
  /**
   * paginate `TagToTagCategory` records
   *
   * using `paginate` may require multiple requests to get all possible results,
   * but will give more fine-grain control in the event all records cannot be
   * returned gracefully
   */
  paginate?: InputMaybe<PaginationInput>;
  projectId?: InputMaybe<StringFilter>;
  tagCategoryId?: InputMaybe<StringFilter>;
  tagId?: InputMaybe<StringFilter>;
};

/** response metadata for a list query of TagToTagCategory records */
export type TagToTagCategoryListResponse = {
  __typename: 'TagToTagCategoryListResponse';
  /** the total count of TagToTagCategory records matching any configured filters */
  count: Scalars['Int'];
  /** the total count of paginated groups of TagToTagCategory */
  pages: Scalars['Int'];
  /** TagToTagCategory records */
  records: Array<TagToTagCategory>;
};

export type Technician = {
  __typename: 'Technician';
  active: Maybe<Scalars['String']>;
  admin: Maybe<Scalars['String']>;
  appManager: Maybe<Scalars['String']>;
  archiver: Maybe<Scalars['String']>;
  asphaltCoreMeasurements: Array<AsphaltCoreMeasurement>;
  asphaltPlacements: Array<AsphaltPlacement>;
  asphaltSamples: Array<AsphaltSample>;
  certExpAsphaltSampling: Maybe<Scalars['String']>;
  certExpConcreteTest: Maybe<Scalars['String']>;
  certExpEarthworksTest: Maybe<Scalars['String']>;
  certExpInspection: Maybe<Scalars['String']>;
  closedByConcreteCoreMeasurements: Array<ConcreteCoreMeasurement>;
  concreteCoreMeasurements: Array<ConcreteCoreMeasurement>;
  concreteSampleLocations: Array<ConcreteSampleLocation>;
  concreteTempTestedByConcreteTests: Array<ConcreteTest>;
  concreteTestSets: Array<ConcreteTestSet>;
  /** the date this record was inserted into the database */
  createdDate: Maybe<Scalars['DateTime']>;
  /** the username or email address of a mobile app user associated with the `createdDate` */
  createdUser: Maybe<Scalars['String']>;
  cylindersCaseByTechConcreteTests: Array<ConcreteTest>;
  dailyInspectionControlPoints: Array<DailyInspectionControlPoint>;
  dailyInspectionInspections: Array<DailyInspectionInspection>;
  dailyInspectionPunchLists: Array<DailyInspectionPunchList>;
  date: Maybe<Scalars['DateTime']>;
  deleted: Maybe<Scalars['String']>;
  densityTests: Array<DensityTest>;
  engineeringJudgementLevel: Maybe<Scalars['Int']>;
  /** a GUID used to globally identify this record in the database */
  globalId: Scalars['String'];
  /** the date this record was last updated in the database */
  lastEditedDate: Maybe<Scalars['DateTime']>;
  /** the username or email address of a mobile app user associated with the `lastEditedDate` */
  lastEditedUser: Maybe<Scalars['String']>;
  payItemGroups: Array<PayItemGroup>;
  percentAirTestedByConcreteTests: Array<ConcreteTest>;
  /** a related `Project` */
  project: Maybe<Project>;
  /** the `globalId` of a related `Project` */
  projectId: Maybe<Scalars['String']>;
  qaSigner: Maybe<Scalars['String']>;
  readOnly: Maybe<Scalars['String']>;
  reviewedByAsphaltLots: Array<AsphaltLot>;
  reviewedByConcreteTestSets: Array<ConcreteTestSet>;
  reviewedByDailyInspectionControlPoints: Array<DailyInspectionControlPoint>;
  reviewedByDailyInspectionInspections: Array<DailyInspectionInspection>;
  reviewedByDailyInspectionPunchLists: Array<DailyInspectionPunchList>;
  reviewedByLots: Array<Lot>;
  reviewer: Maybe<Scalars['String']>;
  slumpTestedByConcreteTests: Array<ConcreteTest>;
  /** `technicianId` is unreliable, a misnomer, every record contains `null` values, or its purpose is generally unknown */
  technicianId: Maybe<Scalars['String']>;
  technicianInitials: Maybe<Scalars['String']>;
  technicianName: Maybe<Scalars['String']>;
  /**
   * this field name is result of a naming convention collision
   * which would produce an invalid schema
   *
   * if any of the below is a column, the associated value is the _database_ column name
   *
   * - this column : `Technician`
   * - colliding query : `technician`
   */
  technicianString: Maybe<Scalars['String']>;
  technicianUsername: Maybe<Scalars['String']>;
  unitWeightTechConcreteTests: Array<ConcreteTest>;
};


export type TechnicianAsphaltCoreMeasurementsArgs = {
  asphaltCoreMeasurementFieldInput?: InputMaybe<AsphaltCoreMeasurementFieldInput>;
};


export type TechnicianAsphaltPlacementsArgs = {
  asphaltPlacementFieldInput?: InputMaybe<AsphaltPlacementFieldInput>;
};


export type TechnicianAsphaltSamplesArgs = {
  asphaltSampleFieldInput?: InputMaybe<AsphaltSampleFieldInput>;
};


export type TechnicianClosedByConcreteCoreMeasurementsArgs = {
  concreteCoreMeasurementFieldInput?: InputMaybe<ConcreteCoreMeasurementFieldInput>;
};


export type TechnicianConcreteCoreMeasurementsArgs = {
  concreteCoreMeasurementFieldInput?: InputMaybe<ConcreteCoreMeasurementFieldInput>;
};


export type TechnicianConcreteSampleLocationsArgs = {
  concreteSampleLocationFieldInput?: InputMaybe<ConcreteSampleLocationFieldInput>;
};


export type TechnicianConcreteTempTestedByConcreteTestsArgs = {
  concreteTestFieldInput?: InputMaybe<ConcreteTestFieldInput>;
};


export type TechnicianConcreteTestSetsArgs = {
  concreteTestSetFieldInput?: InputMaybe<ConcreteTestSetFieldInput>;
};


export type TechnicianCylindersCaseByTechConcreteTestsArgs = {
  concreteTestFieldInput?: InputMaybe<ConcreteTestFieldInput>;
};


export type TechnicianDailyInspectionControlPointsArgs = {
  dailyInspectionControlPointFieldInput?: InputMaybe<DailyInspectionControlPointFieldInput>;
};


export type TechnicianDailyInspectionInspectionsArgs = {
  dailyInspectionInspectionFieldInput?: InputMaybe<DailyInspectionInspectionFieldInput>;
};


export type TechnicianDailyInspectionPunchListsArgs = {
  dailyInspectionPunchListFieldInput?: InputMaybe<DailyInspectionPunchListFieldInput>;
};


export type TechnicianDensityTestsArgs = {
  densityTestFieldInput?: InputMaybe<DensityTestFieldInput>;
};


export type TechnicianPayItemGroupsArgs = {
  payItemGroupFieldInput?: InputMaybe<PayItemGroupFieldInput>;
};


export type TechnicianPercentAirTestedByConcreteTestsArgs = {
  concreteTestFieldInput?: InputMaybe<ConcreteTestFieldInput>;
};


export type TechnicianReviewedByAsphaltLotsArgs = {
  asphaltLotFieldInput?: InputMaybe<AsphaltLotFieldInput>;
};


export type TechnicianReviewedByConcreteTestSetsArgs = {
  concreteTestSetFieldInput?: InputMaybe<ConcreteTestSetFieldInput>;
};


export type TechnicianReviewedByDailyInspectionControlPointsArgs = {
  dailyInspectionControlPointFieldInput?: InputMaybe<DailyInspectionControlPointFieldInput>;
};


export type TechnicianReviewedByDailyInspectionInspectionsArgs = {
  dailyInspectionInspectionFieldInput?: InputMaybe<DailyInspectionInspectionFieldInput>;
};


export type TechnicianReviewedByDailyInspectionPunchListsArgs = {
  dailyInspectionPunchListFieldInput?: InputMaybe<DailyInspectionPunchListFieldInput>;
};


export type TechnicianReviewedByLotsArgs = {
  lotFieldInput?: InputMaybe<LotFieldInput>;
};


export type TechnicianSlumpTestedByConcreteTestsArgs = {
  concreteTestFieldInput?: InputMaybe<ConcreteTestFieldInput>;
};


export type TechnicianUnitWeightTechConcreteTestsArgs = {
  concreteTestFieldInput?: InputMaybe<ConcreteTestFieldInput>;
};

/**
 * helps filter multiple `Technician` records
 *
 * this version of the input will have limited options compared to its other counterpart
 */
export type TechnicianFieldInput = {
  createdDate?: InputMaybe<DateTimeFilter>;
  /**
   * determines now to handle deleted `Technician` records
   *
   * - when `true`, only return deleted records
   * - when `false`, do not return deleted records
   * - when omitted, `deleted` is ignored
   */
  deleted?: InputMaybe<Scalars['Boolean']>;
  lastEditedDate?: InputMaybe<DateTimeFilter>;
  /**
   * how to order `Technician` records
   *
   * executed in the order they are defined
   */
  orderBy?: InputMaybe<Array<OrderByInput>>;
  projectId?: InputMaybe<StringFilter>;
  /**
   * specifies how many records to return
   *
   * analogous to `limit`, `first`, or `top` in SQL dialects
   */
  take?: InputMaybe<Scalars['Int']>;
  technicianName?: InputMaybe<StringFilter>;
};

/** helps filter multiple `Technician` records */
export type TechnicianListInput = {
  createdDate?: InputMaybe<DateTimeFilter>;
  /**
   * determines now to handle deleted `Technician` records
   *
   * - when `true`, only return deleted records
   * - when `false`, do not return deleted records
   * - when omitted, `deleted` is ignored
   */
  deleted?: InputMaybe<Scalars['Boolean']>;
  lastEditedDate?: InputMaybe<DateTimeFilter>;
  /**
   * how to order `Technician` records
   *
   * executed in the order they are defined
   */
  orderBy?: InputMaybe<Array<OrderByInput>>;
  /**
   * paginate `Technician` records
   *
   * using `paginate` may require multiple requests to get all possible results,
   * but will give more fine-grain control in the event all records cannot be
   * returned gracefully
   */
  paginate?: InputMaybe<PaginationInput>;
  projectId?: InputMaybe<StringFilter>;
  technicianName?: InputMaybe<StringFilter>;
};

/** response metadata for a list query of Technician records */
export type TechnicianListResponse = {
  __typename: 'TechnicianListResponse';
  /** the total count of Technician records matching any configured filters */
  count: Scalars['Int'];
  /** the total count of paginated groups of Technician */
  pages: Scalars['Int'];
  /** Technician records */
  records: Array<Technician>;
};

export type TechnicianPermission = {
  __typename: 'TechnicianPermission';
  admin: Maybe<Scalars['String']>;
  /** the date this record was inserted into the database */
  createdDate: Maybe<Scalars['DateTime']>;
  /** the username or email address of a mobile app user associated with the `createdDate` */
  createdUser: Maybe<Scalars['String']>;
  databaseEditor: Maybe<Scalars['String']>;
  deleted: Maybe<Scalars['String']>;
  email: Maybe<Scalars['String']>;
  /** a GUID used to globally identify this record in the database */
  globalId: Scalars['String'];
  iosDate: Maybe<Scalars['DateTime']>;
  iosDevice: Maybe<Scalars['String']>;
  iosSyncDate: Maybe<Scalars['DateTime']>;
  iosVersion: Maybe<Scalars['String']>;
  /** the date this record was last updated in the database */
  lastEditedDate: Maybe<Scalars['DateTime']>;
  /** the username or email address of a mobile app user associated with the `lastEditedDate` */
  lastEditedUser: Maybe<Scalars['String']>;
  permissions: Maybe<Scalars['String']>;
  readOnly: Maybe<Scalars['String']>;
  uwpDate: Maybe<Scalars['DateTime']>;
  uwpDevice: Maybe<Scalars['String']>;
  uwpSyncDate: Maybe<Scalars['DateTime']>;
  uwpVersion: Maybe<Scalars['String']>;
};

/**
 * helps filter multiple `TechnicianPermission` records
 *
 * this version of the input will have limited options compared to its other counterpart
 */
export type TechnicianPermissionFieldInput = {
  /**
   * - when `true`, `admin` is truthy
   * - when `false`, `admin` is falsy
   * - when omitted, `admin` is ignored
   */
  admin?: InputMaybe<Scalars['Boolean']>;
  createdDate?: InputMaybe<DateTimeFilter>;
  /**
   * - when `true`, `databaseEditor` is truthy
   * - when `false`, `databaseEditor` is falsy
   * - when omitted, `databaseEditor` is ignored
   */
  databaseEditor?: InputMaybe<Scalars['Boolean']>;
  /**
   * determines now to handle deleted `TechnicianPermission` records
   *
   * - when `true`, only return deleted records
   * - when `false`, do not return deleted records
   * - when omitted, `deleted` is ignored
   */
  deleted?: InputMaybe<Scalars['Boolean']>;
  email?: InputMaybe<StringFilter>;
  iosDate?: InputMaybe<DateTimeFilter>;
  iosDevice?: InputMaybe<StringFilter>;
  iosSyncDate?: InputMaybe<DateTimeFilter>;
  iosVersion?: InputMaybe<StringFilter>;
  lastEditedDate?: InputMaybe<DateTimeFilter>;
  /**
   * how to order `TechnicianPermission` records
   *
   * executed in the order they are defined
   */
  orderBy?: InputMaybe<Array<OrderByInput>>;
  /**
   * - when `true`, `readOnly` is truthy
   * - when `false`, `readOnly` is falsy
   * - when omitted, `readOnly` is ignored
   */
  readOnly?: InputMaybe<Scalars['Boolean']>;
  /**
   * specifies how many records to return
   *
   * analogous to `limit`, `first`, or `top` in SQL dialects
   */
  take?: InputMaybe<Scalars['Int']>;
  uwpDate?: InputMaybe<DateTimeFilter>;
  uwpDevice?: InputMaybe<StringFilter>;
  uwpSyncDate?: InputMaybe<DateTimeFilter>;
  uwpVersion?: InputMaybe<StringFilter>;
};

/** helps filter multiple `TechnicianPermission` records */
export type TechnicianPermissionListInput = {
  /**
   * - when `true`, `admin` is truthy
   * - when `false`, `admin` is falsy
   * - when omitted, `admin` is ignored
   */
  admin?: InputMaybe<Scalars['Boolean']>;
  createdDate?: InputMaybe<DateTimeFilter>;
  /**
   * - when `true`, `databaseEditor` is truthy
   * - when `false`, `databaseEditor` is falsy
   * - when omitted, `databaseEditor` is ignored
   */
  databaseEditor?: InputMaybe<Scalars['Boolean']>;
  /**
   * determines now to handle deleted `TechnicianPermission` records
   *
   * - when `true`, only return deleted records
   * - when `false`, do not return deleted records
   * - when omitted, `deleted` is ignored
   */
  deleted?: InputMaybe<Scalars['Boolean']>;
  email?: InputMaybe<StringFilter>;
  iosDate?: InputMaybe<DateTimeFilter>;
  iosDevice?: InputMaybe<StringFilter>;
  iosSyncDate?: InputMaybe<DateTimeFilter>;
  iosVersion?: InputMaybe<StringFilter>;
  lastEditedDate?: InputMaybe<DateTimeFilter>;
  /**
   * how to order `TechnicianPermission` records
   *
   * executed in the order they are defined
   */
  orderBy?: InputMaybe<Array<OrderByInput>>;
  /**
   * paginate `TechnicianPermission` records
   *
   * using `paginate` may require multiple requests to get all possible results,
   * but will give more fine-grain control in the event all records cannot be
   * returned gracefully
   */
  paginate?: InputMaybe<PaginationInput>;
  /**
   * - when `true`, `readOnly` is truthy
   * - when `false`, `readOnly` is falsy
   * - when omitted, `readOnly` is ignored
   */
  readOnly?: InputMaybe<Scalars['Boolean']>;
  uwpDate?: InputMaybe<DateTimeFilter>;
  uwpDevice?: InputMaybe<StringFilter>;
  uwpSyncDate?: InputMaybe<DateTimeFilter>;
  uwpVersion?: InputMaybe<StringFilter>;
};

/** response metadata for a list query of TechnicianPermission records */
export type TechnicianPermissionListResponse = {
  __typename: 'TechnicianPermissionListResponse';
  /** the total count of TechnicianPermission records matching any configured filters */
  count: Scalars['Int'];
  /** the total count of paginated groups of TechnicianPermission */
  pages: Scalars['Int'];
  /** TechnicianPermission records */
  records: Array<TechnicianPermission>;
};

export type TestingLab = {
  __typename: 'TestingLab';
  concreteCoreBreakDatas: Array<ConcreteCoreBreakData>;
  concreteTestBreakDatas: Array<ConcreteTestBreakData>;
  /** the date this record was inserted into the database */
  createdDate: Scalars['DateTime'];
  /**
   * the email address of a user associated with the `createdDate`
   *
   * this value will be `unknown` if the `createdDate` was not set by a user
   */
  createdUser: Scalars['String'];
  /** a unique integer to identify this record in the database table */
  id: Scalars['Int'];
  labTechs: Array<LabTech>;
  /** the date this record was last updated in the database */
  lastEditedDate: Scalars['DateTime'];
  /**
   * the email address of a user associated with the `lastEditedDate`
   *
   * this value will be `system` if the `lastEditedDate` was not set by a user
   */
  lastEditedUser: Scalars['String'];
  name: Scalars['String'];
  /** a related `Project` */
  project: Project;
  /** the `globalId` of a related `Project` */
  projectId: Scalars['String'];
};


export type TestingLabConcreteCoreBreakDatasArgs = {
  concreteCoreBreakDataFieldInput?: InputMaybe<ConcreteCoreBreakDataFieldInput>;
};


export type TestingLabConcreteTestBreakDatasArgs = {
  concreteTestBreakDataFieldInput?: InputMaybe<ConcreteTestBreakDataFieldInput>;
};


export type TestingLabLabTechsArgs = {
  labTechFieldInput?: InputMaybe<LabTechFieldInput>;
};

/**
 * helps filter multiple `TestingLab` records
 *
 * this version of the input will have limited options compared to its other counterpart
 */
export type TestingLabFieldInput = {
  createdDate?: InputMaybe<DateTimeFilter>;
  lastEditedDate?: InputMaybe<DateTimeFilter>;
  name?: InputMaybe<StringFilter>;
  /**
   * how to order `TestingLab` records
   *
   * executed in the order they are defined
   */
  orderBy?: InputMaybe<Array<OrderByInput>>;
  projectId?: InputMaybe<StringFilter>;
  /**
   * specifies how many records to return
   *
   * analogous to `limit`, `first`, or `top` in SQL dialects
   */
  take?: InputMaybe<Scalars['Int']>;
};

/** helps filter multiple `TestingLab` records */
export type TestingLabListInput = {
  createdDate?: InputMaybe<DateTimeFilter>;
  lastEditedDate?: InputMaybe<DateTimeFilter>;
  name?: InputMaybe<StringFilter>;
  /**
   * how to order `TestingLab` records
   *
   * executed in the order they are defined
   */
  orderBy?: InputMaybe<Array<OrderByInput>>;
  /**
   * paginate `TestingLab` records
   *
   * using `paginate` may require multiple requests to get all possible results,
   * but will give more fine-grain control in the event all records cannot be
   * returned gracefully
   */
  paginate?: InputMaybe<PaginationInput>;
  projectId?: InputMaybe<StringFilter>;
};

/** response metadata for a list query of TestingLab records */
export type TestingLabListResponse = {
  __typename: 'TestingLabListResponse';
  /** the total count of TestingLab records matching any configured filters */
  count: Scalars['Int'];
  /** the total count of paginated groups of TestingLab */
  pages: Scalars['Int'];
  /** TestingLab records */
  records: Array<TestingLab>;
};

/** A simple text field */
export type TextCustomFieldValue = {
  __typename: 'TextCustomFieldValue';
  /** the date this record was inserted into the database */
  createdDate: Scalars['DateTime'];
  /**
   * the email address of a user associated with the `createdDate`
   *
   * this value will be `unknown` if the `createdDate` was not set by a user
   */
  createdUser: Scalars['String'];
  customField: CustomField;
  /** the `id` of a related `CustomField` */
  customFieldId: Scalars['String'];
  /** the date this record was soft-deleted in the database */
  deletedDate: Maybe<Scalars['DateTime']>;
  /**
   * the email address of a user associated with the `deletedDate`
   *
   * this value will be `system` if the `deletedDate` was not set by a user
   */
  deletedUser: Maybe<Scalars['String']>;
  /** the date this record was last updated in the database */
  lastEditedDate: Scalars['DateTime'];
  /**
   * the email address of a user associated with the `lastEditedDate`
   *
   * this value will be `system` if the `lastEditedDate` was not set by a user
   */
  lastEditedUser: Scalars['String'];
  /** a String value */
  value: Maybe<Scalars['String']>;
};

export type UpdateConcretePlacement = {
  notes?: InputMaybe<Scalars['String']>;
  sqFt?: InputMaybe<Scalars['Float']>;
  steelVerify?: InputMaybe<Scalars['String']>;
};

export type UpsertAsphaltLotMixDesignInput = {
  /**
   * must supply `globalId`, or `mixDesignNumber`, to associate an `AsphaltMixDesign` with the `LIMSAsphaltLot`
   *
   * one of these fields must be supplied to create a new `LIMSAsphaltLot`
   */
  globalId?: InputMaybe<Scalars['String']>;
  id: Scalars['String'];
  /**
   * must supply `mixDesignNumber`, or `id`, to associate an `AsphaltMixDesign` with the `LIMSAsphaltLot`
   *
   * one of these fields must be supplied to create a new `LIMSAsphaltLot`
   */
  mixDesignNumber?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
};

export type UpsertConcreteCoreBreakDataInput = {
  age: Scalars['Int'];
  breakDate: Scalars['DateTime'];
  concreteCoreMeasurementId: Scalars['String'];
  diameter?: InputMaybe<Scalars['String']>;
  labNumber?: InputMaybe<Scalars['String']>;
  labTechId?: InputMaybe<Scalars['Int']>;
  peakLoad?: InputMaybe<Scalars['Float']>;
  strength?: InputMaybe<Scalars['Float']>;
  testingLabId?: InputMaybe<Scalars['Int']>;
  type?: InputMaybe<Scalars['String']>;
};

/** values required to upsert `ConcreteTestAmbientAirIFISettings` objects */
export type UpsertConcreteTestAmbientAirIfiSettingsInput = {
  enabled?: InputMaybe<Scalars['Boolean']>;
  message?: InputMaybe<Scalars['String']>;
  minimumAmbientAirTemperature?: InputMaybe<Scalars['Float']>;
};

export type UpsertConcreteTestBreakDataInput = {
  age: Scalars['Int'];
  breakDate: Scalars['DateTime'];
  /** required to create */
  concreteTestId?: InputMaybe<Scalars['String']>;
  diameter?: InputMaybe<Scalars['String']>;
  /** required to edit */
  id?: InputMaybe<Scalars['Int']>;
  labNumber?: InputMaybe<Scalars['String']>;
  labTechId?: InputMaybe<Scalars['Int']>;
  peakLoad?: InputMaybe<Scalars['Float']>;
  strength?: InputMaybe<Scalars['Float']>;
  testingLabId?: InputMaybe<Scalars['Int']>;
  type?: InputMaybe<Scalars['String']>;
};

/** values required to upsert `ConcreteTestIFISettings` objects */
export type UpsertConcreteTestIfiSettingsInput = {
  ambientAir?: InputMaybe<UpsertConcreteTestAmbientAirIfiSettingsInput>;
  effectiveDate?: InputMaybe<Scalars['DateTime']>;
  percentAir?: InputMaybe<UpsertConcreteTestPercentAirIfiSettingsInput>;
  projectId: Scalars['String'];
  slump?: InputMaybe<UpsertConcreteTestSlumpIfiSettingsInput>;
  temperature?: InputMaybe<UpsertConcreteTestTemperatureIfiSettingsInput>;
};

export type UpsertConcreteTestIfiSettingsResponse = {
  __typename: 'UpsertConcreteTestIFISettingsResponse';
  /** the upserted `ConcreteTestIFISettings` */
  concreteTestIFISettings: ConcreteTestIfiSettings;
};

/** values required to upsert `ConcreteTestPercentAirIFISettings` objects */
export type UpsertConcreteTestPercentAirIfiSettingsInput = {
  enabled?: InputMaybe<Scalars['Boolean']>;
  highMessage?: InputMaybe<Scalars['String']>;
  lowMessage?: InputMaybe<Scalars['String']>;
};

/** values required to upsert `ConcreteTestSlumpIFISettings` objects */
export type UpsertConcreteTestSlumpIfiSettingsInput = {
  enabled?: InputMaybe<Scalars['Boolean']>;
  highMessage?: InputMaybe<Scalars['String']>;
  lowMessage?: InputMaybe<Scalars['String']>;
};

/** values required to upsert `ConcreteTestTemperatureIFISettings` objects */
export type UpsertConcreteTestTemperatureIfiSettingsInput = {
  enabled?: InputMaybe<Scalars['Boolean']>;
  highMessage?: InputMaybe<Scalars['String']>;
  lowMessage?: InputMaybe<Scalars['String']>;
  temperatureHigh?: InputMaybe<Scalars['Float']>;
  temperatureLow?: InputMaybe<Scalars['Float']>;
};

/** values required to upsert `ControlPointMissingGeometryIFISettings` objects */
export type UpsertControlPointMissingGeometryIfiSettingsInput = {
  enabled?: InputMaybe<Scalars['Boolean']>;
  message?: InputMaybe<Scalars['String']>;
};

/** values required to upsert `DailyInspectionControlPointIFISettings` objects */
export type UpsertDailyInspectionControlPointIfiSettingsInput = {
  effectiveDate?: InputMaybe<Scalars['DateTime']>;
  enabled?: InputMaybe<Scalars['Boolean']>;
  missingGeometry?: InputMaybe<UpsertControlPointMissingGeometryIfiSettingsInput>;
  projectId: Scalars['String'];
};

export type UpsertDailyInspectionControlPointIfiSettingsResponse = {
  __typename: 'UpsertDailyInspectionControlPointIFISettingsResponse';
  /** the upserted `DailyInspectionControlPointIFISettings` */
  controlPointIFISettings: DailyInspectionControlPointIfiSettings;
};

/** values required to upsert `DailyInspectionInspectionIFISettings` objects */
export type UpsertDailyInspectionInspectionIfiSettingsInput = {
  effectiveDate?: InputMaybe<Scalars['DateTime']>;
  enabled?: InputMaybe<Scalars['Boolean']>;
  missingGeometry?: InputMaybe<UpsertInspectionMissingGeometryIfiSettingsInput>;
  projectId: Scalars['String'];
};

export type UpsertDailyInspectionInspectionIfiSettingsResponse = {
  __typename: 'UpsertDailyInspectionInspectionIFISettingsResponse';
  /** the upserted `DailyInspectionInspectionIFISettings` */
  inspectionIFISettings: DailyInspectionInspectionIfiSettings;
};

/** values required to upsert `DailyInspectionPunchListIFISettings` objects */
export type UpsertDailyInspectionPunchListIfiSettingsInput = {
  effectiveDate?: InputMaybe<Scalars['DateTime']>;
  enabled?: InputMaybe<Scalars['Boolean']>;
  projectId: Scalars['String'];
};

export type UpsertDailyInspectionPunchListIfiSettingsResponse = {
  __typename: 'UpsertDailyInspectionPunchListIFISettingsResponse';
  /** the upserted `DailyInspectionPunchListIFISettings` */
  punchListIFISettings: DailyInspectionPunchListIfiSettings;
};

/** values required to upsert `DensityTestIFISettings` objects */
export type UpsertDensityTestIfiSettingsInput = {
  effectiveDate?: InputMaybe<Scalars['DateTime']>;
  enabled?: InputMaybe<Scalars['Boolean']>;
  message?: InputMaybe<Scalars['String']>;
  projectId: Scalars['String'];
};

export type UpsertDensityTestIfiSettingsResponse = {
  __typename: 'UpsertDensityTestIFISettingsResponse';
  /** the upserted `DensityTestIFISettings` */
  densityTestIFISettings: DensityTestIfiSettings;
};

/** values required to upsert `InspectionMissingGeometryIFISettings` objects */
export type UpsertInspectionMissingGeometryIfiSettingsInput = {
  enabled?: InputMaybe<Scalars['Boolean']>;
  message?: InputMaybe<Scalars['String']>;
};

/** values required to upsert `LIMSAsphaltJointCore` objects */
export type UpsertLimsAsphaltJointCoreInput = {
  density?: InputMaybe<Scalars['Float']>;
  /**
   * if supplied, only used to edit an existing record
   *
   * will not be used as the `id` of a newly created record
   */
  id?: InputMaybe<Scalars['String']>;
  /**
   * if supplied, used to find an existing record associated with the `LIMSAsphaltLot`
   *
   * if an existing `LIMSAsphaltJointCore` cannot be found by `label`, a new record will be created and associated
   */
  label?: InputMaybe<Scalars['String']>;
  station?: InputMaybe<Scalars['String']>;
};

/** values required to upsert `LIMSAsphaltLot` objects */
export type UpsertLimsAsphaltLotInput = {
  designSize?: InputMaybe<Scalars['String']>;
  /**
   * if supplied, only used to edit an existing record
   *
   * will not be used as the `id` of a newly created record
   */
  id?: InputMaybe<Scalars['String']>;
  jointCompactPayIncen?: InputMaybe<Scalars['Float']>;
  jointCoreTargetDensity?: InputMaybe<Scalars['Float']>;
  /**
   * if supplied, upserts `LIMSAsphaltJointCore` records associated with the `LIMSAsphaltLot`
   *
   * - existing records omitted from this list will be removed
   * - inputs which can be mapped to existing records will be edited and restored if applicable
   * - inputs which cannot be mapped to existing records will be created and associated
   */
  jointCores?: InputMaybe<Array<UpsertLimsAsphaltJointCoreInput>>;
  /**
   * if supplied, used in conjunction with `projectId` to find an existing record to edit.
   *
   * both `label` and `projectId` must be defined to upsert when `id` is omitted
   *
   * if an existing `LIMSAsphaltLot` cannot be found by `label` and `projectId`, a new record will be created
   */
  label?: InputMaybe<Scalars['String']>;
  lastEditedUser?: InputMaybe<Scalars['String']>;
  matCompactPayIncenPayAdjust?: InputMaybe<Scalars['Float']>;
  matCoreDesignThickness?: InputMaybe<Scalars['Float']>;
  matCorePtValue?: InputMaybe<Scalars['Float']>;
  matCoreTargetDensity?: InputMaybe<Scalars['Float']>;
  /**
   * if supplied, upserts `LIMSAsphaltMatCore` records associated with the `LIMSAsphaltLot`
   *
   * - existing records omitted from this list will be removed
   * - inputs which can be mapped to existing records will be edited and restored if applicable
   * - inputs which cannot be mapped to existing records will be created and associated
   */
  matCores?: InputMaybe<Array<UpsertLimsAsphaltMatCoreInput>>;
  /** must be supplied to create a new record */
  mixDesign?: InputMaybe<UpsertAsphaltLotMixDesignInput>;
  /** limited to 4000 characters */
  notes?: InputMaybe<Scalars['String']>;
  /**
   * if supplied, upserts `LIMSAsphaltLotToPayItemNoGeometry` records associated with the `LIMSAsphaltLot`
   *
   * - existing records omitted from this list will be removed
   * - inputs which cannot be mapped to existing records will be created and associated
   */
  payItems?: InputMaybe<Array<UpsertLimsAsphaltLotToPayItemNoGeometryInput>>;
  /**
   * if supplied, used in conjunction with `label` to find an existing record to edit.
   *
   * both `projectId` and `label` must be defined to upsert when `id` is omitted
   *
   * if an existing `LIMSAsphaltLot` cannot be found by `projectId` and `label`, a new record will be created
   */
  projectId?: InputMaybe<Scalars['String']>;
  quantityReportedTons?: InputMaybe<Scalars['Float']>;
  /** limited to 4000 characters */
  remarks?: InputMaybe<Scalars['String']>;
  /**
   * if supplied, upserts `LIMSAsphaltSample` records associated with the `LIMSAsphaltLot`
   *
   * - existing records omitted from this list will be removed
   * - inputs which can be mapped to existing records will be edited and restored if applicable
   * - inputs which cannot be mapped to existing records will be created and associated
   */
  samples?: InputMaybe<Array<UpsertLimsAsphaltSampleInput>>;
  /** must be supplied to create a new record */
  submittedByName?: InputMaybe<Scalars['String']>;
  submittedDate?: InputMaybe<Scalars['DateTime']>;
  unitPrice?: InputMaybe<Scalars['Float']>;
};

export type UpsertLimsAsphaltLotResponse = {
  __typename: 'UpsertLIMSAsphaltLotResponse';
  /** the upserted `LIMSAsphaltLot` */
  lot: LimsAsphaltLot;
};

/** values required to upsert `LIMSAsphaltLotToPayItemNoGeometry` objects */
export type UpsertLimsAsphaltLotToPayItemNoGeometryInput = {
  /**
   * the `description` of a related `PayItemNoGeometry`
   *
   * CIMS online cannot create new `PayItemNoGeometry` records
   *
   * if a `PayItemNoGeometry` cannot be found by `description`, an error will be thrown
   */
  description?: InputMaybe<Scalars['String']>;
  /** the `globalId` of a related `PayItemNoGeometry` */
  globalId?: InputMaybe<Scalars['String']>;
  /**
   * the `payItemId` of a related `PayItemNoGeometry`
   *
   * CIMS online cannot create new `PayItemNoGeometry` records
   *
   * if a `PayItemNoGeometry` cannot be found by `payItemId`, an error will be thrown
   */
  payItemId?: InputMaybe<Scalars['String']>;
};

/** values required to upsert `LIMSAsphaltMatCore` objects */
export type UpsertLimsAsphaltMatCoreInput = {
  density?: InputMaybe<Scalars['Float']>;
  /**
   * if supplied, only used to edit an existing record
   *
   * will not be used as the `id` of a newly created record
   */
  id?: InputMaybe<Scalars['String']>;
  include?: InputMaybe<Scalars['Boolean']>;
  /**
   * if supplied, used to find an existing record associated with the `LIMSAsphaltLot`
   *
   * if an existing `LIMSAsphaltMatCore` cannot be found by `label`, a new record will be created and associated
   */
  label?: InputMaybe<Scalars['String']>;
  station?: InputMaybe<Scalars['String']>;
  thickness?: InputMaybe<Scalars['Float']>;
};

/** values required to upsert `LIMSAsphaltSample` objects */
export type UpsertLimsAsphaltSampleInput = {
  acPercentage?: InputMaybe<Scalars['Float']>;
  avgMixVoids?: InputMaybe<Scalars['Float']>;
  bulkSpecGravMix?: InputMaybe<Scalars['Float']>;
  /**
   * if supplied, only used to edit an existing record
   *
   * will not be used as the `id` of a newly created record
   */
  id?: InputMaybe<Scalars['String']>;
  /**
   * if supplied, used to find an existing record associated with the `LIMSAsphaltLot`
   *
   * if an existing `LIMSAsphaltSample` cannot be found by `label`, a new record will be created and associated
   */
  label?: InputMaybe<Scalars['String']>;
  laydownTemp?: InputMaybe<Scalars['Float']>;
  location?: InputMaybe<Scalars['String']>;
  /**
   * if supplied, upserts `LIMSAsphaltSampleResult` records associated with the `LIMSAsphaltSample`
   *
   * - existing records omitted from this list will be removed
   * - inputs which can be mapped to existing records will be edited and restored if applicable
   * - inputs which cannot be mapped to existing records will be created and associated
   */
  results?: InputMaybe<Array<UpsertLimsAsphaltSampleResultInput>>;
  riceMaxDensity?: InputMaybe<Scalars['Float']>;
  riceVolumeVoidless?: InputMaybe<Scalars['Float']>;
  vma?: InputMaybe<Scalars['Float']>;
};

/** values required to upsert `LIMSAsphaltSampleResult` objects */
export type UpsertLimsAsphaltSampleResultInput = {
  target: UpsertLimsAsphaltSampleResultTargetInput;
  /** assumed to be a number between 0 and 100 */
  value?: InputMaybe<Scalars['Float']>;
};

export type UpsertLimsAsphaltSampleResultTargetInput = {
  /**
   * if supplied, used to find an existing `LIMSAsphaltSampleResult` associated with the `LIMSAsphaltSample`
   *
   * if the supplied `id` does not map to an existing `LIMSAsphaltMixDesignTarget` of the `AsphaltMixDesign` of the `LIMSAsphaltLot` an error will be thrown, CIMS online will not create new `LIMSAsphaltMixDesignTarget` records in this mutation
   *
   * if an existing `LIMSAsphaltSampleResult` cannot be found by `id`, a new record will be created and associated
   */
  id?: InputMaybe<Scalars['String']>;
  /**
   * if supplied, used to find an existing `LIMSAsphaltSampleResult` associated with the `LIMSAsphaltSample`
   *
   * if the supplied `name` does not map to an existing `LIMSAsphaltMixDesignTarget` of the `AsphaltMixDesign` of the `LIMSAsphaltLot` an error will be thrown, CIMS online will not create new `LIMSAsphaltMixDesignTarget` records in this mutation
   *
   * if an existing `LIMSAsphaltSampleResult` cannot be found by `name`, a new record will be created and associated
   */
  name?: InputMaybe<Scalars['String']>;
};

/** values required to upsert `LotCompactionIFISettings` objects */
export type UpsertLotCompactionIfiSettingsInput = {
  enabled?: InputMaybe<Scalars['Boolean']>;
  levelId?: InputMaybe<Scalars['String']>;
  message?: InputMaybe<Scalars['String']>;
};

/** values required to upsert `LotIFISettings` objects */
export type UpsertLotIfiSettingsInput = {
  compaction?: InputMaybe<UpsertLotCompactionIfiSettingsInput>;
  effectiveDate?: InputMaybe<Scalars['DateTime']>;
  proctor?: InputMaybe<UpsertLotProctorIfiSettingsInput>;
  projectId: Scalars['String'];
  testCount?: InputMaybe<UpsertLotTestCountIfiSettingsInput>;
};

export type UpsertLotIfiSettingsResponse = {
  __typename: 'UpsertLotIFISettingsResponse';
  /** the upserted `LotIFISettings` */
  lotIFISettings: LotIfiSettings;
};

/** values required to upsert `LotProctorIFISettings` objects */
export type UpsertLotProctorIfiSettingsInput = {
  enabled?: InputMaybe<Scalars['Boolean']>;
  message?: InputMaybe<Scalars['String']>;
};

/** values required to upsert `LotTestCountIFISettings` objects */
export type UpsertLotTestCountIfiSettingsInput = {
  enabled?: InputMaybe<Scalars['Boolean']>;
  message?: InputMaybe<Scalars['String']>;
};

export type UpsertProjectToIfiReportTypeInput = {
  enabled: Scalars['Boolean'];
  projectId: Scalars['String'];
  reportTypeId: Scalars['String'];
};

export type UpsertProjectToIfiReportTypeResponse = {
  __typename: 'UpsertProjectToIFIReportTypeResponse';
  /** the upserted `ProjectToIFIReportType` */
  projectToIFIReportType: ProjectToIfiReportType;
};

/** values required to upsert `UserToDeveloperPermission` objects */
export type UpsertUserToDeveloperPermissionInput = {
  permissionId: Scalars['String'];
  userIds: Array<Scalars['String']>;
};

export type UpsertUserToDeveloperPermissionResponse = {
  __typename: 'UpsertUserToDeveloperPermissionResponse';
  userToDeveloperPermissions: Array<UserToDeveloperPermission>;
};

/**
 * ### Azure Active Directory copies
 *
 * this object type is a partial copy of an Azure Active Directory `User`
 *
 * it is stored and synced with the Microsoft Graph API
 *
 * additionally, records are synced roughly every 15 minutes with their
 * corresponding `User` in Active Directory
 */
export type User = {
  __typename: 'User';
  admin: Maybe<ProjectToCimsOnlineAdmin>;
  batchReportRequests: Array<BatchReportRequest>;
  casComments: Array<CasComment>;
  casDispositions: Array<ConstructionAdminSubmittal>;
  casRoutingGroups: Array<CasRoutingGroup>;
  casSubmissions: Array<ConstructionAdminSubmittal>;
  casToCASRoutingGroups: Array<CasToCasRoutingGroup>;
  /** the date this record was inserted into the database */
  createdDate: Scalars['DateTime'];
  /**
   * the email address of a user associated with the `createdDate`
   *
   * this value will be `unknown` if the `createdDate` was not set by a user
   */
  createdUser: Scalars['String'];
  /** describes whether the record has been soft-deleted or not */
  deleted: Scalars['Boolean'];
  /** the date this record was soft-deleted in the database */
  deletedDate: Maybe<Scalars['DateTime']>;
  /**
   * the email address of a user associated with the `deletedDate`
   *
   * this value will be `system` if the `deletedDate` was not set by a user
   */
  deletedUser: Maybe<Scalars['String']>;
  designSubmittalDispositions: Array<DesignSubmittal>;
  designSubmittalSubmissions: Array<DesignSubmittal>;
  developer: Scalars['Boolean'];
  developerDate: Maybe<Scalars['DateTime']>;
  developerGrantedBy: Maybe<User>;
  developerGrantedById: Maybe<Scalars['String']>;
  developersGranted: Array<User>;
  /**
   * this is
   * stored in the database with data from the Microsoft Graph API
   *
   * it corresponds to a `User.displayName` value
   */
  displayName: Maybe<Scalars['String']>;
  dsComments: Array<DsComment>;
  dsDisciplines: Array<DsDiscipline>;
  dsToDSDisciplines: Array<DsToDsDiscipline>;
  ejTypes: Array<EjType>;
  engineeringJudgements: Array<EngineeringJudgement>;
  fdcApprovalGroups: Array<FdcApprovalGroup>;
  fdcComments: Array<FdcComment>;
  fdcConcurrenceGroups: Array<FdcConcurrenceGroup>;
  fdcToFDCApprovalGroups: Array<FdcToFdcApprovalGroup>;
  fdcToFDCConcurrenceGroups: Array<FdcToFdcConcurrenceGroup>;
  fieldDesignChanges: Array<FieldDesignChange>;
  /**
   * this is
   * stored in the database with data from the Microsoft Graph API
   *
   * it corresponds to a `User.givenName` value
   */
  givenName: Maybe<Scalars['String']>;
  graphqlDeprecationLogs: Array<GraphQlDeprecationLog>;
  /**
   * this is
   * stored in the database with data from the Microsoft Graph API
   *
   * it corresponds to a `User.id` value
   */
  id: Scalars['String'];
  issueClosures: Array<Issue>;
  issueComments: Array<IssueComment>;
  issueDispositions: Array<Issue>;
  issueResponses: Array<Issue>;
  issueSubmissions: Array<Issue>;
  labTechs: Array<LabTech>;
  /** the date this record was last updated in the database */
  lastEditedDate: Scalars['DateTime'];
  /**
   * the email address of a user associated with the `lastEditedDate`
   *
   * this value will be `system` if the `lastEditedDate` was not set by a user
   */
  lastEditedUser: Scalars['String'];
  /**
   * this is
   * stored in the database with data from the Microsoft Graph API
   *
   * it corresponds to a `User.mail` value
   */
  mail: Scalars['String'];
  /** additional permissions for a given `projectId`, not included in associated project roles */
  permissions: Array<Scalars['String']>;
  photoExportRequests: Array<PhotoExportRequest>;
  projectToCIMSOnlineAdmins: Array<ProjectToCimsOnlineAdmin>;
  rfiComments: Array<RfiComment>;
  rfiResponseDisciplines: Array<RfiResponseDiscipline>;
  rfiSubmissions: Array<RequestForInformation>;
  roles: Array<Role>;
  /**
   * this is
   * stored in the database with data from the Microsoft Graph API
   *
   * it corresponds to a `User.surname` value
   */
  surname: Maybe<Scalars['String']>;
  userGroups: Array<UserGroup>;
  userToDeveloperPermissions: Array<UserToDeveloperPermission>;
  /** resolves into the `displayName` or `mail` */
  username: Scalars['String'];
};


/**
 * ### Azure Active Directory copies
 *
 * this object type is a partial copy of an Azure Active Directory `User`
 *
 * it is stored and synced with the Microsoft Graph API
 *
 * additionally, records are synced roughly every 15 minutes with their
 * corresponding `User` in Active Directory
 */
export type UserAdminArgs = {
  projectId: Scalars['String'];
};


/**
 * ### Azure Active Directory copies
 *
 * this object type is a partial copy of an Azure Active Directory `User`
 *
 * it is stored and synced with the Microsoft Graph API
 *
 * additionally, records are synced roughly every 15 minutes with their
 * corresponding `User` in Active Directory
 */
export type UserBatchReportRequestsArgs = {
  batchReportRequestFieldInput?: InputMaybe<BatchReportRequestFieldInput>;
};


/**
 * ### Azure Active Directory copies
 *
 * this object type is a partial copy of an Azure Active Directory `User`
 *
 * it is stored and synced with the Microsoft Graph API
 *
 * additionally, records are synced roughly every 15 minutes with their
 * corresponding `User` in Active Directory
 */
export type UserCasCommentsArgs = {
  casCommentFieldInput?: InputMaybe<CasCommentFieldInput>;
};


/**
 * ### Azure Active Directory copies
 *
 * this object type is a partial copy of an Azure Active Directory `User`
 *
 * it is stored and synced with the Microsoft Graph API
 *
 * additionally, records are synced roughly every 15 minutes with their
 * corresponding `User` in Active Directory
 */
export type UserCasDispositionsArgs = {
  constructionAdminSubmittalFieldInput?: InputMaybe<ConstructionAdminSubmittalFieldInput>;
};


/**
 * ### Azure Active Directory copies
 *
 * this object type is a partial copy of an Azure Active Directory `User`
 *
 * it is stored and synced with the Microsoft Graph API
 *
 * additionally, records are synced roughly every 15 minutes with their
 * corresponding `User` in Active Directory
 */
export type UserCasRoutingGroupsArgs = {
  casRoutingGroupFieldInput?: InputMaybe<CasRoutingGroupFieldInput>;
};


/**
 * ### Azure Active Directory copies
 *
 * this object type is a partial copy of an Azure Active Directory `User`
 *
 * it is stored and synced with the Microsoft Graph API
 *
 * additionally, records are synced roughly every 15 minutes with their
 * corresponding `User` in Active Directory
 */
export type UserCasSubmissionsArgs = {
  constructionAdminSubmittalFieldInput?: InputMaybe<ConstructionAdminSubmittalFieldInput>;
};


/**
 * ### Azure Active Directory copies
 *
 * this object type is a partial copy of an Azure Active Directory `User`
 *
 * it is stored and synced with the Microsoft Graph API
 *
 * additionally, records are synced roughly every 15 minutes with their
 * corresponding `User` in Active Directory
 */
export type UserCasToCasRoutingGroupsArgs = {
  casToCASRoutingGroupFieldInput?: InputMaybe<CasToCasRoutingGroupFieldInput>;
};


/**
 * ### Azure Active Directory copies
 *
 * this object type is a partial copy of an Azure Active Directory `User`
 *
 * it is stored and synced with the Microsoft Graph API
 *
 * additionally, records are synced roughly every 15 minutes with their
 * corresponding `User` in Active Directory
 */
export type UserDesignSubmittalDispositionsArgs = {
  designSubmittalFieldInput?: InputMaybe<DesignSubmittalFieldInput>;
};


/**
 * ### Azure Active Directory copies
 *
 * this object type is a partial copy of an Azure Active Directory `User`
 *
 * it is stored and synced with the Microsoft Graph API
 *
 * additionally, records are synced roughly every 15 minutes with their
 * corresponding `User` in Active Directory
 */
export type UserDesignSubmittalSubmissionsArgs = {
  designSubmittalFieldInput?: InputMaybe<DesignSubmittalFieldInput>;
};


/**
 * ### Azure Active Directory copies
 *
 * this object type is a partial copy of an Azure Active Directory `User`
 *
 * it is stored and synced with the Microsoft Graph API
 *
 * additionally, records are synced roughly every 15 minutes with their
 * corresponding `User` in Active Directory
 */
export type UserDevelopersGrantedArgs = {
  userFieldInput?: InputMaybe<UserFieldInput>;
};


/**
 * ### Azure Active Directory copies
 *
 * this object type is a partial copy of an Azure Active Directory `User`
 *
 * it is stored and synced with the Microsoft Graph API
 *
 * additionally, records are synced roughly every 15 minutes with their
 * corresponding `User` in Active Directory
 */
export type UserDsCommentsArgs = {
  dsCommentFieldInput?: InputMaybe<DsCommentFieldInput>;
};


/**
 * ### Azure Active Directory copies
 *
 * this object type is a partial copy of an Azure Active Directory `User`
 *
 * it is stored and synced with the Microsoft Graph API
 *
 * additionally, records are synced roughly every 15 minutes with their
 * corresponding `User` in Active Directory
 */
export type UserDsDisciplinesArgs = {
  dsDisciplineFieldInput?: InputMaybe<DsDisciplineFieldInput>;
};


/**
 * ### Azure Active Directory copies
 *
 * this object type is a partial copy of an Azure Active Directory `User`
 *
 * it is stored and synced with the Microsoft Graph API
 *
 * additionally, records are synced roughly every 15 minutes with their
 * corresponding `User` in Active Directory
 */
export type UserDsToDsDisciplinesArgs = {
  dsToDSDisciplineFieldInput?: InputMaybe<DsToDsDisciplineFieldInput>;
};


/**
 * ### Azure Active Directory copies
 *
 * this object type is a partial copy of an Azure Active Directory `User`
 *
 * it is stored and synced with the Microsoft Graph API
 *
 * additionally, records are synced roughly every 15 minutes with their
 * corresponding `User` in Active Directory
 */
export type UserEjTypesArgs = {
  ejTypeFieldInput?: InputMaybe<EjTypeFieldInput>;
};


/**
 * ### Azure Active Directory copies
 *
 * this object type is a partial copy of an Azure Active Directory `User`
 *
 * it is stored and synced with the Microsoft Graph API
 *
 * additionally, records are synced roughly every 15 minutes with their
 * corresponding `User` in Active Directory
 */
export type UserEngineeringJudgementsArgs = {
  engineeringJudgementFieldInput?: InputMaybe<EngineeringJudgementFieldInput>;
};


/**
 * ### Azure Active Directory copies
 *
 * this object type is a partial copy of an Azure Active Directory `User`
 *
 * it is stored and synced with the Microsoft Graph API
 *
 * additionally, records are synced roughly every 15 minutes with their
 * corresponding `User` in Active Directory
 */
export type UserFdcApprovalGroupsArgs = {
  fdcApprovalGroupFieldInput?: InputMaybe<FdcApprovalGroupFieldInput>;
};


/**
 * ### Azure Active Directory copies
 *
 * this object type is a partial copy of an Azure Active Directory `User`
 *
 * it is stored and synced with the Microsoft Graph API
 *
 * additionally, records are synced roughly every 15 minutes with their
 * corresponding `User` in Active Directory
 */
export type UserFdcCommentsArgs = {
  fdcCommentFieldInput?: InputMaybe<FdcCommentFieldInput>;
};


/**
 * ### Azure Active Directory copies
 *
 * this object type is a partial copy of an Azure Active Directory `User`
 *
 * it is stored and synced with the Microsoft Graph API
 *
 * additionally, records are synced roughly every 15 minutes with their
 * corresponding `User` in Active Directory
 */
export type UserFdcConcurrenceGroupsArgs = {
  fdcConcurrenceGroupFieldInput?: InputMaybe<FdcConcurrenceGroupFieldInput>;
};


/**
 * ### Azure Active Directory copies
 *
 * this object type is a partial copy of an Azure Active Directory `User`
 *
 * it is stored and synced with the Microsoft Graph API
 *
 * additionally, records are synced roughly every 15 minutes with their
 * corresponding `User` in Active Directory
 */
export type UserFdcToFdcApprovalGroupsArgs = {
  fdcToFDCApprovalGroupFieldInput?: InputMaybe<FdcToFdcApprovalGroupFieldInput>;
};


/**
 * ### Azure Active Directory copies
 *
 * this object type is a partial copy of an Azure Active Directory `User`
 *
 * it is stored and synced with the Microsoft Graph API
 *
 * additionally, records are synced roughly every 15 minutes with their
 * corresponding `User` in Active Directory
 */
export type UserFdcToFdcConcurrenceGroupsArgs = {
  fdcToFDCConcurrenceGroupFieldInput?: InputMaybe<FdcToFdcConcurrenceGroupFieldInput>;
};


/**
 * ### Azure Active Directory copies
 *
 * this object type is a partial copy of an Azure Active Directory `User`
 *
 * it is stored and synced with the Microsoft Graph API
 *
 * additionally, records are synced roughly every 15 minutes with their
 * corresponding `User` in Active Directory
 */
export type UserFieldDesignChangesArgs = {
  fieldDesignChangeFieldInput?: InputMaybe<FieldDesignChangeFieldInput>;
};


/**
 * ### Azure Active Directory copies
 *
 * this object type is a partial copy of an Azure Active Directory `User`
 *
 * it is stored and synced with the Microsoft Graph API
 *
 * additionally, records are synced roughly every 15 minutes with their
 * corresponding `User` in Active Directory
 */
export type UserGraphqlDeprecationLogsArgs = {
  graphQLDeprecationLogFieldInput?: InputMaybe<GraphQlDeprecationLogFieldInput>;
};


/**
 * ### Azure Active Directory copies
 *
 * this object type is a partial copy of an Azure Active Directory `User`
 *
 * it is stored and synced with the Microsoft Graph API
 *
 * additionally, records are synced roughly every 15 minutes with their
 * corresponding `User` in Active Directory
 */
export type UserIssueClosuresArgs = {
  issueFieldInput?: InputMaybe<IssueFieldInput>;
};


/**
 * ### Azure Active Directory copies
 *
 * this object type is a partial copy of an Azure Active Directory `User`
 *
 * it is stored and synced with the Microsoft Graph API
 *
 * additionally, records are synced roughly every 15 minutes with their
 * corresponding `User` in Active Directory
 */
export type UserIssueCommentsArgs = {
  issueCommentFieldInput?: InputMaybe<IssueCommentFieldInput>;
};


/**
 * ### Azure Active Directory copies
 *
 * this object type is a partial copy of an Azure Active Directory `User`
 *
 * it is stored and synced with the Microsoft Graph API
 *
 * additionally, records are synced roughly every 15 minutes with their
 * corresponding `User` in Active Directory
 */
export type UserIssueDispositionsArgs = {
  issueFieldInput?: InputMaybe<IssueFieldInput>;
};


/**
 * ### Azure Active Directory copies
 *
 * this object type is a partial copy of an Azure Active Directory `User`
 *
 * it is stored and synced with the Microsoft Graph API
 *
 * additionally, records are synced roughly every 15 minutes with their
 * corresponding `User` in Active Directory
 */
export type UserIssueResponsesArgs = {
  issueFieldInput?: InputMaybe<IssueFieldInput>;
};


/**
 * ### Azure Active Directory copies
 *
 * this object type is a partial copy of an Azure Active Directory `User`
 *
 * it is stored and synced with the Microsoft Graph API
 *
 * additionally, records are synced roughly every 15 minutes with their
 * corresponding `User` in Active Directory
 */
export type UserIssueSubmissionsArgs = {
  issueFieldInput?: InputMaybe<IssueFieldInput>;
};


/**
 * ### Azure Active Directory copies
 *
 * this object type is a partial copy of an Azure Active Directory `User`
 *
 * it is stored and synced with the Microsoft Graph API
 *
 * additionally, records are synced roughly every 15 minutes with their
 * corresponding `User` in Active Directory
 */
export type UserLabTechsArgs = {
  labTechFieldInput?: InputMaybe<LabTechFieldInput>;
};


/**
 * ### Azure Active Directory copies
 *
 * this object type is a partial copy of an Azure Active Directory `User`
 *
 * it is stored and synced with the Microsoft Graph API
 *
 * additionally, records are synced roughly every 15 minutes with their
 * corresponding `User` in Active Directory
 */
export type UserPermissionsArgs = {
  projectId: Scalars['String'];
};


/**
 * ### Azure Active Directory copies
 *
 * this object type is a partial copy of an Azure Active Directory `User`
 *
 * it is stored and synced with the Microsoft Graph API
 *
 * additionally, records are synced roughly every 15 minutes with their
 * corresponding `User` in Active Directory
 */
export type UserPhotoExportRequestsArgs = {
  photoExportRequestsFieldInput?: InputMaybe<PhotoExportRequestFieldInput>;
};


/**
 * ### Azure Active Directory copies
 *
 * this object type is a partial copy of an Azure Active Directory `User`
 *
 * it is stored and synced with the Microsoft Graph API
 *
 * additionally, records are synced roughly every 15 minutes with their
 * corresponding `User` in Active Directory
 */
export type UserProjectToCimsOnlineAdminsArgs = {
  projectToCIMSOnlineAdminFieldInput?: InputMaybe<ProjectToCimsOnlineAdminFieldInput>;
};


/**
 * ### Azure Active Directory copies
 *
 * this object type is a partial copy of an Azure Active Directory `User`
 *
 * it is stored and synced with the Microsoft Graph API
 *
 * additionally, records are synced roughly every 15 minutes with their
 * corresponding `User` in Active Directory
 */
export type UserRfiCommentsArgs = {
  rfiCommentFieldInput?: InputMaybe<RfiCommentFieldInput>;
};


/**
 * ### Azure Active Directory copies
 *
 * this object type is a partial copy of an Azure Active Directory `User`
 *
 * it is stored and synced with the Microsoft Graph API
 *
 * additionally, records are synced roughly every 15 minutes with their
 * corresponding `User` in Active Directory
 */
export type UserRfiResponseDisciplinesArgs = {
  rfiResponseDisciplineFieldInput?: InputMaybe<RfiResponseDisciplineFieldInput>;
};


/**
 * ### Azure Active Directory copies
 *
 * this object type is a partial copy of an Azure Active Directory `User`
 *
 * it is stored and synced with the Microsoft Graph API
 *
 * additionally, records are synced roughly every 15 minutes with their
 * corresponding `User` in Active Directory
 */
export type UserRfiSubmissionsArgs = {
  requestForInformationFieldInput?: InputMaybe<RequestForInformationFieldInput>;
};


/**
 * ### Azure Active Directory copies
 *
 * this object type is a partial copy of an Azure Active Directory `User`
 *
 * it is stored and synced with the Microsoft Graph API
 *
 * additionally, records are synced roughly every 15 minutes with their
 * corresponding `User` in Active Directory
 */
export type UserRolesArgs = {
  roleFieldInput?: InputMaybe<RoleFieldInput>;
};


/**
 * ### Azure Active Directory copies
 *
 * this object type is a partial copy of an Azure Active Directory `User`
 *
 * it is stored and synced with the Microsoft Graph API
 *
 * additionally, records are synced roughly every 15 minutes with their
 * corresponding `User` in Active Directory
 */
export type UserUserGroupsArgs = {
  userGroupFieldInput?: InputMaybe<UserGroupFieldInput>;
};


/**
 * ### Azure Active Directory copies
 *
 * this object type is a partial copy of an Azure Active Directory `User`
 *
 * it is stored and synced with the Microsoft Graph API
 *
 * additionally, records are synced roughly every 15 minutes with their
 * corresponding `User` in Active Directory
 */
export type UserUserToDeveloperPermissionsArgs = {
  userToDeveloperPermissionFieldInput?: InputMaybe<UserToDeveloperPermissionFieldInput>;
};

/**
 * helps filter multiple `User` records
 *
 * this version of the input will have limited options compared to its other counterpart
 */
export type UserFieldInput = {
  createdDate?: InputMaybe<DateTimeFilter>;
  /**
   * determines now to handle deleted `User` records
   *
   * - when `true`, only return deleted records
   * - when `false`, do not return deleted records
   * - when omitted, `deleted` is ignored
   */
  deleted?: InputMaybe<Scalars['Boolean']>;
  deletedDate?: InputMaybe<DateTimeFilter>;
  /**
   * - when `true`, `developer` is truthy
   * - when `false`, `developer` is falsy
   * - when omitted, `developer` is ignored
   */
  developer?: InputMaybe<Scalars['Boolean']>;
  displayName?: InputMaybe<StringFilter>;
  givenName?: InputMaybe<StringFilter>;
  id?: InputMaybe<StringFilter>;
  lastEditedDate?: InputMaybe<DateTimeFilter>;
  mail?: InputMaybe<StringFilter>;
  /**
   * how to order `User` records
   *
   * executed in the order they are defined
   */
  orderBy?: InputMaybe<Array<OrderByInput>>;
  surname?: InputMaybe<StringFilter>;
  /**
   * specifies how many records to return
   *
   * analogous to `limit`, `first`, or `top` in SQL dialects
   */
  take?: InputMaybe<Scalars['Int']>;
};

/**
 * ### Azure Active Directory copies
 *
 * this object type is a partial copy of an Azure Active Directory `UserGroup`
 *
 * it is stored and synced with the Microsoft Graph API
 *
 * additionally, records are synced roughly every 15 minutes with their
 * corresponding `UserGroup` in Active Directory
 *
 * at the end of this sync, every `User` associated with each `UserGroup` should match what's in Active Directory
 */
export type UserGroup = {
  __typename: 'UserGroup';
  /** the date this record was inserted into the database */
  createdDate: Scalars['DateTime'];
  /**
   * the email address of a user associated with the `createdDate`
   *
   * this value will be `unknown` if the `createdDate` was not set by a user
   */
  createdUser: Scalars['String'];
  /**
   * this is
   * stored in the database with data from the Microsoft Graph API
   *
   * it corresponds to a `UserGroup.id` value
   */
  id: Scalars['String'];
  /** the date this record was last updated in the database */
  lastEditedDate: Scalars['DateTime'];
  /**
   * the email address of a user associated with the `lastEditedDate`
   *
   * this value will be `system` if the `lastEditedDate` was not set by a user
   */
  lastEditedUser: Scalars['String'];
  /**
   * this is
   * stored in the database with data from the Microsoft Graph API
   *
   * it corresponds to a `UserGroup.displayName` value
   */
  name: Scalars['String'];
  projectToUserGroups: Array<ProjectToUserGroup>;
  users: Array<User>;
};


/**
 * ### Azure Active Directory copies
 *
 * this object type is a partial copy of an Azure Active Directory `UserGroup`
 *
 * it is stored and synced with the Microsoft Graph API
 *
 * additionally, records are synced roughly every 15 minutes with their
 * corresponding `UserGroup` in Active Directory
 *
 * at the end of this sync, every `User` associated with each `UserGroup` should match what's in Active Directory
 */
export type UserGroupProjectToUserGroupsArgs = {
  projectToUserGroupFieldInput?: InputMaybe<ProjectToUserGroupFieldInput>;
};


/**
 * ### Azure Active Directory copies
 *
 * this object type is a partial copy of an Azure Active Directory `UserGroup`
 *
 * it is stored and synced with the Microsoft Graph API
 *
 * additionally, records are synced roughly every 15 minutes with their
 * corresponding `UserGroup` in Active Directory
 *
 * at the end of this sync, every `User` associated with each `UserGroup` should match what's in Active Directory
 */
export type UserGroupUsersArgs = {
  userFieldInput?: InputMaybe<UserFieldInput>;
};

/**
 * helps filter multiple `UserGroup` records
 *
 * this version of the input will have limited options compared to its other counterpart
 */
export type UserGroupFieldInput = {
  createdDate?: InputMaybe<DateTimeFilter>;
  lastEditedDate?: InputMaybe<DateTimeFilter>;
  name?: InputMaybe<StringFilter>;
  /**
   * how to order `UserGroup` records
   *
   * executed in the order they are defined
   */
  orderBy?: InputMaybe<Array<OrderByInput>>;
  /**
   * specifies how many records to return
   *
   * analogous to `limit`, `first`, or `top` in SQL dialects
   */
  take?: InputMaybe<Scalars['Int']>;
};

/** helps filter multiple `UserGroup` records */
export type UserGroupListInput = {
  createdDate?: InputMaybe<DateTimeFilter>;
  lastEditedDate?: InputMaybe<DateTimeFilter>;
  name?: InputMaybe<StringFilter>;
  /**
   * how to order `UserGroup` records
   *
   * executed in the order they are defined
   */
  orderBy?: InputMaybe<Array<OrderByInput>>;
  /**
   * paginate `UserGroup` records
   *
   * using `paginate` may require multiple requests to get all possible results,
   * but will give more fine-grain control in the event all records cannot be
   * returned gracefully
   */
  paginate?: InputMaybe<PaginationInput>;
};

/** response metadata for a list query of UserGroup records */
export type UserGroupListResponse = {
  __typename: 'UserGroupListResponse';
  /** the total count of UserGroup records matching any configured filters */
  count: Scalars['Int'];
  /** the total count of paginated groups of UserGroup */
  pages: Scalars['Int'];
  /** UserGroup records */
  records: Array<UserGroup>;
};

/** helps filter multiple `User` records */
export type UserListInput = {
  createdDate?: InputMaybe<DateTimeFilter>;
  /**
   * determines now to handle deleted `User` records
   *
   * - when `true`, only return deleted records
   * - when `false`, do not return deleted records
   * - when omitted, `deleted` is ignored
   */
  deleted?: InputMaybe<Scalars['Boolean']>;
  deletedDate?: InputMaybe<DateTimeFilter>;
  /**
   * - when `true`, `developer` is truthy
   * - when `false`, `developer` is falsy
   * - when omitted, `developer` is ignored
   */
  developer?: InputMaybe<Scalars['Boolean']>;
  displayName?: InputMaybe<StringFilter>;
  givenName?: InputMaybe<StringFilter>;
  id?: InputMaybe<StringFilter>;
  lastEditedDate?: InputMaybe<DateTimeFilter>;
  mail?: InputMaybe<StringFilter>;
  /**
   * how to order `User` records
   *
   * executed in the order they are defined
   */
  orderBy?: InputMaybe<Array<OrderByInput>>;
  /**
   * paginate `User` records
   *
   * using `paginate` may require multiple requests to get all possible results,
   * but will give more fine-grain control in the event all records cannot be
   * returned gracefully
   */
  paginate?: InputMaybe<PaginationInput>;
  surname?: InputMaybe<StringFilter>;
};

/** response metadata for a list query of User records */
export type UserListResponse = {
  __typename: 'UserListResponse';
  /** the total count of User records matching any configured filters */
  count: Scalars['Int'];
  /** the total count of paginated groups of User */
  pages: Scalars['Int'];
  /** User records */
  records: Array<User>;
};

export type UserToDeveloperPermission = {
  __typename: 'UserToDeveloperPermission';
  permission: Scalars['String'];
  permissionId: Scalars['String'];
  user: User;
  userId: Scalars['String'];
};

/**
 * helps filter multiple `UserToDeveloperPermission` records
 *
 * this version of the input will have limited options compared to its other counterpart
 */
export type UserToDeveloperPermissionFieldInput = {
  /**
   * how to order `UserToDeveloperPermission` records
   *
   * executed in the order they are defined
   */
  orderBy?: InputMaybe<Array<OrderByInput>>;
  permissionId?: InputMaybe<StringFilter>;
  /**
   * specifies how many records to return
   *
   * analogous to `limit`, `first`, or `top` in SQL dialects
   */
  take?: InputMaybe<Scalars['Int']>;
  userId?: InputMaybe<StringFilter>;
};

/** helps filter multiple `UserToDeveloperPermission` records */
export type UserToDeveloperPermissionListInput = {
  /**
   * how to order `UserToDeveloperPermission` records
   *
   * executed in the order they are defined
   */
  orderBy?: InputMaybe<Array<OrderByInput>>;
  /**
   * paginate `UserToDeveloperPermission` records
   *
   * using `paginate` may require multiple requests to get all possible results,
   * but will give more fine-grain control in the event all records cannot be
   * returned gracefully
   */
  paginate?: InputMaybe<PaginationInput>;
  permissionId?: InputMaybe<StringFilter>;
  userId?: InputMaybe<StringFilter>;
};

/** response metadata for a list query of UserToDeveloperPermission records */
export type UserToDeveloperPermissionListResponse = {
  __typename: 'UserToDeveloperPermissionListResponse';
  /** the total count of UserToDeveloperPermission records matching any configured filters */
  count: Scalars['Int'];
  /** the total count of paginated groups of UserToDeveloperPermission */
  pages: Scalars['Int'];
  /** UserToDeveloperPermission records */
  records: Array<UserToDeveloperPermission>;
};

/**
 * used to define non-role permissions for a `User` and `Project`
 *
 * does not include permissions associated with any `Role` the `User` may have
 */
export type UserToProjectToPermission = {
  __typename: 'UserToProjectToPermission';
  permission: Scalars['String'];
  permissionId: Scalars['String'];
  /** a related `Project` */
  project: Project;
  projectId: Scalars['String'];
  user: User;
  userId: Scalars['String'];
};

/**
 * helps filter multiple `UserToProjectToPermission` records
 *
 * this version of the input will have limited options compared to its other counterpart
 */
export type UserToProjectToPermissionFieldInput = {
  /**
   * how to order `UserToProjectToPermission` records
   *
   * executed in the order they are defined
   */
  orderBy?: InputMaybe<Array<OrderByInput>>;
  permissionId?: InputMaybe<StringFilter>;
  projectId?: InputMaybe<StringFilter>;
  /**
   * specifies how many records to return
   *
   * analogous to `limit`, `first`, or `top` in SQL dialects
   */
  take?: InputMaybe<Scalars['Int']>;
  userId?: InputMaybe<StringFilter>;
};

/** helps filter multiple `UserToProjectToPermission` records */
export type UserToProjectToPermissionListInput = {
  /**
   * how to order `UserToProjectToPermission` records
   *
   * executed in the order they are defined
   */
  orderBy?: InputMaybe<Array<OrderByInput>>;
  /**
   * paginate `UserToProjectToPermission` records
   *
   * using `paginate` may require multiple requests to get all possible results,
   * but will give more fine-grain control in the event all records cannot be
   * returned gracefully
   */
  paginate?: InputMaybe<PaginationInput>;
  permissionId?: InputMaybe<StringFilter>;
  projectId?: InputMaybe<StringFilter>;
  userId?: InputMaybe<StringFilter>;
};

/** response metadata for a list query of UserToProjectToPermission records */
export type UserToProjectToPermissionListResponse = {
  __typename: 'UserToProjectToPermissionListResponse';
  /** the total count of UserToProjectToPermission records matching any configured filters */
  count: Scalars['Int'];
  /** the total count of paginated groups of UserToProjectToPermission */
  pages: Scalars['Int'];
  /** UserToProjectToPermission records */
  records: Array<UserToProjectToPermission>;
};

export type WeeklyFrequency = BaseFrequency & {
  __typename: 'WeeklyFrequency';
  /** Default value is 1 - (Monday) */
  day: Scalars['Int'];
  /** Default value is 8 */
  hour: Scalars['Int'];
  /** Default value is 0 */
  minute: Scalars['Int'];
  next: Scalars['DateTime'];
  previous: Scalars['DateTime'];
};

export type WeeklyFrequencyInput = {
  day: Scalars['Int'];
  hour: Scalars['Int'];
  minute: Scalars['Int'];
};

export type WriteHeapSnapshotResponse = {
  __typename: 'WriteHeapSnapshotResponse';
  id: Scalars['String'];
};

export type EditCustomFieldMutationVariables = Exact<{
  editCustomFieldInput: EditCustomFieldInput;
}>;


export type EditCustomFieldMutation = { __typename: 'Mutation', editCustomField: { __typename: 'EditCustomFieldResponse', customField: { __typename: 'CustomField', name: string } } };

export type CreateCustomFieldMutationVariables = Exact<{
  createCustomFieldInput: CreateCustomFieldInput;
}>;


export type CreateCustomFieldMutation = { __typename: 'Mutation', createCustomField: { __typename: 'CreateCustomFieldResponse', customField: { __typename: 'CustomField', name: string } } };

export type EditCustomFieldToClassTypeMutationVariables = Exact<{
  editCustomFieldToClassTypeInput: EditCustomFieldToClassTypeInput;
}>;


export type EditCustomFieldToClassTypeMutation = { __typename: 'Mutation', editCustomFieldToClassType: { __typename: 'EditCustomFieldToClassTypeResponse', customFieldToClassType: { __typename: 'CustomFieldToClassType', classType: string, customField: { __typename: 'CustomField', name: string } } } };

export type SoftRemoveCustomFieldMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type SoftRemoveCustomFieldMutation = { __typename: 'Mutation', softRemoveCustomField: { __typename: 'SoftRemoveCustomFieldResponse', customField: { __typename: 'CustomField', name: string } } };

export type RestoreCustomFieldMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type RestoreCustomFieldMutation = { __typename: 'Mutation', restoreCustomField: { __typename: 'RestoreCustomFieldResponse', customField: { __typename: 'CustomField', name: string } } };

export type CreateNonUserEmailMutationVariables = Exact<{
  createNonUserEmailInput: CreateNonUserEmailInput;
}>;


export type CreateNonUserEmailMutation = { __typename: 'Mutation', createNonUserEmail: { __typename: 'CreateNonUserEmailResponse', nonUserEmail: { __typename: 'NonUserEmail', label: string | null, address: string } } };

export type EditNonUserEmailMutationVariables = Exact<{
  editNonUserEmailInput: EditNonUserEmailInput;
}>;


export type EditNonUserEmailMutation = { __typename: 'Mutation', editNonUserEmail: { __typename: 'EditNonUserEmailResponse', nonUserEmail: { __typename: 'NonUserEmail', label: string | null, address: string } } };

export type RemoveNonUserEmailMutationVariables = Exact<{
  id: Scalars['Int'];
}>;


export type RemoveNonUserEmailMutation = { __typename: 'Mutation', removeNonUserEmail: { __typename: 'RemoveNonUserEmailResponse', nonUserEmail: { __typename: 'NonUserEmail', label: string | null, address: string } } };

export type GetNonUserEmailsQueryVariables = Exact<{
  input: NonUserEmailListInput;
}>;


export type GetNonUserEmailsQuery = { __typename: 'Query', nonUserEmails: { __typename: 'NonUserEmailListResponse', records: Array<{ __typename: 'NonUserEmail', id: number, label: string | null, description: string | null, address: string, createdDate: string }> } };

export type ConcreteTestIfiSettingsQueryVariables = Exact<{
  projectId: Scalars['String'];
}>;


export type ConcreteTestIfiSettingsQuery = { __typename: 'Query', concreteTestIFISettings: { __typename: 'ConcreteTestIFISettingsListResponse', records: Array<{ __typename: 'ConcreteTestIFISettings', enabled: boolean, effectiveDate: string | null, ambientAir: { __typename: 'ConcreteTestAmbientAirIFISettings', enabled: boolean, effectiveDate: string | null, minimumAmbientAirTemperature: number | null, message: string | null }, temperature: { __typename: 'ConcreteTestTemperatureIFISettings', enabled: boolean, effectiveDate: string | null, tempRange: string | null, temperatureHigh: number | null, temperatureLow: number | null, highMessage: string | null, lowMessage: string | null }, slump: { __typename: 'ConcreteTestSlumpIFISettings', enabled: boolean, effectiveDate: string | null, highMessage: string | null, lowMessage: string | null }, percentAir: { __typename: 'ConcreteTestPercentAirIFISettings', enabled: boolean, effectiveDate: string | null, highMessage: string | null, lowMessage: string | null } }> } };

export type ControlPointIfiSettingsQueryVariables = Exact<{
  projectId: Scalars['String'];
}>;


export type ControlPointIfiSettingsQuery = { __typename: 'Query', dailyInspectionControlPointIFISettings: { __typename: 'DailyInspectionControlPointIFISettingsListResponse', records: Array<{ __typename: 'DailyInspectionControlPointIFISettings', enabled: boolean, effectiveDate: string | null, missingGeometry: { __typename: 'ControlPointMissingGeometryIFISettings', enabled: boolean, effectiveDate: string | null, message: string | null } }> } };

export type DensityTestIfiSettingsQueryVariables = Exact<{
  projectId: Scalars['String'];
}>;


export type DensityTestIfiSettingsQuery = { __typename: 'Query', densityTestIFISettings: { __typename: 'DensityTestIFISettingsListResponse', records: Array<{ __typename: 'DensityTestIFISettings', enabled: boolean, effectiveDate: string | null, message: string | null }> } };

export type InspectionIfiSettingsQueryVariables = Exact<{
  projectId: Scalars['String'];
}>;


export type InspectionIfiSettingsQuery = { __typename: 'Query', dailyInspectionInspectionIFISettings: { __typename: 'DailyInspectionInspectionIFISettingsListResponse', records: Array<{ __typename: 'DailyInspectionInspectionIFISettings', enabled: boolean, effectiveDate: string | null, missingGeometry: { __typename: 'InspectionMissingGeometryIFISettings', enabled: boolean, effectiveDate: string | null, message: string | null } }> } };

export type LotIfiSettingsQueryVariables = Exact<{
  projectId: Scalars['String'];
}>;


export type LotIfiSettingsQuery = { __typename: 'Query', lotIFISettings: { __typename: 'LotIFISettingsListResponse', records: Array<{ __typename: 'LotIFISettings', enabled: boolean, effectiveDate: string | null, testCount: { __typename: 'LotTestCountIFISettings', enabled: boolean, effectiveDate: string | null, message: string | null }, proctor: { __typename: 'LotProctorIFISettings', enabled: boolean, effectiveDate: string | null, message: string | null }, compaction: { __typename: 'LotCompactionIFISettings', enabled: boolean, effectiveDate: string | null, message: string | null, levelId: string | null } }> } };

export type PunchListIfiSettingsQueryVariables = Exact<{
  projectId: Scalars['String'];
}>;


export type PunchListIfiSettingsQuery = { __typename: 'Query', dailyInspectionPunchListIFISettings: { __typename: 'DailyInspectionPunchListIFISettingsListResponse', records: Array<{ __typename: 'DailyInspectionPunchListIFISettings', enabled: boolean, effectiveDate: string | null }> } };

export type EditProjectMetadataMutationVariables = Exact<{
  editProjectMetadataInput: EditProjectMetadataInput;
}>;


export type EditProjectMetadataMutation = { __typename: 'Mutation', editProjectMetadata: { __typename: 'EditProjectMetadataResponse', projectMetadata: { __typename: 'ProjectMetadata', sharePointSiteLandingPage: string | null, promptDesignSubmittalAtFDCClosure: boolean | null } } };

export type MetadataQueryVariables = Exact<{
  projectId: Scalars['String'];
}>;


export type MetadataQuery = { __typename: 'Query', project: { __typename: 'Project', sharePointDrives: Array<{ __typename: 'SharePointDrive', id: string, name: string, description: string | null }>, projectMetadata: { __typename: 'ProjectMetadata', sharePointSiteURL: string | null, sharePointSiteLandingPage: string | null, sharePointURL: string | null, promptDesignSubmittalAtFDCClosure: boolean | null, projectLogoB64: string | null, cmProjectLayersId: number | null, customDriveId: string | null, replaceSpacesWithDashesInFilenames: boolean } | null, projectToCIMSOnlineAdmins: Array<{ __typename: 'ProjectToCIMSOnlineAdmin', lastEditedDate: string, lastEditedUser: string, user: { __typename: 'User', id: string, username: string, mail: string, deleted: boolean, userGroups: Array<{ __typename: 'UserGroup', id: string }> } }> } };

export type GetCmProjectLayersWgs84QueryVariables = Exact<{ [key: string]: never; }>;


export type GetCmProjectLayersWgs84Query = { __typename: 'Query', cmProjectLayers: Array<{ __typename: 'MapServerLayer', id: number, name: string }> };

export type GetProjectSettingsProjectAdminsQueryVariables = Exact<{
  projectId: Scalars['String'];
}>;


export type GetProjectSettingsProjectAdminsQuery = { __typename: 'Query', project: { __typename: 'Project', users: Array<{ __typename: 'User', id: string, username: string, mail: string, developer: boolean, admin: { __typename: 'ProjectToCIMSOnlineAdmin', lastEditedDate: string, lastEditedUser: string } | null }> } };

export type UpsertConcreteTestIfiSettingsMutationVariables = Exact<{
  input: UpsertConcreteTestIfiSettingsInput;
}>;


export type UpsertConcreteTestIfiSettingsMutation = { __typename: 'Mutation', upsertConcreteTestIFISettings: { __typename: 'UpsertConcreteTestIFISettingsResponse', concreteTestIFISettings: { __typename: 'ConcreteTestIFISettings', projectId: string } } };

export type UpsertControlPointIfiSettingsMutationVariables = Exact<{
  input: UpsertDailyInspectionControlPointIfiSettingsInput;
}>;


export type UpsertControlPointIfiSettingsMutation = { __typename: 'Mutation', upsertDailyInspectionControlPointIFISettings: { __typename: 'UpsertDailyInspectionControlPointIFISettingsResponse', controlPointIFISettings: { __typename: 'DailyInspectionControlPointIFISettings', projectId: string } } };

export type UpsertLotIfiSettingsMutationVariables = Exact<{
  input: UpsertLotIfiSettingsInput;
}>;


export type UpsertLotIfiSettingsMutation = { __typename: 'Mutation', upsertLotIFISettings: { __typename: 'UpsertLotIFISettingsResponse', lotIFISettings: { __typename: 'LotIFISettings', projectId: string } } };

export type UpsertDensityTestIfiSettingsMutationVariables = Exact<{
  input: UpsertDensityTestIfiSettingsInput;
}>;


export type UpsertDensityTestIfiSettingsMutation = { __typename: 'Mutation', upsertDensityTestIFISettings: { __typename: 'UpsertDensityTestIFISettingsResponse', densityTestIFISettings: { __typename: 'DensityTestIFISettings', projectId: string } } };

export type UpsertInspectionIfiSettingsMutationVariables = Exact<{
  input: UpsertDailyInspectionInspectionIfiSettingsInput;
}>;


export type UpsertInspectionIfiSettingsMutation = { __typename: 'Mutation', upsertDailyInspectionInspectionIFISettings: { __typename: 'UpsertDailyInspectionInspectionIFISettingsResponse', inspectionIFISettings: { __typename: 'DailyInspectionInspectionIFISettings', projectId: string } } };

export type UpsertPunchListIfiSettingsMutationVariables = Exact<{
  input: UpsertDailyInspectionPunchListIfiSettingsInput;
}>;


export type UpsertPunchListIfiSettingsMutation = { __typename: 'Mutation', upsertDailyInspectionPunchListIFISettings: { __typename: 'UpsertDailyInspectionPunchListIFISettingsResponse', punchListIFISettings: { __typename: 'DailyInspectionPunchListIFISettings', projectId: string } } };

export type CreateProjectToCimsOnlineAdminMutationVariables = Exact<{
  input: CreateProjectToCimsOnlineAdminInput;
}>;


export type CreateProjectToCimsOnlineAdminMutation = { __typename: 'Mutation', createProjectToCIMSOnlineAdmin: { __typename: 'CreateProjectToCIMSOnlineAdminResponse', admin: { __typename: 'ProjectToCIMSOnlineAdmin', user: { __typename: 'User', username: string } } } };

export type RemoveProjectToCimsOnlineAdminMutationVariables = Exact<{
  input: RemoveProjectToCimsOnlineAdminInput;
}>;


export type RemoveProjectToCimsOnlineAdminMutation = { __typename: 'Mutation', removeProjectToCIMSOnlineAdmin: { __typename: 'RemoveProjectToCIMSOnlineAdminResponse', admin: { __typename: 'ProjectToCIMSOnlineAdmin', user: { __typename: 'User', username: string } } } };

export type CreateRoleMutationVariables = Exact<{
  createRoleInput: CreateRoleInput;
}>;


export type CreateRoleMutation = { __typename: 'Mutation', createRole: { __typename: 'CreateRoleResponse', role: { __typename: 'Role', name: string } } };

export type EditRoleMutationVariables = Exact<{
  editRoleInput: EditRoleInput;
}>;


export type EditRoleMutation = { __typename: 'Mutation', editRole: { __typename: 'EditRoleResponse', role: { __typename: 'Role', name: string } } };

export type RemoveRoleMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type RemoveRoleMutation = { __typename: 'Mutation', softRemoveRole: { __typename: 'SoftRemoveRoleResponse', role: { __typename: 'Role', name: string } } };

export type RestoreRoleMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type RestoreRoleMutation = { __typename: 'Mutation', restoreRole: { __typename: 'RestoreRoleResponse', role: { __typename: 'Role', name: string } } };

export type GetRolesQueryVariables = Exact<{
  roleListInput: RoleListInput;
}>;


export type GetRolesQuery = { __typename: 'Query', roles: { __typename: 'RoleListResponse', records: Array<{ __typename: 'Role', id: string, name: string, permissions: Array<string>, deleted: boolean, deletedDate: string | null, deletedUser: string | null }> } };

export type BareMinimumRoleFragmentFragment = { __typename: 'Role', id: string, name: string, permissions: Array<string> };

export type GetUsersTableDataQueryVariables = Exact<{
  projectId: Scalars['String'];
}>;


export type GetUsersTableDataQuery = { __typename: 'Query', project: { __typename: 'Project', users: Array<{ __typename: 'User', id: string, mail: string, username: string, displayName: string | null, givenName: string | null, surname: string | null, developer: boolean, developerDate: string | null, permissions: Array<string>, developerGrantedBy: { __typename: 'User', username: string } | null, admin: { __typename: 'ProjectToCIMSOnlineAdmin', lastEditedDate: string, lastEditedUser: string } | null, userGroups: Array<{ __typename: 'UserGroup', id: string, name: string, projectToUserGroups: Array<{ __typename: 'ProjectToUserGroup', projectId: string }> }>, casRoutingGroups: Array<{ __typename: 'CASRoutingGroup', name: string, description: string | null }>, dsDisciplines: Array<{ __typename: 'DSDiscipline', name: string, description: string | null }>, fdcApprovalGroups: Array<{ __typename: 'FDCApprovalGroup', id: string, name: string, description: string | null }>, fdcConcurrenceGroups: Array<{ __typename: 'FDCConcurrenceGroup', id: string, name: string, description: string | null }>, rfiResponseDisciplines: Array<{ __typename: 'RFIResponseDiscipline', name: string, description: string | null }>, ejTypes: Array<{ __typename: 'EJType', name: string }>, roles: Array<{ __typename: 'Role', id: string, name: string, permissions: Array<string>, fdcApprovalGroups: Array<{ __typename: 'FDCApprovalGroup', id: string, name: string, description: string | null }>, fdcConcurrenceGroups: Array<{ __typename: 'FDCConcurrenceGroup', id: string, name: string, description: string | null }> }> }>, roles: Array<{ __typename: 'Role', id: string, name: string, permissions: Array<string> }>, projectToUserGroups: Array<{ __typename: 'ProjectToUserGroup', userGroup: { __typename: 'UserGroup', name: string, id: string } }>, customFields: Array<{ __typename: 'CustomField', id: string, name: string, description: string | null, customFieldToClassTypes: Array<{ __typename: 'CustomFieldToClassType', classType: string, users: Array<{ __typename: 'User', id: string }>, roles: Array<{ __typename: 'Role', id: string }> }> }> } };

export type EditUserMutationVariables = Exact<{
  editUserInput: EditUserInput;
}>;


export type EditUserMutation = { __typename: 'Mutation', editUser: { __typename: 'EditUserResponse', user: { __typename: 'User', username: string } } };

export type RemoveConcreteTestBreakDataMutationVariables = Exact<{
  id: Scalars['Int'];
}>;


export type RemoveConcreteTestBreakDataMutation = { __typename: 'Mutation', removeConcreteTestBreakData: { __typename: 'RemoveConcreteTestBreakDataResponse', concreteTestBreakData: { __typename: 'ConcreteTestBreakData', concreteTest: { __typename: 'ConcreteTest', fieldNumber: string | null, globalId: string } } } };

export type EditConcreteTestSetMutationVariables = Exact<{
  input: EditConcreteTestSetInput;
}>;


export type EditConcreteTestSetMutation = { __typename: 'Mutation', editConcreteTestSet: { __typename: 'EditConcreteTestSetResponse', concreteTestSet: { __typename: 'ConcreteTestSet', testSetId: string | null } } };

export type ConcreteTestSetTrackerPdfModalQueryVariables = Exact<{
  globalId: Scalars['String'];
}>;


export type ConcreteTestSetTrackerPdfModalQuery = { __typename: 'Query', concreteTestSet: { __typename: 'ConcreteTestSet', sharePointResource: { __typename: 'SharePointResource', sharePointResources: Array<{ __typename: 'SharePointResource', id: string, name: string | null, webUrl: string | null }> } | null } };

export type ConcreteTestSetTrackerDocumentChecklistItemFragment = { __typename: 'DocumentChecklistItem', id: number, name: string, documentChecklistItemToConcreteMaterials: Array<{ __typename: 'DocumentChecklistItemToConcreteMaterial', concreteMaterial: { __typename: 'ConcreteMaterial', placementType: string | null } }> };

export type ConcreteTestSetTrackerConcreteTestSetsQueryVariables = Exact<{
  projectId: Scalars['String'];
}>;


export type ConcreteTestSetTrackerConcreteTestSetsQuery = { __typename: 'Query', project: { __typename: 'Project', documentChecklistItems: Array<{ __typename: 'DocumentChecklistItem', id: number, name: string, documentChecklistItemToConcreteMaterials: Array<{ __typename: 'DocumentChecklistItemToConcreteMaterial', concreteMaterial: { __typename: 'ConcreteMaterial', placementType: string | null } }> }>, concreteTestSets: Array<{ __typename: 'ConcreteTestSet', globalId: string, projectId: string | null, testSetId: string | null, estimatedQuantity: number | null, estimatedThicknessIn: number | null, placementDate: string | null, status: string | null, concreteTestSetMetadata: { __typename: 'ConcreteTestSetMetadata', sharePointResourceId: string | null, sharePointResourceWebUrl: string | null, packetSharePointResourceId: string | null, packetSharePointResourceName: string | null, packetSharePointResourceWebUrl: string | null } | null, concreteMixDesign: { __typename: 'ConcreteMixDesign', globalId: string, active: boolean, mixDesignNumber: string | null } | null, concreteMaterial: { __typename: 'ConcreteMaterial', placementType: string | null, specBreakStrength: number | null, maximumBreakStrength: number | null, lowFailureBreakStrength: number | null, airSlumpStartup: number | null, airSlumpTestingFrequency: number | null, airTestsPer: number | null, airUnits: string | null, cylinderSetFrequency: number | null, cylinderSetsPer: number | null, cylinderSetMin: number | null, thicknessCoresPerPlacement: string | null, coreTestingFrequency: number | null, coreUnits: string | null, coresMin: number | null, cureRate: number | null } | null, documentChecklistValues: Array<{ __typename: 'DocumentChecklistValue', checked: boolean, documentChecklistItem: { __typename: 'DocumentChecklistItem', id: number, name: string, documentChecklistItemToConcreteMaterials: Array<{ __typename: 'DocumentChecklistItemToConcreteMaterial', concreteMaterial: { __typename: 'ConcreteMaterial', placementType: string | null } }> } }>, payItemNoGeometries: Array<{ __typename: 'PayItemNoGeometry', globalId: string, label: string, deleted: boolean }> }> } };

export type ConcreteTestSetTrackerRelationsTestingLabFragment = { __typename: 'TestingLab', id: number, name: string };

export type ConcreteTestSetTrackerRelationsLabTechFragment = { __typename: 'LabTech', id: number, name: string, user: { __typename: 'User', id: string, mail: string, displayName: string | null, deleted: boolean, userGroups: Array<{ __typename: 'UserGroup', id: string }> } | null };

export type ConcreteTestSetTrackerRelationsPayItemFragment = { __typename: 'PayItemNoGeometry', globalId: string, deleted: boolean, label: string };

export type ConcreteTestSetTrackerRelationsQueryVariables = Exact<{
  projectId: Scalars['String'];
}>;


export type ConcreteTestSetTrackerRelationsQuery = { __typename: 'Query', project: { __typename: 'Project', concretePlacements: Array<{ __typename: 'ConcretePlacement', globalId: string, concreteTestSetGuid: string | null, placementId: string | null, placementQtyVolCy: number | null, linearFt: number | null, sqFt: number | null, sqYd: number | null, requiredThickness: number | null, cureCoverage: string, cureSqft: number | null, cureGallons: number | null, beginStation: string | null, endStation: string | null, beginOffset: string | null, endOffset: string | null, beginAlignment: string | null, endAlignment: string | null, steelVerified: string, notes: string | null, steelNotes: string | null, payItemNoGeometries: Array<{ __typename: 'PayItemNoGeometry', globalId: string, deleted: boolean, label: string }>, contractor: { __typename: 'Contractor', contractorName: string | null } | null, concreteCoreMeasurements: Array<{ __typename: 'ConcreteCoreMeasurement', globalId: string, measurementId: string | null, station: string | null, offset: string | null, alignment: string | null, requiredThickness: number | null, avgMeasuredThickness: number | null, status: string | null, notes: string | null, measurementDate: string | null, measuredThickness1: number | null, measuredThickness2: number | null, measuredThickness3: number | null, technician: { __typename: 'Technician', technicianName: string | null } | null, concreteCoreBreakData: { __typename: 'ConcreteCoreBreakData', labNumber: string | null, age: number | null, breakDate: string | null, diameter: string | null, peakLoad: number | null, strength: number | null, type: string | null, testingLab: { __typename: 'TestingLab', id: number, name: string } | null, labTech: { __typename: 'LabTech', id: number, name: string, user: { __typename: 'User', id: string, mail: string, displayName: string | null, deleted: boolean, userGroups: Array<{ __typename: 'UserGroup', id: string }> } | null } | null } | null }> }>, concreteTests: Array<{ __typename: 'ConcreteTest', concreteTestSetGuid: string | null, globalId: string, batchTime: string | null, timeTested: string, iaWith: string | null, airMeterNumber: string | null, airMeterCalibrationDate: string | null, fieldNumber: string | null, cylinderNumber: string | null, testSubId: string | null, strengthAge: string | null, strengthAges: Array<number>, truckNumber: number | null, notes: string | null, percentAir: number | null, slump: number | null, airTemp: number | null, concreteTemp: number | null, sampleAtQuantity: number | null, unitWeight: number | null, average28DayStrength: number, overrideComments: string | null, payItemNoGeometries: Array<{ __typename: 'PayItemNoGeometry', globalId: string, deleted: boolean, label: string }>, percentAirTestedBy: { __typename: 'Technician', technicianName: string | null } | null, slumpTestedBy: { __typename: 'Technician', technicianName: string | null } | null, unitWeightTech: { __typename: 'Technician', technicianName: string | null } | null, concreteTestBreakData: Array<{ __typename: 'ConcreteTestBreakData', id: number, labNumber: string | null, age: number | null, breakDate: string | null, diameter: string | null, peakLoad: number | null, strength: number | null, type: string | null, testingLab: { __typename: 'TestingLab', id: number, name: string } | null, labTech: { __typename: 'LabTech', id: number, name: string, user: { __typename: 'User', id: string, mail: string, displayName: string | null, deleted: boolean, userGroups: Array<{ __typename: 'UserGroup', id: string }> } | null } | null }> }> } };

export type SetDocumentChecklistValueMutationVariables = Exact<{
  input: SetDocumentChecklistValueInput;
}>;


export type SetDocumentChecklistValueMutation = { __typename: 'Mutation', setDocumentChecklistValue: { __typename: 'SetDocumentChecklistValueResponse', documentChecklistValue: { __typename: 'DocumentChecklistValue', documentChecklistItem: { __typename: 'DocumentChecklistItem', name: string } } } };

export type CreateDocumentChecklistItemMutationVariables = Exact<{
  createDocumentChecklistItemInput: CreateDocumentChecklistItemInput;
}>;


export type CreateDocumentChecklistItemMutation = { __typename: 'Mutation', createDocumentChecklistItem: { __typename: 'CreateDocumentChecklistItemResponse', documentChecklistItem: { __typename: 'DocumentChecklistItem', name: string } } };

export type EditDocumentChecklistItemMutationVariables = Exact<{
  editDocumentChecklistItemInput: EditDocumentChecklistItemInput;
}>;


export type EditDocumentChecklistItemMutation = { __typename: 'Mutation', editDocumentChecklistItem: { __typename: 'EditDocumentChecklistItemResponse', documentChecklistItem: { __typename: 'DocumentChecklistItem', name: string } } };

export type RemoveDocumentChecklistItemMutationVariables = Exact<{
  id: Scalars['Int'];
}>;


export type RemoveDocumentChecklistItemMutation = { __typename: 'Mutation', removeDocumentChecklistItem: { __typename: 'RemoveDocumentChecklistItemResponse', documentChecklistItem: { __typename: 'DocumentChecklistItem', name: string } } };

export type GetDocumentChecklistItemsQueryVariables = Exact<{
  documentChecklistItemListInput: DocumentChecklistItemListInput;
}>;


export type GetDocumentChecklistItemsQuery = { __typename: 'Query', documentChecklistItems: { __typename: 'DocumentChecklistItemListResponse', records: Array<{ __typename: 'DocumentChecklistItem', id: number, name: string, documentChecklistValues: Array<{ __typename: 'DocumentChecklistValue', documentChecklistItemId: number, checked: boolean, concreteTestSet: { __typename: 'ConcreteTestSet', testSetId: string | null, globalId: string, deleted: string | null, concreteMaterial: { __typename: 'ConcreteMaterial', globalId: string, placementType: string | null } | null } }>, documentChecklistItemToConcreteMaterials: Array<{ __typename: 'DocumentChecklistItemToConcreteMaterial', concreteMaterial: { __typename: 'ConcreteMaterial', globalId: string, placementType: string | null, deleted: string | null } }> }> } };

export type GetDocumentChecklistItemsMetadataQueryVariables = Exact<{
  globalId: Scalars['String'];
}>;


export type GetDocumentChecklistItemsMetadataQuery = { __typename: 'Query', project: { __typename: 'Project', concreteMaterials: Array<{ __typename: 'ConcreteMaterial', globalId: string, placementType: string | null }>, concreteTestSets: Array<{ __typename: 'ConcreteTestSet', globalId: string, testSetId: string | null, deleted: string | null, concreteMaterial: { __typename: 'ConcreteMaterial', placementType: string | null } | null, documentChecklistValues: Array<{ __typename: 'DocumentChecklistValue', checked: boolean, documentChecklistItem: { __typename: 'DocumentChecklistItem', id: number } }> }> } };

export type ConcreteNotificationsUserFragment = { __typename: 'User', id: string, displayName: string | null, mail: string, deleted: boolean, userGroups: Array<{ __typename: 'UserGroup', id: string }> };

export type ConcreteNotificationsRecipientsFragment = { __typename: 'Recipients', users: Array<{ __typename: 'User', id: string, displayName: string | null, mail: string, deleted: boolean, userGroups: Array<{ __typename: 'UserGroup', id: string }> }>, nonUserEmails: Array<{ __typename: 'NonUserEmail', id: number, label: string | null, description: string | null, address: string }> };

export type ProjectConcreteNotificationEventsQueryVariables = Exact<{
  globalId: Scalars['String'];
}>;


export type ProjectConcreteNotificationEventsQuery = { __typename: 'Query', project: { __typename: 'Project', concreteNotifications: Array<{ __typename: 'ConcreteNotification', notificationEventId: string, recipients: { __typename: 'ConcreteNotificationRecipients', every: { __typename: 'Recipients', users: Array<{ __typename: 'User', id: string, displayName: string | null, mail: string, deleted: boolean, userGroups: Array<{ __typename: 'UserGroup', id: string }> }>, nonUserEmails: Array<{ __typename: 'NonUserEmail', id: number, label: string | null, description: string | null, address: string }> } | null, byConcreteMaterial: Array<{ __typename: 'ByConcreteMaterial', concreteMaterial: { __typename: 'ConcreteMaterial', globalId: string }, recipients: { __typename: 'Recipients', users: Array<{ __typename: 'User', id: string, displayName: string | null, mail: string, deleted: boolean, userGroups: Array<{ __typename: 'UserGroup', id: string }> }>, nonUserEmails: Array<{ __typename: 'NonUserEmail', id: number, label: string | null, description: string | null, address: string }> } }>, byConcreteMixDesign: Array<{ __typename: 'ByConcreteMixDesign', concreteMixDesign: { __typename: 'ConcreteMixDesign', globalId: string }, recipients: { __typename: 'Recipients', users: Array<{ __typename: 'User', id: string, displayName: string | null, mail: string, deleted: boolean, userGroups: Array<{ __typename: 'UserGroup', id: string }> }>, nonUserEmails: Array<{ __typename: 'NonUserEmail', id: number, label: string | null, description: string | null, address: string }> } }> } }>, concreteMaterials: Array<{ __typename: 'ConcreteMaterial', globalId: string, shortName: string | null, placementType: string | null }>, concreteMixDesigns: Array<{ __typename: 'ConcreteMixDesign', globalId: string, mixDesignNumber: string | null }> } };

export type EditConcreteNotificationMutationVariables = Exact<{
  editConcreteNotificationInput: EditConcreteNotificationInput;
}>;


export type EditConcreteNotificationMutation = { __typename: 'Mutation', editConcreteNotification: { __typename: 'EditConcreteNotificationResponse', notification: { __typename: 'ConcreteNotification', notificationEvent: string } } };

export type EditLabTechMutationVariables = Exact<{
  input: EditLabTechInput;
}>;


export type EditLabTechMutation = { __typename: 'Mutation', editLabTech: { __typename: 'EditLabTechResponse', labTech: { __typename: 'LabTech', name: string } } };

export type LabTechsConcreteTestSetFragment = { __typename: 'ConcreteTestSet', deleted: string | null, globalId: string, testSetId: string | null };

export type LabTechsQueryVariables = Exact<{
  projectId: Scalars['String'];
}>;


export type LabTechsQuery = { __typename: 'Query', project: { __typename: 'Project', labTechs: Array<{ __typename: 'LabTech', name: string, id: number, user: { __typename: 'User', id: string, displayName: string | null, mail: string, deleted: boolean, userGroups: Array<{ __typename: 'UserGroup', id: string }> } | null, testingLabs: Array<{ __typename: 'TestingLab', name: string, id: number }>, concreteTestBreakDatas: Array<{ __typename: 'ConcreteTestBreakData', concreteTest: { __typename: 'ConcreteTest', concreteTestSet: { __typename: 'ConcreteTestSet', deleted: string | null, globalId: string, testSetId: string | null } | null } }>, concreteCoreBreakDatas: Array<{ __typename: 'ConcreteCoreBreakData', concreteCoreMeasurement: { __typename: 'ConcreteCoreMeasurement', concretePlacement: { __typename: 'ConcretePlacement', concreteTestSet: { __typename: 'ConcreteTestSet', deleted: string | null, globalId: string, testSetId: string | null } | null } | null } }> }> } };

export type CreateLabTechMutationVariables = Exact<{
  input: CreateLabTechInput;
}>;


export type CreateLabTechMutation = { __typename: 'Mutation', createLabTech: { __typename: 'CreateLabTechResponse', labTech: { __typename: 'LabTech', name: string } } };

export type RemoveLabTechMutationVariables = Exact<{
  id: Scalars['Int'];
}>;


export type RemoveLabTechMutation = { __typename: 'Mutation', removeLabTech: { __typename: 'RemoveLabTechResponse', labTech: { __typename: 'LabTech', name: string } } };

export type TestingLabsConcreteTestSetFragment = { __typename: 'ConcreteTestSet', deleted: string | null, globalId: string, testSetId: string | null };

export type TestingLabsQueryVariables = Exact<{
  projectId: Scalars['String'];
}>;


export type TestingLabsQuery = { __typename: 'Query', project: { __typename: 'Project', testingLabs: Array<{ __typename: 'TestingLab', name: string, id: number, concreteCoreBreakDatas: Array<{ __typename: 'ConcreteCoreBreakData', concreteCoreMeasurement: { __typename: 'ConcreteCoreMeasurement', concretePlacement: { __typename: 'ConcretePlacement', concreteTestSet: { __typename: 'ConcreteTestSet', deleted: string | null, globalId: string, testSetId: string | null } | null } | null } }>, concreteTestBreakDatas: Array<{ __typename: 'ConcreteTestBreakData', concreteTest: { __typename: 'ConcreteTest', concreteTestSet: { __typename: 'ConcreteTestSet', deleted: string | null, globalId: string, testSetId: string | null } | null } }>, labTechs: Array<{ __typename: 'LabTech', name: string, id: number, user: { __typename: 'User', id: string, displayName: string | null, mail: string, deleted: boolean, userGroups: Array<{ __typename: 'UserGroup', id: string }> } | null }> }> } };

export type CreateTestingLabMutationVariables = Exact<{
  input: CreateTestingLabInput;
}>;


export type CreateTestingLabMutation = { __typename: 'Mutation', createTestingLab: { __typename: 'CreateTestingLabResponse', testingLab: { __typename: 'TestingLab', name: string } } };

export type EditTestingLabMutationVariables = Exact<{
  input: EditTestingLabInput;
}>;


export type EditTestingLabMutation = { __typename: 'Mutation', editTestingLab: { __typename: 'EditTestingLabResponse', testingLab: { __typename: 'TestingLab', name: string } } };

export type RemoveTestingLabMutationVariables = Exact<{
  id: Scalars['Int'];
}>;


export type RemoveTestingLabMutation = { __typename: 'Mutation', removeTestingLab: { __typename: 'RemoveTestingLabResponse', testingLab: { __typename: 'TestingLab', name: string } } };

export type CreateCasQuickLinkMutationVariables = Exact<{
  input: CreateCasQuickLinkInput;
}>;


export type CreateCasQuickLinkMutation = { __typename: 'Mutation', createCASQuickLink: { __typename: 'CreateCASQuickLinkResponse', casQuickLink: { __typename: 'CASQuickLink', label: string } } };

export type EditCasQuickLinkMutationVariables = Exact<{
  input: EditCasQuickLinkInput;
}>;


export type EditCasQuickLinkMutation = { __typename: 'Mutation', editCASQuickLink: { __typename: 'EditCASQuickLinkResponse', casQuickLink: { __typename: 'CASQuickLink', label: string } } };

export type GetCasQuickLinksQueryVariables = Exact<{
  input: CasQuickLinkListInput;
}>;


export type GetCasQuickLinksQuery = { __typename: 'Query', casQuickLinks: { __typename: 'CASQuickLinkListResponse', records: Array<{ __typename: 'CASQuickLink', id: string, label: string, href: string | null, description: string | null, deleted: boolean, deletedDate: string | null, deletedUser: string | null }> } };

export type RestoreCasQuickLinkMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type RestoreCasQuickLinkMutation = { __typename: 'Mutation', restoreCASQuickLink: { __typename: 'RestoreCASQuickLinkResponse', casQuickLink: { __typename: 'CASQuickLink', label: string } } };

export type SoftRemoveCasQuickLinkMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type SoftRemoveCasQuickLinkMutation = { __typename: 'Mutation', softRemoveCASQuickLink: { __typename: 'SoftRemoveCASQuickLinkResponse', casQuickLink: { __typename: 'CASQuickLink', label: string } } };

export type CasDispositionTypesQueryVariables = Exact<{
  projectId: Scalars['String'];
}>;


export type CasDispositionTypesQuery = { __typename: 'Query', casDispositionTypes: { __typename: 'CASDispositionTypeListResponse', records: Array<{ __typename: 'CASDispositionType', id: string, name: string, description: string | null, deleted: boolean, deletedDate: string | null, deletedUser: string | null, requiresComments: boolean, submittals: Array<{ __typename: 'ConstructionAdminSubmittal', id: string, deleted: boolean, packageNumber: string, packageName: string }> }> } };

export type EditCasDispositionTypeMutationVariables = Exact<{
  input: EditCasDispositionTypeInput;
}>;


export type EditCasDispositionTypeMutation = { __typename: 'Mutation', editCASDispositionType: { __typename: 'EditCASDispositionTypeResponse', dispositionType: { __typename: 'CASDispositionType', name: string } } };

export type CreateCasDispositionTypeMutationVariables = Exact<{
  input: CreateCasDispositionTypeInput;
}>;


export type CreateCasDispositionTypeMutation = { __typename: 'Mutation', createCASDispositionType: { __typename: 'CreateCASDispositionTypeResponse', dispositionType: { __typename: 'CASDispositionType', name: string } } };

export type RemoveCasDispositionTypeMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type RemoveCasDispositionTypeMutation = { __typename: 'Mutation', softRemoveCASDispositionType: { __typename: 'SoftRemoveCASDispositionTypeResponse', dispositionType: { __typename: 'CASDispositionType', name: string } } };

export type RestoreCasDispositionTypeMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type RestoreCasDispositionTypeMutation = { __typename: 'Mutation', restoreCASDispositionType: { __typename: 'RestoreCASDispositionTypeResponse', dispositionType: { __typename: 'CASDispositionType', name: string } } };

export type CasNotificationsUserFragment = { __typename: 'User', id: string, displayName: string | null, mail: string, deleted: boolean, userGroups: Array<{ __typename: 'UserGroup', id: string }> };

export type CasNotificationsRecipientsFragment = { __typename: 'Recipients', users: Array<{ __typename: 'User', id: string, displayName: string | null, mail: string, deleted: boolean, userGroups: Array<{ __typename: 'UserGroup', id: string }> }>, nonUserEmails: Array<{ __typename: 'NonUserEmail', id: number, label: string | null, description: string | null, address: string }> };

export type CasNotificationsQueryVariables = Exact<{
  projectId: Scalars['String'];
}>;


export type CasNotificationsQuery = { __typename: 'Query', project: { __typename: 'Project', casRoutingGroups: Array<{ __typename: 'CASRoutingGroup', name: string, id: string, description: string | null, users: Array<{ __typename: 'User', id: string, displayName: string | null, mail: string, deleted: boolean, userGroups: Array<{ __typename: 'UserGroup', id: string }> }> }>, casNotifications: Array<{ __typename: 'CASNotification', notificationEventId: string, recipients: { __typename: 'CASNotificationRecipients', every: { __typename: 'Recipients', users: Array<{ __typename: 'User', id: string, displayName: string | null, mail: string, deleted: boolean, userGroups: Array<{ __typename: 'UserGroup', id: string }> }>, nonUserEmails: Array<{ __typename: 'NonUserEmail', id: number, label: string | null, description: string | null, address: string }> } | null, byRoutingGroup: Array<{ __typename: 'ByCASRoutingGroup', routingGroup: { __typename: 'CASRoutingGroup', id: string, name: string }, recipients: { __typename: 'Recipients', users: Array<{ __typename: 'User', id: string, displayName: string | null, mail: string, deleted: boolean, userGroups: Array<{ __typename: 'UserGroup', id: string }> }>, nonUserEmails: Array<{ __typename: 'NonUserEmail', id: number, label: string | null, description: string | null, address: string }> } }> }, settings: { __typename: 'CASNotificationSettingsJSON', notificationThresholdDay: number, frequency: { __typename: 'DailyFrequency', next: string, previous: string, hour: number, minute: number } } | null }> } };

export type EditCasNotificationMutationVariables = Exact<{
  input: EditCasNotificationInput;
}>;


export type EditCasNotificationMutation = { __typename: 'Mutation', editCASNotification: { __typename: 'EditCASNotificationResponse', notification: { __typename: 'CASNotification', notificationEvent: string } } };

export type CreateCasRoutingGroupMutationVariables = Exact<{
  createCASRoutingGroupInput: CreateCasRoutingGroupInput;
}>;


export type CreateCasRoutingGroupMutation = { __typename: 'Mutation', createCASRoutingGroup: { __typename: 'CreateCASRoutingGroupResponse', routingGroup: { __typename: 'CASRoutingGroup', name: string } } };

export type EditCasRoutingGroupMutationVariables = Exact<{
  editCASRoutingGroupInput: EditCasRoutingGroupInput;
}>;


export type EditCasRoutingGroupMutation = { __typename: 'Mutation', editCASRoutingGroup: { __typename: 'EditCASRoutingGroupResponse', routingGroup: { __typename: 'CASRoutingGroup', name: string } } };

export type SoftRemoveCasRoutingGroupMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type SoftRemoveCasRoutingGroupMutation = { __typename: 'Mutation', softRemoveCASRoutingGroup: { __typename: 'SoftRemoveCASRoutingGroupResponse', routingGroup: { __typename: 'CASRoutingGroup', name: string } } };

export type RestoreCasRoutingGroupMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type RestoreCasRoutingGroupMutation = { __typename: 'Mutation', restoreCASRoutingGroup: { __typename: 'RestoreCASRoutingGroupResponse', routingGroup: { __typename: 'CASRoutingGroup', name: string } } };

export type GetCasRoutingGroupsQueryVariables = Exact<{
  casRoutingGroupListInput: CasRoutingGroupListInput;
}>;


export type GetCasRoutingGroupsQuery = { __typename: 'Query', casRoutingGroups: { __typename: 'CASRoutingGroupListResponse', records: Array<{ __typename: 'CASRoutingGroup', id: string, name: string, description: string | null, deleted: boolean, deletedDate: string | null, deletedUser: string | null, casToCASRoutingGroups: Array<{ __typename: 'CASToCASRoutingGroup', submittal: { __typename: 'ConstructionAdminSubmittal', id: string, packageNumber: string, packageName: string, deleted: boolean } }>, users: Array<{ __typename: 'User', id: string, displayName: string | null, mail: string, deleted: boolean, userGroups: Array<{ __typename: 'UserGroup', id: string }> }> }> } };

export type EditCaSubmittalMutationVariables = Exact<{
  input: EditConstructionAdminSubmittalInput;
}>;


export type EditCaSubmittalMutation = { __typename: 'Mutation', editConstructionAdminSubmittal: { __typename: 'EditConstructionAdminSubmittalResponse', submittal: { __typename: 'ConstructionAdminSubmittal', sharePointFolderName: string } } };

export type GetCasMetadataQueryVariables = Exact<{
  globalId: Scalars['String'];
}>;


export type GetCasMetadataQuery = { __typename: 'Query', project: { __typename: 'Project', casRoutingGroups: Array<{ __typename: 'CASRoutingGroup', id: string, name: string, description: string | null }>, casTypes: Array<{ __typename: 'CASType', id: string, name: string, description: string | null }>, casSubtypes: Array<{ __typename: 'CASSubtype', id: string, name: string, description: string | null }>, casDispositionTypes: Array<{ __typename: 'CASDispositionType', id: string, name: string, description: string | null, requiresComments: boolean }>, casQuickLinks: Array<{ __typename: 'CASQuickLink', id: string, label: string, href: string | null, description: string | null }> } };

export type GetCaSubmittalsQueryVariables = Exact<{
  input: ConstructionAdminSubmittalListInput;
  projectId: Scalars['String'];
}>;


export type GetCaSubmittalsQuery = { __typename: 'Query', constructionAdminSubmittals: { __typename: 'ConstructionAdminSubmittalListResponse', records: Array<{ __typename: 'ConstructionAdminSubmittal', id: string, previousId: number | null, statusId: string, packageName: string, packageNumber: string, sharePointFolderName: string, sharePointResourceId: string | null, sharePointResourceWebUrl: string | null, packetSharePointResourceId: string | null, packetSharePointResourceName: string | null, packetSharePointResourceWebUrl: string | null, quantity: number, units: string, requestedReviewDate: string, contractualReviewDate: string | null, dispositionDate: string | null, projectId: string, createdDate: string, deleted: boolean, deletedUser: string | null, deletedDate: string | null, type: { __typename: 'CASType', id: string, name: string, description: string | null, deleted: boolean }, subtype: { __typename: 'CASSubtype', id: string, name: string, description: string | null, deleted: boolean } | null, submittedBy: { __typename: 'User', id: string, displayName: string | null, mail: string, deleted: boolean, userGroups: Array<{ __typename: 'UserGroup', id: string }> }, casToCASRoutingGroups: Array<{ __typename: 'CASToCASRoutingGroup', accepted: boolean, acceptedDate: string | null, routingGroup: { __typename: 'CASRoutingGroup', id: string, name: string, description: string | null, users: Array<{ __typename: 'User', id: string }> }, acceptedBy: { __typename: 'User', id: string, mail: string } | null }>, dispositionType: { __typename: 'CASDispositionType', id: string, name: string, description: string | null, deleted: boolean } | null, dispositionBy: { __typename: 'User', id: string, displayName: string | null, mail: string, deleted: boolean, userGroups: Array<{ __typename: 'UserGroup', id: string }> } | null, comments: Array<{ __typename: 'CASComment', text: string, createdDate: string, user: { __typename: 'User', mail: string } }>, casToPayItemNoGeometries: Array<{ __typename: 'CASToPayItemNoGeometry', payItem: { __typename: 'PayItemNoGeometry', globalId: string, deleted: boolean, label: string } }>, externalLinks: Array<{ __typename: 'ExternalLink', label: string, href: string }>, customFields: { __typename: 'CustomFields', booleanValues: Array<{ __typename: 'BooleanCustomFieldValue', customFieldId: string, value: boolean, customField: { __typename: 'CustomField', name: string, description: string | null } }>, dateValues: Array<{ __typename: 'DateCustomFieldValue', customFieldId: string, value: string | null, customField: { __typename: 'CustomField', name: string, description: string | null } }>, entityValues: Array<{ __typename: 'EntityCustomFieldValues', customFieldId: string, customField: { __typename: 'CustomField', name: string, description: string | null }, entities: Array<{ __typename: 'EntityCustomFieldValue', recordId: string | null, href: string | null, entityId: string, label: string | null }> }>, listValues: { __typename: 'ListValues', singles: Array<{ __typename: 'ListCustomFieldValue', customFieldId: string, customField: { __typename: 'CustomField', name: string, description: string | null }, customListItem: { __typename: 'CustomListItem', id: string, deleted: boolean, value: string } | null }>, multiples: Array<{ __typename: 'ListCustomFieldValues', customFieldId: string, customField: { __typename: 'CustomField', name: string, description: string | null }, customListItems: Array<{ __typename: 'CustomListItem', id: string, deleted: boolean, value: string }> }>, checkboxes: Array<{ __typename: 'BooleanListCustomFieldValues', customFieldId: string, customField: { __typename: 'CustomField', name: string, description: string | null }, booleans: Array<{ __typename: 'BooleanListCustomFieldValue', customListItemId: string, checked: boolean, customListItem: { __typename: 'CustomListItem', value: string } }> }> }, numberValues: Array<{ __typename: 'NumberCustomFieldValue', customFieldId: string, value: number | null, customField: { __typename: 'CustomField', name: string, description: string | null } }>, reportValues: Array<{ __typename: 'ReportCustomFieldValues', customFieldId: string, customField: { __typename: 'CustomField', name: string, description: string | null }, reports: Array<{ __typename: 'ReportCustomFieldValue', recordId: string | null, reportId: string, href: string | null, label: string | null }> }>, textValues: Array<{ __typename: 'TextCustomFieldValue', customFieldId: string, value: string | null, customField: { __typename: 'CustomField', name: string, description: string | null } }> } }> } };

export type GroupReviewCasMutationVariables = Exact<{
  input: GroupReviewConstructionAdminSubmittalInput;
}>;


export type GroupReviewCasMutation = { __typename: 'Mutation', groupReviewConstructionAdminSubmittal: { __typename: 'GroupReviewConstructionAdminSubmittalResponse', submittal: { __typename: 'ConstructionAdminSubmittal', sharePointFolderName: string, statusId: string } } };

export type ReReviewCasMutationVariables = Exact<{
  input: ReReviewConstructionAdminSubmittalInput;
}>;


export type ReReviewCasMutation = { __typename: 'Mutation', reReviewConstructionAdminSubmittal: { __typename: 'REReviewConstructionAdminSubmittalResponse', submittal: { __typename: 'ConstructionAdminSubmittal', sharePointFolderName: string, statusId: string } } };

export type RequestCasRevisionsMutationVariables = Exact<{
  input: RequestConstructionAdminSubmittalRevisionsInput;
}>;


export type RequestCasRevisionsMutation = { __typename: 'Mutation', requestConstructionAdminSubmittalRevisions: { __typename: 'RequestConstructionAdminSubmittalRevisionsResponse', submittal: { __typename: 'ConstructionAdminSubmittal', sharePointFolderName: string, statusId: string } } };

export type ReviseCaSubmittalMutationVariables = Exact<{
  input: ReviseConstructionAdminSubmittalInput;
}>;


export type ReviseCaSubmittalMutation = { __typename: 'Mutation', reviseConstructionAdminSubmittal: { __typename: 'ReviseConstructionAdminSubmittalResponse', submittal: { __typename: 'ConstructionAdminSubmittal', sharePointFolderName: string, statusId: string } } };

export type RouteCasToGroupReviewMutationVariables = Exact<{
  input: RouteConstructionAdminSubmittalToGroupReviewInput;
}>;


export type RouteCasToGroupReviewMutation = { __typename: 'Mutation', routeConstructionAdminSubmittalToGroupReview: { __typename: 'RouteConstructionAdminSubmittalToGroupReviewResponse', submittal: { __typename: 'ConstructionAdminSubmittal', sharePointFolderName: string, statusId: string } } };

export type RouteCasToReReviewMutationVariables = Exact<{
  input: RouteConstructionAdminSubmittalToReReviewInput;
}>;


export type RouteCasToReReviewMutation = { __typename: 'Mutation', routeConstructionAdminSubmittalToREReview: { __typename: 'RouteConstructionAdminSubmittalToREReviewResponse', submittal: { __typename: 'ConstructionAdminSubmittal', sharePointFolderName: string, statusId: string } } };

export type GetCasSharePointResourcesQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetCasSharePointResourcesQuery = { __typename: 'Query', constructionAdminSubmittal: { __typename: 'ConstructionAdminSubmittal', packetSharePointResourceId: string | null, sharePointResource: { __typename: 'SharePointResource', sharePointResources: Array<{ __typename: 'SharePointResource', id: string, name: string | null, webUrl: string | null }> } | null } };

export type RevertCasMutationVariables = Exact<{
  input: RevertConstructionAdminSubmittalInput;
}>;


export type RevertCasMutation = { __typename: 'Mutation', revertConstructionAdminSubmittal: { __typename: 'RevertConstructionAdminSubmittalResponse', submittal: { __typename: 'ConstructionAdminSubmittal', sharePointFolderName: string, statusId: string } } };

export type SetCasToCasRoutingGroupMutationVariables = Exact<{
  input: SetCasToCasRoutingGroupInput;
}>;


export type SetCasToCasRoutingGroupMutation = { __typename: 'Mutation', setCASToCASRoutingGroup: { __typename: 'SetCASToCASRoutingGroupResponse', accepted: boolean, routingGroup: { __typename: 'CASRoutingGroup', name: string } } };

export type CreateCaSubmittalMutationVariables = Exact<{
  input: CreateConstructionAdminSubmittalInput;
}>;


export type CreateCaSubmittalMutation = { __typename: 'Mutation', createConstructionAdminSubmittal: { __typename: 'CreateConstructionAdminSubmittalResponse', submittal: { __typename: 'ConstructionAdminSubmittal', sharePointFolderName: string } } };

export type EditCasSharePointReferenceMutationVariables = Exact<{
  input: EditConstructionAdminSubmittalSharePointReferenceInput;
}>;


export type EditCasSharePointReferenceMutation = { __typename: 'Mutation', editConstructionAdminSubmittalSharePointReference: { __typename: 'ConstructionAdminSubmittal', sharePointFolderName: string } };

export type CreateCasCommentMutationVariables = Exact<{
  input: CreateCasCommentInput;
}>;


export type CreateCasCommentMutation = { __typename: 'Mutation', createCASComment: { __typename: 'CreateCASCommentResponse', comment: { __typename: 'CASComment', id: string } } };

export type SoftRemoveCaSubmittalMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type SoftRemoveCaSubmittalMutation = { __typename: 'Mutation', softRemoveConstructionAdminSubmittal: { __typename: 'SoftRemoveConstructionAdminSubmittalResponse', submittal: { __typename: 'ConstructionAdminSubmittal', sharePointFolderName: string } } };

export type RestoreCaSubmittalMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type RestoreCaSubmittalMutation = { __typename: 'Mutation', restoreConstructionAdminSubmittal: { __typename: 'RestoreConstructionAdminSubmittalResponse', submittal: { __typename: 'ConstructionAdminSubmittal', sharePointFolderName: string } } };

export type CreateCasSubtypeMutationVariables = Exact<{
  createCASSubtypeInput: CreateCasSubtypeInput;
}>;


export type CreateCasSubtypeMutation = { __typename: 'Mutation', createCASSubtype: { __typename: 'CreateCASSubtypeResponse', subtype: { __typename: 'CASSubtype', name: string } } };

export type EditCasSubtypeMutationVariables = Exact<{
  editCASSubtypeInput: EditCasSubtypeInput;
}>;


export type EditCasSubtypeMutation = { __typename: 'Mutation', editCASSubtype: { __typename: 'EditCASSubtypeResponse', subtype: { __typename: 'CASSubtype', name: string } } };

export type SoftRemoveCasSubtypeMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type SoftRemoveCasSubtypeMutation = { __typename: 'Mutation', softRemoveCASSubtype: { __typename: 'SoftRemoveCASSubtypeResponse', subtype: { __typename: 'CASSubtype', name: string } } };

export type RestoreCasSubtypeMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type RestoreCasSubtypeMutation = { __typename: 'Mutation', restoreCASSubtype: { __typename: 'RestoreCASSubtypeResponse', subtype: { __typename: 'CASSubtype', name: string } } };

export type GetCasSubtypesQueryVariables = Exact<{
  casSubtypeListInput: CasSubtypeListInput;
}>;


export type GetCasSubtypesQuery = { __typename: 'Query', casSubtypes: { __typename: 'CASSubtypeListResponse', records: Array<{ __typename: 'CASSubtype', id: string, name: string, description: string | null, deleted: boolean, deletedDate: string | null, deletedUser: string | null, submittals: Array<{ __typename: 'ConstructionAdminSubmittal', id: string, packageName: string, packageNumber: string, deleted: boolean }> }> } };

export type GetCasTypesQueryVariables = Exact<{
  casTypeListInput: CasTypeListInput;
}>;


export type GetCasTypesQuery = { __typename: 'Query', casTypes: { __typename: 'CASTypeListResponse', records: Array<{ __typename: 'CASType', id: string, name: string, description: string | null, deleted: boolean, deletedDate: string | null, deletedUser: string | null, submittals: Array<{ __typename: 'ConstructionAdminSubmittal', id: string, packageName: string, packageNumber: string, deleted: boolean }> }> } };

export type CreateCasTypeMutationVariables = Exact<{
  createCASTypeInput: CreateCasTypeInput;
}>;


export type CreateCasTypeMutation = { __typename: 'Mutation', createCASType: { __typename: 'CreateCASTypeResponse', type: { __typename: 'CASType', name: string } } };

export type EditCasTypeMutationVariables = Exact<{
  editCASTypeInput: EditCasTypeInput;
}>;


export type EditCasTypeMutation = { __typename: 'Mutation', editCASType: { __typename: 'EditCASTypeResponse', type: { __typename: 'CASType', name: string } } };

export type SoftRemoveCasTypeMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type SoftRemoveCasTypeMutation = { __typename: 'Mutation', softRemoveCASType: { __typename: 'SoftRemoveCASTypeResponse', type: { __typename: 'CASType', name: string } } };

export type RestoreCasTypeMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type RestoreCasTypeMutation = { __typename: 'Mutation', restoreCASType: { __typename: 'RestoreCASTypeResponse', type: { __typename: 'CASType', name: string } } };

export type CreateDsActionMutationVariables = Exact<{
  input: CreateDsActionInput;
}>;


export type CreateDsActionMutation = { __typename: 'Mutation', createDSAction: { __typename: 'CreateDSActionResponse', action: { __typename: 'DSAction', name: string } } };

export type EditDsActionMutationVariables = Exact<{
  input: EditDsActionInput;
}>;


export type EditDsActionMutation = { __typename: 'Mutation', editDSAction: { __typename: 'EditDSActionResponse', action: { __typename: 'DSAction', name: string } } };

export type SoftRemoveDsActionMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type SoftRemoveDsActionMutation = { __typename: 'Mutation', softRemoveDSAction: { __typename: 'SoftRemoveDSActionResponse', action: { __typename: 'DSAction', name: string } } };

export type RestoreDsActionMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type RestoreDsActionMutation = { __typename: 'Mutation', restoreDSAction: { __typename: 'RestoreDSActionResponse', action: { __typename: 'DSAction', name: string } } };

export type GetDsActionsQueryVariables = Exact<{
  dsActionListInput: DsActionListInput;
}>;


export type GetDsActionsQuery = { __typename: 'Query', dsActions: { __typename: 'DSActionListResponse', records: Array<{ __typename: 'DSAction', id: string, name: string, description: string | null, createdDate: string, lastEditedDate: string, deleted: boolean, deletedUser: string | null, deletedDate: string | null, submittals: Array<{ __typename: 'DesignSubmittal', id: string, packageNumber: string, packageName: string, deleted: boolean }> }> } };

export type CreateDsQuickLinkMutationVariables = Exact<{
  input: CreateDsQuickLinkInput;
}>;


export type CreateDsQuickLinkMutation = { __typename: 'Mutation', createDSQuickLink: { __typename: 'CreateDSQuickLinkResponse', dsQuickLink: { __typename: 'DSQuickLink', label: string } } };

export type EditDsQuickLinkMutationVariables = Exact<{
  input: EditDsQuickLinkInput;
}>;


export type EditDsQuickLinkMutation = { __typename: 'Mutation', editDSQuickLink: { __typename: 'EditDSQuickLinkResponse', dsQuickLink: { __typename: 'DSQuickLink', label: string } } };

export type GetDsQuickLinksQueryVariables = Exact<{
  input: DsQuickLinkListInput;
}>;


export type GetDsQuickLinksQuery = { __typename: 'Query', dsQuickLinks: { __typename: 'DSQuickLinkListResponse', records: Array<{ __typename: 'DSQuickLink', id: string, label: string, href: string | null, description: string | null, deleted: boolean, deletedDate: string | null, deletedUser: string | null }> } };

export type RestoreDsQuickLinkMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type RestoreDsQuickLinkMutation = { __typename: 'Mutation', restoreDSQuickLink: { __typename: 'RestoreDSQuickLinkResponse', dsQuickLink: { __typename: 'DSQuickLink', label: string } } };

export type SoftRemoveDsQuickLinkMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type SoftRemoveDsQuickLinkMutation = { __typename: 'Mutation', softRemoveDSQuickLink: { __typename: 'SoftRemoveDSQuickLinkResponse', dsQuickLink: { __typename: 'DSQuickLink', label: string } } };

export type GiveDesignSubmittalDispositionMutationVariables = Exact<{
  giveDesignSubmittalDispositionInput: GiveDesignSubmittalDispositionInput;
}>;


export type GiveDesignSubmittalDispositionMutation = { __typename: 'Mutation', giveDesignSubmittalDisposition: { __typename: 'GiveDesignSubmittalDispositionResponse', designSubmittal: { __typename: 'DesignSubmittal', sharePointFolderName: string } } };

export type RouteDesignSubmittalMutationVariables = Exact<{
  routeDesignSubmittalInput: RouteDesignSubmittalInput;
}>;


export type RouteDesignSubmittalMutation = { __typename: 'Mutation', routeDesignSubmittal: { __typename: 'RouteDesignSubmittalResponse', designSubmittal: { __typename: 'DesignSubmittal', sharePointFolderName: string } } };

export type RevertDesignSubmittalMutationVariables = Exact<{
  revertDesignSubmittalInput: RevertDesignSubmittalInput;
}>;


export type RevertDesignSubmittalMutation = { __typename: 'Mutation', revertDesignSubmittal: { __typename: 'RevertDesignSubmittalResponse', designSubmittal: { __typename: 'DesignSubmittal', sharePointFolderName: string } } };

export type SetDsToDsDisciplineMutationVariables = Exact<{
  input: SetDsToDsDisciplineInput;
}>;


export type SetDsToDsDisciplineMutation = { __typename: 'Mutation', setDSToDSDiscipline: { __typename: 'SetDSToDSDisciplineResponse', discipline: { __typename: 'DSDiscipline', name: string } } };

export type CreateDesignSubmittalMutationVariables = Exact<{
  input: CreateDesignSubmittalInput;
}>;


export type CreateDesignSubmittalMutation = { __typename: 'Mutation', createDesignSubmittal: { __typename: 'CreateDesignSubmittalResponse', designSubmittal: { __typename: 'DesignSubmittal', sharePointFolderName: string } } };

export type LockUnlockDesignSubmittalMutationVariables = Exact<{
  setSharePointResourcePermissionsInput: SetSharePointResourcePermissionsInput;
}>;


export type LockUnlockDesignSubmittalMutation = { __typename: 'Mutation', setSharePointResourcePermissions: { __typename: 'SetSharePointResourcePermissionsResponse', user: { __typename: 'User', mail: string, displayName: string | null }, designSubmittal: { __typename: 'DesignSubmittal', status: string } | null } };

export type EditDesignSubmittalSharePointReferenceMutationVariables = Exact<{
  input: EditDesignSubmittalSharePointReferenceInput;
}>;


export type EditDesignSubmittalSharePointReferenceMutation = { __typename: 'Mutation', editDesignSubmittalSharePointReference: { __typename: 'DesignSubmittal', packageName: string, packageNumber: string, sharePointFolderName: string, sharePointResourceId: string | null, sharePointResourceWebUrl: string | null } };

export type CreateDesignSubmittalCommentMutationVariables = Exact<{
  input: CreateDsCommentInput;
}>;


export type CreateDesignSubmittalCommentMutation = { __typename: 'Mutation', createDSComment: { __typename: 'CreateDSCommentResponse', comment: { __typename: 'DSComment', id: string } } };

export type SoftRemoveDesignSubmittalMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type SoftRemoveDesignSubmittalMutation = { __typename: 'Mutation', softRemoveDesignSubmittal: { __typename: 'SoftRemoveDesignSubmittalResponse', designSubmittal: { __typename: 'DesignSubmittal', sharePointFolderName: string } } };

export type RestoreDesignSubmittalMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type RestoreDesignSubmittalMutation = { __typename: 'Mutation', restoreDesignSubmittal: { __typename: 'RestoreDesignSubmittalResponse', designSubmittal: { __typename: 'DesignSubmittal', sharePointFolderName: string } } };

export type EditDesignSubmittalMutationVariables = Exact<{
  input: EditDesignSubmittalInput;
}>;


export type EditDesignSubmittalMutation = { __typename: 'Mutation', editDesignSubmittal: { __typename: 'EditDesignSubmittalResponse', designSubmittal: { __typename: 'DesignSubmittal', sharePointFolderName: string } } };

export type GetDesignSubmittalsQueryVariables = Exact<{
  input: DesignSubmittalListInput;
  projectId: Scalars['String'];
}>;


export type GetDesignSubmittalsQuery = { __typename: 'Query', designSubmittals: { __typename: 'DesignSubmittalListResponse', records: Array<{ __typename: 'DesignSubmittal', contractDueDate: string | null, sharePointFolderName: string, sharePointResourceId: string | null, sharePointResourceWebUrl: string | null, createdDate: string, deleted: boolean, deletedDate: string | null, deletedUser: string | null, disposition: string | null, dispositionById: string | null, dispositionDate: string | null, id: string, packageName: string, packageNumber: string, projectId: string, requestedActionDate: string, status: string, submittedById: string, submittedDate: string, dispositionBy: { __typename: 'User', id: string, displayName: string | null, mail: string, deleted: boolean, userGroups: Array<{ __typename: 'UserGroup', id: string }> } | null, externalLinks: Array<{ __typename: 'ExternalLink', href: string, label: string }>, project: { __typename: 'Project', projectName: string | null }, submittedBy: { __typename: 'User', id: string, displayName: string | null, mail: string, deleted: boolean, userGroups: Array<{ __typename: 'UserGroup', id: string }> }, type: { __typename: 'DSType', name: string, id: string, description: string | null, deleted: boolean }, dsToPayItemNoGeometries: Array<{ __typename: 'DSToPayItemNoGeometry', payItem: { __typename: 'PayItemNoGeometry', globalId: string, deleted: boolean, label: string } }>, comments: Array<{ __typename: 'DSComment', text: string, createdDate: string, id: string, user: { __typename: 'User', displayName: string | null, mail: string, id: string } }>, dsToDSDisciplines: Array<{ __typename: 'DSToDSDiscipline', accepted: boolean, acceptedDate: string | null, acceptedBy: { __typename: 'User', id: string, displayName: string | null, mail: string } | null, discipline: { __typename: 'DSDiscipline', id: string, name: string, description: string | null, deleted: boolean, users: Array<{ __typename: 'User', id: string, mail: string, displayName: string | null }> } }>, actions: Array<{ __typename: 'DSAction', id: string, name: string, description: string | null, deleted: boolean }>, organization: { __typename: 'DSOrganization', id: string, name: string, description: string | null, deleted: boolean }, fieldDesignChanges: Array<{ __typename: 'FieldDesignChange', id: string, formattedNumber: string, deleted: boolean }>, customFields: { __typename: 'CustomFields', booleanValues: Array<{ __typename: 'BooleanCustomFieldValue', customFieldId: string, value: boolean, customField: { __typename: 'CustomField', name: string, description: string | null } }>, dateValues: Array<{ __typename: 'DateCustomFieldValue', customFieldId: string, value: string | null, customField: { __typename: 'CustomField', name: string, description: string | null } }>, entityValues: Array<{ __typename: 'EntityCustomFieldValues', customFieldId: string, customField: { __typename: 'CustomField', name: string, description: string | null }, entities: Array<{ __typename: 'EntityCustomFieldValue', recordId: string | null, href: string | null, entityId: string, label: string | null }> }>, listValues: { __typename: 'ListValues', singles: Array<{ __typename: 'ListCustomFieldValue', customFieldId: string, customField: { __typename: 'CustomField', name: string, description: string | null }, customListItem: { __typename: 'CustomListItem', id: string, deleted: boolean, value: string } | null }>, multiples: Array<{ __typename: 'ListCustomFieldValues', customFieldId: string, customField: { __typename: 'CustomField', name: string, description: string | null }, customListItems: Array<{ __typename: 'CustomListItem', id: string, deleted: boolean, value: string }> }>, checkboxes: Array<{ __typename: 'BooleanListCustomFieldValues', customFieldId: string, customField: { __typename: 'CustomField', name: string, description: string | null }, booleans: Array<{ __typename: 'BooleanListCustomFieldValue', customListItemId: string, checked: boolean, customListItem: { __typename: 'CustomListItem', value: string } }> }> }, numberValues: Array<{ __typename: 'NumberCustomFieldValue', customFieldId: string, value: number | null, customField: { __typename: 'CustomField', name: string, description: string | null } }>, reportValues: Array<{ __typename: 'ReportCustomFieldValues', customFieldId: string, customField: { __typename: 'CustomField', name: string, description: string | null }, reports: Array<{ __typename: 'ReportCustomFieldValue', recordId: string | null, reportId: string, href: string | null, label: string | null }> }>, textValues: Array<{ __typename: 'TextCustomFieldValue', customFieldId: string, value: string | null, customField: { __typename: 'CustomField', name: string, description: string | null } }> } }> } };

export type GetDesignSubmittalsMetadataQueryVariables = Exact<{
  globalId: Scalars['String'];
}>;


export type GetDesignSubmittalsMetadataQuery = { __typename: 'Query', project: { __typename: 'Project', dsActions: Array<{ __typename: 'DSAction', id: string, name: string, description: string | null }>, fieldDesignChanges: Array<{ __typename: 'FieldDesignChange', id: string, formattedNumber: string }>, dsOrganizations: Array<{ __typename: 'DSOrganization', id: string, name: string, description: string | null }>, dsDisciplines: Array<{ __typename: 'DSDiscipline', id: string, name: string, description: string | null }>, dsTypes: Array<{ __typename: 'DSType', id: string, name: string, description: string | null }>, dsQuickLinks: Array<{ __typename: 'DSQuickLink', id: string, label: string, href: string | null, description: string | null }> } };

export type CreateDsDisciplineMutationVariables = Exact<{
  createDsDisciplineInput: CreateDsDisciplineInput;
}>;


export type CreateDsDisciplineMutation = { __typename: 'Mutation', createDSDiscipline: { __typename: 'CreateDSDisciplineResponse', discipline: { __typename: 'DSDiscipline', name: string } } };

export type EditDsDisciplineMutationVariables = Exact<{
  editDsDisciplineInput: EditDsDisciplineInput;
}>;


export type EditDsDisciplineMutation = { __typename: 'Mutation', editDSDiscipline: { __typename: 'EditDSDisciplineResponse', discipline: { __typename: 'DSDiscipline', name: string } } };

export type SoftRemoveDsDisciplineMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type SoftRemoveDsDisciplineMutation = { __typename: 'Mutation', softRemoveDSDiscipline: { __typename: 'SoftRemoveDSDisciplineResponse', discipline: { __typename: 'DSDiscipline', name: string } } };

export type RestoreDsDisciplineMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type RestoreDsDisciplineMutation = { __typename: 'Mutation', restoreDSDiscipline: { __typename: 'RestoreDSDisciplineResponse', discipline: { __typename: 'DSDiscipline', name: string } } };

export type GetDsDisciplinesQueryVariables = Exact<{
  dsDisciplineListInput: DsDisciplineListInput;
}>;


export type GetDsDisciplinesQuery = { __typename: 'Query', dsDisciplines: { __typename: 'DSDisciplineListResponse', records: Array<{ __typename: 'DSDiscipline', id: string, name: string, description: string | null, deleted: boolean, deletedUser: string | null, deletedDate: string | null, dsToDSDisciplines: Array<{ __typename: 'DSToDSDiscipline', submittal: { __typename: 'DesignSubmittal', id: string, packageNumber: string, packageName: string, deleted: boolean } }>, users: Array<{ __typename: 'User', id: string, displayName: string | null, mail: string, deleted: boolean, userGroups: Array<{ __typename: 'UserGroup', id: string }> }> }> } };

export type DsNotificationsUserFragment = { __typename: 'User', id: string, displayName: string | null, mail: string, deleted: boolean, userGroups: Array<{ __typename: 'UserGroup', id: string }> };

export type DsNotificationsRecipientsFragment = { __typename: 'Recipients', users: Array<{ __typename: 'User', id: string, displayName: string | null, mail: string, deleted: boolean, userGroups: Array<{ __typename: 'UserGroup', id: string }> }>, nonUserEmails: Array<{ __typename: 'NonUserEmail', id: number, label: string | null, description: string | null, address: string }> };

export type ProjectDsNotificationEventsQueryVariables = Exact<{
  globalId: Scalars['String'];
}>;


export type ProjectDsNotificationEventsQuery = { __typename: 'Query', project: { __typename: 'Project', dsNotifications: Array<{ __typename: 'DSNotification', notificationEventId: string, recipients: { __typename: 'DSNotificationRecipients', every: { __typename: 'Recipients', users: Array<{ __typename: 'User', id: string, displayName: string | null, mail: string, deleted: boolean, userGroups: Array<{ __typename: 'UserGroup', id: string }> }>, nonUserEmails: Array<{ __typename: 'NonUserEmail', id: number, label: string | null, description: string | null, address: string }> } | null, byDSDiscipline: Array<{ __typename: 'ByDSDiscipline', discipline: { __typename: 'DSDiscipline', id: string }, recipients: { __typename: 'Recipients', users: Array<{ __typename: 'User', id: string, displayName: string | null, mail: string, deleted: boolean, userGroups: Array<{ __typename: 'UserGroup', id: string }> }>, nonUserEmails: Array<{ __typename: 'NonUserEmail', id: number, label: string | null, description: string | null, address: string }> } }> } }>, dsDisciplines: Array<{ __typename: 'DSDiscipline', id: string, name: string, description: string | null, users: Array<{ __typename: 'User', id: string, displayName: string | null, mail: string, deleted: boolean, userGroups: Array<{ __typename: 'UserGroup', id: string }> }> }> } };

export type EditDsNotificationMutationVariables = Exact<{
  editDsNotificationInput: EditDsNotificationInput;
}>;


export type EditDsNotificationMutation = { __typename: 'Mutation', editDSNotification: { __typename: 'EditDSNotificationResponse', notification: { __typename: 'DSNotification', notificationEvent: string } } };

export type CreateOrganizationMutationVariables = Exact<{
  createOrganizationInput: CreateDsOrganizationInput;
}>;


export type CreateOrganizationMutation = { __typename: 'Mutation', createDSOrganization: { __typename: 'CreateDSOrganizationResponse', organization: { __typename: 'DSOrganization', name: string } } };

export type EditOrganizationMutationVariables = Exact<{
  editOrganizationInput: EditDsOrganizationInput;
}>;


export type EditOrganizationMutation = { __typename: 'Mutation', editDSOrganization: { __typename: 'EditDSOrganizationResponse', organization: { __typename: 'DSOrganization', name: string } } };

export type RemoveOrganizationMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type RemoveOrganizationMutation = { __typename: 'Mutation', softRemoveDSOrganization: { __typename: 'SoftRemoveDSOrganizationResponse', organization: { __typename: 'DSOrganization', name: string } } };

export type RestoreDsOrganizationMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type RestoreDsOrganizationMutation = { __typename: 'Mutation', restoreDSOrganization: { __typename: 'RestoreDSOrganizationResponse', organization: { __typename: 'DSOrganization', name: string } } };

export type GetOrganizationsQueryVariables = Exact<{
  dsOrganizationListInput: DsOrganizationListInput;
}>;


export type GetOrganizationsQuery = { __typename: 'Query', dsOrganizations: { __typename: 'DSOrganizationListResponse', records: Array<{ __typename: 'DSOrganization', id: string, name: string, description: string | null, deleted: boolean, deletedDate: string | null, deletedUser: string | null, submittals: Array<{ __typename: 'DesignSubmittal', id: string, packageNumber: string, packageName: string, deleted: boolean }> }> } };

export type CreateDsTypeMutationVariables = Exact<{
  createDsTypeInput: CreateDsTypeInput;
}>;


export type CreateDsTypeMutation = { __typename: 'Mutation', createDSType: { __typename: 'CreateDSTypeResponse', type: { __typename: 'DSType', name: string } } };

export type EditDsTypeMutationVariables = Exact<{
  editDsTypeInput: EditDsTypeInput;
}>;


export type EditDsTypeMutation = { __typename: 'Mutation', editDSType: { __typename: 'EditDSTypeResponse', type: { __typename: 'DSType', name: string } } };

export type SoftRemoveDsTypeMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type SoftRemoveDsTypeMutation = { __typename: 'Mutation', softRemoveDSType: { __typename: 'SoftRemoveDSTypeResponse', type: { __typename: 'DSType', name: string } } };

export type RestoreDsTypeMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type RestoreDsTypeMutation = { __typename: 'Mutation', restoreDSType: { __typename: 'RestoreDSTypeResponse', type: { __typename: 'DSType', name: string } } };

export type GetDsTypesQueryVariables = Exact<{
  dsTypeListInput: DsTypeListInput;
}>;


export type GetDsTypesQuery = { __typename: 'Query', dsTypes: { __typename: 'DSTypeListResponse', records: Array<{ __typename: 'DSType', id: string, name: string, description: string | null, deleted: boolean, deletedDate: string | null, deletedUser: string | null, submittals: Array<{ __typename: 'DesignSubmittal', id: string, packageName: string, packageNumber: string, deleted: boolean }> }> } };

export type DevelopersQueryVariables = Exact<{ [key: string]: never; }>;


export type DevelopersQuery = { __typename: 'Query', users: { __typename: 'UserListResponse', records: Array<{ __typename: 'User', id: string, username: string, mail: string, developer: boolean, developerDate: string | null, developerGrantedBy: { __typename: 'User', username: string } | null, userToDeveloperPermissions: Array<{ __typename: 'UserToDeveloperPermission', permissionId: string }> }> } };

export type EditDevelopersMutationVariables = Exact<{
  input: EditUserInput;
}>;


export type EditDevelopersMutation = { __typename: 'Mutation', editUser: { __typename: 'EditUserResponse', user: { __typename: 'User', username: string } } };

export type UpsertUserToDeveloperPermissionsMutationVariables = Exact<{
  input: UpsertUserToDeveloperPermissionInput;
}>;


export type UpsertUserToDeveloperPermissionsMutation = { __typename: 'Mutation', upsertUserToDeveloperPermission: { __typename: 'UpsertUserToDeveloperPermissionResponse', userToDeveloperPermissions: Array<{ __typename: 'UserToDeveloperPermission', permission: string, user: { __typename: 'User', username: string } }> } };

export type WriteHeapSnapshotMutationVariables = Exact<{ [key: string]: never; }>;


export type WriteHeapSnapshotMutation = { __typename: 'Mutation', writeHeapSnapshot: { __typename: 'WriteHeapSnapshotResponse', id: string } };

export type SyncUsersMutationVariables = Exact<{ [key: string]: never; }>;


export type SyncUsersMutation = { __typename: 'Mutation', syncUsers: { __typename: 'SyncUsersResponse', success: boolean } };

export type EditEngineeringJudgementMutationVariables = Exact<{
  input: EditEngineeringJudgementInput;
}>;


export type EditEngineeringJudgementMutation = { __typename: 'Mutation', editEngineeringJudgement: { __typename: 'EditEngineeringJudgementResponse', judgement: { __typename: 'EngineeringJudgement', formattedNumber: string } } };

export type GetEjLogMetadataQueryVariables = Exact<{
  globalId: Scalars['String'];
}>;


export type GetEjLogMetadataQuery = { __typename: 'Query', project: { __typename: 'Project', ejTypes: Array<{ __typename: 'EJType', id: string, name: string, allowanceDescription: string, reportTypeId: string | null, users: Array<{ __typename: 'User', id: string }> }>, ejQuickLinks: Array<{ __typename: 'EJQuickLink', id: string, label: string, href: string | null, description: string | null }> } };

export type EngineeringJudgementCustomFieldFragment = { __typename: 'CustomField', name: string, description: string | null };

export type GetEngineeringJudgementsQueryVariables = Exact<{
  projectId: Scalars['String'];
  engineeringJudgementListInput: EngineeringJudgementListInput;
}>;


export type GetEngineeringJudgementsQuery = { __typename: 'Query', engineeringJudgements: { __typename: 'EngineeringJudgementListResponse', records: Array<{ __typename: 'EngineeringJudgement', id: string, formattedNumber: string, statusId: string, typeId: string, failureDate: string, failureDescription: string | null, justification: string | null, notes: string | null, issuedDate: string | null, manualReportId: string | null, deleted: boolean, deletedUser: string | null, deletedDate: string | null, externalLinks: Array<{ __typename: 'ExternalLink', href: string, label: string }>, type: { __typename: 'EJType', id: string, name: string, allowanceDescription: string }, issuedBy: { __typename: 'User', id: string, displayName: string | null, mail: string, deleted: boolean, userGroups: Array<{ __typename: 'UserGroup', id: string }> } | null, identifiedFieldIssue: { __typename: 'IdentifiedFieldIssue', reportId: string, asphaltLot: { __typename: 'AsphaltLot', globalId: string, asphaltLotId: string | null } | null, concreteTest: { __typename: 'ConcreteTest', globalId: string, fieldNumber: string | null } | null, dailyInspectionControlPoint: { __typename: 'DailyInspectionControlPoint', globalId: string, controlPointId: string | null } | null, dailyInspectionInspection: { __typename: 'DailyInspectionInspection', globalId: string, inspectionId: string | null } | null, dailyInspectionPunchList: { __typename: 'DailyInspectionPunchList', globalId: string, punchListId: string | null } | null, lot: { __typename: 'Lot', globalId: string, lotId: string | null } | null } | null, ejToReports: Array<{ __typename: 'EJToReport', reportId: string, reportTypeId: string, concreteTest: { __typename: 'ConcreteTest', globalId: string, fieldNumber: string | null } | null, concretePlacement: { __typename: 'ConcretePlacement', globalId: string, placementId: string | null } | null, lot: { __typename: 'Lot', globalId: string, lotId: string | null } | null, dailyInspectionControlPoint: { __typename: 'DailyInspectionControlPoint', globalId: string, controlPointId: string | null } | null, dailyInspectionInspection: { __typename: 'DailyInspectionInspection', globalId: string, inspectionId: string | null } | null }>, ejToPayItemNoGeometries: Array<{ __typename: 'EJToPayItemNoGeometry', payItem: { __typename: 'PayItemNoGeometry', globalId: string, deleted: boolean, label: string } }>, customFields: { __typename: 'CustomFields', booleanValues: Array<{ __typename: 'BooleanCustomFieldValue', customFieldId: string, value: boolean, customField: { __typename: 'CustomField', name: string, description: string | null } }>, dateValues: Array<{ __typename: 'DateCustomFieldValue', customFieldId: string, value: string | null, customField: { __typename: 'CustomField', name: string, description: string | null } }>, entityValues: Array<{ __typename: 'EntityCustomFieldValues', customFieldId: string, customField: { __typename: 'CustomField', name: string, description: string | null }, entities: Array<{ __typename: 'EntityCustomFieldValue', recordId: string | null, href: string | null, entityId: string, label: string | null }> }>, listValues: { __typename: 'ListValues', singles: Array<{ __typename: 'ListCustomFieldValue', customFieldId: string, customField: { __typename: 'CustomField', name: string, description: string | null }, customListItem: { __typename: 'CustomListItem', id: string, deleted: boolean, value: string } | null }>, multiples: Array<{ __typename: 'ListCustomFieldValues', customFieldId: string, customField: { __typename: 'CustomField', name: string, description: string | null }, customListItems: Array<{ __typename: 'CustomListItem', id: string, deleted: boolean, value: string }> }>, checkboxes: Array<{ __typename: 'BooleanListCustomFieldValues', customFieldId: string, customField: { __typename: 'CustomField', name: string, description: string | null }, booleans: Array<{ __typename: 'BooleanListCustomFieldValue', customListItemId: string, checked: boolean, customListItem: { __typename: 'CustomListItem', value: string } }> }> }, numberValues: Array<{ __typename: 'NumberCustomFieldValue', customFieldId: string, value: number | null, customField: { __typename: 'CustomField', name: string, description: string | null } }>, reportValues: Array<{ __typename: 'ReportCustomFieldValues', customFieldId: string, customField: { __typename: 'CustomField', name: string, description: string | null }, reports: Array<{ __typename: 'ReportCustomFieldValue', recordId: string | null, reportId: string, href: string | null, label: string | null }> }>, textValues: Array<{ __typename: 'TextCustomFieldValue', customFieldId: string, value: string | null, customField: { __typename: 'CustomField', name: string, description: string | null } }> } }> } };

export type DraftEngineeringJudgementMutationVariables = Exact<{
  input: DraftEngineeringJudgementInput;
}>;


export type DraftEngineeringJudgementMutation = { __typename: 'Mutation', draftEngineeringJudgement: { __typename: 'DraftEngineeringJudgementResponse', judgement: { __typename: 'EngineeringJudgement', formattedNumber: string } } };

export type SubmitEngineeringJudgementMutationVariables = Exact<{
  input: SubmitEngineeringJudgementInput;
}>;


export type SubmitEngineeringJudgementMutation = { __typename: 'Mutation', submitEngineeringJudgement: { __typename: 'SubmitEngineeringJudgementResponse', judgement: { __typename: 'EngineeringJudgement', formattedNumber: string } } };

export type RevertEngineeringJudgementMutationVariables = Exact<{
  input: RevertEngineeringJudgementInput;
}>;


export type RevertEngineeringJudgementMutation = { __typename: 'Mutation', revertEngineeringJudgement: { __typename: 'RevertEngineeringJudgementResponse', judgement: { __typename: 'EngineeringJudgement', formattedNumber: string } } };

export type SoftRemoveEngineeringJudgementMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type SoftRemoveEngineeringJudgementMutation = { __typename: 'Mutation', softRemoveEngineeringJudgement: { __typename: 'SoftRemoveEngineeringJudgementResponse', judgement: { __typename: 'EngineeringJudgement', formattedNumber: string } } };

export type RestoreEngineeringJudgementMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type RestoreEngineeringJudgementMutation = { __typename: 'Mutation', restoreEngineeringJudgement: { __typename: 'RestoreEngineeringJudgementResponse', judgement: { __typename: 'EngineeringJudgement', formattedNumber: string } } };

export type EjNotificationRecipientsFragment = { __typename: 'Recipients', users: Array<{ __typename: 'User', id: string, displayName: string | null, mail: string, deleted: boolean, userGroups: Array<{ __typename: 'UserGroup', id: string }> }>, nonUserEmails: Array<{ __typename: 'NonUserEmail', id: number, label: string | null, address: string, description: string | null }> };

export type EjNotificationsQueryVariables = Exact<{
  projectId: Scalars['String'];
}>;


export type EjNotificationsQuery = { __typename: 'Query', project: { __typename: 'Project', ejNotifications: Array<{ __typename: 'EJNotification', notificationEventId: string, recipients: { __typename: 'EJNotificationRecipients', every: { __typename: 'Recipients', users: Array<{ __typename: 'User', id: string, displayName: string | null, mail: string, deleted: boolean, userGroups: Array<{ __typename: 'UserGroup', id: string }> }>, nonUserEmails: Array<{ __typename: 'NonUserEmail', id: number, label: string | null, address: string, description: string | null }> } | null } }> } };

export type EditEjNotificationMutationVariables = Exact<{
  input: EditEjNotificationInput;
}>;


export type EditEjNotificationMutation = { __typename: 'Mutation', editEJNotification: { __typename: 'EditEJNotificationResponse', notification: { __typename: 'EJNotification', notificationEvent: string } } };

export type CreateEjQuickLinkMutationVariables = Exact<{
  input: CreateEjQuickLinkInput;
}>;


export type CreateEjQuickLinkMutation = { __typename: 'Mutation', createEJQuickLink: { __typename: 'CreateEJQuickLinkResponse', ejQuickLink: { __typename: 'EJQuickLink', label: string } } };

export type EditEjQuickLinkMutationVariables = Exact<{
  input: EditEjQuickLinkInput;
}>;


export type EditEjQuickLinkMutation = { __typename: 'Mutation', editEJQuickLink: { __typename: 'EditEJQuickLinkResponse', ejQuickLink: { __typename: 'EJQuickLink', label: string } } };

export type GetEjQuickLinksQueryVariables = Exact<{
  input: EjQuickLinkListInput;
}>;


export type GetEjQuickLinksQuery = { __typename: 'Query', ejQuickLinks: { __typename: 'EJQuickLinkListResponse', records: Array<{ __typename: 'EJQuickLink', id: string, label: string, href: string | null, description: string | null, deleted: boolean, deletedDate: string | null, deletedUser: string | null }> } };

export type RestoreEjQuickLinkMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type RestoreEjQuickLinkMutation = { __typename: 'Mutation', restoreEJQuickLink: { __typename: 'RestoreEJQuickLinkResponse', ejQuickLink: { __typename: 'EJQuickLink', label: string } } };

export type SoftRemoveEjQuickLinkMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type SoftRemoveEjQuickLinkMutation = { __typename: 'Mutation', softRemoveEJQuickLink: { __typename: 'SoftRemoveEJQuickLinkResponse', ejQuickLink: { __typename: 'EJQuickLink', label: string } } };

export type ConcretePlacementEjReportOptionsQueryVariables = Exact<{
  globalId: Scalars['String'];
}>;


export type ConcretePlacementEjReportOptionsQuery = { __typename: 'Query', concretePlacements: { __typename: 'ConcretePlacementListResponse', records: Array<{ __typename: 'ConcretePlacement', globalId: string, placementId: string | null }> } };

export type ConcreteTestEjReportOptionsQueryVariables = Exact<{
  globalId: Scalars['String'];
}>;


export type ConcreteTestEjReportOptionsQuery = { __typename: 'Query', concreteTests: { __typename: 'ConcreteTestListResponse', records: Array<{ __typename: 'ConcreteTest', globalId: string, fieldNumber: string | null }> } };

export type ControlPointEjReportOptionsQueryVariables = Exact<{
  globalId: Scalars['String'];
}>;


export type ControlPointEjReportOptionsQuery = { __typename: 'Query', dailyInspectionControlPoints: { __typename: 'DailyInspectionControlPointListResponse', records: Array<{ __typename: 'DailyInspectionControlPoint', globalId: string, controlPointId: string | null }> } };

export type InspectionEjReportOptionsQueryVariables = Exact<{
  globalId: Scalars['String'];
}>;


export type InspectionEjReportOptionsQuery = { __typename: 'Query', dailyInspectionInspections: { __typename: 'DailyInspectionInspectionListResponse', records: Array<{ __typename: 'DailyInspectionInspection', globalId: string, inspectionId: string | null }> } };

export type LotEjReportOptionsQueryVariables = Exact<{
  globalId: Scalars['String'];
}>;


export type LotEjReportOptionsQuery = { __typename: 'Query', lots: { __typename: 'LotListResponse', records: Array<{ __typename: 'Lot', globalId: string, lotId: string | null }> } };

export type CreateEjTypeMutationVariables = Exact<{
  input: CreateEjTypeInput;
}>;


export type CreateEjTypeMutation = { __typename: 'Mutation', createEJType: { __typename: 'CreateEJTypeResponse', type: { __typename: 'EJType', name: string } } };

export type EditEjTypeMutationVariables = Exact<{
  input: EditEjTypeInput;
}>;


export type EditEjTypeMutation = { __typename: 'Mutation', editEJType: { __typename: 'EditEJTypeResponse', type: { __typename: 'EJType', name: string } } };

export type SoftRemoveEjTypeMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type SoftRemoveEjTypeMutation = { __typename: 'Mutation', softRemoveEJType: { __typename: 'SoftRemoveEJTypeResponse', type: { __typename: 'EJType', name: string } } };

export type RestoreEjTypeMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type RestoreEjTypeMutation = { __typename: 'Mutation', restoreEJType: { __typename: 'RestoreEJTypeResponse', type: { __typename: 'EJType', name: string } } };

export type GetEjTypesQueryVariables = Exact<{
  ejTypeListInput: EjTypeListInput;
}>;


export type GetEjTypesQuery = { __typename: 'Query', ejTypes: { __typename: 'EJTypeListResponse', records: Array<{ __typename: 'EJType', id: string, name: string, deleted: boolean, deletedDate: string | null, deletedUser: string | null, allowanceDescription: string, reportTypeId: string | null, users: Array<{ __typename: 'User', id: string, displayName: string | null, mail: string, deleted: boolean, userGroups: Array<{ __typename: 'UserGroup', id: string }> }>, judgements: Array<{ __typename: 'EngineeringJudgement', id: string, deleted: boolean, formattedNumber: string }> }> } };

export type CreateFdcApprovalGroupMutationVariables = Exact<{
  createFdcApprovalGroupInput: CreateFdcApprovalGroupInput;
}>;


export type CreateFdcApprovalGroupMutation = { __typename: 'Mutation', createFDCApprovalGroup: { __typename: 'CreateFDCApprovalGroupResponse', approvalGroup: { __typename: 'FDCApprovalGroup', name: string } } };

export type EditFdcApprovalGroupMutationVariables = Exact<{
  editFdcApprovalGroupInput: EditFdcApprovalGroupInput;
}>;


export type EditFdcApprovalGroupMutation = { __typename: 'Mutation', editFDCApprovalGroup: { __typename: 'EditFDCApprovalGroupResponse', approvalGroup: { __typename: 'FDCApprovalGroup', name: string } } };

export type FdcApprovalGroupUserFragment = { __typename: 'User', id: string, displayName: string | null, mail: string, deleted: boolean, userGroups: Array<{ __typename: 'UserGroup', id: string }> };

export type ProjectFdcApprovalGroupsQueryVariables = Exact<{
  globalId: Scalars['String'];
  input: FdcApprovalGroupFieldInput;
}>;


export type ProjectFdcApprovalGroupsQuery = { __typename: 'Query', project: { __typename: 'Project', fdcApprovalGroups: Array<{ __typename: 'FDCApprovalGroup', id: string, name: string, description: string | null, deleted: boolean, deletedDate: string | null, deletedUser: string | null, concurrenceLevels: Array<{ __typename: 'FDCConcurrenceLevel', id: string, name: string, description: string | null }>, roles: Array<{ __typename: 'Role', id: string, name: string, users: Array<{ __typename: 'User', id: string, displayName: string | null, mail: string, deleted: boolean, userGroups: Array<{ __typename: 'UserGroup', id: string }> }> }>, users: Array<{ __typename: 'User', id: string, displayName: string | null, mail: string, deleted: boolean, userGroups: Array<{ __typename: 'UserGroup', id: string }> }>, fdcToFDCApprovalGroups: Array<{ __typename: 'FDCToFDCApprovalGroup', fieldDesignChange: { __typename: 'FieldDesignChange', id: string, formattedNumber: string, deleted: boolean } }> }>, fdcConcurrenceLevels: Array<{ __typename: 'FDCConcurrenceLevel', id: string, name: string, description: string | null }> } };

export type RestoreFdcApprovalGroupMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type RestoreFdcApprovalGroupMutation = { __typename: 'Mutation', restoreFDCApprovalGroup: { __typename: 'RestoreFDCApprovalGroupResponse', approvalGroup: { __typename: 'FDCApprovalGroup', name: string } } };

export type SoftRemoveFdcApprovalGroupMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type SoftRemoveFdcApprovalGroupMutation = { __typename: 'Mutation', softRemoveFDCApprovalGroup: { __typename: 'SoftRemoveFDCApprovalGroupResponse', approvalGroup: { __typename: 'FDCApprovalGroup', name: string } } };

export type RestoreFdcConcurrenceGroupMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type RestoreFdcConcurrenceGroupMutation = { __typename: 'Mutation', restoreFDCConcurrenceGroup: { __typename: 'RestoreFDCConcurrenceGroupResponse', concurrenceGroup: { __typename: 'FDCConcurrenceGroup', name: string } } };

export type CreateFdcConcurrenceGroupMutationVariables = Exact<{
  createFdcConcurrenceGroupInput: CreateFdcConcurrenceGroupInput;
}>;


export type CreateFdcConcurrenceGroupMutation = { __typename: 'Mutation', createFDCConcurrenceGroup: { __typename: 'CreateFDCConcurrenceGroupResponse', concurrenceGroup: { __typename: 'FDCConcurrenceGroup', name: string } } };

export type EditFdcConcurrenceGroupMutationVariables = Exact<{
  editFdcConcurrenceGroupInput: EditFdcConcurrenceGroupInput;
}>;


export type EditFdcConcurrenceGroupMutation = { __typename: 'Mutation', editFDCConcurrenceGroup: { __typename: 'EditFDCConcurrenceGroupResponse', concurrenceGroup: { __typename: 'FDCConcurrenceGroup', name: string } } };

export type FdcConcurrenceGroupUserFragment = { __typename: 'User', id: string, displayName: string | null, mail: string, deleted: boolean, userGroups: Array<{ __typename: 'UserGroup', id: string }> };

export type ProjectFdcConcurrenceGroupsQueryVariables = Exact<{
  globalId: Scalars['String'];
  input?: InputMaybe<FdcConcurrenceGroupFieldInput>;
}>;


export type ProjectFdcConcurrenceGroupsQuery = { __typename: 'Query', project: { __typename: 'Project', fdcConcurrenceGroups: Array<{ __typename: 'FDCConcurrenceGroup', id: string, name: string, description: string | null, deleted: boolean, deletedDate: string | null, deletedUser: string | null, roles: Array<{ __typename: 'Role', id: string, name: string, users: Array<{ __typename: 'User', id: string, displayName: string | null, mail: string, deleted: boolean, userGroups: Array<{ __typename: 'UserGroup', id: string }> }> }>, users: Array<{ __typename: 'User', id: string, displayName: string | null, mail: string, deleted: boolean, userGroups: Array<{ __typename: 'UserGroup', id: string }> }>, fdcToFDCConcurrenceGroups: Array<{ __typename: 'FDCToFDCConcurrenceGroup', fieldDesignChange: { __typename: 'FieldDesignChange', id: string, formattedNumber: string, deleted: boolean } }> }> } };

export type SoftRemoveFdcConcurrenceGroupMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type SoftRemoveFdcConcurrenceGroupMutation = { __typename: 'Mutation', softRemoveFDCConcurrenceGroup: { __typename: 'SoftRemoveFDCConcurrenceGroupResponse', concurrenceGroup: { __typename: 'FDCConcurrenceGroup', name: string } } };

export type CreateFdcConcurrenceLevelMutationVariables = Exact<{
  createFdcConcurrenceLevelInput: CreateFdcConcurrenceLevelInput;
}>;


export type CreateFdcConcurrenceLevelMutation = { __typename: 'Mutation', createFDCConcurrenceLevel: { __typename: 'CreateFDCConcurrenceLevelResponse', concurrenceLevel: { __typename: 'FDCConcurrenceLevel', name: string } } };

export type EditFdcConcurrenceLevelMutationVariables = Exact<{
  editFdcConcurrenceLevelInput: EditFdcConcurrenceLevelInput;
}>;


export type EditFdcConcurrenceLevelMutation = { __typename: 'Mutation', editFDCConcurrenceLevel: { __typename: 'EditFDCConcurrenceLevelResponse', concurrenceLevel: { __typename: 'FDCConcurrenceLevel', name: string } } };

export type ProjectFdcConcurrenceLevelsQueryVariables = Exact<{
  globalId: Scalars['String'];
  input?: InputMaybe<FdcConcurrenceLevelFieldInput>;
}>;


export type ProjectFdcConcurrenceLevelsQuery = { __typename: 'Query', project: { __typename: 'Project', fdcConcurrenceLevels: Array<{ __typename: 'FDCConcurrenceLevel', id: string, name: string, description: string | null, deleted: boolean, deletedDate: string | null, deletedUser: string | null, sideEffectId: string | null, approvalGroups: Array<{ __typename: 'FDCApprovalGroup', id: string, name: string, description: string | null }>, fieldDesignChanges: Array<{ __typename: 'FieldDesignChange', id: string, formattedNumber: string, deleted: boolean }> }>, fdcApprovalGroups: Array<{ __typename: 'FDCApprovalGroup', name: string, id: string, description: string | null }> } };

export type RestoreFdcConcurrenceLevelMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type RestoreFdcConcurrenceLevelMutation = { __typename: 'Mutation', restoreFDCConcurrenceLevel: { __typename: 'RestoreFDCConcurrenceLevelResponse', concurrenceLevel: { __typename: 'FDCConcurrenceLevel', name: string } } };

export type SoftRemoveFdcConcurrenceLevelMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type SoftRemoveFdcConcurrenceLevelMutation = { __typename: 'Mutation', softRemoveFDCConcurrenceLevel: { __typename: 'SoftRemoveFDCConcurrenceLevelResponse', concurrenceLevel: { __typename: 'FDCConcurrenceLevel', name: string } } };

export type CreateFdcDisciplineMutationVariables = Exact<{
  createFdcDisciplineInput: CreateFdcDisciplineInput;
}>;


export type CreateFdcDisciplineMutation = { __typename: 'Mutation', createFDCDiscipline: { __typename: 'CreateFDCDisciplineResponse', discipline: { __typename: 'FDCDiscipline', name: string } } };

export type EditFdcDisciplineMutationVariables = Exact<{
  editFdcDisciplineInput: EditFdcDisciplineInput;
}>;


export type EditFdcDisciplineMutation = { __typename: 'Mutation', editFDCDiscipline: { __typename: 'EditFDCDisciplineResponse', discipline: { __typename: 'FDCDiscipline', name: string } } };

export type ProjectFdcDisciplinesQueryVariables = Exact<{
  globalId: Scalars['String'];
  input?: InputMaybe<FdcDisciplineFieldInput>;
}>;


export type ProjectFdcDisciplinesQuery = { __typename: 'Query', project: { __typename: 'Project', fdcDisciplines: Array<{ __typename: 'FDCDiscipline', id: string, name: string, description: string | null, deleted: boolean, deletedDate: string | null, deletedUser: string | null, fieldDesignChanges: Array<{ __typename: 'FieldDesignChange', id: string, formattedNumber: string, deleted: boolean }> }> } };

export type RestoreFdcDisciplineMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type RestoreFdcDisciplineMutation = { __typename: 'Mutation', restoreFDCDiscipline: { __typename: 'RestoreFDCDisciplineResponse', discipline: { __typename: 'FDCDiscipline', name: string } } };

export type SoftRemoveFdcDisciplineMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type SoftRemoveFdcDisciplineMutation = { __typename: 'Mutation', softRemoveFDCDiscipline: { __typename: 'SoftRemoveFDCDisciplineResponse', discipline: { __typename: 'FDCDiscipline', name: string } } };

export type CreateFdcQuickLinkMutationVariables = Exact<{
  input: CreateFdcQuickLinkInput;
}>;


export type CreateFdcQuickLinkMutation = { __typename: 'Mutation', createFDCQuickLink: { __typename: 'CreateFDCQuickLinkResponse', fdcQuickLink: { __typename: 'FDCQuickLink', label: string } } };

export type EditFdcQuickLinkMutationVariables = Exact<{
  input: EditFdcQuickLinkInput;
}>;


export type EditFdcQuickLinkMutation = { __typename: 'Mutation', editFDCQuickLink: { __typename: 'EditFDCQuickLinkResponse', fdcQuickLink: { __typename: 'FDCQuickLink', label: string } } };

export type GetFdcQuickLinksQueryVariables = Exact<{
  input: FdcQuickLinkListInput;
}>;


export type GetFdcQuickLinksQuery = { __typename: 'Query', fdcQuickLinks: { __typename: 'FDCQuickLinkListResponse', records: Array<{ __typename: 'FDCQuickLink', id: string, label: string, href: string | null, description: string | null, deleted: boolean, deletedDate: string | null, deletedUser: string | null }> } };

export type RestoreFdcQuickLinkMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type RestoreFdcQuickLinkMutation = { __typename: 'Mutation', restoreFDCQuickLink: { __typename: 'RestoreFDCQuickLinkResponse', fdcQuickLink: { __typename: 'FDCQuickLink', label: string } } };

export type SoftRemoveFdcQuickLinkMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type SoftRemoveFdcQuickLinkMutation = { __typename: 'Mutation', softRemoveFDCQuickLink: { __typename: 'SoftRemoveFDCQuickLinkResponse', fdcQuickLink: { __typename: 'FDCQuickLink', label: string } } };

export type CreateFdcCommentMutationVariables = Exact<{
  input: CreateFdcCommentInput;
}>;


export type CreateFdcCommentMutation = { __typename: 'Mutation', createFDCComment: { __typename: 'CreateFDCCommentResponse', comment: { __typename: 'FDCComment', id: string } } };

export type DraftFieldDesignChangeMutationVariables = Exact<{
  input: DraftFieldDesignChangeInput;
}>;


export type DraftFieldDesignChangeMutation = { __typename: 'Mutation', draftFieldDesignChange: { __typename: 'DraftFieldDesignChangeResponse', fieldDesignChange: { __typename: 'FieldDesignChange', formattedNumber: string } } };

export type EditFieldDesignChangeMutationVariables = Exact<{
  input: EditFieldDesignChangeInput;
}>;


export type EditFieldDesignChangeMutation = { __typename: 'Mutation', editFieldDesignChange: { __typename: 'EditFieldDesignChangeResponse', fieldDesignChange: { __typename: 'FieldDesignChange', id: string, formattedNumber: string, project: { __typename: 'Project', projectMetadata: { __typename: 'ProjectMetadata', promptDesignSubmittalAtFDCClosure: boolean | null } | null }, concurrenceLevel: { __typename: 'FDCConcurrenceLevel', sideEffectId: string | null, name: string, description: string | null } | null } } };

export type FdcTrackerTableMetadataQueryVariables = Exact<{
  projectId: Scalars['String'];
}>;


export type FdcTrackerTableMetadataQuery = { __typename: 'Query', project: { __typename: 'Project', fdcConcurrenceLevels: Array<{ __typename: 'FDCConcurrenceLevel', id: string, name: string, sideEffectId: string | null, description: string | null, approvalGroups: Array<{ __typename: 'FDCApprovalGroup', id: string }> }>, fdcConcurrenceGroups: Array<{ __typename: 'FDCConcurrenceGroup', id: string, name: string, description: string | null, roles: Array<{ __typename: 'Role', users: Array<{ __typename: 'User', id: string }> }>, users: Array<{ __typename: 'User', id: string }> }>, fdcApprovalGroups: Array<{ __typename: 'FDCApprovalGroup', id: string, name: string, description: string | null, concurrenceLevels: Array<{ __typename: 'FDCConcurrenceLevel', id: string }>, roles: Array<{ __typename: 'Role', users: Array<{ __typename: 'User', id: string }> }>, users: Array<{ __typename: 'User', id: string }> }>, fdcDisciplines: Array<{ __typename: 'FDCDiscipline', id: string, name: string, description: string | null }>, fdcQuickLinks: Array<{ __typename: 'FDCQuickLink', id: string, label: string, href: string | null, description: string | null }> } };

export type ProjectFieldDesignChangesCustomFieldFragment = { __typename: 'CustomField', name: string, description: string | null };

export type ProjectFieldDesignChangesQueryVariables = Exact<{
  projectId: Scalars['String'];
  input: FieldDesignChangeListInput;
}>;


export type ProjectFieldDesignChangesQuery = { __typename: 'Query', fieldDesignChanges: { __typename: 'FieldDesignChangeListResponse', records: Array<{ __typename: 'FieldDesignChange', deleted: boolean, deletedDate: string | null, deletedUser: string | null, projectId: string, sharePointResourceId: string | null, sharePointResourceWebUrl: string | null, id: string, statusId: string, number: number, formattedNumber: string, issue: string, location: string | null, specsAffected: string | null, drawingsAffected: string | null, requestedApprovalDate: string | null, resolution: string | null, requestedById: string | null, submittedDate: string | null, designSubmittals: Array<{ __typename: 'DesignSubmittal', id: string, packageName: string, packageNumber: string, deleted: boolean }>, customFields: { __typename: 'CustomFields', booleanValues: Array<{ __typename: 'BooleanCustomFieldValue', customFieldId: string, value: boolean, customField: { __typename: 'CustomField', name: string, description: string | null } }>, dateValues: Array<{ __typename: 'DateCustomFieldValue', customFieldId: string, value: string | null, customField: { __typename: 'CustomField', name: string, description: string | null } }>, entityValues: Array<{ __typename: 'EntityCustomFieldValues', customFieldId: string, customField: { __typename: 'CustomField', name: string, description: string | null }, entities: Array<{ __typename: 'EntityCustomFieldValue', recordId: string | null, href: string | null, entityId: string, label: string | null }> }>, listValues: { __typename: 'ListValues', singles: Array<{ __typename: 'ListCustomFieldValue', customFieldId: string, customField: { __typename: 'CustomField', name: string, description: string | null }, customListItem: { __typename: 'CustomListItem', id: string, deleted: boolean, value: string } | null }>, multiples: Array<{ __typename: 'ListCustomFieldValues', customFieldId: string, customField: { __typename: 'CustomField', name: string, description: string | null }, customListItems: Array<{ __typename: 'CustomListItem', id: string, deleted: boolean, value: string }> }>, checkboxes: Array<{ __typename: 'BooleanListCustomFieldValues', customFieldId: string, customField: { __typename: 'CustomField', name: string, description: string | null }, booleans: Array<{ __typename: 'BooleanListCustomFieldValue', customListItemId: string, checked: boolean, customListItem: { __typename: 'CustomListItem', value: string } }> }> }, numberValues: Array<{ __typename: 'NumberCustomFieldValue', customFieldId: string, value: number | null, customField: { __typename: 'CustomField', name: string, description: string | null } }>, reportValues: Array<{ __typename: 'ReportCustomFieldValues', customFieldId: string, customField: { __typename: 'CustomField', name: string, description: string | null }, reports: Array<{ __typename: 'ReportCustomFieldValue', recordId: string | null, reportId: string, href: string | null, label: string | null }> }>, textValues: Array<{ __typename: 'TextCustomFieldValue', customFieldId: string, value: string | null, customField: { __typename: 'CustomField', name: string, description: string | null } }> }, externalLinks: Array<{ __typename: 'ExternalLink', href: string, label: string }>, disciplines: Array<{ __typename: 'FDCDiscipline', id: string, name: string, description: string | null, deleted: boolean }>, concurrenceLevel: { __typename: 'FDCConcurrenceLevel', id: string, name: string, description: string | null, sideEffectId: string | null, deleted: boolean, approvalGroups: Array<{ __typename: 'FDCApprovalGroup', id: string }> } | null, requestedBy: { __typename: 'User', mail: string, displayName: string | null, id: string, deleted: boolean, userGroups: Array<{ __typename: 'UserGroup', id: string }> } | null, fdcToPayItemNoGeometries: Array<{ __typename: 'FDCToPayItemNoGeometry', payItem: { __typename: 'PayItemNoGeometry', globalId: string, deleted: boolean, label: string } }>, fdcToFDCConcurrenceGroups: Array<{ __typename: 'FDCToFDCConcurrenceGroup', concurred: boolean, concurrenceDate: string, concurrenceBy: { __typename: 'User', displayName: string | null, mail: string }, concurrenceGroup: { __typename: 'FDCConcurrenceGroup', id: string, name: string, description: string | null, deleted: boolean } }>, fdcToFDCApprovalGroups: Array<{ __typename: 'FDCToFDCApprovalGroup', approved: boolean, approvalDate: string, approvalBy: { __typename: 'User', displayName: string | null, mail: string }, approvalGroup: { __typename: 'FDCApprovalGroup', id: string, name: string, description: string | null, deleted: boolean } }>, comments: Array<{ __typename: 'FDCComment', text: string, createdDate: string, user: { __typename: 'User', mail: string } }> }> } };

export type RestoreFieldDesignChangeMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type RestoreFieldDesignChangeMutation = { __typename: 'Mutation', restoreFieldDesignChange: { __typename: 'RestoreFieldDesignChangeResponse', fieldDesignChange: { __typename: 'FieldDesignChange', formattedNumber: string } } };

export type RevertFieldDesignChangeMutationVariables = Exact<{
  input: RevertFieldDesignChangeInput;
}>;


export type RevertFieldDesignChangeMutation = { __typename: 'Mutation', revertFieldDesignChange: { __typename: 'RevertFieldDesignChangeResponse', fieldDesignChange: { __typename: 'FieldDesignChange', formattedNumber: string } } };

export type SetFdcToFdcApprovalGroupMutationVariables = Exact<{
  input: SetFdcToFdcApprovalGroupInput;
}>;


export type SetFdcToFdcApprovalGroupMutation = { __typename: 'Mutation', setFDCToFDCApprovalGroup: { __typename: 'SetFDCToFDCApprovalGroupResponse', approved: boolean, approvalGroup: { __typename: 'FDCApprovalGroup', name: string } } };

export type SetFdcToFdcConcurrenceGroupMutationVariables = Exact<{
  input: SetFdcToFdcConcurrenceGroupInput;
}>;


export type SetFdcToFdcConcurrenceGroupMutation = { __typename: 'Mutation', setFDCToFDCConcurrenceGroup: { __typename: 'SetFDCToFDCConcurrenceGroupResponse', concurred: boolean, concurrenceGroup: { __typename: 'FDCConcurrenceGroup', name: string } } };

export type SoftRemoveFieldDesignChangeMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type SoftRemoveFieldDesignChangeMutation = { __typename: 'Mutation', softRemoveFieldDesignChange: { __typename: 'SoftRemoveFieldDesignChangeResponse', fieldDesignChange: { __typename: 'FieldDesignChange', formattedNumber: string } } };

export type SubmitFieldDesignChangeMutationVariables = Exact<{
  input: SubmitFieldDesignChangeInput;
}>;


export type SubmitFieldDesignChangeMutation = { __typename: 'Mutation', submitFieldDesignChange: { __typename: 'SubmitFieldDesignChangeResponse', fieldDesignChange: { __typename: 'FieldDesignChange', id: string, formattedNumber: string, concurrenceLevel: { __typename: 'FDCConcurrenceLevel', name: string, description: string | null, sideEffectId: string | null } | null, project: { __typename: 'Project', projectMetadata: { __typename: 'ProjectMetadata', promptDesignSubmittalAtFDCClosure: boolean | null } | null } } } };

export type FdcNotificationsUserFragment = { __typename: 'User', id: string, displayName: string | null, mail: string, deleted: boolean, userGroups: Array<{ __typename: 'UserGroup', id: string }> };

export type FdcNotificationsRecipientsFragment = { __typename: 'Recipients', users: Array<{ __typename: 'User', id: string, displayName: string | null, mail: string, deleted: boolean, userGroups: Array<{ __typename: 'UserGroup', id: string }> }>, nonUserEmails: Array<{ __typename: 'NonUserEmail', id: number, label: string | null, description: string | null, address: string }> };

export type FdcNotificationsRoleFragment = { __typename: 'Role', id: string, name: string, users: Array<{ __typename: 'User', id: string, displayName: string | null, mail: string, deleted: boolean, userGroups: Array<{ __typename: 'UserGroup', id: string }> }> };

export type ProjectFdcNotificationEventsQueryVariables = Exact<{
  globalId: Scalars['String'];
}>;


export type ProjectFdcNotificationEventsQuery = { __typename: 'Query', project: { __typename: 'Project', fdcNotifications: Array<{ __typename: 'FDCNotification', notificationEventId: string, recipients: { __typename: 'FDCNotificationRecipients', every: { __typename: 'Recipients', users: Array<{ __typename: 'User', id: string, displayName: string | null, mail: string, deleted: boolean, userGroups: Array<{ __typename: 'UserGroup', id: string }> }>, nonUserEmails: Array<{ __typename: 'NonUserEmail', id: number, label: string | null, description: string | null, address: string }> } | null, byConcurrenceLevel: Array<{ __typename: 'ByFDCConcurrenceLevel', concurrenceLevel: { __typename: 'FDCConcurrenceLevel', id: string, name: string, description: string | null }, recipients: { __typename: 'Recipients', users: Array<{ __typename: 'User', id: string, displayName: string | null, mail: string, deleted: boolean, userGroups: Array<{ __typename: 'UserGroup', id: string }> }>, nonUserEmails: Array<{ __typename: 'NonUserEmail', id: number, label: string | null, description: string | null, address: string }> } }>, byConcurrenceGroup: Array<{ __typename: 'ByFDCConcurrenceGroup', concurrenceGroup: { __typename: 'FDCConcurrenceGroup', id: string, name: string, description: string | null }, recipients: { __typename: 'Recipients', users: Array<{ __typename: 'User', id: string, displayName: string | null, mail: string, deleted: boolean, userGroups: Array<{ __typename: 'UserGroup', id: string }> }>, nonUserEmails: Array<{ __typename: 'NonUserEmail', id: number, label: string | null, description: string | null, address: string }> } }>, byConcurrenceLevelAndConcurrenceGroup: Array<{ __typename: 'ByFDCConcurrenceLevelAndConcurrenceGroup', concurrenceGroup: { __typename: 'FDCConcurrenceGroup', id: string, name: string, description: string | null }, concurrenceLevel: { __typename: 'FDCConcurrenceLevel', id: string, name: string, description: string | null }, recipients: { __typename: 'Recipients', users: Array<{ __typename: 'User', id: string, displayName: string | null, mail: string, deleted: boolean, userGroups: Array<{ __typename: 'UserGroup', id: string }> }>, nonUserEmails: Array<{ __typename: 'NonUserEmail', id: number, label: string | null, description: string | null, address: string }> } }>, byApprovalGroup: Array<{ __typename: 'ByFDCApprovalGroup', approvalGroup: { __typename: 'FDCApprovalGroup', id: string, name: string, description: string | null }, recipients: { __typename: 'Recipients', users: Array<{ __typename: 'User', id: string, displayName: string | null, mail: string, deleted: boolean, userGroups: Array<{ __typename: 'UserGroup', id: string }> }>, nonUserEmails: Array<{ __typename: 'NonUserEmail', id: number, label: string | null, description: string | null, address: string }> } }>, byConcurrenceLevelAndApprovalGroup: Array<{ __typename: 'ByFDCConcurrenceLevelAndApprovalGroup', approvalGroup: { __typename: 'FDCApprovalGroup', id: string, name: string, description: string | null }, concurrenceLevel: { __typename: 'FDCConcurrenceLevel', id: string, name: string, description: string | null }, recipients: { __typename: 'Recipients', users: Array<{ __typename: 'User', id: string, displayName: string | null, mail: string, deleted: boolean, userGroups: Array<{ __typename: 'UserGroup', id: string }> }>, nonUserEmails: Array<{ __typename: 'NonUserEmail', id: number, label: string | null, description: string | null, address: string }> } }> } }>, fdcConcurrenceLevels: Array<{ __typename: 'FDCConcurrenceLevel', id: string, name: string, description: string | null }>, fdcConcurrenceGroups: Array<{ __typename: 'FDCConcurrenceGroup', id: string, name: string, description: string | null, users: Array<{ __typename: 'User', id: string, displayName: string | null, mail: string, deleted: boolean, userGroups: Array<{ __typename: 'UserGroup', id: string }> }>, roles: Array<{ __typename: 'Role', id: string, name: string, users: Array<{ __typename: 'User', id: string, displayName: string | null, mail: string, deleted: boolean, userGroups: Array<{ __typename: 'UserGroup', id: string }> }> }> }>, fdcApprovalGroups: Array<{ __typename: 'FDCApprovalGroup', id: string, name: string, description: string | null, users: Array<{ __typename: 'User', id: string, displayName: string | null, mail: string, deleted: boolean, userGroups: Array<{ __typename: 'UserGroup', id: string }> }>, roles: Array<{ __typename: 'Role', id: string, name: string, users: Array<{ __typename: 'User', id: string, displayName: string | null, mail: string, deleted: boolean, userGroups: Array<{ __typename: 'UserGroup', id: string }> }> }> }> } };

export type EditFdcNotificationMutationVariables = Exact<{
  editFdcNotificationInput: EditFdcNotificationInput;
}>;


export type EditFdcNotificationMutation = { __typename: 'Mutation', editFDCNotification: { __typename: 'EditFDCNotificationResponse', notification: { __typename: 'FDCNotification', notificationEvent: string } } };

export type CancelBatchReportRequestMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type CancelBatchReportRequestMutation = { __typename: 'Mutation', cancelBatchReportRequest: { __typename: 'CancelBatchReportRequestResponse', batchReportRequest: { __typename: 'BatchReportRequest', id: string } } };

export type QueuedBatchReportRequestsQueryVariables = Exact<{
  batchReportRequestListInput: BatchReportRequestListInput;
}>;


export type QueuedBatchReportRequestsQuery = { __typename: 'Query', batchReportRequests: { __typename: 'BatchReportRequestListResponse', records: Array<{ __typename: 'BatchReportRequest', createdDate: string, estimatedString: string, id: string, startedDate: string | null, statusId: string, json: { __typename: 'BatchReportRequestJSON', arguments: { __typename: 'BatchReportRequestArgumentsJSON', reportIds: Array<string>, dateRange: { __typename: 'DateRange', from: string, to: string } | null, payItemNoGeometries: Array<{ __typename: 'PayItemNoGeometry', label: string }> } }, requestedBy: { __typename: 'User', id: string, displayName: string | null, mail: string } }> } };

export type CreateBatchReportRequestMutationVariables = Exact<{
  input: CreateBatchReportRequestInput;
}>;


export type CreateBatchReportRequestMutation = { __typename: 'Mutation', createBatchReportRequest: { __typename: 'CreateBatchReportRequestResponse', batchReportRequest: { __typename: 'BatchReportRequest', createdDate: string, requestedBy: { __typename: 'User', mail: string } } } };

export type EditFilenameModalMetadataQueryVariables = Exact<{
  projectGlobalId: Scalars['String'];
}>;


export type EditFilenameModalMetadataQuery = { __typename: 'Query', project: { __typename: 'Project', projectName: string | null, clientProjectName: string | null, clientProjectNumber: string | null } };

export type PhotoFilenamesQueryVariables = Exact<{
  projectId: Scalars['String'];
}>;


export type PhotoFilenamesQuery = { __typename: 'Query', photoFilenames: { __typename: 'PhotoFilenameListResponse', records: Array<{ __typename: 'PhotoFilename', classTypeId: string, templateItems: Array<{ __typename: 'FilenameTemplateItem', type: string, value: string }> | null }> } };

export type EditPhotoFilenameMutationVariables = Exact<{
  input: EditPhotoFilenameInput;
}>;


export type EditPhotoFilenameMutation = { __typename: 'Mutation', editPhotoFilename: { __typename: 'EditPhotoFilenameResponse', photoFilename: { __typename: 'PhotoFilename', classType: string } } };

export type PhotoFilenameExampleQueryVariables = Exact<{
  input: PhotoFilenameExampleInput;
}>;


export type PhotoFilenameExampleQuery = { __typename: 'Query', photoFilenameExample: string | null };

export type PhotoFilenameTemplateQueryVariables = Exact<{
  input: PhotoFilenameTemplateInput;
}>;


export type PhotoFilenameTemplateQuery = { __typename: 'Query', photoFilenameTemplate: string | null };

export type ReportFilenamesQueryVariables = Exact<{
  projectId: Scalars['String'];
}>;


export type ReportFilenamesQuery = { __typename: 'Query', reportFilenames: { __typename: 'ReportFilenameListResponse', records: Array<{ __typename: 'ReportFilename', reportId: string, templateItems: Array<{ __typename: 'FilenameTemplateItem', type: string, value: string }> | null }> } };

export type EditReportFilenameMutationVariables = Exact<{
  input: EditReportFilenameInput;
}>;


export type EditReportFilenameMutation = { __typename: 'Mutation', editReportFilename: { __typename: 'EditReportFilenameResponse', reportFilename: { __typename: 'ReportFilename', report: string } } };

export type ReportFilenameExampleQueryVariables = Exact<{
  input: ReportFilenameExampleInput;
}>;


export type ReportFilenameExampleQuery = { __typename: 'Query', reportFilenameExample: string | null };

export type ReportFilenameTemplateQueryVariables = Exact<{
  input: ReportFilenameTemplateInput;
}>;


export type ReportFilenameTemplateQuery = { __typename: 'Query', reportFilenameTemplate: string | null };

export type FilenamesWarningsQueryVariables = Exact<{
  projectId: Scalars['String'];
}>;


export type FilenamesWarningsQuery = { __typename: 'Query', projectMetadata: { __typename: 'ProjectMetadata', replaceSpacesWithDashesInFilenames: boolean } };

export type AsphaltPlacementMapImageQueryVariables = Exact<{
  globalId: Scalars['String'];
  projectLayerIds: Array<Scalars['Int']> | Scalars['Int'];
}>;


export type AsphaltPlacementMapImageQuery = { __typename: 'Query', asphaltPlacement: { __typename: 'AsphaltPlacement', base64MapImage: string | null } };

export type ConcretePlacementMapImageQueryVariables = Exact<{
  globalId: Scalars['String'];
  projectLayerIds: Array<Scalars['Int']> | Scalars['Int'];
}>;


export type ConcretePlacementMapImageQuery = { __typename: 'Query', concretePlacement: { __typename: 'ConcretePlacement', base64MapImage: string | null } };

export type LotMapImageQueryVariables = Exact<{
  globalId: Scalars['String'];
  projectLayerIds: Array<Scalars['Int']> | Scalars['Int'];
}>;


export type LotMapImageQuery = { __typename: 'Query', lot: { __typename: 'Lot', base64MapImage: string | null } };

export type DailyInspectionControlPointMapImageQueryVariables = Exact<{
  globalId: Scalars['String'];
  projectLayerIds: Array<Scalars['Int']> | Scalars['Int'];
}>;


export type DailyInspectionControlPointMapImageQuery = { __typename: 'Query', dailyInspectionControlPoint: { __typename: 'DailyInspectionControlPoint', base64MapImage: string | null } };

export type DailyInspectionInspectionMapImageQueryVariables = Exact<{
  globalId: Scalars['String'];
  projectLayerIds: Array<Scalars['Int']> | Scalars['Int'];
}>;


export type DailyInspectionInspectionMapImageQuery = { __typename: 'Query', dailyInspectionInspection: { __typename: 'DailyInspectionInspection', base64MapImage: string | null } };

export type DailyInspectionPunchListMapImageQueryVariables = Exact<{
  globalId: Scalars['String'];
  projectLayerIds: Array<Scalars['Int']> | Scalars['Int'];
}>;


export type DailyInspectionPunchListMapImageQuery = { __typename: 'Query', dailyInspectionPunchList: { __typename: 'DailyInspectionPunchList', base64MapImage: string | null } };

export type LayerFragment = { __typename: 'PDFDesignLayer', index: number, json: { __typename: 'PDFDesignLayerJSON', allLayers: Array<number> | null, options: any | null, useAllLayers: boolean } | null };

export type DesignLayerTabPdfDesignLayersQueryVariables = Exact<{
  projectId: Scalars['String'];
}>;


export type DesignLayerTabPdfDesignLayersQuery = { __typename: 'Query', project: { __typename: 'Project', pdfDesignLayers: Array<{ __typename: 'PDFDesignLayer', index: number, json: { __typename: 'PDFDesignLayerJSON', allLayers: Array<number> | null, options: any | null, useAllLayers: boolean } | null }> } };

export type EditPdfDesignLayerMutationVariables = Exact<{
  input: EditPdfDesignLayerInput;
}>;


export type EditPdfDesignLayerMutation = { __typename: 'Mutation', editPDFDesignLayer: { __typename: 'EditPDFDesignLayerResponse', pdfDesignLayer: { __typename: 'PDFDesignLayer', index: number, json: { __typename: 'PDFDesignLayerJSON', allLayers: Array<number> | null, options: any | null, useAllLayers: boolean } | null } } };

export type GetProjectMapServerLayersQueryVariables = Exact<{
  globalId: Scalars['String'];
}>;


export type GetProjectMapServerLayersQuery = { __typename: 'Query', project: { __typename: 'Project', projectMetadata: { __typename: 'ProjectMetadata', mapServerLayers: Array<{ __typename: 'MapServerLayer', id: number, name: string }> } | null } };

export type PdfDesignLayerAsphaltMaterialsQueryVariables = Exact<{
  projectId: Scalars['String'];
}>;


export type PdfDesignLayerAsphaltMaterialsQuery = { __typename: 'Query', asphaltMaterials: { __typename: 'AsphaltMaterialListResponse', records: Array<{ __typename: 'AsphaltMaterial', globalId: string, placementType: string | null }> } };

export type PdfDesignLayerAsphaltPlacementsQueryVariables = Exact<{
  projectId: Scalars['String'];
}>;


export type PdfDesignLayerAsphaltPlacementsQuery = { __typename: 'Query', asphaltPlacements: { __typename: 'AsphaltPlacementListResponse', records: Array<{ __typename: 'AsphaltPlacement', globalId: string, placementId: string | null }> } };

export type PdfDesignLayerConcreteMaterialsQueryVariables = Exact<{
  projectId: Scalars['String'];
}>;


export type PdfDesignLayerConcreteMaterialsQuery = { __typename: 'Query', concreteMaterials: { __typename: 'ConcreteMaterialListResponse', records: Array<{ __typename: 'ConcreteMaterial', globalId: string, placementType: string | null }> } };

export type PdfDesignLayerConcretePlacementsQueryVariables = Exact<{
  projectId: Scalars['String'];
}>;


export type PdfDesignLayerConcretePlacementsQuery = { __typename: 'Query', concretePlacements: { __typename: 'ConcretePlacementListResponse', records: Array<{ __typename: 'ConcretePlacement', globalId: string, placementId: string | null }> } };

export type PdfDesignLayerDailyInspectionControlPointsQueryVariables = Exact<{
  projectId: Scalars['String'];
}>;


export type PdfDesignLayerDailyInspectionControlPointsQuery = { __typename: 'Query', dailyInspectionControlPoints: { __typename: 'DailyInspectionControlPointListResponse', records: Array<{ __typename: 'DailyInspectionControlPoint', globalId: string, controlPointId: string | null }> } };

export type PdfDesignLayerDailyInspectionInspectionsQueryVariables = Exact<{
  projectId: Scalars['String'];
}>;


export type PdfDesignLayerDailyInspectionInspectionsQuery = { __typename: 'Query', dailyInspectionInspections: { __typename: 'DailyInspectionInspectionListResponse', records: Array<{ __typename: 'DailyInspectionInspection', globalId: string, inspectionId: string | null }> } };

export type PdfDesignLayerDailyInspectionPunchListsQueryVariables = Exact<{
  projectId: Scalars['String'];
}>;


export type PdfDesignLayerDailyInspectionPunchListsQuery = { __typename: 'Query', dailyInspectionPunchLists: { __typename: 'DailyInspectionPunchListListResponse', records: Array<{ __typename: 'DailyInspectionPunchList', globalId: string, punchListId: string | null }> } };

export type PdfDesignLayerDailyInspectionWorkTypesQueryVariables = Exact<{
  projectId: Scalars['String'];
}>;


export type PdfDesignLayerDailyInspectionWorkTypesQuery = { __typename: 'Query', dailyInspectionWorkTypes: { __typename: 'DailyInspectionWorkTypeListResponse', records: Array<{ __typename: 'DailyInspectionWorkType', globalId: string, name: string | null }> } };

export type PdfDesignLayerLotsQueryVariables = Exact<{
  projectId: Scalars['String'];
}>;


export type PdfDesignLayerLotsQuery = { __typename: 'Query', lots: { __typename: 'LotListResponse', records: Array<{ __typename: 'Lot', globalId: string, lotId: string | null }> } };

export type PdfDesignLayerMaterialRequirementsQueryVariables = Exact<{
  projectId: Scalars['String'];
}>;


export type PdfDesignLayerMaterialRequirementsQuery = { __typename: 'Query', materialRequirements: { __typename: 'MaterialRequirementListResponse', records: Array<{ __typename: 'MaterialRequirement', globalId: string, materialSection: string | null }> } };

export type CancelPhotoExportRequestMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type CancelPhotoExportRequestMutation = { __typename: 'Mutation', cancelPhotoExportRequest: { __typename: 'CancelPhotoExportRequestResponse', photoExportRequest: { __typename: 'PhotoExportRequest', id: string } } };

export type QueuedPhotoExportRequestsQueryVariables = Exact<{
  photoExportRequestListInput: PhotoExportRequestListInput;
}>;


export type QueuedPhotoExportRequestsQuery = { __typename: 'Query', photoExportRequests: { __typename: 'PhotoExportRequestListResponse', records: Array<{ __typename: 'PhotoExportRequest', id: string, statusId: string, estimatedString: string, createdDate: string, startedDate: string | null, requestedBy: { __typename: 'User', id: string, displayName: string | null, mail: string }, json: { __typename: 'PhotoExportRequestJSON', arguments: { __typename: 'PhotoExportRequestArgumentsJSON', createdDate: { __typename: 'DateRange', from: string, to: string } } } }> } };

export type CreatePhotoExportRequestMutationVariables = Exact<{
  createPhotoExportRequestInput: CreatePhotoExportRequestInput;
}>;


export type CreatePhotoExportRequestMutation = { __typename: 'Mutation', createPhotoExportRequest: { __typename: 'CreatePhotoExportRequestResponse', photoExportRequest: { __typename: 'PhotoExportRequest', createdDate: string, requestedBy: { __typename: 'User', mail: string } } } };

export type ReportCasPacketInfoQueryVariables = Exact<{
  input: ConstructionAdminSubmittalListInput;
}>;


export type ReportCasPacketInfoQuery = { __typename: 'Query', constructionAdminSubmittals: { __typename: 'ConstructionAdminSubmittalListResponse', records: Array<{ __typename: 'ConstructionAdminSubmittal', id: string, sharePointFolderName: string, packetSharePointResource: { __typename: 'SharePointResource', downloadUrl: string | null } | null }> } };

export type ReportConcreteTestSetPacketInfoQueryVariables = Exact<{
  projectId: Scalars['String'];
  concreteTestSetFieldInput?: InputMaybe<ConcreteTestSetFieldInput>;
}>;


export type ReportConcreteTestSetPacketInfoQuery = { __typename: 'Query', project: { __typename: 'Project', concreteTestSets: Array<{ __typename: 'ConcreteTestSet', globalId: string, concreteTestSetMetadata: { __typename: 'ConcreteTestSetMetadata', packetSharePointResource: { __typename: 'SharePointResource', downloadUrl: string | null } | null } | null }> } };

export type AsphaltMixDesignCustomFieldFragment = { __typename: 'CustomField', name: string, description: string | null };

export type AsphaltMixDesignsMetadataQueryVariables = Exact<{
  projectId: Scalars['String'];
}>;


export type AsphaltMixDesignsMetadataQuery = { __typename: 'Query', limsAsphaltMixDesignTargets: { __typename: 'LIMSAsphaltMixDesignTargetListResponse', records: Array<{ __typename: 'LIMSAsphaltMixDesignTarget', id: string, name: string, description: string | null, required: boolean }> }, asphaltMaterialSources: { __typename: 'AsphaltMaterialSourceListResponse', records: Array<{ __typename: 'AsphaltMaterialSource', globalId: string, source: string | null }> } };

export type AsphaltMixDesignsQueryVariables = Exact<{
  projectId: Scalars['String'];
}>;


export type AsphaltMixDesignsQuery = { __typename: 'Query', asphaltMixDesigns: { __typename: 'AsphaltMixDesignListResponse', records: Array<{ __typename: 'AsphaltMixDesign', globalId: string, active: boolean, mixDesignNumber: string | null, supplier: string | null, grade: string | null, nominalSize: string | null, designBinderContent: number | null, vma: number | null, theoMaxSpecGrav: number | null, bulkSpecGravAgg: number | null, expirationDate: string | null, maxAggregateSize: number | null, asphaltMaterialSource: { __typename: 'AsphaltMaterialSource', globalId: string, source: string | null, isDeleted: boolean } | null, percentages: Array<{ __typename: 'AsphaltMixDesignTargetPercentage', percentage: number, target: { __typename: 'LIMSAsphaltMixDesignTarget', id: string, name: string, description: string | null, deleted: boolean } }>, customFields: { __typename: 'CustomFields', booleanValues: Array<{ __typename: 'BooleanCustomFieldValue', customFieldId: string, value: boolean, customField: { __typename: 'CustomField', name: string, description: string | null } }>, dateValues: Array<{ __typename: 'DateCustomFieldValue', customFieldId: string, value: string | null, customField: { __typename: 'CustomField', name: string, description: string | null } }>, entityValues: Array<{ __typename: 'EntityCustomFieldValues', customFieldId: string, customField: { __typename: 'CustomField', name: string, description: string | null }, entities: Array<{ __typename: 'EntityCustomFieldValue', recordId: string | null, href: string | null, entityId: string, label: string | null }> }>, listValues: { __typename: 'ListValues', singles: Array<{ __typename: 'ListCustomFieldValue', customFieldId: string, customField: { __typename: 'CustomField', name: string, description: string | null }, customListItem: { __typename: 'CustomListItem', id: string, deleted: boolean, value: string } | null }>, multiples: Array<{ __typename: 'ListCustomFieldValues', customFieldId: string, customField: { __typename: 'CustomField', name: string, description: string | null }, customListItems: Array<{ __typename: 'CustomListItem', id: string, deleted: boolean, value: string }> }>, checkboxes: Array<{ __typename: 'BooleanListCustomFieldValues', customFieldId: string, customField: { __typename: 'CustomField', name: string, description: string | null }, booleans: Array<{ __typename: 'BooleanListCustomFieldValue', customListItemId: string, checked: boolean, customListItem: { __typename: 'CustomListItem', value: string } }> }> }, numberValues: Array<{ __typename: 'NumberCustomFieldValue', customFieldId: string, value: number | null, customField: { __typename: 'CustomField', name: string, description: string | null } }>, reportValues: Array<{ __typename: 'ReportCustomFieldValues', customFieldId: string, customField: { __typename: 'CustomField', name: string, description: string | null }, reports: Array<{ __typename: 'ReportCustomFieldValue', recordId: string | null, reportId: string, href: string | null, label: string | null }> }>, textValues: Array<{ __typename: 'TextCustomFieldValue', customFieldId: string, value: string | null, customField: { __typename: 'CustomField', name: string, description: string | null } }> } }> } };

export type EditAsphaltMixDesignMutationVariables = Exact<{
  input: EditAsphaltMixDesignInput;
}>;


export type EditAsphaltMixDesignMutation = { __typename: 'Mutation', editAsphaltMixDesign: { __typename: 'EditAsphaltMixDesignResponse', mixDesign: { __typename: 'AsphaltMixDesign', globalId: string, mixDesignNumber: string | null } } };

export type CreateAsphaltMixDesignMutationVariables = Exact<{
  input: CreateAsphaltMixDesignInput;
}>;


export type CreateAsphaltMixDesignMutation = { __typename: 'Mutation', createAsphaltMixDesign: { __typename: 'CreateAsphaltMixDesignResponse', mixDesign: { __typename: 'AsphaltMixDesign', globalId: string, mixDesignNumber: string | null } } };

export type LimsAsphaltMixDesignTargetsQueryVariables = Exact<{
  input: LimsAsphaltMixDesignTargetListInput;
}>;


export type LimsAsphaltMixDesignTargetsQuery = { __typename: 'Query', limsAsphaltMixDesignTargets: { __typename: 'LIMSAsphaltMixDesignTargetListResponse', records: Array<{ __typename: 'LIMSAsphaltMixDesignTarget', id: string, name: string, description: string | null, required: boolean, deleted: boolean, deletedDate: string | null, deletedUser: string | null, percentages: Array<{ __typename: 'AsphaltMixDesignTargetPercentage', percentage: number, mixDesign: { __typename: 'AsphaltMixDesign', globalId: string, mixDesignNumber: string | null, active: boolean, deleted: boolean } }> }> } };

export type LimsAsphaltMixDesignTargetsMetadataQueryVariables = Exact<{
  projectId: Scalars['String'];
}>;


export type LimsAsphaltMixDesignTargetsMetadataQuery = { __typename: 'Query', asphaltMixDesigns: { __typename: 'AsphaltMixDesignListResponse', records: Array<{ __typename: 'AsphaltMixDesign', globalId: string, mixDesignNumber: string | null }> } };

export type EditLimsAsphaltMixDesignTargetMutationVariables = Exact<{
  input: EditLimsAsphaltMixDesignTargetInput;
}>;


export type EditLimsAsphaltMixDesignTargetMutation = { __typename: 'Mutation', editLIMSAsphaltMixDesignTarget: { __typename: 'EditLIMSAsphaltMixDesignTargetResponse', target: { __typename: 'LIMSAsphaltMixDesignTarget', name: string } } };

export type CreateLimsAsphaltMixDesignTargetMutationVariables = Exact<{
  input: CreateLimsAsphaltMixDesignTargetInput;
}>;


export type CreateLimsAsphaltMixDesignTargetMutation = { __typename: 'Mutation', createLIMSAsphaltMixDesignTarget: { __typename: 'CreateLIMSAsphaltMixDesignTargetResponse', target: { __typename: 'LIMSAsphaltMixDesignTarget', name: string } } };

export type RemoveAsphaltMixDesignTargetMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type RemoveAsphaltMixDesignTargetMutation = { __typename: 'Mutation', softRemoveLIMSAsphaltMixDesignTarget: { __typename: 'SoftRemoveLIMSAsphaltMixDesignTargetResponse', target: { __typename: 'LIMSAsphaltMixDesignTarget', name: string } } };

export type RestoreAsphaltMixDesignTargetMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type RestoreAsphaltMixDesignTargetMutation = { __typename: 'Mutation', restoreLIMSAsphaltMixDesignTarget: { __typename: 'RestoreLIMSAsphaltMixDesignTargetResponse', target: { __typename: 'LIMSAsphaltMixDesignTarget', name: string } } };

export type ConcreteMixDesignCustomFieldFragment = { __typename: 'CustomField', name: string, description: string | null };

export type ConcreteMixDesignsQueryVariables = Exact<{
  projectId: Scalars['String'];
}>;


export type ConcreteMixDesignsQuery = { __typename: 'Query', concreteMixDesigns: { __typename: 'ConcreteMixDesignListResponse', records: Array<{ __typename: 'ConcreteMixDesign', globalId: string, active: boolean, mixDesignNumber: string | null, expirationDate: string | null, admixtures: string | null, materialSource: string | null, class: string | null, concreteUse: string | null, submittalId: string | null, wc: string | null, airLow: number | null, airHigh: number | null, slumpLowInches: number | null, slumpHighInches: number | null, airRange: string | null, slumpRange: string | null, maxAggSize: string | null, aggregates: Array<string>, customFields: { __typename: 'CustomFields', booleanValues: Array<{ __typename: 'BooleanCustomFieldValue', customFieldId: string, value: boolean, customField: { __typename: 'CustomField', name: string, description: string | null } }>, dateValues: Array<{ __typename: 'DateCustomFieldValue', customFieldId: string, value: string | null, customField: { __typename: 'CustomField', name: string, description: string | null } }>, entityValues: Array<{ __typename: 'EntityCustomFieldValues', customFieldId: string, customField: { __typename: 'CustomField', name: string, description: string | null }, entities: Array<{ __typename: 'EntityCustomFieldValue', recordId: string | null, href: string | null, entityId: string, label: string | null }> }>, listValues: { __typename: 'ListValues', singles: Array<{ __typename: 'ListCustomFieldValue', customFieldId: string, customField: { __typename: 'CustomField', name: string, description: string | null }, customListItem: { __typename: 'CustomListItem', id: string, deleted: boolean, value: string } | null }>, multiples: Array<{ __typename: 'ListCustomFieldValues', customFieldId: string, customField: { __typename: 'CustomField', name: string, description: string | null }, customListItems: Array<{ __typename: 'CustomListItem', id: string, deleted: boolean, value: string }> }>, checkboxes: Array<{ __typename: 'BooleanListCustomFieldValues', customFieldId: string, customField: { __typename: 'CustomField', name: string, description: string | null }, booleans: Array<{ __typename: 'BooleanListCustomFieldValue', customListItemId: string, checked: boolean, customListItem: { __typename: 'CustomListItem', value: string } }> }> }, numberValues: Array<{ __typename: 'NumberCustomFieldValue', customFieldId: string, value: number | null, customField: { __typename: 'CustomField', name: string, description: string | null } }>, reportValues: Array<{ __typename: 'ReportCustomFieldValues', customFieldId: string, customField: { __typename: 'CustomField', name: string, description: string | null }, reports: Array<{ __typename: 'ReportCustomFieldValue', recordId: string | null, reportId: string, href: string | null, label: string | null }> }>, textValues: Array<{ __typename: 'TextCustomFieldValue', customFieldId: string, value: string | null, customField: { __typename: 'CustomField', name: string, description: string | null } }> } }> } };

export type CreateConcreteMixDesignMutationVariables = Exact<{
  input: CreateConcreteMixDesignInput;
}>;


export type CreateConcreteMixDesignMutation = { __typename: 'Mutation', createConcreteMixDesign: { __typename: 'CreateConcreteMixDesignResponse', mixDesign: { __typename: 'ConcreteMixDesign', globalId: string, mixDesignNumber: string | null } } };

export type EditConcreteMixDesignMutationVariables = Exact<{
  input: EditConcreteMixDesignInput;
}>;


export type EditConcreteMixDesignMutation = { __typename: 'Mutation', editConcreteMixDesign: { __typename: 'EditConcreteMixDesignResponse', mixDesign: { __typename: 'ConcreteMixDesign', globalId: string, mixDesignNumber: string | null } } };

export type PayItemConnectionsGroupFragment = { __typename: 'PayItemConnectionGroup', id: string, name: string, description: string | null };

export type PayItemConnectionsQueryVariables = Exact<{
  projectId: Scalars['String'];
}>;


export type PayItemConnectionsQuery = { __typename: 'Query', project: { __typename: 'Project', payItemConnectionGroups: Array<{ __typename: 'PayItemConnectionGroup', id: string, name: string, description: string | null }>, payItemConnections: Array<{ __typename: 'PayItemConnection', deleted: boolean, deletedDate: string | null, deletedUser: string | null, id: string, name: string | null, order: number | null, syncing: boolean, lastAttemptedDate: string | null, lastSyncDate: string | null, group: { __typename: 'PayItemConnectionGroup', order: number | null, id: string, name: string, description: string | null } | null, lastSyncError: { __typename: 'PayItemConnectionSyncError', message: string, stack: string | null } | null, googleSheet: { __typename: 'GoogleSheetPayItemConnection', title: string | null, sheetId: number, documentId: string, compositeId: string, url: string, payItemColumnKey: string | null, headers: Array<{ __typename: 'GoogleSheetPayItemConnectionHeader', id: string, formattedValue: string, order: number, visible: boolean }> } | null }> } };

export type CreateGoogleSheetPayItemConnectionMutationVariables = Exact<{
  input: CreateGoogleSheetPayItemConnectionInput;
}>;


export type CreateGoogleSheetPayItemConnectionMutation = { __typename: 'Mutation', createGoogleSheetPayItemConnection: { __typename: 'CreateGoogleSheetPayItemConnectionResponse', googleSheet: { __typename: 'GoogleSheetPayItemConnection', connection: { __typename: 'PayItemConnection', name: string | null } } } };

export type RemovePayItemConnectionMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type RemovePayItemConnectionMutation = { __typename: 'Mutation', softRemovePayItemConnection: { __typename: 'SoftRemovePayItemConnectionResponse', payItemConnection: { __typename: 'PayItemConnection', name: string | null, googleSheet: { __typename: 'GoogleSheetPayItemConnection', title: string | null } | null } } };

export type RestorePayItemConnectionMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type RestorePayItemConnectionMutation = { __typename: 'Mutation', restorePayItemConnection: { __typename: 'RestorePayItemConnectionResponse', payItemConnection: { __typename: 'PayItemConnection', name: string | null, googleSheet: { __typename: 'GoogleSheetPayItemConnection', title: string | null } | null } } };

export type PayItemConnectionGroupsConnectionFragment = { __typename: 'PayItemConnection', id: string, name: string | null, googleSheet: { __typename: 'GoogleSheetPayItemConnection', title: string | null, compositeId: string } | null };

export type PayItemConnectionGroupsQueryVariables = Exact<{
  globalId: Scalars['String'];
}>;


export type PayItemConnectionGroupsQuery = { __typename: 'Query', project: { __typename: 'Project', payItemConnections: Array<{ __typename: 'PayItemConnection', id: string, name: string | null, googleSheet: { __typename: 'GoogleSheetPayItemConnection', title: string | null, compositeId: string } | null }>, payItemConnectionGroups: Array<{ __typename: 'PayItemConnectionGroup', id: string, name: string, description: string | null, order: number | null, deleted: boolean, deletedDate: string | null, deletedUser: string | null, internalConnections: Array<{ __typename: 'ProjectToInternalConnection', internalConnectionId: string, order: number | null }>, connections: Array<{ __typename: 'PayItemConnection', order: number | null, id: string, name: string | null, googleSheet: { __typename: 'GoogleSheetPayItemConnection', title: string | null, compositeId: string } | null }> }> } };

export type CreatePayItemConnectionGroupMutationVariables = Exact<{
  input: CreatePayItemConnectionGroupInput;
}>;


export type CreatePayItemConnectionGroupMutation = { __typename: 'Mutation', createPayItemConnectionGroup: { __typename: 'CreatePayItemConnectionGroupResponse', payItemConnectionGroup: { __typename: 'PayItemConnectionGroup', name: string } } };

export type EditPayItemConnectionGroupMutationVariables = Exact<{
  input: EditPayItemConnectionGroupInput;
}>;


export type EditPayItemConnectionGroupMutation = { __typename: 'Mutation', editPayItemConnectionGroup: { __typename: 'EditPayItemConnectionGroupResponse', payItemConnectionGroup: { __typename: 'PayItemConnectionGroup', name: string } } };

export type RemovePayItemConnectionGroupMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type RemovePayItemConnectionGroupMutation = { __typename: 'Mutation', softRemovePayItemConnectionGroup: { __typename: 'SoftRemovePayItemConnectionGroupResponse', payItemConnectionGroup: { __typename: 'PayItemConnectionGroup', name: string } } };

export type RestorePayItemConnectionGroupMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type RestorePayItemConnectionGroupMutation = { __typename: 'Mutation', restorePayItemConnectionGroup: { __typename: 'RestorePayItemConnectionGroupResponse', payItemConnectionGroup: { __typename: 'PayItemConnectionGroup', name: string } } };

export type InternalPayItemConnectionsGroupFragment = { __typename: 'PayItemConnectionGroup', id: string, name: string, description: string | null };

export type InternalPayItemConnectionsQueryVariables = Exact<{
  projectId: Scalars['String'];
}>;


export type InternalPayItemConnectionsQuery = { __typename: 'Query', project: { __typename: 'Project', payItemConnectionGroups: Array<{ __typename: 'PayItemConnectionGroup', id: string, name: string, description: string | null }>, projectToInternalConnections: Array<{ __typename: 'ProjectToInternalConnection', order: number | null, internalConnectionId: string, group: { __typename: 'PayItemConnectionGroup', order: number | null, id: string, name: string, description: string | null } | null }> } };

export type EditProjectToGroupToInternalMutationVariables = Exact<{
  input: EditProjectToInternalConnectionInput;
}>;


export type EditProjectToGroupToInternalMutation = { __typename: 'Mutation', editProjectToInternalConnection: { __typename: 'EditProjectToInternalConnectionResponse', projectToInternalConnection: { __typename: 'ProjectToInternalConnection', internalConnection: string } } };

export type GoogleSheetPayItemConnectionHeaderFragment = { __typename: 'GoogleSheetPayItemConnectionHeader', id: string, formattedValue: string };

export type GoogleSheetPayItemConnectionQueryVariables = Exact<{
  connectionId: Scalars['String'];
  globalId: Scalars['String'];
}>;


export type GoogleSheetPayItemConnectionQuery = { __typename: 'Query', googleSheetPayItemConnection: { __typename: 'GoogleSheetPayItemConnection', connectionId: string, title: string | null, compositeId: string, url: string, headers: Array<{ __typename: 'GoogleSheetPayItemConnectionHeader', visible: boolean, order: number, id: string, formattedValue: string }>, records: { __typename: 'GoogleSheetPayItemConnectionRecords', headers: Array<{ __typename: 'GoogleSheetPayItemConnectionHeader', hyperlink: string | null, note: string | null, id: string, formattedValue: string }>, cells: Array<Array<{ __typename: 'GoogleSheetPayItemConnectionCell', id: string, headerId: string, formattedValue: string | null, hyperlink: string | null, note: string | null }>> } } };

export type PayItemSummarySiderCountsQueryVariables = Exact<{
  projectId: Scalars['String'];
  input: PayItemSummaryCountsInput;
}>;


export type PayItemSummarySiderCountsQuery = { __typename: 'Query', project: { __typename: 'Project', payItemSummaryCounts: { __typename: 'PayItemSummaryCounts', internalConnections: Array<{ __typename: 'InternalConnectionPayItemSummaryCount', count: number | null, internalConnectionId: string, groupId: string | null }>, payItemConnections: Array<{ __typename: 'PayItemConnectionPayItemSummaryCount', count: number | null, payItemConnection: { __typename: 'PayItemConnection', id: string, name: string | null, groupId: string | null, googleSheet: { __typename: 'GoogleSheetPayItemConnection', title: string | null, compositeId: string } | null } }> } | null } };

export type EditPayItemSummaryOrderMutationVariables = Exact<{
  input: EditPayItemSummaryOrderInput;
}>;


export type EditPayItemSummaryOrderMutation = { __typename: 'Mutation', editPayItemSummaryOrder: { __typename: 'EditPayItemSummaryOrderResponse', project: { __typename: 'Project', projectName: string | null } } };

export type PayItemSummaryQueryVariables = Exact<{
  projectId: Scalars['String'];
}>;


export type PayItemSummaryQuery = { __typename: 'Query', project: { __typename: 'Project', payItemConnections: Array<{ __typename: 'PayItemConnection', id: string, order: number | null, name: string | null, groupId: string | null, googleSheet: { __typename: 'GoogleSheetPayItemConnection', title: string | null, compositeId: string } | null }>, projectToInternalConnections: Array<{ __typename: 'ProjectToInternalConnection', internalConnectionId: string, groupId: string | null, order: number | null }>, payItemConnectionGroups: Array<{ __typename: 'PayItemConnectionGroup', id: string, name: string, description: string | null, order: number | null }> } };

export type EditGoogleSheetPayItemConnectionMutationVariables = Exact<{
  input: EditGoogleSheetPayItemConnectionInput;
}>;


export type EditGoogleSheetPayItemConnectionMutation = { __typename: 'Mutation', editGoogleSheetPayItemConnection: { __typename: 'EditGoogleSheetPayItemConnectionResponse', googleSheet: { __typename: 'GoogleSheetPayItemConnection', title: string | null, connection: { __typename: 'PayItemConnection', name: string | null } } } };

export type SyncGoogleSheetPayItemConnectionMutationVariables = Exact<{
  input: SyncGoogleSheetPayItemConnectionInput;
}>;


export type SyncGoogleSheetPayItemConnectionMutation = { __typename: 'Mutation', syncGoogleSheetPayItemConnection: { __typename: 'SyncGoogleSheetPayItemConnectionResponse', googleSheet: { __typename: 'GoogleSheetPayItemConnection', title: string | null, compositeId: string } } };

export type RfiNotificationsUserFragment = { __typename: 'User', id: string, displayName: string | null, mail: string, deleted: boolean, userGroups: Array<{ __typename: 'UserGroup', id: string }> };

export type RfiNotificationsRecipientsFragment = { __typename: 'Recipients', users: Array<{ __typename: 'User', id: string, displayName: string | null, mail: string, deleted: boolean, userGroups: Array<{ __typename: 'UserGroup', id: string }> }>, nonUserEmails: Array<{ __typename: 'NonUserEmail', id: number, label: string | null, description: string | null, address: string }> };

export type RfiNotificationsQueryVariables = Exact<{
  projectId: Scalars['String'];
}>;


export type RfiNotificationsQuery = { __typename: 'Query', project: { __typename: 'Project', rfiResponseDisciplines: Array<{ __typename: 'RFIResponseDiscipline', name: string, id: string, description: string | null, users: Array<{ __typename: 'User', id: string, displayName: string | null, mail: string, deleted: boolean, userGroups: Array<{ __typename: 'UserGroup', id: string }> }> }>, rfiNotifications: Array<{ __typename: 'RFINotification', notificationEventId: string, recipients: { __typename: 'RFINotificationRecipients', every: { __typename: 'Recipients', users: Array<{ __typename: 'User', id: string, displayName: string | null, mail: string, deleted: boolean, userGroups: Array<{ __typename: 'UserGroup', id: string }> }>, nonUserEmails: Array<{ __typename: 'NonUserEmail', id: number, label: string | null, description: string | null, address: string }> } | null, byResponseDiscipline: Array<{ __typename: 'ByResponseDiscipline', responseDiscipline: { __typename: 'RFIResponseDiscipline', id: string, name: string }, recipients: { __typename: 'Recipients', users: Array<{ __typename: 'User', id: string, displayName: string | null, mail: string, deleted: boolean, userGroups: Array<{ __typename: 'UserGroup', id: string }> }>, nonUserEmails: Array<{ __typename: 'NonUserEmail', id: number, label: string | null, description: string | null, address: string }> } }> } }>, requestsForInformation: Array<{ __typename: 'RequestForInformation', submittedBy: { __typename: 'User', id: string, displayName: string | null, mail: string, deleted: boolean, userGroups: Array<{ __typename: 'UserGroup', id: string }> } | null }> } };

export type EditRfiNotificationMutationVariables = Exact<{
  input: EditRfiNotificationInput;
}>;


export type EditRfiNotificationMutation = { __typename: 'Mutation', editRFINotification: { __typename: 'EditRFINotificationResponse', notification: { __typename: 'RFINotification', notificationEvent: string } } };

export type CreateRfiOrganizationMutationVariables = Exact<{
  createRfiOrganizationInput: CreateRfiOrganizationInput;
}>;


export type CreateRfiOrganizationMutation = { __typename: 'Mutation', createRFIOrganization: { __typename: 'CreateRFIOrganizationResponse', organization: { __typename: 'RFIOrganization', name: string } } };

export type EditRfiOrganizationMutationVariables = Exact<{
  editRfiOrganizationInput: EditRfiOrganizationInput;
}>;


export type EditRfiOrganizationMutation = { __typename: 'Mutation', editRFIOrganization: { __typename: 'EditRFIOrganizationResponse', organization: { __typename: 'RFIOrganization', name: string } } };

export type SoftRemoveRfiOrganizationMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type SoftRemoveRfiOrganizationMutation = { __typename: 'Mutation', softRemoveRFIOrganization: { __typename: 'SoftRemoveRFIOrganizationResponse', organization: { __typename: 'RFIOrganization', name: string } } };

export type RestoreRfiOrganizationMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type RestoreRfiOrganizationMutation = { __typename: 'Mutation', restoreRFIOrganization: { __typename: 'RestoreRFIOrganizationResponse', organization: { __typename: 'RFIOrganization', name: string } } };

export type GetRfiOrganizationsQueryVariables = Exact<{
  rfiOrganizationListInput: RfiOrganizationListInput;
}>;


export type GetRfiOrganizationsQuery = { __typename: 'Query', rfiOrganizations: { __typename: 'RFIOrganizationListResponse', records: Array<{ __typename: 'RFIOrganization', id: string, name: string, description: string | null, deleted: boolean, deletedDate: string | null, deletedUser: string | null, requestsForInformation: Array<{ __typename: 'RequestForInformation', id: string, formattedNumber: string, deleted: boolean }> }> } };

export type CreateRfiQuickLinkMutationVariables = Exact<{
  input: CreateRfiQuickLinkInput;
}>;


export type CreateRfiQuickLinkMutation = { __typename: 'Mutation', createRFIQuickLink: { __typename: 'CreateRFIQuickLinkResponse', rfiQuickLink: { __typename: 'RFIQuickLink', label: string } } };

export type EditRfiQuickLinkMutationVariables = Exact<{
  input: EditRfiQuickLinkInput;
}>;


export type EditRfiQuickLinkMutation = { __typename: 'Mutation', editRFIQuickLink: { __typename: 'EditRFIQuickLinkResponse', rfiQuickLink: { __typename: 'RFIQuickLink', label: string } } };

export type GetRfiQuickLinksQueryVariables = Exact<{
  input: RfiQuickLinkListInput;
}>;


export type GetRfiQuickLinksQuery = { __typename: 'Query', rfiQuickLinks: { __typename: 'RFIQuickLinkListResponse', records: Array<{ __typename: 'RFIQuickLink', id: string, label: string, href: string | null, description: string | null, deleted: boolean, deletedDate: string | null, deletedUser: string | null }> } };

export type RestoreRfiQuickLinkMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type RestoreRfiQuickLinkMutation = { __typename: 'Mutation', restoreRFIQuickLink: { __typename: 'RestoreRFIQuickLinkResponse', rfiQuickLink: { __typename: 'RFIQuickLink', label: string } } };

export type SoftRemoveRfiQuickLinkMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type SoftRemoveRfiQuickLinkMutation = { __typename: 'Mutation', softRemoveRFIQuickLink: { __typename: 'SoftRemoveRFIQuickLinkResponse', rfiQuickLink: { __typename: 'RFIQuickLink', label: string } } };

export type CreateRfiResponseMutationVariables = Exact<{
  createRfiResponseInput: CreateRfiResponseInput;
}>;


export type CreateRfiResponseMutation = { __typename: 'Mutation', createRFIResponse: { __typename: 'CreateRFIResponseResponse', response: { __typename: 'RFIResponse', createdUser: string } } };

export type DraftRequestForInformationMutationVariables = Exact<{
  draftRequestForInformationInput: DraftRequestForInformationInput;
}>;


export type DraftRequestForInformationMutation = { __typename: 'Mutation', draftRequestForInformation: { __typename: 'DraftRequestForInformationResponse', requestForInformation: { __typename: 'RequestForInformation', formattedNumber: string } } };

export type SubmitRequestForInformationMutationVariables = Exact<{
  submitRequestForInformationInput: SubmitRequestForInformationInput;
}>;


export type SubmitRequestForInformationMutation = { __typename: 'Mutation', submitRequestForInformation: { __typename: 'SubmitRequestForInformationResponse', requestForInformation: { __typename: 'RequestForInformation', formattedNumber: string } } };

export type RevertRequestForInformationMutationVariables = Exact<{
  revertRequestForInformationInput: RevertRequestForInformationInput;
}>;


export type RevertRequestForInformationMutation = { __typename: 'Mutation', revertRequestForInformation: { __typename: 'RevertRequestForInformationResponse', requestForInformation: { __typename: 'RequestForInformation', formattedNumber: string, statusId: string } } };

export type EditRequestForInformationMutationVariables = Exact<{
  editRequestForInformationInput: EditRequestForInformationInput;
}>;


export type EditRequestForInformationMutation = { __typename: 'Mutation', editRequestForInformation: { __typename: 'EditRequestForInformationResponse', requestForInformation: { __typename: 'RequestForInformation', formattedNumber: string } } };

export type CreateRfiCommentMutationVariables = Exact<{
  createRfiCommentInput: CreateRfiCommentInput;
}>;


export type CreateRfiCommentMutation = { __typename: 'Mutation', createRFIComment: { __typename: 'CreateRFICommentResponse', comment: { __typename: 'RFIComment', id: string } } };

export type EditRfiResponseMutationVariables = Exact<{
  input: EditRfiResponseInput;
}>;


export type EditRfiResponseMutation = { __typename: 'Mutation', editRFIResponse: { __typename: 'EditRFIResponseResponse', response: { __typename: 'RFIResponse', user: { __typename: 'User', mail: string, displayName: string | null } } } };

export type RestoreRfiResponseMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type RestoreRfiResponseMutation = { __typename: 'Mutation', restoreRFIResponse: { __typename: 'RestoreRFIResponseResponse', response: { __typename: 'RFIResponse', user: { __typename: 'User', mail: string, displayName: string | null } } } };

export type SoftRemoveRfiResponseMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type SoftRemoveRfiResponseMutation = { __typename: 'Mutation', softRemoveRFIResponse: { __typename: 'SoftRemoveRFIResponseResponse', response: { __typename: 'RFIResponse', user: { __typename: 'User', mail: string, displayName: string | null } } } };

export type SoftRemoveRequestForInformationMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type SoftRemoveRequestForInformationMutation = { __typename: 'Mutation', softRemoveRequestForInformation: { __typename: 'SoftRemoveRequestForInformationResponse', requestForInformation: { __typename: 'RequestForInformation', formattedNumber: string } } };

export type RestoreRequestForInformationMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type RestoreRequestForInformationMutation = { __typename: 'Mutation', restoreRequestForInformation: { __typename: 'RestoreRequestForInformationResponse', requestForInformation: { __typename: 'RequestForInformation', formattedNumber: string } } };

export type GetRfiTrackerTableMetadataQueryVariables = Exact<{
  globalId: Scalars['String'];
}>;


export type GetRfiTrackerTableMetadataQuery = { __typename: 'Query', project: { __typename: 'Project', rfiOrganizations: Array<{ __typename: 'RFIOrganization', id: string, name: string, description: string | null }>, rfiResponseDisciplines: Array<{ __typename: 'RFIResponseDiscipline', id: string, name: string, description: string | null, users: Array<{ __typename: 'User', id: string, deleted: boolean, userGroups: Array<{ __typename: 'UserGroup', id: string }> }> }>, rfiQuickLinks: Array<{ __typename: 'RFIQuickLink', id: string, label: string, href: string | null, description: string | null }> } };

export type RequestsForInformationCustomFieldFragment = { __typename: 'CustomField', name: string, description: string | null };

export type GetRequestsForInformationQueryVariables = Exact<{
  projectId: Scalars['String'];
  requestForInformationListInput: RequestForInformationListInput;
}>;


export type GetRequestsForInformationQuery = { __typename: 'Query', requestsForInformation: { __typename: 'RequestForInformationListResponse', records: Array<{ __typename: 'RequestForInformation', id: string, statusId: string, number: number, formattedNumber: string, deleted: boolean, deletedUser: string | null, deletedDate: string | null, description: string, organizationId: string | null, sharePointResourceId: string | null, sharePointResourceWebUrl: string | null, requestedResponseDate: string | null, submittedDate: string | null, closedDate: string | null, externalLinks: Array<{ __typename: 'ExternalLink', href: string, label: string }>, organization: { __typename: 'RFIOrganization', name: string } | null, submittedBy: { __typename: 'User', id: string, displayName: string | null, mail: string, deleted: boolean, userGroups: Array<{ __typename: 'UserGroup', id: string }> } | null, responseDisciplines: Array<{ __typename: 'RFIResponseDiscipline', id: string, name: string, description: string | null, users: Array<{ __typename: 'User', id: string }> }>, responses: Array<{ __typename: 'RFIResponse', id: string, closed: boolean, responseDisciplineId: string, responseDate: string, deleted: boolean, text: string, user: { __typename: 'User', displayName: string | null, mail: string } }>, comments: Array<{ __typename: 'RFIComment', text: string, createdDate: string, user: { __typename: 'User', mail: string } }>, customFields: { __typename: 'CustomFields', booleanValues: Array<{ __typename: 'BooleanCustomFieldValue', customFieldId: string, value: boolean, customField: { __typename: 'CustomField', name: string, description: string | null } }>, dateValues: Array<{ __typename: 'DateCustomFieldValue', customFieldId: string, value: string | null, customField: { __typename: 'CustomField', name: string, description: string | null } }>, entityValues: Array<{ __typename: 'EntityCustomFieldValues', customFieldId: string, customField: { __typename: 'CustomField', name: string, description: string | null }, entities: Array<{ __typename: 'EntityCustomFieldValue', recordId: string | null, href: string | null, entityId: string, label: string | null }> }>, listValues: { __typename: 'ListValues', singles: Array<{ __typename: 'ListCustomFieldValue', customFieldId: string, customField: { __typename: 'CustomField', name: string, description: string | null }, customListItem: { __typename: 'CustomListItem', id: string, deleted: boolean, value: string } | null }>, multiples: Array<{ __typename: 'ListCustomFieldValues', customFieldId: string, customField: { __typename: 'CustomField', name: string, description: string | null }, customListItems: Array<{ __typename: 'CustomListItem', id: string, deleted: boolean, value: string }> }>, checkboxes: Array<{ __typename: 'BooleanListCustomFieldValues', customFieldId: string, customField: { __typename: 'CustomField', name: string, description: string | null }, booleans: Array<{ __typename: 'BooleanListCustomFieldValue', customListItemId: string, checked: boolean, customListItem: { __typename: 'CustomListItem', value: string } }> }> }, numberValues: Array<{ __typename: 'NumberCustomFieldValue', customFieldId: string, value: number | null, customField: { __typename: 'CustomField', name: string, description: string | null } }>, reportValues: Array<{ __typename: 'ReportCustomFieldValues', customFieldId: string, customField: { __typename: 'CustomField', name: string, description: string | null }, reports: Array<{ __typename: 'ReportCustomFieldValue', recordId: string | null, reportId: string, href: string | null, label: string | null }> }>, textValues: Array<{ __typename: 'TextCustomFieldValue', customFieldId: string, value: string | null, customField: { __typename: 'CustomField', name: string, description: string | null } }> } }> } };

export type CreateRfiResponseDisciplineMutationVariables = Exact<{
  createRfiResponseDisciplineInput: CreateRfiResponseDisciplineInput;
}>;


export type CreateRfiResponseDisciplineMutation = { __typename: 'Mutation', createRFIResponseDiscipline: { __typename: 'CreateRFIResponseDisciplineResponse', responseDiscipline: { __typename: 'RFIResponseDiscipline', name: string } } };

export type EditRfiResponseDisciplineMutationVariables = Exact<{
  editRfiResponseDisciplineInput: EditRfiResponseDisciplineInput;
}>;


export type EditRfiResponseDisciplineMutation = { __typename: 'Mutation', editRFIResponseDiscipline: { __typename: 'EditRFIResponseDisciplineResponse', responseDiscipline: { __typename: 'RFIResponseDiscipline', name: string } } };

export type SoftRemoveRfiResponseDisciplineMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type SoftRemoveRfiResponseDisciplineMutation = { __typename: 'Mutation', softRemoveRFIResponseDiscipline: { __typename: 'SoftRemoveRFIResponseDisciplineResponse', responseDiscipline: { __typename: 'RFIResponseDiscipline', name: string } } };

export type RestoreRfiResponseDisciplineMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type RestoreRfiResponseDisciplineMutation = { __typename: 'Mutation', restoreRFIResponseDiscipline: { __typename: 'RestoreRFIResponseDisciplineResponse', responseDiscipline: { __typename: 'RFIResponseDiscipline', name: string } } };

export type GetRfiResponseDisciplinesQueryVariables = Exact<{
  rfiResponseDisciplineListInput: RfiResponseDisciplineListInput;
}>;


export type GetRfiResponseDisciplinesQuery = { __typename: 'Query', rfiResponseDisciplines: { __typename: 'RFIResponseDisciplineListResponse', records: Array<{ __typename: 'RFIResponseDiscipline', id: string, name: string, description: string | null, deleted: boolean, deletedDate: string | null, deletedUser: string | null, users: Array<{ __typename: 'User', id: string, displayName: string | null, mail: string, deleted: boolean, userGroups: Array<{ __typename: 'UserGroup', id: string }> }>, requestsForInformation: Array<{ __typename: 'RequestForInformation', id: string, formattedNumber: string, deleted: boolean }> }> } };

export type IfiNotificationRecipientsFragment = { __typename: 'Recipients', users: Array<{ __typename: 'User', id: string, displayName: string | null, mail: string, deleted: boolean, userGroups: Array<{ __typename: 'UserGroup', id: string }> }>, nonUserEmails: Array<{ __typename: 'NonUserEmail', id: number, label: string | null, description: string | null, address: string }> };

export type IfiNotificationsQueryVariables = Exact<{
  projectId: Scalars['String'];
}>;


export type IfiNotificationsQuery = { __typename: 'Query', project: { __typename: 'Project', ifiNotifications: Array<{ __typename: 'IFINotification', notificationEventId: string, recipients: { __typename: 'IFINotificationRecipients', every: { __typename: 'Recipients', users: Array<{ __typename: 'User', id: string, displayName: string | null, mail: string, deleted: boolean, userGroups: Array<{ __typename: 'UserGroup', id: string }> }>, nonUserEmails: Array<{ __typename: 'NonUserEmail', id: number, label: string | null, description: string | null, address: string }> } | null, asphaltLot: { __typename: 'Recipients', users: Array<{ __typename: 'User', id: string, displayName: string | null, mail: string, deleted: boolean, userGroups: Array<{ __typename: 'UserGroup', id: string }> }>, nonUserEmails: Array<{ __typename: 'NonUserEmail', id: number, label: string | null, description: string | null, address: string }> } | null, concreteTest: { __typename: 'Recipients', users: Array<{ __typename: 'User', id: string, displayName: string | null, mail: string, deleted: boolean, userGroups: Array<{ __typename: 'UserGroup', id: string }> }>, nonUserEmails: Array<{ __typename: 'NonUserEmail', id: number, label: string | null, description: string | null, address: string }> } | null, dailyInspectionControlPoint: { __typename: 'Recipients', users: Array<{ __typename: 'User', id: string, displayName: string | null, mail: string, deleted: boolean, userGroups: Array<{ __typename: 'UserGroup', id: string }> }>, nonUserEmails: Array<{ __typename: 'NonUserEmail', id: number, label: string | null, description: string | null, address: string }> } | null, dailyInspectionInspection: { __typename: 'Recipients', users: Array<{ __typename: 'User', id: string, displayName: string | null, mail: string, deleted: boolean, userGroups: Array<{ __typename: 'UserGroup', id: string }> }>, nonUserEmails: Array<{ __typename: 'NonUserEmail', id: number, label: string | null, description: string | null, address: string }> } | null, dailyInspectionPunchList: { __typename: 'Recipients', users: Array<{ __typename: 'User', id: string, displayName: string | null, mail: string, deleted: boolean, userGroups: Array<{ __typename: 'UserGroup', id: string }> }>, nonUserEmails: Array<{ __typename: 'NonUserEmail', id: number, label: string | null, description: string | null, address: string }> } | null, densityLot: { __typename: 'Recipients', users: Array<{ __typename: 'User', id: string, displayName: string | null, mail: string, deleted: boolean, userGroups: Array<{ __typename: 'UserGroup', id: string }> }>, nonUserEmails: Array<{ __typename: 'NonUserEmail', id: number, label: string | null, description: string | null, address: string }> } | null, densityTest: { __typename: 'Recipients', users: Array<{ __typename: 'User', id: string, displayName: string | null, mail: string, deleted: boolean, userGroups: Array<{ __typename: 'UserGroup', id: string }> }>, nonUserEmails: Array<{ __typename: 'NonUserEmail', id: number, label: string | null, description: string | null, address: string }> } | null }, frequency: { __typename: 'DailyFrequency', hour: number, minute: number } | { __typename: 'HourlyFrequency', hours: number } | { __typename: 'MinuteFrequency', minutes: number } | { __typename: 'WeeklyFrequency', day: number, hour: number, minute: number } | null }> } };

export type EditIfiNotificationMutationVariables = Exact<{
  input: EditIfiNotificationInput;
}>;


export type EditIfiNotificationMutation = { __typename: 'Mutation', editIFINotification: { __typename: 'EditIFINotificationResponse', notification: { __typename: 'IFINotification', notificationEvent: string } } };

export type EditIdentifiedFieldIssueMutationVariables = Exact<{
  input: EditIdentifiedFieldIssueInput;
}>;


export type EditIdentifiedFieldIssueMutation = { __typename: 'Mutation', editIdentifiedFieldIssue: { __typename: 'EditIdentifiedFieldIssueResponse', identifiedFieldIssue: { __typename: 'IdentifiedFieldIssue', reportId: string, reportName: string | null, asphaltLot: { __typename: 'AsphaltLot', asphaltLotId: string | null } | null, concreteTest: { __typename: 'ConcreteTest', fieldNumber: string | null } | null, dailyInspectionControlPoint: { __typename: 'DailyInspectionControlPoint', controlPointId: string | null } | null, dailyInspectionInspection: { __typename: 'DailyInspectionInspection', inspectionId: string | null } | null, dailyInspectionPunchList: { __typename: 'DailyInspectionPunchList', punchListId: string | null } | null, lot: { __typename: 'Lot', lotId: string | null } | null } } };

export type IfiTrackerCustomFieldFragment = { __typename: 'CustomField', name: string, description: string | null };

export type IfiTrackerUserFragment = { __typename: 'User', id: string, displayName: string | null, mail: string, deleted: boolean, userGroups: Array<{ __typename: 'UserGroup', id: string }> };

export type IfiTrackerPayItemFragment = { __typename: 'PayItemNoGeometry', globalId: string, deleted: boolean, label: string };

export type IfiTrackerTechnicianFragment = { __typename: 'Technician', technicianName: string | null };

export type IfiTrackerQueryVariables = Exact<{
  projectId: Scalars['String'];
  identifiedFieldIssueListInput: IdentifiedFieldIssueListInput;
}>;


export type IfiTrackerQuery = { __typename: 'Query', identifiedFieldIssueSyncs: Array<{ __typename: 'IdentifiedFieldIssueSync', syncing: boolean, lastEditedDate: string }>, issueQuickLinks: { __typename: 'IssueQuickLinkListResponse', records: Array<{ __typename: 'IssueQuickLink', id: string, label: string, href: string | null, description: string | null }> }, issues: { __typename: 'IssueListResponse', records: Array<{ __typename: 'Issue', id: string, formattedNumber: string, description: string | null }> }, engineeringJudgements: { __typename: 'EngineeringJudgementListResponse', records: Array<{ __typename: 'EngineeringJudgement', id: string, formattedNumber: string }> }, identifiedFieldIssues: { __typename: 'IdentifiedFieldIssueListResponse', records: Array<{ __typename: 'IdentifiedFieldIssue', reportId: string, reportTypeId: string, statusId: string, initialDescription: string | null, reportDescription: string | null, reportDate: string | null, reportName: string | null, reportReviewStatus: string | null, suggestedIssueTypes: Array<string>, reviewedDate: string | null, reviewNotes: string | null, reportTechnician: { __typename: 'Technician', technicianName: string | null } | null, reviewedBy: { __typename: 'User', id: string, displayName: string | null, mail: string, deleted: boolean, userGroups: Array<{ __typename: 'UserGroup', id: string }> } | null, customFields: { __typename: 'CustomFields', booleanValues: Array<{ __typename: 'BooleanCustomFieldValue', customFieldId: string, value: boolean, customField: { __typename: 'CustomField', name: string, description: string | null } }>, dateValues: Array<{ __typename: 'DateCustomFieldValue', customFieldId: string, value: string | null, customField: { __typename: 'CustomField', name: string, description: string | null } }>, entityValues: Array<{ __typename: 'EntityCustomFieldValues', customFieldId: string, customField: { __typename: 'CustomField', name: string, description: string | null }, entities: Array<{ __typename: 'EntityCustomFieldValue', recordId: string | null, href: string | null, entityId: string, label: string | null }> }>, listValues: { __typename: 'ListValues', singles: Array<{ __typename: 'ListCustomFieldValue', customFieldId: string, customField: { __typename: 'CustomField', name: string, description: string | null }, customListItem: { __typename: 'CustomListItem', id: string, deleted: boolean, value: string } | null }>, multiples: Array<{ __typename: 'ListCustomFieldValues', customFieldId: string, customField: { __typename: 'CustomField', name: string, description: string | null }, customListItems: Array<{ __typename: 'CustomListItem', id: string, deleted: boolean, value: string }> }>, checkboxes: Array<{ __typename: 'BooleanListCustomFieldValues', customFieldId: string, customField: { __typename: 'CustomField', name: string, description: string | null }, booleans: Array<{ __typename: 'BooleanListCustomFieldValue', customListItemId: string, checked: boolean, customListItem: { __typename: 'CustomListItem', value: string } }> }> }, numberValues: Array<{ __typename: 'NumberCustomFieldValue', customFieldId: string, value: number | null, customField: { __typename: 'CustomField', name: string, description: string | null } }>, reportValues: Array<{ __typename: 'ReportCustomFieldValues', customFieldId: string, customField: { __typename: 'CustomField', name: string, description: string | null }, reports: Array<{ __typename: 'ReportCustomFieldValue', recordId: string | null, reportId: string, href: string | null, label: string | null }> }>, textValues: Array<{ __typename: 'TextCustomFieldValue', customFieldId: string, value: string | null, customField: { __typename: 'CustomField', name: string, description: string | null } }> }, issues: Array<{ __typename: 'Issue', id: string, formattedNumber: string, description: string | null }>, engineeringJudgements: Array<{ __typename: 'EngineeringJudgement', id: string, formattedNumber: string }>, comments: Array<{ __typename: 'IFIComment', text: string, createdDate: string, user: { __typename: 'User', id: string, displayName: string | null, mail: string, deleted: boolean, userGroups: Array<{ __typename: 'UserGroup', id: string }> } }>, asphaltLot: { __typename: 'AsphaltLot', globalId: string, asphaltLotId: string | null, createdDate: string | null, lastEditedDate: string | null, deleted: string | null, reviewedBy: { __typename: 'Technician', technicianName: string | null } | null, payItemNoGeometries: Array<{ __typename: 'PayItemNoGeometry', globalId: string, deleted: boolean, label: string }> } | null, concreteTest: { __typename: 'ConcreteTest', globalId: string, fieldNumber: string | null, notes: string | null, overrideComments: string | null, percentAir: number | null, slump: number | null, concreteTemp: number | null, createdDate: string | null, lastEditedDate: string | null, deleted: string | null, percentAirTestedBy: { __typename: 'Technician', technicianName: string | null } | null, slumpTestedBy: { __typename: 'Technician', technicianName: string | null } | null, concreteTempTestedBy: { __typename: 'Technician', technicianName: string | null } | null, concreteTestSet: { __typename: 'ConcreteTestSet', concretePlacements: Array<{ __typename: 'ConcretePlacement', placementType: string | null }> } | null, payItemNoGeometries: Array<{ __typename: 'PayItemNoGeometry', globalId: string, deleted: boolean, label: string }> } | null, dailyInspectionControlPoint: { __typename: 'DailyInspectionControlPoint', globalId: string, controlPointId: string | null, createdDate: string | null, lastEditedDate: string | null, reviewDate: string | null, reviewStatus: string | null, submit: string | null, deleted: string | null, reportDate: string | null, reviewedBy: { __typename: 'Technician', technicianName: string | null } | null, workType: { __typename: 'DailyInspectionWorkType', name: string | null } | null, payItemNoGeometries: Array<{ __typename: 'PayItemNoGeometry', globalId: string, deleted: boolean, label: string }> } | null, dailyInspectionInspection: { __typename: 'DailyInspectionInspection', globalId: string, inspectionId: string | null, inspectionNotes: string | null, testingAndSamplingNotes: string | null, createdDate: string | null, lastEditedDate: string | null, reviewDate: string | null, reviewStatus: string | null, submit: string | null, deleted: string | null, reportDate: string | null, ncr: string | null, cdr: string | null, punchListCheck: string | null, ncrIssueDescription: string | null, reviewedBy: { __typename: 'Technician', technicianName: string | null } | null, workType: { __typename: 'DailyInspectionWorkType', name: string | null } | null, payItemNoGeometries: Array<{ __typename: 'PayItemNoGeometry', globalId: string, deleted: boolean, label: string }> } | null, dailyInspectionPunchList: { __typename: 'DailyInspectionPunchList', globalId: string, punchListId: string | null, createdDate: string | null, reviewDate: string | null, reviewStatus: string | null, submit: string | null, statusUpdate: string | null, lastEditedDate: string | null, deleted: string | null, reportDate: string | null, reviewedBy: { __typename: 'Technician', technicianName: string | null } | null, payItemNoGeometries: Array<{ __typename: 'PayItemNoGeometry', globalId: string, deleted: boolean, label: string }> } | null, lot: { __typename: 'Lot', globalId: string, lotId: string | null, createdDate: string | null, createdUser: string | null, lastEditedDate: string | null, globalProctorValue: number | null, compactionAverage: number | null, reviewedDate: string | null, deleted: boolean, material: { __typename: 'MaterialRequirement', lotCompactionRequirement: number | null } | null, payItemNoGeometries: Array<{ __typename: 'PayItemNoGeometry', globalId: string, deleted: boolean, label: string }> } | null, densityTest: { __typename: 'DensityTest', globalId: string, testId: string | null, createdDate: string | null, createdUser: string | null, lastEditedDate: string | null, averagePercent: number | null, deleted: string | null, lot: { __typename: 'Lot', globalId: string, lotId: string | null, compactionAverage: number | null, material: { __typename: 'MaterialRequirement', lotCompactionRequirement: number | null } | null } | null } | null }> } };

export type RevertIdentifiedFieldIssueMutationVariables = Exact<{
  input: RevertIdentifiedFieldIssueInput;
}>;


export type RevertIdentifiedFieldIssueMutation = { __typename: 'Mutation', revertIdentifiedFieldIssue: { __typename: 'RevertIdentifiedFieldIssueResponse', identifiedFieldIssue: { __typename: 'IdentifiedFieldIssue', reportId: string, reportName: string | null, asphaltLot: { __typename: 'AsphaltLot', asphaltLotId: string | null } | null, concreteTest: { __typename: 'ConcreteTest', fieldNumber: string | null } | null, dailyInspectionControlPoint: { __typename: 'DailyInspectionControlPoint', controlPointId: string | null } | null, dailyInspectionInspection: { __typename: 'DailyInspectionInspection', inspectionId: string | null } | null, dailyInspectionPunchList: { __typename: 'DailyInspectionPunchList', punchListId: string | null } | null, lot: { __typename: 'Lot', lotId: string | null } | null } } };

export type ReviewIdentifiedFieldIssueMutationVariables = Exact<{
  input: ReviewIdentifiedFieldIssueInput;
}>;


export type ReviewIdentifiedFieldIssueMutation = { __typename: 'Mutation', reviewIdentifiedFieldIssue: { __typename: 'ReviewIdentifiedFieldIssueResponse', identifiedFieldIssue: { __typename: 'IdentifiedFieldIssue', reportId: string, reportName: string | null, asphaltLot: { __typename: 'AsphaltLot', asphaltLotId: string | null } | null, concreteTest: { __typename: 'ConcreteTest', fieldNumber: string | null } | null, dailyInspectionControlPoint: { __typename: 'DailyInspectionControlPoint', controlPointId: string | null } | null, dailyInspectionInspection: { __typename: 'DailyInspectionInspection', inspectionId: string | null } | null, dailyInspectionPunchList: { __typename: 'DailyInspectionPunchList', punchListId: string | null } | null, lot: { __typename: 'Lot', lotId: string | null } | null } } };

export type RequestIfiSyncMutationVariables = Exact<{
  projectId: Scalars['String'];
}>;


export type RequestIfiSyncMutation = { __typename: 'Mutation', syncIdentifiedFieldIssues: { __typename: 'IdentifiedFieldIssueSync', lastEditedDate: string, syncing: boolean } };

export type CreateIfiCommentMutationVariables = Exact<{
  input: CreateIfiCommentInput;
}>;


export type CreateIfiCommentMutation = { __typename: 'Mutation', createIFIComment: { __typename: 'CreateIFICommentResponse', comment: { __typename: 'IFIComment', id: string } } };

export type AsphaltIssueReportOptionsQueryVariables = Exact<{
  globalId: Scalars['String'];
}>;


export type AsphaltIssueReportOptionsQuery = { __typename: 'Query', asphaltLots: { __typename: 'AsphaltLotListResponse', records: Array<{ __typename: 'AsphaltLot', globalId: string, asphaltLotId: string | null }> } };

export type ConcreteTestIssueReportOptionsQueryVariables = Exact<{
  globalId: Scalars['String'];
}>;


export type ConcreteTestIssueReportOptionsQuery = { __typename: 'Query', concreteTests: { __typename: 'ConcreteTestListResponse', records: Array<{ __typename: 'ConcreteTest', globalId: string, fieldNumber: string | null }> } };

export type ConcreteTestSetIssueReportOptionsQueryVariables = Exact<{
  globalId: Scalars['String'];
}>;


export type ConcreteTestSetIssueReportOptionsQuery = { __typename: 'Query', concreteTestSets: { __typename: 'ConcreteTestSetListResponse', records: Array<{ __typename: 'ConcreteTestSet', globalId: string, testSetId: string | null }> } };

export type ControlPointIssueReportOptionsQueryVariables = Exact<{
  globalId: Scalars['String'];
}>;


export type ControlPointIssueReportOptionsQuery = { __typename: 'Query', dailyInspectionControlPoints: { __typename: 'DailyInspectionControlPointListResponse', records: Array<{ __typename: 'DailyInspectionControlPoint', globalId: string, controlPointId: string | null }> } };

export type InspectionIssueReportOptionsQueryVariables = Exact<{
  globalId: Scalars['String'];
}>;


export type InspectionIssueReportOptionsQuery = { __typename: 'Query', dailyInspectionInspections: { __typename: 'DailyInspectionInspectionListResponse', records: Array<{ __typename: 'DailyInspectionInspection', globalId: string, inspectionId: string | null }> } };

export type LotIssueReportOptionsQueryVariables = Exact<{
  globalId: Scalars['String'];
}>;


export type LotIssueReportOptionsQuery = { __typename: 'Query', lots: { __typename: 'LotListResponse', records: Array<{ __typename: 'Lot', globalId: string, lotId: string | null }> } };

export type PunchListIssueReportOptionsQueryVariables = Exact<{
  globalId: Scalars['String'];
}>;


export type PunchListIssueReportOptionsQuery = { __typename: 'Query', dailyInspectionPunchLists: { __typename: 'DailyInspectionPunchListListResponse', records: Array<{ __typename: 'DailyInspectionPunchList', globalId: string, punchListId: string | null }> } };

export type IssueDispositionTypesQueryVariables = Exact<{
  projectId: Scalars['String'];
}>;


export type IssueDispositionTypesQuery = { __typename: 'Query', issueDispositionTypes: { __typename: 'IssueDispositionTypeListResponse', records: Array<{ __typename: 'IssueDispositionType', id: string, name: string, description: string | null, deleted: boolean, deletedDate: string | null, deletedUser: string | null, nonApplicableIssueTypes: Array<{ __typename: 'IssueType', id: string, name: string, description: string | null, deleted: boolean }>, issues: Array<{ __typename: 'Issue', id: string, formattedNumber: string, deleted: boolean }> }> } };

export type IssueDispositionTypesMetadataQueryVariables = Exact<{
  projectId: Scalars['String'];
}>;


export type IssueDispositionTypesMetadataQuery = { __typename: 'Query', project: { __typename: 'Project', issueTypes: Array<{ __typename: 'IssueType', id: string, name: string, description: string | null }> } };

export type CreateIssueDispositionTypeMutationVariables = Exact<{
  input: CreateIssueDispositionTypeInput;
}>;


export type CreateIssueDispositionTypeMutation = { __typename: 'Mutation', createIssueDispositionType: { __typename: 'CreateIssueDispositionTypeResponse', dispositionType: { __typename: 'IssueDispositionType', name: string } } };

export type EditIssueDispositionTypeMutationVariables = Exact<{
  input: EditIssueDispositionTypeInput;
}>;


export type EditIssueDispositionTypeMutation = { __typename: 'Mutation', editIssueDispositionType: { __typename: 'EditIssueDispositionTypeResponse', dispositionType: { __typename: 'IssueDispositionType', name: string } } };

export type RemoveIssueDispositionTypeMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type RemoveIssueDispositionTypeMutation = { __typename: 'Mutation', softRemoveIssueDispositionType: { __typename: 'SoftRemoveIssueDispositionTypeResponse', dispositionType: { __typename: 'IssueDispositionType', name: string } } };

export type RestoreIssueDispositionTypeMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type RestoreIssueDispositionTypeMutation = { __typename: 'Mutation', restoreIssueDispositionType: { __typename: 'RestoreIssueDispositionTypeResponse', dispositionType: { __typename: 'IssueDispositionType', name: string } } };

export type IssueNotificationRecipientsFragment = { __typename: 'Recipients', users: Array<{ __typename: 'User', id: string, displayName: string | null, mail: string, deleted: boolean, userGroups: Array<{ __typename: 'UserGroup', id: string }> }>, nonUserEmails: Array<{ __typename: 'NonUserEmail', id: number, label: string | null, address: string, description: string | null }> };

export type IssueNotificationsQueryVariables = Exact<{
  projectId: Scalars['String'];
}>;


export type IssueNotificationsQuery = { __typename: 'Query', project: { __typename: 'Project', issueTypes: Array<{ __typename: 'IssueType', id: string, name: string, description: string | null }>, issueNotifications: Array<{ __typename: 'IssueNotification', notificationEventId: string, recipients: { __typename: 'IssueNotificationRecipients', every: { __typename: 'Recipients', users: Array<{ __typename: 'User', id: string, displayName: string | null, mail: string, deleted: boolean, userGroups: Array<{ __typename: 'UserGroup', id: string }> }>, nonUserEmails: Array<{ __typename: 'NonUserEmail', id: number, label: string | null, address: string, description: string | null }> } | null, byIssueType: Array<{ __typename: 'ByIssueType', type: { __typename: 'IssueType', id: string, name: string, description: string | null }, recipients: { __typename: 'Recipients', users: Array<{ __typename: 'User', id: string, displayName: string | null, mail: string, deleted: boolean, userGroups: Array<{ __typename: 'UserGroup', id: string }> }>, nonUserEmails: Array<{ __typename: 'NonUserEmail', id: number, label: string | null, address: string, description: string | null }> } }> | null } }> } };

export type EditIssueNotificationMutationVariables = Exact<{
  input: EditIssueNotificationInput;
}>;


export type EditIssueNotificationMutation = { __typename: 'Mutation', editIssueNotification: { __typename: 'EditIssueNotificationResponse', notification: { __typename: 'IssueNotification', notificationEvent: string } } };

export type CreateIssueQuickLinkMutationVariables = Exact<{
  input: CreateIssueQuickLinkInput;
}>;


export type CreateIssueQuickLinkMutation = { __typename: 'Mutation', createIssueQuickLink: { __typename: 'CreateIssueQuickLinkResponse', quickLink: { __typename: 'IssueQuickLink', label: string } } };

export type EditIssueQuickLinkMutationVariables = Exact<{
  input: EditIssueQuickLinkInput;
}>;


export type EditIssueQuickLinkMutation = { __typename: 'Mutation', editIssueQuickLink: { __typename: 'EditIssueQuickLinkResponse', quickLink: { __typename: 'IssueQuickLink', label: string } } };

export type IssueQuickLinksQueryVariables = Exact<{
  input: IssueQuickLinkListInput;
}>;


export type IssueQuickLinksQuery = { __typename: 'Query', issueQuickLinks: { __typename: 'IssueQuickLinkListResponse', records: Array<{ __typename: 'IssueQuickLink', id: string, href: string | null, label: string, description: string | null, deleted: boolean, deletedDate: string | null, deletedUser: string | null }> } };

export type SoftRemoveIssueQuickLinkMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type SoftRemoveIssueQuickLinkMutation = { __typename: 'Mutation', softRemoveIssueQuickLink: { __typename: 'SoftRemoveIssueQuickLinkResponse', quickLink: { __typename: 'IssueQuickLink', label: string } } };

export type RestoreIssueQuickLinkMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type RestoreIssueQuickLinkMutation = { __typename: 'Mutation', restoreIssueQuickLink: { __typename: 'RestoreIssueQuickLinkResponse', quickLink: { __typename: 'IssueQuickLink', label: string } } };

export type EditIssueMutationVariables = Exact<{
  input: EditIssueInput;
}>;


export type EditIssueMutation = { __typename: 'Mutation', editIssue: { __typename: 'EditIssueResponse', issue: { __typename: 'Issue', formattedNumber: string } } };

export type IssueTrackerCustomFieldFragment = { __typename: 'CustomField', name: string, description: string | null };

export type IssueTrackerUserFragment = { __typename: 'User', id: string, displayName: string | null, mail: string, deleted: boolean, userGroups: Array<{ __typename: 'UserGroup', id: string }> };

export type IssueTrackerIssuesQueryVariables = Exact<{
  input: IssueListInput;
  projectId: Scalars['String'];
}>;


export type IssueTrackerIssuesQuery = { __typename: 'Query', issues: { __typename: 'IssueListResponse', records: Array<{ __typename: 'Issue', id: string, deleted: boolean, deletedUser: string | null, deletedDate: string | null, statusId: string, formattedNumber: string, number: number, sharePointResourceId: string | null, sharePointResourceWebUrl: string | null, description: string | null, submittedDate: string | null, response: string | null, responseDate: string | null, dispositionNotes: string | null, dispositionDate: string | null, closureNotes: string | null, closedDate: string | null, externalLinks: Array<{ __typename: 'ExternalLink', href: string, label: string }>, customFields: { __typename: 'CustomFields', booleanValues: Array<{ __typename: 'BooleanCustomFieldValue', customFieldId: string, value: boolean, customField: { __typename: 'CustomField', name: string, description: string | null } }>, dateValues: Array<{ __typename: 'DateCustomFieldValue', customFieldId: string, value: string | null, customField: { __typename: 'CustomField', name: string, description: string | null } }>, entityValues: Array<{ __typename: 'EntityCustomFieldValues', customFieldId: string, customField: { __typename: 'CustomField', name: string, description: string | null }, entities: Array<{ __typename: 'EntityCustomFieldValue', recordId: string | null, href: string | null, entityId: string, label: string | null }> }>, listValues: { __typename: 'ListValues', singles: Array<{ __typename: 'ListCustomFieldValue', customFieldId: string, customField: { __typename: 'CustomField', name: string, description: string | null }, customListItem: { __typename: 'CustomListItem', id: string, deleted: boolean, value: string } | null }>, multiples: Array<{ __typename: 'ListCustomFieldValues', customFieldId: string, customField: { __typename: 'CustomField', name: string, description: string | null }, customListItems: Array<{ __typename: 'CustomListItem', id: string, deleted: boolean, value: string }> }>, checkboxes: Array<{ __typename: 'BooleanListCustomFieldValues', customFieldId: string, customField: { __typename: 'CustomField', name: string, description: string | null }, booleans: Array<{ __typename: 'BooleanListCustomFieldValue', customListItemId: string, checked: boolean, customListItem: { __typename: 'CustomListItem', value: string } }> }> }, numberValues: Array<{ __typename: 'NumberCustomFieldValue', customFieldId: string, value: number | null, customField: { __typename: 'CustomField', name: string, description: string | null } }>, reportValues: Array<{ __typename: 'ReportCustomFieldValues', customFieldId: string, customField: { __typename: 'CustomField', name: string, description: string | null }, reports: Array<{ __typename: 'ReportCustomFieldValue', recordId: string | null, reportId: string, href: string | null, label: string | null }> }>, textValues: Array<{ __typename: 'TextCustomFieldValue', customFieldId: string, value: string | null, customField: { __typename: 'CustomField', name: string, description: string | null } }> }, identifiedFieldIssue: { __typename: 'IdentifiedFieldIssue', reportId: string, asphaltLot: { __typename: 'AsphaltLot', globalId: string, asphaltLotId: string | null } | null, concreteTest: { __typename: 'ConcreteTest', globalId: string, fieldNumber: string | null } | null, dailyInspectionControlPoint: { __typename: 'DailyInspectionControlPoint', globalId: string, controlPointId: string | null } | null, dailyInspectionInspection: { __typename: 'DailyInspectionInspection', globalId: string, inspectionId: string | null } | null, dailyInspectionPunchList: { __typename: 'DailyInspectionPunchList', globalId: string, punchListId: string | null } | null, lot: { __typename: 'Lot', globalId: string, lotId: string | null } | null } | null, types: Array<{ __typename: 'IssueType', id: string, name: string, description: string | null }>, submittedBy: { __typename: 'User', id: string, displayName: string | null, mail: string, deleted: boolean, userGroups: Array<{ __typename: 'UserGroup', id: string }> } | null, responseBy: { __typename: 'User', id: string, displayName: string | null, mail: string, deleted: boolean, userGroups: Array<{ __typename: 'UserGroup', id: string }> } | null, dispositionType: { __typename: 'IssueDispositionType', id: string, name: string, description: string | null, deleted: boolean } | null, dispositionBy: { __typename: 'User', id: string, displayName: string | null, mail: string, deleted: boolean, userGroups: Array<{ __typename: 'UserGroup', id: string }> } | null, closedBy: { __typename: 'User', id: string, displayName: string | null, mail: string, deleted: boolean, userGroups: Array<{ __typename: 'UserGroup', id: string }> } | null }> } };

export type IssueTrackerRelationsQueryVariables = Exact<{
  projectId: Scalars['String'];
  issueIds: Array<Scalars['String']> | Scalars['String'];
}>;


export type IssueTrackerRelationsQuery = { __typename: 'Query', issueQuickLinks: { __typename: 'IssueQuickLinkListResponse', records: Array<{ __typename: 'IssueQuickLink', id: string, label: string, description: string | null, href: string | null }> }, issueToReports: { __typename: 'IssueToReportListResponse', records: Array<{ __typename: 'IssueToReport', issueId: string, asphaltLot: { __typename: 'AsphaltLot', globalId: string, asphaltLotId: string | null } | null, concreteTest: { __typename: 'ConcreteTest', globalId: string, fieldNumber: string | null } | null, concreteTestSet: { __typename: 'ConcreteTestSet', globalId: string, testSetId: string | null } | null, dailyInspectionControlPoint: { __typename: 'DailyInspectionControlPoint', globalId: string, controlPointId: string | null } | null, dailyInspectionInspection: { __typename: 'DailyInspectionInspection', globalId: string, inspectionId: string | null } | null, dailyInspectionPunchList: { __typename: 'DailyInspectionPunchList', globalId: string, punchListId: string | null } | null, lot: { __typename: 'Lot', globalId: string, lotId: string | null } | null }> }, issueComments: { __typename: 'IssueCommentListResponse', records: Array<{ __typename: 'IssueComment', issueId: string, id: string, text: string, createdDate: string, user: { __typename: 'User', id: string, displayName: string | null, mail: string, deleted: boolean, userGroups: Array<{ __typename: 'UserGroup', id: string }> } }> }, issueToPayItemNoGeometries: { __typename: 'IssueToPayItemNoGeometryListResponse', records: Array<{ __typename: 'IssueToPayItemNoGeometry', issueId: string, payItem: { __typename: 'PayItemNoGeometry', globalId: string, deleted: boolean, label: string } }> } };

export type ActionModalMetadataQueryVariables = Exact<{
  projectId: Scalars['String'];
}>;


export type ActionModalMetadataQuery = { __typename: 'Query', issueDispositionTypes: { __typename: 'IssueDispositionTypeListResponse', records: Array<{ __typename: 'IssueDispositionType', id: string, name: string, description: string | null, nonApplicableIssueTypes: Array<{ __typename: 'IssueType', id: string }> }> } };

export type CloseIssueMutationVariables = Exact<{
  input: CloseIssueInput;
}>;


export type CloseIssueMutation = { __typename: 'Mutation', closeIssue: { __typename: 'CloseIssueResponse', issue: { __typename: 'Issue', formattedNumber: string } } };

export type GiveIssueDispositionMutationVariables = Exact<{
  input: GiveIssueDispositionInput;
}>;


export type GiveIssueDispositionMutation = { __typename: 'Mutation', giveIssueDisposition: { __typename: 'GiveIssueDispositionResponse', issue: { __typename: 'Issue', formattedNumber: string } } };

export type RespondToIssueMutationVariables = Exact<{
  input: RespondToIssueInput;
}>;


export type RespondToIssueMutation = { __typename: 'Mutation', respondToIssue: { __typename: 'RespondToIssueResponse', issue: { __typename: 'Issue', formattedNumber: string } } };

export type RevertIssueMutationVariables = Exact<{
  input: RevertIssueInput;
}>;


export type RevertIssueMutation = { __typename: 'Mutation', revertIssue: { __typename: 'RevertIssueResponse', issue: { __typename: 'Issue', formattedNumber: string, status: string } } };

export type EditIssueModalIssueTypesQueryVariables = Exact<{
  projectId: Scalars['String'];
}>;


export type EditIssueModalIssueTypesQuery = { __typename: 'Query', issueTypes: { __typename: 'IssueTypeListResponse', records: Array<{ __typename: 'IssueType', id: string, name: string, description: string | null }> } };

export type CreateIssueCommentMutationVariables = Exact<{
  input: CreateIssueCommentInput;
}>;


export type CreateIssueCommentMutation = { __typename: 'Mutation', createIssueComment: { __typename: 'CreateIssueCommentResponse', comment: { __typename: 'IssueComment', id: string } } };

export type SoftRemoveIssueMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type SoftRemoveIssueMutation = { __typename: 'Mutation', softRemoveIssue: { __typename: 'SoftRemoveIssueResponse', issue: { __typename: 'Issue', formattedNumber: string } } };

export type RestoreIssueMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type RestoreIssueMutation = { __typename: 'Mutation', restoreIssue: { __typename: 'RestoreIssueResponse', issue: { __typename: 'Issue', formattedNumber: string } } };

export type IssueTypesQueryVariables = Exact<{
  input: IssueTypeListInput;
}>;


export type IssueTypesQuery = { __typename: 'Query', issueTypes: { __typename: 'IssueTypeListResponse', records: Array<{ __typename: 'IssueType', id: string, name: string, description: string | null, deleted: boolean, deletedDate: string | null, deletedUser: string | null, nonApplicableIssueDispositionTypes: Array<{ __typename: 'IssueDispositionType', id: string, name: string, description: string | null, deleted: boolean }>, issues: Array<{ __typename: 'Issue', id: string, formattedNumber: string, deleted: boolean }> }> } };

export type IssueTypesMetadataQueryVariables = Exact<{
  projectId: Scalars['String'];
}>;


export type IssueTypesMetadataQuery = { __typename: 'Query', project: { __typename: 'Project', issueDispositionTypes: Array<{ __typename: 'IssueDispositionType', id: string, name: string, description: string | null }> } };

export type CreateIssueTypeMutationVariables = Exact<{
  input: CreateIssueTypeInput;
}>;


export type CreateIssueTypeMutation = { __typename: 'Mutation', createIssueType: { __typename: 'CreateIssueTypeResponse', type: { __typename: 'IssueType', name: string } } };

export type EditIssueTypeMutationVariables = Exact<{
  input: EditIssueTypeInput;
}>;


export type EditIssueTypeMutation = { __typename: 'Mutation', editIssueType: { __typename: 'EditIssueTypeResponse', type: { __typename: 'IssueType', name: string } } };

export type SoftRemoveIssueTypeMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type SoftRemoveIssueTypeMutation = { __typename: 'Mutation', softRemoveIssueType: { __typename: 'SoftRemoveIssueTypeResponse', type: { __typename: 'IssueType', name: string } } };

export type RestoreIssueTypeMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type RestoreIssueTypeMutation = { __typename: 'Mutation', restoreIssueType: { __typename: 'RestoreIssueTypeResponse', type: { __typename: 'IssueType', name: string } } };

export type CreateIssueFormItemsDataQueryVariables = Exact<{
  projectId: Scalars['String'];
}>;


export type CreateIssueFormItemsDataQuery = { __typename: 'Query', issueTypes: { __typename: 'IssueTypeListResponse', records: Array<{ __typename: 'IssueType', id: string, name: string, description: string | null }> } };

export type DraftIssueMutationVariables = Exact<{
  input: DraftIssueInput;
}>;


export type DraftIssueMutation = { __typename: 'Mutation', draftIssue: { __typename: 'DraftIssueResponse', issue: { __typename: 'Issue', formattedNumber: string } } };

export type RemoveTempIssueNumberMutationVariables = Exact<{
  input: SharePointResourceInput;
}>;


export type RemoveTempIssueNumberMutation = { __typename: 'Mutation', removeSharePointResource: { __typename: 'RemoveSharePointResourceResponse', removed: boolean } };

export type SubmitIssueMutationVariables = Exact<{
  input: SubmitIssueInput;
}>;


export type SubmitIssueMutation = { __typename: 'Mutation', submitIssue: { __typename: 'SubmitIssueResponse', issue: { __typename: 'Issue', formattedNumber: string } } };

export type RemoveSharePointResourceByFolderMutationVariables = Exact<{
  removeSharePointResourceInput: SharePointResourceInput;
}>;


export type RemoveSharePointResourceByFolderMutation = { __typename: 'Mutation', removeSharePointResource: { __typename: 'RemoveSharePointResourceResponse', message: string | null, removed: boolean } };

export type CustomFieldCasEntityOptionsQueryVariables = Exact<{
  globalId: Scalars['String'];
}>;


export type CustomFieldCasEntityOptionsQuery = { __typename: 'Query', constructionAdminSubmittals: { __typename: 'ConstructionAdminSubmittalListResponse', records: Array<{ __typename: 'ConstructionAdminSubmittal', sharePointFolderName: string, id: string }> } };

export type CustomFieldCtsEntityOptionsQueryVariables = Exact<{
  globalId: Scalars['String'];
}>;


export type CustomFieldCtsEntityOptionsQuery = { __typename: 'Query', concreteTestSets: { __typename: 'ConcreteTestSetListResponse', records: Array<{ __typename: 'ConcreteTestSet', testSetId: string | null, globalId: string }> } };

export type CustomFieldDsEntityOptionsQueryVariables = Exact<{
  globalId: Scalars['String'];
}>;


export type CustomFieldDsEntityOptionsQuery = { __typename: 'Query', designSubmittals: { __typename: 'DesignSubmittalListResponse', records: Array<{ __typename: 'DesignSubmittal', sharePointFolderName: string, id: string }> } };

export type CustomFieldFdcEntityOptionsQueryVariables = Exact<{
  globalId: Scalars['String'];
}>;


export type CustomFieldFdcEntityOptionsQuery = { __typename: 'Query', fieldDesignChanges: { __typename: 'FieldDesignChangeListResponse', records: Array<{ __typename: 'FieldDesignChange', number: number, id: string }> } };

export type LabTechSelectLabTechsQueryVariables = Exact<{
  globalId: Scalars['String'];
}>;


export type LabTechSelectLabTechsQuery = { __typename: 'Query', labTechs: { __typename: 'LabTechListResponse', records: Array<{ __typename: 'LabTech', id: number, name: string, user: { __typename: 'User', deleted: boolean, mail: string, displayName: string | null, id: string, userGroups: Array<{ __typename: 'UserGroup', id: string }> } | null }> } };

export type PayItemSelectPayItemNoGeometriesQueryVariables = Exact<{
  globalId: Scalars['String'];
}>;


export type PayItemSelectPayItemNoGeometriesQuery = { __typename: 'Query', payItemNoGeometries: { __typename: 'PayItemNoGeometryListResponse', records: Array<{ __typename: 'PayItemNoGeometry', globalId: string, deleted: boolean, label: string }> } };

export type PhotoExportAsphaltLotOptionsQueryVariables = Exact<{
  projectGlobalId: Scalars['String'];
}>;


export type PhotoExportAsphaltLotOptionsQuery = { __typename: 'Query', asphaltLots: { __typename: 'AsphaltLotListResponse', records: Array<{ __typename: 'AsphaltLot', asphaltLotId: string | null, globalId: string }> } };

export type PhotoExportConcreteTestSetOptionsQueryVariables = Exact<{
  projectGlobalId: Scalars['String'];
}>;


export type PhotoExportConcreteTestSetOptionsQuery = { __typename: 'Query', concreteTestSets: { __typename: 'ConcreteTestSetListResponse', records: Array<{ __typename: 'ConcreteTestSet', testSetId: string | null, globalId: string }> } };

export type PhotoExportControlPointOptionsQueryVariables = Exact<{
  projectGlobalId: Scalars['String'];
}>;


export type PhotoExportControlPointOptionsQuery = { __typename: 'Query', dailyInspectionControlPoints: { __typename: 'DailyInspectionControlPointListResponse', records: Array<{ __typename: 'DailyInspectionControlPoint', controlPointId: string | null, globalId: string }> } };

export type PhotoExportDensityLotOptionsQueryVariables = Exact<{
  projectGlobalId: Scalars['String'];
}>;


export type PhotoExportDensityLotOptionsQuery = { __typename: 'Query', lots: { __typename: 'LotListResponse', records: Array<{ __typename: 'Lot', lotId: string | null, globalId: string }> } };

export type PhotoExportInspectionOptionsQueryVariables = Exact<{
  projectGlobalId: Scalars['String'];
}>;


export type PhotoExportInspectionOptionsQuery = { __typename: 'Query', dailyInspectionInspections: { __typename: 'DailyInspectionInspectionListResponse', records: Array<{ __typename: 'DailyInspectionInspection', inspectionId: string | null, globalId: string }> } };

export type PhotoExportPunchListOptionsQueryVariables = Exact<{
  projectGlobalId: Scalars['String'];
}>;


export type PhotoExportPunchListOptionsQuery = { __typename: 'Query', dailyInspectionPunchLists: { __typename: 'DailyInspectionPunchListListResponse', records: Array<{ __typename: 'DailyInspectionPunchList', punchListId: string | null, globalId: string }> } };

export type RecipientsSelectRecipientsQueryVariables = Exact<{
  globalId: Scalars['String'];
}>;


export type RecipientsSelectRecipientsQuery = { __typename: 'Query', project: { __typename: 'Project', nonUserEmails: Array<{ __typename: 'NonUserEmail', id: number, label: string | null, address: string, description: string | null }>, users: Array<{ __typename: 'User', displayName: string | null, mail: string, id: string }> } };

export type AsphaltReportOptionsQueryVariables = Exact<{
  globalId: Scalars['String'];
}>;


export type AsphaltReportOptionsQuery = { __typename: 'Query', asphaltLots: { __typename: 'AsphaltLotListResponse', records: Array<{ __typename: 'AsphaltLot', globalId: string, asphaltLotId: string | null }> } };

export type CasReportOptionsQueryVariables = Exact<{
  input: ConstructionAdminSubmittalListInput;
}>;


export type CasReportOptionsQuery = { __typename: 'Query', constructionAdminSubmittals: { __typename: 'ConstructionAdminSubmittalListResponse', records: Array<{ __typename: 'ConstructionAdminSubmittal', id: string, packageNumber: string, packetSharePointResourceId: string | null }> } };

export type ConcretePlacementReportOptionsQueryVariables = Exact<{
  globalId: Scalars['String'];
}>;


export type ConcretePlacementReportOptionsQuery = { __typename: 'Query', concretePlacements: { __typename: 'ConcretePlacementListResponse', records: Array<{ __typename: 'ConcretePlacement', globalId: string, placementId: string | null }> } };

export type ConcreteTestReportOptionsQueryVariables = Exact<{
  globalId: Scalars['String'];
}>;


export type ConcreteTestReportOptionsQuery = { __typename: 'Query', concreteTests: { __typename: 'ConcreteTestListResponse', records: Array<{ __typename: 'ConcreteTest', globalId: string, fieldNumber: string | null, cylinderNumber: string | null, testSubId: string | null }> } };

export type ConcreteTestSetReportOptionsQueryVariables = Exact<{
  globalId: Scalars['String'];
}>;


export type ConcreteTestSetReportOptionsQuery = { __typename: 'Query', concreteTestSets: { __typename: 'ConcreteTestSetListResponse', records: Array<{ __typename: 'ConcreteTestSet', globalId: string, testSetId: string | null }> } };

export type ControlPointReportOptionsQueryVariables = Exact<{
  globalId: Scalars['String'];
}>;


export type ControlPointReportOptionsQuery = { __typename: 'Query', dailyInspectionControlPoints: { __typename: 'DailyInspectionControlPointListResponse', records: Array<{ __typename: 'DailyInspectionControlPoint', globalId: string, controlPointId: string | null }> } };

export type InspectionReportOptionsQueryVariables = Exact<{
  globalId: Scalars['String'];
}>;


export type InspectionReportOptionsQuery = { __typename: 'Query', dailyInspectionInspections: { __typename: 'DailyInspectionInspectionListResponse', records: Array<{ __typename: 'DailyInspectionInspection', globalId: string, inspectionId: string | null }> } };

export type LotReportOptionsQueryVariables = Exact<{
  globalId: Scalars['String'];
}>;


export type LotReportOptionsQuery = { __typename: 'Query', lots: { __typename: 'LotListResponse', records: Array<{ __typename: 'Lot', globalId: string, lotId: string | null }> } };

export type PunchListReportOptionsQueryVariables = Exact<{
  globalId: Scalars['String'];
}>;


export type PunchListReportOptionsQuery = { __typename: 'Query', dailyInspectionPunchLists: { __typename: 'DailyInspectionPunchListListResponse', records: Array<{ __typename: 'DailyInspectionPunchList', globalId: string, punchListId: string | null }> } };

export type TestingLabSelectTestingLabsQueryVariables = Exact<{
  projectId: Scalars['String'];
}>;


export type TestingLabSelectTestingLabsQuery = { __typename: 'Query', testingLabs: { __typename: 'TestingLabListResponse', records: Array<{ __typename: 'TestingLab', name: string, id: number }> } };

export type UserRoleSelectUsersRolesQueryVariables = Exact<{
  globalId: Scalars['String'];
}>;


export type UserRoleSelectUsersRolesQuery = { __typename: 'Query', project: { __typename: 'Project', users: Array<{ __typename: 'User', id: string, displayName: string | null, mail: string }>, roles: Array<{ __typename: 'Role', id: string, name: string, users: Array<{ __typename: 'User', id: string }> }> } };

export type UserSelectUsersQueryVariables = Exact<{
  globalId: Scalars['String'];
}>;


export type UserSelectUsersQuery = { __typename: 'Query', project: { __typename: 'Project', users: Array<{ __typename: 'User', displayName: string | null, mail: string, id: string }> } };

export type OrphanedSharePointResourceFragment = { __typename: 'SharePointResource', id: string, name: string | null };

export type OrphanedSharePointResourcesQueryVariables = Exact<{
  input: OrphanedSharePointResourcesInput;
}>;


export type OrphanedSharePointResourcesQuery = { __typename: 'Query', orphanedSharePointResources: { __typename: 'OrphanedSharePointResources', concreteTestSetResources: Array<{ __typename: 'SharePointResource', id: string, name: string | null }>, constructionAdminSubmittalResources: Array<{ __typename: 'SharePointResource', id: string, name: string | null }>, designSubmittalResources: Array<{ __typename: 'SharePointResource', id: string, name: string | null }>, fieldDesignChangeResources: Array<{ __typename: 'SharePointResource', id: string, name: string | null }> } };

export type RepairSharePointResourceMutationVariables = Exact<{
  input: RepairSharePointResourceInput;
}>;


export type RepairSharePointResourceMutation = { __typename: 'Mutation', repairSharePointResource: { __typename: 'RepairSharePointResourceResponse', sharePointResource: { __typename: 'SharePointResource', name: string | null } } };

export type SetSharePointResourcePermissionsMutationVariables = Exact<{
  input: SetSharePointResourcePermissionsInput;
}>;


export type SetSharePointResourcePermissionsMutation = { __typename: 'Mutation', setSharePointResourcePermissions: { __typename: 'SetSharePointResourcePermissionsResponse', constructionAdminSubmittal: { __typename: 'ConstructionAdminSubmittal', sharePointFolderName: string } | null, designSubmittal: { __typename: 'DesignSubmittal', sharePointFolderName: string } | null, concreteTestSet: { __typename: 'ConcreteTestSet', globalId: string, testSetId: string | null } | null, fieldDesignChange: { __typename: 'FieldDesignChange', formattedNumber: string } | null, requestForInformation: { __typename: 'RequestForInformation', formattedNumber: string } | null, issue: { __typename: 'Issue', formattedNumber: string } | null, user: { __typename: 'User', displayName: string | null, mail: string } } };

export type ProjectCustomFieldsUserFragmentFragment = { __typename: 'User', id: string, displayName: string | null, mail: string, deleted: boolean, userGroups: Array<{ __typename: 'UserGroup', id: string }> };

export type ProjectCustomFieldsQueryVariables = Exact<{
  projectId?: InputMaybe<Scalars['String']>;
  customFieldToClassTypeFieldInput: CustomFieldToClassTypeFieldInput;
}>;


export type ProjectCustomFieldsQuery = { __typename: 'Query', customFields: { __typename: 'CustomFieldListResponse', records: Array<{ __typename: 'CustomField', id: string, name: string, description: string | null, dataTypeId: string, deleted: boolean, deletedDate: string | null, deletedUser: string | null, metadata: { __typename: 'CustomFieldMetadata', styleId: string | null, entityIds: Array<string> | null, reportIds: Array<string> | null, timestamp: boolean | null }, customFieldToClassTypes: Array<{ __typename: 'CustomFieldToClassType', customFieldId: string, classTypeId: string, alwaysEditable: boolean, alwaysVisible: boolean, prominent: boolean, required: boolean, roles: Array<{ __typename: 'Role', id: string, name: string, users: Array<{ __typename: 'User', id: string, displayName: string | null, mail: string, deleted: boolean, userGroups: Array<{ __typename: 'UserGroup', id: string }> }> }>, users: Array<{ __typename: 'User', id: string, displayName: string | null, mail: string, deleted: boolean, userGroups: Array<{ __typename: 'UserGroup', id: string }> }> }>, customListItems: Array<{ __typename: 'CustomListItem', id: string, value: string }> }> } };

export type GetSharePointResourceForUploaderQueryVariables = Exact<{
  sharePointResourceInput: SharePointResourceInput;
}>;


export type GetSharePointResourceForUploaderQuery = { __typename: 'Query', sharePointResource: { __typename: 'SharePointResource', webUrl: string | null, sharePointResources: Array<{ __typename: 'SharePointResource', webUrl: string | null, id: string, name: string | null }> } | null };

export type RemoveSharePointUploadByIdMutationVariables = Exact<{
  sharePointResourceInput: SharePointResourceInput;
}>;


export type RemoveSharePointUploadByIdMutation = { __typename: 'Mutation', removeSharePointResource: { __typename: 'RemoveSharePointResourceResponse', message: string | null, removed: boolean } };

export const BareMinimumRoleFragmentFragmentDoc = gql`
    fragment BareMinimumRoleFragment on Role {
  id
  name
  permissions
}
    `;
export const ConcreteTestSetTrackerDocumentChecklistItemFragmentDoc = gql`
    fragment ConcreteTestSetTrackerDocumentChecklistItem on DocumentChecklistItem {
  id
  name
  documentChecklistItemToConcreteMaterials {
    concreteMaterial {
      placementType
    }
  }
}
    `;
export const ConcreteTestSetTrackerRelationsTestingLabFragmentDoc = gql`
    fragment ConcreteTestSetTrackerRelationsTestingLab on TestingLab {
  id
  name
}
    `;
export const ConcreteTestSetTrackerRelationsLabTechFragmentDoc = gql`
    fragment ConcreteTestSetTrackerRelationsLabTech on LabTech {
  id
  name
  user {
    id
    mail
    displayName
    deleted
    userGroups {
      id
    }
  }
}
    `;
export const ConcreteTestSetTrackerRelationsPayItemFragmentDoc = gql`
    fragment ConcreteTestSetTrackerRelationsPayItem on PayItemNoGeometry {
  globalId
  deleted
  label
}
    `;
export const ConcreteNotificationsUserFragmentDoc = gql`
    fragment ConcreteNotificationsUser on User {
  id
  displayName
  mail
  deleted
  userGroups {
    id
  }
}
    `;
export const ConcreteNotificationsRecipientsFragmentDoc = gql`
    fragment ConcreteNotificationsRecipients on Recipients {
  users(userFieldInput: {deleted: false}) {
    ...ConcreteNotificationsUser
  }
  nonUserEmails {
    id
    label
    description
    address
  }
}
    ${ConcreteNotificationsUserFragmentDoc}`;
export const LabTechsConcreteTestSetFragmentDoc = gql`
    fragment LabTechsConcreteTestSet on ConcreteTestSet {
  deleted
  globalId
  testSetId
}
    `;
export const TestingLabsConcreteTestSetFragmentDoc = gql`
    fragment TestingLabsConcreteTestSet on ConcreteTestSet {
  deleted
  globalId
  testSetId
}
    `;
export const CasNotificationsUserFragmentDoc = gql`
    fragment CASNotificationsUser on User {
  id
  displayName
  mail
  deleted
  userGroups {
    id
  }
}
    `;
export const CasNotificationsRecipientsFragmentDoc = gql`
    fragment CASNotificationsRecipients on Recipients {
  users(userFieldInput: {deleted: false}) {
    ...CASNotificationsUser
  }
  nonUserEmails {
    id
    label
    description
    address
  }
}
    ${CasNotificationsUserFragmentDoc}`;
export const DsNotificationsUserFragmentDoc = gql`
    fragment DSNotificationsUser on User {
  id
  displayName
  mail
  deleted
  userGroups {
    id
  }
}
    `;
export const DsNotificationsRecipientsFragmentDoc = gql`
    fragment DSNotificationsRecipients on Recipients {
  users(userFieldInput: {deleted: false}) {
    ...DSNotificationsUser
  }
  nonUserEmails {
    id
    label
    description
    address
  }
}
    ${DsNotificationsUserFragmentDoc}`;
export const EngineeringJudgementCustomFieldFragmentDoc = gql`
    fragment EngineeringJudgementCustomField on CustomField {
  name
  description
}
    `;
export const EjNotificationRecipientsFragmentDoc = gql`
    fragment EJNotificationRecipients on Recipients {
  users(userFieldInput: {deleted: false}) {
    id
    displayName
    mail
    deleted
    userGroups {
      id
    }
  }
  nonUserEmails {
    id
    label
    address
    description
  }
}
    `;
export const FdcApprovalGroupUserFragmentDoc = gql`
    fragment FDCApprovalGroupUser on User {
  id
  displayName
  mail
  deleted
  userGroups {
    id
  }
}
    `;
export const FdcConcurrenceGroupUserFragmentDoc = gql`
    fragment FDCConcurrenceGroupUser on User {
  id
  displayName
  mail
  deleted
  userGroups {
    id
  }
}
    `;
export const ProjectFieldDesignChangesCustomFieldFragmentDoc = gql`
    fragment ProjectFieldDesignChangesCustomField on CustomField {
  name
  description
}
    `;
export const FdcNotificationsUserFragmentDoc = gql`
    fragment FDCNotificationsUser on User {
  id
  displayName
  mail
  deleted
  userGroups {
    id
  }
}
    `;
export const FdcNotificationsRecipientsFragmentDoc = gql`
    fragment FDCNotificationsRecipients on Recipients {
  users(userFieldInput: {deleted: false}) {
    ...FDCNotificationsUser
  }
  nonUserEmails {
    id
    label
    description
    address
  }
}
    ${FdcNotificationsUserFragmentDoc}`;
export const FdcNotificationsRoleFragmentDoc = gql`
    fragment FDCNotificationsRole on Role {
  id
  name
  users {
    ...FDCNotificationsUser
  }
}
    ${FdcNotificationsUserFragmentDoc}`;
export const LayerFragmentDoc = gql`
    fragment layer on PDFDesignLayer {
  json {
    allLayers
    options
    useAllLayers
  }
  index
}
    `;
export const AsphaltMixDesignCustomFieldFragmentDoc = gql`
    fragment AsphaltMixDesignCustomField on CustomField {
  name
  description
}
    `;
export const ConcreteMixDesignCustomFieldFragmentDoc = gql`
    fragment ConcreteMixDesignCustomField on CustomField {
  name
  description
}
    `;
export const PayItemConnectionsGroupFragmentDoc = gql`
    fragment PayItemConnectionsGroup on PayItemConnectionGroup {
  id
  name
  description
}
    `;
export const PayItemConnectionGroupsConnectionFragmentDoc = gql`
    fragment PayItemConnectionGroupsConnection on PayItemConnection {
  id
  name
  googleSheet {
    title
    compositeId
  }
}
    `;
export const InternalPayItemConnectionsGroupFragmentDoc = gql`
    fragment InternalPayItemConnectionsGroup on PayItemConnectionGroup {
  id
  name
  description
}
    `;
export const GoogleSheetPayItemConnectionHeaderFragmentDoc = gql`
    fragment GoogleSheetPayItemConnectionHeader on GoogleSheetPayItemConnectionHeader {
  id
  formattedValue
}
    `;
export const RfiNotificationsUserFragmentDoc = gql`
    fragment RFINotificationsUser on User {
  id
  displayName
  mail
  deleted
  userGroups {
    id
  }
}
    `;
export const RfiNotificationsRecipientsFragmentDoc = gql`
    fragment RFINotificationsRecipients on Recipients {
  users(userFieldInput: {deleted: false}) {
    ...RFINotificationsUser
  }
  nonUserEmails {
    id
    label
    description
    address
  }
}
    ${RfiNotificationsUserFragmentDoc}`;
export const RequestsForInformationCustomFieldFragmentDoc = gql`
    fragment RequestsForInformationCustomField on CustomField {
  name
  description
}
    `;
export const IfiNotificationRecipientsFragmentDoc = gql`
    fragment IFINotificationRecipients on Recipients {
  users(userFieldInput: {deleted: false}) {
    id
    displayName
    mail
    deleted
    userGroups {
      id
    }
  }
  nonUserEmails {
    id
    label
    description
    address
  }
}
    `;
export const IfiTrackerCustomFieldFragmentDoc = gql`
    fragment IFITrackerCustomField on CustomField {
  name
  description
}
    `;
export const IfiTrackerUserFragmentDoc = gql`
    fragment IFITrackerUser on User {
  id
  displayName
  mail
  deleted
  userGroups {
    id
  }
}
    `;
export const IfiTrackerPayItemFragmentDoc = gql`
    fragment IFITrackerPayItem on PayItemNoGeometry {
  globalId
  deleted
  label
}
    `;
export const IfiTrackerTechnicianFragmentDoc = gql`
    fragment IFITrackerTechnician on Technician {
  technicianName
}
    `;
export const IssueNotificationRecipientsFragmentDoc = gql`
    fragment IssueNotificationRecipients on Recipients {
  users(userFieldInput: {deleted: false}) {
    id
    displayName
    mail
    deleted
    userGroups {
      id
    }
  }
  nonUserEmails {
    id
    label
    address
    description
  }
}
    `;
export const IssueTrackerCustomFieldFragmentDoc = gql`
    fragment IssueTrackerCustomField on CustomField {
  name
  description
}
    `;
export const IssueTrackerUserFragmentDoc = gql`
    fragment IssueTrackerUser on User {
  id
  displayName
  mail
  deleted
  userGroups {
    id
  }
}
    `;
export const OrphanedSharePointResourceFragmentDoc = gql`
    fragment OrphanedSharePointResource on SharePointResource {
  id
  name
}
    `;
export const ProjectCustomFieldsUserFragmentFragmentDoc = gql`
    fragment ProjectCustomFieldsUserFragment on User {
  id
  displayName
  mail
  deleted
  userGroups {
    id
  }
}
    `;
export const EditCustomFieldDocument = gql`
    mutation EditCustomField($editCustomFieldInput: EditCustomFieldInput!) {
  editCustomField(editCustomFieldInput: $editCustomFieldInput) {
    customField {
      name
    }
  }
}
    `;
export type EditCustomFieldMutationFn = Apollo.MutationFunction<EditCustomFieldMutation, EditCustomFieldMutationVariables>;

/**
 * __useEditCustomFieldMutation__
 *
 * To run a mutation, you first call `useEditCustomFieldMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditCustomFieldMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editCustomFieldMutation, { data, loading, error }] = useEditCustomFieldMutation({
 *   variables: {
 *      editCustomFieldInput: // value for 'editCustomFieldInput'
 *   },
 * });
 */
export function useEditCustomFieldMutation(baseOptions?: Apollo.MutationHookOptions<EditCustomFieldMutation, EditCustomFieldMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditCustomFieldMutation, EditCustomFieldMutationVariables>(EditCustomFieldDocument, options);
      }
export type EditCustomFieldMutationHookResult = ReturnType<typeof useEditCustomFieldMutation>;
export type EditCustomFieldMutationResult = Apollo.MutationResult<EditCustomFieldMutation>;
export type EditCustomFieldMutationOptions = Apollo.BaseMutationOptions<EditCustomFieldMutation, EditCustomFieldMutationVariables>;
export const CreateCustomFieldDocument = gql`
    mutation CreateCustomField($createCustomFieldInput: CreateCustomFieldInput!) {
  createCustomField(createCustomFieldInput: $createCustomFieldInput) {
    customField {
      name
    }
  }
}
    `;
export type CreateCustomFieldMutationFn = Apollo.MutationFunction<CreateCustomFieldMutation, CreateCustomFieldMutationVariables>;

/**
 * __useCreateCustomFieldMutation__
 *
 * To run a mutation, you first call `useCreateCustomFieldMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCustomFieldMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCustomFieldMutation, { data, loading, error }] = useCreateCustomFieldMutation({
 *   variables: {
 *      createCustomFieldInput: // value for 'createCustomFieldInput'
 *   },
 * });
 */
export function useCreateCustomFieldMutation(baseOptions?: Apollo.MutationHookOptions<CreateCustomFieldMutation, CreateCustomFieldMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateCustomFieldMutation, CreateCustomFieldMutationVariables>(CreateCustomFieldDocument, options);
      }
export type CreateCustomFieldMutationHookResult = ReturnType<typeof useCreateCustomFieldMutation>;
export type CreateCustomFieldMutationResult = Apollo.MutationResult<CreateCustomFieldMutation>;
export type CreateCustomFieldMutationOptions = Apollo.BaseMutationOptions<CreateCustomFieldMutation, CreateCustomFieldMutationVariables>;
export const EditCustomFieldToClassTypeDocument = gql`
    mutation EditCustomFieldToClassType($editCustomFieldToClassTypeInput: EditCustomFieldToClassTypeInput!) {
  editCustomFieldToClassType(
    editCustomFieldToClassTypeInput: $editCustomFieldToClassTypeInput
  ) {
    customFieldToClassType {
      customField {
        name
      }
      classType
    }
  }
}
    `;
export type EditCustomFieldToClassTypeMutationFn = Apollo.MutationFunction<EditCustomFieldToClassTypeMutation, EditCustomFieldToClassTypeMutationVariables>;

/**
 * __useEditCustomFieldToClassTypeMutation__
 *
 * To run a mutation, you first call `useEditCustomFieldToClassTypeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditCustomFieldToClassTypeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editCustomFieldToClassTypeMutation, { data, loading, error }] = useEditCustomFieldToClassTypeMutation({
 *   variables: {
 *      editCustomFieldToClassTypeInput: // value for 'editCustomFieldToClassTypeInput'
 *   },
 * });
 */
export function useEditCustomFieldToClassTypeMutation(baseOptions?: Apollo.MutationHookOptions<EditCustomFieldToClassTypeMutation, EditCustomFieldToClassTypeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditCustomFieldToClassTypeMutation, EditCustomFieldToClassTypeMutationVariables>(EditCustomFieldToClassTypeDocument, options);
      }
export type EditCustomFieldToClassTypeMutationHookResult = ReturnType<typeof useEditCustomFieldToClassTypeMutation>;
export type EditCustomFieldToClassTypeMutationResult = Apollo.MutationResult<EditCustomFieldToClassTypeMutation>;
export type EditCustomFieldToClassTypeMutationOptions = Apollo.BaseMutationOptions<EditCustomFieldToClassTypeMutation, EditCustomFieldToClassTypeMutationVariables>;
export const SoftRemoveCustomFieldDocument = gql`
    mutation SoftRemoveCustomField($id: String!) {
  softRemoveCustomField(id: $id) {
    customField {
      name
    }
  }
}
    `;
export type SoftRemoveCustomFieldMutationFn = Apollo.MutationFunction<SoftRemoveCustomFieldMutation, SoftRemoveCustomFieldMutationVariables>;

/**
 * __useSoftRemoveCustomFieldMutation__
 *
 * To run a mutation, you first call `useSoftRemoveCustomFieldMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSoftRemoveCustomFieldMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [softRemoveCustomFieldMutation, { data, loading, error }] = useSoftRemoveCustomFieldMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSoftRemoveCustomFieldMutation(baseOptions?: Apollo.MutationHookOptions<SoftRemoveCustomFieldMutation, SoftRemoveCustomFieldMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SoftRemoveCustomFieldMutation, SoftRemoveCustomFieldMutationVariables>(SoftRemoveCustomFieldDocument, options);
      }
export type SoftRemoveCustomFieldMutationHookResult = ReturnType<typeof useSoftRemoveCustomFieldMutation>;
export type SoftRemoveCustomFieldMutationResult = Apollo.MutationResult<SoftRemoveCustomFieldMutation>;
export type SoftRemoveCustomFieldMutationOptions = Apollo.BaseMutationOptions<SoftRemoveCustomFieldMutation, SoftRemoveCustomFieldMutationVariables>;
export const RestoreCustomFieldDocument = gql`
    mutation RestoreCustomField($id: String!) {
  restoreCustomField(id: $id) {
    customField {
      name
    }
  }
}
    `;
export type RestoreCustomFieldMutationFn = Apollo.MutationFunction<RestoreCustomFieldMutation, RestoreCustomFieldMutationVariables>;

/**
 * __useRestoreCustomFieldMutation__
 *
 * To run a mutation, you first call `useRestoreCustomFieldMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRestoreCustomFieldMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [restoreCustomFieldMutation, { data, loading, error }] = useRestoreCustomFieldMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRestoreCustomFieldMutation(baseOptions?: Apollo.MutationHookOptions<RestoreCustomFieldMutation, RestoreCustomFieldMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RestoreCustomFieldMutation, RestoreCustomFieldMutationVariables>(RestoreCustomFieldDocument, options);
      }
export type RestoreCustomFieldMutationHookResult = ReturnType<typeof useRestoreCustomFieldMutation>;
export type RestoreCustomFieldMutationResult = Apollo.MutationResult<RestoreCustomFieldMutation>;
export type RestoreCustomFieldMutationOptions = Apollo.BaseMutationOptions<RestoreCustomFieldMutation, RestoreCustomFieldMutationVariables>;
export const CreateNonUserEmailDocument = gql`
    mutation CreateNonUserEmail($createNonUserEmailInput: CreateNonUserEmailInput!) {
  createNonUserEmail(createNonUserEmailInput: $createNonUserEmailInput) {
    nonUserEmail {
      label
      address
    }
  }
}
    `;
export type CreateNonUserEmailMutationFn = Apollo.MutationFunction<CreateNonUserEmailMutation, CreateNonUserEmailMutationVariables>;

/**
 * __useCreateNonUserEmailMutation__
 *
 * To run a mutation, you first call `useCreateNonUserEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateNonUserEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createNonUserEmailMutation, { data, loading, error }] = useCreateNonUserEmailMutation({
 *   variables: {
 *      createNonUserEmailInput: // value for 'createNonUserEmailInput'
 *   },
 * });
 */
export function useCreateNonUserEmailMutation(baseOptions?: Apollo.MutationHookOptions<CreateNonUserEmailMutation, CreateNonUserEmailMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateNonUserEmailMutation, CreateNonUserEmailMutationVariables>(CreateNonUserEmailDocument, options);
      }
export type CreateNonUserEmailMutationHookResult = ReturnType<typeof useCreateNonUserEmailMutation>;
export type CreateNonUserEmailMutationResult = Apollo.MutationResult<CreateNonUserEmailMutation>;
export type CreateNonUserEmailMutationOptions = Apollo.BaseMutationOptions<CreateNonUserEmailMutation, CreateNonUserEmailMutationVariables>;
export const EditNonUserEmailDocument = gql`
    mutation EditNonUserEmail($editNonUserEmailInput: EditNonUserEmailInput!) {
  editNonUserEmail(editNonUserEmailInput: $editNonUserEmailInput) {
    nonUserEmail {
      label
      address
    }
  }
}
    `;
export type EditNonUserEmailMutationFn = Apollo.MutationFunction<EditNonUserEmailMutation, EditNonUserEmailMutationVariables>;

/**
 * __useEditNonUserEmailMutation__
 *
 * To run a mutation, you first call `useEditNonUserEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditNonUserEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editNonUserEmailMutation, { data, loading, error }] = useEditNonUserEmailMutation({
 *   variables: {
 *      editNonUserEmailInput: // value for 'editNonUserEmailInput'
 *   },
 * });
 */
export function useEditNonUserEmailMutation(baseOptions?: Apollo.MutationHookOptions<EditNonUserEmailMutation, EditNonUserEmailMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditNonUserEmailMutation, EditNonUserEmailMutationVariables>(EditNonUserEmailDocument, options);
      }
export type EditNonUserEmailMutationHookResult = ReturnType<typeof useEditNonUserEmailMutation>;
export type EditNonUserEmailMutationResult = Apollo.MutationResult<EditNonUserEmailMutation>;
export type EditNonUserEmailMutationOptions = Apollo.BaseMutationOptions<EditNonUserEmailMutation, EditNonUserEmailMutationVariables>;
export const RemoveNonUserEmailDocument = gql`
    mutation RemoveNonUserEmail($id: Int!) {
  removeNonUserEmail(id: $id) {
    nonUserEmail {
      label
      address
    }
  }
}
    `;
export type RemoveNonUserEmailMutationFn = Apollo.MutationFunction<RemoveNonUserEmailMutation, RemoveNonUserEmailMutationVariables>;

/**
 * __useRemoveNonUserEmailMutation__
 *
 * To run a mutation, you first call `useRemoveNonUserEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveNonUserEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeNonUserEmailMutation, { data, loading, error }] = useRemoveNonUserEmailMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRemoveNonUserEmailMutation(baseOptions?: Apollo.MutationHookOptions<RemoveNonUserEmailMutation, RemoveNonUserEmailMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveNonUserEmailMutation, RemoveNonUserEmailMutationVariables>(RemoveNonUserEmailDocument, options);
      }
export type RemoveNonUserEmailMutationHookResult = ReturnType<typeof useRemoveNonUserEmailMutation>;
export type RemoveNonUserEmailMutationResult = Apollo.MutationResult<RemoveNonUserEmailMutation>;
export type RemoveNonUserEmailMutationOptions = Apollo.BaseMutationOptions<RemoveNonUserEmailMutation, RemoveNonUserEmailMutationVariables>;
export const GetNonUserEmailsDocument = gql`
    query GetNonUserEmails($input: NonUserEmailListInput!) {
  nonUserEmails(nonUserEmailListInput: $input) {
    records {
      id
      label
      description
      address
      createdDate
    }
  }
}
    `;

/**
 * __useGetNonUserEmailsQuery__
 *
 * To run a query within a React component, call `useGetNonUserEmailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNonUserEmailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNonUserEmailsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetNonUserEmailsQuery(baseOptions: Apollo.QueryHookOptions<GetNonUserEmailsQuery, GetNonUserEmailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetNonUserEmailsQuery, GetNonUserEmailsQueryVariables>(GetNonUserEmailsDocument, options);
      }
export function useGetNonUserEmailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetNonUserEmailsQuery, GetNonUserEmailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetNonUserEmailsQuery, GetNonUserEmailsQueryVariables>(GetNonUserEmailsDocument, options);
        }
export type GetNonUserEmailsQueryHookResult = ReturnType<typeof useGetNonUserEmailsQuery>;
export type GetNonUserEmailsLazyQueryHookResult = ReturnType<typeof useGetNonUserEmailsLazyQuery>;
export type GetNonUserEmailsQueryResult = Apollo.QueryResult<GetNonUserEmailsQuery, GetNonUserEmailsQueryVariables>;
export const ConcreteTestIfiSettingsDocument = gql`
    query ConcreteTestIFISettings($projectId: String!) {
  concreteTestIFISettings(
    concreteTestIFISettingsListInput: {projectId: {equals: $projectId}}
  ) {
    records {
      enabled
      effectiveDate
      ambientAir {
        enabled
        effectiveDate
        minimumAmbientAirTemperature
        message
      }
      temperature {
        enabled
        effectiveDate
        tempRange
        temperatureHigh
        temperatureLow
        highMessage
        lowMessage
      }
      slump {
        enabled
        effectiveDate
        highMessage
        lowMessage
      }
      percentAir {
        enabled
        effectiveDate
        highMessage
        lowMessage
      }
    }
  }
}
    `;

/**
 * __useConcreteTestIfiSettingsQuery__
 *
 * To run a query within a React component, call `useConcreteTestIfiSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useConcreteTestIfiSettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useConcreteTestIfiSettingsQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useConcreteTestIfiSettingsQuery(baseOptions: Apollo.QueryHookOptions<ConcreteTestIfiSettingsQuery, ConcreteTestIfiSettingsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ConcreteTestIfiSettingsQuery, ConcreteTestIfiSettingsQueryVariables>(ConcreteTestIfiSettingsDocument, options);
      }
export function useConcreteTestIfiSettingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ConcreteTestIfiSettingsQuery, ConcreteTestIfiSettingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ConcreteTestIfiSettingsQuery, ConcreteTestIfiSettingsQueryVariables>(ConcreteTestIfiSettingsDocument, options);
        }
export type ConcreteTestIfiSettingsQueryHookResult = ReturnType<typeof useConcreteTestIfiSettingsQuery>;
export type ConcreteTestIfiSettingsLazyQueryHookResult = ReturnType<typeof useConcreteTestIfiSettingsLazyQuery>;
export type ConcreteTestIfiSettingsQueryResult = Apollo.QueryResult<ConcreteTestIfiSettingsQuery, ConcreteTestIfiSettingsQueryVariables>;
export const ControlPointIfiSettingsDocument = gql`
    query ControlPointIFISettings($projectId: String!) {
  dailyInspectionControlPointIFISettings(
    dailyInspectionControlPointIFISettingsListInput: {projectId: {equals: $projectId}}
  ) {
    records {
      enabled
      effectiveDate
      missingGeometry {
        enabled
        effectiveDate
        message
      }
    }
  }
}
    `;

/**
 * __useControlPointIfiSettingsQuery__
 *
 * To run a query within a React component, call `useControlPointIfiSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useControlPointIfiSettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useControlPointIfiSettingsQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useControlPointIfiSettingsQuery(baseOptions: Apollo.QueryHookOptions<ControlPointIfiSettingsQuery, ControlPointIfiSettingsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ControlPointIfiSettingsQuery, ControlPointIfiSettingsQueryVariables>(ControlPointIfiSettingsDocument, options);
      }
export function useControlPointIfiSettingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ControlPointIfiSettingsQuery, ControlPointIfiSettingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ControlPointIfiSettingsQuery, ControlPointIfiSettingsQueryVariables>(ControlPointIfiSettingsDocument, options);
        }
export type ControlPointIfiSettingsQueryHookResult = ReturnType<typeof useControlPointIfiSettingsQuery>;
export type ControlPointIfiSettingsLazyQueryHookResult = ReturnType<typeof useControlPointIfiSettingsLazyQuery>;
export type ControlPointIfiSettingsQueryResult = Apollo.QueryResult<ControlPointIfiSettingsQuery, ControlPointIfiSettingsQueryVariables>;
export const DensityTestIfiSettingsDocument = gql`
    query DensityTestIFISettings($projectId: String!) {
  densityTestIFISettings(
    densityTestIFISettingsListInput: {projectId: {equals: $projectId}}
  ) {
    records {
      enabled
      effectiveDate
      message
    }
  }
}
    `;

/**
 * __useDensityTestIfiSettingsQuery__
 *
 * To run a query within a React component, call `useDensityTestIfiSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useDensityTestIfiSettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDensityTestIfiSettingsQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useDensityTestIfiSettingsQuery(baseOptions: Apollo.QueryHookOptions<DensityTestIfiSettingsQuery, DensityTestIfiSettingsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DensityTestIfiSettingsQuery, DensityTestIfiSettingsQueryVariables>(DensityTestIfiSettingsDocument, options);
      }
export function useDensityTestIfiSettingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DensityTestIfiSettingsQuery, DensityTestIfiSettingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DensityTestIfiSettingsQuery, DensityTestIfiSettingsQueryVariables>(DensityTestIfiSettingsDocument, options);
        }
export type DensityTestIfiSettingsQueryHookResult = ReturnType<typeof useDensityTestIfiSettingsQuery>;
export type DensityTestIfiSettingsLazyQueryHookResult = ReturnType<typeof useDensityTestIfiSettingsLazyQuery>;
export type DensityTestIfiSettingsQueryResult = Apollo.QueryResult<DensityTestIfiSettingsQuery, DensityTestIfiSettingsQueryVariables>;
export const InspectionIfiSettingsDocument = gql`
    query InspectionIFISettings($projectId: String!) {
  dailyInspectionInspectionIFISettings(
    dailyInspectionInspectionIFISettingsListInput: {projectId: {equals: $projectId}}
  ) {
    records {
      enabled
      effectiveDate
      missingGeometry {
        enabled
        effectiveDate
        message
      }
    }
  }
}
    `;

/**
 * __useInspectionIfiSettingsQuery__
 *
 * To run a query within a React component, call `useInspectionIfiSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useInspectionIfiSettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInspectionIfiSettingsQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useInspectionIfiSettingsQuery(baseOptions: Apollo.QueryHookOptions<InspectionIfiSettingsQuery, InspectionIfiSettingsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InspectionIfiSettingsQuery, InspectionIfiSettingsQueryVariables>(InspectionIfiSettingsDocument, options);
      }
export function useInspectionIfiSettingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InspectionIfiSettingsQuery, InspectionIfiSettingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InspectionIfiSettingsQuery, InspectionIfiSettingsQueryVariables>(InspectionIfiSettingsDocument, options);
        }
export type InspectionIfiSettingsQueryHookResult = ReturnType<typeof useInspectionIfiSettingsQuery>;
export type InspectionIfiSettingsLazyQueryHookResult = ReturnType<typeof useInspectionIfiSettingsLazyQuery>;
export type InspectionIfiSettingsQueryResult = Apollo.QueryResult<InspectionIfiSettingsQuery, InspectionIfiSettingsQueryVariables>;
export const LotIfiSettingsDocument = gql`
    query LotIFISettings($projectId: String!) {
  lotIFISettings(lotIFISettingsListInput: {projectId: {equals: $projectId}}) {
    records {
      enabled
      effectiveDate
      testCount {
        enabled
        effectiveDate
        message
      }
      proctor {
        enabled
        effectiveDate
        message
      }
      compaction {
        enabled
        effectiveDate
        message
        levelId
      }
    }
  }
}
    `;

/**
 * __useLotIfiSettingsQuery__
 *
 * To run a query within a React component, call `useLotIfiSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useLotIfiSettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLotIfiSettingsQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useLotIfiSettingsQuery(baseOptions: Apollo.QueryHookOptions<LotIfiSettingsQuery, LotIfiSettingsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LotIfiSettingsQuery, LotIfiSettingsQueryVariables>(LotIfiSettingsDocument, options);
      }
export function useLotIfiSettingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LotIfiSettingsQuery, LotIfiSettingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LotIfiSettingsQuery, LotIfiSettingsQueryVariables>(LotIfiSettingsDocument, options);
        }
export type LotIfiSettingsQueryHookResult = ReturnType<typeof useLotIfiSettingsQuery>;
export type LotIfiSettingsLazyQueryHookResult = ReturnType<typeof useLotIfiSettingsLazyQuery>;
export type LotIfiSettingsQueryResult = Apollo.QueryResult<LotIfiSettingsQuery, LotIfiSettingsQueryVariables>;
export const PunchListIfiSettingsDocument = gql`
    query PunchListIFISettings($projectId: String!) {
  dailyInspectionPunchListIFISettings(
    dailyInspectionPunchListIFISettingsListInput: {projectId: {equals: $projectId}}
  ) {
    records {
      enabled
      effectiveDate
    }
  }
}
    `;

/**
 * __usePunchListIfiSettingsQuery__
 *
 * To run a query within a React component, call `usePunchListIfiSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePunchListIfiSettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePunchListIfiSettingsQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function usePunchListIfiSettingsQuery(baseOptions: Apollo.QueryHookOptions<PunchListIfiSettingsQuery, PunchListIfiSettingsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PunchListIfiSettingsQuery, PunchListIfiSettingsQueryVariables>(PunchListIfiSettingsDocument, options);
      }
export function usePunchListIfiSettingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PunchListIfiSettingsQuery, PunchListIfiSettingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PunchListIfiSettingsQuery, PunchListIfiSettingsQueryVariables>(PunchListIfiSettingsDocument, options);
        }
export type PunchListIfiSettingsQueryHookResult = ReturnType<typeof usePunchListIfiSettingsQuery>;
export type PunchListIfiSettingsLazyQueryHookResult = ReturnType<typeof usePunchListIfiSettingsLazyQuery>;
export type PunchListIfiSettingsQueryResult = Apollo.QueryResult<PunchListIfiSettingsQuery, PunchListIfiSettingsQueryVariables>;
export const EditProjectMetadataDocument = gql`
    mutation EditProjectMetadata($editProjectMetadataInput: EditProjectMetadataInput!) {
  editProjectMetadata(editProjectMetadataInput: $editProjectMetadataInput) {
    projectMetadata {
      sharePointSiteLandingPage
      promptDesignSubmittalAtFDCClosure
    }
  }
}
    `;
export type EditProjectMetadataMutationFn = Apollo.MutationFunction<EditProjectMetadataMutation, EditProjectMetadataMutationVariables>;

/**
 * __useEditProjectMetadataMutation__
 *
 * To run a mutation, you first call `useEditProjectMetadataMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditProjectMetadataMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editProjectMetadataMutation, { data, loading, error }] = useEditProjectMetadataMutation({
 *   variables: {
 *      editProjectMetadataInput: // value for 'editProjectMetadataInput'
 *   },
 * });
 */
export function useEditProjectMetadataMutation(baseOptions?: Apollo.MutationHookOptions<EditProjectMetadataMutation, EditProjectMetadataMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditProjectMetadataMutation, EditProjectMetadataMutationVariables>(EditProjectMetadataDocument, options);
      }
export type EditProjectMetadataMutationHookResult = ReturnType<typeof useEditProjectMetadataMutation>;
export type EditProjectMetadataMutationResult = Apollo.MutationResult<EditProjectMetadataMutation>;
export type EditProjectMetadataMutationOptions = Apollo.BaseMutationOptions<EditProjectMetadataMutation, EditProjectMetadataMutationVariables>;
export const MetadataDocument = gql`
    query Metadata($projectId: String!) {
  project(globalId: $projectId) {
    sharePointDrives {
      id
      name
      description
    }
    projectMetadata {
      sharePointSiteURL
      sharePointSiteLandingPage
      sharePointURL
      promptDesignSubmittalAtFDCClosure
      projectLogoB64
      cmProjectLayersId
      customDriveId
      replaceSpacesWithDashesInFilenames
    }
    projectToCIMSOnlineAdmins {
      lastEditedDate
      lastEditedUser
      user {
        id
        username
        mail
        deleted
        userGroups {
          id
        }
      }
    }
  }
}
    `;

/**
 * __useMetadataQuery__
 *
 * To run a query within a React component, call `useMetadataQuery` and pass it any options that fit your needs.
 * When your component renders, `useMetadataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMetadataQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useMetadataQuery(baseOptions: Apollo.QueryHookOptions<MetadataQuery, MetadataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MetadataQuery, MetadataQueryVariables>(MetadataDocument, options);
      }
export function useMetadataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MetadataQuery, MetadataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MetadataQuery, MetadataQueryVariables>(MetadataDocument, options);
        }
export type MetadataQueryHookResult = ReturnType<typeof useMetadataQuery>;
export type MetadataLazyQueryHookResult = ReturnType<typeof useMetadataLazyQuery>;
export type MetadataQueryResult = Apollo.QueryResult<MetadataQuery, MetadataQueryVariables>;
export const GetCmProjectLayersWgs84Document = gql`
    query GetCMProjectLayersWGS84 {
  cmProjectLayers {
    id
    name
  }
}
    `;

/**
 * __useGetCmProjectLayersWgs84Query__
 *
 * To run a query within a React component, call `useGetCmProjectLayersWgs84Query` and pass it any options that fit your needs.
 * When your component renders, `useGetCmProjectLayersWgs84Query` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCmProjectLayersWgs84Query({
 *   variables: {
 *   },
 * });
 */
export function useGetCmProjectLayersWgs84Query(baseOptions?: Apollo.QueryHookOptions<GetCmProjectLayersWgs84Query, GetCmProjectLayersWgs84QueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCmProjectLayersWgs84Query, GetCmProjectLayersWgs84QueryVariables>(GetCmProjectLayersWgs84Document, options);
      }
export function useGetCmProjectLayersWgs84LazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCmProjectLayersWgs84Query, GetCmProjectLayersWgs84QueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCmProjectLayersWgs84Query, GetCmProjectLayersWgs84QueryVariables>(GetCmProjectLayersWgs84Document, options);
        }
export type GetCmProjectLayersWgs84QueryHookResult = ReturnType<typeof useGetCmProjectLayersWgs84Query>;
export type GetCmProjectLayersWgs84LazyQueryHookResult = ReturnType<typeof useGetCmProjectLayersWgs84LazyQuery>;
export type GetCmProjectLayersWgs84QueryResult = Apollo.QueryResult<GetCmProjectLayersWgs84Query, GetCmProjectLayersWgs84QueryVariables>;
export const GetProjectSettingsProjectAdminsDocument = gql`
    query GetProjectSettingsProjectAdmins($projectId: String!) {
  project(globalId: $projectId) {
    users(userFieldInput: {deleted: false}) {
      id
      username
      mail
      developer
      admin(projectId: $projectId) {
        lastEditedDate
        lastEditedUser
      }
    }
  }
}
    `;

/**
 * __useGetProjectSettingsProjectAdminsQuery__
 *
 * To run a query within a React component, call `useGetProjectSettingsProjectAdminsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProjectSettingsProjectAdminsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProjectSettingsProjectAdminsQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useGetProjectSettingsProjectAdminsQuery(baseOptions: Apollo.QueryHookOptions<GetProjectSettingsProjectAdminsQuery, GetProjectSettingsProjectAdminsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProjectSettingsProjectAdminsQuery, GetProjectSettingsProjectAdminsQueryVariables>(GetProjectSettingsProjectAdminsDocument, options);
      }
export function useGetProjectSettingsProjectAdminsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProjectSettingsProjectAdminsQuery, GetProjectSettingsProjectAdminsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProjectSettingsProjectAdminsQuery, GetProjectSettingsProjectAdminsQueryVariables>(GetProjectSettingsProjectAdminsDocument, options);
        }
export type GetProjectSettingsProjectAdminsQueryHookResult = ReturnType<typeof useGetProjectSettingsProjectAdminsQuery>;
export type GetProjectSettingsProjectAdminsLazyQueryHookResult = ReturnType<typeof useGetProjectSettingsProjectAdminsLazyQuery>;
export type GetProjectSettingsProjectAdminsQueryResult = Apollo.QueryResult<GetProjectSettingsProjectAdminsQuery, GetProjectSettingsProjectAdminsQueryVariables>;
export const UpsertConcreteTestIfiSettingsDocument = gql`
    mutation upsertConcreteTestIFISettings($input: UpsertConcreteTestIFISettingsInput!) {
  upsertConcreteTestIFISettings(upsertConcreteTestIFISettingsInput: $input) {
    concreteTestIFISettings {
      projectId
    }
  }
}
    `;
export type UpsertConcreteTestIfiSettingsMutationFn = Apollo.MutationFunction<UpsertConcreteTestIfiSettingsMutation, UpsertConcreteTestIfiSettingsMutationVariables>;

/**
 * __useUpsertConcreteTestIfiSettingsMutation__
 *
 * To run a mutation, you first call `useUpsertConcreteTestIfiSettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertConcreteTestIfiSettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertConcreteTestIfiSettingsMutation, { data, loading, error }] = useUpsertConcreteTestIfiSettingsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpsertConcreteTestIfiSettingsMutation(baseOptions?: Apollo.MutationHookOptions<UpsertConcreteTestIfiSettingsMutation, UpsertConcreteTestIfiSettingsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpsertConcreteTestIfiSettingsMutation, UpsertConcreteTestIfiSettingsMutationVariables>(UpsertConcreteTestIfiSettingsDocument, options);
      }
export type UpsertConcreteTestIfiSettingsMutationHookResult = ReturnType<typeof useUpsertConcreteTestIfiSettingsMutation>;
export type UpsertConcreteTestIfiSettingsMutationResult = Apollo.MutationResult<UpsertConcreteTestIfiSettingsMutation>;
export type UpsertConcreteTestIfiSettingsMutationOptions = Apollo.BaseMutationOptions<UpsertConcreteTestIfiSettingsMutation, UpsertConcreteTestIfiSettingsMutationVariables>;
export const UpsertControlPointIfiSettingsDocument = gql`
    mutation UpsertControlPointIFISettings($input: UpsertDailyInspectionControlPointIFISettingsInput!) {
  upsertDailyInspectionControlPointIFISettings(
    upsertDailyInspectionControlPointIFISettingsInput: $input
  ) {
    controlPointIFISettings {
      projectId
    }
  }
}
    `;
export type UpsertControlPointIfiSettingsMutationFn = Apollo.MutationFunction<UpsertControlPointIfiSettingsMutation, UpsertControlPointIfiSettingsMutationVariables>;

/**
 * __useUpsertControlPointIfiSettingsMutation__
 *
 * To run a mutation, you first call `useUpsertControlPointIfiSettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertControlPointIfiSettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertControlPointIfiSettingsMutation, { data, loading, error }] = useUpsertControlPointIfiSettingsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpsertControlPointIfiSettingsMutation(baseOptions?: Apollo.MutationHookOptions<UpsertControlPointIfiSettingsMutation, UpsertControlPointIfiSettingsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpsertControlPointIfiSettingsMutation, UpsertControlPointIfiSettingsMutationVariables>(UpsertControlPointIfiSettingsDocument, options);
      }
export type UpsertControlPointIfiSettingsMutationHookResult = ReturnType<typeof useUpsertControlPointIfiSettingsMutation>;
export type UpsertControlPointIfiSettingsMutationResult = Apollo.MutationResult<UpsertControlPointIfiSettingsMutation>;
export type UpsertControlPointIfiSettingsMutationOptions = Apollo.BaseMutationOptions<UpsertControlPointIfiSettingsMutation, UpsertControlPointIfiSettingsMutationVariables>;
export const UpsertLotIfiSettingsDocument = gql`
    mutation upsertLotIFISettings($input: UpsertLotIFISettingsInput!) {
  upsertLotIFISettings(upsertLotIFISettingsInput: $input) {
    lotIFISettings {
      projectId
    }
  }
}
    `;
export type UpsertLotIfiSettingsMutationFn = Apollo.MutationFunction<UpsertLotIfiSettingsMutation, UpsertLotIfiSettingsMutationVariables>;

/**
 * __useUpsertLotIfiSettingsMutation__
 *
 * To run a mutation, you first call `useUpsertLotIfiSettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertLotIfiSettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertLotIfiSettingsMutation, { data, loading, error }] = useUpsertLotIfiSettingsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpsertLotIfiSettingsMutation(baseOptions?: Apollo.MutationHookOptions<UpsertLotIfiSettingsMutation, UpsertLotIfiSettingsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpsertLotIfiSettingsMutation, UpsertLotIfiSettingsMutationVariables>(UpsertLotIfiSettingsDocument, options);
      }
export type UpsertLotIfiSettingsMutationHookResult = ReturnType<typeof useUpsertLotIfiSettingsMutation>;
export type UpsertLotIfiSettingsMutationResult = Apollo.MutationResult<UpsertLotIfiSettingsMutation>;
export type UpsertLotIfiSettingsMutationOptions = Apollo.BaseMutationOptions<UpsertLotIfiSettingsMutation, UpsertLotIfiSettingsMutationVariables>;
export const UpsertDensityTestIfiSettingsDocument = gql`
    mutation UpsertDensityTestIFISettings($input: UpsertDensityTestIFISettingsInput!) {
  upsertDensityTestIFISettings(upsertDensityTestIFISettingsInput: $input) {
    densityTestIFISettings {
      projectId
    }
  }
}
    `;
export type UpsertDensityTestIfiSettingsMutationFn = Apollo.MutationFunction<UpsertDensityTestIfiSettingsMutation, UpsertDensityTestIfiSettingsMutationVariables>;

/**
 * __useUpsertDensityTestIfiSettingsMutation__
 *
 * To run a mutation, you first call `useUpsertDensityTestIfiSettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertDensityTestIfiSettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertDensityTestIfiSettingsMutation, { data, loading, error }] = useUpsertDensityTestIfiSettingsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpsertDensityTestIfiSettingsMutation(baseOptions?: Apollo.MutationHookOptions<UpsertDensityTestIfiSettingsMutation, UpsertDensityTestIfiSettingsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpsertDensityTestIfiSettingsMutation, UpsertDensityTestIfiSettingsMutationVariables>(UpsertDensityTestIfiSettingsDocument, options);
      }
export type UpsertDensityTestIfiSettingsMutationHookResult = ReturnType<typeof useUpsertDensityTestIfiSettingsMutation>;
export type UpsertDensityTestIfiSettingsMutationResult = Apollo.MutationResult<UpsertDensityTestIfiSettingsMutation>;
export type UpsertDensityTestIfiSettingsMutationOptions = Apollo.BaseMutationOptions<UpsertDensityTestIfiSettingsMutation, UpsertDensityTestIfiSettingsMutationVariables>;
export const UpsertInspectionIfiSettingsDocument = gql`
    mutation UpsertInspectionIFISettings($input: UpsertDailyInspectionInspectionIFISettingsInput!) {
  upsertDailyInspectionInspectionIFISettings(
    upsertDailyInspectionInspectionIFISettingsInput: $input
  ) {
    inspectionIFISettings {
      projectId
    }
  }
}
    `;
export type UpsertInspectionIfiSettingsMutationFn = Apollo.MutationFunction<UpsertInspectionIfiSettingsMutation, UpsertInspectionIfiSettingsMutationVariables>;

/**
 * __useUpsertInspectionIfiSettingsMutation__
 *
 * To run a mutation, you first call `useUpsertInspectionIfiSettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertInspectionIfiSettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertInspectionIfiSettingsMutation, { data, loading, error }] = useUpsertInspectionIfiSettingsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpsertInspectionIfiSettingsMutation(baseOptions?: Apollo.MutationHookOptions<UpsertInspectionIfiSettingsMutation, UpsertInspectionIfiSettingsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpsertInspectionIfiSettingsMutation, UpsertInspectionIfiSettingsMutationVariables>(UpsertInspectionIfiSettingsDocument, options);
      }
export type UpsertInspectionIfiSettingsMutationHookResult = ReturnType<typeof useUpsertInspectionIfiSettingsMutation>;
export type UpsertInspectionIfiSettingsMutationResult = Apollo.MutationResult<UpsertInspectionIfiSettingsMutation>;
export type UpsertInspectionIfiSettingsMutationOptions = Apollo.BaseMutationOptions<UpsertInspectionIfiSettingsMutation, UpsertInspectionIfiSettingsMutationVariables>;
export const UpsertPunchListIfiSettingsDocument = gql`
    mutation UpsertPunchListIFISettings($input: UpsertDailyInspectionPunchListIFISettingsInput!) {
  upsertDailyInspectionPunchListIFISettings(
    upsertDailyInspectionPunchListIFISettingsInput: $input
  ) {
    punchListIFISettings {
      projectId
    }
  }
}
    `;
export type UpsertPunchListIfiSettingsMutationFn = Apollo.MutationFunction<UpsertPunchListIfiSettingsMutation, UpsertPunchListIfiSettingsMutationVariables>;

/**
 * __useUpsertPunchListIfiSettingsMutation__
 *
 * To run a mutation, you first call `useUpsertPunchListIfiSettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertPunchListIfiSettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertPunchListIfiSettingsMutation, { data, loading, error }] = useUpsertPunchListIfiSettingsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpsertPunchListIfiSettingsMutation(baseOptions?: Apollo.MutationHookOptions<UpsertPunchListIfiSettingsMutation, UpsertPunchListIfiSettingsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpsertPunchListIfiSettingsMutation, UpsertPunchListIfiSettingsMutationVariables>(UpsertPunchListIfiSettingsDocument, options);
      }
export type UpsertPunchListIfiSettingsMutationHookResult = ReturnType<typeof useUpsertPunchListIfiSettingsMutation>;
export type UpsertPunchListIfiSettingsMutationResult = Apollo.MutationResult<UpsertPunchListIfiSettingsMutation>;
export type UpsertPunchListIfiSettingsMutationOptions = Apollo.BaseMutationOptions<UpsertPunchListIfiSettingsMutation, UpsertPunchListIfiSettingsMutationVariables>;
export const CreateProjectToCimsOnlineAdminDocument = gql`
    mutation CreateProjectToCIMSOnlineAdmin($input: CreateProjectToCIMSOnlineAdminInput!) {
  createProjectToCIMSOnlineAdmin(createProjectToCIMSOnlineAdminInput: $input) {
    admin {
      user {
        username
      }
    }
  }
}
    `;
export type CreateProjectToCimsOnlineAdminMutationFn = Apollo.MutationFunction<CreateProjectToCimsOnlineAdminMutation, CreateProjectToCimsOnlineAdminMutationVariables>;

/**
 * __useCreateProjectToCimsOnlineAdminMutation__
 *
 * To run a mutation, you first call `useCreateProjectToCimsOnlineAdminMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateProjectToCimsOnlineAdminMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createProjectToCimsOnlineAdminMutation, { data, loading, error }] = useCreateProjectToCimsOnlineAdminMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateProjectToCimsOnlineAdminMutation(baseOptions?: Apollo.MutationHookOptions<CreateProjectToCimsOnlineAdminMutation, CreateProjectToCimsOnlineAdminMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateProjectToCimsOnlineAdminMutation, CreateProjectToCimsOnlineAdminMutationVariables>(CreateProjectToCimsOnlineAdminDocument, options);
      }
export type CreateProjectToCimsOnlineAdminMutationHookResult = ReturnType<typeof useCreateProjectToCimsOnlineAdminMutation>;
export type CreateProjectToCimsOnlineAdminMutationResult = Apollo.MutationResult<CreateProjectToCimsOnlineAdminMutation>;
export type CreateProjectToCimsOnlineAdminMutationOptions = Apollo.BaseMutationOptions<CreateProjectToCimsOnlineAdminMutation, CreateProjectToCimsOnlineAdminMutationVariables>;
export const RemoveProjectToCimsOnlineAdminDocument = gql`
    mutation RemoveProjectToCIMSOnlineAdmin($input: RemoveProjectToCIMSOnlineAdminInput!) {
  removeProjectToCIMSOnlineAdmin(removeProjectToCIMSOnlineAdminInput: $input) {
    admin {
      user {
        username
      }
    }
  }
}
    `;
export type RemoveProjectToCimsOnlineAdminMutationFn = Apollo.MutationFunction<RemoveProjectToCimsOnlineAdminMutation, RemoveProjectToCimsOnlineAdminMutationVariables>;

/**
 * __useRemoveProjectToCimsOnlineAdminMutation__
 *
 * To run a mutation, you first call `useRemoveProjectToCimsOnlineAdminMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveProjectToCimsOnlineAdminMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeProjectToCimsOnlineAdminMutation, { data, loading, error }] = useRemoveProjectToCimsOnlineAdminMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRemoveProjectToCimsOnlineAdminMutation(baseOptions?: Apollo.MutationHookOptions<RemoveProjectToCimsOnlineAdminMutation, RemoveProjectToCimsOnlineAdminMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveProjectToCimsOnlineAdminMutation, RemoveProjectToCimsOnlineAdminMutationVariables>(RemoveProjectToCimsOnlineAdminDocument, options);
      }
export type RemoveProjectToCimsOnlineAdminMutationHookResult = ReturnType<typeof useRemoveProjectToCimsOnlineAdminMutation>;
export type RemoveProjectToCimsOnlineAdminMutationResult = Apollo.MutationResult<RemoveProjectToCimsOnlineAdminMutation>;
export type RemoveProjectToCimsOnlineAdminMutationOptions = Apollo.BaseMutationOptions<RemoveProjectToCimsOnlineAdminMutation, RemoveProjectToCimsOnlineAdminMutationVariables>;
export const CreateRoleDocument = gql`
    mutation CreateRole($createRoleInput: CreateRoleInput!) {
  createRole(createRoleInput: $createRoleInput) {
    role {
      name
    }
  }
}
    `;
export type CreateRoleMutationFn = Apollo.MutationFunction<CreateRoleMutation, CreateRoleMutationVariables>;

/**
 * __useCreateRoleMutation__
 *
 * To run a mutation, you first call `useCreateRoleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateRoleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createRoleMutation, { data, loading, error }] = useCreateRoleMutation({
 *   variables: {
 *      createRoleInput: // value for 'createRoleInput'
 *   },
 * });
 */
export function useCreateRoleMutation(baseOptions?: Apollo.MutationHookOptions<CreateRoleMutation, CreateRoleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateRoleMutation, CreateRoleMutationVariables>(CreateRoleDocument, options);
      }
export type CreateRoleMutationHookResult = ReturnType<typeof useCreateRoleMutation>;
export type CreateRoleMutationResult = Apollo.MutationResult<CreateRoleMutation>;
export type CreateRoleMutationOptions = Apollo.BaseMutationOptions<CreateRoleMutation, CreateRoleMutationVariables>;
export const EditRoleDocument = gql`
    mutation EditRole($editRoleInput: EditRoleInput!) {
  editRole(editRoleInput: $editRoleInput) {
    role {
      name
    }
  }
}
    `;
export type EditRoleMutationFn = Apollo.MutationFunction<EditRoleMutation, EditRoleMutationVariables>;

/**
 * __useEditRoleMutation__
 *
 * To run a mutation, you first call `useEditRoleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditRoleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editRoleMutation, { data, loading, error }] = useEditRoleMutation({
 *   variables: {
 *      editRoleInput: // value for 'editRoleInput'
 *   },
 * });
 */
export function useEditRoleMutation(baseOptions?: Apollo.MutationHookOptions<EditRoleMutation, EditRoleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditRoleMutation, EditRoleMutationVariables>(EditRoleDocument, options);
      }
export type EditRoleMutationHookResult = ReturnType<typeof useEditRoleMutation>;
export type EditRoleMutationResult = Apollo.MutationResult<EditRoleMutation>;
export type EditRoleMutationOptions = Apollo.BaseMutationOptions<EditRoleMutation, EditRoleMutationVariables>;
export const RemoveRoleDocument = gql`
    mutation RemoveRole($id: String!) {
  softRemoveRole(id: $id) {
    role {
      name
    }
  }
}
    `;
export type RemoveRoleMutationFn = Apollo.MutationFunction<RemoveRoleMutation, RemoveRoleMutationVariables>;

/**
 * __useRemoveRoleMutation__
 *
 * To run a mutation, you first call `useRemoveRoleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveRoleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeRoleMutation, { data, loading, error }] = useRemoveRoleMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRemoveRoleMutation(baseOptions?: Apollo.MutationHookOptions<RemoveRoleMutation, RemoveRoleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveRoleMutation, RemoveRoleMutationVariables>(RemoveRoleDocument, options);
      }
export type RemoveRoleMutationHookResult = ReturnType<typeof useRemoveRoleMutation>;
export type RemoveRoleMutationResult = Apollo.MutationResult<RemoveRoleMutation>;
export type RemoveRoleMutationOptions = Apollo.BaseMutationOptions<RemoveRoleMutation, RemoveRoleMutationVariables>;
export const RestoreRoleDocument = gql`
    mutation RestoreRole($id: String!) {
  restoreRole(id: $id) {
    role {
      name
    }
  }
}
    `;
export type RestoreRoleMutationFn = Apollo.MutationFunction<RestoreRoleMutation, RestoreRoleMutationVariables>;

/**
 * __useRestoreRoleMutation__
 *
 * To run a mutation, you first call `useRestoreRoleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRestoreRoleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [restoreRoleMutation, { data, loading, error }] = useRestoreRoleMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRestoreRoleMutation(baseOptions?: Apollo.MutationHookOptions<RestoreRoleMutation, RestoreRoleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RestoreRoleMutation, RestoreRoleMutationVariables>(RestoreRoleDocument, options);
      }
export type RestoreRoleMutationHookResult = ReturnType<typeof useRestoreRoleMutation>;
export type RestoreRoleMutationResult = Apollo.MutationResult<RestoreRoleMutation>;
export type RestoreRoleMutationOptions = Apollo.BaseMutationOptions<RestoreRoleMutation, RestoreRoleMutationVariables>;
export const GetRolesDocument = gql`
    query GetRoles($roleListInput: RoleListInput!) {
  roles(roleListInput: $roleListInput) {
    records {
      id
      name
      permissions
      deleted
      deletedDate
      deletedUser
    }
  }
}
    `;

/**
 * __useGetRolesQuery__
 *
 * To run a query within a React component, call `useGetRolesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRolesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRolesQuery({
 *   variables: {
 *      roleListInput: // value for 'roleListInput'
 *   },
 * });
 */
export function useGetRolesQuery(baseOptions: Apollo.QueryHookOptions<GetRolesQuery, GetRolesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRolesQuery, GetRolesQueryVariables>(GetRolesDocument, options);
      }
export function useGetRolesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRolesQuery, GetRolesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRolesQuery, GetRolesQueryVariables>(GetRolesDocument, options);
        }
export type GetRolesQueryHookResult = ReturnType<typeof useGetRolesQuery>;
export type GetRolesLazyQueryHookResult = ReturnType<typeof useGetRolesLazyQuery>;
export type GetRolesQueryResult = Apollo.QueryResult<GetRolesQuery, GetRolesQueryVariables>;
export const GetUsersTableDataDocument = gql`
    query GetUsersTableData($projectId: String!) {
  project(globalId: $projectId) {
    users(userFieldInput: {deleted: false}) {
      id
      mail
      username
      displayName
      givenName
      surname
      developer
      developerDate
      developerGrantedBy {
        username
      }
      admin(projectId: $projectId) {
        lastEditedDate
        lastEditedUser
      }
      userGroups(userGroupFieldInput: {}) {
        id
        name
        projectToUserGroups {
          projectId
        }
      }
      casRoutingGroups(
        casRoutingGroupFieldInput: {projectId: {equals: $projectId}, deleted: false}
      ) {
        name
        description
      }
      dsDisciplines(dsDisciplineFieldInput: {projectId: {equals: $projectId}}) {
        name
        description
      }
      fdcApprovalGroups(
        fdcApprovalGroupFieldInput: {deleted: false, projectId: {equals: $projectId}}
      ) {
        id
        name
        description
      }
      fdcConcurrenceGroups(
        fdcConcurrenceGroupFieldInput: {deleted: false, projectId: {equals: $projectId}}
      ) {
        id
        name
        description
      }
      rfiResponseDisciplines(
        rfiResponseDisciplineFieldInput: {deleted: false, projectId: {equals: $projectId}}
      ) {
        name
        description
      }
      ejTypes(ejTypeFieldInput: {deleted: false, projectId: {equals: $projectId}}) {
        name
      }
      roles(roleFieldInput: {projectId: {equals: $projectId}, deleted: false}) {
        ...BareMinimumRoleFragment
        fdcApprovalGroups(
          fdcApprovalGroupFieldInput: {deleted: false, projectId: {equals: $projectId}}
        ) {
          id
          name
          description
        }
        fdcConcurrenceGroups(
          fdcConcurrenceGroupFieldInput: {deleted: false, projectId: {equals: $projectId}}
        ) {
          id
          name
          description
        }
      }
      permissions(projectId: $projectId)
    }
    roles(roleFieldInput: {projectId: {equals: $projectId}, deleted: false}) {
      ...BareMinimumRoleFragment
    }
    projectToUserGroups {
      userGroup {
        name
        id
      }
    }
    customFields(
      customFieldFieldInput: {deleted: false, projectId: {equals: $projectId}}
    ) {
      id
      name
      description
      customFieldToClassTypes {
        classType
        users {
          id
        }
        roles {
          id
        }
      }
    }
  }
}
    ${BareMinimumRoleFragmentFragmentDoc}`;

/**
 * __useGetUsersTableDataQuery__
 *
 * To run a query within a React component, call `useGetUsersTableDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUsersTableDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUsersTableDataQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useGetUsersTableDataQuery(baseOptions: Apollo.QueryHookOptions<GetUsersTableDataQuery, GetUsersTableDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUsersTableDataQuery, GetUsersTableDataQueryVariables>(GetUsersTableDataDocument, options);
      }
export function useGetUsersTableDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUsersTableDataQuery, GetUsersTableDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUsersTableDataQuery, GetUsersTableDataQueryVariables>(GetUsersTableDataDocument, options);
        }
export type GetUsersTableDataQueryHookResult = ReturnType<typeof useGetUsersTableDataQuery>;
export type GetUsersTableDataLazyQueryHookResult = ReturnType<typeof useGetUsersTableDataLazyQuery>;
export type GetUsersTableDataQueryResult = Apollo.QueryResult<GetUsersTableDataQuery, GetUsersTableDataQueryVariables>;
export const EditUserDocument = gql`
    mutation EditUser($editUserInput: EditUserInput!) {
  editUser(editUserInput: $editUserInput) {
    user {
      username
    }
  }
}
    `;
export type EditUserMutationFn = Apollo.MutationFunction<EditUserMutation, EditUserMutationVariables>;

/**
 * __useEditUserMutation__
 *
 * To run a mutation, you first call `useEditUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editUserMutation, { data, loading, error }] = useEditUserMutation({
 *   variables: {
 *      editUserInput: // value for 'editUserInput'
 *   },
 * });
 */
export function useEditUserMutation(baseOptions?: Apollo.MutationHookOptions<EditUserMutation, EditUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditUserMutation, EditUserMutationVariables>(EditUserDocument, options);
      }
export type EditUserMutationHookResult = ReturnType<typeof useEditUserMutation>;
export type EditUserMutationResult = Apollo.MutationResult<EditUserMutation>;
export type EditUserMutationOptions = Apollo.BaseMutationOptions<EditUserMutation, EditUserMutationVariables>;
export const RemoveConcreteTestBreakDataDocument = gql`
    mutation RemoveConcreteTestBreakData($id: Int!) {
  removeConcreteTestBreakData(id: $id) {
    concreteTestBreakData {
      concreteTest {
        fieldNumber
        globalId
      }
    }
  }
}
    `;
export type RemoveConcreteTestBreakDataMutationFn = Apollo.MutationFunction<RemoveConcreteTestBreakDataMutation, RemoveConcreteTestBreakDataMutationVariables>;

/**
 * __useRemoveConcreteTestBreakDataMutation__
 *
 * To run a mutation, you first call `useRemoveConcreteTestBreakDataMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveConcreteTestBreakDataMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeConcreteTestBreakDataMutation, { data, loading, error }] = useRemoveConcreteTestBreakDataMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRemoveConcreteTestBreakDataMutation(baseOptions?: Apollo.MutationHookOptions<RemoveConcreteTestBreakDataMutation, RemoveConcreteTestBreakDataMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveConcreteTestBreakDataMutation, RemoveConcreteTestBreakDataMutationVariables>(RemoveConcreteTestBreakDataDocument, options);
      }
export type RemoveConcreteTestBreakDataMutationHookResult = ReturnType<typeof useRemoveConcreteTestBreakDataMutation>;
export type RemoveConcreteTestBreakDataMutationResult = Apollo.MutationResult<RemoveConcreteTestBreakDataMutation>;
export type RemoveConcreteTestBreakDataMutationOptions = Apollo.BaseMutationOptions<RemoveConcreteTestBreakDataMutation, RemoveConcreteTestBreakDataMutationVariables>;
export const EditConcreteTestSetDocument = gql`
    mutation EditConcreteTestSet($input: EditConcreteTestSetInput!) {
  editConcreteTestSet(editConcreteTestSetInput: $input) {
    concreteTestSet {
      testSetId
    }
  }
}
    `;
export type EditConcreteTestSetMutationFn = Apollo.MutationFunction<EditConcreteTestSetMutation, EditConcreteTestSetMutationVariables>;

/**
 * __useEditConcreteTestSetMutation__
 *
 * To run a mutation, you first call `useEditConcreteTestSetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditConcreteTestSetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editConcreteTestSetMutation, { data, loading, error }] = useEditConcreteTestSetMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEditConcreteTestSetMutation(baseOptions?: Apollo.MutationHookOptions<EditConcreteTestSetMutation, EditConcreteTestSetMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditConcreteTestSetMutation, EditConcreteTestSetMutationVariables>(EditConcreteTestSetDocument, options);
      }
export type EditConcreteTestSetMutationHookResult = ReturnType<typeof useEditConcreteTestSetMutation>;
export type EditConcreteTestSetMutationResult = Apollo.MutationResult<EditConcreteTestSetMutation>;
export type EditConcreteTestSetMutationOptions = Apollo.BaseMutationOptions<EditConcreteTestSetMutation, EditConcreteTestSetMutationVariables>;
export const ConcreteTestSetTrackerPdfModalDocument = gql`
    query ConcreteTestSetTrackerPDFModal($globalId: String!) {
  concreteTestSet(globalId: $globalId) {
    sharePointResource {
      sharePointResources {
        id
        name
        webUrl
      }
    }
  }
}
    `;

/**
 * __useConcreteTestSetTrackerPdfModalQuery__
 *
 * To run a query within a React component, call `useConcreteTestSetTrackerPdfModalQuery` and pass it any options that fit your needs.
 * When your component renders, `useConcreteTestSetTrackerPdfModalQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useConcreteTestSetTrackerPdfModalQuery({
 *   variables: {
 *      globalId: // value for 'globalId'
 *   },
 * });
 */
export function useConcreteTestSetTrackerPdfModalQuery(baseOptions: Apollo.QueryHookOptions<ConcreteTestSetTrackerPdfModalQuery, ConcreteTestSetTrackerPdfModalQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ConcreteTestSetTrackerPdfModalQuery, ConcreteTestSetTrackerPdfModalQueryVariables>(ConcreteTestSetTrackerPdfModalDocument, options);
      }
export function useConcreteTestSetTrackerPdfModalLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ConcreteTestSetTrackerPdfModalQuery, ConcreteTestSetTrackerPdfModalQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ConcreteTestSetTrackerPdfModalQuery, ConcreteTestSetTrackerPdfModalQueryVariables>(ConcreteTestSetTrackerPdfModalDocument, options);
        }
export type ConcreteTestSetTrackerPdfModalQueryHookResult = ReturnType<typeof useConcreteTestSetTrackerPdfModalQuery>;
export type ConcreteTestSetTrackerPdfModalLazyQueryHookResult = ReturnType<typeof useConcreteTestSetTrackerPdfModalLazyQuery>;
export type ConcreteTestSetTrackerPdfModalQueryResult = Apollo.QueryResult<ConcreteTestSetTrackerPdfModalQuery, ConcreteTestSetTrackerPdfModalQueryVariables>;
export const ConcreteTestSetTrackerConcreteTestSetsDocument = gql`
    query ConcreteTestSetTrackerConcreteTestSets($projectId: String!) {
  project(globalId: $projectId) {
    documentChecklistItems {
      ...ConcreteTestSetTrackerDocumentChecklistItem
    }
    concreteTestSets(concreteTestSetFieldInput: {deleted: false}) {
      globalId
      projectId
      testSetId
      estimatedQuantity
      estimatedThicknessIn
      placementDate
      status
      concreteTestSetMetadata {
        sharePointResourceId
        sharePointResourceWebUrl
        packetSharePointResourceId
        packetSharePointResourceName
        packetSharePointResourceWebUrl
      }
      concreteMixDesign {
        globalId
        active
        mixDesignNumber
      }
      concreteMaterial {
        placementType
        specBreakStrength
        maximumBreakStrength
        lowFailureBreakStrength
        airSlumpStartup
        airSlumpTestingFrequency
        airTestsPer
        airUnits
        cylinderSetFrequency
        cylinderSetsPer
        cylinderSetMin
        thicknessCoresPerPlacement
        coreTestingFrequency
        coreUnits
        coresMin
        cureRate
      }
      documentChecklistValues {
        checked
        documentChecklistItem {
          ...ConcreteTestSetTrackerDocumentChecklistItem
        }
      }
      payItemNoGeometries(payItemNoGeometryFieldInput: {deleted: false}) {
        globalId
        label
        deleted
      }
    }
  }
}
    ${ConcreteTestSetTrackerDocumentChecklistItemFragmentDoc}`;

/**
 * __useConcreteTestSetTrackerConcreteTestSetsQuery__
 *
 * To run a query within a React component, call `useConcreteTestSetTrackerConcreteTestSetsQuery` and pass it any options that fit your needs.
 * When your component renders, `useConcreteTestSetTrackerConcreteTestSetsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useConcreteTestSetTrackerConcreteTestSetsQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useConcreteTestSetTrackerConcreteTestSetsQuery(baseOptions: Apollo.QueryHookOptions<ConcreteTestSetTrackerConcreteTestSetsQuery, ConcreteTestSetTrackerConcreteTestSetsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ConcreteTestSetTrackerConcreteTestSetsQuery, ConcreteTestSetTrackerConcreteTestSetsQueryVariables>(ConcreteTestSetTrackerConcreteTestSetsDocument, options);
      }
export function useConcreteTestSetTrackerConcreteTestSetsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ConcreteTestSetTrackerConcreteTestSetsQuery, ConcreteTestSetTrackerConcreteTestSetsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ConcreteTestSetTrackerConcreteTestSetsQuery, ConcreteTestSetTrackerConcreteTestSetsQueryVariables>(ConcreteTestSetTrackerConcreteTestSetsDocument, options);
        }
export type ConcreteTestSetTrackerConcreteTestSetsQueryHookResult = ReturnType<typeof useConcreteTestSetTrackerConcreteTestSetsQuery>;
export type ConcreteTestSetTrackerConcreteTestSetsLazyQueryHookResult = ReturnType<typeof useConcreteTestSetTrackerConcreteTestSetsLazyQuery>;
export type ConcreteTestSetTrackerConcreteTestSetsQueryResult = Apollo.QueryResult<ConcreteTestSetTrackerConcreteTestSetsQuery, ConcreteTestSetTrackerConcreteTestSetsQueryVariables>;
export const ConcreteTestSetTrackerRelationsDocument = gql`
    query ConcreteTestSetTrackerRelations($projectId: String!) {
  project(globalId: $projectId) {
    concretePlacements(concretePlacementFieldInput: {deleted: false}) {
      globalId
      concreteTestSetGuid
      placementId
      placementQtyVolCy
      linearFt
      sqFt
      sqYd
      requiredThickness
      cureCoverage
      cureSqft
      cureGallons
      beginStation
      endStation
      beginOffset
      endOffset
      beginAlignment
      endAlignment
      steelVerified
      notes
      payItemNoGeometries(payItemNoGeometryFieldInput: {deleted: false}) {
        ...ConcreteTestSetTrackerRelationsPayItem
      }
      contractor {
        contractorName
      }
      steelNotes
      concreteCoreMeasurements(concreteCoreMeasurementFieldInput: {deleted: false}) {
        globalId
        measurementId
        station
        offset
        alignment
        requiredThickness
        avgMeasuredThickness
        status
        notes
        technician {
          technicianName
        }
        measurementDate
        measuredThickness1
        measuredThickness2
        measuredThickness3
        concreteCoreBreakData {
          labNumber
          age
          breakDate
          diameter
          peakLoad
          strength
          type
          testingLab {
            ...ConcreteTestSetTrackerRelationsTestingLab
          }
          labTech {
            ...ConcreteTestSetTrackerRelationsLabTech
          }
        }
      }
    }
    concreteTests(concreteTestFieldInput: {deleted: false}) {
      concreteTestSetGuid
      globalId
      batchTime
      timeTested
      iaWith
      airMeterNumber
      airMeterCalibrationDate
      fieldNumber
      cylinderNumber
      testSubId
      strengthAge
      strengthAges
      truckNumber
      notes
      payItemNoGeometries(payItemNoGeometryFieldInput: {deleted: false}) {
        ...ConcreteTestSetTrackerRelationsPayItem
      }
      percentAir
      slump
      airTemp
      concreteTemp
      sampleAtQuantity
      unitWeight
      average28DayStrength
      percentAirTestedBy {
        technicianName
      }
      slumpTestedBy {
        technicianName
      }
      unitWeightTech {
        technicianName
      }
      overrideComments
      concreteTestBreakData {
        id
        labNumber
        age
        breakDate
        diameter
        peakLoad
        strength
        type
        testingLab {
          ...ConcreteTestSetTrackerRelationsTestingLab
        }
        labTech {
          ...ConcreteTestSetTrackerRelationsLabTech
        }
      }
    }
  }
}
    ${ConcreteTestSetTrackerRelationsPayItemFragmentDoc}
${ConcreteTestSetTrackerRelationsTestingLabFragmentDoc}
${ConcreteTestSetTrackerRelationsLabTechFragmentDoc}`;

/**
 * __useConcreteTestSetTrackerRelationsQuery__
 *
 * To run a query within a React component, call `useConcreteTestSetTrackerRelationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useConcreteTestSetTrackerRelationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useConcreteTestSetTrackerRelationsQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useConcreteTestSetTrackerRelationsQuery(baseOptions: Apollo.QueryHookOptions<ConcreteTestSetTrackerRelationsQuery, ConcreteTestSetTrackerRelationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ConcreteTestSetTrackerRelationsQuery, ConcreteTestSetTrackerRelationsQueryVariables>(ConcreteTestSetTrackerRelationsDocument, options);
      }
export function useConcreteTestSetTrackerRelationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ConcreteTestSetTrackerRelationsQuery, ConcreteTestSetTrackerRelationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ConcreteTestSetTrackerRelationsQuery, ConcreteTestSetTrackerRelationsQueryVariables>(ConcreteTestSetTrackerRelationsDocument, options);
        }
export type ConcreteTestSetTrackerRelationsQueryHookResult = ReturnType<typeof useConcreteTestSetTrackerRelationsQuery>;
export type ConcreteTestSetTrackerRelationsLazyQueryHookResult = ReturnType<typeof useConcreteTestSetTrackerRelationsLazyQuery>;
export type ConcreteTestSetTrackerRelationsQueryResult = Apollo.QueryResult<ConcreteTestSetTrackerRelationsQuery, ConcreteTestSetTrackerRelationsQueryVariables>;
export const SetDocumentChecklistValueDocument = gql`
    mutation SetDocumentChecklistValue($input: SetDocumentChecklistValueInput!) {
  setDocumentChecklistValue(setDocumentChecklistValueInput: $input) {
    documentChecklistValue {
      documentChecklistItem {
        name
      }
    }
  }
}
    `;
export type SetDocumentChecklistValueMutationFn = Apollo.MutationFunction<SetDocumentChecklistValueMutation, SetDocumentChecklistValueMutationVariables>;

/**
 * __useSetDocumentChecklistValueMutation__
 *
 * To run a mutation, you first call `useSetDocumentChecklistValueMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetDocumentChecklistValueMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setDocumentChecklistValueMutation, { data, loading, error }] = useSetDocumentChecklistValueMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSetDocumentChecklistValueMutation(baseOptions?: Apollo.MutationHookOptions<SetDocumentChecklistValueMutation, SetDocumentChecklistValueMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetDocumentChecklistValueMutation, SetDocumentChecklistValueMutationVariables>(SetDocumentChecklistValueDocument, options);
      }
export type SetDocumentChecklistValueMutationHookResult = ReturnType<typeof useSetDocumentChecklistValueMutation>;
export type SetDocumentChecklistValueMutationResult = Apollo.MutationResult<SetDocumentChecklistValueMutation>;
export type SetDocumentChecklistValueMutationOptions = Apollo.BaseMutationOptions<SetDocumentChecklistValueMutation, SetDocumentChecklistValueMutationVariables>;
export const CreateDocumentChecklistItemDocument = gql`
    mutation CreateDocumentChecklistItem($createDocumentChecklistItemInput: CreateDocumentChecklistItemInput!) {
  createDocumentChecklistItem(
    createDocumentChecklistItemInput: $createDocumentChecklistItemInput
  ) {
    documentChecklistItem {
      name
    }
  }
}
    `;
export type CreateDocumentChecklistItemMutationFn = Apollo.MutationFunction<CreateDocumentChecklistItemMutation, CreateDocumentChecklistItemMutationVariables>;

/**
 * __useCreateDocumentChecklistItemMutation__
 *
 * To run a mutation, you first call `useCreateDocumentChecklistItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateDocumentChecklistItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createDocumentChecklistItemMutation, { data, loading, error }] = useCreateDocumentChecklistItemMutation({
 *   variables: {
 *      createDocumentChecklistItemInput: // value for 'createDocumentChecklistItemInput'
 *   },
 * });
 */
export function useCreateDocumentChecklistItemMutation(baseOptions?: Apollo.MutationHookOptions<CreateDocumentChecklistItemMutation, CreateDocumentChecklistItemMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateDocumentChecklistItemMutation, CreateDocumentChecklistItemMutationVariables>(CreateDocumentChecklistItemDocument, options);
      }
export type CreateDocumentChecklistItemMutationHookResult = ReturnType<typeof useCreateDocumentChecklistItemMutation>;
export type CreateDocumentChecklistItemMutationResult = Apollo.MutationResult<CreateDocumentChecklistItemMutation>;
export type CreateDocumentChecklistItemMutationOptions = Apollo.BaseMutationOptions<CreateDocumentChecklistItemMutation, CreateDocumentChecklistItemMutationVariables>;
export const EditDocumentChecklistItemDocument = gql`
    mutation EditDocumentChecklistItem($editDocumentChecklistItemInput: EditDocumentChecklistItemInput!) {
  editDocumentChecklistItem(
    editDocumentChecklistItemInput: $editDocumentChecklistItemInput
  ) {
    documentChecklistItem {
      name
    }
  }
}
    `;
export type EditDocumentChecklistItemMutationFn = Apollo.MutationFunction<EditDocumentChecklistItemMutation, EditDocumentChecklistItemMutationVariables>;

/**
 * __useEditDocumentChecklistItemMutation__
 *
 * To run a mutation, you first call `useEditDocumentChecklistItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditDocumentChecklistItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editDocumentChecklistItemMutation, { data, loading, error }] = useEditDocumentChecklistItemMutation({
 *   variables: {
 *      editDocumentChecklistItemInput: // value for 'editDocumentChecklistItemInput'
 *   },
 * });
 */
export function useEditDocumentChecklistItemMutation(baseOptions?: Apollo.MutationHookOptions<EditDocumentChecklistItemMutation, EditDocumentChecklistItemMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditDocumentChecklistItemMutation, EditDocumentChecklistItemMutationVariables>(EditDocumentChecklistItemDocument, options);
      }
export type EditDocumentChecklistItemMutationHookResult = ReturnType<typeof useEditDocumentChecklistItemMutation>;
export type EditDocumentChecklistItemMutationResult = Apollo.MutationResult<EditDocumentChecklistItemMutation>;
export type EditDocumentChecklistItemMutationOptions = Apollo.BaseMutationOptions<EditDocumentChecklistItemMutation, EditDocumentChecklistItemMutationVariables>;
export const RemoveDocumentChecklistItemDocument = gql`
    mutation RemoveDocumentChecklistItem($id: Int!) {
  removeDocumentChecklistItem(id: $id) {
    documentChecklistItem {
      name
    }
  }
}
    `;
export type RemoveDocumentChecklistItemMutationFn = Apollo.MutationFunction<RemoveDocumentChecklistItemMutation, RemoveDocumentChecklistItemMutationVariables>;

/**
 * __useRemoveDocumentChecklistItemMutation__
 *
 * To run a mutation, you first call `useRemoveDocumentChecklistItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveDocumentChecklistItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeDocumentChecklistItemMutation, { data, loading, error }] = useRemoveDocumentChecklistItemMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRemoveDocumentChecklistItemMutation(baseOptions?: Apollo.MutationHookOptions<RemoveDocumentChecklistItemMutation, RemoveDocumentChecklistItemMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveDocumentChecklistItemMutation, RemoveDocumentChecklistItemMutationVariables>(RemoveDocumentChecklistItemDocument, options);
      }
export type RemoveDocumentChecklistItemMutationHookResult = ReturnType<typeof useRemoveDocumentChecklistItemMutation>;
export type RemoveDocumentChecklistItemMutationResult = Apollo.MutationResult<RemoveDocumentChecklistItemMutation>;
export type RemoveDocumentChecklistItemMutationOptions = Apollo.BaseMutationOptions<RemoveDocumentChecklistItemMutation, RemoveDocumentChecklistItemMutationVariables>;
export const GetDocumentChecklistItemsDocument = gql`
    query GetDocumentChecklistItems($documentChecklistItemListInput: DocumentChecklistItemListInput!) {
  documentChecklistItems(
    documentChecklistItemListInput: $documentChecklistItemListInput
  ) {
    records {
      id
      name
      documentChecklistValues {
        documentChecklistItemId
        checked
        concreteTestSet {
          testSetId
          globalId
          deleted
          concreteMaterial {
            globalId
            placementType
          }
        }
      }
      documentChecklistItemToConcreteMaterials {
        concreteMaterial {
          globalId
          placementType
          deleted
        }
      }
    }
  }
}
    `;

/**
 * __useGetDocumentChecklistItemsQuery__
 *
 * To run a query within a React component, call `useGetDocumentChecklistItemsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDocumentChecklistItemsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDocumentChecklistItemsQuery({
 *   variables: {
 *      documentChecklistItemListInput: // value for 'documentChecklistItemListInput'
 *   },
 * });
 */
export function useGetDocumentChecklistItemsQuery(baseOptions: Apollo.QueryHookOptions<GetDocumentChecklistItemsQuery, GetDocumentChecklistItemsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDocumentChecklistItemsQuery, GetDocumentChecklistItemsQueryVariables>(GetDocumentChecklistItemsDocument, options);
      }
export function useGetDocumentChecklistItemsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDocumentChecklistItemsQuery, GetDocumentChecklistItemsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDocumentChecklistItemsQuery, GetDocumentChecklistItemsQueryVariables>(GetDocumentChecklistItemsDocument, options);
        }
export type GetDocumentChecklistItemsQueryHookResult = ReturnType<typeof useGetDocumentChecklistItemsQuery>;
export type GetDocumentChecklistItemsLazyQueryHookResult = ReturnType<typeof useGetDocumentChecklistItemsLazyQuery>;
export type GetDocumentChecklistItemsQueryResult = Apollo.QueryResult<GetDocumentChecklistItemsQuery, GetDocumentChecklistItemsQueryVariables>;
export const GetDocumentChecklistItemsMetadataDocument = gql`
    query GetDocumentChecklistItemsMetadata($globalId: String!) {
  project(globalId: $globalId) {
    concreteMaterials(concreteMaterialFieldInput: {deleted: false}) {
      globalId
      placementType
    }
    concreteTestSets {
      globalId
      testSetId
      deleted
      concreteMaterial {
        placementType
      }
      documentChecklistValues {
        checked
        documentChecklistItem {
          id
        }
      }
    }
  }
}
    `;

/**
 * __useGetDocumentChecklistItemsMetadataQuery__
 *
 * To run a query within a React component, call `useGetDocumentChecklistItemsMetadataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDocumentChecklistItemsMetadataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDocumentChecklistItemsMetadataQuery({
 *   variables: {
 *      globalId: // value for 'globalId'
 *   },
 * });
 */
export function useGetDocumentChecklistItemsMetadataQuery(baseOptions: Apollo.QueryHookOptions<GetDocumentChecklistItemsMetadataQuery, GetDocumentChecklistItemsMetadataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDocumentChecklistItemsMetadataQuery, GetDocumentChecklistItemsMetadataQueryVariables>(GetDocumentChecklistItemsMetadataDocument, options);
      }
export function useGetDocumentChecklistItemsMetadataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDocumentChecklistItemsMetadataQuery, GetDocumentChecklistItemsMetadataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDocumentChecklistItemsMetadataQuery, GetDocumentChecklistItemsMetadataQueryVariables>(GetDocumentChecklistItemsMetadataDocument, options);
        }
export type GetDocumentChecklistItemsMetadataQueryHookResult = ReturnType<typeof useGetDocumentChecklistItemsMetadataQuery>;
export type GetDocumentChecklistItemsMetadataLazyQueryHookResult = ReturnType<typeof useGetDocumentChecklistItemsMetadataLazyQuery>;
export type GetDocumentChecklistItemsMetadataQueryResult = Apollo.QueryResult<GetDocumentChecklistItemsMetadataQuery, GetDocumentChecklistItemsMetadataQueryVariables>;
export const ProjectConcreteNotificationEventsDocument = gql`
    query ProjectConcreteNotificationEvents($globalId: String!) {
  project(globalId: $globalId) {
    concreteNotifications {
      notificationEventId
      recipients {
        every {
          ...ConcreteNotificationsRecipients
        }
        byConcreteMaterial(concreteMaterialFieldInput: {deleted: false}) {
          concreteMaterial {
            globalId
          }
          recipients {
            ...ConcreteNotificationsRecipients
          }
        }
        byConcreteMixDesign(concreteMixDesignFieldInput: {deleted: false}) {
          concreteMixDesign {
            globalId
          }
          recipients {
            ...ConcreteNotificationsRecipients
          }
        }
      }
    }
    concreteMaterials(concreteMaterialFieldInput: {deleted: false}) {
      globalId
      shortName
      placementType
    }
    concreteMixDesigns(concreteMixDesignFieldInput: {deleted: false}) {
      globalId
      mixDesignNumber
    }
  }
}
    ${ConcreteNotificationsRecipientsFragmentDoc}`;

/**
 * __useProjectConcreteNotificationEventsQuery__
 *
 * To run a query within a React component, call `useProjectConcreteNotificationEventsQuery` and pass it any options that fit your needs.
 * When your component renders, `useProjectConcreteNotificationEventsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProjectConcreteNotificationEventsQuery({
 *   variables: {
 *      globalId: // value for 'globalId'
 *   },
 * });
 */
export function useProjectConcreteNotificationEventsQuery(baseOptions: Apollo.QueryHookOptions<ProjectConcreteNotificationEventsQuery, ProjectConcreteNotificationEventsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProjectConcreteNotificationEventsQuery, ProjectConcreteNotificationEventsQueryVariables>(ProjectConcreteNotificationEventsDocument, options);
      }
export function useProjectConcreteNotificationEventsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProjectConcreteNotificationEventsQuery, ProjectConcreteNotificationEventsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProjectConcreteNotificationEventsQuery, ProjectConcreteNotificationEventsQueryVariables>(ProjectConcreteNotificationEventsDocument, options);
        }
export type ProjectConcreteNotificationEventsQueryHookResult = ReturnType<typeof useProjectConcreteNotificationEventsQuery>;
export type ProjectConcreteNotificationEventsLazyQueryHookResult = ReturnType<typeof useProjectConcreteNotificationEventsLazyQuery>;
export type ProjectConcreteNotificationEventsQueryResult = Apollo.QueryResult<ProjectConcreteNotificationEventsQuery, ProjectConcreteNotificationEventsQueryVariables>;
export const EditConcreteNotificationDocument = gql`
    mutation EditConcreteNotification($editConcreteNotificationInput: EditConcreteNotificationInput!) {
  editConcreteNotification(
    editConcreteNotificationInput: $editConcreteNotificationInput
  ) {
    notification {
      notificationEvent
    }
  }
}
    `;
export type EditConcreteNotificationMutationFn = Apollo.MutationFunction<EditConcreteNotificationMutation, EditConcreteNotificationMutationVariables>;

/**
 * __useEditConcreteNotificationMutation__
 *
 * To run a mutation, you first call `useEditConcreteNotificationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditConcreteNotificationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editConcreteNotificationMutation, { data, loading, error }] = useEditConcreteNotificationMutation({
 *   variables: {
 *      editConcreteNotificationInput: // value for 'editConcreteNotificationInput'
 *   },
 * });
 */
export function useEditConcreteNotificationMutation(baseOptions?: Apollo.MutationHookOptions<EditConcreteNotificationMutation, EditConcreteNotificationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditConcreteNotificationMutation, EditConcreteNotificationMutationVariables>(EditConcreteNotificationDocument, options);
      }
export type EditConcreteNotificationMutationHookResult = ReturnType<typeof useEditConcreteNotificationMutation>;
export type EditConcreteNotificationMutationResult = Apollo.MutationResult<EditConcreteNotificationMutation>;
export type EditConcreteNotificationMutationOptions = Apollo.BaseMutationOptions<EditConcreteNotificationMutation, EditConcreteNotificationMutationVariables>;
export const EditLabTechDocument = gql`
    mutation EditLabTech($input: EditLabTechInput!) {
  editLabTech(editLabTechInput: $input) {
    labTech {
      name
    }
  }
}
    `;
export type EditLabTechMutationFn = Apollo.MutationFunction<EditLabTechMutation, EditLabTechMutationVariables>;

/**
 * __useEditLabTechMutation__
 *
 * To run a mutation, you first call `useEditLabTechMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditLabTechMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editLabTechMutation, { data, loading, error }] = useEditLabTechMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEditLabTechMutation(baseOptions?: Apollo.MutationHookOptions<EditLabTechMutation, EditLabTechMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditLabTechMutation, EditLabTechMutationVariables>(EditLabTechDocument, options);
      }
export type EditLabTechMutationHookResult = ReturnType<typeof useEditLabTechMutation>;
export type EditLabTechMutationResult = Apollo.MutationResult<EditLabTechMutation>;
export type EditLabTechMutationOptions = Apollo.BaseMutationOptions<EditLabTechMutation, EditLabTechMutationVariables>;
export const LabTechsDocument = gql`
    query LabTechs($projectId: String!) {
  project(globalId: $projectId) {
    labTechs {
      name
      id
      user {
        id
        displayName
        mail
        deleted
        userGroups {
          id
        }
      }
      testingLabs {
        name
        id
      }
      concreteTestBreakDatas {
        concreteTest {
          concreteTestSet {
            ...LabTechsConcreteTestSet
          }
        }
      }
      concreteCoreBreakDatas {
        concreteCoreMeasurement {
          concretePlacement {
            concreteTestSet {
              ...LabTechsConcreteTestSet
            }
          }
        }
      }
    }
  }
}
    ${LabTechsConcreteTestSetFragmentDoc}`;

/**
 * __useLabTechsQuery__
 *
 * To run a query within a React component, call `useLabTechsQuery` and pass it any options that fit your needs.
 * When your component renders, `useLabTechsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLabTechsQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useLabTechsQuery(baseOptions: Apollo.QueryHookOptions<LabTechsQuery, LabTechsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LabTechsQuery, LabTechsQueryVariables>(LabTechsDocument, options);
      }
export function useLabTechsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LabTechsQuery, LabTechsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LabTechsQuery, LabTechsQueryVariables>(LabTechsDocument, options);
        }
export type LabTechsQueryHookResult = ReturnType<typeof useLabTechsQuery>;
export type LabTechsLazyQueryHookResult = ReturnType<typeof useLabTechsLazyQuery>;
export type LabTechsQueryResult = Apollo.QueryResult<LabTechsQuery, LabTechsQueryVariables>;
export const CreateLabTechDocument = gql`
    mutation CreateLabTech($input: CreateLabTechInput!) {
  createLabTech(createLabTechInput: $input) {
    labTech {
      name
    }
  }
}
    `;
export type CreateLabTechMutationFn = Apollo.MutationFunction<CreateLabTechMutation, CreateLabTechMutationVariables>;

/**
 * __useCreateLabTechMutation__
 *
 * To run a mutation, you first call `useCreateLabTechMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateLabTechMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createLabTechMutation, { data, loading, error }] = useCreateLabTechMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateLabTechMutation(baseOptions?: Apollo.MutationHookOptions<CreateLabTechMutation, CreateLabTechMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateLabTechMutation, CreateLabTechMutationVariables>(CreateLabTechDocument, options);
      }
export type CreateLabTechMutationHookResult = ReturnType<typeof useCreateLabTechMutation>;
export type CreateLabTechMutationResult = Apollo.MutationResult<CreateLabTechMutation>;
export type CreateLabTechMutationOptions = Apollo.BaseMutationOptions<CreateLabTechMutation, CreateLabTechMutationVariables>;
export const RemoveLabTechDocument = gql`
    mutation RemoveLabTech($id: Int!) {
  removeLabTech(id: $id) {
    labTech {
      name
    }
  }
}
    `;
export type RemoveLabTechMutationFn = Apollo.MutationFunction<RemoveLabTechMutation, RemoveLabTechMutationVariables>;

/**
 * __useRemoveLabTechMutation__
 *
 * To run a mutation, you first call `useRemoveLabTechMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveLabTechMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeLabTechMutation, { data, loading, error }] = useRemoveLabTechMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRemoveLabTechMutation(baseOptions?: Apollo.MutationHookOptions<RemoveLabTechMutation, RemoveLabTechMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveLabTechMutation, RemoveLabTechMutationVariables>(RemoveLabTechDocument, options);
      }
export type RemoveLabTechMutationHookResult = ReturnType<typeof useRemoveLabTechMutation>;
export type RemoveLabTechMutationResult = Apollo.MutationResult<RemoveLabTechMutation>;
export type RemoveLabTechMutationOptions = Apollo.BaseMutationOptions<RemoveLabTechMutation, RemoveLabTechMutationVariables>;
export const TestingLabsDocument = gql`
    query TestingLabs($projectId: String!) {
  project(globalId: $projectId) {
    testingLabs {
      name
      id
      concreteCoreBreakDatas {
        concreteCoreMeasurement {
          concretePlacement {
            concreteTestSet {
              ...TestingLabsConcreteTestSet
            }
          }
        }
      }
      concreteTestBreakDatas {
        concreteTest {
          concreteTestSet {
            ...LabTechsConcreteTestSet
          }
        }
      }
      labTechs {
        name
        id
        user {
          id
          displayName
          mail
          deleted
          userGroups {
            id
          }
        }
      }
    }
  }
}
    ${TestingLabsConcreteTestSetFragmentDoc}
${LabTechsConcreteTestSetFragmentDoc}`;

/**
 * __useTestingLabsQuery__
 *
 * To run a query within a React component, call `useTestingLabsQuery` and pass it any options that fit your needs.
 * When your component renders, `useTestingLabsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTestingLabsQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useTestingLabsQuery(baseOptions: Apollo.QueryHookOptions<TestingLabsQuery, TestingLabsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TestingLabsQuery, TestingLabsQueryVariables>(TestingLabsDocument, options);
      }
export function useTestingLabsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TestingLabsQuery, TestingLabsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TestingLabsQuery, TestingLabsQueryVariables>(TestingLabsDocument, options);
        }
export type TestingLabsQueryHookResult = ReturnType<typeof useTestingLabsQuery>;
export type TestingLabsLazyQueryHookResult = ReturnType<typeof useTestingLabsLazyQuery>;
export type TestingLabsQueryResult = Apollo.QueryResult<TestingLabsQuery, TestingLabsQueryVariables>;
export const CreateTestingLabDocument = gql`
    mutation CreateTestingLab($input: CreateTestingLabInput!) {
  createTestingLab(createTestingLabInput: $input) {
    testingLab {
      name
    }
  }
}
    `;
export type CreateTestingLabMutationFn = Apollo.MutationFunction<CreateTestingLabMutation, CreateTestingLabMutationVariables>;

/**
 * __useCreateTestingLabMutation__
 *
 * To run a mutation, you first call `useCreateTestingLabMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateTestingLabMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createTestingLabMutation, { data, loading, error }] = useCreateTestingLabMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateTestingLabMutation(baseOptions?: Apollo.MutationHookOptions<CreateTestingLabMutation, CreateTestingLabMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateTestingLabMutation, CreateTestingLabMutationVariables>(CreateTestingLabDocument, options);
      }
export type CreateTestingLabMutationHookResult = ReturnType<typeof useCreateTestingLabMutation>;
export type CreateTestingLabMutationResult = Apollo.MutationResult<CreateTestingLabMutation>;
export type CreateTestingLabMutationOptions = Apollo.BaseMutationOptions<CreateTestingLabMutation, CreateTestingLabMutationVariables>;
export const EditTestingLabDocument = gql`
    mutation EditTestingLab($input: EditTestingLabInput!) {
  editTestingLab(editTestingLabInput: $input) {
    testingLab {
      name
    }
  }
}
    `;
export type EditTestingLabMutationFn = Apollo.MutationFunction<EditTestingLabMutation, EditTestingLabMutationVariables>;

/**
 * __useEditTestingLabMutation__
 *
 * To run a mutation, you first call `useEditTestingLabMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditTestingLabMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editTestingLabMutation, { data, loading, error }] = useEditTestingLabMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEditTestingLabMutation(baseOptions?: Apollo.MutationHookOptions<EditTestingLabMutation, EditTestingLabMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditTestingLabMutation, EditTestingLabMutationVariables>(EditTestingLabDocument, options);
      }
export type EditTestingLabMutationHookResult = ReturnType<typeof useEditTestingLabMutation>;
export type EditTestingLabMutationResult = Apollo.MutationResult<EditTestingLabMutation>;
export type EditTestingLabMutationOptions = Apollo.BaseMutationOptions<EditTestingLabMutation, EditTestingLabMutationVariables>;
export const RemoveTestingLabDocument = gql`
    mutation RemoveTestingLab($id: Int!) {
  removeTestingLab(id: $id) {
    testingLab {
      name
    }
  }
}
    `;
export type RemoveTestingLabMutationFn = Apollo.MutationFunction<RemoveTestingLabMutation, RemoveTestingLabMutationVariables>;

/**
 * __useRemoveTestingLabMutation__
 *
 * To run a mutation, you first call `useRemoveTestingLabMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveTestingLabMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeTestingLabMutation, { data, loading, error }] = useRemoveTestingLabMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRemoveTestingLabMutation(baseOptions?: Apollo.MutationHookOptions<RemoveTestingLabMutation, RemoveTestingLabMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveTestingLabMutation, RemoveTestingLabMutationVariables>(RemoveTestingLabDocument, options);
      }
export type RemoveTestingLabMutationHookResult = ReturnType<typeof useRemoveTestingLabMutation>;
export type RemoveTestingLabMutationResult = Apollo.MutationResult<RemoveTestingLabMutation>;
export type RemoveTestingLabMutationOptions = Apollo.BaseMutationOptions<RemoveTestingLabMutation, RemoveTestingLabMutationVariables>;
export const CreateCasQuickLinkDocument = gql`
    mutation CreateCASQuickLink($input: CreateCASQuickLinkInput!) {
  createCASQuickLink(createCASQuickLinkInput: $input) {
    casQuickLink {
      label
    }
  }
}
    `;
export type CreateCasQuickLinkMutationFn = Apollo.MutationFunction<CreateCasQuickLinkMutation, CreateCasQuickLinkMutationVariables>;

/**
 * __useCreateCasQuickLinkMutation__
 *
 * To run a mutation, you first call `useCreateCasQuickLinkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCasQuickLinkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCasQuickLinkMutation, { data, loading, error }] = useCreateCasQuickLinkMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateCasQuickLinkMutation(baseOptions?: Apollo.MutationHookOptions<CreateCasQuickLinkMutation, CreateCasQuickLinkMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateCasQuickLinkMutation, CreateCasQuickLinkMutationVariables>(CreateCasQuickLinkDocument, options);
      }
export type CreateCasQuickLinkMutationHookResult = ReturnType<typeof useCreateCasQuickLinkMutation>;
export type CreateCasQuickLinkMutationResult = Apollo.MutationResult<CreateCasQuickLinkMutation>;
export type CreateCasQuickLinkMutationOptions = Apollo.BaseMutationOptions<CreateCasQuickLinkMutation, CreateCasQuickLinkMutationVariables>;
export const EditCasQuickLinkDocument = gql`
    mutation EditCASQuickLink($input: EditCASQuickLinkInput!) {
  editCASQuickLink(editCASQuickLinkInput: $input) {
    casQuickLink {
      label
    }
  }
}
    `;
export type EditCasQuickLinkMutationFn = Apollo.MutationFunction<EditCasQuickLinkMutation, EditCasQuickLinkMutationVariables>;

/**
 * __useEditCasQuickLinkMutation__
 *
 * To run a mutation, you first call `useEditCasQuickLinkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditCasQuickLinkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editCasQuickLinkMutation, { data, loading, error }] = useEditCasQuickLinkMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEditCasQuickLinkMutation(baseOptions?: Apollo.MutationHookOptions<EditCasQuickLinkMutation, EditCasQuickLinkMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditCasQuickLinkMutation, EditCasQuickLinkMutationVariables>(EditCasQuickLinkDocument, options);
      }
export type EditCasQuickLinkMutationHookResult = ReturnType<typeof useEditCasQuickLinkMutation>;
export type EditCasQuickLinkMutationResult = Apollo.MutationResult<EditCasQuickLinkMutation>;
export type EditCasQuickLinkMutationOptions = Apollo.BaseMutationOptions<EditCasQuickLinkMutation, EditCasQuickLinkMutationVariables>;
export const GetCasQuickLinksDocument = gql`
    query GetCASQuickLinks($input: CASQuickLinkListInput!) {
  casQuickLinks(casQuickLinkListInput: $input) {
    records {
      id
      label
      href
      description
      deleted
      deletedDate
      deletedUser
    }
  }
}
    `;

/**
 * __useGetCasQuickLinksQuery__
 *
 * To run a query within a React component, call `useGetCasQuickLinksQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCasQuickLinksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCasQuickLinksQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetCasQuickLinksQuery(baseOptions: Apollo.QueryHookOptions<GetCasQuickLinksQuery, GetCasQuickLinksQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCasQuickLinksQuery, GetCasQuickLinksQueryVariables>(GetCasQuickLinksDocument, options);
      }
export function useGetCasQuickLinksLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCasQuickLinksQuery, GetCasQuickLinksQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCasQuickLinksQuery, GetCasQuickLinksQueryVariables>(GetCasQuickLinksDocument, options);
        }
export type GetCasQuickLinksQueryHookResult = ReturnType<typeof useGetCasQuickLinksQuery>;
export type GetCasQuickLinksLazyQueryHookResult = ReturnType<typeof useGetCasQuickLinksLazyQuery>;
export type GetCasQuickLinksQueryResult = Apollo.QueryResult<GetCasQuickLinksQuery, GetCasQuickLinksQueryVariables>;
export const RestoreCasQuickLinkDocument = gql`
    mutation RestoreCASQuickLink($id: String!) {
  restoreCASQuickLink(id: $id) {
    casQuickLink {
      label
    }
  }
}
    `;
export type RestoreCasQuickLinkMutationFn = Apollo.MutationFunction<RestoreCasQuickLinkMutation, RestoreCasQuickLinkMutationVariables>;

/**
 * __useRestoreCasQuickLinkMutation__
 *
 * To run a mutation, you first call `useRestoreCasQuickLinkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRestoreCasQuickLinkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [restoreCasQuickLinkMutation, { data, loading, error }] = useRestoreCasQuickLinkMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRestoreCasQuickLinkMutation(baseOptions?: Apollo.MutationHookOptions<RestoreCasQuickLinkMutation, RestoreCasQuickLinkMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RestoreCasQuickLinkMutation, RestoreCasQuickLinkMutationVariables>(RestoreCasQuickLinkDocument, options);
      }
export type RestoreCasQuickLinkMutationHookResult = ReturnType<typeof useRestoreCasQuickLinkMutation>;
export type RestoreCasQuickLinkMutationResult = Apollo.MutationResult<RestoreCasQuickLinkMutation>;
export type RestoreCasQuickLinkMutationOptions = Apollo.BaseMutationOptions<RestoreCasQuickLinkMutation, RestoreCasQuickLinkMutationVariables>;
export const SoftRemoveCasQuickLinkDocument = gql`
    mutation SoftRemoveCASQuickLink($id: String!) {
  softRemoveCASQuickLink(id: $id) {
    casQuickLink {
      label
    }
  }
}
    `;
export type SoftRemoveCasQuickLinkMutationFn = Apollo.MutationFunction<SoftRemoveCasQuickLinkMutation, SoftRemoveCasQuickLinkMutationVariables>;

/**
 * __useSoftRemoveCasQuickLinkMutation__
 *
 * To run a mutation, you first call `useSoftRemoveCasQuickLinkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSoftRemoveCasQuickLinkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [softRemoveCasQuickLinkMutation, { data, loading, error }] = useSoftRemoveCasQuickLinkMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSoftRemoveCasQuickLinkMutation(baseOptions?: Apollo.MutationHookOptions<SoftRemoveCasQuickLinkMutation, SoftRemoveCasQuickLinkMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SoftRemoveCasQuickLinkMutation, SoftRemoveCasQuickLinkMutationVariables>(SoftRemoveCasQuickLinkDocument, options);
      }
export type SoftRemoveCasQuickLinkMutationHookResult = ReturnType<typeof useSoftRemoveCasQuickLinkMutation>;
export type SoftRemoveCasQuickLinkMutationResult = Apollo.MutationResult<SoftRemoveCasQuickLinkMutation>;
export type SoftRemoveCasQuickLinkMutationOptions = Apollo.BaseMutationOptions<SoftRemoveCasQuickLinkMutation, SoftRemoveCasQuickLinkMutationVariables>;
export const CasDispositionTypesDocument = gql`
    query CASDispositionTypes($projectId: String!) {
  casDispositionTypes(
    casDispositionTypeListInput: {projectId: {equals: $projectId}}
  ) {
    records {
      id
      name
      description
      deleted
      deletedDate
      deletedUser
      requiresComments
      submittals {
        id
        deleted
        packageNumber
        packageName
      }
    }
  }
}
    `;

/**
 * __useCasDispositionTypesQuery__
 *
 * To run a query within a React component, call `useCasDispositionTypesQuery` and pass it any options that fit your needs.
 * When your component renders, `useCasDispositionTypesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCasDispositionTypesQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useCasDispositionTypesQuery(baseOptions: Apollo.QueryHookOptions<CasDispositionTypesQuery, CasDispositionTypesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CasDispositionTypesQuery, CasDispositionTypesQueryVariables>(CasDispositionTypesDocument, options);
      }
export function useCasDispositionTypesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CasDispositionTypesQuery, CasDispositionTypesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CasDispositionTypesQuery, CasDispositionTypesQueryVariables>(CasDispositionTypesDocument, options);
        }
export type CasDispositionTypesQueryHookResult = ReturnType<typeof useCasDispositionTypesQuery>;
export type CasDispositionTypesLazyQueryHookResult = ReturnType<typeof useCasDispositionTypesLazyQuery>;
export type CasDispositionTypesQueryResult = Apollo.QueryResult<CasDispositionTypesQuery, CasDispositionTypesQueryVariables>;
export const EditCasDispositionTypeDocument = gql`
    mutation EditCASDispositionType($input: EditCASDispositionTypeInput!) {
  editCASDispositionType(editCASDispositionTypeInput: $input) {
    dispositionType {
      name
    }
  }
}
    `;
export type EditCasDispositionTypeMutationFn = Apollo.MutationFunction<EditCasDispositionTypeMutation, EditCasDispositionTypeMutationVariables>;

/**
 * __useEditCasDispositionTypeMutation__
 *
 * To run a mutation, you first call `useEditCasDispositionTypeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditCasDispositionTypeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editCasDispositionTypeMutation, { data, loading, error }] = useEditCasDispositionTypeMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEditCasDispositionTypeMutation(baseOptions?: Apollo.MutationHookOptions<EditCasDispositionTypeMutation, EditCasDispositionTypeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditCasDispositionTypeMutation, EditCasDispositionTypeMutationVariables>(EditCasDispositionTypeDocument, options);
      }
export type EditCasDispositionTypeMutationHookResult = ReturnType<typeof useEditCasDispositionTypeMutation>;
export type EditCasDispositionTypeMutationResult = Apollo.MutationResult<EditCasDispositionTypeMutation>;
export type EditCasDispositionTypeMutationOptions = Apollo.BaseMutationOptions<EditCasDispositionTypeMutation, EditCasDispositionTypeMutationVariables>;
export const CreateCasDispositionTypeDocument = gql`
    mutation CreateCASDispositionType($input: CreateCASDispositionTypeInput!) {
  createCASDispositionType(createCASDispositionTypeInput: $input) {
    dispositionType {
      name
    }
  }
}
    `;
export type CreateCasDispositionTypeMutationFn = Apollo.MutationFunction<CreateCasDispositionTypeMutation, CreateCasDispositionTypeMutationVariables>;

/**
 * __useCreateCasDispositionTypeMutation__
 *
 * To run a mutation, you first call `useCreateCasDispositionTypeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCasDispositionTypeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCasDispositionTypeMutation, { data, loading, error }] = useCreateCasDispositionTypeMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateCasDispositionTypeMutation(baseOptions?: Apollo.MutationHookOptions<CreateCasDispositionTypeMutation, CreateCasDispositionTypeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateCasDispositionTypeMutation, CreateCasDispositionTypeMutationVariables>(CreateCasDispositionTypeDocument, options);
      }
export type CreateCasDispositionTypeMutationHookResult = ReturnType<typeof useCreateCasDispositionTypeMutation>;
export type CreateCasDispositionTypeMutationResult = Apollo.MutationResult<CreateCasDispositionTypeMutation>;
export type CreateCasDispositionTypeMutationOptions = Apollo.BaseMutationOptions<CreateCasDispositionTypeMutation, CreateCasDispositionTypeMutationVariables>;
export const RemoveCasDispositionTypeDocument = gql`
    mutation RemoveCASDispositionType($id: String!) {
  softRemoveCASDispositionType(id: $id) {
    dispositionType {
      name
    }
  }
}
    `;
export type RemoveCasDispositionTypeMutationFn = Apollo.MutationFunction<RemoveCasDispositionTypeMutation, RemoveCasDispositionTypeMutationVariables>;

/**
 * __useRemoveCasDispositionTypeMutation__
 *
 * To run a mutation, you first call `useRemoveCasDispositionTypeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveCasDispositionTypeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeCasDispositionTypeMutation, { data, loading, error }] = useRemoveCasDispositionTypeMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRemoveCasDispositionTypeMutation(baseOptions?: Apollo.MutationHookOptions<RemoveCasDispositionTypeMutation, RemoveCasDispositionTypeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveCasDispositionTypeMutation, RemoveCasDispositionTypeMutationVariables>(RemoveCasDispositionTypeDocument, options);
      }
export type RemoveCasDispositionTypeMutationHookResult = ReturnType<typeof useRemoveCasDispositionTypeMutation>;
export type RemoveCasDispositionTypeMutationResult = Apollo.MutationResult<RemoveCasDispositionTypeMutation>;
export type RemoveCasDispositionTypeMutationOptions = Apollo.BaseMutationOptions<RemoveCasDispositionTypeMutation, RemoveCasDispositionTypeMutationVariables>;
export const RestoreCasDispositionTypeDocument = gql`
    mutation RestoreCASDispositionType($id: String!) {
  restoreCASDispositionType(id: $id) {
    dispositionType {
      name
    }
  }
}
    `;
export type RestoreCasDispositionTypeMutationFn = Apollo.MutationFunction<RestoreCasDispositionTypeMutation, RestoreCasDispositionTypeMutationVariables>;

/**
 * __useRestoreCasDispositionTypeMutation__
 *
 * To run a mutation, you first call `useRestoreCasDispositionTypeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRestoreCasDispositionTypeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [restoreCasDispositionTypeMutation, { data, loading, error }] = useRestoreCasDispositionTypeMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRestoreCasDispositionTypeMutation(baseOptions?: Apollo.MutationHookOptions<RestoreCasDispositionTypeMutation, RestoreCasDispositionTypeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RestoreCasDispositionTypeMutation, RestoreCasDispositionTypeMutationVariables>(RestoreCasDispositionTypeDocument, options);
      }
export type RestoreCasDispositionTypeMutationHookResult = ReturnType<typeof useRestoreCasDispositionTypeMutation>;
export type RestoreCasDispositionTypeMutationResult = Apollo.MutationResult<RestoreCasDispositionTypeMutation>;
export type RestoreCasDispositionTypeMutationOptions = Apollo.BaseMutationOptions<RestoreCasDispositionTypeMutation, RestoreCasDispositionTypeMutationVariables>;
export const CasNotificationsDocument = gql`
    query CASNotifications($projectId: String!) {
  project(globalId: $projectId) {
    casRoutingGroups(casRoutingGroupFieldInput: {deleted: false}) {
      name
      id
      description
      users {
        ...CASNotificationsUser
      }
    }
    casNotifications {
      notificationEventId
      recipients {
        every {
          ...CASNotificationsRecipients
        }
        byRoutingGroup {
          routingGroup {
            id
            name
          }
          recipients {
            ...CASNotificationsRecipients
          }
        }
      }
      settings {
        frequency {
          next
          previous
          hour
          minute
        }
        notificationThresholdDay
      }
    }
  }
}
    ${CasNotificationsUserFragmentDoc}
${CasNotificationsRecipientsFragmentDoc}`;

/**
 * __useCasNotificationsQuery__
 *
 * To run a query within a React component, call `useCasNotificationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCasNotificationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCasNotificationsQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useCasNotificationsQuery(baseOptions: Apollo.QueryHookOptions<CasNotificationsQuery, CasNotificationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CasNotificationsQuery, CasNotificationsQueryVariables>(CasNotificationsDocument, options);
      }
export function useCasNotificationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CasNotificationsQuery, CasNotificationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CasNotificationsQuery, CasNotificationsQueryVariables>(CasNotificationsDocument, options);
        }
export type CasNotificationsQueryHookResult = ReturnType<typeof useCasNotificationsQuery>;
export type CasNotificationsLazyQueryHookResult = ReturnType<typeof useCasNotificationsLazyQuery>;
export type CasNotificationsQueryResult = Apollo.QueryResult<CasNotificationsQuery, CasNotificationsQueryVariables>;
export const EditCasNotificationDocument = gql`
    mutation EditCASNotification($input: EditCASNotificationInput!) {
  editCASNotification(editCASNotificationInput: $input) {
    notification {
      notificationEvent
    }
  }
}
    `;
export type EditCasNotificationMutationFn = Apollo.MutationFunction<EditCasNotificationMutation, EditCasNotificationMutationVariables>;

/**
 * __useEditCasNotificationMutation__
 *
 * To run a mutation, you first call `useEditCasNotificationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditCasNotificationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editCasNotificationMutation, { data, loading, error }] = useEditCasNotificationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEditCasNotificationMutation(baseOptions?: Apollo.MutationHookOptions<EditCasNotificationMutation, EditCasNotificationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditCasNotificationMutation, EditCasNotificationMutationVariables>(EditCasNotificationDocument, options);
      }
export type EditCasNotificationMutationHookResult = ReturnType<typeof useEditCasNotificationMutation>;
export type EditCasNotificationMutationResult = Apollo.MutationResult<EditCasNotificationMutation>;
export type EditCasNotificationMutationOptions = Apollo.BaseMutationOptions<EditCasNotificationMutation, EditCasNotificationMutationVariables>;
export const CreateCasRoutingGroupDocument = gql`
    mutation CreateCASRoutingGroup($createCASRoutingGroupInput: CreateCASRoutingGroupInput!) {
  createCASRoutingGroup(createCASRoutingGroupInput: $createCASRoutingGroupInput) {
    routingGroup {
      name
    }
  }
}
    `;
export type CreateCasRoutingGroupMutationFn = Apollo.MutationFunction<CreateCasRoutingGroupMutation, CreateCasRoutingGroupMutationVariables>;

/**
 * __useCreateCasRoutingGroupMutation__
 *
 * To run a mutation, you first call `useCreateCasRoutingGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCasRoutingGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCasRoutingGroupMutation, { data, loading, error }] = useCreateCasRoutingGroupMutation({
 *   variables: {
 *      createCASRoutingGroupInput: // value for 'createCASRoutingGroupInput'
 *   },
 * });
 */
export function useCreateCasRoutingGroupMutation(baseOptions?: Apollo.MutationHookOptions<CreateCasRoutingGroupMutation, CreateCasRoutingGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateCasRoutingGroupMutation, CreateCasRoutingGroupMutationVariables>(CreateCasRoutingGroupDocument, options);
      }
export type CreateCasRoutingGroupMutationHookResult = ReturnType<typeof useCreateCasRoutingGroupMutation>;
export type CreateCasRoutingGroupMutationResult = Apollo.MutationResult<CreateCasRoutingGroupMutation>;
export type CreateCasRoutingGroupMutationOptions = Apollo.BaseMutationOptions<CreateCasRoutingGroupMutation, CreateCasRoutingGroupMutationVariables>;
export const EditCasRoutingGroupDocument = gql`
    mutation EditCASRoutingGroup($editCASRoutingGroupInput: EditCASRoutingGroupInput!) {
  editCASRoutingGroup(editCASRoutingGroupInput: $editCASRoutingGroupInput) {
    routingGroup {
      name
    }
  }
}
    `;
export type EditCasRoutingGroupMutationFn = Apollo.MutationFunction<EditCasRoutingGroupMutation, EditCasRoutingGroupMutationVariables>;

/**
 * __useEditCasRoutingGroupMutation__
 *
 * To run a mutation, you first call `useEditCasRoutingGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditCasRoutingGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editCasRoutingGroupMutation, { data, loading, error }] = useEditCasRoutingGroupMutation({
 *   variables: {
 *      editCASRoutingGroupInput: // value for 'editCASRoutingGroupInput'
 *   },
 * });
 */
export function useEditCasRoutingGroupMutation(baseOptions?: Apollo.MutationHookOptions<EditCasRoutingGroupMutation, EditCasRoutingGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditCasRoutingGroupMutation, EditCasRoutingGroupMutationVariables>(EditCasRoutingGroupDocument, options);
      }
export type EditCasRoutingGroupMutationHookResult = ReturnType<typeof useEditCasRoutingGroupMutation>;
export type EditCasRoutingGroupMutationResult = Apollo.MutationResult<EditCasRoutingGroupMutation>;
export type EditCasRoutingGroupMutationOptions = Apollo.BaseMutationOptions<EditCasRoutingGroupMutation, EditCasRoutingGroupMutationVariables>;
export const SoftRemoveCasRoutingGroupDocument = gql`
    mutation SoftRemoveCASRoutingGroup($id: String!) {
  softRemoveCASRoutingGroup(id: $id) {
    routingGroup {
      name
    }
  }
}
    `;
export type SoftRemoveCasRoutingGroupMutationFn = Apollo.MutationFunction<SoftRemoveCasRoutingGroupMutation, SoftRemoveCasRoutingGroupMutationVariables>;

/**
 * __useSoftRemoveCasRoutingGroupMutation__
 *
 * To run a mutation, you first call `useSoftRemoveCasRoutingGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSoftRemoveCasRoutingGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [softRemoveCasRoutingGroupMutation, { data, loading, error }] = useSoftRemoveCasRoutingGroupMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSoftRemoveCasRoutingGroupMutation(baseOptions?: Apollo.MutationHookOptions<SoftRemoveCasRoutingGroupMutation, SoftRemoveCasRoutingGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SoftRemoveCasRoutingGroupMutation, SoftRemoveCasRoutingGroupMutationVariables>(SoftRemoveCasRoutingGroupDocument, options);
      }
export type SoftRemoveCasRoutingGroupMutationHookResult = ReturnType<typeof useSoftRemoveCasRoutingGroupMutation>;
export type SoftRemoveCasRoutingGroupMutationResult = Apollo.MutationResult<SoftRemoveCasRoutingGroupMutation>;
export type SoftRemoveCasRoutingGroupMutationOptions = Apollo.BaseMutationOptions<SoftRemoveCasRoutingGroupMutation, SoftRemoveCasRoutingGroupMutationVariables>;
export const RestoreCasRoutingGroupDocument = gql`
    mutation RestoreCASRoutingGroup($id: String!) {
  restoreCASRoutingGroup(id: $id) {
    routingGroup {
      name
    }
  }
}
    `;
export type RestoreCasRoutingGroupMutationFn = Apollo.MutationFunction<RestoreCasRoutingGroupMutation, RestoreCasRoutingGroupMutationVariables>;

/**
 * __useRestoreCasRoutingGroupMutation__
 *
 * To run a mutation, you first call `useRestoreCasRoutingGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRestoreCasRoutingGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [restoreCasRoutingGroupMutation, { data, loading, error }] = useRestoreCasRoutingGroupMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRestoreCasRoutingGroupMutation(baseOptions?: Apollo.MutationHookOptions<RestoreCasRoutingGroupMutation, RestoreCasRoutingGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RestoreCasRoutingGroupMutation, RestoreCasRoutingGroupMutationVariables>(RestoreCasRoutingGroupDocument, options);
      }
export type RestoreCasRoutingGroupMutationHookResult = ReturnType<typeof useRestoreCasRoutingGroupMutation>;
export type RestoreCasRoutingGroupMutationResult = Apollo.MutationResult<RestoreCasRoutingGroupMutation>;
export type RestoreCasRoutingGroupMutationOptions = Apollo.BaseMutationOptions<RestoreCasRoutingGroupMutation, RestoreCasRoutingGroupMutationVariables>;
export const GetCasRoutingGroupsDocument = gql`
    query GetCASRoutingGroups($casRoutingGroupListInput: CASRoutingGroupListInput!) {
  casRoutingGroups(casRoutingGroupListInput: $casRoutingGroupListInput) {
    records {
      id
      name
      description
      deleted
      deletedDate
      deletedUser
      casToCASRoutingGroups {
        submittal {
          id
          packageNumber
          packageName
          deleted
        }
      }
      users(userFieldInput: {deleted: false}) {
        id
        displayName
        mail
        deleted
        userGroups {
          id
        }
      }
    }
  }
}
    `;

/**
 * __useGetCasRoutingGroupsQuery__
 *
 * To run a query within a React component, call `useGetCasRoutingGroupsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCasRoutingGroupsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCasRoutingGroupsQuery({
 *   variables: {
 *      casRoutingGroupListInput: // value for 'casRoutingGroupListInput'
 *   },
 * });
 */
export function useGetCasRoutingGroupsQuery(baseOptions: Apollo.QueryHookOptions<GetCasRoutingGroupsQuery, GetCasRoutingGroupsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCasRoutingGroupsQuery, GetCasRoutingGroupsQueryVariables>(GetCasRoutingGroupsDocument, options);
      }
export function useGetCasRoutingGroupsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCasRoutingGroupsQuery, GetCasRoutingGroupsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCasRoutingGroupsQuery, GetCasRoutingGroupsQueryVariables>(GetCasRoutingGroupsDocument, options);
        }
export type GetCasRoutingGroupsQueryHookResult = ReturnType<typeof useGetCasRoutingGroupsQuery>;
export type GetCasRoutingGroupsLazyQueryHookResult = ReturnType<typeof useGetCasRoutingGroupsLazyQuery>;
export type GetCasRoutingGroupsQueryResult = Apollo.QueryResult<GetCasRoutingGroupsQuery, GetCasRoutingGroupsQueryVariables>;
export const EditCaSubmittalDocument = gql`
    mutation EditCASubmittal($input: EditConstructionAdminSubmittalInput!) {
  editConstructionAdminSubmittal(editConstructionAdminSubmittalInput: $input) {
    submittal {
      sharePointFolderName
    }
  }
}
    `;
export type EditCaSubmittalMutationFn = Apollo.MutationFunction<EditCaSubmittalMutation, EditCaSubmittalMutationVariables>;

/**
 * __useEditCaSubmittalMutation__
 *
 * To run a mutation, you first call `useEditCaSubmittalMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditCaSubmittalMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editCaSubmittalMutation, { data, loading, error }] = useEditCaSubmittalMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEditCaSubmittalMutation(baseOptions?: Apollo.MutationHookOptions<EditCaSubmittalMutation, EditCaSubmittalMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditCaSubmittalMutation, EditCaSubmittalMutationVariables>(EditCaSubmittalDocument, options);
      }
export type EditCaSubmittalMutationHookResult = ReturnType<typeof useEditCaSubmittalMutation>;
export type EditCaSubmittalMutationResult = Apollo.MutationResult<EditCaSubmittalMutation>;
export type EditCaSubmittalMutationOptions = Apollo.BaseMutationOptions<EditCaSubmittalMutation, EditCaSubmittalMutationVariables>;
export const GetCasMetadataDocument = gql`
    query GetCASMetadata($globalId: String!) {
  project(globalId: $globalId) {
    casRoutingGroups(casRoutingGroupFieldInput: {deleted: false}) {
      id
      name
      description
    }
    casTypes(casTypeFieldInput: {deleted: false}) {
      id
      name
      description
    }
    casSubtypes(casSubtypeFieldInput: {deleted: false}) {
      id
      name
      description
    }
    casDispositionTypes(casDispositionTypeFieldInput: {deleted: false}) {
      id
      name
      description
      requiresComments
    }
    casQuickLinks(casQuickLinkFieldInput: {deleted: false}) {
      id
      label
      href
      description
    }
  }
}
    `;

/**
 * __useGetCasMetadataQuery__
 *
 * To run a query within a React component, call `useGetCasMetadataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCasMetadataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCasMetadataQuery({
 *   variables: {
 *      globalId: // value for 'globalId'
 *   },
 * });
 */
export function useGetCasMetadataQuery(baseOptions: Apollo.QueryHookOptions<GetCasMetadataQuery, GetCasMetadataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCasMetadataQuery, GetCasMetadataQueryVariables>(GetCasMetadataDocument, options);
      }
export function useGetCasMetadataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCasMetadataQuery, GetCasMetadataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCasMetadataQuery, GetCasMetadataQueryVariables>(GetCasMetadataDocument, options);
        }
export type GetCasMetadataQueryHookResult = ReturnType<typeof useGetCasMetadataQuery>;
export type GetCasMetadataLazyQueryHookResult = ReturnType<typeof useGetCasMetadataLazyQuery>;
export type GetCasMetadataQueryResult = Apollo.QueryResult<GetCasMetadataQuery, GetCasMetadataQueryVariables>;
export const GetCaSubmittalsDocument = gql`
    query GetCASubmittals($input: ConstructionAdminSubmittalListInput!, $projectId: String!) {
  constructionAdminSubmittals(constructionAdminSubmittalListInput: $input) {
    records {
      id
      previousId
      statusId
      packageName
      packageNumber
      sharePointFolderName
      sharePointResourceId
      sharePointResourceWebUrl
      packetSharePointResourceId
      packetSharePointResourceName
      packetSharePointResourceWebUrl
      type {
        id
        name
        description
        deleted
      }
      subtype {
        id
        name
        description
        deleted
      }
      quantity
      units
      requestedReviewDate
      contractualReviewDate
      submittedBy {
        id
        displayName
        mail
        deleted
        userGroups {
          id
        }
      }
      casToCASRoutingGroups {
        routingGroup {
          id
          name
          description
          users(userFieldInput: {deleted: false}) {
            id
          }
        }
        accepted
        acceptedBy {
          id
          mail
        }
        acceptedDate
      }
      dispositionType {
        id
        name
        description
        deleted
      }
      dispositionDate
      dispositionBy {
        id
        displayName
        mail
        deleted
        userGroups {
          id
        }
      }
      comments {
        text
        user {
          mail
        }
        createdDate
      }
      projectId
      casToPayItemNoGeometries {
        payItem {
          globalId
          deleted
          label
        }
      }
      createdDate
      deleted
      deletedUser
      deletedDate
      externalLinks {
        label
        href
      }
      customFields {
        booleanValues {
          customField {
            ...ProjectFieldDesignChangesCustomField
          }
          customFieldId
          value
        }
        dateValues {
          customField {
            ...ProjectFieldDesignChangesCustomField
          }
          customFieldId
          value
        }
        entityValues {
          customField {
            ...ProjectFieldDesignChangesCustomField
          }
          customFieldId
          entities {
            recordId
            href(projectId: $projectId)
            entityId
            label
          }
        }
        listValues {
          singles {
            customField {
              ...ProjectFieldDesignChangesCustomField
            }
            customFieldId
            customListItem {
              id
              deleted
              value
            }
          }
          multiples {
            customField {
              ...ProjectFieldDesignChangesCustomField
            }
            customFieldId
            customListItems {
              id
              deleted
              value
            }
          }
          checkboxes {
            customField {
              ...ProjectFieldDesignChangesCustomField
            }
            customFieldId
            booleans {
              customListItemId
              customListItem {
                value
              }
              checked
            }
          }
        }
        numberValues {
          customField {
            ...ProjectFieldDesignChangesCustomField
          }
          customFieldId
          value
        }
        reportValues {
          customField {
            ...ProjectFieldDesignChangesCustomField
          }
          customFieldId
          reports {
            recordId
            reportId
            href(projectId: $projectId)
            label
          }
        }
        textValues {
          customField {
            ...ProjectFieldDesignChangesCustomField
          }
          customFieldId
          value
        }
      }
    }
  }
}
    ${ProjectFieldDesignChangesCustomFieldFragmentDoc}`;

/**
 * __useGetCaSubmittalsQuery__
 *
 * To run a query within a React component, call `useGetCaSubmittalsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCaSubmittalsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCaSubmittalsQuery({
 *   variables: {
 *      input: // value for 'input'
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useGetCaSubmittalsQuery(baseOptions: Apollo.QueryHookOptions<GetCaSubmittalsQuery, GetCaSubmittalsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCaSubmittalsQuery, GetCaSubmittalsQueryVariables>(GetCaSubmittalsDocument, options);
      }
export function useGetCaSubmittalsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCaSubmittalsQuery, GetCaSubmittalsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCaSubmittalsQuery, GetCaSubmittalsQueryVariables>(GetCaSubmittalsDocument, options);
        }
export type GetCaSubmittalsQueryHookResult = ReturnType<typeof useGetCaSubmittalsQuery>;
export type GetCaSubmittalsLazyQueryHookResult = ReturnType<typeof useGetCaSubmittalsLazyQuery>;
export type GetCaSubmittalsQueryResult = Apollo.QueryResult<GetCaSubmittalsQuery, GetCaSubmittalsQueryVariables>;
export const GroupReviewCasDocument = gql`
    mutation GroupReviewCAS($input: GroupReviewConstructionAdminSubmittalInput!) {
  groupReviewConstructionAdminSubmittal(
    groupReviewConstructionAdminSubmittalInput: $input
  ) {
    submittal {
      sharePointFolderName
      statusId
    }
  }
}
    `;
export type GroupReviewCasMutationFn = Apollo.MutationFunction<GroupReviewCasMutation, GroupReviewCasMutationVariables>;

/**
 * __useGroupReviewCasMutation__
 *
 * To run a mutation, you first call `useGroupReviewCasMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGroupReviewCasMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [groupReviewCasMutation, { data, loading, error }] = useGroupReviewCasMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGroupReviewCasMutation(baseOptions?: Apollo.MutationHookOptions<GroupReviewCasMutation, GroupReviewCasMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GroupReviewCasMutation, GroupReviewCasMutationVariables>(GroupReviewCasDocument, options);
      }
export type GroupReviewCasMutationHookResult = ReturnType<typeof useGroupReviewCasMutation>;
export type GroupReviewCasMutationResult = Apollo.MutationResult<GroupReviewCasMutation>;
export type GroupReviewCasMutationOptions = Apollo.BaseMutationOptions<GroupReviewCasMutation, GroupReviewCasMutationVariables>;
export const ReReviewCasDocument = gql`
    mutation REReviewCAS($input: REReviewConstructionAdminSubmittalInput!) {
  reReviewConstructionAdminSubmittal(
    reReviewConstructionAdminSubmittalInput: $input
  ) {
    submittal {
      sharePointFolderName
      statusId
    }
  }
}
    `;
export type ReReviewCasMutationFn = Apollo.MutationFunction<ReReviewCasMutation, ReReviewCasMutationVariables>;

/**
 * __useReReviewCasMutation__
 *
 * To run a mutation, you first call `useReReviewCasMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReReviewCasMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reReviewCasMutation, { data, loading, error }] = useReReviewCasMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useReReviewCasMutation(baseOptions?: Apollo.MutationHookOptions<ReReviewCasMutation, ReReviewCasMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ReReviewCasMutation, ReReviewCasMutationVariables>(ReReviewCasDocument, options);
      }
export type ReReviewCasMutationHookResult = ReturnType<typeof useReReviewCasMutation>;
export type ReReviewCasMutationResult = Apollo.MutationResult<ReReviewCasMutation>;
export type ReReviewCasMutationOptions = Apollo.BaseMutationOptions<ReReviewCasMutation, ReReviewCasMutationVariables>;
export const RequestCasRevisionsDocument = gql`
    mutation RequestCASRevisions($input: RequestConstructionAdminSubmittalRevisionsInput!) {
  requestConstructionAdminSubmittalRevisions(
    requestConstructionAdminSubmittalRevisionsInput: $input
  ) {
    submittal {
      sharePointFolderName
      statusId
    }
  }
}
    `;
export type RequestCasRevisionsMutationFn = Apollo.MutationFunction<RequestCasRevisionsMutation, RequestCasRevisionsMutationVariables>;

/**
 * __useRequestCasRevisionsMutation__
 *
 * To run a mutation, you first call `useRequestCasRevisionsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRequestCasRevisionsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [requestCasRevisionsMutation, { data, loading, error }] = useRequestCasRevisionsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRequestCasRevisionsMutation(baseOptions?: Apollo.MutationHookOptions<RequestCasRevisionsMutation, RequestCasRevisionsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RequestCasRevisionsMutation, RequestCasRevisionsMutationVariables>(RequestCasRevisionsDocument, options);
      }
export type RequestCasRevisionsMutationHookResult = ReturnType<typeof useRequestCasRevisionsMutation>;
export type RequestCasRevisionsMutationResult = Apollo.MutationResult<RequestCasRevisionsMutation>;
export type RequestCasRevisionsMutationOptions = Apollo.BaseMutationOptions<RequestCasRevisionsMutation, RequestCasRevisionsMutationVariables>;
export const ReviseCaSubmittalDocument = gql`
    mutation ReviseCASubmittal($input: ReviseConstructionAdminSubmittalInput!) {
  reviseConstructionAdminSubmittal(reviseConstructionAdminSubmittalInput: $input) {
    submittal {
      sharePointFolderName
      statusId
    }
  }
}
    `;
export type ReviseCaSubmittalMutationFn = Apollo.MutationFunction<ReviseCaSubmittalMutation, ReviseCaSubmittalMutationVariables>;

/**
 * __useReviseCaSubmittalMutation__
 *
 * To run a mutation, you first call `useReviseCaSubmittalMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReviseCaSubmittalMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reviseCaSubmittalMutation, { data, loading, error }] = useReviseCaSubmittalMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useReviseCaSubmittalMutation(baseOptions?: Apollo.MutationHookOptions<ReviseCaSubmittalMutation, ReviseCaSubmittalMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ReviseCaSubmittalMutation, ReviseCaSubmittalMutationVariables>(ReviseCaSubmittalDocument, options);
      }
export type ReviseCaSubmittalMutationHookResult = ReturnType<typeof useReviseCaSubmittalMutation>;
export type ReviseCaSubmittalMutationResult = Apollo.MutationResult<ReviseCaSubmittalMutation>;
export type ReviseCaSubmittalMutationOptions = Apollo.BaseMutationOptions<ReviseCaSubmittalMutation, ReviseCaSubmittalMutationVariables>;
export const RouteCasToGroupReviewDocument = gql`
    mutation RouteCASToGroupReview($input: RouteConstructionAdminSubmittalToGroupReviewInput!) {
  routeConstructionAdminSubmittalToGroupReview(
    routeConstructionAdminSubmittalToGroupReviewInput: $input
  ) {
    submittal {
      sharePointFolderName
      statusId
    }
  }
}
    `;
export type RouteCasToGroupReviewMutationFn = Apollo.MutationFunction<RouteCasToGroupReviewMutation, RouteCasToGroupReviewMutationVariables>;

/**
 * __useRouteCasToGroupReviewMutation__
 *
 * To run a mutation, you first call `useRouteCasToGroupReviewMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRouteCasToGroupReviewMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [routeCasToGroupReviewMutation, { data, loading, error }] = useRouteCasToGroupReviewMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRouteCasToGroupReviewMutation(baseOptions?: Apollo.MutationHookOptions<RouteCasToGroupReviewMutation, RouteCasToGroupReviewMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RouteCasToGroupReviewMutation, RouteCasToGroupReviewMutationVariables>(RouteCasToGroupReviewDocument, options);
      }
export type RouteCasToGroupReviewMutationHookResult = ReturnType<typeof useRouteCasToGroupReviewMutation>;
export type RouteCasToGroupReviewMutationResult = Apollo.MutationResult<RouteCasToGroupReviewMutation>;
export type RouteCasToGroupReviewMutationOptions = Apollo.BaseMutationOptions<RouteCasToGroupReviewMutation, RouteCasToGroupReviewMutationVariables>;
export const RouteCasToReReviewDocument = gql`
    mutation RouteCASToREReview($input: RouteConstructionAdminSubmittalToREReviewInput!) {
  routeConstructionAdminSubmittalToREReview(
    routeConstructionAdminSubmittalToREReviewInput: $input
  ) {
    submittal {
      sharePointFolderName
      statusId
    }
  }
}
    `;
export type RouteCasToReReviewMutationFn = Apollo.MutationFunction<RouteCasToReReviewMutation, RouteCasToReReviewMutationVariables>;

/**
 * __useRouteCasToReReviewMutation__
 *
 * To run a mutation, you first call `useRouteCasToReReviewMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRouteCasToReReviewMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [routeCasToReReviewMutation, { data, loading, error }] = useRouteCasToReReviewMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRouteCasToReReviewMutation(baseOptions?: Apollo.MutationHookOptions<RouteCasToReReviewMutation, RouteCasToReReviewMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RouteCasToReReviewMutation, RouteCasToReReviewMutationVariables>(RouteCasToReReviewDocument, options);
      }
export type RouteCasToReReviewMutationHookResult = ReturnType<typeof useRouteCasToReReviewMutation>;
export type RouteCasToReReviewMutationResult = Apollo.MutationResult<RouteCasToReReviewMutation>;
export type RouteCasToReReviewMutationOptions = Apollo.BaseMutationOptions<RouteCasToReReviewMutation, RouteCasToReReviewMutationVariables>;
export const GetCasSharePointResourcesDocument = gql`
    query GetCASSharePointResources($id: String!) {
  constructionAdminSubmittal(id: $id) {
    sharePointResource {
      sharePointResources {
        id
        name
        webUrl
      }
    }
    packetSharePointResourceId
  }
}
    `;

/**
 * __useGetCasSharePointResourcesQuery__
 *
 * To run a query within a React component, call `useGetCasSharePointResourcesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCasSharePointResourcesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCasSharePointResourcesQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetCasSharePointResourcesQuery(baseOptions: Apollo.QueryHookOptions<GetCasSharePointResourcesQuery, GetCasSharePointResourcesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCasSharePointResourcesQuery, GetCasSharePointResourcesQueryVariables>(GetCasSharePointResourcesDocument, options);
      }
export function useGetCasSharePointResourcesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCasSharePointResourcesQuery, GetCasSharePointResourcesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCasSharePointResourcesQuery, GetCasSharePointResourcesQueryVariables>(GetCasSharePointResourcesDocument, options);
        }
export type GetCasSharePointResourcesQueryHookResult = ReturnType<typeof useGetCasSharePointResourcesQuery>;
export type GetCasSharePointResourcesLazyQueryHookResult = ReturnType<typeof useGetCasSharePointResourcesLazyQuery>;
export type GetCasSharePointResourcesQueryResult = Apollo.QueryResult<GetCasSharePointResourcesQuery, GetCasSharePointResourcesQueryVariables>;
export const RevertCasDocument = gql`
    mutation RevertCAS($input: RevertConstructionAdminSubmittalInput!) {
  revertConstructionAdminSubmittal(revertConstructionAdminSubmittalInput: $input) {
    submittal {
      sharePointFolderName
      statusId
    }
  }
}
    `;
export type RevertCasMutationFn = Apollo.MutationFunction<RevertCasMutation, RevertCasMutationVariables>;

/**
 * __useRevertCasMutation__
 *
 * To run a mutation, you first call `useRevertCasMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRevertCasMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [revertCasMutation, { data, loading, error }] = useRevertCasMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRevertCasMutation(baseOptions?: Apollo.MutationHookOptions<RevertCasMutation, RevertCasMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RevertCasMutation, RevertCasMutationVariables>(RevertCasDocument, options);
      }
export type RevertCasMutationHookResult = ReturnType<typeof useRevertCasMutation>;
export type RevertCasMutationResult = Apollo.MutationResult<RevertCasMutation>;
export type RevertCasMutationOptions = Apollo.BaseMutationOptions<RevertCasMutation, RevertCasMutationVariables>;
export const SetCasToCasRoutingGroupDocument = gql`
    mutation SetCASToCASRoutingGroup($input: SetCASToCASRoutingGroupInput!) {
  setCASToCASRoutingGroup(setCASToCASRoutingGroupInput: $input) {
    accepted
    routingGroup {
      name
    }
  }
}
    `;
export type SetCasToCasRoutingGroupMutationFn = Apollo.MutationFunction<SetCasToCasRoutingGroupMutation, SetCasToCasRoutingGroupMutationVariables>;

/**
 * __useSetCasToCasRoutingGroupMutation__
 *
 * To run a mutation, you first call `useSetCasToCasRoutingGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetCasToCasRoutingGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setCasToCasRoutingGroupMutation, { data, loading, error }] = useSetCasToCasRoutingGroupMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSetCasToCasRoutingGroupMutation(baseOptions?: Apollo.MutationHookOptions<SetCasToCasRoutingGroupMutation, SetCasToCasRoutingGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetCasToCasRoutingGroupMutation, SetCasToCasRoutingGroupMutationVariables>(SetCasToCasRoutingGroupDocument, options);
      }
export type SetCasToCasRoutingGroupMutationHookResult = ReturnType<typeof useSetCasToCasRoutingGroupMutation>;
export type SetCasToCasRoutingGroupMutationResult = Apollo.MutationResult<SetCasToCasRoutingGroupMutation>;
export type SetCasToCasRoutingGroupMutationOptions = Apollo.BaseMutationOptions<SetCasToCasRoutingGroupMutation, SetCasToCasRoutingGroupMutationVariables>;
export const CreateCaSubmittalDocument = gql`
    mutation CreateCASubmittal($input: CreateConstructionAdminSubmittalInput!) {
  createConstructionAdminSubmittal(createConstructionAdminSubmittalInput: $input) {
    submittal {
      sharePointFolderName
    }
  }
}
    `;
export type CreateCaSubmittalMutationFn = Apollo.MutationFunction<CreateCaSubmittalMutation, CreateCaSubmittalMutationVariables>;

/**
 * __useCreateCaSubmittalMutation__
 *
 * To run a mutation, you first call `useCreateCaSubmittalMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCaSubmittalMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCaSubmittalMutation, { data, loading, error }] = useCreateCaSubmittalMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateCaSubmittalMutation(baseOptions?: Apollo.MutationHookOptions<CreateCaSubmittalMutation, CreateCaSubmittalMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateCaSubmittalMutation, CreateCaSubmittalMutationVariables>(CreateCaSubmittalDocument, options);
      }
export type CreateCaSubmittalMutationHookResult = ReturnType<typeof useCreateCaSubmittalMutation>;
export type CreateCaSubmittalMutationResult = Apollo.MutationResult<CreateCaSubmittalMutation>;
export type CreateCaSubmittalMutationOptions = Apollo.BaseMutationOptions<CreateCaSubmittalMutation, CreateCaSubmittalMutationVariables>;
export const EditCasSharePointReferenceDocument = gql`
    mutation EditCASSharePointReference($input: EditConstructionAdminSubmittalSharePointReferenceInput!) {
  editConstructionAdminSubmittalSharePointReference(
    editConstructionAdminSubmittalSharePointReferenceInput: $input
  ) {
    sharePointFolderName
  }
}
    `;
export type EditCasSharePointReferenceMutationFn = Apollo.MutationFunction<EditCasSharePointReferenceMutation, EditCasSharePointReferenceMutationVariables>;

/**
 * __useEditCasSharePointReferenceMutation__
 *
 * To run a mutation, you first call `useEditCasSharePointReferenceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditCasSharePointReferenceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editCasSharePointReferenceMutation, { data, loading, error }] = useEditCasSharePointReferenceMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEditCasSharePointReferenceMutation(baseOptions?: Apollo.MutationHookOptions<EditCasSharePointReferenceMutation, EditCasSharePointReferenceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditCasSharePointReferenceMutation, EditCasSharePointReferenceMutationVariables>(EditCasSharePointReferenceDocument, options);
      }
export type EditCasSharePointReferenceMutationHookResult = ReturnType<typeof useEditCasSharePointReferenceMutation>;
export type EditCasSharePointReferenceMutationResult = Apollo.MutationResult<EditCasSharePointReferenceMutation>;
export type EditCasSharePointReferenceMutationOptions = Apollo.BaseMutationOptions<EditCasSharePointReferenceMutation, EditCasSharePointReferenceMutationVariables>;
export const CreateCasCommentDocument = gql`
    mutation CreateCASComment($input: CreateCASCommentInput!) {
  createCASComment(createCASCommentInput: $input) {
    comment {
      id
    }
  }
}
    `;
export type CreateCasCommentMutationFn = Apollo.MutationFunction<CreateCasCommentMutation, CreateCasCommentMutationVariables>;

/**
 * __useCreateCasCommentMutation__
 *
 * To run a mutation, you first call `useCreateCasCommentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCasCommentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCasCommentMutation, { data, loading, error }] = useCreateCasCommentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateCasCommentMutation(baseOptions?: Apollo.MutationHookOptions<CreateCasCommentMutation, CreateCasCommentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateCasCommentMutation, CreateCasCommentMutationVariables>(CreateCasCommentDocument, options);
      }
export type CreateCasCommentMutationHookResult = ReturnType<typeof useCreateCasCommentMutation>;
export type CreateCasCommentMutationResult = Apollo.MutationResult<CreateCasCommentMutation>;
export type CreateCasCommentMutationOptions = Apollo.BaseMutationOptions<CreateCasCommentMutation, CreateCasCommentMutationVariables>;
export const SoftRemoveCaSubmittalDocument = gql`
    mutation SoftRemoveCASubmittal($id: String!) {
  softRemoveConstructionAdminSubmittal(id: $id) {
    submittal {
      sharePointFolderName
    }
  }
}
    `;
export type SoftRemoveCaSubmittalMutationFn = Apollo.MutationFunction<SoftRemoveCaSubmittalMutation, SoftRemoveCaSubmittalMutationVariables>;

/**
 * __useSoftRemoveCaSubmittalMutation__
 *
 * To run a mutation, you first call `useSoftRemoveCaSubmittalMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSoftRemoveCaSubmittalMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [softRemoveCaSubmittalMutation, { data, loading, error }] = useSoftRemoveCaSubmittalMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSoftRemoveCaSubmittalMutation(baseOptions?: Apollo.MutationHookOptions<SoftRemoveCaSubmittalMutation, SoftRemoveCaSubmittalMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SoftRemoveCaSubmittalMutation, SoftRemoveCaSubmittalMutationVariables>(SoftRemoveCaSubmittalDocument, options);
      }
export type SoftRemoveCaSubmittalMutationHookResult = ReturnType<typeof useSoftRemoveCaSubmittalMutation>;
export type SoftRemoveCaSubmittalMutationResult = Apollo.MutationResult<SoftRemoveCaSubmittalMutation>;
export type SoftRemoveCaSubmittalMutationOptions = Apollo.BaseMutationOptions<SoftRemoveCaSubmittalMutation, SoftRemoveCaSubmittalMutationVariables>;
export const RestoreCaSubmittalDocument = gql`
    mutation RestoreCASubmittal($id: String!) {
  restoreConstructionAdminSubmittal(id: $id) {
    submittal {
      sharePointFolderName
    }
  }
}
    `;
export type RestoreCaSubmittalMutationFn = Apollo.MutationFunction<RestoreCaSubmittalMutation, RestoreCaSubmittalMutationVariables>;

/**
 * __useRestoreCaSubmittalMutation__
 *
 * To run a mutation, you first call `useRestoreCaSubmittalMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRestoreCaSubmittalMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [restoreCaSubmittalMutation, { data, loading, error }] = useRestoreCaSubmittalMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRestoreCaSubmittalMutation(baseOptions?: Apollo.MutationHookOptions<RestoreCaSubmittalMutation, RestoreCaSubmittalMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RestoreCaSubmittalMutation, RestoreCaSubmittalMutationVariables>(RestoreCaSubmittalDocument, options);
      }
export type RestoreCaSubmittalMutationHookResult = ReturnType<typeof useRestoreCaSubmittalMutation>;
export type RestoreCaSubmittalMutationResult = Apollo.MutationResult<RestoreCaSubmittalMutation>;
export type RestoreCaSubmittalMutationOptions = Apollo.BaseMutationOptions<RestoreCaSubmittalMutation, RestoreCaSubmittalMutationVariables>;
export const CreateCasSubtypeDocument = gql`
    mutation CreateCASSubtype($createCASSubtypeInput: CreateCASSubtypeInput!) {
  createCASSubtype(createCASSubtypeInput: $createCASSubtypeInput) {
    subtype {
      name
    }
  }
}
    `;
export type CreateCasSubtypeMutationFn = Apollo.MutationFunction<CreateCasSubtypeMutation, CreateCasSubtypeMutationVariables>;

/**
 * __useCreateCasSubtypeMutation__
 *
 * To run a mutation, you first call `useCreateCasSubtypeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCasSubtypeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCasSubtypeMutation, { data, loading, error }] = useCreateCasSubtypeMutation({
 *   variables: {
 *      createCASSubtypeInput: // value for 'createCASSubtypeInput'
 *   },
 * });
 */
export function useCreateCasSubtypeMutation(baseOptions?: Apollo.MutationHookOptions<CreateCasSubtypeMutation, CreateCasSubtypeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateCasSubtypeMutation, CreateCasSubtypeMutationVariables>(CreateCasSubtypeDocument, options);
      }
export type CreateCasSubtypeMutationHookResult = ReturnType<typeof useCreateCasSubtypeMutation>;
export type CreateCasSubtypeMutationResult = Apollo.MutationResult<CreateCasSubtypeMutation>;
export type CreateCasSubtypeMutationOptions = Apollo.BaseMutationOptions<CreateCasSubtypeMutation, CreateCasSubtypeMutationVariables>;
export const EditCasSubtypeDocument = gql`
    mutation EditCASSubtype($editCASSubtypeInput: EditCASSubtypeInput!) {
  editCASSubtype(editCASSubtypeInput: $editCASSubtypeInput) {
    subtype {
      name
    }
  }
}
    `;
export type EditCasSubtypeMutationFn = Apollo.MutationFunction<EditCasSubtypeMutation, EditCasSubtypeMutationVariables>;

/**
 * __useEditCasSubtypeMutation__
 *
 * To run a mutation, you first call `useEditCasSubtypeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditCasSubtypeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editCasSubtypeMutation, { data, loading, error }] = useEditCasSubtypeMutation({
 *   variables: {
 *      editCASSubtypeInput: // value for 'editCASSubtypeInput'
 *   },
 * });
 */
export function useEditCasSubtypeMutation(baseOptions?: Apollo.MutationHookOptions<EditCasSubtypeMutation, EditCasSubtypeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditCasSubtypeMutation, EditCasSubtypeMutationVariables>(EditCasSubtypeDocument, options);
      }
export type EditCasSubtypeMutationHookResult = ReturnType<typeof useEditCasSubtypeMutation>;
export type EditCasSubtypeMutationResult = Apollo.MutationResult<EditCasSubtypeMutation>;
export type EditCasSubtypeMutationOptions = Apollo.BaseMutationOptions<EditCasSubtypeMutation, EditCasSubtypeMutationVariables>;
export const SoftRemoveCasSubtypeDocument = gql`
    mutation SoftRemoveCASSubtype($id: String!) {
  softRemoveCASSubtype(id: $id) {
    subtype {
      name
    }
  }
}
    `;
export type SoftRemoveCasSubtypeMutationFn = Apollo.MutationFunction<SoftRemoveCasSubtypeMutation, SoftRemoveCasSubtypeMutationVariables>;

/**
 * __useSoftRemoveCasSubtypeMutation__
 *
 * To run a mutation, you first call `useSoftRemoveCasSubtypeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSoftRemoveCasSubtypeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [softRemoveCasSubtypeMutation, { data, loading, error }] = useSoftRemoveCasSubtypeMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSoftRemoveCasSubtypeMutation(baseOptions?: Apollo.MutationHookOptions<SoftRemoveCasSubtypeMutation, SoftRemoveCasSubtypeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SoftRemoveCasSubtypeMutation, SoftRemoveCasSubtypeMutationVariables>(SoftRemoveCasSubtypeDocument, options);
      }
export type SoftRemoveCasSubtypeMutationHookResult = ReturnType<typeof useSoftRemoveCasSubtypeMutation>;
export type SoftRemoveCasSubtypeMutationResult = Apollo.MutationResult<SoftRemoveCasSubtypeMutation>;
export type SoftRemoveCasSubtypeMutationOptions = Apollo.BaseMutationOptions<SoftRemoveCasSubtypeMutation, SoftRemoveCasSubtypeMutationVariables>;
export const RestoreCasSubtypeDocument = gql`
    mutation RestoreCASSubtype($id: String!) {
  restoreCASSubtype(id: $id) {
    subtype {
      name
    }
  }
}
    `;
export type RestoreCasSubtypeMutationFn = Apollo.MutationFunction<RestoreCasSubtypeMutation, RestoreCasSubtypeMutationVariables>;

/**
 * __useRestoreCasSubtypeMutation__
 *
 * To run a mutation, you first call `useRestoreCasSubtypeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRestoreCasSubtypeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [restoreCasSubtypeMutation, { data, loading, error }] = useRestoreCasSubtypeMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRestoreCasSubtypeMutation(baseOptions?: Apollo.MutationHookOptions<RestoreCasSubtypeMutation, RestoreCasSubtypeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RestoreCasSubtypeMutation, RestoreCasSubtypeMutationVariables>(RestoreCasSubtypeDocument, options);
      }
export type RestoreCasSubtypeMutationHookResult = ReturnType<typeof useRestoreCasSubtypeMutation>;
export type RestoreCasSubtypeMutationResult = Apollo.MutationResult<RestoreCasSubtypeMutation>;
export type RestoreCasSubtypeMutationOptions = Apollo.BaseMutationOptions<RestoreCasSubtypeMutation, RestoreCasSubtypeMutationVariables>;
export const GetCasSubtypesDocument = gql`
    query GetCASSubtypes($casSubtypeListInput: CASSubtypeListInput!) {
  casSubtypes(casSubtypeListInput: $casSubtypeListInput) {
    records {
      id
      name
      description
      deleted
      deletedDate
      deletedUser
      submittals {
        id
        packageName
        packageNumber
        deleted
      }
    }
  }
}
    `;

/**
 * __useGetCasSubtypesQuery__
 *
 * To run a query within a React component, call `useGetCasSubtypesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCasSubtypesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCasSubtypesQuery({
 *   variables: {
 *      casSubtypeListInput: // value for 'casSubtypeListInput'
 *   },
 * });
 */
export function useGetCasSubtypesQuery(baseOptions: Apollo.QueryHookOptions<GetCasSubtypesQuery, GetCasSubtypesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCasSubtypesQuery, GetCasSubtypesQueryVariables>(GetCasSubtypesDocument, options);
      }
export function useGetCasSubtypesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCasSubtypesQuery, GetCasSubtypesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCasSubtypesQuery, GetCasSubtypesQueryVariables>(GetCasSubtypesDocument, options);
        }
export type GetCasSubtypesQueryHookResult = ReturnType<typeof useGetCasSubtypesQuery>;
export type GetCasSubtypesLazyQueryHookResult = ReturnType<typeof useGetCasSubtypesLazyQuery>;
export type GetCasSubtypesQueryResult = Apollo.QueryResult<GetCasSubtypesQuery, GetCasSubtypesQueryVariables>;
export const GetCasTypesDocument = gql`
    query GetCASTypes($casTypeListInput: CASTypeListInput!) {
  casTypes(casTypeListInput: $casTypeListInput) {
    records {
      id
      name
      description
      deleted
      deletedDate
      deletedUser
      submittals {
        id
        packageName
        packageNumber
        deleted
      }
    }
  }
}
    `;

/**
 * __useGetCasTypesQuery__
 *
 * To run a query within a React component, call `useGetCasTypesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCasTypesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCasTypesQuery({
 *   variables: {
 *      casTypeListInput: // value for 'casTypeListInput'
 *   },
 * });
 */
export function useGetCasTypesQuery(baseOptions: Apollo.QueryHookOptions<GetCasTypesQuery, GetCasTypesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCasTypesQuery, GetCasTypesQueryVariables>(GetCasTypesDocument, options);
      }
export function useGetCasTypesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCasTypesQuery, GetCasTypesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCasTypesQuery, GetCasTypesQueryVariables>(GetCasTypesDocument, options);
        }
export type GetCasTypesQueryHookResult = ReturnType<typeof useGetCasTypesQuery>;
export type GetCasTypesLazyQueryHookResult = ReturnType<typeof useGetCasTypesLazyQuery>;
export type GetCasTypesQueryResult = Apollo.QueryResult<GetCasTypesQuery, GetCasTypesQueryVariables>;
export const CreateCasTypeDocument = gql`
    mutation CreateCASType($createCASTypeInput: CreateCASTypeInput!) {
  createCASType(createCASTypeInput: $createCASTypeInput) {
    type {
      name
    }
  }
}
    `;
export type CreateCasTypeMutationFn = Apollo.MutationFunction<CreateCasTypeMutation, CreateCasTypeMutationVariables>;

/**
 * __useCreateCasTypeMutation__
 *
 * To run a mutation, you first call `useCreateCasTypeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCasTypeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCasTypeMutation, { data, loading, error }] = useCreateCasTypeMutation({
 *   variables: {
 *      createCASTypeInput: // value for 'createCASTypeInput'
 *   },
 * });
 */
export function useCreateCasTypeMutation(baseOptions?: Apollo.MutationHookOptions<CreateCasTypeMutation, CreateCasTypeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateCasTypeMutation, CreateCasTypeMutationVariables>(CreateCasTypeDocument, options);
      }
export type CreateCasTypeMutationHookResult = ReturnType<typeof useCreateCasTypeMutation>;
export type CreateCasTypeMutationResult = Apollo.MutationResult<CreateCasTypeMutation>;
export type CreateCasTypeMutationOptions = Apollo.BaseMutationOptions<CreateCasTypeMutation, CreateCasTypeMutationVariables>;
export const EditCasTypeDocument = gql`
    mutation EditCASType($editCASTypeInput: EditCASTypeInput!) {
  editCASType(editCASTypeInput: $editCASTypeInput) {
    type {
      name
    }
  }
}
    `;
export type EditCasTypeMutationFn = Apollo.MutationFunction<EditCasTypeMutation, EditCasTypeMutationVariables>;

/**
 * __useEditCasTypeMutation__
 *
 * To run a mutation, you first call `useEditCasTypeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditCasTypeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editCasTypeMutation, { data, loading, error }] = useEditCasTypeMutation({
 *   variables: {
 *      editCASTypeInput: // value for 'editCASTypeInput'
 *   },
 * });
 */
export function useEditCasTypeMutation(baseOptions?: Apollo.MutationHookOptions<EditCasTypeMutation, EditCasTypeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditCasTypeMutation, EditCasTypeMutationVariables>(EditCasTypeDocument, options);
      }
export type EditCasTypeMutationHookResult = ReturnType<typeof useEditCasTypeMutation>;
export type EditCasTypeMutationResult = Apollo.MutationResult<EditCasTypeMutation>;
export type EditCasTypeMutationOptions = Apollo.BaseMutationOptions<EditCasTypeMutation, EditCasTypeMutationVariables>;
export const SoftRemoveCasTypeDocument = gql`
    mutation SoftRemoveCASType($id: String!) {
  softRemoveCASType(id: $id) {
    type {
      name
    }
  }
}
    `;
export type SoftRemoveCasTypeMutationFn = Apollo.MutationFunction<SoftRemoveCasTypeMutation, SoftRemoveCasTypeMutationVariables>;

/**
 * __useSoftRemoveCasTypeMutation__
 *
 * To run a mutation, you first call `useSoftRemoveCasTypeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSoftRemoveCasTypeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [softRemoveCasTypeMutation, { data, loading, error }] = useSoftRemoveCasTypeMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSoftRemoveCasTypeMutation(baseOptions?: Apollo.MutationHookOptions<SoftRemoveCasTypeMutation, SoftRemoveCasTypeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SoftRemoveCasTypeMutation, SoftRemoveCasTypeMutationVariables>(SoftRemoveCasTypeDocument, options);
      }
export type SoftRemoveCasTypeMutationHookResult = ReturnType<typeof useSoftRemoveCasTypeMutation>;
export type SoftRemoveCasTypeMutationResult = Apollo.MutationResult<SoftRemoveCasTypeMutation>;
export type SoftRemoveCasTypeMutationOptions = Apollo.BaseMutationOptions<SoftRemoveCasTypeMutation, SoftRemoveCasTypeMutationVariables>;
export const RestoreCasTypeDocument = gql`
    mutation RestoreCASType($id: String!) {
  restoreCASType(id: $id) {
    type {
      name
    }
  }
}
    `;
export type RestoreCasTypeMutationFn = Apollo.MutationFunction<RestoreCasTypeMutation, RestoreCasTypeMutationVariables>;

/**
 * __useRestoreCasTypeMutation__
 *
 * To run a mutation, you first call `useRestoreCasTypeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRestoreCasTypeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [restoreCasTypeMutation, { data, loading, error }] = useRestoreCasTypeMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRestoreCasTypeMutation(baseOptions?: Apollo.MutationHookOptions<RestoreCasTypeMutation, RestoreCasTypeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RestoreCasTypeMutation, RestoreCasTypeMutationVariables>(RestoreCasTypeDocument, options);
      }
export type RestoreCasTypeMutationHookResult = ReturnType<typeof useRestoreCasTypeMutation>;
export type RestoreCasTypeMutationResult = Apollo.MutationResult<RestoreCasTypeMutation>;
export type RestoreCasTypeMutationOptions = Apollo.BaseMutationOptions<RestoreCasTypeMutation, RestoreCasTypeMutationVariables>;
export const CreateDsActionDocument = gql`
    mutation CreateDSAction($input: CreateDSActionInput!) {
  createDSAction(createDSActionInput: $input) {
    action {
      name
    }
  }
}
    `;
export type CreateDsActionMutationFn = Apollo.MutationFunction<CreateDsActionMutation, CreateDsActionMutationVariables>;

/**
 * __useCreateDsActionMutation__
 *
 * To run a mutation, you first call `useCreateDsActionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateDsActionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createDsActionMutation, { data, loading, error }] = useCreateDsActionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateDsActionMutation(baseOptions?: Apollo.MutationHookOptions<CreateDsActionMutation, CreateDsActionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateDsActionMutation, CreateDsActionMutationVariables>(CreateDsActionDocument, options);
      }
export type CreateDsActionMutationHookResult = ReturnType<typeof useCreateDsActionMutation>;
export type CreateDsActionMutationResult = Apollo.MutationResult<CreateDsActionMutation>;
export type CreateDsActionMutationOptions = Apollo.BaseMutationOptions<CreateDsActionMutation, CreateDsActionMutationVariables>;
export const EditDsActionDocument = gql`
    mutation EditDSAction($input: EditDSActionInput!) {
  editDSAction(editDSActionInput: $input) {
    action {
      name
    }
  }
}
    `;
export type EditDsActionMutationFn = Apollo.MutationFunction<EditDsActionMutation, EditDsActionMutationVariables>;

/**
 * __useEditDsActionMutation__
 *
 * To run a mutation, you first call `useEditDsActionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditDsActionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editDsActionMutation, { data, loading, error }] = useEditDsActionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEditDsActionMutation(baseOptions?: Apollo.MutationHookOptions<EditDsActionMutation, EditDsActionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditDsActionMutation, EditDsActionMutationVariables>(EditDsActionDocument, options);
      }
export type EditDsActionMutationHookResult = ReturnType<typeof useEditDsActionMutation>;
export type EditDsActionMutationResult = Apollo.MutationResult<EditDsActionMutation>;
export type EditDsActionMutationOptions = Apollo.BaseMutationOptions<EditDsActionMutation, EditDsActionMutationVariables>;
export const SoftRemoveDsActionDocument = gql`
    mutation SoftRemoveDSAction($id: String!) {
  softRemoveDSAction(id: $id) {
    action {
      name
    }
  }
}
    `;
export type SoftRemoveDsActionMutationFn = Apollo.MutationFunction<SoftRemoveDsActionMutation, SoftRemoveDsActionMutationVariables>;

/**
 * __useSoftRemoveDsActionMutation__
 *
 * To run a mutation, you first call `useSoftRemoveDsActionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSoftRemoveDsActionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [softRemoveDsActionMutation, { data, loading, error }] = useSoftRemoveDsActionMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSoftRemoveDsActionMutation(baseOptions?: Apollo.MutationHookOptions<SoftRemoveDsActionMutation, SoftRemoveDsActionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SoftRemoveDsActionMutation, SoftRemoveDsActionMutationVariables>(SoftRemoveDsActionDocument, options);
      }
export type SoftRemoveDsActionMutationHookResult = ReturnType<typeof useSoftRemoveDsActionMutation>;
export type SoftRemoveDsActionMutationResult = Apollo.MutationResult<SoftRemoveDsActionMutation>;
export type SoftRemoveDsActionMutationOptions = Apollo.BaseMutationOptions<SoftRemoveDsActionMutation, SoftRemoveDsActionMutationVariables>;
export const RestoreDsActionDocument = gql`
    mutation RestoreDSAction($id: String!) {
  restoreDSAction(id: $id) {
    action {
      name
    }
  }
}
    `;
export type RestoreDsActionMutationFn = Apollo.MutationFunction<RestoreDsActionMutation, RestoreDsActionMutationVariables>;

/**
 * __useRestoreDsActionMutation__
 *
 * To run a mutation, you first call `useRestoreDsActionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRestoreDsActionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [restoreDsActionMutation, { data, loading, error }] = useRestoreDsActionMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRestoreDsActionMutation(baseOptions?: Apollo.MutationHookOptions<RestoreDsActionMutation, RestoreDsActionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RestoreDsActionMutation, RestoreDsActionMutationVariables>(RestoreDsActionDocument, options);
      }
export type RestoreDsActionMutationHookResult = ReturnType<typeof useRestoreDsActionMutation>;
export type RestoreDsActionMutationResult = Apollo.MutationResult<RestoreDsActionMutation>;
export type RestoreDsActionMutationOptions = Apollo.BaseMutationOptions<RestoreDsActionMutation, RestoreDsActionMutationVariables>;
export const GetDsActionsDocument = gql`
    query GetDSActions($dsActionListInput: DSActionListInput!) {
  dsActions(dsActionListInput: $dsActionListInput) {
    records {
      id
      name
      description
      createdDate
      lastEditedDate
      deleted
      deletedUser
      deletedDate
      submittals {
        id
        packageNumber
        packageName
        deleted
      }
    }
  }
}
    `;

/**
 * __useGetDsActionsQuery__
 *
 * To run a query within a React component, call `useGetDsActionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDsActionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDsActionsQuery({
 *   variables: {
 *      dsActionListInput: // value for 'dsActionListInput'
 *   },
 * });
 */
export function useGetDsActionsQuery(baseOptions: Apollo.QueryHookOptions<GetDsActionsQuery, GetDsActionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDsActionsQuery, GetDsActionsQueryVariables>(GetDsActionsDocument, options);
      }
export function useGetDsActionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDsActionsQuery, GetDsActionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDsActionsQuery, GetDsActionsQueryVariables>(GetDsActionsDocument, options);
        }
export type GetDsActionsQueryHookResult = ReturnType<typeof useGetDsActionsQuery>;
export type GetDsActionsLazyQueryHookResult = ReturnType<typeof useGetDsActionsLazyQuery>;
export type GetDsActionsQueryResult = Apollo.QueryResult<GetDsActionsQuery, GetDsActionsQueryVariables>;
export const CreateDsQuickLinkDocument = gql`
    mutation CreateDSQuickLink($input: CreateDSQuickLinkInput!) {
  createDSQuickLink(createDSQuickLinkInput: $input) {
    dsQuickLink {
      label
    }
  }
}
    `;
export type CreateDsQuickLinkMutationFn = Apollo.MutationFunction<CreateDsQuickLinkMutation, CreateDsQuickLinkMutationVariables>;

/**
 * __useCreateDsQuickLinkMutation__
 *
 * To run a mutation, you first call `useCreateDsQuickLinkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateDsQuickLinkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createDsQuickLinkMutation, { data, loading, error }] = useCreateDsQuickLinkMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateDsQuickLinkMutation(baseOptions?: Apollo.MutationHookOptions<CreateDsQuickLinkMutation, CreateDsQuickLinkMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateDsQuickLinkMutation, CreateDsQuickLinkMutationVariables>(CreateDsQuickLinkDocument, options);
      }
export type CreateDsQuickLinkMutationHookResult = ReturnType<typeof useCreateDsQuickLinkMutation>;
export type CreateDsQuickLinkMutationResult = Apollo.MutationResult<CreateDsQuickLinkMutation>;
export type CreateDsQuickLinkMutationOptions = Apollo.BaseMutationOptions<CreateDsQuickLinkMutation, CreateDsQuickLinkMutationVariables>;
export const EditDsQuickLinkDocument = gql`
    mutation EditDSQuickLink($input: EditDSQuickLinkInput!) {
  editDSQuickLink(editDSQuickLinkInput: $input) {
    dsQuickLink {
      label
    }
  }
}
    `;
export type EditDsQuickLinkMutationFn = Apollo.MutationFunction<EditDsQuickLinkMutation, EditDsQuickLinkMutationVariables>;

/**
 * __useEditDsQuickLinkMutation__
 *
 * To run a mutation, you first call `useEditDsQuickLinkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditDsQuickLinkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editDsQuickLinkMutation, { data, loading, error }] = useEditDsQuickLinkMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEditDsQuickLinkMutation(baseOptions?: Apollo.MutationHookOptions<EditDsQuickLinkMutation, EditDsQuickLinkMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditDsQuickLinkMutation, EditDsQuickLinkMutationVariables>(EditDsQuickLinkDocument, options);
      }
export type EditDsQuickLinkMutationHookResult = ReturnType<typeof useEditDsQuickLinkMutation>;
export type EditDsQuickLinkMutationResult = Apollo.MutationResult<EditDsQuickLinkMutation>;
export type EditDsQuickLinkMutationOptions = Apollo.BaseMutationOptions<EditDsQuickLinkMutation, EditDsQuickLinkMutationVariables>;
export const GetDsQuickLinksDocument = gql`
    query GetDSQuickLinks($input: DSQuickLinkListInput!) {
  dsQuickLinks(dsQuickLinkListInput: $input) {
    records {
      id
      label
      href
      description
      deleted
      deletedDate
      deletedUser
    }
  }
}
    `;

/**
 * __useGetDsQuickLinksQuery__
 *
 * To run a query within a React component, call `useGetDsQuickLinksQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDsQuickLinksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDsQuickLinksQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetDsQuickLinksQuery(baseOptions: Apollo.QueryHookOptions<GetDsQuickLinksQuery, GetDsQuickLinksQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDsQuickLinksQuery, GetDsQuickLinksQueryVariables>(GetDsQuickLinksDocument, options);
      }
export function useGetDsQuickLinksLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDsQuickLinksQuery, GetDsQuickLinksQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDsQuickLinksQuery, GetDsQuickLinksQueryVariables>(GetDsQuickLinksDocument, options);
        }
export type GetDsQuickLinksQueryHookResult = ReturnType<typeof useGetDsQuickLinksQuery>;
export type GetDsQuickLinksLazyQueryHookResult = ReturnType<typeof useGetDsQuickLinksLazyQuery>;
export type GetDsQuickLinksQueryResult = Apollo.QueryResult<GetDsQuickLinksQuery, GetDsQuickLinksQueryVariables>;
export const RestoreDsQuickLinkDocument = gql`
    mutation RestoreDSQuickLink($id: String!) {
  restoreDSQuickLink(id: $id) {
    dsQuickLink {
      label
    }
  }
}
    `;
export type RestoreDsQuickLinkMutationFn = Apollo.MutationFunction<RestoreDsQuickLinkMutation, RestoreDsQuickLinkMutationVariables>;

/**
 * __useRestoreDsQuickLinkMutation__
 *
 * To run a mutation, you first call `useRestoreDsQuickLinkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRestoreDsQuickLinkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [restoreDsQuickLinkMutation, { data, loading, error }] = useRestoreDsQuickLinkMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRestoreDsQuickLinkMutation(baseOptions?: Apollo.MutationHookOptions<RestoreDsQuickLinkMutation, RestoreDsQuickLinkMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RestoreDsQuickLinkMutation, RestoreDsQuickLinkMutationVariables>(RestoreDsQuickLinkDocument, options);
      }
export type RestoreDsQuickLinkMutationHookResult = ReturnType<typeof useRestoreDsQuickLinkMutation>;
export type RestoreDsQuickLinkMutationResult = Apollo.MutationResult<RestoreDsQuickLinkMutation>;
export type RestoreDsQuickLinkMutationOptions = Apollo.BaseMutationOptions<RestoreDsQuickLinkMutation, RestoreDsQuickLinkMutationVariables>;
export const SoftRemoveDsQuickLinkDocument = gql`
    mutation SoftRemoveDSQuickLink($id: String!) {
  softRemoveDSQuickLink(id: $id) {
    dsQuickLink {
      label
    }
  }
}
    `;
export type SoftRemoveDsQuickLinkMutationFn = Apollo.MutationFunction<SoftRemoveDsQuickLinkMutation, SoftRemoveDsQuickLinkMutationVariables>;

/**
 * __useSoftRemoveDsQuickLinkMutation__
 *
 * To run a mutation, you first call `useSoftRemoveDsQuickLinkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSoftRemoveDsQuickLinkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [softRemoveDsQuickLinkMutation, { data, loading, error }] = useSoftRemoveDsQuickLinkMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSoftRemoveDsQuickLinkMutation(baseOptions?: Apollo.MutationHookOptions<SoftRemoveDsQuickLinkMutation, SoftRemoveDsQuickLinkMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SoftRemoveDsQuickLinkMutation, SoftRemoveDsQuickLinkMutationVariables>(SoftRemoveDsQuickLinkDocument, options);
      }
export type SoftRemoveDsQuickLinkMutationHookResult = ReturnType<typeof useSoftRemoveDsQuickLinkMutation>;
export type SoftRemoveDsQuickLinkMutationResult = Apollo.MutationResult<SoftRemoveDsQuickLinkMutation>;
export type SoftRemoveDsQuickLinkMutationOptions = Apollo.BaseMutationOptions<SoftRemoveDsQuickLinkMutation, SoftRemoveDsQuickLinkMutationVariables>;
export const GiveDesignSubmittalDispositionDocument = gql`
    mutation GiveDesignSubmittalDisposition($giveDesignSubmittalDispositionInput: GiveDesignSubmittalDispositionInput!) {
  giveDesignSubmittalDisposition(
    giveDesignSubmittalDispositionInput: $giveDesignSubmittalDispositionInput
  ) {
    designSubmittal {
      sharePointFolderName
    }
  }
}
    `;
export type GiveDesignSubmittalDispositionMutationFn = Apollo.MutationFunction<GiveDesignSubmittalDispositionMutation, GiveDesignSubmittalDispositionMutationVariables>;

/**
 * __useGiveDesignSubmittalDispositionMutation__
 *
 * To run a mutation, you first call `useGiveDesignSubmittalDispositionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGiveDesignSubmittalDispositionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [giveDesignSubmittalDispositionMutation, { data, loading, error }] = useGiveDesignSubmittalDispositionMutation({
 *   variables: {
 *      giveDesignSubmittalDispositionInput: // value for 'giveDesignSubmittalDispositionInput'
 *   },
 * });
 */
export function useGiveDesignSubmittalDispositionMutation(baseOptions?: Apollo.MutationHookOptions<GiveDesignSubmittalDispositionMutation, GiveDesignSubmittalDispositionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GiveDesignSubmittalDispositionMutation, GiveDesignSubmittalDispositionMutationVariables>(GiveDesignSubmittalDispositionDocument, options);
      }
export type GiveDesignSubmittalDispositionMutationHookResult = ReturnType<typeof useGiveDesignSubmittalDispositionMutation>;
export type GiveDesignSubmittalDispositionMutationResult = Apollo.MutationResult<GiveDesignSubmittalDispositionMutation>;
export type GiveDesignSubmittalDispositionMutationOptions = Apollo.BaseMutationOptions<GiveDesignSubmittalDispositionMutation, GiveDesignSubmittalDispositionMutationVariables>;
export const RouteDesignSubmittalDocument = gql`
    mutation RouteDesignSubmittal($routeDesignSubmittalInput: RouteDesignSubmittalInput!) {
  routeDesignSubmittal(routeDesignSubmittalInput: $routeDesignSubmittalInput) {
    designSubmittal {
      sharePointFolderName
    }
  }
}
    `;
export type RouteDesignSubmittalMutationFn = Apollo.MutationFunction<RouteDesignSubmittalMutation, RouteDesignSubmittalMutationVariables>;

/**
 * __useRouteDesignSubmittalMutation__
 *
 * To run a mutation, you first call `useRouteDesignSubmittalMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRouteDesignSubmittalMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [routeDesignSubmittalMutation, { data, loading, error }] = useRouteDesignSubmittalMutation({
 *   variables: {
 *      routeDesignSubmittalInput: // value for 'routeDesignSubmittalInput'
 *   },
 * });
 */
export function useRouteDesignSubmittalMutation(baseOptions?: Apollo.MutationHookOptions<RouteDesignSubmittalMutation, RouteDesignSubmittalMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RouteDesignSubmittalMutation, RouteDesignSubmittalMutationVariables>(RouteDesignSubmittalDocument, options);
      }
export type RouteDesignSubmittalMutationHookResult = ReturnType<typeof useRouteDesignSubmittalMutation>;
export type RouteDesignSubmittalMutationResult = Apollo.MutationResult<RouteDesignSubmittalMutation>;
export type RouteDesignSubmittalMutationOptions = Apollo.BaseMutationOptions<RouteDesignSubmittalMutation, RouteDesignSubmittalMutationVariables>;
export const RevertDesignSubmittalDocument = gql`
    mutation RevertDesignSubmittal($revertDesignSubmittalInput: RevertDesignSubmittalInput!) {
  revertDesignSubmittal(revertDesignSubmittalInput: $revertDesignSubmittalInput) {
    designSubmittal {
      sharePointFolderName
    }
  }
}
    `;
export type RevertDesignSubmittalMutationFn = Apollo.MutationFunction<RevertDesignSubmittalMutation, RevertDesignSubmittalMutationVariables>;

/**
 * __useRevertDesignSubmittalMutation__
 *
 * To run a mutation, you first call `useRevertDesignSubmittalMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRevertDesignSubmittalMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [revertDesignSubmittalMutation, { data, loading, error }] = useRevertDesignSubmittalMutation({
 *   variables: {
 *      revertDesignSubmittalInput: // value for 'revertDesignSubmittalInput'
 *   },
 * });
 */
export function useRevertDesignSubmittalMutation(baseOptions?: Apollo.MutationHookOptions<RevertDesignSubmittalMutation, RevertDesignSubmittalMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RevertDesignSubmittalMutation, RevertDesignSubmittalMutationVariables>(RevertDesignSubmittalDocument, options);
      }
export type RevertDesignSubmittalMutationHookResult = ReturnType<typeof useRevertDesignSubmittalMutation>;
export type RevertDesignSubmittalMutationResult = Apollo.MutationResult<RevertDesignSubmittalMutation>;
export type RevertDesignSubmittalMutationOptions = Apollo.BaseMutationOptions<RevertDesignSubmittalMutation, RevertDesignSubmittalMutationVariables>;
export const SetDsToDsDisciplineDocument = gql`
    mutation SetDSToDSDiscipline($input: SetDSToDSDisciplineInput!) {
  setDSToDSDiscipline(setDSToDSDisciplineInput: $input) {
    discipline {
      name
    }
  }
}
    `;
export type SetDsToDsDisciplineMutationFn = Apollo.MutationFunction<SetDsToDsDisciplineMutation, SetDsToDsDisciplineMutationVariables>;

/**
 * __useSetDsToDsDisciplineMutation__
 *
 * To run a mutation, you first call `useSetDsToDsDisciplineMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetDsToDsDisciplineMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setDsToDsDisciplineMutation, { data, loading, error }] = useSetDsToDsDisciplineMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSetDsToDsDisciplineMutation(baseOptions?: Apollo.MutationHookOptions<SetDsToDsDisciplineMutation, SetDsToDsDisciplineMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetDsToDsDisciplineMutation, SetDsToDsDisciplineMutationVariables>(SetDsToDsDisciplineDocument, options);
      }
export type SetDsToDsDisciplineMutationHookResult = ReturnType<typeof useSetDsToDsDisciplineMutation>;
export type SetDsToDsDisciplineMutationResult = Apollo.MutationResult<SetDsToDsDisciplineMutation>;
export type SetDsToDsDisciplineMutationOptions = Apollo.BaseMutationOptions<SetDsToDsDisciplineMutation, SetDsToDsDisciplineMutationVariables>;
export const CreateDesignSubmittalDocument = gql`
    mutation CreateDesignSubmittal($input: CreateDesignSubmittalInput!) {
  createDesignSubmittal(createDesignSubmittalInput: $input) {
    designSubmittal {
      sharePointFolderName
    }
  }
}
    `;
export type CreateDesignSubmittalMutationFn = Apollo.MutationFunction<CreateDesignSubmittalMutation, CreateDesignSubmittalMutationVariables>;

/**
 * __useCreateDesignSubmittalMutation__
 *
 * To run a mutation, you first call `useCreateDesignSubmittalMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateDesignSubmittalMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createDesignSubmittalMutation, { data, loading, error }] = useCreateDesignSubmittalMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateDesignSubmittalMutation(baseOptions?: Apollo.MutationHookOptions<CreateDesignSubmittalMutation, CreateDesignSubmittalMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateDesignSubmittalMutation, CreateDesignSubmittalMutationVariables>(CreateDesignSubmittalDocument, options);
      }
export type CreateDesignSubmittalMutationHookResult = ReturnType<typeof useCreateDesignSubmittalMutation>;
export type CreateDesignSubmittalMutationResult = Apollo.MutationResult<CreateDesignSubmittalMutation>;
export type CreateDesignSubmittalMutationOptions = Apollo.BaseMutationOptions<CreateDesignSubmittalMutation, CreateDesignSubmittalMutationVariables>;
export const LockUnlockDesignSubmittalDocument = gql`
    mutation LockUnlockDesignSubmittal($setSharePointResourcePermissionsInput: SetSharePointResourcePermissionsInput!) {
  setSharePointResourcePermissions(
    setSharePointResourcePermissionsInput: $setSharePointResourcePermissionsInput
  ) {
    user {
      mail
      displayName
    }
    designSubmittal {
      status
    }
  }
}
    `;
export type LockUnlockDesignSubmittalMutationFn = Apollo.MutationFunction<LockUnlockDesignSubmittalMutation, LockUnlockDesignSubmittalMutationVariables>;

/**
 * __useLockUnlockDesignSubmittalMutation__
 *
 * To run a mutation, you first call `useLockUnlockDesignSubmittalMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLockUnlockDesignSubmittalMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [lockUnlockDesignSubmittalMutation, { data, loading, error }] = useLockUnlockDesignSubmittalMutation({
 *   variables: {
 *      setSharePointResourcePermissionsInput: // value for 'setSharePointResourcePermissionsInput'
 *   },
 * });
 */
export function useLockUnlockDesignSubmittalMutation(baseOptions?: Apollo.MutationHookOptions<LockUnlockDesignSubmittalMutation, LockUnlockDesignSubmittalMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LockUnlockDesignSubmittalMutation, LockUnlockDesignSubmittalMutationVariables>(LockUnlockDesignSubmittalDocument, options);
      }
export type LockUnlockDesignSubmittalMutationHookResult = ReturnType<typeof useLockUnlockDesignSubmittalMutation>;
export type LockUnlockDesignSubmittalMutationResult = Apollo.MutationResult<LockUnlockDesignSubmittalMutation>;
export type LockUnlockDesignSubmittalMutationOptions = Apollo.BaseMutationOptions<LockUnlockDesignSubmittalMutation, LockUnlockDesignSubmittalMutationVariables>;
export const EditDesignSubmittalSharePointReferenceDocument = gql`
    mutation EditDesignSubmittalSharePointReference($input: EditDesignSubmittalSharePointReferenceInput!) {
  editDesignSubmittalSharePointReference(
    editDesignSubmittalSharePointReferenceInput: $input
  ) {
    packageName
    packageNumber
    sharePointFolderName
    sharePointResourceId
    sharePointResourceWebUrl
  }
}
    `;
export type EditDesignSubmittalSharePointReferenceMutationFn = Apollo.MutationFunction<EditDesignSubmittalSharePointReferenceMutation, EditDesignSubmittalSharePointReferenceMutationVariables>;

/**
 * __useEditDesignSubmittalSharePointReferenceMutation__
 *
 * To run a mutation, you first call `useEditDesignSubmittalSharePointReferenceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditDesignSubmittalSharePointReferenceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editDesignSubmittalSharePointReferenceMutation, { data, loading, error }] = useEditDesignSubmittalSharePointReferenceMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEditDesignSubmittalSharePointReferenceMutation(baseOptions?: Apollo.MutationHookOptions<EditDesignSubmittalSharePointReferenceMutation, EditDesignSubmittalSharePointReferenceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditDesignSubmittalSharePointReferenceMutation, EditDesignSubmittalSharePointReferenceMutationVariables>(EditDesignSubmittalSharePointReferenceDocument, options);
      }
export type EditDesignSubmittalSharePointReferenceMutationHookResult = ReturnType<typeof useEditDesignSubmittalSharePointReferenceMutation>;
export type EditDesignSubmittalSharePointReferenceMutationResult = Apollo.MutationResult<EditDesignSubmittalSharePointReferenceMutation>;
export type EditDesignSubmittalSharePointReferenceMutationOptions = Apollo.BaseMutationOptions<EditDesignSubmittalSharePointReferenceMutation, EditDesignSubmittalSharePointReferenceMutationVariables>;
export const CreateDesignSubmittalCommentDocument = gql`
    mutation CreateDesignSubmittalComment($input: CreateDSCommentInput!) {
  createDSComment(createDSCommentInput: $input) {
    comment {
      id
    }
  }
}
    `;
export type CreateDesignSubmittalCommentMutationFn = Apollo.MutationFunction<CreateDesignSubmittalCommentMutation, CreateDesignSubmittalCommentMutationVariables>;

/**
 * __useCreateDesignSubmittalCommentMutation__
 *
 * To run a mutation, you first call `useCreateDesignSubmittalCommentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateDesignSubmittalCommentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createDesignSubmittalCommentMutation, { data, loading, error }] = useCreateDesignSubmittalCommentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateDesignSubmittalCommentMutation(baseOptions?: Apollo.MutationHookOptions<CreateDesignSubmittalCommentMutation, CreateDesignSubmittalCommentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateDesignSubmittalCommentMutation, CreateDesignSubmittalCommentMutationVariables>(CreateDesignSubmittalCommentDocument, options);
      }
export type CreateDesignSubmittalCommentMutationHookResult = ReturnType<typeof useCreateDesignSubmittalCommentMutation>;
export type CreateDesignSubmittalCommentMutationResult = Apollo.MutationResult<CreateDesignSubmittalCommentMutation>;
export type CreateDesignSubmittalCommentMutationOptions = Apollo.BaseMutationOptions<CreateDesignSubmittalCommentMutation, CreateDesignSubmittalCommentMutationVariables>;
export const SoftRemoveDesignSubmittalDocument = gql`
    mutation SoftRemoveDesignSubmittal($id: String!) {
  softRemoveDesignSubmittal(id: $id) {
    designSubmittal {
      sharePointFolderName
    }
  }
}
    `;
export type SoftRemoveDesignSubmittalMutationFn = Apollo.MutationFunction<SoftRemoveDesignSubmittalMutation, SoftRemoveDesignSubmittalMutationVariables>;

/**
 * __useSoftRemoveDesignSubmittalMutation__
 *
 * To run a mutation, you first call `useSoftRemoveDesignSubmittalMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSoftRemoveDesignSubmittalMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [softRemoveDesignSubmittalMutation, { data, loading, error }] = useSoftRemoveDesignSubmittalMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSoftRemoveDesignSubmittalMutation(baseOptions?: Apollo.MutationHookOptions<SoftRemoveDesignSubmittalMutation, SoftRemoveDesignSubmittalMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SoftRemoveDesignSubmittalMutation, SoftRemoveDesignSubmittalMutationVariables>(SoftRemoveDesignSubmittalDocument, options);
      }
export type SoftRemoveDesignSubmittalMutationHookResult = ReturnType<typeof useSoftRemoveDesignSubmittalMutation>;
export type SoftRemoveDesignSubmittalMutationResult = Apollo.MutationResult<SoftRemoveDesignSubmittalMutation>;
export type SoftRemoveDesignSubmittalMutationOptions = Apollo.BaseMutationOptions<SoftRemoveDesignSubmittalMutation, SoftRemoveDesignSubmittalMutationVariables>;
export const RestoreDesignSubmittalDocument = gql`
    mutation RestoreDesignSubmittal($id: String!) {
  restoreDesignSubmittal(id: $id) {
    designSubmittal {
      sharePointFolderName
    }
  }
}
    `;
export type RestoreDesignSubmittalMutationFn = Apollo.MutationFunction<RestoreDesignSubmittalMutation, RestoreDesignSubmittalMutationVariables>;

/**
 * __useRestoreDesignSubmittalMutation__
 *
 * To run a mutation, you first call `useRestoreDesignSubmittalMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRestoreDesignSubmittalMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [restoreDesignSubmittalMutation, { data, loading, error }] = useRestoreDesignSubmittalMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRestoreDesignSubmittalMutation(baseOptions?: Apollo.MutationHookOptions<RestoreDesignSubmittalMutation, RestoreDesignSubmittalMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RestoreDesignSubmittalMutation, RestoreDesignSubmittalMutationVariables>(RestoreDesignSubmittalDocument, options);
      }
export type RestoreDesignSubmittalMutationHookResult = ReturnType<typeof useRestoreDesignSubmittalMutation>;
export type RestoreDesignSubmittalMutationResult = Apollo.MutationResult<RestoreDesignSubmittalMutation>;
export type RestoreDesignSubmittalMutationOptions = Apollo.BaseMutationOptions<RestoreDesignSubmittalMutation, RestoreDesignSubmittalMutationVariables>;
export const EditDesignSubmittalDocument = gql`
    mutation EditDesignSubmittal($input: EditDesignSubmittalInput!) {
  editDesignSubmittal(editDesignSubmittalInput: $input) {
    designSubmittal {
      sharePointFolderName
    }
  }
}
    `;
export type EditDesignSubmittalMutationFn = Apollo.MutationFunction<EditDesignSubmittalMutation, EditDesignSubmittalMutationVariables>;

/**
 * __useEditDesignSubmittalMutation__
 *
 * To run a mutation, you first call `useEditDesignSubmittalMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditDesignSubmittalMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editDesignSubmittalMutation, { data, loading, error }] = useEditDesignSubmittalMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEditDesignSubmittalMutation(baseOptions?: Apollo.MutationHookOptions<EditDesignSubmittalMutation, EditDesignSubmittalMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditDesignSubmittalMutation, EditDesignSubmittalMutationVariables>(EditDesignSubmittalDocument, options);
      }
export type EditDesignSubmittalMutationHookResult = ReturnType<typeof useEditDesignSubmittalMutation>;
export type EditDesignSubmittalMutationResult = Apollo.MutationResult<EditDesignSubmittalMutation>;
export type EditDesignSubmittalMutationOptions = Apollo.BaseMutationOptions<EditDesignSubmittalMutation, EditDesignSubmittalMutationVariables>;
export const GetDesignSubmittalsDocument = gql`
    query GetDesignSubmittals($input: DesignSubmittalListInput!, $projectId: String!) {
  designSubmittals(designSubmittalListInput: $input) {
    records {
      contractDueDate
      sharePointFolderName
      sharePointResourceId
      sharePointResourceWebUrl
      createdDate
      deleted
      deletedDate
      deletedUser
      disposition
      dispositionBy {
        id
        displayName
        mail
        deleted
        userGroups {
          id
        }
      }
      dispositionById
      dispositionDate
      externalLinks {
        href
        label
      }
      id
      packageName
      packageNumber
      project {
        projectName
      }
      projectId
      requestedActionDate
      status
      submittedBy {
        id
        displayName
        mail
        deleted
        userGroups {
          id
        }
      }
      submittedById
      submittedDate
      type {
        name
        id
        description
        deleted
      }
      dsToPayItemNoGeometries {
        payItem {
          globalId
          deleted
          label
        }
      }
      comments {
        text
        user {
          displayName
          mail
          id
        }
        createdDate
        id
      }
      dsToDSDisciplines {
        accepted
        acceptedBy {
          id
          displayName
          mail
        }
        acceptedDate
        discipline {
          id
          name
          description
          deleted
          users(userFieldInput: {deleted: false}) {
            id
            mail
            displayName
          }
        }
      }
      actions {
        id
        name
        description
        deleted
      }
      organization {
        id
        name
        description
        deleted
      }
      fieldDesignChanges {
        id
        formattedNumber
        deleted
      }
      customFields {
        booleanValues {
          customField {
            ...ProjectFieldDesignChangesCustomField
          }
          customFieldId
          value
        }
        dateValues {
          customField {
            ...ProjectFieldDesignChangesCustomField
          }
          customFieldId
          value
        }
        entityValues {
          customField {
            ...ProjectFieldDesignChangesCustomField
          }
          customFieldId
          entities {
            recordId
            href(projectId: $projectId)
            entityId
            label
          }
        }
        listValues {
          singles {
            customField {
              ...ProjectFieldDesignChangesCustomField
            }
            customFieldId
            customListItem {
              id
              deleted
              value
            }
          }
          multiples {
            customField {
              ...ProjectFieldDesignChangesCustomField
            }
            customFieldId
            customListItems {
              id
              deleted
              value
            }
          }
          checkboxes {
            customField {
              ...ProjectFieldDesignChangesCustomField
            }
            customFieldId
            booleans {
              customListItemId
              customListItem {
                value
              }
              checked
            }
          }
        }
        numberValues {
          customField {
            ...ProjectFieldDesignChangesCustomField
          }
          customFieldId
          value
        }
        reportValues {
          customField {
            ...ProjectFieldDesignChangesCustomField
          }
          customFieldId
          reports {
            recordId
            reportId
            href(projectId: $projectId)
            label
          }
        }
        textValues {
          customField {
            ...ProjectFieldDesignChangesCustomField
          }
          customFieldId
          value
        }
      }
    }
  }
}
    ${ProjectFieldDesignChangesCustomFieldFragmentDoc}`;

/**
 * __useGetDesignSubmittalsQuery__
 *
 * To run a query within a React component, call `useGetDesignSubmittalsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDesignSubmittalsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDesignSubmittalsQuery({
 *   variables: {
 *      input: // value for 'input'
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useGetDesignSubmittalsQuery(baseOptions: Apollo.QueryHookOptions<GetDesignSubmittalsQuery, GetDesignSubmittalsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDesignSubmittalsQuery, GetDesignSubmittalsQueryVariables>(GetDesignSubmittalsDocument, options);
      }
export function useGetDesignSubmittalsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDesignSubmittalsQuery, GetDesignSubmittalsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDesignSubmittalsQuery, GetDesignSubmittalsQueryVariables>(GetDesignSubmittalsDocument, options);
        }
export type GetDesignSubmittalsQueryHookResult = ReturnType<typeof useGetDesignSubmittalsQuery>;
export type GetDesignSubmittalsLazyQueryHookResult = ReturnType<typeof useGetDesignSubmittalsLazyQuery>;
export type GetDesignSubmittalsQueryResult = Apollo.QueryResult<GetDesignSubmittalsQuery, GetDesignSubmittalsQueryVariables>;
export const GetDesignSubmittalsMetadataDocument = gql`
    query GetDesignSubmittalsMetadata($globalId: String!) {
  project(globalId: $globalId) {
    dsActions(dsActionFieldInput: {deleted: false}) {
      id
      name
      description
    }
    fieldDesignChanges(fieldDesignChangeFieldInput: {deleted: false}) {
      id
      formattedNumber
    }
    dsOrganizations(dSOrganizationFieldInput: {deleted: false}) {
      id
      name
      description
    }
    dsDisciplines(dsDisciplineFieldInput: {deleted: false}) {
      id
      name
      description
    }
    dsTypes(dsTypeFieldInput: {deleted: false}) {
      id
      name
      description
    }
    dsQuickLinks(dsQuickLinkFieldInput: {deleted: false}) {
      id
      label
      href
      description
    }
  }
}
    `;

/**
 * __useGetDesignSubmittalsMetadataQuery__
 *
 * To run a query within a React component, call `useGetDesignSubmittalsMetadataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDesignSubmittalsMetadataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDesignSubmittalsMetadataQuery({
 *   variables: {
 *      globalId: // value for 'globalId'
 *   },
 * });
 */
export function useGetDesignSubmittalsMetadataQuery(baseOptions: Apollo.QueryHookOptions<GetDesignSubmittalsMetadataQuery, GetDesignSubmittalsMetadataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDesignSubmittalsMetadataQuery, GetDesignSubmittalsMetadataQueryVariables>(GetDesignSubmittalsMetadataDocument, options);
      }
export function useGetDesignSubmittalsMetadataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDesignSubmittalsMetadataQuery, GetDesignSubmittalsMetadataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDesignSubmittalsMetadataQuery, GetDesignSubmittalsMetadataQueryVariables>(GetDesignSubmittalsMetadataDocument, options);
        }
export type GetDesignSubmittalsMetadataQueryHookResult = ReturnType<typeof useGetDesignSubmittalsMetadataQuery>;
export type GetDesignSubmittalsMetadataLazyQueryHookResult = ReturnType<typeof useGetDesignSubmittalsMetadataLazyQuery>;
export type GetDesignSubmittalsMetadataQueryResult = Apollo.QueryResult<GetDesignSubmittalsMetadataQuery, GetDesignSubmittalsMetadataQueryVariables>;
export const CreateDsDisciplineDocument = gql`
    mutation CreateDSDiscipline($createDsDisciplineInput: CreateDSDisciplineInput!) {
  createDSDiscipline(createDSDisciplineInput: $createDsDisciplineInput) {
    discipline {
      name
    }
  }
}
    `;
export type CreateDsDisciplineMutationFn = Apollo.MutationFunction<CreateDsDisciplineMutation, CreateDsDisciplineMutationVariables>;

/**
 * __useCreateDsDisciplineMutation__
 *
 * To run a mutation, you first call `useCreateDsDisciplineMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateDsDisciplineMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createDsDisciplineMutation, { data, loading, error }] = useCreateDsDisciplineMutation({
 *   variables: {
 *      createDsDisciplineInput: // value for 'createDsDisciplineInput'
 *   },
 * });
 */
export function useCreateDsDisciplineMutation(baseOptions?: Apollo.MutationHookOptions<CreateDsDisciplineMutation, CreateDsDisciplineMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateDsDisciplineMutation, CreateDsDisciplineMutationVariables>(CreateDsDisciplineDocument, options);
      }
export type CreateDsDisciplineMutationHookResult = ReturnType<typeof useCreateDsDisciplineMutation>;
export type CreateDsDisciplineMutationResult = Apollo.MutationResult<CreateDsDisciplineMutation>;
export type CreateDsDisciplineMutationOptions = Apollo.BaseMutationOptions<CreateDsDisciplineMutation, CreateDsDisciplineMutationVariables>;
export const EditDsDisciplineDocument = gql`
    mutation EditDSDiscipline($editDsDisciplineInput: EditDSDisciplineInput!) {
  editDSDiscipline(editDSDisciplineInput: $editDsDisciplineInput) {
    discipline {
      name
    }
  }
}
    `;
export type EditDsDisciplineMutationFn = Apollo.MutationFunction<EditDsDisciplineMutation, EditDsDisciplineMutationVariables>;

/**
 * __useEditDsDisciplineMutation__
 *
 * To run a mutation, you first call `useEditDsDisciplineMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditDsDisciplineMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editDsDisciplineMutation, { data, loading, error }] = useEditDsDisciplineMutation({
 *   variables: {
 *      editDsDisciplineInput: // value for 'editDsDisciplineInput'
 *   },
 * });
 */
export function useEditDsDisciplineMutation(baseOptions?: Apollo.MutationHookOptions<EditDsDisciplineMutation, EditDsDisciplineMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditDsDisciplineMutation, EditDsDisciplineMutationVariables>(EditDsDisciplineDocument, options);
      }
export type EditDsDisciplineMutationHookResult = ReturnType<typeof useEditDsDisciplineMutation>;
export type EditDsDisciplineMutationResult = Apollo.MutationResult<EditDsDisciplineMutation>;
export type EditDsDisciplineMutationOptions = Apollo.BaseMutationOptions<EditDsDisciplineMutation, EditDsDisciplineMutationVariables>;
export const SoftRemoveDsDisciplineDocument = gql`
    mutation SoftRemoveDSDiscipline($id: String!) {
  softRemoveDSDiscipline(id: $id) {
    discipline {
      name
    }
  }
}
    `;
export type SoftRemoveDsDisciplineMutationFn = Apollo.MutationFunction<SoftRemoveDsDisciplineMutation, SoftRemoveDsDisciplineMutationVariables>;

/**
 * __useSoftRemoveDsDisciplineMutation__
 *
 * To run a mutation, you first call `useSoftRemoveDsDisciplineMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSoftRemoveDsDisciplineMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [softRemoveDsDisciplineMutation, { data, loading, error }] = useSoftRemoveDsDisciplineMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSoftRemoveDsDisciplineMutation(baseOptions?: Apollo.MutationHookOptions<SoftRemoveDsDisciplineMutation, SoftRemoveDsDisciplineMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SoftRemoveDsDisciplineMutation, SoftRemoveDsDisciplineMutationVariables>(SoftRemoveDsDisciplineDocument, options);
      }
export type SoftRemoveDsDisciplineMutationHookResult = ReturnType<typeof useSoftRemoveDsDisciplineMutation>;
export type SoftRemoveDsDisciplineMutationResult = Apollo.MutationResult<SoftRemoveDsDisciplineMutation>;
export type SoftRemoveDsDisciplineMutationOptions = Apollo.BaseMutationOptions<SoftRemoveDsDisciplineMutation, SoftRemoveDsDisciplineMutationVariables>;
export const RestoreDsDisciplineDocument = gql`
    mutation RestoreDSDiscipline($id: String!) {
  restoreDSDiscipline(id: $id) {
    discipline {
      name
    }
  }
}
    `;
export type RestoreDsDisciplineMutationFn = Apollo.MutationFunction<RestoreDsDisciplineMutation, RestoreDsDisciplineMutationVariables>;

/**
 * __useRestoreDsDisciplineMutation__
 *
 * To run a mutation, you first call `useRestoreDsDisciplineMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRestoreDsDisciplineMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [restoreDsDisciplineMutation, { data, loading, error }] = useRestoreDsDisciplineMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRestoreDsDisciplineMutation(baseOptions?: Apollo.MutationHookOptions<RestoreDsDisciplineMutation, RestoreDsDisciplineMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RestoreDsDisciplineMutation, RestoreDsDisciplineMutationVariables>(RestoreDsDisciplineDocument, options);
      }
export type RestoreDsDisciplineMutationHookResult = ReturnType<typeof useRestoreDsDisciplineMutation>;
export type RestoreDsDisciplineMutationResult = Apollo.MutationResult<RestoreDsDisciplineMutation>;
export type RestoreDsDisciplineMutationOptions = Apollo.BaseMutationOptions<RestoreDsDisciplineMutation, RestoreDsDisciplineMutationVariables>;
export const GetDsDisciplinesDocument = gql`
    query GetDSDisciplines($dsDisciplineListInput: DSDisciplineListInput!) {
  dsDisciplines(dsDisciplineListInput: $dsDisciplineListInput) {
    records {
      id
      name
      description
      deleted
      deletedUser
      deletedDate
      dsToDSDisciplines {
        submittal {
          id
          packageNumber
          packageName
          deleted
        }
      }
      users(userFieldInput: {deleted: false}) {
        id
        displayName
        mail
        deleted
        userGroups {
          id
        }
      }
    }
  }
}
    `;

/**
 * __useGetDsDisciplinesQuery__
 *
 * To run a query within a React component, call `useGetDsDisciplinesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDsDisciplinesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDsDisciplinesQuery({
 *   variables: {
 *      dsDisciplineListInput: // value for 'dsDisciplineListInput'
 *   },
 * });
 */
export function useGetDsDisciplinesQuery(baseOptions: Apollo.QueryHookOptions<GetDsDisciplinesQuery, GetDsDisciplinesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDsDisciplinesQuery, GetDsDisciplinesQueryVariables>(GetDsDisciplinesDocument, options);
      }
export function useGetDsDisciplinesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDsDisciplinesQuery, GetDsDisciplinesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDsDisciplinesQuery, GetDsDisciplinesQueryVariables>(GetDsDisciplinesDocument, options);
        }
export type GetDsDisciplinesQueryHookResult = ReturnType<typeof useGetDsDisciplinesQuery>;
export type GetDsDisciplinesLazyQueryHookResult = ReturnType<typeof useGetDsDisciplinesLazyQuery>;
export type GetDsDisciplinesQueryResult = Apollo.QueryResult<GetDsDisciplinesQuery, GetDsDisciplinesQueryVariables>;
export const ProjectDsNotificationEventsDocument = gql`
    query ProjectDSNotificationEvents($globalId: String!) {
  project(globalId: $globalId) {
    dsNotifications {
      notificationEventId
      recipients {
        every {
          ...DSNotificationsRecipients
        }
        byDSDiscipline(disciplineFieldInput: {deleted: false}) {
          discipline {
            id
          }
          recipients {
            ...DSNotificationsRecipients
          }
        }
      }
    }
    dsDisciplines(dsDisciplineFieldInput: {deleted: false}) {
      id
      name
      description
      users(userFieldInput: {deleted: false}) {
        ...DSNotificationsUser
      }
    }
  }
}
    ${DsNotificationsRecipientsFragmentDoc}
${DsNotificationsUserFragmentDoc}`;

/**
 * __useProjectDsNotificationEventsQuery__
 *
 * To run a query within a React component, call `useProjectDsNotificationEventsQuery` and pass it any options that fit your needs.
 * When your component renders, `useProjectDsNotificationEventsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProjectDsNotificationEventsQuery({
 *   variables: {
 *      globalId: // value for 'globalId'
 *   },
 * });
 */
export function useProjectDsNotificationEventsQuery(baseOptions: Apollo.QueryHookOptions<ProjectDsNotificationEventsQuery, ProjectDsNotificationEventsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProjectDsNotificationEventsQuery, ProjectDsNotificationEventsQueryVariables>(ProjectDsNotificationEventsDocument, options);
      }
export function useProjectDsNotificationEventsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProjectDsNotificationEventsQuery, ProjectDsNotificationEventsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProjectDsNotificationEventsQuery, ProjectDsNotificationEventsQueryVariables>(ProjectDsNotificationEventsDocument, options);
        }
export type ProjectDsNotificationEventsQueryHookResult = ReturnType<typeof useProjectDsNotificationEventsQuery>;
export type ProjectDsNotificationEventsLazyQueryHookResult = ReturnType<typeof useProjectDsNotificationEventsLazyQuery>;
export type ProjectDsNotificationEventsQueryResult = Apollo.QueryResult<ProjectDsNotificationEventsQuery, ProjectDsNotificationEventsQueryVariables>;
export const EditDsNotificationDocument = gql`
    mutation EditDSNotification($editDsNotificationInput: EditDSNotificationInput!) {
  editDSNotification(editDSNotificationInput: $editDsNotificationInput) {
    notification {
      notificationEvent
    }
  }
}
    `;
export type EditDsNotificationMutationFn = Apollo.MutationFunction<EditDsNotificationMutation, EditDsNotificationMutationVariables>;

/**
 * __useEditDsNotificationMutation__
 *
 * To run a mutation, you first call `useEditDsNotificationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditDsNotificationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editDsNotificationMutation, { data, loading, error }] = useEditDsNotificationMutation({
 *   variables: {
 *      editDsNotificationInput: // value for 'editDsNotificationInput'
 *   },
 * });
 */
export function useEditDsNotificationMutation(baseOptions?: Apollo.MutationHookOptions<EditDsNotificationMutation, EditDsNotificationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditDsNotificationMutation, EditDsNotificationMutationVariables>(EditDsNotificationDocument, options);
      }
export type EditDsNotificationMutationHookResult = ReturnType<typeof useEditDsNotificationMutation>;
export type EditDsNotificationMutationResult = Apollo.MutationResult<EditDsNotificationMutation>;
export type EditDsNotificationMutationOptions = Apollo.BaseMutationOptions<EditDsNotificationMutation, EditDsNotificationMutationVariables>;
export const CreateOrganizationDocument = gql`
    mutation CreateOrganization($createOrganizationInput: CreateDSOrganizationInput!) {
  createDSOrganization(createDSOrganizationInput: $createOrganizationInput) {
    organization {
      name
    }
  }
}
    `;
export type CreateOrganizationMutationFn = Apollo.MutationFunction<CreateOrganizationMutation, CreateOrganizationMutationVariables>;

/**
 * __useCreateOrganizationMutation__
 *
 * To run a mutation, you first call `useCreateOrganizationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOrganizationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOrganizationMutation, { data, loading, error }] = useCreateOrganizationMutation({
 *   variables: {
 *      createOrganizationInput: // value for 'createOrganizationInput'
 *   },
 * });
 */
export function useCreateOrganizationMutation(baseOptions?: Apollo.MutationHookOptions<CreateOrganizationMutation, CreateOrganizationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateOrganizationMutation, CreateOrganizationMutationVariables>(CreateOrganizationDocument, options);
      }
export type CreateOrganizationMutationHookResult = ReturnType<typeof useCreateOrganizationMutation>;
export type CreateOrganizationMutationResult = Apollo.MutationResult<CreateOrganizationMutation>;
export type CreateOrganizationMutationOptions = Apollo.BaseMutationOptions<CreateOrganizationMutation, CreateOrganizationMutationVariables>;
export const EditOrganizationDocument = gql`
    mutation EditOrganization($editOrganizationInput: EditDSOrganizationInput!) {
  editDSOrganization(editDSOrganizationInput: $editOrganizationInput) {
    organization {
      name
    }
  }
}
    `;
export type EditOrganizationMutationFn = Apollo.MutationFunction<EditOrganizationMutation, EditOrganizationMutationVariables>;

/**
 * __useEditOrganizationMutation__
 *
 * To run a mutation, you first call `useEditOrganizationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditOrganizationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editOrganizationMutation, { data, loading, error }] = useEditOrganizationMutation({
 *   variables: {
 *      editOrganizationInput: // value for 'editOrganizationInput'
 *   },
 * });
 */
export function useEditOrganizationMutation(baseOptions?: Apollo.MutationHookOptions<EditOrganizationMutation, EditOrganizationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditOrganizationMutation, EditOrganizationMutationVariables>(EditOrganizationDocument, options);
      }
export type EditOrganizationMutationHookResult = ReturnType<typeof useEditOrganizationMutation>;
export type EditOrganizationMutationResult = Apollo.MutationResult<EditOrganizationMutation>;
export type EditOrganizationMutationOptions = Apollo.BaseMutationOptions<EditOrganizationMutation, EditOrganizationMutationVariables>;
export const RemoveOrganizationDocument = gql`
    mutation RemoveOrganization($id: String!) {
  softRemoveDSOrganization(id: $id) {
    organization {
      name
    }
  }
}
    `;
export type RemoveOrganizationMutationFn = Apollo.MutationFunction<RemoveOrganizationMutation, RemoveOrganizationMutationVariables>;

/**
 * __useRemoveOrganizationMutation__
 *
 * To run a mutation, you first call `useRemoveOrganizationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveOrganizationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeOrganizationMutation, { data, loading, error }] = useRemoveOrganizationMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRemoveOrganizationMutation(baseOptions?: Apollo.MutationHookOptions<RemoveOrganizationMutation, RemoveOrganizationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveOrganizationMutation, RemoveOrganizationMutationVariables>(RemoveOrganizationDocument, options);
      }
export type RemoveOrganizationMutationHookResult = ReturnType<typeof useRemoveOrganizationMutation>;
export type RemoveOrganizationMutationResult = Apollo.MutationResult<RemoveOrganizationMutation>;
export type RemoveOrganizationMutationOptions = Apollo.BaseMutationOptions<RemoveOrganizationMutation, RemoveOrganizationMutationVariables>;
export const RestoreDsOrganizationDocument = gql`
    mutation RestoreDSOrganization($id: String!) {
  restoreDSOrganization(id: $id) {
    organization {
      name
    }
  }
}
    `;
export type RestoreDsOrganizationMutationFn = Apollo.MutationFunction<RestoreDsOrganizationMutation, RestoreDsOrganizationMutationVariables>;

/**
 * __useRestoreDsOrganizationMutation__
 *
 * To run a mutation, you first call `useRestoreDsOrganizationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRestoreDsOrganizationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [restoreDsOrganizationMutation, { data, loading, error }] = useRestoreDsOrganizationMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRestoreDsOrganizationMutation(baseOptions?: Apollo.MutationHookOptions<RestoreDsOrganizationMutation, RestoreDsOrganizationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RestoreDsOrganizationMutation, RestoreDsOrganizationMutationVariables>(RestoreDsOrganizationDocument, options);
      }
export type RestoreDsOrganizationMutationHookResult = ReturnType<typeof useRestoreDsOrganizationMutation>;
export type RestoreDsOrganizationMutationResult = Apollo.MutationResult<RestoreDsOrganizationMutation>;
export type RestoreDsOrganizationMutationOptions = Apollo.BaseMutationOptions<RestoreDsOrganizationMutation, RestoreDsOrganizationMutationVariables>;
export const GetOrganizationsDocument = gql`
    query GetOrganizations($dsOrganizationListInput: DSOrganizationListInput!) {
  dsOrganizations(dsOrganizationListInput: $dsOrganizationListInput) {
    records {
      id
      name
      description
      deleted
      deletedDate
      deletedUser
      submittals {
        id
        packageNumber
        packageName
        deleted
      }
    }
  }
}
    `;

/**
 * __useGetOrganizationsQuery__
 *
 * To run a query within a React component, call `useGetOrganizationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrganizationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrganizationsQuery({
 *   variables: {
 *      dsOrganizationListInput: // value for 'dsOrganizationListInput'
 *   },
 * });
 */
export function useGetOrganizationsQuery(baseOptions: Apollo.QueryHookOptions<GetOrganizationsQuery, GetOrganizationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOrganizationsQuery, GetOrganizationsQueryVariables>(GetOrganizationsDocument, options);
      }
export function useGetOrganizationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOrganizationsQuery, GetOrganizationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOrganizationsQuery, GetOrganizationsQueryVariables>(GetOrganizationsDocument, options);
        }
export type GetOrganizationsQueryHookResult = ReturnType<typeof useGetOrganizationsQuery>;
export type GetOrganizationsLazyQueryHookResult = ReturnType<typeof useGetOrganizationsLazyQuery>;
export type GetOrganizationsQueryResult = Apollo.QueryResult<GetOrganizationsQuery, GetOrganizationsQueryVariables>;
export const CreateDsTypeDocument = gql`
    mutation CreateDSType($createDsTypeInput: CreateDSTypeInput!) {
  createDSType(createDSTypeInput: $createDsTypeInput) {
    type {
      name
    }
  }
}
    `;
export type CreateDsTypeMutationFn = Apollo.MutationFunction<CreateDsTypeMutation, CreateDsTypeMutationVariables>;

/**
 * __useCreateDsTypeMutation__
 *
 * To run a mutation, you first call `useCreateDsTypeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateDsTypeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createDsTypeMutation, { data, loading, error }] = useCreateDsTypeMutation({
 *   variables: {
 *      createDsTypeInput: // value for 'createDsTypeInput'
 *   },
 * });
 */
export function useCreateDsTypeMutation(baseOptions?: Apollo.MutationHookOptions<CreateDsTypeMutation, CreateDsTypeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateDsTypeMutation, CreateDsTypeMutationVariables>(CreateDsTypeDocument, options);
      }
export type CreateDsTypeMutationHookResult = ReturnType<typeof useCreateDsTypeMutation>;
export type CreateDsTypeMutationResult = Apollo.MutationResult<CreateDsTypeMutation>;
export type CreateDsTypeMutationOptions = Apollo.BaseMutationOptions<CreateDsTypeMutation, CreateDsTypeMutationVariables>;
export const EditDsTypeDocument = gql`
    mutation EditDSType($editDsTypeInput: EditDSTypeInput!) {
  editDSType(editDSTypeInput: $editDsTypeInput) {
    type {
      name
    }
  }
}
    `;
export type EditDsTypeMutationFn = Apollo.MutationFunction<EditDsTypeMutation, EditDsTypeMutationVariables>;

/**
 * __useEditDsTypeMutation__
 *
 * To run a mutation, you first call `useEditDsTypeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditDsTypeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editDsTypeMutation, { data, loading, error }] = useEditDsTypeMutation({
 *   variables: {
 *      editDsTypeInput: // value for 'editDsTypeInput'
 *   },
 * });
 */
export function useEditDsTypeMutation(baseOptions?: Apollo.MutationHookOptions<EditDsTypeMutation, EditDsTypeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditDsTypeMutation, EditDsTypeMutationVariables>(EditDsTypeDocument, options);
      }
export type EditDsTypeMutationHookResult = ReturnType<typeof useEditDsTypeMutation>;
export type EditDsTypeMutationResult = Apollo.MutationResult<EditDsTypeMutation>;
export type EditDsTypeMutationOptions = Apollo.BaseMutationOptions<EditDsTypeMutation, EditDsTypeMutationVariables>;
export const SoftRemoveDsTypeDocument = gql`
    mutation SoftRemoveDSType($id: String!) {
  softRemoveDSType(id: $id) {
    type {
      name
    }
  }
}
    `;
export type SoftRemoveDsTypeMutationFn = Apollo.MutationFunction<SoftRemoveDsTypeMutation, SoftRemoveDsTypeMutationVariables>;

/**
 * __useSoftRemoveDsTypeMutation__
 *
 * To run a mutation, you first call `useSoftRemoveDsTypeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSoftRemoveDsTypeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [softRemoveDsTypeMutation, { data, loading, error }] = useSoftRemoveDsTypeMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSoftRemoveDsTypeMutation(baseOptions?: Apollo.MutationHookOptions<SoftRemoveDsTypeMutation, SoftRemoveDsTypeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SoftRemoveDsTypeMutation, SoftRemoveDsTypeMutationVariables>(SoftRemoveDsTypeDocument, options);
      }
export type SoftRemoveDsTypeMutationHookResult = ReturnType<typeof useSoftRemoveDsTypeMutation>;
export type SoftRemoveDsTypeMutationResult = Apollo.MutationResult<SoftRemoveDsTypeMutation>;
export type SoftRemoveDsTypeMutationOptions = Apollo.BaseMutationOptions<SoftRemoveDsTypeMutation, SoftRemoveDsTypeMutationVariables>;
export const RestoreDsTypeDocument = gql`
    mutation RestoreDSType($id: String!) {
  restoreDSType(id: $id) {
    type {
      name
    }
  }
}
    `;
export type RestoreDsTypeMutationFn = Apollo.MutationFunction<RestoreDsTypeMutation, RestoreDsTypeMutationVariables>;

/**
 * __useRestoreDsTypeMutation__
 *
 * To run a mutation, you first call `useRestoreDsTypeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRestoreDsTypeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [restoreDsTypeMutation, { data, loading, error }] = useRestoreDsTypeMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRestoreDsTypeMutation(baseOptions?: Apollo.MutationHookOptions<RestoreDsTypeMutation, RestoreDsTypeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RestoreDsTypeMutation, RestoreDsTypeMutationVariables>(RestoreDsTypeDocument, options);
      }
export type RestoreDsTypeMutationHookResult = ReturnType<typeof useRestoreDsTypeMutation>;
export type RestoreDsTypeMutationResult = Apollo.MutationResult<RestoreDsTypeMutation>;
export type RestoreDsTypeMutationOptions = Apollo.BaseMutationOptions<RestoreDsTypeMutation, RestoreDsTypeMutationVariables>;
export const GetDsTypesDocument = gql`
    query GetDSTypes($dsTypeListInput: DSTypeListInput!) {
  dsTypes(dsTypeListInput: $dsTypeListInput) {
    records {
      id
      name
      description
      deleted
      deletedDate
      deletedUser
      submittals {
        id
        packageName
        packageNumber
        deleted
      }
    }
  }
}
    `;

/**
 * __useGetDsTypesQuery__
 *
 * To run a query within a React component, call `useGetDsTypesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDsTypesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDsTypesQuery({
 *   variables: {
 *      dsTypeListInput: // value for 'dsTypeListInput'
 *   },
 * });
 */
export function useGetDsTypesQuery(baseOptions: Apollo.QueryHookOptions<GetDsTypesQuery, GetDsTypesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDsTypesQuery, GetDsTypesQueryVariables>(GetDsTypesDocument, options);
      }
export function useGetDsTypesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDsTypesQuery, GetDsTypesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDsTypesQuery, GetDsTypesQueryVariables>(GetDsTypesDocument, options);
        }
export type GetDsTypesQueryHookResult = ReturnType<typeof useGetDsTypesQuery>;
export type GetDsTypesLazyQueryHookResult = ReturnType<typeof useGetDsTypesLazyQuery>;
export type GetDsTypesQueryResult = Apollo.QueryResult<GetDsTypesQuery, GetDsTypesQueryVariables>;
export const DevelopersDocument = gql`
    query Developers {
  users(userListInput: {deleted: false}) {
    records {
      id
      username
      mail
      developer
      developerDate
      developerGrantedBy {
        username
      }
      userToDeveloperPermissions {
        permissionId
      }
    }
  }
}
    `;

/**
 * __useDevelopersQuery__
 *
 * To run a query within a React component, call `useDevelopersQuery` and pass it any options that fit your needs.
 * When your component renders, `useDevelopersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDevelopersQuery({
 *   variables: {
 *   },
 * });
 */
export function useDevelopersQuery(baseOptions?: Apollo.QueryHookOptions<DevelopersQuery, DevelopersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DevelopersQuery, DevelopersQueryVariables>(DevelopersDocument, options);
      }
export function useDevelopersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DevelopersQuery, DevelopersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DevelopersQuery, DevelopersQueryVariables>(DevelopersDocument, options);
        }
export type DevelopersQueryHookResult = ReturnType<typeof useDevelopersQuery>;
export type DevelopersLazyQueryHookResult = ReturnType<typeof useDevelopersLazyQuery>;
export type DevelopersQueryResult = Apollo.QueryResult<DevelopersQuery, DevelopersQueryVariables>;
export const EditDevelopersDocument = gql`
    mutation EditDevelopers($input: EditUserInput!) {
  editUser(editUserInput: $input) {
    user {
      username
    }
  }
}
    `;
export type EditDevelopersMutationFn = Apollo.MutationFunction<EditDevelopersMutation, EditDevelopersMutationVariables>;

/**
 * __useEditDevelopersMutation__
 *
 * To run a mutation, you first call `useEditDevelopersMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditDevelopersMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editDevelopersMutation, { data, loading, error }] = useEditDevelopersMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEditDevelopersMutation(baseOptions?: Apollo.MutationHookOptions<EditDevelopersMutation, EditDevelopersMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditDevelopersMutation, EditDevelopersMutationVariables>(EditDevelopersDocument, options);
      }
export type EditDevelopersMutationHookResult = ReturnType<typeof useEditDevelopersMutation>;
export type EditDevelopersMutationResult = Apollo.MutationResult<EditDevelopersMutation>;
export type EditDevelopersMutationOptions = Apollo.BaseMutationOptions<EditDevelopersMutation, EditDevelopersMutationVariables>;
export const UpsertUserToDeveloperPermissionsDocument = gql`
    mutation UpsertUserToDeveloperPermissions($input: UpsertUserToDeveloperPermissionInput!) {
  upsertUserToDeveloperPermission(upsertUserToDeveloperPermissionInput: $input) {
    userToDeveloperPermissions {
      permission
      user {
        username
      }
    }
  }
}
    `;
export type UpsertUserToDeveloperPermissionsMutationFn = Apollo.MutationFunction<UpsertUserToDeveloperPermissionsMutation, UpsertUserToDeveloperPermissionsMutationVariables>;

/**
 * __useUpsertUserToDeveloperPermissionsMutation__
 *
 * To run a mutation, you first call `useUpsertUserToDeveloperPermissionsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertUserToDeveloperPermissionsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertUserToDeveloperPermissionsMutation, { data, loading, error }] = useUpsertUserToDeveloperPermissionsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpsertUserToDeveloperPermissionsMutation(baseOptions?: Apollo.MutationHookOptions<UpsertUserToDeveloperPermissionsMutation, UpsertUserToDeveloperPermissionsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpsertUserToDeveloperPermissionsMutation, UpsertUserToDeveloperPermissionsMutationVariables>(UpsertUserToDeveloperPermissionsDocument, options);
      }
export type UpsertUserToDeveloperPermissionsMutationHookResult = ReturnType<typeof useUpsertUserToDeveloperPermissionsMutation>;
export type UpsertUserToDeveloperPermissionsMutationResult = Apollo.MutationResult<UpsertUserToDeveloperPermissionsMutation>;
export type UpsertUserToDeveloperPermissionsMutationOptions = Apollo.BaseMutationOptions<UpsertUserToDeveloperPermissionsMutation, UpsertUserToDeveloperPermissionsMutationVariables>;
export const WriteHeapSnapshotDocument = gql`
    mutation WriteHeapSnapshot {
  writeHeapSnapshot {
    id
  }
}
    `;
export type WriteHeapSnapshotMutationFn = Apollo.MutationFunction<WriteHeapSnapshotMutation, WriteHeapSnapshotMutationVariables>;

/**
 * __useWriteHeapSnapshotMutation__
 *
 * To run a mutation, you first call `useWriteHeapSnapshotMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useWriteHeapSnapshotMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [writeHeapSnapshotMutation, { data, loading, error }] = useWriteHeapSnapshotMutation({
 *   variables: {
 *   },
 * });
 */
export function useWriteHeapSnapshotMutation(baseOptions?: Apollo.MutationHookOptions<WriteHeapSnapshotMutation, WriteHeapSnapshotMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<WriteHeapSnapshotMutation, WriteHeapSnapshotMutationVariables>(WriteHeapSnapshotDocument, options);
      }
export type WriteHeapSnapshotMutationHookResult = ReturnType<typeof useWriteHeapSnapshotMutation>;
export type WriteHeapSnapshotMutationResult = Apollo.MutationResult<WriteHeapSnapshotMutation>;
export type WriteHeapSnapshotMutationOptions = Apollo.BaseMutationOptions<WriteHeapSnapshotMutation, WriteHeapSnapshotMutationVariables>;
export const SyncUsersDocument = gql`
    mutation SyncUsers {
  syncUsers {
    success
  }
}
    `;
export type SyncUsersMutationFn = Apollo.MutationFunction<SyncUsersMutation, SyncUsersMutationVariables>;

/**
 * __useSyncUsersMutation__
 *
 * To run a mutation, you first call `useSyncUsersMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSyncUsersMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [syncUsersMutation, { data, loading, error }] = useSyncUsersMutation({
 *   variables: {
 *   },
 * });
 */
export function useSyncUsersMutation(baseOptions?: Apollo.MutationHookOptions<SyncUsersMutation, SyncUsersMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SyncUsersMutation, SyncUsersMutationVariables>(SyncUsersDocument, options);
      }
export type SyncUsersMutationHookResult = ReturnType<typeof useSyncUsersMutation>;
export type SyncUsersMutationResult = Apollo.MutationResult<SyncUsersMutation>;
export type SyncUsersMutationOptions = Apollo.BaseMutationOptions<SyncUsersMutation, SyncUsersMutationVariables>;
export const EditEngineeringJudgementDocument = gql`
    mutation EditEngineeringJudgement($input: EditEngineeringJudgementInput!) {
  editEngineeringJudgement(editEngineeringJudgementInput: $input) {
    judgement {
      formattedNumber
    }
  }
}
    `;
export type EditEngineeringJudgementMutationFn = Apollo.MutationFunction<EditEngineeringJudgementMutation, EditEngineeringJudgementMutationVariables>;

/**
 * __useEditEngineeringJudgementMutation__
 *
 * To run a mutation, you first call `useEditEngineeringJudgementMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditEngineeringJudgementMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editEngineeringJudgementMutation, { data, loading, error }] = useEditEngineeringJudgementMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEditEngineeringJudgementMutation(baseOptions?: Apollo.MutationHookOptions<EditEngineeringJudgementMutation, EditEngineeringJudgementMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditEngineeringJudgementMutation, EditEngineeringJudgementMutationVariables>(EditEngineeringJudgementDocument, options);
      }
export type EditEngineeringJudgementMutationHookResult = ReturnType<typeof useEditEngineeringJudgementMutation>;
export type EditEngineeringJudgementMutationResult = Apollo.MutationResult<EditEngineeringJudgementMutation>;
export type EditEngineeringJudgementMutationOptions = Apollo.BaseMutationOptions<EditEngineeringJudgementMutation, EditEngineeringJudgementMutationVariables>;
export const GetEjLogMetadataDocument = gql`
    query GetEJLogMetadata($globalId: String!) {
  project(globalId: $globalId) {
    ejTypes(ejTypeFieldInput: {deleted: false}) {
      id
      name
      allowanceDescription
      reportTypeId
      users(userFieldInput: {deleted: false}) {
        id
      }
    }
    ejQuickLinks {
      id
      label
      href
      description
    }
  }
}
    `;

/**
 * __useGetEjLogMetadataQuery__
 *
 * To run a query within a React component, call `useGetEjLogMetadataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEjLogMetadataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEjLogMetadataQuery({
 *   variables: {
 *      globalId: // value for 'globalId'
 *   },
 * });
 */
export function useGetEjLogMetadataQuery(baseOptions: Apollo.QueryHookOptions<GetEjLogMetadataQuery, GetEjLogMetadataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEjLogMetadataQuery, GetEjLogMetadataQueryVariables>(GetEjLogMetadataDocument, options);
      }
export function useGetEjLogMetadataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEjLogMetadataQuery, GetEjLogMetadataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEjLogMetadataQuery, GetEjLogMetadataQueryVariables>(GetEjLogMetadataDocument, options);
        }
export type GetEjLogMetadataQueryHookResult = ReturnType<typeof useGetEjLogMetadataQuery>;
export type GetEjLogMetadataLazyQueryHookResult = ReturnType<typeof useGetEjLogMetadataLazyQuery>;
export type GetEjLogMetadataQueryResult = Apollo.QueryResult<GetEjLogMetadataQuery, GetEjLogMetadataQueryVariables>;
export const GetEngineeringJudgementsDocument = gql`
    query GetEngineeringJudgements($projectId: String!, $engineeringJudgementListInput: EngineeringJudgementListInput!) {
  engineeringJudgements(
    engineeringJudgementListInput: $engineeringJudgementListInput
  ) {
    records {
      id
      formattedNumber
      statusId
      typeId
      failureDate
      failureDescription
      justification
      notes
      issuedDate
      manualReportId
      deleted
      deletedUser
      deletedDate
      externalLinks {
        href
        label
      }
      type {
        id
        name
        allowanceDescription
      }
      issuedBy {
        id
        displayName
        mail
        deleted
        userGroups {
          id
        }
      }
      identifiedFieldIssue {
        reportId
        asphaltLot {
          globalId
          asphaltLotId
        }
        concreteTest {
          globalId
          fieldNumber
        }
        dailyInspectionControlPoint {
          globalId
          controlPointId
        }
        dailyInspectionInspection {
          globalId
          inspectionId
        }
        dailyInspectionPunchList {
          globalId
          punchListId
        }
        lot {
          globalId
          lotId
        }
      }
      ejToReports {
        reportId
        reportTypeId
        concreteTest {
          globalId
          fieldNumber
        }
        concretePlacement {
          globalId
          placementId
        }
        lot {
          globalId
          lotId
        }
        dailyInspectionControlPoint {
          globalId
          controlPointId
        }
        dailyInspectionInspection {
          globalId
          inspectionId
        }
      }
      ejToPayItemNoGeometries {
        payItem {
          globalId
          deleted
          label
        }
      }
      customFields {
        booleanValues {
          customField {
            ...EngineeringJudgementCustomField
          }
          customFieldId
          value
        }
        dateValues {
          customField {
            ...EngineeringJudgementCustomField
          }
          customFieldId
          value
        }
        entityValues {
          customField {
            ...EngineeringJudgementCustomField
          }
          customFieldId
          entities {
            recordId
            href(projectId: $projectId)
            entityId
            label
          }
        }
        listValues {
          singles {
            customField {
              ...EngineeringJudgementCustomField
            }
            customFieldId
            customListItem {
              id
              deleted
              value
            }
          }
          multiples {
            customField {
              ...EngineeringJudgementCustomField
            }
            customFieldId
            customListItems {
              id
              deleted
              value
            }
          }
          checkboxes {
            customField {
              ...EngineeringJudgementCustomField
            }
            customFieldId
            booleans {
              customListItemId
              customListItem {
                value
              }
              checked
            }
          }
        }
        numberValues {
          customField {
            ...EngineeringJudgementCustomField
          }
          customFieldId
          value
        }
        reportValues {
          customField {
            ...EngineeringJudgementCustomField
          }
          customFieldId
          reports {
            recordId
            reportId
            href(projectId: $projectId)
            label
          }
        }
        textValues {
          customField {
            ...EngineeringJudgementCustomField
          }
          customFieldId
          value
        }
      }
    }
  }
}
    ${EngineeringJudgementCustomFieldFragmentDoc}`;

/**
 * __useGetEngineeringJudgementsQuery__
 *
 * To run a query within a React component, call `useGetEngineeringJudgementsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEngineeringJudgementsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEngineeringJudgementsQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      engineeringJudgementListInput: // value for 'engineeringJudgementListInput'
 *   },
 * });
 */
export function useGetEngineeringJudgementsQuery(baseOptions: Apollo.QueryHookOptions<GetEngineeringJudgementsQuery, GetEngineeringJudgementsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEngineeringJudgementsQuery, GetEngineeringJudgementsQueryVariables>(GetEngineeringJudgementsDocument, options);
      }
export function useGetEngineeringJudgementsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEngineeringJudgementsQuery, GetEngineeringJudgementsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEngineeringJudgementsQuery, GetEngineeringJudgementsQueryVariables>(GetEngineeringJudgementsDocument, options);
        }
export type GetEngineeringJudgementsQueryHookResult = ReturnType<typeof useGetEngineeringJudgementsQuery>;
export type GetEngineeringJudgementsLazyQueryHookResult = ReturnType<typeof useGetEngineeringJudgementsLazyQuery>;
export type GetEngineeringJudgementsQueryResult = Apollo.QueryResult<GetEngineeringJudgementsQuery, GetEngineeringJudgementsQueryVariables>;
export const DraftEngineeringJudgementDocument = gql`
    mutation DraftEngineeringJudgement($input: DraftEngineeringJudgementInput!) {
  draftEngineeringJudgement(draftEngineeringJudgementInput: $input) {
    judgement {
      formattedNumber
    }
  }
}
    `;
export type DraftEngineeringJudgementMutationFn = Apollo.MutationFunction<DraftEngineeringJudgementMutation, DraftEngineeringJudgementMutationVariables>;

/**
 * __useDraftEngineeringJudgementMutation__
 *
 * To run a mutation, you first call `useDraftEngineeringJudgementMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDraftEngineeringJudgementMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [draftEngineeringJudgementMutation, { data, loading, error }] = useDraftEngineeringJudgementMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDraftEngineeringJudgementMutation(baseOptions?: Apollo.MutationHookOptions<DraftEngineeringJudgementMutation, DraftEngineeringJudgementMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DraftEngineeringJudgementMutation, DraftEngineeringJudgementMutationVariables>(DraftEngineeringJudgementDocument, options);
      }
export type DraftEngineeringJudgementMutationHookResult = ReturnType<typeof useDraftEngineeringJudgementMutation>;
export type DraftEngineeringJudgementMutationResult = Apollo.MutationResult<DraftEngineeringJudgementMutation>;
export type DraftEngineeringJudgementMutationOptions = Apollo.BaseMutationOptions<DraftEngineeringJudgementMutation, DraftEngineeringJudgementMutationVariables>;
export const SubmitEngineeringJudgementDocument = gql`
    mutation SubmitEngineeringJudgement($input: SubmitEngineeringJudgementInput!) {
  submitEngineeringJudgement(submitEngineeringJudgementInput: $input) {
    judgement {
      formattedNumber
    }
  }
}
    `;
export type SubmitEngineeringJudgementMutationFn = Apollo.MutationFunction<SubmitEngineeringJudgementMutation, SubmitEngineeringJudgementMutationVariables>;

/**
 * __useSubmitEngineeringJudgementMutation__
 *
 * To run a mutation, you first call `useSubmitEngineeringJudgementMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubmitEngineeringJudgementMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [submitEngineeringJudgementMutation, { data, loading, error }] = useSubmitEngineeringJudgementMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSubmitEngineeringJudgementMutation(baseOptions?: Apollo.MutationHookOptions<SubmitEngineeringJudgementMutation, SubmitEngineeringJudgementMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SubmitEngineeringJudgementMutation, SubmitEngineeringJudgementMutationVariables>(SubmitEngineeringJudgementDocument, options);
      }
export type SubmitEngineeringJudgementMutationHookResult = ReturnType<typeof useSubmitEngineeringJudgementMutation>;
export type SubmitEngineeringJudgementMutationResult = Apollo.MutationResult<SubmitEngineeringJudgementMutation>;
export type SubmitEngineeringJudgementMutationOptions = Apollo.BaseMutationOptions<SubmitEngineeringJudgementMutation, SubmitEngineeringJudgementMutationVariables>;
export const RevertEngineeringJudgementDocument = gql`
    mutation RevertEngineeringJudgement($input: RevertEngineeringJudgementInput!) {
  revertEngineeringJudgement(revertEngineeringJudgementInput: $input) {
    judgement {
      formattedNumber
    }
  }
}
    `;
export type RevertEngineeringJudgementMutationFn = Apollo.MutationFunction<RevertEngineeringJudgementMutation, RevertEngineeringJudgementMutationVariables>;

/**
 * __useRevertEngineeringJudgementMutation__
 *
 * To run a mutation, you first call `useRevertEngineeringJudgementMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRevertEngineeringJudgementMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [revertEngineeringJudgementMutation, { data, loading, error }] = useRevertEngineeringJudgementMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRevertEngineeringJudgementMutation(baseOptions?: Apollo.MutationHookOptions<RevertEngineeringJudgementMutation, RevertEngineeringJudgementMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RevertEngineeringJudgementMutation, RevertEngineeringJudgementMutationVariables>(RevertEngineeringJudgementDocument, options);
      }
export type RevertEngineeringJudgementMutationHookResult = ReturnType<typeof useRevertEngineeringJudgementMutation>;
export type RevertEngineeringJudgementMutationResult = Apollo.MutationResult<RevertEngineeringJudgementMutation>;
export type RevertEngineeringJudgementMutationOptions = Apollo.BaseMutationOptions<RevertEngineeringJudgementMutation, RevertEngineeringJudgementMutationVariables>;
export const SoftRemoveEngineeringJudgementDocument = gql`
    mutation SoftRemoveEngineeringJudgement($id: String!) {
  softRemoveEngineeringJudgement(id: $id) {
    judgement {
      formattedNumber
    }
  }
}
    `;
export type SoftRemoveEngineeringJudgementMutationFn = Apollo.MutationFunction<SoftRemoveEngineeringJudgementMutation, SoftRemoveEngineeringJudgementMutationVariables>;

/**
 * __useSoftRemoveEngineeringJudgementMutation__
 *
 * To run a mutation, you first call `useSoftRemoveEngineeringJudgementMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSoftRemoveEngineeringJudgementMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [softRemoveEngineeringJudgementMutation, { data, loading, error }] = useSoftRemoveEngineeringJudgementMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSoftRemoveEngineeringJudgementMutation(baseOptions?: Apollo.MutationHookOptions<SoftRemoveEngineeringJudgementMutation, SoftRemoveEngineeringJudgementMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SoftRemoveEngineeringJudgementMutation, SoftRemoveEngineeringJudgementMutationVariables>(SoftRemoveEngineeringJudgementDocument, options);
      }
export type SoftRemoveEngineeringJudgementMutationHookResult = ReturnType<typeof useSoftRemoveEngineeringJudgementMutation>;
export type SoftRemoveEngineeringJudgementMutationResult = Apollo.MutationResult<SoftRemoveEngineeringJudgementMutation>;
export type SoftRemoveEngineeringJudgementMutationOptions = Apollo.BaseMutationOptions<SoftRemoveEngineeringJudgementMutation, SoftRemoveEngineeringJudgementMutationVariables>;
export const RestoreEngineeringJudgementDocument = gql`
    mutation RestoreEngineeringJudgement($id: String!) {
  restoreEngineeringJudgement(id: $id) {
    judgement {
      formattedNumber
    }
  }
}
    `;
export type RestoreEngineeringJudgementMutationFn = Apollo.MutationFunction<RestoreEngineeringJudgementMutation, RestoreEngineeringJudgementMutationVariables>;

/**
 * __useRestoreEngineeringJudgementMutation__
 *
 * To run a mutation, you first call `useRestoreEngineeringJudgementMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRestoreEngineeringJudgementMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [restoreEngineeringJudgementMutation, { data, loading, error }] = useRestoreEngineeringJudgementMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRestoreEngineeringJudgementMutation(baseOptions?: Apollo.MutationHookOptions<RestoreEngineeringJudgementMutation, RestoreEngineeringJudgementMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RestoreEngineeringJudgementMutation, RestoreEngineeringJudgementMutationVariables>(RestoreEngineeringJudgementDocument, options);
      }
export type RestoreEngineeringJudgementMutationHookResult = ReturnType<typeof useRestoreEngineeringJudgementMutation>;
export type RestoreEngineeringJudgementMutationResult = Apollo.MutationResult<RestoreEngineeringJudgementMutation>;
export type RestoreEngineeringJudgementMutationOptions = Apollo.BaseMutationOptions<RestoreEngineeringJudgementMutation, RestoreEngineeringJudgementMutationVariables>;
export const EjNotificationsDocument = gql`
    query EJNotifications($projectId: String!) {
  project(globalId: $projectId) {
    ejNotifications(ejNotificationFieldInput: {projectId: {equals: $projectId}}) {
      notificationEventId
      recipients {
        every {
          ...EJNotificationRecipients
        }
      }
    }
  }
}
    ${EjNotificationRecipientsFragmentDoc}`;

/**
 * __useEjNotificationsQuery__
 *
 * To run a query within a React component, call `useEjNotificationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useEjNotificationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEjNotificationsQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useEjNotificationsQuery(baseOptions: Apollo.QueryHookOptions<EjNotificationsQuery, EjNotificationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EjNotificationsQuery, EjNotificationsQueryVariables>(EjNotificationsDocument, options);
      }
export function useEjNotificationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EjNotificationsQuery, EjNotificationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EjNotificationsQuery, EjNotificationsQueryVariables>(EjNotificationsDocument, options);
        }
export type EjNotificationsQueryHookResult = ReturnType<typeof useEjNotificationsQuery>;
export type EjNotificationsLazyQueryHookResult = ReturnType<typeof useEjNotificationsLazyQuery>;
export type EjNotificationsQueryResult = Apollo.QueryResult<EjNotificationsQuery, EjNotificationsQueryVariables>;
export const EditEjNotificationDocument = gql`
    mutation EditEJNotification($input: EditEJNotificationInput!) {
  editEJNotification(editEJNotificationInput: $input) {
    notification {
      notificationEvent
    }
  }
}
    `;
export type EditEjNotificationMutationFn = Apollo.MutationFunction<EditEjNotificationMutation, EditEjNotificationMutationVariables>;

/**
 * __useEditEjNotificationMutation__
 *
 * To run a mutation, you first call `useEditEjNotificationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditEjNotificationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editEjNotificationMutation, { data, loading, error }] = useEditEjNotificationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEditEjNotificationMutation(baseOptions?: Apollo.MutationHookOptions<EditEjNotificationMutation, EditEjNotificationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditEjNotificationMutation, EditEjNotificationMutationVariables>(EditEjNotificationDocument, options);
      }
export type EditEjNotificationMutationHookResult = ReturnType<typeof useEditEjNotificationMutation>;
export type EditEjNotificationMutationResult = Apollo.MutationResult<EditEjNotificationMutation>;
export type EditEjNotificationMutationOptions = Apollo.BaseMutationOptions<EditEjNotificationMutation, EditEjNotificationMutationVariables>;
export const CreateEjQuickLinkDocument = gql`
    mutation CreateEJQuickLink($input: CreateEJQuickLinkInput!) {
  createEJQuickLink(createEJQuickLinkInput: $input) {
    ejQuickLink {
      label
    }
  }
}
    `;
export type CreateEjQuickLinkMutationFn = Apollo.MutationFunction<CreateEjQuickLinkMutation, CreateEjQuickLinkMutationVariables>;

/**
 * __useCreateEjQuickLinkMutation__
 *
 * To run a mutation, you first call `useCreateEjQuickLinkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateEjQuickLinkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createEjQuickLinkMutation, { data, loading, error }] = useCreateEjQuickLinkMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateEjQuickLinkMutation(baseOptions?: Apollo.MutationHookOptions<CreateEjQuickLinkMutation, CreateEjQuickLinkMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateEjQuickLinkMutation, CreateEjQuickLinkMutationVariables>(CreateEjQuickLinkDocument, options);
      }
export type CreateEjQuickLinkMutationHookResult = ReturnType<typeof useCreateEjQuickLinkMutation>;
export type CreateEjQuickLinkMutationResult = Apollo.MutationResult<CreateEjQuickLinkMutation>;
export type CreateEjQuickLinkMutationOptions = Apollo.BaseMutationOptions<CreateEjQuickLinkMutation, CreateEjQuickLinkMutationVariables>;
export const EditEjQuickLinkDocument = gql`
    mutation EditEJQuickLink($input: EditEJQuickLinkInput!) {
  editEJQuickLink(editEJQuickLinkInput: $input) {
    ejQuickLink {
      label
    }
  }
}
    `;
export type EditEjQuickLinkMutationFn = Apollo.MutationFunction<EditEjQuickLinkMutation, EditEjQuickLinkMutationVariables>;

/**
 * __useEditEjQuickLinkMutation__
 *
 * To run a mutation, you first call `useEditEjQuickLinkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditEjQuickLinkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editEjQuickLinkMutation, { data, loading, error }] = useEditEjQuickLinkMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEditEjQuickLinkMutation(baseOptions?: Apollo.MutationHookOptions<EditEjQuickLinkMutation, EditEjQuickLinkMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditEjQuickLinkMutation, EditEjQuickLinkMutationVariables>(EditEjQuickLinkDocument, options);
      }
export type EditEjQuickLinkMutationHookResult = ReturnType<typeof useEditEjQuickLinkMutation>;
export type EditEjQuickLinkMutationResult = Apollo.MutationResult<EditEjQuickLinkMutation>;
export type EditEjQuickLinkMutationOptions = Apollo.BaseMutationOptions<EditEjQuickLinkMutation, EditEjQuickLinkMutationVariables>;
export const GetEjQuickLinksDocument = gql`
    query GetEJQuickLinks($input: EJQuickLinkListInput!) {
  ejQuickLinks(ejQuickLinkListInput: $input) {
    records {
      id
      label
      href
      description
      deleted
      deletedDate
      deletedUser
    }
  }
}
    `;

/**
 * __useGetEjQuickLinksQuery__
 *
 * To run a query within a React component, call `useGetEjQuickLinksQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEjQuickLinksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEjQuickLinksQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetEjQuickLinksQuery(baseOptions: Apollo.QueryHookOptions<GetEjQuickLinksQuery, GetEjQuickLinksQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEjQuickLinksQuery, GetEjQuickLinksQueryVariables>(GetEjQuickLinksDocument, options);
      }
export function useGetEjQuickLinksLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEjQuickLinksQuery, GetEjQuickLinksQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEjQuickLinksQuery, GetEjQuickLinksQueryVariables>(GetEjQuickLinksDocument, options);
        }
export type GetEjQuickLinksQueryHookResult = ReturnType<typeof useGetEjQuickLinksQuery>;
export type GetEjQuickLinksLazyQueryHookResult = ReturnType<typeof useGetEjQuickLinksLazyQuery>;
export type GetEjQuickLinksQueryResult = Apollo.QueryResult<GetEjQuickLinksQuery, GetEjQuickLinksQueryVariables>;
export const RestoreEjQuickLinkDocument = gql`
    mutation RestoreEJQuickLink($id: String!) {
  restoreEJQuickLink(id: $id) {
    ejQuickLink {
      label
    }
  }
}
    `;
export type RestoreEjQuickLinkMutationFn = Apollo.MutationFunction<RestoreEjQuickLinkMutation, RestoreEjQuickLinkMutationVariables>;

/**
 * __useRestoreEjQuickLinkMutation__
 *
 * To run a mutation, you first call `useRestoreEjQuickLinkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRestoreEjQuickLinkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [restoreEjQuickLinkMutation, { data, loading, error }] = useRestoreEjQuickLinkMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRestoreEjQuickLinkMutation(baseOptions?: Apollo.MutationHookOptions<RestoreEjQuickLinkMutation, RestoreEjQuickLinkMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RestoreEjQuickLinkMutation, RestoreEjQuickLinkMutationVariables>(RestoreEjQuickLinkDocument, options);
      }
export type RestoreEjQuickLinkMutationHookResult = ReturnType<typeof useRestoreEjQuickLinkMutation>;
export type RestoreEjQuickLinkMutationResult = Apollo.MutationResult<RestoreEjQuickLinkMutation>;
export type RestoreEjQuickLinkMutationOptions = Apollo.BaseMutationOptions<RestoreEjQuickLinkMutation, RestoreEjQuickLinkMutationVariables>;
export const SoftRemoveEjQuickLinkDocument = gql`
    mutation SoftRemoveEJQuickLink($id: String!) {
  softRemoveEJQuickLink(id: $id) {
    ejQuickLink {
      label
    }
  }
}
    `;
export type SoftRemoveEjQuickLinkMutationFn = Apollo.MutationFunction<SoftRemoveEjQuickLinkMutation, SoftRemoveEjQuickLinkMutationVariables>;

/**
 * __useSoftRemoveEjQuickLinkMutation__
 *
 * To run a mutation, you first call `useSoftRemoveEjQuickLinkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSoftRemoveEjQuickLinkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [softRemoveEjQuickLinkMutation, { data, loading, error }] = useSoftRemoveEjQuickLinkMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSoftRemoveEjQuickLinkMutation(baseOptions?: Apollo.MutationHookOptions<SoftRemoveEjQuickLinkMutation, SoftRemoveEjQuickLinkMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SoftRemoveEjQuickLinkMutation, SoftRemoveEjQuickLinkMutationVariables>(SoftRemoveEjQuickLinkDocument, options);
      }
export type SoftRemoveEjQuickLinkMutationHookResult = ReturnType<typeof useSoftRemoveEjQuickLinkMutation>;
export type SoftRemoveEjQuickLinkMutationResult = Apollo.MutationResult<SoftRemoveEjQuickLinkMutation>;
export type SoftRemoveEjQuickLinkMutationOptions = Apollo.BaseMutationOptions<SoftRemoveEjQuickLinkMutation, SoftRemoveEjQuickLinkMutationVariables>;
export const ConcretePlacementEjReportOptionsDocument = gql`
    query ConcretePlacementEJReportOptions($globalId: String!) {
  concretePlacements(
    concretePlacementListInput: {projectId: {equals: $globalId}, deleted: false}
  ) {
    records {
      globalId
      placementId
    }
  }
}
    `;

/**
 * __useConcretePlacementEjReportOptionsQuery__
 *
 * To run a query within a React component, call `useConcretePlacementEjReportOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useConcretePlacementEjReportOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useConcretePlacementEjReportOptionsQuery({
 *   variables: {
 *      globalId: // value for 'globalId'
 *   },
 * });
 */
export function useConcretePlacementEjReportOptionsQuery(baseOptions: Apollo.QueryHookOptions<ConcretePlacementEjReportOptionsQuery, ConcretePlacementEjReportOptionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ConcretePlacementEjReportOptionsQuery, ConcretePlacementEjReportOptionsQueryVariables>(ConcretePlacementEjReportOptionsDocument, options);
      }
export function useConcretePlacementEjReportOptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ConcretePlacementEjReportOptionsQuery, ConcretePlacementEjReportOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ConcretePlacementEjReportOptionsQuery, ConcretePlacementEjReportOptionsQueryVariables>(ConcretePlacementEjReportOptionsDocument, options);
        }
export type ConcretePlacementEjReportOptionsQueryHookResult = ReturnType<typeof useConcretePlacementEjReportOptionsQuery>;
export type ConcretePlacementEjReportOptionsLazyQueryHookResult = ReturnType<typeof useConcretePlacementEjReportOptionsLazyQuery>;
export type ConcretePlacementEjReportOptionsQueryResult = Apollo.QueryResult<ConcretePlacementEjReportOptionsQuery, ConcretePlacementEjReportOptionsQueryVariables>;
export const ConcreteTestEjReportOptionsDocument = gql`
    query ConcreteTestEJReportOptions($globalId: String!) {
  concreteTests(
    concreteTestListInput: {projectId: {equals: $globalId}, deleted: false}
  ) {
    records {
      globalId
      fieldNumber
    }
  }
}
    `;

/**
 * __useConcreteTestEjReportOptionsQuery__
 *
 * To run a query within a React component, call `useConcreteTestEjReportOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useConcreteTestEjReportOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useConcreteTestEjReportOptionsQuery({
 *   variables: {
 *      globalId: // value for 'globalId'
 *   },
 * });
 */
export function useConcreteTestEjReportOptionsQuery(baseOptions: Apollo.QueryHookOptions<ConcreteTestEjReportOptionsQuery, ConcreteTestEjReportOptionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ConcreteTestEjReportOptionsQuery, ConcreteTestEjReportOptionsQueryVariables>(ConcreteTestEjReportOptionsDocument, options);
      }
export function useConcreteTestEjReportOptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ConcreteTestEjReportOptionsQuery, ConcreteTestEjReportOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ConcreteTestEjReportOptionsQuery, ConcreteTestEjReportOptionsQueryVariables>(ConcreteTestEjReportOptionsDocument, options);
        }
export type ConcreteTestEjReportOptionsQueryHookResult = ReturnType<typeof useConcreteTestEjReportOptionsQuery>;
export type ConcreteTestEjReportOptionsLazyQueryHookResult = ReturnType<typeof useConcreteTestEjReportOptionsLazyQuery>;
export type ConcreteTestEjReportOptionsQueryResult = Apollo.QueryResult<ConcreteTestEjReportOptionsQuery, ConcreteTestEjReportOptionsQueryVariables>;
export const ControlPointEjReportOptionsDocument = gql`
    query ControlPointEJReportOptions($globalId: String!) {
  dailyInspectionControlPoints(
    dailyInspectionControlPointListInput: {projectId: {equals: $globalId}, deleted: false}
  ) {
    records {
      globalId
      controlPointId
    }
  }
}
    `;

/**
 * __useControlPointEjReportOptionsQuery__
 *
 * To run a query within a React component, call `useControlPointEjReportOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useControlPointEjReportOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useControlPointEjReportOptionsQuery({
 *   variables: {
 *      globalId: // value for 'globalId'
 *   },
 * });
 */
export function useControlPointEjReportOptionsQuery(baseOptions: Apollo.QueryHookOptions<ControlPointEjReportOptionsQuery, ControlPointEjReportOptionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ControlPointEjReportOptionsQuery, ControlPointEjReportOptionsQueryVariables>(ControlPointEjReportOptionsDocument, options);
      }
export function useControlPointEjReportOptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ControlPointEjReportOptionsQuery, ControlPointEjReportOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ControlPointEjReportOptionsQuery, ControlPointEjReportOptionsQueryVariables>(ControlPointEjReportOptionsDocument, options);
        }
export type ControlPointEjReportOptionsQueryHookResult = ReturnType<typeof useControlPointEjReportOptionsQuery>;
export type ControlPointEjReportOptionsLazyQueryHookResult = ReturnType<typeof useControlPointEjReportOptionsLazyQuery>;
export type ControlPointEjReportOptionsQueryResult = Apollo.QueryResult<ControlPointEjReportOptionsQuery, ControlPointEjReportOptionsQueryVariables>;
export const InspectionEjReportOptionsDocument = gql`
    query InspectionEJReportOptions($globalId: String!) {
  dailyInspectionInspections(
    dailyInspectionInspectionListInput: {projectId: {equals: $globalId}, deleted: false}
  ) {
    records {
      globalId
      inspectionId
    }
  }
}
    `;

/**
 * __useInspectionEjReportOptionsQuery__
 *
 * To run a query within a React component, call `useInspectionEjReportOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useInspectionEjReportOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInspectionEjReportOptionsQuery({
 *   variables: {
 *      globalId: // value for 'globalId'
 *   },
 * });
 */
export function useInspectionEjReportOptionsQuery(baseOptions: Apollo.QueryHookOptions<InspectionEjReportOptionsQuery, InspectionEjReportOptionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InspectionEjReportOptionsQuery, InspectionEjReportOptionsQueryVariables>(InspectionEjReportOptionsDocument, options);
      }
export function useInspectionEjReportOptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InspectionEjReportOptionsQuery, InspectionEjReportOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InspectionEjReportOptionsQuery, InspectionEjReportOptionsQueryVariables>(InspectionEjReportOptionsDocument, options);
        }
export type InspectionEjReportOptionsQueryHookResult = ReturnType<typeof useInspectionEjReportOptionsQuery>;
export type InspectionEjReportOptionsLazyQueryHookResult = ReturnType<typeof useInspectionEjReportOptionsLazyQuery>;
export type InspectionEjReportOptionsQueryResult = Apollo.QueryResult<InspectionEjReportOptionsQuery, InspectionEjReportOptionsQueryVariables>;
export const LotEjReportOptionsDocument = gql`
    query LotEJReportOptions($globalId: String!) {
  lots(lotListInput: {projectId: {equals: $globalId}, deleted: false}) {
    records {
      globalId
      lotId
    }
  }
}
    `;

/**
 * __useLotEjReportOptionsQuery__
 *
 * To run a query within a React component, call `useLotEjReportOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useLotEjReportOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLotEjReportOptionsQuery({
 *   variables: {
 *      globalId: // value for 'globalId'
 *   },
 * });
 */
export function useLotEjReportOptionsQuery(baseOptions: Apollo.QueryHookOptions<LotEjReportOptionsQuery, LotEjReportOptionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LotEjReportOptionsQuery, LotEjReportOptionsQueryVariables>(LotEjReportOptionsDocument, options);
      }
export function useLotEjReportOptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LotEjReportOptionsQuery, LotEjReportOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LotEjReportOptionsQuery, LotEjReportOptionsQueryVariables>(LotEjReportOptionsDocument, options);
        }
export type LotEjReportOptionsQueryHookResult = ReturnType<typeof useLotEjReportOptionsQuery>;
export type LotEjReportOptionsLazyQueryHookResult = ReturnType<typeof useLotEjReportOptionsLazyQuery>;
export type LotEjReportOptionsQueryResult = Apollo.QueryResult<LotEjReportOptionsQuery, LotEjReportOptionsQueryVariables>;
export const CreateEjTypeDocument = gql`
    mutation CreateEJType($input: CreateEJTypeInput!) {
  createEJType(createEJTypeInput: $input) {
    type {
      name
    }
  }
}
    `;
export type CreateEjTypeMutationFn = Apollo.MutationFunction<CreateEjTypeMutation, CreateEjTypeMutationVariables>;

/**
 * __useCreateEjTypeMutation__
 *
 * To run a mutation, you first call `useCreateEjTypeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateEjTypeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createEjTypeMutation, { data, loading, error }] = useCreateEjTypeMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateEjTypeMutation(baseOptions?: Apollo.MutationHookOptions<CreateEjTypeMutation, CreateEjTypeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateEjTypeMutation, CreateEjTypeMutationVariables>(CreateEjTypeDocument, options);
      }
export type CreateEjTypeMutationHookResult = ReturnType<typeof useCreateEjTypeMutation>;
export type CreateEjTypeMutationResult = Apollo.MutationResult<CreateEjTypeMutation>;
export type CreateEjTypeMutationOptions = Apollo.BaseMutationOptions<CreateEjTypeMutation, CreateEjTypeMutationVariables>;
export const EditEjTypeDocument = gql`
    mutation EditEJType($input: EditEJTypeInput!) {
  editEJType(editEJTypeInput: $input) {
    type {
      name
    }
  }
}
    `;
export type EditEjTypeMutationFn = Apollo.MutationFunction<EditEjTypeMutation, EditEjTypeMutationVariables>;

/**
 * __useEditEjTypeMutation__
 *
 * To run a mutation, you first call `useEditEjTypeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditEjTypeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editEjTypeMutation, { data, loading, error }] = useEditEjTypeMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEditEjTypeMutation(baseOptions?: Apollo.MutationHookOptions<EditEjTypeMutation, EditEjTypeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditEjTypeMutation, EditEjTypeMutationVariables>(EditEjTypeDocument, options);
      }
export type EditEjTypeMutationHookResult = ReturnType<typeof useEditEjTypeMutation>;
export type EditEjTypeMutationResult = Apollo.MutationResult<EditEjTypeMutation>;
export type EditEjTypeMutationOptions = Apollo.BaseMutationOptions<EditEjTypeMutation, EditEjTypeMutationVariables>;
export const SoftRemoveEjTypeDocument = gql`
    mutation SoftRemoveEJType($id: String!) {
  softRemoveEJType(id: $id) {
    type {
      name
    }
  }
}
    `;
export type SoftRemoveEjTypeMutationFn = Apollo.MutationFunction<SoftRemoveEjTypeMutation, SoftRemoveEjTypeMutationVariables>;

/**
 * __useSoftRemoveEjTypeMutation__
 *
 * To run a mutation, you first call `useSoftRemoveEjTypeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSoftRemoveEjTypeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [softRemoveEjTypeMutation, { data, loading, error }] = useSoftRemoveEjTypeMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSoftRemoveEjTypeMutation(baseOptions?: Apollo.MutationHookOptions<SoftRemoveEjTypeMutation, SoftRemoveEjTypeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SoftRemoveEjTypeMutation, SoftRemoveEjTypeMutationVariables>(SoftRemoveEjTypeDocument, options);
      }
export type SoftRemoveEjTypeMutationHookResult = ReturnType<typeof useSoftRemoveEjTypeMutation>;
export type SoftRemoveEjTypeMutationResult = Apollo.MutationResult<SoftRemoveEjTypeMutation>;
export type SoftRemoveEjTypeMutationOptions = Apollo.BaseMutationOptions<SoftRemoveEjTypeMutation, SoftRemoveEjTypeMutationVariables>;
export const RestoreEjTypeDocument = gql`
    mutation RestoreEJType($id: String!) {
  restoreEJType(id: $id) {
    type {
      name
    }
  }
}
    `;
export type RestoreEjTypeMutationFn = Apollo.MutationFunction<RestoreEjTypeMutation, RestoreEjTypeMutationVariables>;

/**
 * __useRestoreEjTypeMutation__
 *
 * To run a mutation, you first call `useRestoreEjTypeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRestoreEjTypeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [restoreEjTypeMutation, { data, loading, error }] = useRestoreEjTypeMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRestoreEjTypeMutation(baseOptions?: Apollo.MutationHookOptions<RestoreEjTypeMutation, RestoreEjTypeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RestoreEjTypeMutation, RestoreEjTypeMutationVariables>(RestoreEjTypeDocument, options);
      }
export type RestoreEjTypeMutationHookResult = ReturnType<typeof useRestoreEjTypeMutation>;
export type RestoreEjTypeMutationResult = Apollo.MutationResult<RestoreEjTypeMutation>;
export type RestoreEjTypeMutationOptions = Apollo.BaseMutationOptions<RestoreEjTypeMutation, RestoreEjTypeMutationVariables>;
export const GetEjTypesDocument = gql`
    query GetEJTypes($ejTypeListInput: EJTypeListInput!) {
  ejTypes(ejTypeListInput: $ejTypeListInput) {
    records {
      id
      name
      deleted
      deletedDate
      deletedUser
      allowanceDescription
      reportTypeId
      users {
        id
        displayName
        mail
        deleted
        userGroups {
          id
        }
      }
      judgements {
        id
        deleted
        formattedNumber
      }
    }
  }
}
    `;

/**
 * __useGetEjTypesQuery__
 *
 * To run a query within a React component, call `useGetEjTypesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEjTypesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEjTypesQuery({
 *   variables: {
 *      ejTypeListInput: // value for 'ejTypeListInput'
 *   },
 * });
 */
export function useGetEjTypesQuery(baseOptions: Apollo.QueryHookOptions<GetEjTypesQuery, GetEjTypesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEjTypesQuery, GetEjTypesQueryVariables>(GetEjTypesDocument, options);
      }
export function useGetEjTypesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEjTypesQuery, GetEjTypesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEjTypesQuery, GetEjTypesQueryVariables>(GetEjTypesDocument, options);
        }
export type GetEjTypesQueryHookResult = ReturnType<typeof useGetEjTypesQuery>;
export type GetEjTypesLazyQueryHookResult = ReturnType<typeof useGetEjTypesLazyQuery>;
export type GetEjTypesQueryResult = Apollo.QueryResult<GetEjTypesQuery, GetEjTypesQueryVariables>;
export const CreateFdcApprovalGroupDocument = gql`
    mutation CreateFDCApprovalGroup($createFdcApprovalGroupInput: CreateFDCApprovalGroupInput!) {
  createFDCApprovalGroup(
    createFDCApprovalGroupInput: $createFdcApprovalGroupInput
  ) {
    approvalGroup {
      name
    }
  }
}
    `;
export type CreateFdcApprovalGroupMutationFn = Apollo.MutationFunction<CreateFdcApprovalGroupMutation, CreateFdcApprovalGroupMutationVariables>;

/**
 * __useCreateFdcApprovalGroupMutation__
 *
 * To run a mutation, you first call `useCreateFdcApprovalGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateFdcApprovalGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createFdcApprovalGroupMutation, { data, loading, error }] = useCreateFdcApprovalGroupMutation({
 *   variables: {
 *      createFdcApprovalGroupInput: // value for 'createFdcApprovalGroupInput'
 *   },
 * });
 */
export function useCreateFdcApprovalGroupMutation(baseOptions?: Apollo.MutationHookOptions<CreateFdcApprovalGroupMutation, CreateFdcApprovalGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateFdcApprovalGroupMutation, CreateFdcApprovalGroupMutationVariables>(CreateFdcApprovalGroupDocument, options);
      }
export type CreateFdcApprovalGroupMutationHookResult = ReturnType<typeof useCreateFdcApprovalGroupMutation>;
export type CreateFdcApprovalGroupMutationResult = Apollo.MutationResult<CreateFdcApprovalGroupMutation>;
export type CreateFdcApprovalGroupMutationOptions = Apollo.BaseMutationOptions<CreateFdcApprovalGroupMutation, CreateFdcApprovalGroupMutationVariables>;
export const EditFdcApprovalGroupDocument = gql`
    mutation EditFDCApprovalGroup($editFdcApprovalGroupInput: EditFDCApprovalGroupInput!) {
  editFDCApprovalGroup(editFDCApprovalGroupInput: $editFdcApprovalGroupInput) {
    approvalGroup {
      name
    }
  }
}
    `;
export type EditFdcApprovalGroupMutationFn = Apollo.MutationFunction<EditFdcApprovalGroupMutation, EditFdcApprovalGroupMutationVariables>;

/**
 * __useEditFdcApprovalGroupMutation__
 *
 * To run a mutation, you first call `useEditFdcApprovalGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditFdcApprovalGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editFdcApprovalGroupMutation, { data, loading, error }] = useEditFdcApprovalGroupMutation({
 *   variables: {
 *      editFdcApprovalGroupInput: // value for 'editFdcApprovalGroupInput'
 *   },
 * });
 */
export function useEditFdcApprovalGroupMutation(baseOptions?: Apollo.MutationHookOptions<EditFdcApprovalGroupMutation, EditFdcApprovalGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditFdcApprovalGroupMutation, EditFdcApprovalGroupMutationVariables>(EditFdcApprovalGroupDocument, options);
      }
export type EditFdcApprovalGroupMutationHookResult = ReturnType<typeof useEditFdcApprovalGroupMutation>;
export type EditFdcApprovalGroupMutationResult = Apollo.MutationResult<EditFdcApprovalGroupMutation>;
export type EditFdcApprovalGroupMutationOptions = Apollo.BaseMutationOptions<EditFdcApprovalGroupMutation, EditFdcApprovalGroupMutationVariables>;
export const ProjectFdcApprovalGroupsDocument = gql`
    query ProjectFDCApprovalGroups($globalId: String!, $input: FDCApprovalGroupFieldInput!) {
  project(globalId: $globalId) {
    fdcApprovalGroups(fdcApprovalGroupFieldInput: $input) {
      id
      name
      description
      deleted
      deletedDate
      deletedUser
      concurrenceLevels(fdcConcurrenceLevelFieldInput: {deleted: false}) {
        id
        name
        description
      }
      roles(roleFieldInput: {deleted: false}) {
        id
        name
        users {
          ...FDCApprovalGroupUser
        }
      }
      users(userFieldInput: {deleted: false}) {
        ...FDCApprovalGroupUser
      }
      fdcToFDCApprovalGroups {
        fieldDesignChange {
          id
          formattedNumber
          deleted
        }
      }
    }
    fdcConcurrenceLevels(fdcConcurrenceLevelFieldInput: {deleted: false}) {
      id
      name
      description
    }
  }
}
    ${FdcApprovalGroupUserFragmentDoc}`;

/**
 * __useProjectFdcApprovalGroupsQuery__
 *
 * To run a query within a React component, call `useProjectFdcApprovalGroupsQuery` and pass it any options that fit your needs.
 * When your component renders, `useProjectFdcApprovalGroupsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProjectFdcApprovalGroupsQuery({
 *   variables: {
 *      globalId: // value for 'globalId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useProjectFdcApprovalGroupsQuery(baseOptions: Apollo.QueryHookOptions<ProjectFdcApprovalGroupsQuery, ProjectFdcApprovalGroupsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProjectFdcApprovalGroupsQuery, ProjectFdcApprovalGroupsQueryVariables>(ProjectFdcApprovalGroupsDocument, options);
      }
export function useProjectFdcApprovalGroupsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProjectFdcApprovalGroupsQuery, ProjectFdcApprovalGroupsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProjectFdcApprovalGroupsQuery, ProjectFdcApprovalGroupsQueryVariables>(ProjectFdcApprovalGroupsDocument, options);
        }
export type ProjectFdcApprovalGroupsQueryHookResult = ReturnType<typeof useProjectFdcApprovalGroupsQuery>;
export type ProjectFdcApprovalGroupsLazyQueryHookResult = ReturnType<typeof useProjectFdcApprovalGroupsLazyQuery>;
export type ProjectFdcApprovalGroupsQueryResult = Apollo.QueryResult<ProjectFdcApprovalGroupsQuery, ProjectFdcApprovalGroupsQueryVariables>;
export const RestoreFdcApprovalGroupDocument = gql`
    mutation RestoreFDCApprovalGroup($id: String!) {
  restoreFDCApprovalGroup(id: $id) {
    approvalGroup {
      name
    }
  }
}
    `;
export type RestoreFdcApprovalGroupMutationFn = Apollo.MutationFunction<RestoreFdcApprovalGroupMutation, RestoreFdcApprovalGroupMutationVariables>;

/**
 * __useRestoreFdcApprovalGroupMutation__
 *
 * To run a mutation, you first call `useRestoreFdcApprovalGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRestoreFdcApprovalGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [restoreFdcApprovalGroupMutation, { data, loading, error }] = useRestoreFdcApprovalGroupMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRestoreFdcApprovalGroupMutation(baseOptions?: Apollo.MutationHookOptions<RestoreFdcApprovalGroupMutation, RestoreFdcApprovalGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RestoreFdcApprovalGroupMutation, RestoreFdcApprovalGroupMutationVariables>(RestoreFdcApprovalGroupDocument, options);
      }
export type RestoreFdcApprovalGroupMutationHookResult = ReturnType<typeof useRestoreFdcApprovalGroupMutation>;
export type RestoreFdcApprovalGroupMutationResult = Apollo.MutationResult<RestoreFdcApprovalGroupMutation>;
export type RestoreFdcApprovalGroupMutationOptions = Apollo.BaseMutationOptions<RestoreFdcApprovalGroupMutation, RestoreFdcApprovalGroupMutationVariables>;
export const SoftRemoveFdcApprovalGroupDocument = gql`
    mutation SoftRemoveFDCApprovalGroup($id: String!) {
  softRemoveFDCApprovalGroup(id: $id) {
    approvalGroup {
      name
    }
  }
}
    `;
export type SoftRemoveFdcApprovalGroupMutationFn = Apollo.MutationFunction<SoftRemoveFdcApprovalGroupMutation, SoftRemoveFdcApprovalGroupMutationVariables>;

/**
 * __useSoftRemoveFdcApprovalGroupMutation__
 *
 * To run a mutation, you first call `useSoftRemoveFdcApprovalGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSoftRemoveFdcApprovalGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [softRemoveFdcApprovalGroupMutation, { data, loading, error }] = useSoftRemoveFdcApprovalGroupMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSoftRemoveFdcApprovalGroupMutation(baseOptions?: Apollo.MutationHookOptions<SoftRemoveFdcApprovalGroupMutation, SoftRemoveFdcApprovalGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SoftRemoveFdcApprovalGroupMutation, SoftRemoveFdcApprovalGroupMutationVariables>(SoftRemoveFdcApprovalGroupDocument, options);
      }
export type SoftRemoveFdcApprovalGroupMutationHookResult = ReturnType<typeof useSoftRemoveFdcApprovalGroupMutation>;
export type SoftRemoveFdcApprovalGroupMutationResult = Apollo.MutationResult<SoftRemoveFdcApprovalGroupMutation>;
export type SoftRemoveFdcApprovalGroupMutationOptions = Apollo.BaseMutationOptions<SoftRemoveFdcApprovalGroupMutation, SoftRemoveFdcApprovalGroupMutationVariables>;
export const RestoreFdcConcurrenceGroupDocument = gql`
    mutation RestoreFDCConcurrenceGroup($id: String!) {
  restoreFDCConcurrenceGroup(id: $id) {
    concurrenceGroup {
      name
    }
  }
}
    `;
export type RestoreFdcConcurrenceGroupMutationFn = Apollo.MutationFunction<RestoreFdcConcurrenceGroupMutation, RestoreFdcConcurrenceGroupMutationVariables>;

/**
 * __useRestoreFdcConcurrenceGroupMutation__
 *
 * To run a mutation, you first call `useRestoreFdcConcurrenceGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRestoreFdcConcurrenceGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [restoreFdcConcurrenceGroupMutation, { data, loading, error }] = useRestoreFdcConcurrenceGroupMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRestoreFdcConcurrenceGroupMutation(baseOptions?: Apollo.MutationHookOptions<RestoreFdcConcurrenceGroupMutation, RestoreFdcConcurrenceGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RestoreFdcConcurrenceGroupMutation, RestoreFdcConcurrenceGroupMutationVariables>(RestoreFdcConcurrenceGroupDocument, options);
      }
export type RestoreFdcConcurrenceGroupMutationHookResult = ReturnType<typeof useRestoreFdcConcurrenceGroupMutation>;
export type RestoreFdcConcurrenceGroupMutationResult = Apollo.MutationResult<RestoreFdcConcurrenceGroupMutation>;
export type RestoreFdcConcurrenceGroupMutationOptions = Apollo.BaseMutationOptions<RestoreFdcConcurrenceGroupMutation, RestoreFdcConcurrenceGroupMutationVariables>;
export const CreateFdcConcurrenceGroupDocument = gql`
    mutation CreateFDCConcurrenceGroup($createFdcConcurrenceGroupInput: CreateFDCConcurrenceGroupInput!) {
  createFDCConcurrenceGroup(
    createFDCConcurrenceGroupInput: $createFdcConcurrenceGroupInput
  ) {
    concurrenceGroup {
      name
    }
  }
}
    `;
export type CreateFdcConcurrenceGroupMutationFn = Apollo.MutationFunction<CreateFdcConcurrenceGroupMutation, CreateFdcConcurrenceGroupMutationVariables>;

/**
 * __useCreateFdcConcurrenceGroupMutation__
 *
 * To run a mutation, you first call `useCreateFdcConcurrenceGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateFdcConcurrenceGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createFdcConcurrenceGroupMutation, { data, loading, error }] = useCreateFdcConcurrenceGroupMutation({
 *   variables: {
 *      createFdcConcurrenceGroupInput: // value for 'createFdcConcurrenceGroupInput'
 *   },
 * });
 */
export function useCreateFdcConcurrenceGroupMutation(baseOptions?: Apollo.MutationHookOptions<CreateFdcConcurrenceGroupMutation, CreateFdcConcurrenceGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateFdcConcurrenceGroupMutation, CreateFdcConcurrenceGroupMutationVariables>(CreateFdcConcurrenceGroupDocument, options);
      }
export type CreateFdcConcurrenceGroupMutationHookResult = ReturnType<typeof useCreateFdcConcurrenceGroupMutation>;
export type CreateFdcConcurrenceGroupMutationResult = Apollo.MutationResult<CreateFdcConcurrenceGroupMutation>;
export type CreateFdcConcurrenceGroupMutationOptions = Apollo.BaseMutationOptions<CreateFdcConcurrenceGroupMutation, CreateFdcConcurrenceGroupMutationVariables>;
export const EditFdcConcurrenceGroupDocument = gql`
    mutation EditFDCConcurrenceGroup($editFdcConcurrenceGroupInput: EditFDCConcurrenceGroupInput!) {
  editFDCConcurrenceGroup(
    editFDCConcurrenceGroupInput: $editFdcConcurrenceGroupInput
  ) {
    concurrenceGroup {
      name
    }
  }
}
    `;
export type EditFdcConcurrenceGroupMutationFn = Apollo.MutationFunction<EditFdcConcurrenceGroupMutation, EditFdcConcurrenceGroupMutationVariables>;

/**
 * __useEditFdcConcurrenceGroupMutation__
 *
 * To run a mutation, you first call `useEditFdcConcurrenceGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditFdcConcurrenceGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editFdcConcurrenceGroupMutation, { data, loading, error }] = useEditFdcConcurrenceGroupMutation({
 *   variables: {
 *      editFdcConcurrenceGroupInput: // value for 'editFdcConcurrenceGroupInput'
 *   },
 * });
 */
export function useEditFdcConcurrenceGroupMutation(baseOptions?: Apollo.MutationHookOptions<EditFdcConcurrenceGroupMutation, EditFdcConcurrenceGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditFdcConcurrenceGroupMutation, EditFdcConcurrenceGroupMutationVariables>(EditFdcConcurrenceGroupDocument, options);
      }
export type EditFdcConcurrenceGroupMutationHookResult = ReturnType<typeof useEditFdcConcurrenceGroupMutation>;
export type EditFdcConcurrenceGroupMutationResult = Apollo.MutationResult<EditFdcConcurrenceGroupMutation>;
export type EditFdcConcurrenceGroupMutationOptions = Apollo.BaseMutationOptions<EditFdcConcurrenceGroupMutation, EditFdcConcurrenceGroupMutationVariables>;
export const ProjectFdcConcurrenceGroupsDocument = gql`
    query ProjectFDCConcurrenceGroups($globalId: String!, $input: FDCConcurrenceGroupFieldInput) {
  project(globalId: $globalId) {
    fdcConcurrenceGroups(fdcConcurrenceGroupFieldInput: $input) {
      id
      name
      description
      deleted
      deletedDate
      deletedUser
      description
      roles(roleFieldInput: {deleted: false}) {
        id
        name
        users {
          ...FDCConcurrenceGroupUser
        }
      }
      users(userFieldInput: {deleted: false}) {
        ...FDCConcurrenceGroupUser
      }
      fdcToFDCConcurrenceGroups {
        fieldDesignChange {
          id
          formattedNumber
          deleted
        }
      }
    }
  }
}
    ${FdcConcurrenceGroupUserFragmentDoc}`;

/**
 * __useProjectFdcConcurrenceGroupsQuery__
 *
 * To run a query within a React component, call `useProjectFdcConcurrenceGroupsQuery` and pass it any options that fit your needs.
 * When your component renders, `useProjectFdcConcurrenceGroupsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProjectFdcConcurrenceGroupsQuery({
 *   variables: {
 *      globalId: // value for 'globalId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useProjectFdcConcurrenceGroupsQuery(baseOptions: Apollo.QueryHookOptions<ProjectFdcConcurrenceGroupsQuery, ProjectFdcConcurrenceGroupsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProjectFdcConcurrenceGroupsQuery, ProjectFdcConcurrenceGroupsQueryVariables>(ProjectFdcConcurrenceGroupsDocument, options);
      }
export function useProjectFdcConcurrenceGroupsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProjectFdcConcurrenceGroupsQuery, ProjectFdcConcurrenceGroupsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProjectFdcConcurrenceGroupsQuery, ProjectFdcConcurrenceGroupsQueryVariables>(ProjectFdcConcurrenceGroupsDocument, options);
        }
export type ProjectFdcConcurrenceGroupsQueryHookResult = ReturnType<typeof useProjectFdcConcurrenceGroupsQuery>;
export type ProjectFdcConcurrenceGroupsLazyQueryHookResult = ReturnType<typeof useProjectFdcConcurrenceGroupsLazyQuery>;
export type ProjectFdcConcurrenceGroupsQueryResult = Apollo.QueryResult<ProjectFdcConcurrenceGroupsQuery, ProjectFdcConcurrenceGroupsQueryVariables>;
export const SoftRemoveFdcConcurrenceGroupDocument = gql`
    mutation SoftRemoveFDCConcurrenceGroup($id: String!) {
  softRemoveFDCConcurrenceGroup(id: $id) {
    concurrenceGroup {
      name
    }
  }
}
    `;
export type SoftRemoveFdcConcurrenceGroupMutationFn = Apollo.MutationFunction<SoftRemoveFdcConcurrenceGroupMutation, SoftRemoveFdcConcurrenceGroupMutationVariables>;

/**
 * __useSoftRemoveFdcConcurrenceGroupMutation__
 *
 * To run a mutation, you first call `useSoftRemoveFdcConcurrenceGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSoftRemoveFdcConcurrenceGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [softRemoveFdcConcurrenceGroupMutation, { data, loading, error }] = useSoftRemoveFdcConcurrenceGroupMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSoftRemoveFdcConcurrenceGroupMutation(baseOptions?: Apollo.MutationHookOptions<SoftRemoveFdcConcurrenceGroupMutation, SoftRemoveFdcConcurrenceGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SoftRemoveFdcConcurrenceGroupMutation, SoftRemoveFdcConcurrenceGroupMutationVariables>(SoftRemoveFdcConcurrenceGroupDocument, options);
      }
export type SoftRemoveFdcConcurrenceGroupMutationHookResult = ReturnType<typeof useSoftRemoveFdcConcurrenceGroupMutation>;
export type SoftRemoveFdcConcurrenceGroupMutationResult = Apollo.MutationResult<SoftRemoveFdcConcurrenceGroupMutation>;
export type SoftRemoveFdcConcurrenceGroupMutationOptions = Apollo.BaseMutationOptions<SoftRemoveFdcConcurrenceGroupMutation, SoftRemoveFdcConcurrenceGroupMutationVariables>;
export const CreateFdcConcurrenceLevelDocument = gql`
    mutation CreateFDCConcurrenceLevel($createFdcConcurrenceLevelInput: CreateFDCConcurrenceLevelInput!) {
  createFDCConcurrenceLevel(
    createFDCConcurrenceLevelInput: $createFdcConcurrenceLevelInput
  ) {
    concurrenceLevel {
      name
    }
  }
}
    `;
export type CreateFdcConcurrenceLevelMutationFn = Apollo.MutationFunction<CreateFdcConcurrenceLevelMutation, CreateFdcConcurrenceLevelMutationVariables>;

/**
 * __useCreateFdcConcurrenceLevelMutation__
 *
 * To run a mutation, you first call `useCreateFdcConcurrenceLevelMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateFdcConcurrenceLevelMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createFdcConcurrenceLevelMutation, { data, loading, error }] = useCreateFdcConcurrenceLevelMutation({
 *   variables: {
 *      createFdcConcurrenceLevelInput: // value for 'createFdcConcurrenceLevelInput'
 *   },
 * });
 */
export function useCreateFdcConcurrenceLevelMutation(baseOptions?: Apollo.MutationHookOptions<CreateFdcConcurrenceLevelMutation, CreateFdcConcurrenceLevelMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateFdcConcurrenceLevelMutation, CreateFdcConcurrenceLevelMutationVariables>(CreateFdcConcurrenceLevelDocument, options);
      }
export type CreateFdcConcurrenceLevelMutationHookResult = ReturnType<typeof useCreateFdcConcurrenceLevelMutation>;
export type CreateFdcConcurrenceLevelMutationResult = Apollo.MutationResult<CreateFdcConcurrenceLevelMutation>;
export type CreateFdcConcurrenceLevelMutationOptions = Apollo.BaseMutationOptions<CreateFdcConcurrenceLevelMutation, CreateFdcConcurrenceLevelMutationVariables>;
export const EditFdcConcurrenceLevelDocument = gql`
    mutation EditFDCConcurrenceLevel($editFdcConcurrenceLevelInput: EditFDCConcurrenceLevelInput!) {
  editFDCConcurrenceLevel(
    editFDCConcurrenceLevelInput: $editFdcConcurrenceLevelInput
  ) {
    concurrenceLevel {
      name
    }
  }
}
    `;
export type EditFdcConcurrenceLevelMutationFn = Apollo.MutationFunction<EditFdcConcurrenceLevelMutation, EditFdcConcurrenceLevelMutationVariables>;

/**
 * __useEditFdcConcurrenceLevelMutation__
 *
 * To run a mutation, you first call `useEditFdcConcurrenceLevelMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditFdcConcurrenceLevelMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editFdcConcurrenceLevelMutation, { data, loading, error }] = useEditFdcConcurrenceLevelMutation({
 *   variables: {
 *      editFdcConcurrenceLevelInput: // value for 'editFdcConcurrenceLevelInput'
 *   },
 * });
 */
export function useEditFdcConcurrenceLevelMutation(baseOptions?: Apollo.MutationHookOptions<EditFdcConcurrenceLevelMutation, EditFdcConcurrenceLevelMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditFdcConcurrenceLevelMutation, EditFdcConcurrenceLevelMutationVariables>(EditFdcConcurrenceLevelDocument, options);
      }
export type EditFdcConcurrenceLevelMutationHookResult = ReturnType<typeof useEditFdcConcurrenceLevelMutation>;
export type EditFdcConcurrenceLevelMutationResult = Apollo.MutationResult<EditFdcConcurrenceLevelMutation>;
export type EditFdcConcurrenceLevelMutationOptions = Apollo.BaseMutationOptions<EditFdcConcurrenceLevelMutation, EditFdcConcurrenceLevelMutationVariables>;
export const ProjectFdcConcurrenceLevelsDocument = gql`
    query ProjectFDCConcurrenceLevels($globalId: String!, $input: FDCConcurrenceLevelFieldInput) {
  project(globalId: $globalId) {
    fdcConcurrenceLevels(fdcConcurrenceLevelFieldInput: $input) {
      id
      name
      description
      description
      deleted
      deletedDate
      deletedUser
      sideEffectId
      approvalGroups(fdcApprovalGroupFieldInput: {deleted: false}) {
        id
        name
        description
      }
      fieldDesignChanges {
        id
        formattedNumber
        deleted
      }
    }
    fdcApprovalGroups(fdcApprovalGroupFieldInput: {deleted: false}) {
      name
      id
      description
    }
  }
}
    `;

/**
 * __useProjectFdcConcurrenceLevelsQuery__
 *
 * To run a query within a React component, call `useProjectFdcConcurrenceLevelsQuery` and pass it any options that fit your needs.
 * When your component renders, `useProjectFdcConcurrenceLevelsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProjectFdcConcurrenceLevelsQuery({
 *   variables: {
 *      globalId: // value for 'globalId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useProjectFdcConcurrenceLevelsQuery(baseOptions: Apollo.QueryHookOptions<ProjectFdcConcurrenceLevelsQuery, ProjectFdcConcurrenceLevelsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProjectFdcConcurrenceLevelsQuery, ProjectFdcConcurrenceLevelsQueryVariables>(ProjectFdcConcurrenceLevelsDocument, options);
      }
export function useProjectFdcConcurrenceLevelsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProjectFdcConcurrenceLevelsQuery, ProjectFdcConcurrenceLevelsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProjectFdcConcurrenceLevelsQuery, ProjectFdcConcurrenceLevelsQueryVariables>(ProjectFdcConcurrenceLevelsDocument, options);
        }
export type ProjectFdcConcurrenceLevelsQueryHookResult = ReturnType<typeof useProjectFdcConcurrenceLevelsQuery>;
export type ProjectFdcConcurrenceLevelsLazyQueryHookResult = ReturnType<typeof useProjectFdcConcurrenceLevelsLazyQuery>;
export type ProjectFdcConcurrenceLevelsQueryResult = Apollo.QueryResult<ProjectFdcConcurrenceLevelsQuery, ProjectFdcConcurrenceLevelsQueryVariables>;
export const RestoreFdcConcurrenceLevelDocument = gql`
    mutation RestoreFDCConcurrenceLevel($id: String!) {
  restoreFDCConcurrenceLevel(id: $id) {
    concurrenceLevel {
      name
    }
  }
}
    `;
export type RestoreFdcConcurrenceLevelMutationFn = Apollo.MutationFunction<RestoreFdcConcurrenceLevelMutation, RestoreFdcConcurrenceLevelMutationVariables>;

/**
 * __useRestoreFdcConcurrenceLevelMutation__
 *
 * To run a mutation, you first call `useRestoreFdcConcurrenceLevelMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRestoreFdcConcurrenceLevelMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [restoreFdcConcurrenceLevelMutation, { data, loading, error }] = useRestoreFdcConcurrenceLevelMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRestoreFdcConcurrenceLevelMutation(baseOptions?: Apollo.MutationHookOptions<RestoreFdcConcurrenceLevelMutation, RestoreFdcConcurrenceLevelMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RestoreFdcConcurrenceLevelMutation, RestoreFdcConcurrenceLevelMutationVariables>(RestoreFdcConcurrenceLevelDocument, options);
      }
export type RestoreFdcConcurrenceLevelMutationHookResult = ReturnType<typeof useRestoreFdcConcurrenceLevelMutation>;
export type RestoreFdcConcurrenceLevelMutationResult = Apollo.MutationResult<RestoreFdcConcurrenceLevelMutation>;
export type RestoreFdcConcurrenceLevelMutationOptions = Apollo.BaseMutationOptions<RestoreFdcConcurrenceLevelMutation, RestoreFdcConcurrenceLevelMutationVariables>;
export const SoftRemoveFdcConcurrenceLevelDocument = gql`
    mutation SoftRemoveFDCConcurrenceLevel($id: String!) {
  softRemoveFDCConcurrenceLevel(id: $id) {
    concurrenceLevel {
      name
    }
  }
}
    `;
export type SoftRemoveFdcConcurrenceLevelMutationFn = Apollo.MutationFunction<SoftRemoveFdcConcurrenceLevelMutation, SoftRemoveFdcConcurrenceLevelMutationVariables>;

/**
 * __useSoftRemoveFdcConcurrenceLevelMutation__
 *
 * To run a mutation, you first call `useSoftRemoveFdcConcurrenceLevelMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSoftRemoveFdcConcurrenceLevelMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [softRemoveFdcConcurrenceLevelMutation, { data, loading, error }] = useSoftRemoveFdcConcurrenceLevelMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSoftRemoveFdcConcurrenceLevelMutation(baseOptions?: Apollo.MutationHookOptions<SoftRemoveFdcConcurrenceLevelMutation, SoftRemoveFdcConcurrenceLevelMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SoftRemoveFdcConcurrenceLevelMutation, SoftRemoveFdcConcurrenceLevelMutationVariables>(SoftRemoveFdcConcurrenceLevelDocument, options);
      }
export type SoftRemoveFdcConcurrenceLevelMutationHookResult = ReturnType<typeof useSoftRemoveFdcConcurrenceLevelMutation>;
export type SoftRemoveFdcConcurrenceLevelMutationResult = Apollo.MutationResult<SoftRemoveFdcConcurrenceLevelMutation>;
export type SoftRemoveFdcConcurrenceLevelMutationOptions = Apollo.BaseMutationOptions<SoftRemoveFdcConcurrenceLevelMutation, SoftRemoveFdcConcurrenceLevelMutationVariables>;
export const CreateFdcDisciplineDocument = gql`
    mutation CreateFDCDiscipline($createFdcDisciplineInput: CreateFDCDisciplineInput!) {
  createFDCDiscipline(createFDCDisciplineInput: $createFdcDisciplineInput) {
    discipline {
      name
    }
  }
}
    `;
export type CreateFdcDisciplineMutationFn = Apollo.MutationFunction<CreateFdcDisciplineMutation, CreateFdcDisciplineMutationVariables>;

/**
 * __useCreateFdcDisciplineMutation__
 *
 * To run a mutation, you first call `useCreateFdcDisciplineMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateFdcDisciplineMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createFdcDisciplineMutation, { data, loading, error }] = useCreateFdcDisciplineMutation({
 *   variables: {
 *      createFdcDisciplineInput: // value for 'createFdcDisciplineInput'
 *   },
 * });
 */
export function useCreateFdcDisciplineMutation(baseOptions?: Apollo.MutationHookOptions<CreateFdcDisciplineMutation, CreateFdcDisciplineMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateFdcDisciplineMutation, CreateFdcDisciplineMutationVariables>(CreateFdcDisciplineDocument, options);
      }
export type CreateFdcDisciplineMutationHookResult = ReturnType<typeof useCreateFdcDisciplineMutation>;
export type CreateFdcDisciplineMutationResult = Apollo.MutationResult<CreateFdcDisciplineMutation>;
export type CreateFdcDisciplineMutationOptions = Apollo.BaseMutationOptions<CreateFdcDisciplineMutation, CreateFdcDisciplineMutationVariables>;
export const EditFdcDisciplineDocument = gql`
    mutation EditFDCDiscipline($editFdcDisciplineInput: EditFDCDisciplineInput!) {
  editFDCDiscipline(editFDCDisciplineInput: $editFdcDisciplineInput) {
    discipline {
      name
    }
  }
}
    `;
export type EditFdcDisciplineMutationFn = Apollo.MutationFunction<EditFdcDisciplineMutation, EditFdcDisciplineMutationVariables>;

/**
 * __useEditFdcDisciplineMutation__
 *
 * To run a mutation, you first call `useEditFdcDisciplineMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditFdcDisciplineMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editFdcDisciplineMutation, { data, loading, error }] = useEditFdcDisciplineMutation({
 *   variables: {
 *      editFdcDisciplineInput: // value for 'editFdcDisciplineInput'
 *   },
 * });
 */
export function useEditFdcDisciplineMutation(baseOptions?: Apollo.MutationHookOptions<EditFdcDisciplineMutation, EditFdcDisciplineMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditFdcDisciplineMutation, EditFdcDisciplineMutationVariables>(EditFdcDisciplineDocument, options);
      }
export type EditFdcDisciplineMutationHookResult = ReturnType<typeof useEditFdcDisciplineMutation>;
export type EditFdcDisciplineMutationResult = Apollo.MutationResult<EditFdcDisciplineMutation>;
export type EditFdcDisciplineMutationOptions = Apollo.BaseMutationOptions<EditFdcDisciplineMutation, EditFdcDisciplineMutationVariables>;
export const ProjectFdcDisciplinesDocument = gql`
    query ProjectFDCDisciplines($globalId: String!, $input: FDCDisciplineFieldInput) {
  project(globalId: $globalId) {
    fdcDisciplines(fdcDisciplineFieldInput: $input) {
      id
      name
      description
      deleted
      deletedDate
      deletedUser
      fieldDesignChanges {
        id
        formattedNumber
        deleted
      }
    }
  }
}
    `;

/**
 * __useProjectFdcDisciplinesQuery__
 *
 * To run a query within a React component, call `useProjectFdcDisciplinesQuery` and pass it any options that fit your needs.
 * When your component renders, `useProjectFdcDisciplinesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProjectFdcDisciplinesQuery({
 *   variables: {
 *      globalId: // value for 'globalId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useProjectFdcDisciplinesQuery(baseOptions: Apollo.QueryHookOptions<ProjectFdcDisciplinesQuery, ProjectFdcDisciplinesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProjectFdcDisciplinesQuery, ProjectFdcDisciplinesQueryVariables>(ProjectFdcDisciplinesDocument, options);
      }
export function useProjectFdcDisciplinesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProjectFdcDisciplinesQuery, ProjectFdcDisciplinesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProjectFdcDisciplinesQuery, ProjectFdcDisciplinesQueryVariables>(ProjectFdcDisciplinesDocument, options);
        }
export type ProjectFdcDisciplinesQueryHookResult = ReturnType<typeof useProjectFdcDisciplinesQuery>;
export type ProjectFdcDisciplinesLazyQueryHookResult = ReturnType<typeof useProjectFdcDisciplinesLazyQuery>;
export type ProjectFdcDisciplinesQueryResult = Apollo.QueryResult<ProjectFdcDisciplinesQuery, ProjectFdcDisciplinesQueryVariables>;
export const RestoreFdcDisciplineDocument = gql`
    mutation RestoreFDCDiscipline($id: String!) {
  restoreFDCDiscipline(id: $id) {
    discipline {
      name
    }
  }
}
    `;
export type RestoreFdcDisciplineMutationFn = Apollo.MutationFunction<RestoreFdcDisciplineMutation, RestoreFdcDisciplineMutationVariables>;

/**
 * __useRestoreFdcDisciplineMutation__
 *
 * To run a mutation, you first call `useRestoreFdcDisciplineMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRestoreFdcDisciplineMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [restoreFdcDisciplineMutation, { data, loading, error }] = useRestoreFdcDisciplineMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRestoreFdcDisciplineMutation(baseOptions?: Apollo.MutationHookOptions<RestoreFdcDisciplineMutation, RestoreFdcDisciplineMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RestoreFdcDisciplineMutation, RestoreFdcDisciplineMutationVariables>(RestoreFdcDisciplineDocument, options);
      }
export type RestoreFdcDisciplineMutationHookResult = ReturnType<typeof useRestoreFdcDisciplineMutation>;
export type RestoreFdcDisciplineMutationResult = Apollo.MutationResult<RestoreFdcDisciplineMutation>;
export type RestoreFdcDisciplineMutationOptions = Apollo.BaseMutationOptions<RestoreFdcDisciplineMutation, RestoreFdcDisciplineMutationVariables>;
export const SoftRemoveFdcDisciplineDocument = gql`
    mutation SoftRemoveFDCDiscipline($id: String!) {
  softRemoveFDCDiscipline(id: $id) {
    discipline {
      name
    }
  }
}
    `;
export type SoftRemoveFdcDisciplineMutationFn = Apollo.MutationFunction<SoftRemoveFdcDisciplineMutation, SoftRemoveFdcDisciplineMutationVariables>;

/**
 * __useSoftRemoveFdcDisciplineMutation__
 *
 * To run a mutation, you first call `useSoftRemoveFdcDisciplineMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSoftRemoveFdcDisciplineMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [softRemoveFdcDisciplineMutation, { data, loading, error }] = useSoftRemoveFdcDisciplineMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSoftRemoveFdcDisciplineMutation(baseOptions?: Apollo.MutationHookOptions<SoftRemoveFdcDisciplineMutation, SoftRemoveFdcDisciplineMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SoftRemoveFdcDisciplineMutation, SoftRemoveFdcDisciplineMutationVariables>(SoftRemoveFdcDisciplineDocument, options);
      }
export type SoftRemoveFdcDisciplineMutationHookResult = ReturnType<typeof useSoftRemoveFdcDisciplineMutation>;
export type SoftRemoveFdcDisciplineMutationResult = Apollo.MutationResult<SoftRemoveFdcDisciplineMutation>;
export type SoftRemoveFdcDisciplineMutationOptions = Apollo.BaseMutationOptions<SoftRemoveFdcDisciplineMutation, SoftRemoveFdcDisciplineMutationVariables>;
export const CreateFdcQuickLinkDocument = gql`
    mutation CreateFDCQuickLink($input: CreateFDCQuickLinkInput!) {
  createFDCQuickLink(createFDCQuickLinkInput: $input) {
    fdcQuickLink {
      label
    }
  }
}
    `;
export type CreateFdcQuickLinkMutationFn = Apollo.MutationFunction<CreateFdcQuickLinkMutation, CreateFdcQuickLinkMutationVariables>;

/**
 * __useCreateFdcQuickLinkMutation__
 *
 * To run a mutation, you first call `useCreateFdcQuickLinkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateFdcQuickLinkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createFdcQuickLinkMutation, { data, loading, error }] = useCreateFdcQuickLinkMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateFdcQuickLinkMutation(baseOptions?: Apollo.MutationHookOptions<CreateFdcQuickLinkMutation, CreateFdcQuickLinkMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateFdcQuickLinkMutation, CreateFdcQuickLinkMutationVariables>(CreateFdcQuickLinkDocument, options);
      }
export type CreateFdcQuickLinkMutationHookResult = ReturnType<typeof useCreateFdcQuickLinkMutation>;
export type CreateFdcQuickLinkMutationResult = Apollo.MutationResult<CreateFdcQuickLinkMutation>;
export type CreateFdcQuickLinkMutationOptions = Apollo.BaseMutationOptions<CreateFdcQuickLinkMutation, CreateFdcQuickLinkMutationVariables>;
export const EditFdcQuickLinkDocument = gql`
    mutation EditFDCQuickLink($input: EditFDCQuickLinkInput!) {
  editFDCQuickLink(editFDCQuickLinkInput: $input) {
    fdcQuickLink {
      label
    }
  }
}
    `;
export type EditFdcQuickLinkMutationFn = Apollo.MutationFunction<EditFdcQuickLinkMutation, EditFdcQuickLinkMutationVariables>;

/**
 * __useEditFdcQuickLinkMutation__
 *
 * To run a mutation, you first call `useEditFdcQuickLinkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditFdcQuickLinkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editFdcQuickLinkMutation, { data, loading, error }] = useEditFdcQuickLinkMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEditFdcQuickLinkMutation(baseOptions?: Apollo.MutationHookOptions<EditFdcQuickLinkMutation, EditFdcQuickLinkMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditFdcQuickLinkMutation, EditFdcQuickLinkMutationVariables>(EditFdcQuickLinkDocument, options);
      }
export type EditFdcQuickLinkMutationHookResult = ReturnType<typeof useEditFdcQuickLinkMutation>;
export type EditFdcQuickLinkMutationResult = Apollo.MutationResult<EditFdcQuickLinkMutation>;
export type EditFdcQuickLinkMutationOptions = Apollo.BaseMutationOptions<EditFdcQuickLinkMutation, EditFdcQuickLinkMutationVariables>;
export const GetFdcQuickLinksDocument = gql`
    query GetFDCQuickLinks($input: FDCQuickLinkListInput!) {
  fdcQuickLinks(fdcQuickLinkListInput: $input) {
    records {
      id
      label
      href
      description
      deleted
      deletedDate
      deletedUser
    }
  }
}
    `;

/**
 * __useGetFdcQuickLinksQuery__
 *
 * To run a query within a React component, call `useGetFdcQuickLinksQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFdcQuickLinksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFdcQuickLinksQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetFdcQuickLinksQuery(baseOptions: Apollo.QueryHookOptions<GetFdcQuickLinksQuery, GetFdcQuickLinksQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFdcQuickLinksQuery, GetFdcQuickLinksQueryVariables>(GetFdcQuickLinksDocument, options);
      }
export function useGetFdcQuickLinksLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFdcQuickLinksQuery, GetFdcQuickLinksQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFdcQuickLinksQuery, GetFdcQuickLinksQueryVariables>(GetFdcQuickLinksDocument, options);
        }
export type GetFdcQuickLinksQueryHookResult = ReturnType<typeof useGetFdcQuickLinksQuery>;
export type GetFdcQuickLinksLazyQueryHookResult = ReturnType<typeof useGetFdcQuickLinksLazyQuery>;
export type GetFdcQuickLinksQueryResult = Apollo.QueryResult<GetFdcQuickLinksQuery, GetFdcQuickLinksQueryVariables>;
export const RestoreFdcQuickLinkDocument = gql`
    mutation RestoreFDCQuickLink($id: String!) {
  restoreFDCQuickLink(id: $id) {
    fdcQuickLink {
      label
    }
  }
}
    `;
export type RestoreFdcQuickLinkMutationFn = Apollo.MutationFunction<RestoreFdcQuickLinkMutation, RestoreFdcQuickLinkMutationVariables>;

/**
 * __useRestoreFdcQuickLinkMutation__
 *
 * To run a mutation, you first call `useRestoreFdcQuickLinkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRestoreFdcQuickLinkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [restoreFdcQuickLinkMutation, { data, loading, error }] = useRestoreFdcQuickLinkMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRestoreFdcQuickLinkMutation(baseOptions?: Apollo.MutationHookOptions<RestoreFdcQuickLinkMutation, RestoreFdcQuickLinkMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RestoreFdcQuickLinkMutation, RestoreFdcQuickLinkMutationVariables>(RestoreFdcQuickLinkDocument, options);
      }
export type RestoreFdcQuickLinkMutationHookResult = ReturnType<typeof useRestoreFdcQuickLinkMutation>;
export type RestoreFdcQuickLinkMutationResult = Apollo.MutationResult<RestoreFdcQuickLinkMutation>;
export type RestoreFdcQuickLinkMutationOptions = Apollo.BaseMutationOptions<RestoreFdcQuickLinkMutation, RestoreFdcQuickLinkMutationVariables>;
export const SoftRemoveFdcQuickLinkDocument = gql`
    mutation SoftRemoveFDCQuickLink($id: String!) {
  softRemoveFDCQuickLink(id: $id) {
    fdcQuickLink {
      label
    }
  }
}
    `;
export type SoftRemoveFdcQuickLinkMutationFn = Apollo.MutationFunction<SoftRemoveFdcQuickLinkMutation, SoftRemoveFdcQuickLinkMutationVariables>;

/**
 * __useSoftRemoveFdcQuickLinkMutation__
 *
 * To run a mutation, you first call `useSoftRemoveFdcQuickLinkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSoftRemoveFdcQuickLinkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [softRemoveFdcQuickLinkMutation, { data, loading, error }] = useSoftRemoveFdcQuickLinkMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSoftRemoveFdcQuickLinkMutation(baseOptions?: Apollo.MutationHookOptions<SoftRemoveFdcQuickLinkMutation, SoftRemoveFdcQuickLinkMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SoftRemoveFdcQuickLinkMutation, SoftRemoveFdcQuickLinkMutationVariables>(SoftRemoveFdcQuickLinkDocument, options);
      }
export type SoftRemoveFdcQuickLinkMutationHookResult = ReturnType<typeof useSoftRemoveFdcQuickLinkMutation>;
export type SoftRemoveFdcQuickLinkMutationResult = Apollo.MutationResult<SoftRemoveFdcQuickLinkMutation>;
export type SoftRemoveFdcQuickLinkMutationOptions = Apollo.BaseMutationOptions<SoftRemoveFdcQuickLinkMutation, SoftRemoveFdcQuickLinkMutationVariables>;
export const CreateFdcCommentDocument = gql`
    mutation CreateFDCComment($input: CreateFDCCommentInput!) {
  createFDCComment(createFDCCommentInput: $input) {
    comment {
      id
    }
  }
}
    `;
export type CreateFdcCommentMutationFn = Apollo.MutationFunction<CreateFdcCommentMutation, CreateFdcCommentMutationVariables>;

/**
 * __useCreateFdcCommentMutation__
 *
 * To run a mutation, you first call `useCreateFdcCommentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateFdcCommentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createFdcCommentMutation, { data, loading, error }] = useCreateFdcCommentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateFdcCommentMutation(baseOptions?: Apollo.MutationHookOptions<CreateFdcCommentMutation, CreateFdcCommentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateFdcCommentMutation, CreateFdcCommentMutationVariables>(CreateFdcCommentDocument, options);
      }
export type CreateFdcCommentMutationHookResult = ReturnType<typeof useCreateFdcCommentMutation>;
export type CreateFdcCommentMutationResult = Apollo.MutationResult<CreateFdcCommentMutation>;
export type CreateFdcCommentMutationOptions = Apollo.BaseMutationOptions<CreateFdcCommentMutation, CreateFdcCommentMutationVariables>;
export const DraftFieldDesignChangeDocument = gql`
    mutation DraftFieldDesignChange($input: DraftFieldDesignChangeInput!) {
  draftFieldDesignChange(draftFieldDesignChangeInput: $input) {
    fieldDesignChange {
      formattedNumber
    }
  }
}
    `;
export type DraftFieldDesignChangeMutationFn = Apollo.MutationFunction<DraftFieldDesignChangeMutation, DraftFieldDesignChangeMutationVariables>;

/**
 * __useDraftFieldDesignChangeMutation__
 *
 * To run a mutation, you first call `useDraftFieldDesignChangeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDraftFieldDesignChangeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [draftFieldDesignChangeMutation, { data, loading, error }] = useDraftFieldDesignChangeMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDraftFieldDesignChangeMutation(baseOptions?: Apollo.MutationHookOptions<DraftFieldDesignChangeMutation, DraftFieldDesignChangeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DraftFieldDesignChangeMutation, DraftFieldDesignChangeMutationVariables>(DraftFieldDesignChangeDocument, options);
      }
export type DraftFieldDesignChangeMutationHookResult = ReturnType<typeof useDraftFieldDesignChangeMutation>;
export type DraftFieldDesignChangeMutationResult = Apollo.MutationResult<DraftFieldDesignChangeMutation>;
export type DraftFieldDesignChangeMutationOptions = Apollo.BaseMutationOptions<DraftFieldDesignChangeMutation, DraftFieldDesignChangeMutationVariables>;
export const EditFieldDesignChangeDocument = gql`
    mutation EditFieldDesignChange($input: EditFieldDesignChangeInput!) {
  editFieldDesignChange(editFieldDesignChangeInput: $input) {
    fieldDesignChange {
      id
      formattedNumber
      project {
        projectMetadata {
          promptDesignSubmittalAtFDCClosure
        }
      }
      concurrenceLevel {
        sideEffectId
        name
        description
      }
    }
  }
}
    `;
export type EditFieldDesignChangeMutationFn = Apollo.MutationFunction<EditFieldDesignChangeMutation, EditFieldDesignChangeMutationVariables>;

/**
 * __useEditFieldDesignChangeMutation__
 *
 * To run a mutation, you first call `useEditFieldDesignChangeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditFieldDesignChangeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editFieldDesignChangeMutation, { data, loading, error }] = useEditFieldDesignChangeMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEditFieldDesignChangeMutation(baseOptions?: Apollo.MutationHookOptions<EditFieldDesignChangeMutation, EditFieldDesignChangeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditFieldDesignChangeMutation, EditFieldDesignChangeMutationVariables>(EditFieldDesignChangeDocument, options);
      }
export type EditFieldDesignChangeMutationHookResult = ReturnType<typeof useEditFieldDesignChangeMutation>;
export type EditFieldDesignChangeMutationResult = Apollo.MutationResult<EditFieldDesignChangeMutation>;
export type EditFieldDesignChangeMutationOptions = Apollo.BaseMutationOptions<EditFieldDesignChangeMutation, EditFieldDesignChangeMutationVariables>;
export const FdcTrackerTableMetadataDocument = gql`
    query FDCTrackerTableMetadata($projectId: String!) {
  project(globalId: $projectId) {
    fdcConcurrenceLevels(fdcConcurrenceLevelFieldInput: {deleted: false}) {
      id
      name
      sideEffectId
      description
      approvalGroups {
        id
      }
    }
    fdcConcurrenceGroups(fdcConcurrenceGroupFieldInput: {deleted: false}) {
      id
      name
      description
      roles(roleFieldInput: {deleted: false}) {
        users {
          id
        }
      }
      users {
        id
      }
    }
    fdcApprovalGroups(fdcApprovalGroupFieldInput: {deleted: false}) {
      id
      name
      description
      concurrenceLevels {
        id
      }
      roles(roleFieldInput: {deleted: false}) {
        users {
          id
        }
      }
      users {
        id
      }
    }
    fdcDisciplines(fdcDisciplineFieldInput: {deleted: false}) {
      id
      name
      description
    }
    fdcQuickLinks(fdcQuickLinkFieldInput: {deleted: false}) {
      id
      label
      href
      description
    }
  }
}
    `;

/**
 * __useFdcTrackerTableMetadataQuery__
 *
 * To run a query within a React component, call `useFdcTrackerTableMetadataQuery` and pass it any options that fit your needs.
 * When your component renders, `useFdcTrackerTableMetadataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFdcTrackerTableMetadataQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useFdcTrackerTableMetadataQuery(baseOptions: Apollo.QueryHookOptions<FdcTrackerTableMetadataQuery, FdcTrackerTableMetadataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FdcTrackerTableMetadataQuery, FdcTrackerTableMetadataQueryVariables>(FdcTrackerTableMetadataDocument, options);
      }
export function useFdcTrackerTableMetadataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FdcTrackerTableMetadataQuery, FdcTrackerTableMetadataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FdcTrackerTableMetadataQuery, FdcTrackerTableMetadataQueryVariables>(FdcTrackerTableMetadataDocument, options);
        }
export type FdcTrackerTableMetadataQueryHookResult = ReturnType<typeof useFdcTrackerTableMetadataQuery>;
export type FdcTrackerTableMetadataLazyQueryHookResult = ReturnType<typeof useFdcTrackerTableMetadataLazyQuery>;
export type FdcTrackerTableMetadataQueryResult = Apollo.QueryResult<FdcTrackerTableMetadataQuery, FdcTrackerTableMetadataQueryVariables>;
export const ProjectFieldDesignChangesDocument = gql`
    query ProjectFieldDesignChanges($projectId: String!, $input: FieldDesignChangeListInput!) {
  fieldDesignChanges(fieldDesignChangeListInput: $input) {
    records {
      deleted
      deletedDate
      deletedUser
      designSubmittals {
        id
        packageName
        packageNumber
        deleted
      }
      projectId
      customFields {
        booleanValues {
          customField {
            ...ProjectFieldDesignChangesCustomField
          }
          customFieldId
          value
        }
        dateValues {
          customField {
            ...ProjectFieldDesignChangesCustomField
          }
          customFieldId
          value
        }
        entityValues {
          customField {
            ...ProjectFieldDesignChangesCustomField
          }
          customFieldId
          entities {
            recordId
            href(projectId: $projectId)
            entityId
            label
          }
        }
        listValues {
          singles {
            customField {
              ...ProjectFieldDesignChangesCustomField
            }
            customFieldId
            customListItem {
              id
              deleted
              value
            }
          }
          multiples {
            customField {
              ...ProjectFieldDesignChangesCustomField
            }
            customFieldId
            customListItems {
              id
              deleted
              value
            }
          }
          checkboxes {
            customField {
              ...ProjectFieldDesignChangesCustomField
            }
            customFieldId
            booleans {
              customListItemId
              customListItem {
                value
              }
              checked
            }
          }
        }
        numberValues {
          customField {
            ...ProjectFieldDesignChangesCustomField
          }
          customFieldId
          value
        }
        reportValues {
          customField {
            ...ProjectFieldDesignChangesCustomField
          }
          customFieldId
          reports {
            recordId
            reportId
            href(projectId: $projectId)
            label
          }
        }
        textValues {
          customField {
            ...ProjectFieldDesignChangesCustomField
          }
          customFieldId
          value
        }
      }
      sharePointResourceId
      sharePointResourceWebUrl
      id
      statusId
      number
      formattedNumber
      externalLinks {
        href
        label
      }
      disciplines {
        id
        name
        description
        deleted
      }
      issue
      concurrenceLevel {
        id
        name
        description
        sideEffectId
        deleted
        approvalGroups {
          id
        }
      }
      location
      specsAffected
      drawingsAffected
      requestedApprovalDate
      resolution
      requestedById
      requestedBy {
        mail
        displayName
        id
        deleted
        userGroups {
          id
        }
      }
      submittedDate
      fdcToPayItemNoGeometries {
        payItem {
          globalId
          deleted
          label
        }
      }
      fdcToFDCConcurrenceGroups {
        concurred
        concurrenceDate
        concurrenceBy {
          displayName
          mail
        }
        concurrenceGroup {
          id
          name
          description
          deleted
        }
      }
      fdcToFDCApprovalGroups {
        approved
        approvalDate
        approvalBy {
          displayName
          mail
        }
        approvalGroup {
          id
          name
          description
          deleted
        }
      }
      comments {
        text
        createdDate
        user {
          mail
        }
      }
    }
  }
}
    ${ProjectFieldDesignChangesCustomFieldFragmentDoc}`;

/**
 * __useProjectFieldDesignChangesQuery__
 *
 * To run a query within a React component, call `useProjectFieldDesignChangesQuery` and pass it any options that fit your needs.
 * When your component renders, `useProjectFieldDesignChangesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProjectFieldDesignChangesQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useProjectFieldDesignChangesQuery(baseOptions: Apollo.QueryHookOptions<ProjectFieldDesignChangesQuery, ProjectFieldDesignChangesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProjectFieldDesignChangesQuery, ProjectFieldDesignChangesQueryVariables>(ProjectFieldDesignChangesDocument, options);
      }
export function useProjectFieldDesignChangesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProjectFieldDesignChangesQuery, ProjectFieldDesignChangesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProjectFieldDesignChangesQuery, ProjectFieldDesignChangesQueryVariables>(ProjectFieldDesignChangesDocument, options);
        }
export type ProjectFieldDesignChangesQueryHookResult = ReturnType<typeof useProjectFieldDesignChangesQuery>;
export type ProjectFieldDesignChangesLazyQueryHookResult = ReturnType<typeof useProjectFieldDesignChangesLazyQuery>;
export type ProjectFieldDesignChangesQueryResult = Apollo.QueryResult<ProjectFieldDesignChangesQuery, ProjectFieldDesignChangesQueryVariables>;
export const RestoreFieldDesignChangeDocument = gql`
    mutation RestoreFieldDesignChange($id: String!) {
  restoreFieldDesignChange(id: $id) {
    fieldDesignChange {
      formattedNumber
    }
  }
}
    `;
export type RestoreFieldDesignChangeMutationFn = Apollo.MutationFunction<RestoreFieldDesignChangeMutation, RestoreFieldDesignChangeMutationVariables>;

/**
 * __useRestoreFieldDesignChangeMutation__
 *
 * To run a mutation, you first call `useRestoreFieldDesignChangeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRestoreFieldDesignChangeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [restoreFieldDesignChangeMutation, { data, loading, error }] = useRestoreFieldDesignChangeMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRestoreFieldDesignChangeMutation(baseOptions?: Apollo.MutationHookOptions<RestoreFieldDesignChangeMutation, RestoreFieldDesignChangeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RestoreFieldDesignChangeMutation, RestoreFieldDesignChangeMutationVariables>(RestoreFieldDesignChangeDocument, options);
      }
export type RestoreFieldDesignChangeMutationHookResult = ReturnType<typeof useRestoreFieldDesignChangeMutation>;
export type RestoreFieldDesignChangeMutationResult = Apollo.MutationResult<RestoreFieldDesignChangeMutation>;
export type RestoreFieldDesignChangeMutationOptions = Apollo.BaseMutationOptions<RestoreFieldDesignChangeMutation, RestoreFieldDesignChangeMutationVariables>;
export const RevertFieldDesignChangeDocument = gql`
    mutation RevertFieldDesignChange($input: RevertFieldDesignChangeInput!) {
  revertFieldDesignChange(revertFieldDesignChangeInput: $input) {
    fieldDesignChange {
      formattedNumber
    }
  }
}
    `;
export type RevertFieldDesignChangeMutationFn = Apollo.MutationFunction<RevertFieldDesignChangeMutation, RevertFieldDesignChangeMutationVariables>;

/**
 * __useRevertFieldDesignChangeMutation__
 *
 * To run a mutation, you first call `useRevertFieldDesignChangeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRevertFieldDesignChangeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [revertFieldDesignChangeMutation, { data, loading, error }] = useRevertFieldDesignChangeMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRevertFieldDesignChangeMutation(baseOptions?: Apollo.MutationHookOptions<RevertFieldDesignChangeMutation, RevertFieldDesignChangeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RevertFieldDesignChangeMutation, RevertFieldDesignChangeMutationVariables>(RevertFieldDesignChangeDocument, options);
      }
export type RevertFieldDesignChangeMutationHookResult = ReturnType<typeof useRevertFieldDesignChangeMutation>;
export type RevertFieldDesignChangeMutationResult = Apollo.MutationResult<RevertFieldDesignChangeMutation>;
export type RevertFieldDesignChangeMutationOptions = Apollo.BaseMutationOptions<RevertFieldDesignChangeMutation, RevertFieldDesignChangeMutationVariables>;
export const SetFdcToFdcApprovalGroupDocument = gql`
    mutation SetFDCToFDCApprovalGroup($input: SetFDCToFDCApprovalGroupInput!) {
  setFDCToFDCApprovalGroup(setFDCToFDCApprovalGroupInput: $input) {
    approved
    approvalGroup {
      name
    }
  }
}
    `;
export type SetFdcToFdcApprovalGroupMutationFn = Apollo.MutationFunction<SetFdcToFdcApprovalGroupMutation, SetFdcToFdcApprovalGroupMutationVariables>;

/**
 * __useSetFdcToFdcApprovalGroupMutation__
 *
 * To run a mutation, you first call `useSetFdcToFdcApprovalGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetFdcToFdcApprovalGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setFdcToFdcApprovalGroupMutation, { data, loading, error }] = useSetFdcToFdcApprovalGroupMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSetFdcToFdcApprovalGroupMutation(baseOptions?: Apollo.MutationHookOptions<SetFdcToFdcApprovalGroupMutation, SetFdcToFdcApprovalGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetFdcToFdcApprovalGroupMutation, SetFdcToFdcApprovalGroupMutationVariables>(SetFdcToFdcApprovalGroupDocument, options);
      }
export type SetFdcToFdcApprovalGroupMutationHookResult = ReturnType<typeof useSetFdcToFdcApprovalGroupMutation>;
export type SetFdcToFdcApprovalGroupMutationResult = Apollo.MutationResult<SetFdcToFdcApprovalGroupMutation>;
export type SetFdcToFdcApprovalGroupMutationOptions = Apollo.BaseMutationOptions<SetFdcToFdcApprovalGroupMutation, SetFdcToFdcApprovalGroupMutationVariables>;
export const SetFdcToFdcConcurrenceGroupDocument = gql`
    mutation SetFDCToFDCConcurrenceGroup($input: SetFDCToFDCConcurrenceGroupInput!) {
  setFDCToFDCConcurrenceGroup(setFDCToFDCConcurrenceGroupInput: $input) {
    concurred
    concurrenceGroup {
      name
    }
  }
}
    `;
export type SetFdcToFdcConcurrenceGroupMutationFn = Apollo.MutationFunction<SetFdcToFdcConcurrenceGroupMutation, SetFdcToFdcConcurrenceGroupMutationVariables>;

/**
 * __useSetFdcToFdcConcurrenceGroupMutation__
 *
 * To run a mutation, you first call `useSetFdcToFdcConcurrenceGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetFdcToFdcConcurrenceGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setFdcToFdcConcurrenceGroupMutation, { data, loading, error }] = useSetFdcToFdcConcurrenceGroupMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSetFdcToFdcConcurrenceGroupMutation(baseOptions?: Apollo.MutationHookOptions<SetFdcToFdcConcurrenceGroupMutation, SetFdcToFdcConcurrenceGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetFdcToFdcConcurrenceGroupMutation, SetFdcToFdcConcurrenceGroupMutationVariables>(SetFdcToFdcConcurrenceGroupDocument, options);
      }
export type SetFdcToFdcConcurrenceGroupMutationHookResult = ReturnType<typeof useSetFdcToFdcConcurrenceGroupMutation>;
export type SetFdcToFdcConcurrenceGroupMutationResult = Apollo.MutationResult<SetFdcToFdcConcurrenceGroupMutation>;
export type SetFdcToFdcConcurrenceGroupMutationOptions = Apollo.BaseMutationOptions<SetFdcToFdcConcurrenceGroupMutation, SetFdcToFdcConcurrenceGroupMutationVariables>;
export const SoftRemoveFieldDesignChangeDocument = gql`
    mutation SoftRemoveFieldDesignChange($id: String!) {
  softRemoveFieldDesignChange(id: $id) {
    fieldDesignChange {
      formattedNumber
    }
  }
}
    `;
export type SoftRemoveFieldDesignChangeMutationFn = Apollo.MutationFunction<SoftRemoveFieldDesignChangeMutation, SoftRemoveFieldDesignChangeMutationVariables>;

/**
 * __useSoftRemoveFieldDesignChangeMutation__
 *
 * To run a mutation, you first call `useSoftRemoveFieldDesignChangeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSoftRemoveFieldDesignChangeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [softRemoveFieldDesignChangeMutation, { data, loading, error }] = useSoftRemoveFieldDesignChangeMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSoftRemoveFieldDesignChangeMutation(baseOptions?: Apollo.MutationHookOptions<SoftRemoveFieldDesignChangeMutation, SoftRemoveFieldDesignChangeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SoftRemoveFieldDesignChangeMutation, SoftRemoveFieldDesignChangeMutationVariables>(SoftRemoveFieldDesignChangeDocument, options);
      }
export type SoftRemoveFieldDesignChangeMutationHookResult = ReturnType<typeof useSoftRemoveFieldDesignChangeMutation>;
export type SoftRemoveFieldDesignChangeMutationResult = Apollo.MutationResult<SoftRemoveFieldDesignChangeMutation>;
export type SoftRemoveFieldDesignChangeMutationOptions = Apollo.BaseMutationOptions<SoftRemoveFieldDesignChangeMutation, SoftRemoveFieldDesignChangeMutationVariables>;
export const SubmitFieldDesignChangeDocument = gql`
    mutation SubmitFieldDesignChange($input: SubmitFieldDesignChangeInput!) {
  submitFieldDesignChange(submitFieldDesignChangeInput: $input) {
    fieldDesignChange {
      id
      formattedNumber
      concurrenceLevel {
        name
        description
        sideEffectId
      }
      project {
        projectMetadata {
          promptDesignSubmittalAtFDCClosure
        }
      }
    }
  }
}
    `;
export type SubmitFieldDesignChangeMutationFn = Apollo.MutationFunction<SubmitFieldDesignChangeMutation, SubmitFieldDesignChangeMutationVariables>;

/**
 * __useSubmitFieldDesignChangeMutation__
 *
 * To run a mutation, you first call `useSubmitFieldDesignChangeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubmitFieldDesignChangeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [submitFieldDesignChangeMutation, { data, loading, error }] = useSubmitFieldDesignChangeMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSubmitFieldDesignChangeMutation(baseOptions?: Apollo.MutationHookOptions<SubmitFieldDesignChangeMutation, SubmitFieldDesignChangeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SubmitFieldDesignChangeMutation, SubmitFieldDesignChangeMutationVariables>(SubmitFieldDesignChangeDocument, options);
      }
export type SubmitFieldDesignChangeMutationHookResult = ReturnType<typeof useSubmitFieldDesignChangeMutation>;
export type SubmitFieldDesignChangeMutationResult = Apollo.MutationResult<SubmitFieldDesignChangeMutation>;
export type SubmitFieldDesignChangeMutationOptions = Apollo.BaseMutationOptions<SubmitFieldDesignChangeMutation, SubmitFieldDesignChangeMutationVariables>;
export const ProjectFdcNotificationEventsDocument = gql`
    query ProjectFDCNotificationEvents($globalId: String!) {
  project(globalId: $globalId) {
    fdcNotifications {
      notificationEventId
      recipients {
        every {
          ...FDCNotificationsRecipients
        }
        byConcurrenceLevel(fdcConcurrenceLevelFieldInput: {deleted: false}) {
          concurrenceLevel {
            id
            name
            description
          }
          recipients {
            ...FDCNotificationsRecipients
          }
        }
        byConcurrenceGroup(fdcConcurrenceGroupFieldInput: {deleted: false}) {
          concurrenceGroup {
            id
            name
            description
          }
          recipients {
            ...FDCNotificationsRecipients
          }
        }
        byConcurrenceLevelAndConcurrenceGroup(
          fdcConcurrenceGroupFieldInput: {deleted: false}
          fdcConcurrenceLevelFieldInput: {deleted: false}
        ) {
          concurrenceGroup {
            id
            name
            description
          }
          concurrenceLevel {
            id
            name
            description
          }
          recipients {
            ...FDCNotificationsRecipients
          }
        }
        byApprovalGroup(fdcApprovalGroupFieldInput: {deleted: false}) {
          approvalGroup {
            id
            name
            description
          }
          recipients {
            ...FDCNotificationsRecipients
          }
        }
        byConcurrenceLevelAndApprovalGroup(
          fdcApprovalGroupFieldInput: {deleted: false}
          fdcConcurrenceLevelFieldInput: {deleted: false}
        ) {
          approvalGroup {
            id
            name
            description
          }
          concurrenceLevel {
            id
            name
            description
          }
          recipients {
            ...FDCNotificationsRecipients
          }
        }
      }
    }
    fdcConcurrenceLevels(fdcConcurrenceLevelFieldInput: {deleted: false}) {
      id
      name
      description
    }
    fdcConcurrenceGroups(fdcConcurrenceGroupFieldInput: {deleted: false}) {
      id
      name
      description
      users(userFieldInput: {deleted: false}) {
        ...FDCNotificationsUser
      }
      roles(roleFieldInput: {deleted: false}) {
        ...FDCNotificationsRole
      }
    }
    fdcApprovalGroups(fdcApprovalGroupFieldInput: {deleted: false}) {
      id
      name
      description
      users(userFieldInput: {deleted: false}) {
        ...FDCNotificationsUser
      }
      roles(roleFieldInput: {deleted: false}) {
        ...FDCNotificationsRole
      }
    }
  }
}
    ${FdcNotificationsRecipientsFragmentDoc}
${FdcNotificationsUserFragmentDoc}
${FdcNotificationsRoleFragmentDoc}`;

/**
 * __useProjectFdcNotificationEventsQuery__
 *
 * To run a query within a React component, call `useProjectFdcNotificationEventsQuery` and pass it any options that fit your needs.
 * When your component renders, `useProjectFdcNotificationEventsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProjectFdcNotificationEventsQuery({
 *   variables: {
 *      globalId: // value for 'globalId'
 *   },
 * });
 */
export function useProjectFdcNotificationEventsQuery(baseOptions: Apollo.QueryHookOptions<ProjectFdcNotificationEventsQuery, ProjectFdcNotificationEventsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProjectFdcNotificationEventsQuery, ProjectFdcNotificationEventsQueryVariables>(ProjectFdcNotificationEventsDocument, options);
      }
export function useProjectFdcNotificationEventsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProjectFdcNotificationEventsQuery, ProjectFdcNotificationEventsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProjectFdcNotificationEventsQuery, ProjectFdcNotificationEventsQueryVariables>(ProjectFdcNotificationEventsDocument, options);
        }
export type ProjectFdcNotificationEventsQueryHookResult = ReturnType<typeof useProjectFdcNotificationEventsQuery>;
export type ProjectFdcNotificationEventsLazyQueryHookResult = ReturnType<typeof useProjectFdcNotificationEventsLazyQuery>;
export type ProjectFdcNotificationEventsQueryResult = Apollo.QueryResult<ProjectFdcNotificationEventsQuery, ProjectFdcNotificationEventsQueryVariables>;
export const EditFdcNotificationDocument = gql`
    mutation EditFDCNotification($editFdcNotificationInput: EditFDCNotificationInput!) {
  editFDCNotification(editFDCNotificationInput: $editFdcNotificationInput) {
    notification {
      notificationEvent
    }
  }
}
    `;
export type EditFdcNotificationMutationFn = Apollo.MutationFunction<EditFdcNotificationMutation, EditFdcNotificationMutationVariables>;

/**
 * __useEditFdcNotificationMutation__
 *
 * To run a mutation, you first call `useEditFdcNotificationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditFdcNotificationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editFdcNotificationMutation, { data, loading, error }] = useEditFdcNotificationMutation({
 *   variables: {
 *      editFdcNotificationInput: // value for 'editFdcNotificationInput'
 *   },
 * });
 */
export function useEditFdcNotificationMutation(baseOptions?: Apollo.MutationHookOptions<EditFdcNotificationMutation, EditFdcNotificationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditFdcNotificationMutation, EditFdcNotificationMutationVariables>(EditFdcNotificationDocument, options);
      }
export type EditFdcNotificationMutationHookResult = ReturnType<typeof useEditFdcNotificationMutation>;
export type EditFdcNotificationMutationResult = Apollo.MutationResult<EditFdcNotificationMutation>;
export type EditFdcNotificationMutationOptions = Apollo.BaseMutationOptions<EditFdcNotificationMutation, EditFdcNotificationMutationVariables>;
export const CancelBatchReportRequestDocument = gql`
    mutation CancelBatchReportRequest($id: String!) {
  cancelBatchReportRequest(id: $id) {
    batchReportRequest {
      id
    }
  }
}
    `;
export type CancelBatchReportRequestMutationFn = Apollo.MutationFunction<CancelBatchReportRequestMutation, CancelBatchReportRequestMutationVariables>;

/**
 * __useCancelBatchReportRequestMutation__
 *
 * To run a mutation, you first call `useCancelBatchReportRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelBatchReportRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelBatchReportRequestMutation, { data, loading, error }] = useCancelBatchReportRequestMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCancelBatchReportRequestMutation(baseOptions?: Apollo.MutationHookOptions<CancelBatchReportRequestMutation, CancelBatchReportRequestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CancelBatchReportRequestMutation, CancelBatchReportRequestMutationVariables>(CancelBatchReportRequestDocument, options);
      }
export type CancelBatchReportRequestMutationHookResult = ReturnType<typeof useCancelBatchReportRequestMutation>;
export type CancelBatchReportRequestMutationResult = Apollo.MutationResult<CancelBatchReportRequestMutation>;
export type CancelBatchReportRequestMutationOptions = Apollo.BaseMutationOptions<CancelBatchReportRequestMutation, CancelBatchReportRequestMutationVariables>;
export const QueuedBatchReportRequestsDocument = gql`
    query QueuedBatchReportRequests($batchReportRequestListInput: BatchReportRequestListInput!) {
  batchReportRequests(batchReportRequestListInput: $batchReportRequestListInput) {
    records {
      createdDate
      estimatedString
      id
      json {
        arguments {
          dateRange {
            from
            to
          }
          reportIds
          payItemNoGeometries {
            label
          }
        }
      }
      requestedBy {
        id
        displayName
        mail
      }
      startedDate
      statusId
    }
  }
}
    `;

/**
 * __useQueuedBatchReportRequestsQuery__
 *
 * To run a query within a React component, call `useQueuedBatchReportRequestsQuery` and pass it any options that fit your needs.
 * When your component renders, `useQueuedBatchReportRequestsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useQueuedBatchReportRequestsQuery({
 *   variables: {
 *      batchReportRequestListInput: // value for 'batchReportRequestListInput'
 *   },
 * });
 */
export function useQueuedBatchReportRequestsQuery(baseOptions: Apollo.QueryHookOptions<QueuedBatchReportRequestsQuery, QueuedBatchReportRequestsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<QueuedBatchReportRequestsQuery, QueuedBatchReportRequestsQueryVariables>(QueuedBatchReportRequestsDocument, options);
      }
export function useQueuedBatchReportRequestsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<QueuedBatchReportRequestsQuery, QueuedBatchReportRequestsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<QueuedBatchReportRequestsQuery, QueuedBatchReportRequestsQueryVariables>(QueuedBatchReportRequestsDocument, options);
        }
export type QueuedBatchReportRequestsQueryHookResult = ReturnType<typeof useQueuedBatchReportRequestsQuery>;
export type QueuedBatchReportRequestsLazyQueryHookResult = ReturnType<typeof useQueuedBatchReportRequestsLazyQuery>;
export type QueuedBatchReportRequestsQueryResult = Apollo.QueryResult<QueuedBatchReportRequestsQuery, QueuedBatchReportRequestsQueryVariables>;
export const CreateBatchReportRequestDocument = gql`
    mutation CreateBatchReportRequest($input: CreateBatchReportRequestInput!) {
  createBatchReportRequest(createBatchReportRequestInput: $input) {
    batchReportRequest {
      createdDate
      requestedBy {
        mail
      }
    }
  }
}
    `;
export type CreateBatchReportRequestMutationFn = Apollo.MutationFunction<CreateBatchReportRequestMutation, CreateBatchReportRequestMutationVariables>;

/**
 * __useCreateBatchReportRequestMutation__
 *
 * To run a mutation, you first call `useCreateBatchReportRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateBatchReportRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createBatchReportRequestMutation, { data, loading, error }] = useCreateBatchReportRequestMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateBatchReportRequestMutation(baseOptions?: Apollo.MutationHookOptions<CreateBatchReportRequestMutation, CreateBatchReportRequestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateBatchReportRequestMutation, CreateBatchReportRequestMutationVariables>(CreateBatchReportRequestDocument, options);
      }
export type CreateBatchReportRequestMutationHookResult = ReturnType<typeof useCreateBatchReportRequestMutation>;
export type CreateBatchReportRequestMutationResult = Apollo.MutationResult<CreateBatchReportRequestMutation>;
export type CreateBatchReportRequestMutationOptions = Apollo.BaseMutationOptions<CreateBatchReportRequestMutation, CreateBatchReportRequestMutationVariables>;
export const EditFilenameModalMetadataDocument = gql`
    query EditFilenameModalMetadata($projectGlobalId: String!) {
  project(globalId: $projectGlobalId) {
    projectName
    clientProjectName
    clientProjectNumber
  }
}
    `;

/**
 * __useEditFilenameModalMetadataQuery__
 *
 * To run a query within a React component, call `useEditFilenameModalMetadataQuery` and pass it any options that fit your needs.
 * When your component renders, `useEditFilenameModalMetadataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEditFilenameModalMetadataQuery({
 *   variables: {
 *      projectGlobalId: // value for 'projectGlobalId'
 *   },
 * });
 */
export function useEditFilenameModalMetadataQuery(baseOptions: Apollo.QueryHookOptions<EditFilenameModalMetadataQuery, EditFilenameModalMetadataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EditFilenameModalMetadataQuery, EditFilenameModalMetadataQueryVariables>(EditFilenameModalMetadataDocument, options);
      }
export function useEditFilenameModalMetadataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EditFilenameModalMetadataQuery, EditFilenameModalMetadataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EditFilenameModalMetadataQuery, EditFilenameModalMetadataQueryVariables>(EditFilenameModalMetadataDocument, options);
        }
export type EditFilenameModalMetadataQueryHookResult = ReturnType<typeof useEditFilenameModalMetadataQuery>;
export type EditFilenameModalMetadataLazyQueryHookResult = ReturnType<typeof useEditFilenameModalMetadataLazyQuery>;
export type EditFilenameModalMetadataQueryResult = Apollo.QueryResult<EditFilenameModalMetadataQuery, EditFilenameModalMetadataQueryVariables>;
export const PhotoFilenamesDocument = gql`
    query PhotoFilenames($projectId: String!) {
  photoFilenames(photoFilenameListInput: {projectId: {equals: $projectId}}) {
    records {
      classTypeId
      templateItems {
        type
        value
      }
    }
  }
}
    `;

/**
 * __usePhotoFilenamesQuery__
 *
 * To run a query within a React component, call `usePhotoFilenamesQuery` and pass it any options that fit your needs.
 * When your component renders, `usePhotoFilenamesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePhotoFilenamesQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function usePhotoFilenamesQuery(baseOptions: Apollo.QueryHookOptions<PhotoFilenamesQuery, PhotoFilenamesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PhotoFilenamesQuery, PhotoFilenamesQueryVariables>(PhotoFilenamesDocument, options);
      }
export function usePhotoFilenamesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PhotoFilenamesQuery, PhotoFilenamesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PhotoFilenamesQuery, PhotoFilenamesQueryVariables>(PhotoFilenamesDocument, options);
        }
export type PhotoFilenamesQueryHookResult = ReturnType<typeof usePhotoFilenamesQuery>;
export type PhotoFilenamesLazyQueryHookResult = ReturnType<typeof usePhotoFilenamesLazyQuery>;
export type PhotoFilenamesQueryResult = Apollo.QueryResult<PhotoFilenamesQuery, PhotoFilenamesQueryVariables>;
export const EditPhotoFilenameDocument = gql`
    mutation EditPhotoFilename($input: EditPhotoFilenameInput!) {
  editPhotoFilename(editPhotoFilenameInput: $input) {
    photoFilename {
      classType
    }
  }
}
    `;
export type EditPhotoFilenameMutationFn = Apollo.MutationFunction<EditPhotoFilenameMutation, EditPhotoFilenameMutationVariables>;

/**
 * __useEditPhotoFilenameMutation__
 *
 * To run a mutation, you first call `useEditPhotoFilenameMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditPhotoFilenameMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editPhotoFilenameMutation, { data, loading, error }] = useEditPhotoFilenameMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEditPhotoFilenameMutation(baseOptions?: Apollo.MutationHookOptions<EditPhotoFilenameMutation, EditPhotoFilenameMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditPhotoFilenameMutation, EditPhotoFilenameMutationVariables>(EditPhotoFilenameDocument, options);
      }
export type EditPhotoFilenameMutationHookResult = ReturnType<typeof useEditPhotoFilenameMutation>;
export type EditPhotoFilenameMutationResult = Apollo.MutationResult<EditPhotoFilenameMutation>;
export type EditPhotoFilenameMutationOptions = Apollo.BaseMutationOptions<EditPhotoFilenameMutation, EditPhotoFilenameMutationVariables>;
export const PhotoFilenameExampleDocument = gql`
    query PhotoFilenameExample($input: PhotoFilenameExampleInput!) {
  photoFilenameExample(photoFilenameExampleInput: $input)
}
    `;

/**
 * __usePhotoFilenameExampleQuery__
 *
 * To run a query within a React component, call `usePhotoFilenameExampleQuery` and pass it any options that fit your needs.
 * When your component renders, `usePhotoFilenameExampleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePhotoFilenameExampleQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePhotoFilenameExampleQuery(baseOptions: Apollo.QueryHookOptions<PhotoFilenameExampleQuery, PhotoFilenameExampleQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PhotoFilenameExampleQuery, PhotoFilenameExampleQueryVariables>(PhotoFilenameExampleDocument, options);
      }
export function usePhotoFilenameExampleLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PhotoFilenameExampleQuery, PhotoFilenameExampleQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PhotoFilenameExampleQuery, PhotoFilenameExampleQueryVariables>(PhotoFilenameExampleDocument, options);
        }
export type PhotoFilenameExampleQueryHookResult = ReturnType<typeof usePhotoFilenameExampleQuery>;
export type PhotoFilenameExampleLazyQueryHookResult = ReturnType<typeof usePhotoFilenameExampleLazyQuery>;
export type PhotoFilenameExampleQueryResult = Apollo.QueryResult<PhotoFilenameExampleQuery, PhotoFilenameExampleQueryVariables>;
export const PhotoFilenameTemplateDocument = gql`
    query PhotoFilenameTemplate($input: PhotoFilenameTemplateInput!) {
  photoFilenameTemplate(photoFilenameTemplateInput: $input)
}
    `;

/**
 * __usePhotoFilenameTemplateQuery__
 *
 * To run a query within a React component, call `usePhotoFilenameTemplateQuery` and pass it any options that fit your needs.
 * When your component renders, `usePhotoFilenameTemplateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePhotoFilenameTemplateQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePhotoFilenameTemplateQuery(baseOptions: Apollo.QueryHookOptions<PhotoFilenameTemplateQuery, PhotoFilenameTemplateQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PhotoFilenameTemplateQuery, PhotoFilenameTemplateQueryVariables>(PhotoFilenameTemplateDocument, options);
      }
export function usePhotoFilenameTemplateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PhotoFilenameTemplateQuery, PhotoFilenameTemplateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PhotoFilenameTemplateQuery, PhotoFilenameTemplateQueryVariables>(PhotoFilenameTemplateDocument, options);
        }
export type PhotoFilenameTemplateQueryHookResult = ReturnType<typeof usePhotoFilenameTemplateQuery>;
export type PhotoFilenameTemplateLazyQueryHookResult = ReturnType<typeof usePhotoFilenameTemplateLazyQuery>;
export type PhotoFilenameTemplateQueryResult = Apollo.QueryResult<PhotoFilenameTemplateQuery, PhotoFilenameTemplateQueryVariables>;
export const ReportFilenamesDocument = gql`
    query ReportFilenames($projectId: String!) {
  reportFilenames(reportFilenameListInput: {projectId: {equals: $projectId}}) {
    records {
      reportId
      templateItems {
        type
        value
      }
    }
  }
}
    `;

/**
 * __useReportFilenamesQuery__
 *
 * To run a query within a React component, call `useReportFilenamesQuery` and pass it any options that fit your needs.
 * When your component renders, `useReportFilenamesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReportFilenamesQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useReportFilenamesQuery(baseOptions: Apollo.QueryHookOptions<ReportFilenamesQuery, ReportFilenamesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ReportFilenamesQuery, ReportFilenamesQueryVariables>(ReportFilenamesDocument, options);
      }
export function useReportFilenamesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReportFilenamesQuery, ReportFilenamesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ReportFilenamesQuery, ReportFilenamesQueryVariables>(ReportFilenamesDocument, options);
        }
export type ReportFilenamesQueryHookResult = ReturnType<typeof useReportFilenamesQuery>;
export type ReportFilenamesLazyQueryHookResult = ReturnType<typeof useReportFilenamesLazyQuery>;
export type ReportFilenamesQueryResult = Apollo.QueryResult<ReportFilenamesQuery, ReportFilenamesQueryVariables>;
export const EditReportFilenameDocument = gql`
    mutation EditReportFilename($input: EditReportFilenameInput!) {
  editReportFilename(editReportFilenameInput: $input) {
    reportFilename {
      report
    }
  }
}
    `;
export type EditReportFilenameMutationFn = Apollo.MutationFunction<EditReportFilenameMutation, EditReportFilenameMutationVariables>;

/**
 * __useEditReportFilenameMutation__
 *
 * To run a mutation, you first call `useEditReportFilenameMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditReportFilenameMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editReportFilenameMutation, { data, loading, error }] = useEditReportFilenameMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEditReportFilenameMutation(baseOptions?: Apollo.MutationHookOptions<EditReportFilenameMutation, EditReportFilenameMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditReportFilenameMutation, EditReportFilenameMutationVariables>(EditReportFilenameDocument, options);
      }
export type EditReportFilenameMutationHookResult = ReturnType<typeof useEditReportFilenameMutation>;
export type EditReportFilenameMutationResult = Apollo.MutationResult<EditReportFilenameMutation>;
export type EditReportFilenameMutationOptions = Apollo.BaseMutationOptions<EditReportFilenameMutation, EditReportFilenameMutationVariables>;
export const ReportFilenameExampleDocument = gql`
    query ReportFilenameExample($input: ReportFilenameExampleInput!) {
  reportFilenameExample(reportFilenameExampleInput: $input)
}
    `;

/**
 * __useReportFilenameExampleQuery__
 *
 * To run a query within a React component, call `useReportFilenameExampleQuery` and pass it any options that fit your needs.
 * When your component renders, `useReportFilenameExampleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReportFilenameExampleQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useReportFilenameExampleQuery(baseOptions: Apollo.QueryHookOptions<ReportFilenameExampleQuery, ReportFilenameExampleQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ReportFilenameExampleQuery, ReportFilenameExampleQueryVariables>(ReportFilenameExampleDocument, options);
      }
export function useReportFilenameExampleLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReportFilenameExampleQuery, ReportFilenameExampleQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ReportFilenameExampleQuery, ReportFilenameExampleQueryVariables>(ReportFilenameExampleDocument, options);
        }
export type ReportFilenameExampleQueryHookResult = ReturnType<typeof useReportFilenameExampleQuery>;
export type ReportFilenameExampleLazyQueryHookResult = ReturnType<typeof useReportFilenameExampleLazyQuery>;
export type ReportFilenameExampleQueryResult = Apollo.QueryResult<ReportFilenameExampleQuery, ReportFilenameExampleQueryVariables>;
export const ReportFilenameTemplateDocument = gql`
    query ReportFilenameTemplate($input: ReportFilenameTemplateInput!) {
  reportFilenameTemplate(reportFilenameTemplateInput: $input)
}
    `;

/**
 * __useReportFilenameTemplateQuery__
 *
 * To run a query within a React component, call `useReportFilenameTemplateQuery` and pass it any options that fit your needs.
 * When your component renders, `useReportFilenameTemplateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReportFilenameTemplateQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useReportFilenameTemplateQuery(baseOptions: Apollo.QueryHookOptions<ReportFilenameTemplateQuery, ReportFilenameTemplateQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ReportFilenameTemplateQuery, ReportFilenameTemplateQueryVariables>(ReportFilenameTemplateDocument, options);
      }
export function useReportFilenameTemplateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReportFilenameTemplateQuery, ReportFilenameTemplateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ReportFilenameTemplateQuery, ReportFilenameTemplateQueryVariables>(ReportFilenameTemplateDocument, options);
        }
export type ReportFilenameTemplateQueryHookResult = ReturnType<typeof useReportFilenameTemplateQuery>;
export type ReportFilenameTemplateLazyQueryHookResult = ReturnType<typeof useReportFilenameTemplateLazyQuery>;
export type ReportFilenameTemplateQueryResult = Apollo.QueryResult<ReportFilenameTemplateQuery, ReportFilenameTemplateQueryVariables>;
export const FilenamesWarningsDocument = gql`
    query FilenamesWarnings($projectId: String!) {
  projectMetadata(projectId: $projectId) {
    replaceSpacesWithDashesInFilenames
  }
}
    `;

/**
 * __useFilenamesWarningsQuery__
 *
 * To run a query within a React component, call `useFilenamesWarningsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFilenamesWarningsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFilenamesWarningsQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useFilenamesWarningsQuery(baseOptions: Apollo.QueryHookOptions<FilenamesWarningsQuery, FilenamesWarningsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FilenamesWarningsQuery, FilenamesWarningsQueryVariables>(FilenamesWarningsDocument, options);
      }
export function useFilenamesWarningsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FilenamesWarningsQuery, FilenamesWarningsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FilenamesWarningsQuery, FilenamesWarningsQueryVariables>(FilenamesWarningsDocument, options);
        }
export type FilenamesWarningsQueryHookResult = ReturnType<typeof useFilenamesWarningsQuery>;
export type FilenamesWarningsLazyQueryHookResult = ReturnType<typeof useFilenamesWarningsLazyQuery>;
export type FilenamesWarningsQueryResult = Apollo.QueryResult<FilenamesWarningsQuery, FilenamesWarningsQueryVariables>;
export const AsphaltPlacementMapImageDocument = gql`
    query AsphaltPlacementMapImage($globalId: String!, $projectLayerIds: [Int!]!) {
  asphaltPlacement(globalId: $globalId) {
    base64MapImage(projectLayerIds: $projectLayerIds)
  }
}
    `;

/**
 * __useAsphaltPlacementMapImageQuery__
 *
 * To run a query within a React component, call `useAsphaltPlacementMapImageQuery` and pass it any options that fit your needs.
 * When your component renders, `useAsphaltPlacementMapImageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAsphaltPlacementMapImageQuery({
 *   variables: {
 *      globalId: // value for 'globalId'
 *      projectLayerIds: // value for 'projectLayerIds'
 *   },
 * });
 */
export function useAsphaltPlacementMapImageQuery(baseOptions: Apollo.QueryHookOptions<AsphaltPlacementMapImageQuery, AsphaltPlacementMapImageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AsphaltPlacementMapImageQuery, AsphaltPlacementMapImageQueryVariables>(AsphaltPlacementMapImageDocument, options);
      }
export function useAsphaltPlacementMapImageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AsphaltPlacementMapImageQuery, AsphaltPlacementMapImageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AsphaltPlacementMapImageQuery, AsphaltPlacementMapImageQueryVariables>(AsphaltPlacementMapImageDocument, options);
        }
export type AsphaltPlacementMapImageQueryHookResult = ReturnType<typeof useAsphaltPlacementMapImageQuery>;
export type AsphaltPlacementMapImageLazyQueryHookResult = ReturnType<typeof useAsphaltPlacementMapImageLazyQuery>;
export type AsphaltPlacementMapImageQueryResult = Apollo.QueryResult<AsphaltPlacementMapImageQuery, AsphaltPlacementMapImageQueryVariables>;
export const ConcretePlacementMapImageDocument = gql`
    query ConcretePlacementMapImage($globalId: String!, $projectLayerIds: [Int!]!) {
  concretePlacement(globalId: $globalId) {
    base64MapImage(projectLayerIds: $projectLayerIds)
  }
}
    `;

/**
 * __useConcretePlacementMapImageQuery__
 *
 * To run a query within a React component, call `useConcretePlacementMapImageQuery` and pass it any options that fit your needs.
 * When your component renders, `useConcretePlacementMapImageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useConcretePlacementMapImageQuery({
 *   variables: {
 *      globalId: // value for 'globalId'
 *      projectLayerIds: // value for 'projectLayerIds'
 *   },
 * });
 */
export function useConcretePlacementMapImageQuery(baseOptions: Apollo.QueryHookOptions<ConcretePlacementMapImageQuery, ConcretePlacementMapImageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ConcretePlacementMapImageQuery, ConcretePlacementMapImageQueryVariables>(ConcretePlacementMapImageDocument, options);
      }
export function useConcretePlacementMapImageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ConcretePlacementMapImageQuery, ConcretePlacementMapImageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ConcretePlacementMapImageQuery, ConcretePlacementMapImageQueryVariables>(ConcretePlacementMapImageDocument, options);
        }
export type ConcretePlacementMapImageQueryHookResult = ReturnType<typeof useConcretePlacementMapImageQuery>;
export type ConcretePlacementMapImageLazyQueryHookResult = ReturnType<typeof useConcretePlacementMapImageLazyQuery>;
export type ConcretePlacementMapImageQueryResult = Apollo.QueryResult<ConcretePlacementMapImageQuery, ConcretePlacementMapImageQueryVariables>;
export const LotMapImageDocument = gql`
    query LotMapImage($globalId: String!, $projectLayerIds: [Int!]!) {
  lot(globalId: $globalId) {
    base64MapImage(projectLayerIds: $projectLayerIds)
  }
}
    `;

/**
 * __useLotMapImageQuery__
 *
 * To run a query within a React component, call `useLotMapImageQuery` and pass it any options that fit your needs.
 * When your component renders, `useLotMapImageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLotMapImageQuery({
 *   variables: {
 *      globalId: // value for 'globalId'
 *      projectLayerIds: // value for 'projectLayerIds'
 *   },
 * });
 */
export function useLotMapImageQuery(baseOptions: Apollo.QueryHookOptions<LotMapImageQuery, LotMapImageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LotMapImageQuery, LotMapImageQueryVariables>(LotMapImageDocument, options);
      }
export function useLotMapImageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LotMapImageQuery, LotMapImageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LotMapImageQuery, LotMapImageQueryVariables>(LotMapImageDocument, options);
        }
export type LotMapImageQueryHookResult = ReturnType<typeof useLotMapImageQuery>;
export type LotMapImageLazyQueryHookResult = ReturnType<typeof useLotMapImageLazyQuery>;
export type LotMapImageQueryResult = Apollo.QueryResult<LotMapImageQuery, LotMapImageQueryVariables>;
export const DailyInspectionControlPointMapImageDocument = gql`
    query DailyInspectionControlPointMapImage($globalId: String!, $projectLayerIds: [Int!]!) {
  dailyInspectionControlPoint(globalId: $globalId) {
    base64MapImage(projectLayerIds: $projectLayerIds)
  }
}
    `;

/**
 * __useDailyInspectionControlPointMapImageQuery__
 *
 * To run a query within a React component, call `useDailyInspectionControlPointMapImageQuery` and pass it any options that fit your needs.
 * When your component renders, `useDailyInspectionControlPointMapImageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDailyInspectionControlPointMapImageQuery({
 *   variables: {
 *      globalId: // value for 'globalId'
 *      projectLayerIds: // value for 'projectLayerIds'
 *   },
 * });
 */
export function useDailyInspectionControlPointMapImageQuery(baseOptions: Apollo.QueryHookOptions<DailyInspectionControlPointMapImageQuery, DailyInspectionControlPointMapImageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DailyInspectionControlPointMapImageQuery, DailyInspectionControlPointMapImageQueryVariables>(DailyInspectionControlPointMapImageDocument, options);
      }
export function useDailyInspectionControlPointMapImageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DailyInspectionControlPointMapImageQuery, DailyInspectionControlPointMapImageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DailyInspectionControlPointMapImageQuery, DailyInspectionControlPointMapImageQueryVariables>(DailyInspectionControlPointMapImageDocument, options);
        }
export type DailyInspectionControlPointMapImageQueryHookResult = ReturnType<typeof useDailyInspectionControlPointMapImageQuery>;
export type DailyInspectionControlPointMapImageLazyQueryHookResult = ReturnType<typeof useDailyInspectionControlPointMapImageLazyQuery>;
export type DailyInspectionControlPointMapImageQueryResult = Apollo.QueryResult<DailyInspectionControlPointMapImageQuery, DailyInspectionControlPointMapImageQueryVariables>;
export const DailyInspectionInspectionMapImageDocument = gql`
    query DailyInspectionInspectionMapImage($globalId: String!, $projectLayerIds: [Int!]!) {
  dailyInspectionInspection(globalId: $globalId) {
    base64MapImage(projectLayerIds: $projectLayerIds)
  }
}
    `;

/**
 * __useDailyInspectionInspectionMapImageQuery__
 *
 * To run a query within a React component, call `useDailyInspectionInspectionMapImageQuery` and pass it any options that fit your needs.
 * When your component renders, `useDailyInspectionInspectionMapImageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDailyInspectionInspectionMapImageQuery({
 *   variables: {
 *      globalId: // value for 'globalId'
 *      projectLayerIds: // value for 'projectLayerIds'
 *   },
 * });
 */
export function useDailyInspectionInspectionMapImageQuery(baseOptions: Apollo.QueryHookOptions<DailyInspectionInspectionMapImageQuery, DailyInspectionInspectionMapImageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DailyInspectionInspectionMapImageQuery, DailyInspectionInspectionMapImageQueryVariables>(DailyInspectionInspectionMapImageDocument, options);
      }
export function useDailyInspectionInspectionMapImageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DailyInspectionInspectionMapImageQuery, DailyInspectionInspectionMapImageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DailyInspectionInspectionMapImageQuery, DailyInspectionInspectionMapImageQueryVariables>(DailyInspectionInspectionMapImageDocument, options);
        }
export type DailyInspectionInspectionMapImageQueryHookResult = ReturnType<typeof useDailyInspectionInspectionMapImageQuery>;
export type DailyInspectionInspectionMapImageLazyQueryHookResult = ReturnType<typeof useDailyInspectionInspectionMapImageLazyQuery>;
export type DailyInspectionInspectionMapImageQueryResult = Apollo.QueryResult<DailyInspectionInspectionMapImageQuery, DailyInspectionInspectionMapImageQueryVariables>;
export const DailyInspectionPunchListMapImageDocument = gql`
    query DailyInspectionPunchListMapImage($globalId: String!, $projectLayerIds: [Int!]!) {
  dailyInspectionPunchList(globalId: $globalId) {
    base64MapImage(projectLayerIds: $projectLayerIds)
  }
}
    `;

/**
 * __useDailyInspectionPunchListMapImageQuery__
 *
 * To run a query within a React component, call `useDailyInspectionPunchListMapImageQuery` and pass it any options that fit your needs.
 * When your component renders, `useDailyInspectionPunchListMapImageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDailyInspectionPunchListMapImageQuery({
 *   variables: {
 *      globalId: // value for 'globalId'
 *      projectLayerIds: // value for 'projectLayerIds'
 *   },
 * });
 */
export function useDailyInspectionPunchListMapImageQuery(baseOptions: Apollo.QueryHookOptions<DailyInspectionPunchListMapImageQuery, DailyInspectionPunchListMapImageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DailyInspectionPunchListMapImageQuery, DailyInspectionPunchListMapImageQueryVariables>(DailyInspectionPunchListMapImageDocument, options);
      }
export function useDailyInspectionPunchListMapImageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DailyInspectionPunchListMapImageQuery, DailyInspectionPunchListMapImageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DailyInspectionPunchListMapImageQuery, DailyInspectionPunchListMapImageQueryVariables>(DailyInspectionPunchListMapImageDocument, options);
        }
export type DailyInspectionPunchListMapImageQueryHookResult = ReturnType<typeof useDailyInspectionPunchListMapImageQuery>;
export type DailyInspectionPunchListMapImageLazyQueryHookResult = ReturnType<typeof useDailyInspectionPunchListMapImageLazyQuery>;
export type DailyInspectionPunchListMapImageQueryResult = Apollo.QueryResult<DailyInspectionPunchListMapImageQuery, DailyInspectionPunchListMapImageQueryVariables>;
export const DesignLayerTabPdfDesignLayersDocument = gql`
    query DesignLayerTabPDFDesignLayers($projectId: String!) {
  project(globalId: $projectId) {
    pdfDesignLayers {
      ...layer
    }
  }
}
    ${LayerFragmentDoc}`;

/**
 * __useDesignLayerTabPdfDesignLayersQuery__
 *
 * To run a query within a React component, call `useDesignLayerTabPdfDesignLayersQuery` and pass it any options that fit your needs.
 * When your component renders, `useDesignLayerTabPdfDesignLayersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDesignLayerTabPdfDesignLayersQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useDesignLayerTabPdfDesignLayersQuery(baseOptions: Apollo.QueryHookOptions<DesignLayerTabPdfDesignLayersQuery, DesignLayerTabPdfDesignLayersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DesignLayerTabPdfDesignLayersQuery, DesignLayerTabPdfDesignLayersQueryVariables>(DesignLayerTabPdfDesignLayersDocument, options);
      }
export function useDesignLayerTabPdfDesignLayersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DesignLayerTabPdfDesignLayersQuery, DesignLayerTabPdfDesignLayersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DesignLayerTabPdfDesignLayersQuery, DesignLayerTabPdfDesignLayersQueryVariables>(DesignLayerTabPdfDesignLayersDocument, options);
        }
export type DesignLayerTabPdfDesignLayersQueryHookResult = ReturnType<typeof useDesignLayerTabPdfDesignLayersQuery>;
export type DesignLayerTabPdfDesignLayersLazyQueryHookResult = ReturnType<typeof useDesignLayerTabPdfDesignLayersLazyQuery>;
export type DesignLayerTabPdfDesignLayersQueryResult = Apollo.QueryResult<DesignLayerTabPdfDesignLayersQuery, DesignLayerTabPdfDesignLayersQueryVariables>;
export const EditPdfDesignLayerDocument = gql`
    mutation EditPDFDesignLayer($input: EditPDFDesignLayerInput!) {
  editPDFDesignLayer(editPDFDesignLayerInput: $input) {
    pdfDesignLayer {
      ...layer
    }
  }
}
    ${LayerFragmentDoc}`;
export type EditPdfDesignLayerMutationFn = Apollo.MutationFunction<EditPdfDesignLayerMutation, EditPdfDesignLayerMutationVariables>;

/**
 * __useEditPdfDesignLayerMutation__
 *
 * To run a mutation, you first call `useEditPdfDesignLayerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditPdfDesignLayerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editPdfDesignLayerMutation, { data, loading, error }] = useEditPdfDesignLayerMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEditPdfDesignLayerMutation(baseOptions?: Apollo.MutationHookOptions<EditPdfDesignLayerMutation, EditPdfDesignLayerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditPdfDesignLayerMutation, EditPdfDesignLayerMutationVariables>(EditPdfDesignLayerDocument, options);
      }
export type EditPdfDesignLayerMutationHookResult = ReturnType<typeof useEditPdfDesignLayerMutation>;
export type EditPdfDesignLayerMutationResult = Apollo.MutationResult<EditPdfDesignLayerMutation>;
export type EditPdfDesignLayerMutationOptions = Apollo.BaseMutationOptions<EditPdfDesignLayerMutation, EditPdfDesignLayerMutationVariables>;
export const GetProjectMapServerLayersDocument = gql`
    query GetProjectMapServerLayers($globalId: String!) {
  project(globalId: $globalId) {
    projectMetadata {
      mapServerLayers {
        id
        name
      }
    }
  }
}
    `;

/**
 * __useGetProjectMapServerLayersQuery__
 *
 * To run a query within a React component, call `useGetProjectMapServerLayersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProjectMapServerLayersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProjectMapServerLayersQuery({
 *   variables: {
 *      globalId: // value for 'globalId'
 *   },
 * });
 */
export function useGetProjectMapServerLayersQuery(baseOptions: Apollo.QueryHookOptions<GetProjectMapServerLayersQuery, GetProjectMapServerLayersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProjectMapServerLayersQuery, GetProjectMapServerLayersQueryVariables>(GetProjectMapServerLayersDocument, options);
      }
export function useGetProjectMapServerLayersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProjectMapServerLayersQuery, GetProjectMapServerLayersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProjectMapServerLayersQuery, GetProjectMapServerLayersQueryVariables>(GetProjectMapServerLayersDocument, options);
        }
export type GetProjectMapServerLayersQueryHookResult = ReturnType<typeof useGetProjectMapServerLayersQuery>;
export type GetProjectMapServerLayersLazyQueryHookResult = ReturnType<typeof useGetProjectMapServerLayersLazyQuery>;
export type GetProjectMapServerLayersQueryResult = Apollo.QueryResult<GetProjectMapServerLayersQuery, GetProjectMapServerLayersQueryVariables>;
export const PdfDesignLayerAsphaltMaterialsDocument = gql`
    query PDFDesignLayerAsphaltMaterials($projectId: String!) {
  asphaltMaterials(
    asphaltMaterialListInput: {projectId: {equals: $projectId}, deleted: false}
  ) {
    records {
      globalId
      placementType
    }
  }
}
    `;

/**
 * __usePdfDesignLayerAsphaltMaterialsQuery__
 *
 * To run a query within a React component, call `usePdfDesignLayerAsphaltMaterialsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePdfDesignLayerAsphaltMaterialsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePdfDesignLayerAsphaltMaterialsQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function usePdfDesignLayerAsphaltMaterialsQuery(baseOptions: Apollo.QueryHookOptions<PdfDesignLayerAsphaltMaterialsQuery, PdfDesignLayerAsphaltMaterialsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PdfDesignLayerAsphaltMaterialsQuery, PdfDesignLayerAsphaltMaterialsQueryVariables>(PdfDesignLayerAsphaltMaterialsDocument, options);
      }
export function usePdfDesignLayerAsphaltMaterialsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PdfDesignLayerAsphaltMaterialsQuery, PdfDesignLayerAsphaltMaterialsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PdfDesignLayerAsphaltMaterialsQuery, PdfDesignLayerAsphaltMaterialsQueryVariables>(PdfDesignLayerAsphaltMaterialsDocument, options);
        }
export type PdfDesignLayerAsphaltMaterialsQueryHookResult = ReturnType<typeof usePdfDesignLayerAsphaltMaterialsQuery>;
export type PdfDesignLayerAsphaltMaterialsLazyQueryHookResult = ReturnType<typeof usePdfDesignLayerAsphaltMaterialsLazyQuery>;
export type PdfDesignLayerAsphaltMaterialsQueryResult = Apollo.QueryResult<PdfDesignLayerAsphaltMaterialsQuery, PdfDesignLayerAsphaltMaterialsQueryVariables>;
export const PdfDesignLayerAsphaltPlacementsDocument = gql`
    query PDFDesignLayerAsphaltPlacements($projectId: String!) {
  asphaltPlacements(
    asphaltPlacementListInput: {projectId: {equals: $projectId}, deleted: false}
  ) {
    records {
      globalId
      placementId
    }
  }
}
    `;

/**
 * __usePdfDesignLayerAsphaltPlacementsQuery__
 *
 * To run a query within a React component, call `usePdfDesignLayerAsphaltPlacementsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePdfDesignLayerAsphaltPlacementsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePdfDesignLayerAsphaltPlacementsQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function usePdfDesignLayerAsphaltPlacementsQuery(baseOptions: Apollo.QueryHookOptions<PdfDesignLayerAsphaltPlacementsQuery, PdfDesignLayerAsphaltPlacementsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PdfDesignLayerAsphaltPlacementsQuery, PdfDesignLayerAsphaltPlacementsQueryVariables>(PdfDesignLayerAsphaltPlacementsDocument, options);
      }
export function usePdfDesignLayerAsphaltPlacementsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PdfDesignLayerAsphaltPlacementsQuery, PdfDesignLayerAsphaltPlacementsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PdfDesignLayerAsphaltPlacementsQuery, PdfDesignLayerAsphaltPlacementsQueryVariables>(PdfDesignLayerAsphaltPlacementsDocument, options);
        }
export type PdfDesignLayerAsphaltPlacementsQueryHookResult = ReturnType<typeof usePdfDesignLayerAsphaltPlacementsQuery>;
export type PdfDesignLayerAsphaltPlacementsLazyQueryHookResult = ReturnType<typeof usePdfDesignLayerAsphaltPlacementsLazyQuery>;
export type PdfDesignLayerAsphaltPlacementsQueryResult = Apollo.QueryResult<PdfDesignLayerAsphaltPlacementsQuery, PdfDesignLayerAsphaltPlacementsQueryVariables>;
export const PdfDesignLayerConcreteMaterialsDocument = gql`
    query PDFDesignLayerConcreteMaterials($projectId: String!) {
  concreteMaterials(
    concreteMaterialListInput: {projectId: {equals: $projectId}, deleted: false}
  ) {
    records {
      globalId
      placementType
    }
  }
}
    `;

/**
 * __usePdfDesignLayerConcreteMaterialsQuery__
 *
 * To run a query within a React component, call `usePdfDesignLayerConcreteMaterialsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePdfDesignLayerConcreteMaterialsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePdfDesignLayerConcreteMaterialsQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function usePdfDesignLayerConcreteMaterialsQuery(baseOptions: Apollo.QueryHookOptions<PdfDesignLayerConcreteMaterialsQuery, PdfDesignLayerConcreteMaterialsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PdfDesignLayerConcreteMaterialsQuery, PdfDesignLayerConcreteMaterialsQueryVariables>(PdfDesignLayerConcreteMaterialsDocument, options);
      }
export function usePdfDesignLayerConcreteMaterialsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PdfDesignLayerConcreteMaterialsQuery, PdfDesignLayerConcreteMaterialsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PdfDesignLayerConcreteMaterialsQuery, PdfDesignLayerConcreteMaterialsQueryVariables>(PdfDesignLayerConcreteMaterialsDocument, options);
        }
export type PdfDesignLayerConcreteMaterialsQueryHookResult = ReturnType<typeof usePdfDesignLayerConcreteMaterialsQuery>;
export type PdfDesignLayerConcreteMaterialsLazyQueryHookResult = ReturnType<typeof usePdfDesignLayerConcreteMaterialsLazyQuery>;
export type PdfDesignLayerConcreteMaterialsQueryResult = Apollo.QueryResult<PdfDesignLayerConcreteMaterialsQuery, PdfDesignLayerConcreteMaterialsQueryVariables>;
export const PdfDesignLayerConcretePlacementsDocument = gql`
    query PDFDesignLayerConcretePlacements($projectId: String!) {
  concretePlacements(
    concretePlacementListInput: {projectId: {equals: $projectId}, deleted: false}
  ) {
    records {
      globalId
      placementId
    }
  }
}
    `;

/**
 * __usePdfDesignLayerConcretePlacementsQuery__
 *
 * To run a query within a React component, call `usePdfDesignLayerConcretePlacementsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePdfDesignLayerConcretePlacementsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePdfDesignLayerConcretePlacementsQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function usePdfDesignLayerConcretePlacementsQuery(baseOptions: Apollo.QueryHookOptions<PdfDesignLayerConcretePlacementsQuery, PdfDesignLayerConcretePlacementsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PdfDesignLayerConcretePlacementsQuery, PdfDesignLayerConcretePlacementsQueryVariables>(PdfDesignLayerConcretePlacementsDocument, options);
      }
export function usePdfDesignLayerConcretePlacementsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PdfDesignLayerConcretePlacementsQuery, PdfDesignLayerConcretePlacementsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PdfDesignLayerConcretePlacementsQuery, PdfDesignLayerConcretePlacementsQueryVariables>(PdfDesignLayerConcretePlacementsDocument, options);
        }
export type PdfDesignLayerConcretePlacementsQueryHookResult = ReturnType<typeof usePdfDesignLayerConcretePlacementsQuery>;
export type PdfDesignLayerConcretePlacementsLazyQueryHookResult = ReturnType<typeof usePdfDesignLayerConcretePlacementsLazyQuery>;
export type PdfDesignLayerConcretePlacementsQueryResult = Apollo.QueryResult<PdfDesignLayerConcretePlacementsQuery, PdfDesignLayerConcretePlacementsQueryVariables>;
export const PdfDesignLayerDailyInspectionControlPointsDocument = gql`
    query PDFDesignLayerDailyInspectionControlPoints($projectId: String!) {
  dailyInspectionControlPoints(
    dailyInspectionControlPointListInput: {projectId: {equals: $projectId}, deleted: false}
  ) {
    records {
      globalId
      controlPointId
    }
  }
}
    `;

/**
 * __usePdfDesignLayerDailyInspectionControlPointsQuery__
 *
 * To run a query within a React component, call `usePdfDesignLayerDailyInspectionControlPointsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePdfDesignLayerDailyInspectionControlPointsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePdfDesignLayerDailyInspectionControlPointsQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function usePdfDesignLayerDailyInspectionControlPointsQuery(baseOptions: Apollo.QueryHookOptions<PdfDesignLayerDailyInspectionControlPointsQuery, PdfDesignLayerDailyInspectionControlPointsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PdfDesignLayerDailyInspectionControlPointsQuery, PdfDesignLayerDailyInspectionControlPointsQueryVariables>(PdfDesignLayerDailyInspectionControlPointsDocument, options);
      }
export function usePdfDesignLayerDailyInspectionControlPointsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PdfDesignLayerDailyInspectionControlPointsQuery, PdfDesignLayerDailyInspectionControlPointsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PdfDesignLayerDailyInspectionControlPointsQuery, PdfDesignLayerDailyInspectionControlPointsQueryVariables>(PdfDesignLayerDailyInspectionControlPointsDocument, options);
        }
export type PdfDesignLayerDailyInspectionControlPointsQueryHookResult = ReturnType<typeof usePdfDesignLayerDailyInspectionControlPointsQuery>;
export type PdfDesignLayerDailyInspectionControlPointsLazyQueryHookResult = ReturnType<typeof usePdfDesignLayerDailyInspectionControlPointsLazyQuery>;
export type PdfDesignLayerDailyInspectionControlPointsQueryResult = Apollo.QueryResult<PdfDesignLayerDailyInspectionControlPointsQuery, PdfDesignLayerDailyInspectionControlPointsQueryVariables>;
export const PdfDesignLayerDailyInspectionInspectionsDocument = gql`
    query PDFDesignLayerDailyInspectionInspections($projectId: String!) {
  dailyInspectionInspections(
    dailyInspectionInspectionListInput: {projectId: {equals: $projectId}, deleted: false}
  ) {
    records {
      globalId
      inspectionId
    }
  }
}
    `;

/**
 * __usePdfDesignLayerDailyInspectionInspectionsQuery__
 *
 * To run a query within a React component, call `usePdfDesignLayerDailyInspectionInspectionsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePdfDesignLayerDailyInspectionInspectionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePdfDesignLayerDailyInspectionInspectionsQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function usePdfDesignLayerDailyInspectionInspectionsQuery(baseOptions: Apollo.QueryHookOptions<PdfDesignLayerDailyInspectionInspectionsQuery, PdfDesignLayerDailyInspectionInspectionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PdfDesignLayerDailyInspectionInspectionsQuery, PdfDesignLayerDailyInspectionInspectionsQueryVariables>(PdfDesignLayerDailyInspectionInspectionsDocument, options);
      }
export function usePdfDesignLayerDailyInspectionInspectionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PdfDesignLayerDailyInspectionInspectionsQuery, PdfDesignLayerDailyInspectionInspectionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PdfDesignLayerDailyInspectionInspectionsQuery, PdfDesignLayerDailyInspectionInspectionsQueryVariables>(PdfDesignLayerDailyInspectionInspectionsDocument, options);
        }
export type PdfDesignLayerDailyInspectionInspectionsQueryHookResult = ReturnType<typeof usePdfDesignLayerDailyInspectionInspectionsQuery>;
export type PdfDesignLayerDailyInspectionInspectionsLazyQueryHookResult = ReturnType<typeof usePdfDesignLayerDailyInspectionInspectionsLazyQuery>;
export type PdfDesignLayerDailyInspectionInspectionsQueryResult = Apollo.QueryResult<PdfDesignLayerDailyInspectionInspectionsQuery, PdfDesignLayerDailyInspectionInspectionsQueryVariables>;
export const PdfDesignLayerDailyInspectionPunchListsDocument = gql`
    query PDFDesignLayerDailyInspectionPunchLists($projectId: String!) {
  dailyInspectionPunchLists(
    dailyInspectionPunchListListInput: {projectId: {equals: $projectId}, deleted: false}
  ) {
    records {
      globalId
      punchListId
    }
  }
}
    `;

/**
 * __usePdfDesignLayerDailyInspectionPunchListsQuery__
 *
 * To run a query within a React component, call `usePdfDesignLayerDailyInspectionPunchListsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePdfDesignLayerDailyInspectionPunchListsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePdfDesignLayerDailyInspectionPunchListsQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function usePdfDesignLayerDailyInspectionPunchListsQuery(baseOptions: Apollo.QueryHookOptions<PdfDesignLayerDailyInspectionPunchListsQuery, PdfDesignLayerDailyInspectionPunchListsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PdfDesignLayerDailyInspectionPunchListsQuery, PdfDesignLayerDailyInspectionPunchListsQueryVariables>(PdfDesignLayerDailyInspectionPunchListsDocument, options);
      }
export function usePdfDesignLayerDailyInspectionPunchListsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PdfDesignLayerDailyInspectionPunchListsQuery, PdfDesignLayerDailyInspectionPunchListsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PdfDesignLayerDailyInspectionPunchListsQuery, PdfDesignLayerDailyInspectionPunchListsQueryVariables>(PdfDesignLayerDailyInspectionPunchListsDocument, options);
        }
export type PdfDesignLayerDailyInspectionPunchListsQueryHookResult = ReturnType<typeof usePdfDesignLayerDailyInspectionPunchListsQuery>;
export type PdfDesignLayerDailyInspectionPunchListsLazyQueryHookResult = ReturnType<typeof usePdfDesignLayerDailyInspectionPunchListsLazyQuery>;
export type PdfDesignLayerDailyInspectionPunchListsQueryResult = Apollo.QueryResult<PdfDesignLayerDailyInspectionPunchListsQuery, PdfDesignLayerDailyInspectionPunchListsQueryVariables>;
export const PdfDesignLayerDailyInspectionWorkTypesDocument = gql`
    query PDFDesignLayerDailyInspectionWorkTypes($projectId: String!) {
  dailyInspectionWorkTypes(
    dailyInspectionWorkTypeListInput: {projectId: {equals: $projectId}, deleted: false}
  ) {
    records {
      globalId
      name
    }
  }
}
    `;

/**
 * __usePdfDesignLayerDailyInspectionWorkTypesQuery__
 *
 * To run a query within a React component, call `usePdfDesignLayerDailyInspectionWorkTypesQuery` and pass it any options that fit your needs.
 * When your component renders, `usePdfDesignLayerDailyInspectionWorkTypesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePdfDesignLayerDailyInspectionWorkTypesQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function usePdfDesignLayerDailyInspectionWorkTypesQuery(baseOptions: Apollo.QueryHookOptions<PdfDesignLayerDailyInspectionWorkTypesQuery, PdfDesignLayerDailyInspectionWorkTypesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PdfDesignLayerDailyInspectionWorkTypesQuery, PdfDesignLayerDailyInspectionWorkTypesQueryVariables>(PdfDesignLayerDailyInspectionWorkTypesDocument, options);
      }
export function usePdfDesignLayerDailyInspectionWorkTypesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PdfDesignLayerDailyInspectionWorkTypesQuery, PdfDesignLayerDailyInspectionWorkTypesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PdfDesignLayerDailyInspectionWorkTypesQuery, PdfDesignLayerDailyInspectionWorkTypesQueryVariables>(PdfDesignLayerDailyInspectionWorkTypesDocument, options);
        }
export type PdfDesignLayerDailyInspectionWorkTypesQueryHookResult = ReturnType<typeof usePdfDesignLayerDailyInspectionWorkTypesQuery>;
export type PdfDesignLayerDailyInspectionWorkTypesLazyQueryHookResult = ReturnType<typeof usePdfDesignLayerDailyInspectionWorkTypesLazyQuery>;
export type PdfDesignLayerDailyInspectionWorkTypesQueryResult = Apollo.QueryResult<PdfDesignLayerDailyInspectionWorkTypesQuery, PdfDesignLayerDailyInspectionWorkTypesQueryVariables>;
export const PdfDesignLayerLotsDocument = gql`
    query PDFDesignLayerLots($projectId: String!) {
  lots(lotListInput: {projectId: {equals: $projectId}, deleted: false}) {
    records {
      globalId
      lotId
    }
  }
}
    `;

/**
 * __usePdfDesignLayerLotsQuery__
 *
 * To run a query within a React component, call `usePdfDesignLayerLotsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePdfDesignLayerLotsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePdfDesignLayerLotsQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function usePdfDesignLayerLotsQuery(baseOptions: Apollo.QueryHookOptions<PdfDesignLayerLotsQuery, PdfDesignLayerLotsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PdfDesignLayerLotsQuery, PdfDesignLayerLotsQueryVariables>(PdfDesignLayerLotsDocument, options);
      }
export function usePdfDesignLayerLotsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PdfDesignLayerLotsQuery, PdfDesignLayerLotsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PdfDesignLayerLotsQuery, PdfDesignLayerLotsQueryVariables>(PdfDesignLayerLotsDocument, options);
        }
export type PdfDesignLayerLotsQueryHookResult = ReturnType<typeof usePdfDesignLayerLotsQuery>;
export type PdfDesignLayerLotsLazyQueryHookResult = ReturnType<typeof usePdfDesignLayerLotsLazyQuery>;
export type PdfDesignLayerLotsQueryResult = Apollo.QueryResult<PdfDesignLayerLotsQuery, PdfDesignLayerLotsQueryVariables>;
export const PdfDesignLayerMaterialRequirementsDocument = gql`
    query PDFDesignLayerMaterialRequirements($projectId: String!) {
  materialRequirements(
    materialRequirementListInput: {projectId: {equals: $projectId}, deleted: false}
  ) {
    records {
      globalId
      materialSection
    }
  }
}
    `;

/**
 * __usePdfDesignLayerMaterialRequirementsQuery__
 *
 * To run a query within a React component, call `usePdfDesignLayerMaterialRequirementsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePdfDesignLayerMaterialRequirementsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePdfDesignLayerMaterialRequirementsQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function usePdfDesignLayerMaterialRequirementsQuery(baseOptions: Apollo.QueryHookOptions<PdfDesignLayerMaterialRequirementsQuery, PdfDesignLayerMaterialRequirementsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PdfDesignLayerMaterialRequirementsQuery, PdfDesignLayerMaterialRequirementsQueryVariables>(PdfDesignLayerMaterialRequirementsDocument, options);
      }
export function usePdfDesignLayerMaterialRequirementsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PdfDesignLayerMaterialRequirementsQuery, PdfDesignLayerMaterialRequirementsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PdfDesignLayerMaterialRequirementsQuery, PdfDesignLayerMaterialRequirementsQueryVariables>(PdfDesignLayerMaterialRequirementsDocument, options);
        }
export type PdfDesignLayerMaterialRequirementsQueryHookResult = ReturnType<typeof usePdfDesignLayerMaterialRequirementsQuery>;
export type PdfDesignLayerMaterialRequirementsLazyQueryHookResult = ReturnType<typeof usePdfDesignLayerMaterialRequirementsLazyQuery>;
export type PdfDesignLayerMaterialRequirementsQueryResult = Apollo.QueryResult<PdfDesignLayerMaterialRequirementsQuery, PdfDesignLayerMaterialRequirementsQueryVariables>;
export const CancelPhotoExportRequestDocument = gql`
    mutation CancelPhotoExportRequest($id: String!) {
  cancelPhotoExportRequest(id: $id) {
    photoExportRequest {
      id
    }
  }
}
    `;
export type CancelPhotoExportRequestMutationFn = Apollo.MutationFunction<CancelPhotoExportRequestMutation, CancelPhotoExportRequestMutationVariables>;

/**
 * __useCancelPhotoExportRequestMutation__
 *
 * To run a mutation, you first call `useCancelPhotoExportRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelPhotoExportRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelPhotoExportRequestMutation, { data, loading, error }] = useCancelPhotoExportRequestMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCancelPhotoExportRequestMutation(baseOptions?: Apollo.MutationHookOptions<CancelPhotoExportRequestMutation, CancelPhotoExportRequestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CancelPhotoExportRequestMutation, CancelPhotoExportRequestMutationVariables>(CancelPhotoExportRequestDocument, options);
      }
export type CancelPhotoExportRequestMutationHookResult = ReturnType<typeof useCancelPhotoExportRequestMutation>;
export type CancelPhotoExportRequestMutationResult = Apollo.MutationResult<CancelPhotoExportRequestMutation>;
export type CancelPhotoExportRequestMutationOptions = Apollo.BaseMutationOptions<CancelPhotoExportRequestMutation, CancelPhotoExportRequestMutationVariables>;
export const QueuedPhotoExportRequestsDocument = gql`
    query QueuedPhotoExportRequests($photoExportRequestListInput: PhotoExportRequestListInput!) {
  photoExportRequests(photoExportRequestListInput: $photoExportRequestListInput) {
    records {
      id
      statusId
      estimatedString
      createdDate
      startedDate
      requestedBy {
        id
        displayName
        mail
      }
      json {
        arguments {
          createdDate {
            from
            to
          }
        }
      }
    }
  }
}
    `;

/**
 * __useQueuedPhotoExportRequestsQuery__
 *
 * To run a query within a React component, call `useQueuedPhotoExportRequestsQuery` and pass it any options that fit your needs.
 * When your component renders, `useQueuedPhotoExportRequestsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useQueuedPhotoExportRequestsQuery({
 *   variables: {
 *      photoExportRequestListInput: // value for 'photoExportRequestListInput'
 *   },
 * });
 */
export function useQueuedPhotoExportRequestsQuery(baseOptions: Apollo.QueryHookOptions<QueuedPhotoExportRequestsQuery, QueuedPhotoExportRequestsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<QueuedPhotoExportRequestsQuery, QueuedPhotoExportRequestsQueryVariables>(QueuedPhotoExportRequestsDocument, options);
      }
export function useQueuedPhotoExportRequestsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<QueuedPhotoExportRequestsQuery, QueuedPhotoExportRequestsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<QueuedPhotoExportRequestsQuery, QueuedPhotoExportRequestsQueryVariables>(QueuedPhotoExportRequestsDocument, options);
        }
export type QueuedPhotoExportRequestsQueryHookResult = ReturnType<typeof useQueuedPhotoExportRequestsQuery>;
export type QueuedPhotoExportRequestsLazyQueryHookResult = ReturnType<typeof useQueuedPhotoExportRequestsLazyQuery>;
export type QueuedPhotoExportRequestsQueryResult = Apollo.QueryResult<QueuedPhotoExportRequestsQuery, QueuedPhotoExportRequestsQueryVariables>;
export const CreatePhotoExportRequestDocument = gql`
    mutation CreatePhotoExportRequest($createPhotoExportRequestInput: CreatePhotoExportRequestInput!) {
  createPhotoExportRequest(
    createPhotoExportRequestInput: $createPhotoExportRequestInput
  ) {
    photoExportRequest {
      createdDate
      requestedBy {
        mail
      }
    }
  }
}
    `;
export type CreatePhotoExportRequestMutationFn = Apollo.MutationFunction<CreatePhotoExportRequestMutation, CreatePhotoExportRequestMutationVariables>;

/**
 * __useCreatePhotoExportRequestMutation__
 *
 * To run a mutation, you first call `useCreatePhotoExportRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePhotoExportRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPhotoExportRequestMutation, { data, loading, error }] = useCreatePhotoExportRequestMutation({
 *   variables: {
 *      createPhotoExportRequestInput: // value for 'createPhotoExportRequestInput'
 *   },
 * });
 */
export function useCreatePhotoExportRequestMutation(baseOptions?: Apollo.MutationHookOptions<CreatePhotoExportRequestMutation, CreatePhotoExportRequestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreatePhotoExportRequestMutation, CreatePhotoExportRequestMutationVariables>(CreatePhotoExportRequestDocument, options);
      }
export type CreatePhotoExportRequestMutationHookResult = ReturnType<typeof useCreatePhotoExportRequestMutation>;
export type CreatePhotoExportRequestMutationResult = Apollo.MutationResult<CreatePhotoExportRequestMutation>;
export type CreatePhotoExportRequestMutationOptions = Apollo.BaseMutationOptions<CreatePhotoExportRequestMutation, CreatePhotoExportRequestMutationVariables>;
export const ReportCasPacketInfoDocument = gql`
    query ReportCASPacketInfo($input: ConstructionAdminSubmittalListInput!) {
  constructionAdminSubmittals(constructionAdminSubmittalListInput: $input) {
    records {
      id
      sharePointFolderName
      packetSharePointResource {
        downloadUrl
      }
    }
  }
}
    `;

/**
 * __useReportCasPacketInfoQuery__
 *
 * To run a query within a React component, call `useReportCasPacketInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useReportCasPacketInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReportCasPacketInfoQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useReportCasPacketInfoQuery(baseOptions: Apollo.QueryHookOptions<ReportCasPacketInfoQuery, ReportCasPacketInfoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ReportCasPacketInfoQuery, ReportCasPacketInfoQueryVariables>(ReportCasPacketInfoDocument, options);
      }
export function useReportCasPacketInfoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReportCasPacketInfoQuery, ReportCasPacketInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ReportCasPacketInfoQuery, ReportCasPacketInfoQueryVariables>(ReportCasPacketInfoDocument, options);
        }
export type ReportCasPacketInfoQueryHookResult = ReturnType<typeof useReportCasPacketInfoQuery>;
export type ReportCasPacketInfoLazyQueryHookResult = ReturnType<typeof useReportCasPacketInfoLazyQuery>;
export type ReportCasPacketInfoQueryResult = Apollo.QueryResult<ReportCasPacketInfoQuery, ReportCasPacketInfoQueryVariables>;
export const ReportConcreteTestSetPacketInfoDocument = gql`
    query ReportConcreteTestSetPacketInfo($projectId: String!, $concreteTestSetFieldInput: ConcreteTestSetFieldInput) {
  project(globalId: $projectId) {
    concreteTestSets(concreteTestSetFieldInput: $concreteTestSetFieldInput) {
      globalId
      concreteTestSetMetadata {
        packetSharePointResource {
          downloadUrl
        }
      }
    }
  }
}
    `;

/**
 * __useReportConcreteTestSetPacketInfoQuery__
 *
 * To run a query within a React component, call `useReportConcreteTestSetPacketInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useReportConcreteTestSetPacketInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReportConcreteTestSetPacketInfoQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      concreteTestSetFieldInput: // value for 'concreteTestSetFieldInput'
 *   },
 * });
 */
export function useReportConcreteTestSetPacketInfoQuery(baseOptions: Apollo.QueryHookOptions<ReportConcreteTestSetPacketInfoQuery, ReportConcreteTestSetPacketInfoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ReportConcreteTestSetPacketInfoQuery, ReportConcreteTestSetPacketInfoQueryVariables>(ReportConcreteTestSetPacketInfoDocument, options);
      }
export function useReportConcreteTestSetPacketInfoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReportConcreteTestSetPacketInfoQuery, ReportConcreteTestSetPacketInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ReportConcreteTestSetPacketInfoQuery, ReportConcreteTestSetPacketInfoQueryVariables>(ReportConcreteTestSetPacketInfoDocument, options);
        }
export type ReportConcreteTestSetPacketInfoQueryHookResult = ReturnType<typeof useReportConcreteTestSetPacketInfoQuery>;
export type ReportConcreteTestSetPacketInfoLazyQueryHookResult = ReturnType<typeof useReportConcreteTestSetPacketInfoLazyQuery>;
export type ReportConcreteTestSetPacketInfoQueryResult = Apollo.QueryResult<ReportConcreteTestSetPacketInfoQuery, ReportConcreteTestSetPacketInfoQueryVariables>;
export const AsphaltMixDesignsMetadataDocument = gql`
    query AsphaltMixDesignsMetadata($projectId: String!) {
  limsAsphaltMixDesignTargets(
    limsAsphaltMixDesignTargetListInput: {projectId: {equals: $projectId}, deleted: false}
  ) {
    records {
      id
      name
      description
      required
    }
  }
  asphaltMaterialSources(
    asphaltMaterialSourceListInput: {deleted: false, projectId: {equals: $projectId}}
  ) {
    records {
      globalId
      source
    }
  }
}
    `;

/**
 * __useAsphaltMixDesignsMetadataQuery__
 *
 * To run a query within a React component, call `useAsphaltMixDesignsMetadataQuery` and pass it any options that fit your needs.
 * When your component renders, `useAsphaltMixDesignsMetadataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAsphaltMixDesignsMetadataQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useAsphaltMixDesignsMetadataQuery(baseOptions: Apollo.QueryHookOptions<AsphaltMixDesignsMetadataQuery, AsphaltMixDesignsMetadataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AsphaltMixDesignsMetadataQuery, AsphaltMixDesignsMetadataQueryVariables>(AsphaltMixDesignsMetadataDocument, options);
      }
export function useAsphaltMixDesignsMetadataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AsphaltMixDesignsMetadataQuery, AsphaltMixDesignsMetadataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AsphaltMixDesignsMetadataQuery, AsphaltMixDesignsMetadataQueryVariables>(AsphaltMixDesignsMetadataDocument, options);
        }
export type AsphaltMixDesignsMetadataQueryHookResult = ReturnType<typeof useAsphaltMixDesignsMetadataQuery>;
export type AsphaltMixDesignsMetadataLazyQueryHookResult = ReturnType<typeof useAsphaltMixDesignsMetadataLazyQuery>;
export type AsphaltMixDesignsMetadataQueryResult = Apollo.QueryResult<AsphaltMixDesignsMetadataQuery, AsphaltMixDesignsMetadataQueryVariables>;
export const AsphaltMixDesignsDocument = gql`
    query AsphaltMixDesigns($projectId: String!) {
  asphaltMixDesigns(
    asphaltMixDesignListInput: {deleted: false, projectId: {equals: $projectId}}
  ) {
    records {
      globalId
      active
      mixDesignNumber
      supplier
      grade
      nominalSize
      designBinderContent
      vma
      theoMaxSpecGrav
      bulkSpecGravAgg
      expirationDate
      maxAggregateSize
      asphaltMaterialSource {
        globalId
        source
        isDeleted
      }
      percentages {
        target {
          id
          name
          description
          deleted
        }
        percentage
      }
      customFields {
        booleanValues {
          customField {
            ...AsphaltMixDesignCustomField
          }
          customFieldId
          value
        }
        dateValues {
          customField {
            ...AsphaltMixDesignCustomField
          }
          customFieldId
          value
        }
        entityValues {
          customField {
            ...AsphaltMixDesignCustomField
          }
          customFieldId
          entities {
            recordId
            href(projectId: $projectId)
            entityId
            label
          }
        }
        listValues {
          singles {
            customField {
              ...AsphaltMixDesignCustomField
            }
            customFieldId
            customListItem {
              id
              deleted
              value
            }
          }
          multiples {
            customField {
              ...AsphaltMixDesignCustomField
            }
            customFieldId
            customListItems {
              id
              deleted
              value
            }
          }
          checkboxes {
            customField {
              ...AsphaltMixDesignCustomField
            }
            customFieldId
            booleans {
              customListItemId
              customListItem {
                value
              }
              checked
            }
          }
        }
        numberValues {
          customField {
            ...AsphaltMixDesignCustomField
          }
          customFieldId
          value
        }
        reportValues {
          customField {
            ...AsphaltMixDesignCustomField
          }
          customFieldId
          reports {
            recordId
            reportId
            href(projectId: $projectId)
            label
          }
        }
        textValues {
          customField {
            ...AsphaltMixDesignCustomField
          }
          customFieldId
          value
        }
      }
    }
  }
}
    ${AsphaltMixDesignCustomFieldFragmentDoc}`;

/**
 * __useAsphaltMixDesignsQuery__
 *
 * To run a query within a React component, call `useAsphaltMixDesignsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAsphaltMixDesignsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAsphaltMixDesignsQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useAsphaltMixDesignsQuery(baseOptions: Apollo.QueryHookOptions<AsphaltMixDesignsQuery, AsphaltMixDesignsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AsphaltMixDesignsQuery, AsphaltMixDesignsQueryVariables>(AsphaltMixDesignsDocument, options);
      }
export function useAsphaltMixDesignsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AsphaltMixDesignsQuery, AsphaltMixDesignsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AsphaltMixDesignsQuery, AsphaltMixDesignsQueryVariables>(AsphaltMixDesignsDocument, options);
        }
export type AsphaltMixDesignsQueryHookResult = ReturnType<typeof useAsphaltMixDesignsQuery>;
export type AsphaltMixDesignsLazyQueryHookResult = ReturnType<typeof useAsphaltMixDesignsLazyQuery>;
export type AsphaltMixDesignsQueryResult = Apollo.QueryResult<AsphaltMixDesignsQuery, AsphaltMixDesignsQueryVariables>;
export const EditAsphaltMixDesignDocument = gql`
    mutation EditAsphaltMixDesign($input: EditAsphaltMixDesignInput!) {
  editAsphaltMixDesign(editAsphaltMixDesignInput: $input) {
    mixDesign {
      globalId
      mixDesignNumber
    }
  }
}
    `;
export type EditAsphaltMixDesignMutationFn = Apollo.MutationFunction<EditAsphaltMixDesignMutation, EditAsphaltMixDesignMutationVariables>;

/**
 * __useEditAsphaltMixDesignMutation__
 *
 * To run a mutation, you first call `useEditAsphaltMixDesignMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditAsphaltMixDesignMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editAsphaltMixDesignMutation, { data, loading, error }] = useEditAsphaltMixDesignMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEditAsphaltMixDesignMutation(baseOptions?: Apollo.MutationHookOptions<EditAsphaltMixDesignMutation, EditAsphaltMixDesignMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditAsphaltMixDesignMutation, EditAsphaltMixDesignMutationVariables>(EditAsphaltMixDesignDocument, options);
      }
export type EditAsphaltMixDesignMutationHookResult = ReturnType<typeof useEditAsphaltMixDesignMutation>;
export type EditAsphaltMixDesignMutationResult = Apollo.MutationResult<EditAsphaltMixDesignMutation>;
export type EditAsphaltMixDesignMutationOptions = Apollo.BaseMutationOptions<EditAsphaltMixDesignMutation, EditAsphaltMixDesignMutationVariables>;
export const CreateAsphaltMixDesignDocument = gql`
    mutation CreateAsphaltMixDesign($input: CreateAsphaltMixDesignInput!) {
  createAsphaltMixDesign(createAsphaltMixDesignInput: $input) {
    mixDesign {
      globalId
      mixDesignNumber
    }
  }
}
    `;
export type CreateAsphaltMixDesignMutationFn = Apollo.MutationFunction<CreateAsphaltMixDesignMutation, CreateAsphaltMixDesignMutationVariables>;

/**
 * __useCreateAsphaltMixDesignMutation__
 *
 * To run a mutation, you first call `useCreateAsphaltMixDesignMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAsphaltMixDesignMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAsphaltMixDesignMutation, { data, loading, error }] = useCreateAsphaltMixDesignMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateAsphaltMixDesignMutation(baseOptions?: Apollo.MutationHookOptions<CreateAsphaltMixDesignMutation, CreateAsphaltMixDesignMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateAsphaltMixDesignMutation, CreateAsphaltMixDesignMutationVariables>(CreateAsphaltMixDesignDocument, options);
      }
export type CreateAsphaltMixDesignMutationHookResult = ReturnType<typeof useCreateAsphaltMixDesignMutation>;
export type CreateAsphaltMixDesignMutationResult = Apollo.MutationResult<CreateAsphaltMixDesignMutation>;
export type CreateAsphaltMixDesignMutationOptions = Apollo.BaseMutationOptions<CreateAsphaltMixDesignMutation, CreateAsphaltMixDesignMutationVariables>;
export const LimsAsphaltMixDesignTargetsDocument = gql`
    query LIMSAsphaltMixDesignTargets($input: LIMSAsphaltMixDesignTargetListInput!) {
  limsAsphaltMixDesignTargets(limsAsphaltMixDesignTargetListInput: $input) {
    records {
      id
      name
      description
      required
      deleted
      deletedDate
      deletedUser
      percentages {
        mixDesign {
          globalId
          mixDesignNumber
          active
          deleted
        }
        percentage
      }
    }
  }
}
    `;

/**
 * __useLimsAsphaltMixDesignTargetsQuery__
 *
 * To run a query within a React component, call `useLimsAsphaltMixDesignTargetsQuery` and pass it any options that fit your needs.
 * When your component renders, `useLimsAsphaltMixDesignTargetsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLimsAsphaltMixDesignTargetsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useLimsAsphaltMixDesignTargetsQuery(baseOptions: Apollo.QueryHookOptions<LimsAsphaltMixDesignTargetsQuery, LimsAsphaltMixDesignTargetsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LimsAsphaltMixDesignTargetsQuery, LimsAsphaltMixDesignTargetsQueryVariables>(LimsAsphaltMixDesignTargetsDocument, options);
      }
export function useLimsAsphaltMixDesignTargetsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LimsAsphaltMixDesignTargetsQuery, LimsAsphaltMixDesignTargetsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LimsAsphaltMixDesignTargetsQuery, LimsAsphaltMixDesignTargetsQueryVariables>(LimsAsphaltMixDesignTargetsDocument, options);
        }
export type LimsAsphaltMixDesignTargetsQueryHookResult = ReturnType<typeof useLimsAsphaltMixDesignTargetsQuery>;
export type LimsAsphaltMixDesignTargetsLazyQueryHookResult = ReturnType<typeof useLimsAsphaltMixDesignTargetsLazyQuery>;
export type LimsAsphaltMixDesignTargetsQueryResult = Apollo.QueryResult<LimsAsphaltMixDesignTargetsQuery, LimsAsphaltMixDesignTargetsQueryVariables>;
export const LimsAsphaltMixDesignTargetsMetadataDocument = gql`
    query LIMSAsphaltMixDesignTargetsMetadata($projectId: String!) {
  asphaltMixDesigns(
    asphaltMixDesignListInput: {projectId: {equals: $projectId}, deleted: false, active: true}
  ) {
    records {
      globalId
      mixDesignNumber
    }
  }
}
    `;

/**
 * __useLimsAsphaltMixDesignTargetsMetadataQuery__
 *
 * To run a query within a React component, call `useLimsAsphaltMixDesignTargetsMetadataQuery` and pass it any options that fit your needs.
 * When your component renders, `useLimsAsphaltMixDesignTargetsMetadataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLimsAsphaltMixDesignTargetsMetadataQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useLimsAsphaltMixDesignTargetsMetadataQuery(baseOptions: Apollo.QueryHookOptions<LimsAsphaltMixDesignTargetsMetadataQuery, LimsAsphaltMixDesignTargetsMetadataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LimsAsphaltMixDesignTargetsMetadataQuery, LimsAsphaltMixDesignTargetsMetadataQueryVariables>(LimsAsphaltMixDesignTargetsMetadataDocument, options);
      }
export function useLimsAsphaltMixDesignTargetsMetadataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LimsAsphaltMixDesignTargetsMetadataQuery, LimsAsphaltMixDesignTargetsMetadataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LimsAsphaltMixDesignTargetsMetadataQuery, LimsAsphaltMixDesignTargetsMetadataQueryVariables>(LimsAsphaltMixDesignTargetsMetadataDocument, options);
        }
export type LimsAsphaltMixDesignTargetsMetadataQueryHookResult = ReturnType<typeof useLimsAsphaltMixDesignTargetsMetadataQuery>;
export type LimsAsphaltMixDesignTargetsMetadataLazyQueryHookResult = ReturnType<typeof useLimsAsphaltMixDesignTargetsMetadataLazyQuery>;
export type LimsAsphaltMixDesignTargetsMetadataQueryResult = Apollo.QueryResult<LimsAsphaltMixDesignTargetsMetadataQuery, LimsAsphaltMixDesignTargetsMetadataQueryVariables>;
export const EditLimsAsphaltMixDesignTargetDocument = gql`
    mutation EditLIMSAsphaltMixDesignTarget($input: EditLIMSAsphaltMixDesignTargetInput!) {
  editLIMSAsphaltMixDesignTarget(editLIMSAsphaltMixDesignTargetInput: $input) {
    target {
      name
    }
  }
}
    `;
export type EditLimsAsphaltMixDesignTargetMutationFn = Apollo.MutationFunction<EditLimsAsphaltMixDesignTargetMutation, EditLimsAsphaltMixDesignTargetMutationVariables>;

/**
 * __useEditLimsAsphaltMixDesignTargetMutation__
 *
 * To run a mutation, you first call `useEditLimsAsphaltMixDesignTargetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditLimsAsphaltMixDesignTargetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editLimsAsphaltMixDesignTargetMutation, { data, loading, error }] = useEditLimsAsphaltMixDesignTargetMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEditLimsAsphaltMixDesignTargetMutation(baseOptions?: Apollo.MutationHookOptions<EditLimsAsphaltMixDesignTargetMutation, EditLimsAsphaltMixDesignTargetMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditLimsAsphaltMixDesignTargetMutation, EditLimsAsphaltMixDesignTargetMutationVariables>(EditLimsAsphaltMixDesignTargetDocument, options);
      }
export type EditLimsAsphaltMixDesignTargetMutationHookResult = ReturnType<typeof useEditLimsAsphaltMixDesignTargetMutation>;
export type EditLimsAsphaltMixDesignTargetMutationResult = Apollo.MutationResult<EditLimsAsphaltMixDesignTargetMutation>;
export type EditLimsAsphaltMixDesignTargetMutationOptions = Apollo.BaseMutationOptions<EditLimsAsphaltMixDesignTargetMutation, EditLimsAsphaltMixDesignTargetMutationVariables>;
export const CreateLimsAsphaltMixDesignTargetDocument = gql`
    mutation CreateLIMSAsphaltMixDesignTarget($input: CreateLIMSAsphaltMixDesignTargetInput!) {
  createLIMSAsphaltMixDesignTarget(createLIMSAsphaltMixDesignTargetInput: $input) {
    target {
      name
    }
  }
}
    `;
export type CreateLimsAsphaltMixDesignTargetMutationFn = Apollo.MutationFunction<CreateLimsAsphaltMixDesignTargetMutation, CreateLimsAsphaltMixDesignTargetMutationVariables>;

/**
 * __useCreateLimsAsphaltMixDesignTargetMutation__
 *
 * To run a mutation, you first call `useCreateLimsAsphaltMixDesignTargetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateLimsAsphaltMixDesignTargetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createLimsAsphaltMixDesignTargetMutation, { data, loading, error }] = useCreateLimsAsphaltMixDesignTargetMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateLimsAsphaltMixDesignTargetMutation(baseOptions?: Apollo.MutationHookOptions<CreateLimsAsphaltMixDesignTargetMutation, CreateLimsAsphaltMixDesignTargetMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateLimsAsphaltMixDesignTargetMutation, CreateLimsAsphaltMixDesignTargetMutationVariables>(CreateLimsAsphaltMixDesignTargetDocument, options);
      }
export type CreateLimsAsphaltMixDesignTargetMutationHookResult = ReturnType<typeof useCreateLimsAsphaltMixDesignTargetMutation>;
export type CreateLimsAsphaltMixDesignTargetMutationResult = Apollo.MutationResult<CreateLimsAsphaltMixDesignTargetMutation>;
export type CreateLimsAsphaltMixDesignTargetMutationOptions = Apollo.BaseMutationOptions<CreateLimsAsphaltMixDesignTargetMutation, CreateLimsAsphaltMixDesignTargetMutationVariables>;
export const RemoveAsphaltMixDesignTargetDocument = gql`
    mutation RemoveAsphaltMixDesignTarget($id: String!) {
  softRemoveLIMSAsphaltMixDesignTarget(id: $id) {
    target {
      name
    }
  }
}
    `;
export type RemoveAsphaltMixDesignTargetMutationFn = Apollo.MutationFunction<RemoveAsphaltMixDesignTargetMutation, RemoveAsphaltMixDesignTargetMutationVariables>;

/**
 * __useRemoveAsphaltMixDesignTargetMutation__
 *
 * To run a mutation, you first call `useRemoveAsphaltMixDesignTargetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveAsphaltMixDesignTargetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeAsphaltMixDesignTargetMutation, { data, loading, error }] = useRemoveAsphaltMixDesignTargetMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRemoveAsphaltMixDesignTargetMutation(baseOptions?: Apollo.MutationHookOptions<RemoveAsphaltMixDesignTargetMutation, RemoveAsphaltMixDesignTargetMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveAsphaltMixDesignTargetMutation, RemoveAsphaltMixDesignTargetMutationVariables>(RemoveAsphaltMixDesignTargetDocument, options);
      }
export type RemoveAsphaltMixDesignTargetMutationHookResult = ReturnType<typeof useRemoveAsphaltMixDesignTargetMutation>;
export type RemoveAsphaltMixDesignTargetMutationResult = Apollo.MutationResult<RemoveAsphaltMixDesignTargetMutation>;
export type RemoveAsphaltMixDesignTargetMutationOptions = Apollo.BaseMutationOptions<RemoveAsphaltMixDesignTargetMutation, RemoveAsphaltMixDesignTargetMutationVariables>;
export const RestoreAsphaltMixDesignTargetDocument = gql`
    mutation RestoreAsphaltMixDesignTarget($id: String!) {
  restoreLIMSAsphaltMixDesignTarget(id: $id) {
    target {
      name
    }
  }
}
    `;
export type RestoreAsphaltMixDesignTargetMutationFn = Apollo.MutationFunction<RestoreAsphaltMixDesignTargetMutation, RestoreAsphaltMixDesignTargetMutationVariables>;

/**
 * __useRestoreAsphaltMixDesignTargetMutation__
 *
 * To run a mutation, you first call `useRestoreAsphaltMixDesignTargetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRestoreAsphaltMixDesignTargetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [restoreAsphaltMixDesignTargetMutation, { data, loading, error }] = useRestoreAsphaltMixDesignTargetMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRestoreAsphaltMixDesignTargetMutation(baseOptions?: Apollo.MutationHookOptions<RestoreAsphaltMixDesignTargetMutation, RestoreAsphaltMixDesignTargetMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RestoreAsphaltMixDesignTargetMutation, RestoreAsphaltMixDesignTargetMutationVariables>(RestoreAsphaltMixDesignTargetDocument, options);
      }
export type RestoreAsphaltMixDesignTargetMutationHookResult = ReturnType<typeof useRestoreAsphaltMixDesignTargetMutation>;
export type RestoreAsphaltMixDesignTargetMutationResult = Apollo.MutationResult<RestoreAsphaltMixDesignTargetMutation>;
export type RestoreAsphaltMixDesignTargetMutationOptions = Apollo.BaseMutationOptions<RestoreAsphaltMixDesignTargetMutation, RestoreAsphaltMixDesignTargetMutationVariables>;
export const ConcreteMixDesignsDocument = gql`
    query ConcreteMixDesigns($projectId: String!) {
  concreteMixDesigns(
    concreteMixDesignListInput: {deleted: false, projectId: {equals: $projectId}}
  ) {
    records {
      globalId
      active
      mixDesignNumber
      expirationDate
      admixtures
      materialSource
      class
      concreteUse
      submittalId
      wc
      airLow
      airHigh
      slumpLowInches
      slumpHighInches
      airRange
      slumpRange
      admixtures
      maxAggSize
      aggregates
      customFields {
        booleanValues {
          customField {
            ...ConcreteMixDesignCustomField
          }
          customFieldId
          value
        }
        dateValues {
          customField {
            ...ConcreteMixDesignCustomField
          }
          customFieldId
          value
        }
        entityValues {
          customField {
            ...ConcreteMixDesignCustomField
          }
          customFieldId
          entities {
            recordId
            href(projectId: $projectId)
            entityId
            label
          }
        }
        listValues {
          singles {
            customField {
              ...ConcreteMixDesignCustomField
            }
            customFieldId
            customListItem {
              id
              deleted
              value
            }
          }
          multiples {
            customField {
              ...ConcreteMixDesignCustomField
            }
            customFieldId
            customListItems {
              id
              deleted
              value
            }
          }
          checkboxes {
            customField {
              ...ConcreteMixDesignCustomField
            }
            customFieldId
            booleans {
              customListItemId
              customListItem {
                value
              }
              checked
            }
          }
        }
        numberValues {
          customField {
            ...ConcreteMixDesignCustomField
          }
          customFieldId
          value
        }
        reportValues {
          customField {
            ...ConcreteMixDesignCustomField
          }
          customFieldId
          reports {
            recordId
            reportId
            href(projectId: $projectId)
            label
          }
        }
        textValues {
          customField {
            ...ConcreteMixDesignCustomField
          }
          customFieldId
          value
        }
      }
    }
  }
}
    ${ConcreteMixDesignCustomFieldFragmentDoc}`;

/**
 * __useConcreteMixDesignsQuery__
 *
 * To run a query within a React component, call `useConcreteMixDesignsQuery` and pass it any options that fit your needs.
 * When your component renders, `useConcreteMixDesignsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useConcreteMixDesignsQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useConcreteMixDesignsQuery(baseOptions: Apollo.QueryHookOptions<ConcreteMixDesignsQuery, ConcreteMixDesignsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ConcreteMixDesignsQuery, ConcreteMixDesignsQueryVariables>(ConcreteMixDesignsDocument, options);
      }
export function useConcreteMixDesignsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ConcreteMixDesignsQuery, ConcreteMixDesignsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ConcreteMixDesignsQuery, ConcreteMixDesignsQueryVariables>(ConcreteMixDesignsDocument, options);
        }
export type ConcreteMixDesignsQueryHookResult = ReturnType<typeof useConcreteMixDesignsQuery>;
export type ConcreteMixDesignsLazyQueryHookResult = ReturnType<typeof useConcreteMixDesignsLazyQuery>;
export type ConcreteMixDesignsQueryResult = Apollo.QueryResult<ConcreteMixDesignsQuery, ConcreteMixDesignsQueryVariables>;
export const CreateConcreteMixDesignDocument = gql`
    mutation CreateConcreteMixDesign($input: CreateConcreteMixDesignInput!) {
  createConcreteMixDesign(createConcreteMixDesignInput: $input) {
    mixDesign {
      globalId
      mixDesignNumber
    }
  }
}
    `;
export type CreateConcreteMixDesignMutationFn = Apollo.MutationFunction<CreateConcreteMixDesignMutation, CreateConcreteMixDesignMutationVariables>;

/**
 * __useCreateConcreteMixDesignMutation__
 *
 * To run a mutation, you first call `useCreateConcreteMixDesignMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateConcreteMixDesignMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createConcreteMixDesignMutation, { data, loading, error }] = useCreateConcreteMixDesignMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateConcreteMixDesignMutation(baseOptions?: Apollo.MutationHookOptions<CreateConcreteMixDesignMutation, CreateConcreteMixDesignMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateConcreteMixDesignMutation, CreateConcreteMixDesignMutationVariables>(CreateConcreteMixDesignDocument, options);
      }
export type CreateConcreteMixDesignMutationHookResult = ReturnType<typeof useCreateConcreteMixDesignMutation>;
export type CreateConcreteMixDesignMutationResult = Apollo.MutationResult<CreateConcreteMixDesignMutation>;
export type CreateConcreteMixDesignMutationOptions = Apollo.BaseMutationOptions<CreateConcreteMixDesignMutation, CreateConcreteMixDesignMutationVariables>;
export const EditConcreteMixDesignDocument = gql`
    mutation EditConcreteMixDesign($input: EditConcreteMixDesignInput!) {
  editConcreteMixDesign(editConcreteMixDesignInput: $input) {
    mixDesign {
      globalId
      mixDesignNumber
    }
  }
}
    `;
export type EditConcreteMixDesignMutationFn = Apollo.MutationFunction<EditConcreteMixDesignMutation, EditConcreteMixDesignMutationVariables>;

/**
 * __useEditConcreteMixDesignMutation__
 *
 * To run a mutation, you first call `useEditConcreteMixDesignMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditConcreteMixDesignMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editConcreteMixDesignMutation, { data, loading, error }] = useEditConcreteMixDesignMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEditConcreteMixDesignMutation(baseOptions?: Apollo.MutationHookOptions<EditConcreteMixDesignMutation, EditConcreteMixDesignMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditConcreteMixDesignMutation, EditConcreteMixDesignMutationVariables>(EditConcreteMixDesignDocument, options);
      }
export type EditConcreteMixDesignMutationHookResult = ReturnType<typeof useEditConcreteMixDesignMutation>;
export type EditConcreteMixDesignMutationResult = Apollo.MutationResult<EditConcreteMixDesignMutation>;
export type EditConcreteMixDesignMutationOptions = Apollo.BaseMutationOptions<EditConcreteMixDesignMutation, EditConcreteMixDesignMutationVariables>;
export const PayItemConnectionsDocument = gql`
    query PayItemConnections($projectId: String!) {
  project(globalId: $projectId) {
    payItemConnectionGroups(payItemConnectionGroupFieldInput: {deleted: false}) {
      ...PayItemConnectionsGroup
    }
    payItemConnections {
      deleted
      deletedDate
      deletedUser
      id
      name
      order
      group {
        ...PayItemConnectionsGroup
        order
      }
      syncing
      lastAttemptedDate
      lastSyncDate
      lastSyncError {
        message
        stack
      }
      googleSheet {
        headers {
          id
          formattedValue
          order
          visible
        }
        title
        sheetId
        documentId
        compositeId
        url
        payItemColumnKey
      }
    }
  }
}
    ${PayItemConnectionsGroupFragmentDoc}`;

/**
 * __usePayItemConnectionsQuery__
 *
 * To run a query within a React component, call `usePayItemConnectionsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePayItemConnectionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePayItemConnectionsQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function usePayItemConnectionsQuery(baseOptions: Apollo.QueryHookOptions<PayItemConnectionsQuery, PayItemConnectionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PayItemConnectionsQuery, PayItemConnectionsQueryVariables>(PayItemConnectionsDocument, options);
      }
export function usePayItemConnectionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PayItemConnectionsQuery, PayItemConnectionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PayItemConnectionsQuery, PayItemConnectionsQueryVariables>(PayItemConnectionsDocument, options);
        }
export type PayItemConnectionsQueryHookResult = ReturnType<typeof usePayItemConnectionsQuery>;
export type PayItemConnectionsLazyQueryHookResult = ReturnType<typeof usePayItemConnectionsLazyQuery>;
export type PayItemConnectionsQueryResult = Apollo.QueryResult<PayItemConnectionsQuery, PayItemConnectionsQueryVariables>;
export const CreateGoogleSheetPayItemConnectionDocument = gql`
    mutation CreateGoogleSheetPayItemConnection($input: CreateGoogleSheetPayItemConnectionInput!) {
  createGoogleSheetPayItemConnection(
    createGoogleSheetPayItemConnectionInput: $input
  ) {
    googleSheet {
      connection {
        name
      }
    }
  }
}
    `;
export type CreateGoogleSheetPayItemConnectionMutationFn = Apollo.MutationFunction<CreateGoogleSheetPayItemConnectionMutation, CreateGoogleSheetPayItemConnectionMutationVariables>;

/**
 * __useCreateGoogleSheetPayItemConnectionMutation__
 *
 * To run a mutation, you first call `useCreateGoogleSheetPayItemConnectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateGoogleSheetPayItemConnectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createGoogleSheetPayItemConnectionMutation, { data, loading, error }] = useCreateGoogleSheetPayItemConnectionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateGoogleSheetPayItemConnectionMutation(baseOptions?: Apollo.MutationHookOptions<CreateGoogleSheetPayItemConnectionMutation, CreateGoogleSheetPayItemConnectionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateGoogleSheetPayItemConnectionMutation, CreateGoogleSheetPayItemConnectionMutationVariables>(CreateGoogleSheetPayItemConnectionDocument, options);
      }
export type CreateGoogleSheetPayItemConnectionMutationHookResult = ReturnType<typeof useCreateGoogleSheetPayItemConnectionMutation>;
export type CreateGoogleSheetPayItemConnectionMutationResult = Apollo.MutationResult<CreateGoogleSheetPayItemConnectionMutation>;
export type CreateGoogleSheetPayItemConnectionMutationOptions = Apollo.BaseMutationOptions<CreateGoogleSheetPayItemConnectionMutation, CreateGoogleSheetPayItemConnectionMutationVariables>;
export const RemovePayItemConnectionDocument = gql`
    mutation RemovePayItemConnection($id: String!) {
  softRemovePayItemConnection(id: $id) {
    payItemConnection {
      name
      googleSheet {
        title
      }
    }
  }
}
    `;
export type RemovePayItemConnectionMutationFn = Apollo.MutationFunction<RemovePayItemConnectionMutation, RemovePayItemConnectionMutationVariables>;

/**
 * __useRemovePayItemConnectionMutation__
 *
 * To run a mutation, you first call `useRemovePayItemConnectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemovePayItemConnectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removePayItemConnectionMutation, { data, loading, error }] = useRemovePayItemConnectionMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRemovePayItemConnectionMutation(baseOptions?: Apollo.MutationHookOptions<RemovePayItemConnectionMutation, RemovePayItemConnectionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemovePayItemConnectionMutation, RemovePayItemConnectionMutationVariables>(RemovePayItemConnectionDocument, options);
      }
export type RemovePayItemConnectionMutationHookResult = ReturnType<typeof useRemovePayItemConnectionMutation>;
export type RemovePayItemConnectionMutationResult = Apollo.MutationResult<RemovePayItemConnectionMutation>;
export type RemovePayItemConnectionMutationOptions = Apollo.BaseMutationOptions<RemovePayItemConnectionMutation, RemovePayItemConnectionMutationVariables>;
export const RestorePayItemConnectionDocument = gql`
    mutation RestorePayItemConnection($id: String!) {
  restorePayItemConnection(id: $id) {
    payItemConnection {
      name
      googleSheet {
        title
      }
    }
  }
}
    `;
export type RestorePayItemConnectionMutationFn = Apollo.MutationFunction<RestorePayItemConnectionMutation, RestorePayItemConnectionMutationVariables>;

/**
 * __useRestorePayItemConnectionMutation__
 *
 * To run a mutation, you first call `useRestorePayItemConnectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRestorePayItemConnectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [restorePayItemConnectionMutation, { data, loading, error }] = useRestorePayItemConnectionMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRestorePayItemConnectionMutation(baseOptions?: Apollo.MutationHookOptions<RestorePayItemConnectionMutation, RestorePayItemConnectionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RestorePayItemConnectionMutation, RestorePayItemConnectionMutationVariables>(RestorePayItemConnectionDocument, options);
      }
export type RestorePayItemConnectionMutationHookResult = ReturnType<typeof useRestorePayItemConnectionMutation>;
export type RestorePayItemConnectionMutationResult = Apollo.MutationResult<RestorePayItemConnectionMutation>;
export type RestorePayItemConnectionMutationOptions = Apollo.BaseMutationOptions<RestorePayItemConnectionMutation, RestorePayItemConnectionMutationVariables>;
export const PayItemConnectionGroupsDocument = gql`
    query PayItemConnectionGroups($globalId: String!) {
  project(globalId: $globalId) {
    payItemConnections(payItemConnectionFieldInput: {deleted: false}) {
      ...PayItemConnectionGroupsConnection
    }
    payItemConnectionGroups {
      id
      name
      description
      order
      internalConnections {
        internalConnectionId
        order
      }
      connections(payItemConnectionFieldInput: {deleted: false}) {
        ...PayItemConnectionGroupsConnection
        order
      }
      deleted
      deletedDate
      deletedUser
    }
  }
}
    ${PayItemConnectionGroupsConnectionFragmentDoc}`;

/**
 * __usePayItemConnectionGroupsQuery__
 *
 * To run a query within a React component, call `usePayItemConnectionGroupsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePayItemConnectionGroupsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePayItemConnectionGroupsQuery({
 *   variables: {
 *      globalId: // value for 'globalId'
 *   },
 * });
 */
export function usePayItemConnectionGroupsQuery(baseOptions: Apollo.QueryHookOptions<PayItemConnectionGroupsQuery, PayItemConnectionGroupsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PayItemConnectionGroupsQuery, PayItemConnectionGroupsQueryVariables>(PayItemConnectionGroupsDocument, options);
      }
export function usePayItemConnectionGroupsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PayItemConnectionGroupsQuery, PayItemConnectionGroupsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PayItemConnectionGroupsQuery, PayItemConnectionGroupsQueryVariables>(PayItemConnectionGroupsDocument, options);
        }
export type PayItemConnectionGroupsQueryHookResult = ReturnType<typeof usePayItemConnectionGroupsQuery>;
export type PayItemConnectionGroupsLazyQueryHookResult = ReturnType<typeof usePayItemConnectionGroupsLazyQuery>;
export type PayItemConnectionGroupsQueryResult = Apollo.QueryResult<PayItemConnectionGroupsQuery, PayItemConnectionGroupsQueryVariables>;
export const CreatePayItemConnectionGroupDocument = gql`
    mutation CreatePayItemConnectionGroup($input: CreatePayItemConnectionGroupInput!) {
  createPayItemConnectionGroup(createPayItemConnectionGroupInput: $input) {
    payItemConnectionGroup {
      name
    }
  }
}
    `;
export type CreatePayItemConnectionGroupMutationFn = Apollo.MutationFunction<CreatePayItemConnectionGroupMutation, CreatePayItemConnectionGroupMutationVariables>;

/**
 * __useCreatePayItemConnectionGroupMutation__
 *
 * To run a mutation, you first call `useCreatePayItemConnectionGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePayItemConnectionGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPayItemConnectionGroupMutation, { data, loading, error }] = useCreatePayItemConnectionGroupMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreatePayItemConnectionGroupMutation(baseOptions?: Apollo.MutationHookOptions<CreatePayItemConnectionGroupMutation, CreatePayItemConnectionGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreatePayItemConnectionGroupMutation, CreatePayItemConnectionGroupMutationVariables>(CreatePayItemConnectionGroupDocument, options);
      }
export type CreatePayItemConnectionGroupMutationHookResult = ReturnType<typeof useCreatePayItemConnectionGroupMutation>;
export type CreatePayItemConnectionGroupMutationResult = Apollo.MutationResult<CreatePayItemConnectionGroupMutation>;
export type CreatePayItemConnectionGroupMutationOptions = Apollo.BaseMutationOptions<CreatePayItemConnectionGroupMutation, CreatePayItemConnectionGroupMutationVariables>;
export const EditPayItemConnectionGroupDocument = gql`
    mutation EditPayItemConnectionGroup($input: EditPayItemConnectionGroupInput!) {
  editPayItemConnectionGroup(editPayItemConnectionGroupInput: $input) {
    payItemConnectionGroup {
      name
    }
  }
}
    `;
export type EditPayItemConnectionGroupMutationFn = Apollo.MutationFunction<EditPayItemConnectionGroupMutation, EditPayItemConnectionGroupMutationVariables>;

/**
 * __useEditPayItemConnectionGroupMutation__
 *
 * To run a mutation, you first call `useEditPayItemConnectionGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditPayItemConnectionGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editPayItemConnectionGroupMutation, { data, loading, error }] = useEditPayItemConnectionGroupMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEditPayItemConnectionGroupMutation(baseOptions?: Apollo.MutationHookOptions<EditPayItemConnectionGroupMutation, EditPayItemConnectionGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditPayItemConnectionGroupMutation, EditPayItemConnectionGroupMutationVariables>(EditPayItemConnectionGroupDocument, options);
      }
export type EditPayItemConnectionGroupMutationHookResult = ReturnType<typeof useEditPayItemConnectionGroupMutation>;
export type EditPayItemConnectionGroupMutationResult = Apollo.MutationResult<EditPayItemConnectionGroupMutation>;
export type EditPayItemConnectionGroupMutationOptions = Apollo.BaseMutationOptions<EditPayItemConnectionGroupMutation, EditPayItemConnectionGroupMutationVariables>;
export const RemovePayItemConnectionGroupDocument = gql`
    mutation RemovePayItemConnectionGroup($id: String!) {
  softRemovePayItemConnectionGroup(id: $id) {
    payItemConnectionGroup {
      name
    }
  }
}
    `;
export type RemovePayItemConnectionGroupMutationFn = Apollo.MutationFunction<RemovePayItemConnectionGroupMutation, RemovePayItemConnectionGroupMutationVariables>;

/**
 * __useRemovePayItemConnectionGroupMutation__
 *
 * To run a mutation, you first call `useRemovePayItemConnectionGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemovePayItemConnectionGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removePayItemConnectionGroupMutation, { data, loading, error }] = useRemovePayItemConnectionGroupMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRemovePayItemConnectionGroupMutation(baseOptions?: Apollo.MutationHookOptions<RemovePayItemConnectionGroupMutation, RemovePayItemConnectionGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemovePayItemConnectionGroupMutation, RemovePayItemConnectionGroupMutationVariables>(RemovePayItemConnectionGroupDocument, options);
      }
export type RemovePayItemConnectionGroupMutationHookResult = ReturnType<typeof useRemovePayItemConnectionGroupMutation>;
export type RemovePayItemConnectionGroupMutationResult = Apollo.MutationResult<RemovePayItemConnectionGroupMutation>;
export type RemovePayItemConnectionGroupMutationOptions = Apollo.BaseMutationOptions<RemovePayItemConnectionGroupMutation, RemovePayItemConnectionGroupMutationVariables>;
export const RestorePayItemConnectionGroupDocument = gql`
    mutation RestorePayItemConnectionGroup($id: String!) {
  restorePayItemConnectionGroup(id: $id) {
    payItemConnectionGroup {
      name
    }
  }
}
    `;
export type RestorePayItemConnectionGroupMutationFn = Apollo.MutationFunction<RestorePayItemConnectionGroupMutation, RestorePayItemConnectionGroupMutationVariables>;

/**
 * __useRestorePayItemConnectionGroupMutation__
 *
 * To run a mutation, you first call `useRestorePayItemConnectionGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRestorePayItemConnectionGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [restorePayItemConnectionGroupMutation, { data, loading, error }] = useRestorePayItemConnectionGroupMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRestorePayItemConnectionGroupMutation(baseOptions?: Apollo.MutationHookOptions<RestorePayItemConnectionGroupMutation, RestorePayItemConnectionGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RestorePayItemConnectionGroupMutation, RestorePayItemConnectionGroupMutationVariables>(RestorePayItemConnectionGroupDocument, options);
      }
export type RestorePayItemConnectionGroupMutationHookResult = ReturnType<typeof useRestorePayItemConnectionGroupMutation>;
export type RestorePayItemConnectionGroupMutationResult = Apollo.MutationResult<RestorePayItemConnectionGroupMutation>;
export type RestorePayItemConnectionGroupMutationOptions = Apollo.BaseMutationOptions<RestorePayItemConnectionGroupMutation, RestorePayItemConnectionGroupMutationVariables>;
export const InternalPayItemConnectionsDocument = gql`
    query InternalPayItemConnections($projectId: String!) {
  project(globalId: $projectId) {
    payItemConnectionGroups(payItemConnectionGroupFieldInput: {deleted: false}) {
      ...InternalPayItemConnectionsGroup
    }
    projectToInternalConnections {
      order
      group {
        ...InternalPayItemConnectionsGroup
        order
      }
      internalConnectionId
    }
  }
}
    ${InternalPayItemConnectionsGroupFragmentDoc}`;

/**
 * __useInternalPayItemConnectionsQuery__
 *
 * To run a query within a React component, call `useInternalPayItemConnectionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useInternalPayItemConnectionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInternalPayItemConnectionsQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useInternalPayItemConnectionsQuery(baseOptions: Apollo.QueryHookOptions<InternalPayItemConnectionsQuery, InternalPayItemConnectionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InternalPayItemConnectionsQuery, InternalPayItemConnectionsQueryVariables>(InternalPayItemConnectionsDocument, options);
      }
export function useInternalPayItemConnectionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InternalPayItemConnectionsQuery, InternalPayItemConnectionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InternalPayItemConnectionsQuery, InternalPayItemConnectionsQueryVariables>(InternalPayItemConnectionsDocument, options);
        }
export type InternalPayItemConnectionsQueryHookResult = ReturnType<typeof useInternalPayItemConnectionsQuery>;
export type InternalPayItemConnectionsLazyQueryHookResult = ReturnType<typeof useInternalPayItemConnectionsLazyQuery>;
export type InternalPayItemConnectionsQueryResult = Apollo.QueryResult<InternalPayItemConnectionsQuery, InternalPayItemConnectionsQueryVariables>;
export const EditProjectToGroupToInternalDocument = gql`
    mutation EditProjectToGroupToInternal($input: EditProjectToInternalConnectionInput!) {
  editProjectToInternalConnection(editProjectToInternalConnectionInput: $input) {
    projectToInternalConnection {
      internalConnection
    }
  }
}
    `;
export type EditProjectToGroupToInternalMutationFn = Apollo.MutationFunction<EditProjectToGroupToInternalMutation, EditProjectToGroupToInternalMutationVariables>;

/**
 * __useEditProjectToGroupToInternalMutation__
 *
 * To run a mutation, you first call `useEditProjectToGroupToInternalMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditProjectToGroupToInternalMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editProjectToGroupToInternalMutation, { data, loading, error }] = useEditProjectToGroupToInternalMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEditProjectToGroupToInternalMutation(baseOptions?: Apollo.MutationHookOptions<EditProjectToGroupToInternalMutation, EditProjectToGroupToInternalMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditProjectToGroupToInternalMutation, EditProjectToGroupToInternalMutationVariables>(EditProjectToGroupToInternalDocument, options);
      }
export type EditProjectToGroupToInternalMutationHookResult = ReturnType<typeof useEditProjectToGroupToInternalMutation>;
export type EditProjectToGroupToInternalMutationResult = Apollo.MutationResult<EditProjectToGroupToInternalMutation>;
export type EditProjectToGroupToInternalMutationOptions = Apollo.BaseMutationOptions<EditProjectToGroupToInternalMutation, EditProjectToGroupToInternalMutationVariables>;
export const GoogleSheetPayItemConnectionDocument = gql`
    query GoogleSheetPayItemConnection($connectionId: String!, $globalId: String!) {
  googleSheetPayItemConnection(connectionId: $connectionId) {
    connectionId
    title
    compositeId
    url
    headers {
      ...GoogleSheetPayItemConnectionHeader
      visible
      order
    }
    records(payItemGlobalId: $globalId) {
      headers {
        ...GoogleSheetPayItemConnectionHeader
        hyperlink
        note
      }
      cells {
        id
        headerId
        formattedValue
        hyperlink
        note
      }
    }
  }
}
    ${GoogleSheetPayItemConnectionHeaderFragmentDoc}`;

/**
 * __useGoogleSheetPayItemConnectionQuery__
 *
 * To run a query within a React component, call `useGoogleSheetPayItemConnectionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGoogleSheetPayItemConnectionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGoogleSheetPayItemConnectionQuery({
 *   variables: {
 *      connectionId: // value for 'connectionId'
 *      globalId: // value for 'globalId'
 *   },
 * });
 */
export function useGoogleSheetPayItemConnectionQuery(baseOptions: Apollo.QueryHookOptions<GoogleSheetPayItemConnectionQuery, GoogleSheetPayItemConnectionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GoogleSheetPayItemConnectionQuery, GoogleSheetPayItemConnectionQueryVariables>(GoogleSheetPayItemConnectionDocument, options);
      }
export function useGoogleSheetPayItemConnectionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GoogleSheetPayItemConnectionQuery, GoogleSheetPayItemConnectionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GoogleSheetPayItemConnectionQuery, GoogleSheetPayItemConnectionQueryVariables>(GoogleSheetPayItemConnectionDocument, options);
        }
export type GoogleSheetPayItemConnectionQueryHookResult = ReturnType<typeof useGoogleSheetPayItemConnectionQuery>;
export type GoogleSheetPayItemConnectionLazyQueryHookResult = ReturnType<typeof useGoogleSheetPayItemConnectionLazyQuery>;
export type GoogleSheetPayItemConnectionQueryResult = Apollo.QueryResult<GoogleSheetPayItemConnectionQuery, GoogleSheetPayItemConnectionQueryVariables>;
export const PayItemSummarySiderCountsDocument = gql`
    query PayItemSummarySiderCounts($projectId: String!, $input: PayItemSummaryCountsInput!) {
  project(globalId: $projectId) {
    payItemSummaryCounts(payItemSummaryCountsInput: $input) {
      internalConnections {
        count
        internalConnectionId
        groupId
      }
      payItemConnections {
        count
        payItemConnection {
          id
          name
          groupId
          googleSheet {
            title
            compositeId
          }
        }
      }
    }
  }
}
    `;

/**
 * __usePayItemSummarySiderCountsQuery__
 *
 * To run a query within a React component, call `usePayItemSummarySiderCountsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePayItemSummarySiderCountsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePayItemSummarySiderCountsQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePayItemSummarySiderCountsQuery(baseOptions: Apollo.QueryHookOptions<PayItemSummarySiderCountsQuery, PayItemSummarySiderCountsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PayItemSummarySiderCountsQuery, PayItemSummarySiderCountsQueryVariables>(PayItemSummarySiderCountsDocument, options);
      }
export function usePayItemSummarySiderCountsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PayItemSummarySiderCountsQuery, PayItemSummarySiderCountsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PayItemSummarySiderCountsQuery, PayItemSummarySiderCountsQueryVariables>(PayItemSummarySiderCountsDocument, options);
        }
export type PayItemSummarySiderCountsQueryHookResult = ReturnType<typeof usePayItemSummarySiderCountsQuery>;
export type PayItemSummarySiderCountsLazyQueryHookResult = ReturnType<typeof usePayItemSummarySiderCountsLazyQuery>;
export type PayItemSummarySiderCountsQueryResult = Apollo.QueryResult<PayItemSummarySiderCountsQuery, PayItemSummarySiderCountsQueryVariables>;
export const EditPayItemSummaryOrderDocument = gql`
    mutation EditPayItemSummaryOrder($input: EditPayItemSummaryOrderInput!) {
  editPayItemSummaryOrder(editPayItemSummaryOrderInput: $input) {
    project {
      projectName
    }
  }
}
    `;
export type EditPayItemSummaryOrderMutationFn = Apollo.MutationFunction<EditPayItemSummaryOrderMutation, EditPayItemSummaryOrderMutationVariables>;

/**
 * __useEditPayItemSummaryOrderMutation__
 *
 * To run a mutation, you first call `useEditPayItemSummaryOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditPayItemSummaryOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editPayItemSummaryOrderMutation, { data, loading, error }] = useEditPayItemSummaryOrderMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEditPayItemSummaryOrderMutation(baseOptions?: Apollo.MutationHookOptions<EditPayItemSummaryOrderMutation, EditPayItemSummaryOrderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditPayItemSummaryOrderMutation, EditPayItemSummaryOrderMutationVariables>(EditPayItemSummaryOrderDocument, options);
      }
export type EditPayItemSummaryOrderMutationHookResult = ReturnType<typeof useEditPayItemSummaryOrderMutation>;
export type EditPayItemSummaryOrderMutationResult = Apollo.MutationResult<EditPayItemSummaryOrderMutation>;
export type EditPayItemSummaryOrderMutationOptions = Apollo.BaseMutationOptions<EditPayItemSummaryOrderMutation, EditPayItemSummaryOrderMutationVariables>;
export const PayItemSummaryDocument = gql`
    query PayItemSummary($projectId: String!) {
  project(globalId: $projectId) {
    payItemConnections(payItemConnectionFieldInput: {deleted: false}) {
      id
      order
      name
      groupId
      googleSheet {
        title
        compositeId
      }
    }
    projectToInternalConnections {
      internalConnectionId
      groupId
      order
    }
    payItemConnectionGroups(payItemConnectionGroupFieldInput: {deleted: false}) {
      id
      name
      description
      order
    }
  }
}
    `;

/**
 * __usePayItemSummaryQuery__
 *
 * To run a query within a React component, call `usePayItemSummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `usePayItemSummaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePayItemSummaryQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function usePayItemSummaryQuery(baseOptions: Apollo.QueryHookOptions<PayItemSummaryQuery, PayItemSummaryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PayItemSummaryQuery, PayItemSummaryQueryVariables>(PayItemSummaryDocument, options);
      }
export function usePayItemSummaryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PayItemSummaryQuery, PayItemSummaryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PayItemSummaryQuery, PayItemSummaryQueryVariables>(PayItemSummaryDocument, options);
        }
export type PayItemSummaryQueryHookResult = ReturnType<typeof usePayItemSummaryQuery>;
export type PayItemSummaryLazyQueryHookResult = ReturnType<typeof usePayItemSummaryLazyQuery>;
export type PayItemSummaryQueryResult = Apollo.QueryResult<PayItemSummaryQuery, PayItemSummaryQueryVariables>;
export const EditGoogleSheetPayItemConnectionDocument = gql`
    mutation EditGoogleSheetPayItemConnection($input: EditGoogleSheetPayItemConnectionInput!) {
  editGoogleSheetPayItemConnection(editGoogleSheetPayItemConnectionInput: $input) {
    googleSheet {
      title
      connection {
        name
      }
    }
  }
}
    `;
export type EditGoogleSheetPayItemConnectionMutationFn = Apollo.MutationFunction<EditGoogleSheetPayItemConnectionMutation, EditGoogleSheetPayItemConnectionMutationVariables>;

/**
 * __useEditGoogleSheetPayItemConnectionMutation__
 *
 * To run a mutation, you first call `useEditGoogleSheetPayItemConnectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditGoogleSheetPayItemConnectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editGoogleSheetPayItemConnectionMutation, { data, loading, error }] = useEditGoogleSheetPayItemConnectionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEditGoogleSheetPayItemConnectionMutation(baseOptions?: Apollo.MutationHookOptions<EditGoogleSheetPayItemConnectionMutation, EditGoogleSheetPayItemConnectionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditGoogleSheetPayItemConnectionMutation, EditGoogleSheetPayItemConnectionMutationVariables>(EditGoogleSheetPayItemConnectionDocument, options);
      }
export type EditGoogleSheetPayItemConnectionMutationHookResult = ReturnType<typeof useEditGoogleSheetPayItemConnectionMutation>;
export type EditGoogleSheetPayItemConnectionMutationResult = Apollo.MutationResult<EditGoogleSheetPayItemConnectionMutation>;
export type EditGoogleSheetPayItemConnectionMutationOptions = Apollo.BaseMutationOptions<EditGoogleSheetPayItemConnectionMutation, EditGoogleSheetPayItemConnectionMutationVariables>;
export const SyncGoogleSheetPayItemConnectionDocument = gql`
    mutation SyncGoogleSheetPayItemConnection($input: SyncGoogleSheetPayItemConnectionInput!) {
  syncGoogleSheetPayItemConnection(syncGoogleSheetPayItemConnectionInput: $input) {
    googleSheet {
      title
      compositeId
    }
  }
}
    `;
export type SyncGoogleSheetPayItemConnectionMutationFn = Apollo.MutationFunction<SyncGoogleSheetPayItemConnectionMutation, SyncGoogleSheetPayItemConnectionMutationVariables>;

/**
 * __useSyncGoogleSheetPayItemConnectionMutation__
 *
 * To run a mutation, you first call `useSyncGoogleSheetPayItemConnectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSyncGoogleSheetPayItemConnectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [syncGoogleSheetPayItemConnectionMutation, { data, loading, error }] = useSyncGoogleSheetPayItemConnectionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSyncGoogleSheetPayItemConnectionMutation(baseOptions?: Apollo.MutationHookOptions<SyncGoogleSheetPayItemConnectionMutation, SyncGoogleSheetPayItemConnectionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SyncGoogleSheetPayItemConnectionMutation, SyncGoogleSheetPayItemConnectionMutationVariables>(SyncGoogleSheetPayItemConnectionDocument, options);
      }
export type SyncGoogleSheetPayItemConnectionMutationHookResult = ReturnType<typeof useSyncGoogleSheetPayItemConnectionMutation>;
export type SyncGoogleSheetPayItemConnectionMutationResult = Apollo.MutationResult<SyncGoogleSheetPayItemConnectionMutation>;
export type SyncGoogleSheetPayItemConnectionMutationOptions = Apollo.BaseMutationOptions<SyncGoogleSheetPayItemConnectionMutation, SyncGoogleSheetPayItemConnectionMutationVariables>;
export const RfiNotificationsDocument = gql`
    query RFINotifications($projectId: String!) {
  project(globalId: $projectId) {
    rfiResponseDisciplines(rfiResponseDisciplineFieldInput: {deleted: false}) {
      name
      id
      description
      users {
        ...RFINotificationsUser
      }
    }
    rfiNotifications {
      notificationEventId
      recipients {
        every {
          ...RFINotificationsRecipients
        }
        byResponseDiscipline {
          responseDiscipline {
            id
            name
          }
          recipients {
            ...RFINotificationsRecipients
          }
        }
      }
    }
    requestsForInformation(requestForInformationFieldInput: {deleted: false}) {
      submittedBy {
        ...RFINotificationsUser
      }
    }
  }
}
    ${RfiNotificationsUserFragmentDoc}
${RfiNotificationsRecipientsFragmentDoc}`;

/**
 * __useRfiNotificationsQuery__
 *
 * To run a query within a React component, call `useRfiNotificationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useRfiNotificationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRfiNotificationsQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useRfiNotificationsQuery(baseOptions: Apollo.QueryHookOptions<RfiNotificationsQuery, RfiNotificationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RfiNotificationsQuery, RfiNotificationsQueryVariables>(RfiNotificationsDocument, options);
      }
export function useRfiNotificationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RfiNotificationsQuery, RfiNotificationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RfiNotificationsQuery, RfiNotificationsQueryVariables>(RfiNotificationsDocument, options);
        }
export type RfiNotificationsQueryHookResult = ReturnType<typeof useRfiNotificationsQuery>;
export type RfiNotificationsLazyQueryHookResult = ReturnType<typeof useRfiNotificationsLazyQuery>;
export type RfiNotificationsQueryResult = Apollo.QueryResult<RfiNotificationsQuery, RfiNotificationsQueryVariables>;
export const EditRfiNotificationDocument = gql`
    mutation EditRFINotification($input: EditRFINotificationInput!) {
  editRFINotification(editRFINotificationInput: $input) {
    notification {
      notificationEvent
    }
  }
}
    `;
export type EditRfiNotificationMutationFn = Apollo.MutationFunction<EditRfiNotificationMutation, EditRfiNotificationMutationVariables>;

/**
 * __useEditRfiNotificationMutation__
 *
 * To run a mutation, you first call `useEditRfiNotificationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditRfiNotificationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editRfiNotificationMutation, { data, loading, error }] = useEditRfiNotificationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEditRfiNotificationMutation(baseOptions?: Apollo.MutationHookOptions<EditRfiNotificationMutation, EditRfiNotificationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditRfiNotificationMutation, EditRfiNotificationMutationVariables>(EditRfiNotificationDocument, options);
      }
export type EditRfiNotificationMutationHookResult = ReturnType<typeof useEditRfiNotificationMutation>;
export type EditRfiNotificationMutationResult = Apollo.MutationResult<EditRfiNotificationMutation>;
export type EditRfiNotificationMutationOptions = Apollo.BaseMutationOptions<EditRfiNotificationMutation, EditRfiNotificationMutationVariables>;
export const CreateRfiOrganizationDocument = gql`
    mutation CreateRFIOrganization($createRfiOrganizationInput: CreateRFIOrganizationInput!) {
  createRFIOrganization(createRFIOrganizationInput: $createRfiOrganizationInput) {
    organization {
      name
    }
  }
}
    `;
export type CreateRfiOrganizationMutationFn = Apollo.MutationFunction<CreateRfiOrganizationMutation, CreateRfiOrganizationMutationVariables>;

/**
 * __useCreateRfiOrganizationMutation__
 *
 * To run a mutation, you first call `useCreateRfiOrganizationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateRfiOrganizationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createRfiOrganizationMutation, { data, loading, error }] = useCreateRfiOrganizationMutation({
 *   variables: {
 *      createRfiOrganizationInput: // value for 'createRfiOrganizationInput'
 *   },
 * });
 */
export function useCreateRfiOrganizationMutation(baseOptions?: Apollo.MutationHookOptions<CreateRfiOrganizationMutation, CreateRfiOrganizationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateRfiOrganizationMutation, CreateRfiOrganizationMutationVariables>(CreateRfiOrganizationDocument, options);
      }
export type CreateRfiOrganizationMutationHookResult = ReturnType<typeof useCreateRfiOrganizationMutation>;
export type CreateRfiOrganizationMutationResult = Apollo.MutationResult<CreateRfiOrganizationMutation>;
export type CreateRfiOrganizationMutationOptions = Apollo.BaseMutationOptions<CreateRfiOrganizationMutation, CreateRfiOrganizationMutationVariables>;
export const EditRfiOrganizationDocument = gql`
    mutation EditRFIOrganization($editRfiOrganizationInput: EditRFIOrganizationInput!) {
  editRFIOrganization(editRFIOrganizationInput: $editRfiOrganizationInput) {
    organization {
      name
    }
  }
}
    `;
export type EditRfiOrganizationMutationFn = Apollo.MutationFunction<EditRfiOrganizationMutation, EditRfiOrganizationMutationVariables>;

/**
 * __useEditRfiOrganizationMutation__
 *
 * To run a mutation, you first call `useEditRfiOrganizationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditRfiOrganizationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editRfiOrganizationMutation, { data, loading, error }] = useEditRfiOrganizationMutation({
 *   variables: {
 *      editRfiOrganizationInput: // value for 'editRfiOrganizationInput'
 *   },
 * });
 */
export function useEditRfiOrganizationMutation(baseOptions?: Apollo.MutationHookOptions<EditRfiOrganizationMutation, EditRfiOrganizationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditRfiOrganizationMutation, EditRfiOrganizationMutationVariables>(EditRfiOrganizationDocument, options);
      }
export type EditRfiOrganizationMutationHookResult = ReturnType<typeof useEditRfiOrganizationMutation>;
export type EditRfiOrganizationMutationResult = Apollo.MutationResult<EditRfiOrganizationMutation>;
export type EditRfiOrganizationMutationOptions = Apollo.BaseMutationOptions<EditRfiOrganizationMutation, EditRfiOrganizationMutationVariables>;
export const SoftRemoveRfiOrganizationDocument = gql`
    mutation SoftRemoveRFIOrganization($id: String!) {
  softRemoveRFIOrganization(id: $id) {
    organization {
      name
    }
  }
}
    `;
export type SoftRemoveRfiOrganizationMutationFn = Apollo.MutationFunction<SoftRemoveRfiOrganizationMutation, SoftRemoveRfiOrganizationMutationVariables>;

/**
 * __useSoftRemoveRfiOrganizationMutation__
 *
 * To run a mutation, you first call `useSoftRemoveRfiOrganizationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSoftRemoveRfiOrganizationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [softRemoveRfiOrganizationMutation, { data, loading, error }] = useSoftRemoveRfiOrganizationMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSoftRemoveRfiOrganizationMutation(baseOptions?: Apollo.MutationHookOptions<SoftRemoveRfiOrganizationMutation, SoftRemoveRfiOrganizationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SoftRemoveRfiOrganizationMutation, SoftRemoveRfiOrganizationMutationVariables>(SoftRemoveRfiOrganizationDocument, options);
      }
export type SoftRemoveRfiOrganizationMutationHookResult = ReturnType<typeof useSoftRemoveRfiOrganizationMutation>;
export type SoftRemoveRfiOrganizationMutationResult = Apollo.MutationResult<SoftRemoveRfiOrganizationMutation>;
export type SoftRemoveRfiOrganizationMutationOptions = Apollo.BaseMutationOptions<SoftRemoveRfiOrganizationMutation, SoftRemoveRfiOrganizationMutationVariables>;
export const RestoreRfiOrganizationDocument = gql`
    mutation RestoreRFIOrganization($id: String!) {
  restoreRFIOrganization(id: $id) {
    organization {
      name
    }
  }
}
    `;
export type RestoreRfiOrganizationMutationFn = Apollo.MutationFunction<RestoreRfiOrganizationMutation, RestoreRfiOrganizationMutationVariables>;

/**
 * __useRestoreRfiOrganizationMutation__
 *
 * To run a mutation, you first call `useRestoreRfiOrganizationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRestoreRfiOrganizationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [restoreRfiOrganizationMutation, { data, loading, error }] = useRestoreRfiOrganizationMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRestoreRfiOrganizationMutation(baseOptions?: Apollo.MutationHookOptions<RestoreRfiOrganizationMutation, RestoreRfiOrganizationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RestoreRfiOrganizationMutation, RestoreRfiOrganizationMutationVariables>(RestoreRfiOrganizationDocument, options);
      }
export type RestoreRfiOrganizationMutationHookResult = ReturnType<typeof useRestoreRfiOrganizationMutation>;
export type RestoreRfiOrganizationMutationResult = Apollo.MutationResult<RestoreRfiOrganizationMutation>;
export type RestoreRfiOrganizationMutationOptions = Apollo.BaseMutationOptions<RestoreRfiOrganizationMutation, RestoreRfiOrganizationMutationVariables>;
export const GetRfiOrganizationsDocument = gql`
    query GetRFIOrganizations($rfiOrganizationListInput: RFIOrganizationListInput!) {
  rfiOrganizations(rfiOrganizationListInput: $rfiOrganizationListInput) {
    records {
      id
      name
      description
      deleted
      deletedDate
      deletedUser
      requestsForInformation {
        id
        formattedNumber
        deleted
      }
    }
  }
}
    `;

/**
 * __useGetRfiOrganizationsQuery__
 *
 * To run a query within a React component, call `useGetRfiOrganizationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRfiOrganizationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRfiOrganizationsQuery({
 *   variables: {
 *      rfiOrganizationListInput: // value for 'rfiOrganizationListInput'
 *   },
 * });
 */
export function useGetRfiOrganizationsQuery(baseOptions: Apollo.QueryHookOptions<GetRfiOrganizationsQuery, GetRfiOrganizationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRfiOrganizationsQuery, GetRfiOrganizationsQueryVariables>(GetRfiOrganizationsDocument, options);
      }
export function useGetRfiOrganizationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRfiOrganizationsQuery, GetRfiOrganizationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRfiOrganizationsQuery, GetRfiOrganizationsQueryVariables>(GetRfiOrganizationsDocument, options);
        }
export type GetRfiOrganizationsQueryHookResult = ReturnType<typeof useGetRfiOrganizationsQuery>;
export type GetRfiOrganizationsLazyQueryHookResult = ReturnType<typeof useGetRfiOrganizationsLazyQuery>;
export type GetRfiOrganizationsQueryResult = Apollo.QueryResult<GetRfiOrganizationsQuery, GetRfiOrganizationsQueryVariables>;
export const CreateRfiQuickLinkDocument = gql`
    mutation CreateRFIQuickLink($input: CreateRFIQuickLinkInput!) {
  createRFIQuickLink(createRFIQuickLinkInput: $input) {
    rfiQuickLink {
      label
    }
  }
}
    `;
export type CreateRfiQuickLinkMutationFn = Apollo.MutationFunction<CreateRfiQuickLinkMutation, CreateRfiQuickLinkMutationVariables>;

/**
 * __useCreateRfiQuickLinkMutation__
 *
 * To run a mutation, you first call `useCreateRfiQuickLinkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateRfiQuickLinkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createRfiQuickLinkMutation, { data, loading, error }] = useCreateRfiQuickLinkMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateRfiQuickLinkMutation(baseOptions?: Apollo.MutationHookOptions<CreateRfiQuickLinkMutation, CreateRfiQuickLinkMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateRfiQuickLinkMutation, CreateRfiQuickLinkMutationVariables>(CreateRfiQuickLinkDocument, options);
      }
export type CreateRfiQuickLinkMutationHookResult = ReturnType<typeof useCreateRfiQuickLinkMutation>;
export type CreateRfiQuickLinkMutationResult = Apollo.MutationResult<CreateRfiQuickLinkMutation>;
export type CreateRfiQuickLinkMutationOptions = Apollo.BaseMutationOptions<CreateRfiQuickLinkMutation, CreateRfiQuickLinkMutationVariables>;
export const EditRfiQuickLinkDocument = gql`
    mutation EditRFIQuickLink($input: EditRFIQuickLinkInput!) {
  editRFIQuickLink(editRFIQuickLinkInput: $input) {
    rfiQuickLink {
      label
    }
  }
}
    `;
export type EditRfiQuickLinkMutationFn = Apollo.MutationFunction<EditRfiQuickLinkMutation, EditRfiQuickLinkMutationVariables>;

/**
 * __useEditRfiQuickLinkMutation__
 *
 * To run a mutation, you first call `useEditRfiQuickLinkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditRfiQuickLinkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editRfiQuickLinkMutation, { data, loading, error }] = useEditRfiQuickLinkMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEditRfiQuickLinkMutation(baseOptions?: Apollo.MutationHookOptions<EditRfiQuickLinkMutation, EditRfiQuickLinkMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditRfiQuickLinkMutation, EditRfiQuickLinkMutationVariables>(EditRfiQuickLinkDocument, options);
      }
export type EditRfiQuickLinkMutationHookResult = ReturnType<typeof useEditRfiQuickLinkMutation>;
export type EditRfiQuickLinkMutationResult = Apollo.MutationResult<EditRfiQuickLinkMutation>;
export type EditRfiQuickLinkMutationOptions = Apollo.BaseMutationOptions<EditRfiQuickLinkMutation, EditRfiQuickLinkMutationVariables>;
export const GetRfiQuickLinksDocument = gql`
    query GetRFIQuickLinks($input: RFIQuickLinkListInput!) {
  rfiQuickLinks(rfiQuickLinkListInput: $input) {
    records {
      id
      label
      href
      description
      deleted
      deletedDate
      deletedUser
    }
  }
}
    `;

/**
 * __useGetRfiQuickLinksQuery__
 *
 * To run a query within a React component, call `useGetRfiQuickLinksQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRfiQuickLinksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRfiQuickLinksQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetRfiQuickLinksQuery(baseOptions: Apollo.QueryHookOptions<GetRfiQuickLinksQuery, GetRfiQuickLinksQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRfiQuickLinksQuery, GetRfiQuickLinksQueryVariables>(GetRfiQuickLinksDocument, options);
      }
export function useGetRfiQuickLinksLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRfiQuickLinksQuery, GetRfiQuickLinksQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRfiQuickLinksQuery, GetRfiQuickLinksQueryVariables>(GetRfiQuickLinksDocument, options);
        }
export type GetRfiQuickLinksQueryHookResult = ReturnType<typeof useGetRfiQuickLinksQuery>;
export type GetRfiQuickLinksLazyQueryHookResult = ReturnType<typeof useGetRfiQuickLinksLazyQuery>;
export type GetRfiQuickLinksQueryResult = Apollo.QueryResult<GetRfiQuickLinksQuery, GetRfiQuickLinksQueryVariables>;
export const RestoreRfiQuickLinkDocument = gql`
    mutation RestoreRFIQuickLink($id: String!) {
  restoreRFIQuickLink(id: $id) {
    rfiQuickLink {
      label
    }
  }
}
    `;
export type RestoreRfiQuickLinkMutationFn = Apollo.MutationFunction<RestoreRfiQuickLinkMutation, RestoreRfiQuickLinkMutationVariables>;

/**
 * __useRestoreRfiQuickLinkMutation__
 *
 * To run a mutation, you first call `useRestoreRfiQuickLinkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRestoreRfiQuickLinkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [restoreRfiQuickLinkMutation, { data, loading, error }] = useRestoreRfiQuickLinkMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRestoreRfiQuickLinkMutation(baseOptions?: Apollo.MutationHookOptions<RestoreRfiQuickLinkMutation, RestoreRfiQuickLinkMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RestoreRfiQuickLinkMutation, RestoreRfiQuickLinkMutationVariables>(RestoreRfiQuickLinkDocument, options);
      }
export type RestoreRfiQuickLinkMutationHookResult = ReturnType<typeof useRestoreRfiQuickLinkMutation>;
export type RestoreRfiQuickLinkMutationResult = Apollo.MutationResult<RestoreRfiQuickLinkMutation>;
export type RestoreRfiQuickLinkMutationOptions = Apollo.BaseMutationOptions<RestoreRfiQuickLinkMutation, RestoreRfiQuickLinkMutationVariables>;
export const SoftRemoveRfiQuickLinkDocument = gql`
    mutation SoftRemoveRFIQuickLink($id: String!) {
  softRemoveRFIQuickLink(id: $id) {
    rfiQuickLink {
      label
    }
  }
}
    `;
export type SoftRemoveRfiQuickLinkMutationFn = Apollo.MutationFunction<SoftRemoveRfiQuickLinkMutation, SoftRemoveRfiQuickLinkMutationVariables>;

/**
 * __useSoftRemoveRfiQuickLinkMutation__
 *
 * To run a mutation, you first call `useSoftRemoveRfiQuickLinkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSoftRemoveRfiQuickLinkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [softRemoveRfiQuickLinkMutation, { data, loading, error }] = useSoftRemoveRfiQuickLinkMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSoftRemoveRfiQuickLinkMutation(baseOptions?: Apollo.MutationHookOptions<SoftRemoveRfiQuickLinkMutation, SoftRemoveRfiQuickLinkMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SoftRemoveRfiQuickLinkMutation, SoftRemoveRfiQuickLinkMutationVariables>(SoftRemoveRfiQuickLinkDocument, options);
      }
export type SoftRemoveRfiQuickLinkMutationHookResult = ReturnType<typeof useSoftRemoveRfiQuickLinkMutation>;
export type SoftRemoveRfiQuickLinkMutationResult = Apollo.MutationResult<SoftRemoveRfiQuickLinkMutation>;
export type SoftRemoveRfiQuickLinkMutationOptions = Apollo.BaseMutationOptions<SoftRemoveRfiQuickLinkMutation, SoftRemoveRfiQuickLinkMutationVariables>;
export const CreateRfiResponseDocument = gql`
    mutation CreateRFIResponse($createRfiResponseInput: CreateRFIResponseInput!) {
  createRFIResponse(createRFIResponseInput: $createRfiResponseInput) {
    response {
      createdUser
    }
  }
}
    `;
export type CreateRfiResponseMutationFn = Apollo.MutationFunction<CreateRfiResponseMutation, CreateRfiResponseMutationVariables>;

/**
 * __useCreateRfiResponseMutation__
 *
 * To run a mutation, you first call `useCreateRfiResponseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateRfiResponseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createRfiResponseMutation, { data, loading, error }] = useCreateRfiResponseMutation({
 *   variables: {
 *      createRfiResponseInput: // value for 'createRfiResponseInput'
 *   },
 * });
 */
export function useCreateRfiResponseMutation(baseOptions?: Apollo.MutationHookOptions<CreateRfiResponseMutation, CreateRfiResponseMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateRfiResponseMutation, CreateRfiResponseMutationVariables>(CreateRfiResponseDocument, options);
      }
export type CreateRfiResponseMutationHookResult = ReturnType<typeof useCreateRfiResponseMutation>;
export type CreateRfiResponseMutationResult = Apollo.MutationResult<CreateRfiResponseMutation>;
export type CreateRfiResponseMutationOptions = Apollo.BaseMutationOptions<CreateRfiResponseMutation, CreateRfiResponseMutationVariables>;
export const DraftRequestForInformationDocument = gql`
    mutation DraftRequestForInformation($draftRequestForInformationInput: DraftRequestForInformationInput!) {
  draftRequestForInformation(
    draftRequestForInformationInput: $draftRequestForInformationInput
  ) {
    requestForInformation {
      formattedNumber
    }
  }
}
    `;
export type DraftRequestForInformationMutationFn = Apollo.MutationFunction<DraftRequestForInformationMutation, DraftRequestForInformationMutationVariables>;

/**
 * __useDraftRequestForInformationMutation__
 *
 * To run a mutation, you first call `useDraftRequestForInformationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDraftRequestForInformationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [draftRequestForInformationMutation, { data, loading, error }] = useDraftRequestForInformationMutation({
 *   variables: {
 *      draftRequestForInformationInput: // value for 'draftRequestForInformationInput'
 *   },
 * });
 */
export function useDraftRequestForInformationMutation(baseOptions?: Apollo.MutationHookOptions<DraftRequestForInformationMutation, DraftRequestForInformationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DraftRequestForInformationMutation, DraftRequestForInformationMutationVariables>(DraftRequestForInformationDocument, options);
      }
export type DraftRequestForInformationMutationHookResult = ReturnType<typeof useDraftRequestForInformationMutation>;
export type DraftRequestForInformationMutationResult = Apollo.MutationResult<DraftRequestForInformationMutation>;
export type DraftRequestForInformationMutationOptions = Apollo.BaseMutationOptions<DraftRequestForInformationMutation, DraftRequestForInformationMutationVariables>;
export const SubmitRequestForInformationDocument = gql`
    mutation SubmitRequestForInformation($submitRequestForInformationInput: SubmitRequestForInformationInput!) {
  submitRequestForInformation(
    submitRequestForInformationInput: $submitRequestForInformationInput
  ) {
    requestForInformation {
      formattedNumber
    }
  }
}
    `;
export type SubmitRequestForInformationMutationFn = Apollo.MutationFunction<SubmitRequestForInformationMutation, SubmitRequestForInformationMutationVariables>;

/**
 * __useSubmitRequestForInformationMutation__
 *
 * To run a mutation, you first call `useSubmitRequestForInformationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubmitRequestForInformationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [submitRequestForInformationMutation, { data, loading, error }] = useSubmitRequestForInformationMutation({
 *   variables: {
 *      submitRequestForInformationInput: // value for 'submitRequestForInformationInput'
 *   },
 * });
 */
export function useSubmitRequestForInformationMutation(baseOptions?: Apollo.MutationHookOptions<SubmitRequestForInformationMutation, SubmitRequestForInformationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SubmitRequestForInformationMutation, SubmitRequestForInformationMutationVariables>(SubmitRequestForInformationDocument, options);
      }
export type SubmitRequestForInformationMutationHookResult = ReturnType<typeof useSubmitRequestForInformationMutation>;
export type SubmitRequestForInformationMutationResult = Apollo.MutationResult<SubmitRequestForInformationMutation>;
export type SubmitRequestForInformationMutationOptions = Apollo.BaseMutationOptions<SubmitRequestForInformationMutation, SubmitRequestForInformationMutationVariables>;
export const RevertRequestForInformationDocument = gql`
    mutation RevertRequestForInformation($revertRequestForInformationInput: RevertRequestForInformationInput!) {
  revertRequestForInformation(
    revertRequestForInformationInput: $revertRequestForInformationInput
  ) {
    requestForInformation {
      formattedNumber
      statusId
    }
  }
}
    `;
export type RevertRequestForInformationMutationFn = Apollo.MutationFunction<RevertRequestForInformationMutation, RevertRequestForInformationMutationVariables>;

/**
 * __useRevertRequestForInformationMutation__
 *
 * To run a mutation, you first call `useRevertRequestForInformationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRevertRequestForInformationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [revertRequestForInformationMutation, { data, loading, error }] = useRevertRequestForInformationMutation({
 *   variables: {
 *      revertRequestForInformationInput: // value for 'revertRequestForInformationInput'
 *   },
 * });
 */
export function useRevertRequestForInformationMutation(baseOptions?: Apollo.MutationHookOptions<RevertRequestForInformationMutation, RevertRequestForInformationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RevertRequestForInformationMutation, RevertRequestForInformationMutationVariables>(RevertRequestForInformationDocument, options);
      }
export type RevertRequestForInformationMutationHookResult = ReturnType<typeof useRevertRequestForInformationMutation>;
export type RevertRequestForInformationMutationResult = Apollo.MutationResult<RevertRequestForInformationMutation>;
export type RevertRequestForInformationMutationOptions = Apollo.BaseMutationOptions<RevertRequestForInformationMutation, RevertRequestForInformationMutationVariables>;
export const EditRequestForInformationDocument = gql`
    mutation EditRequestForInformation($editRequestForInformationInput: EditRequestForInformationInput!) {
  editRequestForInformation(
    editRequestForInformationInput: $editRequestForInformationInput
  ) {
    requestForInformation {
      formattedNumber
    }
  }
}
    `;
export type EditRequestForInformationMutationFn = Apollo.MutationFunction<EditRequestForInformationMutation, EditRequestForInformationMutationVariables>;

/**
 * __useEditRequestForInformationMutation__
 *
 * To run a mutation, you first call `useEditRequestForInformationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditRequestForInformationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editRequestForInformationMutation, { data, loading, error }] = useEditRequestForInformationMutation({
 *   variables: {
 *      editRequestForInformationInput: // value for 'editRequestForInformationInput'
 *   },
 * });
 */
export function useEditRequestForInformationMutation(baseOptions?: Apollo.MutationHookOptions<EditRequestForInformationMutation, EditRequestForInformationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditRequestForInformationMutation, EditRequestForInformationMutationVariables>(EditRequestForInformationDocument, options);
      }
export type EditRequestForInformationMutationHookResult = ReturnType<typeof useEditRequestForInformationMutation>;
export type EditRequestForInformationMutationResult = Apollo.MutationResult<EditRequestForInformationMutation>;
export type EditRequestForInformationMutationOptions = Apollo.BaseMutationOptions<EditRequestForInformationMutation, EditRequestForInformationMutationVariables>;
export const CreateRfiCommentDocument = gql`
    mutation CreateRFIComment($createRfiCommentInput: CreateRFICommentInput!) {
  createRFIComment(createRFICommentInput: $createRfiCommentInput) {
    comment {
      id
    }
  }
}
    `;
export type CreateRfiCommentMutationFn = Apollo.MutationFunction<CreateRfiCommentMutation, CreateRfiCommentMutationVariables>;

/**
 * __useCreateRfiCommentMutation__
 *
 * To run a mutation, you first call `useCreateRfiCommentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateRfiCommentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createRfiCommentMutation, { data, loading, error }] = useCreateRfiCommentMutation({
 *   variables: {
 *      createRfiCommentInput: // value for 'createRfiCommentInput'
 *   },
 * });
 */
export function useCreateRfiCommentMutation(baseOptions?: Apollo.MutationHookOptions<CreateRfiCommentMutation, CreateRfiCommentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateRfiCommentMutation, CreateRfiCommentMutationVariables>(CreateRfiCommentDocument, options);
      }
export type CreateRfiCommentMutationHookResult = ReturnType<typeof useCreateRfiCommentMutation>;
export type CreateRfiCommentMutationResult = Apollo.MutationResult<CreateRfiCommentMutation>;
export type CreateRfiCommentMutationOptions = Apollo.BaseMutationOptions<CreateRfiCommentMutation, CreateRfiCommentMutationVariables>;
export const EditRfiResponseDocument = gql`
    mutation EditRFIResponse($input: EditRFIResponseInput!) {
  editRFIResponse(editRFIResponseInput: $input) {
    response {
      user {
        mail
        displayName
      }
    }
  }
}
    `;
export type EditRfiResponseMutationFn = Apollo.MutationFunction<EditRfiResponseMutation, EditRfiResponseMutationVariables>;

/**
 * __useEditRfiResponseMutation__
 *
 * To run a mutation, you first call `useEditRfiResponseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditRfiResponseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editRfiResponseMutation, { data, loading, error }] = useEditRfiResponseMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEditRfiResponseMutation(baseOptions?: Apollo.MutationHookOptions<EditRfiResponseMutation, EditRfiResponseMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditRfiResponseMutation, EditRfiResponseMutationVariables>(EditRfiResponseDocument, options);
      }
export type EditRfiResponseMutationHookResult = ReturnType<typeof useEditRfiResponseMutation>;
export type EditRfiResponseMutationResult = Apollo.MutationResult<EditRfiResponseMutation>;
export type EditRfiResponseMutationOptions = Apollo.BaseMutationOptions<EditRfiResponseMutation, EditRfiResponseMutationVariables>;
export const RestoreRfiResponseDocument = gql`
    mutation RestoreRFIResponse($id: String!) {
  restoreRFIResponse(id: $id) {
    response {
      user {
        mail
        displayName
      }
    }
  }
}
    `;
export type RestoreRfiResponseMutationFn = Apollo.MutationFunction<RestoreRfiResponseMutation, RestoreRfiResponseMutationVariables>;

/**
 * __useRestoreRfiResponseMutation__
 *
 * To run a mutation, you first call `useRestoreRfiResponseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRestoreRfiResponseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [restoreRfiResponseMutation, { data, loading, error }] = useRestoreRfiResponseMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRestoreRfiResponseMutation(baseOptions?: Apollo.MutationHookOptions<RestoreRfiResponseMutation, RestoreRfiResponseMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RestoreRfiResponseMutation, RestoreRfiResponseMutationVariables>(RestoreRfiResponseDocument, options);
      }
export type RestoreRfiResponseMutationHookResult = ReturnType<typeof useRestoreRfiResponseMutation>;
export type RestoreRfiResponseMutationResult = Apollo.MutationResult<RestoreRfiResponseMutation>;
export type RestoreRfiResponseMutationOptions = Apollo.BaseMutationOptions<RestoreRfiResponseMutation, RestoreRfiResponseMutationVariables>;
export const SoftRemoveRfiResponseDocument = gql`
    mutation SoftRemoveRFIResponse($id: String!) {
  softRemoveRFIResponse(id: $id) {
    response {
      user {
        mail
        displayName
      }
    }
  }
}
    `;
export type SoftRemoveRfiResponseMutationFn = Apollo.MutationFunction<SoftRemoveRfiResponseMutation, SoftRemoveRfiResponseMutationVariables>;

/**
 * __useSoftRemoveRfiResponseMutation__
 *
 * To run a mutation, you first call `useSoftRemoveRfiResponseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSoftRemoveRfiResponseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [softRemoveRfiResponseMutation, { data, loading, error }] = useSoftRemoveRfiResponseMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSoftRemoveRfiResponseMutation(baseOptions?: Apollo.MutationHookOptions<SoftRemoveRfiResponseMutation, SoftRemoveRfiResponseMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SoftRemoveRfiResponseMutation, SoftRemoveRfiResponseMutationVariables>(SoftRemoveRfiResponseDocument, options);
      }
export type SoftRemoveRfiResponseMutationHookResult = ReturnType<typeof useSoftRemoveRfiResponseMutation>;
export type SoftRemoveRfiResponseMutationResult = Apollo.MutationResult<SoftRemoveRfiResponseMutation>;
export type SoftRemoveRfiResponseMutationOptions = Apollo.BaseMutationOptions<SoftRemoveRfiResponseMutation, SoftRemoveRfiResponseMutationVariables>;
export const SoftRemoveRequestForInformationDocument = gql`
    mutation SoftRemoveRequestForInformation($id: String!) {
  softRemoveRequestForInformation(id: $id) {
    requestForInformation {
      formattedNumber
    }
  }
}
    `;
export type SoftRemoveRequestForInformationMutationFn = Apollo.MutationFunction<SoftRemoveRequestForInformationMutation, SoftRemoveRequestForInformationMutationVariables>;

/**
 * __useSoftRemoveRequestForInformationMutation__
 *
 * To run a mutation, you first call `useSoftRemoveRequestForInformationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSoftRemoveRequestForInformationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [softRemoveRequestForInformationMutation, { data, loading, error }] = useSoftRemoveRequestForInformationMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSoftRemoveRequestForInformationMutation(baseOptions?: Apollo.MutationHookOptions<SoftRemoveRequestForInformationMutation, SoftRemoveRequestForInformationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SoftRemoveRequestForInformationMutation, SoftRemoveRequestForInformationMutationVariables>(SoftRemoveRequestForInformationDocument, options);
      }
export type SoftRemoveRequestForInformationMutationHookResult = ReturnType<typeof useSoftRemoveRequestForInformationMutation>;
export type SoftRemoveRequestForInformationMutationResult = Apollo.MutationResult<SoftRemoveRequestForInformationMutation>;
export type SoftRemoveRequestForInformationMutationOptions = Apollo.BaseMutationOptions<SoftRemoveRequestForInformationMutation, SoftRemoveRequestForInformationMutationVariables>;
export const RestoreRequestForInformationDocument = gql`
    mutation RestoreRequestForInformation($id: String!) {
  restoreRequestForInformation(id: $id) {
    requestForInformation {
      formattedNumber
    }
  }
}
    `;
export type RestoreRequestForInformationMutationFn = Apollo.MutationFunction<RestoreRequestForInformationMutation, RestoreRequestForInformationMutationVariables>;

/**
 * __useRestoreRequestForInformationMutation__
 *
 * To run a mutation, you first call `useRestoreRequestForInformationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRestoreRequestForInformationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [restoreRequestForInformationMutation, { data, loading, error }] = useRestoreRequestForInformationMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRestoreRequestForInformationMutation(baseOptions?: Apollo.MutationHookOptions<RestoreRequestForInformationMutation, RestoreRequestForInformationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RestoreRequestForInformationMutation, RestoreRequestForInformationMutationVariables>(RestoreRequestForInformationDocument, options);
      }
export type RestoreRequestForInformationMutationHookResult = ReturnType<typeof useRestoreRequestForInformationMutation>;
export type RestoreRequestForInformationMutationResult = Apollo.MutationResult<RestoreRequestForInformationMutation>;
export type RestoreRequestForInformationMutationOptions = Apollo.BaseMutationOptions<RestoreRequestForInformationMutation, RestoreRequestForInformationMutationVariables>;
export const GetRfiTrackerTableMetadataDocument = gql`
    query GetRFITrackerTableMetadata($globalId: String!) {
  project(globalId: $globalId) {
    rfiOrganizations(rfiOrganizationFieldInput: {deleted: false}) {
      id
      name
      description
    }
    rfiResponseDisciplines(rfiResponseDisciplineFieldInput: {deleted: false}) {
      id
      name
      description
      users {
        id
        deleted
        userGroups {
          id
        }
      }
    }
    rfiQuickLinks(rfiQuickLinkFieldInput: {deleted: false}) {
      id
      label
      href
      description
    }
  }
}
    `;

/**
 * __useGetRfiTrackerTableMetadataQuery__
 *
 * To run a query within a React component, call `useGetRfiTrackerTableMetadataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRfiTrackerTableMetadataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRfiTrackerTableMetadataQuery({
 *   variables: {
 *      globalId: // value for 'globalId'
 *   },
 * });
 */
export function useGetRfiTrackerTableMetadataQuery(baseOptions: Apollo.QueryHookOptions<GetRfiTrackerTableMetadataQuery, GetRfiTrackerTableMetadataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRfiTrackerTableMetadataQuery, GetRfiTrackerTableMetadataQueryVariables>(GetRfiTrackerTableMetadataDocument, options);
      }
export function useGetRfiTrackerTableMetadataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRfiTrackerTableMetadataQuery, GetRfiTrackerTableMetadataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRfiTrackerTableMetadataQuery, GetRfiTrackerTableMetadataQueryVariables>(GetRfiTrackerTableMetadataDocument, options);
        }
export type GetRfiTrackerTableMetadataQueryHookResult = ReturnType<typeof useGetRfiTrackerTableMetadataQuery>;
export type GetRfiTrackerTableMetadataLazyQueryHookResult = ReturnType<typeof useGetRfiTrackerTableMetadataLazyQuery>;
export type GetRfiTrackerTableMetadataQueryResult = Apollo.QueryResult<GetRfiTrackerTableMetadataQuery, GetRfiTrackerTableMetadataQueryVariables>;
export const GetRequestsForInformationDocument = gql`
    query GetRequestsForInformation($projectId: String!, $requestForInformationListInput: RequestForInformationListInput!) {
  requestsForInformation(
    requestForInformationListInput: $requestForInformationListInput
  ) {
    records {
      id
      statusId
      number
      formattedNumber
      deleted
      deletedUser
      deletedDate
      externalLinks {
        href
        label
      }
      description
      organizationId
      organization {
        name
      }
      sharePointResourceId
      sharePointResourceWebUrl
      submittedBy {
        id
        displayName
        mail
        deleted
        userGroups {
          id
        }
      }
      requestedResponseDate
      submittedDate
      closedDate
      responseDisciplines {
        id
        name
        description
        users {
          id
        }
      }
      responses {
        id
        closed
        responseDisciplineId
        responseDate
        deleted
        user {
          displayName
          mail
        }
        text
      }
      comments {
        text
        createdDate
        user {
          mail
        }
      }
      customFields {
        booleanValues {
          customField {
            ...RequestsForInformationCustomField
          }
          customFieldId
          value
        }
        dateValues {
          customField {
            ...RequestsForInformationCustomField
          }
          customFieldId
          value
        }
        entityValues {
          customField {
            ...RequestsForInformationCustomField
          }
          customFieldId
          entities {
            recordId
            href(projectId: $projectId)
            entityId
            label
          }
        }
        listValues {
          singles {
            customField {
              ...RequestsForInformationCustomField
            }
            customFieldId
            customListItem {
              id
              deleted
              value
            }
          }
          multiples {
            customField {
              ...RequestsForInformationCustomField
            }
            customFieldId
            customListItems {
              id
              deleted
              value
            }
          }
          checkboxes {
            customField {
              ...RequestsForInformationCustomField
            }
            customFieldId
            booleans {
              customListItemId
              customListItem {
                value
              }
              checked
            }
          }
        }
        numberValues {
          customField {
            ...RequestsForInformationCustomField
          }
          customFieldId
          value
        }
        reportValues {
          customField {
            ...RequestsForInformationCustomField
          }
          customFieldId
          reports {
            recordId
            reportId
            href(projectId: $projectId)
            label
          }
        }
        textValues {
          customField {
            ...RequestsForInformationCustomField
          }
          customFieldId
          value
        }
      }
    }
  }
}
    ${RequestsForInformationCustomFieldFragmentDoc}`;

/**
 * __useGetRequestsForInformationQuery__
 *
 * To run a query within a React component, call `useGetRequestsForInformationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRequestsForInformationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRequestsForInformationQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      requestForInformationListInput: // value for 'requestForInformationListInput'
 *   },
 * });
 */
export function useGetRequestsForInformationQuery(baseOptions: Apollo.QueryHookOptions<GetRequestsForInformationQuery, GetRequestsForInformationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRequestsForInformationQuery, GetRequestsForInformationQueryVariables>(GetRequestsForInformationDocument, options);
      }
export function useGetRequestsForInformationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRequestsForInformationQuery, GetRequestsForInformationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRequestsForInformationQuery, GetRequestsForInformationQueryVariables>(GetRequestsForInformationDocument, options);
        }
export type GetRequestsForInformationQueryHookResult = ReturnType<typeof useGetRequestsForInformationQuery>;
export type GetRequestsForInformationLazyQueryHookResult = ReturnType<typeof useGetRequestsForInformationLazyQuery>;
export type GetRequestsForInformationQueryResult = Apollo.QueryResult<GetRequestsForInformationQuery, GetRequestsForInformationQueryVariables>;
export const CreateRfiResponseDisciplineDocument = gql`
    mutation CreateRFIResponseDiscipline($createRfiResponseDisciplineInput: CreateRFIResponseDisciplineInput!) {
  createRFIResponseDiscipline(
    createRFIResponseDisciplineInput: $createRfiResponseDisciplineInput
  ) {
    responseDiscipline {
      name
    }
  }
}
    `;
export type CreateRfiResponseDisciplineMutationFn = Apollo.MutationFunction<CreateRfiResponseDisciplineMutation, CreateRfiResponseDisciplineMutationVariables>;

/**
 * __useCreateRfiResponseDisciplineMutation__
 *
 * To run a mutation, you first call `useCreateRfiResponseDisciplineMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateRfiResponseDisciplineMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createRfiResponseDisciplineMutation, { data, loading, error }] = useCreateRfiResponseDisciplineMutation({
 *   variables: {
 *      createRfiResponseDisciplineInput: // value for 'createRfiResponseDisciplineInput'
 *   },
 * });
 */
export function useCreateRfiResponseDisciplineMutation(baseOptions?: Apollo.MutationHookOptions<CreateRfiResponseDisciplineMutation, CreateRfiResponseDisciplineMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateRfiResponseDisciplineMutation, CreateRfiResponseDisciplineMutationVariables>(CreateRfiResponseDisciplineDocument, options);
      }
export type CreateRfiResponseDisciplineMutationHookResult = ReturnType<typeof useCreateRfiResponseDisciplineMutation>;
export type CreateRfiResponseDisciplineMutationResult = Apollo.MutationResult<CreateRfiResponseDisciplineMutation>;
export type CreateRfiResponseDisciplineMutationOptions = Apollo.BaseMutationOptions<CreateRfiResponseDisciplineMutation, CreateRfiResponseDisciplineMutationVariables>;
export const EditRfiResponseDisciplineDocument = gql`
    mutation EditRFIResponseDiscipline($editRfiResponseDisciplineInput: EditRFIResponseDisciplineInput!) {
  editRFIResponseDiscipline(
    editRFIResponseDisciplineInput: $editRfiResponseDisciplineInput
  ) {
    responseDiscipline {
      name
    }
  }
}
    `;
export type EditRfiResponseDisciplineMutationFn = Apollo.MutationFunction<EditRfiResponseDisciplineMutation, EditRfiResponseDisciplineMutationVariables>;

/**
 * __useEditRfiResponseDisciplineMutation__
 *
 * To run a mutation, you first call `useEditRfiResponseDisciplineMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditRfiResponseDisciplineMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editRfiResponseDisciplineMutation, { data, loading, error }] = useEditRfiResponseDisciplineMutation({
 *   variables: {
 *      editRfiResponseDisciplineInput: // value for 'editRfiResponseDisciplineInput'
 *   },
 * });
 */
export function useEditRfiResponseDisciplineMutation(baseOptions?: Apollo.MutationHookOptions<EditRfiResponseDisciplineMutation, EditRfiResponseDisciplineMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditRfiResponseDisciplineMutation, EditRfiResponseDisciplineMutationVariables>(EditRfiResponseDisciplineDocument, options);
      }
export type EditRfiResponseDisciplineMutationHookResult = ReturnType<typeof useEditRfiResponseDisciplineMutation>;
export type EditRfiResponseDisciplineMutationResult = Apollo.MutationResult<EditRfiResponseDisciplineMutation>;
export type EditRfiResponseDisciplineMutationOptions = Apollo.BaseMutationOptions<EditRfiResponseDisciplineMutation, EditRfiResponseDisciplineMutationVariables>;
export const SoftRemoveRfiResponseDisciplineDocument = gql`
    mutation SoftRemoveRFIResponseDiscipline($id: String!) {
  softRemoveRFIResponseDiscipline(id: $id) {
    responseDiscipline {
      name
    }
  }
}
    `;
export type SoftRemoveRfiResponseDisciplineMutationFn = Apollo.MutationFunction<SoftRemoveRfiResponseDisciplineMutation, SoftRemoveRfiResponseDisciplineMutationVariables>;

/**
 * __useSoftRemoveRfiResponseDisciplineMutation__
 *
 * To run a mutation, you first call `useSoftRemoveRfiResponseDisciplineMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSoftRemoveRfiResponseDisciplineMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [softRemoveRfiResponseDisciplineMutation, { data, loading, error }] = useSoftRemoveRfiResponseDisciplineMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSoftRemoveRfiResponseDisciplineMutation(baseOptions?: Apollo.MutationHookOptions<SoftRemoveRfiResponseDisciplineMutation, SoftRemoveRfiResponseDisciplineMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SoftRemoveRfiResponseDisciplineMutation, SoftRemoveRfiResponseDisciplineMutationVariables>(SoftRemoveRfiResponseDisciplineDocument, options);
      }
export type SoftRemoveRfiResponseDisciplineMutationHookResult = ReturnType<typeof useSoftRemoveRfiResponseDisciplineMutation>;
export type SoftRemoveRfiResponseDisciplineMutationResult = Apollo.MutationResult<SoftRemoveRfiResponseDisciplineMutation>;
export type SoftRemoveRfiResponseDisciplineMutationOptions = Apollo.BaseMutationOptions<SoftRemoveRfiResponseDisciplineMutation, SoftRemoveRfiResponseDisciplineMutationVariables>;
export const RestoreRfiResponseDisciplineDocument = gql`
    mutation RestoreRFIResponseDiscipline($id: String!) {
  restoreRFIResponseDiscipline(id: $id) {
    responseDiscipline {
      name
    }
  }
}
    `;
export type RestoreRfiResponseDisciplineMutationFn = Apollo.MutationFunction<RestoreRfiResponseDisciplineMutation, RestoreRfiResponseDisciplineMutationVariables>;

/**
 * __useRestoreRfiResponseDisciplineMutation__
 *
 * To run a mutation, you first call `useRestoreRfiResponseDisciplineMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRestoreRfiResponseDisciplineMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [restoreRfiResponseDisciplineMutation, { data, loading, error }] = useRestoreRfiResponseDisciplineMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRestoreRfiResponseDisciplineMutation(baseOptions?: Apollo.MutationHookOptions<RestoreRfiResponseDisciplineMutation, RestoreRfiResponseDisciplineMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RestoreRfiResponseDisciplineMutation, RestoreRfiResponseDisciplineMutationVariables>(RestoreRfiResponseDisciplineDocument, options);
      }
export type RestoreRfiResponseDisciplineMutationHookResult = ReturnType<typeof useRestoreRfiResponseDisciplineMutation>;
export type RestoreRfiResponseDisciplineMutationResult = Apollo.MutationResult<RestoreRfiResponseDisciplineMutation>;
export type RestoreRfiResponseDisciplineMutationOptions = Apollo.BaseMutationOptions<RestoreRfiResponseDisciplineMutation, RestoreRfiResponseDisciplineMutationVariables>;
export const GetRfiResponseDisciplinesDocument = gql`
    query GetRFIResponseDisciplines($rfiResponseDisciplineListInput: RFIResponseDisciplineListInput!) {
  rfiResponseDisciplines(
    rfiResponseDisciplineListInput: $rfiResponseDisciplineListInput
  ) {
    records {
      id
      name
      description
      deleted
      deletedDate
      deletedUser
      users {
        id
        displayName
        mail
        deleted
        userGroups {
          id
        }
      }
      requestsForInformation {
        id
        formattedNumber
        deleted
      }
    }
  }
}
    `;

/**
 * __useGetRfiResponseDisciplinesQuery__
 *
 * To run a query within a React component, call `useGetRfiResponseDisciplinesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRfiResponseDisciplinesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRfiResponseDisciplinesQuery({
 *   variables: {
 *      rfiResponseDisciplineListInput: // value for 'rfiResponseDisciplineListInput'
 *   },
 * });
 */
export function useGetRfiResponseDisciplinesQuery(baseOptions: Apollo.QueryHookOptions<GetRfiResponseDisciplinesQuery, GetRfiResponseDisciplinesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRfiResponseDisciplinesQuery, GetRfiResponseDisciplinesQueryVariables>(GetRfiResponseDisciplinesDocument, options);
      }
export function useGetRfiResponseDisciplinesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRfiResponseDisciplinesQuery, GetRfiResponseDisciplinesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRfiResponseDisciplinesQuery, GetRfiResponseDisciplinesQueryVariables>(GetRfiResponseDisciplinesDocument, options);
        }
export type GetRfiResponseDisciplinesQueryHookResult = ReturnType<typeof useGetRfiResponseDisciplinesQuery>;
export type GetRfiResponseDisciplinesLazyQueryHookResult = ReturnType<typeof useGetRfiResponseDisciplinesLazyQuery>;
export type GetRfiResponseDisciplinesQueryResult = Apollo.QueryResult<GetRfiResponseDisciplinesQuery, GetRfiResponseDisciplinesQueryVariables>;
export const IfiNotificationsDocument = gql`
    query IFINotifications($projectId: String!) {
  project(globalId: $projectId) {
    ifiNotifications(ifiNotificationFieldInput: {projectId: {equals: $projectId}}) {
      notificationEventId
      recipients {
        every {
          ...IFINotificationRecipients
        }
        asphaltLot {
          ...IFINotificationRecipients
        }
        concreteTest {
          ...IFINotificationRecipients
        }
        dailyInspectionControlPoint {
          ...IFINotificationRecipients
        }
        dailyInspectionInspection {
          ...IFINotificationRecipients
        }
        dailyInspectionPunchList {
          ...IFINotificationRecipients
        }
        densityLot {
          ...IFINotificationRecipients
        }
        densityTest {
          ...IFINotificationRecipients
        }
      }
      frequency {
        ... on MinuteFrequency {
          minutes
        }
        ... on HourlyFrequency {
          hours
        }
        ... on DailyFrequency {
          hour
          minute
        }
        ... on WeeklyFrequency {
          day
          hour
          minute
        }
      }
    }
  }
}
    ${IfiNotificationRecipientsFragmentDoc}`;

/**
 * __useIfiNotificationsQuery__
 *
 * To run a query within a React component, call `useIfiNotificationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useIfiNotificationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIfiNotificationsQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useIfiNotificationsQuery(baseOptions: Apollo.QueryHookOptions<IfiNotificationsQuery, IfiNotificationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IfiNotificationsQuery, IfiNotificationsQueryVariables>(IfiNotificationsDocument, options);
      }
export function useIfiNotificationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IfiNotificationsQuery, IfiNotificationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IfiNotificationsQuery, IfiNotificationsQueryVariables>(IfiNotificationsDocument, options);
        }
export type IfiNotificationsQueryHookResult = ReturnType<typeof useIfiNotificationsQuery>;
export type IfiNotificationsLazyQueryHookResult = ReturnType<typeof useIfiNotificationsLazyQuery>;
export type IfiNotificationsQueryResult = Apollo.QueryResult<IfiNotificationsQuery, IfiNotificationsQueryVariables>;
export const EditIfiNotificationDocument = gql`
    mutation EditIFINotification($input: EditIFINotificationInput!) {
  editIFINotification(editIFINotificationInput: $input) {
    notification {
      notificationEvent
    }
  }
}
    `;
export type EditIfiNotificationMutationFn = Apollo.MutationFunction<EditIfiNotificationMutation, EditIfiNotificationMutationVariables>;

/**
 * __useEditIfiNotificationMutation__
 *
 * To run a mutation, you first call `useEditIfiNotificationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditIfiNotificationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editIfiNotificationMutation, { data, loading, error }] = useEditIfiNotificationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEditIfiNotificationMutation(baseOptions?: Apollo.MutationHookOptions<EditIfiNotificationMutation, EditIfiNotificationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditIfiNotificationMutation, EditIfiNotificationMutationVariables>(EditIfiNotificationDocument, options);
      }
export type EditIfiNotificationMutationHookResult = ReturnType<typeof useEditIfiNotificationMutation>;
export type EditIfiNotificationMutationResult = Apollo.MutationResult<EditIfiNotificationMutation>;
export type EditIfiNotificationMutationOptions = Apollo.BaseMutationOptions<EditIfiNotificationMutation, EditIfiNotificationMutationVariables>;
export const EditIdentifiedFieldIssueDocument = gql`
    mutation EditIdentifiedFieldIssue($input: EditIdentifiedFieldIssueInput!) {
  editIdentifiedFieldIssue(editIdentifiedFieldIssueInput: $input) {
    identifiedFieldIssue {
      reportId
      reportName
      asphaltLot {
        asphaltLotId
      }
      concreteTest {
        fieldNumber
      }
      dailyInspectionControlPoint {
        controlPointId
      }
      dailyInspectionInspection {
        inspectionId
      }
      dailyInspectionPunchList {
        punchListId
      }
      lot {
        lotId
      }
    }
  }
}
    `;
export type EditIdentifiedFieldIssueMutationFn = Apollo.MutationFunction<EditIdentifiedFieldIssueMutation, EditIdentifiedFieldIssueMutationVariables>;

/**
 * __useEditIdentifiedFieldIssueMutation__
 *
 * To run a mutation, you first call `useEditIdentifiedFieldIssueMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditIdentifiedFieldIssueMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editIdentifiedFieldIssueMutation, { data, loading, error }] = useEditIdentifiedFieldIssueMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEditIdentifiedFieldIssueMutation(baseOptions?: Apollo.MutationHookOptions<EditIdentifiedFieldIssueMutation, EditIdentifiedFieldIssueMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditIdentifiedFieldIssueMutation, EditIdentifiedFieldIssueMutationVariables>(EditIdentifiedFieldIssueDocument, options);
      }
export type EditIdentifiedFieldIssueMutationHookResult = ReturnType<typeof useEditIdentifiedFieldIssueMutation>;
export type EditIdentifiedFieldIssueMutationResult = Apollo.MutationResult<EditIdentifiedFieldIssueMutation>;
export type EditIdentifiedFieldIssueMutationOptions = Apollo.BaseMutationOptions<EditIdentifiedFieldIssueMutation, EditIdentifiedFieldIssueMutationVariables>;
export const IfiTrackerDocument = gql`
    query IFITracker($projectId: String!, $identifiedFieldIssueListInput: IdentifiedFieldIssueListInput!) {
  identifiedFieldIssueSyncs(projectId: $projectId) {
    syncing
    lastEditedDate
  }
  issueQuickLinks(
    issueQuickLinkListInput: {projectId: {equals: $projectId}, deleted: false}
  ) {
    records {
      id
      label
      href
      description
    }
  }
  issues(issueListInput: {projectId: {equals: $projectId}, deleted: false}) {
    records {
      id
      formattedNumber
      description
    }
  }
  engineeringJudgements(
    engineeringJudgementListInput: {projectId: {equals: $projectId}, deleted: false}
  ) {
    records {
      id
      formattedNumber
    }
  }
  identifiedFieldIssues(
    identifiedFieldIssueListInput: $identifiedFieldIssueListInput
  ) {
    records {
      reportId
      reportTypeId
      statusId
      initialDescription
      reportDescription
      reportDate
      reportName
      reportReviewStatus
      reportTechnician {
        technicianName
      }
      suggestedIssueTypes
      reviewedBy {
        ...IFITrackerUser
      }
      reviewedDate
      reviewNotes
      customFields {
        booleanValues {
          customField {
            ...IFITrackerCustomField
          }
          customFieldId
          value
        }
        dateValues {
          customField {
            ...IFITrackerCustomField
          }
          customFieldId
          value
        }
        entityValues {
          customField {
            ...IFITrackerCustomField
          }
          customFieldId
          entities {
            recordId
            href(projectId: $projectId)
            entityId
            label
          }
        }
        listValues {
          singles {
            customField {
              ...IFITrackerCustomField
            }
            customFieldId
            customListItem {
              id
              deleted
              value
            }
          }
          multiples {
            customField {
              ...IFITrackerCustomField
            }
            customFieldId
            customListItems {
              id
              deleted
              value
            }
          }
          checkboxes {
            customField {
              ...IFITrackerCustomField
            }
            customFieldId
            booleans {
              customListItemId
              customListItem {
                value
              }
              checked
            }
          }
        }
        numberValues {
          customField {
            ...IFITrackerCustomField
          }
          customFieldId
          value
        }
        reportValues {
          customField {
            ...IFITrackerCustomField
          }
          customFieldId
          reports {
            recordId
            reportId
            href(projectId: $projectId)
            label
          }
        }
        textValues {
          customField {
            ...IFITrackerCustomField
          }
          customFieldId
          value
        }
      }
      issues(issueFieldInput: {deleted: false}) {
        id
        formattedNumber
        description
      }
      engineeringJudgements(engineeringJudgementFieldInput: {deleted: false}) {
        id
        formattedNumber
      }
      comments(ifiCommentFieldInput: {deleted: false}) {
        user {
          ...IFITrackerUser
        }
        text
        createdDate
      }
      asphaltLot {
        globalId
        asphaltLotId
        createdDate
        lastEditedDate
        reviewedBy {
          ...IFITrackerTechnician
        }
        deleted
        payItemNoGeometries(payItemNoGeometryFieldInput: {deleted: false}) {
          ...IFITrackerPayItem
        }
      }
      concreteTest {
        globalId
        fieldNumber
        notes
        overrideComments
        percentAir
        percentAirTestedBy {
          ...IFITrackerTechnician
        }
        slump
        slumpTestedBy {
          ...IFITrackerTechnician
        }
        concreteTemp
        concreteTempTestedBy {
          ...IFITrackerTechnician
        }
        createdDate
        lastEditedDate
        deleted
        concreteTestSet {
          concretePlacements {
            placementType
          }
        }
        payItemNoGeometries(payItemNoGeometryFieldInput: {deleted: false}) {
          ...IFITrackerPayItem
        }
      }
      dailyInspectionControlPoint {
        globalId
        controlPointId
        createdDate
        lastEditedDate
        reviewDate
        reviewStatus
        reviewedBy {
          ...IFITrackerTechnician
        }
        submit
        workType {
          name
        }
        deleted
        reportDate
        payItemNoGeometries(payItemNoGeometryFieldInput: {deleted: false}) {
          ...IFITrackerPayItem
        }
      }
      dailyInspectionInspection {
        globalId
        inspectionId
        inspectionNotes
        testingAndSamplingNotes
        createdDate
        lastEditedDate
        reviewDate
        reviewStatus
        reviewedBy {
          ...IFITrackerTechnician
        }
        submit
        deleted
        reportDate
        ncr
        cdr
        punchListCheck
        ncrIssueDescription
        workType {
          name
        }
        payItemNoGeometries(payItemNoGeometryFieldInput: {deleted: false}) {
          ...IFITrackerPayItem
        }
      }
      dailyInspectionPunchList {
        globalId
        punchListId
        createdDate
        reviewDate
        reviewStatus
        reviewedBy {
          ...IFITrackerTechnician
        }
        submit
        statusUpdate
        lastEditedDate
        deleted
        reportDate
        payItemNoGeometries(payItemNoGeometryFieldInput: {deleted: false}) {
          ...IFITrackerPayItem
        }
      }
      lot {
        globalId
        lotId
        createdDate
        createdUser
        lastEditedDate
        globalProctorValue
        compactionAverage
        reviewedDate
        material {
          lotCompactionRequirement
        }
        deleted
        payItemNoGeometries(payItemNoGeometryFieldInput: {deleted: false}) {
          ...IFITrackerPayItem
        }
      }
      densityTest {
        globalId
        testId
        createdDate
        createdUser
        lastEditedDate
        averagePercent
        lot {
          globalId
          lotId
          compactionAverage
          material {
            lotCompactionRequirement
          }
        }
        deleted
      }
    }
  }
}
    ${IfiTrackerUserFragmentDoc}
${IfiTrackerCustomFieldFragmentDoc}
${IfiTrackerTechnicianFragmentDoc}
${IfiTrackerPayItemFragmentDoc}`;

/**
 * __useIfiTrackerQuery__
 *
 * To run a query within a React component, call `useIfiTrackerQuery` and pass it any options that fit your needs.
 * When your component renders, `useIfiTrackerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIfiTrackerQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      identifiedFieldIssueListInput: // value for 'identifiedFieldIssueListInput'
 *   },
 * });
 */
export function useIfiTrackerQuery(baseOptions: Apollo.QueryHookOptions<IfiTrackerQuery, IfiTrackerQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IfiTrackerQuery, IfiTrackerQueryVariables>(IfiTrackerDocument, options);
      }
export function useIfiTrackerLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IfiTrackerQuery, IfiTrackerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IfiTrackerQuery, IfiTrackerQueryVariables>(IfiTrackerDocument, options);
        }
export type IfiTrackerQueryHookResult = ReturnType<typeof useIfiTrackerQuery>;
export type IfiTrackerLazyQueryHookResult = ReturnType<typeof useIfiTrackerLazyQuery>;
export type IfiTrackerQueryResult = Apollo.QueryResult<IfiTrackerQuery, IfiTrackerQueryVariables>;
export const RevertIdentifiedFieldIssueDocument = gql`
    mutation RevertIdentifiedFieldIssue($input: RevertIdentifiedFieldIssueInput!) {
  revertIdentifiedFieldIssue(revertIdentifiedFieldIssueInput: $input) {
    identifiedFieldIssue {
      reportId
      reportName
      asphaltLot {
        asphaltLotId
      }
      concreteTest {
        fieldNumber
      }
      dailyInspectionControlPoint {
        controlPointId
      }
      dailyInspectionInspection {
        inspectionId
      }
      dailyInspectionPunchList {
        punchListId
      }
      lot {
        lotId
      }
    }
  }
}
    `;
export type RevertIdentifiedFieldIssueMutationFn = Apollo.MutationFunction<RevertIdentifiedFieldIssueMutation, RevertIdentifiedFieldIssueMutationVariables>;

/**
 * __useRevertIdentifiedFieldIssueMutation__
 *
 * To run a mutation, you first call `useRevertIdentifiedFieldIssueMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRevertIdentifiedFieldIssueMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [revertIdentifiedFieldIssueMutation, { data, loading, error }] = useRevertIdentifiedFieldIssueMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRevertIdentifiedFieldIssueMutation(baseOptions?: Apollo.MutationHookOptions<RevertIdentifiedFieldIssueMutation, RevertIdentifiedFieldIssueMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RevertIdentifiedFieldIssueMutation, RevertIdentifiedFieldIssueMutationVariables>(RevertIdentifiedFieldIssueDocument, options);
      }
export type RevertIdentifiedFieldIssueMutationHookResult = ReturnType<typeof useRevertIdentifiedFieldIssueMutation>;
export type RevertIdentifiedFieldIssueMutationResult = Apollo.MutationResult<RevertIdentifiedFieldIssueMutation>;
export type RevertIdentifiedFieldIssueMutationOptions = Apollo.BaseMutationOptions<RevertIdentifiedFieldIssueMutation, RevertIdentifiedFieldIssueMutationVariables>;
export const ReviewIdentifiedFieldIssueDocument = gql`
    mutation ReviewIdentifiedFieldIssue($input: ReviewIdentifiedFieldIssueInput!) {
  reviewIdentifiedFieldIssue(reviewIdentifiedFieldIssueInput: $input) {
    identifiedFieldIssue {
      reportId
      reportName
      asphaltLot {
        asphaltLotId
      }
      concreteTest {
        fieldNumber
      }
      dailyInspectionControlPoint {
        controlPointId
      }
      dailyInspectionInspection {
        inspectionId
      }
      dailyInspectionPunchList {
        punchListId
      }
      lot {
        lotId
      }
    }
  }
}
    `;
export type ReviewIdentifiedFieldIssueMutationFn = Apollo.MutationFunction<ReviewIdentifiedFieldIssueMutation, ReviewIdentifiedFieldIssueMutationVariables>;

/**
 * __useReviewIdentifiedFieldIssueMutation__
 *
 * To run a mutation, you first call `useReviewIdentifiedFieldIssueMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReviewIdentifiedFieldIssueMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reviewIdentifiedFieldIssueMutation, { data, loading, error }] = useReviewIdentifiedFieldIssueMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useReviewIdentifiedFieldIssueMutation(baseOptions?: Apollo.MutationHookOptions<ReviewIdentifiedFieldIssueMutation, ReviewIdentifiedFieldIssueMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ReviewIdentifiedFieldIssueMutation, ReviewIdentifiedFieldIssueMutationVariables>(ReviewIdentifiedFieldIssueDocument, options);
      }
export type ReviewIdentifiedFieldIssueMutationHookResult = ReturnType<typeof useReviewIdentifiedFieldIssueMutation>;
export type ReviewIdentifiedFieldIssueMutationResult = Apollo.MutationResult<ReviewIdentifiedFieldIssueMutation>;
export type ReviewIdentifiedFieldIssueMutationOptions = Apollo.BaseMutationOptions<ReviewIdentifiedFieldIssueMutation, ReviewIdentifiedFieldIssueMutationVariables>;
export const RequestIfiSyncDocument = gql`
    mutation RequestIFISync($projectId: String!) {
  syncIdentifiedFieldIssues(projectId: $projectId) {
    lastEditedDate
    syncing
  }
}
    `;
export type RequestIfiSyncMutationFn = Apollo.MutationFunction<RequestIfiSyncMutation, RequestIfiSyncMutationVariables>;

/**
 * __useRequestIfiSyncMutation__
 *
 * To run a mutation, you first call `useRequestIfiSyncMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRequestIfiSyncMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [requestIfiSyncMutation, { data, loading, error }] = useRequestIfiSyncMutation({
 *   variables: {
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useRequestIfiSyncMutation(baseOptions?: Apollo.MutationHookOptions<RequestIfiSyncMutation, RequestIfiSyncMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RequestIfiSyncMutation, RequestIfiSyncMutationVariables>(RequestIfiSyncDocument, options);
      }
export type RequestIfiSyncMutationHookResult = ReturnType<typeof useRequestIfiSyncMutation>;
export type RequestIfiSyncMutationResult = Apollo.MutationResult<RequestIfiSyncMutation>;
export type RequestIfiSyncMutationOptions = Apollo.BaseMutationOptions<RequestIfiSyncMutation, RequestIfiSyncMutationVariables>;
export const CreateIfiCommentDocument = gql`
    mutation CreateIFIComment($input: CreateIFICommentInput!) {
  createIFIComment(createIFICommentInput: $input) {
    comment {
      id
    }
  }
}
    `;
export type CreateIfiCommentMutationFn = Apollo.MutationFunction<CreateIfiCommentMutation, CreateIfiCommentMutationVariables>;

/**
 * __useCreateIfiCommentMutation__
 *
 * To run a mutation, you first call `useCreateIfiCommentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateIfiCommentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createIfiCommentMutation, { data, loading, error }] = useCreateIfiCommentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateIfiCommentMutation(baseOptions?: Apollo.MutationHookOptions<CreateIfiCommentMutation, CreateIfiCommentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateIfiCommentMutation, CreateIfiCommentMutationVariables>(CreateIfiCommentDocument, options);
      }
export type CreateIfiCommentMutationHookResult = ReturnType<typeof useCreateIfiCommentMutation>;
export type CreateIfiCommentMutationResult = Apollo.MutationResult<CreateIfiCommentMutation>;
export type CreateIfiCommentMutationOptions = Apollo.BaseMutationOptions<CreateIfiCommentMutation, CreateIfiCommentMutationVariables>;
export const AsphaltIssueReportOptionsDocument = gql`
    query AsphaltIssueReportOptions($globalId: String!) {
  asphaltLots(
    asphaltLotListInput: {projectId: {equals: $globalId}, deleted: false}
  ) {
    records {
      globalId
      asphaltLotId
    }
  }
}
    `;

/**
 * __useAsphaltIssueReportOptionsQuery__
 *
 * To run a query within a React component, call `useAsphaltIssueReportOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAsphaltIssueReportOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAsphaltIssueReportOptionsQuery({
 *   variables: {
 *      globalId: // value for 'globalId'
 *   },
 * });
 */
export function useAsphaltIssueReportOptionsQuery(baseOptions: Apollo.QueryHookOptions<AsphaltIssueReportOptionsQuery, AsphaltIssueReportOptionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AsphaltIssueReportOptionsQuery, AsphaltIssueReportOptionsQueryVariables>(AsphaltIssueReportOptionsDocument, options);
      }
export function useAsphaltIssueReportOptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AsphaltIssueReportOptionsQuery, AsphaltIssueReportOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AsphaltIssueReportOptionsQuery, AsphaltIssueReportOptionsQueryVariables>(AsphaltIssueReportOptionsDocument, options);
        }
export type AsphaltIssueReportOptionsQueryHookResult = ReturnType<typeof useAsphaltIssueReportOptionsQuery>;
export type AsphaltIssueReportOptionsLazyQueryHookResult = ReturnType<typeof useAsphaltIssueReportOptionsLazyQuery>;
export type AsphaltIssueReportOptionsQueryResult = Apollo.QueryResult<AsphaltIssueReportOptionsQuery, AsphaltIssueReportOptionsQueryVariables>;
export const ConcreteTestIssueReportOptionsDocument = gql`
    query ConcreteTestIssueReportOptions($globalId: String!) {
  concreteTests(
    concreteTestListInput: {projectId: {equals: $globalId}, deleted: false}
  ) {
    records {
      globalId
      fieldNumber
    }
  }
}
    `;

/**
 * __useConcreteTestIssueReportOptionsQuery__
 *
 * To run a query within a React component, call `useConcreteTestIssueReportOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useConcreteTestIssueReportOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useConcreteTestIssueReportOptionsQuery({
 *   variables: {
 *      globalId: // value for 'globalId'
 *   },
 * });
 */
export function useConcreteTestIssueReportOptionsQuery(baseOptions: Apollo.QueryHookOptions<ConcreteTestIssueReportOptionsQuery, ConcreteTestIssueReportOptionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ConcreteTestIssueReportOptionsQuery, ConcreteTestIssueReportOptionsQueryVariables>(ConcreteTestIssueReportOptionsDocument, options);
      }
export function useConcreteTestIssueReportOptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ConcreteTestIssueReportOptionsQuery, ConcreteTestIssueReportOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ConcreteTestIssueReportOptionsQuery, ConcreteTestIssueReportOptionsQueryVariables>(ConcreteTestIssueReportOptionsDocument, options);
        }
export type ConcreteTestIssueReportOptionsQueryHookResult = ReturnType<typeof useConcreteTestIssueReportOptionsQuery>;
export type ConcreteTestIssueReportOptionsLazyQueryHookResult = ReturnType<typeof useConcreteTestIssueReportOptionsLazyQuery>;
export type ConcreteTestIssueReportOptionsQueryResult = Apollo.QueryResult<ConcreteTestIssueReportOptionsQuery, ConcreteTestIssueReportOptionsQueryVariables>;
export const ConcreteTestSetIssueReportOptionsDocument = gql`
    query ConcreteTestSetIssueReportOptions($globalId: String!) {
  concreteTestSets(
    concreteTestSetListInput: {projectId: {equals: $globalId}, deleted: false}
  ) {
    records {
      globalId
      testSetId
    }
  }
}
    `;

/**
 * __useConcreteTestSetIssueReportOptionsQuery__
 *
 * To run a query within a React component, call `useConcreteTestSetIssueReportOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useConcreteTestSetIssueReportOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useConcreteTestSetIssueReportOptionsQuery({
 *   variables: {
 *      globalId: // value for 'globalId'
 *   },
 * });
 */
export function useConcreteTestSetIssueReportOptionsQuery(baseOptions: Apollo.QueryHookOptions<ConcreteTestSetIssueReportOptionsQuery, ConcreteTestSetIssueReportOptionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ConcreteTestSetIssueReportOptionsQuery, ConcreteTestSetIssueReportOptionsQueryVariables>(ConcreteTestSetIssueReportOptionsDocument, options);
      }
export function useConcreteTestSetIssueReportOptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ConcreteTestSetIssueReportOptionsQuery, ConcreteTestSetIssueReportOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ConcreteTestSetIssueReportOptionsQuery, ConcreteTestSetIssueReportOptionsQueryVariables>(ConcreteTestSetIssueReportOptionsDocument, options);
        }
export type ConcreteTestSetIssueReportOptionsQueryHookResult = ReturnType<typeof useConcreteTestSetIssueReportOptionsQuery>;
export type ConcreteTestSetIssueReportOptionsLazyQueryHookResult = ReturnType<typeof useConcreteTestSetIssueReportOptionsLazyQuery>;
export type ConcreteTestSetIssueReportOptionsQueryResult = Apollo.QueryResult<ConcreteTestSetIssueReportOptionsQuery, ConcreteTestSetIssueReportOptionsQueryVariables>;
export const ControlPointIssueReportOptionsDocument = gql`
    query ControlPointIssueReportOptions($globalId: String!) {
  dailyInspectionControlPoints(
    dailyInspectionControlPointListInput: {projectId: {equals: $globalId}, deleted: false}
  ) {
    records {
      globalId
      controlPointId
    }
  }
}
    `;

/**
 * __useControlPointIssueReportOptionsQuery__
 *
 * To run a query within a React component, call `useControlPointIssueReportOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useControlPointIssueReportOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useControlPointIssueReportOptionsQuery({
 *   variables: {
 *      globalId: // value for 'globalId'
 *   },
 * });
 */
export function useControlPointIssueReportOptionsQuery(baseOptions: Apollo.QueryHookOptions<ControlPointIssueReportOptionsQuery, ControlPointIssueReportOptionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ControlPointIssueReportOptionsQuery, ControlPointIssueReportOptionsQueryVariables>(ControlPointIssueReportOptionsDocument, options);
      }
export function useControlPointIssueReportOptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ControlPointIssueReportOptionsQuery, ControlPointIssueReportOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ControlPointIssueReportOptionsQuery, ControlPointIssueReportOptionsQueryVariables>(ControlPointIssueReportOptionsDocument, options);
        }
export type ControlPointIssueReportOptionsQueryHookResult = ReturnType<typeof useControlPointIssueReportOptionsQuery>;
export type ControlPointIssueReportOptionsLazyQueryHookResult = ReturnType<typeof useControlPointIssueReportOptionsLazyQuery>;
export type ControlPointIssueReportOptionsQueryResult = Apollo.QueryResult<ControlPointIssueReportOptionsQuery, ControlPointIssueReportOptionsQueryVariables>;
export const InspectionIssueReportOptionsDocument = gql`
    query InspectionIssueReportOptions($globalId: String!) {
  dailyInspectionInspections(
    dailyInspectionInspectionListInput: {projectId: {equals: $globalId}, deleted: false}
  ) {
    records {
      globalId
      inspectionId
    }
  }
}
    `;

/**
 * __useInspectionIssueReportOptionsQuery__
 *
 * To run a query within a React component, call `useInspectionIssueReportOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useInspectionIssueReportOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInspectionIssueReportOptionsQuery({
 *   variables: {
 *      globalId: // value for 'globalId'
 *   },
 * });
 */
export function useInspectionIssueReportOptionsQuery(baseOptions: Apollo.QueryHookOptions<InspectionIssueReportOptionsQuery, InspectionIssueReportOptionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InspectionIssueReportOptionsQuery, InspectionIssueReportOptionsQueryVariables>(InspectionIssueReportOptionsDocument, options);
      }
export function useInspectionIssueReportOptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InspectionIssueReportOptionsQuery, InspectionIssueReportOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InspectionIssueReportOptionsQuery, InspectionIssueReportOptionsQueryVariables>(InspectionIssueReportOptionsDocument, options);
        }
export type InspectionIssueReportOptionsQueryHookResult = ReturnType<typeof useInspectionIssueReportOptionsQuery>;
export type InspectionIssueReportOptionsLazyQueryHookResult = ReturnType<typeof useInspectionIssueReportOptionsLazyQuery>;
export type InspectionIssueReportOptionsQueryResult = Apollo.QueryResult<InspectionIssueReportOptionsQuery, InspectionIssueReportOptionsQueryVariables>;
export const LotIssueReportOptionsDocument = gql`
    query LotIssueReportOptions($globalId: String!) {
  lots(lotListInput: {projectId: {equals: $globalId}, deleted: false}) {
    records {
      globalId
      lotId
    }
  }
}
    `;

/**
 * __useLotIssueReportOptionsQuery__
 *
 * To run a query within a React component, call `useLotIssueReportOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useLotIssueReportOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLotIssueReportOptionsQuery({
 *   variables: {
 *      globalId: // value for 'globalId'
 *   },
 * });
 */
export function useLotIssueReportOptionsQuery(baseOptions: Apollo.QueryHookOptions<LotIssueReportOptionsQuery, LotIssueReportOptionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LotIssueReportOptionsQuery, LotIssueReportOptionsQueryVariables>(LotIssueReportOptionsDocument, options);
      }
export function useLotIssueReportOptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LotIssueReportOptionsQuery, LotIssueReportOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LotIssueReportOptionsQuery, LotIssueReportOptionsQueryVariables>(LotIssueReportOptionsDocument, options);
        }
export type LotIssueReportOptionsQueryHookResult = ReturnType<typeof useLotIssueReportOptionsQuery>;
export type LotIssueReportOptionsLazyQueryHookResult = ReturnType<typeof useLotIssueReportOptionsLazyQuery>;
export type LotIssueReportOptionsQueryResult = Apollo.QueryResult<LotIssueReportOptionsQuery, LotIssueReportOptionsQueryVariables>;
export const PunchListIssueReportOptionsDocument = gql`
    query PunchListIssueReportOptions($globalId: String!) {
  dailyInspectionPunchLists(
    dailyInspectionPunchListListInput: {projectId: {equals: $globalId}, deleted: false}
  ) {
    records {
      globalId
      punchListId
    }
  }
}
    `;

/**
 * __usePunchListIssueReportOptionsQuery__
 *
 * To run a query within a React component, call `usePunchListIssueReportOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePunchListIssueReportOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePunchListIssueReportOptionsQuery({
 *   variables: {
 *      globalId: // value for 'globalId'
 *   },
 * });
 */
export function usePunchListIssueReportOptionsQuery(baseOptions: Apollo.QueryHookOptions<PunchListIssueReportOptionsQuery, PunchListIssueReportOptionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PunchListIssueReportOptionsQuery, PunchListIssueReportOptionsQueryVariables>(PunchListIssueReportOptionsDocument, options);
      }
export function usePunchListIssueReportOptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PunchListIssueReportOptionsQuery, PunchListIssueReportOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PunchListIssueReportOptionsQuery, PunchListIssueReportOptionsQueryVariables>(PunchListIssueReportOptionsDocument, options);
        }
export type PunchListIssueReportOptionsQueryHookResult = ReturnType<typeof usePunchListIssueReportOptionsQuery>;
export type PunchListIssueReportOptionsLazyQueryHookResult = ReturnType<typeof usePunchListIssueReportOptionsLazyQuery>;
export type PunchListIssueReportOptionsQueryResult = Apollo.QueryResult<PunchListIssueReportOptionsQuery, PunchListIssueReportOptionsQueryVariables>;
export const IssueDispositionTypesDocument = gql`
    query IssueDispositionTypes($projectId: String!) {
  issueDispositionTypes(
    issueDispositionTypeListInput: {projectId: {equals: $projectId}}
  ) {
    records {
      id
      name
      description
      deleted
      deletedDate
      deletedUser
      nonApplicableIssueTypes {
        id
        name
        description
        deleted
      }
      issues {
        id
        formattedNumber
        deleted
      }
    }
  }
}
    `;

/**
 * __useIssueDispositionTypesQuery__
 *
 * To run a query within a React component, call `useIssueDispositionTypesQuery` and pass it any options that fit your needs.
 * When your component renders, `useIssueDispositionTypesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIssueDispositionTypesQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useIssueDispositionTypesQuery(baseOptions: Apollo.QueryHookOptions<IssueDispositionTypesQuery, IssueDispositionTypesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IssueDispositionTypesQuery, IssueDispositionTypesQueryVariables>(IssueDispositionTypesDocument, options);
      }
export function useIssueDispositionTypesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IssueDispositionTypesQuery, IssueDispositionTypesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IssueDispositionTypesQuery, IssueDispositionTypesQueryVariables>(IssueDispositionTypesDocument, options);
        }
export type IssueDispositionTypesQueryHookResult = ReturnType<typeof useIssueDispositionTypesQuery>;
export type IssueDispositionTypesLazyQueryHookResult = ReturnType<typeof useIssueDispositionTypesLazyQuery>;
export type IssueDispositionTypesQueryResult = Apollo.QueryResult<IssueDispositionTypesQuery, IssueDispositionTypesQueryVariables>;
export const IssueDispositionTypesMetadataDocument = gql`
    query IssueDispositionTypesMetadata($projectId: String!) {
  project(globalId: $projectId) {
    issueTypes(issueTypeFieldInput: {deleted: false}) {
      id
      name
      description
    }
  }
}
    `;

/**
 * __useIssueDispositionTypesMetadataQuery__
 *
 * To run a query within a React component, call `useIssueDispositionTypesMetadataQuery` and pass it any options that fit your needs.
 * When your component renders, `useIssueDispositionTypesMetadataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIssueDispositionTypesMetadataQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useIssueDispositionTypesMetadataQuery(baseOptions: Apollo.QueryHookOptions<IssueDispositionTypesMetadataQuery, IssueDispositionTypesMetadataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IssueDispositionTypesMetadataQuery, IssueDispositionTypesMetadataQueryVariables>(IssueDispositionTypesMetadataDocument, options);
      }
export function useIssueDispositionTypesMetadataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IssueDispositionTypesMetadataQuery, IssueDispositionTypesMetadataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IssueDispositionTypesMetadataQuery, IssueDispositionTypesMetadataQueryVariables>(IssueDispositionTypesMetadataDocument, options);
        }
export type IssueDispositionTypesMetadataQueryHookResult = ReturnType<typeof useIssueDispositionTypesMetadataQuery>;
export type IssueDispositionTypesMetadataLazyQueryHookResult = ReturnType<typeof useIssueDispositionTypesMetadataLazyQuery>;
export type IssueDispositionTypesMetadataQueryResult = Apollo.QueryResult<IssueDispositionTypesMetadataQuery, IssueDispositionTypesMetadataQueryVariables>;
export const CreateIssueDispositionTypeDocument = gql`
    mutation CreateIssueDispositionType($input: CreateIssueDispositionTypeInput!) {
  createIssueDispositionType(createIssueDispositionTypeInput: $input) {
    dispositionType {
      name
    }
  }
}
    `;
export type CreateIssueDispositionTypeMutationFn = Apollo.MutationFunction<CreateIssueDispositionTypeMutation, CreateIssueDispositionTypeMutationVariables>;

/**
 * __useCreateIssueDispositionTypeMutation__
 *
 * To run a mutation, you first call `useCreateIssueDispositionTypeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateIssueDispositionTypeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createIssueDispositionTypeMutation, { data, loading, error }] = useCreateIssueDispositionTypeMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateIssueDispositionTypeMutation(baseOptions?: Apollo.MutationHookOptions<CreateIssueDispositionTypeMutation, CreateIssueDispositionTypeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateIssueDispositionTypeMutation, CreateIssueDispositionTypeMutationVariables>(CreateIssueDispositionTypeDocument, options);
      }
export type CreateIssueDispositionTypeMutationHookResult = ReturnType<typeof useCreateIssueDispositionTypeMutation>;
export type CreateIssueDispositionTypeMutationResult = Apollo.MutationResult<CreateIssueDispositionTypeMutation>;
export type CreateIssueDispositionTypeMutationOptions = Apollo.BaseMutationOptions<CreateIssueDispositionTypeMutation, CreateIssueDispositionTypeMutationVariables>;
export const EditIssueDispositionTypeDocument = gql`
    mutation EditIssueDispositionType($input: EditIssueDispositionTypeInput!) {
  editIssueDispositionType(editIssueDispositionTypeInput: $input) {
    dispositionType {
      name
    }
  }
}
    `;
export type EditIssueDispositionTypeMutationFn = Apollo.MutationFunction<EditIssueDispositionTypeMutation, EditIssueDispositionTypeMutationVariables>;

/**
 * __useEditIssueDispositionTypeMutation__
 *
 * To run a mutation, you first call `useEditIssueDispositionTypeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditIssueDispositionTypeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editIssueDispositionTypeMutation, { data, loading, error }] = useEditIssueDispositionTypeMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEditIssueDispositionTypeMutation(baseOptions?: Apollo.MutationHookOptions<EditIssueDispositionTypeMutation, EditIssueDispositionTypeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditIssueDispositionTypeMutation, EditIssueDispositionTypeMutationVariables>(EditIssueDispositionTypeDocument, options);
      }
export type EditIssueDispositionTypeMutationHookResult = ReturnType<typeof useEditIssueDispositionTypeMutation>;
export type EditIssueDispositionTypeMutationResult = Apollo.MutationResult<EditIssueDispositionTypeMutation>;
export type EditIssueDispositionTypeMutationOptions = Apollo.BaseMutationOptions<EditIssueDispositionTypeMutation, EditIssueDispositionTypeMutationVariables>;
export const RemoveIssueDispositionTypeDocument = gql`
    mutation RemoveIssueDispositionType($id: String!) {
  softRemoveIssueDispositionType(id: $id) {
    dispositionType {
      name
    }
  }
}
    `;
export type RemoveIssueDispositionTypeMutationFn = Apollo.MutationFunction<RemoveIssueDispositionTypeMutation, RemoveIssueDispositionTypeMutationVariables>;

/**
 * __useRemoveIssueDispositionTypeMutation__
 *
 * To run a mutation, you first call `useRemoveIssueDispositionTypeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveIssueDispositionTypeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeIssueDispositionTypeMutation, { data, loading, error }] = useRemoveIssueDispositionTypeMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRemoveIssueDispositionTypeMutation(baseOptions?: Apollo.MutationHookOptions<RemoveIssueDispositionTypeMutation, RemoveIssueDispositionTypeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveIssueDispositionTypeMutation, RemoveIssueDispositionTypeMutationVariables>(RemoveIssueDispositionTypeDocument, options);
      }
export type RemoveIssueDispositionTypeMutationHookResult = ReturnType<typeof useRemoveIssueDispositionTypeMutation>;
export type RemoveIssueDispositionTypeMutationResult = Apollo.MutationResult<RemoveIssueDispositionTypeMutation>;
export type RemoveIssueDispositionTypeMutationOptions = Apollo.BaseMutationOptions<RemoveIssueDispositionTypeMutation, RemoveIssueDispositionTypeMutationVariables>;
export const RestoreIssueDispositionTypeDocument = gql`
    mutation RestoreIssueDispositionType($id: String!) {
  restoreIssueDispositionType(id: $id) {
    dispositionType {
      name
    }
  }
}
    `;
export type RestoreIssueDispositionTypeMutationFn = Apollo.MutationFunction<RestoreIssueDispositionTypeMutation, RestoreIssueDispositionTypeMutationVariables>;

/**
 * __useRestoreIssueDispositionTypeMutation__
 *
 * To run a mutation, you first call `useRestoreIssueDispositionTypeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRestoreIssueDispositionTypeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [restoreIssueDispositionTypeMutation, { data, loading, error }] = useRestoreIssueDispositionTypeMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRestoreIssueDispositionTypeMutation(baseOptions?: Apollo.MutationHookOptions<RestoreIssueDispositionTypeMutation, RestoreIssueDispositionTypeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RestoreIssueDispositionTypeMutation, RestoreIssueDispositionTypeMutationVariables>(RestoreIssueDispositionTypeDocument, options);
      }
export type RestoreIssueDispositionTypeMutationHookResult = ReturnType<typeof useRestoreIssueDispositionTypeMutation>;
export type RestoreIssueDispositionTypeMutationResult = Apollo.MutationResult<RestoreIssueDispositionTypeMutation>;
export type RestoreIssueDispositionTypeMutationOptions = Apollo.BaseMutationOptions<RestoreIssueDispositionTypeMutation, RestoreIssueDispositionTypeMutationVariables>;
export const IssueNotificationsDocument = gql`
    query IssueNotifications($projectId: String!) {
  project(globalId: $projectId) {
    issueTypes(
      issueTypeFieldInput: {projectId: {equals: $projectId}, deleted: false}
    ) {
      id
      name
      description
    }
    issueNotifications(
      issueNotificationFieldInput: {projectId: {equals: $projectId}}
    ) {
      notificationEventId
      recipients {
        every {
          ...IssueNotificationRecipients
        }
        byIssueType {
          type {
            id
            name
            description
          }
          recipients {
            ...IssueNotificationRecipients
          }
        }
      }
    }
  }
}
    ${IssueNotificationRecipientsFragmentDoc}`;

/**
 * __useIssueNotificationsQuery__
 *
 * To run a query within a React component, call `useIssueNotificationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useIssueNotificationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIssueNotificationsQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useIssueNotificationsQuery(baseOptions: Apollo.QueryHookOptions<IssueNotificationsQuery, IssueNotificationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IssueNotificationsQuery, IssueNotificationsQueryVariables>(IssueNotificationsDocument, options);
      }
export function useIssueNotificationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IssueNotificationsQuery, IssueNotificationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IssueNotificationsQuery, IssueNotificationsQueryVariables>(IssueNotificationsDocument, options);
        }
export type IssueNotificationsQueryHookResult = ReturnType<typeof useIssueNotificationsQuery>;
export type IssueNotificationsLazyQueryHookResult = ReturnType<typeof useIssueNotificationsLazyQuery>;
export type IssueNotificationsQueryResult = Apollo.QueryResult<IssueNotificationsQuery, IssueNotificationsQueryVariables>;
export const EditIssueNotificationDocument = gql`
    mutation EditIssueNotification($input: EditIssueNotificationInput!) {
  editIssueNotification(editIssueNotificationInput: $input) {
    notification {
      notificationEvent
    }
  }
}
    `;
export type EditIssueNotificationMutationFn = Apollo.MutationFunction<EditIssueNotificationMutation, EditIssueNotificationMutationVariables>;

/**
 * __useEditIssueNotificationMutation__
 *
 * To run a mutation, you first call `useEditIssueNotificationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditIssueNotificationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editIssueNotificationMutation, { data, loading, error }] = useEditIssueNotificationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEditIssueNotificationMutation(baseOptions?: Apollo.MutationHookOptions<EditIssueNotificationMutation, EditIssueNotificationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditIssueNotificationMutation, EditIssueNotificationMutationVariables>(EditIssueNotificationDocument, options);
      }
export type EditIssueNotificationMutationHookResult = ReturnType<typeof useEditIssueNotificationMutation>;
export type EditIssueNotificationMutationResult = Apollo.MutationResult<EditIssueNotificationMutation>;
export type EditIssueNotificationMutationOptions = Apollo.BaseMutationOptions<EditIssueNotificationMutation, EditIssueNotificationMutationVariables>;
export const CreateIssueQuickLinkDocument = gql`
    mutation CreateIssueQuickLink($input: CreateIssueQuickLinkInput!) {
  createIssueQuickLink(createIssueQuickLinkInput: $input) {
    quickLink {
      label
    }
  }
}
    `;
export type CreateIssueQuickLinkMutationFn = Apollo.MutationFunction<CreateIssueQuickLinkMutation, CreateIssueQuickLinkMutationVariables>;

/**
 * __useCreateIssueQuickLinkMutation__
 *
 * To run a mutation, you first call `useCreateIssueQuickLinkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateIssueQuickLinkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createIssueQuickLinkMutation, { data, loading, error }] = useCreateIssueQuickLinkMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateIssueQuickLinkMutation(baseOptions?: Apollo.MutationHookOptions<CreateIssueQuickLinkMutation, CreateIssueQuickLinkMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateIssueQuickLinkMutation, CreateIssueQuickLinkMutationVariables>(CreateIssueQuickLinkDocument, options);
      }
export type CreateIssueQuickLinkMutationHookResult = ReturnType<typeof useCreateIssueQuickLinkMutation>;
export type CreateIssueQuickLinkMutationResult = Apollo.MutationResult<CreateIssueQuickLinkMutation>;
export type CreateIssueQuickLinkMutationOptions = Apollo.BaseMutationOptions<CreateIssueQuickLinkMutation, CreateIssueQuickLinkMutationVariables>;
export const EditIssueQuickLinkDocument = gql`
    mutation EditIssueQuickLink($input: EditIssueQuickLinkInput!) {
  editIssueQuickLink(editIssueQuickLinkInput: $input) {
    quickLink {
      label
    }
  }
}
    `;
export type EditIssueQuickLinkMutationFn = Apollo.MutationFunction<EditIssueQuickLinkMutation, EditIssueQuickLinkMutationVariables>;

/**
 * __useEditIssueQuickLinkMutation__
 *
 * To run a mutation, you first call `useEditIssueQuickLinkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditIssueQuickLinkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editIssueQuickLinkMutation, { data, loading, error }] = useEditIssueQuickLinkMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEditIssueQuickLinkMutation(baseOptions?: Apollo.MutationHookOptions<EditIssueQuickLinkMutation, EditIssueQuickLinkMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditIssueQuickLinkMutation, EditIssueQuickLinkMutationVariables>(EditIssueQuickLinkDocument, options);
      }
export type EditIssueQuickLinkMutationHookResult = ReturnType<typeof useEditIssueQuickLinkMutation>;
export type EditIssueQuickLinkMutationResult = Apollo.MutationResult<EditIssueQuickLinkMutation>;
export type EditIssueQuickLinkMutationOptions = Apollo.BaseMutationOptions<EditIssueQuickLinkMutation, EditIssueQuickLinkMutationVariables>;
export const IssueQuickLinksDocument = gql`
    query IssueQuickLinks($input: IssueQuickLinkListInput!) {
  issueQuickLinks(issueQuickLinkListInput: $input) {
    records {
      id
      href
      label
      description
      deleted
      deletedDate
      deletedUser
    }
  }
}
    `;

/**
 * __useIssueQuickLinksQuery__
 *
 * To run a query within a React component, call `useIssueQuickLinksQuery` and pass it any options that fit your needs.
 * When your component renders, `useIssueQuickLinksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIssueQuickLinksQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useIssueQuickLinksQuery(baseOptions: Apollo.QueryHookOptions<IssueQuickLinksQuery, IssueQuickLinksQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IssueQuickLinksQuery, IssueQuickLinksQueryVariables>(IssueQuickLinksDocument, options);
      }
export function useIssueQuickLinksLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IssueQuickLinksQuery, IssueQuickLinksQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IssueQuickLinksQuery, IssueQuickLinksQueryVariables>(IssueQuickLinksDocument, options);
        }
export type IssueQuickLinksQueryHookResult = ReturnType<typeof useIssueQuickLinksQuery>;
export type IssueQuickLinksLazyQueryHookResult = ReturnType<typeof useIssueQuickLinksLazyQuery>;
export type IssueQuickLinksQueryResult = Apollo.QueryResult<IssueQuickLinksQuery, IssueQuickLinksQueryVariables>;
export const SoftRemoveIssueQuickLinkDocument = gql`
    mutation SoftRemoveIssueQuickLink($id: String!) {
  softRemoveIssueQuickLink(id: $id) {
    quickLink {
      label
    }
  }
}
    `;
export type SoftRemoveIssueQuickLinkMutationFn = Apollo.MutationFunction<SoftRemoveIssueQuickLinkMutation, SoftRemoveIssueQuickLinkMutationVariables>;

/**
 * __useSoftRemoveIssueQuickLinkMutation__
 *
 * To run a mutation, you first call `useSoftRemoveIssueQuickLinkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSoftRemoveIssueQuickLinkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [softRemoveIssueQuickLinkMutation, { data, loading, error }] = useSoftRemoveIssueQuickLinkMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSoftRemoveIssueQuickLinkMutation(baseOptions?: Apollo.MutationHookOptions<SoftRemoveIssueQuickLinkMutation, SoftRemoveIssueQuickLinkMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SoftRemoveIssueQuickLinkMutation, SoftRemoveIssueQuickLinkMutationVariables>(SoftRemoveIssueQuickLinkDocument, options);
      }
export type SoftRemoveIssueQuickLinkMutationHookResult = ReturnType<typeof useSoftRemoveIssueQuickLinkMutation>;
export type SoftRemoveIssueQuickLinkMutationResult = Apollo.MutationResult<SoftRemoveIssueQuickLinkMutation>;
export type SoftRemoveIssueQuickLinkMutationOptions = Apollo.BaseMutationOptions<SoftRemoveIssueQuickLinkMutation, SoftRemoveIssueQuickLinkMutationVariables>;
export const RestoreIssueQuickLinkDocument = gql`
    mutation RestoreIssueQuickLink($id: String!) {
  restoreIssueQuickLink(id: $id) {
    quickLink {
      label
    }
  }
}
    `;
export type RestoreIssueQuickLinkMutationFn = Apollo.MutationFunction<RestoreIssueQuickLinkMutation, RestoreIssueQuickLinkMutationVariables>;

/**
 * __useRestoreIssueQuickLinkMutation__
 *
 * To run a mutation, you first call `useRestoreIssueQuickLinkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRestoreIssueQuickLinkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [restoreIssueQuickLinkMutation, { data, loading, error }] = useRestoreIssueQuickLinkMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRestoreIssueQuickLinkMutation(baseOptions?: Apollo.MutationHookOptions<RestoreIssueQuickLinkMutation, RestoreIssueQuickLinkMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RestoreIssueQuickLinkMutation, RestoreIssueQuickLinkMutationVariables>(RestoreIssueQuickLinkDocument, options);
      }
export type RestoreIssueQuickLinkMutationHookResult = ReturnType<typeof useRestoreIssueQuickLinkMutation>;
export type RestoreIssueQuickLinkMutationResult = Apollo.MutationResult<RestoreIssueQuickLinkMutation>;
export type RestoreIssueQuickLinkMutationOptions = Apollo.BaseMutationOptions<RestoreIssueQuickLinkMutation, RestoreIssueQuickLinkMutationVariables>;
export const EditIssueDocument = gql`
    mutation EditIssue($input: EditIssueInput!) {
  editIssue(editIssueInput: $input) {
    issue {
      formattedNumber
    }
  }
}
    `;
export type EditIssueMutationFn = Apollo.MutationFunction<EditIssueMutation, EditIssueMutationVariables>;

/**
 * __useEditIssueMutation__
 *
 * To run a mutation, you first call `useEditIssueMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditIssueMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editIssueMutation, { data, loading, error }] = useEditIssueMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEditIssueMutation(baseOptions?: Apollo.MutationHookOptions<EditIssueMutation, EditIssueMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditIssueMutation, EditIssueMutationVariables>(EditIssueDocument, options);
      }
export type EditIssueMutationHookResult = ReturnType<typeof useEditIssueMutation>;
export type EditIssueMutationResult = Apollo.MutationResult<EditIssueMutation>;
export type EditIssueMutationOptions = Apollo.BaseMutationOptions<EditIssueMutation, EditIssueMutationVariables>;
export const IssueTrackerIssuesDocument = gql`
    query IssueTrackerIssues($input: IssueListInput!, $projectId: String!) {
  issues(issueListInput: $input) {
    records {
      id
      deleted
      deletedUser
      deletedDate
      statusId
      formattedNumber
      number
      sharePointResourceId
      sharePointResourceWebUrl
      externalLinks {
        href
        label
      }
      customFields {
        booleanValues {
          customField {
            ...IssueTrackerCustomField
          }
          customFieldId
          value
        }
        dateValues {
          customField {
            ...IssueTrackerCustomField
          }
          customFieldId
          value
        }
        entityValues {
          customField {
            ...IssueTrackerCustomField
          }
          customFieldId
          entities {
            recordId
            href(projectId: $projectId)
            entityId
            label
          }
        }
        listValues {
          singles {
            customField {
              ...IssueTrackerCustomField
            }
            customFieldId
            customListItem {
              id
              deleted
              value
            }
          }
          multiples {
            customField {
              ...IssueTrackerCustomField
            }
            customFieldId
            customListItems {
              id
              deleted
              value
            }
          }
          checkboxes {
            customField {
              ...IssueTrackerCustomField
            }
            customFieldId
            booleans {
              customListItemId
              customListItem {
                value
              }
              checked
            }
          }
        }
        numberValues {
          customField {
            ...IssueTrackerCustomField
          }
          customFieldId
          value
        }
        reportValues {
          customField {
            ...IssueTrackerCustomField
          }
          customFieldId
          reports {
            recordId
            reportId
            href(projectId: $projectId)
            label
          }
        }
        textValues {
          customField {
            ...IssueTrackerCustomField
          }
          customFieldId
          value
        }
      }
      identifiedFieldIssue {
        reportId
        asphaltLot {
          globalId
          asphaltLotId
        }
        concreteTest {
          globalId
          fieldNumber
        }
        dailyInspectionControlPoint {
          globalId
          controlPointId
        }
        dailyInspectionInspection {
          globalId
          inspectionId
        }
        dailyInspectionPunchList {
          globalId
          punchListId
        }
        lot {
          globalId
          lotId
        }
      }
      types(issueTypeFieldInput: {deleted: false}) {
        id
        name
        description
      }
      description
      submittedBy {
        ...IssueTrackerUser
      }
      submittedDate
      response
      responseBy {
        ...IssueTrackerUser
      }
      responseDate
      dispositionType {
        id
        name
        description
        deleted
      }
      dispositionNotes
      dispositionBy {
        ...IssueTrackerUser
      }
      dispositionDate
      closureNotes
      closedBy {
        ...IssueTrackerUser
      }
      closedDate
    }
  }
}
    ${IssueTrackerCustomFieldFragmentDoc}
${IssueTrackerUserFragmentDoc}`;

/**
 * __useIssueTrackerIssuesQuery__
 *
 * To run a query within a React component, call `useIssueTrackerIssuesQuery` and pass it any options that fit your needs.
 * When your component renders, `useIssueTrackerIssuesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIssueTrackerIssuesQuery({
 *   variables: {
 *      input: // value for 'input'
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useIssueTrackerIssuesQuery(baseOptions: Apollo.QueryHookOptions<IssueTrackerIssuesQuery, IssueTrackerIssuesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IssueTrackerIssuesQuery, IssueTrackerIssuesQueryVariables>(IssueTrackerIssuesDocument, options);
      }
export function useIssueTrackerIssuesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IssueTrackerIssuesQuery, IssueTrackerIssuesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IssueTrackerIssuesQuery, IssueTrackerIssuesQueryVariables>(IssueTrackerIssuesDocument, options);
        }
export type IssueTrackerIssuesQueryHookResult = ReturnType<typeof useIssueTrackerIssuesQuery>;
export type IssueTrackerIssuesLazyQueryHookResult = ReturnType<typeof useIssueTrackerIssuesLazyQuery>;
export type IssueTrackerIssuesQueryResult = Apollo.QueryResult<IssueTrackerIssuesQuery, IssueTrackerIssuesQueryVariables>;
export const IssueTrackerRelationsDocument = gql`
    query IssueTrackerRelations($projectId: String!, $issueIds: [String!]!) {
  issueQuickLinks(
    issueQuickLinkListInput: {deleted: false, projectId: {equals: $projectId}}
  ) {
    records {
      id
      label
      description
      href
    }
  }
  issueToReports(issueToReportListInput: {issueId: {list: $issueIds}}) {
    records {
      issueId
      asphaltLot {
        globalId
        asphaltLotId
      }
      concreteTest {
        globalId
        fieldNumber
      }
      concreteTestSet {
        globalId
        testSetId
      }
      dailyInspectionControlPoint {
        globalId
        controlPointId
      }
      dailyInspectionInspection {
        globalId
        inspectionId
      }
      dailyInspectionPunchList {
        globalId
        punchListId
      }
      lot {
        globalId
        lotId
      }
    }
  }
  issueComments(issueCommentListInput: {issueId: {list: $issueIds}}) {
    records {
      issueId
      id
      text
      createdDate
      user {
        id
        displayName
        mail
        deleted
        userGroups {
          id
        }
      }
    }
  }
  issueToPayItemNoGeometries(
    issueToPayItemNoGeometryListInput: {issueId: {list: $issueIds}}
  ) {
    records {
      issueId
      payItem {
        globalId
        deleted
        label
      }
    }
  }
}
    `;

/**
 * __useIssueTrackerRelationsQuery__
 *
 * To run a query within a React component, call `useIssueTrackerRelationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useIssueTrackerRelationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIssueTrackerRelationsQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      issueIds: // value for 'issueIds'
 *   },
 * });
 */
export function useIssueTrackerRelationsQuery(baseOptions: Apollo.QueryHookOptions<IssueTrackerRelationsQuery, IssueTrackerRelationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IssueTrackerRelationsQuery, IssueTrackerRelationsQueryVariables>(IssueTrackerRelationsDocument, options);
      }
export function useIssueTrackerRelationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IssueTrackerRelationsQuery, IssueTrackerRelationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IssueTrackerRelationsQuery, IssueTrackerRelationsQueryVariables>(IssueTrackerRelationsDocument, options);
        }
export type IssueTrackerRelationsQueryHookResult = ReturnType<typeof useIssueTrackerRelationsQuery>;
export type IssueTrackerRelationsLazyQueryHookResult = ReturnType<typeof useIssueTrackerRelationsLazyQuery>;
export type IssueTrackerRelationsQueryResult = Apollo.QueryResult<IssueTrackerRelationsQuery, IssueTrackerRelationsQueryVariables>;
export const ActionModalMetadataDocument = gql`
    query ActionModalMetadata($projectId: String!) {
  issueDispositionTypes(
    issueDispositionTypeListInput: {deleted: false, projectId: {equals: $projectId}}
  ) {
    records {
      id
      name
      description
      nonApplicableIssueTypes(issueTypeFieldInput: {deleted: false}) {
        id
      }
    }
  }
}
    `;

/**
 * __useActionModalMetadataQuery__
 *
 * To run a query within a React component, call `useActionModalMetadataQuery` and pass it any options that fit your needs.
 * When your component renders, `useActionModalMetadataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useActionModalMetadataQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useActionModalMetadataQuery(baseOptions: Apollo.QueryHookOptions<ActionModalMetadataQuery, ActionModalMetadataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ActionModalMetadataQuery, ActionModalMetadataQueryVariables>(ActionModalMetadataDocument, options);
      }
export function useActionModalMetadataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ActionModalMetadataQuery, ActionModalMetadataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ActionModalMetadataQuery, ActionModalMetadataQueryVariables>(ActionModalMetadataDocument, options);
        }
export type ActionModalMetadataQueryHookResult = ReturnType<typeof useActionModalMetadataQuery>;
export type ActionModalMetadataLazyQueryHookResult = ReturnType<typeof useActionModalMetadataLazyQuery>;
export type ActionModalMetadataQueryResult = Apollo.QueryResult<ActionModalMetadataQuery, ActionModalMetadataQueryVariables>;
export const CloseIssueDocument = gql`
    mutation CloseIssue($input: CloseIssueInput!) {
  closeIssue(closeIssueInput: $input) {
    issue {
      formattedNumber
    }
  }
}
    `;
export type CloseIssueMutationFn = Apollo.MutationFunction<CloseIssueMutation, CloseIssueMutationVariables>;

/**
 * __useCloseIssueMutation__
 *
 * To run a mutation, you first call `useCloseIssueMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCloseIssueMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [closeIssueMutation, { data, loading, error }] = useCloseIssueMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCloseIssueMutation(baseOptions?: Apollo.MutationHookOptions<CloseIssueMutation, CloseIssueMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CloseIssueMutation, CloseIssueMutationVariables>(CloseIssueDocument, options);
      }
export type CloseIssueMutationHookResult = ReturnType<typeof useCloseIssueMutation>;
export type CloseIssueMutationResult = Apollo.MutationResult<CloseIssueMutation>;
export type CloseIssueMutationOptions = Apollo.BaseMutationOptions<CloseIssueMutation, CloseIssueMutationVariables>;
export const GiveIssueDispositionDocument = gql`
    mutation GiveIssueDisposition($input: GiveIssueDispositionInput!) {
  giveIssueDisposition(giveIssueDispositionInput: $input) {
    issue {
      formattedNumber
    }
  }
}
    `;
export type GiveIssueDispositionMutationFn = Apollo.MutationFunction<GiveIssueDispositionMutation, GiveIssueDispositionMutationVariables>;

/**
 * __useGiveIssueDispositionMutation__
 *
 * To run a mutation, you first call `useGiveIssueDispositionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGiveIssueDispositionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [giveIssueDispositionMutation, { data, loading, error }] = useGiveIssueDispositionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGiveIssueDispositionMutation(baseOptions?: Apollo.MutationHookOptions<GiveIssueDispositionMutation, GiveIssueDispositionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GiveIssueDispositionMutation, GiveIssueDispositionMutationVariables>(GiveIssueDispositionDocument, options);
      }
export type GiveIssueDispositionMutationHookResult = ReturnType<typeof useGiveIssueDispositionMutation>;
export type GiveIssueDispositionMutationResult = Apollo.MutationResult<GiveIssueDispositionMutation>;
export type GiveIssueDispositionMutationOptions = Apollo.BaseMutationOptions<GiveIssueDispositionMutation, GiveIssueDispositionMutationVariables>;
export const RespondToIssueDocument = gql`
    mutation RespondToIssue($input: RespondToIssueInput!) {
  respondToIssue(respondToIssueInput: $input) {
    issue {
      formattedNumber
    }
  }
}
    `;
export type RespondToIssueMutationFn = Apollo.MutationFunction<RespondToIssueMutation, RespondToIssueMutationVariables>;

/**
 * __useRespondToIssueMutation__
 *
 * To run a mutation, you first call `useRespondToIssueMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRespondToIssueMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [respondToIssueMutation, { data, loading, error }] = useRespondToIssueMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRespondToIssueMutation(baseOptions?: Apollo.MutationHookOptions<RespondToIssueMutation, RespondToIssueMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RespondToIssueMutation, RespondToIssueMutationVariables>(RespondToIssueDocument, options);
      }
export type RespondToIssueMutationHookResult = ReturnType<typeof useRespondToIssueMutation>;
export type RespondToIssueMutationResult = Apollo.MutationResult<RespondToIssueMutation>;
export type RespondToIssueMutationOptions = Apollo.BaseMutationOptions<RespondToIssueMutation, RespondToIssueMutationVariables>;
export const RevertIssueDocument = gql`
    mutation RevertIssue($input: RevertIssueInput!) {
  revertIssue(revertIssueInput: $input) {
    issue {
      formattedNumber
      status
    }
  }
}
    `;
export type RevertIssueMutationFn = Apollo.MutationFunction<RevertIssueMutation, RevertIssueMutationVariables>;

/**
 * __useRevertIssueMutation__
 *
 * To run a mutation, you first call `useRevertIssueMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRevertIssueMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [revertIssueMutation, { data, loading, error }] = useRevertIssueMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRevertIssueMutation(baseOptions?: Apollo.MutationHookOptions<RevertIssueMutation, RevertIssueMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RevertIssueMutation, RevertIssueMutationVariables>(RevertIssueDocument, options);
      }
export type RevertIssueMutationHookResult = ReturnType<typeof useRevertIssueMutation>;
export type RevertIssueMutationResult = Apollo.MutationResult<RevertIssueMutation>;
export type RevertIssueMutationOptions = Apollo.BaseMutationOptions<RevertIssueMutation, RevertIssueMutationVariables>;
export const EditIssueModalIssueTypesDocument = gql`
    query EditIssueModalIssueTypes($projectId: String!) {
  issueTypes(
    issueTypeListInput: {projectId: {equals: $projectId}, deleted: false}
  ) {
    records {
      id
      name
      description
    }
  }
}
    `;

/**
 * __useEditIssueModalIssueTypesQuery__
 *
 * To run a query within a React component, call `useEditIssueModalIssueTypesQuery` and pass it any options that fit your needs.
 * When your component renders, `useEditIssueModalIssueTypesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEditIssueModalIssueTypesQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useEditIssueModalIssueTypesQuery(baseOptions: Apollo.QueryHookOptions<EditIssueModalIssueTypesQuery, EditIssueModalIssueTypesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EditIssueModalIssueTypesQuery, EditIssueModalIssueTypesQueryVariables>(EditIssueModalIssueTypesDocument, options);
      }
export function useEditIssueModalIssueTypesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EditIssueModalIssueTypesQuery, EditIssueModalIssueTypesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EditIssueModalIssueTypesQuery, EditIssueModalIssueTypesQueryVariables>(EditIssueModalIssueTypesDocument, options);
        }
export type EditIssueModalIssueTypesQueryHookResult = ReturnType<typeof useEditIssueModalIssueTypesQuery>;
export type EditIssueModalIssueTypesLazyQueryHookResult = ReturnType<typeof useEditIssueModalIssueTypesLazyQuery>;
export type EditIssueModalIssueTypesQueryResult = Apollo.QueryResult<EditIssueModalIssueTypesQuery, EditIssueModalIssueTypesQueryVariables>;
export const CreateIssueCommentDocument = gql`
    mutation CreateIssueComment($input: CreateIssueCommentInput!) {
  createIssueComment(createIssueCommentInput: $input) {
    comment {
      id
    }
  }
}
    `;
export type CreateIssueCommentMutationFn = Apollo.MutationFunction<CreateIssueCommentMutation, CreateIssueCommentMutationVariables>;

/**
 * __useCreateIssueCommentMutation__
 *
 * To run a mutation, you first call `useCreateIssueCommentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateIssueCommentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createIssueCommentMutation, { data, loading, error }] = useCreateIssueCommentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateIssueCommentMutation(baseOptions?: Apollo.MutationHookOptions<CreateIssueCommentMutation, CreateIssueCommentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateIssueCommentMutation, CreateIssueCommentMutationVariables>(CreateIssueCommentDocument, options);
      }
export type CreateIssueCommentMutationHookResult = ReturnType<typeof useCreateIssueCommentMutation>;
export type CreateIssueCommentMutationResult = Apollo.MutationResult<CreateIssueCommentMutation>;
export type CreateIssueCommentMutationOptions = Apollo.BaseMutationOptions<CreateIssueCommentMutation, CreateIssueCommentMutationVariables>;
export const SoftRemoveIssueDocument = gql`
    mutation SoftRemoveIssue($id: String!) {
  softRemoveIssue(id: $id) {
    issue {
      formattedNumber
    }
  }
}
    `;
export type SoftRemoveIssueMutationFn = Apollo.MutationFunction<SoftRemoveIssueMutation, SoftRemoveIssueMutationVariables>;

/**
 * __useSoftRemoveIssueMutation__
 *
 * To run a mutation, you first call `useSoftRemoveIssueMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSoftRemoveIssueMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [softRemoveIssueMutation, { data, loading, error }] = useSoftRemoveIssueMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSoftRemoveIssueMutation(baseOptions?: Apollo.MutationHookOptions<SoftRemoveIssueMutation, SoftRemoveIssueMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SoftRemoveIssueMutation, SoftRemoveIssueMutationVariables>(SoftRemoveIssueDocument, options);
      }
export type SoftRemoveIssueMutationHookResult = ReturnType<typeof useSoftRemoveIssueMutation>;
export type SoftRemoveIssueMutationResult = Apollo.MutationResult<SoftRemoveIssueMutation>;
export type SoftRemoveIssueMutationOptions = Apollo.BaseMutationOptions<SoftRemoveIssueMutation, SoftRemoveIssueMutationVariables>;
export const RestoreIssueDocument = gql`
    mutation RestoreIssue($id: String!) {
  restoreIssue(id: $id) {
    issue {
      formattedNumber
    }
  }
}
    `;
export type RestoreIssueMutationFn = Apollo.MutationFunction<RestoreIssueMutation, RestoreIssueMutationVariables>;

/**
 * __useRestoreIssueMutation__
 *
 * To run a mutation, you first call `useRestoreIssueMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRestoreIssueMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [restoreIssueMutation, { data, loading, error }] = useRestoreIssueMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRestoreIssueMutation(baseOptions?: Apollo.MutationHookOptions<RestoreIssueMutation, RestoreIssueMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RestoreIssueMutation, RestoreIssueMutationVariables>(RestoreIssueDocument, options);
      }
export type RestoreIssueMutationHookResult = ReturnType<typeof useRestoreIssueMutation>;
export type RestoreIssueMutationResult = Apollo.MutationResult<RestoreIssueMutation>;
export type RestoreIssueMutationOptions = Apollo.BaseMutationOptions<RestoreIssueMutation, RestoreIssueMutationVariables>;
export const IssueTypesDocument = gql`
    query IssueTypes($input: IssueTypeListInput!) {
  issueTypes(issueTypeListInput: $input) {
    records {
      id
      name
      description
      deleted
      deletedDate
      deletedUser
      nonApplicableIssueDispositionTypes {
        id
        name
        description
        deleted
      }
      issues {
        id
        formattedNumber
        deleted
      }
    }
  }
}
    `;

/**
 * __useIssueTypesQuery__
 *
 * To run a query within a React component, call `useIssueTypesQuery` and pass it any options that fit your needs.
 * When your component renders, `useIssueTypesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIssueTypesQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useIssueTypesQuery(baseOptions: Apollo.QueryHookOptions<IssueTypesQuery, IssueTypesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IssueTypesQuery, IssueTypesQueryVariables>(IssueTypesDocument, options);
      }
export function useIssueTypesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IssueTypesQuery, IssueTypesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IssueTypesQuery, IssueTypesQueryVariables>(IssueTypesDocument, options);
        }
export type IssueTypesQueryHookResult = ReturnType<typeof useIssueTypesQuery>;
export type IssueTypesLazyQueryHookResult = ReturnType<typeof useIssueTypesLazyQuery>;
export type IssueTypesQueryResult = Apollo.QueryResult<IssueTypesQuery, IssueTypesQueryVariables>;
export const IssueTypesMetadataDocument = gql`
    query IssueTypesMetadata($projectId: String!) {
  project(globalId: $projectId) {
    issueDispositionTypes(issueDispositionTypeFieldInput: {deleted: false}) {
      id
      name
      description
    }
  }
}
    `;

/**
 * __useIssueTypesMetadataQuery__
 *
 * To run a query within a React component, call `useIssueTypesMetadataQuery` and pass it any options that fit your needs.
 * When your component renders, `useIssueTypesMetadataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIssueTypesMetadataQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useIssueTypesMetadataQuery(baseOptions: Apollo.QueryHookOptions<IssueTypesMetadataQuery, IssueTypesMetadataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IssueTypesMetadataQuery, IssueTypesMetadataQueryVariables>(IssueTypesMetadataDocument, options);
      }
export function useIssueTypesMetadataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IssueTypesMetadataQuery, IssueTypesMetadataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IssueTypesMetadataQuery, IssueTypesMetadataQueryVariables>(IssueTypesMetadataDocument, options);
        }
export type IssueTypesMetadataQueryHookResult = ReturnType<typeof useIssueTypesMetadataQuery>;
export type IssueTypesMetadataLazyQueryHookResult = ReturnType<typeof useIssueTypesMetadataLazyQuery>;
export type IssueTypesMetadataQueryResult = Apollo.QueryResult<IssueTypesMetadataQuery, IssueTypesMetadataQueryVariables>;
export const CreateIssueTypeDocument = gql`
    mutation CreateIssueType($input: CreateIssueTypeInput!) {
  createIssueType(createIssueTypeInput: $input) {
    type {
      name
    }
  }
}
    `;
export type CreateIssueTypeMutationFn = Apollo.MutationFunction<CreateIssueTypeMutation, CreateIssueTypeMutationVariables>;

/**
 * __useCreateIssueTypeMutation__
 *
 * To run a mutation, you first call `useCreateIssueTypeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateIssueTypeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createIssueTypeMutation, { data, loading, error }] = useCreateIssueTypeMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateIssueTypeMutation(baseOptions?: Apollo.MutationHookOptions<CreateIssueTypeMutation, CreateIssueTypeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateIssueTypeMutation, CreateIssueTypeMutationVariables>(CreateIssueTypeDocument, options);
      }
export type CreateIssueTypeMutationHookResult = ReturnType<typeof useCreateIssueTypeMutation>;
export type CreateIssueTypeMutationResult = Apollo.MutationResult<CreateIssueTypeMutation>;
export type CreateIssueTypeMutationOptions = Apollo.BaseMutationOptions<CreateIssueTypeMutation, CreateIssueTypeMutationVariables>;
export const EditIssueTypeDocument = gql`
    mutation EditIssueType($input: EditIssueTypeInput!) {
  editIssueType(editIssueTypeInput: $input) {
    type {
      name
    }
  }
}
    `;
export type EditIssueTypeMutationFn = Apollo.MutationFunction<EditIssueTypeMutation, EditIssueTypeMutationVariables>;

/**
 * __useEditIssueTypeMutation__
 *
 * To run a mutation, you first call `useEditIssueTypeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditIssueTypeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editIssueTypeMutation, { data, loading, error }] = useEditIssueTypeMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEditIssueTypeMutation(baseOptions?: Apollo.MutationHookOptions<EditIssueTypeMutation, EditIssueTypeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditIssueTypeMutation, EditIssueTypeMutationVariables>(EditIssueTypeDocument, options);
      }
export type EditIssueTypeMutationHookResult = ReturnType<typeof useEditIssueTypeMutation>;
export type EditIssueTypeMutationResult = Apollo.MutationResult<EditIssueTypeMutation>;
export type EditIssueTypeMutationOptions = Apollo.BaseMutationOptions<EditIssueTypeMutation, EditIssueTypeMutationVariables>;
export const SoftRemoveIssueTypeDocument = gql`
    mutation SoftRemoveIssueType($id: String!) {
  softRemoveIssueType(id: $id) {
    type {
      name
    }
  }
}
    `;
export type SoftRemoveIssueTypeMutationFn = Apollo.MutationFunction<SoftRemoveIssueTypeMutation, SoftRemoveIssueTypeMutationVariables>;

/**
 * __useSoftRemoveIssueTypeMutation__
 *
 * To run a mutation, you first call `useSoftRemoveIssueTypeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSoftRemoveIssueTypeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [softRemoveIssueTypeMutation, { data, loading, error }] = useSoftRemoveIssueTypeMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSoftRemoveIssueTypeMutation(baseOptions?: Apollo.MutationHookOptions<SoftRemoveIssueTypeMutation, SoftRemoveIssueTypeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SoftRemoveIssueTypeMutation, SoftRemoveIssueTypeMutationVariables>(SoftRemoveIssueTypeDocument, options);
      }
export type SoftRemoveIssueTypeMutationHookResult = ReturnType<typeof useSoftRemoveIssueTypeMutation>;
export type SoftRemoveIssueTypeMutationResult = Apollo.MutationResult<SoftRemoveIssueTypeMutation>;
export type SoftRemoveIssueTypeMutationOptions = Apollo.BaseMutationOptions<SoftRemoveIssueTypeMutation, SoftRemoveIssueTypeMutationVariables>;
export const RestoreIssueTypeDocument = gql`
    mutation RestoreIssueType($id: String!) {
  restoreIssueType(id: $id) {
    type {
      name
    }
  }
}
    `;
export type RestoreIssueTypeMutationFn = Apollo.MutationFunction<RestoreIssueTypeMutation, RestoreIssueTypeMutationVariables>;

/**
 * __useRestoreIssueTypeMutation__
 *
 * To run a mutation, you first call `useRestoreIssueTypeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRestoreIssueTypeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [restoreIssueTypeMutation, { data, loading, error }] = useRestoreIssueTypeMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRestoreIssueTypeMutation(baseOptions?: Apollo.MutationHookOptions<RestoreIssueTypeMutation, RestoreIssueTypeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RestoreIssueTypeMutation, RestoreIssueTypeMutationVariables>(RestoreIssueTypeDocument, options);
      }
export type RestoreIssueTypeMutationHookResult = ReturnType<typeof useRestoreIssueTypeMutation>;
export type RestoreIssueTypeMutationResult = Apollo.MutationResult<RestoreIssueTypeMutation>;
export type RestoreIssueTypeMutationOptions = Apollo.BaseMutationOptions<RestoreIssueTypeMutation, RestoreIssueTypeMutationVariables>;
export const CreateIssueFormItemsDataDocument = gql`
    query CreateIssueFormItemsData($projectId: String!) {
  issueTypes(
    issueTypeListInput: {deleted: false, projectId: {equals: $projectId}}
  ) {
    records {
      id
      name
      description
    }
  }
}
    `;

/**
 * __useCreateIssueFormItemsDataQuery__
 *
 * To run a query within a React component, call `useCreateIssueFormItemsDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useCreateIssueFormItemsDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCreateIssueFormItemsDataQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useCreateIssueFormItemsDataQuery(baseOptions: Apollo.QueryHookOptions<CreateIssueFormItemsDataQuery, CreateIssueFormItemsDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CreateIssueFormItemsDataQuery, CreateIssueFormItemsDataQueryVariables>(CreateIssueFormItemsDataDocument, options);
      }
export function useCreateIssueFormItemsDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CreateIssueFormItemsDataQuery, CreateIssueFormItemsDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CreateIssueFormItemsDataQuery, CreateIssueFormItemsDataQueryVariables>(CreateIssueFormItemsDataDocument, options);
        }
export type CreateIssueFormItemsDataQueryHookResult = ReturnType<typeof useCreateIssueFormItemsDataQuery>;
export type CreateIssueFormItemsDataLazyQueryHookResult = ReturnType<typeof useCreateIssueFormItemsDataLazyQuery>;
export type CreateIssueFormItemsDataQueryResult = Apollo.QueryResult<CreateIssueFormItemsDataQuery, CreateIssueFormItemsDataQueryVariables>;
export const DraftIssueDocument = gql`
    mutation DraftIssue($input: DraftIssueInput!) {
  draftIssue(draftIssueInput: $input) {
    issue {
      formattedNumber
    }
  }
}
    `;
export type DraftIssueMutationFn = Apollo.MutationFunction<DraftIssueMutation, DraftIssueMutationVariables>;

/**
 * __useDraftIssueMutation__
 *
 * To run a mutation, you first call `useDraftIssueMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDraftIssueMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [draftIssueMutation, { data, loading, error }] = useDraftIssueMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDraftIssueMutation(baseOptions?: Apollo.MutationHookOptions<DraftIssueMutation, DraftIssueMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DraftIssueMutation, DraftIssueMutationVariables>(DraftIssueDocument, options);
      }
export type DraftIssueMutationHookResult = ReturnType<typeof useDraftIssueMutation>;
export type DraftIssueMutationResult = Apollo.MutationResult<DraftIssueMutation>;
export type DraftIssueMutationOptions = Apollo.BaseMutationOptions<DraftIssueMutation, DraftIssueMutationVariables>;
export const RemoveTempIssueNumberDocument = gql`
    mutation RemoveTempIssueNumber($input: SharePointResourceInput!) {
  removeSharePointResource(removeSharePointResourceInput: $input) {
    removed
  }
}
    `;
export type RemoveTempIssueNumberMutationFn = Apollo.MutationFunction<RemoveTempIssueNumberMutation, RemoveTempIssueNumberMutationVariables>;

/**
 * __useRemoveTempIssueNumberMutation__
 *
 * To run a mutation, you first call `useRemoveTempIssueNumberMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveTempIssueNumberMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeTempIssueNumberMutation, { data, loading, error }] = useRemoveTempIssueNumberMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRemoveTempIssueNumberMutation(baseOptions?: Apollo.MutationHookOptions<RemoveTempIssueNumberMutation, RemoveTempIssueNumberMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveTempIssueNumberMutation, RemoveTempIssueNumberMutationVariables>(RemoveTempIssueNumberDocument, options);
      }
export type RemoveTempIssueNumberMutationHookResult = ReturnType<typeof useRemoveTempIssueNumberMutation>;
export type RemoveTempIssueNumberMutationResult = Apollo.MutationResult<RemoveTempIssueNumberMutation>;
export type RemoveTempIssueNumberMutationOptions = Apollo.BaseMutationOptions<RemoveTempIssueNumberMutation, RemoveTempIssueNumberMutationVariables>;
export const SubmitIssueDocument = gql`
    mutation SubmitIssue($input: SubmitIssueInput!) {
  submitIssue(submitIssueInput: $input) {
    issue {
      formattedNumber
    }
  }
}
    `;
export type SubmitIssueMutationFn = Apollo.MutationFunction<SubmitIssueMutation, SubmitIssueMutationVariables>;

/**
 * __useSubmitIssueMutation__
 *
 * To run a mutation, you first call `useSubmitIssueMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubmitIssueMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [submitIssueMutation, { data, loading, error }] = useSubmitIssueMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSubmitIssueMutation(baseOptions?: Apollo.MutationHookOptions<SubmitIssueMutation, SubmitIssueMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SubmitIssueMutation, SubmitIssueMutationVariables>(SubmitIssueDocument, options);
      }
export type SubmitIssueMutationHookResult = ReturnType<typeof useSubmitIssueMutation>;
export type SubmitIssueMutationResult = Apollo.MutationResult<SubmitIssueMutation>;
export type SubmitIssueMutationOptions = Apollo.BaseMutationOptions<SubmitIssueMutation, SubmitIssueMutationVariables>;
export const RemoveSharePointResourceByFolderDocument = gql`
    mutation RemoveSharePointResourceByFolder($removeSharePointResourceInput: SharePointResourceInput!) {
  removeSharePointResource(
    removeSharePointResourceInput: $removeSharePointResourceInput
  ) {
    message
    removed
  }
}
    `;
export type RemoveSharePointResourceByFolderMutationFn = Apollo.MutationFunction<RemoveSharePointResourceByFolderMutation, RemoveSharePointResourceByFolderMutationVariables>;

/**
 * __useRemoveSharePointResourceByFolderMutation__
 *
 * To run a mutation, you first call `useRemoveSharePointResourceByFolderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveSharePointResourceByFolderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeSharePointResourceByFolderMutation, { data, loading, error }] = useRemoveSharePointResourceByFolderMutation({
 *   variables: {
 *      removeSharePointResourceInput: // value for 'removeSharePointResourceInput'
 *   },
 * });
 */
export function useRemoveSharePointResourceByFolderMutation(baseOptions?: Apollo.MutationHookOptions<RemoveSharePointResourceByFolderMutation, RemoveSharePointResourceByFolderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveSharePointResourceByFolderMutation, RemoveSharePointResourceByFolderMutationVariables>(RemoveSharePointResourceByFolderDocument, options);
      }
export type RemoveSharePointResourceByFolderMutationHookResult = ReturnType<typeof useRemoveSharePointResourceByFolderMutation>;
export type RemoveSharePointResourceByFolderMutationResult = Apollo.MutationResult<RemoveSharePointResourceByFolderMutation>;
export type RemoveSharePointResourceByFolderMutationOptions = Apollo.BaseMutationOptions<RemoveSharePointResourceByFolderMutation, RemoveSharePointResourceByFolderMutationVariables>;
export const CustomFieldCasEntityOptionsDocument = gql`
    query CustomFieldCASEntityOptions($globalId: String!) {
  constructionAdminSubmittals(
    constructionAdminSubmittalListInput: {projectId: {equals: $globalId}, deleted: false}
  ) {
    records {
      sharePointFolderName
      id
    }
  }
}
    `;

/**
 * __useCustomFieldCasEntityOptionsQuery__
 *
 * To run a query within a React component, call `useCustomFieldCasEntityOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCustomFieldCasEntityOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCustomFieldCasEntityOptionsQuery({
 *   variables: {
 *      globalId: // value for 'globalId'
 *   },
 * });
 */
export function useCustomFieldCasEntityOptionsQuery(baseOptions: Apollo.QueryHookOptions<CustomFieldCasEntityOptionsQuery, CustomFieldCasEntityOptionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CustomFieldCasEntityOptionsQuery, CustomFieldCasEntityOptionsQueryVariables>(CustomFieldCasEntityOptionsDocument, options);
      }
export function useCustomFieldCasEntityOptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CustomFieldCasEntityOptionsQuery, CustomFieldCasEntityOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CustomFieldCasEntityOptionsQuery, CustomFieldCasEntityOptionsQueryVariables>(CustomFieldCasEntityOptionsDocument, options);
        }
export type CustomFieldCasEntityOptionsQueryHookResult = ReturnType<typeof useCustomFieldCasEntityOptionsQuery>;
export type CustomFieldCasEntityOptionsLazyQueryHookResult = ReturnType<typeof useCustomFieldCasEntityOptionsLazyQuery>;
export type CustomFieldCasEntityOptionsQueryResult = Apollo.QueryResult<CustomFieldCasEntityOptionsQuery, CustomFieldCasEntityOptionsQueryVariables>;
export const CustomFieldCtsEntityOptionsDocument = gql`
    query CustomFieldCTSEntityOptions($globalId: String!) {
  concreteTestSets(
    concreteTestSetListInput: {projectId: {equals: $globalId}, deleted: false}
  ) {
    records {
      testSetId
      globalId
    }
  }
}
    `;

/**
 * __useCustomFieldCtsEntityOptionsQuery__
 *
 * To run a query within a React component, call `useCustomFieldCtsEntityOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCustomFieldCtsEntityOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCustomFieldCtsEntityOptionsQuery({
 *   variables: {
 *      globalId: // value for 'globalId'
 *   },
 * });
 */
export function useCustomFieldCtsEntityOptionsQuery(baseOptions: Apollo.QueryHookOptions<CustomFieldCtsEntityOptionsQuery, CustomFieldCtsEntityOptionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CustomFieldCtsEntityOptionsQuery, CustomFieldCtsEntityOptionsQueryVariables>(CustomFieldCtsEntityOptionsDocument, options);
      }
export function useCustomFieldCtsEntityOptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CustomFieldCtsEntityOptionsQuery, CustomFieldCtsEntityOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CustomFieldCtsEntityOptionsQuery, CustomFieldCtsEntityOptionsQueryVariables>(CustomFieldCtsEntityOptionsDocument, options);
        }
export type CustomFieldCtsEntityOptionsQueryHookResult = ReturnType<typeof useCustomFieldCtsEntityOptionsQuery>;
export type CustomFieldCtsEntityOptionsLazyQueryHookResult = ReturnType<typeof useCustomFieldCtsEntityOptionsLazyQuery>;
export type CustomFieldCtsEntityOptionsQueryResult = Apollo.QueryResult<CustomFieldCtsEntityOptionsQuery, CustomFieldCtsEntityOptionsQueryVariables>;
export const CustomFieldDsEntityOptionsDocument = gql`
    query CustomFieldDSEntityOptions($globalId: String!) {
  designSubmittals(
    designSubmittalListInput: {projectId: {equals: $globalId}, deleted: false}
  ) {
    records {
      sharePointFolderName
      id
    }
  }
}
    `;

/**
 * __useCustomFieldDsEntityOptionsQuery__
 *
 * To run a query within a React component, call `useCustomFieldDsEntityOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCustomFieldDsEntityOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCustomFieldDsEntityOptionsQuery({
 *   variables: {
 *      globalId: // value for 'globalId'
 *   },
 * });
 */
export function useCustomFieldDsEntityOptionsQuery(baseOptions: Apollo.QueryHookOptions<CustomFieldDsEntityOptionsQuery, CustomFieldDsEntityOptionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CustomFieldDsEntityOptionsQuery, CustomFieldDsEntityOptionsQueryVariables>(CustomFieldDsEntityOptionsDocument, options);
      }
export function useCustomFieldDsEntityOptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CustomFieldDsEntityOptionsQuery, CustomFieldDsEntityOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CustomFieldDsEntityOptionsQuery, CustomFieldDsEntityOptionsQueryVariables>(CustomFieldDsEntityOptionsDocument, options);
        }
export type CustomFieldDsEntityOptionsQueryHookResult = ReturnType<typeof useCustomFieldDsEntityOptionsQuery>;
export type CustomFieldDsEntityOptionsLazyQueryHookResult = ReturnType<typeof useCustomFieldDsEntityOptionsLazyQuery>;
export type CustomFieldDsEntityOptionsQueryResult = Apollo.QueryResult<CustomFieldDsEntityOptionsQuery, CustomFieldDsEntityOptionsQueryVariables>;
export const CustomFieldFdcEntityOptionsDocument = gql`
    query CustomFieldFDCEntityOptions($globalId: String!) {
  fieldDesignChanges(
    fieldDesignChangeListInput: {projectId: {equals: $globalId}, deleted: false}
  ) {
    records {
      number
      id
    }
  }
}
    `;

/**
 * __useCustomFieldFdcEntityOptionsQuery__
 *
 * To run a query within a React component, call `useCustomFieldFdcEntityOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCustomFieldFdcEntityOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCustomFieldFdcEntityOptionsQuery({
 *   variables: {
 *      globalId: // value for 'globalId'
 *   },
 * });
 */
export function useCustomFieldFdcEntityOptionsQuery(baseOptions: Apollo.QueryHookOptions<CustomFieldFdcEntityOptionsQuery, CustomFieldFdcEntityOptionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CustomFieldFdcEntityOptionsQuery, CustomFieldFdcEntityOptionsQueryVariables>(CustomFieldFdcEntityOptionsDocument, options);
      }
export function useCustomFieldFdcEntityOptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CustomFieldFdcEntityOptionsQuery, CustomFieldFdcEntityOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CustomFieldFdcEntityOptionsQuery, CustomFieldFdcEntityOptionsQueryVariables>(CustomFieldFdcEntityOptionsDocument, options);
        }
export type CustomFieldFdcEntityOptionsQueryHookResult = ReturnType<typeof useCustomFieldFdcEntityOptionsQuery>;
export type CustomFieldFdcEntityOptionsLazyQueryHookResult = ReturnType<typeof useCustomFieldFdcEntityOptionsLazyQuery>;
export type CustomFieldFdcEntityOptionsQueryResult = Apollo.QueryResult<CustomFieldFdcEntityOptionsQuery, CustomFieldFdcEntityOptionsQueryVariables>;
export const LabTechSelectLabTechsDocument = gql`
    query LabTechSelectLabTechs($globalId: String!) {
  labTechs(labTechListInput: {projectId: {equals: $globalId}}) {
    records {
      id
      name
      user {
        deleted
        mail
        displayName
        id
        userGroups {
          id
        }
      }
    }
  }
}
    `;

/**
 * __useLabTechSelectLabTechsQuery__
 *
 * To run a query within a React component, call `useLabTechSelectLabTechsQuery` and pass it any options that fit your needs.
 * When your component renders, `useLabTechSelectLabTechsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLabTechSelectLabTechsQuery({
 *   variables: {
 *      globalId: // value for 'globalId'
 *   },
 * });
 */
export function useLabTechSelectLabTechsQuery(baseOptions: Apollo.QueryHookOptions<LabTechSelectLabTechsQuery, LabTechSelectLabTechsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LabTechSelectLabTechsQuery, LabTechSelectLabTechsQueryVariables>(LabTechSelectLabTechsDocument, options);
      }
export function useLabTechSelectLabTechsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LabTechSelectLabTechsQuery, LabTechSelectLabTechsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LabTechSelectLabTechsQuery, LabTechSelectLabTechsQueryVariables>(LabTechSelectLabTechsDocument, options);
        }
export type LabTechSelectLabTechsQueryHookResult = ReturnType<typeof useLabTechSelectLabTechsQuery>;
export type LabTechSelectLabTechsLazyQueryHookResult = ReturnType<typeof useLabTechSelectLabTechsLazyQuery>;
export type LabTechSelectLabTechsQueryResult = Apollo.QueryResult<LabTechSelectLabTechsQuery, LabTechSelectLabTechsQueryVariables>;
export const PayItemSelectPayItemNoGeometriesDocument = gql`
    query PayItemSelectPayItemNoGeometries($globalId: String!) {
  payItemNoGeometries(
    payItemNoGeometryListInput: {projectId: {equals: $globalId}, deleted: false}
  ) {
    records {
      globalId
      deleted
      label
    }
  }
}
    `;

/**
 * __usePayItemSelectPayItemNoGeometriesQuery__
 *
 * To run a query within a React component, call `usePayItemSelectPayItemNoGeometriesQuery` and pass it any options that fit your needs.
 * When your component renders, `usePayItemSelectPayItemNoGeometriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePayItemSelectPayItemNoGeometriesQuery({
 *   variables: {
 *      globalId: // value for 'globalId'
 *   },
 * });
 */
export function usePayItemSelectPayItemNoGeometriesQuery(baseOptions: Apollo.QueryHookOptions<PayItemSelectPayItemNoGeometriesQuery, PayItemSelectPayItemNoGeometriesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PayItemSelectPayItemNoGeometriesQuery, PayItemSelectPayItemNoGeometriesQueryVariables>(PayItemSelectPayItemNoGeometriesDocument, options);
      }
export function usePayItemSelectPayItemNoGeometriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PayItemSelectPayItemNoGeometriesQuery, PayItemSelectPayItemNoGeometriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PayItemSelectPayItemNoGeometriesQuery, PayItemSelectPayItemNoGeometriesQueryVariables>(PayItemSelectPayItemNoGeometriesDocument, options);
        }
export type PayItemSelectPayItemNoGeometriesQueryHookResult = ReturnType<typeof usePayItemSelectPayItemNoGeometriesQuery>;
export type PayItemSelectPayItemNoGeometriesLazyQueryHookResult = ReturnType<typeof usePayItemSelectPayItemNoGeometriesLazyQuery>;
export type PayItemSelectPayItemNoGeometriesQueryResult = Apollo.QueryResult<PayItemSelectPayItemNoGeometriesQuery, PayItemSelectPayItemNoGeometriesQueryVariables>;
export const PhotoExportAsphaltLotOptionsDocument = gql`
    query PhotoExportAsphaltLotOptions($projectGlobalId: String!) {
  asphaltLots(
    asphaltLotListInput: {projectId: {equals: $projectGlobalId}, deleted: false}
  ) {
    records {
      asphaltLotId
      globalId
    }
  }
}
    `;

/**
 * __usePhotoExportAsphaltLotOptionsQuery__
 *
 * To run a query within a React component, call `usePhotoExportAsphaltLotOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePhotoExportAsphaltLotOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePhotoExportAsphaltLotOptionsQuery({
 *   variables: {
 *      projectGlobalId: // value for 'projectGlobalId'
 *   },
 * });
 */
export function usePhotoExportAsphaltLotOptionsQuery(baseOptions: Apollo.QueryHookOptions<PhotoExportAsphaltLotOptionsQuery, PhotoExportAsphaltLotOptionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PhotoExportAsphaltLotOptionsQuery, PhotoExportAsphaltLotOptionsQueryVariables>(PhotoExportAsphaltLotOptionsDocument, options);
      }
export function usePhotoExportAsphaltLotOptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PhotoExportAsphaltLotOptionsQuery, PhotoExportAsphaltLotOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PhotoExportAsphaltLotOptionsQuery, PhotoExportAsphaltLotOptionsQueryVariables>(PhotoExportAsphaltLotOptionsDocument, options);
        }
export type PhotoExportAsphaltLotOptionsQueryHookResult = ReturnType<typeof usePhotoExportAsphaltLotOptionsQuery>;
export type PhotoExportAsphaltLotOptionsLazyQueryHookResult = ReturnType<typeof usePhotoExportAsphaltLotOptionsLazyQuery>;
export type PhotoExportAsphaltLotOptionsQueryResult = Apollo.QueryResult<PhotoExportAsphaltLotOptionsQuery, PhotoExportAsphaltLotOptionsQueryVariables>;
export const PhotoExportConcreteTestSetOptionsDocument = gql`
    query PhotoExportConcreteTestSetOptions($projectGlobalId: String!) {
  concreteTestSets(
    concreteTestSetListInput: {deleted: false, projectId: {equals: $projectGlobalId}}
  ) {
    records {
      testSetId
      globalId
    }
  }
}
    `;

/**
 * __usePhotoExportConcreteTestSetOptionsQuery__
 *
 * To run a query within a React component, call `usePhotoExportConcreteTestSetOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePhotoExportConcreteTestSetOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePhotoExportConcreteTestSetOptionsQuery({
 *   variables: {
 *      projectGlobalId: // value for 'projectGlobalId'
 *   },
 * });
 */
export function usePhotoExportConcreteTestSetOptionsQuery(baseOptions: Apollo.QueryHookOptions<PhotoExportConcreteTestSetOptionsQuery, PhotoExportConcreteTestSetOptionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PhotoExportConcreteTestSetOptionsQuery, PhotoExportConcreteTestSetOptionsQueryVariables>(PhotoExportConcreteTestSetOptionsDocument, options);
      }
export function usePhotoExportConcreteTestSetOptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PhotoExportConcreteTestSetOptionsQuery, PhotoExportConcreteTestSetOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PhotoExportConcreteTestSetOptionsQuery, PhotoExportConcreteTestSetOptionsQueryVariables>(PhotoExportConcreteTestSetOptionsDocument, options);
        }
export type PhotoExportConcreteTestSetOptionsQueryHookResult = ReturnType<typeof usePhotoExportConcreteTestSetOptionsQuery>;
export type PhotoExportConcreteTestSetOptionsLazyQueryHookResult = ReturnType<typeof usePhotoExportConcreteTestSetOptionsLazyQuery>;
export type PhotoExportConcreteTestSetOptionsQueryResult = Apollo.QueryResult<PhotoExportConcreteTestSetOptionsQuery, PhotoExportConcreteTestSetOptionsQueryVariables>;
export const PhotoExportControlPointOptionsDocument = gql`
    query PhotoExportControlPointOptions($projectGlobalId: String!) {
  dailyInspectionControlPoints(
    dailyInspectionControlPointListInput: {deleted: false, projectId: {equals: $projectGlobalId}}
  ) {
    records {
      controlPointId
      globalId
    }
  }
}
    `;

/**
 * __usePhotoExportControlPointOptionsQuery__
 *
 * To run a query within a React component, call `usePhotoExportControlPointOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePhotoExportControlPointOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePhotoExportControlPointOptionsQuery({
 *   variables: {
 *      projectGlobalId: // value for 'projectGlobalId'
 *   },
 * });
 */
export function usePhotoExportControlPointOptionsQuery(baseOptions: Apollo.QueryHookOptions<PhotoExportControlPointOptionsQuery, PhotoExportControlPointOptionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PhotoExportControlPointOptionsQuery, PhotoExportControlPointOptionsQueryVariables>(PhotoExportControlPointOptionsDocument, options);
      }
export function usePhotoExportControlPointOptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PhotoExportControlPointOptionsQuery, PhotoExportControlPointOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PhotoExportControlPointOptionsQuery, PhotoExportControlPointOptionsQueryVariables>(PhotoExportControlPointOptionsDocument, options);
        }
export type PhotoExportControlPointOptionsQueryHookResult = ReturnType<typeof usePhotoExportControlPointOptionsQuery>;
export type PhotoExportControlPointOptionsLazyQueryHookResult = ReturnType<typeof usePhotoExportControlPointOptionsLazyQuery>;
export type PhotoExportControlPointOptionsQueryResult = Apollo.QueryResult<PhotoExportControlPointOptionsQuery, PhotoExportControlPointOptionsQueryVariables>;
export const PhotoExportDensityLotOptionsDocument = gql`
    query PhotoExportDensityLotOptions($projectGlobalId: String!) {
  lots(lotListInput: {deleted: false, projectId: {equals: $projectGlobalId}}) {
    records {
      lotId
      globalId
    }
  }
}
    `;

/**
 * __usePhotoExportDensityLotOptionsQuery__
 *
 * To run a query within a React component, call `usePhotoExportDensityLotOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePhotoExportDensityLotOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePhotoExportDensityLotOptionsQuery({
 *   variables: {
 *      projectGlobalId: // value for 'projectGlobalId'
 *   },
 * });
 */
export function usePhotoExportDensityLotOptionsQuery(baseOptions: Apollo.QueryHookOptions<PhotoExportDensityLotOptionsQuery, PhotoExportDensityLotOptionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PhotoExportDensityLotOptionsQuery, PhotoExportDensityLotOptionsQueryVariables>(PhotoExportDensityLotOptionsDocument, options);
      }
export function usePhotoExportDensityLotOptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PhotoExportDensityLotOptionsQuery, PhotoExportDensityLotOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PhotoExportDensityLotOptionsQuery, PhotoExportDensityLotOptionsQueryVariables>(PhotoExportDensityLotOptionsDocument, options);
        }
export type PhotoExportDensityLotOptionsQueryHookResult = ReturnType<typeof usePhotoExportDensityLotOptionsQuery>;
export type PhotoExportDensityLotOptionsLazyQueryHookResult = ReturnType<typeof usePhotoExportDensityLotOptionsLazyQuery>;
export type PhotoExportDensityLotOptionsQueryResult = Apollo.QueryResult<PhotoExportDensityLotOptionsQuery, PhotoExportDensityLotOptionsQueryVariables>;
export const PhotoExportInspectionOptionsDocument = gql`
    query PhotoExportInspectionOptions($projectGlobalId: String!) {
  dailyInspectionInspections(
    dailyInspectionInspectionListInput: {deleted: false, projectId: {equals: $projectGlobalId}}
  ) {
    records {
      inspectionId
      globalId
    }
  }
}
    `;

/**
 * __usePhotoExportInspectionOptionsQuery__
 *
 * To run a query within a React component, call `usePhotoExportInspectionOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePhotoExportInspectionOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePhotoExportInspectionOptionsQuery({
 *   variables: {
 *      projectGlobalId: // value for 'projectGlobalId'
 *   },
 * });
 */
export function usePhotoExportInspectionOptionsQuery(baseOptions: Apollo.QueryHookOptions<PhotoExportInspectionOptionsQuery, PhotoExportInspectionOptionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PhotoExportInspectionOptionsQuery, PhotoExportInspectionOptionsQueryVariables>(PhotoExportInspectionOptionsDocument, options);
      }
export function usePhotoExportInspectionOptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PhotoExportInspectionOptionsQuery, PhotoExportInspectionOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PhotoExportInspectionOptionsQuery, PhotoExportInspectionOptionsQueryVariables>(PhotoExportInspectionOptionsDocument, options);
        }
export type PhotoExportInspectionOptionsQueryHookResult = ReturnType<typeof usePhotoExportInspectionOptionsQuery>;
export type PhotoExportInspectionOptionsLazyQueryHookResult = ReturnType<typeof usePhotoExportInspectionOptionsLazyQuery>;
export type PhotoExportInspectionOptionsQueryResult = Apollo.QueryResult<PhotoExportInspectionOptionsQuery, PhotoExportInspectionOptionsQueryVariables>;
export const PhotoExportPunchListOptionsDocument = gql`
    query PhotoExportPunchListOptions($projectGlobalId: String!) {
  dailyInspectionPunchLists(
    dailyInspectionPunchListListInput: {deleted: false, projectId: {equals: $projectGlobalId}}
  ) {
    records {
      punchListId
      globalId
    }
  }
}
    `;

/**
 * __usePhotoExportPunchListOptionsQuery__
 *
 * To run a query within a React component, call `usePhotoExportPunchListOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePhotoExportPunchListOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePhotoExportPunchListOptionsQuery({
 *   variables: {
 *      projectGlobalId: // value for 'projectGlobalId'
 *   },
 * });
 */
export function usePhotoExportPunchListOptionsQuery(baseOptions: Apollo.QueryHookOptions<PhotoExportPunchListOptionsQuery, PhotoExportPunchListOptionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PhotoExportPunchListOptionsQuery, PhotoExportPunchListOptionsQueryVariables>(PhotoExportPunchListOptionsDocument, options);
      }
export function usePhotoExportPunchListOptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PhotoExportPunchListOptionsQuery, PhotoExportPunchListOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PhotoExportPunchListOptionsQuery, PhotoExportPunchListOptionsQueryVariables>(PhotoExportPunchListOptionsDocument, options);
        }
export type PhotoExportPunchListOptionsQueryHookResult = ReturnType<typeof usePhotoExportPunchListOptionsQuery>;
export type PhotoExportPunchListOptionsLazyQueryHookResult = ReturnType<typeof usePhotoExportPunchListOptionsLazyQuery>;
export type PhotoExportPunchListOptionsQueryResult = Apollo.QueryResult<PhotoExportPunchListOptionsQuery, PhotoExportPunchListOptionsQueryVariables>;
export const RecipientsSelectRecipientsDocument = gql`
    query RecipientsSelectRecipients($globalId: String!) {
  project(globalId: $globalId) {
    nonUserEmails {
      id
      label
      address
      description
    }
    users(userFieldInput: {deleted: false}) {
      displayName
      mail
      id
    }
  }
}
    `;

/**
 * __useRecipientsSelectRecipientsQuery__
 *
 * To run a query within a React component, call `useRecipientsSelectRecipientsQuery` and pass it any options that fit your needs.
 * When your component renders, `useRecipientsSelectRecipientsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRecipientsSelectRecipientsQuery({
 *   variables: {
 *      globalId: // value for 'globalId'
 *   },
 * });
 */
export function useRecipientsSelectRecipientsQuery(baseOptions: Apollo.QueryHookOptions<RecipientsSelectRecipientsQuery, RecipientsSelectRecipientsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RecipientsSelectRecipientsQuery, RecipientsSelectRecipientsQueryVariables>(RecipientsSelectRecipientsDocument, options);
      }
export function useRecipientsSelectRecipientsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RecipientsSelectRecipientsQuery, RecipientsSelectRecipientsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RecipientsSelectRecipientsQuery, RecipientsSelectRecipientsQueryVariables>(RecipientsSelectRecipientsDocument, options);
        }
export type RecipientsSelectRecipientsQueryHookResult = ReturnType<typeof useRecipientsSelectRecipientsQuery>;
export type RecipientsSelectRecipientsLazyQueryHookResult = ReturnType<typeof useRecipientsSelectRecipientsLazyQuery>;
export type RecipientsSelectRecipientsQueryResult = Apollo.QueryResult<RecipientsSelectRecipientsQuery, RecipientsSelectRecipientsQueryVariables>;
export const AsphaltReportOptionsDocument = gql`
    query AsphaltReportOptions($globalId: String!) {
  asphaltLots(
    asphaltLotListInput: {projectId: {equals: $globalId}, deleted: false}
  ) {
    records {
      globalId
      asphaltLotId
    }
  }
}
    `;

/**
 * __useAsphaltReportOptionsQuery__
 *
 * To run a query within a React component, call `useAsphaltReportOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAsphaltReportOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAsphaltReportOptionsQuery({
 *   variables: {
 *      globalId: // value for 'globalId'
 *   },
 * });
 */
export function useAsphaltReportOptionsQuery(baseOptions: Apollo.QueryHookOptions<AsphaltReportOptionsQuery, AsphaltReportOptionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AsphaltReportOptionsQuery, AsphaltReportOptionsQueryVariables>(AsphaltReportOptionsDocument, options);
      }
export function useAsphaltReportOptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AsphaltReportOptionsQuery, AsphaltReportOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AsphaltReportOptionsQuery, AsphaltReportOptionsQueryVariables>(AsphaltReportOptionsDocument, options);
        }
export type AsphaltReportOptionsQueryHookResult = ReturnType<typeof useAsphaltReportOptionsQuery>;
export type AsphaltReportOptionsLazyQueryHookResult = ReturnType<typeof useAsphaltReportOptionsLazyQuery>;
export type AsphaltReportOptionsQueryResult = Apollo.QueryResult<AsphaltReportOptionsQuery, AsphaltReportOptionsQueryVariables>;
export const CasReportOptionsDocument = gql`
    query CASReportOptions($input: ConstructionAdminSubmittalListInput!) {
  constructionAdminSubmittals(constructionAdminSubmittalListInput: $input) {
    records {
      id
      packageNumber
      packetSharePointResourceId
    }
  }
}
    `;

/**
 * __useCasReportOptionsQuery__
 *
 * To run a query within a React component, call `useCasReportOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCasReportOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCasReportOptionsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCasReportOptionsQuery(baseOptions: Apollo.QueryHookOptions<CasReportOptionsQuery, CasReportOptionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CasReportOptionsQuery, CasReportOptionsQueryVariables>(CasReportOptionsDocument, options);
      }
export function useCasReportOptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CasReportOptionsQuery, CasReportOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CasReportOptionsQuery, CasReportOptionsQueryVariables>(CasReportOptionsDocument, options);
        }
export type CasReportOptionsQueryHookResult = ReturnType<typeof useCasReportOptionsQuery>;
export type CasReportOptionsLazyQueryHookResult = ReturnType<typeof useCasReportOptionsLazyQuery>;
export type CasReportOptionsQueryResult = Apollo.QueryResult<CasReportOptionsQuery, CasReportOptionsQueryVariables>;
export const ConcretePlacementReportOptionsDocument = gql`
    query ConcretePlacementReportOptions($globalId: String!) {
  concretePlacements(
    concretePlacementListInput: {projectId: {equals: $globalId}, deleted: false}
  ) {
    records {
      globalId
      placementId
    }
  }
}
    `;

/**
 * __useConcretePlacementReportOptionsQuery__
 *
 * To run a query within a React component, call `useConcretePlacementReportOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useConcretePlacementReportOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useConcretePlacementReportOptionsQuery({
 *   variables: {
 *      globalId: // value for 'globalId'
 *   },
 * });
 */
export function useConcretePlacementReportOptionsQuery(baseOptions: Apollo.QueryHookOptions<ConcretePlacementReportOptionsQuery, ConcretePlacementReportOptionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ConcretePlacementReportOptionsQuery, ConcretePlacementReportOptionsQueryVariables>(ConcretePlacementReportOptionsDocument, options);
      }
export function useConcretePlacementReportOptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ConcretePlacementReportOptionsQuery, ConcretePlacementReportOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ConcretePlacementReportOptionsQuery, ConcretePlacementReportOptionsQueryVariables>(ConcretePlacementReportOptionsDocument, options);
        }
export type ConcretePlacementReportOptionsQueryHookResult = ReturnType<typeof useConcretePlacementReportOptionsQuery>;
export type ConcretePlacementReportOptionsLazyQueryHookResult = ReturnType<typeof useConcretePlacementReportOptionsLazyQuery>;
export type ConcretePlacementReportOptionsQueryResult = Apollo.QueryResult<ConcretePlacementReportOptionsQuery, ConcretePlacementReportOptionsQueryVariables>;
export const ConcreteTestReportOptionsDocument = gql`
    query ConcreteTestReportOptions($globalId: String!) {
  concreteTests(
    concreteTestListInput: {projectId: {equals: $globalId}, deleted: false}
  ) {
    records {
      globalId
      fieldNumber
      cylinderNumber
      testSubId
    }
  }
}
    `;

/**
 * __useConcreteTestReportOptionsQuery__
 *
 * To run a query within a React component, call `useConcreteTestReportOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useConcreteTestReportOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useConcreteTestReportOptionsQuery({
 *   variables: {
 *      globalId: // value for 'globalId'
 *   },
 * });
 */
export function useConcreteTestReportOptionsQuery(baseOptions: Apollo.QueryHookOptions<ConcreteTestReportOptionsQuery, ConcreteTestReportOptionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ConcreteTestReportOptionsQuery, ConcreteTestReportOptionsQueryVariables>(ConcreteTestReportOptionsDocument, options);
      }
export function useConcreteTestReportOptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ConcreteTestReportOptionsQuery, ConcreteTestReportOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ConcreteTestReportOptionsQuery, ConcreteTestReportOptionsQueryVariables>(ConcreteTestReportOptionsDocument, options);
        }
export type ConcreteTestReportOptionsQueryHookResult = ReturnType<typeof useConcreteTestReportOptionsQuery>;
export type ConcreteTestReportOptionsLazyQueryHookResult = ReturnType<typeof useConcreteTestReportOptionsLazyQuery>;
export type ConcreteTestReportOptionsQueryResult = Apollo.QueryResult<ConcreteTestReportOptionsQuery, ConcreteTestReportOptionsQueryVariables>;
export const ConcreteTestSetReportOptionsDocument = gql`
    query ConcreteTestSetReportOptions($globalId: String!) {
  concreteTestSets(
    concreteTestSetListInput: {projectId: {equals: $globalId}, deleted: false}
  ) {
    records {
      globalId
      testSetId
    }
  }
}
    `;

/**
 * __useConcreteTestSetReportOptionsQuery__
 *
 * To run a query within a React component, call `useConcreteTestSetReportOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useConcreteTestSetReportOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useConcreteTestSetReportOptionsQuery({
 *   variables: {
 *      globalId: // value for 'globalId'
 *   },
 * });
 */
export function useConcreteTestSetReportOptionsQuery(baseOptions: Apollo.QueryHookOptions<ConcreteTestSetReportOptionsQuery, ConcreteTestSetReportOptionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ConcreteTestSetReportOptionsQuery, ConcreteTestSetReportOptionsQueryVariables>(ConcreteTestSetReportOptionsDocument, options);
      }
export function useConcreteTestSetReportOptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ConcreteTestSetReportOptionsQuery, ConcreteTestSetReportOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ConcreteTestSetReportOptionsQuery, ConcreteTestSetReportOptionsQueryVariables>(ConcreteTestSetReportOptionsDocument, options);
        }
export type ConcreteTestSetReportOptionsQueryHookResult = ReturnType<typeof useConcreteTestSetReportOptionsQuery>;
export type ConcreteTestSetReportOptionsLazyQueryHookResult = ReturnType<typeof useConcreteTestSetReportOptionsLazyQuery>;
export type ConcreteTestSetReportOptionsQueryResult = Apollo.QueryResult<ConcreteTestSetReportOptionsQuery, ConcreteTestSetReportOptionsQueryVariables>;
export const ControlPointReportOptionsDocument = gql`
    query ControlPointReportOptions($globalId: String!) {
  dailyInspectionControlPoints(
    dailyInspectionControlPointListInput: {projectId: {equals: $globalId}, deleted: false}
  ) {
    records {
      globalId
      controlPointId
    }
  }
}
    `;

/**
 * __useControlPointReportOptionsQuery__
 *
 * To run a query within a React component, call `useControlPointReportOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useControlPointReportOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useControlPointReportOptionsQuery({
 *   variables: {
 *      globalId: // value for 'globalId'
 *   },
 * });
 */
export function useControlPointReportOptionsQuery(baseOptions: Apollo.QueryHookOptions<ControlPointReportOptionsQuery, ControlPointReportOptionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ControlPointReportOptionsQuery, ControlPointReportOptionsQueryVariables>(ControlPointReportOptionsDocument, options);
      }
export function useControlPointReportOptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ControlPointReportOptionsQuery, ControlPointReportOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ControlPointReportOptionsQuery, ControlPointReportOptionsQueryVariables>(ControlPointReportOptionsDocument, options);
        }
export type ControlPointReportOptionsQueryHookResult = ReturnType<typeof useControlPointReportOptionsQuery>;
export type ControlPointReportOptionsLazyQueryHookResult = ReturnType<typeof useControlPointReportOptionsLazyQuery>;
export type ControlPointReportOptionsQueryResult = Apollo.QueryResult<ControlPointReportOptionsQuery, ControlPointReportOptionsQueryVariables>;
export const InspectionReportOptionsDocument = gql`
    query InspectionReportOptions($globalId: String!) {
  dailyInspectionInspections(
    dailyInspectionInspectionListInput: {projectId: {equals: $globalId}, deleted: false}
  ) {
    records {
      globalId
      inspectionId
    }
  }
}
    `;

/**
 * __useInspectionReportOptionsQuery__
 *
 * To run a query within a React component, call `useInspectionReportOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useInspectionReportOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInspectionReportOptionsQuery({
 *   variables: {
 *      globalId: // value for 'globalId'
 *   },
 * });
 */
export function useInspectionReportOptionsQuery(baseOptions: Apollo.QueryHookOptions<InspectionReportOptionsQuery, InspectionReportOptionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InspectionReportOptionsQuery, InspectionReportOptionsQueryVariables>(InspectionReportOptionsDocument, options);
      }
export function useInspectionReportOptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InspectionReportOptionsQuery, InspectionReportOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InspectionReportOptionsQuery, InspectionReportOptionsQueryVariables>(InspectionReportOptionsDocument, options);
        }
export type InspectionReportOptionsQueryHookResult = ReturnType<typeof useInspectionReportOptionsQuery>;
export type InspectionReportOptionsLazyQueryHookResult = ReturnType<typeof useInspectionReportOptionsLazyQuery>;
export type InspectionReportOptionsQueryResult = Apollo.QueryResult<InspectionReportOptionsQuery, InspectionReportOptionsQueryVariables>;
export const LotReportOptionsDocument = gql`
    query LotReportOptions($globalId: String!) {
  lots(lotListInput: {projectId: {equals: $globalId}, deleted: false}) {
    records {
      globalId
      lotId
    }
  }
}
    `;

/**
 * __useLotReportOptionsQuery__
 *
 * To run a query within a React component, call `useLotReportOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useLotReportOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLotReportOptionsQuery({
 *   variables: {
 *      globalId: // value for 'globalId'
 *   },
 * });
 */
export function useLotReportOptionsQuery(baseOptions: Apollo.QueryHookOptions<LotReportOptionsQuery, LotReportOptionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LotReportOptionsQuery, LotReportOptionsQueryVariables>(LotReportOptionsDocument, options);
      }
export function useLotReportOptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LotReportOptionsQuery, LotReportOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LotReportOptionsQuery, LotReportOptionsQueryVariables>(LotReportOptionsDocument, options);
        }
export type LotReportOptionsQueryHookResult = ReturnType<typeof useLotReportOptionsQuery>;
export type LotReportOptionsLazyQueryHookResult = ReturnType<typeof useLotReportOptionsLazyQuery>;
export type LotReportOptionsQueryResult = Apollo.QueryResult<LotReportOptionsQuery, LotReportOptionsQueryVariables>;
export const PunchListReportOptionsDocument = gql`
    query PunchListReportOptions($globalId: String!) {
  dailyInspectionPunchLists(
    dailyInspectionPunchListListInput: {projectId: {equals: $globalId}, deleted: false}
  ) {
    records {
      globalId
      punchListId
    }
  }
}
    `;

/**
 * __usePunchListReportOptionsQuery__
 *
 * To run a query within a React component, call `usePunchListReportOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePunchListReportOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePunchListReportOptionsQuery({
 *   variables: {
 *      globalId: // value for 'globalId'
 *   },
 * });
 */
export function usePunchListReportOptionsQuery(baseOptions: Apollo.QueryHookOptions<PunchListReportOptionsQuery, PunchListReportOptionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PunchListReportOptionsQuery, PunchListReportOptionsQueryVariables>(PunchListReportOptionsDocument, options);
      }
export function usePunchListReportOptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PunchListReportOptionsQuery, PunchListReportOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PunchListReportOptionsQuery, PunchListReportOptionsQueryVariables>(PunchListReportOptionsDocument, options);
        }
export type PunchListReportOptionsQueryHookResult = ReturnType<typeof usePunchListReportOptionsQuery>;
export type PunchListReportOptionsLazyQueryHookResult = ReturnType<typeof usePunchListReportOptionsLazyQuery>;
export type PunchListReportOptionsQueryResult = Apollo.QueryResult<PunchListReportOptionsQuery, PunchListReportOptionsQueryVariables>;
export const TestingLabSelectTestingLabsDocument = gql`
    query TestingLabSelectTestingLabs($projectId: String!) {
  testingLabs(testingLabListInput: {projectId: {equals: $projectId}}) {
    records {
      name
      id
    }
  }
}
    `;

/**
 * __useTestingLabSelectTestingLabsQuery__
 *
 * To run a query within a React component, call `useTestingLabSelectTestingLabsQuery` and pass it any options that fit your needs.
 * When your component renders, `useTestingLabSelectTestingLabsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTestingLabSelectTestingLabsQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useTestingLabSelectTestingLabsQuery(baseOptions: Apollo.QueryHookOptions<TestingLabSelectTestingLabsQuery, TestingLabSelectTestingLabsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TestingLabSelectTestingLabsQuery, TestingLabSelectTestingLabsQueryVariables>(TestingLabSelectTestingLabsDocument, options);
      }
export function useTestingLabSelectTestingLabsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TestingLabSelectTestingLabsQuery, TestingLabSelectTestingLabsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TestingLabSelectTestingLabsQuery, TestingLabSelectTestingLabsQueryVariables>(TestingLabSelectTestingLabsDocument, options);
        }
export type TestingLabSelectTestingLabsQueryHookResult = ReturnType<typeof useTestingLabSelectTestingLabsQuery>;
export type TestingLabSelectTestingLabsLazyQueryHookResult = ReturnType<typeof useTestingLabSelectTestingLabsLazyQuery>;
export type TestingLabSelectTestingLabsQueryResult = Apollo.QueryResult<TestingLabSelectTestingLabsQuery, TestingLabSelectTestingLabsQueryVariables>;
export const UserRoleSelectUsersRolesDocument = gql`
    query UserRoleSelectUsersRoles($globalId: String!) {
  project(globalId: $globalId) {
    users(userFieldInput: {deleted: false}) {
      id
      displayName
      mail
    }
    roles(roleFieldInput: {deleted: false}) {
      id
      name
      users {
        id
      }
    }
  }
}
    `;

/**
 * __useUserRoleSelectUsersRolesQuery__
 *
 * To run a query within a React component, call `useUserRoleSelectUsersRolesQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserRoleSelectUsersRolesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserRoleSelectUsersRolesQuery({
 *   variables: {
 *      globalId: // value for 'globalId'
 *   },
 * });
 */
export function useUserRoleSelectUsersRolesQuery(baseOptions: Apollo.QueryHookOptions<UserRoleSelectUsersRolesQuery, UserRoleSelectUsersRolesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserRoleSelectUsersRolesQuery, UserRoleSelectUsersRolesQueryVariables>(UserRoleSelectUsersRolesDocument, options);
      }
export function useUserRoleSelectUsersRolesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserRoleSelectUsersRolesQuery, UserRoleSelectUsersRolesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserRoleSelectUsersRolesQuery, UserRoleSelectUsersRolesQueryVariables>(UserRoleSelectUsersRolesDocument, options);
        }
export type UserRoleSelectUsersRolesQueryHookResult = ReturnType<typeof useUserRoleSelectUsersRolesQuery>;
export type UserRoleSelectUsersRolesLazyQueryHookResult = ReturnType<typeof useUserRoleSelectUsersRolesLazyQuery>;
export type UserRoleSelectUsersRolesQueryResult = Apollo.QueryResult<UserRoleSelectUsersRolesQuery, UserRoleSelectUsersRolesQueryVariables>;
export const UserSelectUsersDocument = gql`
    query UserSelectUsers($globalId: String!) {
  project(globalId: $globalId) {
    users(userFieldInput: {deleted: false}) {
      displayName
      mail
      id
    }
  }
}
    `;

/**
 * __useUserSelectUsersQuery__
 *
 * To run a query within a React component, call `useUserSelectUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserSelectUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserSelectUsersQuery({
 *   variables: {
 *      globalId: // value for 'globalId'
 *   },
 * });
 */
export function useUserSelectUsersQuery(baseOptions: Apollo.QueryHookOptions<UserSelectUsersQuery, UserSelectUsersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserSelectUsersQuery, UserSelectUsersQueryVariables>(UserSelectUsersDocument, options);
      }
export function useUserSelectUsersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserSelectUsersQuery, UserSelectUsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserSelectUsersQuery, UserSelectUsersQueryVariables>(UserSelectUsersDocument, options);
        }
export type UserSelectUsersQueryHookResult = ReturnType<typeof useUserSelectUsersQuery>;
export type UserSelectUsersLazyQueryHookResult = ReturnType<typeof useUserSelectUsersLazyQuery>;
export type UserSelectUsersQueryResult = Apollo.QueryResult<UserSelectUsersQuery, UserSelectUsersQueryVariables>;
export const OrphanedSharePointResourcesDocument = gql`
    query OrphanedSharePointResources($input: OrphanedSharePointResourcesInput!) {
  orphanedSharePointResources(orphanedSharePointResourcesInput: $input) {
    concreteTestSetResources {
      ...OrphanedSharePointResource
    }
    constructionAdminSubmittalResources {
      ...OrphanedSharePointResource
    }
    designSubmittalResources {
      ...OrphanedSharePointResource
    }
    fieldDesignChangeResources {
      ...OrphanedSharePointResource
    }
  }
}
    ${OrphanedSharePointResourceFragmentDoc}`;

/**
 * __useOrphanedSharePointResourcesQuery__
 *
 * To run a query within a React component, call `useOrphanedSharePointResourcesQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrphanedSharePointResourcesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrphanedSharePointResourcesQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useOrphanedSharePointResourcesQuery(baseOptions: Apollo.QueryHookOptions<OrphanedSharePointResourcesQuery, OrphanedSharePointResourcesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OrphanedSharePointResourcesQuery, OrphanedSharePointResourcesQueryVariables>(OrphanedSharePointResourcesDocument, options);
      }
export function useOrphanedSharePointResourcesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OrphanedSharePointResourcesQuery, OrphanedSharePointResourcesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OrphanedSharePointResourcesQuery, OrphanedSharePointResourcesQueryVariables>(OrphanedSharePointResourcesDocument, options);
        }
export type OrphanedSharePointResourcesQueryHookResult = ReturnType<typeof useOrphanedSharePointResourcesQuery>;
export type OrphanedSharePointResourcesLazyQueryHookResult = ReturnType<typeof useOrphanedSharePointResourcesLazyQuery>;
export type OrphanedSharePointResourcesQueryResult = Apollo.QueryResult<OrphanedSharePointResourcesQuery, OrphanedSharePointResourcesQueryVariables>;
export const RepairSharePointResourceDocument = gql`
    mutation RepairSharePointResource($input: RepairSharePointResourceInput!) {
  repairSharePointResource(repairSharePointResourceInput: $input) {
    sharePointResource {
      name
    }
  }
}
    `;
export type RepairSharePointResourceMutationFn = Apollo.MutationFunction<RepairSharePointResourceMutation, RepairSharePointResourceMutationVariables>;

/**
 * __useRepairSharePointResourceMutation__
 *
 * To run a mutation, you first call `useRepairSharePointResourceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRepairSharePointResourceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [repairSharePointResourceMutation, { data, loading, error }] = useRepairSharePointResourceMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRepairSharePointResourceMutation(baseOptions?: Apollo.MutationHookOptions<RepairSharePointResourceMutation, RepairSharePointResourceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RepairSharePointResourceMutation, RepairSharePointResourceMutationVariables>(RepairSharePointResourceDocument, options);
      }
export type RepairSharePointResourceMutationHookResult = ReturnType<typeof useRepairSharePointResourceMutation>;
export type RepairSharePointResourceMutationResult = Apollo.MutationResult<RepairSharePointResourceMutation>;
export type RepairSharePointResourceMutationOptions = Apollo.BaseMutationOptions<RepairSharePointResourceMutation, RepairSharePointResourceMutationVariables>;
export const SetSharePointResourcePermissionsDocument = gql`
    mutation setSharePointResourcePermissions($input: SetSharePointResourcePermissionsInput!) {
  setSharePointResourcePermissions(setSharePointResourcePermissionsInput: $input) {
    constructionAdminSubmittal {
      sharePointFolderName
    }
    designSubmittal {
      sharePointFolderName
    }
    concreteTestSet {
      globalId
      testSetId
    }
    fieldDesignChange {
      formattedNumber
    }
    requestForInformation {
      formattedNumber
    }
    issue {
      formattedNumber
    }
    user {
      displayName
      mail
    }
  }
}
    `;
export type SetSharePointResourcePermissionsMutationFn = Apollo.MutationFunction<SetSharePointResourcePermissionsMutation, SetSharePointResourcePermissionsMutationVariables>;

/**
 * __useSetSharePointResourcePermissionsMutation__
 *
 * To run a mutation, you first call `useSetSharePointResourcePermissionsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetSharePointResourcePermissionsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setSharePointResourcePermissionsMutation, { data, loading, error }] = useSetSharePointResourcePermissionsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSetSharePointResourcePermissionsMutation(baseOptions?: Apollo.MutationHookOptions<SetSharePointResourcePermissionsMutation, SetSharePointResourcePermissionsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetSharePointResourcePermissionsMutation, SetSharePointResourcePermissionsMutationVariables>(SetSharePointResourcePermissionsDocument, options);
      }
export type SetSharePointResourcePermissionsMutationHookResult = ReturnType<typeof useSetSharePointResourcePermissionsMutation>;
export type SetSharePointResourcePermissionsMutationResult = Apollo.MutationResult<SetSharePointResourcePermissionsMutation>;
export type SetSharePointResourcePermissionsMutationOptions = Apollo.BaseMutationOptions<SetSharePointResourcePermissionsMutation, SetSharePointResourcePermissionsMutationVariables>;
export const ProjectCustomFieldsDocument = gql`
    query ProjectCustomFields($projectId: String, $customFieldToClassTypeFieldInput: CustomFieldToClassTypeFieldInput!) {
  customFields(customFieldListInput: {projectId: {equals: $projectId}}) {
    records {
      id
      name
      description
      dataTypeId
      deleted
      deletedDate
      deletedUser
      metadata {
        styleId
        entityIds
        reportIds
        timestamp
      }
      customFieldToClassTypes(
        customFieldToClassTypeFieldInput: $customFieldToClassTypeFieldInput
      ) {
        customFieldId
        classTypeId
        alwaysEditable
        alwaysVisible
        prominent
        required
        roles(roleFieldInput: {deleted: false}) {
          id
          name
          users {
            ...ProjectCustomFieldsUserFragment
          }
        }
        users(userFieldInput: {deleted: false}) {
          ...ProjectCustomFieldsUserFragment
        }
      }
      customListItems(customListItemFieldInput: {deleted: false}) {
        id
        value
      }
    }
  }
}
    ${ProjectCustomFieldsUserFragmentFragmentDoc}`;

/**
 * __useProjectCustomFieldsQuery__
 *
 * To run a query within a React component, call `useProjectCustomFieldsQuery` and pass it any options that fit your needs.
 * When your component renders, `useProjectCustomFieldsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProjectCustomFieldsQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      customFieldToClassTypeFieldInput: // value for 'customFieldToClassTypeFieldInput'
 *   },
 * });
 */
export function useProjectCustomFieldsQuery(baseOptions: Apollo.QueryHookOptions<ProjectCustomFieldsQuery, ProjectCustomFieldsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProjectCustomFieldsQuery, ProjectCustomFieldsQueryVariables>(ProjectCustomFieldsDocument, options);
      }
export function useProjectCustomFieldsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProjectCustomFieldsQuery, ProjectCustomFieldsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProjectCustomFieldsQuery, ProjectCustomFieldsQueryVariables>(ProjectCustomFieldsDocument, options);
        }
export type ProjectCustomFieldsQueryHookResult = ReturnType<typeof useProjectCustomFieldsQuery>;
export type ProjectCustomFieldsLazyQueryHookResult = ReturnType<typeof useProjectCustomFieldsLazyQuery>;
export type ProjectCustomFieldsQueryResult = Apollo.QueryResult<ProjectCustomFieldsQuery, ProjectCustomFieldsQueryVariables>;
export const GetSharePointResourceForUploaderDocument = gql`
    query GetSharePointResourceForUploader($sharePointResourceInput: SharePointResourceInput!) {
  sharePointResource(sharePointResourceInput: $sharePointResourceInput) {
    webUrl
    sharePointResources {
      webUrl
      id
      name
    }
  }
}
    `;

/**
 * __useGetSharePointResourceForUploaderQuery__
 *
 * To run a query within a React component, call `useGetSharePointResourceForUploaderQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSharePointResourceForUploaderQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSharePointResourceForUploaderQuery({
 *   variables: {
 *      sharePointResourceInput: // value for 'sharePointResourceInput'
 *   },
 * });
 */
export function useGetSharePointResourceForUploaderQuery(baseOptions: Apollo.QueryHookOptions<GetSharePointResourceForUploaderQuery, GetSharePointResourceForUploaderQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSharePointResourceForUploaderQuery, GetSharePointResourceForUploaderQueryVariables>(GetSharePointResourceForUploaderDocument, options);
      }
export function useGetSharePointResourceForUploaderLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSharePointResourceForUploaderQuery, GetSharePointResourceForUploaderQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSharePointResourceForUploaderQuery, GetSharePointResourceForUploaderQueryVariables>(GetSharePointResourceForUploaderDocument, options);
        }
export type GetSharePointResourceForUploaderQueryHookResult = ReturnType<typeof useGetSharePointResourceForUploaderQuery>;
export type GetSharePointResourceForUploaderLazyQueryHookResult = ReturnType<typeof useGetSharePointResourceForUploaderLazyQuery>;
export type GetSharePointResourceForUploaderQueryResult = Apollo.QueryResult<GetSharePointResourceForUploaderQuery, GetSharePointResourceForUploaderQueryVariables>;
export const RemoveSharePointUploadByIdDocument = gql`
    mutation RemoveSharePointUploadById($sharePointResourceInput: SharePointResourceInput!) {
  removeSharePointResource(
    removeSharePointResourceInput: $sharePointResourceInput
  ) {
    message
    removed
  }
}
    `;
export type RemoveSharePointUploadByIdMutationFn = Apollo.MutationFunction<RemoveSharePointUploadByIdMutation, RemoveSharePointUploadByIdMutationVariables>;

/**
 * __useRemoveSharePointUploadByIdMutation__
 *
 * To run a mutation, you first call `useRemoveSharePointUploadByIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveSharePointUploadByIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeSharePointUploadByIdMutation, { data, loading, error }] = useRemoveSharePointUploadByIdMutation({
 *   variables: {
 *      sharePointResourceInput: // value for 'sharePointResourceInput'
 *   },
 * });
 */
export function useRemoveSharePointUploadByIdMutation(baseOptions?: Apollo.MutationHookOptions<RemoveSharePointUploadByIdMutation, RemoveSharePointUploadByIdMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveSharePointUploadByIdMutation, RemoveSharePointUploadByIdMutationVariables>(RemoveSharePointUploadByIdDocument, options);
      }
export type RemoveSharePointUploadByIdMutationHookResult = ReturnType<typeof useRemoveSharePointUploadByIdMutation>;
export type RemoveSharePointUploadByIdMutationResult = Apollo.MutationResult<RemoveSharePointUploadByIdMutation>;
export type RemoveSharePointUploadByIdMutationOptions = Apollo.BaseMutationOptions<RemoveSharePointUploadByIdMutation, RemoveSharePointUploadByIdMutationVariables>;